/**!
* @license FusionCharts JavaScript Library
* Copyright FusionCharts Technologies LLP
* License Information at <http://www.fusioncharts.com/license>
*
* @version 3.13.3-sr.1
*
* @attributions (infers respective third-party copyrights)
* Raphael 2.1.0 (modified as 'Red Raphael') <http://raphaeljs.com/license.html>
* JSON v2 <http://www.JSON.org/js.html>
* Firebug Lite 1.3.0 <http://getfirebug.com/firebuglite>
*/
"function" != typeof Object.assign && (Object.assign = function (e) {
  "use strict";

  var t, n, r, o;
  if (null == e) throw new TypeError("Cannot convert undefined or null to object");

  for (t = Object(e), n = 1; n < arguments.length; n++) {
    if (null != (r = arguments[n])) for (o in r) {
      Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
    }
  }

  return t;
}), Function.prototype.bind || (Function.prototype.bind = function (e) {
  "use strict";

  var t, n, r, o;
  if ("function" != typeof this) throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
  return t = Array.prototype.slice.call(arguments, 1), n = this, r = function r() {}, o = function o() {
    return n.apply(this instanceof r ? this : e, t.concat(Array.prototype.slice.call(arguments)));
  }, this.prototype && (r.prototype = this.prototype), o.prototype = new r(), o;
}), function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.FusionCharts = t() : e.FusionCharts = t();
}(window, function () {
  return function (e) {
    function t(t) {
      for (var n, o, i = t[0], a = t[1], s = 0, c = []; s < i.length; s++) {
        o = i[s], r[o] && c.push(r[o][0]), r[o] = 0;
      }

      for (n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
      }

      for (l && l(t); c.length;) {
        c.shift()();
      }
    }

    var n = {},
        r = {
      0: 0
    };

    function o(t) {
      if (n[t]) return n[t].exports;
      var r = n[t] = {
        i: t,
        l: !1,
        exports: {}
      };
      return e[t].call(r.exports, r, r.exports, o), r.l = !0, r.exports;
    }

    o.e = function (e) {
      var t = [],
          n = r[e];
      if (0 !== n) if (n) t.push(n[2]);else {
        var i = new Promise(function (t, o) {
          n = r[e] = [t, o];
        });
        t.push(n[2] = i);
        var a,
            s = document.getElementsByTagName("head")[0],
            l = document.createElement("script");
        l.charset = "utf-8", l.timeout = 120, o.nc && l.setAttribute("nonce", o.nc), l.src = function (e) {
          return o.p + "" + ({
            1: "fusioncharts.charts",
            2: "fusioncharts.common",
            3: "fusioncharts.timeseries",
            4: "fusioncharts.powercharts",
            5: "fusioncharts.widgets",
            6: "fusioncharts.zoomline",
            7: "fusioncharts.gantt",
            8: "fusioncharts.treemap",
            9: "fusioncharts.zoomscatter",
            10: "fusioncharts.msstackedcolumn2dsplinedy",
            11: "fusioncharts.overlappedbar2d",
            12: "fusioncharts.overlappedcolumn2d",
            13: "fusioncharts.maps",
            14: "fusioncharts.vml"
          }[e] || e) + ".js";
        }(e), a = function a(t) {
          l.onerror = l.onload = null, clearTimeout(c);
          var n = r[e];

          if (0 !== n) {
            if (n) {
              var o = t && ("load" === t.type ? "missing" : t.type),
                  i = t && t.target && t.target.src,
                  a = new Error("Loading chunk " + e + " failed.\n(" + o + ": " + i + ")");
              a.type = o, a.request = i, n[1](a);
            }

            r[e] = undefined;
          }
        };
        var c = setTimeout(function () {
          a({
            type: "timeout",
            target: l
          });
        }, 12e4);
        l.onerror = l.onload = a, s.appendChild(l);
      }
      return Promise.all(t);
    }, o.m = e, o.c = n, o.d = function (e, t, n) {
      o.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, o.t = function (e, t) {
      if (1 & t && (e = o(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (o.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        o.d(n, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return n;
    }, o.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return o.d(t, "a", t), t;
    }, o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.p = "", o.oe = function (e) {
      throw console.error(e), e;
    };
    var i = window.webpackJsonpFusionCharts = window.webpackJsonpFusionCharts || [],
        a = i.push.bind(i);
    i.push = t, i = i.slice();

    for (var s = 0; s < i.length; s++) {
      t(i[s]);
    }

    var l = a;
    return o(o.s = 0);
  }([function (e, t, n) {
    n(1), n(92), n(116), e.exports = n(121);
  }, function (e, t, n) {
    "use strict";

    n(2), n(38), n(42), n(44), n(50), n(53), n(56), n(59), n(66), n(68), n(70), n(73), n(75), n(77), window.getComputedStyle || (window.getComputedStyle = function (e) {
      return this.el = e, this.getPropertyValue = function (t) {
        var n = /(\-([a-z]){1})/g;
        return "float" === t && (t = "styleFloat"), n.test(t) && (t = t.replace(n, function () {
          return arguments[2].toUpperCase();
        })), e.currentStyle[t] ? e.currentStyle[t] : null;
      }, this;
    }), Event.prototype.stopPropagation || (Event.prototype.stopPropagation = function () {
      this.cancelBubble = !0;
    });
  }, function (e, t, n) {
    n(3);
    var r = n(7).Object;

    e.exports = function (e) {
      return r.getOwnPropertyNames(e);
    };
  }, function (e, t, n) {
    n(4)("getOwnPropertyNames", function () {
      return n(23).f;
    });
  }, function (e, t, n) {
    var r = n(5),
        o = n(7),
        i = n(14);

    e.exports = function (e, t) {
      var n = (o.Object || {})[e] || Object[e],
          a = {};
      a[e] = t(n), r(r.S + r.F * i(function () {
        n(1);
      }), "Object", a);
    };
  }, function (e, t, n) {
    var r = n(6),
        o = n(7),
        i = n(8),
        a = n(18),
        s = n(21),
        l = function l(e, t, n) {
      var c,
          u,
          d,
          f,
          h = e & l.F,
          p = e & l.G,
          g = e & l.S,
          m = e & l.P,
          v = e & l.B,
          y = p ? r : g ? r[t] || (r[t] = {}) : (r[t] || {}).prototype,
          b = p ? o : o[t] || (o[t] = {}),
          x = b.prototype || (b.prototype = {});

      for (c in p && (n = t), n) {
        d = ((u = !h && y && y[c] !== undefined) ? y : n)[c], f = v && u ? s(d, r) : m && "function" == typeof d ? s(Function.call, d) : d, y && a(y, c, d, e & l.U), b[c] != d && i(b, c, f), m && x[c] != d && (x[c] = d);
      }
    };

    r.core = o, l.F = 1, l.G = 2, l.S = 4, l.P = 8, l.B = 16, l.W = 32, l.U = 64, l.R = 128, e.exports = l;
  }, function (e, t) {
    var n = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = n);
  }, function (e, t) {
    var n = e.exports = {
      version: "2.5.7"
    };
    "number" == typeof __e && (__e = n);
  }, function (e, t, n) {
    var r = n(9),
        o = n(17);
    e.exports = n(13) ? function (e, t, n) {
      return r.f(e, t, o(1, n));
    } : function (e, t, n) {
      return e[t] = n, e;
    };
  }, function (e, t, n) {
    var r = n(10),
        o = n(12),
        i = n(16),
        a = Object.defineProperty;
    t.f = n(13) ? Object.defineProperty : function (e, t, n) {
      if (r(e), t = i(t, !0), r(n), o) try {
        return a(e, t, n);
      } catch (s) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
      return "value" in n && (e[t] = n.value), e;
    };
  }, function (e, t, n) {
    var r = n(11);

    e.exports = function (e) {
      if (!r(e)) throw TypeError(e + " is not an object!");
      return e;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return "object" == typeof e ? null !== e : "function" == typeof e;
    };
  }, function (e, t, n) {
    e.exports = !n(13) && !n(14)(function () {
      return 7 != Object.defineProperty(n(15)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, t, n) {
    e.exports = !n(14)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, t) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (t) {
        return !0;
      }
    };
  }, function (e, t, n) {
    var r = n(11),
        o = n(6).document,
        i = r(o) && r(o.createElement);

    e.exports = function (e) {
      return i ? o.createElement(e) : {};
    };
  }, function (e, t, n) {
    var r = n(11);

    e.exports = function (e, t) {
      if (!r(e)) return e;
      var n, o;
      if (t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
      if ("function" == typeof (n = e.valueOf) && !r(o = n.call(e))) return o;
      if (!t && "function" == typeof (n = e.toString) && !r(o = n.call(e))) return o;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: t
      };
    };
  }, function (e, t, n) {
    var r = n(6),
        o = n(8),
        i = n(19),
        a = n(20)("src"),
        s = Function.toString,
        l = ("" + s).split("toString");
    n(7).inspectSource = function (e) {
      return s.call(e);
    }, (e.exports = function (e, t, n, s) {
      var c = "function" == typeof n;
      c && (i(n, "name") || o(n, "name", t)), e[t] !== n && (c && (i(n, a) || o(n, a, e[t] ? "" + e[t] : l.join(String(t)))), e === r ? e[t] = n : s ? e[t] ? e[t] = n : o(e, t, n) : (delete e[t], o(e, t, n)));
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && this[a] || s.call(this);
    });
  }, function (e, t) {
    var n = {}.hasOwnProperty;

    e.exports = function (e, t) {
      return n.call(e, t);
    };
  }, function (e, t) {
    var n = 0,
        r = Math.random();

    e.exports = function (e) {
      return "Symbol(".concat(e === undefined ? "" : e, ")_", (++n + r).toString(36));
    };
  }, function (e, t, n) {
    var r = n(22);

    e.exports = function (e, t, n) {
      if (r(e), t === undefined) return e;

      switch (n) {
        case 1:
          return function (n) {
            return e.call(t, n);
          };

        case 2:
          return function (n, r) {
            return e.call(t, n, r);
          };

        case 3:
          return function (n, r, o) {
            return e.call(t, n, r, o);
          };
      }

      return function () {
        return e.apply(t, arguments);
      };
    };
  }, function (e, t) {
    e.exports = function (e) {
      if ("function" != typeof e) throw TypeError(e + " is not a function!");
      return e;
    };
  }, function (e, t, n) {
    var r = n(24),
        o = n(28).f,
        i = {}.toString,
        a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

    e.exports.f = function (e) {
      return a && "[object Window]" == i.call(e) ? function (e) {
        try {
          return o(e);
        } catch (t) {
          return a.slice();
        }
      }(e) : o(r(e));
    };
  }, function (e, t, n) {
    var r = n(25),
        o = n(27);

    e.exports = function (e) {
      return r(o(e));
    };
  }, function (e, t, n) {
    var r = n(26);
    e.exports = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
      return "String" == r(e) ? e.split("") : Object(e);
    };
  }, function (e, t) {
    var n = {}.toString;

    e.exports = function (e) {
      return n.call(e).slice(8, -1);
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (e == undefined) throw TypeError("Can't call method on  " + e);
      return e;
    };
  }, function (e, t, n) {
    var r = n(29),
        o = n(37).concat("length", "prototype");

    t.f = Object.getOwnPropertyNames || function (e) {
      return r(e, o);
    };
  }, function (e, t, n) {
    var r = n(19),
        o = n(24),
        i = n(30)(!1),
        a = n(34)("IE_PROTO");

    e.exports = function (e, t) {
      var n,
          s = o(e),
          l = 0,
          c = [];

      for (n in s) {
        n != a && r(s, n) && c.push(n);
      }

      for (; t.length > l;) {
        r(s, n = t[l++]) && (~i(c, n) || c.push(n));
      }

      return c;
    };
  }, function (e, t, n) {
    var r = n(24),
        o = n(31),
        i = n(33);

    e.exports = function (e) {
      return function (t, n, a) {
        var s,
            l = r(t),
            c = o(l.length),
            u = i(a, c);

        if (e && n != n) {
          for (; c > u;) {
            if ((s = l[u++]) != s) return !0;
          }
        } else for (; c > u; u++) {
          if ((e || u in l) && l[u] === n) return e || u || 0;
        }

        return !e && -1;
      };
    };
  }, function (e, t, n) {
    var r = n(32),
        o = Math.min;

    e.exports = function (e) {
      return e > 0 ? o(r(e), 9007199254740991) : 0;
    };
  }, function (e, t) {
    var n = Math.ceil,
        r = Math.floor;

    e.exports = function (e) {
      return isNaN(e = +e) ? 0 : (e > 0 ? r : n)(e);
    };
  }, function (e, t, n) {
    var r = n(32),
        o = Math.max,
        i = Math.min;

    e.exports = function (e, t) {
      return (e = r(e)) < 0 ? o(e + t, 0) : i(e, t);
    };
  }, function (e, t, n) {
    var r = n(35)("keys"),
        o = n(20);

    e.exports = function (e) {
      return r[e] || (r[e] = o(e));
    };
  }, function (e, t, n) {
    var r = n(7),
        o = n(6),
        i = o["__core-js_shared__"] || (o["__core-js_shared__"] = {});
    (e.exports = function (e, t) {
      return i[e] || (i[e] = t !== undefined ? t : {});
    })("versions", []).push({
      version: r.version,
      mode: n(36) ? "pure" : "global",
      copyright: "© 2018 Denis Pushkarev (zloirock.ru)"
    });
  }, function (e, t) {
    e.exports = !1;
  }, function (e, t) {
    e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (e, t, n) {
    n(39);
    var r = n(7).Object;

    e.exports = function (e, t) {
      return r.getOwnPropertyDescriptor(e, t);
    };
  }, function (e, t, n) {
    var r = n(24),
        o = n(40).f;
    n(4)("getOwnPropertyDescriptor", function () {
      return function (e, t) {
        return o(r(e), t);
      };
    });
  }, function (e, t, n) {
    var r = n(41),
        o = n(17),
        i = n(24),
        a = n(16),
        s = n(19),
        l = n(12),
        c = Object.getOwnPropertyDescriptor;
    t.f = n(13) ? c : function (e, t) {
      if (e = i(e), t = a(t, !0), l) try {
        return c(e, t);
      } catch (n) {}
      if (s(e, t)) return o(!r.f.call(e, t), e[t]);
    };
  }, function (e, t) {
    t.f = {}.propertyIsEnumerable;
  }, function (e, t, n) {
    n(43);
    var r = n(7).Object;

    e.exports = function (e, t, n) {
      return r.defineProperty(e, t, n);
    };
  }, function (e, t, n) {
    var r = n(5);
    r(r.S + r.F * !n(13), "Object", {
      defineProperty: n(9).f
    });
  }, function (e, t, n) {
    n(45);
    var r = n(7).Object;

    e.exports = function (e, t) {
      return r.create(e, t);
    };
  }, function (e, t, n) {
    var r = n(5);
    r(r.S, "Object", {
      create: n(46)
    });
  }, function (e, t, n) {
    var r = n(10),
        o = n(47),
        i = n(37),
        a = n(34)("IE_PROTO"),
        s = function s() {},
        _l = function l() {
      var e,
          t = n(15)("iframe"),
          r = i.length;

      for (t.style.display = "none", n(49).appendChild(t), t.src = "javascript:", (e = t.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), _l = e.F; r--;) {
        delete _l.prototype[i[r]];
      }

      return _l();
    };

    e.exports = Object.create || function (e, t) {
      var n;
      return null !== e ? (s.prototype = r(e), n = new s(), s.prototype = null, n[a] = e) : n = _l(), t === undefined ? n : o(n, t);
    };
  }, function (e, t, n) {
    var r = n(9),
        o = n(10),
        i = n(48);
    e.exports = n(13) ? Object.defineProperties : function (e, t) {
      o(e);

      for (var n, a = i(t), s = a.length, l = 0; s > l;) {
        r.f(e, n = a[l++], t[n]);
      }

      return e;
    };
  }, function (e, t, n) {
    var r = n(29),
        o = n(37);

    e.exports = Object.keys || function (e) {
      return r(e, o);
    };
  }, function (e, t, n) {
    var r = n(6).document;
    e.exports = r && r.documentElement;
  }, function (e, t, n) {
    n(51), e.exports = n(7).Object.keys;
  }, function (e, t, n) {
    var r = n(52),
        o = n(48);
    n(4)("keys", function () {
      return function (e) {
        return o(r(e));
      };
    });
  }, function (e, t, n) {
    var r = n(27);

    e.exports = function (e) {
      return Object(r(e));
    };
  }, function (e, t, n) {
    n(54), e.exports = n(7).Object.entries;
  }, function (e, t, n) {
    var r = n(5),
        o = n(55)(!0);
    r(r.S, "Object", {
      entries: function entries(e) {
        return o(e);
      }
    });
  }, function (e, t, n) {
    var r = n(48),
        o = n(24),
        i = n(41).f;

    e.exports = function (e) {
      return function (t) {
        for (var n, a = o(t), s = r(a), l = s.length, c = 0, u = []; l > c;) {
          i.call(a, n = s[c++]) && u.push(e ? [n, a[n]] : a[n]);
        }

        return u;
      };
    };
  }, function (e, t, n) {
    n(57), e.exports = n(7).Array.indexOf;
  }, function (e, t, n) {
    "use strict";

    var r = n(5),
        o = n(30)(!1),
        i = [].indexOf,
        a = !!i && 1 / [1].indexOf(1, -0) < 0;
    r(r.P + r.F * (a || !n(58)(i)), "Array", {
      indexOf: function indexOf(e) {
        return a ? i.apply(this, arguments) || 0 : o(this, e, arguments[1]);
      }
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(14);

    e.exports = function (e, t) {
      return !!e && r(function () {
        t ? e.call(null, function () {}, 1) : e.call(null);
      });
    };
  }, function (e, t, n) {
    n(60), e.exports = n(7).Array.forEach;
  }, function (e, t, n) {
    "use strict";

    var r = n(5),
        o = n(61)(0),
        i = n(58)([].forEach, !0);
    r(r.P + r.F * !i, "Array", {
      forEach: function forEach(e) {
        return o(this, e, arguments[1]);
      }
    });
  }, function (e, t, n) {
    var r = n(21),
        o = n(25),
        i = n(52),
        a = n(31),
        s = n(62);

    e.exports = function (e, t) {
      var n = 1 == e,
          l = 2 == e,
          c = 3 == e,
          u = 4 == e,
          d = 6 == e,
          f = 5 == e || d,
          h = t || s;
      return function (t, s, p) {
        for (var g, m, v = i(t), y = o(v), b = r(s, p, 3), x = a(y.length), w = 0, C = n ? h(t, x) : l ? h(t, 0) : undefined; x > w; w++) {
          if ((f || w in y) && (m = b(g = y[w], w, v), e)) if (n) C[w] = m;else if (m) switch (e) {
            case 3:
              return !0;

            case 5:
              return g;

            case 6:
              return w;

            case 2:
              C.push(g);
          } else if (u) return !1;
        }

        return d ? -1 : c || u ? u : C;
      };
    };
  }, function (e, t, n) {
    var r = n(63);

    e.exports = function (e, t) {
      return new (r(e))(t);
    };
  }, function (e, t, n) {
    var r = n(11),
        o = n(64),
        i = n(65)("species");

    e.exports = function (e) {
      var t;
      return o(e) && ("function" != typeof (t = e.constructor) || t !== Array && !o(t.prototype) || (t = undefined), r(t) && null === (t = t[i]) && (t = undefined)), t === undefined ? Array : t;
    };
  }, function (e, t, n) {
    var r = n(26);

    e.exports = Array.isArray || function (e) {
      return "Array" == r(e);
    };
  }, function (e, t, n) {
    var r = n(35)("wks"),
        o = n(20),
        i = n(6).Symbol,
        a = "function" == typeof i;
    (e.exports = function (e) {
      return r[e] || (r[e] = a && i[e] || (a ? i : o)("Symbol." + e));
    }).store = r;
  }, function (e, t, n) {
    n(67), e.exports = n(7).Array.map;
  }, function (e, t, n) {
    "use strict";

    var r = n(5),
        o = n(61)(1);
    r(r.P + r.F * !n(58)([].map, !0), "Array", {
      map: function map(e) {
        return o(this, e, arguments[1]);
      }
    });
  }, function (e, t, n) {
    n(69), e.exports = n(7).Array.filter;
  }, function (e, t, n) {
    "use strict";

    var r = n(5),
        o = n(61)(2);
    r(r.P + r.F * !n(58)([].filter, !0), "Array", {
      filter: function filter(e) {
        return o(this, e, arguments[1]);
      }
    });
  }, function (e, t, n) {
    n(71), e.exports = n(7).Array.reduce;
  }, function (e, t, n) {
    "use strict";

    var r = n(5),
        o = n(72);
    r(r.P + r.F * !n(58)([].reduce, !0), "Array", {
      reduce: function reduce(e) {
        return o(this, e, arguments.length, arguments[1], !1);
      }
    });
  }, function (e, t, n) {
    var r = n(22),
        o = n(52),
        i = n(25),
        a = n(31);

    e.exports = function (e, t, n, s, l) {
      r(t);
      var c = o(e),
          u = i(c),
          d = a(c.length),
          f = l ? d - 1 : 0,
          h = l ? -1 : 1;
      if (n < 2) for (;;) {
        if (f in u) {
          s = u[f], f += h;
          break;
        }

        if (f += h, l ? f < 0 : d <= f) throw TypeError("Reduce of empty array with no initial value");
      }

      for (; l ? f >= 0 : d > f; f += h) {
        f in u && (s = t(s, u[f], f, c));
      }

      return s;
    };
  }, function (e, t, n) {
    n(74), e.exports = n(7).Array.isArray;
  }, function (e, t, n) {
    var r = n(5);
    r(r.S, "Array", {
      isArray: n(64)
    });
  }, function (e, t, n) {
    n(76), e.exports = n(7).Array.some;
  }, function (e, t, n) {
    "use strict";

    var r = n(5),
        o = n(61)(3);
    r(r.P + r.F * !n(58)([].some, !0), "Array", {
      some: function some(e) {
        return o(this, e, arguments[1]);
      }
    });
  }, function (e, t, n) {
    n(78), n(85), e.exports = n(7).Array.from;
  }, function (e, t, n) {
    "use strict";

    var r = n(79)(!0);
    n(80)(String, "String", function (e) {
      this._t = String(e), this._i = 0;
    }, function () {
      var e,
          t = this._t,
          n = this._i;
      return n >= t.length ? {
        value: undefined,
        done: !0
      } : (e = r(t, n), this._i += e.length, {
        value: e,
        done: !1
      });
    });
  }, function (e, t, n) {
    var r = n(32),
        o = n(27);

    e.exports = function (e) {
      return function (t, n) {
        var i,
            a,
            s = String(o(t)),
            l = r(n),
            c = s.length;
        return l < 0 || l >= c ? e ? "" : undefined : (i = s.charCodeAt(l)) < 55296 || i > 56319 || l + 1 === c || (a = s.charCodeAt(l + 1)) < 56320 || a > 57343 ? e ? s.charAt(l) : i : e ? s.slice(l, l + 2) : a - 56320 + (i - 55296 << 10) + 65536;
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(36),
        o = n(5),
        i = n(18),
        a = n(8),
        s = n(81),
        l = n(82),
        c = n(83),
        u = n(84),
        d = n(65)("iterator"),
        f = !([].keys && "next" in [].keys()),
        h = function h() {
      return this;
    };

    e.exports = function (e, t, n, p, g, m, v) {
      l(n, t, p);

      var y,
          b,
          x,
          w = function w(e) {
        if (!f && e in E) return E[e];

        switch (e) {
          case "keys":
          case "values":
            return function () {
              return new n(this, e);
            };
        }

        return function () {
          return new n(this, e);
        };
      },
          C = t + " Iterator",
          _ = "values" == g,
          S = !1,
          E = e.prototype,
          k = E[d] || E["@@iterator"] || g && E[g],
          A = k || w(g),
          T = g ? _ ? w("entries") : A : undefined,
          M = "Array" == t && E.entries || k;

      if (M && (x = u(M.call(new e()))) !== Object.prototype && x.next && (c(x, C, !0), r || "function" == typeof x[d] || a(x, d, h)), _ && k && "values" !== k.name && (S = !0, A = function A() {
        return k.call(this);
      }), r && !v || !f && !S && E[d] || a(E, d, A), s[t] = A, s[C] = h, g) if (y = {
        values: _ ? A : w("values"),
        keys: m ? A : w("keys"),
        entries: T
      }, v) for (b in y) {
        b in E || i(E, b, y[b]);
      } else o(o.P + o.F * (f || S), t, y);
      return y;
    };
  }, function (e, t) {
    e.exports = {};
  }, function (e, t, n) {
    "use strict";

    var r = n(46),
        o = n(17),
        i = n(83),
        a = {};
    n(8)(a, n(65)("iterator"), function () {
      return this;
    }), e.exports = function (e, t, n) {
      e.prototype = r(a, {
        next: o(1, n)
      }), i(e, t + " Iterator");
    };
  }, function (e, t, n) {
    var r = n(9).f,
        o = n(19),
        i = n(65)("toStringTag");

    e.exports = function (e, t, n) {
      e && !o(e = n ? e : e.prototype, i) && r(e, i, {
        configurable: !0,
        value: t
      });
    };
  }, function (e, t, n) {
    var r = n(19),
        o = n(52),
        i = n(34)("IE_PROTO"),
        a = Object.prototype;

    e.exports = Object.getPrototypeOf || function (e) {
      return e = o(e), r(e, i) ? e[i] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? a : null;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(21),
        o = n(5),
        i = n(52),
        a = n(86),
        s = n(87),
        l = n(31),
        c = n(88),
        u = n(89);
    o(o.S + o.F * !n(91)(function (e) {
      Array.from(e);
    }), "Array", {
      from: function from(e) {
        var t,
            n,
            o,
            d,
            f = i(e),
            h = "function" == typeof this ? this : Array,
            p = arguments.length,
            g = p > 1 ? arguments[1] : undefined,
            m = g !== undefined,
            v = 0,
            y = u(f);
        if (m && (g = r(g, p > 2 ? arguments[2] : undefined, 2)), y == undefined || h == Array && s(y)) for (n = new h(t = l(f.length)); t > v; v++) {
          c(n, v, m ? g(f[v], v) : f[v]);
        } else for (d = y.call(f), n = new h(); !(o = d.next()).done; v++) {
          c(n, v, m ? a(d, g, [o.value, v], !0) : o.value);
        }
        return n.length = v, n;
      }
    });
  }, function (e, t, n) {
    var r = n(10);

    e.exports = function (e, t, n, o) {
      try {
        return o ? t(r(n)[0], n[1]) : t(n);
      } catch (a) {
        var i = e["return"];
        throw i !== undefined && r(i.call(e)), a;
      }
    };
  }, function (e, t, n) {
    var r = n(81),
        o = n(65)("iterator"),
        i = Array.prototype;

    e.exports = function (e) {
      return e !== undefined && (r.Array === e || i[o] === e);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        o = n(17);

    e.exports = function (e, t, n) {
      t in e ? r.f(e, t, o(0, n)) : e[t] = n;
    };
  }, function (e, t, n) {
    var r = n(90),
        o = n(65)("iterator"),
        i = n(81);

    e.exports = n(7).getIteratorMethod = function (e) {
      if (e != undefined) return e[o] || e["@@iterator"] || i[r(e)];
    };
  }, function (e, t, n) {
    var r = n(26),
        o = n(65)("toStringTag"),
        i = "Arguments" == r(function () {
      return arguments;
    }());

    e.exports = function (e) {
      var t, n, a;
      return e === undefined ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function (e, t) {
        try {
          return e[t];
        } catch (n) {}
      }(t = Object(e), o)) ? n : i ? r(t) : "Object" == (a = r(t)) && "function" == typeof t.callee ? "Arguments" : a;
    };
  }, function (e, t, n) {
    var r = n(65)("iterator"),
        o = !1;

    try {
      var i = [7][r]();
      i["return"] = function () {
        o = !0;
      }, Array.from(i, function () {
        throw 2;
      });
    } catch (a) {}

    e.exports = function (e, t) {
      if (!t && !o) return !1;
      var n = !1;

      try {
        var i = [7],
            s = i[r]();
        s.next = function () {
          return {
            done: n = !0
          };
        }, i[r] = function () {
          return s;
        }, e(i);
      } catch (a) {}

      return n;
    };
  }, function (e, t, n) {
    "use strict";

    n(93), n(96), n(99), n(77), n(101), n(104), n(106), n(108), n(110), n(112), n(114), Element.prototype.remove || (Element.prototype.remove = function () {
      this.parentNode && this.parentNode.removeChild(this);
    });
  }, function (e, t, n) {
    n(94), e.exports = n(7).Math.sign;
  }, function (e, t, n) {
    var r = n(5);
    r(r.S, "Math", {
      sign: n(95)
    });
  }, function (e, t) {
    e.exports = Math.sign || function (e) {
      return 0 == (e = +e) || e != e ? e : e < 0 ? -1 : 1;
    };
  }, function (e, t, n) {
    n(97), e.exports = n(7).Array.findIndex;
  }, function (e, t, n) {
    "use strict";

    var r = n(5),
        o = n(61)(6),
        i = "findIndex",
        a = !0;
    i in [] && Array(1)[i](function () {
      a = !1;
    }), r(r.P + r.F * a, "Array", {
      findIndex: function findIndex(e) {
        return o(this, e, arguments.length > 1 ? arguments[1] : undefined);
      }
    }), n(98)(i);
  }, function (e, t, n) {
    var r = n(65)("unscopables"),
        o = Array.prototype;
    o[r] == undefined && n(8)(o, r, {}), e.exports = function (e) {
      o[r][e] = !0;
    };
  }, function (e, t, n) {
    n(100), e.exports = n(7).Array.find;
  }, function (e, t, n) {
    "use strict";

    var r = n(5),
        o = n(61)(5),
        i = !0;
    "find" in [] && Array(1).find(function () {
      i = !1;
    }), r(r.P + r.F * i, "Array", {
      find: function find(e) {
        return o(this, e, arguments.length > 1 ? arguments[1] : undefined);
      }
    }), n(98)("find");
  }, function (e, t, n) {
    n(102), e.exports = n(7).Array.fill;
  }, function (e, t, n) {
    var r = n(5);
    r(r.P, "Array", {
      fill: n(103)
    }), n(98)("fill");
  }, function (e, t, n) {
    "use strict";

    var r = n(52),
        o = n(33),
        i = n(31);

    e.exports = function (e) {
      for (var t = r(this), n = i(t.length), a = arguments.length, s = o(a > 1 ? arguments[1] : undefined, n), l = a > 2 ? arguments[2] : undefined, c = l === undefined ? n : o(l, n); c > s;) {
        t[s++] = e;
      }

      return t;
    };
  }, function (e, t, n) {
    n(105), e.exports = n(7).Array.includes;
  }, function (e, t, n) {
    "use strict";

    var r = n(5),
        o = n(30)(!0);
    r(r.P, "Array", {
      includes: function includes(e) {
        return o(this, e, arguments.length > 1 ? arguments[1] : undefined);
      }
    }), n(98)("includes");
  }, function (e, t, n) {
    n(107), e.exports = Math.pow(2, -52);
  }, function (e, t, n) {
    var r = n(5);
    r(r.S, "Number", {
      EPSILON: Math.pow(2, -52)
    });
  }, function (e, t, n) {
    n(109), e.exports = -9007199254740991;
  }, function (e, t, n) {
    var r = n(5);
    r(r.S, "Number", {
      MIN_SAFE_INTEGER: -9007199254740991
    });
  }, function (e, t, n) {
    n(111), e.exports = 9007199254740991;
  }, function (e, t, n) {
    var r = n(5);
    r(r.S, "Number", {
      MAX_SAFE_INTEGER: 9007199254740991
    });
  }, function (e, t, n) {
    n(113), e.exports = n(7).Number.isFinite;
  }, function (e, t, n) {
    var r = n(5),
        o = n(6).isFinite;
    r(r.S, "Number", {
      isFinite: function isFinite(e) {
        return "number" == typeof e && o(e);
      }
    });
  }, function (e, t, n) {
    n(115), e.exports = n(7).Number.isNaN;
  }, function (e, t, n) {
    var r = n(5);
    r(r.S, "Number", {
      isNaN: function isNaN(e) {
        return e != e;
      }
    });
  }, function (e, t, n) {
    (function (e, t) {
      !function () {
        "use strict";

        function n() {}

        function r(e) {
          if (!(this instanceof r)) throw new TypeError("Promises must be constructed via new");
          if ("function" != typeof e) throw new TypeError("not a function");
          this._state = 0, this._handled = !1, this._value = undefined, this._deferreds = [], l(e, this);
        }

        function o(e, t) {
          for (; 3 === e._state;) {
            e = e._value;
          }

          0 !== e._state ? (e._handled = !0, r._immediateFn(function () {
            var n = 1 === e._state ? t.onFulfilled : t.onRejected;

            if (null !== n) {
              var r;

              try {
                r = n(e._value);
              } catch (l) {
                return void a(t.promise, l);
              }

              i(t.promise, r);
            } else (1 === e._state ? i : a)(t.promise, e._value);
          })) : e._deferreds.push(t);
        }

        function i(e, t) {
          try {
            if (t === e) throw new TypeError("A promise cannot be resolved with itself.");

            if (t && ("object" == typeof t || "function" == typeof t)) {
              var n = t.then;
              if (t instanceof r) return e._state = 3, e._value = t, void s(e);
              if ("function" == typeof n) return void l(function (e, t) {
                return function () {
                  e.apply(t, arguments);
                };
              }(n, t), e);
            }

            e._state = 1, e._value = t, s(e);
          } catch (c) {
            a(e, c);
          }
        }

        function a(e, t) {
          e._state = 2, e._value = t, s(e);
        }

        function s(e) {
          2 === e._state && 0 === e._deferreds.length && r._immediateFn(function () {
            e._handled || r._unhandledRejectionFn(e._value);
          });

          for (var t = 0, n = e._deferreds.length; n > t; t++) {
            o(e, e._deferreds[t]);
          }

          e._deferreds = null;
        }

        function l(e, t) {
          var n = !1;

          try {
            e(function (e) {
              n || (n = !0, i(t, e));
            }, function (e) {
              n || (n = !0, a(t, e));
            });
          } catch (s) {
            if (n) return;
            n = !0, a(t, s);
          }
        }

        var c = setTimeout;
        r.prototype["catch"] = function (e) {
          return this.then(null, e);
        }, r.prototype.then = function (e, t) {
          var r = new this.constructor(n);
          return o(this, new function (e, t, n) {
            this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.promise = n;
          }(e, t, r)), r;
        }, r.prototype["finally"] = function (e) {
          var t = this.constructor;
          return this.then(function (n) {
            return t.resolve(e()).then(function () {
              return n;
            });
          }, function (n) {
            return t.resolve(e()).then(function () {
              return t.reject(n);
            });
          });
        }, r.all = function (e) {
          return new r(function (t, n) {
            function r(e, a) {
              try {
                if (a && ("object" == typeof a || "function" == typeof a)) {
                  var s = a.then;
                  if ("function" == typeof s) return void s.call(a, function (t) {
                    r(e, t);
                  }, n);
                }

                o[e] = a, 0 == --i && t(o);
              } catch (u) {
                n(u);
              }
            }

            if (!e || "undefined" == typeof e.length) throw new TypeError("Promise.all accepts an array");
            var o = Array.prototype.slice.call(e);
            if (0 === o.length) return t([]);

            for (var i = o.length, a = 0; o.length > a; a++) {
              r(a, o[a]);
            }
          });
        }, r.resolve = function (e) {
          return e && "object" == typeof e && e.constructor === r ? e : new r(function (t) {
            t(e);
          });
        }, r.reject = function (e) {
          return new r(function (t, n) {
            n(e);
          });
        }, r.race = function (e) {
          return new r(function (t, n) {
            for (var r = 0, o = e.length; o > r; r++) {
              e[r].then(t, n);
            }
          });
        }, r._immediateFn = "function" == typeof e && function (t) {
          e(t);
        } || function (e) {
          c(e, 0);
        }, r._unhandledRejectionFn = function (e) {
          void 0 !== console && console && console.warn("Possible Unhandled Promise Rejection:", e);
        };

        var u = function () {
          if ("undefined" != typeof self) return self;
          if ("undefined" != typeof window) return window;
          if (void 0 !== t) return t;
          throw Error("unable to locate global object");
        }();

        u.Promise || (u.Promise = r);
      }();
    }).call(this, n(117).setImmediate, n(118));
  }, function (e, t, n) {
    (function (e) {
      var r = void 0 !== e && e || "undefined" != typeof self && self || window,
          o = Function.prototype.apply;

      function i(e, t) {
        this._id = e, this._clearFn = t;
      }

      t.setTimeout = function () {
        return new i(o.call(setTimeout, r, arguments), clearTimeout);
      }, t.setInterval = function () {
        return new i(o.call(setInterval, r, arguments), clearInterval);
      }, t.clearTimeout = t.clearInterval = function (e) {
        e && e.close();
      }, i.prototype.unref = i.prototype.ref = function () {}, i.prototype.close = function () {
        this._clearFn.call(r, this._id);
      }, t.enroll = function (e, t) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
      }, t.unenroll = function (e) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
      }, t._unrefActive = t.active = function (e) {
        clearTimeout(e._idleTimeoutId);
        var t = e._idleTimeout;
        t >= 0 && (e._idleTimeoutId = setTimeout(function () {
          e._onTimeout && e._onTimeout();
        }, t));
      }, n(119), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
    }).call(this, n(118));
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (r) {
      "object" == typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    (function (e, t) {
      !function (e, n) {
        "use strict";

        if (!e.setImmediate) {
          var r,
              o,
              i,
              a,
              s,
              l = 1,
              c = {},
              u = !1,
              d = e.document,
              f = Object.getPrototypeOf && Object.getPrototypeOf(e);
          f = f && f.setTimeout ? f : e, "[object process]" === {}.toString.call(e.process) ? r = function r(e) {
            t.nextTick(function () {
              p(e);
            });
          } : !function () {
            if (e.postMessage && !e.importScripts) {
              var t = !0,
                  n = e.onmessage;
              return e.onmessage = function () {
                t = !1;
              }, e.postMessage("", "*"), e.onmessage = n, t;
            }
          }() ? e.MessageChannel ? ((i = new MessageChannel()).port1.onmessage = function (e) {
            p(e.data);
          }, r = function r(e) {
            i.port2.postMessage(e);
          }) : d && "onreadystatechange" in d.createElement("script") ? (o = d.documentElement, r = function r(e) {
            var t = d.createElement("script");
            t.onreadystatechange = function () {
              p(e), t.onreadystatechange = null, o.removeChild(t), t = null;
            }, o.appendChild(t);
          }) : r = function r(e) {
            setTimeout(p, 0, e);
          } : (a = "setImmediate$" + Math.random() + "$", s = function s(t) {
            t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(a) && p(+t.data.slice(a.length));
          }, e.addEventListener ? e.addEventListener("message", s, !1) : e.attachEvent("onmessage", s), r = function r(t) {
            e.postMessage(a + t, "*");
          }), f.setImmediate = function (e) {
            "function" != typeof e && (e = new Function("" + e));

            for (var t = new Array(arguments.length - 1), n = 0; n < t.length; n++) {
              t[n] = arguments[n + 1];
            }

            var o = {
              callback: e,
              args: t
            };
            return c[l] = o, r(l), l++;
          }, f.clearImmediate = h;
        }

        function h(e) {
          delete c[e];
        }

        function p(e) {
          if (u) setTimeout(p, 0, e);else {
            var t = c[e];

            if (t) {
              u = !0;

              try {
                !function (e) {
                  var t = e.callback,
                      r = e.args;

                  switch (r.length) {
                    case 0:
                      t();
                      break;

                    case 1:
                      t(r[0]);
                      break;

                    case 2:
                      t(r[0], r[1]);
                      break;

                    case 3:
                      t(r[0], r[1], r[2]);
                      break;

                    default:
                      t.apply(n, r);
                  }
                }(t);
              } finally {
                h(e), u = !1;
              }
            }
          }
        }
      }("undefined" == typeof self ? void 0 === e ? this : e : self);
    }).call(this, n(118), n(120));
  }, function (e, t) {
    var n,
        r,
        o = e.exports = {};

    function i() {
      throw new Error("setTimeout has not been defined");
    }

    function a() {
      throw new Error("clearTimeout has not been defined");
    }

    function s(e) {
      if (n === setTimeout) return setTimeout(e, 0);
      if ((n === i || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

      try {
        return n(e, 0);
      } catch (t) {
        try {
          return n.call(null, e, 0);
        } catch (t) {
          return n.call(this, e, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : i;
      } catch (e) {
        n = i;
      }

      try {
        r = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (e) {
        r = a;
      }
    }();
    var l,
        c = [],
        u = !1,
        d = -1;

    function f() {
      u && l && (u = !1, l.length ? c = l.concat(c) : d = -1, c.length && h());
    }

    function h() {
      if (!u) {
        var e = s(f);
        u = !0;

        for (var t = c.length; t;) {
          for (l = c, c = []; ++d < t;) {
            l && l[d].run();
          }

          d = -1, t = c.length;
        }

        l = null, u = !1, function (e) {
          if (r === clearTimeout) return clearTimeout(e);
          if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

          try {
            r(e);
          } catch (t) {
            try {
              return r.call(null, e);
            } catch (t) {
              return r.call(this, e);
            }
          }
        }(e);
      }
    }

    function p(e, t) {
      this.fun = e, this.array = t;
    }

    function g() {}

    o.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      c.push(new p(e, t)), 1 !== c.length || u || s(h);
    }, p.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = g, o.addListener = g, o.once = g, o.off = g, o.removeListener = g, o.removeAllListeners = g, o.emit = g, o.prependListener = g, o.prependOnceListener = g, o.listeners = function (e) {
      return [];
    }, o.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, o.cwd = function () {
      return "/";
    }, o.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, o.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = s(n(122)),
        o = s(n(353)),
        i = s(n(354)),
        a = s(n(166));

    function s(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    r["default"].addDep(a["default"]);
    var l,
        c = (l = {}, function (e) {
      return e = e && e.replace(/(^\s*)|(\s*$)/g, "") || "", l[e] || (l[e] = {
        key: e,
        subject: e.replace(/[^\/]*?$/gi, ""),
        predicate: e.replace(/^.*\//gi, "")
      });
    });

    function u(e) {
      var t,
          n = r["default"].options;
      return e = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        return "" === e ? e : e.replace(/^[\s\S]*\//gi, "").replace(/\?/g, "%3F").replace(/\#/g, "%23").replace(/\:/g, "%3A");
      }((t = c(e)).predicate), t.subject + n.html5ScriptNamePrefix + e + n.html5ScriptNameSuffix;
    }

    r["default"].addEventListener("resourceRequested", function (e) {
      var t = e.sender,
          a = t.chartType(),
          s = t.options.chartTypeSourcePath || "";
      r["default"].getDep(a, "chartapi") || r["default"].getDep(a, "maps") || r["default"].addDep({
        name: a,
        type: "dependency",
        extension: function (e) {
          switch (o["default"][e]) {
            case "charts":
              return Promise.all([n.e(2), n.e(1)]).then(n.t.bind(null, 356, 7));

            case "timeseries":
              return Promise.all([n.e(2), n.e(3)]).then(n.t.bind(null, 610, 7));

            case "powercharts":
              return Promise.all([n.e(2), n.e(4)]).then(n.t.bind(null, 831, 7));

            case "widgets":
              return Promise.all([n.e(2), n.e(5)]).then(n.t.bind(null, 970, 7));

            case "zoomline":
              return Promise.all([n.e(2), n.e(6)]).then(n.t.bind(null, 1064, 7));

            case "gantt":
              return Promise.all([n.e(2), n.e(7)]).then(n.t.bind(null, 1075, 7));

            case "treemap":
              return Promise.all([n.e(2), n.e(8)]).then(n.t.bind(null, 1093, 7));

            case "zoomscatter":
              return Promise.all([n.e(2), n.e(9)]).then(n.t.bind(null, 1099, 7));

            case "msstackedcolumn2dsplinedy":
              return Promise.all([n.e(2), n.e(10)]).then(n.t.bind(null, 1103, 7));

            case "overlappedbar2d":
              return Promise.all([n.e(2), n.e(11)]).then(n.t.bind(null, 1107, 7));

            case "overlappedcolumn2d":
              return Promise.all([n.e(2), n.e(12)]).then(n.t.bind(null, 1112, 7));

            default:
              return (0, i["default"])("" + r["default"].getScriptBaseURI() + u(e));
          }
        }(s + a)
      });
    }), window && n(355) && (window.FusionCharts = r["default"]), t["default"] = r["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        o = u(n(123)),
        i = n(131),
        a = u(n(272)),
        s = n(320),
        l = n(349),
        c = n(350);

    function u(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    o["default"].DataStore = a["default"], o["default"].DataStore.Operators = {
      between: s.between,
      equals: s.equals,
      less: s.less,
      lessEquals: s.lessEquals,
      greater: s.greater,
      greaterEquals: s.greaterEquals,
      filter: s.filter,
      select: s.select,
      groupBy: s.groupBy,
      pipe: s.pipe,
      sort: s.sort,
      pivot: s.pivot
    }, o["default"].Utils = {
      duration: c.duration,
      before: c.before,
      after: c.after,
      parseDate: c.parseDate,
      formatDate: c.formatDate,
      DatetimeUnits: c.DatetimeUnits,
      Weekdays: c.Weekdays
    }, o["default"].DataStore.Aggregators = {
      aggregatorStore: l.aggregatorStore
    };

    var d = ["type", "id", "width", "height", "debugMode", "registerWithJS", "backgroundColor", "scaleMode", "lang", "detectFlashVersion", "autoInstallRedirect"],
        f = function f(e, t) {
      var n, o;

      for (n = 0, o = d.length; n < o; n++) {
        "object" === r(t[n]) ? Object.assign(e, t[n]) : e[d[n]] = t[n];
      }

      return e;
    };

    function h(e) {
      return this instanceof h ? (1 === arguments.length && "object" === (void 0 === e ? "undefined" : r(e)) || (e = f({}, arguments)), new (Function.prototype.bind.apply(o["default"], [null].concat(e)))()) : 1 === arguments.length && e instanceof Array && "private" === e[0] ? o["default"].register("module", e) : 1 === arguments.length && "string" == typeof e ? o["default"].getChartFromId(e) : void (0, i.raiseError)(h, "25081840", "run", "", new SyntaxError('Use the "new" keyword while creating a new FusionCharts object'));
    }

    for (var p in h.prototype = o["default"].prototype, o["default"]) {
      o["default"].hasOwnProperty(p) && (h[p] = o["default"][p]);
    }

    t["default"] = h;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = i(n(124)),
        o = i(n(166));

    function i(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    r["default"].addDep(o["default"]), t["default"] = r["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        o = n(125),
        i = n(131),
        a = n(132),
        s = n(133),
        l = C(n(134)),
        c = n(135),
        u = C(c),
        d = C(n(142)),
        f = n(136),
        h = C(n(145)),
        p = C(n(146)),
        g = C(n(147)),
        m = C(n(148)),
        v = C(n(151)),
        y = C(n(153)),
        b = C(n(154)),
        x = C(n(161)),
        w = C(n(165));

    function C(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var _,
        S,
        E,
        k,
        A = "json",
        T = "3.13.3-sr.1",
        M = /(^|[\/\\])(fusioncharts\.js)([\?#].*)?$/gi,
        O = /^(FusionCharts|FusionWidgets|FusionMaps)/,
        F = /[^\%\d]*$/gi,
        I = /url$/i,
        L = !0,
        N = function N(e) {
      return e.toString().toLowerCase();
    },
        D = (S = {}, E = function E() {
      return {
        state: 2
      };
    }, k = function de() {
      var e,
          t,
          n,
          r,
          o,
          i = 0,
          a = parseInt(ue.options.visibilityTrackingInterval, 10) || 300;

      for (e in S) {
        if (i += 1, t = S[e].chart, n = S[e].container, r = S[e].insertMode, o = S[e].callback, t.disposed || !P(n)) {
          if (delete S[e], i -= 1, delete t.containerHidden, t.disposed) return;
          t.renderOpts = {
            containerElement: n,
            insertMode: r,
            callback: o
          }, t._addChartDependency("chartContainer", {
            scopeOf: t,
            opts: {
              containerElement: n,
              insertMode: r,
              callback: o
            },
            resolve: le
          }), t._setState();
        } else S[e] && S[e].chart && (S[e].chart.containerHidden = !0, S[e].chart._addChartDependency("chartContainer", {
          resolve: E
        }), S[e].chart._setState());
      }

      _ = i ? setTimeout(de, a) : clearTimeout(_);
    }, function (e, t, n, r) {
      S[e.id] = {
        chart: e,
        container: t,
        insertMode: n,
        callback: r
      }, _ || (_ = setTimeout(k, parseInt(ue.options.visibilityTrackingInterval, 10) || 300));
    }),
        P = function fe(e) {
      var t = e.parentNode;
      return !!t && 9 !== t.nodeType && ("none" === function (e, t) {
        return window.getComputedStyle ? t = window.getComputedStyle(e).getPropertyValue(t) : e.currentStyle && (t = e.currentStyle[t]), t;
      }(e, "display") || !!t && fe(t));
    },
        R = void 0,
        j = void 0,
        V = void 0,
        B = 0,
        H = !1,
        G = ["disposed", "error", "waiting", "ready", "initialized"],
        z = {},
        U = "https://www.fusioncharts.com/dev/migration/deprecated-functionalities?version=3.13.0",
        $ = 'You are using incompatible files or deprecated "register" API of FusionCharts, please go through the docs to know more at ' + U,
        X = function X() {
      setTimeout(function () {
        R = !0, (0, i.triggerEvent)("ready", ue, {
          version: ue.version,
          now: !0
        });
      }, 1);
    };

    function W() {
      return this.state;
    }

    function Y() {
      return this.msg;
    }

    function q() {
      return this.msgStyle;
    }

    function K() {
      return "chartobject-" + (K.lastId += 1);
    }

    function J(e) {
      var t = {},
          n = void 0;

      for (n in e) {
        t[n.toLowerCase()] = e[n];
      }

      return t;
    }

    function Z(e) {
      var t = [],
          n = void 0;

      for (n in e) {
        t.push(n + "_" + e[n]);
      }

      return t.sort(), t.join(",");
    }

    function Q(e) {
      var t,
          n,
          r = e.options,
          o = e.args,
          i = e.options.showChartLoadingMessage;
      return t = {
        imageHAlign: o.loadMessageImageHAlign || r.baseChartMessageImageHAlign,
        imageVAlign: o.loadMessageImageVAlign || r.baseChartMessageImageVAlign,
        imageAlpha: o.loadMessageImageAlpha || r.baseChartMessageImageAlpha,
        imageScale: o.loadMessageImageScale || r.baseChartMessageImageScale
      }, n = {
        color: o.loadMessageColor || r.baseChartMessageColor,
        fontFamily: o.loadMessageFont || r.baseChartMessageFont,
        fontSize: o.loadMessageFontSize || r.baseChartMessageFontSize
      }, {
        msg: i ? r.PBarLoadingText || r.loadMessage : "",
        msgStyle: {
          message: n,
          image: t
        }
      };
    }

    function ee(e) {
      var t,
          n,
          r = e.args,
          o = e.options;
      return t = {
        imageHAlign: r.typeNotSupportedMessageImageHAlign || o.baseChartMessageImageHAlign,
        imageVAlign: r.typeNotSupportedMessageImageVAlign || o.baseChartMessageImageVAlign,
        imageAlpha: r.typeNotSupportedMessageImageAlpha || o.baseChartMessageImageAlpha,
        imageScale: r.typeNotSupportedMessageImageScale || o.baseChartMessageImageScale
      }, n = {
        color: r.typeNotSupportedMessageColor || o.baseChartMessageColor,
        fontFamily: r.typeNotSupportedMessageFont || o.baseChartMessageFont,
        fontSize: r.typeNotSupportedMessageFontSize || o.baseChartMessageFontSize
      }, H && (o.messageURL = U), {
        msg: H ? $ : o.typeNotSupportedMessage,
        msgStyle: {
          image: t,
          message: n
        }
      };
    }

    function te(e) {
      var t,
          n,
          r = e.args,
          o = e.options;
      return t = {
        imageHAlign: r.browserNotSupportedMessageImageHAlign || o.baseChartMessageImageHAlign,
        imageVAlign: r.browserNotSupportedMessageImageVAlign || o.baseChartMessageImageVAlign,
        imageAlpha: r.browserNotSupportedMessageImageAlpha || o.baseChartMessageImageAlpha,
        imageScale: r.browserNotSupportedMessageImageScale || o.baseChartMessageImageScale
      }, n = {
        color: r.browserNotSupportedMessageColor || o.baseChartMessageColor,
        fontFamily: r.browserNotSupportedMessageFont || o.baseChartMessageFont,
        fontSize: r.browserNotSupportedMessageFontSize || o.baseChartMessageFontSize
      }, {
        msg: o.browserNotSupportedMessage,
        msgStyle: {
          image: t,
          message: n
        }
      };
    }

    function ne() {
      H = !0;
    }

    function re(e) {
      var t,
          n,
          r = this.opts,
          l = r.data,
          c = r.sanitisedFormat,
          u = r.silent,
          d = (0, a.getDepsByType)("transcoder"),
          f = d[c] && d[c](),
          h = e.options,
          p = void 0,
          g = function (e) {
        var t,
            n,
            r = e.options,
            i = e.args;
        return t = {
          imageHAlign: (0, o.pluck)(i.dataInvalidMessageImageHAlign, r.baseChartMessageImageHAlign).toLowerCase(),
          imageVAlign: (0, o.pluck)(i.dataInvalidMessageImageVAlign, r.baseChartMessageImageVAlign).toLowerCase(),
          imageAlpha: (0, o.pluckNumber)(i.dataInvalidMessageImageAlpha, r.baseChartMessageImageAlpha),
          imageScale: (0, o.pluckNumber)(i.dataInvalidMessageImageScale, r.baseChartMessageImageScale)
        }, n = {
          fontFamily: i.dataInvalidMessageFont || r.baseChartMessageFont,
          fontSize: i.dataInvalidMessageFontSize || r.baseChartMessageFontSize,
          color: i.dataInvalidMessageColor || r.baseChartMessageColor
        }, {
          msg: r.dataInvalidMessage,
          msgStyle: {
            image: t,
            message: n
          }
        };
      }(e),
          m = g.msg,
          v = g.msgStyle,
          y = void 0;

      return e.__state.newDataArrived = !0, f && f.toJSON ? y = (p = f.toJSON(l, e)).error ? {
        state: 1,
        msg: m,
        msgStyle: v
      } : {
        state: 3
      } : (p = {
        error: new Error("Unable to convert data.")
      }, y = {
        state: 1,
        msg: m,
        msgStyle: v
      }), t = p.error ? p : p.data, h.dataErroneous = h.error = p.error, h.dataSource = t, h.dataFormat = c, n = function (e, t, n, r) {
        var o = {};
        return o.native = n === A, o.dataFormat = n, o.format = A, o.data = t, o.dataSource = e, o.silent = !!r, o;
      }(l, t, c, u), h.dataErroneous || (0, i.triggerEvent)("beforeDataUpdate", e, n, void 0, s.onDataUpdateSuccess, s.onDataUpdateCancel), y;
    }

    function oe(e) {
      var t,
          n,
          r,
          s,
          l,
          c = this.opts,
          u = c.url,
          d = u === undefined ? "" : u,
          f = c.format,
          h = c.config,
          p = c.callback,
          g = c.silent,
          m = (0, a.getDepsByType)("transcoder"),
          v = void 0,
          y = (s = (t = e).options, l = t.args, n = {
        imageHAlign: (0, o.pluck)(l.dataLoadStartMessageImageHAlign, s.baseChartMessageImageHAlign).toLowerCase(),
        imageVAlign: (0, o.pluck)(l.dataLoadStartMessageImageVAlign, s.baseChartMessageImageVAlign).toLowerCase(),
        imageAlpha: (0, o.pluckNumber)(l.dataLoadStartMessageImageAlpha, s.baseChartMessageImageAlpha),
        imageScale: (0, o.pluckNumber)(l.dataLoadStartMessageImageScale, s.baseChartMessageImageScale)
      }, r = {
        fontFamily: l.dataLoadStartMessageFont || s.baseChartMessageFont,
        fontSize: l.dataLoadStartMessageFontSize || s.baseChartMessageFontSize,
        color: l.dataLoadStartMessageColor || s.baseChartMessageColor
      }, {
        msg: s.dataLoadStartMessage,
        msgStyle: {
          image: n,
          message: r
        }
      }),
          b = y.msg,
          x = y.msgStyle,
          w = void 0;
      return void 0 !== f && null !== f && "function" == typeof f.toString || (f = e.options.dataFormat, (0, i.raiseWarning)(e, "03091609", "param", "FusionCharts#setChartDataUrl", "Invalid Data Format. Reverting to current data format - " + f)), v = N(f), I.test(v) || (v += "url"), w = m[v] && m[v](), e.jsVars.stallLoad = !0, w && w.toJSON ? (w.toJSON(d, h, p, g, e), {
        state: 2,
        msg: b,
        msgStyle: x
      }) : {
        state: 1,
        error: new Error("Unable to fetch data.")
      };
    }

    function ie(e) {
      var t = e.__state,
          n = e.chartType(),
          r = void 0,
          o = void 0,
          s = (0, a.getDep)(t.lastRenderedType, "chartapi") || (0, a.getDep)(t.lastRenderedType, "maps");
      if (s && t.lastRenderedType !== n && ((0, i.triggerEvent)("chartTypeChanged", e, {
        previousType: t.lastRenderedType,
        newType: n
      }), r = s)) for (o in r) {
        delete e[o];
      }
      t.lastRenderedType = n;
    }

    function ae(e) {
      var t = Q(e),
          r = t.msgStyle,
          o = t.msg;
      return Promise.all([n.e(2), n.e(13)]).then(n.t.bind(null, 1116, 7)).then(function (t) {
        ue.addDep(t["default"]), ie(e), e._addChartDependency("mapModuleLoad", {
          resolve: function resolve() {
            return {
              state: 3
            };
          }
        }), (0, i.triggerEvent)("loaded", e, {
          type: e.chartType(),
          renderer: "javascript"
        }, [e.id]), e._setState();
      })["catch"](function () {
        var t = ee(e),
            n = t.msgStyle,
            r = t.msg;
        e._addChartDependency("mapModuleLoad", {
          resolve: function resolve() {
            return {
              state: 1,
              msgStyle: n,
              msg: r
            };
          }
        }), (0, i.raiseError)(ue, "12052314141", "run", "JavaScriptRenderer~Maps", new Error("FusionCharts' maps file is required to render the visualization.")), e._setState(), (0, i.triggerEvent)("charttypeinvalid", e, {}, [e.id]);
      }), {
        state: 2,
        msgStyle: r,
        msg: o
      };
    }

    function se(e) {
      var t = this.opts.value,
          n = ue.getDep(t, "dependency") || ue.getDep(t, "chartapi") || ue.getDep(t, "maps");

      if (H = !1, n) {
        if (n.then) {
          ue.addEventListener("register", ne), n.then(function (n) {
            if (!e.disposed) {
              if (n.__esModule) {
                var r = (0, a.getDep)(t, "maps");
                ue.addDep(n["default"]), (!r || !L) && ie(e), e._addChartDependency("chartModuleLoad", {
                  resolve: function resolve() {
                    return r && L ? e._addChartDependency("mapModuleLoad", {
                      scopeOf: e,
                      resolve: ae
                    }) : (0, i.triggerEvent)("loaded", e, {
                      type: t,
                      renderer: "javascript"
                    }, [e.id]), {
                      state: 3
                    };
                  }
                });
              } else e._addChartDependency("chartModuleLoad", {
                resolve: function resolve() {
                  return (0, a.getDep)(t, "maps") && L ? e._addChartDependency("mapModuleLoad", {
                    scopeOf: e,
                    resolve: ae
                  }) : (ie(e), (0, i.triggerEvent)("loaded", e, {
                    type: t,
                    renderer: "javascript"
                  }, [e.id])), {
                    state: 3
                  };
                }
              });

              e._setState();
            }
          })["catch"](function () {
            if (!e.disposed) {
              var t = ee(e),
                  n = t.msgStyle,
                  r = t.msg;
              e._addChartDependency("chartModuleLoad", {
                resolve: function resolve() {
                  return {
                    state: 1,
                    msgStyle: n,
                    msg: r
                  };
                }
              }), e._setState(), (0, i.triggerEvent)("charttypeinvalid", e, {}, [e.id]);
            }
          });
          var r = Q(e);
          return {
            state: 2,
            msgStyle: r.msgStyle,
            msg: r.msg
          };
        }

        return (0, a.getDep)(t, "maps") && L ? (e._addChartDependency("mapModuleLoad", {
          scopeOf: e,
          resolve: ae
        }), e._setState()) : (ie(e), (0, i.triggerEvent)("loaded", e, {
          type: t,
          renderer: "javascript"
        }, [e.id])), {
          state: 3
        };
      }

      var o = ee(e),
          s = o.msgStyle,
          l = o.msg;
      return (0, i.triggerEvent)("charttypeinvalid", this, {}, [this.id]), {
        state: 1,
        msgStyle: s,
        msg: l
      };
    }

    function le(e) {
      var t,
          n = this.opts,
          r = n.containerElement,
          a = n.insertMode,
          s = n.callback,
          l = void 0,
          c = void 0,
          u = void 0;
      if (s ? "function" != typeof s && (s = void 0) : "function" == typeof a ? (s = a, a = void 0) : a || "function" != typeof r || (s = r, r = void 0), a = (a || e.options.insertMode).toLowerCase() || o.domInsertModes.REPLACE, void 0 === r && (r = e.options.containerElementId || e.options.containerElement), "string" == typeof r && (r = document.getElementById(r)), void 0 === r || null === r) return (0, i.raiseError)(e, "03091456", "run", ".render()", new Error("Unable to find the container DOM element.")), (0, i.triggerEvent)("containernotfound", e, {}, [e.id]), {
        state: 1
      };
      if (function (e, t) {
        var n,
            r,
            o,
            i = document.getElementById(e),
            a = t.id || t.getAttribute("id");
        if (null === i) return !1;
        if (e === a) return !0;

        for (r = 0, o = (n = t.getElementsByTagName("*")).length; r < o; r++) {
          if (n[r] === i) return !1;
        }

        return !0;
      }(e.id, r)) return (0, i.raiseError)(e, "05102109", "run", ".render()", new Error("A duplicate object already exists with the specific Id: " + e.id)), {
        state: 1
      };
      if (P(r)) return e.containerHidden = !0, D(e, r, a, s), {
        state: 2
      };
      if (delete e.containerHidden, ((c = window[e.id]) && c.FusionCharts && c.FusionCharts === e || (c = e.ref) && c.FusionCharts && c.FusionCharts === e) && (e._dispose(), c === window[e.id] && (window[e.id] = void 0)), "undefined" != typeof window[e.id]) return (0, i.raiseError)(e, "25081843", "comp", ".render", new Error("#25081843:IECompatibility() Chart Id is same as a JavaScript variable name. Variable naming error. Please use unique name for chart JS variable, chart-id and container id.")), {
        state: 1
      };
      if ((l = document.createElement(e.options.containerElementType || "span")).setAttribute("id", e.id), "append" !== a && "prepend" !== a) for (; r.hasChildNodes();) {
        r.removeChild(r.firstChild);
      }
      return "prepend" === a && r.firstChild ? r.insertBefore(l, r.firstChild) : r.appendChild(l), e.options.containerElement = r, e.options.containerElementId = r.id, (u = l.style) && (u.position = "relative", u.textAlign = "left", u.lineHeight = "normal", u.display = "inline-block", u.zoom = "1", u["vertical-align"] = "middle", u.fontWeight = "normal", u.fontVariant = "normal", u.fontStyle = "normal", u.textDecoration = "none", u["*DISPLAY"] = "inline", u.padding = "0", u.margin = "0", u.border = "none", u.direction = "ltr"), e.options.containerClassName && (l.className = e.options.containerClassName), t = (0, o.normalizeCSSDimension)(e.width, e.height, l), e.__state.renderedWidth = t.pixelWidth, e.__state.renderedHeight = t.pixelHeight, e.__state.rendering = !0, e.renderOpts = {
        containerElement: l,
        insertMode: a,
        callback: s
      }, {
        state: 3
      };
    }

    K.lastId = 0;

    var ce,
        ue = function () {
      function e() {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
        var a,
            s = {};
        (this.__state = {}, this.id = "", this._deps = {}, this.__state._unresolvedDeps = {}, this.__state.state = 4, 1 === arguments.length && "object" === r(arguments.length <= 0 ? undefined : arguments[0]) && (s = arguments.length <= 0 ? undefined : arguments[0]), arguments.length > 1 && "object" === r((t = arguments.length - 1, arguments.length <= t ? undefined : arguments[t]))) && (0, o.extend2)(s, (a = arguments.length - 1, arguments.length <= a ? undefined : arguments[a]), !1, !0);
        this.id = "undefined" == typeof s.id ? K() : s.id, this.args = s, this._parsePolicies(p["default"]), this._attachDefaultEventListeners(), this.jsVars.fcObj = this, (0, i.triggerEvent)("beforeInitialize", this, s), e.items[this.id] instanceof e && (0, i.raiseWarning)(this, "06091847", "param", "", new Error('A FusionCharts object with the specified id "' + this.id + '" already exists.Renaming it to ' + (this.id = K()))), this.attributes.id = this.id, n.p = e.getScriptBaseURI(), this.chartType && this.chartType(s.type || s.swfUrl || ""), this.setChartData(this.args.dataSource, this.args.dataFormat, void 0, void 0, !0), e.items[this.id] = this, e.defaultOptions = e.options, (0, i.triggerEvent)("initialized", this, s), this._setState();
      }

      return e.getObjectReference = function () {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        return e.items[t] && e.items[t].ref;
      }, e.register = function () {
        (0, i.triggerEvent)("register", e, arguments, undefined, function () {
          (0, i.raiseError)(this, "0604111219", "run", ".register()", new Error($));
        });
      }, e.render = function (t, n) {
        return t instanceof e ? (t.render(n), t) : new e(t).render(n);
      }, e.addDep = function () {
        for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return a.addDep.call.apply(a.addDep, [this].concat(t));
      }, e.getDep = function (e, t) {
        return a.getDep.call(this, e, t);
      }, e.addEventListener = function (e, t) {
        return (0, i.addListener)(e, t);
      }, e.on = function (t, n) {
        return e.addEventListener(t, n);
      }, e.removeEventListener = function (e, t) {
        return (0, i.removeListener)(e, t);
      }, e.ready = function (t) {
        var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e,
            r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e,
            o = function o() {
          t.call(r, n);
        };

        "function" == typeof t && (R ? setTimeout(o, 0) : e.addEventListener("ready", o));
      }, e.formatNumber = function (e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            n = arguments[2],
            r = Z(t = J(t)),
            o = void 0;
        return z[r] ? o = z[r] : z[r] = o = new g["default"](t, {
          useScaleRecursively: !0
        }), o.configure(t), o.dataLabels(e, n);
      }, e.transcodeData = function (e, t, n, r) {
        var o = (0, a.getDepsByType)("transcoder"),
            s = N(n),
            l = N(t),
            c = void 0,
            u = void 0,
            d = void 0,
            f = void 0;
        if (l && "function" == typeof l.toString && s && "function" == typeof s.toString && "undefined" != typeof o[s] && "undefined" != typeof o[l]) return d = o[l](), f = o[s](), d.toJSON && (c = d.toJSON(e, this), u = f.fromJSON(c.data, this)), c.error instanceof Error || (u.error = c.error), r ? u : u.data;
        (0, i.raiseError)(this, "14090217", "param", ".transcodeData()", "Unrecognized data-format specified during transcoding.");
      }, e.setAnimation = function (t) {
        !e.options._globalAnimationRule && (e.options._globalAnimationRule = []), e.options._globalAnimationRule.push(t);
      }, e.setEasingEffect = function (t, n) {
        e.getDep("redraphael", "plugin").easing_formulas[t] = n;
      }, e.getScriptBaseURI = function () {
        return e.options.scriptBaseUri;
      }, e.setScriptBaseURI = function (t) {
        e.options.scriptBaseUri = t, n.p = t;
      }, e.getChartFromId = function (t) {
        return e.items[t];
      }, e.getVersion = function (e) {
        var t = {
          fcs: T,
          fc: "3.13.3-sr.1",
          fw: "3.13.3-sr.1",
          pc: "3.13.3-sr.1",
          fm: "3.13.3-sr.1",
          ft: "1.0.0-beta.1"
        };
        return t[e] || t;
      }, e.prototype._attachDefaultEventListeners = function () {
        var e = this.options.events,
            t = void 0,
            n = void 0;
        if (e) for (t in e) {
          "function" == typeof e[t] && this.addEventListener(t, e[t]);
        }

        for (n in this.options.renderer = "javascript", l["default"]) {
          this.addEventListener(n, l["default"][n]);
        }
      }, e.prototype._setState = function () {
        var e = this._deps,
            t = void 0,
            n = void 0,
            r = this.__state.state,
            o = 4;

        for (var a in e) {
          e.hasOwnProperty(a) && (o > (n = (t = e[a]).getState()) && (o = n, this.__state.currChartMsg = t.getMsg(), this.__state.currChartMsgStyle = t.getMsgStyle()), 3 === n && this._removeChartDependency(a));
        }

        if (this.__state.prevState = r, this.__state.state = o, r !== o && (0, i.triggerEvent)("stateChanged", this, {
          prevState: G[r],
          state: G[o]
        }, [this.id]), !this.containerHidden) if (3 === o && this.__state.renderInvoked) {
          var s = this.renderOpts,
              l = s.containerElement,
              c = s.callback;
          this._renderChart(l, void 0, c), this._clearPrevContext(), delete this.renderOpts.callback;
        } else if ((2 === o || 1 === o) && this.__state.renderInvoked && this._contextChanged() && (!this.__state.renderComplete || 2 !== o)) {
          var u = this.renderOpts,
              d = u.containerElement,
              f = u.callback;
          this._renderChart(d, "base", 1 === o && f, this.__state.currChartMsg, this.__state.currChartMsgStyle), 1 === o && delete this.renderOpts.callback;
        }
      }, e.prototype._clearPrevContext = function () {
        this.__state.prevChartMsg = "", this.__state.prevChartMsgStyle = {};
      }, e.prototype._contextChanged = function () {
        if (this.__state.currChartMsg !== this.__state.prevChartMsg) return this.__state.prevChartMsg = this.__state.currChartMsg, this.__state.prevChartMsgStyle = this.__state.currChartMsgStyle, !0;
        var e = this.__state.prevChartMsgStyle && this.__state.prevChartMsgStyle.image,
            t = this.__state.currChartMsgStyle && this.__state.currChartMsgStyle.image,
            n = this.__state.prevChartMsgStyle && this.__state.prevChartMsgStyle.message,
            r = this.__state.currChartMsgStyle && this.__state.currChartMsgStyle.message;
        return !(!e || e.imageHAlign === t.imageHAlign && e.imageVAlign === t.imageVAlign && e.imageAlpha === t.imageAlpha && e.imageScale === t.imageScale && n.color === r.color && n.fontFamily === r.fontFamily && n.fontSize === r.fontSize) && (this.__state.prevChartMsg = this.__state.currChartMsg, this.__state.prevChartMsgStyle = this.__state.currChartMsgStyle, !0);
      }, e.prototype._sudoSetState = function (e) {
        this.__state.prevState = this.__state.state, this.__state.state = e, (0, i.triggerEvent)("stateChanged", this, {
          prevState: G[this.__state.prevState],
          state: G[this.__state.state]
        }, [this.id]);
      }, e.prototype._getState = function () {
        return G[this.__state.state];
      }, e.prototype._addChartDependency = function (e, t) {
        this._deps && this._deps[e] && this._removeChartDependency(e), this._deps[e] = t, t.getState = W, t.getMsg = Y, t.getMsgStyle = q, Object.assign(t, t.resolve(t.scopeOf));
      }, e.prototype._removeChartDependency = function (e) {
        this._deps[e] && (this._deps[e].removed = !0, delete this._deps[e]);
      }, e.prototype._parsePolicies = function (e) {
        var t = this.args,
            n = void 0,
            o = void 0,
            i = void 0;

        for (n in e) {
          if (p["default"][n] instanceof Array) o = t[e[n][0]], this[n] = void 0 === o ? e[n][1] : o;else for (i in "object" !== r(this[n]) && (this[n] = {}), e[n]) {
            o = t[e[n][i][0]], this[n][i] = void 0 === o ? e[n][i][1] : o;
          }
        }
      }, e.prototype.hasRendered = function () {
        return !(!this.jsVars.hcObj || !this.jsVars.hcObj.hasRendered);
      }, e.prototype.setTransparent = function (e) {
        var t;
        (t = this.jsVars) && ("boolean" != typeof e && null !== e && (e = !0), t.transparent = null !== e && !0 === e);
      }, e.prototype.addEventListener = function (e, t) {
        return (0, i.addListener)(e, t, this);
      }, e.prototype.on = function (e, t) {
        return this.addEventListener(e, t);
      }, e.prototype.removeEventListener = function (e, t) {
        return (0, i.removeListener)(e, t, this);
      }, e.prototype.formatNumber = function (e, t, n, r) {
        var i,
            a = this.apiInstance || {},
            s = a.numberFormatter,
            l = void 0,
            c = void 0,
            u = void 0,
            d = void 0;

        switch (i = Z(n), n = n && J(n) || {}, "" === i ? s ? u = s : (c = Z(l = this.options.dataSource.chart || {}), z[c] ? u = z[c] : z[c] = u = new g["default"](a, l)) : (l = this.options.dataSource.chart || {}, c = Z(l = (0, o.extend2)((0, o.extend2)({}, l), n)), z[c] ? u = z[c] : z[c] = u = new g["default"](a, l)), (t && t.toLowerCase ? t : "").toLowerCase()) {
          case "yaxisvalues":
            d = u.yAxis(e, r);
            break;

          case "xaxisvalues":
            d = u.xAxis(e);
            break;

          case "scale":
            d = u.scale(e);
            break;

          default:
            d = u.dataLabels(e, r);
        }

        return d;
      }, e.prototype.clone = function (t, n) {
        var i = void 0 === t ? "undefined" : r(t),
            a = {},
            s = (0, o.extend2)({}, this.args, !1, !0);

        switch (function (e, t, n) {
          var r, o;

          for (r in e) {
            if (e[r] instanceof Array) t[e[r][0]] = n[r];else for (o in e[r]) {
              t[e[r][o][0]] = n[r][o];
            }
          }
        }(p["default"], s, this), delete s.id, delete s.animate, delete s.stallLoad, a.link = s.link, (s = (0, o.extend2)({}, s, !1, !0)).link = a.link, i) {
          case "object":
            (0, o.extend2)(s, t, !1, !0);
            break;

          case "boolean":
            n = t;
        }

        return n ? s : new e(s);
      }, e.prototype.isActive = function () {
        if (!this.ref || window.document.getElementById(this.id) !== this.ref) return !1;

        try {
          return O.test("FusionCharts");
        } catch (e) {
          return !1;
        }
      }, e.prototype.chartType = function (t, n) {
        var a = this.options,
            s = void 0;

        if ("string" == typeof t && "" !== t) {
          if (n = "object" === (void 0 === n ? "undefined" : r(n)) ? n : {}, s = t.replace(/[\?\#][\s\S]*$/g, ""), a.chartType = s.replace(/^[\s\S]*\//gi, ""), a.chartTypeSourcePath = -1 === s.indexOf("/") ? n.chartTypeSourcePath || e.options.chartTypeSourcePath || "" : s.replace(/[^\/]*?$/gi, ""), "zoomscatter" === a.chartType && !document.createElement("canvas").getContext) {
            var l = te(this),
                c = l.msgStyle,
                u = l.msg;
            return this._addChartDependency("chartModuleLoad", {
              scopeOf: this,
              opts: {
                value: a.chartType
              },
              resolve: function resolve() {
                return {
                  state: 1,
                  msgStyle: c,
                  msg: u
                };
              }
            }), void this._setState();
          }

          if ("timeseries" === a.chartType && o.isIE) {
            var d = te(this),
                f = d.msgStyle,
                h = d.msg;
            return this._addChartDependency("chartModuleLoad", {
              scopeOf: this,
              opts: {
                value: a.chartType
              },
              resolve: function resolve() {
                return {
                  state: 1,
                  msgStyle: f,
                  msg: h
                };
              }
            }), void this._setState();
          }

          (0, i.triggerEvent)("resourceRequested", this), this._addChartDependency("chartModuleLoad", {
            scopeOf: this,
            opts: {
              value: a.chartType
            },
            resolve: se
          }), "undefined" != typeof n.dataSource && null !== n.dataSource && this.setChartData(n.dataSource, n.dataFormat, n.dataConfiguration), this._setState();
        } else if (t !== undefined) {
          var p = ee(this),
              g = p.msgStyle,
              m = p.msg;
          return this._addChartDependency("chartModuleLoad", {
            resolve: function resolve() {
              return {
                state: 1,
                msgStyle: g,
                msg: m
              };
            }
          }), this._setState(), void (0, i.triggerEvent)("charttypeinvalid", this, {}, [this.id]);
        }

        return (a.chartType || "").toLowerCase();
      }, e.prototype.setChartDataUrl = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "",
            t = arguments[1],
            n = arguments[2],
            r = arguments[3],
            o = arguments[4];
        this._addChartDependency("data", {
          scopeOf: this,
          opts: {
            url: e,
            format: t,
            config: n,
            callback: r,
            silent: o
          },
          resolve: oe
        }), this._setState();
      }, e.prototype.setChartData = function (e, t, n, o) {
        var i,
            a = !(arguments.length > 4 && arguments[4] !== undefined) || arguments[4],
            s = this.options;

        if (void 0 !== e && null !== e) {
          if ("string" != typeof t) switch (void 0 === e ? "undefined" : r(e)) {
            case "function":
              e = e.call(this, s.dataConfiguration), t = this.args.dataFormat = "JSON";
              break;

            case "string":
              t = this.args.dataFormat = /^\s*?\{[\s\S]*\}\s*?$/g.test(t) ? "JSON" : "XML";
              break;

            case "object":
              t = this.args.dataFormat = "JSON";
          }
        } else t = A;

        i = N(t), I.test(i) ? this.setChartDataUrl(e, i, n, o, a) : (this._addChartDependency("data", {
          opts: {
            data: e,
            sanitisedFormat: i,
            config: n,
            callback: o,
            silent: a
          },
          scopeOf: this,
          resolve: re
        }), !this.disposed && this._setState());
      }, e.prototype.getChartData = function () {
        var e,
            t,
            n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : A,
            r = arguments[1],
            o = arguments[2],
            i = (0, a.getDepsByType)("transcoder")[N(n)](),
            s = this.options,
            l = this.apiInstance,
            c = !o && (e = l && l.getCollatedData && l.getCollatedData(s.dataSource)) ? e : s.dataSource;
        return !(t = i ? i.fromJSON ? i.fromJSON(c, this) : {
          error: new Error("Unable to convert data.")
        } : {
          error: new Error("Data format not recognized.")
        }).error && s.error && (t.error = s.error), r ? t : t.data;
      }, e.prototype.dataReady = function (e) {
        return e ? this.__state.dataAvailable : this.__state.dataReady;
      }, e.prototype.setChartAttribute = function (e, t) {
        var n, o, a, s;
        if ("string" == typeof e) (e = {})[arguments[0]] = t;else if (null === e || "object" !== (void 0 === e ? "undefined" : r(e))) return;

        if (s = 0, a = (n = this.getChartData(A)) && (n.chart || n.graph || n.map)) {
          for (o in e) {
            s += 1, null !== e[o] ? a[o.toLowerCase()] = e[o] : delete a[o.toLowerCase()];
          }

          s > 0 && ("undefined" == typeof a.animation && (a.animation = "0"), this.setChartData(n, A));
        } else (0, i.raiseError)(this, "2105141421", "run", "#setChartAttribute()", "Could not retrieve attribute list. Is data ready?");
      }, e.prototype.getChartAttribute = function (e) {
        var t,
            n,
            r = this.getChartData(A),
            o = r && (r.chart || r.graph || r.map);
        if (0 === arguments.length || void 0 === e || void 0 === o) return o;
        if ("string" == typeof e) t = o[e.toString().toLowerCase()];else if (e instanceof Array) for (t = {}, n = 0; n < e.length; n += 1) {
          t[e[n]] = o[e[n].toString().toLowerCase()];
        } else (0, i.raiseError)(this, "25081429", "param", "~getChartAttribute()", 'Unexpected value of "attribute"');
        return t;
      }, e.prototype.render = function (e, t, n) {
        return this.disposed || (this.__state.beforeRenderFired = !1, this._addChartDependency("chartContainer", {
          scopeOf: this,
          opts: {
            containerElement: e,
            insertMode: t,
            callback: n
          },
          resolve: le
        }), this.__state.renderInvoked = !0), this._setState(), this;
      }, e.prototype._renderChart = function (e, t, n, r, o) {
        var a = arguments.length > 5 && arguments[5] !== undefined && arguments[5];

        if (!this.disposed) {
          var s,
              l = this,
              c = function c() {
            !0 !== l.disposed && l._render(e, t, n && function () {
              if (n) try {
                n.call(l, l.options.containerElement);
              } catch (e) {
                setTimeout(function () {
                  throw e;
                });
              }
            }, r, o);
          };

          return a || this.__state.beforeRenderFired ? c() : (this.__state.beforeRenderFired = !0, (0, i.triggerEvent)("beforeRender", this, s = {
            container: l.options.containerElement,
            width: this.width,
            height: this.height,
            renderer: this.options.renderer
          }, void 0, c, function () {
            (0, i.triggerEvent)("renderCancelled", l, s), this.__state.renderInvoked = !1;
          })), this;
        }
      }, e.prototype._render = function (t, n, r, o, a) {
        var s = this;
        s.apiInstance && s.apiInstance.removeJob("resizeScheduled"), s.__state.beforedrawFired ? ((0, u["default"])(e, s, t, n, r, o, a), s.__state.beforedrawFired = !0) : (0, i.triggerEvent)("beforedraw", s, {}, void 0, function () {
          (0, u["default"])(e, s, t, n, r, o, a);
        }, function () {
          (0, i.triggerEvent)("drawCancelled", s);
        });
      }, e.prototype.resizeTo = function (e, t, n) {
        var o = this,
            a = o.width,
            s = o.height,
            l = o.__state;
        return (o.apiInstance && o.apiInstance.config || {}).resize = !0, "object" === (void 0 === e ? "undefined" : r(e)) && (n = t, t = e.h, e = e.w), e = null === e || void 0 === e ? a : e.toString().replace(F, ""), t = null === t || void 0 === t ? s : t.toString().replace(F, ""), !0 !== n && (0, i.triggerEvent)("beforeresize", o, {
          currentWidth: a,
          currentHeight: s,
          newWidth: e,
          newHeight: t
        }, void 0, function () {
          o.width = e, o.height = t, o.scheduleResize({
            width: e,
            height: t
          }), o.apiInstance && o.apiInstance.addJob("resized" + B++, function () {
            (0, i.triggerEvent)("resized", o, {
              id: o.id,
              width: o.width,
              height: o.height,
              prevWidth: a,
              prevHeight: s,
              pixelWidth: o.ref && o.ref.offsetWidth || 0,
              pixelHeight: o.ref && o.ref.offsetHeight || 0,
              originalWidth: l.renderedWidth,
              originalHeight: l.renderedHeight
            });
          }, f.priorityList.postRender);
        }, function () {
          (0, i.triggerEvent)("resizecancelled", o, {
            currentWidth: a,
            currentHeight: s,
            cancelledTargetWidth: e,
            cancelledTargetHeight: t
          });
        }), this;
      }, e.prototype.dispose = function () {
        var t = this,
            n = {};
        (0, i.triggerEvent)("beforeDispose", t, n, void 0, function () {
          t._addChartDependency("dispose", {
            scopeOf: t,
            resolve: function resolve(t) {
              for (var r in t._dispose(), t._addChartDependency("dispose", {
                resolve: function resolve() {
                  return {
                    state: 0
                  };
                }
              }), t._setState(), (0, i.triggerEvent)("disposed", t, n), (0, i.disposeEvents)(t), delete e.items[t.id], t) {
                t.hasOwnProperty(r) && delete t[r];
              }

              return t.disposed = !0, {
                state: 0
              };
            }
          });
        }, function () {
          (0, i.triggerEvent)("disposeCancelled", t, n);
        });
      }, e.prototype._dispose = function () {
        var e,
            t = this.jsVars;
        this.apiInstance && (this.apiInstance.removeJob("resizeScheduled"), this.apiInstance.remove({
          instant: !0
        }), delete this.apiInstance, delete t.instanceAPI), (e = window[this.id]) && (!function n(e) {
          var t,
              r,
              o,
              i = e.attributes;
          if (i) for (t = i.length - 1; t >= 0; t -= 1) {
            "function" == typeof e[o = i[t].name] && (e[o] = null);
          }
          if (i = e.childNodes) for (r = i.length, t = 0; t < r; t += 1) {
            n(e.childNodes[t]);
          }
        }(e), e.parentNode && e.parentNode.removeChild(e)), t.container = null;
      }, e.prototype._config = function (e, t) {
        var n,
            r,
            o = this.jsVars,
            i = o.msgStore,
            a = o.cfgStore,
            s = this.options;

        for (n in r = {
          LoadingText: "loadMessage",
          ChartNotSupported: "typeNotSupportedMessage",
          RenderChartErrorText: "renderErrorMessage",
          XMLLoadingText: "dataLoadStartMessage",
          ChartNoDataText: "dataEmptyMessage",
          LoadDataErrorText: "dataLoadErrorMessage",
          InvalidXMLText: "dataInvalidMessage"
        }, "string" == typeof e && arguments.length > 1 && (n = e, (e = {})[n] = t), e) {
          "undefined" != typeof i[n] ? i[n] = e[n] : a[n.toLowerCase()] = e[n], r[n] ? s[r[n]] = e[n] : s[n] = e[n];
        }
      }, e.prototype.configure = function (e, t) {
        var n;
        e && ("string" == typeof e ? (n = {})[e] = t : n = e, this._config(n));
      }, e.prototype.print = function (e) {
        var t = this.apiInstance,
            n = (0, o.extend2)({}, e);
        if (t.config.isPrinting || !t.config.hasRendered) return !1;
        (0, i.triggerEvent)("BeforePrint", this, n, void 0, function () {
          var e,
              r,
              a,
              s,
              l = t.getFromEnv("chart-container"),
              c = [],
              u = l.parentNode,
              d = document.body || document.getElementsByTagName("body")[0],
              f = d.childNodes;
          if (t.config.isPrinting = !0, (0, o.fcEach)(f, function (e, t) {
            1 === e.nodeType && (c[t] = e.style.display, e.style.display = "NONE");
          }), !1 !== n.hideButtons && (s = t.getChildren("chartMenuBar"))) for (a = 0, e = (r = s[0].getChildren("tool")).length; a < e; a++) {
            r[0].getChildren("listContainer")[0].hide();
          }
          d.appendChild(l), window.print(), setTimeout(function () {
            u.appendChild(l), (0, o.fcEach)(f, function (e, t) {
              1 === e.nodeType && (e.style.display = c[t]);
            }), n.hideButtons, t.config.isPrinting = !1, (0, i.triggerEvent)("PrintComplete", t.getFromEnv("chartInstance"), n);
          }, 1e3);
        }, function () {
          (0, i.triggerEvent)("PrintCancelled", t.getFromEnv("chartInstance"), n);
        });
      }, e.prototype.getSVGString = function (e, t) {
        var n,
            r = this.apiInstance,
            o = r && r.getFromEnv("paper");
        if (t && t.keepImages && (n = !0), "function" != typeof e) return o && o.toSVG ? o.toSVG(n) : "<svg></svg>";
        r.addJob("getSVG", function () {
          e(o && o.toSVG && o.toSVG(n));
        }, f.priorityList.postRender);
      }, e.prototype.lockResize = function (e) {
        return "boolean" != typeof e ? !!this.jsVars.resizeLocked : this.jsVars.resizeLocked = e;
      }, e.prototype.showChartMessage = function (e, t, n) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
            o = this,
            i = o.apiInstance,
            a = function a() {
          o._showChartMessage(e, t, n, r);
        };

        return i && ("base" === i.getName() ? o.addEventListener("renderComplete", a) : a()), e;
      }, e.prototype._showChartMessage = function (e, t, n) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
            i = this,
            a = i.jsVars,
            s = i.apiInstance,
            l = i.options,
            c = void 0;
        s._hideChartMessage(), void 0 !== e ? (c = {
          fontFamily: (0, o.pluck)(r.font, l.baseChartMessageFont, "Verdana,sans"),
          fontSize: (0, o.pluck)(r.fontSize, l.baseChartMessageFontSize, 10),
          color: (0, o.pluck)(r.color && (0, o.convertColor)(r.color, r.alpha), l.baseChartMessageColor)
        }, a.msgStore[e] && (e = a.msgStore[e]), s.addJob("showMsg", function () {
          t && s && s.config.hasRendered ? (s._show && s._show(), i.showMessage(e, c, n)) : (s._hide && s._hide(), s.setChartMessage(e, {
            _chartMessageStyle: c
          }), s.drawChartMessage());
        }, f.priorityList.postRender)) : i.hideChartMessage();
      }, e.prototype._resize = function () {
        var e = this.jsVars,
            t = this.apiInstance,
            n = e.container;
        this.__state.resize = !0, t ? (t.config.elScroll = !1, t.getFromEnv("animationManager").setAnimationState("resize"), t.addToEnv("chartWidth", n.offsetWidth), t.addToEnv("chartHeight", n.offsetHeight), this._addChartDependency("resize", {
          resolve: function resolve() {
            return {
              state: 3
            };
          }
        })) : this._addChartDependency("resize", {
          resolve: function resolve() {
            return {
              state: 1
            };
          }
        }), this._setState(), this.__state.resize = !1;
      }, e.prototype.hideChartMessage = function () {
        var e = this.apiInstance;
        e._hideChartMessage(), e._show && e._show();
      }, e.prototype.showMessage = function () {
        var e,
            t,
            n,
            r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "",
            i = arguments[1],
            a = arguments[2],
            s = this.apiInstance,
            l = s.config,
            c = s.getFromEnv("paper"),
            u = s.getFromEnv("smartLabel"),
            d = s.getFromEnv("animationManager"),
            f = s.getGraphicalElement("messageText"),
            h = s.getGraphicalElement("messageVeil"),
            p = c.width,
            g = c.height;
        t = s.getChildContainer("messageGroup"), d.setAnimationState("showmessage"), (e = d.setAnimation({
          el: t || "group",
          attr: {
            name: "messageGroup"
          },
          component: s,
          label: "group"
        })).show().toFront(), t || s.addChildContainer("messageGroup", e), (h = d.setAnimation({
          el: h || "rect",
          attr: {
            x: 0,
            y: 0,
            width: p,
            height: g,
            fill: "rgba(0,0,0,0.2)",
            stroke: "none"
          },
          container: e,
          component: s,
          label: "rect"
        })).off("fc-click", e.hide), h.show().toFront().attr("cursor", a ? o.POINTER : "default"), a && h.on("fc-click", s._hideChartMessage, s), s.addGraphicalElement("messageVeil", h), u.setStyle(i), n = u.getSmartText(r, p - (l.marginRight || 0) - (l.marginLeft || 0), g - (l.marginTop || 0) - (l.marginBotton || 0)), (f = d.setAnimation({
          el: f || "text",
          attr: {
            "font-size": i.fontSize,
            "font-family": i.fontFamily,
            fill: i.color,
            text: n.text,
            "line-height": 14,
            x: p / 2,
            y: g / 2
          },
          container: e,
          component: s,
          label: "text"
        })).attr("cursor", a ? o.POINTER : "default")[a ? "click" : "unclick"](s._hideChartMessage, s).show().toFront(), s.addGraphicalElement("messageText", f);
      }, e.prototype.scheduleResize = function (e) {
        var t,
            n = this,
            r = n.ref,
            i = n.apiInstance;
        r && (n._addChartDependency("resize", {
          resolve: function resolve() {
            return {
              state: 2
            };
          }
        }), i.addJob("resizeScheduled", function () {
          t = (0, o.normalizeCSSDimension)(e.width, e.height, r), "undefined" != typeof e.width && (r.style.width = t.width), "undefined" !== e.height && (r.style.height = t.height), n._resize();
        }, f.priorityList.instant));
      }, e;
    }();

    ue.id = "FusionCharts", ue.options = {
      html5ScriptNameSuffix: ".js",
      html5ScriptNamePrefix: "fusioncharts.",
      "export": {
        useCanvas: !1
      },
      scriptBaseUri: (ce = function (e) {
        var t,
            n,
            r = window.document.getElementsByTagName("script"),
            o = r.length;

        for (n = 0; n < o; n += 1) {
          if (void 0 !== (t = r[n].getAttribute("src")) && null !== t && null !== t.match(e)) return t.replace(e, "$1");
        }
      }(M), void 0 === ce ? ((0, i.raiseError)(ue, "1603111624", "run", ">GenericRuntime~scriptBaseUri", "Unable to locate FusionCharts script source location (URL)."), "") : ce)
    }, n.p = ue.getScriptBaseURI(), ue.version = T.split(/[\.\-]/g), ue.items = {}, (0, i.setRootSender)(ue), R = !1, o.hasSVG || ue.addDep({
      name: "vml",
      type: "dependency",
      extension: n.e(14).then(n.t.bind(null, 1123, 7))
    }), (j = ue.getDep("vml", "dependency")) ? j.then ? j.then(function (e) {
      ue.addDep(e["default"]), X();
    })["catch"](function () {
      (0, i.raiseError)(ue, "162162788", "run", ">RendererError~VMLRendererLoad", "Unable to load FusionCharts VML renderer.");
    }) : (ue.addDep(j), X()) : X(), ue.addEventListener("dependencyAdded", function (e, t) {
      if ("maps" === t.type) {
        var n = {};
        n[t.name] = ["fusioncharts.maps.js"], ue.getDep("dependency") || ue.addDep({
          name: "dependency",
          extension: n
        });
      }
    }), ue.addEventListener("initialized", function he() {
      ue.removeEventListener("initialized", he), V = new d["default"](document.body || document.getElementsByTagName("body")[0]), c.globalStore.addToEnv("smartLabel", V);
    }), ue.addDep(h["default"]), ue.addDep(m["default"]), ue.addDep(w["default"]), ue.addDep(v["default"]), ue.addDep(y["default"]), ue.addDep(b["default"]), ue.addDep(x["default"]), t["default"] = ue;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.DEFAULT_FT_FONT = t.isIpad = t.getFirstAlpha = t.getFirstColor = t.HEXtoRGB = t.rawRGBtoHEX = t.RGBtoHex = t.getValidColor = t.parseColor = t.getAngle = t.getPointColor = t.getColumnColor = t.mapSymbolName = t.getLightColor = t.getDarkColor = t.convertColor = t._manageInteractiveSpace = t.domInsertModes = t.normalizeCSSDimension = t.isXSSSafe = t.getSuggestiveRotation = t.extent = t.normalizeAngle = t.safeMin = t.safeMax = t.LINE_HEIGHT_FACTOR = t.PROJECT_VERSION = t.trimString = t.datasetFactory = t.componentFactory = t.dropHash = t.BGRATIOSTRING = t.VISIBLE = t.touchEnabled = t.MOUSEMOVE = t.MOUSEOUT = t.FIT = t.FILL = t.TILE = t.COMMA = t.animationObjStr = t.configStr = t.ROUND = t.BLANK = t.POINTER = t.HAND = t.BOLD = t.NORMAL = t.mathRound = t.mathAbs = t.animHelperFN = t.xssEncode = t.MathExt = t.defaultGaugePaletteOptions = t.crispBound = t.hasAttribDefs = t.setAttribDefs = t.parseConfiguration = t.attribDefs = t.canvasBorderColorStr = t.defined = t.pInt = t.attrTypeBool = t.canvasBGAlphaStr = t.attrTypeNum = t.DASH_DEF = t.chartPaletteStr = t.TRACKER_FILL = t.capitalizeString = t.getContainerBackgroundColor = t.appliedCSS = t.validhexcolor = t.pseudoEval = t.executeJS = t.componentDispose = t.createDialog = t.chartAPI = t.getDashStyle = t.getAxisLimits = undefined, t.supportedStyle = t.parsexAxisStyles = t.setLineHeight = t.setImageDisplayMode = t.getLinkAction = t.lineHeightFactor = t.isEdge = t.isIE9 = t.isIE11 = t.isIE = t.CREDIT_REGEX = t.hasSVG = t.stableSort = t.stubFN = t.preDefStr = t.getCripValues = t.getCrispValue = t.isArray = t.getImageURL = t.regReplaceEscape = t.regescape = t.CREDIT_STRING = t.CREDIT_HREF = t.creditLabel = t.hasTouch = t.toPrecision = t.parseTooltext = t.parseUnsafeString = t.parsePointValue = t.fastTrim = t.gradientify = t.rgbaToHex = t.toRaphaelColor = t.clampNumber = t.getColorCodeString = t.getFirstValue = t.getDefinedColor = t.fcEach = t.bindSelectionEvent = t.getViewPortDimension = t.getPosition = t.getValidValue = t.pluckFontSize = t.getComparatorFN = t.dehashify = t.hashify = t.polyPathToPath = t.createElement = t.getFirstDefinedValue = t.pluckNumber = t.pluck = t.imprint = t.extend2 = t.getTouchEvent = t.getMouseCoordinate = t.getEventCoordinate = t.regex = t.CLICK_THRESHOLD_PIXELS = t.TOUCH_THRESHOLD_PIXELS = t.cleanColorCode = t.startsRGBA = t.visibleStr = t.hiddenStr = t.TEXTANCHOR = t.COMMASPACE = t.PXSTRING = t.HUNDREDSTRING = t.SHAPE_RECT = t.FC_CONFIG_STRING = t.POSITION_END = t.POSITION_START = t.POSITION_MIDDLE = t.POSITION_CENTER = t.POSITION_LEFT = t.POSITION_BOTTOM = t.POSITION_RIGHT = t.POSITION_TOP = t.STRINGUNDEFINED = t.DECIMALSTRING = t.ONESTRING = t.TESTSTR = t.SAMPLESTRING = t.ZEROSTRING = t.COMMASTRING = t.OBJECTSTRING = t.STRINGSTRING = t.BREAKSTRING = t.HASHSTRING = t.COLOR_TRANSPARENT = t.COLOR_WHITE = t.COLOR_GLASS = t.COLOR_BLACK = t.BLANKSTRING = t.UNDERSCORE = t.UNDEF = t.isFirefox = t.BLANKSTRINGPLACEHOLDER = t.getEmptyConstractor = t.addInterActiveEvtName = t.isInterActiveEvt = undefined;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        o = n(126),
        i = c(n(127)),
        a = c(n(128)),
        s = n(129),
        l = n(130);

    function c(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var u,
        d,
        f,
        h,
        p,
        g,
        m,
        v,
        y,
        b,
        x,
        w,
        C,
        _,
        S,
        E = 1.2,
        k = window,
        A = "none",
        T = (S = k.navigator.userAgent.toLowerCase(), !(!(_ = -1 != S.indexOf("msie") && k.parseInt(S.split("msie")[1])) || 9 !== _)),
        M = /Firefox/i.test(k.navigator.userAgent),
        O = k.document,
        F = k.navigator,
        I = Boolean(k.SVGAngle || O.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1")),
        L = /trident/i.test(F.userAgent) && /rv:11/i.test(F.userAgent) && !window.opera,
        N = /msie/i.test(F.userAgent) && !k.opera,
        D = /Edge/.test(F.userAgent),
        P = !!F.platform && /iPad|iPhone|iPod/.test(F.platform),
        R = P ? "Verdana,sans" : "Source Sans Pro",
        j = /[\\\"<>;&]/,
        V = /^[^\S]*?(sf|f|ht)(tp|tps):\/\//i,
        B = "rgba(192,192,192," + (N ? .002 : 1e-6) + ")",
        H = "<br />",
        G = "",
        z = G,
        U = ",",
        $ = "r",
        X = "px",
        W = "http://www.fusioncharts.com?BS=FCHSEvalMark&utm_source=FCS_trial&pver=" + escape("3.13.3-sr.1"),
        Y = parseFloat,
        q = /fusioncharts\.com|fusioncharts\.github\.io$/i,
        K = /\{br\}\s*/gi,
        J = /^#?/,
        Z = /^rgba/i,
        Q = /[#\s]/gi,
        ee = Math.abs,
        te = Math.pow,
        ne = Math.round,
        re = te(2, -24),
        oe = "ontouchstart" in O,
        ie = oe && !(F.maxTouchPoints || F.msMaxTouchPoints),
        ae = !q.test(k.location.hostname),
        se = Math,
        le = se.max,
        ce = se.min,
        ue = {
      pageX: 0,
      pageY: 0
    },
        de = ["8BBA00", "F6BD0F", "FF654F", "AFD8F8", "FDB398", "CDC309", "B1D0D2", "FAD1B9", "B8A79E", "D7CEA5", "C4B3CE", "E9D3BE", "EFE9AD", "CEA7A2", "B2D9BA"],
        fe = {
      paletteColors: [de, de, de, de, de],
      bgColor: ["CBCBCB,E9E9E9", "CFD4BE,F3F5DD", "C5DADD,EDFBFE", "A86402,FDC16D", "FF7CA0,FFD1DD"],
      bgAngle: [270, 270, 270, 270, 270],
      bgRatio: ["0,100", "0,100", "0,100", "0,100", "0,100"],
      bgAlpha: ["50,50", "60,50", "40,20", "20,10", "30,30"],
      toolTipBgColor: ["FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF"],
      toolTipBorderColor: ["545454", "545454", "415D6F", "845001", "68001B"],
      baseFontColor: ["555555", "60634E", "025B6A", "A15E01", "68001B"],
      tickColor: ["333333", "60634E", "025B6A", "A15E01", "68001B"],
      trendDarkColor: ["333333", "60634E", "025B6A", "A15E01", "68001B"],
      trendLightColor: ["f1f1f1", "F3F5DD", "EDFBFE", "FFF5E8", "FFD1DD"],
      pointerBorderColor: ["545454", "60634E", "415D6F", "845001", "68001B"],
      pointerBgColor: ["545454", "60634E", "415D6F", "845001", "68001B"],
      canvasBgColor: ["FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF"],
      canvasBgAngle: [0, 0, 0, 0, 0],
      canvasBgAlpha: ["100", "100", "100", "100", "100"],
      canvasBgRatio: ["", "", "", "", ""],
      canvasBorderColor: ["545454", "545454", "415D6F", "845001", "68001B"],
      canvasBorderAlpha: [100, 100, 100, 90, 100],
      altHGridColor: ["EEEEEE", "D8DCC5", "99C4CD", "DEC49C", "FEC1D0"],
      altHGridAlpha: [50, 35, 10, 20, 15],
      altVGridColor: ["767575", "D8DCC5", "99C4CD", "DEC49C", "FEC1D0"],
      altVGridAlpha: [10, 20, 10, 15, 10],
      borderColor: ["767575", "545454", "415D6F", "845001", "68001B"],
      borderAlpha: [50, 50, 50, 50, 50],
      legendBgColor: ["ffffff", "ffffff", "ffffff", "ffffff", "ffffff"],
      legendBorderColor: ["545454", "545454", "415D6F", "845001", "D55979"],
      plotFillColor: ["767575", "D8DCC5", "99C4CD", "DEC49C", "FEC1D0"],
      plotBorderColor: ["999999", "8A8A8A", "6BA9B6", "C1934D", "FC819F"],
      msgLogColor: ["717170", "7B7D6D", "92CDD6", "965B01", "68001B"],
      TrendLightShadeOffset: 30
    },
        he = {
      numDecimals: function numDecimals(e) {
        e = We(e, 10);
        var t = We((e = Math.abs(e)) - Math.floor(e), 10),
            n = String(t).length - 2;
        return n = n < 0 ? 0 : n, n;
      },
      toRadians: function toRadians(e) {
        return e / 180 * Math.PI;
      },
      toDegrees: function toDegrees(e) {
        return e / Math.PI * 180;
      },
      flashToStandardAngle: function flashToStandardAngle(e) {
        return -1 * e;
      },
      standardToFlashAngle: function standardToFlashAngle(e) {
        return -1 * e;
      },
      flash180ToStandardAngle: function flash180ToStandardAngle(e) {
        var t = 360 - ((e %= 360) < 0 ? e + 360 : e);
        return 360 == t ? 0 : t;
      },
      getAngularPoint: function getAngularPoint(e, t, n, r) {
        return r *= Math.PI / 180, {
          x: e + n * Math.cos(r),
          y: t - n * Math.sin(r)
        };
      },
      remainderOf: function remainderOf(e, t) {
        return Math.ceil(e % t);
      },
      boundAngle: function boundAngle(e) {
        return e >= 0 ? he.prototype.remainderOf(e, 360) : 360 - he.prototype.remainderOf(Math.abs(e), 360);
      },
      toNearestTwip: function toNearestTwip(e) {
        var t = e,
            n = t < 0 ? -1 : 1,
            r = Math.abs(t),
            o = Math.round(100 * r),
            i = Math.floor(o / 5);
        return n * ((Number(String(o - 5 * i)) > 2 ? 5 * i + 5 : 5 * i) / 100);
      },
      roundUp: function roundUp(e, t) {
        t = t || 2;
        var n = Math.pow(10, t);
        return e *= n, e = Math.round(Number(String(e))), e /= n;
      }
    },
        pe = 2 * se.PI,
        ge = {
      chart2D: {
        bgColor: "bgColor",
        bgAlpha: "bgAlpha",
        bgAngle: "bgAngle",
        bgRatio: "bgRatio",
        canvasBgColor: "canvasBgColor",
        canvasBaseColor: "canvasBaseColor",
        divLineColor: "divLineColor",
        legendBgColor: "legendBgColor",
        legendBorderColor: "legendBorderColor",
        toolTipbgColor: "toolTipbgColor",
        toolTipBorderColor: "toolTipBorderColor",
        baseFontColor: "baseFontColor",
        anchorBgColor: "anchorBgColor"
      },
      chart3D: {
        bgColor: "bgColor3D",
        bgAlpha: "bgAlpha3D",
        bgAngle: "bgAngle3D",
        bgRatio: "bgRatio3D",
        canvasBgColor: "canvasBgColor3D",
        canvasBaseColor: "canvasBaseColor3D",
        divLineColor: "divLineColor3D",
        divLineAlpha: "divLineAlpha3D",
        legendBgColor: "legendBgColor3D",
        legendBorderColor: "legendBorderColor3D",
        toolTipbgColor: "toolTipbgColor3D",
        toolTipBorderColor: "toolTipBorderColor3D",
        baseFontColor: "baseFontColor3D",
        anchorBgColor: "anchorBgColor3D"
      }
    },
        me = I ? 0 : .5,
        ve = function () {
      if (Array.isArray) return Array.isArray;
      var e = Object.prototype.toString,
          t = e.call([]);
      return function (n) {
        return e.call(n) === t;
      };
    }(),
        ye = function ye(e) {
      return e.pageX === u && (e.pageX = e.clientX + O.body.scrollLeft + O.documentElement.scrollLeft, e.pageY = e.clientY + O.body.scrollTop + O.documentElement.scrollTop), e;
    },
        be = (b = "innerWidth", x = "innerHeight", w = O.documentElement || O.body, C = w, "innerWidth" in k ? C = k : (b = "clientWidth", x = "clientHeight"), function () {
      return {
        width: C[b],
        height: C[x],
        scrollTop: w.scrollTop,
        scrollLeft: w.scrollLeft
      };
    }),
        xe = (y = /^@window_/g, function (e, t, n) {
      var r,
          o,
          i,
          a,
          s = e.replace(/\[[\'\"]/g, ".").replace(/[\'\"]\]/g, G).replace(/\[/g, ".@window_").replace(/\]/g, G).split("."),
          l = k,
          c = G;

      for (i = s.length, a = 0; a < i; a += 1) {
        if (r = l, (o = s[a]).match(y)) l = l[k[o.replace(y, G)]];else {
          if (l === u || null === l) throw (c || o).replace(y, G) + " is not defined";
          l = l[o];
        }
        c = o;
      }

      if (!l || "function" != typeof l.call && l !== k.alert) {
        if ("void" === c) return;
        setTimeout(function () {
          throw o.replace(y, G) + "() is not a function";
        }, 0);
      } else l === k.alert ? l(t) : n ? l.apply(r, t.split("__FC_ARG_SEP__")) : l.call(r, t);
    }),
        we = (v = {}, function (e) {
      var t,
          n,
          r,
          o,
          i,
          a = (e = e || this) && e.FCcolor || e,
          l = a.color,
          c = a.ratio,
          d = a.angle,
          f = a.alpha,
          h = a.r,
          p = a.cx,
          g = a.cy,
          m = a.fx,
          y = a.fy,
          b = a.gradientUnits,
          x = a.x1,
          w = a.y1,
          C = a.x2,
          _ = a.y2,
          S = a.radialGradient,
          E = 1;
      if ("string" == typeof e) return v[i = "~" + e] || (v[i] = e.replace(/^#?([a-f0-9]{3,6})/gi, "#$1"));
      if (!(l = l || G)) return t;
      if (i = [l, f, c, d, h, p, g, b, m, y, x, C, w, _, S].join("_").replace(/[\(\)\s,\xb0#]/g, "_"), v[i]) return v[i];
      if (c = c && (c + G).split(U) || [], f = (f || 0 === f) && (f + G).split(U) || [], l = l.split(U)) if (t = G, 1 === l.length) o = l[0].replace(/^#?([a-f0-9]{3,6})/gi, "$1"), t = f.length ? "rgba(" + (0, s.HEXtoRGB)(o).join(U) + "," + .01 * Y(f[0]) + ")" : o.replace(/^#?([a-f0-9]{3,6})/gi, "#$1");else {
        for (n = 0, r = l.length; n < r; n++) {
          o = l[n].replace(/^#?([a-f0-9]{3,6})/gi, "$1"), isNaN(c[n]) || (c[n] = Y(c[n]), o += ":" + c[n], isNaN(c[n + 1]) || (c[n + 1] = Y(c[n + 1]) + c[n])), isNaN(f[n]) || f[n] === G || (E = .01 * f[n]), l[n] = "rgba(" + (0, s.HEXtoRGB)(o).join(U) + "," + E + ")", isNaN(c[n]) || (c[n] === c[n - 1] && (c[n] += .001), l[n] = l[n] + ":" + c[n]);
        }

        t += l.join("-"), h !== u || m !== u || p !== u || a.radialGradient ? t = "xr(" + [m, y, h, p, g, b].join(",") + ")" + t : (t = "-" + t, x === u && w === u && C === u && _ === u || (t = "(" + [x, w, C, _, b].join(",") + ")" + t), d === u && (d = 0), t = 360 - Y(d) % 360 + t);
      }
      return v[i] = t;
    }),
        Ce = function Ce() {
      return "";
    },
        _e = function () {
      var e,
          t = [{
        regex: /((^|[^\\])((\\)\\)*\$cleanvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$cleanvalue))/gi,
        argIndex: 2,
        argKey: "cleanvalue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$datavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$datavalue))/gi,
        argIndex: 2,
        argKey: "formattedValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$value)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$value))/gi,
        argIndex: 3,
        argKey: "value"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$label)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$label))/gi,
        argIndex: 2,
        argKey: "label"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$seriesname)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$seriesname))/gi,
        argIndex: 5,
        argKey: "seriesname"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$yaxisname)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$yaxisname))/gi,
        argIndex: 2,
        argKey: "yaxisName"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$xaxisname)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$xaxisname))/gi,
        argIndex: 2,
        argKey: "xaxisName"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$displayvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$displayvalue))/gi,
        argIndex: 3,
        argKey: "displayvalue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$xdatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$xdatavalue))/gi,
        argIndex: 2,
        argKey: "xDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$ydatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$ydatavalue))/gi,
        argIndex: 2,
        argKey: "yDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$xvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$xvalue))/gi,
        argIndex: 3,
        argKey: "x"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$yvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$yvalue))/gi,
        argIndex: 3,
        argKey: "y"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$zvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$zvalue))/gi,
        argIndex: 3,
        argKey: "z"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$name)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$name))/gi,
        argIndex: 3,
        argKey: "name"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$percentValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$percentValue))/gi,
        argIndex: 2,
        argKey: "percentValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$startValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$startValue))/gi,
        argIndex: 2,
        argKey: "startValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$startDataValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$startDataValue))/gi,
        argIndex: 2,
        argKey: "startDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$endValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$endValue))/gi,
        argIndex: 2,
        argKey: "endValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$endDataValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$endDataValue))/gi,
        argIndex: 2,
        argKey: "endDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$axisName)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$axisName))/gi,
        argIndex: 2,
        argKey: "axisName"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$cumulativevalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$cumulativevalue))/gi,
        argIndex: 2,
        argKey: "cumulativeValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$cumulativedatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$cumulativedatavalue))/gi,
        argIndex: 2,
        argKey: "cumulativeDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$cumulativePercentValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$cumulativePercentValue))/gi,
        argIndex: 2,
        argKey: "cumulativePercentValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$cumulativepercentdatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$cumulativepercentdatavalue))/gi,
        argIndex: 2,
        argKey: "cumulativePercentDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$sum)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$sum))/gi,
        argIndex: 2,
        argKey: "sum"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$unformattedsum)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$unformattedsum))/gi,
        argIndex: 2,
        argKey: "unformattedSum"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$targetvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$targetvalue))/gi,
        argIndex: 2,
        argKey: "targetValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$targetdatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$targetdatavalue))/gi,
        argIndex: 2,
        argKey: "targetDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$processname)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$processname))/gi,
        argIndex: 2,
        argKey: "processName"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$start)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$start))/gi,
        argIndex: 2,
        argKey: "start"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$end)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$end))/gi,
        argIndex: 2,
        argKey: "end"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$percentcomplete)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$percentcomplete))/gi,
        argIndex: 2,
        argKey: "percentComplete"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$taskpercentcomplete)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$taskpercentcomplete))/gi,
        argIndex: 2,
        argKey: "taskPercentComplete"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$taskstartdate)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$taskstartdate))/gi,
        argIndex: 2,
        argKey: "taskStartDate"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$taskenddate)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$taskenddate))/gi,
        argIndex: 2,
        argKey: "taskEndDate"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$tasklabel)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$tasklabel))/gi,
        argIndex: 2,
        argKey: "taskLabel"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$date)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$date))/gi,
        argIndex: 2,
        argKey: "date"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$percentofprevvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$percentofprevvalue))/gi,
        argIndex: 2,
        argKey: "percentOfPrevValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$sname)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$sname))/gi,
        argIndex: 2,
        argKey: "sName"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$lname)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$lname))/gi,
        argIndex: 2,
        argKey: "lName"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$fromid)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$fromid))/gi,
        argIndex: 2,
        argKey: "fromId"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$fromlabel)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$fromlabel))/gi,
        argIndex: 2,
        argKey: "fromLabel"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$toid)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$toid))/gi,
        argIndex: 2,
        argKey: "toId"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$tolabel)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$tolabel))/gi,
        argIndex: 2,
        argKey: "toLabel"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$fromxvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$fromxvalue))/gi,
        argIndex: 2,
        argKey: "fromXValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$fromyvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$fromyvalue))/gi,
        argIndex: 2,
        argKey: "fromYValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$fromxdatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$fromxdatavalue))/gi,
        argIndex: 2,
        argKey: "fromXDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$fromydatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$fromydatavalue))/gi,
        argIndex: 2,
        argKey: "fromYDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$fromlabel)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$fromlabel))/gi,
        argIndex: 2,
        argKey: "fromLabel"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$toxvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$toxvalue))/gi,
        argIndex: 2,
        argKey: "toXValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$toyvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$toyvalue))/gi,
        argIndex: 2,
        argKey: "toYValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$toxdatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$toxdatavalue))/gi,
        argIndex: 2,
        argKey: "toXDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$toydatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$toydatavalue))/gi,
        argIndex: 2,
        argKey: "toYDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$tolabel)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$tolabel))/gi,
        argIndex: 2,
        argKey: "toLabel"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$openvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$openvalue))/gi,
        argIndex: 2,
        argKey: "openValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$closevalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$closevalue))/gi,
        argIndex: 2,
        argKey: "closeValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$highvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$highvalue))/gi,
        argIndex: 2,
        argKey: "highValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$lowvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$lowvalue))/gi,
        argIndex: 2,
        argKey: "lowValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$opendatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$opendatavalue))/gi,
        argIndex: 2,
        argKey: "openDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$closedatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$closedatavalue))/gi,
        argIndex: 2,
        argKey: "closeDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$highdatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$highdatavalue))/gi,
        argIndex: 2,
        argKey: "highDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$lowdatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$lowdatavalue))/gi,
        argIndex: 2,
        argKey: "lowDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$maxvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$maxvalue))/gi,
        argIndex: 2,
        argKey: "maxValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$maxdatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$maxdatavalue))/gi,
        argIndex: 2,
        argKey: "maxDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$minvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$minvalue))/gi,
        argIndex: 2,
        argKey: "minValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$mindatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$mindatavalue))/gi,
        argIndex: 2,
        argKey: "minDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$q1)/gi,
        argIndex: 2,
        argKey: "Q1"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$unformattedQ1)/gi,
        argIndex: 2,
        argKey: "unformattedQ1"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$q3)/gi,
        argIndex: 2,
        argKey: "Q3"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$unformattedQ3)/gi,
        argIndex: 2,
        argKey: "unformattedQ3"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$median)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$median))/gi,
        argIndex: 2,
        argKey: "median"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$unformattedMedian)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$unformattedMedian))/gi,
        argIndex: 2,
        argKey: "unformattedMedian"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$SD)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$SD))/gi,
        argIndex: 2,
        argKey: "SD"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$unformattedsd)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$unformattedsd))/gi,
        argIndex: 2,
        argKey: "unformattedsd"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$QD)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$QD))/gi,
        argIndex: 2,
        argKey: "QD"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$unformattedQD)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$unformattedQD))/gi,
        argIndex: 2,
        argKey: "unformattedQD"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$MD)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$MD))/gi,
        argIndex: 2,
        argKey: "MD"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$unformattedMD)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$unformattedMD))/gi,
        argIndex: 2,
        argKey: "unformattedMD"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$mean)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$mean))/gi,
        argIndex: 2,
        argKey: "mean"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$unformattedMean)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$unformattedMean))/gi,
        argIndex: 2,
        argKey: "unformattedMean"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$unformattedMean)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$unformattedMean))/gi,
        argIndex: 2,
        argKey: "unformattedMean"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$volumeValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$volumeValue))/gi,
        argIndex: 2,
        argKey: "volumeValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$volumeDataValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$volumeDataValue))/gi,
        argIndex: 2,
        argKey: "volumeDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$fromXValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$fromXValue))/gi,
        argIndex: 2,
        argKey: "fromXValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$fromYValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$fromYValue))/gi,
        argIndex: 2,
        argKey: "fromYValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$fromXDataValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$fromXDataValue))/gi,
        argIndex: 2,
        argKey: "fromXDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$fromYDataValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$fromYDataValue))/gi,
        argIndex: 2,
        argKey: "fromYDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$fromLabel)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$fromLabel))/gi,
        argIndex: 2,
        argKey: "fromLabel"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$toXValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$toXValue))/gi,
        argIndex: 2,
        argKey: "toXValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$toYValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$toYValue))/gi,
        argIndex: 2,
        argKey: "toYValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$toXDataValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$toXDataValue))/gi,
        argIndex: 2,
        argKey: "toXDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$toYDataValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$toYDataValue))/gi,
        argIndex: 2,
        argKey: "toYDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$tolabel)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$tolabel))/gi,
        argIndex: 2,
        argKey: "toLabel"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$tlLabel)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$tlLabel))/gi,
        argIndex: 5,
        argKey: "tlLabel"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$trlabel)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$trlabel))/gi,
        argIndex: 5,
        argKey: "trLabel"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$bllabel)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$bllabel))/gi,
        argIndex: 5,
        argKey: "blLabel"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$brlabel)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$brlabel))/gi,
        argIndex: 5,
        argKey: "brLabel"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$rowlabel)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$rowlabel))/gi,
        argIndex: 5,
        argKey: "rowLabel"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$columnlabel)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$columnlabel))/gi,
        argIndex: 5,
        argKey: "columnLabel"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$errorvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$errorvalue))/gi,
        argIndex: 2,
        argKey: "errorValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$errordatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$errordatavalue))/gi,
        argIndex: 2,
        argKey: "errorDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$errorpercentvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$errorpercentvalue))/gi,
        argIndex: 2,
        argKey: "errorPercentValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$errorpercentdatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$errorpercentdatavalue))/gi,
        argIndex: 2,
        argKey: "errorPercentDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$horizontalErrorValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$horizontalErrorValue))/gi,
        argIndex: 2,
        argKey: "horizontalErrorValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$horizontalErrorDataValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$horizontalErrorDataValue))/gi,
        argIndex: 2,
        argKey: "horizontalErrorDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$verticalErrorValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$verticalErrorValue))/gi,
        argIndex: 2,
        argKey: "verticalErrorValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$verticalErrorDataValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$verticalErrorDataValue))/gi,
        argIndex: 2,
        argKey: "verticalErrorDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$horizontalErrorPercent)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$horizontalErrorPercentValue))/gi,
        argIndex: 2,
        argKey: "horizontalErrorPercentValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$horizontalErrorPercentDataValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$horizontalErrorPercentDataValue))/gi,
        argIndex: 2,
        argKey: "horizontalErrorPercentDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$verticalErrorPercent)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$verticalErrorPercentValue))/gi,
        argIndex: 2,
        argKey: "verticalErrorPercentValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$verticalErrorPercentDataValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$verticalErrorPercentDataValue))/gi,
        argIndex: 2,
        argKey: "verticalErrorPercentDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$xaxispercentvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$xaxispercentvalue))/gi,
        argIndex: 2,
        argKey: "xAxisPercentValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$percentdatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$percentdatavalue))/gi,
        argIndex: 2,
        argKey: "percentDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$trType)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$trType))/gi,
        argIndex: 4,
        argKey: "trtype"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$tlType)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$tlType))/gi,
        argIndex: 4,
        argKey: "tltype"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$brType)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$brType))/gi,
        argIndex: 4,
        argKey: "brtype"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$blType)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$blType))/gi,
        argIndex: 4,
        argKey: "bltype"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$colorRangeLabel)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$colorRangeLabel))/gi,
        argIndex: 5,
        argKey: "colorRangeLabel"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$zdatavalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$zdatavalue))/gi,
        argIndex: 2,
        argKey: "zDataValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$svalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$svalue))/gi,
        argIndex: 3,
        argKey: "svalue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$positiveErrorValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$positiveErrorValue))/gi,
        argIndex: 2,
        argKey: "positiveErrorValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$negativeErrorValue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$negativeErrorValue))/gi,
        argIndex: 2,
        argKey: "negativeErrorValue"
      }, {
        regex: /((^|[^\\])((\\)\\)*\$datasvalue)/gi,
        escapeRegex: /((^|[^\\])((\\)\\)*\\(\$datasvalue))/gi,
        argIndex: 2,
        argKey: "formattedsValue"
      }],
          n = [],
          r = t.length;

      for (e = 0; e < r; e += 1) {
        n.push(e);
      }

      return function () {
        var e,
            r,
            o,
            i,
            a,
            s = arguments[0],
            l = arguments[1];
        if (ve(l) || (l = n), s) for (a = l.length, i = 0; i < a; i += 1) {
          (o = t[l[i]]) && (e = Ve(Be((r = arguments[o.argIndex]) && r[o.argKey], G) + G), s = (s = s.replace(o.regex, "$2$4" + (o.parsingMethod ? o.parsingMethod(e) : e))).replace(o.escapeRegex, "$2$4$5"));
        }
        return s;
      };
    }(),
        Se = (p = function p(e, t, n, r, o) {
      var i,
          a = Math.abs(t - e),
          s = a / (n + 1);
      return m(a, n, r) || (o && (i = r > 1 ? 2 : .5, Number(s) / Number(r) < i && (r /= 10)), a = (s = (Math.floor(s / r) + 1) * r) * (n + 1)), a;
    }, g = function g(e) {
      e = Math.abs(e);
      var t = String(e),
          n = 0,
          r = t.indexOf(".");
      return -1 != r && (n = t.length - r - 1), n;
    }, m = function m(e, t, n) {
      return !(g(e / (t + 1)) > g(n));
    }, function (e, t, n, r, o, i, a, s) {
      var l,
          c,
          d,
          f,
          h,
          g,
          v,
          y,
          b,
          x,
          w,
          C,
          _,
          S,
          E,
          k,
          A,
          T,
          M,
          O,
          F,
          I,
          L,
          N,
          D,
          P,
          R,
          j = 0;

      if ((e = !0 === isNaN(e) || e === u ? .1 : e) === (t = !0 === isNaN(t) || t === u ? 0 : t) && 0 === e && (e = .1), o = void 0 === o || o, i = void 0 === i || i, v = Math.floor(Math.log(Math.abs(e)) / Math.LN10), y = Math.floor(Math.log(Math.abs(t)) / Math.LN10), b = Math.max(y, v), x = Math.pow(10, b), Math.abs(e) / x < 2 && Math.abs(t) / x < 2 && (b--, x = Math.pow(10, b)), w = Math.floor(Math.log(e - t) / Math.LN10), C = Math.pow(10, w), e - t > 0 && x / C >= 10 && (x = C, b = w), _ = (Math.floor(e / x) + 1) * x, S = t < 0 ? (Math.floor(Math.abs(t / x)) + 1) * x * -1 : i ? 0 : (S = Math.floor(Math.abs(t / x) - 1) * x) < 0 ? 0 : S, o && e <= 0 && (_ = 0), l = !(!n && 0 !== n), c = !(!r && 0 !== r), d = !1 === l || !0 === l && Number(n) < e && e - Number(n) > re ? _ : Number(n), f = !1 === c || !0 === c && Number(r) > t && Number(r) - t > re ? S : Number(r), h = Math.abs(d - f), g = x, !1 === c && !1 === l && s) {
        if (d > 0 && f < 0) {
          for (k = !1, T = p(f, d, a, A = g > 10 ? g / 10 : g, !1) - (a + 1) * A; !1 === k;) {
            if (m(T += (a + 1) * A, a, A)) if (E = T - h, M = T / (a + 1), O = (F = Math.min(Math.abs(f), d)) == Math.abs(f) ? -1 : 1, 0 === a) k = !0;else for (L = 1; L <= Math.floor((a + 1) / 2); L++) {
              (I = M * L) - F > E || I > F && (P = T - I) / M == Math.floor(P / M) && I / M == Math.floor(I / M) && (h = T, d = -1 == O ? P : I, f = -1 == O ? -I : -P, k = !0);
            }
          }
        } else E = (N = p(f, d, a, g, !0)) - h, h = N, d > 0 ? d += E : f -= E;
      } else s && (R = function R(e, t, n) {
        for (var r, o = 0, i = 1; !m(t, r = 0 === (r = e + o * i) ? 1 : r, n);) {
          if ((o = -1 == i || o > e ? ++o : o) > 25) {
            r = 0;
            break;
          }

          i = o <= e ? -1 * i : 1;
        }

        return r;
      }, a > 0 && (0 === (D = R(a, h, g)) && (D = R(a, h + 1, g), j = 1), a = D));
      return {
        Max: d,
        Min: f,
        Range: h,
        interval: g,
        divGap: (d - f + j) / (a + 1)
      };
    }),
        Ee = ((h = function h(e, t, n) {
      var r,
          o = n.jsVars && n.jsVars.smartLabel,
          i = e.offsetWidth,
          a = e.offsetHeight,
          s = this.chart,
          l = this.title,
          c = n._chartMessageImageStyle,
          d = Xe(t);
      l.y = a / 2, l.x = i / 2, s.bgSWF = l.text = u, t = d.string, d.image ? (s.bgSWF = t, s.bgImageHAlign = c.imageHAlign, s.bgImageVAlign = c.imageVAlign, s.bgImageScale = c.imageScale, s.bgSWFAlpha = c.imageAlpha) : t !== u && (o ? (qe(l.style), o.setStyle(l.style), r = o.getSmartText(Ge(t), i, a), l.text = r.text) : l.text = Ge(t), l.verticalAlign = "middle"), l.style = n._chartMessageStyle, delete n._chartMessageImageStyle, delete n._chartMessageStyle;
    }).prototype = {
      chart: {
        events: {},
        margin: [0, 0, 0, 0],
        backgroundColor: {
          FCcolor: {
            alpha: 0
          }
        }
      },
      credits: {
        href: W,
        text: "FusionCharts Trial",
        enabled: ae
      },
      legend: {
        enabled: !1
      },
      title: {
        text: "",
        style: {
          fontFamily: "Verdana,sans",
          fontSize: "10px",
          color: "#666666"
        }
      },
      plotOptions: {
        series: {}
      },
      series: [{}],
      exporting: {
        enabled: !1
      },
      nativeMessage: !0
    }).constructor = h,
        ke = {
      keyup: !0,
      blur: !0,
      click: !0,
      load: !0,
      dragstart: !0,
      dragmove: !0,
      dragend: !0,
      dblclick: !0,
      mousedown: !0,
      mousemove: !0,
      mouseout: !0,
      mouseover: !0,
      mouseup: !0,
      "fc-wheel": !0,
      "fc-click": !0,
      "fc-dragstart": !0,
      "fc-dragmove": !0,
      "fc-dragend": !0,
      "fc-dbclick": !0,
      "fc-mousedown": !0,
      "fc-mousemove": !0,
      "fc-mouseout": !0,
      "fc-mouseover": !0,
      "fc-mouseup": !0,
      "fc-pinchstart": oe || ie,
      "fc-pinchmove": oe || ie,
      "fc-pinchend": oe || ie,
      touchstart: oe || ie,
      touchmove: oe || ie,
      touchend: oe || ie,
      touchcancel: oe || ie
    },
        Ae = {
      stripWhitespace: /\s+/g,
      dropHash: J,
      startsRGBA: Z,
      cleanColorCode: Q,
      breakPlaceholder: K,
      hexcode: /^#?[0-9a-f]{6}/i
    },
        Te = {
      colors: {
        B90000: "B90000",
        FFFFFF: "FFFFFF",
        AAAAAA: "AAAAAA",
        c000000: "000000"
      },
      BLANK: "",
      DATASET: "dataset",
      NORMALSTRING: "normal",
      PX: "px",
      INPUT: "input",
      LABEL: "label",
      BLANKSPACE: " ",
      COMMA: ",",
      OBJECTBOUNDINGBOX: "objectBoundingBox",
      GROUPID: "groupId",
      EVENTARGS: "eventArgs",
      CIRCLE: "circle",
      POLYGON: "polygon",
      SPOKE: "spoke",
      RECTANGLE: "rectangle",
      ROLLOUT: "rollout",
      ROLLOVER: "rollover",
      DATAPLOTCLICK: "dataplotclick",
      defaultFontStr: "Verdana,sans",
      line: "line",
      bar: "bar",
      column: "column",
      volume: "volume",
      HUNDREDSTRING: "100",
      SEVENTYSTRING: "70",
      NINETYSTRING: "90",
      AUTOSTRING: "auto",
      configStr: "config",
      animationObjStr: "animationObj",
      showHoverEffectStr: "showHoverEffect",
      hiddenStr: "hidden",
      visibleStr: "visible",
      columnStr: "columns",
      barStr: "bars",
      barHotStr: "bar-hot",
      colHotStr: "col-hot",
      shadowStr: "shadow",
      dataLabelStr: "datalabel",
      errorBarStr: "errorBar",
      errorHotStr: "error-hot",
      errorShadowStr: "error-shadow",
      negativeValueStr: "negative-values",
      positiveValueStr: "positive-values",
      zeroPlaneStr: "zero-plane",
      categoryPlotsStr: "categoryplots",
      noneStr: "none",
      setRolloverAttrStr: "setRolloverAttr",
      setRolloutAttrStr: "setRolloutAttr",
      elementStr: "element",
      hotElementStr: "hotElement",
      strokeWidthStr: "stroke-width",
      strokeDashStr: "stroke-dasharray",
      strokeLineJoinStr: "stroke-linejoin",
      miterStr: "miter",
      visiblilityStr: "visibility",
      ROUND: "round",
      PERCENTAGESTRING: "%",
      pStr: "p",
      sStr: "s",
      divLineAlpha3DStr: "divLineAlpha3D",
      divLineAlphaStr: "divLineAlpha",
      altVGridColorStr: "altVGridColor",
      altVGridAlphaStr: "altVGridAlpha",
      altHGridColorStr: "altHGridColor",
      altHGridAlphaStr: "altHGridAlpha",
      PLOTFILLCOLOR_STR: "plotFillColor",
      UNDERSCORE: "_",
      gaugeFillColorStr: "gaugeFillColor",
      gaugeBorderColorStr: "gaugeBorderColor",
      NORMAL: "normal",
      BOLD: "bold",
      POINTER: "pointer",
      DEFAULT: "default",
      POSITION_MIDDLE: "middle",
      POSITION_START: "start",
      POSITION_TOP: "top",
      POSITION_BOTTOM: "bottom",
      POSITION_END: "end"
    },
        Me = function Me() {
      var e,
          t,
          n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
          r = arguments[1],
          o = n.length,
          i = -1;

      if ("function" == typeof r) {
        for (; ++i < o;) {
          if (null != (e = r(n[i], i, n)) && e >= e) for (t = e; ++i < o;) {
            null != (e = r(n[i], i, n)) && e > t && (t = e);
          }
        }
      } else for (; ++i < o;) {
        if (null != (e = n[i]) && e >= e) for (t = e; ++i < o;) {
          null != (e = n[i]) && e > t && (t = e);
        }
      }

      return t;
    },
        Oe = function Oe() {
      var e,
          t,
          n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
          r = arguments[1],
          o = n.length,
          i = -1;

      if ("function" == typeof r) {
        for (; ++i < o;) {
          if (null != (e = r(n[i], i, n)) && e <= e) for (t = e; ++i < o;) {
            null != (e = r(n[i], i, n)) && e < t && (t = e);
          }
        }
      } else for (; ++i < o;) {
        if (null != (e = n[i]) && e <= e) for (t = e; ++i < o;) {
          null != (e = n[i]) && e < t && (t = e);
        }
      }

      return t;
    };

    function Fe(e) {
      return void 0 !== e && null !== e;
    }

    function Ie(e) {
      e.data && (e.data.elScroll = !1);
    }

    function Le(e, t) {
      var n,
          r,
          o,
          a,
          s,
          l,
          c = {
        top: 0,
        left: 0
      },
          u = O.webkitIsFullScreen || O.mozFullScreen || O.msFullscreenElement || O.fullscreenElement,
          d = t && t.config,
          f = t && (t.eventListeners || (t.eventListeners = [])),
          h = t && (d.isEvntAdded || (d.isEvntAdded = !1));

      if (e) {
        if (u) c = e.getBoundingClientRect();else {
          for (c.top = e.offsetTop, c.left = e.offsetLeft, n = e; (n = n.parentNode) && "BODY" !== n.tagName;) {
            a = o = 0, (s = k.getComputedStyle(n).getPropertyValue("transform")) && "none" !== (l = s.replace(/\)/, "").split(/\,/))[0] && (N || L || T ? (o = -l[l.length - 4], a = -l[l.length - 3]) : (o = -l[l.length - 2], a = -l[l.length - 1])), t && (r = k.getComputedStyle(n).getPropertyValue("position"), /fixed/.test(r) && (d.itemFixed = !0)), c.top -= n.scrollTop || a || 0, c.left -= n.scrollLeft || o || 0, t && !h && f.push(i["default"].listen(n, "scroll", Ie, d)), t && !h && f.push(i["default"].listen(n, "transitionend", Ie, d));
          }

          for (; n;) {
            c.top -= n.scrollTop || 0, c.left -= n.scrollLeft || 0, n = n.parentNode;
          }

          for (; e = e.offsetParent;) {
            c.top += e.offsetTop, c.left += e.offsetLeft;
          }

          c.top += Ne(L ? O.documentElement.scrollTop : D ? O.body.scrollTop : k.pageYOffset, k.scrollY, O.documentElement.scrollTop), c.left += Ne(L ? O.documentElement.scrollLeft : D ? O.body.scrollLeft : k.pageXOffset, k.scrollX, O.documentElement.scrollLeft);
        }
        t && !h && (f.push(i["default"].listen(k, "resize", Ie, d)), f.push(i["default"].listen(k, "scroll", Ie, d)), d.isEvntAdded = !0);
      }

      return c;
    }

    function Ne() {
      var e, t, n;

      for (t = 0, n = arguments.length; t < n; t += 1) {
        if (((e = arguments[t]) || !1 === e || 0 === e) && !isNaN(e = Number(e))) return e;
      }

      return u;
    }

    function De(e) {
      var t = e && (e.sourceEvent || e.originalEvent || e);
      return oe && t && (t.touches && t.touches[0] || t.changedTouches && t.changedTouches[0]) || t || ue;
    }

    function Pe(e) {
      var t,
          n,
          r,
          o = e.data,
          i = o.chart,
          a = i.getFromEnv("animationManager"),
          s = e.state,
          l = ye(De(e.originalEvent)),
          c = i.getChildren("canvas")[0],
          u = t = c.getGraphicalElement("resizeBox"),
          d = o.layerX = l.pageX - o.chartPosLeft,
          f = o.layerY = l.pageY - o.chartPosTop,
          h = d - o.ox,
          p = f - o.oy,
          g = o.bBox,
          m = o.ox,
          v = o.oy,
          y = o.zoomX,
          b = o.zoomY,
          x = o.canvasY,
          w = o.canvasX,
          C = o.canvasW,
          _ = o.canvasH,
          S = o.canvasX2,
          E = o.canvasY2,
          k = o.strokeWidth,
          A = o.attr;

      switch (s) {
        case "start":
          n = Le(this), o.chartPosLeft = n.left, o.chartPosTop = n.top, d = l.pageX - o.chartPosLeft, f = l.pageY - o.chartPosTop, o.oy = f, o.ox = d, o.allowMove = !1, A.x = 0, A.y = 0, A.height = 0, A.width = 0, u = c.addGraphicalElement("resizeBox", a.setAnimation({
            el: t || "rect",
            attr: A,
            container: i.getChildContainer("trackerGroup")
          })).show(), t || c.addGraphicalElement("resizeBox", u), d > w && d < S && f > x && f < E && (o.allowMove = !0), e.target._isTrackerElem && (o.allowMove = !1);
          break;

        case "end":
          r = {
            chart: i,
            selectionLeft: (g = u.getBBox()).x,
            selectionTop: g.y,
            selectionHeight: g.height,
            selectionWidth: g.width,
            originalEvent: e.originalEvent
          }, o.isDragged && (o.selectionEnd && o.selectionEnd(r), o.isDragged = 0), u.hide(), delete o.oy, delete o.ox;
          break;

        default:
          if (!o.allowMove) return;
          h = d - o.ox, p = f - o.oy, g = o.bBox, m = o.ox, v = o.oy, o.isDragged || (r = {
            chart: i,
            selectionLeft: (y ? ce(m, m + h) : w) + .5 * k,
            selectionTop: (b ? ce(v, v + p) : x) + .5 * k,
            selectionHeight: 0,
            selectionWidth: 0,
            originalEvent: e.originalEvent
          }, o.selectionStart && o.selectionStart(r), o.isDragged = 1), h = -(m - ce(m - (m - le(m + h, w)), S)), p = -(v - ce(v - (v - le(v + p, x)), E)), a.setAnimation({
            el: u,
            attr: {
              x: (y ? ce(m, m + h) : w) + .5 * k,
              y: (b ? ce(v, v + p) : x) + .5 * k,
              width: y ? ee(h) : C,
              height: b ? ee(p) : _
            }
          });
      }
    }

    function Re(e) {
      var t = e.data,
          n = e.originalEvent,
          r = n.target || n.originalTarget || n.srcElement || n.relatedTarget || n.fromElement,
          o = n.type,
          i = n.layerX,
          a = n.layerY;
      i === u && (i = n.pageX - t.chartPosLeft, a = n.pageY - t.chartPosTop), "mousedown" === o && (r.ishot = i > t.canvasX && i < t.canvasX2 && a > t.canvasY && a < t.canvasY2), "mouseup" === o && setTimeout(function () {
        r.ishot = !1;
      }, 1);
    }

    function je() {
      var e, t, n;

      for (t = 0, n = arguments.length; t < n; t += 1) {
        if ((e = arguments[t]) || !1 === e || 0 === e) return e;
      }

      return G;
    }

    function Ve(e) {
      return e && e.replace(/\$/g, "$$$$");
    }

    function Be(e, t) {
      return e || !1 === e || 0 === e ? e : t;
    }

    function He() {
      var e, t, n;

      for (t = 0, n = arguments.length; t < n; t += 1) {
        if ((e = arguments[t]) || !1 === e || 0 === e) return e;
      }

      return u;
    }

    function Ge(e) {
      return "string" == typeof e ? e.replace(K, H) : G;
    }

    function ze(e, t, n) {
      var r = n % 2 / 2,
          o = ne(e + r) - r;
      return {
        position: o,
        distance: ne(e + t + r) - r - o
      };
    }

    function Ue(e, t) {
      xe(e.substr(0, e.indexOf("__FC_ARG_SEP__")).replace(/\s/g, G), e.substr(e.indexOf("__FC_ARG_SEP__")).replace(/__FC_ARG_SEP__/, ""), t);
    }

    function $e(e) {
      /^j\s*\-/.test(e) ? Ue(e.replace(/^j\s*\-/, G).replace(/\-/, "__FC_ARG_SEP__")) : Ue(e.replace(/^javascript\s*\:/i, G).replace(/[\'\"]?\s*\,\s*[\'\"]?/g, "__FC_ARG_SEP__").replace(/\(\s*[\'\"]?(.*)\)\;?/, "__FC_ARG_SEP__$1").replace(/[\'\"]?$/, ""), !0);
    }

    function Xe(e) {
      var t = {
        image: !1
      };
      return e !== u && (e = e.replace(/^\s+/, G).replace(/\s+$/, G), /^i\s*[\-]\s*/i.test(e) ? (t.image = !0, t.string = e.replace(/^i\s*[\-]\s*/i, G)) : t.string = e.replace(/^\\/, G)), t;
    }

    function We(e, t) {
      var n = te(10, t);
      return ne(e * n) / n;
    }

    function Ye(e, t, n) {
      return n || n === u ? [e, t] : A;
    }

    function qe(e, t) {
      return "object" !== (void 0 === e ? "undefined" : r(e)) ? G : ((e.fontSize || e["font-size"]) && (!e.fontSize && e["font-size"] && (e.fontSize = e["font-size"], delete e["font-size"]), e.lineHeight = (parseFloat(e.fontSize) || t || 10) * E + "px", delete e["line-height"]), !e.lineHeight && e["line-height"] && (e.lineHeight = e["line-height"], delete e["line-height"]), e.lineHeight);
    }

    function Ke(e, t) {
      return e - t;
    }

    function Je(e, t) {
      return t - e;
    }

    t.isInterActiveEvt = function (e) {
      return !!ke[e];
    }, t.addInterActiveEvtName = function (e) {
      e && e.toLowerCase && (ke[e.toLowerCase()] = !0);
    }, t.getEmptyConstractor = function () {
      return function () {};
    }, t.BLANKSTRINGPLACEHOLDER = "#BLANK#", t.isFirefox = M, t.UNDEF = u, t.UNDERSCORE = "_", t.BLANKSTRING = z, t.COLOR_BLACK = "000000", t.COLOR_GLASS = "rgba(255, 255, 255, 0.3)", t.COLOR_WHITE = "FFFFFF", t.COLOR_TRANSPARENT = "rgba(0,0,0,0)", t.HASHSTRING = "#", t.BREAKSTRING = H, t.STRINGSTRING = "string", t.OBJECTSTRING = "object", t.COMMASTRING = ",", t.ZEROSTRING = "0", t.SAMPLESTRING = "Ay0", t.TESTSTR = "Ag", t.ONESTRING = "1", t.DECIMALSTRING = ".", t.STRINGUNDEFINED = "undefined", t.POSITION_TOP = "top", t.POSITION_RIGHT = "right", t.POSITION_BOTTOM = "bottom", t.POSITION_LEFT = "left", t.POSITION_CENTER = "center", t.POSITION_MIDDLE = "middle", t.POSITION_START = "start", t.POSITION_END = "end", t.FC_CONFIG_STRING = "_FCconf", t.SHAPE_RECT = "rect", t.HUNDREDSTRING = "100", t.PXSTRING = X, t.COMMASPACE = ", ", t.TEXTANCHOR = "text-anchor", t.hiddenStr = "hidden", t.visibleStr = "visible", t.startsRGBA = Z, t.cleanColorCode = Q, t.TOUCH_THRESHOLD_PIXELS = 15, t.CLICK_THRESHOLD_PIXELS = 5, t.regex = Ae, t.getEventCoordinate = ye, t.getMouseCoordinate = function (e, t, n) {
      var r,
          o = O.webkitIsFullScreen || O.mozFullScreen || O.msFullscreenElement || O.fullscreenElement,
          i = ye(De(t)),
          a = o ? i.clientX : i.pageX,
          s = o ? i.clientY : i.pageY,
          l = n && n.config,
          c = t.type,
          u = l && l.itemFixed,
          h = u ? k.pageYOffset || k.scrollY || O.documentElement.scrollTop : 0,
          p = u ? k.pageXOffset || k.scrollX || O.documentElement.scrollLeft : 0;
      return l && l.elScroll && l.posOb ? r = l.posOb : (l && (l.elScroll = !0), r = Le(e, n), l && (l.posOb = r)), "touchend" === c ? (a = d, s = f) : "touchmove" !== c && "touchstart" !== c || (d = a, f = s), {
        chartX: a - r.left - p,
        chartY: s - r.top - h,
        pageX: a,
        pageY: s
      };
    }, t.getTouchEvent = De, t.extend2 = a["default"], t.imprint = function (e, t, n) {
      var o;
      if ("object" !== (void 0 === e ? "undefined" : r(e)) || null === e) return e = t, t;
      if ("object" !== (void 0 === t ? "undefined" : r(t)) || null === t) return e;

      for (o in t) {
        (e[o] === u || !n && null === e[o]) && (e[o] = t[o]);
      }

      return e;
    }, t.pluck = He, t.pluckNumber = Ne, t.getFirstDefinedValue = function () {
      var e, t, n;

      for (t = 0, n = arguments.length; t < n; t += 1) {
        if ((e = arguments[t]) || !1 === e || 0 === e || e == G) return e;
      }

      return u;
    }, t.createElement = function (e, t, n) {
      var r,
          o = O.createElement(e);

      for (r in t) {
        o.setAttribute(r, t[r]);
      }

      return n && n.appendChild && n.appendChild(o), o;
    }, t.polyPathToPath = function (e) {
      var t,
          n,
          r,
          o,
          i,
          a = e[0],
          s = e[1],
          l = e[2],
          c = e[3],
          u = e[4],
          d = e[5];
      if (t = [], a = k.parseInt(a, 10) || 0, s = Y(s) || 0, l = Y(l) || 0, c = Y(c) || 0, u = null === u || isNaN(u) ? .5 * Math.PI : u % 360 * (Math.PI / 180), d = null === d || isNaN(d) ? 0 : Y(d), o = u, a > 2) switch (n = 2 * Math.PI / a, d) {
        case 0:
          for (r = 0; r < a; r++) {
            t.push("L", s + c * Math.cos(-o), l + c * Math.sin(-o)), o += n;
          }

          t[0] = "M", t.push("Z");
          break;

        case 1:
          for (r = 0; r < a; r++) {
            t.push("M", s, l, "L", s + c * Math.cos(-o), l + c * Math.sin(-o)), o += n;
          }

          break;

        default:
          for (n *= .5, i = c * Math.cos(n) * (1 - d), r = 0; r < a; r++) {
            t.push("L", s + c * Math.cos(-o), l + c * Math.sin(-o)), o += n, t.push("L", s + i * Math.cos(-o), l + i * Math.sin(-o)), o += n;
          }

          t[0] = "M", t.push("Z");
      } else 0 === c ? t.push("M", s, l, "L", s, l, "Z") : t.push("M", s - c, l, "A", c, c, 0, 0, 0, s + c, l, "A", c, c, 0, 0, 0, s - c, l, "Z");
      return t;
    }, t.hashify = function (e) {
      return e && e.replace(/^#?([a-f0-9]+)/gi, "#$1") || "none";
    }, t.dehashify = function (e) {
      return e && e.replace(/^#?([a-f0-9]+)/gi, "$1") || "none";
    }, t.getComparatorFN = function (e, t) {
      return e ? t ? function (e, n) {
        return e[t] - n[t];
      } : Ke : t ? function (e, n) {
        return n[t] - e[t];
      } : Je;
    }, t.pluckFontSize = function () {
      var e, t, n;

      for (t = 0, n = arguments.length; t < n; t += 1) {
        if (((e = arguments[t]) || !1 === e || 0 === e) && !isNaN(e = Number(e))) return e < 1 ? 1 : e;
      }

      return 1;
    }, t.getValidValue = Be, t.getPosition = Le, t.getViewPortDimension = be, t.bindSelectionEvent = function (e, t) {
      t = t || {};
      var n = e.config,
          r = e.getFromEnv("chart-container"),
          o = n.zoomType,
          s = (0, a["default"])({}, t.attr || {}),
          l = s["stroke-width"] = Ne(s.strokeWidth, s["stroke-width"], 1),
          c = e.eventListeners || (e.eventListeners = []),
          u = Le(r, e);
      t = (0, a["default"])({
        chart: e,
        zoomX: /x/.test(o),
        zoomY: /y/.test(o),
        canvasY: n.canvasTop,
        canvasX: n.canvasLeft,
        canvasW: n.canvasWidth,
        canvasH: n.canvasHeight,
        canvasX2: n.canvasLeft + n.canvasWidth,
        canvasY2: n.canvasTop + n.canvasHeight,
        strokeWidth: l,
        chartPosLeft: u.left,
        chartPosTop: u.top,
        attr: s
      }, t), s.stroke = je(s.stroke, "rgba(51,153,255,0.8)"), s.fill = je(s.fill, "rgba(185,213,241,0.3)"), r && (i["default"].unlisten(r, "pointerdrag", Pe), c.push(i["default"].listen(r, "pointerdrag", Pe, t))), n.link && (i["default"].unlisten(e.getFromEnv("chart-container"), "mouseup mousedown", Re), c.push(i["default"].listen(e.getFromEnv("chart-container"), "mouseup mousedown", Re, t)));
    }, t.fcEach = function (e, t, n, r) {
      var o;

      if (n || (n = e), r || (r = {}), ve(e)) {
        for (o = 0; o < e.length; o += 1) {
          if (!1 === t.call(n, e[o], o, e, r)) return o;
        }
      } else if (null !== e && e !== u) for (o in e) {
        if (!1 === t.call(n, e[o], o, e, r)) return o;
      }
    }, t.getDefinedColor = function (e, t) {
      return e || 0 === e || e === G ? e : t;
    }, t.getFirstValue = je, t.getColorCodeString = function (e, t) {
      var n,
          r,
          o = "",
          i = 0,
          a = t.split(U);

      for (r = a.length; i < r; i += 1) {
        2 === (n = a[i].split("-")).length ? "-1" !== n[0].indexOf("dark") ? o += (0, s.getLightColor)(e, 100 - parseInt(n[1], 10)) + U : o += (0, s.getDarkColor)(e, 100 - parseInt(n[1], 10)) + U : o += a[i] + U;
      }

      return o.substring(0, o.length - 1);
    }, t.clampNumber = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -Infinity,
          n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
      return e <= t ? t : e >= n ? n : e;
    }, t.toRaphaelColor = we, t.rgbaToHex = function (e) {
      return "#" + ("000000" + ((e = e.replace("rgba(", z).split(","))[0] << 16 | e[1] << 8 | e[2]).toString(16)).slice(-6);
    }, t.gradientify = Ce, t.fastTrim = function (e) {
      for (var t = /\s/, n = (e = e.replace(/^\s\s*/, "")).length; t.test(e.charAt(n -= 1));) {
        ;
      }

      return e.slice(0, n + 1);
    }, t.parsePointValue = s.parsePointValue, t.parseUnsafeString = Ge, t.parseTooltext = _e, t.toPrecision = We, t.hasTouch = ie, t.creditLabel = ae, t.CREDIT_HREF = W, t.CREDIT_STRING = "FusionCharts Trial", t.regescape = function (e) {
      return e && e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    }, t.regReplaceEscape = Ve, t.getImageURL = Xe, t.isArray = ve, t.getCrispValue = ze, t.getCripValues = ze, t.preDefStr = Te, t.stubFN = function () {}, t.stableSort = function (e, t) {
      var n,
          r = e.length;

      for (n = 0; n < r; n++) {
        e[n].ssI = n;
      }

      for (e.sort(function (e, n) {
        var r = t(e, n);
        return 0 === r ? e.ssI - n.ssI : r;
      }), n = 0; n < r; n++) {
        delete e[n].ssI;
      }
    }, t.hasSVG = I, t.CREDIT_REGEX = q, t.isIE = N, t.isIE11 = L, t.isIE9 = T, t.isEdge = D, t.lineHeightFactor = 1.2, t.getLinkAction = function (e, t) {
      var n = function n(e) {
        return e;
      };

      return function (r) {
        if (!r || !t.config.clickURLOverridesPlotLinks) {
          var o,
              i,
              a,
              s,
              l,
              c,
              d,
              f,
              h,
              p,
              g = Ne((e.chart || e.map || {}).unescapelinks, 1),
              m = this.entity || u,
              v = this.entityBox || u,
              y = this.link,
              b = y;

          if (y !== u) {
            switch (g && (y = k.decodeURIComponent ? k.decodeURIComponent(y) : k.unescape(y)), -1 !== (y = y.replace(/^\s+/, G).replace(/\s+$/, G)).search(/^[a-z]*\s*[\-\:]\s*/i) && (p = (l = y.split(/\s*[\-\:]\s*/)[0].toLowerCase()).length), r && (t.config.hotElemClicked = !0), l) {
              case "j":
              case "javascript":
                $e(y);
                break;

              case "n":
                y.replace(/^n\s*\-/i, "n-"), k.open(n(y.slice(2)));
                break;

              case "f":
                -1 !== (o = (y = y.replace(/^f\s*\-/i, "f-")).indexOf("-", 2)) ? (i = y.substr(2, o - 2)) && k.frames[i] ? k.frames[i].location = n(y.slice(o + 1)) : k.open(n(y.slice(o + 1)), i) : k.open(n(y.slice(2)));
                break;

              case "p":
                o = (y = y.replace(/p\s*\-/i, "p-")).indexOf("-", 2), a = y.indexOf(U, 2), -1 === o && (o = 1), s = n(y.slice(o + 1)), (h = k.open(s, y.substr(2, a - 2), y.substr(a + 1, o - a - 1))) && h.focus();
                break;

              case "newchart":
              case "newmap":
                switch (":" === y.charAt(p) && (o = y.indexOf("-", p + 1), f = y.substring(p + 1, o), p = o), o = y.indexOf("-", p + 1), c = y.substring(p + 1, o).toLowerCase()) {
                  case "xmlurl":
                  case "jsonurl":
                    d = y.substring(o + 1, y.length);
                    break;

                  case "xml":
                  case "json":
                    d = function (e, t) {
                      var n,
                          r = {
                        chart: {}
                      },
                          o = t;
                      if (e = e.toLowerCase(), o.linkeddata) for (n = 0; n < o.linkeddata.length; n += 1) {
                        o.linkeddata[n].id.toLowerCase() === e && (r = o.linkeddata[n].linkedchart || o.linkeddata[n].linkedmap);
                      }
                      return r;
                    }(y.substring(o + 1, y.length), e), c = "json";
                }

                t.fireChartInstanceEvent("linkedChartInvoked", {
                  alias: f,
                  linkType: c.toUpperCase(),
                  data: d,
                  clickedEntity: m,
                  clickedEntityBox: v
                });
                break;

              default:
                k.location.href = n(y);
            }

            t.fireChartInstanceEvent("linkClicked", {
              linkProvided: b,
              linkInvoked: y,
              linkAction: l && l.toLowerCase()
            });
          }
        }
      };
    }, t.setImageDisplayMode = function (e, t, n, r, o, i, a, s) {
      var c = s.width * (r / 100),
          u = s.height * (r / 100),
          d = i - 2 * o,
          f = a - 2 * o;
      return (0, l.getAlignImage)(t, n, e, c, u, i, a, o, d, f);
    }, t.setLineHeight = qe, t.parsexAxisStyles = function (e, t, n, r, o) {
      var i,
          a = je(e.labelbordercolor, t.bordercolor, n.labelbordercolor, G),
          l = He(e.labelbgcolor, t.bgcolor, n.labelbgcolor),
          c = Ne(e.labelborderthickness, t.borderthickness, n.labelborderthickness, 1),
          u = Ne(n.usedataplotcolorforlabels, 0) && o || r.color;
      return a = a ? (0, s.convertColor)(a, Ne(e.labelborderalpha, t.borderalpha, n.labelborderalpha, e.labelalpha, t.alpha, n.labelalpha, 100)) : G, (i = {
        fontFamily: He(e.labelfont, t.font, n.labelfont, r.fontFamily),
        fontSize: He(e.labelfontsize, t.fontsize, n.labelfontsize, parseInt(r.fontSize, 10)) + X,
        color: (0, s.convertColor)(He(e.labelfontcolor, t.fontcolor, n.labelfontcolor, u), Ne(e.labelfontalpha, t.fontalpha, n.labelfontalpha, e.labelalpha, t.alpha, n.labelalpha, 100)),
        fontWeight: Ne(e.labelfontbold, t.fontbold, n.labelfontbold) ? "bold" : "normal",
        fontStyle: Ne(e.labelfontitalic, t.fontitalic, n.labelfontitalic) ? "italic" : "normal",
        border: a || l ? c + "px solid" : G,
        borderColor: a,
        borderThickness: c,
        borderPadding: Ne(e.labelborderpadding, t.borderpadding, n.labelborderpadding, 2),
        borderRadius: Ne(e.labelborderradius, t.borderradius, n.labelborderradius, 0),
        backgroundColor: l ? (0, s.convertColor)(l, Ne(e.labelbgalpha, t.bgalpha, n.labelbgalpha, e.labelalpha, t.alpha, n.labelalpha, 100)) : G,
        borderDash: Ne(e.labelborderdashed, t.borderdashed, n.labelborderdashed, 0) ? Ye(Ne(e.labelborderdashlen, t.borderdashlen, n.labelborderdashlen, 4), Ne(e.labelborderdashgap, t.borderdashgap, n.labelborderdashgap, 2)) : A
      }).lineHeight = qe(i), i;
    }, t.supportedStyle = {
      font: "font",
      fontFamily: "font-family",
      "font-family": "font-family",
      fontWeight: "font-weight",
      "font-weight": "font-weight",
      fontSize: "font-size",
      "font-size": "font-size",
      lineHeight: "line-height",
      "line-height": "line-height",
      textDecoration: "text-decoration",
      "text-decoration": "text-decoration",
      color: "color",
      whiteSpace: "white-space",
      "white-space": "white-space",
      padding: "padding",
      margin: "margin",
      background: "background",
      backgroundColor: "background-color",
      "background-color": "background-color",
      backgroundImage: "background-image",
      "background-image": "background-image",
      backgroundPosition: "background-position",
      "background-position": "background-position",
      backgroundPositionLeft: "background-position-left",
      "background-position-left": "background-position-left",
      backgroundPositionTop: "background-position-top",
      "background-position-top": "background-position-top",
      backgroundRepeat: "background-repeat",
      "background-repeat": "background-repeat",
      border: "border",
      borderColor: "border-color",
      "border-color": "border-color",
      borderStyle: "border-style",
      "border-style": "border-style",
      borderThickness: "border-thickness",
      "border-thickness": "border-thickness",
      borderTop: "border-top",
      "border-top": "border-top",
      borderTopColor: "border-top-color",
      "border-top-color": "border-top-color",
      borderTopStyle: "border-top-style",
      "border-top-style": "border-top-style",
      borderTopThickness: "border-top-thickness",
      "border-top-thickness": "border-top-thickness",
      borderRight: "border-right",
      "border-right": "border-right",
      borderRightColor: "border-right-color",
      "border-right-color": "border-right-color",
      borderRightStyle: "border-right-style",
      "border-right-style": "border-right-style",
      borderRightThickness: "border-right-thickness",
      "border-right-thickness": "border-right-thickness",
      borderBottom: "border-bottom",
      "border-bottom": "border-bottom",
      borderBottomColor: "border-bottom-color",
      "border-bottom-color": "border-bottom-color",
      borderBottomStyle: "border-bottom-style",
      "border-bottom-style": "border-bottom-style",
      borderBottomThickness: "border-bottom-thickness",
      "border-bottom-thickness": "border-bottom-thickness",
      borderLeft: "border-left",
      "border-left": "border-left",
      borderLeftColor: "border-left-color",
      "border-left-color": "border-left-color",
      borderLeftStyle: "border-left-style",
      "border-left-Style": "border-left-style",
      borderLeftThickness: "border-left-thickness",
      "border-left-thickness": "border-left-thickness"
    }, t.getAxisLimits = Se, t.getDashStyle = Ye, t.chartAPI = void 0, t.createDialog = Ee, t.componentDispose = function Ze() {
      var e, t, n, r, o, i, a, s, l, c, u, d;

      if (this && this !== k) {
        if (this.disposing = !0, e = this.components) for (n in e) {
          if ((t = e[n]) instanceof Array) for (r = t.length, o = 0; o < r; o++) {
            (d = t[o]) && !this.disposing && (d.dispose ? d.dispose() : Ze.call(d));
          } else t && !t.disposing && (t.dispose ? t.dispose() : Ze.call(t));
        }

        for (s in i = this.graphics) {
          if (a = i[s]) if (a.hide) a.hide(), a.followers && a.followers[0] && (u = a.followers[0].el) && u.hide && u.hide();else for (l in a) {
            (c = a[l]).hide && c.hide();
          }
        }

        for (n in this) {
          delete this[n];
        }
      }
    }, t.executeJS = Ue, t.pseudoEval = $e, t.validhexcolor = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i, t.appliedCSS = ["fontFamily", "fontSize", "fontWeight", "fontStyle"], t.getContainerBackgroundColor = function (e) {
      var t = e.options,
          n = t.containerBackgroundColor,
          r = t.containerBackgroundOpacity;
      return Fe(e.jsVars.transparent) ? r = e.jsVars.transparent ? 0 : 1 : (r = parseFloat(r)) < 0 ? r = 0 : r > 1 && (r = 1), n || (n = "#ffffff"), N && !I ? r ? n : "transparent" : (n = n.replace(/^#?([a-f0-9]+)/gi, "$1"), (n = (0, s.HEXtoRGB)(n))[3] = r.toString(), "rgba(" + n.join(",") + ")");
    }, t.capitalizeString = function (e, t) {
      return e ? e.replace(t ? /(^|\s)([a-z])/g : /(^|\s)([a-z])/, function (e, t, n) {
        return t + n.toUpperCase();
      }) : e;
    }, t.TRACKER_FILL = B, t.chartPaletteStr = ge, t.DASH_DEF = A, t.attrTypeNum = 1, t.canvasBGAlphaStr = "canvasBgAlpha", t.attrTypeBool = 2, t.pInt = function (e, t) {
      return parseInt(e, t || 10);
    }, t.defined = Fe, t.canvasBorderColorStr = "canvasBorderColor", t.attribDefs = o.attribDefs, t.parseConfiguration = o.parseConfiguration, t.setAttribDefs = o.setAttribDefs, t.hasAttribDefs = o.hasAttribDefs, t.crispBound = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0,
          t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0,
          n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0,
          r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0,
          o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0,
          i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {},
          a = arguments[6];
      if (r < 1 || n < 1) return {
        x: e,
        y: t,
        width: n,
        height: r,
        "stroke-width": o
      };
      (o >= n || o >= r) && (o = Math.floor(Math.min(n, r) / 2) || o);
      var s = e,
          l = t,
          c = e + n,
          u = o / 2,
          d = o % 2,
          f = t + r;
      return l = i.top ? Math.round(l) + u - me : d ? Math.floor(l) + .5 - me : Math.round(l) - me, f = i.bottom ? Math.round(f) - u - me : a && i.top ? Math.round(f) + u - me : d ? Math.floor(f) + .5 - me : Math.round(f) - me, s = i.left ? Math.round(s) + u - me : a && i.right ? Math.round(s) - u - me : d ? Math.floor(s) + .5 - me : Math.round(s) - me, c = i.right ? Math.round(c) - u - me : d ? Math.floor(c) + .5 - me : Math.round(c) - me, {
        x: s,
        y: l,
        width: Math.abs(c - s),
        height: Math.abs(f - l),
        "stroke-width": o
      };
    }, t.defaultGaugePaletteOptions = fe, t.MathExt = he, t.xssEncode = function (e) {
      return null === e || void 0 === e || "function" != typeof e.toString ? "" : e = e.toString().replace(/&/g, "&amp;").replace(/\'/g, "&#39;").replace(/\"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }, t.animHelperFN = {
      getTimeByValue: function getTimeByValue(e, t, n) {
        var r = (e.end - e.start) / (t.endPx - t.startPx);
        return {
          start: e.start + r * (n.startPx - t.startPx),
          end: e.start + r * (n.endPx - t.startPx)
        };
      },
      animByWeight: function animByWeight(e, t, n, r, o) {
        return {
          start: e / --t * n * (r = r || 1) + (o = o || 0),
          end: e / t * n * r + n + o
        };
      }
    }, t.mathAbs = ee, t.mathRound = ne, t.NORMAL = "normal", t.BOLD = "bold", t.HAND = "pointer", t.POINTER = "pointer", t.BLANK = G, t.ROUND = "round", t.configStr = "config", t.animationObjStr = "animationObj", t.COMMA = U, t.TILE = "tile", t.FILL = "fill", t.FIT = "fit", t.MOUSEOUT = "fc-mouseout", t.MOUSEMOVE = "fc-mousemove", t.touchEnabled = oe, t.VISIBLE = "visible", t.BGRATIOSTRING = void 0, t.dropHash = J, t.componentFactory = function (e, t, n) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1,
          o = arguments[4];

      if (e && t && n) {
        var i,
            a = e.getChildren(n) || [],
            s = void 0,
            l = void 0;

        for (s = 0; s < r; s += 1) {
          a && a[s] && !a[s].getState("removed") ? l = a[s] : (l = new t(), e.attachChild(l, n)), o && o.length > s && l.configure && l.configure(o[s]);
        }

        if (s < (i = a && a.length)) for (; s < i; s += 1) {
          a[s] && a[s].remove && a[s].remove();
        }
      }
    }, t.datasetFactory = function (e, t, n) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1,
          o = arguments[4],
          i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

      if (e && t && n) {
        var a,
            s = e.getChildren(n) || [],
            l = void 0,
            c = void 0;

        for (l = 0; l < r; l += 1) {
          s && s[l] && !s[l].getState("removed") ? c = s[l] : (c = new t(), e.attachChild(c, n)), c.config._childIndex = l, c.setState("_total", r), c.setJSONIndex && c.setJSONIndex(i[l] || l), o && o.length > l && c.configure && c.configure(o[l]);
        }

        if (l < (a = s && s.length)) for (; l < a; l += 1) {
          s[l] && s[l].remove && s[l].remove();
        }
      }
    }, t.trimString = function (e) {
      for (var t = /\s/, n = (e = e.replace(/^\s\s*/, "")).length; t.test(e.charAt(n -= 1));) {
        ;
      }

      return e.slice(0, n + 1);
    }, t.PROJECT_VERSION = "3.13.3-sr.1", t.LINE_HEIGHT_FACTOR = E, t.safeMax = Me, t.safeMin = Oe, t.normalizeAngle = function (e, t) {
      var n = t ? 360 : pe;
      return (e = (e || 0) % n) < 0 ? n + e : e;
    }, t.extent = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
          t = arguments[1],
          n = Me(e, t);
      return [Oe(e, t), n];
    }, t.getSuggestiveRotation = function () {
      var e, t, n, r;
      return e = arguments[0], 1 === arguments.length ? (t = e.angle, n = e.x, r = e.y) : (t = e, n = arguments[1], r = arguments[2]), $ + (t = t || 0) + U + n + U + r;
    }, t.isXSSSafe = function (e, t) {
      return (!t || null === V.exec(e)) && null === j.exec(e);
    }, t.normalizeCSSDimension = function (e, t, n) {
      var r = void 0 === e ? n.offsetWidth || parseFloat(n.style.width) : e,
          o = void 0 === t ? n.offsetHeight || parseFloat(n.style.height) : t,
          i = {},
          a = n.style,
          s = void 0;
      if (a.width = r = r.toString ? r.toString() : "0", a.height = o = o.toString ? o.toString() : "0", (i.widthIsRelative = r.match(/^\s*\d*\.?\d*\%\s*$/) && !r.match(/^\s*0\%\s*$/)) && 0 === n.offsetWidth) for (s = n; s = s.offsetParent;) {
        if (s.offsetWidth > 0) {
          r = (s.offsetWidth * parseFloat(r.match(/\d*/)[0]) / 100).toString();
          break;
        }
      }
      if ((i.heightIsRelative = o.match(/^\s*\d*\.?\d*\%\s*$/) && !o.match(/^\s*0\%\s*$/)) && n.offsetHeight <= 20) for (s = n; s = s.offsetParent;) {
        if (s.offsetHeight > 0) {
          o = (s.offsetHeight * parseFloat(o.match(/\d*/)[0]) / 100).toString();
          break;
        }
      }
      return i.width = r.replace ? r.replace(/^\s*(\d*\.?\d*)\s*$/gi, "$1px") : r, i.height = o.replace ? o.replace(/^\s*(\d*\.?\d*)\s*$/gi, "$1px") : o, a.width = i.width, a.height = i.height, i.pixelWidth = i.widthIsRelative ? n.offsetWidth : parseInt(i.width, 10) || 0, i.pixelHeight = i.heightIsRelative ? n.offsetHeight : parseInt(i.height, 10) || 0, i;
    }, t.domInsertModes = {
      REPLACE: "replace",
      APPEND: "append",
      PREPEND: "prepend"
    }, t._manageInteractiveSpace = function () {
      var e,
          t,
          n,
          r,
          o,
          i,
          a,
          s = this.config,
          l = this.getChildren(),
          c = l.xAxis[0],
          u = l.yAxis[0],
          d = l.canvas && l.canvas[0],
          f = d.config,
          h = f.canvasBorderWidth,
          p = f.canvasPaddingTop,
          g = f.canvasPaddingBottom,
          m = f.canvasPadding || 0,
          v = f.canvasPaddingLeft,
          y = f.canvasPaddingRight,
          b = s.xAxisSpaceAllocation,
          x = s.yAxisSpaceAllocation[0].spaceTaken;
      r = s.availableHeight, t = s.xAxisSpaceAllocation = c.placeAxis(r + b.bottom), o = s.availableWidth, n = s.yAxisSpaceAllocation[0].spaceTaken = u.placeAxis(o + x.left), e = t.bottom - b.bottom, a = n.left - x.left, e && this._allocateSpace({
        bottom: e
      }), a && this._allocateSpace({
        left: a
      }), c && c.setAxisDimention({
        x: s.canvasLeft + Math.max(v, m),
        y: s.canvasBottom + h,
        opposite: s.canvasTop - h,
        axisLength: s.canvasWidth - Math.max(v, m) - Math.max(y, m)
      }), i = s.canvasLeft - h, u && u.setAxisDimention({
        x: i,
        y: s.canvasTop + p,
        axisLength: s.canvasHeight - p - g
      }), (e || a) && d.asyncDraw();
    }, t.convertColor = s.convertColor, t.getDarkColor = s.getDarkColor, t.getLightColor = s.getLightColor, t.mapSymbolName = s.mapSymbolName, t.getColumnColor = s.getColumnColor, t.getPointColor = s.getPointColor, t.getAngle = s.getAngle, t.parseColor = s.parseColor, t.getValidColor = s.getValidColor, t.RGBtoHex = s.RGBtoHex, t.rawRGBtoHEX = s.rawRGBtoHEX, t.HEXtoRGB = s.HEXtoRGB, t.getFirstColor = s.getFirstColor, t.getFirstAlpha = s.getFirstAlpha, t.isIpad = P, t.DEFAULT_FT_FONT = R;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = 1,
        i = 2,
        a = void 0,
        s = {},
        l = Math.max;
    t.attribDefs = r = {
      setBorderWidth: {
        type: o,
        pAttr: "plotborderthickness"
      },
      plotborderthickness: {
        type: o,
        pAttr: "plotborderthickness"
      },
      showBorderEffect: {
        parser: function parser() {
          var e = arguments[1];
          return 1 == +e.showplotborder && .1 === e.plotborderthickness ? 1 : 0;
        }
      },
      alphaanimation: {
        type: o
      },
      showplotborder: {
        type: o,
        pAttr: "showplotborder"
      },
      zeroplanethickness: {
        type: o
      },
      showzeroplaneontop: {
        type: o
      },
      stickytracking: {
        type: o
      },
      usemessagelog: {
        type: o
      },
      showtooltip: {
        type: o,
        pAttr: "showtooltip"
      },
      seriesnameintooltip: {
        type: o
      },
      plothovereffect: {
        type: o,
        attr: "anchorhovereffect"
      },
      anchorhovereffect: {
        type: o,
        attr: "showhovereffect"
      },
      showhovereffect: {
        type: o
      },
      linethickness: {
        type: o,
        pAttr: "linethickness"
      },
      dashed: {
        type: o,
        pAttr: "linedashed"
      },
      linedashed: {
        type: o,
        attr: "plotborderdashed"
      },
      plotborderdashed: {
        type: o,
        pAttr: "plotborderdashed"
      },
      linedashlen: {
        type: o,
        pAttr: "linedashlen"
      },
      linedashgap: {
        type: o,
        pAttr: "linedashgap"
      },
      anchoralpha: {
        pAttr: "anchoralpha"
      },
      anchorsides: {
        type: o,
        pAttr: "anchorsides"
      },
      anchorradius: {
        type: o,
        pAttr: "anchorradius"
      },
      anchorbgalpha: {
        pAttr: "anchorbgalpha"
      },
      anchorbgcolor: {
        pAttr: "anchorbgcolor"
      },
      anchorbordercolor: {
        pAttr: "anchorbordercolor"
      },
      anchorstartangle: {
        type: o,
        pAttr: "anchorstartangle"
      },
      anchorimageurl: {
        pAttr: "anchorimageurl"
      },
      anchorimagescale: {
        type: o,
        pAttr: "anchorimagescale"
      },
      anchorimagealpha: {
        pAttr: "anchorimagealpha"
      },
      anchorimagepadding: {
        type: o,
        pAttr: "anchorimagepadding"
      },
      anchorborderthickness: {
        type: o,
        pAttr: "anchorborderthickness"
      },
      anchorshadow: {
        type: o,
        pAttr: "anchorshadow"
      },
      valuepadding: {
        type: o,
        pAttr: "valuepadding"
      },
      valueposition: {
        pAttr: "valueposition"
      },
      plotfillangle: {
        type: o,
        pAttr: "plotfillangle"
      },
      useplotgradientcolor: {
        type: o
      },
      rotatevalues: {
        type: o,
        pAttr: "rotatevalues"
      },
      includeinlegend: {
        type: o
      },
      connectnulldata: {
        type: o
      },
      plotfillalpha: {
        pAttr: "plotfillalpha"
      },
      alpha: {
        pAttr: "linealpha"
      },
      linealpha: {
        pAttr: "plotfillalpha"
      },
      showvalues: {
        type: o,
        pAttr: "showvalues"
      },
      showpercentvalues: {
        type: o,
        parser: function parser(e) {
          return e.isstacked && e.stack100percent ? 1 : 0;
        }
      },
      showpercentintooltip: {
        type: o,
        parser: function parser(e) {
          return e.isstacked && e.stack100percent ? 1 : 0;
        }
      },
      stack100percent: {
        type: o,
        attr: "usepercentdistribution"
      },
      drawfullareaborder: {
        type: o
      },
      use3dlineshift: {
        type: o
      },
      parentyaxis: {
        type: o
      },
      radarborderthickness: {
        type: o
      },
      radarborderradius: {
        type: o
      },
      gaugeoriginx: {
        type: o
      },
      hasgaugeoriginx: {
        attr: "gaugeoriginx"
      },
      gaugeoriginy: {
        type: o
      },
      hasgaugeoriginy: {
        attr: "gaugeoriginy"
      },
      gaugeradius: {
        type: o
      },
      hasgaugeradius: {
        attr: "gaugeradius"
      },
      showgaugeborder: {
        type: o
      },
      setAdaptiveMin: {
        type: o
      },
      adjustDiv: {
        type: o
      },
      axisNameWidth: {
        type: o
      },
      rotateAxisName: {
        type: o
      },
      useEllipsesWhenOverflow: {
        type: o
      },
      showZeroPlane: {
        type: o
      },
      zeroPlaneAlpha: {
        type: o
      },
      showZeroPlaneValue: {
        type: o
      },
      zeroPlaneOnTop: {
        type: o
      },
      trendlineThickness: {
        type: o
      },
      showTrendlinesOnTop: {
        type: o
      },
      trendlinesAreDashed: {
        type: o
      },
      trendlinesDashLen: {
        type: o
      },
      trendlinesDashGap: {
        type: o
      },
      showTrendlines: {
        type: o
      },
      showTrendlineLabels: {
        type: o
      },
      showLabels: {
        type: o
      },
      rotateLabels: {
        type: o
      },
      slantLabel: {
        type: o
      },
      showAxisValues: {
        type: o
      },
      showTooltip: {
        type: o
      },
      maxLabelHeight: {
        type: o
      },
      useroundedges: {
        type: o,
        pAttr: "useroundedges"
      },
      placevaluesinside: {
        type: o
      },
      plotpaddingpercent: {
        type: o
      },
      use3dlighting: {
        type: o,
        pAttr: "use3dlighting"
      },
      usedataplotcolorforlabels: {
        type: o
      },
      plotspacepercent: {
        type: o,
        parser: function parser(e) {
          return l(e.plotspacepercent % 100, 0);
        }
      },
      ratio: {
        pAttr: "plotfillratio"
      },
      base: {
        type: o
      },
      showMinorDivLineValues: {
        type: o
      },
      numMinorDivLines: {
        type: o
      },
      majorTMNumber: {
        type: o
      },
      majorTMHeight: {
        type: o
      },
      showTickMarks: {
        type: o
      },
      majorTMThickness: {
        type: o
      },
      adjustTM: {
        type: i
      },
      minorTMNumber: {
        type: o
      },
      minorTMThickness: {
        type: o
      },
      tickMarkDistance: {
        type: o
      },
      placeTicksInside: {
        type: o
      },
      placeValuesInside: {
        type: o
      },
      axisValuePadding: {
        type: o
      },
      gridLineWidth: {
        type: o
      },
      showRadarBorder: {
        type: o
      },
      radarBorderThickness: {
        type: o
      },
      maxcolwidth: {
        type: o,
        parser: function parser(e) {
          return Math.abs(e.maxcolwidth);
        }
      },
      maxbarheight: {
        type: o,
        parser: function parser(e) {
          return Math.abs(e.maxbarheight);
        }
      },
      plotborderalpha: {
        parser: function parser(e, t) {
          return t.plotborderalpha || e.plotfillalpha;
        }
      },
      autoscale: {
        type: o
      },
      plotborderdashlen: {
        type: o,
        pAttr: "plotborderdashlen"
      },
      plotborderdashgap: {
        type: o,
        pAttr: "plotborderdashgap"
      },
      plotfillratio: {
        pAttr: "plotfillratio"
      },
      drawverticaljoins: {
        type: o,
        pAttr: "drawverticaljoins"
      },
      useforwardsteps: {
        type: o,
        pAttr: "useforwardsteps"
      },
      minimizetendency: {
        type: o
      },
      usepercentdistribution: {
        type: o
      },
      stepatmiddle: {
        type: o
      }
    }, t.attribDefs = r, t.parseConfiguration = function (e, n, l, c, u, d) {
      var f,
          h,
          p,
          g = 1;

      for (f in t.attribDefs = r = r || s, c = c || s, d = d || s, u = u || {}, e) {
        if (!c[f] && ((h = e[f]) || !1 === h || 0 === h)) switch ((p = d[f] || r[f]) && p.type) {
          case o:
            h = Number(h), isNaN(h) || (n[f] = h);
            break;

          case i:
            h = Number(h), isNaN(h) || (n[f] = !!h);
            break;

          default:
            n[f] = h;
        }
      }

      if (l) for (f in n) {
        n[f] === a && (p = d[f] || r[f]) && p.pAttr && (n[f] = l[p.pAttr]);
      }

      for (; g;) {
        for (f in g = 0, n) {
          n[f] === a && (p = d[f] || r[f]) && (p.attr ? (h = n[p.attr]) !== a && (n[f] = h, g += 1) : p.parser && (h = p.parser(n, l, u)) !== a && (n[f] = h, g += 1));
        }
      }
    }, t.setAttribDefs = function (e, n) {
      var o, i;

      for (i in t.attribDefs = r = r || {}, "string" == typeof e ? (o = {})[e] = n : o = e, o) {
        r[i] || (r[i] = o[i]);
      }
    }, t.hasAttribDefs = function (e) {
      return !!r[e];
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(128),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    };
    var a,
        s,
        l,
        c = " ",
        u = window,
        d = u.document,
        f = "ontouchstart" in u,
        h = "click",
        p = "touchstart",
        g = "touchend",
        m = "touchmove",
        v = "mouseout",
        y = "mouseover",
        b = "keydown",
        x = ((l = {}).pointerdrag = {
      start: ["mousedown"],
      end: ["mouseup"],
      onStart: ["mousemove"],
      postHandlers: {},
      preHandlers: {}
    }, l.pointerhover = {
      start: [y],
      end: [v]
    }, l.click = {
      start: [h]
    }, l.escape = {
      start: [b],
      preHandlers: {
        start: function start(e) {
          return !(!(e = e || u.event).keyCode || 27 !== e.keyCode);
        }
      }
    }, f && ((s = l.pointerdrag).start.push(p), s.end.push(g), s.onStart.push(m), s.postHandlers.onStart = function (e) {
      e.preventDefault ? e.preventDefault() : e.returnValue = !1;
    }), l);
    a = (0, i["default"])({}, x), t["default"] = new function () {
      var e = {},
          t = {},
          n = d.addEventListener ? function (e, t, n) {
        e.addEventListener(t, n, !1);
      } : function (e, t, n) {
        e.attachEvent("on" + t, n);
      },
          r = d.removeEventListener ? function (e, t, n) {
        e.removeEventListener(t, n, !1);
      } : function (e, t, n) {
        e.detachEvent("on" + t, n);
      },
          o = function o(e, t, _o, i) {
        return n(e, t, _o[i = i || "closure"]), function () {
          r(e, t, _o[i]);
        };
      },
          s = function s(e, t, n) {
        var r,
            i,
            s,
            l,
            c = [];
        if (l = a[t], n.start = function (t) {
          var r = l.onStart,
              i = l.end,
              a = [],
              s = [],
              c = r && r.length || 0;

          for (t = t || u.event; c--;) {
            a.push(o(e, r[c], n, "onStart"));
          }

          for (c = i && i.length || 0; c--;) {
            s.push(o(e, i[c], n, "end"));
          }

          n.startUn = n.startUn ? n.startUn.concat(a) : a, n.endUn = n.endUn ? n.endUn.concat(s) : s, n.state = "start", n.closure(t);
        }, n.onStart = function (e) {
          e = e || u.event, n.state = "on", n.gDef && n.gDef.preHandlers && "function" == typeof n.gDef.preHandlers.onStart && n.gDef.preHandlers.onStart(e), n.closure(e), n.gDef && n.gDef.postHandlers && "function" == typeof n.gDef.postHandlers.onStart && n.gDef.postHandlers.onStart(e);
        }, n.end = function (e) {
          var t = n.startUn,
              r = n.endUn,
              o = t && t.length || 0;

          for (e = e || u.event; o--;) {
            t[o]();
          }

          for (delete n.startUn, n.startUn = [], o = r && r.length || 0; o--;) {
            r[o]();
          }

          delete n.endUn, n.endUn = [], n.state = "end", n.closure(e);
        }, l) for (s = (r = l.start).length; s--;) {
          (i = r[s]) && c.push(o(e, i, n, "start"));
        }
        return c;
      },
          l = function l(e, t, n) {
        var o, i, s, l;
        if (l = a[t]) for (s = (o = l.start).length; s--;) {
          (i = o[s]) && r(e, i, n.start);
        }
      },
          f = function f(e) {
        return function (t) {
          var n,
              r = e.context || e.elem;
          t = t.originalEvent || t, n = {
            data: e.data,
            type: e.type,
            state: e.state,
            isGesture: e.isGesture,
            target: t.target || t.srcElement,
            originalEvent: t
          }, t = t || u.event, e.handler.call(r, n);
        };
      };

      return {
        listen: function listen(n, r, i, l, u) {
          var h,
              p,
              g,
              m,
              v,
              y = this,
              b = "string" == typeof r ? r.split(c) : r,
              x = b.length,
              w = [],
              C = function C(e, t, n) {
            w.push(function () {
              y.unlisten(e, t, n);
            });
          };

          if (n.ownerDocument && n.ownerDocument === d) for (; x--;) {
            p = b[x], m = Boolean(a[p]), (g = {
              handler: v = "function" == typeof i ? i : i[x],
              elem: n,
              type: p,
              isGesture: m,
              gDef: m ? a[p] : null,
              data: l,
              context: u,
              start: [],
              end: [],
              links: {
                prev: null,
                next: null
              }
            }).closure = f(g), m ? ((h = t[p]) || (h = t[p] = []), h.push(g), s(n, p, g)) : ((h = e[p]) || (h = e[p] = []), h.push(g), o(n, p, g)), C(n, p, v);
          } else for (; x--;) {
            p = b[x], (g = {
              handler: v = "function" == typeof i ? i : i[x],
              elem: n,
              type: p,
              isGesture: m,
              data: l,
              context: u,
              start: [],
              end: [],
              links: {
                prev: null,
                next: null
              }
            }).closure = f(g), (h = e[p]) || (h = e[p] = []), h.push(g), o(n, p, g), C(n, p, v);
          }
          return {
            unlisten: function unlisten() {
              for (var e = w.length; e--;) {
                w[e]();
              }

              w.length = 0, w = null;
            }
          };
        },
        unlisten: function unlisten(n, o, i) {
          var s,
              c,
              u,
              d = !1;
          if (Boolean(a[o])) for (c = (s = t[o]) && s.length || 0; c--;) {
            (u = s[c]).handler === i && u.elem === n && (l(n, o, u), s.splice(c, 1), d = !0);
          } else for (c = (s = e[o]) && s.length || 0; c--;) {
            (u = s[c]).handler === i && u.elem === n && (r(n, o, u.closure), s.splice(c, 1), d = !0);
          }
          return d;
        },
        fire: function fire(t, n, r, o) {
          var a, s, l, c;
          if (t.ownerDocument && t.ownerDocument === d) d.createEvent ? ((c = d.createEvent("HTMLEvents")).initEvent(n, !0, !0), r && r.originalEvent && (r.originalEvent = c), "function" == typeof t[n] && t[n](), t.dispatchEvent(c), o && !c.returnValue && o(c)) : ((c = d.createEventObject()).eventType = n, r && (r.originalEvent ? r.originalEvent = c : (0, i["default"])(c, r)), "function" == typeof t[n] && t[n](), t.fireEvent("on" + n, c), o && !c.returnValue && o(c));else for (s = (a = e[n]) && a.length || 0; s--;) {
            (l = a[s]).elem === t && l.closure(r);
          }
        }
      };
    }();
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };

    t["default"] = function (e, t, n, o) {
      var i;
      if ((void 0 === e ? "undefined" : r(e)) !== s && (void 0 === t ? "undefined" : r(t)) !== s) return null;
      if ((void 0 === t ? "undefined" : r(t)) !== s || null === t) return e;
      if (void 0 === e && (e = t instanceof Array ? [] : {}), o) for (i in t) {
        e[i] = t[i];
      } else u(e, t, n);
      return e;
    };

    var o = "__blank",
        i = "␀",
        a = "",
        s = "object",
        l = function l(e, t) {
      for (var n = t.length, r = -1; n--;) {
        if (e === t[n]) return r = n;
      }

      return r;
    },
        c = function c(e) {
      var t, n, r;

      for (t = 0, n = e.length, r = new Array(n); t < n; t++) {
        r[t] = e[t];
      }

      return r;
    },
        u = function d(e, t, n, o, i) {
      var a, c, u, f, h;
      if (i ? (o.push(e), i.push(t)) : (o = [e], i = [t]), t instanceof Array) for (a = 0; a < t.length; a += 1) {
        try {
          c = e[a], u = t[a];
        } catch (p) {
          continue;
        }

        (void 0 === u ? "undefined" : r(u)) !== s ? n && void 0 === u || (e[a] = u) : (null !== c && (void 0 === c ? "undefined" : r(c)) === s || (c = e[a] = u instanceof Array ? [] : {}), -1 !== (h = l(u, i)) ? c = e[a] = o[h] : d(c, u, n, o, i));
      } else for (a in t) {
        try {
          c = e[a], u = t[a];
        } catch (p) {
          continue;
        }

        null !== u && (void 0 === u ? "undefined" : r(u)) === s ? "[object Object]" === (f = Object.prototype.toString.call(u)) ? (null !== c && (void 0 === c ? "undefined" : r(c)) === s || (c = e[a] = {}), -1 !== (h = l(u, i)) ? c = e[a] = o[h] : d(c, u, n, o, i)) : "[object Array]" === f ? (null !== c && c instanceof Array || (c = e[a] = []), -1 !== (h = l(u, i)) ? c = e[a] = o[h] : d(c, u, n, o, i)) : e[a] = u : e[a] = u;
      }
      return e;
    };

    t.merge = u, t.getArrayCopy = c, t.dashedAttr2CSSMap = {
      "font-family": "fontFamily",
      "font-size": "fontSize",
      "text-anchor": "textAnchor",
      "font-weight": "fontWeight",
      "letter-spacing": "letterSpacing",
      "font-style": "fontStyle"
    }, t.loadRefImage = function (e, t) {
      var n = t.src,
          r = e._.RefImg;
      r || (r = e._.RefImg = new Image()), t.src !== undefined && (r.src = n, e._.RefImg = r);
    }, t.showRecursively = function (e) {
      for (var t = {}, n = e, r = t; n;) {
        n.node && n.node.style && "none" === n.node.style.display && (n.show(), r._doHide = !0), n = n.parent, r.parent = {}, r = r.parent;
      }

      return function () {
        for (var n = e, r = t; n;) {
          r._doHide && n.hide(), n = n.parent, r = r.parent;
        }
      };
    }, t.cacher = function (e, t, n, r, s, l, u) {
      var d = l || {},
          f = 0;
      return d.__start === undefined && (d.__start = null), d.__end === undefined && (d.__end = null), s = s || 1e3, r = r || "item", function (l) {
        var h,
            p,
            g,
            m = u ? l : c(arguments).join(i);
        return (h = d[m = m === a ? o : m]) ? h.__prev && (d[h.__prev].__next = h.__next, h.__next ? h.__next.__prev = h.__prev : d.__end = h.__prev) : (h = d[m] = {}, e && (d[m][r] = n ? n(e.apply(t, arguments)) : e.apply(t, arguments)), null === d.__end && (d.__end = m), ++f > s && d.__end && (p = d[d.__end], d[p.__prev].__next = null, delete d[d.__end], d.__end = p.__prev, f--)), (g = d.__start) !== h && (h.__prev = null, h.__next = g, g && (g.__prev = m), d.__start = h), d[m][r];
      };
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o,
        i = {
      circle: "circle",
      triangle: "triangle",
      square: "square",
      diamond: "diamond",
      poly: "poly_",
      spoke: "spoke_"
    },
        a = "000000",
        s = "FFFFFF",
        l = Math.abs,
        c = /\s+/g,
        u = /^#?/,
        d = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i,
        f = ",",
        h = /^rgba/i,
        p = /[#\s]/gi,
        g = "",
        m = "#";

    function v(e, t) {
      return e = e || !1 === e || 0 === e ? Number(e) : NaN, isNaN(e) ? null : t ? l(e) : e;
    }

    function y(e, t) {
      return (e = (e = e.split(f)[t || 0]).replace(c, g)) == g && (e = a), e.replace(u, m);
    }

    function b(e) {
      return e = parseInt(e, 10), (isNaN(e) || e > 100 || e < 0) && (e = 100), e;
    }

    function x(e, t) {
      return e = Number(e), e = isNaN(e) ? 100 : e, t !== r && (e = e * t / 100), e % 101;
    }

    function w(e, t) {
      t = t < 0 || t > 100 ? 100 : t, t /= 100, e = e.replace(p, g);
      var n = parseInt(e, 16),
          r = Math.floor(n / 65536),
          o = Math.floor((n - 65536 * r) / 256);
      return (a + (r * t << 16 | o * t << 8 | (n - 65536 * r - 256 * o) * t).toString(16)).slice(-6);
    }

    function C(e, t) {
      t = t < 0 || t > 100 ? 100 : t, t /= 100, e = e.replace(p, g);
      var n = parseInt(e, 16),
          r = Math.floor(n / 65536),
          o = Math.floor((n - 65536 * r) / 256);
      return (a + (256 - (256 - r) * t << 16 | 256 - (256 - o) * t << 8 | 256 - (256 - (n - 65536 * r - 256 * o)) * t).toString(16)).slice(-6);
    }

    function _(e) {
      return e.replace(p, g).replace(u, m);
    }

    t.convertColor = function (e, t, n) {
      var r,
          o,
          i = 0,
          a = 0,
          l = 0;
      if (n && n.match(h) && (i = (o = n.split(f))[0].slice(o[0].indexOf("(") + 1), a = o[1], l = o[2], t || 0 === t || (t = parseInt(100 * o[3].slice(0, o[3].indexOf(")")), 10))), e) if (e.match(h)) i = (o = e.split(f))[0].slice(o[0].indexOf("(") + 1), a = o[1], l = o[2];else {
        switch ((r = e.replace(p, g).split(f)[0]).length) {
          case 3:
            r = r.charAt(0) + r.charAt(0) + r.charAt(1) + r.charAt(1) + r.charAt(2) + r.charAt(2);
            break;

          case 6:
            break;

          default:
            r = (r + s).slice(0, 6);
        }

        i = parseInt(r.slice(0, 2), 16) || 0, a = parseInt(r.slice(2, 4), 16) || 0, l = parseInt(r.slice(4, 6), 16) || 0;
      }
      return t || 0 === t || (t = 100), "string" == typeof t && (t = t.split(f)[0]), t = parseInt(t, 10) / 100, "rgba(" + i + f + a + f + l + f + t + ")";
    }, t.getDarkColor = w, t.getLightColor = C, t.mapSymbolName = function (e, t) {
      var n = i.circle;
      return (e = v(e)) >= 3 && (n = (t ? i.spoke : i.poly) + e), n;
    }, t.getColumnColor = function (e, t, n, o, i, a, s, l, c) {
      var u, d, h, p, m, v, y;
      return d = e.split(f), h = t.split(f), p = a.split(f), y = s.split(f), e = e.replace(/\s/g, g).replace(/\,$/, g), c ? u = {
        FCcolor: {
          color: d[0],
          alpha: h[0]
        }
      } : i ? (m = d[0], v = h[0], u = {
        FCcolor: {
          color: w(m, 75) + f + C(m, 10) + f + w(m, 90) + f + C(m, 55) + f + w(m, 80),
          alpha: v + f + v + f + v + f + v + f + v,
          ratio: "0,11,14,57,18",
          angle: l ? "90" : "0"
        }
      }, p = [w(m, 70)]) : u = {
        FCcolor: {
          color: e,
          alpha: t = function (e, t, n) {
            var o,
                i = e.split(f);

            for (n !== r && (n = Number(n.split(f)[0])), n = isNaN(n) ? r : n, i[0] = x(i[0], n), o = 1; o < t; o += 1) {
              i[o] = i[0] * x(i[o], n) / 100;
            }

            return i.join(f);
          }(t, d.length),
          ratio: n,
          angle: l ? -o : o
        }
      }, [u, {
        FCcolor: {
          color: p[0],
          alpha: y[0]
        }
      }];
    }, t.getPointColor = function (e, t) {
      var n, r;
      return e = y(e), t = b(t), n = C(e, 70), r = w(e, 50), {
        FCcolor: {
          gradientUnits: "objectBoundingBox",
          cx: .4,
          cy: .4,
          r: "100%",
          color: n + f + r,
          alpha: t + f + t,
          ratio: o,
          radialGradient: !0
        }
      };
    }, t.getAngle = function (e, t, n) {
      var r = 180 * Math.atan(t / e) / Math.PI;
      return 2 == n ? r = 180 - r : 3 == n ? r += 180 : 4 == n && (r = 360 - r), r;
    }, t.parseColor = _, t.getValidColor = function (e) {
      return d.test(_(e)) && e;
    }, t.RGBtoHex = function (e) {
      return (a + (e[0] << 16 | e[1] << 8 | e[2]).toString(16)).slice(-6);
    }, t.rawRGBtoHEX = function (e) {
      var t;
      return t = e.match(/[\d+]+/g).splice(0, 3), (a + (t[0] << 16 | t[1] << 8 | t[2]).toString(16)).slice(-6);
    }, t.HEXtoRGB = function (e) {
      var t = parseInt(e, 16),
          n = Math.floor(t / 65536),
          r = Math.floor((t - 65536 * n) / 256);
      return [n, r, Math.floor(t - 65536 * n - 256 * r)];
    }, t.parsePointValue = v, t.getFirstColor = y, t.getFirstAlpha = b;
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n, r, o, i, a) {
      var s = {};

      switch (t) {
        case "top":
          s.y = e;
          break;

        case "bottom":
          s.y = a - o - e;
          break;

        case "middle":
          s.y = (a - o) / 2;
      }

      switch (n) {
        case "left":
          s.x = e;
          break;

        case "right":
          s.x = i - r - e;
          break;

        case "middle":
          s.x = (i - r) / 2;
      }

      return s;
    }

    t.__esModule = !0, t.getAlignImage = function (e, t, n, o, i, a, s, l, c, u) {
      var d,
          f,
          h,
          p,
          g = {};

      switch (n) {
        case "center":
          g.width = o, g.height = i, g.y = s / 2 - i / 2, g.x = a / 2 - o / 2;
          break;

        case "stretch":
          g.width = a - 2 * l, g.height = s - 2 * l, g.y = l, g.x = l;
          break;

        case "tile":
          g.width = o, g.height = i, g.tileInfo = {}, g.tileInfo.xCount = f = Math.ceil(c / o), g.tileInfo.yCount = h = Math.ceil(u / i), p = r(l, e, t, o * f, i * h, a, s), g.y = p.y, g.x = p.x;
          break;

        case "fit":
          d = o / i > c / u ? c / o : u / i, g.width = o * d, g.height = i * d, p = r(l, e, t, g.width, g.height, a, s), g.y = p.y, g.x = p.x;
          break;

        case "fill":
          d = o / i > c / u ? u / i : c / o, g.width = o * d, g.height = i * d, p = r(l, e, t, g.width, g.height, a, s), g.y = p.y, g.x = p.x;
          break;

        default:
          p = r(l, e, t, o, i, a, s), g.width = o, g.height = i, g.y = p.y, g.x = p.x;
      }

      return g;
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = {},
        o = {},
        i = function i(e, t, n, r) {
      try {
        e[0].call(t, n, r || {});
      } catch (o) {
        setTimeout(function () {
          throw o;
        }, 0);
      }
    },
        a = function a(e, t, n) {
      var r,
          a = 0;
      if (e instanceof Array && !t.cancelled) for (; a < e.length; a += 1) {
        if (!0 !== e[a].removed) {
          if (e[a][1] !== t.sender && void 0 !== e[a][1] || (r = e[a][1] === t.sender ? t.sender : o, i(e[a], r, t, n), !0 === t.detached && (e.splice(a, 1), a -= 1, t.detached = !1)), !0 === t.cancelled) break;
        } else e.splice(a, 1), a -= 1;
      }
    },
        s = function s() {
      this.originalEvent && this.originalEvent.stopPropagation && this.originalEvent.stopPropagation.call && this.originalEvent.stopPropagation();
    },
        l = function l() {
      this.cancelled = !0, this.originalEvent && this.originalEvent.stopImmediatePropagation && this.originalEvent.stopImmediatePropagation.call ? this.originalEvent.stopImmediatePropagation() : this.originalEvent && this.originalEvent.stopPropagation && this.originalEvent.stopPropagation.call && this.originalEvent.stopPropagation();
    },
        c = function c() {
      return !1 == (this.detached = !0);
    },
        u = function u() {
      this.defaultPrevented = !0, this.originalEvent && this.originalEvent.preventDefault && this.originalEvent.preventDefault.call && this.originalEvent.preventDefault();
    },
        d = {},
        f = 0,
        h = function h(e, t, n, r, o, i) {
      var h, g, m, v, y;
      if (!t || !t.disposed) return e = e.toLowerCase(), g = p(e, t), m = p("*", t), v = d[e], y = d["*"], (g && g.length || m && m.length || v && v.length || y && y.length) && (h = {
        type: e,
        eventType: e,
        eventId: f += 1,
        sender: t || new Error("Orphan Event"),
        stopPropagation: s,
        stopImmediatePropagation: l,
        cancelled: !1,
        preventDefault: u,
        defaultPrevented: !1,
        originalEvent: r,
        detached: !1,
        data: n,
        detachHandler: c
      }, a(y, h, n), a(v, h, n), t && (a(p("*", t), h, n), a(p(e, t), h, n))), h && h.defaultPrevented ? i && "function" == typeof i && i.call(t, h, n || {}) : o && "function" == typeof o && o.call(t, h, n || {}), !0;
    },
        p = function p(e, t) {
      if ("string" == typeof e) return e = e.toLowerCase(), t ? t._evtListeners && t._evtListeners[e] : d[e];
      v(t, "03091559", "param", "::removeListener", new Error("Unspecified Event Type"));
    },
        g = {
      type: "TypeException",
      range: "ValueRangeException",
      impl: "NotImplementedException",
      param: "ParameterException",
      run: "RuntimeException",
      comp: "DesignTimeError",
      undefined: "UnspecifiedException"
    },
        m = function m(e, t, n, r, o, i) {
      var a = "#" + t + " " + (e ? e.id : "unknown-source") + r + " " + i + " >> ";
      o instanceof Error ? (o.name = g[n], o.module = "FusionCharts" + r, o.level = i, o.message = a + o.message, a = o.message, setTimeout(function () {
        throw o;
      }, 0)) : a += o, h(i, e, {
        id: t,
        nature: g[n],
        source: "FusionCharts" + r,
        message: a
      });
    },
        v = function v(e, t, n, r, o) {
      m(e, t, n, r, o, "Error");
    };

    t.addListener = function y(e, t, n, r) {
      var o, i, a;

      if (e instanceof Array) {
        for (o = [], i = 0; i < e.length; i += 1) {
          o.push(y(e[i], t, n));
        }

        return o;
      }

      if ("string" == typeof e) {
        if ("function" == typeof t) return e = e.toLowerCase(), n ? (n._evtListeners || (n._evtListeners = {}), n._evtListeners[e] instanceof Array || (n._evtListeners[e] = []), a = n._evtListeners[e]) : (d[e] instanceof Array || (d[e] = []), a = d[e]), !function (e, t, n) {
          var r = void 0,
              o = e.length;

          for (r = 0; r < o; r += 1) {
            if (e[r][0] === t && e[r][1] === n && !e[r].removed) return !0;
          }
        }(a, t, n) && (r && r.priority ? a.unshift([t, n]) : a.push([t, n]), t);
        v(n, "03091550", "param", "::addListener", new Error("Invalid Event Listener"));
      } else v(n, "03091549", "param", "::addListener", new Error("Unspecified Event Type"));
    }, t.removeListener = function b(e, t, n) {
      var r, o;

      if ("function" == typeof t) {
        if (e instanceof Array) for (o = 0; o < e.length; o += 1) {
          b(e[o], t, n);
        } else if ((r = p(e, n)) instanceof Array && r.length) for (o = r.length - 1; o >= 0; o -= 1) {
          r[o][0] === t && r[o][1] === n && (r[o].removed = !0);
        }
      } else v(n, "03091560", "param", "::removeListener", new Error("Invalid Event Listener"));
    }, t.triggerEvent = h, t.getListeners = p, t.disposeEvents = function (e) {
      var t,
          n = e ? e._evtListeners : d;

      for (t in n) {
        n[t].length && (n[t].length = 0);
      }
    }, t.raiseWarning = function (e, t, n, r, o) {
      m(e, t, n, r, o, "Warning");
    }, t.raiseError = v, t.raiseEventGroup = function (e, t, n, o, i, a, s) {
      var l = o.id,
          c = e + l;
      r[c] ? (clearTimeout(r[c]), delete r[c]) : l && c ? r[c] = setTimeout(function () {
        h(t, o, n, i, a, s), delete r[c];
      }, 0) : h(t, o, n, i, a, s);
    }, t.setRootSender = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      o = e;
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.getDepsByType = t.getDep = t.addDep = undefined;
    var r = n(131),
        o = {},
        i = {};
    t.addDep = function () {
      for (var e = this, t = arguments.length, n = Array(t), a = 0; a < t; a++) {
        n[a] = arguments[a];
      }

      n.length ? n.forEach(function (t) {
        var n,
            a,
            s,
            l,
            c = void 0,
            u = void 0;
        t ? (c = t.extension ? t.extension : t, n = function () {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              t = e.getName && e.getName() || e.name;
          return void 0 === t && (0, r.raiseError)({
            id: "Extension"
          }, "90211", "extension", "Name", new Error("A FusionCharts extension must have a getName API or a name property.")), t && t.toLowerCase();
        }(t), a = function () {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              t = e.getType && e.getType() || e.type;
          return t && t.toLowerCase();
        }(t), s = t.requiresFusionCharts, a ? (!o[a] && "string" == typeof (l = a) && (o[l] = {}), (u = o[a][n] !== c) && (o[a][n] = c)) : n && (u = i[n] !== c) && (i[n] = c), u && (0, r.triggerEvent)("dependencyadded", e, {
          name: n,
          type: a
        }), u && s && c(e)) : (0, r.raiseError)({
          id: "Extension"
        }, "90211", "dependency", "Extension", new Error("A FusionCharts extension must have a valid extension property."));
      }) : (0, r.raiseError)({
        id: "Extension"
      }, "90211", "dependency", "Extension", new Error("A FusionCharts extension must have a valid extension property."));
    }, t.getDep = function (e, t) {
      var n = void 0;
      if (e = e && e.toLowerCase(), t && o[t]) return o[t][e];
      if (!t) for (var r in o) {
        if (o.hasOwnProperty(r) && (n = o[r][e])) return n;
      }
      return i[e];
    }, t.getDepsByType = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return "" === e ? o : o[e.toLowerCase()];
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.onDataUpdateCancel = t.onDataUpdateSuccess = undefined;
    var r = n(131);
    t.onDataUpdateSuccess = function (e, t) {
      var n = e.sender,
          o = n.__state;
      o.dataReady = void 0, o.dataAvailable = !0, !0 !== t.silent ? !0 !== n.options.safeMode || !0 !== o.rendering || n.isActive() ? delete o.args : (o.updatePending = t, (0, r.raiseWarning)(n, "23091255", "run", "::DataHandler~update", "Renderer update was postponed due to async loading.")) : n.options.dataSource = t.data, (0, r.triggerEvent)("dataUpdated", n, t, void 0, t.successcallback);
    }, t.onDataUpdateCancel = function (e, t) {
      (0, r.triggerEvent)("dataUpdateCancelled", e.sender, t, void 0, t.failurecallback);
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      delete e.sender.jsVars._reflowData, e.sender.jsVars._reflowData = {}, delete e.sender.jsVars._reflowClean;
    }

    t.__esModule = !0, t["default"] = {
      beforeInitialize: function beforeInitialize(e) {
        var t,
            n = e.sender,
            r = n.jsVars;
        r.fcObj = n, r.msgStore = r.msgStore || {
          LoadDataErrorText: "Error in loading data.",
          XMLLoadingText: "Retrieving data. Please wait",
          InvalidXMLText: "Invalid data.",
          ChartNoDataText: "No data to display.",
          ReadingDataText: "Reading data. Please wait",
          ChartNotSupported: "Chart type not supported.",
          PBarLoadingText: "",
          LoadingText: "Loading chart. Please wait",
          RenderChartErrorText: "Unable to render chart."
        }, r.cfgStore = r.cfgStore || {}, r.previousDrawCount = -1, r.drawCount = 0, r._reflowData = {}, n.addEventListener("beforeRender", function (e) {
          return e.detachHandler();
        }), r.userModules instanceof Array || (t = r.userModules, r.userModules = [], "string" == typeof t && (r.userModules = r.userModules.concat(t.split(","))));
      },
      beforeDataUpdate: r,
      beforeDispose: function beforeDispose(e) {
        var t = e.sender.jsVars;
        t.smartLabel && !t.smartLabel.disposed && t.smartLabel.dispose(), r.apply(undefined, arguments);
      },
      beforeRender: function beforeRender(e) {
        delete e.sender.jsVars.drLoadAttempted, r.apply(undefined, arguments);
      },
      dataLoadRequested: function dataLoadRequested(e) {
        var t = e.sender,
            n = t.jsVars;
        delete n.loadError, t.ref && t.options.showDataLoadingMessage ? n.hcObj && !n.hasNativeMessage && n.hcObj.showLoading ? n.hcObj.showMessage(n.msgStore.XMLLoadingText) : t.ref.showChartMessage ? t.ref.showChartMessage("XMLLoadingText") : n.stallLoad = !0 : n.stallLoad = !0;
      },
      dataLoadRequestCompleted: function dataLoadRequestCompleted(e) {
        delete e.sender.jsVars.stallLoad;
      }
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.globalStore = undefined;
    var r,
        o = n(125),
        i = n(131),
        a = n(132),
        s = n(136),
        l = n(137);
    var c,
        u,
        d,
        f,
        h = /\%/,
        p = new ((r = l) && r.__esModule ? r : {
      "default": r
    })["default"](),
        g = (d = {}, f = function y() {
      var e,
          t,
          n,
          r,
          o,
          i,
          a,
          s,
          l = 0,
          f = parseInt(u.options.resizeTrackingInterval, 10) || 300,
          p = {},
          g = function g() {
        p.itemVar._containerOffsetW = p.parentEle.offsetWidth, p.itemVar._containerOffsetH = p.parentEle.offsetHeight;
      };

      for (e in d) {
        l += 1, n = (t = d[e]).jsVars, o = t.ref, !t.disposed && (r = o && o.parentNode) && (i = o.style) && (h.test(i.width) || h.test(i.height)) ? (a = r.offsetWidth, s = r.offsetHeight, !n.resizeLocked && (a && n._containerOffsetW !== a || s && n._containerOffsetH !== s) && (t.resizeTo && t.resizeTo(), p.itemVar = n, p.parentEle = r, setTimeout(g, 1))) : (delete d[e], l -= 1);
      }

      c = l ? setTimeout(y, f) : clearTimeout(c);
    }, function (e, t, n) {
      var r = e.jsVars,
          o = t || e.ref && e.ref.parentNode || {};
      u = n, r._containerOffsetW = o.parentNode.offsetWidth, r._containerOffsetH = o.parentNode.offsetHeight, d[e.id] = e, c || (c = setTimeout(f, parseInt(n.options.resizeTrackingInterval, 10) || 300));
    });

    function m(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined && arguments[2],
          r = this.apiInstance,
          o = (this.jsVars && this.jsVars.themeObject && this.jsVars.themeObject.getThemedJSONData() || this.getChartData((0, a.getDepsByType)("transcoder").JSON, !0, !0)).data;
      n || (0, i.triggerEvent)("dataloaded", this, {}, [this.id]), this.__state && (this.__state.newDataArrived = !1), r.addToEnv("dataSource", o), r.addToEnv("chart-attrib", o.chart), r._checkInvalidData() || r._checkInvalidSpecificData() ? (r.getContainer("parentgroup") && r.getContainer("parentgroup").hide(), r.createBaseComponent(), r.getFromEnv("animationManager").setAnimationState("chartmessage"), r.setChartMessage(), r.drawChartMessage(), this._sudoSetState(1), (0, i.triggerEvent)("nodatatodisplay", this, {}, [this.id])) : (r.config.hasChartMessage = !1, r.setData(o));
    }

    function v(e) {
      (0, i.triggerEvent)("dataloadcancelled", e, {}, [e.id]), e.__state && (e.__state.newDataArrived = !1);
    }

    t.globalStore = p, t["default"] = function (e, t, n, r, l, c, u, d) {
      var f = void 0,
          y = t.apiInstance,
          b = void 0,
          x = t.jsVars,
          w = void 0,
          C = void 0,
          _ = void 0,
          S = h.test(t.width) ? n.offsetWidth : t.width,
          E = h.test(t.height) ? n.offsetHeight : t.height;

      if (n.FusionCharts = e.items[t.id], t.__state.beforedrawFired = !0, r = r || t.chartType(), !(f = (0, a.getDep)(r, "chartapi")) && (w = (0, a.getDep)(r, "maps")) && (f = (0, a.getDep)("maps", "chartapi"), C = !0), y && y.getName().toLowerCase() !== r.toLowerCase() && (y.remove({
        instant: !0
      }), y = o.UNDEF), y && y.getName().toLowerCase() === r.toLowerCase() || (y = t.apiInstance = new f(), p.attachChild(y, "chartAPI")), C) for (var k in w = w[0]) {
        w.hasOwnProperty(k) && (y.config[k] = w[k]);
      }
      if (y.addToEnv("core-options", e.options), y.addToEnv("chartInstance", t), y.addToEnv("chart", y), y.addToEnv("chart-container", n), y.addToEnv("eventListeners", []), y.addToEnv("chartWidth", S), y.addToEnv("chartHeight", E), y._removeWaitingJobs(), y.setDummyEImethods(r), y.config.origRenderWidth = t.__state.renderedWidth, y.config.origRenderHeight = t.__state.renderedHeight, "base" === r || c) !function (e) {
        var t = arguments.length > 1 && arguments[1] !== undefined && arguments[1],
            n = e.options.dataErroneous;
        if (n) e.__state.dataReady = !1, t || (0, i.triggerEvent)("dataInvalid", e, {
          error: n
        }, o.UNDEF, function () {
          (0, i.triggerEvent)("dataxmlinvalid", e, {}, [e.id]);
        });
      }(t, d), function (e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        e._chartMessageImageStyle = t.image || {}, e._chartMessageStyle = t.message || {};
      }(t, u), y.createBaseComponent(), y.getFromEnv("animationManager").setAnimationState("chartmessage"), y.setChartMessage(c, t, n), y.drawChartMessage();else if (t.__state.resize) y.asyncDraw();else {
        if (y.getFromEnv("toolTipController") || (_ = new ((0, a.getDep)("ToolTipController"))(n), y.addToEnv("toolTipController", _)), y.disposeChartStyleSheet(), n.jsVars = t.jsVars, b = y.eiMethods, t.ref = n, x.type = r, b && "string" != typeof b) for (var A in b) {
          n[A] = b[A];
        }
        !d && t.__state.newDataArrived ? (0, i.triggerEvent)("beforedataload", t, {
          data: t.getChartData((0, a.getDepsByType)("transcoder").JSON, !0, !0)
        }, void 0, m, v) : m.call(t, void 0, void 0, d);
      }
      !t.disposed && function (e, t, n, r, a) {
        var l = e.jsVars,
            c = e.apiInstance,
            u = l.fcObj,
            d = u.width,
            f = u.height,
            h = l.overlayButton;
        l.width = c.getFromEnv("chartWidth"), l.height = c.getFromEnv("chartHeight"), l.container = t, l.hcObj = e, l.hcObj.container = t, l.instanceAPI = c, e.hasRendered && l.overlayButtonActive && h && (h.innerHTML = o.BLANK, h.appendChild(document.createTextNode(l.overlayButtonMessage)), e.container.appendChild(h)), (/\%/g.test(d) || /\%/g.test(f)) && t && t.parentNode && !a.options.preventTrackResize && g(e, t, a), function (e, t, n) {
          e.apiInstance.addJob("fire-rendered", function () {
            if (e.apiInstance.config.hasRendered = n.hasRendered, "waiting" !== e._getState() && "function" == typeof t && t(n), "waiting" !== e._getState() && ((0, i.triggerEvent)("drawcomplete", e, {
              width: e.jsVars.width,
              height: e.jsVars.height,
              drawCount: e.jsVars.drawCount,
              displayingMessage: "waiting" === e._getState() || "error" === e._getState(),
              renderer: "javascript"
            }, [e.id]), e.__state && delete e.__state.beforedrawFired), !e.disposed && "ready" === e._getState()) {
              if (e.__state.rendering && (0, i.triggerEvent)("rendered", e, {
                renderer: "javascript"
              }, [e.id]), e.disposed) return;
              if ((0, i.triggerEvent)("renderComplete", e, {
                width: e.jsVars.width,
                height: e.jsVars.height,
                drawCount: e.jsVars.drawCount,
                renderer: "javascript"
              }), e.disposed) return;
              e.__state && delete e.__state.rendering, e.__state.renderComplete = !0;
            }
          }, s.priorityList.postRender);
        }(e, n, r);
      }(t, n, l, {
        hasRendered: !0,
        container: n
      }, e);
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        o = [],
        i = {},
        a = [],
        s = {},
        l = 0,
        c = window,
        u = c.navigator,
        d = /trident/i.test(u.userAgent) && /rv:11/i.test(u.userAgent) && !c.opera,
        f = /msie/i.test(u.userAgent) && !c.opera,
        h = /Edge/.test(u.userAgent),
        p = {},
        g = c.requestAnimationFrame || c.webkitRequestAnimationFrame || c.mozRequestAnimationFrame || c.oRequestAnimationFrame || c.msRequestAnimationFrame || function (e) {
      setTimeout(e, 16);
    },
        m = !1,
        v = function y() {
      var e = !0,
          t = void 0,
          n = new Date().getTime(),
          r = void 0,
          i = void 0;

      for (m = !0; e && (t = o[0]);) {
        r = new Date().getTime(), t.OIAF && i || t.executeAfter && !(t.executeAfter < r) || !(r - n < 16) ? e = !1 : (o.shift(), a[t.priority] -= 1, s[t.jobID] && !t.executed && (t.executed = !0, delete s[t.jobID], t.job(), i = t.OIAF));
      }

      o.length ? g(y) : m = !1;
    };

    (d || f || h) && (g = g.bind(window)), p.addJob = function (e, t, n) {
      var i,
          c,
          u,
          d = 0,
          f = n && n.oneInAFrame,
          h = n && n.addToTop ? t - 1 : t;

      for ("function" === (void 0 === e ? "undefined" : r(e)) ? (c = {
        job: e,
        priority: t,
        OIAF: f,
        jobID: i = "JOB_" + ++l + "_" + (t || 1)
      }, n && n.executionDelay && (c.executeAfter = new Date().getTime() + n.executionDelay)) : c = e, u = 0; u <= h; u++) {
        d += a[u] || 0;
      }

      return o.splice(d, 0, c), s[c.jobID] = c, a[t] = (a[t] || 0) + 1, m || 1 !== o.length || (f ? g(v) : setTimeout(v, 0)), i;
    }, p.removeJob = function (e) {
      s[e] && delete s[e];
    }, p.updateJob = function (e, t, n, r) {
      return s[e] ? (s[e].job = t, e) : this.addJob(t, n, r);
    }, p.pauseExecution = function (e) {
      if (!s[e]) return !1;
      i[e] = s[e], delete s[e];
    }, p.resumeExecution = function (e) {
      var t = i[e];
      if (!t) return !1;
      p.addJob(t, t.priority), delete i[e];
    }, t["default"] = p, t.priorityList = {
      instant: 1,
      render: 1,
      chartEvents: 1,
      configure: 2,
      chartClick: 2,
      draw: 3,
      entitydraw: 4,
      label: 4,
      animation: 5,
      tracker: 6,
      kdTree: 6,
      postRender: 7
    };
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    t.__esModule = !0;

    var o = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return r(t, e), t.prototype.getName = function () {
        return "globalStore";
      }, t.prototype.getType = function () {
        return "globalStore";
      }, t;
    }(n(138).ComponentInterface);

    t["default"] = o;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.SmartRenderer = t.ComponentInterface = undefined;
    var r = i(n(139)),
        o = i(n(141));

    function i(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    t.ComponentInterface = r["default"], t.SmartRenderer = o["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(140);

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var a = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this)),
            r = n;

        return r._components = {}, r.fireEvent("instantiated"), r.__setDefaultConfig(), n;
      }

      return i(t, e), t.prototype.addGraphicalElement = function (e, t, n, r) {
        var i = this._graphics;
        return n = n || !1, t && (n ? (void 0 === i[e] && (i[e] = []), r ? i[e][r] = t : i[e].push(t)) : (i[e] = t, this.fireEvent("graphicalelementattached", {
          element: t
        })), (0, o.addAllEventsOnGraphic)(t, this._middleListeners, this)), t;
      }, t.prototype.removeGraphicalElement = function (e) {
        var t = this,
            n = t._graphics,
            r = void 0;
        (0, o._mapSubFnForward)(n, function (i, a, s) {
          i === e && (r = !0, (0, o.removeAllEventsFromGraphic)(i, t._middleListeners), t._setRemoveAnim(i, a), void 0 !== s ? n[a].splice(s, 1) : delete n[a]);
        }), r && this.fireEvent("graphicalelementremoved", {
          element: e
        });
      }, t.prototype.getGraphicalElement = function (e) {
        return void 0 !== e ? this._graphics[e] : this._graphics;
      }, t.prototype.addChildContainer = function (e, t) {
        var n = this._childContainers;
        return t && (void 0 === n && (n = this._childContainers = {}), n[e] = t, (0, o.addAllEventsOnGraphic)(t, this._middleListeners, this)), t;
      }, t.prototype.removeChildContainer = function (e) {
        var t = this._childContainers;
        t && t[e] && ((0, o.removeAllEventsFromGraphic)(t[e], this._middleListeners), this._setRemoveAnim(t[e], e), delete t[e]);
      }, t.prototype.getChildContainer = function (e) {
        return void 0 === this._childContainers && (this._childContainers = {}), e ? this._childContainers[e] : this._childContainers;
      }, t.prototype.addContainer = function (e, t) {
        var n = this._containers;
        return t && (void 0 === n && (n = this._containers = {}), n[e] = t), t;
      }, t.prototype.removeContainer = function (e) {
        var t = this._containers;
        t && t[e] && (this._setRemoveAnim(t[e], e), delete t[e]);
      }, t.prototype.getContainer = function (e) {
        return void 0 === this._containers && (this._containers = {}), e ? this._containers[e] : this._containers;
      }, t.prototype.addEventListener = function (t, n, r) {
        var i = e.prototype.addEventListener.call(this, t, n, r);
        return !0 === i ? (function (e, t, n) {
          var r;
          t && n && (r = function r(e) {
            e.on && e.on(t, n);
          }, (0, o._mapSubFnForward)(e.getGraphicalElement(), r), (0, o._mapSubFnForward)(e.getChildContainer(), r));
        }(this, t, this._middleListeners[t]), n) : !!i && n;
      }, t.prototype.removeEventListener = function (t, n) {
        e.prototype.removeEventListener.call(this, t, n) && function (e, t, n) {
          var r;
          t && n && (r = function r(e) {
            e.off && e.off(t, n);
          }, (0, o._mapSubFnForward)(e.getGraphicalElement(), r), (0, o._mapSubFnForward)(e.getChildContainer(), r));
        }(this, t, this._middleListeners[t]);
      }, t.prototype._dispose = function () {
        var t = void 0;

        if (e.prototype._dispose.call(this)) {
          for (t in this.getFromEnv("paper") && !this.getFromEnv("paper").removed && ((0, o._mapSubFnForward)(this.getChildContainer(), this.__instantRemoveFn), (0, o._mapSubFnForward)(this.getGraphicalElement(), this.__instantRemoveFn), (0, o._mapSubFnForward)(this.getContainer(), this.__instantRemoveFn)), this) {
            this.hasOwnProperty(t) && delete this[t];
          }

          this.fireEvent("removed");
        }
      }, t.prototype.removingDraw = function () {
        (0, o._mapSubFnForward)(this.getChildContainer(), this._setRemoveAnim), (0, o._mapSubFnForward)(this.getGraphicalElement(), this._setRemoveAnim), (0, o._mapSubFnForward)(this.getContainer(), this._setRemoveAnim);
      }, t.prototype.attachChild = function (e, t, n) {
        var r = t || e.getType(),
            o = this._components;
        return !1 === n ? o[r] = e : (o[r] && o[r] instanceof Array || (o[r] = []), o[r].push(e)), e._setLinkedParent(this), this.fireEvent("childattached", {
          attachedChild: e
        }), e;
      }, t.prototype.getChild = function (e) {
        var t,
            n = this._components;
        return void 0 === e ? n : (this._searchChildren(e, function (e) {
          t = e;
        }), t);
      }, t.prototype._searchChildren = function (e, t) {
        var n,
            r,
            o,
            i = this._components;

        for (r in i) {
          if (i.hasOwnProperty(r)) if ((n = i[r]).constructor === Array) {
            for (o = n.length - 1; o >= 0; o--) {
              if (n[o].getId && n[o].getId() === e) return t(n[o], o, n);
            }
          } else if (n.getId && n.getId() === e) return t(r, void 0, i);
        }
      }, t.prototype.getChildren = function (e) {
        return e ? this._components[e] : this._components;
      }, t;
    }(((r = o) && r.__esModule ? r : {
      "default": r
    })["default"]);

    t["default"] = a;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t._mapSubFnForward = t.addAllEventsOnGraphic = t.removeAllEventsFromGraphic = undefined;
    var r,
        o = n(125),
        i = n(131),
        a = n(136),
        s = (r = a) && r.__esModule ? r : {
      "default": r
    };

    var l = {},
        c = {
      executionDelay: 16
    },
        u = function u(e, t) {
      if (e && e.hasOwnProperty && t && t.call) {
        var n = void 0,
            r = void 0,
            o = void 0,
            i = void 0;

        for (n in e) {
          if (e.hasOwnProperty(n)) if ((r = e[n]) instanceof Array) for (i = r.length, o = 0; o < i; o++) {
            t(r[o], n, o);
          } else t(r, n);
        }
      }
    },
        d = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
        var t = this;
        t.config = {}, t._jobList = {}, t._env = {}, t._extListeners = {}, t._state = {}, t._factories = [], t._factoriyNames = {}, t._graphics = {}, t.__drawJob = function () {
          t.updateVisual();
        }, t.__remove = function () {
          t.getState("removed") && t._dispose();
        }, t._setRemoveAnim = function (e, n) {
          var r = t.getFromEnv("animationManager");
          r.setAnimation({
            el: e,
            component: t,
            label: n,
            props: e.__props
          }), t._setRemoveAnim = function (e, n) {
            r.setAnimation({
              el: e,
              component: t,
              label: n,
              props: e.__props
            });
          };
        }, t.__instantRemoveFn = function (e) {
          var n = t.getFromEnv("animationManager");
          n.removeElement(e, !0), t.__instantRemoveFn = function (e) {
            return n.removeElement(e, !0);
          };
        };
      }

      return e.prototype.configure = function (e) {
        this.preConfigure(e), this.configureAttributes(e), this.postConfigure(e), this.invokeFactories();
      }, e.prototype.preConfigure = function (e) {
        this.fireEvent("preconfigure", e);
      }, e.prototype.configureAttributes = function () {
        return this;
      }, e.prototype.postConfigure = function (e) {
        this.fireEvent("postconfigure", e);
      }, e.prototype.prepareAttributes = function () {
        this.fireEvent("beforeattributeprepared"), this.allocatePosition && this.allocatePosition(), this._mapChildren(function (e) {
          e.prepareAttributes && e.prepareAttributes();
        }), this.fireEvent("attributeprepared");
      }, e.prototype.setDefaults = function () {
        this.__setDefaultConfig(), this._mapChildren(function (e) {
          return e.setDefaults();
        });
      }, e.prototype.__setDefaultConfig = function () {
        return this;
      }, e.prototype.setData = function (e) {
        var t,
            n = arguments.length > 1 && arguments[1] !== undefined && arguments[1],
            r = this.getLinkedParent();
        this.asyncDraw(), !n && this.setDefaults(), this.configure && this.configure(e), (t = this.getState("change-info")) && t.hasNoExternalEffect || r && r.childChange && r.childChange(t, this.getId());
      }, e.prototype.getName = function () {
        return "generic";
      }, e.prototype.getType = function () {
        return "generic";
      }, e.prototype.getId = function () {
        return this._id || this.setId(), this._id;
      }, e.prototype.setId = function (e) {
        var t;
        e === o.UNDEF && (t = this.getType() + o.UNDERSCORE + this.getName(), l[t] || (l[t] = 1), e = t + o.UNDERSCORE + l[t], l[t] += 1), this._id = e;
      }, e.prototype.iterateComponents = function (e) {
        this._mapChildren(function t(n, r, o) {
          !1 !== e(n, r, o) && n._mapChildren && n._mapChildren(t);
        });
      }, e.prototype.getFromEnv = function (e) {
        return e ? this._env[e] : this._env;
      }, e.prototype.addToEnv = function (e, t) {
        e && (this._env[e] = t);
      }, e.prototype.deleteFromEnv = function (e) {
        delete this._env[e];
      }, e.prototype._updateParentEnv = function () {
        var e,
            t,
            n,
            r,
            o = this.getLinkedParent(),
            i = this._env;

        if (o) {
          if (e = o.getFromEnv(), (t = function t() {}).prototype = e, t.prototype.constructor = t, n = new t(), i) for (r in i) {
            i.hasOwnProperty(r) && (n[r] = i[r]);
          }
          this._env = n, this._mapChildren(function (e) {
            e._updateParentEnv && e._updateParentEnv();
          });
        }
      }, e.prototype.addJob = function (e, t, n, r) {
        this._jobList[e] ? this._jobList[e] = s["default"].updateJob(this._jobList[e], t, n, r) : this._jobList[e] = s["default"].addJob(t, n, r);
      }, e.prototype.removeJob = function (e) {
        var t = this._jobList[e];
        t && (s["default"].removeJob(t), delete this._jobList[e]);
      }, e.prototype.removeAllJobs = function () {
        var e = void 0,
            t = this._jobList;

        for (e in t) {
          t.hasOwnProperty(e) && (s["default"].removeJob(t[e]), delete t[name]);
        }
      }, e.prototype.asyncDraw = function () {
        this.addJob("draw", this.__drawJob, a.priorityList && a.priorityList.draw, c);
      }, e.prototype.syncDraw = function () {
        var e = this;
        e.fireEvent("predraw"), e.removeJob("draw"), e.getState("removed") ? e.removingDraw() : e.draw && e.draw(), e.addExtEventListener("animationComplete", e.__remove, e.getFromEnv("animationManager")), e.childrenSyncDraw(), e.setState("dirty", !1), e.setState("parentChanged", !1), e.addJob("draw-complete", function () {
          e.fireEvent("drawn");
        }, a.priorityList.instant);
      }, e.prototype.updateVisual = function () {
        this.fireEvent("beforevisualupdate"), this.removeJob("visualupdate"), this.manageSpace && this.manageSpace(), this.prepareAttributes(), this.syncDraw(), this.fireEvent("visualupdated");
      }, e.prototype.childrenSyncDraw = function () {
        this._mapChildren(function (e) {
          e && e.draw && e.syncDraw();
        });
      }, e.prototype.addEventListener = function (e, t, n) {
        var r,
            a = this;
        return !!(e && e.toLowerCase && (e = e.toLowerCase(), (0, i.addListener)(e, t, a, n))) && ((0, o.isInterActiveEvt)(e) && (r = (0, i.getListeners)(e, a)) && 1 === r.length ? (a._middleListeners || (a._middleListeners = {}), a._middleListeners[e] || (a._middleListeners[e] = function (t) {
          a.fireEvent(e, o.UNDEF, o.UNDEF, o.UNDEF, t);
        }), !0) : t);
      }, e.prototype.removeEventListener = function (e, t) {
        var n;
        if (e && e.toLowerCase && (e = e.toLowerCase(), (0, i.removeListener)(e, t, this), (0, o.isInterActiveEvt)(e) && (n = (0, i.getListeners)(e, this)) && 0 === n.length && this._middleListeners && this._middleListeners[e])) return !0;
      }, e.prototype.fireEvent = function (e, t, n, r, o) {
        (0, i.triggerEvent)(e, this, t, o, n, r);
      }, e.prototype.addExtEventListener = function (e, t, n) {
        return !!(n && n.addEventListener && n.addEventListener(e, t)) && (this._extListeners[e] || (this._extListeners[e] = []), this._extListeners[e].push({
          fn: t,
          component: n
        }), t);
      }, e.prototype.removeExtEventListener = function (e, t, n) {
        var r, o;
        if (n && n.addEventListener && this._extListeners && this._extListeners[e]) for (r = (o = this._extListeners[e]).length - 1; r >= 0; r -= 1) {
          if (o[r] && o[r].fn === t && o[r].component === n) return n.removeEventListener(e, t), void o.splice(r, 1);
        }
      }, e.prototype._setLinkedParent = function (e) {
        var t = this._linkedParent;
        this._linkedParent = e, t !== e && (this.setState("parentChanged", !0), t && this.fireEvent("parentdetached", {
          oldParent: t
        }), e && this.fireEvent("parentAttached", {
          newParent: e
        })), this._updateParentEnv && this._updateParentEnv();
      }, e.prototype.getLinkedParent = function () {
        return this._linkedParent;
      }, e.prototype.setLinkedItem = function (e, t) {
        this.linkedItems || (this.linkedItems = {}), e === o.UNDEF && t === o.UNDEF || (this.linkedItems[e] = t);
      }, e.prototype.getLinkedItem = function (e) {
        if (this.linkedItems) return e !== o.UNDEF ? this.linkedItems[e] : this.linkedItems;
      }, e.prototype.removeLinkedItem = function (e) {
        this.linkedItems && this.linkedItems[e] && delete this.linkedItems[e];
      }, e.prototype.detachChild = function (e) {
        var t,
            n = this;
        return e === o.UNDEF ? o.UNDEF : (n._searchChildren(e, function (e, r, i) {
          i && i.constructor === Array ? t = i.splice(r, 1)[0] : (t = i[e], delete i[e]), t._setLinkedParent(o.UNDEF), n.fireEvent("childdetached", {
            detachedChild: t
          });
        }), t);
      }, e.prototype._mapChildren = function (e, t) {
        t ? function (e, t) {
          if (e && e.hasOwnProperty && t && t.call) {
            var n = void 0,
                r = void 0,
                o = void 0;

            for (n in e) {
              if (e.hasOwnProperty(n)) if ((r = e[n]) instanceof Array) for (o = r.length - 1; o >= 0; o--) {
                t(r[o], n, o);
              } else t(r, n);
            }
          }
        }(this.getChildren(), e) : u(this.getChildren(), e);
      }, e.prototype._dispose = function () {
        var e, t, n, r;

        if (this && this !== window && !0 !== this._disposing) {
          if (this._disposing = !0, this.fireEvent("beforeremove"), (e = this.getLinkedParent()) && e.detachChild && !e._disposing && e.detachChild(this.getId()), this._extListeners) for (n in this._extListeners) {
            for (t = (r = this._extListeners[n]).length - 1; t >= 0; t--) {
              r[t].component && r[t].component.addEventListener && r[t].component.removeEventListener(n, r[t].fn);
            }
          }
          return this.removeAllJobs(), !0;
        }
      }, e.prototype.remove = function (e) {
        var t = e && e.instant;
        this.setState("removed", !0), this.getChildren() && this._mapChildren(function (t) {
          t && t.remove && t.remove(e);
        }, !0), t && this._dispose();
      }, e.prototype.setState = function (e, t) {
        this._state[e] = t;
      }, e.prototype.getState = function (e) {
        return this._state && this._state[e];
      }, e.prototype.registerFactory = function (e, t, n) {
        var r = {
          name: e,
          factory: t,
          dep: n
        };
        if (this._factoriyNames[e]) for (var o = 0, i = this._factories.length, a = !1; o < i && !a; o += 1) {
          this._factories[o].name === e && (this._factories.splice(o, 1), a = !0);
        }
        this._factories.push(r), this._factoriyNames[e] = !0;
      }, e.prototype.deregisterFactory = function (e) {
        if (this._factoriyNames[e]) return delete this._factoriyNames[e], this._factories.splice(this._factories.findIndex(function (t) {
          return t.name === e;
        }), 1)[0].factory;
      }, e.prototype.invokeFactories = function () {
        for (var e = this, t = e._factoriyNames, n = {}, r = e._factories, o = void 0, i = r.length + 1, a = function a(r) {
          var i = void 0;
          r.dep && r.dep.length && r.dep.forEach(function (e) {
            i = t[e] && !n[e];
          }), i ? o.push(r) : (r.factory(e), n[r.name] = !0);
        }; r.length && r.length < i;) {
          o = [], r.forEach(a), i = r.length, r = o;
        }

        r.length && r.forEach(function (t) {
          return t.factory(e);
        }), this.fireEvent("factoriesinvoked", {});
      }, e;
    }();

    t["default"] = d, t.removeAllEventsFromGraphic = function (e, t) {
      var n, r;
      if (t && t.hasOwnProperty) for (n in t) {
        t.hasOwnProperty(n) && (r = (0, i.getListeners)(n, this)) && r.length >= 1 && e && e.off(n, t[n]);
      }
    }, t.addAllEventsOnGraphic = function (e, t, n) {
      var r, o;
      if (t && t.hasOwnProperty) for (r in t) {
        t.hasOwnProperty(r) && (o = (0, i.getListeners)(r, n)) && o.length >= 1 && e && e.on(r, t[r]);
      }
    }, t._mapSubFnForward = u;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        i = n(140);

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var s = function s(e, t) {
      if (e && e.hasOwnProperty && t && t.call) {
        var n = void 0,
            r = void 0,
            o = void 0;

        for (n in e) {
          for (o = (r = e[n].elemStore) && r.length - 1; o >= 0 && !t(r[o], n, o); o--) {
            ;
          }
        }
      }
    },
        l = function l(e, t) {
      if (e && e.hasOwnProperty && t && t.call) {
        var n = void 0,
            r = void 0,
            o = void 0,
            i = void 0;

        for (r in e) {
          for (i = 0, n = (o = e[r].elemStore) && o.length; i < n && !t(o[i], r, i); i++) {
            ;
          }
        }
      }
    },
        c = function (e) {
      function t(n) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var r = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this)),
            o = r;

        return o._id = n, o._componentStore = {}, o._oldComponentStore = [], o.fireEvent("instantiated"), o.__setDefaultConfig(), r;
      }

      return a(t, e), t.prototype.isDrawingRequired = function () {
        return this;
      }, t.prototype.syncDraw = function () {
        this.isDrawingRequired() && (this._removeUnusedComponent(), this._resetGraphicalStore(), e.prototype.syncDraw.call(this), this._removeUnusedGraphics());
      }, t.prototype.setDimension = function (e, t) {
        this.config.width = e, this.config.height = t;
      }, t.prototype.setTranslation = function (e, t) {
        var n = this.config;
        n._translateX = e, n._translateY = t, n.translate = "t" + e + "," + t;
      }, t.prototype.getTranslation = function (e, t) {
        return {
          x: this.config._translateX,
          y: this.config._translateY
        };
      }, t.prototype._resetGraphicalStore = function () {
        this._oldGraphicalStore = this._graphicalStore, this._graphicalStore = {};
      }, t.prototype._getLastUsedElem = function () {
        return this.config.lastElemUsed;
      }, t.prototype.addGraphicalElement = function () {
        var e,
            t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            n = arguments[1],
            r = this.getFromEnv("animationManager"),
            a = t.label,
            s = this._graphicalStore[a] || (this._graphicalStore[a] = {
          elemStore: [],
          idMap: {},
          indexMap: {},
          lastIndexUsed: -1
        }),
            l = void 0,
            c = !0,
            u = this._oldGraphicalStore && this._oldGraphicalStore[a],
            d = s.lastIndexUsed += 1,
            f = void 0,
            h = void 0,
            p = t.attr,
            g = t.id;
        u && (g && u.idMap[g] !== undefined ? (f = u.idMap[g], h = u.elemStore[f], delete u.elemStore[f], delete u.indexMap[f], delete u.idMap[g]) : u.elemStore[d] && (u.indexMap[d] || (h = u.elemStore[d], delete u.elemStore[d]))), h && (t.el = h, c = !1, (p = function (e, t) {
          var n = void 0,
              r = void 0,
              i = void 0,
              a = void 0;

          for (a in e) {
            i = void 0 === (r = e[a]) ? "undefined" : o(r), t[a] !== undefined ? "object" === i ? r.toString().replace(/,/g, "") !== t[a].toString().replace(/,/g, "") && (n || (n = {}), n[a] = r) : "string" === i ? r.replace(/,/g, "") !== t[a].toString().replace(/,/g, "") && (n || (n = {}), n[a] = r) : r !== t[a] && (n || (n = {}), n[a] = r) : (n || (n = {}), n[a] = r);
          }

          return n;
        }(t.attr, h.attrs)) && (t.attr = p)), (e = t.container) ? (l = e.isParent ? this.getLinkedParent() : this, t.container = l.getGraphicalElement(e.id, e.label) || l.getChildContainer(e.id)) : t.container = this.getFromEnv("chart-container"), p && (h = r.setAnimation(t)), s.elemStore[d] = h, g && (s.idMap[g] && (delete s.indexMap[s.idMap[g]], delete s.idMap[g]), s.idMap[g] = d, s.indexMap[d] = g), this.fireEvent("graphicalelementattached", {
          element: h
        }), h._skipEvents = n, t.shadow && h.shadow(t.shadow), t.tooltext && this.getFromEnv("toolTipController").enableToolTip(h, t.tooltext), this.config.lastElemUsed = h, !n && c && (0, i.addAllEventsOnGraphic)(h, this._middleListeners, this);
      }, t.prototype.removeGraphicalElement = function (e, t) {
        var n,
            r,
            a = this,
            l = a._graphicalStore;
        "object" === (void 0 === e ? "undefined" : o(e)) ? s(l, function (t, o, s) {
          if (e === t) return r = !0, !t._skipEvents && (0, i.removeAllEventsFromGraphic)(t, a._middleListeners), a._setRemoveAnim(t, o), (n = l[o]).elemStore.splice(s, 1), delete n.idMap[n.indexMap[s]], delete n.indexMap[s], !0;
        }) : s(l, function (o, s, c) {
          if (n = l[s], n.indexMap[c] === e && (!t || t === s)) return r = !0, !o._skipEvents && (0, i.removeAllEventsFromGraphic)(o, a._middleListeners), a._setRemoveAnim(o, s), n.elemStore.splice(c, 1), delete n.idMap[n.indexMap[c]], delete n.indexMap[c], !0;
        }), r && this.fireEvent("graphicalelementremoved", {
          element: void 0
        });
      }, t.prototype.getChildContainer = function (e) {
        return this.getGraphicalElement(void 0, e);
      }, t.prototype._removeUnusedGraphics = function () {
        var e = this,
            t = e._oldGraphicalStore,
            n = void 0;
        s(t, function (r, o, a) {
          r && (!r._skipEvents && (0, i.removeAllEventsFromGraphic)(r, e._middleListeners), e._setRemoveAnim(r, o), delete (n = t[o]).idMap[n.indexMap[a]], delete n.indexMap[a]);
        });
      }, t.prototype.getGraphicalElement = function (e, t) {
        var n,
            r = void 0,
            o = void 0,
            i = void 0,
            a = this._graphicalStore;
        return t || e ? t ? (n = a[t], e ? n && n.elemStore && n.elemStore[n.idMap[e]] : n && n.elemStore && n.elemStore[0]) : (l(a, function () {
          if (i = arguments[2], r = a[arguments[1]], r.idMap[i] === e) return o = r.elemStore[i], !0;
        }), o) : a;
      }, t.prototype.addEventListener = function (t, n, r) {
        var o = e.prototype.addEventListener.call(this, t, n, r);
        return !0 === o ? (function (e, t, n) {
          var r;
          t && n && (r = function r(e) {
            !e._skipEvents && e.on && e.on(t, n);
          }, l(e.getGraphicalElement(), r));
        }(this, t, this._middleListeners[t]), n) : !!o && n;
      }, t.prototype.removeEventListener = function (t, n) {
        e.prototype.removeEventListener.call(this, t, n) && function (e, t, n) {
          var r;
          t && n && (r = function r(e) {
            !e._skipEvents && e.off && e.off(t, n);
          }, l(e.getGraphicalElement(), r));
        }(this, t, this._middleListeners[t]);
      }, t.prototype._dispose = function () {
        var t = void 0;

        if (e.prototype._dispose.call(this)) {
          for (t in this.getFromEnv("paper") && !this.getFromEnv("paper").removed && l(this.getGraphicalElement(), this.__instantRemoveFn), this) {
            this.hasOwnProperty(t) && delete this[t];
          }

          this.fireEvent("removed");
        }
      }, t.prototype.removingDraw = function () {
        l(this.getGraphicalElement(), this._setRemoveAnim);
      }, t.prototype.configure = function (t) {
        this._resetComponentStore(), e.prototype.configure.call(this, t);
      }, t.prototype._resetComponentStore = function () {
        this._oldComponentStore.push(this._componentStore), this._componentStore = {};
      }, t.prototype._mapChildren = function (e, t) {
        t ? s(this.getChildren(), e) : l(this.getChildren(), e);
      }, t.prototype.attachChild = function (e, t, n) {
        var r = this._componentStore[t] || (this._componentStore[t] = {
          elemStore: [],
          idMap: {},
          indexMap: {},
          lastIndexUsed: -1
        }),
            o = this._oldComponentStore && this._oldComponentStore.length && this._oldComponentStore[this._oldComponentStore.length - 1][t],
            i = r.lastIndexUsed += 1,
            a = void 0,
            s = void 0;
        return o && (n && o.idMap[n] !== undefined ? (a = o.idMap[n], s = o.elemStore[a], delete o.elemStore[a], delete o.indexMap[a], delete o.idMap[n]) : o.elemStore[i] && (o.indexMap[i] || (s = o.elemStore[i], delete o.elemStore[i]))), s || (s = new e(n)), r.elemStore[i] = s, n && (r.idMap[n] = i, r.indexMap[i] = n), s._setLinkedParent(this), this.fireEvent("childattached", {
          attachedChild: s
        }), s;
      }, t.prototype._removeUnusedComponent = function () {
        for (var e = this._oldComponentStore, t = e.length, n = 0, r = function r(t, _r, o) {
          var i = void 0;
          t && (delete (i = e[n][_r]).idMap[i.indexMap[o]], delete i.indexMap[o], t.remove());
        }; n < t; n += 1) {
          s(e[n], r);
        }

        this._oldComponentStore.length = 0;
      }, t.prototype.getChild = function (e, t) {
        var n;
        return this._searchChildren(e, function (e) {
          n = e;
        }, t), n;
      }, t.prototype._searchChildren = function (e, t, n) {
        var r,
            o,
            i,
            a = this._componentStore;
        if (e ? s(a, function (t, s, l) {
          if (r = a[s], r.indexMap[l] === e && (!n || n === s)) return i = t, o = l, n = s, !0;
        }) : i = a[n] && a[n].elemStore, i) return t(i, o, n);
      }, t.prototype.getChildren = function (e) {
        return e ? this._componentStore[e] && this._componentStore[e].elemStore : this._componentStore;
      }, t.prototype.detachChild = function (e) {
        var t,
            n,
            r = this,
            o = r._componentStore;
        if (void 0 !== e) return r._searchChildren(e, function (e, i, a) {
          (n = o[a]).elemStore.splice(i, 1), delete n.idMap[n.indexMap[i]], delete n.indexMap[i], e._setLinkedParent(void 0), t = e, r.fireEvent("childdetached", {
            detachedChild: t
          });
        }), t;
      }, t;
    }(((r = i) && r.__esModule ? r : {
      "default": r
    })["default"]);

    t["default"] = c;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = i(n(143)),
        o = i(n(144));

    function i(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var a = r["default"].init(window),
        s = a.win.document,
        l = a.win.Math,
        c = l.max,
        u = l.round,
        d = {
      " ": "&nbsp;"
    },
        f = a.getDocumentSupport(),
        h = f.isWebKit ? 0 : 4.5;

    function p(e, t, n) {
      var r,
          i,
          l,
          c = !1,
          u = window.document.createElement("canvas");

      for (i in (n = n || {}).maxCacheLimit = isFinite(l = n.maxCacheLimit) ? l : a.maxDefaultCacheLimit, "string" == typeof e && (e = s.getElementById(e)), (r = a.createContainer(e)).innerHTML = a.testStrAvg, !f.isHeadLess && (f.isIE || r.offsetHeight || r.offsetWidth) || (c = !0), r.innerHTML = "", a.parentContainerStyle) {
        r.style[i] = a.parentContainerStyle[i];
      }

      this.parentContainer = r, this.ctx = u && u.getContext && u.getContext("2d"), this._containerManager = new o["default"](r, c, 10), this._showNoEllipses = !t, this._init = !0, this.style = {}, this.oldStyle = {}, this.options = n, this.setStyle();
    }

    p.textToLines = function (e) {
      return (e = e || {}).text ? "string" != typeof e.text && (e.text = e.text.toString()) : e.text = "", e.lines = e.text.split(/\n|<br\s*?\/?>/gi), e;
    }, p.prototype._calCharDimWithCache = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "",
          t = arguments[1],
          n = arguments[2];
      if (!this._init) return !1;
      var r,
          o,
          i,
          a,
          s,
          l,
          c,
          u,
          f,
          h = this.options.maxCacheLimit,
          p = this.style || {};
      return l = this._advancedCache = this._advancedCache || (this._advancedCache = {}), c = this._advancedCacheKey || (this._advancedCacheKey = []), u = e + p.fontSize + p.fontFamily + p.fontWeight + p.fontStyle, f = e + "init" + p.fontSize + p.fontFamily + p.fontWeight + p.fontStyle, !this.ctx && d[e] && (e = d[e]), t ? (s = l[f]) === undefined && (o = this._getDimention(e.repeat ? e.repeat(n) : Array(n + 1).join(e)).width, i = this._getDimention(e).width, s = l[f] = (o - n * i) / (n + 1), c.push(f), c.length > h && delete l[c.shift()]) : s = 0, (a = l[u]) ? {
        width: a.width,
        height: a.height
      } : ((r = this._getDimention(e)).width += s, l[u] = {
        width: r.width,
        height: r.height
      }, c.push(u), c.length > h && delete l[c.shift()], r);
    }, p.prototype._getDimention = function (e) {
      return this.requireDiv || !this.ctx ? a._getDimentionUsingDiv(e, this) : a._getDimentionUsingCanvas(e, this);
    }, p.prototype._getWidthFn = function () {
      var e = this,
          t = e._containerObj.svgText;
      return t ? function (e) {
        var n, r;
        return t.textContent = e, (r = (n = t.getBBox()).width - h) < 1 && (r = n.width), r;
      } : function (t) {
        return e.requireDiv || !e.ctx ? a._getDimentionUsingDiv(t, e).width : a._getDimentionUsingCanvas(t, e).width;
      };
    }, p.prototype._isSameStyle = function () {
      var e = this.oldStyle || {},
          t = this.style;
      return t.fontSize === e.fontSize && t.fontFamily === e.fontFamily && t.fontStyle === e.fontStyle && t.fontWeight === e.fontWeight && t.fontVariant === e.fontVariant;
    }, p.prototype._setStyleOfCanvas = function () {
      if (!this._isSameStyle()) {
        var e,
            t,
            n = this,
            r = n.style,
            o = (n.ctx, r.fontStyle),
            i = r.fontVariant,
            s = r.fontWeight,
            l = r.fontSize,
            c = r.fontFamily;
        e = o + " " + i + " " + s + " " + (l += -1 === l.indexOf("px") ? "px" : "") + " " + c, n.ctx.font = e, t = this._containerObj = this._containerManager.get(r), this._containerObj ? (this._container = t.node, this._context = t.context, this._cache = t.charCache, this._lineHeight = t.lineHeight, this._styleNotSet = !1) : this._styleNotSet = !0, t.ellipsesWidth = n._calCharDimWithCache("...", !1).width, t.dotWidth = n._calCharDimWithCache(".", !1).width, t.lineHeight = this._lineHeight = t.lineHeight || a._getCleanHeight(r.lineHeight), this.oldStyle = r;
      }
    }, p.prototype._setStyleOfDiv = function () {
      var e,
          t = this.style;
      this._containerObj = e = this._containerManager.get(t), !e.node && this._containerManager._makeDivNode(this._containerObj), this._containerObj ? (this._container = e.node, this._context = e.context, this._cache = e.charCache, this._lineHeight = e.lineHeight, this._styleNotSet = !1) : this._styleNotSet = !0;
    }, p.prototype._updateStyle = function () {
      return this.requireDiv || !this.ctx ? this._setStyleOfDiv() : this._setStyleOfCanvas();
    }, p.prototype.setStyle = function (e) {
      this.style = a.parseStyle(e), a.setLineHeight(this.style);
    }, p.prototype.useEllipsesOnOverflow = function (e) {
      return this._init ? (this._showNoEllipses = !e, this) : this;
    }, p.prototype.getSmartText = function (e, t, n, r) {
      if (!this._init) return !1;
      e === undefined || null === e ? e = "" : "string" != typeof e && (e = e.toString());

      var o,
          i,
          l,
          u,
          d,
          h,
          p,
          g,
          m,
          v,
          y,
          b,
          x,
          w,
          C,
          _,
          S,
          E,
          k,
          A,
          T,
          M,
          O,
          F,
          I,
          L,
          N,
          D,
          P,
          R,
          j,
          V,
          B,
          H,
          G,
          z = 0,
          U = -1,
          $ = -1,
          X = -1,
          W = 0,
          Y = 0,
          q = [],
          K = 0,
          J = this._showNoEllipses ? "" : "...",
          Z = this.ctx,
          Q = [],
          ee = -1,
          te = -1,
          ne = -1,
          re = function re(e) {
        for (var t = /\s/, n = (e = e.replace(/^\s\s*/, "")).length; t.test(e.charAt(n -= 1));) {
          ;
        }

        return e.slice(0, n + 1);
      },
          oe = {
        text: e,
        maxWidth: t,
        maxHeight: n,
        width: null,
        height: null,
        oriTextWidth: null,
        oriTextHeight: null,
        oriText: e,
        isTruncated: !1
      };

      if (N = a.xmlTagRegEx.test(e), H = a._hasOnlyBRTag(e), this.requireDiv = N && !H, this._updateStyle(), D = this._lineHeight, P = this._context, R = this._container, V = (j = this._containerObj).ellipsesWidth, B = j.dotWidth, h = e.replace(a.spanAdditionRegx, "$2"), b = this._getWidthFn(), D - n <= 1 && D - n >= 0 && (n *= 1.2), Z || R) {
        if (!f.isBrowserLess) {
          if (N ? H ? (e = e.replace(a.brRegex, "<br />"), G = a._getDimentionOfMultiLineText(e, this), oe.oriTextWidth = p = G.width, oe.oriTextHeight = g = G.height) : (R.innerHTML = e, oe.oriTextWidth = p = R.offsetWidth, oe.oriTextHeight = g = R.offsetHeight) : (u = e = e.replace(a.ltgtRegex, function (e) {
            return "&lt;" === e ? "<" : ">";
          }), C = this.getOriSize(u, !0, {
            hasHTMLTag: N,
            hasOnlyBrTag: H,
            cleanText: !0
          }), oe.oriTextWidth = p = C.width, oe.oriTextHeight = g = C.height), g <= n && p <= t) return oe.width = oe.oriTextWidth = p, oe.height = oe.oriTextHeight = g, oe;
          if (D > n) return oe.text = "", oe.width = oe.oriTextWidth = 0, oe.height = oe.oriTextHeight = 0, oe;
        }

        if (e = re(e).replace(/(\s+)/g, " "), d = this._showNoEllipses ? t : t - V, !N || H) {
          if (o = (q = a._getTextArray(e)).length, i = "", l = [], y = q[0], this._cache[y] ? k = this._cache[y].width : (k = b(y), this._cache[y] = {
            width: k
          }), d > k && !H) l = e.substr(0, a.getNearestBreakIndex(e, d, this)).split("");else {
            if (k > t) return oe.text = "", oe.width = oe.oriTextWidth = oe.height = oe.oriTextHeight = 0, oe;
            J && ((d = t - 2 * B) > k ? J = ".." : (d = t - B) > k ? J = "." : (d = 0, J = ""));
          }

          if (K = l.length, W = b(l.join("")), Y = this._lineHeight, r) {
            for (; K < o; K += 1) {
              if (y = l[K] = q[K], "<br />" !== l[K]) {
                if (this._cache[y] ? k = this._cache[y].width : (C && (k = C.detailObj[y]) || (k = b(y)), this._cache[y] = {
                  width: k
                }), (W += k) > d && (i || (i = l.slice(0, -1).join("")), W > t)) return oe.text = re(i) + J, oe.tooltext = oe.oriText, oe.width = c(z, W), oe.height = Y, oe;
              } else Y += this._lineHeight, X = K, z = c(z, W), W = 0, i = null;
            }

            return oe.text = l.join(""), oe.width = c(z, W), oe.height = Y, oe;
          }

          for (; K < o; K += 1) {
            if (" " !== (y = l[K] = q[K]) || P || (y = this.ctx ? " " : "&nbsp;"), "<br />" === l[K]) {
              if (z = c(z, W), (Y += this._lineHeight) <= n) {
                X = K, W = 0, i = null;
                continue;
              }

              if (Y > n) return i = l.slice(0, -1).join(""), oe.text = re(i) + J, oe.tooltext = h, oe.width = z, oe.height = Y - this._lineHeight, oe;
            }

            if (this._cache[y] ? k = this._cache[y].width : (C && (k = C.detailObj[y]) || (k = b(y)), this._cache[y] = {
              width: k
            }), (W += k) > d && (i || (i = l.slice(0, -1).join("")), W > t)) {
              if ("<br />" === q[K + 1]) continue;
              if ($ = a._findLastIndex(q.slice(0, l.length), " "), U = a._findLastIndex(q.slice(0, l.length), "-"), $ > X ? (W = b(l.slice(X + 1, $).join("")), l.splice($, 1, "<br />"), X = $, m = $ + 1) : U > X ? (U === l.length - 1 ? (W = b(l.slice(X + 1, $).join("")), l.splice(U, 1, "<br />-")) : (W = b(l.slice(X + 1, $).join("")), l.splice(U, 1, "-<br />")), X = U, m = U + 1) : (l.splice(l.length - 1, 1, "<br />" + q[K]), ne = l.length - 2, W = b(l.slice(X + 1, ne + 1).join("")), X = ne, m = K), (Y += this._lineHeight) > n) return oe.text = re(i) + J, oe.tooltext = oe.oriText, oe.width = t, oe.height = Y - this._lineHeight, oe;
              z = c(z, W), i = null, H ? W = a._getDimentionOfMultiLineText(l.slice(X + 1).join(""), this).width : (v = a.getNearestBreakIndex(e.substr(m), d, this), W = b(e.substr(m, v || 1)), l.length < m + v && (K = (l = l.concat(e.substr(l.length, m + v - l.length).split(""))).length - 1));
            }
          }

          return z = c(z, W), oe.text = l.join(""), oe.width = z, oe.height = Y, oe;
        }

        for (h = e.replace(a.spanAdditionRegx, "$2"), e = (e = e.replace(a.spanAdditionRegx, a.spanAdditionReplacer)).replace(/(<br\s*\/*\>)/g, '<span class="' + [a.classNameWithTag, " ", a.classNameWithTagBR].join("") + '">$1</span>'), R.innerHTML = e, S = 0, E = (_ = R[f.childRetriverFn](f.childRetriverString)).length; S < E; S += 1) {
          A = _[S], (f.noClassTesting || a.classNameReg.test(A.className)) && "" !== (T = A.innerHTML) && (" " === T ? te = Q.length : "-" === T && (ee = Q.length), Q.push({
            spaceIdx: te,
            dashIdx: ee,
            elem: A
          }), q.push(T));
        }

        if (K = 0, (k = (o = Q.length) && Q[0].elem.offsetWidth) > t || !o) return oe.text = "", oe.width = oe.oriTextWidth = oe.height = oe.oriTextHeight = 0, oe;
        if (k > d && !this._showNoEllipses && ((d = t - 2 * B) > k ? J = ".." : (d = t - B) > k ? J = "." : (d = 0, J = "")), x = Q[0].elem.offsetLeft, w = Q[0].elem.offsetTop, r) for (; K < o; K += 1) {
          (M = (A = Q[K].elem).offsetLeft - x + A.offsetWidth) > d && (L || (L = K), R.offsetWidth > t && (I = K, K = o));
        } else for (; K < o; K += 1) {
          O = (A = Q[K].elem).offsetHeight + (A.offsetTop - w), F = null, (M = A.offsetLeft - x + A.offsetWidth) > d ? (L || (L = K), M > t && ($ = Q[K].spaceIdx, U = Q[K].dashIdx, $ > X ? (Q[$].elem.innerHTML = "<br/>", X = $) : U > X ? (Q[U].elem.innerHTML = U === K ? "<br/>-" : "-<br/>", X = U) : A.parentNode.insertBefore(F = s.createElement("br"), A), A.offsetHeight + A.offsetTop > n ? (F ? F.parentNode.removeChild(F) : X === U ? Q[U].elem.innerHTML = "-" : Q[$].elem.innerHTML = " ", I = K, K = o) : L = null)) : O > n && (I = K, K = o);
        }

        if (I < o) {
          for (oe.isTruncated = !0, L = L || I, K = o - 1; K >= L; K -= 1) {
            (A = Q[K].elem).parentNode.removeChild(A);
          }

          for (; K >= 0; K -= 1) {
            A = Q[K].elem, a.classNameBrReg.test(A.className) ? A.parentNode.removeChild(A) : K = 0;
          }
        }

        return oe.text = R.innerHTML.replace(a.spanRemovalRegx, "$1").replace(/\&amp\;/g, "&"), oe.isTruncated && (oe.text += J, oe.tooltext = h), oe.height = R.offsetHeight, oe.width = R.offsetWidth, oe;
      }

      return oe.error = new Error("Body Tag Missing!"), oe;
    }, p.prototype.getOriSize = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "",
          t = !(arguments.length > 1 && arguments[1] !== undefined) || arguments[1],
          n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!this._init) return !1;
      var r,
          o,
          i,
          s,
          l,
          d,
          f = 0,
          h = 0,
          p = {},
          g = n.hasHTMLTag,
          m = n.hasOnlyBrTag;
      if (void 0 === g && (g = a.xmlTagRegEx.test(e)), void 0 === m && (m = a._hasOnlyBRTag(e)), this.requireDiv = g && !m, n.cleanText || (e = e.replace(a.ltgtRegex, function (e) {
        return "&lt;" === e ? "<" : ">";
      })), this._updateStyle(), d = this._container, m) return a._getDimentionOfMultiLineText(e, this);
      if (!t) return this._calCharDimWithCache(e);
      if (g) return d.innerHTML = e, {
        width: d.offsetWidth,
        height: d.offsetHeight
      };

      for (s = 0, l = (r = e.split("")).length; s < l; s++) {
        o = r[s], i = this._calCharDimWithCache(o, !1, r.length), h = c(h, i.height), f += i.width, p[o] = i.width;
      }

      return {
        width: u(f),
        height: h,
        detailObj: p
      };
    }, p.prototype.dispose = function () {
      return this._init ? (this._containerManager && this._containerManager.dispose && this._containerManager.dispose(), delete this._container, delete this._context, delete this._cache, delete this._containerManager, delete this._containerObj, delete this.id, delete this.style, delete this.parentContainer, delete this._showNoEllipses, this) : this;
    }, t["default"] = p;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = {
      init: function init(e) {
        var t = e.document,
            n = e.navigator.userAgent,
            o = Math.ceil,
            i = Math.floor,
            a = "fusioncharts-smartlabel-",
            s = a + "container",
            l = a + "tag";
        return r = {
          win: e,
          containerClass: s,
          classNameWithTag: l,
          classNameWithTagBR: "fusioncharts-smartlabel-br",
          maxDefaultCacheLimit: 1e3,
          classNameReg: /\bfusioncharts-smartlabel-tag\b/,
          classNameBrReg: /\bfusioncharts-smartlabel-br\b/,
          spanAdditionRegx: /(<[^<\>]+?\>)|(&(?:[a-z]+|#[0-9]+);|.)/gi,
          spanAdditionReplacer: '$1<span class="' + l + '">$2</span>',
          spanRemovalRegx: new RegExp("\\<span[^\\>]+?" + l + "[^\\>]{0,}\\>(.*?)\\<\\/span\\>", "ig"),
          xmlTagRegEx: new RegExp("<[^>][^<]*[^>]+>", "i"),
          brRegex: new RegExp("({br[ ]*})|(<br[ ]*>)|(<br[ ]*/>)|(<BR[ ]*/>)|(<br\\>)", "g"),
          ltgtRegex: /&lt;|&gt;/g,
          htmlSpecialEntityRegex: /&amp;|&quot;|&lt;|&gt;/g,
          brReplaceRegex: /<br\/>/gi,
          testStrAvg: "WgI",
          parentContainerStyle: {
            position: "absolute",
            top: "-9999em",
            whiteSpace: "nowrap",
            padding: "0px",
            width: "1px",
            height: "1px",
            overflow: "hidden"
          },
          supportedStyle: {
            font: "font",
            fontFamily: "font-family",
            "font-family": "font-family",
            fontWeight: "font-weight",
            "font-weight": "font-weight",
            fontSize: "font-size",
            "font-size": "font-size",
            lineHeight: "line-height",
            "line-height": "line-height",
            fontStyle: "font-style",
            "font-style": "font-style"
          },
          getDocumentSupport: function getDocumentSupport() {
            var r, o, i;
            return t.getElementsByClassName ? (r = "getElementsByClassName", o = l, i = !0) : (r = "getElementsByTagName", o = "span", i = !1), {
              isIE: /msie/i.test(n) && !e.opera,
              hasSVG: Boolean(e.SVGAngle || t.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1")),
              isHeadLess: new RegExp(" HtmlUnit").test(n),
              isWebKit: new RegExp(" AppleWebKit/").test(n),
              childRetriverFn: r,
              childRetriverString: o,
              noClassTesting: i
            };
          },
          createContainer: function createContainer(e) {
            var n, r;

            if (e && (e.offsetWidth || e.offsetHeight)) {
              if (e.appendChild) return e.appendChild(r = t.createElement("DIV")), r.className = s, r.setAttribute("aria-hidden", "true"), r.setAttribute("role", "presentation"), r;
            } else if ((n = t.getElementsByTagName("body")[0]) && n.appendChild) return (r = t.createElement("DIV")).className = s, r.setAttribute("aria-hidden", "true"), r.setAttribute("role", "presentation"), n.appendChild(r), r;
          },
          getNearestBreakIndex: function getNearestBreakIndex(e, t, n) {
            if (!e || !e.length) return 0;

            var r,
                a = n._getWidthFn(),
                s = 0,
                l = 0,
                c = a(e),
                u = c / e.length;

            if (r = t, s = o(t / u), c < t) return e.length - 1;

            for (s > e.length && (r = t - c, s = e.length); r > 0;) {
              if (r = t - a(e.substr(0, s)), !(l = i(r / u))) return s;
              s += l;
            }

            for (; r < 0;) {
              if (r = t - a(e.substr(0, s)), !(l = i(r / u))) return s;
              s += l;
            }

            return s;
          },
          parseStyle: function parseStyle() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                t = {};
            return t.fontSize = (e.fontSize || e["font-size"] || "12px") + "", t.fontVariant = e.fontVariant || e["font-variant"] || "normal", t.fontWeight = e.fontWeight || e["font-weight"] || "normal", t.fontStyle = e.fontStyle || e["font-style"] || "normal", t.fontFamily = e.fontFamily || e["font-family"] || "Verdana,sans", t;
          },
          setLineHeight: function setLineHeight(e) {
            var t = e.fontSize;
            return e.lineHeight = e.lineHeight || e["line-height"] || 1.2 * parseInt(t, 10) + "px", e;
          },
          _getCleanHeight: function _getCleanHeight(e) {
            return e = e.replace(/px/g, ""), Number(e);
          },
          _getDimentionUsingDiv: function _getDimentionUsingDiv() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "",
                t = arguments[1]._container;
            return e instanceof Array && (e = e.join("")), t.innerHTML = e, {
              width: t.offsetWidth,
              height: t.offsetHeight
            };
          },
          _getDimentionUsingCanvas: function _getDimentionUsingCanvas() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "",
                t = arguments[1],
                n = t.ctx,
                o = t.style,
                i = r._getCleanHeight(o.lineHeight);

            return e = e instanceof Array ? (e = e.join("")).replace(/<br \/>/g, "") : e.replace(/<br \/>/g, ""), {
              width: n.measureText(e).width,
              height: i
            };
          },
          _hasOnlyBRTag: function _hasOnlyBRTag() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            return !r.xmlTagRegEx.test(e) && r.brRegex.test(e);
          },
          _getDimentionOfMultiLineText: function _getDimentionOfMultiLineText() {
            var e,
                t,
                n,
                o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "",
                i = arguments[1],
                a = o.replace(r.brRegex, "<br />"),
                s = r._getTextArray(a),
                l = 0,
                c = 0,
                u = i._getWidthFn(),
                d = r._getCleanHeight(i.style.lineHeight),
                f = d,
                h = {};

            for (e = 0, t = s.length; e < t; e++) {
              "<br />" === s[e] ? (c = Math.max(c, l), l = 0, f += d) : (l += n = u(s[e]), h[s[e]] = n);
            }

            return {
              height: f,
              width: c = Math.max(c, l),
              detailObj: h
            };
          },
          _getTextArray: function _getTextArray() {
            var e,
                t,
                n,
                r,
                o,
                i,
                a = [];

            for (n = (o = (arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "").split("<br />")).length, e = 0; e < n; e++) {
              for (r = (i = o[e].split("")).length, t = 0; t < r; t++) {
                a.push(i[t]);
              }

              e !== n - 1 && a.push("<br />");
            }

            return a;
          },
          _findLastIndex: function _findLastIndex() {
            var e,
                t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
                n = arguments[1];

            for (e = t.length - 1; e >= 0; e--) {
              if (t[e] === n) return e;
            }

            return -1;
          }
        };
      }
    };
    t["default"] = r;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(143);
    var i = ((r = o) && r.__esModule ? r : {
      "default": r
    })["default"].init(window),
        a = i.win.document,
        s = i.getDocumentSupport(),
        l = s.isWebKit ? 0 : 4.5;

    function c(e, t, n) {
      var r;
      n = (n = n > 5 ? n : 5) < 20 ? n : 20, this.maxContainers = n, this.first = null, this.last = null, this.containers = {}, this.length = 0, this.rootNode = e, t && ((r = a.createElementNS("http://www.w3.org/2000/svg", "svg")).setAttributeNS("http://www.w3.org/2000/svg", "xlink", "http://www.w3.org/1999/xlink"), r.setAttributeNS("http://www.w3.org/2000/svg", "height", "0"), r.setAttributeNS("http://www.w3.org/2000/svg", "width", "0"), this.svgRoot = r, this.rootNode.appendChild(r));
    }

    c.prototype.get = function (e) {
      var t,
          n,
          r,
          o = this.containers,
          a = this.length,
          s = this.maxContainers,
          l = "";

      for (n in i.supportedStyle) {
        e[n] !== undefined && (l += i.supportedStyle[n] + ":" + e[n] + ";");
      }

      if (!l) return !1;
      if (r = o[l]) this.first !== r && (r.prev && (r.prev.next = r.next), r.next && (r.next.prev = r.prev), r.next = this.first, r.next.prev = r, this.last === r && (this.last = r.prev), r.prev = null, this.first = r);else {
        if (a >= s) for (t = a - s + 1; t--;) {
          this.removeContainer(this.last);
        }
        r = this.addContainer(l);
      }
      return r;
    }, c.prototype._makeDivNode = function (e) {
      var t,
          n = e.keyStr;
      e.node || (e.node = a.createElement("div"), e.node.className = "fusioncharts-div", this.rootNode.appendChild(e.node)), t = e.node, s.isIE && !s.hasSVG ? t.style.setAttribute("cssText", n) : t.setAttribute("style", n), t.setAttribute("aria-hidden", "true"), t.setAttribute("role", "presentation"), t.style.display = "inline-block", t.innerHTML = i.testStrAvg, e.lineHeight = t.offsetHeight, e.avgCharWidth = t.offsetWidth / 3, s.isBrowserLess ? (e.svgText || (e.svgText = a.createElementNS("http://www.w3.org/2000/svg", "text"), this.svgRoot.appendChild(t)), (t = e.svgText).setAttribute("style", n), t.textContent = i.testStrAvg, e.lineHeight = t.getBBox().height, e.avgCharWidth = (t.getBBox().width - l) / 3, t.textContent = "...", e.ellipsesWidth = t.getBBox().width - l, t.textContent = ".", e.dotWidth = t.getBBox().width - l) : (t.innerHTML = "...", e.ellipsesWidth = t.offsetWidth, t.innerHTML = ".", e.dotWidth = t.offsetWidth, t.innerHTML = "");
    }, c.prototype.addContainer = function (e) {
      var t;
      return this.containers[e] = t = {
        next: null,
        prev: null,
        node: null,
        ellipsesWidth: 0,
        lineHeight: 0,
        dotWidth: 0,
        avgCharWidth: 4,
        keyStr: e,
        charCache: {}
      }, t.next = this.first, t.next && (t.next.prev = t), this.first = t, this.last || (this.last = t), this.length += 1, t;
    }, c.prototype.removeContainer = function (e) {
      var t = e.keyStr;
      t && this.length && e && (this.length -= 1, e.prev && (e.prev.next = e.next), e.next && (e.next.prev = e.prev), this.first === e && (this.first = e.next), this.last === e && (this.last = e.prev), e.node && e.node.parentNode.removeChild(e.node), delete this.containers[t]);
    }, c.prototype.dispose = function () {
      var e,
          t = this.containers;

      for (e in this.maxContainers = null, t) {
        this.removeContainer(t[e]);
      }

      this.rootNode.parentNode.removeChild(this.rootNode), this.rootNode = null, this.first = null, this.last = null;
    }, t["default"] = c;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = {},
        o = function o(e) {
      r[e] = !0;
    },
        i = function i(e) {
      return r[e];
    };

    t.addFile = o, t.getFile = i, t["default"] = {
      extension: function extension(e) {
        e.addFile = o, e.getFile = i;
      },
      name: "fileStore",
      type: "plugin",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = {
      options: {
        chartTypeSourcePath: ["typeSourcePath", ""],
        product: ["product", "v3"],
        insertMode: ["insertMode", "replace"],
        safeMode: ["safeMode", !0],
        overlayButton: ["overlayButton"],
        containerBackgroundColor: ["containerBackgroundColor", "#ffffff"],
        containerBackgroundOpacity: ["containerBackgroundOpacity", 1],
        containerClassName: ["containerClassName", "fusioncharts-container"],
        chartType: ["type"],
        baseChartMessageFont: ["baseChartMessageFont", "Verdana,sans"],
        baseChartMessageFontSize: ["baseChartMessageFontSize", "10"],
        baseChartMessageColor: ["baseChartMessageColor", "#666666"],
        baseChartMessageImageHAlign: ["baseChartMessageImageHAlign", "middle"],
        baseChartMessageImageVAlign: ["baseChartMessageImageVAlign", "middle"],
        baseChartMessageImageAlpha: ["baseChartMessageImageAlpha", 100],
        baseChartMessageImageScale: ["baseChartMessageImageScale", 100],
        dataLoadStartMessage: ["dataLoadStartMessage", "Retrieving data. Please wait."],
        dataLoadErrorMessage: ["dataLoadErrorMessage", "Error in loading data."],
        dataInvalidMessage: ["dataInvalidMessage", "Invalid data."],
        dataEmptyMessage: ["dataEmptyMessage", "No data to display."],
        typeNotSupportedMessage: ["typeNotSupportedMessage", "Chart type not supported."],
        browserNotSupportedMessage: ["browserNotSupportedMessage", "This browser is not supported."],
        loadMessage: ["loadMessage", "Loading chart. Please wait."],
        renderErrorMessage: ["renderErrorMessage", "Unable to render chart."],
        messageURL: ["messageURL", ""],
        containerElementId: ["renderAt"],
        renderer: ["renderer"],
        containerElementType: ["containerElementType"],
        showChartLoadingMessage: ["showChartLoadingMessage", !0],
        visibilityTrackingInterval: 300,
        events: ["events", {}]
      },
      jsVars: {},
      attributes: {
        lang: ["lang", "EN"],
        id: ["id"]
      },
      link: ["link"],
      width: ["width", "400"],
      height: ["height", "300"]
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        o = n(125);

    var i = Math.abs,
        a = Math.pow,
        s = Math.round,
        l = void 0,
        c = void 0,
        u = void 0,
        d = void 0,
        f = void 0,
        h = {
      formatnumber: "1",
      formatnumberscale: "1",
      forcenumberscale: "0",
      defaultnumberscale: "",
      numberscaleunit: ["K", "M"],
      numberscalevalue: [1e3, 1e3],
      numberprefix: "",
      numbersuffix: "",
      decimals: "",
      forcedecimals: "0",
      yaxisvaluedecimals: "2",
      decimalseparator: ".",
      thousandseparator: ",",
      thousandseparatorposition: [3],
      indecimalseparator: "",
      inthousandseparator: "",
      sformatnumber: "1",
      sformatnumberscale: "0",
      sforcenumberscale: "0",
      sdefaultnumberscale: "",
      snumberscaleunit: ["K", "M"],
      snumberscalevalue: [1e3, 1e3],
      snumberprefix: "",
      snumbersuffix: "",
      sdecimals: "2",
      sforcedecimals: "0",
      syaxisvaluedecimals: "2",
      xFormatNumber: "0",
      xFormatNumberScale: "0",
      xforcenumberscale: "0",
      xDefaultNumberScale: "",
      xNumberScaleUnit: ["K", "M"],
      xNumberScaleValue: [1e3, 1e3],
      xNumberPrefix: "",
      xNumberSuffix: ""
    },
        p = {
      mscombidy2d: {
        formatnumberscale: "1"
      }
    },
        g = function () {
      function e(t, n) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
        var r = t.getName && t.getName(),
            i = this.csConf = (0, o.extend2)({}, h),
            a = p[r];
        this.cleaneValueCacheStore = {}, this.percentStrCacheStore = {}, a && (i = (0, o.extend2)(i, a)), this.linkedItems = {
          chart: t
        }, this.configure(n);
      }

      return e.prototype.setDefaults = function () {
        var e = this.linkedItems.chart,
            t = e.getName && e.getName(),
            n = this.csConf = (0, o.extend2)({}, h),
            r = p[t];
        r && (0, o.extend2)(n, r);
      }, e.prototype.configure = function (e) {
        var t,
            n,
            r,
            i,
            a,
            s,
            l,
            c,
            u,
            d,
            f,
            p,
            g,
            m,
            v,
            y,
            b,
            x,
            w,
            C,
            _,
            S,
            E,
            k,
            A,
            T,
            M,
            O,
            F = this,
            I = F.linkedItems.chart,
            L = e || I.getFromEnv("chart-attrib"),
            N = I.getName && I.getName(),
            D = I.config,
            P = F.csConf;

        if (D || (D = I), F.csConf = P, F.useScaleRecursively = D.useScaleRecursively, (0, o.getValidValue)(L.numberscaleunit) && (t = L.numberscaleunit.split(",")), (n = (0, o.getValidValue)(L.snumberscaleunit, L.numberscaleunit)) && (n = n.split(",")), (r = (0, o.getValidValue)(L.xnumberscaleunit, L.numberscaleunit)) && (r = r.split(",")), (i = (0, o.getValidValue)(L.ticknumberscaleunit, L.numberscaleunit)) && (i = i.split(",")), (a = (0, o.getValidValue)(L.ynumberscaleunit, L.numberscaleunit)) && (a = a.split(",")), (0, o.getValidValue)(L.numberscalevalue) && (s = L.numberscalevalue.split(",")), (f = (0, o.getValidValue)(L.snumberscalevalue, L.numberscalevalue)) && (f = f.split(",")), (l = (0, o.getValidValue)(L.xnumberscalevalue, L.numberscalevalue)) && (l = l.split(",")), (c = (0, o.getValidValue)(L.ticknumberscalevalue, L.numberscalevalue)) && (c = c.split(",")), (u = (0, o.getValidValue)(L.ynumberscalevalue, L.numberscalevalue)) && (u = u.split(",")), (0, o.getValidValue)(L.thousandseparatorposition)) for (b = (d = L.thousandseparatorposition.split(",")).length, w = h.thousandseparatorposition[0]; b--;) {
          (x = parseInt(d[b], 10)) <= 0 && (x = w), w = d[b] = x;
        }
        C = (0, o.pluckNumber)(L.scalerecursively, 0), _ = (0, o.pluckNumber)(L.sscalerecursively, C), S = (0, o.pluckNumber)(L.xscalerecursively, C), E = (0, o.pluckNumber)(L.maxscalerecursion, -1), k = (0, o.pluckNumber)(L.smaxscalerecursion, E), A = (0, o.pluckNumber)(L.xmaxscalerecursion, E), T = (0, o.getValidValue)(L.scaleseparator, " "), M = (0, o.getValidValue)(L.sscaleseparator, T), O = (0, o.getValidValue)(L.xscaleseparator, T), E || (E = -1), F.baseConf = y = {
          cacheStore: [],
          formatnumber: (0, o.pluck)(L.formatnumber, P.formatnumber),
          formatnumberscale: (0, o.pluck)(L.formatnumberscale, D.formatnumberscale, P.formatnumberscale),
          forcenumberscale: (0, o.pluck)(L.forcenumberscale, P.forcenumberscale),
          defaultnumberscale: (0, o.getFirstValue)(L.defaultnumberscale, P.defaultnumberscale),
          numberscaleunit: (0, o.pluck)(t, P.numberscaleunit).concat(),
          numberscalevalue: (0, o.pluck)(s, P.numberscalevalue).concat(),
          numberprefix: (0, o.getFirstValue)(L.numberprefix, P.numberprefix),
          numbersuffix: (0, o.getFirstValue)(L.numbersuffix, P.numbersuffix),
          decimalprecision: parseInt("auto" === L.decimals ? P.decimalprecision : (0, o.pluck)(L.decimals, L.decimalprecision, D.decimals, P.decimals, D.decimalprecision, P.decimalprecision), 10),
          forcedecimals: (0, o.pluck)(L.forcedecimals, P.forcedecimals),
          decimalseparator: (0, o.pluck)(L.decimalseparator, P.decimalseparator),
          thousandseparator: (0, o.pluck)(L.thousandseparator, P.thousandseparator),
          thousandseparatorposition: (0, o.pluck)(d, P.thousandseparatorposition),
          indecimalseparator: (0, o.getFirstValue)(L.indecimalseparator, P.indecimalseparator),
          inthousandseparator: (0, o.getFirstValue)(L.inthousandseparator, P.inthousandseparator),
          scalerecursively: C,
          maxscalerecursion: E,
          scaleseparator: T
        }, (0, o.getValidValue)(y.inthousandseparator) && (F.baseConf._REGinthousandseparator = new RegExp((0, o.regescape)(y.inthousandseparator), "g")), (0, o.getValidValue)(y.indecimalseparator) && (F.baseConf._REGindecimalseparator = new RegExp((0, o.regescape)(y.indecimalseparator))), F.Y = [], p = {
          cacheStore: [],
          formatnumber: y.formatnumber,
          formatnumberscale: y.formatnumberscale,
          forcenumberscale: y.forcenumberscale,
          defaultnumberscale: y.defaultnumberscale,
          numberscaleunit: y.numberscaleunit.concat(),
          numberscalevalue: y.numberscalevalue.concat(),
          numberprefix: y.numberprefix,
          numbersuffix: y.numbersuffix,
          decimalprecision: y.decimalprecision,
          forcedecimals: y.forcedecimals,
          decimalseparator: y.decimalseparator,
          thousandseparator: y.thousandseparator,
          thousandseparatorposition: y.thousandseparatorposition,
          indecimalseparator: y.indecimalseparator,
          inthousandseparator: y.inthousandseparator,
          scalerecursively: C,
          maxscalerecursion: E,
          scaleseparator: T
        }, D.useScaleRecursively && (p.numberscalevalue && p.numberscalevalue.length) == (p.numberscaleunit && p.numberscaleunit.length) || (p.scalerecursively = C = 0), m = {
          cacheStore: [],
          formatnumber: p.formatnumber,
          formatnumberscale: p.formatnumberscale,
          forcenumberscale: p.forcenumberscale,
          defaultnumberscale: p.defaultnumberscale,
          numberscaleunit: p.numberscaleunit.concat(),
          numberscalevalue: p.numberscalevalue.concat(),
          numberprefix: p.numberprefix,
          numbersuffix: p.numbersuffix,
          decimalprecision: parseInt((0, o.pluck)(L.yaxisvaluedecimals, p.decimalprecision, 2), 10),
          forcedecimals: (0, o.pluck)(L.forceyaxisvaluedecimals, p.forcedecimals),
          decimalseparator: p.decimalseparator,
          thousandseparator: p.thousandseparator,
          thousandseparatorposition: p.thousandseparatorposition.concat(),
          indecimalseparator: p.indecimalseparator,
          inthousandseparator: p.inthousandseparator,
          scalerecursively: C,
          maxscalerecursion: E,
          scaleseparator: T
        }, v = {
          cacheStore: [],
          formatnumber: (0, o.pluck)(L.sformatnumber, h.sformatnumber),
          formatnumberscale: (0, o.pluck)(L.sformatnumberscale, h.sformatnumberscale),
          forcenumberscale: (0, o.pluck)(L.sforcenumberscale, h.sforcenumberscale),
          defaultnumberscale: (0, o.getFirstValue)(L.sdefaultnumberscale, p.defaultnumberscale),
          numberscaleunit: (0, o.pluck)(n, h.snumberscaleunit).concat(),
          numberscalevalue: (0, o.pluck)(f, h.snumberscalevalue).concat(),
          numberprefix: (0, o.getFirstValue)(L.snumberprefix, h.snumberprefix),
          numbersuffix: (0, o.getFirstValue)(L.snumbersuffix, h.snumbersuffix),
          decimalprecision: parseInt((0, o.pluck)(L.syaxisvaluedecimals, L.sdecimals, L.decimals, h.sdecimals), 10),
          forcedecimals: (0, o.pluck)(L.forcesyaxisvaluedecimals, L.sforcedecimals, L.forcedecimals, h.sforcedecimals),
          decimalseparator: (0, o.pluck)(L.decimalseparator, h.decimalseparator),
          thousandseparator: (0, o.pluck)(L.thousandseparator, h.thousandseparator),
          thousandseparatorposition: p.thousandseparatorposition.concat(),
          indecimalseparator: (0, o.pluck)(L.indecimalseparator, h.indecimalseparator),
          inthousandseparator: (0, o.pluck)(L.inthousandseparator, h.inthousandseparator),
          scalerecursively: _,
          maxscalerecursion: k,
          scaleseparator: M
        }, (g = (0, o.extend2)({}, v)).decimalprecision = parseInt((0, o.pluck)(L.sdecimals, L.decimals, L.syaxisvaluedecimals, h.sdecimals), 10), g.forcedecimals = (0, o.pluck)(L.sforcedecimals, L.forcedecimals, L.forcesyaxisvaluedecimals, h.sforcedecimals), g.cacheStore = [], D.useScaleRecursively && (v.numberscalevalue && v.numberscalevalue.length) == (v.numberscaleunit && v.numberscaleunit.length) || (v.scalerecursively = _ = 0), /^(bubble|scatter|selectscatter|zoomscatter)$/gi.test(N) && (m.formatnumber = (0, o.pluck)(L.yformatnumber, m.formatnumber), m.formatnumberscale = (0, o.pluck)(L.yformatnumberscale, m.formatnumberscale), m.forcenumberscale = (0, o.pluck)(L.yforcenumberscale, m.forcenumberscale), m.defaultnumberscale = (0, o.getFirstValue)(L.ydefaultnumberscale, m.defaultnumberscale), m.numberscaleunit = (0, o.pluck)(a, m.numberscaleunit), m.numberscalevalue = (0, o.pluck)(u, m.numberscalevalue), m.numberprefix = (0, o.pluck)(L.ynumberprefix, m.numberprefix), m.numbersuffix = (0, o.pluck)(L.ynumbersuffix, m.numbersuffix), p.formatnumber = (0, o.pluck)(L.yformatnumber, p.formatnumber), p.formatnumberscale = (0, o.pluck)(L.yformatnumberscale, p.formatnumberscale), p.forcenumberscale = (0, o.pluck)(L.yforcenumberscale, p.forcenumberscale), p.defaultnumberscale = (0, o.getFirstValue)(L.ydefaultnumberscale, p.defaultnumberscale), p.numberscaleunit = (0, o.pluck)(L.ynumberscaleunit, p.numberscaleunit.concat()), p.numberscalevalue = (0, o.pluck)(L.ynumberscalevalue, p.numberscalevalue.concat()), p.numberprefix = (0, o.pluck)(L.ynumberprefix, p.numberprefix), p.numbersuffix = (0, o.pluck)(L.ynumbersuffix, p.numbersuffix)), /^(pie2d|pie3d|doughnut2d|doughnut3d|marimekko|pareto2d|pareto3d)$/.test(N) && (p.decimalprecision = (0, o.pluck)(L.decimals, "2")), C && (p.numberscalevalue.push(1), p.numberscaleunit.unshift(p.defaultnumberscale), m.numberscalevalue.push(1), m.numberscaleunit.unshift(m.defaultnumberscale)), _ && (v.numberscalevalue.push(1), v.numberscaleunit.unshift(v.defaultnumberscale), g.numberscalevalue.push(1), g.numberscaleunit.unshift(g.defaultnumberscale)), F.Y[0] = {
          yAxisLabelConf: m,
          dataLabelConf: p
        }, F.Y[1] = {
          yAxisLabelConf: v,
          dataLabelConf: g
        }, F.paramLabels = p, F.param1 = m, F.param2 = v, F.paramLabels2 = g, F.paramX = {
          cacheStore: [],
          formatnumber: (0, o.pluck)(L.xformatnumber, y.formatnumber),
          formatnumberscale: (0, o.pluck)(L.xformatnumberscale, y.formatnumberscale),
          forcenumberscale: (0, o.pluck)(L.xforcenumberscale, y.forcenumberscale),
          defaultnumberscale: (0, o.getFirstValue)(L.xdefaultnumberscale, y.defaultnumberscale),
          numberscaleunit: (0, o.pluck)(r, y.numberscaleunit.concat()),
          numberscalevalue: (0, o.pluck)(l, y.numberscalevalue.concat()),
          numberprefix: (0, o.pluck)(L.xnumberprefix, y.numberprefix),
          numbersuffix: (0, o.pluck)(L.xnumbersuffix, y.numbersuffix),
          decimalprecision: parseInt((0, o.pluck)(L.xaxisvaluedecimals, L.xaxisvaluesdecimals, y.decimalprecision, 2), 10),
          forcedecimals: (0, o.pluck)(L.forcexaxisvaluedecimals, 0),
          decimalseparator: y.decimalseparator,
          thousandseparator: y.thousandseparator,
          thousandseparatorposition: y.thousandseparatorposition.concat(),
          indecimalseparator: y.indecimalseparator,
          inthousandseparator: y.inthousandseparator,
          scalerecursively: S,
          maxscalerecursion: A,
          scaleseparator: O
        }, F.paramLegend = (0, o.extend2)((0, o.extend2)({}, y), {
          cacheStore: [],
          decimalprecision: parseInt((0, o.pluckNumber)(L.legendvaluedecimals, y.decimalprecision, 2), 10),
          forcedecimals: (0, o.pluckNumber)(L.legendvalueforcedecimals, y.forcedecimals, 0),
          formatnumberscale: (0, o.pluck)(L.legendvalueformatnumberscale, y.formatnumberscale),
          forcenumberscale: (0, o.pluck)(L.legendvalueforcenumberscale, y.forcenumberscale),
          formatnumber: (0, o.pluck)(L.legendvalueformatnumber, y.formatnumber)
        }), C && (F.paramLegend.numberscalevalue.push(1), F.paramLegend.numberscaleunit.unshift(F.paramLegend.defaultnumberscale)), D.useScaleRecursively && (F.paramX.numberscalevalue && F.paramX.numberscalevalue.length) == (F.paramX.numberscaleunit && F.paramX.numberscaleunit.length) || (F.paramX.scalerecursively = S = 0), S && (F.paramX.numberscalevalue.push(1), F.paramX.numberscaleunit.unshift(F.paramX.defaultnumberscale)), F.paramScale = {
          cacheStore: [],
          formatnumber: (0, o.pluck)(L.tickformatnumber, y.formatnumber),
          formatnumberscale: (0, o.pluck)(L.tickformatnumberscale, y.formatnumberscale),
          forcenumberscale: (0, o.pluck)(L.tickforcenumberscale, y.forcenumberscale),
          defaultnumberscale: (0, o.getFirstValue)(L.tickdefaultnumberscale, y.defaultnumberscale),
          numberscaleunit: (0, o.pluck)(i, y.numberscaleunit.concat()),
          numberscalevalue: (0, o.pluck)(c, y.numberscalevalue.concat()),
          numberprefix: (0, o.pluck)(L.ticknumberprefix, y.numberprefix),
          numbersuffix: (0, o.pluck)(L.ticknumbersuffix, y.numbersuffix),
          decimalprecision: parseInt((0, o.pluck)(L.tickvaluedecimals, y.decimalprecision, "2"), 10),
          forcedecimals: (0, o.pluck)(L.forcetickvaluedecimals, y.forcedecimals, 0),
          decimalseparator: y.decimalseparator,
          thousandseparator: y.thousandseparator,
          thousandseparatorposition: y.thousandseparatorposition.concat(),
          indecimalseparator: y.indecimalseparator,
          inthousandseparator: y.inthousandseparator,
          scalerecursively: C,
          maxscalerecursion: E,
          scaleseparator: T
        }, C && (F.paramScale.numberscalevalue.push(1), F.paramScale.numberscaleunit.unshift(F.paramScale.defaultnumberscale)), F.timeConf = {
          inputDateFormat: (0, o.pluck)(L.inputdateformat, L.dateformat, "mm/dd/yyyy"),
          outputDateFormat: (0, o.pluck)(L.outputdateformat, L.inputdateformat, L.dateformat, "mm/dd/yyyy"),
          days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          daySuffix: ["", "st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "st"]
        }, F.cleaneValueCacheStore = {}, F.percentStrCacheStore = {};
      }, e.prototype.dispose = function () {
        var e = this;
        e.Y && delete e.Y, e.cleaneValueCacheStore && delete e.cleaneValueCacheStore, e.percentStrCacheStore && delete e.percentStrCacheStore, e.paramLabels && delete e.paramLabels, e.param1 && delete e.param1, e.param2 && delete e.param2, e.paramLabels2 && delete e.paramLabels2, e.csConf && delete e.csConf, e.chart && delete e.chart, e.baseConf && delete e.baseConf, e.timeConf && delete e.timeConf, e.paramX && delete e.paramX, e.paramScale && delete e.paramScale;
      }, e.prototype.parseMLAxisConf = function (e, t) {
        var n,
            r,
            a,
            s,
            l,
            c,
            u,
            d,
            f = this.baseConf,
            p = this.csConf,
            g = (0, o.pluckNumber)(e.scalerecursively, f.scalerecursively),
            m = (0, o.pluckNumber)(e.maxscalerecursion, f.maxscalerecursion),
            v = (0, o.getValidValue)(e.scaleseparator, f.scaleseparator);
        if (t = (0, o.pluckNumber)(t, this.Y.length), (0, o.getValidValue)(e.numberscaleunit) && (r = e.numberscaleunit.split(",")), (0, o.getValidValue)(e.numberscalevalue) && (a = e.numberscalevalue.split(",")), m || (m = -1), (0, o.getValidValue)(e.thousandseparatorposition)) for (c = (l = e.thousandseparatorposition.split(",")).length, d = h.thousandseparatorposition[0]; c--;) {
          (u = (0, o.pluckNumber)(i(l[c]))) ? d = u : u = d, l[c] = u;
        }
        n = {
          cacheStore: [],
          formatnumber: (0, o.pluck)(e.formatnumber, f.formatnumber),
          formatnumberscale: (0, o.pluck)(e.formatnumberscale, f.formatnumberscale),
          forcenumberscale: (0, o.pluck)(e.forcenumberscale, f.forcenumberscale),
          defaultnumberscale: (0, o.getFirstValue)(e.defaultnumberscale, f.defaultnumberscale),
          numberscaleunit: (0, o.pluck)(r, f.numberscaleunit).concat(),
          numberscalevalue: (0, o.pluck)(a, f.numberscalevalue).concat(),
          numberprefix: (0, o.getFirstValue)(e.numberprefix, f.numberprefix),
          numbersuffix: (0, o.getFirstValue)(e.numbersuffix, f.numbersuffix),
          forcedecimals: (0, o.pluck)(e.forcedecimals, f.forcedecimals),
          decimalprecision: parseInt("auto" === e.decimals ? p.decimalprecision : (0, o.pluck)(e.decimals, f.decimalprecision), 10),
          decimalseparator: (0, o.pluck)(e.decimalseparator, f.decimalseparator),
          thousandseparator: (0, o.pluck)(e.thousandseparator, f.thousandseparator),
          thousandseparatorposition: (0, o.pluck)(l, f.thousandseparatorposition),
          indecimalseparator: (0, o.getFirstValue)(e.indecimalseparator, f.indecimalseparator),
          inthousandseparator: (0, o.getFirstValue)(e.inthousandseparator, f.inthousandseparator),
          scalerecursively: g,
          maxscalerecursion: m,
          scaleseparator: v
        }, this.useScaleRecursively && (n.numberscalevalue && n.numberscalevalue.length) == (n.numberscaleunit && n.numberscaleunit.length) || (n.scalerecursively = g = 0), s = {
          cacheStore: [],
          formatnumber: n.formatnumber,
          formatnumberscale: n.formatnumberscale,
          forcenumberscale: n.forcenumberscale,
          defaultnumberscale: n.defaultnumberscale,
          numberscaleunit: n.numberscaleunit.concat(),
          numberscalevalue: n.numberscalevalue.concat(),
          numberprefix: n.numberprefix,
          numbersuffix: n.numbersuffix,
          decimalprecision: parseInt((0, o.pluck)(e.yaxisvaluedecimals, n.decimalprecision, 2), 10),
          forcedecimals: (0, o.pluck)(e.forceyaxisvaluedecimals, n.forcedecimals),
          decimalseparator: n.decimalseparator,
          thousandseparator: n.thousandseparator,
          thousandseparatorposition: n.thousandseparatorposition.concat(),
          indecimalseparator: n.indecimalseparator,
          inthousandseparator: n.inthousandseparator,
          scalerecursively: g,
          maxscalerecursion: m,
          scaleseparator: v
        }, g && (n.numberscalevalue.push(1), n.numberscaleunit.unshift(n.defaultnumberscale), s.numberscalevalue.push(1), s.numberscaleunit.unshift(s.defaultnumberscale)), this.Y[t] = {
          dataLabelConf: n,
          yAxisLabelConf: s
        };
      }, e.prototype.percentValue = function (e) {
        var t,
            n = this.percentStrCacheStore[e];
        return void 0 === n && (t = isNaN(this.paramLabels.decimalprecision) ? "2" : this.paramLabels.decimalprecision, n = this.percentStrCacheStore[e] = f(d(e, t, this.paramLabels.forcedecimals), this.paramLabels.decimalseparator, this.paramLabels.thousandseparator, this.paramLabels.thousandseparatorposition) + "%"), n;
      }, e.prototype.yAxisPercentValue = function (e, t) {
        window.th = this;
        var n,
            r,
            o = this.Y[t] || (t ? this.Y[1] : this.Y[0]);
        return void 0 === (n = (o = o && o.yAxisLabelConf || this.baseConf).cacheStore[e]) && (r = isNaN(o.decimalprecision) ? "2" : o.decimalprecision, n = o.cacheStore[e] = f(d(e, r, o.forcedecimals), o.decimalseparator, o.thousandseparator, o.thousandseparatorposition) + "%"), n;
      }, e.prototype.getCleanValue = function (e, t) {
        var n,
            r = this.cleaneValueCacheStore[e];
        return (void 0 === r || t) && (n = u(e, this.baseConf), this.cleaneValueCacheStore[e] = r = isNaN(n) ? null : t ? i(n) : n), r;
      }, e.prototype.dataLabels = function (e, t) {
        var n,
            r = this.Y[t] || (t ? this.Y[1] : this.Y[0]);
        return void 0 === (n = (r = r && r.dataLabelConf || this.baseConf).cacheStore[e]) && (n = r.cacheStore[e] = l(e, r)), n;
      }, e.prototype.formatValue = function (e) {
        var t,
            n = this.baseConf;
        return void 0 === (t = n.cacheStore[e]) && (t = n.cacheStore[e] = l(e, n)), t;
      }, e.prototype.yAxis = function (e, t) {
        var n,
            r = this.Y[t] || (t ? this.Y[1] : this.Y[0]);
        return void 0 === (n = (r = r && r.yAxisLabelConf || this.baseConf).cacheStore[e]) && (n = r.cacheStore[e] = l(e, r, !0)), n;
      }, e.prototype.xAxis = function (e) {
        var t = this.paramX.cacheStore[e];
        return void 0 === t && (t = this.paramX.cacheStore[e] = l(e, this.paramX, !0)), t;
      }, e.prototype.sYAxis = function (e) {
        var t,
            n = this.Y[1];
        return void 0 === (t = (n = n && n.yAxisLabelConf || this.baseConf).cacheStore[e]) && (t = n.cacheStore[e] = l(e, n)), t;
      }, e.prototype.scale = function (e) {
        var t = this.paramScale.cacheStore[e];
        return void 0 === t && (t = this.paramScale.cacheStore[e] = l(e, this.paramScale)), t;
      }, e.prototype.legendValue = function (e) {
        var t = this.paramLegend.cacheStore[e];
        return void 0 === t && (t = this.paramLegend.cacheStore[e] = l(e, this.paramLegend)), t;
      }, e.prototype.legendPercentValue = function (e) {
        var t,
            n = this.percentStrCacheStore[e],
            r = this.paramLegend;
        return void 0 === n && (t = isNaN(r.decimalprecision) ? "2" : r.decimalprecision, n = this.percentStrCacheStore[e] = f(d(e, t, r.forcedecimals), r.decimalseparator, r.thousandseparator, r.thousandseparatorposition) + "%"), n;
      }, e.prototype.getDateValue = function (e) {
        var t, n, r, i, a;
        return e && !/\//.test(this.timeConf.inputDateFormat) && (e = e.replace(new RegExp(this.timeConf.inputDateFormat.replace(/[a-z]/gi, "").slice(0, 1), "g"), "/")), e = /^dd/.test(this.timeConf.inputDateFormat) && e && e.replace(/(\d{1,2})\/(\d{1,2})\/(\d{2,4})/, "$2/$1/$3") || e, !(a = (t = new Date(e)).getTime()) && e && /\:/.test(e) && (e = e.split(":"), n = (0, o.pluckNumber)(e[0], 0), r = (0, o.pluckNumber)(e[1], 0), i = (0, o.pluckNumber)(e[2], 0), n = n > 23 ? 24 === n && 0 === r && 0 === i ? n : 23 : n, r = r > 59 ? 59 : r, i = i > 59 ? 59 : i, (t = new Date()).setHours(n), t.setMinutes(r), t.setSeconds(i), a = t.getTime()), {
          ms: a,
          date: t
        };
      }, e.prototype.getFormattedDate = function (e, t) {
        var n = "object" === (void 0 === e ? "undefined" : r(e)) && e || new Date(e),
            i = this.timeConf,
            a = (0, o.pluck)(t, i.outputDateFormat),
            s = n.getFullYear(),
            l = n.getMonth(),
            c = n.getDate(),
            u = n.getDay(),
            d = n.getMinutes(),
            f = n.getSeconds(),
            h = n.getHours();
        return d = d > 9 ? "" + d : "0" + d, f = f > 9 ? "" + f : "0" + f, h = h > 9 ? "" + h : "0" + h, a.match(/dnl/) && (a = a.replace(/dnl/gi, i.days[u])), a.match(/dns/) && (a = a.replace(/dns/gi, i.days[u] && i.days[u].substr(0, 3))), a.match(/dd/) && (a = a.replace(/dd/gi, c)), a.match(/mnl/) && (a = a.replace(/mnl/gi, i.months[l])), a.match(/mns/) && (a = a.replace(/mns/gi, i.months[l] && i.months[l].substr(0, 3))), a.match(/mm/) && (a = a.replace(/mm/gi, l + 1)), a.match(/yyyy/) && (a = a.replace(/yyyy/gi, s)), a.match(/yy/) && (a = a.replace(/yy/gi, (s % 1e3 % 100 + "").replace(/^(\d)$/, "0$1"))), a.match(/hh12/) && (a = a.replace(/hh12/gi, h % 12 || 12)), a.match(/hh/) && (a = a.replace(/hh/gi, h)), a.match(/mn/) && (a = a.replace(/mn/gi, d)), a.match(/ss/) && (a = a.replace(/ss/gi, f)), a.match(/ampm/) && (a = a.replace(/ampm/gi, h < 12 ? "AM" : "PM")), a.match(/ds/) && (a = a.replace(/ds/gi, i.daySuffix[c])), a;
      }, e;
    }();

    l = function l(e, t, n) {
      var r, i, a, s, l, u, h, p, g, m, v;

      if (null !== e) {
        if (r = (e = Number(e)) + "", i = 1 == t.formatnumberscale ? t.defaultnumberscale : "", m = (g = r.split(".")[1]) ? g.length : t.forcedecimals ? "2" : "", 1 == t.formatnumberscale && (r = (v = c(e, t.defaultnumberscale, t.numberscalevalue, t.numberscaleunit, t.scalerecursively, t.forcenumberscale)).value, e = v.value, i = v.scale), t.scalerecursively && 0 !== t.formatnumberscale && "0" !== t.formatnumberscale) {
          if (a = v.value, s = v.scale, l = -1 == t.maxscalerecursion ? a.length : Math.min(a.length, t.maxscalerecursion), 1 == t.formatnumber) for (r = "", p = 0; p < l; p++) {
            h = (u = 0 === p ? a[p] : Math.abs(a[p])) + "", p == l - 1 && (h = d(u, (0, o.pluck)(t.decimalprecision, m), t.forcedecimals)), r = r + f(h, t.decimalseparator, t.thousandseparator, t.thousandseparatorposition) + s[p] + (p < l - 1 ? t.scaleseparator : "");
          } else for (r = "", p = 0; p < l; p++) {
            r = r + (0 === p ? a[p] : Math.abs(a[p]) + "") + s[p] + (p < l - 1 ? t.scaleseparator : "");
          }
          r = (t.numberprefix || "") + r + (t.numbersuffix || "");
        } else 1 == t.formatnumber && (r = d(e, (0, o.pluck)(t.decimalprecision, m), t.forcedecimals), r = f(r, t.decimalseparator, t.thousandseparator, t.thousandseparatorposition, n)), r = (t.numberprefix || "") + r + i + (t.numbersuffix || "");

        return r;
      }
    }, c = function c(e, t, n, r, i, a) {
      var s,
          l,
          c,
          u,
          d = {},
          f = t,
          h = 0,
          p = [],
          g = [];

      if (a = (0, o.pluckNumber)(a) || 0, i) {
        for (s = (0, o.pluckNumber)(n[0]) || 1e3, h = 0; h < n.length; h++) {
          if (c = (0, o.pluckNumber)(n[h]) || 1e3, !(Math.abs(Number(e)) >= c && h < n.length - 1)) {
            0 === h && "" === t && a ? (e = Number(e) / s, p.push(e), g.push(r[1] || "")) : (1 === h && "" === t && a ? (l = e + (p.length ? p.pop() : 0), g.pop(), p.push(l)) : p.push(e), g.push(r[h]));
            break;
          }

          e = (e - (u = e % c)) / c, 0 === h && 0 !== u && "" === r[h] && a ? (p.push(u / s), g.push(r[1] || "")) : 0 !== u && (1 === h && "" === t && a ? (l = u + (p.length ? p.pop() : 0), g.pop(), p.push(l)) : p.push(u), g.push(r[h]));
        }

        p.reverse(), g.reverse(), d.value = p, d.scale = g;
      } else {
        if (n.length === r.length) for (h = 0; h < n.length; h++) {
          if (!((c = (0, o.pluckNumber)(n[h]) || 1e3) && Math.abs(Number(e)) >= c)) {
            0 === h && "" === t && a && (f = r[0] || "", e = Number(e) / c);
            break;
          }

          f = r[h] || "", e = Number(e) / c;
        }
        d.value = e, d.scale = f;
      }

      return d;
    }, d = function d(e, t, n) {
      var r, o, i, l;
      if (t <= 0) return s(e) + "";
      if (isNaN(t)) return (e += "").length > 12 && -1 != e.indexOf(".") && (t = 12 - e.split(".")[0].length, r = a(10, t), e = o = s(e * r) / r + ""), e;
      if (r = a(10, t), o = s(e * r) / r + "", 1 == n) for (-1 == o.indexOf(".") && (o += ".0"), i = t - o.split(".")[1].length, l = 1; l <= i; l++) {
        o += "0";
      }
      return o;
    }, f = function f(e, t, n, r, o) {
      var i,
          a,
          s,
          l,
          c = Number(e),
          u = "",
          d = !1,
          f = "",
          h = "",
          p = 0,
          g = 0;
      if (isNaN(c)) return "";
      if (c > 1e15) return i = o ? 1 : 14, c.toExponential(i);
      if (p = 0, g = e.length, -1 != e.indexOf(".") && (u = e.substring(e.indexOf(".") + 1, e.length), g = e.indexOf(".")), c < 0 && (d = !0, p = 1), (a = (f = e.substring(p, g)).length) < (l = r[s = r.length - 1])) h = f;else for (; a >= l;) {
        h = (a - l ? n : "") + f.substr(a - l, l) + h, (a -= l) < (l = (s -= 1) <= 0 ? r[0] : r[s]) && (h = f.substring(a, 0) + h);
      }
      return "" != u && (h = h + t + u), !0 === d && (h = "-" + h), h;
    }, u = function u(e, t) {
      return e += "", t._REGinthousandseparator && (e = e.replace(t._REGinthousandseparator, "")), t._REGindecimalseparator && (e = e.replace(t._REGindecimalseparator, ".")), e = parseFloat(e), isFinite(e) ? e : NaN;
    }, t["default"] = g;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(149),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    };
    i["default"].stopPartialEventPropagation = !0, i["default"]._stopabsolutePath = !0, t["default"] = {
      extension: i["default"],
      name: "redraphael",
      type: "plugin"
    };
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      t.__esModule = !0;
      var r,
          o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      },
          i = l(n(150)),
          a = n(128),
          s = l(a);

      function l(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      var c = "undefined" != typeof window ? window : void 0 !== e ? e : null;

      function u(e) {
        var t, n, r;
        return u._url === undefined && (u._url = g), u.is(e, k) ? d ? e() : i["default"].on("raphael.DOMload", e) : u.is(e, C) ? u._engine.create[y](u, e.splice(0, 3 + u.is(e[0], x))).add(e) : (n = (0, a.getArrayCopy)(arguments), t = Array.prototype.slice.call(n, 0), u.is(t[t.length - 1], k) ? (r = t.pop(), d ? r.call(u._engine.create[y](u, t)) : i["default"].on("raphael.DOMload", function () {
          r.call(u._engine.create[y](u, t));
        })) : u._engine.create[y](u, arguments));
      }

      u.upgrade = "1.0.0", u.version = "2.1.0", u.eve = i["default"];

      var d,
          f,
          h,
          p,
          g = "",
          m = " ",
          v = "hasOwnProperty",
          y = "apply",
          b = "concat",
          x = "number",
          w = "string",
          C = "array",
          _ = "object",
          S = "split",
          E = "none",
          k = "function",
          A = /R/i,
          T = /trident/i.test(c.navigator.userAgent),
          M = {
        a: 7,
        c: 6,
        h: 1,
        l: 2,
        m: 2,
        r: 4,
        q: 4,
        s: 4,
        t: 2,
        v: 1,
        z: 0
      },
          O = Array.prototype.splice,
          F = function () {}.hasOwnProperty("prototype"),
          I = {
        doc: c.document,
        win: c
      },
          L = I.doc,
          N = I.win,
          D = u.safePointerEventMapping = {
        mouseover: "pointerover",
        mousedown: "pointerdown",
        mousemove: "pointermove",
        mouseup: "pointerup",
        mouseout: "pointerout"
      },
          P = N.navigator,
          R = u.supportsTouch = "ontouchstart" in L || P.maxTouchPoints || P.msMaxTouchPoints,
          j = u.supportsPointer = "onpointerover" in L,
          V = u.isEdge = /Edge/.test(P.userAgent),
          B = u.isIE11 = /trident/i.test(P.userAgent) && /rv:11/i.test(P.userAgent) && !N.opera,
          H = u.isFirefox = /Firefox/.test(P.userAgent),
          G = u.isWindows = /Windows/.test(P.userAgent),
          z = "m",
          U = "M",
          $ = "L",
          X = [],
          W = /[a-z]/i,
          Y = function Y(e, t, n) {
        var r = t.toLowerCase(),
            o = [],
            i = 0;
        if (X.length = 0, n.replace(ke, function (e, t) {
          t && X.push(+t);
        }), "r" === r) f.push([t][b](X));else if ("z" === r) f.push([t]);else if (X.length >= M[r]) {
          for (; i < X.length;) {
            i % M[r] ? o.push(X[i]) : (o.length && f.push(o) && (o = []), o.push(t, X[i])), i++;
          }

          f.push(o);
        }
      },
          q = function q() {},
          K = (u.ca = u.customAttributes = q.prototype, function () {
        this.ca = this.customAttributes = new q(), this._CustomAttributes = function () {}, this._CustomAttributes.prototype = this.ca, this._elementsById = {}, this.id = u._oid++, (0, i["default"])("raphael.new", this);
      }),
          J = u.fn = K.prototype = u.prototype,
          Z = "click dblclick mousedown mousemove mouseout mouseover mouseup touchstart touchmove touchend touchcancel dragstart dragmove dragend"[S](m),
          Q = {
        dragstart: "touchstart",
        dragmove: "touchmove",
        dragend: "touchend"
      },
          ee = String,
          te = N.parseFloat,
          ne = N.parseInt,
          re = Math,
          oe = re.max,
          ie = re.min,
          ae = re.abs,
          se = re.pow,
          le = re.cos,
          ce = re.sin,
          ue = re.sqrt,
          de = re.round,
          fe = re.PI,
          he = fe / 180,
          pe = 180 / fe,
          ge = ee.prototype.toLowerCase,
          me = ee.prototype.toUpperCase,
          ve = Object.prototype.toString,
          ye = /[, ]+/,
          be = /\{(\d+)\}/g,
          xe = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\))\s*$/i,
          we = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,
          Ce = /[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/,
          _e = /,?([achlmqrstvxz]),?/gi,
          Se = /([achlmrqstvz])[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*)+)/gi,
          Ee = /([rstm])[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*)+)/gi,
          ke = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/gi,
          Ae = {
        NaN: 1,
        Infinity: 1,
        "-Infinity": 1
      },
          Te = {
        hs: 1,
        rg: 1
      },
          Me = u._availableAttrs = ((r = {
        "arrow-end": E,
        "arrow-start": E,
        blur: 0,
        "clip-rect": "0 0 1e9 1e9",
        "clip-path": g,
        cursor: "default",
        cx: 0,
        cy: 0,
        fill: "#fff",
        "fill-opacity": 1,
        font: '10px "Arial"',
        "font-family": '"Arial"',
        "font-size": "10",
        "font-style": "normal",
        "font-weight": 400,
        gradient: 0,
        height: 0,
        href: "about:blank",
        "letter-spacing": 0,
        "line-height": 12,
        "vertical-align": "middle",
        opacity: 1,
        path: "M0,0",
        r: 0,
        rx: 0,
        ry: 0,
        src: g,
        stroke: "#000",
        "stroke-dasharray": g,
        "stroke-linecap": "butt",
        "stroke-linejoin": "butt",
        "stroke-miterlimit": 0,
        "stroke-opacity": 1,
        "stroke-width": 1,
        target: "_blank",
        "text-anchor": "middle",
        visibility: g,
        title: g,
        transform: g,
        rotation: 0,
        width: 0,
        x: 0,
        y: 0,
        "shape-rendering": "auto",
        alpha: x,
        "font-stretch": "normal",
        "alignment-baseline": "auto",
        "baseline-shift": "auto",
        "clip-rule": "nonzero",
        direction: "ltr",
        "dominant-baseline": "auto",
        "fill-rule": "nonzero",
        filter: E,
        "flood-color": "#000",
        "flood-opacity": 1,
        "font-size-adjust": E
      })["font-stretch"] = "normal", r["font-variant"] = "normal", r.kerning = "auto", r["lighting-color"] = "white", r["marker-end"] = E, r["marker-mid"] = E, r["marker-start"] = E, r.mask = E, r["pointer-events"] = "visiblePainted", r["stop-color"] = "#000", r["stop-opacity"] = 1, r["stroke-dashoffset"] = 0, r["text-decoration"] = E, r["vector-effect"] = g, r.visibility = "visible", r["word-spacing"] = "normal", r["writing-mode"] = "lr-tb", r),
          Oe = u._availableAnimAttrs = {
        blur: x,
        "clip-rect": "csv",
        "clip-path": "path",
        cx: x,
        cy: x,
        fill: "colour",
        "fill-opacity": x,
        "font-size": x,
        height: x,
        opacity: x,
        path: "path",
        r: x,
        rx: x,
        ry: x,
        stroke: "colour",
        "stroke-opacity": x,
        "stroke-width": x,
        transform: "transform",
        width: x,
        x: x,
        y: x,
        color: "colour",
        borderColor: "colour",
        borderWidth: x,
        alpha: x,
        "text-bound": "text-bound"
      },
          Fe = {},
          Ie = function Ie(e, t) {
        return te(e) - te(t);
      },
          Le = function Le(e) {
        return e;
      },
          Ne = u._rectPath = function (e, t, n, r, o) {
        return o ? [[U, e + o, t], ["l", n - 2 * o, 0], ["a", o, o, 0, 0, 1, o, o], ["l", 0, r - 2 * o], ["a", o, o, 0, 0, 1, -o, o], ["l", 2 * o - n, 0], ["a", o, o, 0, 0, 1, -o, -o], ["l", 0, 2 * o - r], ["a", o, o, 0, 0, 1, o, -o], ["z"]] : [[U, e, t], ["l", n, 0], ["l", 0, r], ["l", -n, 0], ["z"]];
      },
          De = function De(e, t, n, r) {
        return null == r && (r = n), [[U, e, t], [z, 0, -r], ["a", n, r, 0, 1, 1, 0, 2 * r], ["a", n, r, 0, 1, 1, 0, -2 * r], ["z"]];
      },
          Pe = u._getPath = {
        group: function group() {
          return !1;
        },
        path: function path(e) {
          return e.attr("path");
        },
        circle: function circle(e) {
          var t = e.attrs;
          return De(t.cx, t.cy, t.r);
        },
        ellipse: function ellipse(e) {
          var t = e.attrs;
          return De(t.cx, t.cy, t.rx, t.ry);
        },
        rect: function rect(e) {
          var t = e.attrs;
          return Ne(t.x, t.y, t.width, t.height, t.r);
        },
        image: function image(e) {
          var t = e.attrs;
          return Ne(t.x, t.y, t.width, t.height);
        },
        text: function text(e) {
          var t = e._getBBox();

          return Ne(t.x, t.y, t.width, t.height);
        }
      },
          Re = u.mapPath = function (e, t) {
        if (!t) return e;
        var n, r, o, i, a, s, l;

        for (o = 0, a = (e = lt(e).slice(0)).length; o < a; o++) {
          for (i = 1, s = (l = e[o] = e[o].slice(0)).length; i < s; i += 2) {
            n = t.x(l[i], l[i + 1]), r = t.y(l[i], l[i + 1]), l[i] = n, l[i + 1] = r;
          }
        }

        return e;
      },
          je = u._lastArgIfGroup = function (e, t) {
        var n = e.length - 1,
            r = e[n];
        if (r && r.constructor === u.el.constructor && "group" === r.type) return t && (e[n] = undefined, delete e[n], O.call(e, n, 1)), r;
      },
          Ve = u._serializeArgs = function (e) {
        var t,
            n,
            r,
            o,
            i = e[0];
        if (u.is(i, _) && !u.is(i, C) && "group" !== i.type) for (n = i, i.path && (t = i.path) && !u.is(t, w) && !u.is(t[0], C) && (t += g), r = 1, o = arguments.length; r < o; r += 2) {
          n[arguments[r]] || (n[arguments[r]] = arguments[r + 1]);
        } else for (n = {}, r = 1, o = arguments.length; r < o; r += 2) {
          n[arguments[r]] = e[(r - 1) / 2] || arguments[r + 1];
        }
        return n;
      },
          Be = u.is = function (e, t) {
        return "finite" === t ? !Ae[v](+e) : t === C ? e instanceof Array : (t !== _ || void 0 !== e && null !== e) && ("null" === t && null === e || t === (void 0 === e ? "undefined" : o(e)) && null !== e || t === _ && e === Object(e) || t === C && Array.isArray && Array.isArray(e) || ve.call(e).slice(8, -1).toLowerCase() === t);
      },
          He = u.clone = F ? function (e) {
        if (Object(e) !== e) return e;
        if (e instanceof Function) return e;
        var t = new e.constructor();

        for (var n in e) {
          "prototype" !== n && e[v](n) && (t[n] = He(e[n]));
        }

        return t;
      } : function (e) {
        if (Object(e) !== e) return e;
        if (e instanceof Function) return e;
        var t = new e.constructor();

        for (var n in e) {
          e[v](n) && (t[n] = He(e[n]));
        }

        return t;
      },
          Ge = c.Node;

      function ze(e) {
        this._comparator = e, this._elements = [];
      }

      Ge && !Ge.prototype.contains && (Ge.prototype.contains = function (e) {
        for (; e = e.parentNode;) {
          if (e === this) return !0;
        }

        return !1;
      }), u._g = I, u.merge = a.merge, u.extend = s["default"], u.createUUID = (h = /[xy]/g, p = function p(e) {
        var t = 16 * re.random() | 0;
        return ("x" === e ? t : 3 & t | 8).toString(16);
      }, function () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(h, p).toUpperCase();
      }), u._radial_gradient = /^x?r(?:\(([^\)]*?)\))?/, u._ISURL = /^url\(['"]?([^\)]+?)['"]?\)$/i, u.getElementID = function (e) {
        return "rr-" + e;
      }, ze.prototype.isEmpty = function () {
        return 0 === this.size();
      }, ze.prototype.peek = function () {
        return this.isEmpty() ? null : this._elements[0];
      }, ze.prototype.deq = function () {
        var e = this.peek(),
            t = this._elements.pop(),
            n = this.size();

        if (0 === n) return e;
        this._elements[0] = t;

        for (var r = 0; r < n;) {
          var o = r,
              i = 2 * r + 1,
              a = 2 * r + 2;
          if (i < n && this._compare(i, o) >= 0 && (o = i), a < n && this._compare(a, o) >= 0 && (o = a), o === r) break;
          this._swap(o, r), r = o;
        }

        return e;
      }, ze.prototype.enq = function (e) {
        for (var t = this._elements.push(e), n = t - 1; n > 0;) {
          var r = Math.floor((n - 1) / 2);
          if (this._compare(n, r) <= 0) break;
          this._swap(r, n), n = r;
        }

        return t;
      }, ze.prototype.size = function () {
        return this._elements.length;
      }, ze.prototype._compare = function (e, t) {
        return this._comparator(this._elements[e], this._elements[t]);
      }, ze.prototype._swap = function (e, t) {
        var n = this._elements[e];
        this._elements[e] = this._elements[t], this._elements[t] = n;
      }, u.type = N.ENABLE_RED_CANVAS && (N.CanvasRenderingContext2D || L.createElement("canvas").getContext) ? "CANVAS" : N.SVGAngle || L.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1") ? "SVG" : "VML", u.svg = !((u.vml = "VML" === u.type) || (u.canvas = "CANVAS" === u.type)), u._Paper = K, u._id = 0, u._oid = 0, u.rad = function (e) {
        return e % 360 * he;
      }, u.deg = function (e) {
        return e * pe % 360;
      };

      var _Ue = function Ue(e) {
        if (u.vml) {
          var t,
              n = /^\s+|\s+$/g;

          try {
            var r = new ActiveXObject("htmlfile");
            r.write("<body>"), r.close(), t = r.body;
          } catch (s) {
            t = createPopup().document.body;
          }

          var o = t.createTextRange();
          _Ue = (0, a.cacher)(function (e) {
            try {
              t.style.color = ee(e).replace(n, g);
              var r = o.queryCommandValue("ForeColor");
              return "#" + ("000000" + (r = (255 & r) << 16 | 65280 & r | (16711680 & r) >>> 16).toString(16)).slice(-6);
            } catch (s) {
              return E;
            }
          });
        } else {
          var i = I.doc.createElement("i");
          i.title = "Raphaël Colour Picker", i.style.display = E, I.doc.body.appendChild(i), _Ue = (0, a.cacher)(function (e) {
            return i.style.color = e, I.doc.defaultView.getComputedStyle(i, g).getPropertyValue("color");
          });
        }

        return _Ue(e);
      },
          $e = function $e() {
        return "hsb(" + [this.h, this.s, this.b] + ")";
      },
          Xe = function Xe() {
        return "hsl(" + [this.h, this.s, this.l] + ")";
      },
          We = function We() {
        return this.hex;
      },
          Ye = function Ye(e, t, n) {
        if (null == t && Be(e, _) && "r" in e && "g" in e && "b" in e && (n = e.b, t = e.g, e = e.r), null == t && Be(e, w)) {
          var r = u.getRGB(e);
          e = r.r, t = r.g, n = r.b;
        }

        return (e > 1 || t > 1 || n > 1) && (e /= 255, t /= 255, n /= 255), [e, t, n];
      },
          qe = function qe(e, t, n, r) {
        var o = {
          r: e *= 255,
          g: t *= 255,
          b: n *= 255,
          hex: u.rgb(e, t, n),
          toString: We
        };
        return Be(r, "finite") && (o.opacity = r), o;
      };

      function Ke() {
        return this.hex;
      }

      function Je(e, t) {
        for (var n = [], r = 0, o = e.length; o - 2 * !t > r; r += 2) {
          var i = [{
            x: +e[r - 2],
            y: +e[r - 1]
          }, {
            x: +e[r],
            y: +e[r + 1]
          }, {
            x: +e[r + 2],
            y: +e[r + 3]
          }, {
            x: +e[r + 4],
            y: +e[r + 5]
          }];
          t ? r ? o - 4 === r ? i[3] = {
            x: +e[0],
            y: +e[1]
          } : o - 2 === r && (i[2] = {
            x: +e[0],
            y: +e[1]
          }, i[3] = {
            x: +e[2],
            y: +e[3]
          }) : i[0] = {
            x: +e[o - 2],
            y: +e[o - 1]
          } : o - 4 === r ? i[3] = i[2] : r || (i[0] = {
            x: +e[r],
            y: +e[r + 1]
          }), n.push(["C", (-i[0].x + 6 * i[1].x + i[2].x) / 6, (-i[0].y + 6 * i[1].y + i[2].y) / 6, (i[1].x + 6 * i[2].x - i[3].x) / 6, (i[1].y + 6 * i[2].y - i[3].y) / 6, i[2].x, i[2].y]);
        }

        return n;
      }

      u.color = function (e) {
        var t;
        return u.is(e, _) && "h" in e && "s" in e && "b" in e ? (t = u.hsb2rgb(e), e.r = t.r, e.g = t.g, e.b = t.b, e.hex = t.hex) : u.is(e, _) && "h" in e && "s" in e && "l" in e ? (t = u.hsl2rgb(e), e.r = t.r, e.g = t.g, e.b = t.b, e.hex = t.hex) : (u.is(e, w) && (e = u.getRGB(e)), u.is(e, _) && "r" in e && "g" in e && "b" in e ? (t = u.rgb2hsl(e), e.h = t.h, e.s = t.s, e.l = t.l, t = u.rgb2hsb(e), e.v = t.b) : (e = {
          hex: E
        }).r = e.g = e.b = e.h = e.s = e.v = e.l = -1), e.toString = We, e;
      }, u.hsb2rgb = function (e, t, n, r) {
        var o, i, a, s, l;
        return this.is(e, _) && "h" in e && "s" in e && "b" in e && (n = e.b, t = e.s, r = (e = e.h).o), s = (l = n * t) * (1 - ae((e = (e *= 360) % 360 / 60) % 2 - 1)), o = i = a = n - l, qe(o += [l, s, 0, 0, s, l][e = ~~e], i += [s, l, l, s, 0, 0][e], a += [0, 0, s, l, l, s][e], r);
      }, u.hsl2rgb = function (e, t, n, r) {
        var o, i, a, s, l;
        return this.is(e, _) && "h" in e && "s" in e && "l" in e && (n = e.l, t = e.s, e = e.h), (e > 1 || t > 1 || n > 1) && (e /= 360, t /= 100, n /= 100), e = (e *= 360) % 360 / 60, s = (l = 2 * t * (n < .5 ? n : 1 - n)) * (1 - ae(e % 2 - 1)), o = i = a = n - l / 2, qe(o += [l, s, 0, 0, s, l][e = ~~e], i += [s, l, l, s, 0, 0][e], a += [0, 0, s, l, l, s][e], r);
      }, u.rgb2hsb = function (e, t, n) {
        var r, o;
        return e = (n = Ye(e, t, n))[0], t = n[1], n = n[2], {
          h: ((0 === (o = (r = oe(e, t, n)) - ie(e, t, n)) ? null : r === e ? (t - n) / o : r === t ? (n - e) / o + 2 : (e - t) / o + 4) + 360) % 6 * 60 / 360,
          s: 0 === o ? 0 : o / r,
          b: r,
          toString: $e
        };
      }, u.rgb2hsl = function (e, t, n) {
        var r, o, i, a;
        return e = (n = Ye(e, t, n))[0], t = n[1], n = n[2], r = ((o = oe(e, t, n)) + (i = ie(e, t, n))) / 2, {
          h: ((0 === (a = o - i) ? null : o === e ? (t - n) / a : o === t ? (n - e) / a + 2 : (e - t) / a + 4) + 360) % 6 * 60 / 360,
          s: 0 === a ? 0 : r < .5 ? a / (2 * r) : a / (2 - 2 * r),
          l: r,
          toString: Xe
        };
      }, u._path2string = function () {
        return this.join(",").replace(_e, "$1");
      }, u._cacher = a.cacher, u.getRGB = (0, a.cacher)(function (e) {
        var t, n, r, o, i, a, s;
        return e && Be(e, _) && "opacity" in e && (t = e.opacity), !e || (e = ee(e)).indexOf("-") + 1 ? {
          r: -1,
          g: -1,
          b: -1,
          hex: E,
          error: 1,
          toString: Ke
        } : e === E ? {
          r: -1,
          g: -1,
          b: -1,
          hex: E,
          toString: Ke
        } : (!Te[v](e.toLowerCase().substring(0, 2)) && "#" !== e.charAt() && (e = _Ue(e)), (s = e.match(xe)) ? (s[2] && (o = ne(s[2].substring(5), 16), r = ne(s[2].substring(3, 5), 16), n = ne(s[2].substring(1, 3), 16)), s[3] && (o = ne((i = s[3].charAt(3)) + i, 16), r = ne((i = s[3].charAt(2)) + i, 16), n = ne((i = s[3].charAt(1)) + i, 16)), s[4] && (a = s[4][S](Ce), n = te(a[0]), "%" === a[0].slice(-1) && (n *= 2.55), r = te(a[1]), "%" === a[1].slice(-1) && (r *= 2.55), o = te(a[2]), "%" === a[2].slice(-1) && (o *= 2.55), "rgba" === s[1].toLowerCase().slice(0, 4) && (t = te(a[3])), a[3] && "%" === a[3].slice(-1) && (t /= 100)), s[5] ? (a = s[5][S](Ce), n = te(a[0]), "%" === a[0].slice(-1) && (n *= 2.55), r = te(a[1]), "%" === a[1].slice(-1) && (r *= 2.55), o = te(a[2]), "%" === a[2].slice(-1) && (o *= 2.55), ("deg" === a[0].slice(-3) || "°" === a[0].slice(-1)) && (n /= 360), "hsba" === s[1].toLowerCase().slice(0, 4) && (t = te(a[3])), a[3] && "%" === a[3].slice(-1) && (t /= 100), u.hsb2rgb(n, r, o, t)) : s[6] ? (a = s[6][S](Ce), n = te(a[0]), "%" === a[0].slice(-1) && (n *= 2.55), r = te(a[1]), "%" === a[1].slice(-1) && (r *= 2.55), o = te(a[2]), "%" === a[2].slice(-1) && (o *= 2.55), ("deg" === a[0].slice(-3) || "°" === a[0].slice(-1)) && (n /= 360), "hsla" === s[1].toLowerCase().slice(0, 4) && (t = te(a[3])), a[3] && "%" === a[3].slice(-1) && (t /= 100), u.hsl2rgb(n, r, o, t)) : ((s = {
          r: n,
          g: r,
          b: o,
          toString: Ke
        }).hex = "#" + (16777216 | o | r << 8 | n << 16).toString(16).slice(1), u.is(t, "finite") && (s.opacity = t), s)) : {
          r: -1,
          g: -1,
          b: -1,
          hex: E,
          error: 1,
          toString: Ke
        });
      }, u), u.tintshade = (0, a.cacher)(function (e, t) {
        var n,
            r = u.getRGB(e),
            o = 255;
        return t < 0 && (t *= -1, o = 0), t > 1 && (t = 1), (n = 0 === t ? r : {
          r: o - (o - r.r) * t,
          g: o - (o - r.g) * t,
          b: o - (o - r.b) * t,
          toString: Ke
        }).hex = u.rgb(n.r, n.g, n.b), r.error && (n.error = r.error), "opacity" in r ? (n.rgba = "rgba(" + [n.r, n.g, n.b, r.opacity].join(",") + ")", n.opacity = r.opacity) : n.rgba = "rgb(" + [n.r, n.g, n.b].join(",") + ")", n;
      }, u), u.rgb = (0, a.cacher)(function (e, t, n) {
        return "#" + (16777216 | n | t << 8 | e << 16).toString(16).slice(1);
      }), u.sanitizePath = function (e) {
        var t;
        return t = e.join ? e.join(",") : e, t = A.test(t) ? u._pathToAbsolute(t) : t.replace(_e, "$1");
      }, u.parsePathString = function (e) {
        if (!e || !e.length) return null;
        var t = Ze(e);
        if (t.arr) return nt(t.arr);
        if (f = void 0, u.is(e, C)) if (e = ee(e).replace(/,?([A-Z]),?/g, ",$1,").replace(/(^,?)|(,?$)/g, "").replace(/,,?/g, ",").split(","), u.is(e[0], C)) f = nt(e);else {
          var n,
              r,
              o,
              i = [],
              a = e.length;

          for (f = [], n = 0; n < a; n += 1) {
            W.test(e[n]) ? (i.length && f.push(i), i = [r = e[n]], o = M[r.toLowerCase()]) : o ? (i.push(+e[n]), o--) : e[n].length && (f.push(i), i = [r].concat(+e[n]), o = M[r.toLowerCase()] - 1);
          }

          f.push(i);
        }
        return f && f.length || (f = [], ee(e).replace(Se, Y)), f.toString = u._path2string, t.arr = f, t.arr;
      }, u.parseTransformString = (0, a.cacher)(function (e) {
        if (!e) return null;
        var t = [];
        return u.is(e, C) && u.is(e[0], C) && (t = nt(e)), t.length || ee(e).replace(Ee, function (e, n, r) {
          var o = [];
          ge.call(n);
          r.replace(ke, function (e, t) {
            t && o.push(+t);
          }), t.push([n][b](o));
        }), t.toString = u._path2string, t;
      });
      var Ze = (0, a.cacher)(function () {
        return {};
      }, void 0, void 0, void 0, 500, {}, !0);

      function Qe(e, t, n, r, o) {
        return e * (e * (-3 * t + 9 * n - 9 * r + 3 * o) + 6 * t - 12 * n + 6 * r) - 3 * t + 3 * n;
      }

      function et(e, t, n, r, o, i, a, s, l) {
        null == l && (l = 1);

        for (var c = (l = l > 1 ? 1 : l < 0 ? 0 : l) / 2, u = [-.1252, .1252, -.3678, .3678, -.5873, .5873, -.7699, .7699, -.9041, .9041, -.9816, .9816], d = [.2491, .2491, .2335, .2335, .2032, .2032, .1601, .1601, .1069, .1069, .0472, .0472], f = 0, h = 0; h < 12; h++) {
          var p = c * u[h] + c,
              g = Qe(p, e, n, o, a),
              m = Qe(p, t, r, i, s);
          f += d[h] * ue(g * g + m * m);
        }

        return c * f;
      }

      u.findDotsAtSegment = function (e, t, n, r, o, i, a, s, l) {
        var c = 1 - l,
            u = se(c, 3),
            d = se(c, 2),
            f = l * l,
            h = f * l,
            p = u * e + 3 * d * l * n + 3 * c * l * l * o + h * a,
            g = u * t + 3 * d * l * r + 3 * c * l * l * i + h * s,
            m = e + 2 * l * (n - e) + f * (o - 2 * n + e),
            v = t + 2 * l * (r - t) + f * (i - 2 * r + t),
            y = n + 2 * l * (o - n) + f * (a - 2 * o + n),
            b = r + 2 * l * (i - r) + f * (s - 2 * i + r),
            x = c * e + l * n,
            w = c * t + l * r,
            C = c * o + l * a,
            _ = c * i + l * s,
            S = 90 - 180 * re.atan2(m - y, v - b) / fe;

        return (m > y || v < b) && (S += 180), {
          x: p,
          y: g,
          m: {
            x: m,
            y: v
          },
          n: {
            x: y,
            y: b
          },
          start: {
            x: x,
            y: w
          },
          end: {
            x: C,
            y: _
          },
          alpha: S
        };
      }, u._removedFactory = function (e) {
        return function () {
          (0, i["default"])("raphael.log", null, "Raphaël: you are calling to method “" + e + "” of removed object", e);
        };
      };

      var tt = u.pathBBox = function (e) {
        var t = Ze(e);
        if (!e) return {
          x: 0,
          y: 0,
          width: 0,
          height: 0,
          x2: 0,
          y2: 0
        };

        for (var n, r = 0, o = 0, i = [], a = [], s = 0, l = (e = lt(e)).length; s < l; s++) {
          if ((n = e[s])[0] === U) r = n[1], o = n[2], i.push(r), a.push(o);else {
            var c = st(r, o, n[1], n[2], n[3], n[4], n[5], n[6]);
            i = i[b](c.min.x, c.max.x), a = a[b](c.min.y, c.max.y), r = n[5], o = n[6];
          }
        }

        var u = ie[y](0, i),
            d = ie[y](0, a),
            f = oe[y](0, i),
            h = oe[y](0, a),
            p = {
          x: u,
          y: d,
          x2: f,
          y2: h,
          width: f - u,
          height: h - d
        };
        return t.bbox = He(p), p;
      },
          nt = function nt(e) {
        var t = He(e);
        return t.toString = u._path2string, t;
      },
          rt = u._pathToAbsolute = function (e) {
        var t,
            n = Ze(e);

        if (!n.abs) {
          if (u.is(e, C) && u.is(e && e[0], C) || (e = u.parsePathString(e)), !e || !e.length) return (t = [[U, 0, 0]]).toString = u._path2string, t;
          var r = 0,
              o = 0,
              i = 0,
              a = 0,
              s = 0;
          t = [], e[0][0] === U && (i = r = +e[0][1], a = o = +e[0][2], s++, t[0] = [U, r, o]);

          for (var l, c, d = 3 === e.length && e[0][0] === U && "R" === e[1][0].toUpperCase() && "Z" === e[2][0].toUpperCase(), f = s, h = e.length; f < h; f++) {
            if (t.push(l = []), (c = e[f])[0] != me.call(c[0])) switch (l[0] = me.call(c[0]), l[0]) {
              case "A":
                l[1] = c[1], l[2] = c[2], l[3] = c[3], l[4] = c[4], l[5] = c[5], l[6] = +(c[6] + r), l[7] = +(c[7] + o);
                break;

              case "V":
                l[1] = +c[1] + o;
                break;

              case "H":
                l[1] = +c[1] + r;
                break;

              case "R":
                for (var p = [r, o][b](c.slice(1)), g = 2, m = p.length; g < m; g++) {
                  p[g] = +p[g] + r, p[++g] = +p[g] + o;
                }

                t.pop(), t = t[b](Je(p, d));
                break;

              case "M":
                i = +c[1] + r, a = +c[2] + o;

              default:
                for (g = 1, m = c.length; g < m; g++) {
                  l[g] = +c[g] + (g % 2 ? r : o), g % 2 ? r = l[g] : o = l[g];
                }

            } else if ("R" === c[0]) p = [r, o][b](c.slice(1)), t.pop(), t = t[b](Je(p, d)), l = ["R"][b](c.slice(-2));else for (var v = 0, y = c.length; v < y; v++) {
              l[v] = c[v];
            }

            switch (l[0]) {
              case "Z":
                r = i, o = a;
                break;

              case "H":
                r = l[1];
                break;

              case "V":
                o = l[1];
                break;

              case "M":
                i = l[l.length - 2], a = l[l.length - 1];

              default:
                r = l[l.length - 2], o = l[l.length - 1];
            }
          }

          t.toString = u._path2string, n.abs = t;
        }

        return nt(n.abs);
      },
          ot = function ot(e, t, n, r) {
        return [e, t, n, r, n, r];
      },
          it = function it(e, t, n, r, o, i) {
        return [1 / 3 * e + 2 / 3 * n, 1 / 3 * t + 2 / 3 * r, 1 / 3 * o + 2 / 3 * n, 1 / 3 * i + 2 / 3 * r, o, i];
      },
          at = function at(e, t, n, r, o, i, a, s, l) {
        var c = 1 - l;
        return {
          x: se(c, 3) * e + 3 * se(c, 2) * l * n + 3 * c * l * l * o + se(l, 3) * a,
          y: se(c, 3) * t + 3 * se(c, 2) * l * r + 3 * c * l * l * i + se(l, 3) * s
        };
      },
          st = (0, a.cacher)(function (e, t, n, r, o, i, a, s) {
        var l,
            c = o - 2 * n + e - (a - 2 * o + n),
            u = 2 * (n - e) - 2 * (o - n),
            d = e - n,
            f = (-u + ue(u * u - 4 * c * d)) / 2 / c,
            h = (-u - ue(u * u - 4 * c * d)) / 2 / c,
            p = [t, s],
            g = [e, a];
        return ae(f) > "1e12" && (f = .5), ae(h) > "1e12" && (h = .5), f > 0 && f < 1 && (l = at(e, t, n, r, o, i, a, s, f), g.push(l.x), p.push(l.y)), h > 0 && h < 1 && (l = at(e, t, n, r, o, i, a, s, h), g.push(l.x), p.push(l.y)), f = (-(u = 2 * (r - t) - 2 * (i - r)) + ue(u * u - 4 * (c = i - 2 * r + t - (s - 2 * i + r)) * (d = t - r))) / 2 / c, h = (-u - ue(u * u - 4 * c * d)) / 2 / c, ae(f) > "1e12" && (f = .5), ae(h) > "1e12" && (h = .5), f > 0 && f < 1 && (l = at(e, t, n, r, o, i, a, s, f), g.push(l.x), p.push(l.y)), h > 0 && h < 1 && (l = at(e, t, n, r, o, i, a, s, h), g.push(l.x), p.push(l.y)), {
          min: {
            x: ie[y](0, g),
            y: ie[y](0, p)
          },
          max: {
            x: oe[y](0, g),
            y: oe[y](0, p)
          }
        };
      }),
          lt = u._path2curve = (0, a.cacher)(function (e, t) {
        var n = !t && Ze(e);
        if (!t && n.curve) return nt(n.curve);

        for (var r = rt(e), o = t && rt(t), i = {
          x: 0,
          y: 0,
          bx: 0,
          by: 0,
          X: 0,
          Y: 0,
          qx: null,
          qy: null
        }, s = {
          x: 0,
          y: 0,
          bx: 0,
          by: 0,
          X: 0,
          Y: 0,
          qx: null,
          qy: null
        }, l = function l(e, t) {
          if (!e) return ["C", t.x, t.y, t.x, t.y, t.x, t.y];

          switch (!(e[0] in {
            T: 1,
            Q: 1
          }) && (t.qx = t.qy = null), e[0]) {
            case "M":
              t.X = e[1], t.Y = e[2];
              break;

            case "A":
              e = ["C"][b](function n(e, t, r, o, i, s, l, c, u, d) {
                l = l && +l, s = s && +s;
                var f,
                    h = 120 * fe / 180,
                    p = he * (+i || 0),
                    g = [],
                    m = (0, a.cacher)(function (e, t, n) {
                  return {
                    x: e * le(n) - t * ce(n),
                    y: e * ce(n) + t * le(n)
                  };
                });
                if (d) A = d[0], T = d[1], E = d[2], k = d[3];else {
                  e = (f = m(e, t, -p)).x, t = f.y, c = (f = m(c, u, -p)).x, u = f.y, le(he * i), ce(he * i);
                  var v = (e - c) / 2,
                      y = (t - u) / 2,
                      x = v * v / (r * r) + y * y / (o * o);
                  x > 1 && (r *= x = ue(x), o *= x);

                  var w = r * r,
                      C = o * o,
                      _ = (s === l ? -1 : 1) * ue(ae((w * C - w * y * y - C * v * v) / (w * y * y + C * v * v))),
                      E = _ * r * y / o + (e + c) / 2,
                      k = _ * -o * v / r + (t + u) / 2,
                      A = re.asin(((t - k) / o).toFixed(9)),
                      T = re.asin(((u - k) / o).toFixed(9));

                  A = e < E ? fe - A : A, T = c < E ? fe - T : T, A < 0 && (A = 2 * fe + A), T < 0 && (T = 2 * fe + T), l && A > T && (A -= 2 * fe), !l && T > A && (T -= 2 * fe);
                }
                var M = T - A;

                if (ae(M) > h) {
                  var O = T,
                      F = c,
                      I = u;
                  g = n(c = E + r * le(T = A + h * (l && T > A ? 1 : -1)), u = k + o * ce(T), r, o, i, 0, l, F, I, [T, O, E, k]);
                }

                M = T - A;
                var L = le(A),
                    N = ce(A),
                    D = le(T),
                    P = ce(T),
                    R = re.tan(M / 4),
                    j = 4 / 3 * r * R,
                    V = 4 / 3 * o * R,
                    B = [e, t],
                    H = [e + j * N, t - V * L],
                    G = [c + j * P, u - V * D],
                    z = [c, u];
                if (H[0] = 2 * B[0] - H[0], H[1] = 2 * B[1] - H[1], d) return [H, G, z][b](g);

                for (var U = [], $ = 0, X = (g = [H, G, z][b](g).join()[S](",")).length; $ < X; $++) {
                  U[$] = $ % 2 ? m(g[$ - 1], g[$], p).y : m(g[$], g[$ + 1], p).x;
                }

                return U;
              }[y](0, [t.x, t.y][b](e.slice(1))));
              break;

            case "S":
              e = ["C", t.x + (t.x - (t.bx || t.x)), t.y + (t.y - (t.by || t.y))][b](e.slice(1));
              break;

            case "T":
              t.qx = t.x + (t.x - (t.qx || t.x)), t.qy = t.y + (t.y - (t.qy || t.y)), e = ["C"][b](it(t.x, t.y, t.qx, t.qy, e[1], e[2]));
              break;

            case "Q":
              t.qx = e[1], t.qy = e[2], e = ["C"][b](it(t.x, t.y, e[1], e[2], e[3], e[4]));
              break;

            case "L":
              e = ["C"][b](ot(t.x, t.y, e[1], e[2]));
              break;

            case "H":
              e = ["C"][b](ot(t.x, t.y, e[1], t.y));
              break;

            case "V":
              e = ["C"][b](ot(t.x, t.y, t.x, e[1]));
              break;

            case "Z":
              e = ["C"][b](ot(t.x, t.y, t.X, t.Y));
          }

          return e;
        }, c = function c(e, t) {
          if (e[t].length > 7) {
            e[t].shift();

            for (var n = e[t]; n.length;) {
              e.splice(t++, 0, ["C"][b](n.splice(0, 6)));
            }

            e.splice(t, 1), f = oe(r.length, o && o.length || 0);
          }
        }, u = function u(e, t, n, i, a) {
          e && t && e[a][0] === U && t[a][0] != U && !a && (t.splice(a, 0, [U, i.x, i.y]), n.bx = 0, n.by = 0, n.x = e[a][1], n.y = e[a][2], f = oe(r.length, o && o.length || 0));
        }, d = 0, f = oe(r.length, o && o.length || 0); d < f; d++) {
          r[d] = l(r[d], i), c(r, d), o && (o[d] = l(o[d], s)), o && c(o, d), u(r, o, i, s, d), u(o, r, s, i, d);
          var h = r[d],
              p = o && o[d],
              g = h.length,
              m = o && p.length;
          i.x = h[g - 2], i.y = h[g - 1], i.bx = te(h[g - 4]) || i.x, i.by = te(h[g - 3]) || i.y, s.bx = o && (te(p[m - 4]) || s.x), s.by = o && (te(p[m - 3]) || s.y), s.x = o && p[m - 2], s.y = o && p[m - 1];
        }

        return o || (n.curve = nt(r)), o ? [r, o] : r;
      }, null, nt),
          ct = (u._parseDots = (0, a.cacher)(function (e) {
        for (var t = [], n = 0, r = e.length; n < r; n++) {
          var o = {},
              i = e[n].match(/^([^:]*):?([\d\.]*)/);
          if (o.color = u.getRGB(i[1]), o.color.error) return null;
          o.opacity = o.color.opacity, o.color = o.color.hex, i[2] && (o.offset = i[2] + "%"), t.push(o);
        }

        for (n = 1, r = t.length - 1; n < r; n++) {
          if (!t[n].offset) {
            for (var a = te(t[n - 1].offset || 0), s = 0, l = n + 1; l < r; l++) {
              if (t[l].offset) {
                s = t[l].offset;
                break;
              }
            }

            s || (s = 100, l = r);

            for (var c = ((s = te(s)) - a) / (l - n + 1); n < l; n++) {
              a += c, t[n].offset = a + "%";
            }
          }
        }

        return t;
      }), u._tear = function (e, t) {
        e === t.top && (t.top = e.prev), e === t.bottom && (t.bottom = e.next), e.next && (e.next.prev = e.prev), e.prev && (e.prev.next = e.next);
      }),
          ut = (u._tofront = function (e, t) {
        return t.top !== e && (ct(e, t), e.next = null, e.prev = t.top, t.top.next = e, t.top = e, !0);
      }, u._toback = function (e, t) {
        return t.bottom !== e && (ct(e, t), e.next = t.bottom, e.prev = null, t.bottom.prev = e, t.bottom = e, !0);
      }, u._insertafter = function (e, t, n, r) {
        ct(e, n), e.parent = r, t === r.top && (r.top = e), t.next && (t.next.prev = e), e.next = t.next, e.prev = t, t.next = e;
      }, u._insertbefore = function (e, t, n, r) {
        ct(e, n), e.parent = r, t === r.bottom && (r.bottom = e), t.prev && (t.prev.next = e), e.prev = t.prev, t.prev = e, e.next = t;
      }, u._extractTransform = function (e, t) {
        if (null == t) return e._.transform;
        t = ee(t).replace(/\.{3}|\u2026/g, e._.transform || g);
        var n,
            r,
            o = u.parseTransformString(t),
            i = 0,
            a = 1,
            s = 1,
            l = e._,
            c = new ht();
        if (l.transform = o || [], o) for (var d = 0, f = o.length; d < f; d++) {
          var h,
              p,
              m,
              v,
              y,
              b = o[d],
              x = b.length,
              w = ee(b[0]).toLowerCase(),
              C = b[0] != w,
              _ = C ? c.invert() : 0;

          "t" === w && 3 === x ? C ? (h = _.x(0, 0), p = _.y(0, 0), m = _.x(b[1], b[2]), v = _.y(b[1], b[2]), c.translate(m - h, v - p)) : c.translate(b[1], b[2]) : "r" === w ? 2 === x ? (y = l.bb || (l.bb = e.getBBox(1)), c.rotate(b[1], y.x + y.width / 2, y.y + y.height / 2), i += b[1]) : 4 === x && (C ? (m = _.x(b[2], b[3]), v = _.y(b[2], b[3]), c.rotate(b[1], m, v)) : c.rotate(b[1], b[2], b[3]), i += b[1]) : "s" === w ? 2 === x || 3 === x ? (y = l.bb || (l.bb = e.getBBox(1)), c.scale(b[1], b[x - 1], y.x + y.width / 2, y.y + y.height / 2), a *= b[1], s *= b[x - 1]) : 5 === x && (C ? (m = _.x(b[3], b[4]), v = _.y(b[3], b[4]), c.scale(b[1], b[2], m, v)) : c.scale(b[1], b[2], b[3], b[4]), a *= b[1], s *= b[2]) : w === z && 7 === x && c.add(b[1], b[2], b[3], b[4], b[5], b[6]), l.dirtyT = 1, e.matrix = c;
        }
        e.matrix = c, l.sx = a, l.sy = s, l.deg = i, l.dx = n = c.e, l.dy = r = c.f, 1 === a && 1 === s && !i && l.bbox ? (l.bbox.x += +n, l.bbox.y += +r) : l.dirtyT = 1;
      }),
          dt = function dt(e) {
        var t = e[0];

        switch (t.toLowerCase()) {
          case "t":
            return [t, 0, 0];

          case "m":
            return [t, 1, 0, 0, 1, 0, 0];

          case "r":
            return 4 === e.length ? [t, 0, e[2], e[3]] : [t, 0];

          case "s":
            return 5 === e.length ? [t, 1, 1, e[3], e[4]] : 3 === e.length ? [t, 1, 1] : [t, 1];
        }
      },
          ft = u._equaliseTransform = function (e, t) {
        t = ee(t).replace(/\.{3}|\u2026/g, e), e = u.parseTransformString(e) || [], t = u.parseTransformString(t) || [];

        for (var n, r, o, i, a = oe(e.length, t.length), s = [], l = [], c = 0; c < a; c++) {
          if (o = e[c] || dt(t[c]), i = t[c] || dt(o), o[0] != i[0] || "r" === o[0].toLowerCase() && (o[2] != i[2] || o[3] != i[3]) || "s" === o[0].toLowerCase() && (o[3] != i[3] || o[4] != i[4])) return;

          for (s[c] = [], l[c] = [], n = 0, r = oe(o.length, i.length); n < r; n++) {
            n in o && (s[c][n] = o[n]), n in i && (l[c][n] = i[n]);
          }
        }

        return {
          from: s,
          to: l
        };
      };

      function ht(e, t, n, r, o, i) {
        null != e ? (this.a = +e, this.b = +t, this.c = +n, this.d = +r, this.e = +o, this.f = +i) : (this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.e = 0, this.f = 0);
      }

      u._getContainer = function (e, t, n, r) {
        var o;
        if (null != (o = null != r || u.is(e, _) ? e : I.doc.getElementById(e))) return o.tagName ? null == t ? {
          container: o,
          width: o.style.pixelWidth || o.offsetWidth,
          height: o.style.pixelHeight || o.offsetHeight
        } : {
          container: o,
          width: t,
          height: n
        } : {
          container: 1,
          x: e,
          y: t,
          width: n,
          height: r
        };
      }, u._engine = {}, u.path2curve = lt, u.matrix = function (e, t, n, r, o, i) {
        return new ht(e, t, n, r, o, i);
      }, function (e) {
        function t(e) {
          return e[0] * e[0] + e[1] * e[1];
        }

        function n(e) {
          var n = ue(t(e));
          e[0] && (e[0] /= n), e[1] && (e[1] /= n);
        }

        e.add = function (e, t, n, r, o, i) {
          var a,
              s,
              l,
              c,
              u = [[], [], []],
              d = [[this.a, this.c, this.e], [this.b, this.d, this.f], [0, 0, 1]],
              f = [[e, n, o], [t, r, i], [0, 0, 1]];

          for (e && e instanceof ht && (f = [[e.a, e.c, e.e], [e.b, e.d, e.f], [0, 0, 1]]), a = 0; a < 3; a++) {
            for (s = 0; s < 3; s++) {
              for (c = 0, l = 0; l < 3; l++) {
                c += d[a][l] * f[l][s];
              }

              u[a][s] = c;
            }
          }

          this.a = u[0][0], this.b = u[1][0], this.c = u[0][1], this.d = u[1][1], this.e = u[0][2], this.f = u[1][2];
        }, e.invert = function () {
          var e = this,
              t = e.a * e.d - e.b * e.c;
          return new ht(e.d / t, -e.b / t, -e.c / t, e.a / t, (e.c * e.f - e.d * e.e) / t, (e.b * e.e - e.a * e.f) / t);
        }, e.clone = function () {
          return new ht(this.a, this.b, this.c, this.d, this.e, this.f);
        }, e.translate = function (e, t) {
          this.add(1, 0, 0, 1, e, t);
        }, e.scale = function (e, t, n, r) {
          null == t && (t = e), (n || r) && this.add(1, 0, 0, 1, n, r), this.add(e, 0, 0, t, 0, 0), (n || r) && this.add(1, 0, 0, 1, -n, -r);
        }, e.rotate = function (e, t, n) {
          e = u.rad(e), t = t || 0, n = n || 0;
          var r = +le(e).toFixed(9),
              o = +ce(e).toFixed(9);
          this.add(r, o, -o, r, t, n), this.add(1, 0, 0, 1, -t, -n);
        }, e.x = function (e, t) {
          return e * this.a + t * this.c + this.e;
        }, e.y = function (e, t) {
          return e * this.b + t * this.d + this.f;
        }, e.get = function (e) {
          return +this[ee.fromCharCode(97 + e)].toFixed(4);
        }, e.toString = function () {
          return u.svg ? "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")" : [this.get(0), this.get(2), this.get(1), this.get(3), 0, 0].join();
        }, e.toMatrixString = function () {
          return "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")";
        }, e.toFilter = function () {
          return "progid:DXImageTransform.Microsoft.Matrix(M11=" + this.get(0) + ", M12=" + this.get(2) + ", M21=" + this.get(1) + ", M22=" + this.get(3) + ", Dx=" + this.get(4) + ", Dy=" + this.get(5) + ", sizingmethod='auto expand')";
        }, e.offset = function () {
          return [this.e.toFixed(4), this.f.toFixed(4)];
        }, e.split = function () {
          var e = {};
          e.dx = this.e, e.dy = this.f;
          var r = [[this.a, this.c], [this.b, this.d]];
          e.scalex = ue(t(r[0])), n(r[0]), e.shear = r[0][0] * r[1][0] + r[0][1] * r[1][1], r[1] = [r[1][0] - r[0][0] * e.shear, r[1][1] - r[0][1] * e.shear], e.scaley = ue(t(r[1])), n(r[1]), e.shear /= e.scaley;
          var o = -r[0][1],
              i = r[1][1];
          return i < 0 ? (e.rotate = u.deg(re.acos(i)), o < 0 && (e.rotate = 360 - e.rotate)) : e.rotate = u.deg(re.asin(o)), e.isSimple = !(+e.shear.toFixed(9) || e.scalex.toFixed(9) !== e.scaley.toFixed(9) && e.rotate), e.isSuperSimple = !+e.shear.toFixed(9) && e.scalex.toFixed(9) === e.scaley.toFixed(9) && !e.rotate, e.noRotation = !+e.shear.toFixed(9) && !e.rotate, e;
        }, e.toTransformString = function (e) {
          var t = e || this[S]();
          return t.isSimple ? (t.scalex = +t.scalex.toFixed(4), t.scaley = +t.scaley.toFixed(4), t.rotate = +t.rotate.toFixed(4), (t.dx || t.dy ? "t" + [t.dx, t.dy] : g) + (1 != t.scalex || 1 != t.scaley ? "s" + [t.scalex, t.scaley, 0, 0] : g) + (t.rotate ? "r" + [t.rotate, 0, 0] : g)) : z + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)];
        };
      }(ht.prototype);
      var pt = (P = N.navigator).userAgent.match(/Version\/(.*?)\s/) || P.userAgent.match(/Chrome\/(\d+)/);
      "Apple Computer, Inc." === P.vendor && (pt && pt[1] < 4 || "iP" === P.platform.slice(0, 2)) || "Google Inc." === P.vendor && pt && pt[1] < 8 ? J.safari = function () {
        var e = this.rect(-99, -99, this.width + 99, this.height + 99).attr({
          stroke: E
        });
        return setTimeout(function () {
          e.remove();
        }), !0;
      } : J.safari = function () {};

      for (var gt = function gt() {
        this.returnValue = !1;
      }, mt = function mt() {
        return this.originalEvent.preventDefault();
      }, vt = function vt() {
        this.cancelBubble = !0;
      }, yt = function yt() {
        return this.originalEvent.stopPropagation();
      }, bt = {
        stopPropagation: "fn",
        stopImmediatePropagation: "fn",
        preventDefault: "fn",
        type: !0,
        clientX: !0,
        clientY: !0,
        pageX: !0,
        pageY: !0,
        bubbles: !0,
        cancelable: !0,
        touches: !0,
        target: !0,
        originalTarget: !0,
        srcElement: !0,
        relatedTarget: !0,
        fromElement: !0,
        changedTouches: !0,
        layerX: !0,
        layerY: !0,
        deltaX: !0,
        deltaY: !0
      }, xt = u.makeSelectiveCopy = function (e, t) {
        var n = function n(_n) {
          e[_n] = "fn" === bt[_n] ? function () {
            t[_n]();
          } : t[_n];
        };

        for (var r in bt) {
          n(r);
        }

        e.originalEvent = t, e.type || (e.type = t.originalEvent && t.originalEvent.type);
      }, wt = u.addEvent = I.doc.addEventListener ? function (e, t, n, r) {
        var o,
            i,
            a = j ? D[t] : R ? Q[t] : t;
        return T || (i = {
          capture: !1
        }), r.dragFn && ("pointerup" === a ? a = "mouseup" : void 0 === a && (a = "touchend")), o = function o(_o2) {
          var i,
              a = I.doc.documentElement.scrollTop || I.doc.body.scrollTop,
              s = I.doc.documentElement.scrollLeft || I.doc.body.scrollLeft;
          if (R && Q[t]) for (var l = 0, c = _o2.targetTouches && _o2.targetTouches.length; l < c; l++) {
            if ((i = _o2.targetTouches[l].target) === e || "tspan" === i.nodeName && i.parentNode === e) {
              var u = _o2;
              (_o2 = _o2.targetTouches[l]).originalEvent = u, _o2.preventDefault = mt, _o2.stopPropagation = yt;
              break;
            }
          }
          return n.call(r, _o2, _o2.clientX + s, _o2.clientY + a);
        }, e.addEventListener(a, o, i), function () {
          return e.removeEventListener(a, o, i), !0;
        };
      } : I.doc.attachEvent ? function (e, t, n, r) {
        var o = function o(e) {
          e = e || I.win.event;
          var t = I.doc.documentElement.scrollTop || I.doc.body.scrollTop,
              o = I.doc.documentElement.scrollLeft || I.doc.body.scrollLeft,
              i = e.clientX + o,
              a = e.clientY + t;
          return e.preventDefault = e.preventDefault || gt, e.stopPropagation = e.stopPropagation || vt, n.call(r, e, i, a);
        };

        return e.attachEvent("on" + t, o), function () {
          return e.detachEvent("on" + t, o), !0;
        };
      } : void 0, Ct = function Ct(e) {
        var t,
            n = I.doc.documentElement.scrollTop || I.doc.body.scrollTop,
            r = I.doc.documentElement.scrollLeft || I.doc.body.scrollLeft,
            o = (void 0 !== e.clientX ? e.clientX : e.changedTouches && e.changedTouches[0].clientX) + r,
            a = (void 0 !== e.clientY ? e.clientY : e.changedTouches && e.changedTouches[0].clientY) + n,
            s = {},
            l = this,
            c = l.dragInfo.onmove.length;
        if (!(l.dragStartFn && !(Math.abs(o - l._drag.x) >= 2.5 || Math.abs(a - l._drag.y) >= 2.5) || l._blockDrag || j && R && !e.isPrimary)) for (; c--;) {
          if (R && "touchmove" === e.type) for (var d, f = e.touches.length; f--;) {
            if ((d = e.touches[f]).identifier === l._drag.id) {
              o = d.clientX + r, a = d.clientY + n;
              break;
            }
          }

          if (!l.removed) {
            if (l.dragStartFn && (l.dragStartFn(c), l.dragStartFn = undefined, l.dragInfo._dragmove = !0), I.win.opera) {
              var h = u._engine.getNode(l),
                  p = h.nextSibling,
                  g = h.parentNode,
                  m = h.style.display;

              g.removeChild(h), h.style.display = E, h.style.display = m, p ? g.insertBefore(h, p) : g.appendChild(h);
            }

            xt(s, e), t = s.data = [o - l._drag.x, a - l._drag.y, o, a], (0, i["default"])("raphael.drag.move." + l.id, l.dragInfo.move_scope[c] || l, s, t);
          }
        }
      }, _t = function e(t) {
        var n = this,
            r = n.dragInfo,
            o = r.onend.length;
        if (n.dragInfo._dragmove) for (; o--;) {
          n._drag = {}, (0, i["default"])("raphael.drag.end." + n.id, r.end_scope[o] || r.start_scope[o] || r.move_scope[o] || n, t);
        }
        n.dragInfo._dragmove = undefined, R && !B && !V && (!G || !H) && (n.paper.canvas.style["touch-action"] = "auto"), u.undragmove.call(n, Ct), u.undragend.call(n, e), u.unmousemove.call(n, Ct).unmouseup.call(n, e);
      }, St = u.el = {}, Et = Z.length; Et--;) {
        !function (e) {
          u[e] = St[e] = function (t, n, r) {
            return u.is(t, k) && (this.events = this.events || [], this.events.push({
              name: e,
              f: t,
              unbind: wt(r || this.shape || this.node || I.doc, e, t, n || this)
            })), this;
          }, u["un" + e] = St["un" + e] = function (t) {
            for (var n = this.events || [], r = n.length; r--;) {
              if (n[r].name === e && n[r].f === t) return n[r].unbind(), n.splice(r, 1), !n.length && delete this.events, this;
            }

            return this;
          };
        }(Z[Et]);
      }

      St.data = function (e, t) {
        var n = Fe[this.id] = Fe[this.id] || {};

        if (1 === arguments.length) {
          if (u.is(e, _)) {
            for (var r in e) {
              e[v](r) && this.data(r, e[r]);
            }

            return this;
          }

          return u.stopPartialEventPropagation || (0, i["default"])("raphael.data.get." + this.id, this, n[e], e), n[e];
        }

        return n[e] = t, u.stopPartialEventPropagation || (0, i["default"])("raphael.data.set." + this.id, this, t, e), this;
      }, St.removeData = function (e) {
        return null == e ? delete Fe[this.id] : Fe[this.id] && delete Fe[this.id][e], this;
      }, St.dbclick = function (e, t) {
        var n,
            r = this,
            o = function o(n) {
          var o;
          j && !n.isPrimary || (n && n.preventDefault(), (!(o = n).touches || o.touches && 1 === o.touches.length) && (r._tappedOnce ? (e.call(t || r, n), r._tappedOnce = !1) : (r._tappedOnce = !0, setTimeout(function () {
            r._tappedOnce = !1;
          }, 500))));
        };

        n = j ? "pointerup" : u.supportsTouch ? "touchstart" : "mouseup", r.node.addEventListener(n, o), u.storeHandlers(r, e, o);
      }, St.undbclick = function (e) {
        var t = removeHandlers(this, e);
        t && this.node.removeEventListener(j ? "pointerup" : u.supportsTouch ? "touchstart" : "mouseup", t);
      }, St.getData = function () {
        return He(Fe[this.id] || {});
      };

      var kt = [],
          At = function At() {
        this.untrack = wt(I.doc, "mouseup", Tt, this);
      },
          Tt = function Tt() {
        return this.untrack(), this.untrack = null, this.fn && this.fn.apply(this.scope || this.el, arguments);
      };

      St.mouseup = function (e, t, n, r) {
        return n ? (kt.push(n = {
          el: this,
          fn: e,
          scope: t
        }), n.unbind = wt(this.shape || this.node || I.doc, "mousedown", At, n), this) : u.mouseup.apply(this, [e, t, r]);
      }, St.unmouseup = function (e) {
        for (var t, n = kt.length; n--;) {
          kt[n].el === this && kt[n].fn === e && ((t = kt[n]).unbind(), t.untrack && t.untrack(), kt.splice(n, 1));
        }

        return t ? this : u.unmouseup.apply(this, arguments);
      }, St.hover = function (e, t, n, r) {
        return this.on("fc-mouseover", e, n).on("fc-mouseout", t, r);
      }, St.unhover = function (e, t) {
        return this.off("fc-mouseover", e).off("fc-mouseout", t);
      }, St.fcclick = function (e, t) {
        var n,
            r,
            o,
            i,
            a,
            s = this,
            l = s.node,
            c = function c(e) {
          s._lastEventTriggered = "mousedown", o = void 0 !== e.clientX ? e.clientX : e.changedTouches && e.changedTouches[0].clientX, i = void 0 !== e.clientY ? e.clientY : e.changedTouches && e.changedTouches[0].clientY;
        },
            d = function d(e) {
          var t = void 0 !== e.clientX ? e.clientX : e.changedTouches && e.changedTouches[0].clientX,
              n = void 0 !== e.clientY ? e.clientY : e.changedTouches && e.changedTouches[0].clientY;
          (Math.abs(o - t) >= 2.5 || Math.abs(i - n) >= 2.5) && (s._lastEventTriggered = undefined);
        };

        if (s._clickStoreActual || (s._clickStoreActual = []), s._clickStoreDerived || (s._clickStoreDerived = []), !s._clickHandlerHelper) {
          for (n in a = !j && u.supportsTouch ? {
            touchstart: function touchstart() {
              s._lastEventTriggered = "touchstart", s._lastEventTriggeredAt = new Date().getTime();
            },
            touchmove: d
          } : j && u.supportsTouch ? {
            pointerdown: c,
            pointermove: d
          } : {
            mousedown: c,
            mousemove: d
          }) {
            l.addEventListener ? l.addEventListener(n, a[n]) : l.attachEvent("on" + n, a[n]);
          }

          s._clickHandlerHelper = a;
        }

        return !j && u.supportsTouch ? (n = "touchend", r = function r(n) {
          "touchstart" === s._lastEventTriggered && new Date().getTime() - s._lastEventTriggeredAt <= 500 && setTimeout(function () {
            e.call(t || s, n);
          }, 0);
        }) : (n = "click", r = function r(n) {
          "mousedown" === s._lastEventTriggered && e.call(t || s, n);
        }), l.addEventListener ? l.addEventListener(n, r) : l.attachEvent("on" + n, r), s._clickStoreDerived.push(r), s._clickStoreActual.push(e), s;
      }, St.fcunclick = function (e) {
        var t,
            n,
            r = this.node,
            o = this._clickHandlerHelper,
            i = this._clickStoreActual,
            a = this._clickStoreDerived;

        if (i) {
          for (t = i.length - 1; t >= 0; t--) {
            i[t] === e && (r.removeEventListener ? r.removeEventListener(!j && u.supportsTouch ? "touchend" : "click", a[t]) : r.detachEvent("onclick", a[t]), i.splice(t, 1), a.splice(t, 1));
          }

          if (!i.length) {
            for (n in o) {
              r.removeEventListener ? r.removeEventListener(n, o[n]) : r.detachEvent("on" + n, o[n]);
            }

            this._clickHandlerHelper = undefined;
          }
        }

        return this;
      };
      var Mt = [];

      function Ot() {
        return this.x + m + this.y + m + this.width + " × " + this.height;
      }

      St.drag = function (e, t, n, r, o, a) {
        var s = this,
            l = s.dragInfo || (s.dragInfo = {
          onmove: [],
          onstart: [],
          onend: [],
          move_scope: [],
          start_scope: [],
          end_scope: []
        });
        return e && l.onmove.push(e) && l.move_scope.push(r), t && l.onstart.push(t) && l.start_scope.push(o), n && l.onend.push(n) && l.end_scope.push(a), s.dragFn = s.dragFn || function (e) {
          var t,
              n,
              r,
              o,
              a,
              l,
              c,
              d,
              f,
              h,
              p = I.doc.documentElement.scrollTop || I.doc.body.scrollTop,
              g = I.doc.documentElement.scrollLeft || I.doc.body.scrollLeft,
              m = {},
              v = s.dragInfo,
              y = [Ct, void 0, I.doc];

          if (!j || e.isPrimary) {
            for (R && (j ? B || V || G && H || (s.paper.canvas.style["touch-action"] = "none") : e.preventDefault()), s._drag.x = f = (void 0 !== e.clientX ? e.clientX : e.changedTouches && e.changedTouches[0].clientX) + g, s._drag.y = h = (void 0 !== e.clientY ? e.clientY : e.changedTouches && e.changedTouches[0].clientY) + p, s._drag.id = e.identifier, R && !j ? u.dragmove.apply(s, y) : u.mousemove.apply(s, y).mouseup.call(s, _t, void 0, void 0, I.doc), R && u.dragend.call(s, _t, void 0, I.doc), xt(m, e), t = m.data = [f, h], n = 0, a = v.onstart.length; n < a; n++) {
              i["default"].on("raphael.drag.start." + s.id, v.onstart[n]);
            }

            for (r = 0, l = v.onmove.length; r < l; r++) {
              i["default"].on("raphael.drag.move." + s.id, v.onmove[r]);
            }

            for (o = 0, c = v.onend.length; o < c; o++) {
              i["default"].on("raphael.drag.end." + s.id, v.onend[o]);
            }

            a && !l && (d = function d() {
              s.undragmove(), v.onmove = [];
            }, v.onmove.push(d), i["default"].on("raphael.drag.end." + s.id, d)), s.dragStartFn = function (e) {
              (0, i["default"])("raphael.drag.start." + s.id, s.dragInfo.start_scope[e] || s.dragInfo.move_scope[e] || s, m, t);
            };
          }
        }, s._drag = {}, Mt.push({
          el: s,
          start: s.dragFn,
          onstart: t,
          onmove: e,
          onend: n
        }), t && !s.startHandlerAttached && (R && !j ? s.dragstart(s.dragFn) : s.mousedown(s.dragFn), s.startHandlerAttached = !0), s;
      }, St.onDragOver = function (e) {
        e ? i["default"].on("raphael.drag.over." + this.id, e) : i["default"].unbind("raphael.drag.over." + this.id);
      }, St.undrag = function () {
        for (var e = Mt.length; e--;) {
          Mt[e].el === this && (this.unmousedown(this.dragFn), Mt.splice(e, 1), i["default"].unbind("raphael.drag.*." + this.id), this.dragInfo = undefined, this.dragFn = undefined, this.startHandlerAttached = undefined);
        }

        u.unmousemove.call(this, Ct).unmouseup.call(this, _t), u.undragmove.call(this, Ct), u.undragend.call(this, _t), delete this._drag;
      }, St.undragstart = function (e) {
        var t,
            n,
            r = this.dragInfo,
            o = r && r.onstart,
            a = r && r.start_scope;
        if (e) for (t = 0, n = o && o.length; t < n; t++) {
          if (o[t] === e) {
            o.splice(t, 1), a.splice(t, 1), i["default"].unbind("raphael.drag.start." + this.id, e);
            break;
          }
        }
        o && o.length && e || (u.undragstart.call(this, this.dragFn), u.unmousedown.call(this, this.dragFn), i["default"].unbind("raphael.drag.start." + this.id), this.startHandlerAttached = !1, r && (r.onstart = [], r.start_scope = []));
      }, St.undragmove = function (e) {
        var t,
            n,
            r = this.dragInfo,
            o = r && r.onmove,
            a = r && r.move_scope;
        if (e) for (t = 0, n = o && o.length; t < n; t++) {
          if (o[t] === e) {
            o.splice(t, 1), a.splice(t, 1), i["default"].unbind("raphael.drag.move." + this.id, e);
            break;
          }
        }
        o && o.length && e || (u.undragmove.call(this, Ct), u.unmousemove.call(this, Ct), r && (r.onmove = [], r.move_scope = []), i["default"].unbind("raphael.drag.move." + this.id));
      }, St.undragend = function (e) {
        var t,
            n,
            r = this.dragInfo,
            o = r && r.onend,
            a = r && r.end_scope;
        if (e) for (t = 0, n = o && o.length; t < n; t++) {
          if (o[t] === e) {
            o.splice(t, 1), a.splice(t, 1), i["default"].unbind("raphael.drag.end." + this.id, e);
            break;
          }
        }
        o && o.length && e || (u.undragend.call(this, _t), u.unmouseup.call(this, _t), r && (r.onend = [], r.end_scope = []), i["default"].unbind("raphael.drag.end." + this.id));
      }, St.follow = function (e, t, n) {
        return e.removed || e.constructor !== u.el.constructor ? this : (e.followers.push({
          el: this,
          stalk: n = {
            before: "insertBefore",
            after: "insertAfter"
          }[n],
          cb: t
        }), n && this[n](e), this);
      }, St.unfollow = function (e) {
        if (e.removed || e.constructor !== u.el.constructor) return this;

        for (var t = 0, n = e.followers.length; t < n; t++) {
          if (e.followers[t].el === this) {
            e.followers.splice(t, 1);
            break;
          }
        }

        return this;
      }, J.hide = function () {
        return this.canvas.style.visibility = "hidden", this;
      }, J.show = function () {
        return this.canvas.style.visibility = g, this;
      }, J.group = function () {
        var e = (0, a.getArrayCopy)(arguments),
            t = je(e, !0),
            n = u._engine.group(this, e[0], t);

        return this.__set__ && this.__set__.push(n), this._elementsById[n.id] = n;
      }, J.circle = function () {
        var e = (0, a.getArrayCopy)(arguments),
            t = je(e, !0),
            n = this._addDefAttribs() ? Ve(e, "cx", 0, "cy", 0, "r", 0, "fill", E, "stroke", "#000") : Ve(e),
            r = u._engine.circle(this, n, t);

        return this.__set__ && this.__set__.push(r), this._elementsById[r.id] = r;
      }, J.rect = function () {
        var e = (0, a.getArrayCopy)(arguments),
            t = je(e, !0),
            n = this._addDefAttribs() ? Ve(e, "x", 0, "y", 0, "width", 0, "height", 0, "r", 0, "fill", E, "stroke", "#000") : Ve(e),
            r = u._engine.rect(this, n, t);

        return this.__set__ && this.__set__.push(r), this._elementsById[r.id] = r;
      }, J.ellipse = function () {
        var e = (0, a.getArrayCopy)(arguments),
            t = je(e, !0),
            n = this._addDefAttribs() ? Ve(e, "x", 0, "y", 0, "rx", 0, "ry", 0, "fill", E, "stroke", "#000") : Ve(e),
            r = u._engine.ellipse(this, n, t);

        return this.__set__ && this.__set__.push(r), this._elementsById[r.id] = r;
      }, J.path = function () {
        var e = (0, a.getArrayCopy)(arguments),
            t = je(e, !0),
            n = this.config,
            r = n && n["stroke-linecap"] || "butt",
            o = this._addDefAttribs() ? Ve(e, "path", g, "fill", E, "stroke", "#000", "stroke-linecap", r) : Ve(e),
            i = u._engine.path(this, o, t);

        return this.__set__ && this.__set__.push(i), this._elementsById[i.id] = i;
      }, J.image = function () {
        var e = (0, a.getArrayCopy)(arguments),
            t = je(e, !0),
            n = this._addDefAttribs() ? Ve(e, "x", 0, "y", 0, "width", 0, "height", 0) : Ve(e),
            r = u._engine.image(this, n, t);

        return this.__set__ && this.__set__.push(r), this._elementsById[r.id] = r;
      }, J.text = function () {
        var e = (0, a.getArrayCopy)(arguments),
            t = je(e, !0),
            n = this._addDefAttribs() ? Ve(e, "x", 0, "y", 0, "text", g, "stroke", E, "fill", "#000", "text-anchor", "middle", "vertical-align", "middle") : Ve(e),
            r = u._engine.text(this, n, t, e[1]);

        return this.__set__ && this.__set__.push(r), this._elementsById[r.id] = r;
      }, J._addDefAttribs = function () {
        return !(u.svg && this.config && this.config.noDefaultAttribs);
      }, J.setConfig = function (e, t) {
        return e !== undefined && t !== undefined && (this.config = this.config || {}, this.config[e] = t), this.config;
      }, J._createDOMNodes = function (e, t, n) {
        var r,
            o,
            i,
            a,
            s = {},
            l = u._createNode,
            c = t.tagName,
            d = t.children || [];

        for (a in !n && (n = {}), t) {
          "tagName" !== a && "children" !== a && (s[a] = t[a]);
        }

        if (!s.id && (s.id = u.getElementID(u.createUUID())), !this.canvas.getElementById(s.id) && c) for (r = e.appendChild(l(c, s)), n.element = r, n.id = s.id, (i = d.length) > 0 && (n.children = []), o = 0; o < i; o++) {
          n.children[o] = {}, this._createDOMNodes(r, d[o], n.children[o]);
        }
        return n;
      }, J.addDefs = function (e) {
        if (u.svg) {
          var t,
              n = {},
              r = this.defs;

          for (t in e) {
            n[t] = {}, this._createDOMNodes(r, e[t], n[t]);
          }

          return n;
        }
      }, J.setSize = function (e, t) {
        return u._engine.setSize.call(this, e, t);
      }, J.setDimension = function (e, t) {
        var n;
        (void 0 === e ? "undefined" : o(e)) === _ ? (n = e.width, t = e.height, this.setSize(e.width, e.height)) : (n = e, this.setSize(n, t));
      }, J.attr = function (e) {
        return null == e ? {
          width: this.width,
          height: this.height
        } : u.is(e, w) ? this[e] : (this.setDimension(e), this);
      }, J.status = function (e, t) {
        return St.status.call(this, e, t);
      }, J.animateWith = function (e, t, n, r, o, i, a) {
        return St.animateWith.call(this, e, t, n, r, o, i, a);
      }, J.animate = function (e, t, n, r) {
        return St.animate.call(this, e, t, n, r);
      }, J.setViewBox = function (e, t, n, r, o) {
        return u._engine.setViewBox.call(this, e, t, n, r, o);
      }, J.getById = function (e) {
        return this._elementsById[e] || null;
      }, J.top = J.bottom = null, J.raphael = u, St.getBBox = function (e) {
        if (this.removed) return {};
        var t = this._;
        return e ? (!t.dirty && t.bboxwt || (this.realPath = Pe[this.type](this), t.bboxwt = tt(this.realPath), t.bboxwt.toString = Ot, t.dirty = 0), t.bboxwt) : ((t.dirty || t.dirtyT || !t.bbox) && (!t.dirty && this.realPath || (t.bboxwt = 0, this.realPath = Pe[this.type](this)), t.bbox = tt(Re(this.realPath, this.matrix)), t.bbox.toString = Ot, t.dirty = t.dirtyT = 0), t.bbox);
      }, St.clone = function (e, t) {
        if (this.removed) return null;
        var n,
            r,
            o = this,
            i = o.attr();

        if (e) {
          for (n in e) {
            i[n] = e[n];
          }

          r = o.paper[o.type](i, t);
        } else r = o.paper[o.type]().attr(i);

        return o.__set__ && o.__set__.push(r), r;
      };

      var Ft = function Ft(e, t, n, r, o, i, a, s, l) {
        return null == l ? et(e, t, n, r, o, i, a, s) : u.findDotsAtSegment(e, t, n, r, o, i, a, s, function (e, t, n, r, o, i, a, s, l) {
          if (!(l < 0 || et(e, t, n, r, o, i, a, s) < l)) {
            var c,
                u = .5,
                d = 1 - u;

            for (c = et(e, t, n, r, o, i, a, s, d); ae(c - l) > .01;) {
              u /= 2, c = et(e, t, n, r, o, i, a, s, d += (c < l ? 1 : -1) * u);
            }

            return d;
          }
        }(e, t, n, r, o, i, a, s, l));
      },
          It = function It(e, t) {
        return function (n, r, o) {
          n = lt(n);

          for (var i, a, s, l, c, d = g, f = {}, h = 0, p = 0, m = n.length; p < m; p++) {
            if ((s = n[p])[0] === U) i = +s[1], a = +s[2];else {
              if (h + (l = Ft(i, a, s[1], s[2], s[3], s[4], s[5], s[6])) > r) {
                if (t && !f.start) {
                  if (d += ["C" + (c = Ft(i, a, s[1], s[2], s[3], s[4], s[5], s[6], r - h)).start.x, c.start.y, c.m.x, c.m.y, c.x, c.y], o) return d;
                  f.start = d, d = [U + c.x, c.y + "C" + c.n.x, c.n.y, c.end.x, c.end.y, s[5], s[6]].join(), h += l, i = +s[5], a = +s[6];
                  continue;
                }

                if (!e && !t) return {
                  x: (c = Ft(i, a, s[1], s[2], s[3], s[4], s[5], s[6], r - h)).x,
                  y: c.y,
                  alpha: c.alpha
                };
              }

              h += l, i = +s[5], a = +s[6];
            }
            d += s.shift() + s;
          }

          return f.end = d, (c = e ? h : t ? f : u.findDotsAtSegment(i, a, s[0], s[1], s[2], s[3], s[4], s[5], 1)).alpha && (c = {
            x: c.x,
            y: c.y,
            alpha: c.alpha
          }), c;
        };
      },
          Lt = It(1),
          Nt = It();

      It(0, 1);
      u.getTotalLength = Lt, u.getPointAtLength = Nt, St.getTotalLength = function () {
        if ("path" == this.type) return this.node.getTotalLength ? this.node.getTotalLength() : Lt(this.attrs.path);
      }, St.getPointAtLength = function (e) {
        if ("path" == this.type) return Nt(this.attrs.path, e);
      };
      var Dt = u.easing_formulas = {
        linear: function linear(e) {
          return e;
        },
        "<": function _(e) {
          return se(e, 1.7);
        },
        ">": function _(e) {
          return se(e, .48);
        },
        "<>": function _(e) {
          var t = .48 - e / 1.04,
              n = ue(.1734 + t * t),
              r = n - t,
              o = -n - t,
              i = se(ae(r), 1 / 3) * (r < 0 ? -1 : 1) + se(ae(o), 1 / 3) * (o < 0 ? -1 : 1) + .5;
          return 3 * (1 - i) * i * i + i * i * i;
        },
        backIn: function backIn(e) {
          var t = 1.70158;
          return e * e * ((t + 1) * e - t);
        },
        backOut: function backOut(e) {
          var t = 1.70158;
          return (e -= 1) * e * ((t + 1) * e + t) + 1;
        },
        elastic: function elastic(e) {
          return e === !!e ? e : se(2, -10 * e) * ce(2 * fe * (e - .075) / .3) + 1;
        },
        bounce: function bounce(e) {
          var t = 7.5625,
              n = 2.75;
          return e < 1 / n ? t * e * e : e < 2 / n ? t * (e -= 1.5 / n) * e + .75 : e < 2.5 / n ? t * (e -= 2.25 / n) * e + .9375 : t * (e -= 2.625 / n) * e + .984375;
        },
        oneBounceOut: function oneBounceOut(e) {
          return e <= .9 ? 1.33 * Dt.easeIn(e) : 1.2 - e / 5;
        },
        elasticOnce: function elasticOnce(e) {
          return e === !!e ? e : Math.pow(2, -10 * e) * Math.sin((e - .225) * (2 * Math.PI) / .9) + 1;
        },
        easeInQuad: function easeInQuad(e) {
          return e * e;
        },
        easeOutQuad: function easeOutQuad(e) {
          return e * (2 - e);
        },
        easeInOutQuad: function easeInOutQuad(e) {
          return e < .5 ? 2 * e * e : (4 - 2 * e) * e - 1;
        },
        easeInCubic: function easeInCubic(e) {
          return e * e * e;
        },
        easeOutCubic: function easeOutCubic(e) {
          return --e * e * e + 1;
        },
        easeInOutCubic: function easeInOutCubic(e) {
          return e < .5 ? 4 * e * e * e : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1;
        },
        easeInQuart: function easeInQuart(e) {
          return e * e * e * e;
        },
        easeOutQuart: function easeOutQuart(e) {
          return 1 - --e * e * e * e;
        },
        easeInOutQuart: function easeInOutQuart(e) {
          return e < .5 ? 8 * e * e * e * e : 1 - 8 * --e * e * e * e;
        },
        easeInQuint: function easeInQuint(e) {
          return e * e * e * e * e;
        },
        easeOutQuint: function easeOutQuint(e) {
          return 1 + --e * e * e * e * e;
        },
        easeInOutQuint: function easeInOutQuint(e) {
          return e < .5 ? 16 * e * e * e * e * e : 1 + 16 * --e * e * e * e * e;
        }
      };
      Dt.easeIn = Dt["ease-in"] = Dt["<"], Dt.easeOut = Dt["ease-out"] = Dt[">"], Dt.easeInOut = Dt["ease-in-out"] = Dt["<>"], Dt["back-in"] = Dt.backIn, Dt["back-out"] = Dt.backOut;

      var Pt,
          Rt = [],
          jt = function Kt() {
        for (var e, t, n, r = +new Date(), o = 0, a = [], s = 0; o < Rt.length; o++) {
          var l = Rt[o];

          if (!(l.el.removed || l.paused || l.parentEl && l.parentEl.e && l.parentEl.e.paused)) {
            for (var c, d, f, h = r - l.start, p = l.ms, y = l.easing, x = l.from, w = l.diff, C = l.to, _ = (l.t, l.el), S = {}, E = {}, A = !u.stopPartialEventPropagation, T = (s = 0, l.el && l.el.animElements && l.el.animElements.peek()); T && T.pos <= h / p;) {
              a.push(l.el.animElements.deq()), T = l.el.animElements.peek();
            }

            if (l.initstatus ? (h = (l.initstatus * l.anim.top - l.prev) / (l.percent - l.prev) * p, l.status = l.initstatus, delete l.initstatus, l.stop && (delete l.el, Rt.splice(o--, 1))) : l.status = (l.prev + (l.percent - l.prev) * (h / p)) / l.anim.top, d = p, l.parentEl && l.parentEl.animElements ? (p = l.delayend - l.delaystart, h = l.parentEl.cPos - l.delaystart) : l.el.animElements && (l.el.cPos = h / p), !(h < 0)) if (h < p) {
              var M = y(h / p);

              for (var O in p = d, x) {
                if (x[v](O)) {
                  switch (Oe[O]) {
                    case "number":
                      c = +x[O] + M * p * w[O];
                      break;

                    case "colour":
                      if (w[O].length) {
                        for (c = [], s = 0, F = x[O].length; s < F; ++s) {
                          0 === s ? x[O].isRadial || w[O].isRadial ? (n = "xr(", n += x[O][0].f1 * (1 - M) + w[O][0].f1 * M || g, n += ",", n += x[O][0].f2 * (1 - M) + w[O][0].f2 * M || g, n += ",", n += 100 * (x[O][0].f3 * (1 - M) + w[O][0].f3 * M) || g, n += "%,", n += x[O][0].f4 * (1 - M) + w[O][0].f4 * M || g, n += ",", n += x[O][0].f5 * (1 - M) + w[O][0].f5 * M, n += ",", n += x[O][0].f6, n += ")", c.push(n)) : (c.push(x[O][s] * (1 - M) + M * w[O][s]), c[0] <= 0 && (c[0] += 360)) : c.push("rgba(" + [Vt(de(x[O][s].r + M * p * w[O][s].r)), Vt(de(x[O][s].g + M * p * w[O][s].g)), Vt(de(x[O][s].b + M * p * w[O][s].b)), x[O][s].opacity + M * p * w[O][s].opacity].join(",") + "):" + x[O][s].position);
                        }

                        c = c.join("-"), (x[O].isRadial || w[O].isRadial) && (c = c.replace("-", g));
                      } else t = x[O].opacity + M * p * w[O].opacity, isNaN(t) && (t = 1), c = "rgba(" + [Vt(de(x[O].r + M * p * w[O].r)), Vt(de(x[O].g + M * p * w[O].g)), Vt(de(x[O].b + M * p * w[O].b)), t].join(",") + ")";

                      break;

                    case "path":
                      c = [];
                      s = 0;

                      for (var F = x[O].length; s < F; s++) {
                        var I;
                        c[s] = [x[O][s][0]], I = x[O][s] ? x[O][s].length : 0;

                        for (var L = 1; L < I; L++) {
                          c[s][L] = (+x[O][s][L] + M * p * w[O][s][L]).toFixed(4);
                        }

                        c[s] = c[s].join(m);
                      }

                      c = c.join(m);
                      break;

                    case "transform":
                      if (w[O].real) for (c = [], s = 0, F = x[O].length; s < F; s++) {
                        for (c[s] = [x[O][s][0]], L = 1, I = x[O][s].length; L < I; L++) {
                          c[s][L] = x[O][s][L] + M * p * w[O][s][L];
                        }
                      } else {
                        var N = function N(e) {
                          return +x[O][e] + M * p * w[O][e];
                        };

                        c = [[z, N(0), N(1), N(2), N(3), N(4), N(5)]];
                      }
                      break;

                    case "csv":
                      if ("clip-rect" === O) for (c = [], s = 4; s--;) {
                        c[s] = +x[O][s] + M * p * w[O][s];
                      }
                      break;

                    case "text-bound":
                      c = [][b](x[O]);
                      break;

                    default:
                      var D = [][b](x[O]);

                      for (c = [], s = _.ca[O].length; s--;) {
                        c[s] = +D[s] + M * p * w[O][s];
                      }

                  }

                  S[O] = c;
                }
              }

              _.attr(S), A && function (e, t, n) {
                setTimeout(function () {
                  (0, i["default"])("raphael.anim.frame." + e, t, n);
                });
              }(_.id, _, l.anim);
            } else {
              if (function (e, t, n) {
                setTimeout(function () {
                  A && (0, i["default"])("raphael.anim.frame." + t.id, t, n), A && (0, i["default"])("raphael.anim.finish." + t.id, t, n), u.is(e, k) && e.call(t);
                });
              }(l.callback, _, l.anim), _.attr(C), delete l.el, Rt.splice(o--, 1), l.repeat > 1 && !l.next) {
                for (f in C) {
                  C[v](f) && (E[f] = l.totalOrigin[f]);
                }

                l.el.attr(E), Wt(l.anim, l.el, l.anim.percents[0], null, l.totalOrigin, l.repeat - 1);
              }

              l.next && !l.stop && Wt(l.anim, l.el, l.next, null, l.totalOrigin, l.repeat);
            }
          }
        }

        for (u.svg && _ && _.paper && _.paper.safari(), o = 0, e = a.length; o < e; ++o) {
          u.getInstantAnimFrameFn()(function (e) {
            return function () {
              Wt.apply(null, a[e].params);
            };
          }(o));
        }

        Rt.length && (Pt || u.getAnimFrameFn())(Kt);
      },
          Vt = function Vt(e) {
        return e > 255 ? 255 : e < 0 ? 0 : e;
      },
          Bt = function Bt(e) {
        return e > 1 && (e = 1), e < 0 && (e = 0), e;
      };

      function Ht(e, t, n, r, o, i) {
        var a = 3 * t,
            s = 3 * (r - t) - a,
            l = 1 - a - s,
            c = 3 * n,
            u = 3 * (o - n) - c,
            d = 1 - c - u;

        function f(e) {
          return ((l * e + s) * e + a) * e;
        }

        return function (e, t) {
          var n = function (e, t) {
            var n, r, o, i, c, u;

            for (o = e, u = 0; u < 8; u++) {
              if (i = f(o) - e, ae(i) < t) return o;
              if (ae(c = (3 * l * o + 2 * s) * o + a) < 1e-6) break;
              o -= i / c;
            }

            if (r = 1, (o = e) < (n = 0)) return n;
            if (o > r) return r;

            for (; n < r;) {
              if (i = f(o), ae(i - e) < t) return o;
              e > i ? n = o : r = o, o = (r - n) / 2 + n;
            }

            return o;
          }(e, t);

          return ((d * n + u) * n + c) * n;
        }(e, 1 / (200 * i));
      }

      function Gt(e, t) {
        var n = [],
            r = {};

        if (this.ms = t, this.times = 1, e) {
          for (var o in e) {
            e[v](o) && (r[te(o)] = e[o], n.push(te(o)));
          }

          n.sort(Ie);
        }

        this.anim = r, this.top = n[n.length - 1], this.percents = n;
      }

      u.getAnimFrameFn = function () {
        return Pt = u.requestAnimFrame || c.webkitRequestAnimationFrame || c.mozRequestAnimationFrame || c.oRequestAnimationFrame || c.msRequestAnimationFrame || function (e) {
          setTimeout(e, 16);
        };
      }, u.getInstantAnimFrameFn = function () {
        return u.instantRequestAnimFrame || c.webkitRequestAnimationFrame || c.mozRequestAnimationFrame || c.oRequestAnimationFrame || c.msRequestAnimationFrame || function (e) {
          setTimeout(e, 16);
        };
      }, St.animateWith = function (e, t, n, r, o, i, a) {
        var s,
            l = this,
            c = {};

        for (s in a = a || {}) {
          a.hasOwnProperty(s) && (c[s] = a[s]);
        }

        if (a = c, l.removed) return i && i.call(l), l;
        if (0 === r) return u.is(i, k) && setTimeout(function () {
          i.call(l);
        }, 0), l.attr(n);
        var d = n instanceof Gt ? n : u.animation(n, r, o, i);
        a.start = Bt(a.start || 0), a.end = Bt(a.end || 1), a.start >= a.end && (a.start = a.end), !a.from && a.start > .01 ? (e.animElements = e.animElements || new ze(function (e, t) {
          return t.pos - e.pos;
        }), e.animElements.enq({
          pos: a.start,
          attr: a.start === a.end,
          params: [d, l, d.percents[0], null, l.attr(), undefined, e, {
            start: a.start,
            end: a.end,
            smartMorph: a.smartMorph,
            hookFn: a.hookFn
          }, n],
          executeOb: {
            el: this,
            attrs: n,
            callback: i,
            hookFn: a.hookFn
          }
        })) : Wt(d, l, d.percents[0], null, l.attr(), undefined, e, a);

        for (var f = 0, h = Rt.length; f < h; f++) {
          if (Rt[f].anim === t && Rt[f].el === e) {
            Rt[h - 1].start = Rt[f].start;
            break;
          }
        }

        return l;
      }, St.onAnimation = function (e) {
        return e ? i["default"].on("raphael.anim.frame." + this.id, e) : i["default"].unbind("raphael.anim.frame." + this.id), this;
      }, Gt.prototype.delay = function (e) {
        var t = new Gt(this.anim, this.ms);
        return t.times = this.times, t.del = +e || 0, t;
      }, Gt.prototype.repeat = function (e) {
        var t = new Gt(this.anim, this.ms);
        return t.del = this.del, t.times = re.floor(oe(e, 0)) || 1, t;
      };

      var zt = function Jt(e, t, n) {
        e.isRadial && !t.isRadial && (+t[0], t[0] = {
          f1: 0,
          f2: 0,
          f3: 0,
          f4: 0,
          f5: 0,
          f6: g
        }, t.isRadial = !0), n || Jt(t, e, !0);
      };

      function Ut(e, t, n) {
        var r,
            o,
            i = 0,
            a = 0,
            s = [],
            l = [],
            c = {},
            u = 0,
            d = [];
        if (e = e.constructor === Array ? e[0] : e, t = t.constructor === Array ? t[0] : t, r = e.split("-"), o = t.split("-"), 1 === r.length && 1 === o.length) return [e, t];

        for (r = f(r), o = f(o), !r.defaultAngleSet && o.defaultAngleSet && (o[0] = r[0]), !o.defaultAngleSet && r.defaultAngleSet && (r[0] = o[0]), zt(r, o), i = 1, a = r.length; i < a; ++i) {
          u = r[i].position, d.push(u);
        }

        for (i = 1, a = o.length; i < a; ++i) {
          u = o[i].position, -1 === d.indexOf(u) && d.push(u);
        }

        for (d.push(0), d.sort(function (e, t) {
          return e - t;
        }), s = [r[0]], i = 1, a = d.length; i < a; ++i) {
          u = d[i], c = r.getColorAtPosition(u), s.push(c);
        }

        for (l = [o[0]], i = 1, a = d.length; i < a; ++i) {
          u = d[i], c = o.getColorAtPosition(u), l.push(c);
        }

        return s.isRadial = r.isRadial, l.isRadial = o.isRadial, [s, l];

        function f(e) {
          var t,
              r = 0,
              o = 0,
              i = 0,
              a = [],
              s = {},
              l = 0,
              c = 0,
              u = 0,
              d = 0,
              f = 0,
              h = 0,
              p = {
            f1: .5,
            f2: .5
          };

          for (1 === e.length && (e[0] === E && (e[0] = "rgba(0,0,0,0)"), e.unshift(0), e.defaultAngleSet = !0), isNaN(e[0]) ? ~"rx".indexOf(e[0].charAt(0)) ? (e.isRadial = !0, d = 1, -1 !== e[0].indexOf(")") && (d = e[0].indexOf(")"), f = e[0].indexOf("(") + 1, h = d, a = e[0].substr(f, h - f).split(","), p.f1 = parseFloat(a[0]) || 0, p.f2 = parseFloat(a[1]) || 0, ~a[2].indexOf("%") && (a[2] = parseFloat(a[2]) / 100), p.f3 = parseFloat(a[2]) || 0, p.f4 = parseFloat(a[3]) || 0, p.f5 = parseFloat(a[4]) || 0, p.f6 = a[5]), e[0] = e[0].substr(h + 1), e.unshift(p)) : e[0] = 0 : e[0] = +e[0], r = 1, o = e.length; r < o; ++r) {
            a = e[r].split(":"), s = n(a[0]), e[r] = {}, e[r].r = s.r, e[r].g = s.g, e[r].b = s.b, e[r].opacity = s.opacity, e[r].opacity = +e[r].opacity, isNaN(e[r].opacity) && (e[r].opacity = 1), e[r].position = +a[1];
          }

          if (e.sort(function (e, t) {
            return "number" == typeof e || e.f1 ? -1 : "number" == typeof t || e.f2 ? 1 : isNaN(e.position) && isNaN(t.position) ? 0 : isNaN(e.position) ? -1 : isNaN(t.position) ? 1 : e.position - t.position;
          }), 0 != +e[1].position) if (isNaN(e[1].position)) e[1].position = 0;else {
            for (t in s = {}, e[1]) {
              s[t] = e[1][t];
            }

            for (s.position = 0, e.push({}), r = e.length - 1; 1 !== r; --r) {
              e[r] = e[r - 1];
            }

            e[1] = s;
          }
          if (100 !== e[o = e.length - 1].position) if (isNaN(e[o].position)) e[o].position = 100;else {
            for (t in s = {}, e[o]) {
              s[t] = e[o][t];
            }

            s.position = 100, e.push(s);
          }

          for (r = 2, o = e.length; r < o; ++r) {
            if (!e[r].position) {
              for (l = e[r - 1].position, u = 1, i = r + 1; i < o; ++i) {
                if (++u, !isNaN(e[i].position)) {
                  c = +e[i].position;
                  break;
                }
              }

              e[r].position = l + (c - l) / u;
            }
          }

          return e.getColorAtPosition = function (e) {
            for (var t = -1, n = this.length, r = 1, o = this.length, i = 0, a = g, s = {
              r: 0,
              g: 0,
              b: 0
            }; r < o - 1; ++r) {
              if (this[r].position <= e && (t = r, n = r + 1), !(this[r].position < e) && this[r].position >= e) {
                n = r;
                break;
              }
            }

            for (a in i = (e - this[t].position) / (this[n].position - this[t].position), isNaN(i) && (i = 0), s) {
              s[a] = Vt((1 - i) * this[t][a] + i * this[n][a]);
            }

            return s.position = e, s.opacity = (1 - i) * this[t].opacity + i * this[n].opacity, s;
          }, e;
        }
      }

      function $t(e, t) {
        var n,
            r = [],
            i = [],
            a = f(e),
            s = f(t),
            l = 0,
            c = 0,
            u = document.createElementNS && document.createElementNS.bind(document),
            d = u && u("http://www.w3.org/2000/svg", "path");
        if (!a || !s || !d) return [e, t];
        if (function (e, t) {
          var n,
              r,
              o = g,
              i = g;
          if (d.setAttribute("d", "M300 10 L300 300 C50 310,50 640,350 650C600 640,600 310,400 300 L400 10 L295 10"), n = d.getTotalLength(), r = d.getPointAtLength(10), n < 1829.1 || n > 1829.2) return !0;
          if (300 !== Math.round(r.x) || 20 !== Math.round(r.y)) return !0;

          function a(e) {
            for (var t = e.length; t-- - 1 && e[t].join(g) === e[t - 1].join(g);) {
              e.pop();
            }
          }

          function s(e) {
            for (var t = g, n = 0, r = e.length; n < r; ++n) {
              t += e[n].join(m);
            }

            return t;
          }

          if (a(e), a(t), o = s(e), i = s(t), o.split(/[Mm]/).length > 2 || i.split(/[Mm]/).length > 2) return !1;
          if (e.length === t.length) return !0;
          return !1;
        }(e, t)) return [e, t];
        if (!e || !t) return [e, t];
        if (!document.createElementNS) return [e, t];
        if (a = f(e), s = f(t), -1 !== a.join().indexOf("undefined")) return [e, t];
        if (-1 !== s.join().indexOf("undefined")) return [e, t];
        if (!d.getTotalLength || !d.getPointAtLength) return [e, t];

        function f(e) {
          var t = [],
              n = 0,
              r = e.length;
          if ((void 0 === e ? "undefined" : o(e)) === w) return e;

          for (n = 0; n < r; ++n) {
            if (!e[n].join) return;
            n && e[n + 1] && "M" === e[n + 1][0] && "M" === e[n][0] || t.push(e[n].join(m));
          }

          for (n = 0, r = (t = (t = t.join(g)).split(/[Mm]/).slice(1)).length; n < r; ++n) {
            t[n] = "M" + t[n];
          }

          return t;
        }

        for (c = Math.max(a.length, s.length), l = 0; l < c; ++l) {
          n = Xt(a[l], s[l]), a[l] = n[0], s[l] = n[1];
        }

        function h(e) {
          var t,
              n = 0,
              r = [];

          for (t = (e = e || []).length, n = 0; n < t; ++n) {
            e[n].length - 1 && r.push(e[n].join(m));
          }

          return r.join(g);
        }

        function p(e, t) {
          for (var n = e.length; n-- - 1 && e[n].slice(1).toString() === e[n - 1].slice(1).toString();) {
            e.pop();
          }

          1 === e.length && t && (e.length = 0);
        }

        function v(e, t) {
          for (var n, r = [], o = [], i = e.length, a = 0, s = 0, l = 0, c = 0, u = t - i; u >= 0;) {
            a = e.length - 1, e.push(e.slice(a)[0]), --u;
          }

          for (i = e.length, a = 0; a <= t; ++a) {
            o.push(Math.round(a / t * i));
          }

          for (a = 0, n = o.length - 1; a < n; ++a) {
            r.push(e.slice(o[a], o[a + 1])), "M" !== r[a][0][0] && r[a][0][0] !== z && (l = r[a - 1].length - 1, s = r[a - 1][l][1], c = r[a - 1][l][2], r[a].unshift(["M", s, c]));
          }

          return r;
        }

        for (l = a.length; l--;) {
          p(a[l], l), a[l].length || a.pop();
        }

        for (l = s.length; l--;) {
          p(s[l], l), s[l].length || s.pop();
        }

        for (function (e) {
          var t,
              n = [],
              r = [],
              o = [],
              i = 0,
              l = !0;

          if (0 !== e) {
            for (e > 0 ? (n = s, l = !1) : (e = -e, n = a), i = 0, t = n.length; i < t; ++i) {
              r.push(1);
            }

            for (; e--;) {
              --i < 0 && (i = t - 1), r[i]++;
            }

            for (i = 0; i < t; ++i) {
              1 === r[i] ? o.push(n[i]) : o.push.apply(o, v(n[i], r[i]));
            }

            l ? a = o : s = o;
          }
        }(a.length - s.length), c = Math.max(a.length, s.length), l = 0; l < c; ++l) {
          n = Xt(h(a[l]), h(s[l])), a[l] = n[0], s[l] = n[1];
        }

        for (l = 0, c = a.length; l < c; ++l) {
          r = r.concat(a[l]);
        }

        for (l = 0, c = s.length; l < c; ++l) {
          i = i.concat(s[l]);
        }

        return [r, i];
      }

      function Xt(e, t) {
        var n,
            r,
            o,
            i = 0,
            a = [],
            s = [];

        function l(e, t) {
          var n,
              r,
              o,
              i,
              a = 0,
              s = {},
              l = [],
              c = [],
              u = 0,
              d = Math.round;

          for ((n = document.createElementNS("http://www.w3.org/2000/svg", "path")).setAttribute("d", e), (r = document.createElementNS("http://www.w3.org/2000/svg", "path")).setAttribute("d", t), o = n.getTotalLength(), i = r.getTotalLength(), u = .15 * Math.max(o, i), (!(u = Math.ceil(u)) || !isFinite(u) || u < 10) && (u = 10), a = 0; a <= u; ++a) {
            s = n.getPointAtLength(a / u * o), l.push([a ? $ : U, d(s.x), d(s.y)]), s = r.getPointAtLength(a / u * i), c.push([a ? $ : U, d(s.x), d(s.y)]);
          }

          return [l, c];
        }

        for (e && "M  " !== e || (e = t.split(m).slice(0, 3).join(m).replace(/[LC]/, g)), t && "M  " !== t || (t = e.split(m).slice(0, 3).join(m).replace(/[LC]/, g)), r = function (e, t) {
          var n,
              r,
              o,
              i,
              a = 0,
              s = 0,
              l = 0,
              c = 0,
              u = {},
              d = {},
              f = [],
              h = [],
              p = -1,
              v = -1,
              y = !0;

          function b(e) {
            var t,
                n = 0;

            for (n = 0, t = (e = e.split(/[MCLmcl]/).slice(1)).length; n < t; ++n) {
              e[n] = e[n].split(m).slice(1), n || e[n].unshift("M"), n && (2 === e[n].length && e[n].unshift($) || e[n].unshift("C"));
            }

            return e;
          }

          function x(e, t) {
            var n,
                r,
                o = 0,
                i = e.length;

            for (o = 0, i = e.length; o < i; ++o) {
              n = e[o].join(m), "C" === (r = e[o])[0] && r[3] === r[5] && r[4] === r[6] ? e[o].stringValue = [$, r[3], r[4]].join(m) : r.stringValue = n, t[r.stringValue] && t[r.stringValue].push(o), t[r.stringValue] || (t[r.stringValue] = [o]);
            }
          }

          function w(e, t, n, r, o) {
            for (var i, a = n, s = 0, l = 0; a < r; ++a) {
              if (i = t[e[a].stringValue]) for (s = 0, l = i.length; s < l; ++s) {
                if (i[s] >= o) return {
                  index: a,
                  mapValue: i[s],
                  diff: a - n
                };
              }
            }

            return -1;
          }

          function C(e) {
            var t = e.length - 1;
            return ["M", e[t - 1], e[t]].join(m);
          }

          function _(e) {
            return e.join(g);
          }

          for (e = b(e), t = b(t), x(e, u), x(t, d), n = e.length, r = t.length, a = 0, s = 0; a < n && s < r;) {
            if (++v, f[++p] = [], h[v] = [], y = e[a].stringValue === t[s].stringValue, a && (f[p].push(C(e[a - 1])), h[v].push(C(t[s - 1]))), y) for (; a < n && s < r && e[a].stringValue === t[s].stringValue;) {
              f[p].push(e[a].stringValue), h[v].push(t[s].stringValue), ++a, ++s;
            } else {
              for (o = w(e, d, a, n, s), i = w(t, u, s, r, a), l = o.index, c = o.mapValue, (!~o || o.diff > i.diff) && (l = i.mapValue, c = i.index), ~o || ~i || (l = n - 1, c = r - 1); a <= l;) {
                f[p].push(e[a].stringValue), ++a;
              }

              for (; s <= c;) {
                h[v].push(t[s].stringValue), ++s;
              }
            }
            f[p] = _(f[p]), h[v] = _(h[v]);
          }

          if (a < n) {
            for (f[++p] = [], f[p].push(C(e[a - 1])), h[++v] = [], h[v].push(C(t[s - 1])); a < n;) {
              f[p].push(e[a].stringValue), ++a;
            }

            f[p] = _(f[p]);
          }

          if (s < r) {
            for (f[++p] = [], f[p].push(C(e[a - 1])), h[++v] = [], h[v].push(C(t[s - 1])); s < r;) {
              h[v].push(t[s].stringValue), ++s;
            }

            h[v] = _(h[v]);
          }

          return [f, h];
        }(e, t), i = 0, n = r[0].length; i < n; ++i) {
          o = l(r[0][i], r[1][i]), i ? (a = a.concat(o[0].slice(1)), s = s.concat(o[1].slice(1))) : (a = a.concat(o[0]), s = s.concat(o[1]));
        }

        return [a, s];
      }

      function Wt(e, t, n, r, a, s, l, c) {
        n = te(n);
        var d,
            f,
            h,
            p,
            g,
            m,
            y,
            x,
            C = e.ms,
            _ = {},
            k = {},
            A = {};

        if (null !== t.type) {
          if ((c = c || {}).hookFn && c.hookFn.call(t), c.from = c.from || {}, r) for (M = 0, O = Rt.length; M < O; M++) {
            var T = Rt[M];

            if (T.el.id === t.id && T.anim === e) {
              T.percent != n ? (delete T.el.e, delete T.el, Rt.splice(M, 1), h = 1) : f = T, t.attr(T.totalOrigin);
              break;
            }
          } else r = +k;

          for (var M = 0, O = e.percents.length; M < O; M++) {
            if (e.percents[M] === n || e.percents[M] > r * e.top) {
              n = e.percents[M], g = e.percents[M - 1] || 0, C = C / e.top * (n - g), p = e.percents[M + 1], d = e.anim[n];
              break;
            }

            r && t.attr(e.anim[e.percents[M]]);
          }

          if (d) {
            if (f) f.initstatus = r, f.start = new Date() - f.ms * r;else {
              for (var F in d) {
                if (d[v](F)) if (Oe[v](F) || t.ca[F]) {
                  switch (_[F] = c.from[F] || t.attr(F), null == _[F] && (_[F] = Me[F]), k[F] = d[F], x = !1, Oe[F]) {
                    case "number":
                      ((y = k[F] - _[F]) || isNaN(y)) && (x = !0), A[F] = y / C;
                      break;

                    case "colour":
                      if (_[F] === k[F]) break;
                      x = !0;
                      var I = Ut(_[F], k[F], u.getRGB);
                      _[F] = I[0];
                      var L = I[1];
                      if ((void 0 === L ? "undefined" : o(L)) === w) _[F].toLowerCase() !== E ? (_[F] = u.getRGB(_[F]), _[F].opacity || (_[F].opacity = 1)) : _[F] = {
                        r: 0,
                        g: 0,
                        b: 0,
                        opacity: 0
                      }, k[F].toLowerCase() !== E ? (L = u.getRGB(k[F])).opacity || (L.opacity = 1) : L = {
                        r: 0,
                        g: 0,
                        b: 0,
                        opacity: 0
                      }, A[F] = {
                        r: (L.r - _[F].r) / C,
                        g: (L.g - _[F].g) / C,
                        b: (L.b - _[F].b) / C,
                        opacity: (L.opacity - _[F].opacity) / C
                      };else for (A[F] = [], M = 0, O = _[F].length; M < O; ++M) {
                        0 === M ? A[F].push(L[0]) : A[F].push({
                          r: (L[M].r - _[F][M].r) / C,
                          g: (L[M].g - _[F][M].g) / C,
                          b: (L[M].b - _[F][M].b) / C,
                          opacity: (L[M].opacity - _[F][M].opacity) / C
                        });
                      }
                      break;

                    case "path":
                      var N,
                          D = lt(_[F], k[F]);

                      for (c.smartMorph && (D = $t(D[0], D[1])), N = D[1], _[F] = D[0], A[F] = [], M = 0, O = _[F].length; M < O; M++) {
                        var P;
                        A[F][M] = [0], P = _[F][M] ? _[F][M].length : 0;

                        for (var R = 1; R < P; R++) {
                          A[F][M][R] = (N[M][R] - _[F][M][R]) / C, !x && A[F][M][R] && (x = !0);
                        }
                      }

                      break;

                    case "transform":
                      var j = t._,
                          V = ft(j[F], k[F]);
                      if (x = !0, V) for (_[F] = V.from, k[F] = V.to, A[F] = [], A[F].real = !0, M = 0, O = _[F].length; M < O; M++) {
                        for (A[F][M] = [_[F][M][0]], R = 1, P = _[F][M].length; R < P; R++) {
                          A[F][M][R] = (k[F][M][R] - _[F][M][R]) / C;
                        }
                      } else {
                        var B = t.matrix || new ht(),
                            H = {
                          _: {
                            transform: j.transform
                          },
                          getBBox: function getBBox() {
                            return t.getBBox(1);
                          }
                        };
                        _[F] = [B.a, B.b, B.c, B.d, B.e, B.f], ut(H, k[F]), k[F] = H._.transform, A[F] = [(H.matrix.a - B.a) / C, (H.matrix.b - B.b) / C, (H.matrix.c - B.c) / C, (H.matrix.d - B.d) / C, (H.matrix.e - B.e) / C, (H.matrix.f - B.f) / C];
                      }
                      break;

                    case "csv":
                      var G = ee(d[F])[S](ye),
                          z = ee(_[F])[S](ye);
                      if ("clip-rect" === F) for (_[F] = z, A[F] = [], M = z.length; M--;) {
                        ((y = G[M] - _[F][M]) || isNaN(y)) && (x = !0), A[F][M] = y / C;
                      }
                      k[F] = G;
                      break;

                    default:
                      for (G = [][b](d[F]), z = [][b](_[F]), A[F] = [], M = t.ca[F].length; M--;) {
                        ((y = (G[M] || 0) - (z[M] || 0)) || isNaN(y)) && (x = !0), A[F][M] = y / C;
                      }

                  }

                  x || (delete _[F], delete k[F], delete d[F], delete A[F]);
                } else (u._availableAttrs[v](F) || "text" === F || t.ca[F]) && (t.attr(F, d[F]), delete d[F]);
              }

              var U = d.easing,
                  $ = u.easing_formulas[U];
              if (!$) if (($ = ee(U).match(we)) && 5 === $.length) {
                var X = $;

                $ = function $(e) {
                  return Ht(e, +X[1], +X[2], +X[3], +X[4], C);
                };
              } else $ = Le;
              if (m = d.start || e.start || +new Date(), t.e = T = {
                anim: e,
                percent: n,
                timestamp: m,
                start: m + (e.del || 0),
                status: 0,
                initstatus: r || 0,
                stop: !1,
                ms: C,
                easing: $,
                from: _,
                diff: A,
                to: k,
                el: t,
                callback: d.callback,
                prev: g,
                next: p,
                repeat: s || e.times,
                origin: t.attr(),
                totalOrigin: a,
                parentEl: l,
                delayend: c && c.end,
                delaystart: c && c.start
              }, Rt.push(T), r && !f && !h && (T.stop = !0, T.start = new Date() - C * r, 1 === Rt.length)) return jt();
              h && (T.start = new Date() - T.ms * r), 1 === Rt.length && (Pt || u.getAnimFrameFn())(jt);
            }
            (0, i["default"])("raphael.anim.start." + t.id, t, e);
          }
        }
      }

      function Yt(e) {
        for (var t = 0; t < Rt.length; t++) {
          Rt[t].el.paper === e && Rt.splice(t--, 1);
        }
      }

      u.animation = function (e, t, n, r, o) {
        if (e instanceof Gt) return e;
        !u.is(n, k) && n || (r = r || n || null, n = null), !u.stopPartialEventPropagation && (u.stopPartialEventPropagation = o), e = Object(e), t = +t || 0;
        var i,
            a,
            s = {};

        for (a in e) {
          e[v](a) && te(a) != a && te(a) + "%" != a && (i = !0, s[a] = e[a]);
        }

        return r && (i = !0), i ? (n && (s.easing = n), r && (s.callback = r), new Gt({
          100: s
        }, t)) : new Gt(e, t);
      }, St.animate = function (e, t, n, r) {
        if (this.removed) return r && r.call(this), this;
        var o = e instanceof Gt ? e : u.animation(e, t, n, r);
        return Wt(o, this, o.percents[0], null, this.attr()), this;
      }, St.status = function (e, t) {
        var n,
            r,
            o = [],
            i = 0;
        if (null != t) return Wt(e, this, -1, ie(t, 1)), this;

        for (n = Rt.length; i < n; i++) {
          if ((r = Rt[i]).el.id === this.id && (!e || r.anim === e)) {
            if (e) return r.status;
            o.push({
              anim: r.anim,
              status: r.status
            });
          }
        }

        return e ? 0 : o;
      }, St.pause = function (e, t) {
        var n,
            r,
            o = +new Date();

        for (r = 0; r < Rt.length; r++) {
          !((n = Rt[r]).el.id === this.id || t && n.parentEl && n.parentEl.e.el && n.parentEl.e.el.id === this.id) || e && n.anim !== e || !1 !== (0, i["default"])("raphael.anim.pause." + this.id, this, n.anim) && (n.paused = !0, n.pauseStart = o);
        }

        return this;
      }, St.resume = function (e, t) {
        var n,
            r,
            o = +new Date();

        for (r = 0; r < Rt.length; r++) {
          !((n = Rt[r]).el.id === this.id || t && n.parentEl && n.parentEl.e.el && n.parentEl.e.el.id === this.id) || e && n.anim !== e || !1 !== (0, i["default"])("raphael.anim.resume." + this.id, this, n.anim) && (delete n.paused, n.el.status(n.anim, n.status), n.pauseEnd = o, n.start += (n.parentEl && n.parentEl.e.pauseEnd || n.pauseEnd) - (n.parentEl && n.parentEl.e.pauseStart || n.pauseStart) || 0);
        }

        return this;
      }, St.stop = function (e, t, n) {
        var r, o;
        if (t) for (a = Rt.length - 1; a >= 0; a--) {
          !((r = Rt[a]).el.id === this.id || r.parentEl && r.parentEl.id === this.id) || e && Rt[a].anim !== e || (o = r.el, n && o.attr(r.to), r.callback && r.callback.call(o), delete o.e, delete r.el, Rt.splice(a, 1));
        } else for (var a = 0; a < Rt.length; a++) {
          (r = Rt[a]).el.id !== this.id || e && r.anim !== e || !1 !== (0, i["default"])("raphael.anim.stop." + this.id, this, r.anim) && Rt.splice(a--, 1);
        }
        return this.animElements && function (e) {
          var t;

          for (; t = e.deq();) {
            (t = t.executeOb).hookFn && t.hookFn.call(t.el), t.el.attr(t.attrs), t.callback && t.callback.call(t.el);
          }
        }(this.animElements), this;
      }, i["default"].on("raphael.remove", Yt), i["default"].on("raphael.clear", Yt), St.toString = function () {
        return "Raphaël’s object";
      }, St.toFront = function () {
        if (this.removed) return this;

        var e,
            t,
            n,
            r = this,
            o = u._engine.getNode(r),
            i = r.parent,
            a = r.followers;

        for (u._tofront(r, i) && i.canvas.appendChild(o), t = 0, n = a.length; t < n; t++) {
          (e = a[t]).stalk && e.el[e.stalk](r);
        }

        return r;
      }, St.toBack = function () {
        if (this.removed) return this;

        var e,
            t,
            n,
            r = this,
            o = u._engine.getNode(r),
            i = r.parent,
            a = r.followers;

        for (u._toback(r, i) && i.canvas.insertBefore(o, i.canvas.firstChild), t = 0, n = a.length; t < n; t++) {
          (e = a[t]).stalk && e.el[e.stalk](r);
        }

        return r;
      }, St.insertAfter = function (e) {
        if (this.removed) return this;

        var t,
            n,
            r,
            o = this,
            i = u._engine.getNode(o),
            a = u._engine.getLastNode(e),
            s = e.parent.canvas,
            l = o.followers;

        for (a.nextSibling ? s.insertBefore(i, a.nextSibling) : s.appendChild(i), u._insertafter(o, e, o.parent, e.parent), n = 0, r = l.length; n < r; n++) {
          (t = l[n]).stalk && t.el[t.stalk](e);
        }

        return o;
      }, St.insertBefore = function (e) {
        if (this.removed) return this;

        var t,
            n,
            r,
            o = this,
            i = u._engine.getNode(o),
            a = u._engine.getNode(e),
            s = o.followers;

        for (e.parent.canvas.insertBefore(i, a), u._insertbefore(o, e, o.parent, e.parent), o.parent = e.parent, n = 0, r = s.length; n < r; n++) {
          (t = s[n]).stalk && t.el[t.stalk](e);
        }

        return this;
      }, St.appendChild = function (e) {
        if (this.removed || "group" !== this.type) return this;
        var t,
            n,
            r,
            o,
            i = this.followers;
        if (e.parent === this) return e.toFront(), this;

        for (n = u._engine.getNode(e), u._tear(e, e.parent), this.canvas.appendChild(n), e.parent = this, !this.bottom && (this.bottom = e), e.prev = this.top, e.next = null, this.top && (this.top.next = e), this.top = e, r = 0, o = i.length; r < o; r++) {
          (t = i[r]).stalk && t.el[t.stalk](e);
        }

        return this;
      }, St.appendTo = function (e) {
        return e.appendChild(this);
      }, St.removeChild = function (e) {
        if (this.removed || "group" !== this.type || e.parent !== this) return this;

        var t = this,
            n = u._engine.getNode(e),
            r = t.paper;

        return u._tear(e, t), r.canvas.appendChild(n), t.parent = r, !r.bottom && (r.bottom = t), t.prev = r.top, r.top && (r.top.next = t), r.top = t, t.next = null, t;
      }, u.format = function (e, t) {
        var n = (0, a.getArrayCopy)(arguments),
            r = u.is(t, C) ? [0][b](t) : n;
        return e && u.is(e, w) && r.length - 1 && (e = e.replace(be, function (e, t) {
          return null == r[++t] ? g : r[t];
        })), e || g;
      };
      var qt = u.vml ? .5 : 0;
      u.crispBound = (0, a.cacher)(function (e, t, n, r, o) {
        var i,
            a = {};
        return e = e || 0, t = t || 0, n = n || 0, r = r || 0, i = (o = o || 0) % 2 / 2 + qt, a.x = de(e + i) - i, a.y = de(t + i) - i, a.width = de(e + n + i) - i - a.x, a.height = de(t + r + i) - i - a.y, a["stroke-width"] = o, 0 === a.width && 0 !== n && (a.width = 1), 0 === a.height && 0 !== r && (a.height = 1), a;
      }, u), St.crisp = function () {
        var e,
            t = this,
            n = t.attrs,
            r = t.attr();

        for (e in r = u.crispBound(r.x, r.y, r.width, r.height, r["stroke-width"])) {
          n[e] === r[e] && delete r[e];
        }

        return t.attr(r);
      }, u.define = function (e, t, n, r, o, i) {
        var s, l;
        if (u.is(e, C)) for (s = 0, l = e.length; s < l; s++) {
          u.define(e[s]);
        } else if (u.is(e, _)) u.define(e.name, e[e.name], e.ca, e.fn, e.e, e.data);else if (e && !u.fn[e]) return u.fn[e] = function () {
          var i,
              s = (0, a.getArrayCopy)(arguments),
              l = t.apply(this, s);
          if (r && u.is(r, _)) for (i in r) {
            l[i] = r[i];
          }
          if (o && u.is(o, _)) for (i in o) {
            l[i] && l[i](o[i]);
          }

          if (n) {
            if (u.is(n, k)) l.ca[e] = n;else for (i in n) {
              l.ca[i] = n[i];
            }
            l.ca[e] && (u._lastArgIfGroup(s, !0), s.length && (s[0][e] ? l.attr.apply(l, s) : l.attr(e, s[0])));
          }

          return l;
        }, n && (u.fn[e].ca = n), r && (u.fn[e].fn = r), o && (u.fn[e].e = o), i && (u.fn[e].data = i), u.fn[e];
      }, function (e, t, _n2) {
        null == e.readyState && e.addEventListener && (e.addEventListener("DOMContentLoaded", _n2 = function n() {
          e.removeEventListener("DOMContentLoaded", _n2, !1), e.readyState = "complete";
        }, !1), e.readyState = "loading"), function r() {
          /in/.test(e.readyState) ? setTimeout(r, 9) : u.eve("raphael.DOMload");
        }();
      }(L), i["default"].on("raphael.DOMload", function () {
        d = !0;
      }), u._preload = function (e, t) {
        var n = I.doc,
            r = n.createElement("img");
        r.style.cssText = "position:absolute;left:-9999em;top:-9999em", r.onload = function () {
          t.call(this), this.onload = null, n.body.removeChild(this);
        }, r.onerror = function () {
          n.body.removeChild(this);
        }, n.body.appendChild(r), r.src = e;
      }, t["default"] = u;
    }).call(this, n(118));
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      t.__esModule = !0;
      var r = n(128);

      t["default"] = function (e) {
        var t,
            n,
            o = "hasOwnProperty",
            i = /[\.\/]/,
            a = /\s*,\s*/,
            s = function s(e, t) {
          return e - t;
        },
            l = {
          n: {}
        },
            c = function c() {
          for (var e = 0, t = this.length; e < t; e++) {
            if ("undefined" != typeof this[e]) return this[e];
          }
        },
            u = function u() {
          for (var e = this.length; --e;) {
            if ("undefined" != typeof this[e]) return this[e];
          }
        },
            d = Object.prototype.toString,
            f = String,
            h = Array.isArray || function (e) {
          return e instanceof Array || "[object Array]" == d.call(e);
        };

        function p(e, o) {
          var i,
              a = n,
              l = (0, r.getArrayCopy)(arguments),
              d = Array.prototype.slice.call(l, 2),
              f = p.listeners(e),
              h = 0,
              g = [],
              m = {},
              v = [],
              y = t;
          v.firstDefined = c, v.lastDefined = u, t = e, n = 0;

          for (var b = 0, x = f.length; b < x; b++) {
            "zIndex" in f[b] && (g.push(f[b].zIndex), f[b].zIndex < 0 && (m[f[b].zIndex] = f[b]));
          }

          for (g.sort(s); g[h] < 0;) {
            if (i = m[g[h++]], v.push(i.apply(o, d)), n) return n = a, v;
          }

          for (b = 0; b < x; b++) {
            if ("zIndex" in (i = f[b])) {
              if (i.zIndex == g[h]) {
                if (v.push(i.apply(o, d)), n) break;

                do {
                  if ((i = m[g[++h]]) && v.push(i.apply(o, d)), n) break;
                } while (i);
              } else m[i.zIndex] = i;
            } else if (v.push(i.apply(o, d)), n) break;
          }

          return n = a, t = y, v;
        }

        return p._events = l, p.listeners = function (e) {
          var t,
              n,
              r,
              o,
              a,
              s,
              c,
              u,
              d = h(e) ? e : e.split(i),
              f = l,
              p = [f],
              g = [];

          for (o = 0, a = d.length; o < a; o++) {
            for (u = [], s = 0, c = p.length; s < c; s++) {
              for (n = [(f = p[s].n)[d[o]], f["*"]], r = 2; r--;) {
                (t = n[r]) && (u.push(t), g = g.concat(t.f || []));
              }
            }

            p = u;
          }

          return g;
        }, p.separator = function (e) {
          e ? (e = "[" + (e = f(e).replace(/(?=[\.\^\]\[\-])/g, "\\")) + "]", i = new RegExp(e)) : i = /[\.\/]/;
        }, p.on = function (e, t) {
          if ("function" != typeof t) return function () {};

          for (var n = h(e) ? h(e[0]) ? e : [e] : f(e).split(a), r = 0, o = n.length; r < o; r++) {
            !function (e) {
              for (var n, r = h(e) ? e : f(e).split(i), o = l, a = 0, s = r.length; a < s; a++) {
                o = (o = o.n).hasOwnProperty(r[a]) && o[r[a]] || (o[r[a]] = {
                  n: {}
                });
              }

              for (o.f = o.f || [], a = 0, s = o.f.length; a < s; a++) {
                if (o.f[a] == t) {
                  n = !0;
                  break;
                }
              }

              !n && o.f.push(t);
            }(n[r]);
          }

          return function (e) {
            +e == +e && (t.zIndex = +e);
          };
        }, p.f = function (e) {
          var t = (0, r.getArrayCopy)(arguments),
              n = [].slice.call(t, 1);
          return function () {
            p.apply(null, [e, null].concat(n).concat([].slice.call(t, 0)));
          };
        }, p.stop = function () {
          n = 1;
        }, p.nt = function (e) {
          var n = h(t) ? t.join(".") : t;
          return e ? new RegExp("(?:\\.|\\/|^)" + e + "(?:\\.|\\/|$)").test(n) : n;
        }, p.nts = function () {
          return h(t) ? t : t.split(i);
        }, p.off = p.unbind = function (e, t) {
          if (e) {
            var n = h(e) ? h(e[0]) ? e : [e] : f(e).split(a);
            if (n.length > 1) for (var r = 0, s = n.length; r < s; r++) {
              p.off(n[r], t);
            } else {
              n = h(e) ? e : f(e).split(i);
              var c,
                  u,
                  d,
                  g,
                  m,
                  v = [l],
                  y = [];

              for (r = 0, s = n.length; r < s; r++) {
                for (g = 0; g < v.length; g += d.length - 2) {
                  if (d = [g, 1], c = v[g].n, "*" != n[r]) c[n[r]] && (d.push(c[n[r]]), y.unshift({
                    n: c,
                    name: n[r]
                  }));else for (u in c) {
                    c[o](u) && (d.push(c[u]), y.unshift({
                      n: c,
                      name: u
                    }));
                  }
                  v.splice.apply(v, d);
                }
              }

              for (r = 0, s = v.length; r < s; r++) {
                for (c = v[r]; c.n;) {
                  if (t) {
                    if (c.f) {
                      for (g = 0, m = c.f.length; g < m; g++) {
                        if (c.f[g] == t) {
                          c.f.splice(g, 1);
                          break;
                        }
                      }

                      !c.f.length && delete c.f;
                    }

                    for (u in c.n) {
                      if (c.n[o](u) && c.n[u].f) {
                        var b = c.n[u].f;

                        for (g = 0, m = b.length; g < m; g++) {
                          if (b[g] == t) {
                            b.splice(g, 1);
                            break;
                          }
                        }

                        !b.length && delete c.n[u].f;
                      }
                    }
                  } else for (u in delete c.f, c.n) {
                    c.n[o](u) && c.n[u].f && delete c.n[u].f;
                  }

                  c = c.n;
                }
              }

              e: for (r = 0, s = y.length; r < s; r++) {
                for (u in (c = y[r]).n[c.name].f) {
                  continue e;
                }

                for (u in c.n[c.name].n) {
                  continue e;
                }

                delete c.n[c.name];
              }
            }
          } else p._events = l = {
            n: {}
          };
        }, p.once = function (e, t) {
          return p.on(e, function n() {
            return p.off(e, n), t.apply(this, arguments);
          });
        }, p.version = "0.5.3", p.toString = function () {
          return "You are running Eve 0.5.3";
        }, e.eve = p, p;
      }("undefined" != typeof window ? window : void 0 !== e ? e : null);
    }).call(this, n(118));
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(152),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    };
    t["default"] = {
      extension: function extension(e) {
        (0, i["default"])(e.getDep("redraphael", "plugin"));
      },
      name: "redraphaelSvg",
      type: "plugin",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };

    t["default"] = function (e) {
      if (e.svg) {
        var t = "hasOwnProperty",
            n = "vertical-align",
            i = "function",
            a = {
          visibility: "hidden",
          "font-size": "0px"
        },
            s = String,
            l = parseFloat,
            c = parseInt,
            u = {
          top: 0,
          bottom: -1,
          middle: -.5
        },
            d = e._g.win.navigator,
            f = !!document.documentMode,
            h = Math,
            p = h.max,
            g = h.abs,
            m = h.pow,
            v = h.sqrt,
            y = /^xlink:/,
            b = /[, ]+/,
            x = /\n|<br\s*?\/?>/i,
            w = /&lt|&gt|<br/i,
            C = Array.prototype.shift,
            _ = !(!/AppleWebKit/.test(d.userAgent) || /Chrome/.test(d.userAgent) && !(d.appVersion.match(/Chrome\/(\d+)\./)[1] < 29)),
            S = e.eve,
            E = "",
            k = " ",
            A = "http://www.w3.org/1999/xlink",
            T = "http://www.w3.org/2000/svg",
            M = (!!d.platform && /iPad|iPhone|iPod/.test(d.platform), {
          block: "M5,0 0,2.5 5,5z",
          classic: "M5,0 0,2.5 5,5 3.5,3 3.5,2z",
          diamond: "M2.5,0 5,2.5 2.5,5 0,2.5z",
          open: "M6,1 1,3.5 6,6",
          oval: "M2.5,0A2.5,2.5,0,0,1,2.5,5 2.5,2.5,0,0,1,2.5,0z"
        }),
            O = {
          speed: "optimizeSpeed",
          crisp: "crispEdges",
          precision: "geometricPrecision"
        },
            F = d.userAgent.toLowerCase(),
            I = !(!(oe = -1 != F.indexOf("msie") && parseInt(F.split("msie")[1])) || 9 !== oe),
            L = e.supportsPointer,
            N = e.supportsTouch,
            D = {},
            P = function P(t, n, r, o) {
          e._preload(r[1], function () {
            var e = this.offsetWidth,
                r = this.offsetHeight;
            G(t, {
              width: e,
              height: r
            }), G(n, {
              width: e,
              height: r
            }), o.safari();
          });
        },
            R = function R(e, t) {
          if (t) for (var n in t) {
            e[n] = t[n];
          }
        },
            j = {
          elementInfo: []
        },
            V = e._g.doc,
            B = (e._g.win, {
          mouseover: "touchstart",
          mousedown: "touchstart",
          mouseup: "touchend",
          mousemove: "touchmove",
          mouseout: "touchend"
        });

        N && V.addEventListener(L ? "pointerover" : "touchstart", function (e) {
          if (j.srcElement && j.srcElement !== (e.srcElement || e.target)) {
            var t,
                n,
                r,
                o = (t = j.elementInfo).length;

            for (r = 0; r < o; r++) {
              (n = t[r]).callback.call(n.el, e);
            }
          }

          j = {
            elementInfo: []
          };
        }, !0), e.toString = function () {
          return "Your browser supports SVG.\nYou are running Raphaël " + this.version;
        }, e._url = E;

        var H = function H(e, t) {
          var n = e.gradient;

          if (n) {
            if (n === t) return;
            n.refCount--, n.refCount || n.parentNode.removeChild(n), delete e.gradient;
          }

          t && (e.gradient = t, t.refCount++);
        },
            G = e._createNode = function (t, n) {
          var o, i;
          if ("string" === (void 0 === t ? "undefined" : r(t)) && (t = e._g.doc.createElementNS(T, t)), n) for (o in n) {
            i = I ? s(n[o]) : n[o], y.test(o) ? t.setAttributeNS(A, o.replace(y, E), i) : t.setAttribute(o, i);
          }
          return t;
        },
            z = {
          userSpaceOnUse: "userSpaceOnUse",
          objectBoundingBox: "objectBoundingBox"
        },
            U = {
          pad: "pad",
          redlect: "reflect",
          repeat: "repeat"
        },
            $ = function $(t, n) {
          if (!t.paper || !t.paper.defs) return 0;

          var r,
              o,
              i,
              a,
              c,
              u,
              d = "linear",
              f = t.paper,
              y = e.getElementID((f.id + "-" + n).replace(/[()\s%:,\xb0#]/g, "_")),
              b = .5,
              x = .5,
              w = t.node,
              C = w.style,
              _ = e._g.doc.getElementById(y);

          if (!_) {
            if (n = (n = s(n).replace(e._radial_gradient, function (e, t) {
              d = "radial", t = t ? t.split(",") : [], a = t[5], c = t[6];
              var n,
                  s,
                  u = t[0],
                  f = t[1],
                  h = t[2],
                  p = t[3],
                  g = t[4],
                  y = u && f;
              return h && (r = /%/.test(h) ? h : l(h)), a === z.userSpaceOnUse ? (y && (b = u, x = f), p && g && (o = p, i = g, y || (b = o, x = i)), E) : (y && (b = l(u), n = 2 * ((x = l(f)) > .5) - 1, (s = m(b - .5, 2)) + m(x - .5, 2) > .25 && s < .25 && (x = v(.25 - s) * n + .5) && .5 !== x && (x = x.toFixed(5) - 1e-5 * n)), p && g && (o = l(p), n = 2 * ((i = l(g)) > .5) - 1, (s = m(o - .5, 2)) + m(i - .5, 2) > .25 && s < .25 && (i = v(.25 - s) * n + .5) && .5 !== i && (i = i.toFixed(5) - 1e-5 * n), y || (b = o, x = i)), E);
            })).split(/\s*-\s*/), "linear" === d) {
              var S,
                  k = n.shift(),
                  A = k.match(/\((.*)\)/);
              if (A = A && A[1] && A[1].split(/\s*,\s*/), k = -l(k), isNaN(k)) return null;
              A && A.length ? (A[0] in z ? (a = A.shift(), A[0] in U && (c = A.shift())) : (A[4] && (a = A[4]), A[5] && (c = A[5])), u = [A[0] || "0%", A[1] || "0%", A[2] || "100%", A[3] || "0%"]) : (u = [0, 0, h.cos(e.rad(k)), h.sin(e.rad(k))], S = 1 / (p(g(u[2]), g(u[3])) || 1), u[2] *= S, u[3] *= S, u[2] < 0 && (u[0] = -u[2], u[2] = 0), u[3] < 0 && (u[1] = -u[3], u[3] = 0));
            }

            var T = e._parseDots(n);

            if (!T) return null;
            (_ = G(d + "Gradient", {
              id: y
            })).refCount = 0, a in z && _.setAttribute("gradientUnits", s(a)), c in U && _.setAttribute("spreadMethod", s(c)), "radial" === d ? (r !== undefined && _.setAttribute("r", s(r)), o !== undefined && i !== undefined && (_.setAttribute("cx", s(o)), _.setAttribute("cy", s(i))), _.setAttribute("fx", s(b)), _.setAttribute("fy", s(x))) : G(_, {
              x1: u[0],
              y1: u[1],
              x2: u[2],
              y2: u[3]
            });

            for (var M = 0, O = T.length; M < O; M++) {
              _.appendChild(G("stop", {
                offset: T[M].offset ? T[M].offset : M ? "100%" : "0%",
                "stop-color": T[M].color || "#fff",
                "stop-opacity": T[M].opacity === undefined ? 1 : T[M].opacity
              }));
            }

            f.defs.appendChild(_);
          }

          return H(t, _), G(w, {
            fill: "url('" + e._url + "#" + y + "')",
            "fill-opacity": 1
          }), C.fill = E, 1;
        },
            X = function X(e) {
          var t = e.getBBox(1);
          G(e.pattern, {
            patternTransform: e.matrix.invert() + " translate(" + t.x + "," + t.y + ")"
          });
        },
            W = function W(n, r, o) {
          if ("path" == n.type) {
            for (var i, a, l, c, u, d = s(r).toLowerCase().split("-"), f = n.paper, h = o ? "end" : "start", p = n.node, g = n.attrs, m = g["stroke-width"], v = d.length, y = "classic", b = 3, x = 3, w = 5; v--;) {
              switch (d[v]) {
                case "block":
                case "classic":
                case "oval":
                case "diamond":
                case "open":
                case "none":
                  y = d[v];
                  break;

                case "wide":
                  x = 5;
                  break;

                case "narrow":
                  x = 2;
                  break;

                case "long":
                  b = 5;
                  break;

                case "short":
                  b = 2;
              }
            }

            if ("open" == y ? (b += 2, x += 2, w += 2, l = 1, c = o ? 4 : 1, u = {
              fill: "none",
              stroke: g.stroke
            }) : (c = l = b / 2, u = {
              fill: g.stroke,
              stroke: "none"
            }), n._.arrows ? o ? (n._.arrows.endPath && D[n._.arrows.endPath]--, n._.arrows.endMarker && D[n._.arrows.endMarker]--) : (n._.arrows.startPath && D[n._.arrows.startPath]--, n._.arrows.startMarker && D[n._.arrows.startMarker]--) : n._.arrows = {}, "none" != y) {
              var C = "raphael-marker-" + y,
                  _ = "raphael-marker-" + h + y + b + x + "-obj" + n.id;

              e._g.doc.getElementById(C) ? D[C]++ : (f.defs.appendChild(G(G("path"), {
                "stroke-linecap": "round",
                d: M[y],
                id: C
              })), D[C] = 1);

              var S,
                  k = e._g.doc.getElementById(_);

              k ? (D[_]++, S = k.getElementsByTagName("use")[0]) : (k = G(G("marker"), {
                id: _,
                markerHeight: x,
                markerWidth: b,
                orient: "auto",
                refX: c,
                refY: x / 2
              }), S = G(G("use"), {
                "xlink:href": "#" + C,
                transform: (o ? "rotate(180 " + b / 2 + " " + x / 2 + ") " : E) + "scale(" + b / w + "," + x / w + ")",
                "stroke-width": (1 / ((b / w + x / w) / 2)).toFixed(4)
              }), k.appendChild(S), f.defs.appendChild(k), D[_] = 1), G(S, u);
              var A = l * ("diamond" != y && "oval" != y);
              o ? (i = n._.arrows.startdx * m || 0, a = e.getTotalLength(g.path) - A * m) : (i = A * m, a = e.getTotalLength(g.path) - (n._.arrows.enddx * m || 0)), (u = {})["marker-" + h] = "url('" + e._url + "#" + _ + "')", (a || i) && (u.d = e.getSubpath(g.path, i, a)), G(p, u), n._.arrows[h + "Path"] = C, n._.arrows[h + "Marker"] = _, n._.arrows[h + "dx"] = A, n._.arrows[h + "Type"] = y, n._.arrows[h + "String"] = r;
            } else o ? (i = n._.arrows.startdx * m || 0, a = e.getTotalLength(g.path) - i) : (i = 0, a = e.getTotalLength(g.path) - (n._.arrows.enddx * m || 0)), n._.arrows[h + "Path"] && G(p, {
              d: e.getSubpath(g.path, i, a)
            }), delete n._.arrows[h + "Path"], delete n._.arrows[h + "Marker"], delete n._.arrows[h + "dx"], delete n._.arrows[h + "Type"], delete n._.arrows[h + "String"];

            for (u in D) {
              if (D[t](u) && !D[u]) {
                var T = e._g.doc.getElementById(u);

                T && T.parentNode.removeChild(T);
              }
            }
          }
        },
            Y = {
          "": ["none"],
          none: ["none"],
          "-": [3, 1],
          ".": [1, 1],
          "-.": [3, 1, 1, 1],
          "-..": [3, 1, 1, 1, 1, 1],
          ". ": [1, 3],
          "- ": [4, 3],
          "--": [8, 3],
          "- .": [4, 3, 1, 3],
          "--.": [8, 3, 1, 3],
          "--..": [8, 3, 1, 3, 1, 3]
        },
            q = function q(t, n, r) {
          if (n !== undefined) {
            var o,
                i,
                a,
                s,
                l,
                c = Y[n.toLowerCase && n.toLowerCase()];

            if (n = c || [].concat(n), e.is(n, "array")) {
              if (a = {
                round: i = r["stroke-width"] || t.attrs["stroke-width"] || 1,
                square: i,
                butt: 0
              }[r["stroke-linecap"] || t.attrs["stroke-linecap"]] || 0, s = n.length, l = c ? i : 1, "none" === n[0]) o = n;else for (o = []; s--;) {
                o[s] = n[s] * l + (s % 2 ? 1 : -1) * a, o[s] <= 0 && (o[s] = .01 + (i <= 1 ? a : 0)), isNaN(o[s]) && (o[s] = 0);
              }
              return {
                "stroke-dasharray": o.join(",")
              };
            }
          }
        },
            K = e._setFillAndStroke = function (n, r) {
          if (n.paper.canvas) {
            var i,
                a,
                l,
                u,
                d,
                f,
                h = n.node,
                m = n.attrs,
                v = n.paper,
                y = {},
                x = {};

            for (a in "image" === n.type && (0, o.loadRefImage)(n, r), r) {
              if (a in e._availableAttrs) if ((l = r[a]) === E && a in m) delete m[a], h.removeAttribute("src" === a ? "href" : a);else switch (m[a] = l, a) {
                case "blur":
                  n.blur(l);
                  break;

                case "href":
                case "title":
                case "target":
                  var w = h.parentNode;

                  if ("a" !== w.tagName.toLowerCase()) {
                    if (l === E) break;
                    var C = G("a");
                    C.raphael = !0, C.raphaelid = h.raphaelid, w.insertBefore(C, h), C.appendChild(h), w = C;
                  }

                  "target" === a ? w.setAttributeNS(A, "show", "blank" === l ? "new" : l) : w.setAttributeNS(A, a, l), h.titleNode = w;
                  break;

                case "cursor":
                  x.cursor = l;
                  break;

                case "transform":
                  n.transform(l);
                  break;

                case "rotation":
                  e.is(l, "array") ? n.rotate.apply(n, l) : n.rotate(l);
                  break;

                case "arrow-start":
                  W(n, l);
                  break;

                case "arrow-end":
                  W(n, l, 1);
                  break;

                case "clip-path":
                  u = !0;

                case "clip-rect":
                  if (f = !u && s(l).split(b), n._.clipispath = !!u, u || 4 === f.length) {
                    n.clip && n.clip.parentNode.parentNode.removeChild(n.clip.parentNode);
                    var S = G(u ? "path" : "rect");
                    (i = G("clipPath")).id = e.getElementID(e.createUUID()), G(S, u ? {
                      d: l ? m["clip-path"] = e._pathToAbsolute(l) : e._availableAttrs.path,
                      fill: "none"
                    } : {
                      x: f[0],
                      y: f[1],
                      width: f[2],
                      height: f[3],
                      transform: n.matrix.invert()
                    }), i.appendChild(S), v.defs.appendChild(i), y["clip-path"] = "url('" + e._url + "#" + i.id + "')", n.clip = S;
                  }

                  if (!l) {
                    var k = h.getAttribute("clip-path");

                    if (k) {
                      var T = e._g.doc.getElementById(k.replace(/(^url\(#|\)$)/g, E));

                      T && T.parentNode.removeChild(T), y["clip-path"] = E, 11 === document.documentMode && h.removeAttribute("clip-path"), delete n.clip;
                    }
                  }

                  break;

                case "path":
                  "path" === n.type && (y.d = l ? m.path = e._stopabsolutePath ? e.sanitizePath(l) : e._pathToAbsolute(l) : e._availableAttrs.path, n._.dirty = 1, n._.arrows && ("startString" in n._.arrows && W(n, n._.arrows.startString), "endString" in n._.arrows && W(n, n._.arrows.endString, 1)));
                  break;

                case "width":
                  if (y[a] = l, n._.dirty = 1, !m.fx) break;
                  a = "x", l = m.x;

                case "x":
                  m.fx && (l = -m.x - (m.width || 0));

                case "rx":
                  if ("rx" === a && "rect" === n.type) break;

                case "cx":
                  y[a] = l, n.pattern && X(n), n._.dirty = 1;
                  break;

                case "height":
                  if (y[a] = l, n._.dirty = 1, !m.fy) break;
                  a = "y", l = m.y;

                case "y":
                  if ("text" === n.type) break;
                  m.fy && (l = -m.y - (m.height || 0));

                case "ry":
                  if ("ry" === a && "rect" === n.type) break;

                case "cy":
                  y[a] = l, n.pattern && X(n), n._.dirty = 1;
                  break;

                case "r":
                  "rect" === n.type ? y.rx = y.ry = l : y[a] = l, n._.dirty = 1;
                  break;

                case "src":
                  "image" === n.type && h.setAttributeNS(A, "href", l);
                  break;

                case "stroke-width":
                  1 === n._.sx && 1 === n._.sy || (l /= p(g(n._.sx), g(n._.sy)) || 1), v._vbSize && (l *= v._vbSize), _ && 0 === l && (l = 1e-6), y[a] = l, !r["stroke-dasharray"] && m["stroke-dasharray"] && R(y, q(n, m["stroke-dasharray"], r)), n._.arrows && ("startString" in n._.arrows && e.addArrow && e.addArrow(n, n._.arrows.startString), "endString" in n._.arrows && e.addArrow && e.addArrow(n, n._.arrows.endString, 1));
                  break;

                case "stroke-dasharray":
                  R(y, q(n, l, r));
                  break;

                case "fill":
                  if (e._ISURL.test(l)) {
                    d = l.split(e._ISURL), i = G("pattern");
                    var M = G("image");
                    i.id = e.getElementID(e.createUUID()), G(i, {
                      x: 0,
                      y: 0,
                      patternUnits: "userSpaceOnUse",
                      height: 1,
                      width: 1
                    }), G(M, {
                      x: 0,
                      y: 0,
                      "xlink:href": d[1]
                    }), i.appendChild(M), P(i, M, d, v), v.defs.appendChild(i), y.fill = "url('" + e._url + d[1] + "')", n.pattern = i, n.pattern && X(n);
                    break;
                  }

                  var F = e.getRGB(l);

                  if (F.error) {
                    if (("circle" === n.type || "ellipse" === n.type || "r" !== s(l).charAt()) && $(n, l)) {
                      m.gradient = l;
                      break;
                    }
                  } else delete r.gradient, delete m.gradient, !e.is(m["fill-opacity"], "undefined") && e.is(r["fill-opacity"], "undefined") && (y["fill-opacity"] = m["fill-opacity"]), n.gradient && H(n);

                  F[t]("opacity") ? (y["fill-opacity"] = F.opacity > 1 ? F.opacity / 100 : F.opacity, n._.fillOpacityDirty = !0) : n._.fillOpacityDirty && e.is(m["fill-opacity"], "undefined") && e.is(r["fill-opacity"], "undefined") && (h.removeAttribute("fill-opacity"), delete n._.fillOpacityDirty);

                case "stroke":
                  F = e.getRGB(l), y[a] = F.hex, "stroke" === a && (F[t]("opacity") ? (y["stroke-opacity"] = F.opacity > 1 ? F.opacity / 100 : F.opacity, n._.strokeOpacityDirty = !0) : n._.strokeOpacityDirty && e.is(m["stroke-opacity"], "undefined") && e.is(r["stroke-opacity"], "undefined") && (h.removeAttribute("stroke-opacity"), delete n._.strokeOpacityDirty), n._.arrows && ("startString" in n._.arrows && W(n, n._.arrows.startString), "endString" in n._.arrows && W(n, n._.arrows.endString, 1)));
                  break;

                case "gradient":
                  ("circle" === n.type || "ellipse" === n.type || "r" !== s(l).charAt()) && $(n, l);
                  break;

                case "visibility":
                  "hidden" === l ? n.hide() : n.show();
                  break;

                case "opacity":
                  l = l > 1 ? l / 100 : l, y.opacity = l;
                  break;

                case "fill-opacity":
                  l = l > 1 ? l / 100 : l, y["fill-opacity"] = l;
                  break;

                case "shape-rendering":
                  n.attrs[a] = l = O[l] || l || "auto", y[a] = l, h.style.shapeRendering = l;
                  break;

                case "line-height":
                case "vertical-align":
                  break;

                default:
                  "font-size" === a && (l = c(l, 10) + "px"), n._.dirty = 1, y[a] = l, o.dashedAttr2CSSMap[a] && (x[o.dashedAttr2CSSMap[a]] = l);
              }
            }

            for (a in x) {
              h.style[a] = x[a];
            }

            for (a in y) {
              h.setAttribute(a, y[a]);
            }

            "text" === n.type && !r["_do-not-tune"] && Z(n, r);
          }
        },
            J = e._updateFollowers = function () {
          var e,
              t,
              n,
              r = (0, o.getArrayCopy)(arguments),
              i = C.call(r),
              a = C.call(r);

          for (e = 0, t = i.followers.length; e < t; e++) {
            (n = i.followers[e].el)[a].apply(n, r);
          }
        },
            Z = function Z(r, o) {
          if ("text" === r.type && (o[t]("text") || o[t]("font") || o[t]("font-size") || o[t]("x") || o[t]("y") || o[t]("line-height") || o[t](n))) {
            var i,
                c,
                d,
                h,
                p,
                g,
                m,
                v,
                y,
                b,
                C,
                _ = r.attrs,
                S = r.parent,
                A = r.node,
                T = r._oldAttr = r._oldAttr || {
              baseLineDiff: 8,
              valign: -.5
            },
                M = l(o["line-height"] || _["line-height"]),
                O = o.direction || _.direction || S && S.attrs && S.attrs.direction || T.direction || "initial",
                F = !1,
                I = !1,
                L = f || "rtl" !== O ? 1 : 2,
                N = !1,
                D = !1,
                P = !(f || !T.direction || O === T.direction);
            if (T.direction = O, M || (M = 1.2 * (i = (i = o.fontSize || o["font-size"] || _["font-size"] || S && S.attrs && S.attrs.fontSize) ? i.toString().replace("px", E) : 10)), o[t]("text") && (C = e.is(o.text, "array") ? o.text.join("<br>") : o.text) !== T.text && (D = !0, C && w.test(C) && (C = C.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&<br\/>lt;|&l<br\/>t;|&lt<br\/>;/g, "<<br/>").replace(/&<br\/>gt;|&g<br\/>t;|&gt<br\/>;/g, "><br/>")), T.text = _.text = C, x.test(C) ? (T.noTSpan && (T.noTSpan = !(P = !0)), p = (m = s(C).split(x)).length) : (P = !0, T.noTSpan = !0, p = 1), T.lineCount !== p && (T.lineCount = p, N = !0)), M !== T.lineHeight && (T.lineHeight = M, T.baseLineDiff = .75 * M, N = !0), P) for (; A.firstChild;) {
              A.removeChild(A.firstChild);
            }

            if (T.lineCount > 1) {
              if (d = {}, T.tspanAttr || (T.tspanAttr = {}, T.tspan0Attr = {}), T.tspanAttr.dy !== T.lineHeight && (T.tspanAttr.dy = d.dy = T.lineHeight, I = !0), o[t]("x") && T.tspanAttr.x !== o.x && (T.tspan0Attr.x = T.tspanAttr.x = d.x = _.x, I = !0), D) {
                for (b = A.getElementsByTagName("tspan"), h = 0; h < p; h++) {
                  if (y = b[h * L]) {
                    if (y.innerHTML = E, f) for (; y.firstChild;) {
                      y.removeChild(y.firstChild);
                    }
                    I && G(y, h ? d : T.tspan0Attr);
                  } else y = G("tspan", h ? T.tspanAttr : T.tspan0Attr), A.appendChild(y), f || "rtl" !== O || ((v = G("tspan", a)).appendChild(e._g.doc.createTextNode("i")), A.appendChild(v));

                  m[h] || (y.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), m[h] = k), y.appendChild(e._g.doc.createTextNode(m[h]));
                }

                if (g = p * L, b.length > g) for (h = b.length - 1; h >= g; h -= 1) {
                  A.removeChild(b[h]);
                }
              } else if (I) for (g = (b = A.getElementsByTagName("tspan")).length, h = 0; h < g; h += L) {
                G(b[h], h ? d : T.tspan0Attr);
              }
            } else D && A.appendChild(e._g.doc.createTextNode(C));

            o[n] && (c = u[_[n]] || 0) !== T.valign && (T.valign = c, N = !0), N && (T.shift = T.baseLineDiff + T.lineCount * T.lineHeight * T.valign, F = !0), !o.y && 0 !== o.y || T.y === o.y || (T.y = _.y, F = !0), !F || !T.y && 0 !== T.y || !T.shift && 0 !== T.shift || G(A, {
              y: Math.round(T.y + T.shift)
            });
          }
        },
            Q = function Q(t, n, r) {
          var o = this,
              i = r || n;
          /*! dontAppend && */

          i.canvas && i.canvas.appendChild(t), o.node = o[0] = t, t.raphael = !0, t.raphaelid = o.id = e._oid++, o.matrix = e.matrix(), o.realPath = null, o.attrs = o.attrs || {}, o.followers = o.followers || [], o.paper = n, o.ca = o.customAttributes = o.customAttributes || new n._CustomAttributes(), o._ = {
            transform: [],
            sx: 1,
            sy: 1,
            deg: 0,
            dx: 0,
            dy: 0,
            dirty: 1
          }, o.parent = i, !i.bottom && (i.bottom = o), o.prev = i.top, i.top && (i.top.next = o), i.top = o, o.next = null;
        },
            ee = function ee(e, t, n) {
          var r = n ? "pageY" : "pageX";
          return Math.abs(t[r] - e[r]);
        },
            te = e.storeHandlers = function (e, t, n) {
          e._actualListners || (e._actualListners = []), e._derivedListeners || (e._derivedListeners = []), e._actualListners.push(t), e._derivedListeners.push(n);
        },
            ne = function ne(e, t) {
          var n,
              r = e._actualListners.indexOf(t);

          return -1 !== r && (n = e._derivedListeners[r], e._actualListners.splice(r, 1), e._derivedListeners.splice(r, 1)), n;
        },
            re = e.el;

        Q.prototype = re, re.constructor = Q, e._engine.getNode = function (e) {
          var t = e.node || e[0].node;
          return t.titleNode || t;
        }, e._engine.getLastNode = function (e) {
          var t = e.node || e[e.length - 1].node;
          return t.titleNode || t;
        }, re.rotate = function (e, t, n) {
          var r,
              o = this;
          return o.removed ? o : (J(o, "rotate", e, t, n), (e = s(e).split(b)).length - 1 && (t = l(e[1]), n = l(e[2])), e = l(e[0]), null == n && (t = n), null != t && null != n || (t = (r = o.getBBox(1)).x + r.width / 2, n = r.y + r.height / 2), o.transform(o._.transform.concat([["r", e, t, n]])), o);
        }, re.scale = function (e, t, n, r) {
          var o,
              i = this;
          return i.removed ? i : (J(i, "scale", e, t, n, r), (e = s(e).split(b)).length - 1 && (t = l(e[1]), n = l(e[2]), r = l(e[3])), e = l(e[0]), null == t && (t = e), null == r && (n = r), null != n && null != r || (o = i.getBBox(1)), n = null == n ? o.x + o.width / 2 : n, r = null == r ? o.y + o.height / 2 : r, i.transform(i._.transform.concat([["s", e, t, n, r]])), i);
        }, re.translate = function (e, t) {
          var n = this;
          return n.removed ? n : (J(n, "translate", e, t), (e = s(e).split(b)).length - 1 && (t = l(e[1])), e = l(e[0]) || 0, t = +t || 0, n.transform(n._.transform.concat([["t", e, t]])), n);
        }, re.transform = function (t) {
          var n,
              r = this,
              o = r._;
          return null == t ? o.transform : (e._extractTransform(r, t), r.clip && !o.clipispath && G(r.clip, {
            transform: r.matrix.invert()
          }), r.pattern && X(r), r.node && G(r.node, {
            transform: r.matrix
          }), 1 === o.sx && 1 === o.sy || (n = r.attrs["stroke-width"]) && r.attr({
            "stroke-width": n
          }), r);
        }, re.hide = function () {
          var e = this;
          return J(e, "hide"), !e.removed && e.paper.safari(e.node.style.display = "none"), e;
        }, re.show = function () {
          var e = this;
          return J(e, "show"), !e.removed && e.paper.safari(e.node.style.display = E), e;
        }, re.remove = function () {
          if (!this.removed && this.parent.canvas) {
            var t,
                n = this,
                o = e._engine.getNode(n),
                a = n.paper,
                s = a.defs;

            for (a.__set__ && a.__set__.exclude(n), S.unbind("raphael.*.*." + n.id), n.gradient && s && H(n); t = n.followers.pop();) {
              t.el.remove();
            }

            for (; t = n.bottom;) {
              t.remove();
            }

            if (n._drag && n.undrag(), n.events) for (; t = n.events.pop();) {
              t.unbind();
            }

            for (t in n.parent.canvas.contains(o) && n.parent.canvas.removeChild(o), n.removeData(), delete a._elementsById[n.id], e._tear(n, n.parent), n) {
              n[t] = r(n[t]) === i ? e._removedFactory(t) : null;
            }

            n.removed = !0;
          }
        }, re._getBBox = function () {
          var e,
              t,
              r,
              i = this,
              a = i.node,
              s = {},
              l = i.attrs,
              c = "text" === i.type;
          f && c ? e = (0, o.showRecursively)(i) : "none" === a.style.display && (i.show(), r = !0);

          try {
            s = a.getBBox(), c && (s.x === undefined && (s.isCalculated = !0, t = l["text-anchor"], s.x = (l.x || 0) - s.width * ("start" === t ? 0 : "middle" === t ? .5 : 1)), s.y === undefined && (s.isCalculated = !0, t = l[n], s.y = (l.y || 0) - s.height * ("bottom" === t ? 1 : "middle" === t ? .5 : 0)));
          } catch (u) {} finally {
            s = s || {};
          }

          return f && c ? e && e() : r && i.hide(), s;
        }, re.attr = function (n, r) {
          if (this.removed) return this;
          var o,
              a,
              s,
              l,
              c,
              u,
              d,
              f,
              h = this.attrs,
              p = {},
              g = this._invokedCa || (this._invokedCa = {}),
              m = this.ca;

          if (null == n) {
            var v = {};

            for (o in h) {
              h[t](o) && (v[o] = h[o]);
            }

            return v.gradient && "none" === v.fill && (v.fill = v.gradient) && delete v.gradient, v.transform = this._.transform, v.visibility = "none" === this.node.style.display ? "hidden" : "visible", v;
          }

          if (null == r) {
            if (e.is(n, "object")) l = n;else if (e.is(n, "string")) return "fill" === n && "none" === h.fill && h.gradient ? h.gradient : "transform" === n ? this._.transform : "visibility" === n ? "none" === this.node.style.display ? "hidden" : "visible" : n in h ? h[n] : e.is(m[n], i) ? m[n].def : e._availableAttrs[n];
          } else (l = {})[n] = r;

          if (!e.stopPartialEventPropagation) for (o in l) {
            S("raphael.attr." + o + "." + this.id, this, l[o], o);
          }

          for (o in l) {
            if ((f = m[o]) && !g[o] && e.is(f, i)) {
              for (c in g[o] = !0, u = f.apply(this, [].concat(l[o])), g[o] = !1, u) {
                p[c] = u[c];
              }

              h[o] = l[o];
            } else p[o] = l[o];
          }

          for (K(this, p), a = 0, s = this.followers.length; a < s; a++) {
            (d = this.followers[a]).cb && !d.cb.call(d.el, p, this) || d.el.attr(p);
          }

          return this;
        }, re.pinchstart = function (t, n) {
          var r = this,
              o = {},
              i = function i(_i) {
            if (_i.touches && 2 === _i.touches.length) {
              var a = _i.touches[0],
                  s = _i.touches[1];
              r._blockDrag = !0, _i && _i.preventDefault(), e.makeSelectiveCopy(o, _i), o.data = {
                finger0: a,
                finger1: s,
                distanceX: ee(a, s),
                distanceY: ee(a, s, !0)
              }, t.call(n || r, o);
            } else r._blockDrag = !1;
          };

          te(r, t, i), r.node.addEventListener("touchstart", i);
        }, re.unpinchstart = function (e) {
          var t = ne(this, e);
          this.__blockDrag = !1, this._pinchDragStarted = !1, t && this.node.removeEventListener("touchstart", t);
        }, re.pinchmove = function (t, n) {
          var r = this,
              o = {},
              i = function i(_i2) {
            if (_i2.touches && 2 === _i2.touches.length) {
              var a = _i2.touches[0],
                  s = _i2.touches[1];
              _i2 && _i2.preventDefault(), r._pinchDragStarted = !0, e.makeSelectiveCopy(o, _i2), o.data = {
                finger0: a,
                finger1: s,
                distanceX: ee(a, s),
                distanceY: ee(a, s, !0)
              }, t.call(n || r, o);
            }
          };

          te(r, t, i), r.node.addEventListener("touchmove", i);
        }, re.unpinchmove = function (e) {
          var t = ne(this, e);
          t && this.node.removeEventListener("touchmove", t);
        }, re.pinchend = function (e, t) {
          var n = this,
              r = function r(_r2) {
            n._pinchDragStarted && (n._pinchDragStarted = !1, e.call(t || n, _r2));
          };

          te(n, e, r), n.node.addEventListener("touchend", r);
        }, re.unpinchend = function (e) {
          var t = ne(this, e);
          this._pinchDragStarted = !1, t && this.node.removeEventListener("touchend", t);
        }, re.pinch = function (e, t, n) {
          re.pinchstart.call(this, e), re.pinchin.call(this, t), re.pinchend.call(this, n);
        }, re.unpinch = function (e, t, n) {
          re.unpinchstart.call(this, e), re.unpinchin.call(this, t), re.unpinchend.call(this, n);
        }, re.fcwheel = function (t, n) {
          var r = this,
              o = {},
              i = function i(_i3) {
            _i3 && _i3.preventDefault(), e.makeSelectiveCopy(o, _i3), t.call(n || r, o);
          };

          te(r, t, i), r.node.addEventListener("wheel", i);
        }, re.fcunwheel = function (e) {
          var t = ne(this, e);
          t && this.node.removeEventListener("wheel", t);
        }, re.on = function (t, n, r) {
          if (n && t) {
            var o,
                i,
                a = this,
                s = t.match(/fc-/),
                l = n;
            if (this.removed) return this;

            switch (a._actualListners || (a._actualListners = []), a._derivedListeners || (a._derivedListeners = []), t) {
              case "fc-dragstart":
                return a.drag(null, n), a;

              case "fc-dragmove":
                return a.drag(n), a;

              case "fc-dragend":
                return a.drag(null, null, n), a;

              case "fc-dbclick":
                return a.dbclick(n, r), a;

              case "fc-pinchstart":
                return a.pinchstart(n, r), a;

              case "fc-pinchmove":
                return a.pinchmove(n, r), a;

              case "fc-pinchend":
                return a.pinchend(n, r), a;

              case "fc-click":
                return a.fcclick(n, r), a;

              case "fc-wheel":
                return a.fcwheel(n, r), a;
            }

            return s && (t = t.replace(/fc-/, "")), s && N && (i = t, t = (L ? e.safePointerEventMapping[t] : B[t]) || t, "mouseout" === i && (l = function l(e) {
              L && N && !e.isPrimary || (j.elementInfo.push({
                el: r || a,
                callback: n
              }), j.srcElement = e.srcElement || e.target);
            }, t = L ? "pointerover" : "touchstart")), this._ && this._.RefImg && ("load" === t || "error" === t) ? (o = this._.RefImg, l = function l(e) {
              (!L || !N || e.isPrimary) && !a.removed && n.call(a, e);
            }) : o = this.node, l === n && (l = function l(e) {
              (!L || !N || e.isPrimary) && n.call(r || a, e);
            }), a._actualListners.push(n), a._derivedListeners.push(l), o.addEventListener ? o.addEventListener(t, l) : o["on" + t] = l, this;
          }
        }, re.off = function (t, n) {
          var r,
              o,
              i,
              a = n,
              s = t.match(/fc-/);
          if (this.removed || !this._actualListners || !t || !n) return this;

          switch (t) {
            case "fc-dragstart":
              return this.undragstart(n), this;

            case "fc-dragmove":
              return this.undragmove(n), this;

            case "fc-dragend":
              return this.undragend(n), this;

            case "fc-dbclick":
              return this.undbclick(n), this;

            case "fc-pinchstart":
              return this.unpinchstart(n), this;

            case "fc-pinchmove":
              return this.unpinchmove(n), this;

            case "fc-pinchend":
              return this.unpinchend(n), this;

            case "fc-click":
              return this.fcunclick(n), this;

            case "fc-wheel":
              return this.fcunwheel(n), this;
          }

          return s && (t = t.replace(/fc-/, "")), a = n, s && N && (r = t, t = (L ? e.safePointerEventMapping[t] : B[t]) || t, "mouseout" === r && (t = L ? "pointerover" : "touchstart")), i = this._ && this._.RefImg ? this._.RefImg : this.node, -1 !== (o = this._actualListners.indexOf(a)) && (a = this._derivedListeners[o], this._actualListners.splice(o, 1), this._derivedListeners.splice(o, 1)), i.removeEventListener ? i.removeEventListener(t, a) : i["on" + t] = null, this;
        }, e._engine.path = function (e, t, n) {
          var r = G("path"),
              o = new Q(r, e, n);
          return o.type = "path", t && o.attr(t), o;
        }, e._engine.group = function (e, t, n) {
          var r = G("g"),
              o = new Q(r, e, n);
          return o.type = "group", o.canvas = o.node, o.top = o.bottom = null, o._id = t || E, t && r.setAttribute("class", "raphael-group-" + o.id + "-" + t), o;
        }, e._engine.circle = function (e, t, n) {
          var r = G("circle"),
              o = new Q(r, e, n);
          return o.type = "circle", t && o.attr(t), o;
        }, e._engine.rect = function (e, t, n) {
          var r = G("rect"),
              o = new Q(r, e, n);
          return o.type = "rect", t.rx = t.ry = t.r, t && o.attr(t), o;
        }, e._engine.ellipse = function (e, t, n) {
          var r = G("ellipse"),
              o = new Q(r, e, n);
          return o.type = "ellipse", t && o.attr(t), o;
        }, e._engine.image = function (e, t, n) {
          var r = G("image"),
              o = new Q(r, e, n, !0);
          return o._.group = n || e, o.type = "image", r.setAttribute("preserveAspectRatio", "none"), t && o.attr(t), o;
        }, e._engine.text = function (e, t, n, r) {
          var o = G("text"),
              i = new Q(o, e, n);
          return i.type = "text", r && i.css && i.css(r, undefined, !0), t && i.attr(t), i;
        }, e._engine.setSize = function (e, t) {
          return this.width = e || this.width, this.height = t || this.height, this.canvas.setAttribute("width", this.width), this.canvas.setAttribute("height", this.height), this._viewBox && this.setViewBox.apply(this, this._viewBox), this;
        }, e._engine.create = function () {
          var t,
              n = e._getContainer.apply(0, arguments),
              r = n && n.container,
              o = n.x,
              i = n.y,
              a = n.width,
              s = n.height;

          if (!r) throw new Error("SVG container not found.");
          var l,
              c = G("svg"),
              u = "overflow:hidden;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-moz-user-select:-moz-none;-khtml-user-select:none;-ms-user-select:none;user-select:none;-o-user-select:none;cursor:default;vertical-align:middle;";
          return N && (e.isEdge ? u += "touch-action:none;" : e.isFirefox && e.isWindows ? u += "touch-action:none;" : e.isIE11 && (u += "-ms-touch-action:none;")), o = o || 0, i = i || 0, a = a || 512, G(c, {
            height: s = s || 342,
            version: 1.1,
            width: a,
            xmlns: T
          }), 1 === r ? (c.style.cssText = u + "position:absolute;left:" + o + "px;top:" + i + "px", (r = e._g.doc.body).appendChild(c), l = 1) : (c.style.cssText = u + "position:relative", r.firstChild ? r.insertBefore(c, r.firstChild) : r.appendChild(c)), (t = new e._Paper()).width = a, t.height = s, t.canvas = c, t.container = r, G(c, {
            id: "raphael-paper-" + t.id
          }), t.clear(), t._left = t._top = 0, l && (t.renderfix = function () {}), t.renderfix(), t;
        }, e._engine.setViewBox = function (e, t, n, r, o) {
          S("raphael.setViewBox", this, this._viewBox, [e, t, n, r, o]);
          var i,
              a,
              s = p(n / this.width, r / this.height),
              l = this.top,
              c = o ? "meet" : "xMinYMin";
          if (null == e ? (this._vbSize && (s = 1), delete this._vbSize, i = "0 0 " + this.width + k + this.height) : (this._vbSize = s, i = e + k + t + k + n + k + r), G(this.canvas, {
            viewBox: i,
            preserveAspectRatio: c
          }), s) for (; l;) {
            a = "stroke-width" in l.attrs ? l.attrs["stroke-width"] : 1, l.attr({
              "stroke-width": a
            }), l._.dirty = 1, l._.dirtyT = 1, l = l.prev;
          }
          return this._viewBox = [e, t, n, r, !!o], this;
        }, e.prototype.detachPaper = function () {
          !1 !== this._detached && (this.container.removeChild(this.canvas), this._detached = !0);
        }, e.prototype.attachPaper = function () {
          this._detached && (this.container.appendChild(this.canvas), this._detached = !1);
        }, e.prototype.renderfix = function () {
          var e,
              t = this.canvas,
              n = t.style;

          try {
            e = t.getScreenCTM() || t.createSVGMatrix();
          } catch (i) {
            e = t.createSVGMatrix();
          }

          var r = -e.e % 1,
              o = -e.f % 1;
          (r || o) && (r && (this._left = (this._left + r) % 1, n.left = this._left + "px"), o && (this._top = (this._top + o) % 1, n.top = this._top + "px"));
        }, e.prototype._desc = function (t) {
          var n = this.desc;
          if (n) for (; n.firstChild;) {
            n.removeChild(n.firstChild);
          } else this.desc = n = G("desc"), this.canvas.appendChild(n);
          n.appendChild(e._g.doc.createTextNode(e.is(t, "string") ? t : "Created with Red Raphaël " + e.version));
        }, e.prototype.clear = function () {
          var e;

          for (S("raphael.clear", this); e = this.bottom;) {
            e.remove();
          }

          for (e = this.canvas; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          this.bottom = this.top = null, e.appendChild(this.desc = G("desc")), e.appendChild(this.defs = G("defs"));
        }, e.prototype.remove = function () {
          var t;

          for (S("raphael.remove", this); t = this.bottom;) {
            t.remove();
          }

          for (t in this.defs && this.defs.parentNode.removeChild(this.defs), this.desc && this.desc.parentNode.removeChild(this.desc), this.canvas.parentNode && this.canvas.parentNode.removeChild(this.canvas), this) {
            this[t] = r(this[t]) === i ? e._removedFactory(t) : null;
          }

          this.removed = !0;
        }, e.prototype.setHTMLClassName = function () {};
      }

      var oe;
    };

    var o = n(128);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = {
        data: {}
      };
      if (!e) return t;
      if ("string" == typeof e) try {
        t.data = JSON.parse(e);
      } catch (n) {
        t.error = n;
      } else t.data = e;
      return t;
    }

    function o() {
      return this.getChartData("json");
    }

    function i(e) {
      this.setChartData(e, "json");
    }

    t.__esModule = !0, t["default"] = {
      extension: function extension(e) {
        return e && (e.prototype.setJSONData = i), e && (e.prototype.getJSONData = o), {
          format: "json",
          toJSON: r,
          fromJSON: r
        };
      },
      name: "JSON",
      type: "transcoder",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(136),
        o = d(r),
        i = d(n(155)),
        a = d(n(156)),
        s = d(n(157)),
        l = d(n(158)),
        c = d(n(159)),
        u = d(n(160));

    function d(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var f = {
      oneInAFrame: !0
    };
    t["default"] = {
      extension: function extension(e) {
        var t = e.getDep("redraphael", "plugin"),
            n = {};
        t.fn._elementFromEvent = function (e) {
          if (!e || this.removed) return null;
          var t = e.srcElement || e.target || (e = e.originalEvent) && (e.srcElement || e.target) || n;
          return "tspan" === t.nodeName && (t = t.parentNode), this.getById(t.raphaelid);
        }, t.requestAnimFrame = o["default"].addJob && function (e) {
          o["default"].addJob(e, r.priorityList.animation, f);
        }, t.instantRequestAnimFrame = o["default"].addJob && function (e) {
          o["default"].addJob(e, r.priorityList.instant);
        }, (0, u["default"])(t), (0, i["default"])(t), (0, a["default"])(t), (0, s["default"])(t), (0, l["default"])(t), (0, c["default"])(t);
      },
      name: "redraphaelExt",
      type: "plugin",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };

    t["default"] = function (e) {
      var t,
          n,
          i = e.eve,
          a = e._g,
          s = e.fn,
          l = e.el,
          c = /[, ]+/,
          u = "",
          d = " ",
          f = /\B([A-Z]{1})/g,
          h = "fusioncharts-raphael-stylesheet";
      (n = (t = function t(e) {
        this.styleSheet = u, this.rules = {}, this.ns = e || u;
      }).prototype).getSheet = function () {
        var t = this.node;
        return this.styleSheet = n.getStyleSheet(h), this.styleSheet || ((t = this.node = a.doc.createElement("style")).setAttribute("id", e.format("raphael-stylesheet-{0}", e._oid++)), t.setAttribute("type", "text/css"), t.setAttribute("title", h), (a.doc.head || a.doc.getElementsByTagName("head")[0]).appendChild(this.node), this.styleSheet = n.getStyleSheet(h)), this.styleSheet;
      }, n.getStyleSheet = function (e) {
        for (var t, n = a.doc.styleSheets, r = n.length; r--;) {
          if ((t = n[r]).title === e) return t;
        }
      }, n.applyCSSRule = function (e, t) {
        var n,
            r = this.styleSheet;

        if (!r) {
          if (!e || !t) return;
          r = this.getSheet();
        }

        n = (r.rules || r.cssRules || {}).length || 0, r.insertRule ? r.insertRule(e + "{" + t + "}", n) : r.addRule && r.addRule(e, t, n);
      }, n.removeCSS = function (e) {
        var t,
            n = this.styleSheet,
            r = n.rules || n.cssRules || {},
            o = r.length || 0;

        for (e = e || this.ns; o--;) {
          t = r[o], new RegExp(e).test(t.selectorText) && (n.removeRule ? n.removeRule(o) : n.deleteRule(o));
        }
      }, n.destroy = function () {
        this.removeCSS(), delete this.node, delete this.styleSheet, delete this.ns, delete this.rules;
      }, n.clear = function () {
        this.removeCSS(), this.rules = {};
      }, n.add = function (e, t, n) {
        var r,
            o = u,
            i = this.rules[e] || (this.rules[e] = {}),
            a = n ? u : "\t",
            s = n ? ":" : ": ";

        for (r in t) {
          (i[r] = t[r]) && (o += a + r.replace(f, "-$1").toLowerCase() + s + i[r] + ";");
        }

        this.applyCSSRule(e, o);
      }, n.render = function () {
        this.setCssText();
      }, n.setCssText = function (e) {
        var t,
            n,
            r = e ? u : "\t",
            o = e ? ":" : ": ",
            i = u,
            a = u;

        for (t in this.rules) {
          for (n in i = u, a = t.replace(/(^|\,)/g, "$1" + this.ns + d), t = this.rules[t]) {
            t[n] && (i += r + n.replace(f, "-$1").toLowerCase() + o + t[n] + ";");
          }

          this.applyCSSRule(a, i);
        }
      }, i.on("raphael.new", function () {
        this._stylesheet = this._stylesheet || new t(), this.cssNamespace(u);
      }), i.on("raphael.remove", function () {
        this._stylesheet && this._stylesheet.destroy(), delete this._stylesheet;
      }), s.cssNamespace = function (t) {
        return arguments.length && (this._stylesheet.ns = e.format("{0}#raphael-paper-{1}", t && t + d || u, this.id)), this._stylesheet.ns;
      }, s.cssAddRule = function (e, t) {
        if (1 === arguments.length && "object" === (void 0 === e ? "undefined" : r(e))) {
          for (var n in e) {
            this.cssAddRule(n, e[n]);
          }

          return this;
        }

        return this._stylesheet.add(e, t), this;
      }, s.cssRender = function () {
        return e.svg && this._stylesheet.render(), this;
      }, s.cssClear = function () {
        return this._stylesheet.clear(), this;
      }, e.ca["class"] = function (t) {
        var n,
            r,
            o,
            i,
            a = this,
            s = a.node,
            l = a.paper,
            c = "." + t,
            f = l._stylesheet && l._stylesheet.rules,
            h = a.parent,
            p = a.attrs,
            g = {};
        if (e.svg) t = t || u, s.setAttribute("class", "group" === a.type && a._id ? "raphael-group-" + a.id + "-" + a._id + d + t : t);else if (e.vml && (n = s.className = "group" === a.type ? t && a._id + d + t || a._id : "rvml " + t, s.className = n ? n + " fusioncharts-div" : "fusioncharts-div", c && f)) {
          for (i in r = f[c]) {
            "color" === i && "text" === a.type && (i = "fill"), !p[i] && (g[i] = r[i]);
          }

          for (; h && h.attr;) {
            if (o = h.attr("class")) for (i in r = f[c = "." + o + d + c]) {
              "color" === i && "text" === a.type && (i = "fill"), !p[i] && !g[i] && (g[i] = r[i]);
            }
            h = h.parent;
          }

          a.css(g);
        }
      }, l.css = function (t, n, r) {
        var o, a, s, l, u, d, f;
        if (this.removed) return this;

        if (this.styles || (this.styles = {}), void 0 === n && e.is(t, "string")) {
          for (s = {}, d = 0, f = (o = t.split(c)).length; d < f; d++) {
            (t = o[d]) in this.styles && (s[t] = this.styles[t]);
          }

          return f - 1 ? s : s[o[0]];
        }

        if (void 0 === n && e.is(t, "array")) {
          for (s = {}, d = 0, f = t.length; d < f; d++) {
            s[t[d]] = this.styles(t[d]);
          }

          return s;
        }

        for (d in void 0 !== n ? (a = {})[t] = n : t && e.is(t, "object") && (a = t), u = {}, a) {
          l = d.replace(/\B([A-Z]{1})/g, "-$1").toLowerCase(), e._availableAttrs.hasOwnProperty(l) || "color" === l ? ("color" === l && "text" === this.type && (l = "fill"), u[l] = a[d], u.dirty = !0) : (i("raphael.css." + l + "." + this.id, this, a[d], l), this.node.style[l] = a[d], this.styles[l] = a[d]);
        }

        for (d = 0, f = this.followers.length; d < f; d++) {
          this.followers[d].el.attr(a);
        }

        return u.hasOwnProperty("dirty") && (delete u.dirty, r && (u["_do-not-tune"] = !0), this.attr(u)), this;
      }, l.removeCSS = function (t) {
        var n, r, i;
        if (!t && (t = o.appliedCSS), this.removed) return this;
        if (e.is(t, "string") && (t = t.split(",")), e.is(t, "array")) for (i = t.length, r = 0; r < i; r++) {
          n = t[r].replace(/\B([A-Z]{1})/g, "-$1").toLowerCase(), this.node.removeAttribute(n), this.node.style[n] = "";
        }
        return this;
      };
    };

    var o = n(125);
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };

    t["default"] = function (e) {
      var t,
          n = window,
          i = Math.sqrt,
          a = n.parseFloat,
          s = n.parseInt,
          l = "none",
          c = "rgba(0,0,0,1)",
          u = n.SVGFilterElement || n.SVGFEColorMatrixElement && 2 === n.SVGFEColorMatrixElement.SVG_FECOLORMATRIX_TYPE_SATURATE,
          d = {
        "drop-shadow": "drop-shadow",
        stroke: "stroke",
        fill: "fill",
        "stroke-width": "stroke-width",
        "stroke-opacity": "stroke-opacity",
        "stroke-linecap": "stroke-linecap",
        "stroke-linejoin": "stroke-linejoin",
        "shape-rendering": "shape-rendering",
        opacity: "opacity",
        "fill-opacity": "fill-opacity"
      };
      e.svg ? (u && (e.filterShadow = function (t, n) {
        var r,
            s,
            l,
            u,
            d = t.dx || 1,
            f = t.dy || 1,
            h = t.spread || 3,
            p = t.color || "rgb(64,64,64)",
            g = t.paper,
            m = g.cacheShadows || (g.cacheShadows = {}),
            v = t.id || "drop-shadow-" + (n ? "layered" : "non-layered") + "-" + [d, f, h, p].join(" "),
            y = t.id || e.getElementID(v.replace(/[\(\)\s%:,\xb0#]/g, "_")),
            b = !!(t.id ? e._g.doc.getElementById(y) : m[v]);
        return g && !b ? ((p = e.color(p)).error && (p = e.color(c)), l = (0, o.pluck)(p.opacity, 1), l = t.opacity || l, s = (r = g.addDefs({
          filter: {
            tagName: "filter",
            id: y,
            y: "-1000%",
            x: "-1000%",
            width: "2000%",
            height: "2000%",
            children: [{
              tagName: "feOffset",
              result: "offOut",
              "in": "SourceGraphic",
              dx: a(d),
              dy: a(f)
            }, {
              tagName: "feColorMatrix",
              result: "matrixOut",
              "in": "offOut",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 " + l + " 0"
            }, {
              tagName: "feGaussianBlur",
              result: "blurOut",
              "in": "matrixOut",
              stdDeviation: n ? 1 : i(a(h))
            }, {
              tagName: "feComposite",
              "in": "SourceGraphic",
              in2: "blurOut",
              operator: "over"
            }]
          }
        })).filter.children, u = m[v] = {
          use: 1,
          hash: v,
          id: y,
          filter: r.filter.element,
          offset: s[0].element,
          matrix: s[1].element,
          blur: s[2].element,
          blend: s[3].element
        }) : (u = m[v]).use += 1, u;
      }, e.el.dropshadow = function (n, r, o, i, a, s) {
        var c,
            u,
            d,
            f,
            h,
            p,
            g,
            m,
            v = this,
            y = v._.shadowFilter,
            b = v.paper,
            x = b.cacheShadows || (b.cacheShadows = {}),
            w = "drop-shadow" + [n, r, o, i].join(" ");

        for (h = f = .05 * a, g = 1; g <= 3; g++) {
          h += f * g * (a - h);
        }

        if (u = (c = s ? v.shadowElem || v.clone({
          fill: l,
          stroke: "rgb(51, 51, 51)",
          "stroke-width": v.attr("stroke-width") || 1,
          opacity: h
        }, s).translate(n, r).follow(v, t, !s && "before") : v).shadowElem && c.shadowElem.node || c.node, n === l) {
          if (y) {
            if (y.use -= 1, u.removeAttribute("filter"), v.shadowElem && v.shadowElem.attr("opacity", 0), !y.use) {
              for (d in w = y.hash, y) {
                (m = y[d]).parentNode && m.parentNode.removeChild(m), delete y[d];
              }

              m = null, delete x[w];
            }

            y = null, delete v._.shadowFilter;
          }
        } else s && !v.shadowElem && (p = !0), s && (v.shadowElem = c), y = y && x[w] ? x[w] : v._.shadowFilter = e.filterShadow({
          paper: b,
          dx: n,
          dy: r,
          spread: o,
          color: i,
          opacity: !s && h
        }, !!s), !p && v.shadowElem && v.shadowElem.attr("opacity", h), u.setAttribute("filter", 'url("' + e._url + "#" + y.id + '")');

        return this;
      }), t = function t(e, _t2) {
        var n,
            r,
            o = this,
            i = {};

        for (r in e) {
          switch (d[r] && (i[r] = e[r], delete e[r]), r) {
            case "transform":
              (n = _t2.matrix.clone()).translate(o.__shadowx, o.__shadowy), o.transform(n.toTransformString());
              break;

            case "stroke-width":
              e[r] = i[r] || 1;
          }
        }

        for (r in o.attr(e), i) {
          e[r] = i[r];
        }
      }, e.ca["drop-shadow"] = function (n, r, i, a, u, d) {
        var f,
            h,
            p,
            g,
            m,
            v,
            y,
            b = this,
            x = b._.shadows || (b._.shadows = []);
        if (b.__shadowblocked) return !1;
        if (n === l) for (; h = x.pop();) {
          h.remove();
        } else for ((a = e.color(a)).error && (a = e.color(c)), u instanceof Array ? (m = u[0], v = u[1]) : m = v = u, m = 1 / (0, o.pluck)(m, 1), v = 1 / (0, o.pluck)(v, 1), n = (0, o.pluck)(n, 1) * m, r = (0, o.pluck)(r, 1) * m, f = .05 * (0, o.pluck)(a.opacity, 1), p = s(b.attr("stroke-width") || 1, 10) + 6, (g = b.matrix.clone()).translate(n, r), y = 1; y <= 3; y++) {
          (h = (x[y - 1] || b.clone().follow(b, t, !d && "before")).attr({
            stroke: a.hex,
            "stroke-opacity": f * y,
            opacity: "1",
            "stroke-width": (p - 2 * y) * v,
            transform: g.toTransformString(),
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            fill: l
          })).__shadowlevel = y, h.__shadowscale = v, h.__shadowx = n, h.__shadowy = r, d && d.appendChild(h), x.push(h);
        }
        return !1;
      }, e.el.shadow = function (t, n, i, a) {
        var s;

        if (i && i.constructor === e.el.constructor && (a = i, i = undefined), "object" === (void 0 === t ? "undefined" : r(t)) && (n && n.constructor === e.el.constructor && (a = n), n = t.opacity, i = t.scalefactor, s = t.useFilter !== undefined ? !!t.useFilter : !o.isIE9, t = t.apply === undefined ? !!n : t.apply), n === undefined && (n = 1), this.dropshadow) {
          if (s && !this.ca.hasOwnProperty("drop-shadow")) return t && this.dropshadow(1, 1, 3, "rgb(64,64,64)", n, a) || this.dropshadow(l), this;
          this._.shadowFilter && this.dropshadow(l);
        }

        return this.attr("drop-shadow", t ? [1, 1, 3, "rgba(64,64,64," + n + ")", i, a] : l);
      }) : e.vml ? (e.ca["drop-shadow"] = function (t, n, r, i, s, u) {
        var d,
            f,
            h,
            p,
            g = this,
            m = g._.shadow;
        return !g.isShadow && (t === l ? m && (m = g._.shadow = m.remove()) : (m || (m = g._.shadow = g.clone(), u && u.appendChild(m.follow(g)) || m.follow(g, void 0, "before"), m.attr({
          fill: "none",
          "fill-opacity": .5,
          "stroke-opacity": 1
        }).isShadow = !0, m.attr("stroke-width") <= 0 && m.attr("stroke-width", 1)), f = (d = m.node.runtimeStyle).filter.replace(/ progid:\S+Blur\([^\)]+\)/g, ""), (i = e.color(i)).error && (i = e.color(c)), p = (0, o.pluck)(i.opacity, 1) / 5, h = s instanceof Array ? s[0] : s, h = 1 / (0, o.pluck)(s, 1), t = (0, o.pluck)(t, 1) * h, n = (0, o.pluck)(n, 1) * h, m.translate(t, n), d.filter = f + " progid:DXImageTransform.Microsoft.Blur(pixelRadius=" + a(.4 * r) + " makeShadow=True Color=" + i.hex + ' shadowOpacity="' + p + '");'), !1);
      }, e.el.shadow = function (t, n, o, i) {
        return o && o.constructor === e.el.constructor && (i = o, o = void 0), "object" === (void 0 === t ? "undefined" : r(t)) && (n && "group" === n.type && (i = n), n = t.opacity, o = t.scalefactor, t = void 0 === t.apply ? !!n : t.apply), void 0 === n && (n = 1), this.attr("drop-shadow", t || !n ? [1, 1, 5, "rgba(64,64,64," + n + ")", o, i] : l);
      }) : e.canvas && (e.el.shadow = function () {
        return this;
      });
    };

    var o = n(125);
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function (e) {
      var t = /rgba\([\d]+\,[\d]+\,[\d]+\,0\)$/,
          n = window,
          o = Math,
          i = o.cos,
          a = o.sin,
          s = o.PI,
          l = n.parseInt,
          c = n.parseFloat,
          u = String,
          d = Array.prototype.slice,
          f = "hasOwnProperty",
          h = "M",
          p = "L",
          g = "Z",
          m = /\s*\,\s*/g;
      e && e._availableAnimAttrs && e._availableAnimAttrs.cx && (e._availableAnimAttrs["scroll-position"] = e._availableAnimAttrs.cx), e.define && e.define([{
        name: "polypath",
        polypath: function polypath() {
          return this.path(void 0, e._lastArgIfGroup(arguments));
        },
        ca: {
          polypath: function polypath(t, n, r, o, u, d) {
            var f, m, v, y, b;
            if (f = [], t = l(t, 10) || 0, n = c(n) || 0, r = c(r) || 0, o = c(o) || 0, u = null === u || isNaN(u) ? .5 * s : e.rad(u), d = null === d || isNaN(d) ? 0 : c(d), y = u, t > 2) switch (m = 2 * s / t, d) {
              case 0:
                for (v = 0; v < t; v++) {
                  f.push(p, n + o * i(-y), r + o * a(-y)), y += m;
                }

                f[0] = h, f.push(g);
                break;

              case 1:
                for (v = 0; v < t; v++) {
                  f.push(h, n, r, p, n + o * i(-y), r + o * a(-y)), y += m;
                }

                break;

              default:
                for (b = o * i(m *= .5) * (1 - d), v = 0; v < t; v++) {
                  f.push(p, n + o * i(-y), r + o * a(-y)), y += m, f.push(p, n + b * i(-y), r + b * a(-y)), y += m;
                }

                f[0] = h, f.push(g);
            } else 0 === o ? f.push(h, n, r, p, n, r, g) : f.push(h, n - o, r, "A", o, o, 0, 0, 0, n + o, r, "A", o, o, 0, 0, 0, n - o, r, g);
            return {
              path: f
            };
          },
          r: function r(e) {
            var t = this.attrs.polypath;
            return t[3] = e, this.attr("polypath", t), !1;
          }
        }
      }]), e.ca["text-bound"] = function (n, r, o, i, a, s, l) {
        var c = this,
            u = c.paper,
            d = c._.textbound;
        if (this._origOpacity = void 0 !== l ? l : 1, "text" === this.type) return r && "none" !== r && !t.test(r) || n && "none" !== n && !t.test(n) ? (c.attrs["text-bound"] = arguments, (!o || !e.is(o, "finite")) && (o = 0), (!a || !e.is(a, "finite")) && (a = 0), !d && (d = c._.textbound = u.rect(0, 0, 0, 0, c.group).follow(c, e.ca["text-bound"].reposition, "before")), d.attr({
          stroke: r || "none",
          "stroke-width": o,
          fill: n || "none",
          "shape-rendering": 1 === o ? "crisp" : "",
          r: a
        }), void 0 !== l && d.attr("opacity", l), s && d.attr("stroke-dasharray", s), e.ca["text-bound"].reposition.call(d, c.attr(), c), !1) : (c._.textbound = d && d.unfollow(c).remove(), !1);
      }, e.ca["text-bound"].reposition = function (e, t) {
        var n,
            o,
            i,
            a,
            s,
            l,
            d,
            h,
            p,
            g = this,
            v = {};
        e[f]("visibility") && g.attr("visibility", e.visibility), (e[f]("text-bound") || e[f]("x") || e[f]("y") || e[f]("text") || e[f]("text-anchor") || e[f]("text-align") || e[f]("font-size") || e[f]("line-height") || e[f]("vertical-align") || e[f]("transform") || e[f]("rotation") || e[f]("opacity")) && (o = (n = t.attrs)["text-bound"], i = u(o && o[3] || "0").split(m), a = c(i[0]) || 0, s = (0, r.pluck)(c(i[1]), a), h = (l = t.getBBox()).width, p = l.height, g._origOpacity = t._origOpacity || 1, d = c(e.opacity || n.opacity), v.opacity = isNaN(d) ? g._origOpacity : g._origOpacity * d, isNaN(h) || (v.x = l.x - a, v.y = l.y - s, v.width = Math.max(h + 2 * a, 0), v.height = Math.max(p + 2 * s, 0)), g.attr(v));
      }, e.fn.symbol = function () {
        var t,
            n = arguments,
            r = n.length - 1,
            o = n[r];
        return o && o.constructor === e.el.constructor ? n[r] = void 0 : o = void 0, (t = this.path(void 0, o)).ca.symbol = e.fn.symbol.ca.symbol, n.length === !!o + 0 ? t : t.attr("symbol", n);
      }, e.fn.getSuggestiveRotation = function () {
        var e, t, n, r;
        return e = arguments[0], 1 === arguments.length ? (t = e.angle, n = e.x, r = e.y) : (t = e, n = arguments[1], r = arguments[2]), "r" + (t = t || 0) + "," + n + "," + r;
      }, e.fn.symbol.cache = {
        "": e._cacher(function (e, t, n, r) {
          return arguments.length > 3 ? ["M", e, t, "h", n, "v", r, "h", -n, "v", -r, "z"] : ["M", e - n, t - n, "h", n *= 2, "v", n, "h", -n, "v", -n, "z"];
        })
      }, e.fn.symbol.ca = {
        symbol: function symbol(t) {
          var n,
              r,
              o = e.is(t, "object") && 1 === arguments.length && !e.is(t, "function") ? t : arguments;
          o === t && (t = o[0]), r = (n = e.is(t, "function") && t || e.fn.symbol.cache[t] || e.fn.symbol.cache[""]) && n.apply(e, d.call(o, 1)), e.is(r, "array") || e.is(r, "string") ? this.attr("path", r) : r && this.attr(r);
        }
      }, e.addSymbol = function (t, n) {
        var r,
            o,
            i = e.fn.symbol.cache,
            a = [];

        for (o in r = e.is(n, "function") && ((r = {})[t] = n, r) || t) {
          n = r[o], i[o] = e.is(n, "function") && e._cacher(n, e) || (a.push(o), n);
        }

        for (o = a.pop(); o;) {
          i[o] = i[i[o]], o = a.pop();
        }
      };
    };
    var r = n(125);
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };

    t["default"] = function (e) {
      var t = function t(e, _t3, r) {
        return function () {
          var o = n(e._.imageGridAttr, _t3),
              i = 1,
              a = 1,
              s = 1,
              l = void 0,
              c = void 0,
              u = void 0;

          if (o.tileInfo && (i = o.tileInfo.xCount, a = s = o.tileInfo.yCount, u = o.y, delete o.tileInfo), e._.gridElem) {
            for (c = 0; c < e._.gridElem.length; c++) {
              e._.gridElem[c].remove();
            }

            e._.gridElem.length = 0;
          }

          for (c = 0; i && o.width && o.height;) {
            s--, 0 === c ? e.attr(r ? Object.assign(o, {
              applysrc: e._._src
            }) : o) : (l = e.clone().attr({
              x: o.x,
              y: o.y
            }), e._.gridElem.push(l.follow(e, void 0, "after"))), o.y += o.height, 0 === s && (s = a, i--, o.x += o.width, o.y = u), c++;
          }
        };
      },
          n = function n(e, t) {
        var n = void 0;

        if (e) {
          var r = e.displayMode,
              i = e.vAlign,
              a = e.hAlign,
              s = e.scale,
              l = e.canvasBorderWidth,
              c = e.canvasWidth,
              u = e.canvasHeight,
              d = t.width * (s / 100),
              f = t.height * (s / 100),
              h = c - 2 * l,
              p = u - 2 * l;
          n = (0, o.getAlignImage)(i, a, r, d, f, c, u, l, h, p);
        }

        return n || {
          x: 0,
          y: 0,
          width: t.width,
          height: t.height
        };
      };

      e.define && e.define([{
        name: "imagegrid",
        imagegrid: function imagegrid() {
          var n = void 0,
              o = void 0,
              i = arguments,
              a = i.length - 1,
              s = i[a];
          return s && s.constructor === e.el.constructor ? i[a] = void 0 : s = void 0, n = new Image(), (o = this.image(s))._.gridElem = [], o._.refImage = n, o._attr = o.attr, o.attr = function (e, t) {
            var n = Array.isArray(e),
                i = !n && "object" === (void 0 === e ? "undefined" : r(e)),
                a = "string" == typeof e;

            if (n && (i = "object" === (void 0 === (e = e[0]) ? "undefined" : r(e))), i) {
              var s = Object.assign({}, e),
                  l = s && s.src,
                  c = s && s.applysrc;
              delete s.src, delete s.applysrc, l && delete o._._src, o._attr(s), l && o._attr({
                _src: l
              }), c && o._attr({
                src: c
              });
            } else {
              if (void 0 === e && void 0 === t) return this.attrs;
              if (void 0 === t) return this.attrs[e];
              a && t && ("src" === e ? o._attr({
                _src: t
              }) : "applysrc" === e ? o._attr({
                src: t
              }) : o._attr({
                name: t
              }));
            }

            return this;
          }, n.onload = t(o, n, !0), n.onerror = function (e) {
            return function () {
              e.hide();

              for (var t = 0, n = e._.gridElem && e._.gridElem.length; t < n; t++) {
                e._.gridElem[t].remove();
              }

              e._.gridElem = [], e._attr({
                src: e._._src
              }), setTimeout(function () {
                e.show();
              }, 100);
            };
          }(o), o;
        },
        ca: {
          imagegrid: function imagegrid(e, n, r) {
            var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100,
                i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0,
                a = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0,
                s = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0,
                l = this;
            "tile" === e || "fill" === e || "fit" === e ? ("top" !== n && "middle" !== n && "bottom" !== n && (n = "middle"), "left" !== r && "middle" !== r && "right" !== r && (r = "middle")) : ("top" !== n && "middle" !== n && "bottom" !== n && (n = "top"), "left" !== r && "middle" !== r && "right" !== r && (r = "left")), l._.imageGridAttr = {
              displayMode: e,
              vAlign: n,
              hAlign: r,
              scale: o,
              canvasBorderWidth: i,
              canvasWidth: a,
              canvasHeight: s
            }, this._._src && t(l, l._.refImage)();
          },
          _src: function _src(e) {
            return this._.refImage.src = e, this._._src = e, {
              _src: e
            };
          }
        }
      }]);
    };

    var o = n(130);
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };

    t["default"] = function (e) {
      var t,
          n,
          _o3,
          i = window,
          l = i.document,
          c = /msie/i.test(i.navigator.userAgent) && !i.opera,
          u = "VML" === e.type,
          d = {
        cursor: "cursor"
      },
          f = {
        x: "left",
        y: "top",
        strokeWidth: "borderThickness",
        "stroke-width": "borderThickness",
        width: "width",
        height: "height"
      },
          h = {
        fill: "backgroundColor",
        stroke: "borderColor",
        color: "color"
      },
          p = {
        left: 0,
        top: 0,
        padding: 0,
        border: "none",
        margin: 0,
        outline: "none",
        "-webkit-apperance": "none",
        position: "absolute",
        zIndex: 20
      },
          g = function g(e, t, n, r) {
        var o,
            i = l.createElement(e);

        for (o in t) {
          f[o] ? i.style[o] = t[o] : i.setAttribute(o, t[o]);
        }

        for (o in n) {
          i.style[o] = n[o];
        }

        return r && r.appendChild && r.appendChild(i), i;
      };

      (t = (_o3 = function o(e, t, n) {
        t && t instanceof _o3 && (t = t.element), this.element = g(e, n, p, t), this.nodeName = e.toLowerCase(), this.added = Boolean(t), this.attrs = {};
      }).prototype = {
        attr: function attr(e) {
          var t,
              n,
              o,
              i,
              a,
              s,
              p,
              g,
              m,
              v,
              y,
              b = this.element,
              x = {};
          if ("object" !== (void 0 === e ? "undefined" : r(e))) return void 0 !== this[e] ? this[e] : function (e, t, n) {
            var o, i;
            if ("string" == typeof t) void 0 !== n && null !== n ? e.setAttribute(t, n) : e && e.getAttribute && (i = e.getAttribute(t));else if (void 0 !== t && null !== t && "object" === (void 0 === t ? "undefined" : r(t))) for (o in t) {
              e.setAttribute(o, t[o]);
            }
            return i;
          }(b, e);

          for (t in e) {
            if (o = e[t], d[t]) {
              switch (t) {
                case "cursor":
                  "pointer" === o && u && (o = "hand");
              }

              b.style[d[t]] = o, i = !0;
            } else if (f[t]) b.style[f[t]] = o + "px", i = !0;else if (h[t]) b.style[h[t]] = (y = o) && y.replace(/^#?([a-f0-9]+)/gi, "#$1") || "none", i = !0;else if (/^visibility$/i.test(t)) a = "hidden" === o, b.style.display = a ? "none" : "", this.hidden = a, i = !0;else if (/^opacity$/i.test(t)) b.style.opacity = o, c && (n = 100 * Number(o), b.style.filter = "progid:DXImageTransform.Microsoft.Alpha(Opacity=" + n + ")"), i = !0;else if (/^innerhtml$/i.test(t)) {
              if (u && "select" == b.nodeName.toLowerCase()) {
                for (s = o.match(/<option\s?[\s\S]*?(\/>|><\/option>|>[\s\S]*?<\/option>)/gi); b.firstChild;) {
                  b.removeChild(b.firstChild);
                }

                for (g = 0, m = s.length; g < m; g += 1) {
                  p = s[g], v = l.createElement("option"), /<option\s([\s\S]*[\'\"])\s*?(\/>|>[\s\S]*<\/option>)/gi.test(p) && (v.value = p.replace(/<option\s([\s\S]*[\'\"])\s*?(\/>|>[\s\S]*<\/option>)/gi, "$1").replace(/[\s\S]*value\s*\=\s*[\'\"]([\s\S]*)[\'\"]/, "$1")), v.text = p.replace(/<option\s*[\s\S]*[\'\"]?\s*?[\/>|\>]([\s\S]*)<\/option>/gi, "$1 "), b.options.add(v);
                }
              } else "input" !== b.nodeName.toLowerCase() && void 0 !== o && (b.innerHTML = o || "");

              i = !0;
            } else /^text$/i.test(t) ? ("input" !== b.nodeName.toLowerCase() && (b.innerHTML = "", void 0 !== o && b.appendChild(l.createTextNode(o))), i = !0) : /^type$/i.test(t) && c && this.added && (i = !0);

            i && (x[t] = o, delete e[t], i = !1);
          }

          for (t in e) {
            b.setAttribute(t, e[t]);
          }

          for (t in x) {
            this[t] = this.attrs[t] = e[t] = x[t], delete x[t];
          }

          return this;
        },
        val: function val(e) {
          var t = this.element,
              n = void 0 === e;
          if ("input" === this.nodeName && "checkbox" === t.getAttribute("type")) return n ? this.checked() ? 1 : 0 : this.checked(e);

          if ("select" === this.nodeName) {
            var r = t.childNodes,
                o = t.selectedIndex,
                i = r.length;
            if ("" === e) return;
            if (!n) for (var a = 0; a < i; a++) {
              if (r[a].value === e) return t.selectedIndex = a, r[a].value;
            }
            return s.isIE9 && (o = 0), n ? r[o].value : (r[i - 1].value = e, t.selectedIndex = i - 1, this);
          }

          return n ? t.value : (t.value = e, this);
        },
        checked: function checked(e) {
          var t = this.element;
          return void 0 === e ? t.checked : (e ? t.setAttribute("checked", "checked") : t.removeAttribute("checked"), this);
        },
        css: function css(e, t) {
          var n,
              o = this.element.style;
          if ("object" === (void 0 === e ? "undefined" : r(e))) for (n in e) {
            o[n] = e[n];
          } else n && void 0 !== t && (o[n] = t);
          return this;
        },
        translate: function translate(e, t) {
          var n = this.element;
          return void 0 !== e && (n.style.left = e + "px"), void 0 !== t && (n.style.top = t + "px"), this;
        },
        add: function add(e, t) {
          var n = this.element,
              r = e.element;
          return t ? r.insertBefore(n, r.firstChild) : r.appendChild(n), this.added = !0, this;
        },
        hide: function hide() {
          return this.element.style.display = "none", this;
        },
        show: function show() {
          return this.element.style.display = "", this;
        },
        isVisible: function isVisible() {
          return "none" !== this.element.style.display;
        },
        focus: function focus() {
          "function" == typeof this.element.focus ? this.element.focus() : a["default"].fire(this.element, "focus");
        },
        destroy: function destroy() {
          var t,
              o = this.element || {};

          for (t in o.onclick = o.onmouseout = o.onmouseover = o.onmousemove = o.onblur = o.onfocus = null, o = function (e) {
            n || (n = g("div")), e && n.appendChild(e), n.innerHTML = "";
          }(o), delete this.element, this) {
            this[t] = "function" === r(this[t]) ? e._removedFactory(t) : null;
          }

          return this.removed = !0, null;
        },
        on: u ? function (e, t) {
          return this.element["on" + e] = function () {
            var e = i.event;
            e.target = e.srcElement, t(e);
          }, this;
        } : function (e, t) {
          var n = t;
          return s.hasTouch && "click" === e && (e = "touchstart", n = function n(e) {
            e.preventDefault(), t();
          }), this.element["on" + e] = n, this;
        },
        bind: function bind(e, t, n) {
          return a["default"].listen(this.element, e, t, n), this;
        },
        unbind: function unbind(e, t) {
          return a["default"].unlisten(this.element, e, t), this;
        },
        trigger: function trigger(e, t) {
          return a["default"].fire(this.element, e, t), this;
        }
      }).remove = t.destroy, t.constructor = _o3, e.fn.html = function (t, n, r, i) {
        var a,
            s,
            l = {};

        for (s in n && "type" in n && (l.type = n.type, delete n.type), a = new _o3(t, i, l).css(r).attr(n), l) {
          n[s] = l[s];
        }

        return a.ca = function () {
          return !1;
        }, a.appendTo = function (e) {
          e && e instanceof _o3 && (e = e.element), e.appendChild(this.element);
        }, a.animateWith = e.el.animateWith, a;
      };
    };

    var o,
        i = n(127),
        a = (o = i) && o.__esModule ? o : {
      "default": o
    },
        s = n(125);
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function (e) {
      var t = [{
        reg: /xmlns\=\"http\:\/\/www.w3.org\/2000\/svg\"/gi,
        repStr: ""
      }, {
        reg: /^.*<svg /,
        repStr: '<svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" '
      }, {
        reg: /\/svg>.*$/,
        repStr: "/svg>"
      }, {
        reg: /<desc\>[^<]*<\/desc\>/,
        repStr: ""
      }, {
        reg: /zIndex="[^"]+"/g,
        repStr: ""
      }, {
        reg: /url\((\\?[\'\"])[^#]+#/g,
        repStr: "url($1#"
      }, {
        reg: / href=/g,
        repStr: " xlink:href="
      }, {
        reg: /(id|class|width|height)=([^" >]+)/g,
        repStr: '$1="$2"'
      }, {
        reg: /:(path|rect)/g,
        repStr: "$1"
      }, {
        reg: /<ima?ge? ([^\>]+?[^\/])\>/gi,
        repStr: "<image $1 />"
      }, {
        reg: /<\/ima?ge?\>/g,
        repStr: ""
      }, {
        reg: /style="([^"]+)"/g,
        repStr: function repStr(e) {
          return e.toLowerCase();
        }
      }, {
        reg: /NS\d+\:href=/g,
        repStr: "xlink:href="
      }],
          n = function n(e) {
        var t = JSON.stringify(e);
        return t = t = (t = (t = (t = t.replace(/([a-z]+)([A-Z]+)([a-z]+)/g, function (e, t, n, r) {
          return t + "-" + n.toLowerCase() + r;
        })).replace(/\"\,\"/g, '";"')).replace(/\"/g, " ")).replace(/\{|\}/g, "");
      };

      e.svg && (e.fn.toSVG = function (e) {
        var r,
            o = "",
            i = 0,
            a = t.length;

        if (this.canvas && this.canvas.parentNode) {
          for (o = this.canvas.parentNode.innerHTML; i < a; i += 1) {
            r = t[i], o = o.replace(r.reg, r.repStr);
          }

          this._stylesheet && this._stylesheet.rules && (o = function (e, t) {
            var r,
                o,
                i,
                a,
                s,
                l,
                c,
                u = function u(e) {
              return e = e.match(/style\s*=/) ? e.replace(/(style\s*=")([^"]+)/g, function (e, t, n) {
                return t + a + n;
              }) : e.replace(/class\s*="[^"]*"/i, function (e) {
                return e + ' style="' + a + '" ';
              });
            };

            for (r in t) {
              if (t.hasOwnProperty(r)) for (l in o = /\s+/, i = r.split(o), a = n(t[r]), i) {
                i.hasOwnProperty(l) && (s = i[l].trim().replace(".", ""), c = new RegExp("<[^>]+(" + s + ")[^>]+", "g"), e = e.replace(c, u));
              }
            }

            return e;
          }(o, this._stylesheet.rules));
        }

        return e || (o = o.replace(/<image[^\>]*\>/gi, function (e) {
          return e.match(/href=\"data\:image/i) ? e : "";
        })), o;
      });
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t._mouseEvtHandler = undefined;
    var r = n(125),
        o = n(131),
        i = u(n(162)),
        a = n(138),
        s = u(n(163)),
        l = n(132),
        c = u(n(164));

    function u(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function d(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var f = r.creditLabel,
        h = function h(e, t, n) {
      var o,
          i,
          a,
          s,
          l,
          c,
          u,
          d,
          f = n.mouseTracker,
          h = t.originalEvent,
          p = e.config.datasetOrder || e.getDatasets(),
          g = !1,
          m = p.length,
          v = f._lastDatasetIndex,
          y = f._lastPointIndex;

      for (i = (o = (0, r.getMouseCoordinate)(e.getFromEnv("chart-container"), h, e)).chartX, a = o.chartY; m-- && !g;) {
        (s = p[m]) && s.getState("visible") && (l = s._getHoveredPlot && s._getHoveredPlot(i, a)) && l.hovered && (g = !0, l.datasetIndex = m, d = f.getMouseEvents(t, l.datasetIndex, l.pointIndex));
      }

      if ((!g || d && d.fireOut) && void 0 !== v && p[v] && p[v]._firePlotEvent && (d && !d.events.length ? f.mouseoutTimer = setTimeout(function () {
        e.mouseoutHandler(t, v, y);
      }, 20) : (e.mouseoutHandler(t, v, y), clearTimeout(f.mouseoutTimer))), g) for ((u = d.events && d.events.length) && (f._lastDatasetIndex = l.datasetIndex, y = f._lastPointIndex = l.pointIndex), c = 0; c < u; c += 1) {
        s && s._firePlotEvent && s && s._firePlotEvent && s._firePlotEvent(d.events[c], y, t, l.datasetIndex);
      }
    },
        p = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return d(t, e), t.getName = function () {
        return "base";
      }, t.prototype.setDummyEImethods = function (e) {
        var t = this.config,
            n = t._eiStore || (t._eiStore = {}),
            r = function (e) {
          return (c["default"][e] || []).concat(c["default"]["*"]);
        }(e),
            o = this.getFromEnv("chartInstance");

        r.forEach(function (e) {
          var t;
          !o[e] && (o[e] = (t = e, function () {
            !n[t] && (n[t] = []), n[t].push(arguments);
          }));
        }), o.addEventListener("renderComplete", function () {
          var e = function e(_e2) {
            n[_e2].forEach(function (t) {
              o[_e2].apply(o, t);
            });
          };

          for (var r in n) {
            e(r);
          }

          t._eiStore = {};
        });
      }, t.getType = function () {
        return "chartAPI";
      }, t.prototype.mouseoutHandler = function (e, t, n) {
        var r = this.config.datasetOrder || this.getDatasets(),
            o = this.getChildren("mouseTracker")[0];
        r[t] && r[t].components.data[n] ? r[t]._firePlotEvent("fc-mouseout", n, e) : this.getFromEnv("toolTipController").hideAll(), delete o._lastDatasetIndex, delete o._lastPointIndex;
      }, t.prototype.getName = function () {
        return "base";
      }, t.prototype.getType = function () {
        return "chartAPI";
      }, t.prototype._mouseEvtHandler = function (e, t) {
        h(this, e, t);
      }, t.prototype.getComponents = function (e, t) {
        var n = [];
        return (e || this).iterateComponents(function (e) {
          e.getType() === t && n.push(e);
        }), n;
      }, t.prototype.getDatasets = function (e) {
        var t = [];
        return (e || this).iterateComponents(function (e) {
          "dataset" === e.getType() && t.push(e);
        }), t;
      }, t.prototype.preConfigure = function (t) {
        e.prototype.preConfigure.call(this, t), function (e, t) {
          var n = void 0;

          for (n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        }(this.getFromEnv("chartInstance"), this.eiMethods);
      }, t.prototype.configureAttributes = function (t) {
        e.prototype.configureAttributes.call(this, t), this.createBaseComponent();
      }, t.prototype.createBaseComponent = function () {
        var e = this,
            t = void 0;
        (t = e.getFromEnv("animationManager")) ? t.configure() : (t = new s["default"](), e.addToEnv("animationManager", t), t.addToEnv("chart", e), t.addToEnv("animationManager", t), t.configure(), e.addExtEventListener("animationstart", function (t) {
          var n = t.data.duration;
          n && e.fireChartInstanceEvent("animationinvoked", {
            duration: n
          });
        }, t));
      }, t.prototype.setChartMessage = function (e, t, n) {
        var o, a;
        (0, r.componentFactory)(this, i["default"], "chartMessage"), a = this.getChildren("chartMessage")[0], n ? this.addToEnv("chart-container", n) : n = this.getFromEnv("chart-container"), (o = this.getFromEnv("paper")) || ((o = new ((0, l.getDep)("redraphael", "plugin"))(n, this.getFromEnv("chartWidth"), this.getFromEnv("chartHeight"))).setHTMLClassName("fusioncharts-div"), this.addToEnv("paper", o)), o.setConfig("stroke-linecap", r.ROUND), !this.getChildContainer("messageGroup") && this.addChildContainer("messageGroup", o.group("messageGroup")), this.config.hasChartMessage = !0, a.setChartMessage(e, t);
      }, t.prototype.drawChartMessage = function () {
        this.config.hasChartMessage = !0, this.getChildren("chartMessage")[0].drawChartMessage(), this._drawCreditLabel();
      }, t.prototype._dispose = function () {
        this._clearTimers && this._clearTimers();
        var t = this.getFromEnv("paper");
        t && t.remove && t.remove(), e.prototype._dispose.call(this);
      }, t.prototype.fireChartInstanceEvent = function (e, t, n, r, i) {
        var a = this.getFromEnv("chartInstance");
        (0, o.triggerEvent)(e, a, t, n, r, i);
      }, t.prototype._hideChartMessage = function () {
        var e = this.getChildren("chartMessage");
        this.config.hasChartMessage = !1, e && e[0]._hideChartMessage(), this.getGraphicalElement("messageText") && this.getGraphicalElement("messageText").hide(), this.getGraphicalElement("messageVeil") && this.getGraphicalElement("messageVeil").hide();
      }, t.prototype._removeWaitingJobs = function () {
        this.iterateComponents(function (e) {
          return e.removeAllJobs();
        });
      }, t.prototype._drawCreditLabel = function () {
        var e,
            t,
            n,
            o,
            i = this.getFromEnv("core-options"),
            a = this.getFromEnv("paper"),
            s = i.creditLabel,
            l = this.getFromEnv("chartInstance").args.creditLabel,
            c = +this.getFromEnv("chartHeight"),
            u = this.getGraphicalElement("creditLabel"),
            d = this.getContainer("parentgroup"),
            h = {
          href: r.CREDIT_HREF,
          text: r.CREDIT_STRING
        };
        (0, r.pluck)(l, s, f) ? (t = this.getContainer("creditgroup") || this.addContainer("creditgroup", a.group("creditgroup")), d && t.insertAfter(d), n = {
          text: h.text,
          x: 6,
          y: c - 4,
          "vertical-align": r.POSITION_BOTTOM,
          "text-anchor": r.POSITION_START,
          fill: "rgba(0,0,0,0.5)",
          title: h.title || r.BLANK
        }, o = {
          fontSize: 9,
          fontFamily: "Verdana,sans",
          cursor: r.POINTER,
          _cursor: r.HAND
        }, u ? u.attr(n).css(o) : (e = a.text(n, o, t), this.addGraphicalElement("creditLabel", e), e.on("fc-click", function () {
          try {
            open(h.href);
          } catch (e) {
            (top || window).location.href = h.href;
          }
        }))) : e && e.remove && this.removeGraphicalElement("creditLabel");
      }, t.prototype._hideModal = function () {
        this.getChildContainer("messageGroup").hide();
      }, t.prototype.remove = function (t) {
        var n = this.getFromEnv("animationManager");
        e.prototype.remove.call(this, t), n && n.remove(t);
      }, t;
    }(a.ComponentInterface);

    p.stringConstants = {
      BACKGROUNDLOADED: "BackgroundLoaded",
      BACKGROUNDLOADERROR: "BackgroundLoadError",
      clipRectStr: "clip-rect"
    }, t._mouseEvtHandler = h, t["default"] = p;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(138),
        o = n(125);

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var a = o.preDefStr.noneStr,
        s = function s(e, t) {
      e.on("fc-click", function () {
        try {
          open(t);
        } catch (e) {
          (top || window).location.href = t;
        }
      }), e.css({
        cursor: "pointer",
        _cursor: "pointer"
      });
    },
        l = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return i(t, e), t.prototype.getName = function () {
        return "chartMessage";
      }, t.prototype._drawBackground = function (e) {
        var t,
            n,
            r,
            i,
            l = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            c = this,
            u = c.config,
            d = c.getFromEnv("paper"),
            f = c.getFromEnv("chart"),
            h = c.getGraphicalElement("backgroundElement"),
            p = c.getGraphicalElement("backgroundImage"),
            g = c.getFromEnv("chartWidth"),
            m = c.getFromEnv("chartHeight"),
            v = c.getLinkedParent().getChildContainer("messageGroup").show(),
            y = (0, o.pluckNumber)(l.imageAlpha, 100),
            b = 0 + o.COMMA + 0 + o.COMMA + g + o.COMMA + m,
            x = (0, o.getValidValue)(l.imageVAlign, o.BLANKSTRING).toLowerCase(),
            w = (0, o.pluck)(l.imageHAlign, o.BLANKSTRING).toLowerCase(),
            C = (0, o.pluckNumber)(l.imageScale, 100),
            _ = c.getFromEnv("chartInstance"),
            S = u.messageURL,
            E = (0, o.getContainerBackgroundColor)(_);

        d.canvas.style.backgroundColor = E, x !== o.POSITION_TOP && x !== o.POSITION_MIDDLE && x !== o.POSITION_BOTTOM && (x = o.POSITION_TOP), w !== o.POSITION_LEFT && w !== o.POSITION_MIDDLE && w !== o.POSITION_RIGHT && (w = o.POSITION_LEFT), n = {
          x: 0,
          y: 0,
          width: g,
          height: m,
          stroke: a
        }, h || (h = d.rect(v), c.addGraphicalElement("backgroundElement", h)), h.attr(n), h && S && s(h, S), u.bgImageVAlign = x, u.bgImageHAlign = w, u.bgImageScale = C, u.bgSWFAlpha = y, u.imgClipRect = b, e && ((t = p) ? t.attr({
          src: e
        }) : (t = c.getFromEnv("paper").image(v), c.addGraphicalElement("backgroundImage", t), t.attr({
          src: e
        }), t.on("load", function () {
          if (!(!t || t && t.removed)) {
            var n = t._.RefImg;
            r = c.getFromEnv("chartConfig"), u.isImage && (void 0 === r || r.hasChartMessage) && (i = (0, o.setImageDisplayMode)(a, u.bgImageVAlign, u.bgImageHAlign, u.bgImageScale, 0, c.getFromEnv("chartWidth"), c.getFromEnv("chartHeight"), n), (0, o.extend2)(i, {
              opacity: .01 * u.bgSWFAlpha,
              visibility: "visible",
              "clip-rect": u.imgClipRect
            }), t.attr(i).show(), t && S && s(t, S), f.fireChartInstanceEvent("backgroundloaded", {
              url: e,
              bgImageAlpha: 100 * u.bgSWFAlpha,
              bgImageDisplayMode: a,
              bgImageVAlign: u.bgImageVAlign,
              bgImageHAlign: u.bgImageHAlign,
              bgImageScale: u.bgImageScale,
              imageWidth: n.width,
              imageHeight: n.height
            }));
          }
        }), t.on("error", function (n) {
          t.removed || f.fireChartInstanceEvent("backgroundloaderror", {
            url: e,
            bgImageAlpha: 100 * u.bgSWFAlpha,
            error: n,
            bgImageDisplayMode: a,
            bgImageVAlign: u.bgImageVAlign,
            bgImageHAlign: u.bgImageHAlign,
            bgImageScale: u.bgImageScale
          }, _);
        })));
      }, t.prototype.setChartMessage = function (e, t) {
        var n,
            r,
            i,
            a,
            s = this.getFromEnv("chartInstance"),
            l = s.options,
            c = s.args,
            u = this.config,
            d = this.getFromEnv("smartLabel"),
            f = (0, o.getImageURL)(void 0 !== e ? e : l.dataEmptyMessage),
            h = this.getFromEnv("chartWidth"),
            p = this.getFromEnv("chartHeight");
        r = u.width = Number(h), n = u.height = Number(p), f.image ? (i = f.string, a = t ? {
          imageHAlign: (0, o.pluck)(t._chartMessageImageStyle.imageHAlign, l.baseChartMessageImageHAlign).toLowerCase(),
          imageVAlign: (0, o.pluck)(t._chartMessageImageStyle.imageVAlign, l.baseChartMessageImageVAlign).toLowerCase(),
          imageAlpha: (0, o.pluckNumber)(t._chartMessageImageStyle.imageAlpha, l.baseChartMessageImageAlpha),
          imageScale: (0, o.pluckNumber)(t._chartMessageImageStyle.imageScale, l.baseChartMessageImageScale)
        } : {
          imageHAlign: (0, o.pluck)(c.dataEmptyMessageImageHAlign, l.baseChartMessageImageHAlign).toLowerCase(),
          imageVAlign: (0, o.pluck)(c.dataEmptyMessageImageVAlign, l.baseChartMessageImageVAlign).toLowerCase(),
          imageAlpha: (0, o.pluckNumber)(c.dataEmptyMessageImageAlpha, l.baseChartMessageImageAlpha),
          imageScale: (0, o.pluckNumber)(c.dataEmptyMessageImageScale, l.baseChartMessageImageScale)
        }, u.chartMessageType = "image") : (a = t ? {
          "font-family": t._chartMessageStyle.fontFamily || l.baseChartMessageFont,
          "font-size": t._chartMessageStyle.fontSize || l.baseChartMessageFontSize,
          fill: t._chartMessageStyle.color || l.baseChartMessageColor
        } : {
          "font-family": c.dataEmptyMessageFont || l.baseChartMessageFont,
          "font-size": c.dataEmptyMessageFontSize || l.baseChartMessageFontSize,
          fill: c.dataEmptyMessageColor || l.baseChartMessageColor
        }, d.setStyle(a), i = {
          text: d.getSmartText((0, o.parseUnsafeString)(f.string), r, n).text,
          x: r / 2,
          y: n / 2
        }, u.chartMessageType = "text"), u.messageURL = l.messageURL, u.chartMessageAttr = i, u.chartMessageStyle = a;
      }, t.prototype.drawChartMessage = function () {
        var e,
            t,
            n,
            r = this.config,
            i = this.getFromEnv("paper"),
            a = r.isImage = "image" === r.chartMessageType,
            l = r.messageURL,
            c = a ? r.chartMessageAttr : (0, o.extend2)(r.chartMessageAttr, r.chartMessageStyle);
        e = this.getGraphicalElement("messageText"), n = this._graphics, t = this.getLinkedParent().getChildContainer("messageGroup").show(), a ? this._drawBackground(r.chartMessageAttr, r.chartMessageStyle) : e || "text" !== r.chartMessageType ? (n.message = e.attr(c), e.show()) : e = this.addGraphicalElement("messageText", i.text(c, t)), (e || n.message) && l && s(e || n.message, l), this._hideOtherMessage(a);
      }, t.prototype._hideOtherMessage = function (e) {
        var t, n, r;
        e ? (n = this.getGraphicalElement("messageText")) && n.hide() : (t = this.getGraphicalElement("backgroundImage"), r = this.getGraphicalElement("backgroundElement"), t && t.hide(), r && r.hide());
      }, t.prototype._hideChartMessage = function () {
        this._hideOtherMessage(!0), this._hideOtherMessage();
      }, t.prototype.getType = function () {
        return "chartMessage";
      }, t;
    }(r.ComponentInterface);

    t["default"] = l;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        o = n(125),
        i = n(136),
        a = n(138),
        s = n(132);

    function l(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var c = void 0,
        u = !o.hasSVG,
        d = {
      initial: 1,
      update: 0,
      realTimeUpdate: 0,
      resize: 0,
      dispose: 0,
      legendInteraction: 0,
      scroll: 0,
      mouseOut: 0,
      mouseOver: 0,
      "default": 0,
      slicing: .25,
      timenavSqueeze: 0,
      selectedRange: 0,
      timenavScroll: 0
    },
        f = ["default", "global", "chartSpecific"],
        h = {
      fadeIn: {
        opacity: {
          start: 0,
          end: 1
        }
      },
      fadeOut: {
        opacity: {
          start: 1,
          end: 0
        }
      }
    },
        p = {
      fadeIn: function fadeIn() {
        this && this.show();
      },
      fadeOut: function fadeOut() {
        this && this.hide();
      }
    },
        g = function g(e) {
      return null === e;
    },
        m = function m(e) {
      var t = [];
      return (arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "").split(",").forEach(function (n) {
        e[n] && e[n].animation && t.push(e[n].animation);
      }), t;
    },
        v = function v(e, t, n) {
      var r,
          o = Object.assign({}, e),
          i = n / t;
      return i > .2 && (i = .2), r = o.end - o.start, o.start *= 1 - i, o.start += i, o.end = o.start + (1 - i) * r, o.start = Math.round(100 * o.start) / 100, o.end = Math.round(100 * o.end) / 100, o;
    },
        y = function y(e, t, n) {
      var r,
          o = h[t],
          i = "",
          a = {};

      if (o && e && e.el && e.el[0]) {
        for (i in o) {
          a[i] = e.el.attrs[i], a[i] === c && (a[i] = null), e.attrs[i] = o[i].end, e.el.attr(i, o[i].start);
        }

        r = e.callback, e.callback = function () {
          n && p[t] && p[t].call(this), r && r.call && r.call(this), this.attr(a);
        };
      }
    },
        b = function b(e, t) {
      var n,
          r = !0;

      if (t) {
        for (e.attrs = e.attrs || {}, ~(t = t.split("-")).indexOf("nc") && (r = !1), n = t.length; n--;) {
          y(e, t[n], r);
        }

        return e;
      }
    },
        x = function x(e, t, n, r, o, i, a, s) {
      e.animateWith(o, i, t, a, s, n, r);
    },
        w = function w(e) {
      var t = {};

      for (var n in e) {
        if (e.hasOwnProperty(n) && "__esModule" !== n) {
          var r = e[n];
          C(t, r);
        }
      }

      return t;
    },
        C = function C(e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (!e[n] && (e[n] = []), e[n].push(t[n]));
      }
    },
        _ = function _(e) {
      return "function" === (void 0 === e ? "undefined" : r(e));
    };

    function S(e, t, n, r) {
      var o,
          i,
          a,
          s,
          l,
          c = e.length,
          u = 0,
          d = 0,
          f = t;

      for (i = 0, a = 0, l = 0; l < c; l += 1) {
        (o = e[l]).hasAnimation || !1 === o.collapsible ? a += 1 : i += o.duration, d += o.duration;
      }

      for (i /= a, l = 0; l < c; l += 1) {
        (o = e[l]).hasAnimation && (s = n - t, f = (u = f) + (o.duration / d + i) * s, r[o.name] = {
          start: u,
          end: f,
          effect: o.effect,
          transition: o.transition
        }, o.child && k(o.child, u, f, r));
      }
    }

    function E(e, t, n, r) {
      var o, i, a;
      i = e.start, a = e.end, i = t + i * (o = n - t), a = t + a * o, r[e.name] = {
        start: i,
        end: a,
        effect: e.effect,
        transition: e.transition
      }, e.child && k(e.child, i, a, r);
    }

    function k(e, t, n, r) {
      var o,
          i,
          a = e.length;

      for (o = 0; o < a; o++) {
        i = e[o], Array.isArray(i) ? S(i, t, n, r) : E(i, t, n, r);
      }
    }

    h.fadein = h.fadeIn, h.fadeout = h.fadeOut;

    var A = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this)),
            r = n;

        return r._removedGraphics = [], r._animCallBack = function () {
          if (!r.getState("removed") && !this.removed) {
            var e = r.getAnimationState();
            r._removeElems(), r.reset(), r.fireEvent("animationComplete", {
              currAnimState: e
            });
          }
        }, r.startAnimation = function () {
          r.kickStart(), r.animate();
        }, n;
      }

      return l(t, e), t.prototype.getType = function () {
        return "animationManager";
      }, t.prototype.getName = function () {
        return "animationManager";
      }, t.prototype.stopAnimation = function () {
        if (this.getState("chartAnimating")) {
          var e,
              t = this.config.animationObj,
              n = t && t.duration;
          n ? (e = this.getGraphicalElement().dummyObj) && e.stop(c, !0, !0) : 0 === n && (this.removeJob("anim-callBack"), this._animCallBack());
        }
      }, t.prototype.kickStart = function () {
        var e,
            t,
            n = this.config,
            r = this.getGraphicalElement(),
            o = this.getFromEnv("paper"),
            i = n.animationObj,
            a = void 0,
            l = n.animationeffect;
        e = i.duration, i.animObj = t = (0, s.getDep)("redraphael", "plugin").animation({
          x: 0
        }, e, l, this._animCallBack, !0), i.animType = l, (a = r.dummyObj) ? a.attr({
          x: 100
        }) : (a = o.rect({
          x: 100,
          y: 0,
          width: 10,
          height: 30
        }), this.addGraphicalElement("dummyObj", a), a.hide()), i.dummyObj = r.dummyObj, a.stop(c, !0, !0), this.fireEvent("animationStart", {
          duration: e
        }), this.setState("chartAnimating", !0), a.animate(t);
      }, t.prototype.setAnimationState = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : c;
        e && this.stopAnimation(), this.config.__state = e, this._setAnimDuration(e);
      }, t.prototype.getAnimationState = function () {
        return this.config && this.config.__state;
      }, t.prototype._setAnimDuration = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default",
            n = this.config,
            r = n.animationObj || (n.animationObj = {}),
            o = n.animationDuration || (n.animationDuration = {}),
            i = this.getFromEnv("chart").getFromEnv("chart-attrib") || {},
            a = e + "AnimDuration",
            s = n.killSwitch ? 0 : 1e3 * (o[a] || i[a.toLowerCase()] || t.getFallbackAnimDuration(e));
        r && (r[a] = s, r.duration = +s);
      }, t.prototype.configureAttributes = function () {
        var e = this.getFromEnv("chart"),
            t = e.config,
            n = this.config,
            r = e.getFromEnv("chart-attrib") || {};
        n.killSwitch = !(0, o.pluckNumber)(r.animation, t.animation, 1), n.animationeffect = t.animationeffect || "linear", this.invokeAnimationRules(), !n.workingRules && (n.workingRules = {}), !n.animateArr && (n.animateArr = []), !n.animationName && (n.animationName = []);
      }, t.prototype.invokeAnimationRules = function () {
        var e = this.getFromEnv("chart"),
            n = e.getFromEnv("chart-attrib") || {},
            r = e.config || {},
            i = this.config,
            a = e.getFromEnv("chartInstance").args.animation,
            l = e.getFromEnv("core-options").defaultTheme,
            c = function (e) {
          var t = {},
              n = void 0;

          for (var r in e) {
            e.hasOwnProperty(r) && (t[(n = e[r]).name] = n);
          }

          return t;
        }((0, s.getDepsByType)("theme")),
            u = (e.getFromEnv("core-options")._globalAnimationRule || []).concat(m(c, l)),
            d = (a && [a] || []).concat(m(c, r.theme)),
            f = void 0;

        i.animationRules = {
          global: w(u.map(function (e) {
            return e && e.rule;
          }).filter(function (e) {
            return e;
          })),
          chartSpecific: w(d.map(function (e) {
            return e && e.rule;
          }).filter(function (e) {
            return e;
          })),
          "default": w((0, s.getDepsByType)("animationRule"))
        }, i.animationDuration = f = {}, u.map(function (e) {
          return Object.assign(f, e.duration);
        }), d.map(function (e) {
          return Object.assign(f, e.duration);
        }), f.initialAnimDuration = (0, o.pluckNumber)(f.initialAnimDuration, n.initialanimduration, n.animationduration), this.config.slots = t.getFallbackAnimTimeSlots().concat([].concat.apply([], u.map(function (e) {
          return e.slots;
        })).filter(function (e) {
          return e;
        })).concat([].concat.apply([], d.map(function (e) {
          return e.slots;
        })).filter(function (e) {
          return e;
        }));
      }, t.prototype.reInitialize = function () {
        var e = this.config.animationObj.duration;
        this.setState("initialized", !0), e ? this.addJob("start-animation", this.startAnimation, i.priorityList.animation) : (this.fireEvent("animationStart", {
          duration: e
        }), this.setState("chartAnimating", !0), this.addJob("anim-callBack", this._animCallBack, i.priorityList.animation));
      }, t.prototype.reset = function () {
        this.setState("initialized", !1), this.config && this.config.animateArr && (this.config.animateArr.length = 0), this.setState("chartAnimating", !1), this.setAnimationState();
      }, t.prototype.registerAnimObj = function (e) {
        var t;

        for (t in e) {
          this.registerAnimation(e[t], t);
        }
      }, t.prototype.getFinalSlots = function () {
        var e = this.config,
            t = e.slots,
            n = e.workingRules = {};
        return function r(e, t) {
          var n,
              o,
              i,
              a,
              s,
              l,
              c = !1;
          if (!e) return !1;

          for (i = 0, a = e.length; i < a; i += 1) {
            if (o = e[i], Array.isArray(o)) for (s = 0, l = e[i].length; s < l; s += 1) {
              o = e[i][s], n = !1, -1 !== t.indexOf(o.name) ? n = !0 : o.child && (n = o.hasAnimation = r(o.child, t)), c = c || n, o.hasAnimation = n;
            } else n = !1, -1 !== t.indexOf(o.name) ? n = !0 : o.child && (n = o.hasAnimation = r(o.child, t)), c = c || n, o.hasAnimation = n;
          }

          return c;
        }(t, e.animationName), k(t, 0, 1, n), n["default"] = {
          start: 0,
          end: 1
        }, n;
      }, t.prototype.registerOne = function (e, t) {
        this.registerAnimation([{
          data: [e]
        }], t);
      }, t.prototype.registerAnimation = function () {
        var e,
            t,
            n,
            r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
            o = arguments[1],
            i = !1;

        for (e = 0, n = r.length; e < n; e += 1) {
          (t = r[e]).data && t.data.length && (this.config.animateArr.push((t.component = o, t)), i = !0);
        }

        i && this.config.animationName.push(o), !this.getState("initialized") && this.reInitialize();
      }, t.prototype.onAnimationComplete = function (e) {
        this.addEventListener("animationComplete", function (t) {
          e(), t.detachHandler();
        });
      }, t.removeOpacityFromGroup = function (e, t) {
        t && u && ("group" === e || "group" === e.type) && delete t.opacity;
      }, t.prototype.setAnimation = function () {
        var e,
            n,
            o,
            i,
            a,
            s,
            l,
            u,
            d,
            f,
            h,
            p,
            g,
            m,
            v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            y = this.config,
            b = y.animationObj,
            x = v.el,
            w = v.attr || {},
            C = {},
            _ = {},
            S = function S(e, t, n, r) {
          return function () {
            n.callback && n.callback.call(this), e && this.attr(e), t && v.callback && v.callback.call(this), r && this.appendTo(r);
          };
        },
            E = function E(e, t, n) {
          return function () {
            t.hookFn && t.hookFn.call(this), e && this.attr(e), n && this.appendTo(n);
          };
        },
            k = [],
            A = b.duration,
            T = this.getState("chartAnimating"),
            M = "object" === (void 0 === x ? "undefined" : r(x)) && v.container && x.parent !== v.container;

        if (this.getState("chartAnimating") && y.animationObj && y.animationObj.duration && this.setAnimationState("default"), !T && A && (d = this.getAnimAttributes(v))) {
          for (u = d.length, m = !1, h = !(f = "appearing" === v.state || "string" === (void 0 === x ? "undefined" : r(x))) && x.attrs, l = {}, s = 0; s < u; s++) {
            for (i in p = s === u - 1, a = k[s] = {}, e = (g = d[s]).finalAttr, n = g.initialAttr, t.removeOpacityFromGroup(v.el, n), t.removeOpacityFromGroup(v.el, e), n) {
              l[i] = n[i], _[i] === c && (_[i] = n[i]);
            }

            for (i in e) {
              l[i] = e[i], f && _[i] === c && (_[i] = e[i]);
            }

            if (a.attrs = e, a.transition = g.transition, a.effect = g.effect, a.animConfig = [g.startEnd], g.callback && (a.callback = g.callback), (m = M && g.changeGroup) && (M = !1), p) {
              if (f) for (i in w) {
                _[i] === c && (_[i] = w[i]);
              }

              for (i in w) {
                o = w[i], !l[i] && f || l[i] === o || (e && e[i] === c ? e[i] = o : C[i] = o);
              }

              for (i in l) {
                C[i] === c && (o = w[i] || h[i] || "", l[i] !== o && (e && e[i] === c && o !== c ? e[i] = o : C[i] = o));
              }

              e || (a.attrs = C), a.callback = S((e || n) && C, p, g, M && v.container), x = this.setAttributes(x, {
                attr: _,
                inputJSON: v
              });
            }

            (n || g.hookFn || m) && (a.animConfig[0].hookFn = E((!f || s) && n, g, m && v.container));
          }

          for (s = 0; s < u; s++) {
            k[s].el = x.el, this.registerAnimation([{
              data: [k[s]]
            }], d[s].slot);
          }
        } else T ? x = this.setAttributes(x, {
          attr: w,
          inputJSON: v,
          groupChangeReq: M,
          immediate: !0
        }) : (this.registerAnimation(), x = this.setAttributes(x, {
          attr: w,
          inputJSON: v,
          groupChangeReq: M,
          immediate: !0
        }));

        return x.removed ? null : x.el;
      }, t.prototype._removeElems = function () {
        if (this.getFromEnv("paper") && !this.getFromEnv("paper").removed) {
          this._removedGraphics.forEach(function (e) {
            return e.remove && e.remove();
          }), this._removedGraphics.length = 0;
        }
      }, t.prototype.removeElement = function (e, t) {
        return t ? e.remove() : this._removedGraphics.push(e), null;
      }, t._ruleSelectorQueryBuilder = function (e) {
        var t = !(arguments.length > 1 && arguments[1] !== undefined) || arguments[1],
            n = e.label,
            r = e.state,
            o = e.component,
            i = o.getType(),
            a = o.getName();

        if (t) {
          var s = ["*", "*.*", "*.*.*"],
              l = ["*.*." + a, "*." + i + ".*", "*." + i + "." + a];
          return "*" === r ? s.concat(l) : s.concat(l, [r + ".*", r + ".*.*", r + ".*." + a, r + "." + i + ".*", r + "." + i + "." + a]);
        }

        return [n + "." + r, n + ".*", "*." + r, "*.*", "*"];
      }, t.prototype._getRulesByState = function (e) {
        var n,
            r = e.component,
            o = void 0,
            i = void 0,
            a = void 0,
            s = this.getAnimationState() || "*",
            l = t._ruleSelectorQueryBuilder(Object.assign(e, {
          state: s
        }));

        return (n = (a = r.getState("animRules") || {})[s]) ? n : (o = a[s] = {}, i = this.config.animationRules, f.forEach(function (e) {
          var t = i[e];
          t && l.forEach(function (e) {
            t[e] && (Array.isArray(t[e]) ? t[e].forEach(function (e) {
              o = a[s] = g(e) ? null : Object.assign(o || {}, _(e) ? e.call(r) : e);
            }) : o = a[s] = g(t[e]) ? null : Object.assign(o || {}, _(t[e]) ? t[e].call(r) : t[e]));
          });
        }), r.setState("animRules", a), !r.getState("ruleFlushAttached") && r.addExtEventListener("predraw", function () {
          r.setState("animRules", c), r.setState("ruleFlushAttached", !0);
        }, r.getFromEnv("chart")), o);
      }, t._getRulesByElement = function (e, n) {
        var r = void 0;
        return t._ruleSelectorQueryBuilder(n, !1).forEach(function (t) {
          r === undefined && (r = e[t]);
        }), r;
      }, t.prototype.getAnimAttributes = function (e) {
        var n,
            o = e.component || this.getFromEnv("chart"),
            i = e.label || ("object" === r(e.el) ? e.el.type : e.el),
            a = e.state,
            s = this._getRulesByState({
          label: i,
          component: o
        }),
            l = void 0,
            c = void 0,
            u = [],
            d = void 0,
            f = void 0;

        if (!g(s) && (!a && (a = "string" === r(e.el) ? "appearing" : e.attr ? "updating" : "disappearing"), l = t._getRulesByElement(s, {
          component: o,
          state: a,
          label: i
        }), !g(l))) {
          if (!l) return t.getFallbackAnimRule(e);

          if (!_(l) || (l = l.call(o, e), !g(l))) {
            for (n = l.length, f = 0; f < n; f++) {
              d = {}, (c = l[f]).initialAttr && (d.initialAttr = _(c.initialAttr) ? c.initialAttr.call(o, e) : Object.assign({}, c.initialAttr)), c.finalAttr && (d.finalAttr = _(c.finalAttr) ? c.finalAttr.call(o, e) : Object.assign({}, c.finalAttr)), d.startEnd = _(c.startEnd) ? c.startEnd.call(o, e) : c.startEnd ? Object.assign({}, c.startEnd) : {
                start: 0,
                end: 1
              }, d.slot = c.slot || "default", d.callback = c.callback, d.hookFn = c.hookFn, d.transition = c.transition, d.effect = c.effect || "linear", c.groupChange && (d.groupChange = !0), u.push(d);
            }

            return u;
          }
        }
      }, t.getFallbackAnimRule = function (e) {
        if ("appearing" === e.state || "string" === r(e.el)) {
          if ("group" !== e.el) return [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: e.attr && e.attr.opacity || 1
            },
            startEnd: {
              start: 0,
              end: 1
            }
          }];
        } else {
          if ("updating" === e.state || e.attr) return [{
            startEnd: {
              start: 0,
              end: 1
            }
          }];
          if ("group" !== e.el.type) return [{
            initialAttr: {
              opacity: 1
            },
            finalAttr: {
              opacity: 0
            },
            startEnd: {
              start: 0,
              end: 1
            }
          }];
        }
      }, t.getFallbackAnimDuration = function (e) {
        return d[e] || 0;
      }, t.getFallbackAnimTimeSlots = function () {
        return [{
          name: "_default",
          start: 0,
          end: 1,
          child: [[{
            name: "initial",
            duration: .125
          }, {
            name: "middle",
            duration: .75,
            child: [[{
              name: "axis",
              duration: .25
            }, {
              name: "plot",
              duration: .75
            }]]
          }, {
            name: "final",
            duration: .125
          }]]
        }];
      }, t.prototype.createElement = function (e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            n = arguments[2],
            r = this.getFromEnv("paper");
        if (r || (r = this.getFromEnv("chart").getFromEnv("paper"), this.addToEnv("paper", r)), "group" === e) (e = r.group(n.attr && n.attr.name || "", n.container)).attr(t);else if ("html" === e) e = r.html(n.attr.type, t, n.css, n.container);else {
          if ("text" === e && n.css) return r[n.el](t, n.css, n.container);
          e = r[n.el](t, n.container);
        }
        return e;
      }, t.prototype.setAttributes = function (e, t) {
        var n,
            r = t.attr,
            o = t.inputJSON || {};
        return "string" == typeof e ? e = this.createElement(e, r, o) : 0 !== Object.keys(r).length ? e.attr(r) : o.attr && "disappearing" !== o.state || (n = !o.doNotRemove), n ? this.removeElement(e, t.immediate) : (o.css && e.css(o.css), t.groupChangeReq && e.appendTo(o.container), t.immediate && o.callback && o.callback.call(e)), {
          el: e,
          removed: n
        };
      }, t.prototype.prepareAnimateArr = function (e) {
        var t,
            n,
            r,
            o,
            i,
            a,
            s,
            l,
            u,
            d = this.config.preAnimArr = [];

        function f(e, t) {
          var r,
              o,
              i,
              a = {
            start: 0,
            end: 1
          };

          for (i in e) {
            if (e.hasOwnProperty(i)) {
              if (e[i].syncWith && !n[e[i].syncWith]) continue;
              r = e[i].syncWith, a.start = e[i].start === c ? 0 : e[i].start, a.end = e[i].end === c ? 1 : e[i].end, a.hookFn = e[i].hookFn || e.hookFn, a.smartMorph = e[i].smartMorph || e.smartMorph;
              break;
            }
          }

          return r = r && n[r] ? r : t && n[t] ? t : "default", o = n[r].end - n[r].start, a.start = n[r].start + a.start * o, a.end = n[r].start + a.end * o, a;
        }

        for (n = this.getFinalSlots(), o = 0, i = e.length; o < i; o += 1) {
          for (r = (t = e[o]).component, a = 0, s = t.data.length; a < s; a += 1) {
            (l = (u = t.data[a]).transition || n[r] && n[r].transition) && b(u, l), u.preAnimFn && d.push({
              el: u.el,
              fn: u.preAnimFn
            }), u.animConfig && (u.animConfig = f(u.animConfig, r));
          }

          t.effect || n[r] && (t.effect = n[r].effect), t.animConfig || (t.animConfig = [{}]), t.animConfig = f(t.animConfig, r);
        }
      }, t.prototype.animate = function () {
        var e,
            t,
            n,
            r,
            o,
            i,
            a,
            s,
            l = this.config,
            c = this.config.animateArr,
            u = l.animationObj,
            d = u.animObj,
            f = u.dummyObj,
            h = u.duration;

        for (this.prepareAnimateArr(c), function (e) {
          var t = 0,
              n = e.length;

          for (t = 0; t < n; ++t) {
            e[t].fn && e[t].fn.call(e[t].el);
          }
        }(this.config.preAnimArr), o = 0, i = c.length; o < i; o += 1) {
          for (a = 0, s = (t = c[o]).data.length - 1; a <= s; a += 1) {
            n = t.data[a].animConfig || t.animConfig, n = v(n, h, 180), e = t.data[a].effect || t.effect || "linear", r = o === i && t.callback || t.data[a].callback, t.data[a].preAttrs && t.data[a].el.attr(t.data[a].preAttrs), t.data[a].el && x(t.data[a].el, t.data[a].attrs, r || null, n, f, d, h, e);
          }
        }
      }, t.prototype.remove = function (t) {
        this.removeAllJobs(), t.instant && this.getGraphicalElement("dummyObj") && this.getGraphicalElement("dummyObj").remove(), e.prototype.remove.call(this, t);
      }, t;
    }(a.ComponentInterface);

    t["default"] = A;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = {
      pie2d: ["isPlotItemSliced", "addData", "removeData", "updateData", "slicePlotItem", "startingAngle"],
      dragcolumn2d: ["getDataWithId", "getData", "setUpperLimit", "setLowerLimit", "getLowerLimit", "getUpperLimit"],
      realtimecolumn: ["feedData", "setData", "stopUpdate", "restartUpdate", "isUpdateActive", "clearChart", "getData", "getDataForId", "setDataForId", "getDataJSON", "showLog", "hideLog", "clearLog"],
      scrollcolumn2d: ["scrollTo"],
      doughnut: ["centerLabel"],
      zoomline: ["zoomOut", "zoomTo", "resetChart", "setZoomMode", "getViewStartIndex", "getViewEndIndex", "scrollTo"],
      maps: ["getMapName", "getEntityList", "getMapAttribute", "exportMap", "addMarker", "updateMarker", "removeMarker"],
      "*": ["exportChart", "getXML", "getChartAttribute", "getCSVData", "getChartData", "getDataAsCSV", "getJSONData", "getSVGString", "getXMLData"]
    };
    r.pie3d = r.pie2d, r.doughnut2d = r.doughnut3d = r.doughnut.concat(r.pie2d), r.dragarea = r.dragline = r.dragnode = r.dragcolumn2d, r.realtimearea = r.realtimeline = r.realtimelinedy = r.realtimestackedarea = r.realtimestackedcolumn = r.bulb = r.angulargauge = r.hlineargauge = r.hled = r.vled = r.vbullet = r.hbullet = r.thermometer = r.cylinder = r.realtimecolumn, r.scrollarea2d = r.scrollline2d = r.scrollcombidy2d = r.scrollcombi2d = r.scrollstackedcolumn2d = r.scrollcolumn2d, r.zoomlinedy = r.zoomline, t["default"] = r;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
      }

      return e.prototype.draw = function () {}, e.prototype.drawAt = function () {}, e.prototype.hide = function () {}, e.prototype.hideAll = function () {}, e.prototype.enableToolTip = function () {}, e.prototype.disableToolTip = function () {}, e.prototype.setStyle = function () {}, e;
    }();

    t["default"] = {
      extension: r,
      name: "ToolTipController",
      type: "plugin"
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.MultiCanvasCrossLine = t.CrossLine = t.CenterLabel = t.debug = t.supportOldThemes = t.LogoExtension = t.BatchExportLinker = t.exportModule = t.LegendEventManagerLinker = t.inputAdapter = t.RegressionExtension = t.Annotation = t.DataSkipping = t.AlertManager = t.ConsolidatedToolTip = t.ToolTipController = t.PlotHighlighter = t.DefaultTheme = t.ThemeEngine = t.IgnoreCaseExt = t.XMLUrlTranscoder = t.JSONUrlTranscoder = t.CSVTranscoder = t.XMLTranscoder = t.linkedChartsExtension = t.MessageLogger = undefined;

    var r = M(n(167)),
        o = M(n(170)),
        i = M(n(172)),
        a = M(n(173)),
        s = M(n(174)),
        l = M(n(177)),
        c = M(n(178)),
        u = M(n(179)),
        d = M(n(180)),
        f = M(n(181)),
        h = M(n(183)),
        p = M(n(185)),
        g = M(n(186)),
        m = M(n(188)),
        v = M(n(192)),
        y = M(n(218)),
        b = M(n(224)),
        x = M(n(252)),
        w = M(n(253)),
        C = M(n(259)),
        _ = M(n(260)),
        S = M(n(262)),
        E = M(n(263)),
        k = M(n(264)),
        A = M(n(267)),
        T = M(n(271));

    function M(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    t.MessageLogger = r["default"], t.linkedChartsExtension = o["default"], t.XMLTranscoder = i["default"], t.CSVTranscoder = a["default"], t.JSONUrlTranscoder = s["default"], t.XMLUrlTranscoder = l["default"], t.IgnoreCaseExt = c["default"], t.ThemeEngine = u["default"], t.DefaultTheme = d["default"], t.PlotHighlighter = f["default"], t.ToolTipController = h["default"], t.ConsolidatedToolTip = p["default"], t.AlertManager = g["default"], t.DataSkipping = m["default"], t.Annotation = v["default"], t.RegressionExtension = y["default"], t.inputAdapter = b["default"], t.LegendEventManagerLinker = x["default"], t.exportModule = w["default"], t.BatchExportLinker = C["default"], t.LogoExtension = _["default"], t.supportOldThemes = S["default"], t.debug = E["default"], t.CenterLabel = k["default"], t.CrossLine = A["default"], t.MultiCanvasCrossLine = T["default"], t["default"] = {
      name: "features",
      type: "package",
      requiresFusionCharts: !0,
      extension: function extension(e) {
        e.addDep(o["default"]), e.addDep(i["default"]), e.addDep(a["default"]), e.addDep(s["default"]), e.addDep(l["default"]), e.addDep(c["default"]), e.addDep(u["default"]), e.addDep(f["default"]), e.addDep(d["default"]), e.addDep(h["default"]), e.addDep(p["default"]), e.addDep(g["default"]), e.addDep(r["default"]), e.addDep(m["default"]), e.addDep(v["default"]), e.addDep(w["default"]), e.addDep(y["default"]), e.addDep(b["default"]), e.addDep(x["default"]), e.addDep(C["default"]), e.addDep(_["default"]), e.addDep(S["default"]), e.addDep(E["default"]), e.addDep(k["default"]), e.addDep(A["default"]), e.addDep(T["default"]);
      }
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(168),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    };
    var a = {
      timeseries: !0
    };
    t["default"] = {
      extension: function extension(e) {
        e.addEventListener("instantiated", function (e) {
          var t = e.sender.getName().toLowerCase();
          "chartAPI" !== e.sender.getType() || a[t] || e.sender.registerFactory("messageLogger", function (t) {
            if (t.getChildren("messageLogger")) t.getChildren("messageLogger")[0].configure(t);else {
              var n = t.getFromEnv("chart-container"),
                  r = new i["default"]();
              r.configure(t), r.addToEnv("chart-container", n), t.attachChild(r, "messageLogger"), t.getFromEnv("chartInstance").showLog = function () {
                return r && r.show && r.show();
              }, t.getFromEnv("chartInstance").hideLog = function () {
                return r && r.hide && r.hide();
              }, t.getFromEnv("chartInstance").clearLog = function () {
                return r && r.clearLog && r.clearLog();
              }, e.sender.addEventListener("realtimeDataUpdate", function (e) {
                e.sender.getChildren("messageLogger") && e.sender.getChildren("messageLogger")[0].addLog(e.data);
              });
            }
          });
        });
      },
      name: "messageLoggerLinker",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(169),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(138),
        s = n(125);

    function l(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var c = Math.min,
        u = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this));

        return n.pIndex = 1, n.linkedItems = n.linkedItems || (n.linkedItems = {}), n.components = n.components || {}, n.components.messages = n.components.messages || [], n.graphics = n.graphics || {}, n.config = n.config || (n.config = {}), n;
      }

      return l(t, e), t.prototype.getType = function () {
        return "extension";
      }, t.prototype.getName = function () {
        return "MessageLogger";
      }, t.prototype.configure = function (e) {
        this.linkedItems.chart = e;
        var t = e.getFromEnv("chart-attrib") || {},
            n = this.config.usemessagelog = e.getFromEnv("chartConfig").usemessagelog;
        this.config.messageLogWPercent = c((0, s.pluckNumber)(t.messagelogwpercent, 80), 100), this.config.messageLogHPercent = c((0, s.pluckNumber)(t.messageloghpercent, 70), 100), this.config.messageLogShowTitle = (0, s.pluckNumber)(t.messagelogshowtitle, 1), this.config.messageLogTitle = (0, s.pluck)(t.messagelogtitle, "Message Log"), this.config.messageLogColor = (0, s.pluck)(t.messagelogcolor, "#fbfbfb").replace(/^#?([a-f0-9]+)/gi, "$1"), this.config.messageLogColorRgb = (0, s.HEXtoRGB)(this.config.messageLogColor), this.config.messageGoesToJS = (0, s.pluckNumber)(t.messagegoestojs, 0), this.config.messageGoesToLog = (0, s.pluckNumber)(t.messagegoestolog, 1), this.config.messageJSHandler = (0, s.pluck)(t.messagejshandler, ""), this.config.messagePassAllToJS = (0, s.pluckNumber)(t.messagepassalltojs, 0), this.config.messagePassAsObject = (0, s.pluckNumber)(t.messagepassasobject, 0), this.config.messageLogIsCancelable = (0, s.pluckNumber)(t.messagelogiscancelable, 1), this.config.alwaysShowMessageLogMenu = (0, s.pluckNumber)(t.alwaysshowmessagelogmenu, n), e.config.useShowLogMenu = n && this.config.messageGoesToLog, this.config.dynamicScrolling = !1, this.config.scrollToBottom = !0;
      }, t.prototype._createMessage = function (e) {
        var t = new i["default"](e, this);
        return this.graphics.container && t.draw(), t;
      }, t.prototype.addLog = function (e) {
        var t = this.components.messages,
            n = (0, s.pluckNumber)(e.msgGoesToLog, this.config.messageGoesToLog),
            r = (0, s.pluckNumber)(e.msgGoesToJS, this.config.messageGoesToJS),
            o = window[this.config.messageJSHandler],
            i = (0, s.pluck)(e.msgId, ""),
            a = (0, s.pluck)(e.msgTitle, ""),
            l = (0, s.pluck)(e.msgText, ""),
            c = (0, s.pluck)(e.msgType, "literal"),
            u = void 0;
        0 != this.config.usemessagelog && (r && o && "function" == typeof o && (this.config.messagePassAllToJS ? this.config.messagePassAsObject ? o(e) : o(i, a, l, c) : o(l)), "1" === e.clearLog && this.clearLog(), n && (e.msgTitle || e.msgText) && (u = this._createMessage(e), t.push(u), 1 !== t.length || this.config.visible || this.show()));
      }, t.prototype.show = function () {
        this.config.visible || 1 != this.config.usemessagelog || (this.config.visible = !0, this.draw(), this.graphics.container || this.draw(), this.graphics.container && this.graphics.container.show());
      }, t.prototype.hide = function () {
        this.config.visible = !1, this.graphics.container && this.graphics.container.hide();
      }, t.prototype.clearLog = function () {
        var e = this.components.messages,
            t = void 0,
            n = e.length;

        for (t = 0; t < n; t += 1) {
          e[t] && e[t].dispose && e[t].dispose();
        }

        e.splice(0, n);
      }, t.prototype.isDrawn = function () {
        return !!this.graphics.container;
      }, t.prototype.draw = function () {
        var e = this.components.messages,
            t = void 0,
            n = void 0;
        if (0 === this.config.usemessagelog) this.isDrawn() && (this.clearLog(), this.hide());else for (this._createHTMLDialogue(), this.config.visible || this.hide(), n = e.length, t = 0; t < n; t += 1) {
          e[t] && e[t].draw && e[t].draw();
        }
      }, t.prototype._createHTMLDialogue = function () {
        var e,
            t,
            n,
            r,
            o = this,
            i = this.config,
            a = this.graphics,
            s = this.linkedItems.chart,
            l = this.getFromEnv("paper"),
            c = this.getFromEnv("chart-container"),
            u = s.config,
            d = u.width,
            f = u.height,
            h = u.style,
            p = h && h.inCanvasStyle,
            g = this.config.messageLogWPercent,
            m = this.config.messageLogHPercent,
            v = this.config.messageLogShowTitle,
            y = this.config.messageLogIsCancelable,
            b = this.config.messageLogColor,
            x = this.config.messageLogTitle,
            w = d * (g / 100),
            C = f * (m / 100),
            _ = (d - w) / 2,
            S = (f - C) / 2,
            E = w - 18 - 22,
            k = C - 18 - 22,
            A = b,
            T = b,
            M = a.container,
            O = this.isDrawn() && u.animation && u.animation.transposeAnimDuration;

        M || (M = a.container = l.html("div", {
          fill: "transparent"
        }, {
          fontSize: "10px",
          lineHeight: "15px"
        }, c), a.veil = l.html("div", {
          id: "veil",
          fill: "000000",
          opacity: .1
        }, void 0, M).on("click", function () {
          y && o.hide();
        }), x && v && (a.title = l.html("p", {
          id: "Title",
          innerHTML: x,
          x: 5,
          y: 5
        }, {
          "font-weight": "bold"
        }, M)), a.dialog = l.html("div", {
          id: "dialog",
          strokeWidth: 1
        }, {
          borderRadius: "5px",
          boxShadow: "1px 1px 3px #000000",
          "-webkit-border-radius": "5px",
          "-webkit-box-shadow": "1px 1px 3px #000000",
          filter: 'progid:DXImageTransform.Microsoft.Shadow(Strength=4, Direction=135, Color="#000000")'
        }, M), a.logBackground = l.html("div", {
          id: "dialogBackground",
          x: 0,
          y: 0
        }, void 0, a.dialog), y && (a.closeButton = l.html("div", {
          id: "closeButton",
          x: w - 11 - 3,
          y: 2,
          innerHTML: "<b>x</b>"
        }, {
          cursor: "pointer",
          _cursor: "hand"
        }, a.dialog).on("click", function () {
          y && o.hide();
        })), a.logWrapper = l.html("div", {
          id: "logWrapper"
        }, {
          overflow: "auto"
        }, a.dialog).on("scroll", function () {
          var e = this && this.scrollTop,
              t = this && this.scrollHeight,
              n = this && this.offsetHeight;
          i.dynamicScrolling ? i.dynamicScrolling = !1 : i.scrollToBottom = t - e === n;
        }), a.log = l.html("div", {
          id: "log",
          x: 0,
          y: 0
        }, {}, a.logWrapper)), M.css({
          fontFamily: p.fontFamily
        }), a.dialog.attr({
          fill: "ffffff",
          stroke: A
        }), a.logBackground.attr({
          fill: T
        }), e = {
          width: d,
          height: f
        }, t = {
          x: _,
          y: S,
          width: w,
          height: C
        }, n = {
          width: w,
          height: C
        }, r = {
          x: (w - E) / 2,
          y: (C - k) / 2,
          width: E,
          height: k
        }, O ? (M.animate(e, O, "normal"), a.veil.animate(e, O, "normal"), a.dialog.animate(t, O, "normal"), a.logBackground.animate(n, O, "normal"), a.logWrapper.animate(r, O, "normal")) : (M.attr(e), a.veil.attr(e), a.dialog.attr(t), a.logBackground.attr(n), a.logWrapper.attr(r));
      }, t;
    }(a.ComponentInterface);

    t["default"] = u;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(125);
    var o = 8 === window.document.documentMode,
        i = {},
        a = {
      display: "block",
      paddingLeft: "10px",
      paddingRight: "10px",
      "font-family": "Arial",
      "font-size": "11px"
    };
    i.literal = i.info = {
      title: '<span style="color: #005900">$titleVal$</span>',
      body: '<span">$msgVal$</span>'
    }, i.link = {
      title: i.info.title,
      body: '<a href="$msgLinkVal$">$msgVal$</a>'
    }, i.error = {
      title: '<span style="color: #CC0000">$titleVal$</span>',
      body: '<span style="color: #CC0000">$msgVal$</span>'
    };

    var s = function () {
      function e(t, n) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.config = {}, this.messageType = (t.msgType && t.msgType.replace(/^[\r\n]+|\.|[\r\n]+$/g, "") || "").toLowerCase(), this.msgTitle = t.msgTitle, this.msgText = t.msgText, this.msgLink = t.msgLink, this.graphics = {}, this.linkedItems = {
          msgLogger: n
        }, this.msgObj = i[this.messageType] || i.literal, this.configureMsgTextAndMsgTitle();
      }

      return e.prototype.configureMsgTextAndMsgTitle = function () {
        this.config.totalHTML = "", this.msgTitle && (this.config.titleHTML = this.msgObj.title.replace("$titleVal$", this.msgTitle), this.config.totalHTML += this.config.titleHTML), this.msgText && (this.config.msgHTML = this.msgObj.body.replace("$msgVal$", this.msgText), this.config.msgHTML = this.config.msgHTML.replace("$msgLinkVal$", this.msgText), this.config.totalHTML += this.config.msgHTML);
      }, e.prototype.draw = function () {
        var e,
            t,
            n,
            i = this.graphics.element,
            s = this.linkedItems.msgLogger,
            l = s.graphics,
            c = l && l.log && l.log.element,
            u = l.logWrapper && l.logWrapper.element,
            d = s.config;

        if (!i) {
          for (e in i = this.graphics.element = window.document.createElement("span"), a) {
            i.style[e] = a[e];
          }

          c.appendChild && c.appendChild(i);
        }

        this.graphics.element.innerHTML = this.config.totalHTML, r.isIE && o && (t = c.innerHTML, c.innerHTML = t), d.scrollToBottom && (d.dynamicScrolling = !0, n = u.scrollHeight, u.scrollTop = n);
      }, e.prototype.dispose = function () {
        var e = this.linkedItems.msgLogger;
        e && e.graphics && e.graphics.log && e.graphics.log.element && e.graphics.log.element.removeChild && e.graphics.log.element.removeChild(this.graphics.element), delete this.graphics.element, r.componentDispose.call(this);
      }, e;
    }();

    t["default"] = s;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        o = n(171),
        i = c(o),
        a = n(131),
        s = n(125),
        l = c(n(127));

    function c(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var u = s.regex.dropHash;

    function d(e, t) {
      return (e.options.containerElement === t.options.containerElement || e.options.containerElementId === t.options.containerElementId) && e.options.insertMode === s.domInsertModes.REPLACE;
    }

    function f(e) {
      var t;
      e.sender.link instanceof i["default"] && !e.sender.link.root.disposed ? e.sender.link.parent instanceof this && !(t = e.sender.link.parent.link.items)[e.sender.id] && (t[e.sender.id] = e.sender) : e.sender.link = new i["default"](e.sender);
    }

    t["default"] = {
      type: "extension",
      name: "LinkedChart",
      extension: function extension(e) {
        e.prototype.configureLink = function (e, t) {
          var n;

          if (e instanceof Array) {
            for (n = 0; n < e.length; n += 1) {
              "object" !== r(o.store[this.link.root.id][n]) && (o.store[this.link.root.id][n] = {}), (0, s.extend2)(o.store[this.link.root.id][n], e[n], !1, !0);
            }

            o.store[this.link.root.id].splice(e.length);
          } else "object" === (void 0 === e ? "undefined" : r(e)) ? ("number" != typeof t && (t = this.link.level), "undefined" == typeof o.store[this.link.root.id][t] && (o.store[this.link.root.id][t] = {}), (0, s.extend2)(o.store[this.link.root.id][t], e, !1, !0)) : (0, a.raiseError)(this, "25081731", "param", "~configureLink()", "Unable to update link configuration from set parameters");
        }, e.prototype.drawOverlayButton = function (e) {
          var t,
              n,
              r,
              o = this.jsVars,
              i = o.overlayButton;

          if (e && e.show) {
            for (i || (i = o.overlayButton = document.createElement("span"), l["default"].listen(i, "click", function () {
              (0, a.triggerEvent)("OverlayButtonClick", o.fcObj, e);
            })), r = e.message ? e.message : "Back"; i.firstChild;) {
              i.removeChild(i.firstChild);
            }

            for (n in i.appendChild(document.createTextNode(r)), o.overlayButtonMessage = r, t = {
              border: "1px solid " + (e.borderColor ? e.borderColor.replace(u, s.HASHSTRING) : "#7f8975"),
              backgroundColor: e.bgColor ? e.bgColor.replace(u, s.HASHSTRING) : "#edefec",
              fontFamily: e.font ? e.font : "Verdana,sans",
              color: e.fontColor,
              fontSize: (e.fontSize ? e.fontSize : "10") + s.PXSTRING,
              padding: (e.padding ? e.padding : "3") + s.PXSTRING,
              fontWeight: 0 === parseInt(e.bold, 10) ? s.NORMAL : s.BOLD,
              position: "absolute",
              top: "0",
              right: "0",
              cursor: s.POINTER
            }) {
              i.style[n] = t[n];
            }

            o.hcObj.container.appendChild(i), o.overlayButtonActive = !0;
          } else i && (o.overlayButton = i.parentNode.removeChild(i), o.overlayButtonActive = !1, delete o.overlayButtonMessage);
        }, e.addEventListener("beforeRender", f), e.addEventListener("beforeInitialize", f), e.addEventListener("linkedChartInvoked", function (t, n) {
          var o,
              l = t.sender,
              c = l.clone({
            dataSource: n.data,
            dataFormat: n.linkType,
            link: new i["default"](l.link.root, l, l instanceof e),
            clickedEntity: n.clickedEntity,
            clickedEntityBox: n.clickedEntityBox
          }, !0),
              u = n.alias;
          u && (!c.typeSource && c.swfUrl && (c.typeSource = c.swfUrl.replace(/(.*?)?[^\/]*\.swf.*?/gi, "$1")), c.type = u), l.args && 0 !== parseInt(l.args.animate, 10) && delete c.animate, (0, s.extend2)(c, l.link.configuration(), !1, !0), (0, a.triggerEvent)("beforeLinkedItemOpen", l.link.root, {
            level: l.link.level
          }, void 0, function () {
            e.items[c.id] instanceof e && e.items[c.id].dispose(), d(o = new e(c), l) || l.options.overlayButton && l.options.overlayButton.message || ("object" !== r(l.options.overlayButton) && (l.options.overlayButton = {}), l.options.overlayButton.message = "Close"), o.render(), (0, a.triggerEvent)("linkedItemOpened", l.link.root, {
              level: l.link.level,
              item: o
            });
          });
        }), e.addEventListener("overlayButtonClick", function (t, n) {
          var r, o, i, s;
          "LinkManager" === n.id && (r = t.sender, o = r.link.level - 1, i = r.link.parent, s = r.link.root, (0, a.triggerEvent)("beforeLinkedItemClose", s, {
            level: o,
            item: r
          }, void 0, function () {
            setTimeout(function () {
              e.items[r.id] && r.dispose(), (0, a.triggerEvent)("linkedItemClosed", s, {
                level: o
              });
            }, 0), i.disposed || i.isActive() || !d(r, i) ? (i._addChartDependency("returnFromLinkedChart", {
              resolve: function resolve() {
                return {
                  state: 3
                };
              }
            }), i._setState()) : i.render();
          }));
        }), e.addEventListener("DrawComplete", function (t) {
          var n,
              r = t.sender;
          r && "undefined" != typeof r.link && r.link.root !== r && r.link.parent instanceof e && (r.ref && "function" == typeof r.drawOverlayButton ? (n = (0, s.extend2)({
            show: !0,
            id: "LinkManager"
          }, r.link.parent.options.overlayButton, !1, !0), (0, s.extend2)(n, r.link.parent.link.configuration().overlayButton || {}, !1, !0), r.drawOverlayButton(n)) : (0, a.raiseWarning)(r, "04091602", "run", "::LinkManager^Loaded", "Unable to draw overlay button on object. -" + r.id));
        }), e.addEventListener("beforeDispose", function (t) {
          var n = t.sender;
          n && n.link instanceof i["default"] && (n && n.link && n.link.parent instanceof e && n.link.parent.link && n.link.parent.link.items && delete n.link.parent.link.items[t.sender.id], delete o.store[n.id]);
        });
      },
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = {},
        o = function () {
      function e(t, n, o) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.items = {}, this.root = t, this.parent = n, o ? this.level = this.parent.link.level + 1 : (r[t.id] = [{}], this.level = 0);
      }

      return e.prototype.configuration = function () {
        return r[this.root.id][this.level] || (r[this.root.id][this.level] = {});
      }, e;
    }();

    t.store = r, t["default"] = o;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        i = n(125);

    function a(e) {
      return e.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    var s,
        _l2,
        c,
        u,
        d = (u = {
      arr: {
        set: !0,
        trendlines: !0,
        vtrendlines: !0,
        line: {
          trendlines: !0,
          vtrendlines: !0
        },
        data: !0,
        dataset: !0,
        lineset: !0,
        categories: !0,
        category: !0,
        tasks: !0,
        linkeddata: !0,
        application: !0,
        definition: !0,
        axis: !0,
        connectors: !0,
        connector: {
          connectors: !0
        },
        trendset: !0,
        row: {
          rows: !0
        },
        column: {
          columns: !0
        },
        label: {
          labels: !0
        },
        color: {
          colorrange: !0
        },
        dial: {
          dials: !0
        },
        pointer: {
          pointers: !0
        },
        point: {
          trendpoints: !0
        },
        process: {
          processes: !0
        },
        task: {
          tasks: !0
        },
        milestone: {
          milestones: !0
        },
        datacolumn: {
          datatable: !0
        },
        text: {
          datacolumn: !0
        },
        item: {
          legend: !0
        },
        alert: {
          alerts: !0
        },
        groups: {
          annotations: !0
        },
        items: {
          groups: !0,
          data: !0
        },
        shapes: !0,
        shape: {
          shapes: !0
        },
        entitydef: !0,
        entity: {
          entitydef: !0
        }
      },
      tag: {
        chart: "linkedchart",
        map: "linkedmap",
        set: "data",
        vline: {
          chart: "data",
          graph: "data",
          dataset: "data",
          categories: "category",
          linkedchart: "data"
        },
        apply: {
          application: "application"
        },
        style: {
          definition: "definition"
        },
        marker: {
          application: "application",
          definition: "definition",
          data: "items"
        },
        entity: {
          entitydef: "entitydef",
          data: "data"
        },
        shape: {
          shapes: "shapes"
        },
        connector: {
          connectors: {
            chart: "connector",
            linkedchart: "connector",
            map: "connectors",
            linkedmap: "connectors"
          }
        },
        annotationgroup: {
          annotations: "groups"
        },
        annotation: {
          groups: "items"
        }
      },
      attr: {
        vline: {
          vline: "true"
        }
      },
      ins: {
        chart: !0,
        map: !0,
        graph: !0
      },
      dsv: {
        dataset: "data",
        categories: "category"
      },
      text: {
        target: "target",
        value: "value"
      },
      group: {
        styles: {
          definition: !0,
          application: !0
        },
        chart: {
          value: !0,
          target: !0
        },
        graph: {
          value: !0,
          target: !0
        },
        linkedchart: {
          value: !0,
          target: !0
        },
        markers: {
          definition: !0,
          application: !0,
          shapes: !0,
          connectors: !0,
          data: !0
        },
        map: {
          entitydef: !0,
          data: !0
        },
        linkedmap: {
          entitydef: !0,
          data: !0
        }
      }
    }, s = {
      append: function append(e, t, n, r) {
        !u.arr[n] || !0 !== u.arr[n] && !0 !== u.arr[n][r] ? t[n] = e : (t[n] instanceof Array || (t[n] = []), t[n].push(e));
      },
      child: function child(e, t, n, r) {
        var a, l, c, d, f, h;

        for (a = 0; a < t.length; a += 1) {
          switch (l = (c = t[a]).nodeName.toLowerCase(), c.nodeType) {
            case 1:
              if (d = s.attr(c.attributes), !0 === (h = u.ins[l]) && (f = d, (d = {})[l] = f, f = void 0), "object" === (void 0 === (h = u.attr[l]) ? "undefined" : o(h)) && (0, i.extend2)(d, h, !1, !0), h = u.tag[l]) if ("object" === (void 0 === h ? "undefined" : o(h)) && "object" === o(h[n])) {
                for (f in f = void 0, h[n]) {
                  if (r[f]) {
                    l = h[n][f];
                    break;
                  }
                }
              } else "object" === (void 0 === h ? "undefined" : o(h)) && "string" === o(h[n]) ? l = h[n] : "string" === (void 0 === h ? "undefined" : o(h)) && (l = h);
              c.childNodes.length && ((h = u.group[n]) && h[l] ? s.child(e, c.childNodes, l, r) : s.child(d, c.childNodes, l, r)), (h = u.group[n]) && h[l] || s.append(d, e, l, n);
              break;

            case 3:
              (h = u.text[n]) && (l = h, d = c.data, s.append(d, e, l, n)), "string" === (void 0 === (h = u.dsv[n]) ? "undefined" : o(h)) && r.chart && parseInt(r.chart.compactdatamode, 10) && (l = h, d = c.data, e[l] = e[l] ? e[l] + d : d);
          }
        }
      },
      attr: function attr(e) {
        var t,
            n = {};
        if (!e || !e.length) return n;

        for (t = 0; t < e.length; t += 1) {
          "xml" === c && (e[t].value ? e[t].value = a(e[t].value) : e[t].nodeValue && (e[t].nodeValue = a(e[t].nodeValue))), n[e[t].nodeName.toLowerCase()] = e[t].value || e[t].nodeValue;
        }

        return n;
      }
    }, _l2 = function l(e) {
      var t,
          n,
          a,
          c,
          u,
          d,
          f,
          h,
          p,
          g = {};
      if ("object" !== (void 0 === e ? "undefined" : o(e)) && e && "function" !== o(e.toString)) return _l2.errorObject = new TypeError("xml2json.parse()"), g;
      if (e = e.toString().replace(/<\!--[\s\S]*?-->/g, "").replace(/<\?xml[\s\S]*?\?>/gi, "").replace(/&(?!([^;\n\r]+?;))/g, "&amp;$1"), !(e = (0, i.fastTrim)(e))) return g;

      try {
        if (window.DOMParser ? t = new window.DOMParser().parseFromString(e, "text/xml") : document.body && r.options.allowIESafeXMLParsing ? ((n = document.createElement("xml")).innerHTML = e, document.body.appendChild(n), t = n.XMLDocument, document.body.removeChild(n), n = null) : ((t = new window.ActiveXObject("Microsoft.XMLDOM")).async = "false", t.loadXML(e)), !(t && t.childNodes && 1 === t.childNodes.length && (a = t.childNodes[0]) && a.nodeName && (c = a.nodeName.toLowerCase())) || "chart" !== c && "map" !== c && "graph" !== c) return _l2.errorObject = new TypeError("xml2json.parse()"), g;

        if ("graph" === c) {
          for (u = t.createElement("chart"), p = (f = a.attributes) && f.length || 0; p--;) {
            u.setAttribute(f[p].name, f[p].value), f.removeNamedItem(f[p].name);
          }

          for ((p = (h = a.childNodes) && h.length || 0) && (p -= 1, d = a.removeChild(h[p]), u.appendChild(d)); p--;) {
            d = a.removeChild(h[p]), u.insertBefore(d, u.firstChild);
          }

          t.replaceChild(u, a), a = u;
        }
      } catch (m) {
        _l2.errorObject = m;
      }

      return a ? (a.attributes && (g[c] = s.attr(a.attributes)), a.childNodes && s.child(g, a.childNodes, c, g), delete _l2.errorObject) : _l2.errorObject = new TypeError("xml2json.parse()"), g;
    }, function (e) {
      return delete _l2.errorObject, c = arguments[arguments.length - 1], {
        data: _l2(e),
        error: _l2.errorObject
      };
    }),
        f = function () {
      var e, _t4;

      return e = {
        items: {
          explode: {
            data: "set",
            groups: {
              annotations: "annotationgroup"
            },
            items: {
              groups: "annotation"
            }
          },
          text: {
            chart: {
              target: "target",
              value: "value"
            },
            graph: {
              target: "target",
              value: "value"
            }
          },
          dsv: {
            dataset: {
              data: "dataset"
            },
            categories: {
              category: "categories"
            }
          },
          attr: {
            chart: {
              chart: "chart"
            },
            graph: {
              graph: "graph"
            },
            map: {
              map: "map"
            },
            linkedmap: {
              map: "map"
            },
            linkedchart: {
              chart: "chart"
            }
          },
          group: {
            styles: {
              definition: "style",
              application: "apply"
            },
            map: {
              data: "entity",
              entitydef: "entity"
            },
            markers: {
              definition: "marker",
              application: "marker",
              shapes: "shape",
              connectors: "connector",
              items: "marker"
            }
          },
          tag: {
            markers: {
              items: "data"
            }
          }
        },
        qualify: function qualify(e, t, n) {
          return "object" === o(this.items[e][n]) ? this.items[e][n][t] : this.items[e][n];
        }
      }, _t4 = function t(n, r, a, s) {
        var l,
            c,
            u,
            d,
            f = "",
            h = "",
            p = "",
            g = "";
        if (r && "function" == typeof r.toLowerCase && (r = r.toLowerCase()), void 0 === a && n[r]) for (c in n[r]) {
          "compactdatamode" === (u = c.toLowerCase()) && (s.applyDSV = 1 === n[r][c]);
        }
        if (n instanceof Array) for (c = 0; c < n.length; c += 1) {
          "string" === o(n[c]) ? p += (0, i.xssEncode)(n[c]) : p += _t4(n[c], r, a, s);
        } else {
          for (c in n) {
            u = c.toLowerCase().replace(/[`~!@#$%^&*()|+\=?;:'", <>\{\}\[\]\\\/]/gi, ""), n[c] instanceof Array && (d = e.qualify("group", u, r)) ? h += "<" + (l = e.qualify("tag", u, r) || u) + ">" + _t4(n[c], d, r, s) + "</" + l + ">" : "object" === o(n[c]) ? (d = e.qualify("attr", u, r)) ? (g = _t4(n[c], d, r, s).replace(/\s*\/\>/gi, ""), r = u) : h += _t4(n[c], u, r, s) : s.applyDSV && (d = e.qualify("dsv", u, r)) ? h += n[c] : (d = e.qualify("text", u, r)) ? h += "<" + (l = e.qualify("tag", u, r) || d) + ">" + n[c] + "</" + l + ">" : "vline" === u && Boolean(n[c]) ? r = "vline" : f += " " + u + '="' + (0, i.xssEncode)(n[c]).toString().replace(/\"/gi, "&quot;") + '"';
          }

          (d = e.qualify("explode", a, r)) && (r = d), l = r, p = ("" !== g ? g : "<" + l) + f + ("" !== h ? ">" + h + "</" + l + ">" : " />");
        }
        return p;
      }, function (e) {
        if (delete _t4.errorObject, e && "string" === (void 0 === e ? "undefined" : o(e))) try {
          e = JSON.parse(e);
        } catch (r) {
          _t4.errorObject = r;
        }
        var n = e && e.graph ? "graph" : e && e.map ? "map" : "chart";
        return {
          data: _t4(e, n, void 0, {}),
          error: _t4.errorObject
        };
      };
    }(),
        h = function h() {
      return this.getChartData("xml");
    },
        p = function p(e) {
      this.setChartData(e, "xml");
    };

    t["default"] = {
      extension: function extension(e) {
        return e && (r = e, e.prototype.getXMLData = h, e.prototype.setXMLData = p), {
          format: "xml",
          toJSON: d,
          fromJSON: f
        };
      },
      name: "XML",
      type: "transcoder",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(131);

    var o,
        i,
        a,
        s,
        l,
        _c,
        u,
        d,
        f,
        h,
        p = window,
        g = p.parseInt,
        m = p.parseFloat,
        v = function v(e) {
      return e;
    },
        y = function () {
      function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.data = [], this.rowCount = 0, this.columnCount = 0, this.configure(t);
      }

      return e.prototype.set = function (e, t, n) {
        var r;

        if (this.rowCount <= e) {
          for (r = this.rowCount; r <= e; r += 1) {
            this.data[r] = [];
          }

          this.rowCount = e + 1;
        }

        this.columnCount <= t && (this.columnCount = t + 1), this.data[e][t] = n;
      }, e.prototype.setRow = function (e, t) {
        var n;

        if (this.rowCount <= e) {
          for (n = this.rowCount; n <= e; n += 1) {
            this.data[n] = [];
          }

          this.rowCount = e + 1;
        }

        this.columnCount < t.length && (this.columnCount = t.length), this.data[e] = t;
      }, e.prototype.get = function (e, t) {
        var n = this.data;
        return n[e] && n[e][t];
      }, e.prototype.configure = function (t) {
        var n = e.decodeLiterals;
        this.delimiter = n(t.delimiter, ","), this.qualifier = n(t.qualifier, '"'), this.eolCharacter = n(t.eolCharacter, "\r\n"), this.numberFormatted = !!g(t.numberFormatted, 0);
      }, e.prototype.clear = function () {
        this.data = [], this.rowCount = 0, this.columnCount = 0;
      }, e.prototype.toString = function () {
        var e,
            t,
            n = "";

        for (e = 0; e < this.rowCount; e += 1) {
          n += '""' === (t = this.qualifier + this.data[e].join(this.qualifier + this.delimiter + this.qualifier) + this.qualifier) ? this.eolCharacter : t + this.eolCharacter;
        }

        return this.rowCount > 0 && (n = n.slice(0, n.length - 2)), n;
      }, e;
    }();

    function b() {
      return this.getChartData("csv");
    }

    function x() {
      return this.getCSVData();
    }

    y.decodeLiterals = function (e, t) {
      return e !== i && null !== e && e.toString ? e.replace("{tab}", "\t").replace("{quot}", '"').replace("{apos}", "'") : t;
    }, _c = function c(e, t) {
      var n = e.label || "",
          r = void 0;

      if (u.push(n), h++, f = Math.max(f, h), e.category !== i) {
        for (r = 0; r < e.category.length; ++r) {
          _c(e.category[r], t);
        }

        u.pop(), h--;
      } else t.setRow(d++, u.slice()), u.pop(), h--;
    }, l = function l(e) {
      var t,
          n,
          r,
          o = e,
          a = o.chart,
          s = o && o.category || [],
          l = s.length,
          p = [];

      for (d = 1, f = 0, h = 0, r = new y({
        separator: a.exportdataseparator,
        qualifier: a.exportdataqualifier,
        numberFormatted: a.exportdataformattedval
      }), t = 0; t < l; ++t) {
        n = s[t], u = [], _c(n, r);
      }

      for (t = 0; t < f; ++t) {
        p.push("category");
      }

      return r.setRow(0, p), {
        data: r.toString(),
        error: i,
        predictedFormat: {
          multilevel: !0
        }
      };
    }, a = function a(e, t) {
      var n,
          r,
          a,
          s,
          c,
          u,
          d,
          f,
          h,
          p,
          g,
          b,
          x,
          w,
          C,
          _,
          S,
          E,
          k,
          A,
          T,
          M,
          O,
          F,
          I,
          L,
          N,
          D,
          P,
          R,
          j,
          V,
          B,
          H = e,
          G = t && t.jsVars,
          z = t && t.args,
          U = z && z.type,
          $ = G && G.instanceAPI,
          X = H.chart || H.map || H.graph || {},
          W = Boolean(X.exporterrorcolumns || 0),
          Y = H.categories && H.categories[0] && H.categories[0].category || [],
          q = H.map && !H.chart || G && G.instanceAPI && "geo" === G.instanceAPI.defaultSeriesType,
          K = !1,
          J = !1,
          Z = !1,
          Q = !1,
          ee = !1,
          te = v,
          ne = {},
          re = 0,
          oe = -1;

      if ("multilevelpie" === U) return l(e);
      if (n = new y({
        separator: X.exportdataseparator,
        qualifier: X.exportdataqualifier,
        numberFormatted: X.exportdataformattedval
      }), o.formatNumber && n.numberFormatted && (te = function te(e, t) {
        return o.formatNumber(e, X, t);
      }), q) for (N in ne.geo = !0, L = (h = G.instanceAPI.getDatasets()) && h[0] && h[0].components.data || [], n.setRow(0, ["Id", " Short Name", "Long Name", "Value", "Formatted Value"]), c = 0, L) {
        V = (P = (D = L[N]).config).cleanValue, !0 !== D.hidden && n.setRow(++c, [N, P.shortLabel, P.label, null === V ? "" : V, P.formattedValue]);
      } else if ((h = H.dials && H.dials.dial || H.pointers && H.pointers.pointer || H.value) !== i) {
        if (ne.gauge = !0, "string" == typeof h) n.set(0, 0, te(h)), ne.singlevalue = !0, "string" == typeof H.target && (n.set(0, 1, te(H.target)), ne.bullet = !0);else for (n.setRow(0, ["Id", "Value"]), ne.multivalue = !0, c = 0, d = 1, u = h.length; c < u; c += 1, d += 1) {
          n.setRow(d, [d, te(h[c].value)]);
        }
      } else if (h = H.dataset || !(H.data instanceof Array) && []) {
        if (ne.multiseries = !0, a = 1, (p = H.lineset) && (h = h.concat(p), ne.lineset = !0), (g = H.axis) && (h = h.concat(g), ne.multiaxis = !0), w = h.length, x = Y.length, !(w = h.length)) {
          for (c = 0; c < x; c += 1) {
            C = Y[c], n.set(c + 1, 0, C.label || C.name);
          }

          ne.multilevel = !0;
        }

        for (c = 0; c < w; c += 1) {
          for ((_ = h)[c].dataset ? (s = 0, b = (_ = _[c].dataset).length) : (_ = h, b = (s = c) + 1); s < b && !K && !Z; s += 1) {
            if (S = _[s], oe++, !($ && (O = $.getDatasets()) && O[oe] && !1 === O[oe].visible)) {
              for (B = (R = $ && O && O[oe]) && R.config && R.config.parentYAxis, n.set(0, a, S.seriesname), "string" == typeof S.data && (ne.compactdata = !0, S.data = S.data.split(X.dataseparator || "|")), u = 0, d = 0, E = S.data && S.data.length || 0; u < E || u < x; u += 1) {
                if (C = Y[u], r = d + 1, (k = S.data && S.data[d] || {}).x !== i && k.y !== i) {
                  K = ne.xy = !0;
                  break;
                }

                if (k.open !== i || k.high !== i || k.close !== i || k.low !== i) {
                  Q = ne.ohlc = !0;
                  break;
                }

                if (k.rowid !== i && k.columnid !== i) {
                  Z = ne.heatmap = !0;
                  break;
                }

                u < x && !C.vline && (n.set(r, 0, C.label || C.name), A = m(k ? k.value : ""), A = isNaN(A) ? "" : te(A, B), n.set(r, a, A), (J || W || k.errorvalue) && (J || n.set(0, a + 1, "Error"), M = 1, n.set(r, a + 1, te(k.errorvalue))), d += 1);
              }

              M && (a += M, M = 0), a += 1;
            }
          }
        }

        p && (h = h.slice(0, -p.length)), g && (h = h.slice(0, -g.length));
      } else if (h = H.data) {
        for (n.set(0, 1, X.yaxisname || "Value"), ne.singleseries = !0, ee = "1" == X.showsumatend, c = 0, x = h.length; c < x; c += 1) {
          (k = h[c]).vline || (A = m(k.value ? k.value : ""), n.setRow(c + 1, [k.label || k.name, isNaN(A) ? "" : (re += A, te(A))]));
        }

        ee && (ne.summation = !0, n.setRow(c + 1, [X.sumlabel || "Total", te(re)]));
      }
      if (Q) for (n.clear(), n.setRow(0, ["Open", "Close", "High", "Low"]), c = 0, r = 1, b = (h = H.dataset).length; c < b; c += 1) {
        for (u = 0, w = (S = h[c] && h[c].data || []).length; u < w; u += 1, r += 1) {
          k = S[u] || {}, n.setRow(u + 1, [te(k.open), te(k.close), te(k.high), te(k.low)]);
        }
      } else if (K) {
        for (n.clear(), J = !1, M = 0, n.setRow(0, ["Series", "x", "y"]), c = 0, r = 1, b = (h = H.dataset).length; c < b; c += 1) {
          if (!($ && (O = $.getDatasets()) && O[c] && !1 === O[c].visible)) for (u = 0, w = (S = h[c] && h[c].data || []).length; u < w; u += 1, r += 1) {
            k = S[u] || {}, A = [h[c].seriesname, te(k.x), te(k.y)], k.z !== i && (A.push(te(k.z)), M || (n.set(0, 3, "z"), M = 1)), (J || W || k.errorvalue !== i || k.horizontalerrorvalue !== i || k.verticalerrorvalue !== i) && (T = te(k.errorvalue), A.push(k.errorvalue, k.horizontalerrorvalue === i ? T : te(k.horizontalerrorvalue), k.verticalerrorvalue === i ? T : te(k.verticalerrorvalue)), J || (n.set(0, M + 3, "Error"), n.set(0, M + 4, "Horizontal Error"), n.set(0, M + 5, "Vertical Error")), J = ne.error = !0), n.setRow(r, A);
          }
        }
      } else if (Z) {
        for (n.clear(), F = {}, I = {}, c = 0, u = 1, f = (Y = H.rows && H.rows.row || []).length; c < f; c += 1, u += 1) {
          (C = Y[c]).id && (F[C.id.toLowerCase()] = u, n.set(u, 0, C.label || C.id));
        }

        for (c = 0, u = 1, f = (Y = H.columns && H.columns.column || []).length; c < f; c += 1, u += 1) {
          (C = Y[c]).id && (I[C.id.toLowerCase()] = u, n.set(0, u, C.label || C.id));
        }

        for (S = H.dataset && H.dataset[0] && H.dataset[0].data || [], j = $ && (O = $.getDatasets()) && O[0] && O[0].components && O[0].components.data || [], c = 0, f = S.length; c < f; c += 1) {
          r = (k = S[c]).rowid.toLowerCase(), a = k.columnid.toLowerCase(), j[c] && !1 === j[c].visible || (F[r] || (F[r] = n.rowCount, n.set(n.rowCount, 0, k.rowid)), I[a] || (I[a] = n.columnCount, n.set(0, n.columnCount, k.columnid)), n.set(F[r], I[a], te(k.value)));
        }
      }
      return g = null, p = null, Y = null, h = null, n.rowCount > 0 && n.get(0, 0) === i && n.set(0, 0, X.xaxisname || "Label"), {
        data: n.toString(),
        error: i,
        predictedFormat: ne
      };
    }, s = function s(e, t) {
      return (0, r.raiseError)(t, "0604111215", "run", "csvToJson()", "fusionCharts CSV data-handler only supports encoding of data."), e;
    }, t["default"] = {
      extension: function extension(e) {
        return e && (o = e, e.prototype.getDataAsCSV = x, e.prototype.getCSVData = b), {
          format: "csv",
          toJSON: s,
          fromJSON: a
        };
      },
      name: "csv",
      type: "transcoder",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(131),
        o = n(175),
        i = "json",
        a = void 0;

    function s(e, t, n, s, l) {
      (0, r.triggerEvent)("dataLoadRequested", l, {
        source: o.sourceName,
        url: e,
        dataFormat: i,
        silent: !!s,
        config: t,
        successcallback: n
      }, a, o.onDataLoadRequest, o.onDataLoadRequestCancel);
    }

    function l(e) {
      this.setChartDataUrl(e, "jsonurl");
    }

    t["default"] = {
      extension: function extension(e) {
        return e && (e.prototype.setJSONUrl = l), {
          format: "jsonurl",
          toJSON: s
        };
      },
      name: "JSONUrl",
      type: "transcoder",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.onDataLoadRequestCancel = t.onDataLoadRequest = t.sourceName = undefined;
    var r,
        o = n(176),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(131);
    var s = "XmlHttpRequest",
        l = void 0;

    function c(e, t) {
      e.sender.jsVars.stallLoad = !1, e.sender.setChartData(t.dataSource, t.dataFormat, t.config, t.successcallback, t.silent);
    }

    function u(e, t) {
      (0, a.triggerEvent)("dataLoadCancelled", e.sender, t), t.xmlHttpRequestObject.abort();
    }

    function d(e, t, n, r) {
      var o = n.obj,
          i = n.args;
      i.dataSource = e, i.xmlHttpRequestObject = t, i.source = s, i.url = r, (0, a.triggerEvent)("dataLoadRequestCompleted", o, i, l, c, u);
    }

    function f(e, t, n) {
      var r = n.obj,
          o = n.args;
      o.error = e, o.httpStatus = t.xhr && t.xhr.status ? t.xhr.status : -1, o.xmlHttpRequestObject = t, r._addChartDependency("data", {
        resolve: function resolve() {
          return {
            state: 1,
            msg: r.options.dataLoadErrorMessage,
            msgStyle: {
              image: {
                imageHAlign: r.args.dataLoadErrorMessageImageHAlign || r.options.baseChartMessageImageHAlign,
                imageVAlign: r.args.dataLoadErrorMessageImageVAlign || r.options.baseChartMessageImageVAlign,
                imageAlpha: r.args.dataLoadErrorMessageImageAlpha || r.options.baseChartMessageImageAlpha,
                imageScale: r.args.dataLoadErrorMessageImageScale || r.options.baseChartMessageImageScale
              },
              message: {
                color: r.args.dataLoadErrorMessageColor || r.options.baseChartMessageColor,
                fontFamily: r.args.dataLoadErrorMessageFont || r.options.baseChartMessageFont,
                fontSize: r.args.dataLoadErrorMessageFontSize || r.options.baseChartMessageFontSize
              }
            }
          };
        }
      }), r._setState(), (0, a.triggerEvent)("dataLoadError", r, o);
    }

    t.sourceName = s, t.onDataLoadRequest = function (e, t) {
      var n = e.sender,
          r = n.__state,
          o = t.url;
      n.options.dataSource = t.url, r.dhmXhrObj || (r.dhmXhrObj = new i["default"](d, f)), r.dhmXhrObj.get("function" == typeof window.decodeURIComponent ? window.decodeURIComponent(o) : window.unescape(o), {
        obj: n,
        args: t
      });
    }, t.onDataLoadRequestCancel = function (e, t) {
      var n = e.sender,
          r = n.__state;
      (0, a.triggerEvent)("dataLoadRequestCancelled", n, t), r && r.dhmXhrObj && r.dhmXhrObj.abort();
    };
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      t.__esModule = !0;
      var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      },
          o = n(131),
          i = n(125);

      var a = window,
          s = parseFloat(a.navigator.appVersion.split("MSIE")[1]),
          l = !!(s >= 5.5 && s <= 7),
          c = "file:" === a.location.protocol,
          u = a.ActiveXObject,
          d = (!u || !c) && a.XMLHttpRequest,
          f = {
        objects: 0,
        xhr: 0,
        requests: 0,
        success: 0,
        failure: 0,
        idle: 0
      },
          _h = function h() {
        var e;
        if (d) return (_h = function h() {
          return f.xhr++, new d();
        })();

        try {
          e = new u("Msxml2.XMLHTTP"), _h = function h() {
            return f.xhr++, new u("Msxml2.XMLHTTP");
          };
        } catch (t) {
          try {
            e = new u("Microsoft.XMLHTTP"), _h = function h() {
              return f.xhr++, new u("Microsoft.XMLHTTP");
            };
          } catch (n) {
            e = !1;
          }
        }

        return e;
      },
          p = function () {
        function t(e, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.onSuccess = e, this.onError = n, this.open = !1, f.objects++, f.idle++;
        }

        return t.stats = function (e) {
          return e ? f[e] : (0, i.extend2)({}, f);
        }, t.prototype.transact = function (n, r, s, u) {
          var d,
              p,
              g = this,
              m = g.xmlhttp,
              v = t.headers,
              y = g.onError,
              b = g.onSuccess,
              x = "POST" === n,
              w = Object.prototype.hasOwnProperty;
          -1 !== r.search(/^(http:\/\/|https:\/\/)/) && a.location.hostname !== /(http:\/\/|https:\/\/)([^\/\:]*)/.exec(r)[2] ? delete v["X-Requested-By"] : !w.call(v, "X-Requested-By") && (v["X-Requested-By"] = "FusionCharts"), (!m || l || i.isFirefox) && (m = _h(), g.xmlhttp = m), m.onreadystatechange = function () {
            try {
              4 === m.readyState && (!m.status && c || m.status >= 200 && m.status < 300 || 304 === m.status || 1223 === m.status || 0 === m.status ? (b && b(m.responseText, g, u, r), f.success++) : y && (y(new Error("XmlHttprequest Error"), g, u, r), f.failure++), f.idle--, g.open = !1);
            } catch (e) {
              y && y(e, g, u, r), a.FC_DEV_ENVIRONMENT && setTimeout(function () {
                throw e;
              }, 0), f.failure++;
            }
          };

          try {
            if (m.open(x ? "POST" : "GET", r, !0), m.overrideMimeType && m.overrideMimeType("text/plain"), x) {
              if ("string" == typeof s) d = s;else {
                for (p in d = [], s) {
                  d.push(p + "=" + (s[p] + "").replace(/\=/g, "%3D").replace(/\&/g, "%26"));
                }

                d = d.join("&");
              }
            } else d = null;

            for (p in v) {
              m.setRequestHeader(p, v[p]);
            }

            m.send(d), f.requests++, f.idle++, g.open = !0;
          } catch (C) {
            (0, o.raiseError)(e.core, "1110111515A", "run", "XmlHttprequest Error", C.message);
          }

          return m;
        }, t.prototype.get = function (e, t) {
          return this.transact("GET", e, void 0, t);
        }, t.prototype.post = function (e, t, n) {
          return this.transact("POST", e, t, n);
        }, t.prototype.abort = function () {
          var e = this.xmlhttp;
          return this.open = !1, e && "function" === r(e.abort) && e.readyState && 0 !== e.readyState && e.abort();
        }, t.prototype.dispose = function () {
          var e = this;
          return e.open && e.abort(), delete e.onError, delete e.onSuccess, delete e.xmlhttp, delete e.open, f.objects--, null;
        }, t;
      }();

      p.headers = {
        "If-Modified-Since": "Sat, 29 Oct 1994 19:43:31 GMT",
        "X-Requested-With": "XMLHttpRequest",
        "X-Requested-By": "FusionCharts",
        Accept: "text/plain, */*",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      }, t["default"] = p;
    }).call(this, n(118));
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(131),
        o = n(175),
        i = "xml",
        a = void 0;

    function s() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "",
          t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          n = arguments[2],
          s = arguments[3],
          l = arguments[4];
      (0, r.triggerEvent)("dataLoadRequested", l, {
        source: o.sourceName,
        url: e,
        dataFormat: i,
        silent: !!s,
        config: t,
        successcallback: n
      }, a, o.onDataLoadRequest, o.onDataLoadRequestCancel);
    }

    function l(e) {
      this.setChartDataUrl(e, "xmlurl");
    }

    function c() {
      (0, r.raiseWarning)(this, "11171116293", "run", "JavaScriptRenderer~setDataURL()", 'Use of deprecated "setDataURL()". Replace with "setXMLUrl()".'), this.setXMLUrl.apply(this, arguments);
    }

    t["default"] = {
      extension: function extension(e) {
        return e && (e.prototype.setXMLUrl = l), e && (e.prototype.setDataURL = c), {
          format: "xmlurl",
          toJSON: s
        };
      },
      name: "XMLUrl",
      type: "transcoder",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };
    t["default"] = {
      extension: function extension(e) {
        e.addEventListener("beforedataupdate", function (e, t) {
          t.data = function n(e) {
            var t = void 0 === e ? "undefined" : r(e);
            if ("string" === t || "number" === t || "function" === t || "boolean" === t) return e;
            if (null === e || e === undefined) return e;

            if (Array.isArray(e)) {
              for (var o = [], i = 0; i < e.length; i++) {
                o.push(n(e[i]));
              }

              return o;
            }

            if ("object" === (void 0 === e ? "undefined" : r(e))) {
              var a = {};

              for (var s in e) {
                var l = s.toLowerCase();
                "data" !== l ? a[l] = n(e[s]) : e[s] && e[s]._dataStore ? a[l] = e[s] : a[l] = n(e[s]);
              }

              return a;
            }
          }(t.data);
        });
      },
      name: "IgnoreCaseExt",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        o = n(138),
        i = n(132),
        a = n(131);

    function s(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function l(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function c(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var u = void 0,
        d = /\s+!important$/,
        f = /\\!important$/,
        h = function h(e, t) {
      var n, r;

      for (r in t = (t + "").toLowerCase(), e) {
        if (e.hasOwnProperty(r) && t === (r + "").toLowerCase()) {
          n = e[r];
          break;
        }
      }

      return n;
    },
        p = function p(e) {
      for (var t = /\s/, n = (e = e.replace(/^\s\s*/, "")).length; t.test(e.charAt(n -= 1));) {
        ;
      }

      return e.slice(0, n + 1);
    },
        g = function g(e) {
      var t = {},
          n = void 0;

      for (var r in e) {
        e.hasOwnProperty(r) && (t[(n = e[r]).name] = n);
      }

      return t;
    },
        m = function m(e, t) {
      for (var n = t.length, r = -1; n--;) {
        if (e === t[n]) return r = n;
      }

      return r;
    },
        v = function v(e, t, n) {
      return "object" !== (void 0 === e ? "undefined" : r(e)) && "object" !== (void 0 === t ? "undefined" : r(t)) ? null : "object" !== (void 0 === t ? "undefined" : r(t)) || null === t ? e : ("object" !== (void 0 === e ? "undefined" : r(e)) && (e = t instanceof Array ? [] : {}), function o(e, t, n, i, a) {
        var s, l, c, u, d;
        if (a ? (i.push(e), a.push(t)) : (i = [e], a = [t]), t instanceof Array) for (s = 0; s < t.length; s += 1) {
          try {
            l = e[s], c = t[s];
          } catch (f) {
            continue;
          }

          "object" !== (void 0 === c ? "undefined" : r(c)) ? n && void 0 === c || (e[s] = c) : (null !== l && "object" === (void 0 === l ? "undefined" : r(l)) || (l = e[s] = c instanceof Array ? [] : {}), -1 !== (d = m(c, a)) ? l = e[s] = i[d] : o(l, c, n, i, a));
        } else for (s in t) {
          try {
            l = e[s], c = t[s];
          } catch (f) {
            continue;
          }

          null !== c && "object" === (void 0 === c ? "undefined" : r(c)) ? "[object Object]" === (u = Object.prototype.toString.call(c)) ? (null !== l && "object" === (void 0 === l ? "undefined" : r(l)) || (l = e[s] = {}), -1 !== (d = m(c, a)) ? l = e[s] = i[d] : o(l, c, n, i, a)) : "[object Array]" === u ? (null !== l && l instanceof Array || (l = e[s] = []), -1 !== (d = m(c, a)) ? l = e[s] = i[d] : o(l, c, n, i, a)) : e[s] = c : e[s] = c;
        }
        return e;
      }(e, t, n), e);
    },
        y = function y(e) {
      var t = {
        important: !1,
        str: ""
      };
      return e ? (e = e.toString(), d.test(e) ? (e = e.replace(d, ""), t.important = !0) : (e = e.replace(f, "!imporant"), t.important = !1), t.str = e, t) : t;
    },
        b = function b(e, t) {
      var n,
          r,
          o,
          i = t.getAll();

      for (n in i) {
        r = i[n].toString(), (o = y(r)).important ? e[n.toLowerCase()] = o.str : void 0 === e[n.toLowerCase()] && (e[n.toLowerCase()] = o.str);
      }
    },
        x = function x(e) {
      var t,
          n = e.sender,
          r = n.getChartData();
      r.error || ((t = r && (r.chart && r.chart.theme || r.map && r.map.theme)) ? (r.map && (r.chart = r.map, delete r.map), u.themify(t, n, n.chartType(), r, "geo" === n.apiInstance.defaultSeriesType && "geo")) : n.jsVars && n.jsVars.themeObject && n.jsVars.themeObject.dispose());
    },
        w = function (e) {
      function t() {
        return s(this, t), l(this, e.apply(this, arguments));
      }

      return c(t, e), t.prototype.configure = function () {
        !this.config.themeStore && (this.config.themeStore = {});
      }, t.prototype.add = function (e) {
        for (var t, n = 0, r = e.length; n < r; n += 1) {
          (t = e[n].name) && (this.config.themeStore[t] = e[n]);
        }
      }, t.prototype.themify = function (e, n, r, o, s) {
        var l,
            c,
            u = n.jsVars,
            d = e.split(","),
            f = [],
            h = d.length;

        if (this.config.themeStore = g((0, i.getDepsByType)("theme")), h) {
          for (c = 0; c < h; c += 1) {
            (l = this.config.themeStore[p(d[c])]) && f.push(t.evaluateThemeJSON(l.theme, n, r, s));
          }

          f.length ? (u.themeObject = new C(f, n, !1, o), t.applyTheme(n), this._attachedListeners || (n.addEventListener("chartTypeChanged", x), this._attachedListeners = !0)) : (0, a.raiseWarning)(n, "14051100501", "run", "api.themes~themify()", 'The theme "' + e + '" requested has not been registered.');
        }
      }, t.evaluateThemeJSON = function (e, t, n, o) {
        var i,
            a,
            s = {},
            l = t.jsVars,
            c = function c(e) {
          var t, n;

          for (t in e) {
            (n = e[t]) instanceof Array ? s[t] = v(s[t] || [], n) : "object" === (void 0 === n ? "undefined" : r(n)) ? s[t] = v(s[t] || {}, n) : s[t] = n;
          }
        };

        return n = n || t.chartType(), l.themeObject && e !== l.themeObject && (l.themeObject.dispose(), delete l.themeObject), c(h(e, "base")), o && (i = h(e, o)), i && c(i), n && (a = h(e, n)), a && c(a), s;
      }, t.applyTheme = function (e) {
        var t = e.jsVars.themeObject,
            n = t.getThemedJSONData().data;
        n && function o(e, t) {
          var n,
              i,
              a,
              s,
              l,
              c,
              u = 0,
              d = 0;

          for (n in e) {
            if ((i = e[n]) instanceof Array) for (c = i.length, l = 0; l < c; l += 1) {
              "object" === (void 0 === (s = i[l]) ? "undefined" : r(s)) && ("category" === n ? "true" === s.vline ? (a = t.component("vline", u, s)) && (b(s, a), u += 1) : (a = t.component("category", d, s, c)) && (b(s, a), d += 1) : (a = t.component(n, l, s, c)) && (b(s, a), o(s, a)));
            } else "object" === (void 0 === i ? "undefined" : r(i)) && (a = t.component(n, null, i)) && (b(i, a), o(i, a));
          }
        }(n, t);
      }, t;
    }(o.ComponentInterface),
        C = function (e) {
      function t(n, r, o, i) {
        s(this, t);
        var a,
            c = l(this, e.call(this)),
            u = 0;

        for (c.themeArray = n, c.themeComponents = {}, c.base = {}, c.chartInstance = r, c.isChildInstance = Boolean(o), c.themedData = o ? null : v({
          chart: {}
        }, i), c.length = n.length, a = n.length; u < a; u += 1) {
          c.parse(n[u]);
        }

        return c;
      }

      return c(t, e), t.prototype.pushTheme = function (e) {
        e && (this.themeArray.push(e), this.parse(e), this.length += 1);
      }, t.prototype.parse = function (e) {
        var n,
            o,
            i,
            a,
            s,
            l = this.themeComponents,
            c = this.chartInstance,
            u = this.base;

        for (o in s = e) {
          "string" == typeof s[o] || "number" == typeof s[o] ? u[o] ? (i = y(s[o]), a = y(u[o]), !i.important && a.important || (u[o] = s[o])) : u[o] = s[o] : (l[o] || (l[o] = []), n = l[o], s[o] instanceof Array ? n.push(v([], s[o])) : "object" === r(s[o]) ? n.push(new t([s[o]], c, !0)) : "function" == typeof s[o] && n.push(s[o]));
        }
      }, t.prototype.merge = function (e) {
        var t,
            n,
            r,
            o = this.base,
            i = e.base,
            a = this.themeComponents,
            s = e.themeComponents;

        for (r in i) {
          t = y(o[r]), n = y(i[r]), t.important && !n.important || (o[r] = i[r]);
        }

        for (r in s) {
          a[r] ? a[r] = a[r].concat(s[r]) : a[r] = [].concat(s[r]);
        }

        this.length += e.length;
      }, t.prototype.get = function (e) {
        return this.base[e];
      }, t.prototype.getAll = function () {
        return v({}, this.base);
      }, t.prototype.component = function (e, n, r, o) {
        var i,
            a,
            s,
            l,
            c,
            u = this.themeComponents,
            d = this.chartInstance,
            f = new t([], d, !0);
        if (!(l = u[e])) return null;

        for (a = 0, s = l.length; a < s; a += 1) {
          "function" == typeof (c = l[a]) ? (n = n || 0, f.pushTheme(c.call(d, n, r, o))) : c instanceof Array ? (n = n || 0, (i = c[n %= c.length]) instanceof t ? f.merge(i) : "function" == typeof i ? f.pushTheme(i.call(d, n, r, o)) : f.pushTheme(i)) : c instanceof t ? f.merge(c) : f.pushTheme(c);
        }

        return f;
      }, t.prototype.getThemedJSONData = function () {
        return {
          data: this.themedData
        };
      }, t.prototype.dispose = function () {
        var e,
            t,
            n = this,
            r = n.themeComponents,
            o = n.chartInstance;

        for (e in r) {
          if (t = r[e].length) {
            for (; t--;) {
              r[e][t].dispose && r[e][t].dispose();
            }

            delete r[e];
          }
        }

        !n.isChildInstance && o && o.removeEventListener("chartTypeChanged", x), n.themeComponents = null, n.chartInstance = null, n.base = null, n.themeArray = null, n.isChildInstance = null, n.dataWithoutTheme = null;
      }, t;
    }(o.ComponentInterface);

    (u = new w()).configure(), t["default"] = {
      extension: function extension(e) {
        var t = function t(_t5) {
          var n,
              r,
              o,
              a = _t5.sender,
              s = g((0, i.getDepsByType)("theme")),
              l = a.getChartData(),
              c = e.options.defaultTheme,
              d = l && (l.chart && l.chart.theme || l.map && l.map.theme),
              f = (c || d) && (c || "") + "," + (d || ""),
              h = f && f.split(","),
              m = h && h.length,
              v = !1;

          for (r = 0; r < m; r++) {
            o = p(h[r]), s && "" !== o && s.hasOwnProperty(o) && (v = !0);
          }

          v ? (n = a.chartType(), l.map && (l.chart = l.map, delete l.map), u.themify(f, a, n, l, "geo" === a.apiInstance.defaultSeriesType && "geo")) : a.jsVars && a.jsVars.themeObject && (a.jsVars && a.jsVars.themeObject.dispose(), a.jsVars && delete a.jsVars.themeObject);
        };

        e.addEventListener("beforedataload", t), e.addEventListener("charttypechanged", t);
      },
      name: "ThemeEngine",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    /** !
     * @license FusionCharts JavaScript Library
     * Copyright FusionCharts Technologies LLP
     * License Information at <http://www.fusioncharts.com/license>
     */

    var r = {
      name: "default",
      theme: {
        base: {
          chart: {
            labelDisplay: "stagger !important",
            caption: "Theme Caption \\!important",
            canvasBgColor: "#56EF22",
            borderThickness: "5 !important",
            borderColor: "#E60539",
            baseFontColor: "#781129"
          },
          categories: [{
            fontColor: "#0F4F40",
            fontSize: 15,
            category: function category(e) {
              return {
                showLabel: e % 2 ? 0 : 1
              };
            },
            vline: {
              color: "#000000",
              thickness: 2
            }
          }],
          dataset: [{
            color: "#8C3146",
            data: function data(e, t) {
              return 8 == e && (t.value = ""), {
                color: Number(t.value) < 32e3 ? "#8C3146" : "#FF0000",
                alpha: "100"
              };
            }
          }],
          trendlines: [{
            line: function line(e) {
              return e ? {
                color: "#ff0000",
                thickness: 3
              } : {
                color: "#ffff00",
                thickness: 3
              };
            }
          }]
        },
        pie2d: {
          chart: {
            bgColor: "#FF0000"
          }
        },
        msline: {
          chart: {
            canvasBgColor: "#ff0000"
          }
        },
        geo: {
          chart: {
            canvasBgColor: "#0000ff"
          }
        },
        world: {
          chart: {
            canvasBgColor: "#00ff00"
          }
        }
      }
    };
    t["default"] = {
      extension: r,
      name: "DefaultTheme",
      type: "theme"
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        i = n(125),
        a = n(182),
        s = (r = a) && r.__esModule ? r : {
      "default": r
    },
        l = n(136);

    var c = void 0,
        u = void 0,
        d = /^#?[0-9a-f]{6}/i,
        f = /FFFFFF/i,
        h = /255,255,255/,
        p = function p(e) {
      return "#" + ("000000" + ((e = e.replace("rgba(", "").split(","))[0] << 16 | e[1] << 8 | e[2]).toString(16)).slice(-6);
    },
        g = function g(e, t) {
      var n,
          r,
          o = [];
      if ("number" == typeof e) return t;

      for (r = e.split && e.split(","), n = 0; n < r.length; n++) {
        o.push(t);
      }

      return o.join();
    },
        m = function m(e) {
      var t;
      return /rgb/.test(e) ? (t = e.match(/[\d\.]+\)/g), parseFloat(t && t[0])) : e.FCcolor ? (0, i.getFirstAlpha)(e.FCcolor.alpha) : void 0;
    },
        v = function v(e) {
      e.forEach(function (e) {
        e.removeStateCosmetics("highlight");
      });
    },
        y = function y(e, t, n, r, o) {
      var a, s, l, c, u, d, f, h, g, v;
      a = p(r.color), l = 100 * m(r.color), s = o ? (0, i.pluck)(n.valuefontcolor, a) : a, c = o ? (0, i.pluck)(n.valuefontalpha, n.alpha, l) : l, a = "" === r.backgroundColor ? "" : p(r.backgroundColor), l = "" === r.backgroundColor ? 0 : 100 * m(r.backgroundColor), isNaN(l) && (l = 0), d = o ? (0, i.pluck)(n.valuebgcolor, a) : a, u = o ? (0, i.pluck)(n.valuebgalpha, n.alpha, l) : l, g = (0, i.toRaphaelColor)({
        color: d,
        alpha: u
      }), a = "" === r.borderColor ? "" : p(r.borderColor), l = "" === r.borderColor ? "" : 100 * m(r.borderColor), isNaN(l) && (l = 0), f = o ? (0, i.pluck)(n.valuebordercolor, a) : a, h = o ? (0, i.pluck)(n.valueborderalpha, n.alpha, l) : l, v = (0, i.toRaphaelColor)({
        color: f,
        alpha: h
      }), t && e.setAnimation({
        el: t,
        label: "highlightedDataLabel",
        attr: {
          fill: (0, i.toRaphaelColor)({
            color: s,
            alpha: c
          }),
          "text-bound": [g, v, r.borderThickness, r.borderPadding, r.borderRadius, r.borderDash]
        }
      });
    },
        b = function b(e) {
      var t,
          n,
          r,
          o,
          i,
          a = e.split(","),
          s = {};

      for (t = 0, n = a.length; t < n; t++) {
        o = (r = a[t].split("="))[0], i = r[1], s[o] = i;
      }

      return s;
    },
        x = function x(e, t, n) {
      var r,
          o,
          a = t.color;
      return /rgb/.test(e) ? (r = (0, i.pluck)(t.alpha, 100 * m(e)), /rgb/.test(a) && (a = p(a)), o = n ? (0, i.toRaphaelColor)({
        color: (0, i.pluck)(a, p(e)),
        alpha: r
      }) : e) : e.FCcolor ? o = n ? (0, i.toRaphaelColor)(function (e, t) {
        var n,
            r,
            o = {};

        for (n in e) {
          "alpha" === n ? o[n] = t.alpha ? g(e[n], t.alpha) : e[n] : "color" === n ? (-1 !== e[n].indexOf(",") && t.color && (r = t.color + "," + e[n].substring(e[n].indexOf(",") + 1)), o[n] = (0, i.pluck)(r || t.color, e[n])) : o[n] = e[n];
        }

        return o;
      }(e.FCcolor, t)) : (0, i.toRaphaelColor)(e.FCcolor) : d.test(e.color || e) && (o = n ? (0, i.toRaphaelColor)({
        color: (0, i.pluck)(t.color, e.color, e),
        alpha: (0, i.pluck)(t.alpha, e.alpha)
      }) : (0, i.toRaphaelColor)({
        color: e.color || e,
        alpha: e.alpha
      })), o;
    },
        w = function w(e, t, n, r, o, a) {
      var s,
          l,
          c,
          u,
          d,
          f,
          h,
          g,
          v = {},
          y = {};
      o ? (s = (0, i.getColumnColor)(r.color || n.upperColorArr[0].FCcolor.color, r.alpha.toString(), n.upperColorArr[0].FCcolor.ratio, n.upperColorArr[0].FCcolor.angle, a, r.bordercolor || p(n.upperBoxBorder.color), r.borderalpha && r.borderalpha.toString() || (100 * m(n.lowerBoxBorder.color)).toString()), y = (0, i.toRaphaelColor)(s[0]), l = (0, i.getColumnColor)(r.color || n.lowerColorArr[0].FCcolor.color, r.alpha.toString(), n.lowerColorArr[0].FCcolor.ratio, n.lowerColorArr[0].FCcolor.angle, a, r.bordercolor || p(n.lowerBoxBorder.color), r.borderalpha && r.borderalpha.toString() || (100 * m(n.lowerBoxBorder.color)).toString()), v = (0, i.toRaphaelColor)(l[0]), c = x(n.median.color, r, o), f = x(n.lowerQuartile.color, r, o), h = x(n.upperQuartile.color, r, o)) : (y = (0, i.toRaphaelColor)(n.upperColorArr[0]), v = (0, i.toRaphaelColor)(n.lowerColorArr[0]), c = n.median.color, u = n.upperBoxBorder.color, d = n.lowerBoxBorder.color, h = n.upperQuartile.color, f = n.lowerQuartile.color), g = t.upperBoxElem, e.setAnimation({
        el: g,
        label: "highlightedBoxAnsWhiskerPlot",
        attr: {
          fill: y,
          "drop-shadow": g.attrs["drop-shadow"] && "none" !== g.attrs["drop-shadow"] ? [1, 1, 3, "rgba(64,64,64," + m(y) + ")", g.attrs[4], g.attrs["drop-shadow"][5]] : "none"
        }
      }), g = t.lowerBoxElem, e.setAnimation({
        el: g,
        label: "highlightedBoxAnsWhiskerPlot",
        attr: {
          fill: v,
          "drop-shadow": g.attrs["drop-shadow"] && "none" !== g.attrs["drop-shadow"] ? [1, 1, 3, "rgba(64,64,64," + m(v) + ")", g.attrs[4], g.attrs["drop-shadow"][5]] : "none"
        }
      }), g = t.lowerBoxBorderEle, e.setAnimation({
        el: g,
        label: "highlightedBoxAnsWhiskerPlot",
        attr: {
          stroke: d
        }
      }), t.upperBoxBorderEle && e.setAnimation({
        el: t.upperBoxBorderEle,
        label: "highlightedBoxAnsWhiskerPlot",
        attr: {
          stroke: u
        }
      }), t.lowerQuartileEle && e.setAnimation({
        el: t.lowerQuartileEle,
        label: "highlightedBoxAnsWhiskerPlot",
        attr: {
          stroke: f
        }
      }), t.upperQuartileEl && e.setAnimation({
        el: t.upperQuartileEl,
        label: "highlightedBoxAnsWhiskerPlot",
        attr: {
          stroke: h
        }
      }), t.midLineElem && e.setAnimation({
        el: t.midLineElem,
        label: "highlightedBoxAnsWhiskerPlot",
        attr: {
          stroke: c
        }
      });
    },
        C = function C(e, t, n) {
      var r,
          o,
          a,
          s,
          l,
          c,
          u,
          d,
          f,
          h = e.getFromEnv("chart"),
          p = e.getFromEnv("animationManager"),
          g = (h.config, h.config.dataLabelStyle),
          m = e.components.data;

      for (r = 0, o = m.length; r < o; r++) {
        if (u = m[r]) for (c in a = u.graphics, f = (s = u.config.anchorProps).enabled, l = {
          fillColor: {
            FCcolor: {
              alpha: n && f ? (0, i.pluck)(t.anchorbgalpha, t.alpha, s.bgAlpha) : s.bgAlpha,
              color: n && f ? (0, i.pluck)(t.anchorbgcolor, t.color, s.bgColor) : s.bgColor
            }
          },
          borderColor: {
            FCcolor: {
              alpha: n && f ? (0, i.pluck)(t.borderalpha, t.alpha, s.borderAlpha) : s.borderAlpha,
              color: n && f ? (0, i.pluck)(t.anchorbordercolor, t.color, s.borderColor) : s.borderColor
            }
          },
          imageAlpha: n ? t.alpha : s.imageAlpha,
          imageScale: s.imageScale
        }, a) {
          switch ((d = !c.match(/error/gi) && a[c]) && d.type) {
            case "path":
              p.setAnimation({
                el: d,
                label: "highlightedAnchorPlot",
                attr: {
                  fill: (0, i.toRaphaelColor)(l.fillColor),
                  stroke: (0, i.toRaphaelColor)(l.borderColor)
                }
              });
              break;

            case "image":
              p.setAnimation({
                el: d,
                label: "highlightedAnchorImagePlot",
                attr: {
                  opacity: l.imageAlpha / 100
                }
              });
              break;

            case "text":
              y(p, d, t, g, n);
          }
        }
      }
    },
        _ = function _(e, t, n, r, o) {
      var a,
          s = e.getStateCosmetics("default").symbol || {},
          l = s.fill,
          c = s.stroke,
          u = o ? (0, i.pluck)(r.color, p(n.text.fill)) : p(n.text.fill),
          g = t.legendItemLine,
          m = n.symbol.stroke,
          v = e.getFromEnv("animationManager");
      g && m && (d.test(m) ? v.setAnimation({
        el: g,
        label: "highlightedLegendItem",
        attr: {
          stroke: o ? (0, i.toRaphaelColor)({
            color: (0, i.pluck)(r.color, m),
            alpha: r.alpha
          }) : m
        }
      }) : (a = x(m, r, o), v.setAnimation({
        el: g,
        label: "highlightedLegendItem",
        attr: {
          stroke: a
        }
      }))), l && (l = l.match(d) ? o && !f.test(l) ? (0, i.toRaphaelColor)({
        color: r.color || l,
        alpha: r.alpha
      }) : l : h.test(l) ? l : x(l, r, o)), c && (c = d.test(c) ? o && !f.test(c) ? (0, i.toRaphaelColor)({
        color: r.color || c,
        alpha: r.alpha
      }) : c : o && !h.test(c) && r.color ? (0, i.toRaphaelColor)({
        color: r.color,
        alpha: r.alpha
      }) : c), e.setStateCosmetics("highlight", {
        symbol: {
          fill: l || "none",
          stroke: c || "none",
          opacity: (o ? r.alpha : 100) / 100
        },
        text: {
          fill: (0, i.toRaphaelColor)({
            color: u,
            alpha: o ? r.alpha : 100
          })
        }
      }), e.hasState("hidden") || e.setLegendState("highlight", !0);
    },
        S = function S(e, t) {
      var n = e.getFromEnv("legend").getItem(t);
      return n && n.getGraphicalElement();
    },
        E = {
      area: function area(e, t, n) {
        var r,
            o,
            a,
            s,
            l,
            c,
            u,
            d,
            f,
            h,
            p,
            g,
            v,
            y,
            x,
            w = this.getFromEnv("chart"),
            E = this.getFromEnv("animationManager"),
            k = w.config,
            A = w.getFromEnv("legend").getChildren("legendItem") || [],
            T = arguments[4],
            M = A.length,
            O = b(e),
            F = S(w, T),
            I = k.dataLabelStyle,
            L = this.getContainer("labelGroup"),
            N = this.config,
            D = (N.shadow || {}).opacity > 0;

        if (!n && this.getState("visible")) {
          for (O.alpha = O.alpha || 30, o = 0; o < M && (r = A[o] || {}).getId() !== T; o++) {
            ;
          }

          L && E.setAnimation({
            el: L,
            label: "highlightedGroup",
            attr: {
              opacity: t ? O.alpha / 100 : m(I.color)
            }
          }), s = N.plotbordercolor, f = N.plotborderalpha, y = N.plotfillalpha, a = N.plotgradientcolor, g = this.getGraphicalElement("lineElement") || this.getGraphicalElement("splineElement"), u = t ? (0, i.pluck)(O.bordercolor, O.color, s) : s, O.color && (h = O.color + (a ? "," + a : "")), p = N.fillColor.color, l = t ? (0, i.pluck)(h, p) : p, v = N.plotfillangle, c = t ? O.alpha : y, d = t ? (0, i.pluck)(O.borderalpha, O.alpha) : f, x = !!D && (t ? O.alpha / 100 : c / 100), E.setAnimation({
            el: g,
            label: "highlightedAreaPlot",
            attr: {
              fill: (0, i.toRaphaelColor)({
                color: l,
                alpha: c,
                angle: v
              }),
              stroke: (0, i.toRaphaelColor)({
                color: u,
                alpha: d
              })
            }
          }), g.shadow(x), F && _(r, F, r.parseLegendCosmetics(), O, t), C(this, O, t);
        }
      },
      bubble: function bubble(e, t, n) {
        var r,
            o,
            a,
            s,
            l,
            c,
            u,
            d,
            f,
            h,
            p,
            g,
            v = this.getFromEnv("chart"),
            x = this.getFromEnv("animationManager"),
            w = v.config,
            C = v.getFromEnv("legend").getChildren("legendItem") || [],
            E = C.length,
            k = arguments[4],
            A = w.dataLabelStyle,
            T = S(v, k),
            M = this.getContainer("labelGroup"),
            O = b(e);

        if (!1 === n && this.getState("visible")) {
          for (O.alpha || (O.alpha = 30), a = this.components.data || [], o = 0; o < E && (r = C[o] || {}).getId() !== k; o++) {
            ;
          }

          for (_(r, T, r.parseLegendCosmetics(), O, t), M && x.setAnimation({
            el: M,
            label: "highlightedGroup",
            attr: {
              opacity: t ? O.alpha / 100 : m(A.color)
            }
          }), o = 0, E = a.length; o < E; o++) {
            (s = a[o]) && (p = s.graphics, c = (l = s.config).colorObj, d = l.is3D, u = p.element, g = p.label, d ? (h = t ? (0, i.getPointColor)((0, i.pluck)(O.color, c.FCcolor.color), (0, i.pluck)(O.alpha, (0, i.getFirstAlpha)(c.alpha))) : c, h = (0, i.toRaphaelColor)(h)) : (h = t ? (0, i.pluck)(O.color, c.color) : c.color, f = t ? O.alpha : c.alpha, h = (0, i.toRaphaelColor)({
              color: h,
              alpha: f
            })), u && x.setAnimation({
              el: u,
              label: "highlightedBubblePlot",
              attr: {
                fill: h
              }
            }), g && y(x, g, O, A, t));
          }
        }
      },
      pie: function pie(e, t, n, r) {
        var o,
            a,
            l,
            c,
            u,
            d,
            f,
            h,
            p,
            g,
            v,
            x,
            w,
            C,
            E = r.getFromEnv("chart"),
            k = r.getFromEnv("animationManager"),
            A = E.getFromEnv("legend"),
            T = this,
            M = {},
            O = arguments[4],
            F = A.getChildren("legendItem") || [],
            I = b(e);

        if (!1 === n) {
          for (I.alpha || (I.alpha = 30), a = this.graphics.element, l = this.config, v = 0, g = F.length; v < g && (w = F[v]).getId() !== O; v++) {
            ;
          }

          x = S(E, O), _(w, x, w.parseLegendCosmetics(), I, t), u = l.color.color, E = (T = a.data("plotItem")).chart, o = T.style, c = 90, f = E.config.is3D, (d = T.center) && (M = {
            cx: d[0],
            cy: d[1],
            r: T.radius
          }), u = t ? (0, s["default"])((0, i.pluck)(I.color, u), I.alpha, c) : l.color, C = t ? I.alpha : u.alpha, u = (0, i.extend2)(u, M), f ? a && k.setAnimation({
            el: a,
            label: "highlightedPiePlot",
            attr: {
              color: u.color.split(",")[0],
              alpha: C
            }
          }) : a && k.setAnimation({
            el: a,
            label: "highlightedPiePlot",
            attr: {
              fill: (0, i.toRaphaelColor)(u)
            }
          }), h = this.graphics.label, p = this.graphics.connector, h && y(k, h, I, o, t), p && k.setAnimation({
            el: p,
            label: "highlightedPieConnectorPlot",
            attr: {
              opacity: t ? I.alpha / 100 : m(o.color)
            }
          });
        }
      },
      line: function line(e, t, n) {
        var r,
            a,
            s,
            l,
            c,
            u,
            d,
            f = this.getFromEnv("chart"),
            h = this.getFromEnv("animationManager"),
            p = f.config,
            g = f.getFromEnv("legend").getChildren("legendItem") || [],
            v = g.length,
            y = arguments[4],
            x = p.dataLabelStyle,
            w = b(e),
            E = S(f, y),
            k = this.getContainer("labelGroup"),
            A = this.getContainer("errorPlotGroup"),
            T = this.config,
            M = T.linecolor,
            O = T.alpha || T.lineAlpha,
            F = (T.shadow || {}).opacity > 0,
            I = this.config.lineOb,
            L = "";

        if (!n && this.getState("visible")) {
          for (w.alpha || (w.alpha = 30), c = 0; c < v && (r = g[c] || {}).getId() !== y; c++) {
            ;
          }

          if (A && (a = T.errorBarColor && m(T.errorBarColor), s = t ? (0, i.pluck)(w.alpha / 100, a) : a, h.setAnimation({
            el: A,
            label: "highlightedGroup",
            attr: {
              opacity: s
            }
          })), k && h.setAnimation({
            el: k,
            label: "highlightedGroup",
            attr: {
              opacity: t ? w.alpha / 100 : m(x.color)
            }
          }), l = this.getGraphicalElement("lineElement"), M = t ? (0, i.pluck)(w.color, M) : M, O = t ? (0, i.pluck)(w.alpha, O) : O, u = !!F && (t ? w.alpha / 100 : O / 100), l && h.setAnimation({
            el: l,
            label: "highlightedLinePlot",
            attr: {
              stroke: (0, i.toRaphaelColor)({
                color: M,
                alpha: O
              })
            }
          }), l && l.shadow(u), "object" === (void 0 === I ? "undefined" : o(I)) && I) for (L in I) {
            (d = I[L] && I[L].el) && h.setAnimation({
              el: d,
              label: "highlightedLinePlot",
              attr: {
                stroke: t ? M : I[L].attr.stroke,
                "stroke-opacity": O / 100
              }
            }), d && d.shadow(u);
          }
          E && _(r, E, r.parseLegendCosmetics(), w, t), C(this, w, t);
        }
      },
      boxandwhisker2d: function boxandwhisker2d(e, t, n) {
        var r,
            o,
            i,
            a,
            s,
            l,
            c = this.config,
            u = this.getFromEnv("chart"),
            d = this.getFromEnv("animationManager"),
            f = c.isRoundEdges,
            h = arguments[4],
            p = S(u, h),
            g = this.getContainer("lowerWhiskerGroup"),
            m = this.getContainer("upperWhiskerGroup"),
            v = this.getContainer("labelGroup"),
            y = u.getFromEnv("legend").getChildren("legendItem") || [],
            x = y.length,
            C = b(e);

        if (!1 === n && this.getState("visible")) {
          for (C.alpha || (C.alpha = 30), r = 0; r < x && (o = y[r] || {}).getId() !== h; r++) {
            ;
          }

          for (_(o, p, o.parseLegendCosmetics(), C, t), g && d.setAnimation({
            el: g,
            label: "highlightedGroup",
            attr: {
              opacity: t ? C.alpha / 100 : 1
            }
          }), m && d.setAnimation({
            el: m,
            label: "highlightedGroup",
            attr: {
              opacity: t ? C.alpha / 100 : 1
            }
          }), v && d.setAnimation({
            el: v,
            label: "highlightedGroup",
            attr: {
              opacity: t ? C.alpha / 100 : 1
            }
          }), r = 0, x = (l = this.components.data).length; r < x; r++) {
            s = (a = l[r]).config, i = a.graphics, w(d, i, s, C, t, f);
          }
        }
      },
      heatmap: function heatmap(e, t, n, r) {
        var o,
            a,
            s,
            l,
            c,
            u,
            d,
            f,
            h,
            g,
            v,
            x = r.getFromEnv("chart"),
            w = r.getFromEnv("animationManager"),
            C = x.config,
            E = C.dataLabelStyle,
            k = x.getFromEnv("legend"),
            A = arguments[4],
            T = b(e),
            M = k.getChildren("legendItem") || [];

        if (!n && r.getState("visible") && !1 !== this.visible) {
          for (T.alpha || (T.alpha = t ? 30 : 100), C = this.config, h = 0, f = M.length; h < f && (v = M[h]).getId() !== A; h++) {
            ;
          }

          for (u in g = S(x, A), _(v, g, v.parseLegendCosmetics(), T, t), c = p(C.color), l = m(C.color), o = t ? (0, i.pluck)(T.color, c) : c, a = t ? T.alpha : 100 * l, (s = (d = this.graphics).element) && w.setAnimation({
            el: s,
            label: "highlightedHeatmapPlot",
            attr: {
              fill: (0, i.toRaphaelColor)({
                color: o,
                alpha: a
              })
            }
          }), d) {
            "text" === (s = d[u]).type && y(w, s, T, E, t);
          }
        }
      },
      funnelpyramid: function funnelpyramid(e, t, n, r) {
        var o,
            a,
            s,
            l,
            c,
            u,
            d,
            f,
            h,
            g,
            v,
            x,
            w,
            C,
            E,
            k = r.getFromEnv("chart"),
            A = r.getFromEnv("animationManager"),
            T = k.getFromEnv("legend"),
            M = b(e),
            O = T.getChildren("legendItem") || [],
            F = arguments[4];

        if (!1 === n) {
          for (M.alpha || (M.alpha = 30), l = this, w = 0, x = O.length; w < x && (E = O[w]).getId() !== F; w++) {
            ;
          }

          C = S(k, F), _(E, C, E.parseLegendCosmetics(), M, t), a = l.style, v = l.color, c = p(v), g = m(v), u = t ? (0, i.pluck)(M.color, c) : c, d = t ? M.alpha : 100 * g, s = this.getGraphicalElement("graphic"), f = this.getGraphicalElement("dataLabel"), h = this.getGraphicalElement("connector"), o = this.style, s && A.setAnimation({
            el: s,
            label: "highlightedFunnelPyramidPlot",
            attr: {
              fill: (0, i.toRaphaelColor)({
                color: u,
                alpha: d
              })
            }
          }), f && y(A, f, M, o, t), h && A.setAnimation({
            el: h,
            label: "highlightedFunnelPyramidConnectorPlot",
            attr: {
              opacity: t ? M.alpha / 100 : m(a.color)
            }
          });
        }
      },
      "default": function _default(e, t, n) {
        var r,
            o,
            a,
            s,
            l,
            c,
            u,
            d,
            f,
            h,
            p,
            g,
            v,
            x,
            w,
            C = this.config,
            E = this.getFromEnv("chart"),
            k = this.getFromEnv("animationManager"),
            A = E.config,
            T = A.dataLabelStyle,
            M = A.useroundedges,
            O = E.config.is3D,
            F = b(e),
            I = arguments[4],
            L = S(E, I),
            N = this.getContainer("labelGroup"),
            D = this.getContainer("errorPlotGroup"),
            P = "",
            R = E.getFromEnv("legend").getChildren("legendItem") || [],
            j = R.length,
            V = C.showShadow;

        if (!1 === n && !0 === this.getState("visible")) {
          for (F.alpha || (F.alpha = "30"), p = this.components.data || [], o = 0; o < j && (x = R[o] || {}).getId() !== I; o++) {
            ;
          }

          for (L && _(x, L, x.parseLegendCosmetics(), F, t), N && k.setAnimation({
            el: N,
            label: "highlightedGroup",
            attr: {
              opacity: t ? F.alpha / 100 : m(T.color)
            }
          }), D && (l = C.errorBarColor && m(C.errorBarColor), c = t ? (0, i.pluck)(F.alpha / 100, l) : l, k.setAnimation({
            el: D,
            label: "highlightedGroup",
            attr: {
              opacity: c
            }
          })), o = 0, j = p.length; o < j; o++) {
            (g = p[o]) && g.graphics && (h = (A = g.config).colorArr[0], w = (a = A.colorArr[1]).FCcolor.alpha, P = -1 !== (d = (r = h.FCcolor.color).indexOf(",")) && F.color ? F.color + r.substring(d) : (0, i.pluck)(F.color, r), f = O ? w : (0, i.pluck)(F.borderalpha, F.alpha, w), 0 === (0, i.pluckNumber)(w) && (f = "0"), u = t ? (0, i.getColumnColor)(P, F.alpha, h.FCcolor.ratio, h.FCcolor.angle, M, (0, i.pluck)(F.bordercolor, a.FCcolor.color), f, !1, O) : [h, a], (s = g.graphics.element) && (r = (0, i.toRaphaelColor)(u[0]), a = (0, i.toRaphaelColor)(u[1]), k.setAnimation({
              el: s,
              label: "highlightedDefaultPlot",
              attr: {
                stroke: a,
                fill: r
              }
            }), s.shadow({
              opacity: V ? (0, i.getFirstAlpha)(u[0].alpha) / 100 : 0
            })), v = g.graphics.label, y(k, v, F, T, t));
          }
        }
      }
    },
        k = function k(e) {
      e && u.add(e);
    };

    t["default"] = {
      extension: function extension(e) {
        var t = function () {
          function t() {
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, t), this.effectStore = {}, this.eventHandlers = {};
          }

          return t.prototype.add = function (e) {
            this.effectStore[e.name] = e;
          }, t.prototype.attachEventHandlers = function (t, n) {
            this.eventHandlers[t] || (this.eventHandlers[t] = {}, this.eventHandlers[t].listenerFn = e.addEventListener(t, n));
          }, t.prototype.applyEffect = function (e, t, n) {
            var r,
                o,
                a,
                s,
                l,
                u,
                d,
                f,
                h,
                p,
                g,
                m,
                y = this.effectStore,
                b = e.getFromEnv("chart-attrib"),
                x = e.config.defaultDatasetType,
                w = b.plothighlighteffect && b.plothighlighteffect.toLowerCase(),
                C = e.getDatasets(),
                _ = e.config.isSingleSeries ? C[0].components.data : C,
                S = (0, i.pluck)(t.itemId, t.legendItemId, t.legendItemIndex),
                E = "";

            if (v(e.getFromEnv("legend").getChildren("legendItem")), "funnel" !== e.getName() && "Pyramid" !== e.getName() || (_ = C[0].getChildren("data")), e.getFromEnv("animationManager").setAnimationState("plotHighlighter"), w && (m = (w = w.replace(/\s+/g, "").split("|"))[0], E = w[1] || ""), m && y[m]) if ("HeatMap" === e.getName()) for (r = e.getFromEnv("colorRange"), g = function g(e) {
              var t = d.getChildren("legendItem"),
                  n = void 0,
                  r = void 0,
                  o = t && t.length;

              for (n = 0; n < o; ++n) {
                if (t[n].config.datasetObj.code === e) {
                  r = t[n].getId();
                  break;
                }
              }

              return r;
            }, h = (d = e.getFromEnv("legend")).getItem(S).config.datasetObj, l = 0; l < _.length; l++) {
              o = (s = _[l]).config.value, (p = r.getColorObj(o)).outOfRange || (h.code === p.code ? y[m][x].call(s, E, n, !0, C[0], S) : y[m][x].call(s, E, n, !1, C[0], g(p.code)));
            } else for (l = 0, f = _.length; l < f; l++) {
              x = (x = (s = _[l]).getName && s.getName() || x).toLowerCase(), (a = (0, i.pluck)(s.config.itemId, s.config.legendItemId)) !== c && (u = a === S, y[m][x] ? y[m][x].call(s, E, n, u, C[0], a) : y[m]["default"].call(s, E, n, u, C[0], a));
            }
          }, t;
        }();

        (u = new t()).attachEventHandlers("legenditemrollover", function (e, t) {
          var n = e.sender.apiInstance;
          !1 !== n.hasInteractiveLegend && !1 !== n.highlightEnabled && u.applyEffect(n, t, !0);
        }), u.attachEventHandlers("legenditemrollout", function (e, t) {
          var n = e.sender.apiInstance;
          !1 !== n.hasInteractiveLegend && !1 !== n.highlightEnabled && u.applyEffect(n, t, !1);
        }), u.attachEventHandlers("legenditemclicked", function (e, t) {
          var n = e.sender.apiInstance;
          n.addJob("plothighlighteffect", function () {
            !1 !== n.hasInteractiveLegend && !1 !== n.highlightEnabled && u.applyEffect(n, t, !0);
          }, l.priorityList.postRender);
        }), k({
          name: "fadeout",
          area: E.area,
          radar: E.area,
          bubble: E.bubble,
          pie2d: E.pie,
          line: E.line,
          spline: E.line,
          splinearea: E.area,
          pie3d: E.pie,
          zoomline: E.line,
          funnelpoint: E.funnelpyramid,
          pyramidpoint: E.funnelpyramid,
          scatter: E.line,
          selectscatter: E.line,
          dragline: E.line,
          dragarea: E.area,
          realtimearea: E.area,
          realtimeline: E.line,
          realtimelinedy: E.line,
          realtimestackedarea: E.area,
          errorline: E.line,
          errorscatter: E.line,
          stepline: E.line,
          doughnut2d: E.pie,
          doughnut3d: E.pie,
          heatmap: E.heatmap,
          boxandwhisker2d: E.boxandwhisker2d,
          multiaxisline: E.line,
          "default": E["default"]
        });
      },
      name: "PlotHighlighter",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(125);

    t["default"] = function (e, t, n, o) {
      var i, a, s, l, c, u;
      return e = (0, r.getFirstColor)(e), t = (0, r.getFirstAlpha)(t), n < 100 && r.hasSVG ? o ? (c = (0, r.getDarkColor)(e, Math.floor(100 * (85 - .2 * (100 - n))) / 100), u = (0, r.getLightColor)(e, Math.floor(100 * (100 - .5 * n)) / 100), i = {
        color: c + r.COMMASTRING + u + r.COMMASTRING + u + r.COMMASTRING + c,
        alpha: t + r.COMMASTRING + t + r.COMMASTRING + t + r.COMMASTRING + t,
        radialGradient: !0,
        gradientUnits: "userSpaceOnUse",
        r: n
      }) : (a = Math.floor(.85 * (100 - .35 * n) * 100) / 100, s = (0, r.getDarkColor)(e, a), l = Math.floor(.5 * (100 + n) * 100) / 100, i = {
        color: (0, r.getLightColor)(e, l) + r.COMMASTRING + s,
        alpha: t + r.COMMASTRING + t,
        ratio: n + "," + (100 - n),
        radialGradient: !0,
        gradientUnits: "userSpaceOnUse"
      }) : i = {
        color: e + r.COMMASTRING + e,
        alpha: t + r.COMMASTRING + t,
        ratio: "0,100"
      }, i;
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(184),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125);

    var s = "__FC_tooltipText",
        l = function l(e, t, n) {
      n = (0, a.getTouchEvent)(n);
      var r = t.universe.getBoundingClientRect(),
          o = n.clientX,
          i = n.clientY;
      o -= r.left, i -= r.top, o += 11, i += 11, u._draw.call(t, o, i, this.data(s), e);
    },
        c = function c(e) {
      u._hide(e);
    },
        u = function () {
      function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
        var n = this,
            r = n.config = {};
        n.universe = t, n.toolTips = {
          implicit: [],
          explicit: []
        }, n.hideImplicitToolTip = function (t) {
          var o = r.lastActiveToolip;
          o && t.target !== o.getData("targetElement").node && (e._hide(o), n.config.lastActiveToolip = undefined);
        }, n.config.positioningArr = [], n.config.canvasArr = [], t.FusionCharts.jsVars.fcObj.addEventListener("resized", n._updateAllToolTipBounds.bind(n));
      }

      return e.prototype._updateAllToolTipBounds = function () {
        var e = this.config,
            t = e.canvasArr,
            n = e.positioningArr,
            r = void 0,
            o = void 0,
            i = void 0,
            a = function a(e) {
          e.universeBounds && (i = e.universeBounds.canvas) && (r = t.indexOf(i)), e.setUniverseBounds(n[r]);
        },
            s = this.toolTips;

        for (o in s) {
          s[o].forEach(a);
        }
      }, e.prototype._setRelativePosition = function (e) {
        var t = this.config,
            n = t.canvasArr,
            r = t.positioningArr,
            o = n.indexOf(e.canvas);
        -1 === o ? (n.push(e.canvas), r.push(e)) : (n[o] = e.canvas, r[o] = e);
      }, e.prototype._createToolTip = function (e, t) {
        var n = this.config,
            r = n.canvasArr,
            o = n.positioningArr,
            a = r.indexOf(t),
            s = void 0;
        return (s = new i["default"](this.universe, o[a])).setStyle(this.config.tooltipStyle), this.toolTips[e].push(s), s;
      }, e.prototype.enableToolTip = function (e, t, n) {
        var r,
            o = this,
            i = o.toolTips.implicit,
            a = i.length,
            u = o.config,
            d = void 0;
        return t ? e.data(s) ? (a > 0 && (d = i[a - 1]).getData("active") && d.show(t), e.data(s, t), o) : (d = o._getAvailableToolTip("implicit", n), o.disableToolTip(e), e.data(s, t), e.data("__FC_onTooltipMove", l.bind(e, d, o)), e.data("__FC_onTooltipOut", c.bind(e, d)), e.data("__FC_onTooltipOver", (r = e, function (t) {
          o.draw(t, e.data(s), d), d.setData("targetElement", r), u.lastActiveToolip = d;
        })), e.on("fc-mousemove", e.data("__FC_onTooltipMove")), e.on("fc-mouseout", e.data("__FC_onTooltipOut")), e.on("fc-mouseover", e.data("__FC_onTooltipOver")), o) : (o.disableToolTip(e), o);
      }, e.prototype.disableToolTip = function (e) {
        var t = e.data("__FC_onTooltipOut"),
            n = e.data("__FC_onTooltipMove"),
            r = e.data("__FC_onTooltipOver");
        return n && e.off("fc-mousemove", n), t && e.off("fc-mouseout", t), r && e.off("fc-mouseover", r), e.removeData(s), this;
      }, e.prototype.draw = function (t, n, r, o) {
        var i = this.universe.getBoundingClientRect(),
            s = void 0,
            l = void 0;
        return s = (t = (0, a.getTouchEvent)(t)).clientX, l = t.clientY, r = r && !r.disposed ? r : this._getAvailableToolTip("explicit", o), s -= i.left, l -= i.top, s += 11, l += 11, e._draw.call(this, s, l, n, r), r;
      }, e.prototype.drawAt = function (t, n, r, o, i) {
        return o = o && !o.disposed ? o : this._getAvailableToolTip("explicit", i), e._draw.call(this, t, n, r, o), o;
      }, e._draw = function (e, t, n, r) {
        r.show(n), r.update(e, t);
      }, e.prototype._getAvailableToolTip = function (e, t) {
        for (var n = this.toolTips[e], r = void 0, o = 0, i = n.length; o < i; o++) {
          if (!1 === (r = n[o]).getData("active")) return r;
        }

        return this._createToolTip(e, t);
      }, e.prototype.setStyle = function (e) {
        var t = this.config,
            n = t.tooltipStyle || (t.tooltipStyle = {});

        for (var r in e) {
          n[r] = e[r];
        }
      }, e.prototype.hide = function (t) {
        return e._hide(t), this;
      }, e.prototype.hideAll = function () {
        var t, n;

        for (t in this.toolTips) {
          for (n = 0; n < this.toolTips[t].length; n++) {
            e._hide(this.toolTips[t][n]);
          }
        }
      }, e._hide = function (e, t) {
        e && (t ? e.dispose() : e.hide());
      }, e;
    }();

    t["default"] = {
      extension: u,
      name: "ToolTipController",
      type: "plugin"
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(125);

    var o = function o(e) {
      var t = e.getBoundingClientRect();
      return {
        left: 0,
        top: 0,
        right: t.width,
        bottom: t.height
      };
    },
        i = function () {
      function e(t, n) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
        this.text = "", this.x = 0, this.y = 0, this.visibleWidth = 0, this.universe = t, this.setUniverseBounds(n || o(t)), this.data = {
          active: !1,
          target: !1
        }, this.element = this.createElement(t);
      }

      return e.prototype.setUniverseBounds = function (e) {
        this.universeBounds = e || this.universe && o(this.universe);
      }, e.prototype.createElement = function (e) {
        var t = document.createElement("div");
        return t.setAttribute("class", "fc__tooltip"), t.className += " fusioncharts-div", t.innerHTML = this.text, t.style.color = "#545454", t.style.padding = "3px", t.style.fontSize = "10px", t.style.overflow = "hidden", t.style.borderWidth = "1px", t.style.borderColor = "#000000", t.style.whiteSpace = "nowrap", t.style.position = "absolute", t.style.borderStyle = "solid", t.style.backgroundColor = "#ffffff", t.style["user-select"] = "none", t.style["-ms-user-select"] = "none", t.style["-moz-user-select"] = "none", t.style["-webkit-user-select"] = "none", t.style["-webkit-touch-callout"] = "none", t.style.top = this.x + "px", t.style.left = this.y + "px", t.style.visibility = "hidden", t.style["pointer-events"] = "none", e.appendChild(t), t;
      }, e.prototype.setData = function (e, t) {
        this.data[e] = t;
      }, e.prototype.getData = function (e) {
        return this.data[e];
      }, e.prototype.setStyle = function (e) {
        var t = this.element.style;
        t.color = e.fontColor, r.hasSVG ? (t.backgroundColor = e.bgColor, t.borderColor = e.borderColor, e.showToolTipShadow ? t.boxShadow = "1px 1px 3px rgba(64,64,64,0.4)" : t.boxShadow = "none") : (t.backgroundColor = e.rawBgColor, t.borderColor = e.rawBorderColor), t.fontFamily = e["font-family"], t.fontSize = e["font-size"] + "px", t.borderWidth = e.borderThickness + "px", t.borderRadius = e.borderRadius + "px", t.padding = e.padding + "px";
      }, e.prototype.show = function (e) {
        this.text !== e && (this.text = e, this.element.innerHTML = this.text), this.setData("active", !0), "visible" !== this.element.style.visibility && (this.element.style.visibility = "visible"), this.element.style["will-change"] = "left, top", this.element.style["max-width"] = this.universeBounds.right - this.universeBounds.left - 24 + "px";
      }, e.prototype.update = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.x,
            t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.y,
            n = this.universeBounds,
            r = n.right,
            o = n.left + 12,
            i = n.bottom - 12,
            a = this.universeBounds.right - this.universeBounds.left - 24,
            s = this.element,
            l = s.offsetWidth,
            c = s.offsetHeight,
            u = s.style;
        e + l < r ? (u.left = e + "px", u.whiteSpace = "nowrap") : l < a ? u.left = e - l - 12 + "px" : (u.left = o + "px", u.whiteSpace = "normal"), u.top = t + c < i ? t + "px" : i - c + "px";
      }, e.prototype.hide = function () {
        this.y = 0, this.x = 0, this.x = "", this.setData("active", !1), this.setData("target", !1), this.element.style.visibility = "hidden", this.element.style["will-change"] = "auto", this.element.innerHTML = "", this.text = void 0;
      }, e.prototype.dispose = function () {
        this.hide(), this.universe.removeChild(this.element), this.universe = undefined, this.disposed = !0;
      }, e;
    }();

    t["default"] = i;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = n(125),
        o = {
      treemap: !0,
      scatter: !0,
      bubble: !0,
      errorscatter: !0,
      errorline: !0,
      errorbar2d: !0,
      candlestick: !0,
      stackedcolumn3d: !0,
      stackedbar3d: !0,
      mscolumnline3d: !0,
      mscombi3d: !0,
      mscolumn3dlinedy: !0,
      stackedcolumn3dline: !0,
      stackedcolumn3dlinedy: !0
    },
        i = function i(e) {
      return o[e.getName().toLowerCase()];
    },
        a = function a(e, t) {
      return e + '<div style="margin: 0;">' + t + "</div>";
    },
        s = function s(e, t) {
      return t.hovered ? e + 1 : e;
    },
        l = function l(e) {
      return e.anchorProps ? e.anchorProps.borderColor : e.originalPlotColor || e.plotColor || e.color;
    };

    function c(e) {
      var t = e.sender.getFromEnv("chart"),
          n = t.config.tooltipgrayoutcolor,
          o = t.config.plotcolorintooltip,
          i = t.getFromEnv("toolTipController"),
          c = t.getDatasets().sort(function (e, t) {
        return t.getJSONIndex() - e.getJSONIndex();
      }),
          u = t.getFromEnv("consolidated-tooltip"),
          d = (0, r.getMouseCoordinate)(e.sender.getFromEnv("chart-container"), e.originalEvent, t),
          f = d.chartX,
          h = d.chartY,
          p = !1,
          g = c.map(function (e) {
        return e.getPlotInCategoryAt(f, h);
      }).filter(Boolean),
          m = g.reduce(s, 0),
          v = g.map(function (e) {
        var t = e.pointObj.config,
            i = t.finalTooltext || t.toolText,
            a = l(t);
        return m > 0 ? !p && e.hovered ? (i = '<div style="display: inline-block;">' + i + "</div>", p = !0) : (a = n, i = '<div style="color: ' + (0, r.hashify)(n) + '; display: inline-block;">' + i + "</div>") : i = '<div style="display: inline-block;">' + i + "</div>", o ? '<div style="color: ' + (0, r.hashify)(a) + '; display: inline-block;">&#9632&nbsp;</div>' + i : i;
      }),
          y = [].concat(v).reverse().reduce(a, "");
      this.isWithinCanvas(f, h) && y ? u ? i.draw(e.originalEvent, y, u) : t.addToEnv("consolidated-tooltip", i.draw(e.originalEvent, y)) : u && i.hide(u);
    }

    function u(e) {
      var t = e.sender.getFromEnv("chart"),
          n = t.getFromEnv("toolTipController"),
          r = t.getFromEnv("consolidated-tooltip");
      r && n.hide(r);
    }

    function d(e) {
      var t = this.apiInstance,
          n = t.getDatasets().sort(function (e, t) {
        return e.getJSONIndex() - t.getJSONIndex();
      }),
          o = t.config.plotcolorintooltip,
          i = t.getFromEnv("toolTipController"),
          s = t.getFromEnv("consolidated-tooltip"),
          c = n.map(function (t) {
        var n = t.components.data;
        return n[e] && n[e];
      }).filter(Boolean),
          u = c[0] && {
        x: c[0].config._Px - c[0]._width,
        y: c[0].config._Py,
        width: c[0].config._width
      },
          d = c.map(function (e) {
        var t = e.config,
            n = t.finalTooltext || t.toolText,
            i = l(t);
        return o ? '<div style="color: ' + (0, r.hashify)(i) + '; display: inline-block;">&#9632&nbsp;</div><div style="display: inline-block;">' + n + "</div>" : '<div style="display: inline-block;">' + n + "</div>";
      }).reduce(a, "");
      d && u ? s ? i.drawAt(u.x, u.y, d, s) : t.addToEnv("consolidated-tooltip", i.drawAt(u.x, u.y, d)) : s && i.hide(s);
    }

    t["default"] = {
      extension: function extension(e) {
        e.addEventListener("predraw", function (e) {
          var t = void 0;

          if (e.sender.getType && "chartAPI" === e.sender.getType() && !i(e.sender)) {
            var n = (t = e.sender).getChildren("canvas");
            t.getFromEnv("chartInstance").drawConsolidatedToolTip = d, n && n.forEach(function (e) {
              if (!t.config.drawTrendRegion || !t.config.showtooltip) return e.removeEventListener("fc-mouseover", c), e.removeEventListener("fc-mousemove", c), e.removeEventListener("fc-mouseout", u), void e.setState("consolidatedTooltipEventListenerAttached", !1);
              !e.getState("consolidatedTooltipEventListenerAttached") && t.config.showtooltip && (e.addEventListener("fc-mouseover", c), e.addEventListener("fc-mousemove", c), e.addEventListener("fc-mouseout", u), e.setState("consolidatedTooltipEventListenerAttached", !0));
            });
          }
        });
      },
      name: "ConsolidatedToolTip",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(187),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125);

    var s = function s(e) {
      e.sender.apiInstance.getChildren("alertManager") && e.sender.apiInstance.getChildren("alertManager")[0].processRTData(e.data);
    };

    t["default"] = {
      extension: function extension(e) {
        e.addEventListener("instantiated", function (e) {
          "chartAPI" === e.sender.getType() && e.sender.registerFactory("alertManager", function (e) {
            if (e.getChildren("alertManager")) e.getChildren("alertManager")[0].configure();else {
              var t = e.getFromEnv("chart");
              (0, a.componentFactory)(t, i["default"], "alertManager", 1, [{}]);
            }
          });
        }), e.addEventListener("updateDataReceived", s), e.addEventListener("postConfigure", function (e) {
          if ("dataset" === e.sender.getType()) {
            var t,
                n = e.sender,
                r = n.config,
                o = r.JSONData,
                i = n.getFromEnv("chart").getChildren("alertManager"),
                s = void 0;
            if (!i || !o) return;
            t = (0, a.pluckNumber)(o && o.checkforalerts, 1), (s = (i = i[0]).config || (i.config = {})).datasetMap = s.datasetMap || {}, s.datasetMap[r.index] = t;
          }
        });
      },
      name: "alertManagerLinker",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(125);

    function o(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var i = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this));

        return n.pIndex = 1, n.linkedItems = {
          chart: {}
        }, n;
      }

      return o(t, e), t.prototype.getType = function () {
        return "extension";
      }, t.prototype.getName = function () {
        return "AlertManager";
      }, t.prototype.configure = function () {
        var e,
            t,
            n,
            r = this.getFromEnv("dataSource"),
            o = r && r.alerts && r.alerts.alert,
            i = this.getFromEnv("number-formatter"),
            a = this.config || (this.config = {});
        if (o && o.length) for (a.alertArr = o, e = o.length, t = 0; t < e; t += 1) {
          (n = o[t]).minvalue = i.getCleanValue(n.minvalue), n.maxvalue = i.getCleanValue(n.maxvalue);
        } else a.alertArr = [];
      }, t.prototype.processRTData = function (e) {
        var t,
            n,
            r,
            o,
            i,
            a,
            s = this.config,
            l = this.getFromEnv("number-formatter");
        if (e && e.dataset && e.dataset.length) for (r = e.dataset.length, t = 0; t < r; t += 1) {
          if ((o = e.dataset[t]).data && o.data.length) {
            if (s.datasetMap && 0 === s.datasetMap[t]) continue;

            for (i = o.data.length, n = 0; n < i; n += 1) {
              null !== ((a = o.data[n]) && l.getCleanValue(a.value)) && this._doAlert(l.getCleanValue(a.value));
            }
          }
        }
      }, t.prototype._doAlert = function (e) {
        var t,
            n,
            o,
            i = this.getLinkedParent(),
            a = this.config.alertArr,
            s = a.length;

        for (n = 0; n < s; n += 1) {
          if (o = (t = a[n]).action && t.action.toLowerCase(), t.minvalue <= e && t.maxvalue >= e) {
            if ("1" !== t.occuronce || !t.hasOccurred) {
              switch (t.hasOccurred = !0, t.state = "1", o) {
                case "calljs":
                  setTimeout((0, r.pseudoEval)(t.param));
                  break;

                case "showannotation":
                  i.showAnnotation && i.showAnnotation(t.param);
              }

              i.fireChartInstanceEvent("AlertComplete", {
                alertValue: e,
                alertMaxValue: t.maxvalue,
                alertMinValue: t.minvalue
              });
            }
          } else "showannotation" === o && "1" === t.state && i.hideAnnotation && i.hideAnnotation(t.param), t.state = "2";
        }
      }, t;
    }(n(138).ComponentInterface);

    t["default"] = i;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(189),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(191);
    t["default"] = {
      extension: function extension(e) {
        e.addEventListener("preconfigure", function (e) {
          var t = e.sender,
              n = t.getFromEnv("chart");
          a.allowedCharts[n && n.getName()] && ("dataset" === t.getType() && "cartesianStackGroup" !== t.getLinkedParent().getName() ? (t.setState("applySkippingOnConf", !0), i["default"].dataSkipping({
            component: t,
            datasetType: t.getName(),
            compType: "dataset"
          })) : "cartesianStackGroup" === t.getName() && (t.setState("applySkippingOnConf", !0), i["default"].dataSkipping({
            component: t,
            datasetType: t.getName(),
            compType: "group"
          })));
        }), e.addEventListener("preattributeprepared", function (e) {
          var t = e.sender.getFromEnv && e.sender.getFromEnv("chart");
          if (a.allowedCharts[t && t.getName()]) if ("dataset" === e.sender.getType()) {
            var n = e.sender,
                r = n.getFromEnv("canvasConfig"),
                o = n.getFromEnv("chart").isBar ? r.canvasHeight : r.canvasWidth;
            "cartesianStackGroup" !== n.getLinkedParent().getName() && (n.getState("applySkippingOnConf") ? n.setState("applySkippingOnConf", !1) : i["default"].dataSkipping({
              component: n,
              compType: "dataset",
              datasetType: n.getName(),
              width: o
            }));
          } else if ("cartesianStackGroup" === e.sender.getName()) {
            var s = e.sender,
                l = s.getFromEnv("canvasConfig"),
                c = s.getFromEnv("chart").isBar ? l.canvasHeight : l.canvasWidth,
                u = Object.keys(s.getChildren())[0];
            s.getState("applySkippingOnConf") ? s.setState("applySkippingOnConf", !1) : i["default"].dataSkipping({
              component: s,
              compType: "group",
              datasetType: s.getChildren(u)[0].getName(),
              width: c
            });
          }
        }), e.addEventListener("dataplotdragend", function (e, t) {
          if (e.sender.getType && "dataset" === e.sender.getType()) {
            var n = e.sender,
                r = n.getSkippingInfo && n.getSkippingInfo();
            r && r.skippingApplied && i["default"].updateDragMap({
              component: n,
              compType: "dataset",
              evenType: "dataplotdragend",
              eventArgs: t
            });
          }
        });
      },
      name: "DataSkipping",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(190),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(191),
        s = n(125);
    var l = 1.5,
        c = [],
        u = 0,
        d = {},
        f = [];

    function h() {
      return (arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : []).filter(function (e) {
        return !c[e];
      });
    }

    function p(e, t) {
      for (var n = 0, r = [], o = 1; o < d.noOfPlotBins; ++o) {
        e(n, (n += d.plotsPerBin) - 1, t, f, r);
      }

      return e(n, t.length - 1, t, f, r), f = [], r;
    }

    function g(e) {
      var t,
          n = e.datasetType,
          r = a.filterType[n],
          o = e.component,
          s = o.getSkippingInfo && o.getSkippingInfo(),
          l = s && s.draw.slice(0),
          g = s && (s.labelDraw || []).slice(0),
          m = {},
          v = [],
          y = void 0,
          b = void 0,
          x = void 0,
          w = void 0,
          C = o.getFromEnv("xAxis").getTicksLen(),
          _ = void 0;

      if ((!l || !l.length) && (l = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        return Array.from(new Array(e), function (e, t) {
          return t;
        });
      }(u)), (!g || !g.length) && (g = l), f = s && s.dragHashMap, "cartesianStackGroup" === o.getName()) {
        for (w = d.jsonData.length, y = 0; y < C; ++y) {
          for (x = 0, b = 0; b < w; ++b) {
            _ = d.jsonData[b].data, x += Number(_[y] ? _[y].value : 0);
          }

          v.push({
            value: x
          });
        }

        m.draw = p((0, i["default"])(r), v);
      } else m.draw = p((0, i["default"])(r), d.jsonData.data);

      return m.draw.forEach(function (e) {
        c[e] = !0;
      }), m.drawOnlyMap = c, m.hide = h(l), t = function (e) {
        var t = d.plotBinSize,
            n = d.labelBinSize / t,
            r = [],
            o = [],
            i = void 0,
            a = e.length;

        for (i = 0; i < a; i++) {
          i % n || (r.push(e[i]), o[e[i]] = !0);
        }

        return {
          drawableLabelIndices: r,
          labelHashMap: o
        };
      }(m.draw), m.labelDraw = t.drawableLabelIndices, c = m.labelDrawOnlyMap = t.labelHashMap, m.hideLabel = h(g), m.plotsPerBin = d.plotsPerBin, m.skippingApplied = !0, m.dragHashMap = [], m.prevDrawInfo = l.slice(0), m;
    }

    t["default"] = {
      dataSkipping: function dataSkipping() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            t = e.component;
        !function () {
          var e,
              t,
              n,
              r,
              o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              i = o.component,
              a = o.compType,
              f = void 0,
              h = i.getFromEnv("chartConfig"),
              p = i.getFromEnv("dataSource").chart || {},
              g = (0, s.pluckNumber)(p.plotbinsize, h.plotbinsize),
              m = (0, s.pluckNumber)(p.labelbinsize, h.labelbinsize),
              v = i.getFromEnv("chartWidth"),
              y = i.getFromEnv("chartHeight");
          return d.plotBinSize = g, d.labelBinSize = m, d.jsonData = i.config.JSONData, "group" === a ? (f = d.jsonData[0].data, u = i.config.stackValues && i.config.stackValues.length || 0) : "dataset" === a && (f = d.jsonData.data, u = i.components.data && i.components.data.length || 0), e = f && f.length, c = [], d.width = r = i.getFromEnv("chart").isBar ? o.height || y : o.width || v, t = e / r, n = Math.floor(t * g), t >= l && n > 1 && (d.plotsPerBin = n, d.noOfPlotBins = Math.ceil(e / d.plotsPerBin), !0);
        }(e) ? t.setSkippingInfo && t.setSkippingInfo() : t.setSkippingInfo && t.setSkippingInfo(g(e));
      },
      updateDragMap: function updateDragMap() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            t = e.component,
            n = e.eventArgs,
            r = t.getSkippingInfo && t.getSkippingInfo() || {};
        n && (r.dragHashMap[n.dataIndex] = n.endValue);
      }
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    t["default"] = function (e) {
      var t = {
        maxOnly: function maxOnly(e, t, n) {
          for (var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [], o = arguments[4], i = n[t].value, a = t, s = void 0, l = t - 1; l >= e; --l) {
            (s = void 0 !== r[l] ? r[l] : n[l].value) > i && (i = s, a = l);
          }

          return o.push(a), o;
        },
        minMax: function minMax(e, t, n) {
          for (var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [], o = arguments[4], i = n[t].value, a = t, s = n[t].value, l = t, c = void 0, u = t - 1; u >= e; --u) {
            (c = void 0 !== r[u] ? r[u] : n[u].value) > i ? (i = c, a = u) : c < s && (s = c, l = u);
          }

          var d = l < a ? [l, a] : [a, l];
          return l = d[0], a = d[1], o.push(l), l !== a && o.push(a), o;
        }
      };
      return t[e] || t.maxOnly;
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    t.allowedCharts = {
      Column2D: !0,
      Line: !0,
      Area2D: !0,
      Bar2D: !0,
      MSColumn2D: !0,
      MSLine: !0,
      MSBar2D: !0,
      MSArea: !0,
      StackedColumn2D: !0,
      StackedBar2D: !0,
      StackedArea2D: !0,
      MSStackedColumn2D: !0,
      MSCombi2D: !0,
      StackedColumn2DLine: !0,
      MSCombidy2D: !0,
      LogMSColumn2d: !0,
      LogMSLine: !0,
      DragColumn: !0,
      DragLine: !0,
      DragArea: !0
    }, t.filterType = {
      Column: "maxOnly",
      line: "minMax",
      area: "minMax"
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = i(n(193)),
        o = i(n(214));

    function i(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var a = function a(e) {
      return "chartAPI" === e.getType();
    },
        s = function s(e, t) {
      return "groups" !== t && "items" !== t;
    };

    t["default"] = {
      extension: function extension(e) {
        e.addEventListener("instantiated", function (e) {
          var t = e.sender;
          a(t) && t.registerFactory("annotation", function (e) {
            var t = e.getFromEnv("dataSource").annotations,
                n = e.getChildren().annotation,
                i = n && n[0];
            i && i.disposeConfiguration(), delete e.getFromEnv("chartInstance").annotations, t && (i || (i = new r["default"]((0, o["default"])(s, t)), e.attachChild(i, "annotation"), i.config.drawn = !1), i._JSONData = t, i.configure(t), e.getFromEnv("chartInstance").annotations = i);
          });
        });
      },
      name: "Annotation",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        o = f(n(194)),
        i = f(n(214)),
        a = n(196),
        s = n(125),
        l = n(132),
        c = f(n(215)),
        u = f(n(216)),
        d = f(n(217));

    function f(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function h(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var p = ["pie2d", "doughnut2d"],
        g = ["pie3d", "doughnut3d"],
        m = function m(e) {
      var t,
          n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          i = {};

      for (var a in i.annotationType = "shape", i.id = e.id, i.type = e.type && e.type.toLowerCase(), i.toolText = (0, s.pluck)(e.tooltext, e.toolText), i.animationLabel = (0, s.pluck)(e.animationlabel, e.animationLabel), i.dashed = e.dashed, i.dashLen = (0, s.pluck)(e.dashlen, e.dashLen), i.dashGap = (0, s.pluck)(e.dashgap, e.dashGap), i.thickness = e.thickness, i.showBorder = (0, s.pluck)(e.showborder, e.showBorder), i.borderColor = (0, s.pluck)(e.bordercolor, e.borderColor), i.borderAlpha = (0, s.pluck)(e.borderalpha, e.borderAlpha), i.borderThickness = (0, s.pluck)(e.borderthickness, e.borderThickness), i.alpha = e.alpha, i.color = e.color, i.fillColor = (0, s.pluck)(e.fillcolor, e.fillColor), i.fontColor = (0, s.pluck)(e.fontcolor, e.fontColor), i.fillAlpha = (0, s.pluck)(e.fillalpha, e.fillAlpha), i.fillAngle = (0, s.pluck)(e.fillangle, e.fillAngle), i.fillRatio = (0, s.pluck)(e.fillratio, e.fillRatio), i.fillPattern = (0, s.pluck)(e.fillpattern, e.fillPattern), i.sides = e.sides, i.radius = e.radius, i.yRadius = (0, s.pluck)(e.yradius, e.yRadius), i.innerRadius = (0, s.pluck)(e.innerradius, e.innerRadius), i.endAngle = (0, s.pluck)(e.endangle, e.endAngle), i.startAngle = (0, s.pluck)(e.startangle, e.startAngle), i.isVisible = !0 == (t = e.visible, !(0 === parseInt(t, 10))), i.x = e.x, i.y = e.y, i.xPos = (0, s.pluck)(e.xpos, e.xPos), i.yPos = (0, s.pluck)(e.ypos, e.yPos), i.toY = (0, s.pluck)(e.toy, e.toY), i.toX = (0, s.pluck)(e.tox, e.toX), i.autoScale = (0, s.pluck)(e.autoscale, e.autoScale), i.path = e.path, i.css = e.css, i.wrap = e.wrap, i.text = e.text !== s.UNDEF && null !== e.text && e.text.toString() || s.UNDEF, i.font = (0, s.pluck)(e.font, n.font, o.basefont), i.bold = (0, s.pluck)(e.bold, e.isbold, e.bold, e.isBold), i.label = e.label, i.align = e.align, i.italic = e.italic, i.vAlign = (0, s.pluck)(e.valign, e.vAlign), i.bgColor = (0, s.pluck)(e.bgcolor, e.bgColor), i.fontSize = (0, s.pluck)(e.fontsize, e.fontSize, n.fontSize, o.basefontsize), i.wrapWidth = (0, s.pluck)(e.wrapwidth, e.wrapWidth), i.leftMargin = (0, s.pluck)(e.leftmargin, e.leftMargin), i.rotateText = (0, s.pluck)(e.rotatetext, e.rotateText), i.wrapHeight = (0, s.pluck)(e.wrapheight, e.wrapHeight), i.showShadow = (0, s.pluck)(e.showshadow, e.showShadow), i.link = e.link, i.url = e.url, i.link = e.link, i.width = e.width, i.height = e.height, i.xScale = (0, s.pluck)(e.xscale, e.xScale), i.yScale = (0, s.pluck)(e.yscale, e.yScale), i.onload = e.onload, i.onerror = e.onerror, "object" === r(e.component) && (i.component = e.component), i) {
        if (i.hasOwnProperty(a)) void 0 === i[a] && delete i[a];
      }

      return i;
    },
        v = function v(e, t) {
      return "itemConfigs" !== t;
    },
        y = function y() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        groups: []
      },
          t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return (e.groups || []).map(function (n) {
        var o, i;
        return o = e, (i = n).css = i.css || o.css, i.autoscale = (0, s.pluck)(i.autoscale, o.autoscale), i.animationLabel = (0, s.pluck)(i.animationLabel, o.animationLabel), i.constrainedscale = (0, s.pluck)(i.constrainedscale, o.constrainedscale), i.scaletext = (0, s.pluck)(i.scaletext, o.scaletext), i.scaleimages = (0, s.pluck)(i.scaleimages, o.scaleimages), i.xshift = (0, s.pluck)(i.xshift, o.xshift), i.yshift = (0, s.pluck)(i.yshift, o.yshift), i.grpxshift = (0, s.pluck)(i.grpxshift, o.grpxshift), i.grpyshift = (0, s.pluck)(i.grpyshift, o.grpyshift), i.origw = (0, s.pluck)(i.origw, o.origw), i.origh = (0, s.pluck)(i.origh, o.origh), i.showbelow = (0, s.pluck)(i.showbelow, o.showbelow, 1), i.onAnnotationClick = o.onAnnotationClick, i.onAnnotationRollover = o.onAnnotationRollover, i.onAnnotationRollout = o.onAnnotationRollout, function (e, t) {
          var n = {},
              o = e.items;

          for (var i in o = e.items = (0, a.arrangeItems)(o), n.annotationType = "group", n.id = e.id, n.showBelow = "undefined" == typeof e.showbelow || null === e.showbelow ? 1 : Number(e.showbelow), n.x = e.x, n.y = e.y, n.animationLabel = (0, s.pluck)(e.animationlabel, e.animationLabel), n.xPos = (0, s.pluck)(e.xpos, e.xPos), n.yPos = (0, s.pluck)(e.ypos, e.yPos), n.grpXShift = (0, s.pluck)(e.grpxshift, e.grpXShift), n.grpYShift = (0, s.pluck)(e.grpyshift, e.grpYShift), n.xShift = (0, s.pluck)(e.xshift, e.xShift), n.yShift = (0, s.pluck)(e.yshift, e.yShift), n.color = e.color, n.alpha = e.alpha, n.isVisible = 1 === Number(e.visible || 1), n.font = (0, s.pluck)(e.font, t.basefont), n.link = e.link, n.fontSize = (0, s.pluck)(e.fontsize, e.fontSize, t.basefontsize), n.textAlign = (0, s.pluck)(e.textalign, e.textAlign), n.textVAlign = (0, s.pluck)(e.textvalign, e.textVAlign), n.rotateText = (0, s.pluck)(e.rotatetext, e.rotateText), n.wrapText = (0, s.pluck)(e.wraptext, e.wrapText), n.toolText = (0, s.pluck)(e.tooltext, e.toolText), n.link = e.link, n.showShadow = (0, s.pluck)(e.showshadow, e.showShadow), n.items = e.items, n.css = e.css, n.autoScale = (0, s.pluck)(e.autoscale, e.autoScale), n.scaleText = (0, s.pluck)(e.scaletext, e.scaleText), n.xScale = (0, s.pluck)(e.xscale, e.xScale), n.yScale = (0, s.pluck)(e.yscale, e.yScale), n.scaleImages = (0, s.pluck)(e.scaleimages, e.scaleImages), n.constrainedScale = (0, s.pluck)(e.constrainedscale), n.origH = (0, s.pluck)(e.origh, e.origH, t.origh), n.origW = (0, s.pluck)(e.origw, e.origW, t.origw), n.onAnnotationClick = e.onAnnotationClick, n.onAnnotationRollover = e.onAnnotationRollover, n.onAnnotationRollout = e.onAnnotationRollout, "object" === r(e.component) && (n.component = e.component), n) {
            n.hasOwnProperty(i) && void 0 === n[i] && delete n[i];
          }

          return Array.isArray(o) && (n.itemConfigs = o.map(function (e) {
            return m(e, n, t);
          })), n;
        }(n, t);
      });
    },
        b = function (e) {
      function t() {
        var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var r = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this));

        return (0, l.addDep)({
          name: "annotationAnimation",
          type: "animationRule",
          extension: c["default"]
        }), (0, u["default"])((0, l.getDep)("redraphael", "plugin")), (0, d["default"])((0, l.getDep)("redraphael", "plugin")), r.rawConfig = JSON.parse(JSON.stringify(n)), r.groups = [], r.config.dependencies = {}, r;
      }

      return h(t, e), t.prototype.getName = function () {
        return "annotation";
      }, t.prototype.getType = function () {
        return "extension";
      }, t.prototype.setup = function () {
        var e = this.config;
        this.rawConfig = {
          group: []
        }, !e.parsedConfigs && (e.parsedConfigs = []);
      }, t.prototype.configureAttributes = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          groups: []
        },
            t = this.config,
            n = this.getFromEnv("chart");
        this.setup(), e.groups ? t.parsedConfigs = y(e, n.config) : t.parsedConfigs = [], this.createAnnotationItems();
      }, t.prototype.createAnnotationItems = function (e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            n = this,
            r = n.config;
        (e || r.parsedConfigs).forEach(function (e) {
          var r = e.itemConfigs || {},
              o = void 0;
          e = (0, i["default"])(v, e), o = n.createItem(e, s.UNDEF, t), r.forEach(function (e) {
            n.createItem(e, o, t);
          }), o.items = o.getChildren("item") || [];
        }), n.groups = n.getChildren("group") || [];
      }, t.prototype.__addItem = function (e) {
        var t,
            n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            r = void 0,
            o = void 0,
            i = this._JSONData;

        for (n = Object.assign({}, n), !i && (this._JSONData = i = {
          groups: []
        }), o = 0, t = i.groups.length; o < t && (r = i.groups[o]).id !== e; o++) {
          ;
        }

        return r ? r.items.push(n) : i.groups.push({
          id: e,
          items: [n]
        }), this.setData(i), this.config.lastCreatedItem;
      }, t.prototype.addItem = function (e) {
        var t,
            n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            o = arguments[2],
            i = this.retrieveGroup(e),
            a = m(n),
            s = void 0;
        if (a.isVisible = !0, i = i || this.addGroup({
          id: e
        }), "object" === (void 0 === o ? "undefined" : r(o)) && (s = {
          component: o
        }), t = this.createItem(a, i, s)) return i.items = i.getChildren("item") || [], this.asyncDraw(), t;
      }, t.prototype.__addGroup = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            t = this._JSONData;
        return e = Object.assign({}, e), !t && (this._JSONData = t = {
          groups: []
        }), t.groups.push(e), this.setData(t), this.config.lastCreatedGroup;
      }, t.prototype.addGroup = function () {
        var e,
            t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            n = arguments[1],
            r = this.config,
            o = Object.assign({}, t),
            i = void 0;
        return this.setup(), (i = y({
          groups: [o]
        }))[0], i.forEach(function (e) {
          r.parsedConfigs.push(e);
        }), this.createAnnotationItems(i, {
          component: n
        }), e = this.groups[this.groups.length - 1], this.asyncDraw(), e;
      }, t.prototype.addCustomGroup = function (e) {
        e && (this.config.customGroup = e);
      }, t.prototype.update = function (e, t) {
        var n = void 0,
            r = void 0,
            o = {},
            i = void 0,
            a = void 0;

        if (e) {
          for (r in t) {
            o[r.toLowerCase()] = t[r] && t[r].toString();
          }

          if (!(n = this.retrieveItem(e) || this.retrieveGroup(e)) || !n.getElement()) return;
          return "undefined" == typeof o.visible && (o.visible = n._getConfig("isVisible")), i = n.rawConfig, i = Object.assign(i, o), (a = m(i)).isVisible = o.visible, n.setData(a), n;
        }
      }, t.prototype.destroy = function (e) {
        var t = this._JSONData,
            n = void 0,
            r = void 0,
            o = void 0,
            i = void 0,
            a = void 0,
            s = !1;

        if (e) {
          for (n = 0, o = t.groups.length; n < o; n++) {
            for (r = 0, i = ((a = t.groups[n]).items || []).length; r < i; r++) {
              if (a.items[r].id === e && !s) {
                a.items.splice(r, 1), s = !0;
                break;
              }
            }
          }

          if (!s) for (n = 0, o = t.groups.length; n < o; n++) {
            (a = t.groups[n]).id === e && t.groups.splice(n, 1);
          }
        } else t = this._JSONData = {
          groups: []
        };

        this.setData(t);
      }, t.prototype.clear = function () {
        this.destroy();
      }, t.prototype.draw = function () {
        var e, t, n, r, o, i, s, l, c, u, d, f, h, m;
        this.addToEnv("snapPoints", (e = this.getFromEnv("chart"), n = e.config, r = e.getChildren(), o = r.caption[0], i = r.subCaption[0], s = r.legend && r.legend[0] || {}, l = r.gLegend && r.gLegend[0] || {}, c = o.config, u = i.config, d = c.width || 0, f = u.width || 0, h = void 0, m = void 0, "end" === c.align ? (h = c.x - d, m = c.x - f) : "start" === c.align ? h = m = c.x : (h = c.x - d / 2, m = c.x - f / 2), t = n.gLegendEnabled ? l.conf : s.config, {
          canvasendx: n.canvasRight,
          canvasendy: n.canvasBottom,
          canvasheight: n.canvasHeight,
          canvasstartx: n.canvasLeft,
          canvasstarty: n.canvasTop,
          canvaswidth: n.canvasWidth,
          canvascenterx: n.canvasCenterX || n.canvasLeft + (n.canvasRight - n.canvasLeft) / 2,
          canvascentery: n.canvasCenterY || n.canvasTop + (n.canvasBottom - n.canvasTop) / 2,
          chartcenterx: n.width / 2,
          chartcentery: n.height / 2,
          chartstartx: 0,
          chartstarty: 0,
          chartendx: n.width,
          chartendy: n.height,
          chartheight: n.height,
          chartwidth: n.width,
          chartleftmargin: n.marginLeft,
          chartrightmargin: n.marginRight,
          chartbottommargin: n.marginBottom,
          charttopmargin: n.marginTop,
          captionendx: h + c.width,
          captionendy: c.y + c.height,
          captionheight: c.height,
          captionstartx: h,
          captionstarty: c.y,
          captionwidth: d,
          subcaptionendx: m + u.width,
          subcaptionendy: u.y + u.height,
          subcaptionheight: u.height,
          subcaptionstartx: m,
          subcaptionstarty: u.y,
          subcaptionwidth: f,
          legendendx: t && t.xPos + t.width,
          legendendy: t && t.yPos + t.height,
          legendheight: t && t.height,
          legendstartx: t && t.xPos,
          legendstarty: t && t.yPos,
          legendwidth: t && t.width,
          dataset: function dataset(t) {
            var n,
                r = t.split(a.DEFAULT_MACRO_SEPARATOR).slice(1),
                o = void 0,
                i = void 0,
                s = [];
            return e.iterateComponents(function (e) {
              "dataset" === e.getType() && s.push(e);
            }), s.sort(function (e, t) {
              return e.getJSONIndex() - t.getJSONIndex();
            }), o = s[Number(r[0])], n = o.components.data[Number(r[2])], p.indexOf(o.getName().toLowerCase()) > -1 ? (0, a.computeSliceBounds)(r[3], n.config) : g.indexOf(o.getName().toLowerCase()) > -1 ? (0, a.compute3DSliceBounds)(r[3], n.config) : (i = (0, a.computePlotBounds)(n, o.getName()), (0, a.xyCalculator)(r[3], i));
          },
          xaxis: (0, a.axisMacroParser)(e, "xAxis"),
          yaxis: (0, a.axisMacroParser)(e, "yAxis"),
          gaugestartx: n.gaugeStartX,
          gaugestarty: n.gaugeStartY,
          gaugeendx: n.gaugeEndX,
          gaugeendy: n.gaugeEndY,
          gaugecenterx: n.gaugeCenterX,
          gaugecentery: n.gaugeCenterY,
          gaugestartangle: n.gaugeStartAngle,
          gaugeendangle: n.gaugeEndAngle,
          gaugeradius: n.gaugeRadius,
          plotwidth: n.plotWidth,
          plotsemiwidth: n.plotSemiWidth
        })), this.addGraphicalElement({
          el: "group",
          attr: {
            name: "upperannotations"
          },
          component: this,
          container: {
            label: "group",
            id: "abovePlotGroup",
            isParent: !0
          },
          id: "upperAnnotationGroup",
          label: "group"
        }), this.addGraphicalElement({
          el: "group",
          attr: {
            name: "lowerannotations"
          },
          component: this,
          container: {
            label: "group",
            id: "belowPlotGroup",
            isParent: !0
          },
          id: "lowerAnnotationGroup",
          label: "group"
        });
      }, t;
    }(o["default"]);

    t["default"] = b;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(138),
        o = n(125),
        i = f(n(195)),
        a = f(n(207)),
        s = f(n(209)),
        l = f(n(210)),
        c = f(n(211)),
        u = f(n(212)),
        d = f(n(213));

    function f(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function h(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var p = {
      circle: a["default"],
      arc: a["default"],
      line: s["default"],
      path: s["default"],
      rectangle: l["default"],
      polygon: c["default"],
      image: u["default"],
      text: d["default"]
    },
        g = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return h(t, e), t.prototype.createItem = function (e, t) {
        var n = void 0,
            r = void 0;
        if ("group" === e.annotationType) e.groupXShift = (0, o.pluckNumber)(e.groupXShift, this.config.groupXShift), e.groupYShift = (0, o.pluckNumber)(e.groupYShift, this.config.groupYShift), n = this.attachChild(i["default"], "group", e.id), this.config.lastCreatedGroup = n;else {
          if (r = e.type && e.type.toLowerCase(), !(n = t.attachChild(p[r], "item", e.id))) return;
          this.config.lastCreatedItem = n;
        }
        return n._setToStore("component", e.component), n.configure(e), n;
      }, t.prototype.retrieveItem = function (e, t) {
        var n = void 0,
            r = void 0,
            o = void 0;

        for (o in this.groups) {
          if (n = this.groups[o].retrieveItem(e, t)) {
            r = n;
            break;
          }
        }

        return r;
      }, t.prototype.retrieveGroup = function (e, t) {
        var n = void 0,
            r = void 0;
        if (t) this.detachChild(e);else for (n = 0, r = this.groups.length; n < r; n++) {
          if (this.groups[n].getId() === e) return this.groups[n];
        }
      }, t.prototype.show = function (e) {
        var t = void 0;
        e ? (t = this.retrieveItem(e) || this.retrieveGroup(e)) && t.show() : this.groups.forEach(function (e) {
          e.show(), e.items.forEach(function (e) {
            e.show();
          });
        });
      }, t.prototype.hide = function (e) {
        var t = void 0;
        e ? (t = this.retrieveItem(e) || this.retrieveGroup(e)) && t.hide() : this.groups.forEach(function (e) {
          e.hide(), e.items.forEach(function (e) {
            e.hide();
          });
        });
      }, t.prototype.dispose = function () {
        var e = this.config,
            t = void 0,
            n = void 0,
            r = void 0,
            o = void 0;

        if (e.groups) {
          for (t = e.groups.length - 1; t >= 0; t--) {
            for (n = ((r = e.groups[t]).items && r.items.length) - 1; n >= 0; n--) {
              (o = r.items[n]) && o.dispose();
            }

            r.items = [], r.dispose();
          }

          e.groups = [];
        }
      }, t.prototype.disposeConfiguration = function () {
        var e = this.config;
        e.parsedConfigs = [], e.groups = [];
      }, t;
    }(r.SmartRenderer);

    t["default"] = g;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(125),
        o = n(196),
        i = s(n(197)),
        a = s(n(198));

    function s(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function l(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var c = function (e) {
      function t() {
        var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var r = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this, n));

        return r.groups = [], r.items = [], r;
      }

      return l(t, e), t.prototype.getName = function () {
        return "group";
      }, t.prototype.configureAttributes = function (e) {
        var t,
            n = this.config;
        this.rawConfig = {}, t = (0, a["default"])(this.rawConfig, e), this.rawConfig = t, n.id = this.rawConfig.id || this.getId("group"), n.autoScale = (0, r.pluckNumber)(this.rawConfig.autoScale, 1), n.scaleText = (0, r.pluckNumber)(this.rawConfig.scaleText, 0), n.scaleX = n.origScaleX = (0, r.pluckNumber)(this.rawConfig.xScale) / 100, n.scaleY = n.origScaleY = (0, r.pluckNumber)(this.rawConfig.yScale) / 100, n.scaleImages = (0, r.pluckNumber)(this.rawConfig.scaleImages, 0), n.constrainedScale = (0, r.pluckNumber)(this.rawConfig.constrainedScale, 1), n.origH = Number(this.rawConfig.origH), n.origW = Number(this.rawConfig.origW), n.link = this.rawConfig.link, n.color = this.rawConfig.color || "#FF0000", n.alpha = (0, r.pluckNumber)(parseFloat(this.rawConfig.alpha), 100), n.showShadow = (0, r.pluckNumber)(this.rawConfig.showShadow, 0), n.x = (0, r.pluckNumber)(this.rawConfig.x, this.rawConfig.xPos, 0), n.y = (0, r.pluckNumber)(this.rawConfig.y, this.rawConfig.yPos, 0), n.font = (0, r.pluck)(this.rawConfig.font, "Verdana, sans"), n.fontSize = (0, r.pluckFontSize)(this.rawConfig.fontSize, 10), n.textAlign = (0, r.pluck)(this.rawConfig.textAlign), n.textVAlign = (0, r.pluck)(this.rawConfig.textVAlign), n.rotateText = (0, r.pluck)(this.rawConfig.rotateText), n.wrapText = (0, r.pluck)(this.rawConfig.wrapText), n.grpXShift = (0, r.pluckNumber)(this.rawConfig.grpXShift, 0), n.grpYShift = (0, r.pluckNumber)(this.rawConfig.grpYShift, 0), n.xShift = (0, r.pluckNumber)(this.rawConfig.xShift, 0), n.yShift = (0, r.pluckNumber)(this.rawConfig.yShift, 0), n.toolText = this.rawConfig.toolText, n.isVisible = (0, o.pluckBoolean)(this.rawConfig.isVisible, !0), n.elementType = "group", n.containerConfiguration = {
          id: this.rawConfig.showBelow ? "lowerAnnotationGroup" : "upperAnnotationGroup",
          label: "group",
          isParent: !0
        }, n.animationLabel = "group";
      }, t.prototype.updateScale = function () {
        var e,
            t = this.config,
            n = void 0,
            r = void 0,
            o = void 0,
            i = void 0,
            a = this._getConfig("origScaleX"),
            s = this._getConfig("origScaleY"),
            l = this.getFromEnv("chart"),
            c = +l.getFromEnv("chartHeight"),
            u = +l.getFromEnv("chartWidth"),
            d = this._getConfig("autoScale"),
            f = this._getConfig("constrainedScale");

        this._setConfig("origW", Number(this._getConfig("origW")) || u), this._setConfig("origH", Number(this._getConfig("origH")) || c), d ? (n = u / this._getConfig("origW") * (Number(a) || 1), r = c / this._getConfig("origH") * (Number(s) || 1)) : n = r = 1, e = Math.min(n, r), this._setConfig("scaleValue", e), (d > 0 || isNaN(this._getConfig("scaleX"))) && (o = f ? e : n, this._setConfig("scaleX", o)), (d > 0 || isNaN(this._getConfig("scaleY"))) && (i = f ? e : r, this._setConfig("scaleY", i)), this._setConfig("scaleFont", this._getConfig("scaleText") ? Math.min(this._getConfig("scaleX"), this._getConfig("scaleY")) : 1), this._setConfig("scaleImageX", this._getConfig("scaleImages") ? this._getConfig("scaleX") : 1), this._setConfig("scaleImageY", this._getConfig("scaleImages") ? this._getConfig("scaleY") : 1), t.scaleInfo = {
          scaleX: t.scaleX,
          scaleY: t.scaleY,
          scaleValue: t.scaleValue
        };
      }, t.prototype.updateAttr = function () {
        var e,
            t,
            n = this.config,
            r = n.calculatedAttrs,
            o = void 0;

        for (o in r) {
          r[o] && (n[o] = r[o]);
        }

        e = this.getScaledVal(this._getConfig("grpXShift")) + this._getConfig("xShift"), t = this.getScaledVal(this._getConfig("grpYShift")) + this._getConfig("yShift"), this._setConfig("attr", {
          transform: "T" + e + "," + t
        });
      }, t.prototype.retrieveItem = function (e, t) {
        var n = void 0,
            r = void 0;
        if (t) this.detachChild(e);else for (n = 0, r = this.items.length; n < r; n++) {
          if (this.items[n].getId() === e) return this.items[n];
        }
      }, t.prototype.getScaledVal = function (e, t) {
        return this ? e * (t ? this._getConfig("scaleX") : (!1 === t ? this._getConfig("scaleY") : this._getConfig("scaleValue")) || 1) : e;
      }, t.prototype.getScaledFont = function (e) {
        return this ? e * this._getConfig("scaleFont") : e;
      }, t.prototype.getScaledImageVal = function (e, t) {
        return this ? e * ((t ? this._getConfig("scaleImageX") : this._getConfig("scaleImageY")) || 1) : e;
      }, t.prototype.getScaleInfo = function () {
        return this.config.scaleInfo;
      }, t.prototype.draw = function () {
        var e,
            t,
            n = this._getConfig("attr") || {};
        this.updateScale(), this.parseAndSetAttribute(), e = this.getScaledVal(this._getConfig("grpXShift")) + this._getConfig("xShift"), t = this.getScaledVal(this._getConfig("grpYShift")) + this._getConfig("yShift"), n.name = this._getConfig("id"), n.transform = n.transform || "T" + e + "," + t, n.visibility = this.config.isVisible ? r.visibleStr : r.hiddenStr, this.addGraphicalElement({
          el: "group",
          attr: n,
          container: this.config.containerConfiguration,
          component: this._getFromStore("component") || this,
          label: this.config.animationLabel,
          id: this.config.id
        });
      }, t.prototype.dispose = function () {
        var e = this._getFromStore("originalComponent"),
            t = e.retrieveGroup(this.config.id, !0),
            n = void 0,
            r = t.items || [],
            o = void 0;

        for (o = 0; o < r.length; o++) {
          (n = e.retrieveItem(r[o].getId(), !0)) && n.dispose();
        }

        e.removeGraphicalElement(t.config.id), t.items = [];
      }, t;
    }(i["default"]);

    t["default"] = c;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.getEventData = t.getScaledVal = t.parseEquation = t.solveEquation = t.isMacro = t.trim = t.pluckBoolean = t.DEFAULT_MACRO_SEPARATOR = t.DEFAULT_MACRO_PREFIX = t.UNDERSCORE = t.UNDEF = t.xyCalculator = t.axisMacroParser = t.arrangeItems = t.cleanMacro = t.compute3DSliceBounds = t.computeSliceBounds = t.computePlotBounds = t.getQuadrant = t.polarToCartesian = t.deg2Rad = undefined;

    var r = n(125),
        o = undefined,
        i = 2 * Math.PI,
        a = [-i, -3 * i / 4, -i / 2, -i / 4, 0],
        s = [i, 3 * i / 4, i / 2, i / 4, 0],
        l = function l(e) {
      return e * e;
    },
        c = function c(e) {
      return e * (Math.PI / 180);
    },
        u = function u(e, t) {
      var n = !(arguments.length > 2 && arguments[2] !== undefined) || arguments[2],
          r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      return n || (t = c(t)), {
        x: e * Math.cos(t) + (r.x || 0),
        y: e * Math.sin(t) + (r.y || 0)
      };
    },
        d = function d(e, t, n) {
      var r = l(e),
          o = l(t);
      return 0 === e || 0 === t ? 0 : e * t / Math.sqrt(o * l(Math.cos(n)) + r * l(Math.sin(n)));
    },
        f = function f(e) {
      var t,
          n,
          o,
          s,
          l,
          c,
          d = e.ringpath,
          f = [],
          h = [],
          p = void 0,
          g = void 0,
          m = void 0,
          v = Infinity,
          y = Infinity,
          b = -Infinity,
          x = -Infinity;

      for (t = (0, r.pluckNumber)(d[2]), n = (0, r.pluckNumber)(d[3]), o = (0, r.pluckNumber)(d[4]) % i, s = (0, r.pluckNumber)(d[5]) % i, l = (0, r.pluckNumber)(d[0]), c = (0, r.pluckNumber)(d[1]), g = u(t, o, !0, {
        x: l,
        y: c
      }), m = u(t, s, !0, {
        x: l,
        y: c
      }), h.push(g), h.push(m), p = 0; p < a.length; p++) {
        a[p] >= o && a[p] <= s && f.push(p);
      }

      for (p = 0; p < f.length; p++) {
        g = u(t, a[f[p]], !0, {
          x: l,
          y: c
        }), m = u(n, a[f[p]], !0, {
          x: l,
          y: c
        }), h.push(g), h.push(m);
      }

      for (g = u(n, o, !0, {
        x: l,
        y: c
      }), m = u(n, s, !0, {
        x: l,
        y: c
      }), h.push(g), h.push(m), p = 0; p < h.length; p++) {
        b = Math.max(b, h[p].x), v = Math.min(v, h[p].x), x = Math.max(x, h[p].y), y = Math.min(y, h[p].y);
      }

      return {
        x: v,
        y: y,
        width: Math.abs(b - v),
        height: Math.abs(y - x)
      };
    },
        h = function h(e, t, n) {
      var r,
          o = void 0,
          a = void 0;
      return r = Math.tan(n), o = e * t / Math.sqrt(t * t + e * e * r * r), a = e * t / Math.sqrt(e * e + t * t / (r * r)), n > i / 4 && n < 3 * i / 4 ? o *= -1 : o = Math.abs(o), n > i / 2 && n < i ? a *= -1 : a = Math.abs(a), Math.abs(o) <= 1e-5 && (o = 0), Math.abs(a) <= 1e-5 && (a = 0), {
        x: o,
        y: a
      };
    },
        p = function p(e, t) {
      var n = e.config || e,
          o = void 0,
          i = void 0,
          a = void 0,
          s = void 0,
          l = void 0;

      switch (t) {
        case "column3D":
        case "bar2D":
        case "bar3D":
        case "paretoColumn":
        case "waterFall2D":
        case "errorBar2D":
        case "candlestick":
        case "heatMap":
        case "dragColumn":
        case "sparkColumn":
        case "marimekko":
        case "task":
        case "column":
          o = {
            x: (i = n.props.element.attr).x + (0, r.pluckNumber)(i.xDepth, 0),
            y: i.y - (0, r.pluckNumber)(i.yDepth, 0),
            width: i.width,
            height: i.height
          };
          break;

        case "line":
        case "zoomLine":
        case "zoomScatter":
        case "scatter":
        case "spline":
        case "splinearea":
        case "multiaxisline":
        case "stepLine":
        case "errorScatter":
        case "errorLine":
        case "radar":
        case "selectScatter":
        case "dragLine":
        case "dragArea":
        case "kagi":
        case "sparkLine":
        case "area":
          a = e._xPos, s = e._yPos, o = {
            x: a - (l = Number(n.anchorProps.radius) || 0),
            y: s - l,
            width: 2 * l,
            height: 2 * l
          };
          break;

        case "bubble":
          o = {
            x: (i = n.props.element.attr).cx - i.r,
            y: i.cy - i.r,
            width: 2 * i.r,
            height: 2 * i.r
          };
          break;

        case "dragNode":
          i = n.props.element.attr, "rect" === n.shapeType ? o = {
            x: i.x,
            y: i.y,
            width: i.width,
            height: i.height
          } : (a = n._xPos, s = n._yPos, o = {
            x: a - (l = +n.radius || 0),
            y: s - l,
            width: 2 * l,
            height: 2 * l
          });
          break;

        case "boxandwhisker2D":
          o = {
            x: (i = n.props.upperBoxElem.attr).x,
            y: i.y,
            width: i.width,
            height: i.height
          };
          break;

        case "category":
        case "polarCategory":
        case "log":
        case "numeric":
          o = {
            x: (i = n.props.label.attr).x - n.width / 2,
            y: i.y - n.height / 2,
            width: n.width,
            height: n.height
          }, "end" === i["text-anchor"] || "left" === i["text-anchor"] ? o.x = i.x - n.width : "start" !== i["text-anchor"] && "right" !== i["text-anchor"] || (o.x = i.x), "top" === i["vertical-align"] ? o.y = i.y : "bottom" === i["vertical-align"] && (o.y = i.y - n.height);
          break;

        case "multiLevelPie":
          i = n.props.element.attr, o = f(i);
      }

      return o;
    },
        g = function g(e, t) {
      var n = 0;

      switch (e) {
        case "startx":
          n = t.x;
          break;

        case "starty":
          n = t.y;
          break;

        case "x":
        case "middlex":
        case "centerx":
          n = t.x + t.width / 2;
          break;

        case "y":
        case "middley":
        case "centery":
          n = t.y + t.height / 2;
          break;

        case "endx":
          n = t.x + t.width;
          break;

        case "endy":
          n = t.y + t.height;
          break;

        default:
          n = 0;
      }

      return n;
    },
        m = function m(e, t) {
      var n = void 0;

      switch (t.axis) {
        case "x":
        case "toX":
          n = t.scaleX;
          break;

        case "y":
        case "toY":
          n = t.scaleY;
          break;

        default:
          n = t.scaleValue || 1;
      }

      return e * n;
    };

    t.deg2Rad = c, t.polarToCartesian = u, t.getQuadrant = function (e, t, n) {
      return e.x >= t ? e.y <= n ? 0 : 3 : e.y <= n ? 1 : 2;
    }, t.computePlotBounds = p, t.computeSliceBounds = function (e, t) {
      var n,
          r,
          o,
          i,
          a,
          s = t.props.element.attr,
          l = s.ringpath,
          c = void 0;

      switch (n = l[0], r = l[1], o = l[2], i = l[4], a = l[5], e) {
        case "slicex":
        case "slicemiddlex":
        case "slicecenterx":
          c = u(o, (i + a) / 2).x + n;
          break;

        case "slicey":
        case "slicemiddley":
        case "slicecentery":
          c = u(o, (i + a) / 2).y + r;
          break;

        case "slicestartx":
          c = u(o, a).x + n;
          break;

        case "slicestarty":
          c = u(o, a).y + r;
          break;

        case "sliceendx":
          c = u(o, i).x + n;
          break;

        case "sliceendy":
          c = u(o, i).y + r;
          break;

        default:
          c = g(e, f(s));
      }

      return c;
    }, t.compute3DSliceBounds = function (e, t) {
      var n = t.props.element.attr,
          o = n.radiusYFactor,
          a = n.r,
          l = a * o,
          c = n.cx,
          f = n.cy,
          p = n.sAngle,
          m = n.eAngle,
          v = void 0;

      switch (e) {
        case "slicex":
        case "slicemiddlex":
        case "slicecenterx":
          v = h(a, l, (p + m) / 2).x + c;
          break;

        case "slicey":
        case "slicemiddley":
        case "slicecentery":
          v = h(a, l, (p + m) / 2).y + f;
          break;

        case "slicestartx":
          v = h(a, l, p).x + c;
          break;

        case "slicestarty":
          v = h(a, l, p).y + f;
          break;

        case "sliceendx":
          v = h(a, l, m).x + c;
          break;

        case "sliceendy":
          v = h(a, l, m).y + f;
          break;

        default:
          v = g(e, function (e) {
            var t,
                n,
                o,
                a,
                l = void 0,
                c = void 0,
                f = [],
                h = [],
                p = void 0,
                g = void 0,
                m = void 0,
                v = Infinity,
                y = Infinity,
                b = -Infinity,
                x = -Infinity;
            l = (0, r.pluckNumber)(e.r), c = (0, r.pluckNumber)(l * e.radiusYFactor), t = (0, r.pluckNumber)(e.sAngle) % i, n = (0, r.pluckNumber)(e.eAngle) % i, o = (0, r.pluckNumber)(e.cx), a = (0, r.pluckNumber)(e.cy), g = u(d(l, c, t), t, !0, {
              x: o,
              y: a
            }), m = u(d(l, c, n), n, !0, {
              x: o,
              y: a
            }), h.push(g), h.push(m);

            for (var w = 0; w < s.length; w++) {
              s[w] >= t && s[w] <= n && f.push(w);
            }

            for (p = 0; p < f.length; p++) {
              g = u(d(l, c, s[f[p]]), s[f[p]], !0, {
                x: o,
                y: a
              }), h.push(g);
            }

            for (l = (0, r.pluckNumber)(e.innerR, 0), c = (0, r.pluckNumber)(l * e.radiusYFactor, 0), g = u(d(l, c, t), t, !0, {
              x: o,
              y: a
            }), m = u(d(l, c, n), n, !0, {
              x: o,
              y: a
            }), h.push(g), h.push(m), p = 0; p < f.length; p++) {
              g = u(d(l, c, s[f[p]]), s[f[p]], !0, {
                x: o,
                y: a
              }), h.push(g);
            }

            for (var C = 0; C < h.length; C++) {
              b = Math.max(b, h[C].x), v = Math.min(v, h[C].x), x = Math.max(x, h[C].y), y = Math.min(y, h[C].y);
            }

            return {
              x: v,
              y: y,
              width: Math.abs(b - v),
              height: Math.abs(y - x)
            };
          }(n));
      }

      return v;
    }, t.cleanMacro = function (e) {
      var t,
          n = void 0,
          r = "";

      for (n = 0, t = e.length; n < t; n++) {
        " " !== e[n] && (r += e[n]);
      }

      return r;
    }, t.arrangeItems = function () {
      var e,
          t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
          n = [],
          r = [],
          o = void 0;

      for (e = t.length, o = 0; o < e; o++) {
        "text" === t[o].type ? r.push(t[o]) : n.push(t[o]);
      }

      return n.concat(r);
    }, t.axisMacroParser = function (e, t) {
      return function (n) {
        var r,
            o,
            i,
            a = n.split(".").slice(1),
            s = isNaN(Number(a[0])) ? 0 : Number(a[0]),
            l = isNaN(Number(a[0])) ? a[1] : a[2],
            c = isNaN(Number(a[0])) ? a[2] : a[3],
            u = void 0;
        return i = (u = e.getChildren(t)[s]).components, l = Number(l), i.labelIndexArr && (l = i.labelIndexArr[l]), r = i.labels[l].config, o = p(r, u.getName()), g(c, o);
      };
    }, t.xyCalculator = g, t.UNDEF = o, t.UNDERSCORE = "_", t.DEFAULT_MACRO_PREFIX = "$", t.DEFAULT_MACRO_SEPARATOR = ".", t.pluckBoolean = function () {
      for (var e, t = void 0, n = void 0, r = arguments.length, o = Array(r), i = 0; i < r; i++) {
        o[i] = arguments[i];
      }

      for (n = 0, e = o.length; n < e; n++) {
        if (!0 === (t = o[n]) || !1 === t) return t;
      }

      return !1;
    }, t.trim = function (e) {
      return e.replace(/^\s+|\s+$/g, "");
    }, t.isMacro = function (e) {
      return ~e.indexOf("$");
    }, t.solveEquation = function (e) {
      for (var t = +e[0], n = 1, r = e.length, o = void 0, i = void 0; n < r; ++n) {
        if (i = e[n], n % 2) o = i;else switch (o) {
          case "+":
            t += +i;
            break;

          case "-":
            t -= +i;
        }
      }

      return t;
    }, t.parseEquation = function (e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined && arguments[2],
          r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "$",
          o = e.split(/([+])/),
          i = void 0,
          a = [],
          s = void 0,
          l = void 0,
          c = void 0,
          u = o.length;

      for (s = 0; s < u; s++) {
        if ("+" !== o[s]) {
          for (l = 0, c = (i = o[s].split(/([-])/)).length; l < c; l++) {
            "-" !== i[l] && (a.push(i[l]), l < c - 1 && a.push("-"));
          }

          s < u - 1 && a.push("+");
        }
      }

      return a.map(function (e) {
        var o = "",
            i = "",
            a = "",
            s = void 0,
            l = void 0,
            c = void 0;

        if (e.charAt(0) === r) {
          if (a = (i = e.replace(new RegExp("[\\$ ]", "g"), "")).split(".")[0], !isNaN(+i)) return +i;

          for (o in t) {
            if (a === o) {
              if (l = new RegExp(o, "g"), "function" == typeof t[o]) try {
                s = a.replace(l, t[o](i));
              } catch (u) {
                s = a.replace(l, 0);
              } else s = a.replace(l, t[o] || 0);
              break;
            }
          }
        } else c = Number(e), isNaN(c) ? "+" !== e && "-" !== e && (e = 0) : e = n ? m(c, n).toString() : c.toString(), s = e;

        return s;
      });
    }, t.getScaledVal = m, t.getEventData = function (e, t, n) {
      var r = t.getElement(),
          o = n.getFromEnv("getMouseCoordinate")(n.getFromEnv("chart-container"), e, n),
          i = t.getLinkedParent();
      return {
        element: r,
        rawConfig: t.getAttribute(),
        pageX: o.pageX,
        pageY: o.pageY,
        chartX: o.chartX,
        chartY: o.chartY,
        annotationId: t.getId(),
        groupId: i && i.getId(),
        annotationOptions: t.rawConfig,
        groupOptions: i && i.rawConfig
      };
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(138),
        o = n(125),
        i = n(196);

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var s = function (e) {
      function t() {
        var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var r = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this));

        return "string" == typeof n && r.setId(n), r.rawConfig = JSON.parse(JSON.stringify(n)), r.store = {}, r;
      }

      return a(t, e), t.prototype.getType = function () {
        return this._getConfig("type");
      }, t.prototype._setToStore = function (e, t) {
        this.store[e] = t;
      }, t.prototype._getFromStore = function (e) {
        return this.store[e];
      }, t.prototype._setConfig = function (e, t) {
        this.config[e] = t;
      }, t.prototype._getConfig = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        return "" === e ? this.config : this.config[e];
      }, t.prototype.getElement = function () {
        var e = this.config;
        return this.getGraphicalElement(e.id, e.animationLabel);
      }, t.prototype.getBounds = function () {
        return this.getElement().getBBox();
      }, t.prototype.data = function (e, t) {
        if (e && "string" == typeof e) {
          if (t === undefined) return this._data && this._data[e];
          !this._data && (this._data = {}), this._data[e] = t;
        }
      }, t.prototype.parseAndSetAttribute = function () {
        var e = this.rawConfig,
            t = this.getFromEnv("snapPoints"),
            n = (0, o.pluckNumber)(e.autoscale, e.autoScale, 1),
            r = {
          x: (0, o.pluck)(e.x, e.xPos, 0),
          y: (0, o.pluck)(e.y, e.yPos, 0),
          toX: (0, o.pluck)(e.toX),
          toY: (0, o.pluck)(e.toY)
        },
            a = this.config.calculatedAttrs = {},
            s = void 0,
            l = void 0,
            c = this.getScaleInfo();

        for (var u in r) {
          r.hasOwnProperty(u) && void 0 !== (l = r[u]) && (l = l.toString(), c.axis = u, (0, i.isMacro)(l) ? a[u] = (0, i.solveEquation)((0, i.parseEquation)((0, i.cleanMacro)(l.toLowerCase()), t, c)) : (a[u] = (0, i.solveEquation)((0, i.parseEquation)((0, i.cleanMacro)(l.toLowerCase()), t)), n && (a[u] = (0, i.getScaledVal)(a[u], c))));
        }

        "group" !== this.config.elementType && (s = this.getLinkedParent().config.calculatedAttrs, a.x = a.x + (s.x || 0), a.y = a.y + (s.y || 0), isNaN(Number(a.toX)) ? a.toX = a.x : a.toX += s.x || 0, isNaN(Number(a.toY)) || (a.toY += s.y || 0)), this.updateAttr();
      }, t.prototype.getAttribute = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        return "" === e ? this.rawConfig : this.rawConfig[e];
      }, t.prototype.show = function () {
        this.addGraphicalElement({
          el: this.config.elementType,
          attr: {
            visibility: o.hiddenStr
          },
          component: this,
          container: this.config.containerConfiguration,
          id: this.config.id,
          label: this.config.animationLabel
        });
      }, t.prototype.hide = function () {
        this.addGraphicalElement({
          el: this.config.elementType,
          attr: {
            visibility: o.hiddenStr
          },
          component: this,
          container: this.config.containerConfiguration,
          id: this.config.id,
          label: this.config.animationLabel
        });
      }, t.prototype.dispose = function () {
        var e,
            t = this._getFromStore("originalComponent");

        t.retrieveItem(this.config.id, !0) && (e = t.getGraphicalElement(this.config.id)) && t.removeGraphicalElement(e);
      }, t;
    }(r.SmartRenderer);

    t["default"] = s;
  }, function (e, t, n) {
    var r = n(199),
        o = n(202),
        i = r(function (e, t) {
      return o(function (e, t, n) {
        return n;
      }, e, t);
    });
    e.exports = i;
  }, function (e, t, n) {
    var r = n(200),
        o = n(201);

    e.exports = function (e) {
      return function t(n, i) {
        switch (arguments.length) {
          case 0:
            return t;

          case 1:
            return o(n) ? t : r(function (t) {
              return e(n, t);
            });

          default:
            return o(n) && o(i) ? t : o(n) ? r(function (t) {
              return e(t, i);
            }) : o(i) ? r(function (t) {
              return e(n, t);
            }) : e(n, i);
        }
      };
    };
  }, function (e, t, n) {
    var r = n(201);

    e.exports = function (e) {
      return function t(n) {
        return 0 === arguments.length || r(n) ? t : e.apply(this, arguments);
      };
    };
  }, function (e, t) {
    e.exports = function (e) {
      return null != e && "object" == typeof e && !0 === e["@@functional/placeholder"];
    };
  }, function (e, t, n) {
    var r = n(203),
        o = n(204),
        i = n(205),
        a = r(function s(e, t, n) {
      return i(function (t, n, r) {
        return o(n) && o(r) ? s(e, n, r) : e(t, n, r);
      }, t, n);
    });
    e.exports = a;
  }, function (e, t, n) {
    var r = n(200),
        o = n(199),
        i = n(201);

    e.exports = function (e) {
      return function t(n, a, s) {
        switch (arguments.length) {
          case 0:
            return t;

          case 1:
            return i(n) ? t : o(function (t, r) {
              return e(n, t, r);
            });

          case 2:
            return i(n) && i(a) ? t : i(n) ? o(function (t, n) {
              return e(t, a, n);
            }) : i(a) ? o(function (t, r) {
              return e(n, t, r);
            }) : r(function (t) {
              return e(n, a, t);
            });

          default:
            return i(n) && i(a) && i(s) ? t : i(n) && i(a) ? o(function (t, n) {
              return e(t, n, s);
            }) : i(n) && i(s) ? o(function (t, n) {
              return e(t, a, n);
            }) : i(a) && i(s) ? o(function (t, r) {
              return e(n, t, r);
            }) : i(n) ? r(function (t) {
              return e(t, a, s);
            }) : i(a) ? r(function (t) {
              return e(n, t, s);
            }) : i(s) ? r(function (t) {
              return e(n, a, t);
            }) : e(n, a, s);
        }
      };
    };
  }, function (e, t) {
    e.exports = function (e) {
      return "[object Object]" === Object.prototype.toString.call(e);
    };
  }, function (e, t, n) {
    var r = n(203),
        o = n(206),
        i = r(function (e, t, n) {
      var r,
          i = {};

      for (r in t) {
        o(r, t) && (i[r] = o(r, n) ? e(r, t[r], n[r]) : t[r]);
      }

      for (r in n) {
        o(r, n) && !o(r, i) && (i[r] = n[r]);
      }

      return i;
    });
    e.exports = i;
  }, function (e, t) {
    e.exports = function (e, t) {
      return Object.prototype.hasOwnProperty.call(t, e);
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(125),
        i = n(208);

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var s = 180;

    function l(e) {
      return e * (Math.PI / s);
    }

    var c = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return a(t, e), t.prototype.getName = function () {
        return "circle";
      }, t.prototype.configureAttributes = function () {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        e.prototype.configureAttributes.call(this, t);
        var n,
            r = this.rawConfig,
            i = this.getFromEnv("chart"),
            a = +i.getFromEnv("chartHeight"),
            s = +i.getFromEnv("chartWidth"),
            l = a || 700,
            c = s || 350,
            u = Math.max(l, c),
            d = Math.sqrt(u);
        this.config.radius = r.radius, this.config.xRadius = (0, o.pluckNumber)(parseFloat(r.radius), parseFloat(r.xRadius), d), this.config.yRadius = (0, o.pluckNumber)(parseFloat(r.yRadius), this.config.xRadius), this.config.startAngle = (0, o.pluckNumber)(parseFloat(r.startAngle), 0), this.config.endAngle = (0, o.pluckNumber)(parseFloat(r.endAngle), 360), this.config.innerRadius = (0, o.pluckNumber)(parseFloat(r.innerRadius), 0), this.config.innerYRadius = (0, o.pluckNumber)(parseFloat(r.innerYRadius), this.config.innerRadius, 0), "arc" === this.config.type ? this.config.elementType = "ringpath" : 0 !== (n = this.config).startAngle || 360 !== n.endAngle || function (e) {
          return e.innerRadius > 0 || e.innerYRadius > 0;
        }(this.config) ? this.config.elementType = "ringpath" : this.config.elementType = "ellipse";
      }, t.prototype.updateAttr = function () {
        var e = this.config,
            t = e.calculatedAttrs,
            n = void 0,
            r = this.getFromEnv("chart"),
            i = +r.getFromEnv("chartHeight"),
            a = +r.getFromEnv("chartWidth"),
            s = this.getScaledVal(e.xRadius),
            c = this.getScaledVal(e.yRadius),
            u = this.getScaledVal(e.innerRadius),
            d = this.getScaledVal(e.innerYRadius);

        switch ((0, o.pluck)(e.radius) || (e.radius = a < i ? this.getScaledVal(a) : this.getScaledVal(i), e.radius *= .3, u > e.radius && (u += e.radius, e.radius = u - e.radius, u -= e.radius), s = c = e.radius, d = u), e.elementType) {
          case "ringpath":
            n = {
              ringpath: [(0, o.pluckNumber)(t.x, this.getScaledVal(e.x, !0)), (0, o.pluckNumber)(t.y, this.getScaledVal(e.y, !1)), s, u, l(360 - e.endAngle), l(360 - e.startAngle), c, d]
            };
            break;

          default:
            n = {
              cx: (0, o.pluckNumber)(t.x, this.getScaledVal(e.x, !0)),
              cy: (0, o.pluckNumber)(t.y, this.getScaledVal(e.y, !1))
            };
        }

        this._setConfig("attr", n);
      }, t.prototype._getAnnotationAttrs = function () {
        var e = this.config,
            t = this._getConfig("attr") || {},
            n = e.x,
            r = e.y,
            o = this.getScaledVal(e.xRadius),
            i = this.getScaledVal(e.yRadius),
            a = this.getScaledVal(e.innerRadius),
            s = this.getScaledVal(e.innerYRadius),
            c = e.startAngle,
            u = e.endAngle,
            d = e.borderColor,
            f = e.borderThickness,
            h = e.dashArrayStr,
            p = e.color,
            g = void 0;

        switch (e.xRadius || (o = 0), e.yRadius || (i = 0), t.fill = p, t.stroke = d, t["stroke-width"] = f, t["stroke-dasharray"] = h, this.config.elementType) {
          case "ringpath":
            g = [this.getScaledVal(n, !0), this.getScaledVal(r, !1), o, a, l(360 - u), l(360 - c), i, s], t.ringpath = t.ringpath || g;
            break;

          default:
            t.rx = o, t.ry = i, t.cx = "undefined" == typeof t.cx ? this.getScaledVal(n, !0) : t.cx, t.cy = "undefined" == typeof t.cy ? this.getScaledVal(r, !1) : t.cy;
        }

        return t;
      }, t;
    }(((r = i) && r.__esModule ? r : {
      "default": r
    })["default"]);

    t["default"] = c;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = s(n(198)),
        o = s(n(197)),
        i = n(125),
        a = n(196);

    function s(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function l(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var c = function c(e) {
      return void 0 === e ? void 0 : 1;
    },
        u = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return l(t, e), t.prototype.configureAttributes = function (e) {
        var t,
            n,
            o,
            s = this,
            l = s.config,
            u = s.getFromEnv("chart"),
            d = s.getLinkedParent();
        s.groupConfig = {}, s.rawConfig = {}, null !== d && (s.groupConfig.x = d._getConfig("x"), s.groupConfig.y = d._getConfig("y"), s.groupConfig.grpXShift = d._getConfig("grpXShift"), s.groupConfig.grpYShift = d._getConfig("grpYShift"), s.groupConfig.color = d._getConfig("color"), s.groupConfig.alpha = d._getConfig("alpha"), s.groupConfig.font = d._getConfig("font"), s.groupConfig.fontSize = d._getConfig("fontSize"), s.groupConfig.textAlign = d._getConfig("textAlign"), s.groupConfig.textVAlign = d._getConfig("textVAlign"), s.groupConfig.rotateText = d._getConfig("rotateText"), s.groupConfig.wrapText = d._getConfig("wrapText"), s.groupConfig.toolText = d._getConfig("toolText"), s.groupConfig.scaleX = d._getConfig("scaleX"), s.groupConfig.scaleY = d._getConfig("scaleY"), s.groupConfig.scaleImageX = d._getConfig("scaleImageX"), s.groupConfig.scaleImageY = d._getConfig("scaleImageY"), s.groupConfig.link = d._getConfig("link")), o = (0, r["default"])(s.rawConfig, e), s.rawConfig = o, l.type = s.rawConfig.type, l.color = s._getFillColor(s.rawConfig, this.groupConfig), l.link = (0, i.pluck)(s.rawConfig.link, s.groupConfig.link), l.borderThickness = (0, i.pluckNumber)(parseFloat(s.rawConfig.borderThickness), parseFloat(s.rawConfig.thickness), 2), l.showBorder = (0, i.pluckNumber)(s.rawConfig.showBorder, parseFloat(s.rawConfig.borderThickness), parseFloat(s.rawConfig.thickness), c(s.rawConfig.borderColor), c(s.rawConfig.borderAlpha), 0), l.borderColor = s._getBorderColor(s.rawConfig), l.dashed = (0, i.pluckNumber)(s.rawConfig.dashed, 0), l.dashLen = (0, i.pluckNumber)(s.rawConfig.dashLen, 5), l.dashGap = (0, i.pluckNumber)(parseFloat(s.rawConfig.dashGap), 3), l.dashArrayStr = l.dashed ? (0, i.getDashStyle)(l.dashLen, l.dashGap) : "none", l.x = (0, i.pluckNumber)(s.rawConfig.x, s.rawConfig.xPos, 0), l.y = (0, i.pluckNumber)(s.rawConfig.y, s.rawConfig.yPos, 0), l.tox = (0, i.pluckNumber)(s.rawConfig.toX, l.x, 0), l.toy = (0, i.pluckNumber)(s.rawConfig.toY, l.y, 0), l.toy >= 0 && l.y >= 0 && l.toy < l.y && (t = [l.toy, l.y], l.y = t[0], l.toy = t[1]), l.tox >= 0 && l.x >= 0 && l.tox < l.x && (n = [l.tox, l.x], l.x = n[0], l.tox = n[1]), l.showShadow = (0, i.pluckNumber)(s.rawConfig.showShadow, d.config.showShadow, 0), l.toolText = (0, i.getFirstValue)(s.rawConfig.toolText, this.groupConfig.toolText, ""), l.isVisible = (0, a.pluckBoolean)(s.rawConfig.isVisible, !0), l.id = (0, i.pluck)(s.rawConfig.id, s.getId(s.config.elementType)), l.containerConfiguration = {
          id: s.getLinkedParent().config.id,
          label: "group",
          isParent: !0
        }, s._clickHandler = s._clickHandler || function (e) {
          s.config.link && s.getFromEnv("linkClickFN").call({
            link: s.config.link
          }, !0), s.rawConfig.onAnnotationClick instanceof Function ? s.rawConfig.onAnnotationClick() : d.rawConfig.onAnnotationClick instanceof Function ? d.rawConfig.onAnnotationClick() : u.fireChartInstanceEvent("annotationclick", (0, a.getEventData)(e, s, u), void 0, void 0, e);
        }, s._rollOverHandler = s._rollOverHandler || function (e) {
          s.rawConfig.onAnnotationRollover instanceof Function ? s.rawConfig.onAnnotationRollover() : d.rawConfig.onAnnotationRollover instanceof Function ? d.rawConfig.onAnnotationRollover() : u.fireChartInstanceEvent("annotationrollover", (0, a.getEventData)(e, s, u), void 0, void 0, e);
        }, s._rollOutHandler = s._rollOutHandler || function (e) {
          s.rawConfig.onAnnotationRollout instanceof Function ? s.rawConfig.onAnnotationRollout() : d.rawConfig.onAnnotationRollout instanceof Function ? d.rawConfig.onAnnotationRollout() : u.fireChartInstanceEvent("annotationrollout", (0, a.getEventData)(e, s, u), void 0, void 0, e);
        };
      }, t.prototype._getBorderColor = function (e) {
        var t = "none",
            n = {
          color: "",
          alpha: ""
        };
        return "line" !== this.getType() && (n.color = this.config.rawBorderColor = (0, i.pluck)(e.borderColor, e.fillColor && e.fillColor.split(",")[0], e.color && e.color.split(",")[0], "#000000"), 0 === this.config.showBorder ? (n.alpha = 1, this.config.borderThickness = 2) : n.alpha = this.config.rawBorderAlpha = (0, i.pluckNumber)(parseFloat(e.borderAlpha), parseFloat(e.alpha), 100), t = (0, i.toRaphaelColor)(n)), t;
      }, t.prototype._getFillColor = function (e, t) {
        var n = this.getType(),
            r = {
          color: "",
          alpha: "",
          angle: "",
          ratio: "",
          radialGradient: "circle" === n || "arc" === n
        };
        return "line" === n || "image" === n ? (r.color = e.color || t.color || "#FF0000", r.alpha = (0, i.pluckNumber)(parseFloat(e.alpha), t.alpha, 100)) : (r.color = e.fillColor || e.color || t.color || "#FF0000", r.alpha = (0, i.pluck)(e.fillAlpha, parseFloat(e.alpha), t.alpha, 100), r.angle = 360 - (0, i.pluckNumber)(e.fillAngle, 0), r.ratio = (0, i.pluck)(e.fillRatio), e.fillPattern && (r.radialGradient = "radial" === e.fillPattern.toLowerCase() || (0, i.pluckNumber)(e.fillPattern)), r.radialGradient && (r.gradientUnits = "objectBoundingBox", r.cx = .5, r.cy = .5, r.fx = .5, r.fy = .5)), this.config.rawColor = r.color, this.config.rawAlpha = r.alpha, this.config.rawAngle = r.angle, this.config.rawFillPattern = r.radialGradient ? "radial" : "linear", this.config.rawRatio = r.ratio, (0, i.toRaphaelColor)(r);
      }, t.destroySelectionBox = function () {}, t.prototype._applyAttr = function (e) {
        var t,
            n = this.getLinkedParent(),
            r = this.rawConfig.animationLabel,
            o = n.config.animationLabel,
            a = this.config.elementType,
            s = this.config.link,
            l = Object.assign({}, e);
        ("image" !== a || this.config.url) && ((t = this.rawConfig.css || {}).cursor = s ? i.POINTER : "default", this.config.isVisible ? l.visibility = i.visibleStr : l.visibility = i.hiddenStr, this.addEventListener("fc-click", this._clickHandler), this.addEventListener("fc-mouseover", this._rollOverHandler), this.addEventListener("fc-mouseout", this._rollOutHandler), this.config.animationLabel = r || o || a, this.addGraphicalElement({
          el: a,
          attr: l,
          css: t,
          container: this.config.containerConfiguration,
          component: this._getFromStore("component") || this,
          label: this.config.animationLabel,
          id: this.config.id,
          tooltext: this.config.toolText,
          shadow: {
            opacity: 0 !== this.config.showShadow ? 1 : 0,
            useFilter: "path" === a ? 0 : 1
          }
        }));
      }, t.prototype.getScaledVal = function (e, t) {
        var n = this.getLinkedParent();
        return n ? n.getScaledVal(e, t) : e;
      }, t.prototype.getScaledFont = function (e) {
        var t = this.getLinkedParent();
        return t ? t.getScaledFont(e) : e;
      }, t.prototype.getScaledImageVal = function (e, t) {
        var n = this.getLinkedParent();
        return n ? n.getScaledImageVal(e, t) : e;
      }, t.prototype.getScaleInfo = function () {
        return this.getLinkedParent().config.scaleInfo;
      }, t.prototype.draw = function () {
        var e;
        this.parseAndSetAttribute(), e = this._getAnnotationAttrs() || {}, this._applyAttr(e);
      }, t;
    }(o["default"]);

    t["default"] = u;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(125),
        i = n(196),
        a = n(208);

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    function l(e) {
      return e <= "9" && e >= "0" || "-" === e || "." === e ? 0 : e <= "z" && e >= "a" || e <= "Z" && e >= "A" ? 1 : 2;
    }

    var c = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return s(t, e), t.prototype.getName = function () {
        return "path";
      }, t.prototype.configureAttributes = function () {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        e.prototype.configureAttributes.call(this, t);
        var n = this.rawConfig;
        this.config.pathStr = (0, o.pluck)(n.path), this.config.x = (0, o.pluckNumber)(n.x, 0), this.config.y = (0, o.pluckNumber)(n.y, 0), this.config.tox = (0, o.pluckNumber)(n.toX, this.config.x), this.config.toy = (0, o.pluckNumber)(n.toY, this.config.y), this.config.elementType = "path";
      }, t.prototype.getScaledPath = function () {
        var e = this.config.pathStr,
            t = [],
            n = void 0,
            r = void 0,
            o = "",
            a = void 0,
            s = void 0,
            c = void 0;

        for (c = e && e.length, a = 0; a < c; a++) {
          for (s = a, r = "", n = l(e[a]); s < c && l(e[s]) === n;) {
            r += e[s], s++;
          }

          "" !== (r = (0, i.trim)(r)) && n < 2 && t.push(r), a = s === a ? s : s - 1;
        }

        for (c = t.length, a = 0; a < c;) {
          switch (o += t[a], t[a].toLowerCase()) {
            case "m":
            case "l":
            case "t":
              o += this.getScaledVal(Number(t[a + 1]), !0).toString() + ",", o += this.getScaledVal(Number(t[a + 2]), !1).toString(), a += 3;
              break;

            case "s":
            case "q":
              o += this.getScaledVal(Number(t[a + 1]), !0).toString() + ",", o += this.getScaledVal(Number(t[a + 2]), !1).toString() + ",", o += this.getScaledVal(Number(t[a + 3]), !0).toString() + ",", o += this.getScaledVal(Number(t[a + 4]), !1).toString(), a += 5;
              break;

            case "h":
              o += this.getScaledVal(Number(t[a + 1]), !0).toString(), a += 2;
              break;

            case "v":
              o += this.getScaledVal(Number(t[a + 1]), !1).toString(), a += 2;
              break;

            case "c":
              o += this.getScaledVal(Number(t[a + 1]), !0).toString() + ",", o += this.getScaledVal(Number(t[a + 2]), !1).toString() + ",", o += this.getScaledVal(Number(t[a + 3]), !0).toString() + ",", o += this.getScaledVal(Number(t[a + 4]), !1).toString() + ",", o += this.getScaledVal(Number(t[a + 5]), !0).toString() + ",", o += this.getScaledVal(Number(t[a + 6]), !1).toString(), a += 7;
              break;

            case "a":
              o += this.getScaledVal(Number(t[a + 1]), !0).toString() + ",", o += this.getScaledVal(Number(t[a + 2]), !1).toString() + ",", o += this.getScaledVal(Number(t[a + 3]), !0).toString() + ",", o += t[a + 4] + ",", o += t[a + 5] + ",", o += this.getScaledVal(Number(t[a + 6]), !0).toString() + ",", o += this.getScaledVal(Number(t[a + 7]), !1).toString(), a += 8;
              break;

            case "z":
            default:
              a++;
          }
        }

        return o.toString();
      }, t.prototype.updateAttr = function () {
        var e,
            t,
            n,
            r,
            i = this.config,
            a = i.calculatedAttrs,
            s = {};
        e = (0, o.pluckNumber)(a.x, this.getScaledVal(i.x, !0)), t = (0, o.pluckNumber)(a.y, this.getScaledVal(i.y, !1)), n = (0, o.pluckNumber)(a.toX, e, this.getScaledVal(i.tox, !0)), r = (0, o.pluckNumber)(a.toY, t, this.getScaledVal(i.toy, !1)), i.pathStr ? (s.path = this.getScaledPath(), s.transform = "T" + e + "," + t) : s.path = "M" + e + "," + t + "L" + n + "," + r, this._setConfig("attr", s);
      }, t.prototype._getAnnotationAttrs = function () {
        var e,
            t,
            n,
            r,
            o,
            i = this.config,
            a = this._getConfig("attr") || {},
            s = i.borderThickness,
            l = i.dashArrayStr,
            c = i.color;
        return a.stroke = c, this.rawConfig.color && (a.fill = c), a["stroke-width"] = this.getScaledVal(s), a["stroke-dasharray"] = l, e = a.x || this.getScaledVal(i.x, !0), t = a.y || this.getScaledVal(i.y, !1), n = a.toX || this.getScaledVal(i.tox, !0), r = a.toY || this.getScaledVal(i.toy, !1), a.path ? a : ((o = this.getScaledPath()) ? (a.path = o, a.transform = a.transform || "T" + e + "," + t) : a.path = a.path || "M" + e + "," + t + "L" + n + "," + r, a);
      }, t;
    }(((r = a) && r.__esModule ? r : {
      "default": r
    })["default"]);

    t["default"] = c;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(125),
        i = n(208);

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var s = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return a(t, e), t.prototype.getName = function () {
        return "rect";
      }, t.prototype.configureAttributes = function () {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        e.prototype.configureAttributes.call(this, t);
        var n = this.rawConfig;
        this.config.xRadius = (0, o.pluckNumber)(parseFloat(n.radius), 0), this.config.elementType = "rect";
      }, t.prototype.updateAttr = function () {
        var e,
            t,
            n = this.config,
            r = void 0,
            i = void 0,
            a = void 0,
            s = void 0,
            l = n.calculatedAttrs;
        r = (0, o.pluckNumber)(l.x, this.getScaledVal(n.x, !0)), i = (0, o.pluckNumber)(l.y, this.getScaledVal(n.y, !1)), a = (0, o.pluckNumber)(l.toX, this.getScaledVal(n.tox, !0)), (s = (0, o.pluckNumber)(l.toY, this.getScaledVal(n.toy, !1))) >= 0 && i >= 0 && s < i && (i = (e = [s, i])[0], s = e[1]), a >= 0 && r >= 0 && a < r && (r = (t = [a, r])[0], a = t[1]), this._setConfig("attr", {
          x: r,
          y: i,
          width: Math.abs(a - r),
          height: Math.abs(s - i)
        });
      }, t.prototype._getAnnotationAttrs = function () {
        var e = this.config,
            t = this._getConfig("attr") || {},
            n = this.getScaledVal(e.x),
            r = this.getScaledVal(e.y),
            o = e.xRadius,
            i = this.getScaledVal(e.tox),
            a = this.getScaledVal(e.toy),
            s = e.borderColor,
            l = e.borderThickness,
            c = e.dashArrayStr,
            u = e.color;
        return t.x = "undefined" == typeof t.x ? n : t.x, t.y = "undefined" == typeof t.y ? r : t.y, t.width = "undefined" == typeof t.width ? Math.abs(i - n) : t.width, t.height = "undefined" == typeof t.height ? Math.abs(a - r) : t.height, t.r = this.getScaledVal(o), t.fill = u, t.stroke = s, t["stroke-width"] = l, t["stroke-dasharray"] = c, t;
      }, t;
    }(((r = i) && r.__esModule ? r : {
      "default": r
    })["default"]);

    t["default"] = s;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(208),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125);

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var l = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return s(t, e), t.prototype.getName = function () {
        return "polygon";
      }, t.prototype.configureAttributes = function () {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        e.prototype.configureAttributes.call(this, t);
        var n = this.rawConfig;
        this.config.sides = (0, a.pluckNumber)((0, a.clampNumber)(n.sides, 3), 5), this.config.startAngle = (0, a.pluckNumber)(parseFloat(n.startAngle), 0), this.config.xRadius = (0, a.pluckNumber)(parseFloat(n.radius), 0), this.config.elementType = "polypath";
      }, t.prototype.updateAttr = function () {
        var e,
            t = this.config,
            n = t.calculatedAttrs;
        e = [t.sides, (0, a.pluckNumber)(n.x, this.getScaledVal(t.x, !0)), (0, a.pluckNumber)(n.y, this.getScaledVal(t.y, !1)), this.getScaledVal(t.xRadius), t.startAngle, 0], this._setConfig("attr", {
          polypath: e
        });
      }, t.prototype._getAnnotationAttrs = function () {
        var e = this.config,
            t = this._getConfig("attr") || {},
            n = e.sides,
            r = e.x,
            o = e.y,
            i = e.color,
            a = e.startAngle,
            s = e.borderColor,
            l = e.borderThickness,
            c = e.dashArrayStr,
            u = e.xRadius;
        return t.fill = i, t.stroke = s, t["stroke-width"] = l, t["stroke-dasharray"] = c, t.polypath = t.polypath || [n, this.getScaledVal(r, !0), this.getScaledVal(o, !1), this.getScaledVal(u), a, 0], t;
      }, t;
    }(i["default"]);

    t["default"] = l;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(208),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125);

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var l = function l(e) {
      var t = e.height,
          n = e.width,
          r = e.vAlign,
          o = e.align,
          i = e.x,
          a = e.y,
          s = {
        x: i,
        y: a
      };

      switch (o) {
        case "center":
          s.x = i - n / 2;
          break;

        case "right":
          s.x = i - n;
      }

      switch (r) {
        case "middle":
          s.y = a - t / 2;
          break;

        case "bottom":
          s.y = a - t;
      }

      return s;
    },
        c = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this));

        return n._listener = function (e) {
          var t = this.config,
              n = e.originalEvent.target,
              r = n.height,
              o = n.width,
              i = this._getConfig("align"),
              a = this._getConfig("vAlign"),
              s = this._getConfig("xScale"),
              c = r * this._getConfig("yScale"),
              u = o * s,
              d = l({
            x: t.derivedX,
            y: t.derivedY,
            height: c,
            width: u,
            align: i,
            vAlign: a
          });

          t = Object.assign(this.rawConfig, {
            x: d.x,
            y: d.y,
            width: u,
            height: c,
            autoScale: 0
          }), this.setData(t), this.rawConfig.onload && this.rawConfig.onload.call(this, {
            width: u,
            height: c
          }), e.detachHandler();
        }, n;
      }

      return s(t, e), t.prototype.getName = function () {
        return "image";
      }, t.prototype.configureAttributes = function () {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        e.prototype.configureAttributes.call(this, t);
        var n = this.rawConfig,
            r = this.config,
            o = this.groupConfig.scaleX || 1,
            i = this.groupConfig.scaleY || 1;
        r.url = (0, a.getValidValue)(n.url), r.xScale = (0, a.pluckNumber)(n.xScale, 100) / 100, r.yScale = (0, a.pluckNumber)(n.yScale, 100) / 100, r.width = (0, a.pluckNumber)(n.width), r.height = (0, a.pluckNumber)(n.height), r.align = (0, a.pluck)(n.align, "left"), r.vAlign = (0, a.pluck)(n.vAlign, "top"), r.xScale = r.xScale * o, r.yScale = r.yScale * i, r.elementType = "image", "undefined" == typeof r.width && "undefined" == typeof r.height && this.addEventListener("load", this._listener);
      }, t.prototype.updateAttr = function () {
        var e = this.config,
            t = e.calculatedAttrs;

        this._setConfig("attr", {
          x: (0, a.pluckNumber)(t.x, this.getScaledVal(e.x, !0)),
          y: (0, a.pluckNumber)(t.y, this.getScaledVal(e.y, !1))
        });
      }, t.prototype._getAnnotationAttrs = function () {
        var e = this.config,
            t = (0, a.pluckNumber)(this.rawConfig.autoscale, this.rawConfig.autoScale, 1),
            n = e.attr,
            r = e.url,
            o = (0, a.pluckNumber)(e.attr.x, e.x),
            i = (0, a.pluckNumber)(e.attr.y, e.y);
        return t || (n = {
          x: o,
          y: i
        }), e.derivedX = n.x = "undefined" == typeof n.x ? this.getScaledVal(o, !0) : n.x, e.derivedY = n.y = "undefined" == typeof n.y ? this.getScaledVal(i, !1) : n.y, n.src = r, n.opacity = (0, a.pluckNumber)(e.rawAlpha, 100) / 100, "undefined" != typeof e.width && (n.width = e.width), "undefined" != typeof e.height && (n.height = e.height), n;
      }, t;
    }(i["default"]);

    t["default"] = c;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(208),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125);

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var l = {
      left: "start",
      right: "end",
      center: "middle"
    },
        c = {
      top: "bottom",
      middle: "middle",
      bottom: "top"
    },
        u = {
      0: "0",
      1: "270",
      right: "90",
      cw: "90",
      left: "270",
      ccw: "270"
    };

    var d = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return s(t, e), t.prototype.getName = function () {
        return "text";
      }, t.prototype.configureAttributes = function () {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        e.prototype.configureAttributes.call(this, t);
        var n,
            r = this.rawConfig,
            o = this.groupConfig;
        this.config.text = (0, a.parseUnsafeString)((0, a.pluck)(r.text, r.label, "")), this.config.font = (0, a.pluck)(r.font, o.font, "Verdana, sans"), this.config.fontSize = (0, a.pluckFontSize)(r.fontSize, o.fontSize, 10), this.config.align = (0, a.pluck)(l[r.align && r.align.toLowerCase()], l[o.textAlign && o.textAlign.toLowerCase()], "middle"), this.config.vAlign = (0, a.pluck)(c[r.vAlign && r.vAlign.toLowerCase()], c[o.textVAlign && o.textVAlign.toLowerCase()], "middle"), this.config.radius = (0, a.pluckNumber)(parseFloat(r.radius), 0), this.config.fontWeight = (0, a.pluckNumber)(r.bold, 0) ? "bold" : "normal", this.config.fontStyle = (0, a.pluckNumber)(r.italic, 0) ? "italic" : "normal", this.config.bgColor = (n = r.bgColor, (/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(n) ? n : /(^[0-9A-F]{6}$)|(^[0-9A-F]{3}$)/i.test(n)) ? r.bgColor : "none"), this.config.borderThickness = (0, a.pluckNumber)(parseFloat(this.rawConfig.borderThickness), parseFloat(this.rawConfig.thickness), 1), this.config.rotateText = (0, a.pluck)(r.rotateText, o.rotateText, "0"), this.config.rotateAngle = u[this.config.rotateText && this.config.rotateText.toLowerCase()], this.config.wrap = (0, a.pluckNumber)(r.wrap, o.wrapText, r.wrapHeight, r.wrapWidth, 1), this.config.wrap && (this.config.wrapWidth = (0, a.pluckNumber)(r.wrapWidth), this.config.wrapHeight = (0, a.pluckNumber)(r.wrapHeight)), this.config.leftMargin = (0, a.pluckNumber)(r.leftMargin, 0), this.config.elementType = "text";
      }, t.prototype.getText = function () {
        var e = this.config,
            t = this.getFromEnv("smartLabel"),
            n = e.wrap,
            r = this.getLinkedParent(),
            o = r && r._getConfig("scaleText"),
            i = o ? this.getScaledVal(e.wrapWidth, !0) : e.wrapWidth,
            s = o ? this.getScaledVal(e.wrapHeight, !1) : e.wrapHeight,
            l = {
          fontStyle: e.fontStyle,
          fontFamily: e.font,
          fontWeight: e.fontWeight,
          fontSize: e.fontSize + "px",
          "text-anchor": e.align,
          "vertical-align": e.vAlign
        };

        return (0, a.setLineHeight)(l), t && t.setStyle(l), t && n ? t.getSmartText(e.text, i, s, 0).text : e.text;
      }, t.prototype._getFillColor = function (e, t) {
        var n = this.getType(),
            r = {
          color: "",
          alpha: "",
          angle: "",
          ratio: "",
          radialGradient: "circle" === n || "arc" === n
        };
        return r.color = e.fontColor || e.fillColor || e.color || t.color || "#FF0000", r.alpha = (0, a.pluck)(e.fillAlpha, parseFloat(e.alpha), t.alpha, 100), r.angle = 360 - (0, a.pluckNumber)(e.fillAngle, 0), r.ratio = (0, a.pluck)(e.fillRatio), e.fillPattern && (r.radialGradient = "radial" === e.fillPattern || (0, a.pluckNumber)(e.fillPattern)), r.radialGradient && (r.gradientUnits = "objectBoundingBox", r.cx = .5, r.cy = .5, r.fx = .5, r.fy = .5), this.config.rawColor = r.color, this.config.rawAlpha = r.alpha, this.config.rawAngle = r.angle, this.config.rawFillPattern = r.radialGradient ? "radial" : "linear", this.config.rawRatio = r.ratio, (0, a.toRaphaelColor)(r);
      }, t.prototype.updateAttr = function () {
        var e = this.config,
            t = e.calculatedAttrs,
            n = (0, a.pluckNumber)(t.x, this.getScaledVal(e.x, !0)),
            r = (0, a.pluckNumber)(t.y, this.getScaledVal(e.y, !0)),
            o = void 0;
        "0" !== e.rotateText && (o = (0, a.getSuggestiveRotation)(parseFloat(e.rotateAngle), n, r)), this._setConfig("attr", {
          x: n,
          y: r,
          transform: o
        });
      }, t.prototype._getAnnotationAttrs = function () {
        var e,
            t,
            n = this.config,
            r = this._getConfig("attr") || {},
            o = this.getText(),
            i = this.getScaledVal(n.x, !0),
            s = this.getScaledVal(n.y, !1);
        return r.x = ("undefined" == typeof r.x ? i : r.x) + n.leftMargin / 2, r.y = "undefined" == typeof r.y ? s : r.y, r.text = o, r.fill = n.color, e = this.rawConfig.borderColor, t = this.rawConfig.borderAlpha, r["text-bound"] = e && "none" !== e && 0 !== t ? [(0, a.toRaphaelColor)(n.bgColor), n.borderColor, n.borderThickness, 2, n.radius, n.dashArrayStr] : [], r["font-style"] = n.fontStyle, r["font-weight"] = n.fontWeight, r["font-family"] = n.font, r["font-size"] = this.getScaledFont(n.fontSize), r["text-anchor"] = n.align, r["vertical-align"] = n.vAlign, "0" !== n.rotateText && (r.transform = r.transform || (0, a.getSuggestiveRotation)(parseFloat(n.rotateAngle), i, s)), r;
      }, t;
    }(i["default"]);

    t["default"] = d;
  }, function (e, t, n) {
    var r = n(199)(function (e, t) {
      var n = {};

      for (var r in t) {
        e(t[r], r, t) && (n[r] = t[r]);
      }

      return n;
    });
    e.exports = r;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = function r() {
      return [{
        initialAttr: {
          opacity: 0
        },
        finalAttr: {
          opacity: 1
        },
        slot: "initial"
      }];
    };

    t["default"] = {
      "initial.extension.annotation": function initialExtensionAnnotation() {
        return {
          "polypath.appearing": r,
          "text.appearing": r,
          "image.appearing": r,
          "ellipse.appearing": r,
          "ringpath.appearing": r,
          "path.appearing": r,
          "rect.appearing": r,
          "*": null
        };
      }
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function (e) {
      var t = Math,
          n = t.cos,
          r = t.sin,
          o = t.abs,
          i = t.pow,
          a = t.PI,
          s = 2 * a,
          l = "M",
          c = "A",
          u = i(2, -24);
      e.define && e.define([{
        name: "ringpath",
        ringpath: function ringpath() {
          return this.path(void 0, e._lastArgIfGroup(arguments));
        },
        ca: function ca(e, t, i, d, f, h, p, g) {
          var m,
              v,
              y,
              b,
              x,
              w,
              C,
              _,
              S,
              E,
              k,
              A,
              T,
              M,
              O = h % s - f % s,
              F = h - f;

          return isNaN(p) && (p = i), isNaN(g) && (g = d), this._.ringangle = .5 * (f + h), o(F) < u ? (m = n(f), v = r(f), w = [l, e + i * m, t + p * v, "L", e + d * m, t + g * v, "Z"]) : o(F) > u && +(o(F) % s < u || s - o(F) % s < u) ? (w = [l, e - i, t, c, i, p, 0, 0, 0, e + i, t, c, i, p, 0, 0, 0, e - i, t], 0 === d && 0 === g || (w = w.concat([l, e - d, t, c, d, g, 0, 0, 1, e + d, t, c, d, g, 0, 0, 1, e - d, t])), w.push("Z")) : (m = n(f), v = r(f), y = n(h), b = r(h), (O %= s) < 0 && (O += s), x = O < a ? 0 : 1, k = t + p * v, A = t + p * b, S = e + d * y, T = t + g * b, o((C = e + i * m) - (_ = e + i * y)) < .01 && o(k - A) < .01 && (C = e + i * n(f + .0001745329), k = t + p * r(f + .0001745329)), w = [l, C, k, c, i, p, 0, x, 1, _, A, "L", S, T], 0 === d && 0 === g || (M = t + g * v, o(S - (E = e + d * m)) < .01 && o(T - M) < .01 && (E = e + d * n(f + .0001745329), M = t + g * r(f + .0001745329)), w.push(c, d, g, 0, x, 0, E, M)), w.push("Z")), {
            path: w
          };
        }
      }]);
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function (e) {
      e.define && e.define([{
        name: "arcpath",
        arcpath: function arcpath() {
          return this.path(void 0, e._lastArgIfGroup(arguments));
        },
        ca: function ca(e, t, n, r) {
          var o = r,
              i = o - 90,
              a = Math.PI * (i / 180),
              s = e + n * Math.cos(a),
              l = t + n * Math.sin(a);
          return {
            path: ["M", e, t - n, "A", n, n, 0, o > 180 ? 1 : 0, 1, s, l]
          };
        }
      }]);
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(219),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125),
        s = n(222);
    t["default"] = {
      extension: function extension(e) {
        e.addEventListener("instantiated", function (e) {
          var t = e.sender;
          (0, s.isValidDataset)(t) && t.registerFactory("regression", function (e) {
            var t = e.getFromEnv("chart").getFromEnv("dataSource").chart,
                n = e.config.JSONData;
            (0, a.componentFactory)(e, i["default"], "regression", Number((0, s.hasRegressionLine)(t, n)), [e]);
          });
        });
      },
      name: "Regression",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(138),
        o = u(n(220)),
        i = u(n(221)),
        a = n(125),
        s = n(222),
        l = n(132),
        c = u(n(223));

    function u(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function d(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    (0, l.addDep)({
      name: "regressionLineAnimation",
      type: "animationRule",
      extension: c["default"]
    });

    var f = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this));

        return n._config = {
          regressionPoints: []
        }, n.regressionLine = [], n;
      }

      return d(t, e), t.prototype.getType = function () {
        return "extension";
      }, t.prototype.getName = function () {
        return "regression";
      }, t.prototype.configureAttributes = function (e) {
        var t = this.getFromEnv("dataSource").chart,
            n = e.config,
            r = n.JSONData,
            l = this._config;
        l.regressionPoints.splice(0, l.regressionPoints.length), l.showYOnX = (0, a.pluckNumber)(r.showyonx, t.showyonx, 1), l.regressionLineColor = (0, a.toRaphaelColor)((0, a.pluck)(r.regressionlinecolor, t.regressionlinecolor, n.anchorbordercolor, n.lineColor, n.anchorBgColor, "fff000")), l.polynomialRegressionLineColor = (0, a.toRaphaelColor)((0, a.pluck)(r.polynomialregressionlinecolor, t.polynomialregressionlinecolor, l.regressionLineColor)), l.regressionLineThickness = (0, a.pluckNumber)(r.regressionlinethickness, t.regressionlinethickness, r.anchorborderthickness, 1), l.polynomialRegressionLineThickness = (0, a.pluckNumber)(r.polynomialregressionlinethickness, t.polynomialregressionlinethickness, l.regressionLineThickness), l.regressionLineAlpha = (0, a.pluckNumber)(r.regressionlinealpha, t.regressionlinealpha, 100), l.polynomialRegressionLineAlpha = (0, a.pluckNumber)(r.polynomialregressionlinealpha, t.polynomialregressionlinealpha, l.regressionLineAlpha), (0, s.createLinear)(t, r) && l.regressionPoints.push((0, o["default"])(r.data, l.showYOnX)), (0, s.createPolynomial)(t, r) && l.regressionPoints.push((0, i["default"])(r.data, l.showYOnX));
      }, t.prototype.draw = function () {
        var e,
            t,
            n = this._config,
            r = this.getFromEnv("xAxis"),
            o = this.getFromEnv("yAxis"),
            i = this.getFromEnv("chart"),
            s = i.getChildren("canvas")[0].config,
            l = this.getLinkedParent().getState("visible"),
            c = this.getContainer("regressionlinecontainer"),
            u = i.getChildContainer("abovePlotGroup"),
            d = this.getFromEnv("animationManager"),
            f = n.regressionPoints,
            h = [],
            p = [],
            g = void 0,
            m = this.getGraphicalElement("regressionLineLinear"),
            v = this.getGraphicalElement("regressionLinePolynomial"),
            y = void 0,
            b = void 0,
            x = void 0,
            w = void 0,
            C = function C() {
          this.hide();
        };

        !l && (w = "disappearing"), c = this.addContainer("regressionlinecontainer", d.setAnimation({
          el: c || "group",
          attr: {
            name: "regressionlinecontainer",
            "clip-rect": [s.canvasLeft, s.canvasTop, s.canvasWidth, s.canvasHeight]
          },
          container: u,
          component: this,
          label: "group"
        }));

        for (var _ = 0; _ < f.length; _++) {
          var S = "";
          if (h = f[_][0], g = (p = f[_][1]).length, 0 === h.length && 0 === p.length) y = !0, S += "M0,0";else if (0 !== h.length && 0 === p.length) y = !1, S += "M0,0";else if (0 === h.length) y = !0, S += "M" + r.getPixel(p[0].x) + "," + o.getPixel(p[0].y), S += "L" + r.getPixel(p[g - 1].x) + "," + o.getPixel(p[g - 1].y);else {
            y = !1, S += "M" + r.getPixel(p[0].x) + "," + o.getPixel(p[0].y), S += " R" + r.getPixel(p[1].x) + "," + o.getPixel(p[1].y);

            for (var E = 2; E < g; E++) {
              S += " " + r.getPixel(p[E].x) + "," + o.getPixel(p[E].y);
            }
          }
          y ? b = {
            opacity: Number(n.regressionLineAlpha) / 100,
            stroke: n.regressionLineColor,
            "stroke-width": n.regressionLineThickness,
            path: S
          } : x = {
            opacity: Number((0, a.pluck)(n.polynomialRegressionLineAlpha, n.regressionLineAlpha)) / 100,
            stroke: (0, a.pluck)(n.polynomialRegressionLineColor, n.regressionLineColor),
            "stroke-width": (0, a.pluck)(n.polynomialRegressionLineThickness, n.regressionLineThickness),
            path: S
          };
        }

        "disappearing" !== w && (m && m.show(), v && v.show()), e = d.setAnimation({
          el: m || "path",
          container: c,
          component: this,
          doNotRemove: !0,
          attr: !("disappearing" === w) && b,
          callback: "disappearing" === w && C,
          label: "path"
        }), m || this.addGraphicalElement("regressionLineLinear", e), t = d.setAnimation({
          el: v || "path",
          container: c,
          component: this,
          doNotRemove: !0,
          attr: !("disappearing" === w) && x,
          callback: "disappearing" === w && C,
          label: "path"
        }), v || this.addGraphicalElement("regressionLinePolynomial", t);
      }, t;
    }(r.ComponentInterface);

    t["default"] = f;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function (e, t) {
      return Number(t) ? function (e) {
        e.sort(function (e, t) {
          return parseFloat(e.x) - parseFloat(t.x);
        });

        for (var t = [], n = [], r = 0, o = 0, i = 0, a = 0, s = e.length, l = void 0, c = void 0, u = [], d = void 0, f = void 0, h = 0; h < e.length; h++) {
          d = Number(e[h].x), f = Number(e[h].y), isNaN(d) || isNaN(f) || (t.push(d), n.push(f));
        }

        s = t.length;

        for (var p = 0; p < s; p++) {
          r += t[p], o += n[p];
        }

        r /= s, o /= s;

        for (var g = 0; g < s; g++) {
          i += (t[g] - r) * (n[g] - o), a += (t[g] - r) * (t[g] - r);
        }

        if (0 === a) return [[], []];
        return c = o - (l = i / a) * r, u.push({
          x: t[0],
          y: l * t[0] + c
        }), u.push({
          x: t[s - 1],
          y: l * t[s - 1] + c
        }), [[], u];
      }(e) : function (e) {
        e.sort(function (e, t) {
          return parseFloat(e.y) - parseFloat(t.y);
        });

        for (var t = [], n = [], r = 0, o = 0, i = 0, a = 0, s = e.length, l = void 0, c = void 0, u = [], d = void 0, f = void 0, h = 0; h < e.length; h++) {
          d = Number(e[h].x), f = Number(e[h].y), isNaN(d) || isNaN(f) || (t.push(d), n.push(f));
        }

        s = t.length;

        for (var p = 0; p < s; p++) {
          r += t[p], o += n[p];
        }

        r /= s, o /= s;

        for (var g = 0; g < s; g++) {
          i += (t[g] - r) * (n[g] - o), a += (n[g] - o) * (n[g] - o);
        }

        if (0 === a) return [[], []];
        return c = r - (l = i / a) * o, (u = []).push({
          x: l * n[0] + c,
          y: n[0]
        }), u.push({
          x: l * n[s - 1] + c,
          y: n[s - 1]
        }), [[], u];
      }(e);
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function (e, t) {
      return Number(t) ? function (e) {
        e.sort(function (e, t) {
          return parseFloat(e.x) - parseFloat(t.x);
        });

        for (var t = [], n = [], r = 0, o = 0, i = e.length, a = 0, s = 0, l = 0, c = 0, u = 0, d = void 0, f = void 0, h = void 0, p = void 0, g = void 0, m = void 0, v = void 0, y = void 0, b = void 0, x = void 0, w = [], C = 0; C < e.length; C++) {
          b = Number(e[C].x), x = Number(e[C].y), isNaN(b) || isNaN(x) || (t.push(b), n.push(x));
        }

        i = t.length;

        for (var _ = 0; _ < i; _++) {
          r += n[_], o += t[_] * n[_], u += t[_] * t[_] * n[_], a += t[_], s += t[_] * t[_], c += t[_] * t[_] * t[_], l += t[_] * t[_] * t[_] * t[_];
        }

        if (f = o - a * r / i, p = u - s * r / i, (d = s - a * a / i) * (g = l - s * s / i) - (h = c - s * a / i) * h == 0 || 0 === i) return [e, []];
        y = r / i - (v = (f * g - p * h) / (d * g - h * h)) * (a / i) - (m = (p * d - f * h) / (d * g - h * h)) * (s / i);

        for (var S = 0; S < i; S++) {
          w.push({
            x: t[S],
            y: m * t[S] * t[S] + v * t[S] + y
          });
        }

        return [e, w];
      }(e) : function (e) {
        e.sort(function (e, t) {
          return parseFloat(e.x) - parseFloat(t.x);
        });

        for (var t = [], n = [], r = 0, o = 0, i = e.length, a = 0, s = 0, l = 0, c = 0, u = 0, d = void 0, f = void 0, h = void 0, p = void 0, g = void 0, m = void 0, v = void 0, y = void 0, b = void 0, x = void 0, w = [], C = 0; C < e.length; C++) {
          b = Number(e[C].x), x = Number(e[C].y), isNaN(b) || isNaN(x) || (t.push(b), n.push(x));
        }

        i = t.length;

        for (var _ = 0; _ < i; _++) {
          r += t[_], o += n[_] * t[_], u += n[_] * n[_] * t[_], a += n[_], s += n[_] * n[_], c += n[_] * n[_] * n[_], l += n[_] * n[_] * n[_] * n[_];
        }

        if (f = o - a * r / i, p = u - s * r / i, (d = s - a * a / i) * (g = l - s * s / i) - (h = c - s * a / i) * h == 0 || 0 === i) return [e, []];
        y = r / i - (v = (f * g - p * h) / (d * g - h * h)) * (a / i) - (m = (p * d - f * h) / (d * g - h * h)) * (s / i);

        for (var S = 0; S < i; S++) {
          w.push({
            x: m * n[S] * n[S] + v * n[S] + y,
            y: n[S]
          });
        }

        return [e, w];
      }(e);
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = ["scatter", "bubble", "errorScatter", "selectScatter"];
    t.createPolynomial = function (e, t) {
      var n = Number(e.showpolynomialregressionline) || 0;
      return isNaN(t.showpolynomialregressionline) && n || Number(t.showpolynomialregressionline);
    }, t.createLinear = function (e, t) {
      var n = Number(e.showregressionline) || 0;
      return isNaN(t.showregressionline) && n || Number(t.showregressionline);
    }, t.isInArray = function (e, t) {
      return e = e.toLowerCase(), t.indexOf(e) > -1;
    }, t.hasRegressionLine = function (e, t) {
      return t.showregressionline || e.showregressionline || t.showpolynomialregressionline || e.showpolynomialregressionline;
    }, t.isValidDataset = function (e) {
      return function (e) {
        return "dataset" === e.getType();
      }(e) && r.indexOf(e.getName()) >= 0;
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = {
      "initial.extension.regression": function initialExtensionRegression() {
        var e = this;
        return {
          "path.appearing": null,
          "path.updating": null,
          "path.disappearing": null,
          "group.appearing": function groupAppearing() {
            var t,
                n = e.getFromEnv("chart").getChildren("canvas")[0],
                r = 0,
                o = [],
                i = [];

            for (o.push(n.config.canvasLeft), o.push(n.config.canvasTop), o.push(0), o.push(n.config.canvasHeight), t = o.length; r < t;) {
              i.push(o[r]), r++;
            }

            return i[2] = n.config.canvasWidth, [{
              initialAttr: function initialAttr() {
                return {
                  "clip-rect": o
                };
              },
              finalAttr: function finalAttr() {
                return {
                  "clip-rect": i
                };
              },
              effect: "linear",
              slot: "plot"
            }];
          },
          "*": null
        };
      }
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(125),
        o = m(n(225)),
        i = m(n(226)),
        a = m(n(243)),
        s = m(n(244)),
        l = m(n(245)),
        c = m(n(246)),
        u = m(n(247)),
        d = m(n(248)),
        f = m(n(249)),
        h = m(n(250)),
        p = n(132),
        g = m(n(251));

    function m(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var v = {
      DragZoomIn: i["default"],
      ZoomResetButton: a["default"],
      ZoomOutButton: s["default"],
      DbTapZoom: c["default"],
      DragPin: u["default"],
      ZoomInButton: l["default"],
      DragPan: d["default"],
      PinchZoom: f["default"],
      SwipeGesture: h["default"]
    };
    t["default"] = {
      extension: function extension(e) {
        var t,
            n,
            i = (0, p.getDep)("redraphael", "plugin");
        (0, g["default"])(i), e.addEventListener("instantiated", function (e) {
          var i = e.sender,
              a = void 0;
          "canvas" === i.getType() && i.registerFactory("inputManager", function (e) {
            if (n = e.getFromEnv("chart"), t = n.constructor.includeInputOptions && n.constructor.includeInputOptions()) {
              (0, r.componentFactory)(e, o["default"], "inputManager", 1, [{}]), a = e.getChildren("inputManager")[0];

              for (var i = 0, s = t && t.length; i < s; i++) {
                (0, r.componentFactory)(a, v[t[i]], t[i], 1, [{}]);
              }
            }
          });
        });
      },
      name: "inputAdapter",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    t.__esModule = !0;

    var o = function o(e, t, n, r) {
      var o, i;
      (i = r[e]) && (i.some(function (e, r) {
        if (e.callback === t && e.component === n) return o = r, !0;
      }), o !== undefined && i.splice(o, 1));
    },
        i = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return r(t, e), t.prototype.configure = function () {
        var e = this.getFromEnv("chart"),
            t = e.getInputConfigurations;
        this.addToEnv("canvas", this.getLinkedParent()), this.addToEnv("inputOptions", t && t.call(e)), this.config = {
          controlObj: {},
          dependancyObj: {}
        };
      }, t.prototype.addEventToChild = function () {
        var e = this,
            t = e.getChildren(),
            n = ["zoomin", "zoomout", "dragzoomenabled", "dragzoomdisabled", "pinenabled", "pindisabled", "panenabled", "pandisabled"],
            r = function r(_r3) {
          n.forEach(function (n) {
            e.addExtEventListener(n, e.manageEvents.bind(e), t[_r3][0]);
          });
        };

        for (var o in t) {
          r(o);
        }
      }, t.prototype.manageEvents = function (e) {
        var t = this.config.dependancyObj,
            n = e.type;
        t[n] && t[n].forEach(function (t) {
          t.component !== e.sender && t.callback.call(t.component, e);
        });
      }, t.prototype.fetchZoomableAxes = function () {
        if (!this.config.axesObArr) {
          var e = this.config.axesObArr = [];
          this.getLinkedParent().getAxes().forEach(function (t) {
            (t.config.zoomable || t.config.pannable) && e.push({
              axis: t.axis,
              stack: [],
              isY: t.isY
            });
          }), this.addToEnv("axesObArr", e);
        }
      }, t.prototype.draw = function () {
        this.fetchZoomableAxes(), this.addEventToChild();
      }, t.prototype.getControl = function (e, t) {
        var n,
            r = this.config.controlObj,
            o = this.getLinkedParent();
        t || e.forEach(function (e) {
          (n = e.nativeInteraction) instanceof Array ? n.forEach(function (t) {
            (r[t] || (r[t] = [])).push({
              callback: e.callback,
              component: e.component
            }), e.component.addExtEventListener(t, e.callback, o);
          }) : ((r[n] || (r[n] = [])).push({
            callback: e.callback,
            component: e.component
          }), e.component.addExtEventListener(n, e.callback, o));
        });
      }, t.prototype.releaseControl = function (e) {
        var t,
            n = this,
            r = n.getLinkedParent();
        e.forEach(function (e) {
          (t = e.nativeInteraction) instanceof Array ? t.forEach(function (t) {
            e.component.removeExtEventListener(t, e.callback, r), o(t, e.callback, e.component, n.config.controlObj);
          }) : (e.component.removeExtEventListener(t, e.callback, r), o(t, e.callback, e.component, n.config.controlObj));
        });
      }, t.prototype._updateControlObj = function (e, t) {
        var n, r;
        (r = this.config.controlObj[e]) && (r.some(function (e, r) {
          if (e.callback === t) return n = r, !0;
        }), n !== undefined && r.splice(n, 1));
      }, t.prototype.registerDependancy = function (e) {
        var t,
            n = this.config.dependancyObj;
        e.forEach(function (e) {
          (t = e.derivedInteraction) instanceof Array ? t.forEach(function (t) {
            (n[t] || (n[t] = [])).push({
              callback: e.callback,
              component: e.component,
              derivedInteraction: t
            });
          }) : (n[t] || (n[t] = [])).push(e);
        });
      }, t.prototype.removeDependancy = function (e) {
        var t,
            n = this;
        e.forEach(function (e) {
          (t = e.derivedInteraction) instanceof Array ? t.forEach(function (t) {
            o(t, e.callback, e.component, n.config.dependancyObj);
          }) : o(t, e.callback, e.component, n.config.dependancyObj);
        });
      }, t.prototype.zoomOut = function () {
        var e = this.getChildren("ZoomOutButton");
        e && e[0].zoomOut();
      }, t.prototype.zoomTo = function (e, t) {
        var n = this.getChildren("DragZoomIn");
        n && n[0].zoomTo(e, t);
      }, t.prototype.resetChart = function () {
        var e = this.getChildren("ZoomResetButton");
        e && e[0].zoomOut();
      }, t.prototype.setZoomMode = function (e) {
        var t = this.getChildren("DragPin");
        t && (e ? t[0].disable() : t[0].enable());
      }, t;
    }(n(138).ComponentInterface);

    t["default"] = i;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(227),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125);

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var l = Math.min,
        c = Math.abs,
        u = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this)),
            r = n;

        return r.controlArr = [{
          nativeInteraction: ["fc-dragstart"],
          callback: r.dragStart.bind(r),
          component: r
        }, {
          nativeInteraction: ["fc-dragmove"],
          callback: r.onDrag.bind(r),
          component: r
        }, {
          nativeInteraction: ["fc-dragend"],
          callback: r.onDragEnd.bind(r),
          component: r
        }], a.isFirefox && r.controlArr.push({
          nativeInteraction: ["fc-mousedown"],
          callback: t.mousedown,
          component: r
        }), r._toggle = function () {
          r._checkStackLen() && r.toggle();
        }, n;
      }

      return s(t, e), t.prototype.getName = function () {
        return "dragZoomIn";
      }, t.prototype.configure = function () {
        e.prototype.configure.call(this);
        var t = this.getLinkedParent(),
            n = this.config;
        n.boxStyle = n.boxStyle || {
          "stroke-width": 1,
          stroke: "red",
          fill: "#00FF00",
          opacity: .2,
          cursor: "ne-resize"
        }, !this.config.skipGraphics && this.setLinkedItem("button", this.createButton({
          icon: "zoomModeIcon",
          tooltext: this.config.tooltext,
          handlers: {
            click: this._toggle
          },
          state: "activated"
        })), this.enable("pressed"), t.registerDependancy([{
          derivedInteraction: ["pinenabled", "pindisabled", "panenabled", "pandisabled"],
          callback: this.dependancyFn,
          component: this
        }]);
      }, t.mousedown = function (e) {
        e && e.preventDefault();
      }, t.prototype.setControl = function () {
        var e = this.getLinkedParent(),
            t = this.getLinkedItem("button"),
            n = this.controlArr;
        e.releaseControl(n), this.isEnabled() && e.getControl(n), t && t.setCurrentState(this.isEnabled() ? this.config.state : "disabled");
      }, t.prototype.getCoordinates = function (e) {
        var t = this.getFromEnv("chart"),
            n = (0, a.getMouseCoordinate)(t.getFromEnv("chart-container"), e, t);
        return {
          x: n.chartX,
          y: n.chartY
        };
      }, t.prototype.inCanvasLimit = function (e) {
        var t = this.getFromEnv("canvas").getGraphicalElement("canvasElement").attrs,
            n = t.x,
            r = t.y,
            o = e.x - t.x,
            i = e.y - t.y,
            a = t.width - o,
            s = t.height - i;
        return e.x > n && e.y > r && e.width < a && e.height < s;
      }, t.prototype.drawBox = function () {
        var e,
            t = this.config,
            n = this.getGraphicalElement("box"),
            r = this.getFromEnv("paper"),
            o = this.getFromEnv("canvas").getGraphicalElement("canvasElement").attrs;
        n || (n = this.addGraphicalElement("box", r.rect())).attr(t.boxStyle), e = function (e, t, n, r) {
          t.x < n.x && (t.x = n.x), t.y < n.y && (t.y = n.y), t.x > n.width + n.x && (t.x = n.width + n.x), t.y > n.height + n.y && (t.y = n.height + n.y);
          var o,
              i = t.x - e.x,
              a = e.y - t.y,
              s = l(e.x, t.x),
              u = l(e.y, t.y);
          return i > 0 && a > 0 ? o = r ? "ne-resize" : "e-resize" : i < 0 && a > 0 ? o = r ? "nw-resize" : "w-resize" : i < 0 && a < 0 ? o = r ? "sw-resize" : "w-resize" : i > 0 && a < 0 && (o = r ? "se-resize" : "e-resize"), {
            x: s,
            y: u,
            width: i = c(i),
            height: a = c(a),
            cursor: o
          };
        }(this.dragBoxConfig.startPos, this.dragBoxConfig.currentPos, o, this.getFromEnv("chart").isXY), t.scaleX || (e.x = o.x, e.width = o.width), t.scaleY || (e.y = o.y, e.height = o.height), n.attr(e), n.show();
      }, t.prototype.onDragEnd = function (e) {
        var t,
            n,
            r,
            o,
            i = this.config,
            a = this.getFromEnv("canvas").getGraphicalElement("canvasElement").attrs,
            s = this.getGraphicalElement("box") || {},
            l = s.attrs;
        l && i.dragmove && (i.dragmove = !1, s.hide(), i.startPosX = t = (l.x - a.x) / a.width, i.endPosX = n = (l.x + l.width - a.x) / a.width, i.startPosY = r = (l.y - a.y) / a.height, i.endPosY = o = (l.y + l.height - a.y) / a.height, n - t < .01 || o - r < .01 || this.zoomTo(void 0, void 0, e));
      }, t.prototype.zoomTo = function (e, t, n) {
        var r,
            o,
            i,
            a,
            s,
            l,
            c,
            u,
            d = this,
            f = d.getFromEnv("axesObArr"),
            h = d.config,
            p = !1,
            g = {},
            m = h.catZoomLimit - 1;
        f.forEach(function (f) {
          var v = f.axis,
              y = v.getVisibleConfig(),
              b = f.isY ? y.maxValue : y.minValue,
              x = y.maxValue - y.minValue;
          f.isY ? (a = r = void 0 === e ? b - x * h.endPosY : e, l = o = void 0 === t ? b - h.startPosY * x : t) : (s = r = void 0 === e ? b + h.startPosX * x : e, c = o = void 0 === t ? b + x * h.endPosX : t, g = d.constructor._getZoomInfo(s, c, v)), m && !v.config.isVertical && Math.round(o - r) < m && (r = Math.round(r), o = r + m), (x > 1 || o - r > 1) && (h.dragendFn && "function" == typeof h.dragendFn && h.dragendFn(n, r, o), u = v.setVisibleConfig(r, o), p = p || u, f.stack.push(y), i = f.stack.length + 1);
        }), p && d._raiseZoomEvents("zoomin", "zoomedin", Object.assign(g, {
          level: i,
          startX: s,
          endX: c,
          startY: a,
          endY: l
        }, {
          originalEvent: n && n.originalEvent
        }));
      }, t.prototype.onDrag = function (e) {
        var t = this.config,
            n = this.getCoordinates(e.originalEvent);
        t.dragmove = !0, this.getFromEnv("animationManager").setAnimationState("drag"), t.dragmoveFn && "function" == typeof t.dragmoveFn && t.dragmoveFn(e), this.dragBoxConfig.currentPos = n, this.drawBox();
      }, t.prototype.dragStart = function (e) {
        var t = this.config,
            n = this.getCoordinates(e.originalEvent);
        t.dragstartFn && "function" == typeof t.dragstartFn && t.dragstartFn(e), this.dragBoxConfig = {
          startPos: n,
          currentPos: n
        };
      }, t.prototype.enable = function () {
        !0 !== this.config.enabled && (this.config.enabled = !0, this.config.state = "pressed", this.fireEvent("dragzoomenabled"), this.setControl());
      }, t.prototype.disable = function () {
        !1 !== this.config.enabled && (this.config.enabled = !1, this.config.state = "activated", this.fireEvent("dragzoomdisabled"), this.setControl());
      }, t.prototype.dependancyFn = function (e) {
        "pinenabled" === e.type || "panenabled" === e.type ? this.disable() : "pindisabled" !== e.type && "pandisabled" !== e.type || this.enable();
      }, t;
    }(i["default"]);

    t["default"] = u;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(138),
        o = n(228);

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var a = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return i(t, e), t.prototype.configure = function () {
        var e = this.config = {},
            t = this.getFromEnv("inputOptions") || {};
        Object.assign(e, t[this.getName()]);
      }, t.prototype._checkStackLen = function () {
        var e = this.getFromEnv("axesObArr"),
            t = 0;
        return e && e.forEach(function (e) {
          t += e.stack.length;
        }), t;
      }, t._getZoomInfo = function (e, t, n) {
        var r = {
          startIndex: Math.ceil(e),
          endIndex: Math.floor(t)
        };
        return n.getLabel && (r.startLabel = n.getLabel(r.startIndex).label, r.endLabel = n.getLabel(r.endIndex).label), r;
      }, t.prototype._raiseZoomEvents = function (e, t, n, r) {
        var o = this.getFromEnv("chart");
        e && this.fireEvent(e), t && o.fireChartInstanceEvent(t, n, r), t && o.fireChartInstanceEvent("zoomed", n, r);
      }, t.prototype.getType = function () {
        return "canvasInput";
      }, t.prototype.enable = function (e) {
        !0 !== this.config.enabled && (this.config.enabled = !0, e && this.fireEvent(e), this.setControl());
      }, t.prototype.disable = function (e) {
        !1 !== this.config.enabled && (this.config.enabled = !1, e && this.fireEvent(e), this.setControl());
      }, t.prototype.toggle = function (e) {
        this.isEnabled() ? this.disable(e) : this.enable(e);
      }, t.prototype.isEnabled = function () {
        return this.config.enabled;
      }, t.prototype.setControl = function () {
        var e = this.getLinkedItem("button");
        e && e.setCurrentState(this.isEnabled() ? this.config.state : "disabled");
      }, t.prototype.createButton = function (e) {
        var t,
            n = this.getLinkedParent().getFromEnv("chart"),
            r = n.getFromEnv("tool-config");

        for (var i in (t = n.getFromEnv("toolbar").attachChild(o.Tool, "tool", this.getId())).configure(Object.assign({}, r, {
          name: e.icon,
          tooltext: e.tooltext
        })), e.handlers) {
          e.handlers.hasOwnProperty(i) && t.addEventListener("fc-" + i, e.handlers[i]);
        }

        return t.setLinkedItem("input", this), t;
      }, t;
    }(r.ComponentInterface);

    t["default"] = a;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.ToolBar = t.Tool = t.MenuItemContainer = t.Label = t.Hamburger = t.Checkbox = t.Scroller = undefined;
    var r,
        o = n(229),
        i = n(242),
        a = (r = i) && r.__esModule ? r : {
      "default": r
    };
    t.Scroller = o.Scroller, t.Checkbox = o.Checkbox, t.Hamburger = o.Hamburger, t.Label = o.Label, t.MenuItemContainer = o.MenuItemContainer, t.Tool = o.Tool, t.ToolBar = a["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.Tool = t.Separator = t.MenuItemContainer = t.Label = t.Hamburger = t.Checkbox = t.Scroller = undefined;
    var r = u(n(230)),
        o = u(n(236)),
        i = u(n(237)),
        a = u(n(240)),
        s = u(n(241)),
        l = u(n(238)),
        c = u(n(231));

    function u(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    t.Scroller = r["default"], t.Checkbox = o["default"], t.Hamburger = i["default"], t.Label = a["default"], t.MenuItemContainer = l["default"], t.Separator = s["default"], t.Tool = c["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(125),
        o = c(n(231)),
        i = c(n(233)),
        a = c(n(234)),
        s = c(n(235)),
        l = n(232);

    function c(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function u(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var d = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return u(t, e), t.prototype.configureAttributes = function () {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        e.prototype.configureAttributes.call(this, t);
        var n = this.config,
            o = this.getFromEnv("chart-attrib");
        n.conf = {}, n.color = o.scrollcolor && (0, r.convertColor)(o.scrollcolor), n.padding = (0, r.pluckNumber)(o.scrollpadding, 0), n.height = (0, r.pluckNumber)(o.scrollheight, 12), n.width = (0, r.pluckNumber)(o.scrollwidth, 12), n.displayFlat = (0, r.pluckNumber)(o.flatscrollbars, 0), n.scrollBar3DLighting = (0, r.pluckNumber)(o.scrollbar3dlighting, 1), n.startPercent = Math.min(1, Math.max(0, parseFloat(o.scrolltoend) || 0)), n.showButtons = !!(0, r.pluckNumber)(o.scrollshowbuttons, 1), n.buttonPadding = (0, r.pluckNumber)(o.scrollbtnpadding, 0), n.anchorFill = t.anchorFill, n.anchorStroke = t.anchorStroke, n.trackFill = t.trackFill, n.trackStroke = t.trackStroke, n.buttonFill = t.buttonFill, n.buttonStroke = t.buttonStroke, n.buttonPointerFill = t.buttonPointerFill, n.drawStripes = t.drawStripes, n.stripesStroke = t.stripesStroke, n.restrictScrollAnchor = (0, r.pluckNumber)(t.restrictScrollAnchor, 1), this.setConfiguaration(t), n.evt = {
          tooltext: void 0,
          click: r.stubFN,
          hover: [r.stubFN, r.stubFN]
        }, this.createScrollItems();
      }, t.prototype.createScrollItems = function () {
        var e = this.config,
            t = this.getChildren("scrollTrack") && this.getChildren("scrollTrack")[0],
            n = this.getChildren("scrollAnchor") && this.getChildren("scrollAnchor")[0],
            r = this.getChildren("scrollButtons") && this.getChildren("scrollButtons")[0],
            o = this.getChildren("scrollButtons") && this.getChildren("scrollButtons")[0];
        t || ((t = this.attachChild(i["default"], "scrollTrack")).configure({
          trackFill: e.trackFill,
          trackStroke: e.trackStroke
        }), t.attachEventHandlers()), n || ((n = this.attachChild(a["default"], "scrollAnchor")).configure({
          anchorFill: e.anchorFill,
          anchorStroke: e.anchorStroke,
          drawStripes: e.drawStripes,
          stripesStroke: e.stripesStroke
        }), n.attachEventHandlers()), !r && e.showButtons && ((r = this.attachChild(s["default"], "scrollStartButton")).configure({
          type: "start",
          buttonFill: e.buttonFill,
          buttonStroke: e.buttonStroke,
          buttonPointerFill: e.buttonPointerFill
        }), r.attachEventHandlers()), !o && e.showButtons && ((o = this.attachChild(s["default"], "scrollEndButton")).configure({
          type: "end",
          buttonFill: e.buttonFill,
          buttonStroke: e.buttonStroke,
          buttonPointerFill: e.buttonPointerFill
        }), o.attachEventHandlers());
      }, t.prototype.getName = function () {
        return "scroller";
      }, t.prototype.getType = function () {
        return "scroller";
      }, t.prototype.setConfiguaration = function (e) {
        var t = this.config,
            n = this.getFromEnv("chart").getFromEnv("color-manager");
        t.color || (t.color = "#" + n.getColor("altHGridColor")), (0, l.mergeConf)(e, t);
      }, t.prototype.getLogicalSpace = function () {
        var t = this.config,
            n = t.conf,
            r = {};
        return (0, l.mergeConf)(t, r), (0, l.mergeConf)(r, n), e.prototype.getLogicalSpace.call(this);
      }, t.prototype.setDimension = function (t) {
        e.prototype.setDimension.call(this, t);
        var n = this.getLinkedParent(),
            r = n.getPosition && n.getPosition() || {},
            o = this.getChildren("scrollTrack")[0].config;
        o.transLateX = r.x || 0, o.transLateY = r.y || 0;
      }, t.prototype.draw = function () {
        var e = this.config,
            t = {};
        e.conf.isHorizontal ? delete t.width : delete t.height, (0, l.mergeConf)(t, e, !0), this.addGraphicalElement({
          el: "group",
          attr: {
            name: "scrollContainer"
          },
          component: this,
          container: {
            id: "scrollerContainer",
            label: "scroller",
            isParent: !0
          },
          label: "scrollerGroup",
          id: "scrollerGroup"
        });
      }, t.prototype.attachEventHandlers = function (e) {
        var t = this.config.evt;
        return e && (e.scroll && "function" == typeof e.scroll && (t.scroll = e.scroll), e.scrollStart && "function" == typeof e.scrollStart && (t.scrollStart = e.scrollStart), e.scrollEnd && "function" == typeof e.scrollEnd && (t.scrollEnd = e.scrollEnd)), this;
      }, t;
    }(o["default"]);

    d.registerSymbol = void 0, d._setConfiguaration = r.stubFN, t["default"] = d;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(138),
        o = n(125),
        i = n(232),
        a = n(196);

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var l = function (e) {
      function t(n) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var r = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this, n));

        return r._listeners = {}, r;
      }

      return s(t, e), t.prototype.getName = function () {
        return "button";
      }, t.prototype.getType = function () {
        return "tool";
      }, t.prototype.__setDefaultConfig = function () {
        var e = this.config;
        e.scale = 1.15, e.width = o.touchEnabled ? 20 : 15, e.height = o.touchEnabled ? 20 : 15, e.radius = o.touchEnabled ? 4 : 2, e.spacing = 2.5, e.marginTop = 2.5, e.marginLeft = 2.5, e.marginRight = 2.5, e.marginBottom = 2.5, e.fill = "ffffff", e.fillAlpha = "cccccc", e.symbolFill = "ffffff", e.stroke = "bbbbbb", e.symbolStroke = "9a9a9a", e.strokeWidth = 1, e.symbolStrokeWidth = 1, e.symbolPadding = 5, e.symbolHPadding = 5, e.symbolVPadding = 5, e.fillAlpha = 100, e.stateStyle = {}, e.text = "", e.marginTop = e.marginLeft = e.marginRight = e.marginBottom = 2.5, e.labelFontSize = 12;
      }, t.prototype.configureAttributes = function () {
        var e,
            t,
            n,
            r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            i = this.config;
        r = function (e) {
          for (var t in e) {
            if (e.hasOwnProperty(t)) {
              var n = e[t];
              n !== a.UNDEF && "" !== n || delete e[t];
            }
          }

          return e;
        }(r), Object.assign(i, r), i.symbolName = i.name, this.setState("visible", !0 !== i.isHidden), i.marginTop = (0, o.pluckNumber)(r.marginTop, r.spacing, i.marginTop), i.marginLeft = (0, o.pluckNumber)(r.marginLeft, r.spacing, i.marginLeft), i.marginRight = (0, o.pluckNumber)(r.marginRight, r.spacing, i.marginRight), i.marginBottom = (0, o.pluckNumber)(r.marginBottom, r.spacing, i.marginBottom), i.fill = (0, o.pluck)(r.fill, i.fill), i.fillAlpha = (0, o.pluckNumber)(r.fillAlpha, i.fillAlpha), i.labelFill = (0, o.pluck)(r.labelFill, i.labelFill), i.symbolFill = (0, o.pluck)(r.symbolFill, i.symbolFill), i.hoverFill = (0, o.pluck)(r.hoverFill, i.hoverFill), i.stroke = (0, o.pluck)(r.stroke, i.stroke), i.symbolStroke = (0, o.pluck)(r.symbolStroke, i.symbolStroke), i.strokeWidth = (0, o.pluckNumber)(r.strokeWidth, i.strokeWidth), i.symbolStrokeWidth = (0, o.pluckNumber)(r.symbolStrokeWidth, i.symbolStrokeWidth), e = i.symbolPadding = (0, o.pluckNumber)(r.symbolPadding, i.symbolPadding), i.symbolHPadding = (0, o.pluckNumber)(r.symbolHPadding, e), i.symbolVPadding = (0, o.pluckNumber)(r.symbolVPadding, e), i.hAlign = (0, o.pluck)(r.hAlign, "center").toLowerCase(), i.vAlign = (0, o.pluck)(r.vAlign, "middle").toLowerCase(), i.containerInfo = r.containerInfo || {
          id: "group",
          label: "group",
          isParent: !0
        }, t = r.x, n = r.y, void 0 === t || void 0 === n ? i.spaceNotHardCoded = !0 : (i.x = t, i.y = n, i.spaceNotHardCoded = !1);
      }, t.prototype.setDimension = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            t = this.config;
        e.x !== undefined && (t.x = e.x), e.y !== undefined && (t.y = e.y), e.width !== undefined && (t.width = t.width && t.width > e.width ? t.width : e.width), e.height !== undefined && (t.height = t.height && t.height > e.height ? t.height : e.height);
      }, t.prototype.getAlignment = function () {
        return {
          hAlign: this.config.hAlign,
          vAlign: this.config.vAlign
        };
      }, t.prototype.getLogicalSpace = function () {
        var e = this.config,
            t = e.width,
            n = e.height,
            r = e.marginTop,
            o = e.marginLeft,
            i = e.marginRight,
            a = e.marginBottom,
            s = e.scale;
        return t *= s, n *= s, (this.config.skipGraphics || this.config.isHidden || this.getState("removed")) && (t = n = a = o = i = r = 0), {
          width: t,
          height: n,
          marginTop: r,
          marginLeft: o,
          marginRight: i,
          marginBottom: a
        };
      }, t.prototype.setCurrentState = function (e) {
        this.config.state = e, this.asyncDraw();
      }, t.prototype.getCurrentState = function () {
        return this.config.state;
      }, t.prototype.draw = function () {
        var e,
            t,
            n,
            r = this.config,
            a = r,
            s = r.text,
            l = r.labelFontSize,
            c = r.labelFontFamily;
        r.skipGraphics || (e = {
          width: r.width * r.scale,
          height: r.height * r.scale,
          r: r.radius * r.scale,
          verticalPadding: r.symbolVPadding * r.scale,
          horizontalPadding: r.symbolHPadding
        }, t = Object.assign({
          button: [r.x, r.y, s, r.symbolName, e, l, c],
          "button-label": s,
          "button-padding": [r.symbolHPadding, r.symbolVPadding * r.scale],
          "button-repaint": [a.x, a.y, r.width * r.scale, r.height * r.scale, r.radius * r.scale],
          fill: (0, o.convertColor)(r.fill),
          labelFill: (0, o.convertColor)(r.labelFill),
          symbolFill: (0, o.convertColor)(r.symbolFill),
          hoverFill: r.hoverFill,
          stroke: (0, o.convertColor)(r.stroke),
          "symbol-stroke": (0, o.convertColor)(r.symbolStroke || r.stroke),
          "stroke-width": r.strokeWidth,
          "symbol-stroke-width": (0, o.pluckNumber)(r.symbolStrokeWidth, r.strokeWidth)
        }, r.stateStyle[r.state] || i.preConfig[r.state] || {}), n = r.btnTextStyle, !r.isHidden && this.addGraphicalElement({
          el: "button",
          attr: t,
          css: n,
          component: this,
          container: r.containerInfo,
          label: "button",
          id: "button",
          tooltext: r.tooltext
        }));
      }, t.prototype.hide = function () {
        this.config.isHidden = !0, this.setState("visible", !1), this.asyncDraw();
      }, t.prototype.show = function () {
        this.config.isHidden = !1, this.setState("visible", !0), this.asyncDraw();
      }, t;
    }(r.SmartRenderer);

    t["default"] = l;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.bottomPath = t.mergeConf = t.RSymbolFns = t.defaultTextStyle = t.SymbolStore = t.preConfig = t.DEFAULT_TIMEOUT = t.CLICK = t.HOVER = t.getEventHandlersFor = undefined;
    var r,
        o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        i = n(127),
        a = (r = i) && r.__esModule ? r : {
      "default": r
    },
        s = n(132),
        l = n(125);
    var c = {
      activated: {
        config: {
          hover: {
            fill: "#ffffff",
            labelFill: "#ffffff",
            symbolFill: "#ffffff",
            hoverFill: "#ffffff",
            "fill-symbol": "#ffffff",
            "stroke-width": 1,
            stroke: "#aaaaaa",
            "symbol-stroke": "#aaaaaa",
            cursor: "pointer"
          },
          normal: {
            fill: "#ffffff",
            labelFill: "#ffffff",
            symbolFill: "#ffffff",
            hoverFill: "#ffffff",
            "fill-symbol": "#ffffff",
            stroke: "#c2c2c2",
            "symbol-stroke": "#c2c2c2",
            "stroke-width": 1,
            cursor: "pointer"
          },
          disable: {
            fill: "#ffffff",
            labelFill: "#ffffff",
            symbolFill: "#ffffff",
            hoverFill: "#ffffff",
            "fill-symbol": "#ffffff",
            "stroke-width": 1,
            stroke: "#e3e3e3",
            "symbol-stroke": "#e3e3e3",
            "stroke-opacity": 1,
            cursor: "pointer"
          },
          pressed: {
            fill: "#efefef",
            labelFill: "#efefef",
            symbolFill: "#efefef",
            hoverFill: "#efefef",
            "fill-symbol": "#efefef",
            "stroke-width": 1,
            stroke: "#c2c2c2",
            "symbol-stroke": "#c2c2c2",
            cursor: "pointer"
          }
        },
        "button-disabled": !1,
        fill: "#ffffff",
        labelFill: "#ffffff",
        symbolFill: "#ffffff",
        hoverFill: "#ffffff",
        stroke: "#c2c2c2",
        "symbol-stroke": "#c2c2c2",
        "stroke-opacity": 1,
        cursor: "pointer"
      },
      disabled: {
        config: {
          hover: {
            fill: "#ffffff",
            labelFill: "#ffffff",
            symbolFill: "#ffffff",
            hoverFill: "#ffffff",
            "fill-symbol": "#ffffff",
            "stroke-width": 1,
            stroke: "#e3e3e3",
            "symbol-stroke": "#e3e3e3",
            cursor: "default"
          },
          normal: {
            fill: "#ffffff",
            labelFill: "#ffffff",
            symbolFill: "#ffffff",
            hoverFill: "#ffffff",
            "fill-symbol": "#ffffff",
            stroke: "#e3e3e3",
            "symbol-stroke": "#e3e3e3",
            "stroke-width": 1,
            cursor: "default"
          },
          disable: {
            fill: "#ffffff",
            labelFill: "#ffffff",
            symbolFill: "#ffffff",
            hoverFill: "#ffffff",
            "fill-symbol": "#ffffff",
            "stroke-width": 1,
            stroke: "#e3e3e3",
            "symbol-stroke": "#e3e3e3",
            "stroke-opacity": 1,
            cursor: "default"
          },
          pressed: {
            fill: "#ffffff",
            labelFill: "#ffffff",
            symbolFill: "#ffffff",
            hoverFill: "#ffffff",
            "fill-symbol": "#ffffff",
            "stroke-width": 1,
            stroke: "#e3e3e3",
            "symbol-stroke": "#e3e3e3",
            cursor: "default"
          }
        },
        fill: "#ffffff",
        labelFill: "#ffffff",
        symbolFill: "#ffffff",
        hoverFill: "#ffffff",
        "button-disabled": !1,
        stroke: "#e3e3e3",
        "symbol-stroke": "#e3e3e3",
        "stroke-opacity": 1,
        cursor: "default"
      },
      pressed: {
        config: {
          hover: {
            fill: "#dcdcdc",
            labelFill: "#dcdcdc",
            symbolFill: "#ffffff",
            hoverFill: "#dcdcdc",
            "fill-symbol": "#ffffff",
            "stroke-width": 1,
            stroke: "#b7b7b7",
            "symbol-stroke": "#b7b7b7",
            cursor: "pointer"
          },
          normal: {
            fill: "#dcdcdc",
            labelFill: "#dcdcdc",
            symbolFill: "#ffffff",
            hoverFill: "#dcdcdc",
            "fill-symbol": "#ffffff",
            "stroke-width": 1,
            stroke: "#b7b7b7",
            "symbol-stroke": "#b7b7b7",
            cursor: "pointer"
          },
          pressed: {
            fill: "#dcdcdc",
            labelFill: "#dcdcdc",
            symbolFill: "#ffffff",
            hoverFill: "#dcdcdc",
            "fill-symbol": "#ffffff",
            "stroke-width": 1,
            stroke: "#b7b7b7",
            "symbol-stroke": "#b7b7b7",
            cursor: "pointer"
          }
        },
        fill: "#dcdcdc",
        labelFill: "#dcdcdc",
        symbolFill: "#ffffff",
        hoverFill: "#dcdcdc",
        "fill-symbol": "#ffffff",
        "stroke-width": 1,
        stroke: "#b7b7b7",
        "symbol-stroke": "#b7b7b7",
        cursor: "pointer"
      }
    },
        u = (0, s.getDep)("redraphael", "plugin"),
        d = {
      CB_NOT_CHECKED: function CB_NOT_CHECKED(e, t, n) {
        return ["M", e - n, t - n];
      },
      CB_CHECKED: function CB_CHECKED(e, t, n) {
        var r = n / 4;
        return ["M", e - 3 * r, t, "L", e - r, t + n, e + n, t - n];
      }
    },
        f = (u.addSymbol("Internal_CB", d.CB_NOT_CHECKED), {
      register: function register() {
        var e, t, n, r;

        if (1 === arguments.length) {
          if (null === (n = arguments[0]) && n === l.UNDEF || "object" !== (void 0 === n ? "undefined" : o(n))) return;
          r = n;
        } else {
          if (!(arguments.length > 1)) return;
          if (e = arguments[0], t = arguments[1], "string" != typeof e || "function" != typeof t) return;
          (r = {})[e] = t;
        }

        for (e in r) {
          t = r[e], {}.hasOwnProperty.call(r, e) && u.addSymbol(e, t);
        }
      }
    });
    t.getEventHandlersFor = function (e, t) {
      var n = function n() {
        a["default"].listen(t, "mousemove", function (e) {
          e.originalEvent.stopPropagation();
        });
      };

      switch (e) {
        case "click":
          return function (e) {
            a["default"].listen(t, "click", function (t) {
              t.target && t.target.parentNode && e.call(t.target);
            }), n();
          };

        case "hover":
          return function (e, r) {
            a["default"].listen(t, "pointerhover", function (t) {
              t.target && t.target.parentNode && ("start" === t.state ? e : r).call(t.target);
            }), n();
          };
      }
    }, t.HOVER = "hover", t.CLICK = "click", t.DEFAULT_TIMEOUT = 300, t.preConfig = c, t.SymbolStore = f, t.defaultTextStyle = {
      fill: "#555555",
      labelFill: "#555555",
      symbolFill: "#555555",
      hoverFill: "#555555",
      fontFamily: "Verdana,sans",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: "normal",
      lineHeight: "14.399999999999999px"
    }, t.RSymbolFns = d, t.mergeConf = function (e, t, n) {
      var r, o;

      for (r in e) {
        if ((o = e[r]) !== l.UNDEF && null !== o) if (n) {
          if (t[r]) continue;
          t[r] = o;
        } else t[r] = o;
      }
    }, t.bottomPath = function (e, t, n, r, o) {
      var i = e,
          a = r / 2,
          s = t + Math.round(o / 4 + 1) + 3;
      return ["M", i - a, s, "L", i + a, s];
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(231),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(132),
        s = n(136),
        l = n(125);

    function c(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var u = (0, a.getDep)("redraphael", "plugin"),
        d = Math.max,
        f = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this));

        return n._evtHandlers = {}, n;
      }

      return c(t, e), t.prototype.configureAttributes = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            t = this.config,
            n = this.getLinkedParent().config;
        t.fillColor = e.trackFill || n.displayFlat && n.color || [90 * n.isHorizontal, u.tintshade(n.color, .15).rgba, n.color].join("-"), t.strokeColor = e.trackStroke || u.tintshade(n.color, -.75).rgba;
      }, t.prototype.attachEventHandlers = function () {
        var e = this,
            t = e.config,
            n = e.getLinkedParent(),
            r = n.config,
            o = r.isHorizontal,
            i = void 0,
            a = void 0,
            l = void 0,
            c = void 0,
            u = void 0,
            d = void 0,
            f = void 0,
            h = function h() {
          r.scrollPosition > 1 ? (r.scrollPosition = 1, c = !1) : (r.scrollPosition < 0 || isNaN(r.scrollPosition)) && (r.scrollPosition = 0, c = !1), d.asyncDraw(), "function" == typeof r.evt.scroll && r.evt.scroll(r.scrollPosition);
        },
            p = function m() {
          r.scrollPosition += .01, u >= r.scrollPosition && c && (h(), e.addJob("dragScrollAnchorRight", m, s.priorityList.draw));
        },
            g = function v() {
          r.scrollPosition -= .01, u <= r.scrollPosition && c && (h(), e.addJob("dragScrollAnchorLeft", v, s.priorityList.draw));
        };

        e.addEventListener("fc-mousedown", e._evtHandlers.mousedown || (e._evtHandlers.mousedown = function (h) {
          d = n.getChildren("scrollAnchor")[0], f = d.config, i = h.originalEvent.layerX, a = h.originalEvent.layerY, c = !0, l = o ? i - (f._nodeDimensions.x + t.transLateX + f._nodeDimensions.width / 2) : a - (f._nodeDimensions.y + t.transLateY + f._nodeDimensions.height / 2), (u = l / f.trackLength + r.scrollPosition) >= r.scrollPosition ? e.addJob("dragScrollAnchorRight", p, s.priorityList.draw) : e.addJob("dragScrollAnchorLeft", g, s.priorityList.draw);
        })), e.addEventListener("fc-mouseup", e._evtHandlers.mouseup || (e._evtHandlers.mouseup = function () {
          c = !1;
        }));
      }, t.prototype.draw = function () {
        var e = this.config,
            t = this.getLinkedParent().config,
            n = (0, l.crispBound)(t.x + .5, t.y + t.padding + .5, t.width - 1, t.height - 1, t.strokeWidth);
        this.addGraphicalElement({
          el: "rect",
          attr: {
            x: n.x,
            y: n.y,
            width: d(n.width, 0),
            height: d(n.height, 0),
            fill: e.fillColor,
            stroke: e.strokeColor,
            r: t.roundEdges ? 2 : 0
          },
          container: {
            id: "scrollerGroup",
            label: "scrollerGroup",
            isParent: !0
          },
          component: this,
          label: "scrollerTrack",
          id: "scrollerTrack"
        });
      }, t;
    }(i["default"]);

    t["default"] = f;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(231),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125);

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var l = (0, n(132).getDep)("redraphael", "plugin"),
        c = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this));

        return n._evtHandlers = {}, n;
      }

      return s(t, e), t.prototype.configureAttributes = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            t = this.config,
            n = this.getLinkedParent().config;
        t.fillColor = e.anchorFill || n.displayFlat && l.tintshade(n.color, -.6).rgba || [270 * n.isHorizontal, l.tintshade(n.color, .3).rgba + ":40", l.tintshade(n.color, -.7).rgba].join("-"), t.strokeColor = e.anchorStroke || l.tintshade(n.color, -.6).rgba, t.drawStripes = (0, a.pluckNumber)(e.drawStripes, 0), t.stripesStroke = e.stripesStroke || "5F5F5F", t._nodeDimensions = {};
      }, t.prototype.attachEventHandlers = function () {
        var e = this,
            t = e.config,
            n = this.getLinkedParent().config,
            r = void 0,
            o = void 0,
            i = void 0,
            a = n.isHorizontal;
        e.addEventListener("fc-dragmove", e._evtHandlers.dragmove || (e._evtHandlers.dragmove = function (a) {
          (i = r + a.originalEvent.data[o] / t.trackLength) >= 1 ? i = 1 : (i <= 0 || isNaN(i)) && (i = 0), n.scrollPosition = i, e.asyncDraw(), "function" == typeof n.evt.scroll && n.evt.scroll(n.scrollPosition);
        })), e.addEventListener("fc-dragstart", e._evtHandlers.dragstart || (e._evtHandlers.dragstart = function () {
          o = a ? 0 : 1, r = n.scrollPosition, "function" == typeof n.evt.scrollStart && n.evt.scrollStart(n.scrollPosition);
        })), e.addEventListener("fc-dragend", e._evtHandlers.dragend || (e._evtHandlers.dragend = function () {
          "function" == typeof n.evt.scrollEnd && n.evt.scrollEnd(n.scrollPosition);
        }));
      }, t.prototype.draw = function () {
        var e,
            t,
            n = this.config,
            r = this.getLinkedParent().config,
            o = r.x + .5,
            i = r.y + r.padding + .5,
            s = r.width - 1,
            l = r.height - 1 < 1 ? 1 : r.height - 1,
            c = r.restrictScrollAnchor ? Math.max(r.scrollRatio, .01) : r.scrollRatio,
            u = r.isHorizontal,
            d = (0, a.pluckNumber)(r.scrollPosition, r.startPercent, 0),
            f = 0,
            h = u ? s * c : l * c;
        d >= 1 ? d = 1 : (d <= 0 || isNaN(d)) && (d = 0), r.showButtons && (h -= 2 * (f = u ? Math.min(l, .5 * s) : Math.min(s, .5 * l)) * c), n.trackLength = e = u ? s - 2 * f - h : l - 2 * f - h, n.trackOffset = t = u ? o + f + .5 : i + f + .5, n._nodeDimensions = {
          x: u ? t + e * d : o,
          y: u ? i : t + e * d,
          width: u ? h - 1 < 1 ? 1 : h - 1 : s < 1 ? 1 : s,
          height: u ? l < 1 ? 1 : l : h - 1 < 1 ? 1 : h - 1
        }, this.addGraphicalElement({
          el: "rect",
          attr: {
            x: n._nodeDimensions.x,
            y: n._nodeDimensions.y,
            width: n._nodeDimensions.width,
            height: n._nodeDimensions.height,
            fill: n.fillColor,
            stroke: n.strokeColor,
            r: r.roundEdges ? 2 : 0
          },
          container: {
            id: "scrollerGroup",
            label: "scrollerGroup",
            isParent: !0
          },
          component: this,
          label: "scrollerAnchor",
          id: "scrollerAnchor"
        }), n.drawStripes && n._nodeDimensions.width >= 8 && this.addGraphicalElement({
          el: "path",
          attr: {
            path: ["M", n._nodeDimensions.x + n._nodeDimensions.width / 2 - 3, n._nodeDimensions.y + .2 * n._nodeDimensions.height, "v", .6 * n._nodeDimensions.height, "m", 3, -.6 * n._nodeDimensions.height, "v", .6 * n._nodeDimensions.height, "m", 3, -.6 * n._nodeDimensions.height, "v", .6 * n._nodeDimensions.height],
            stroke: n.stripesStroke,
            "stroke-linecap": "round",
            "stroke-width": 2
          },
          container: {
            id: "scrollerGroup",
            label: "scrollerGroup",
            isParent: !0
          },
          component: this,
          label: "scrollerAnchorStripe",
          id: "scrollerAnchorStripe"
        });
      }, t;
    }(i["default"]);

    t["default"] = c;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(231),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(132),
        s = n(125),
        l = n(136);

    function c(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var u = (0, a.getDep)("redraphael", "plugin"),
        d = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this));

        return n._evtHandlers = {}, n;
      }

      return c(t, e), t.prototype.configureAttributes = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            t = this.config,
            n = this.getLinkedParent().config;
        t.type = e.type, t.buttonFill = e.buttonFill, t.buttonStroke = e.buttonStroke, t.arrowFillColor = e.buttonPointerFill || u.tintshade(n.color, -.4).rgba;
      }, t.prototype.attachEventHandlers = function () {
        var e = this,
            t = e.config,
            n = void 0,
            r = void 0,
            o = e.getLinkedParent(),
            i = o.config,
            a = o.getChildren("scrollAnchor")[0],
            s = function s() {
          i.scrollPosition >= 1 ? i.scrollPosition = 1 : (i.scrollPosition <= 0 || isNaN(i.scrollPosition)) && (i.scrollPosition = 0), a.asyncDraw(), "function" == typeof i.evt.scroll && i.evt.scroll(i.scrollPosition);
        },
            c = function u() {
          r = !0, "start" === t.type ? i.scrollPosition -= .01 : i.scrollPosition += .01, s(), e.addJob("dragScrollAnchor", u, l.priorityList.draw);
        };

        e.addEventListener("fc-mousedown", e._evtHandlers.mousedown || (e._evtHandlers.mousedown = function () {
          n = setTimeout(function () {
            e.addJob("dragScrollAnchor", c, l.priorityList.draw);
          }, 300);
        })), e.addEventListener("fc-mouseup", e._evtHandlers.mouseup || (e._evtHandlers.mouseup = function () {
          clearTimeout(n), e.removeJob("dragScrollAnchor"), r || ("start" === t.type ? i.scrollPosition -= .1 : i.scrollPosition += .1, s()), r = !1;
        })), e.addEventListener("fc-mouseout", function () {
          r && e._evtHandlers.mouseup();
        });
      }, t.prototype.draw = function () {
        var e = this.config,
            t = this.getLinkedParent().config,
            n = {
          id: "scrollerGroup",
          label: "scrollerGroup",
          isParent: !0
        },
            r = t.isHorizontal,
            o = t.x + .5,
            i = t.y + t.padding + .5,
            a = t.width - 1,
            l = t.height - 1 < 1 ? 1 : t.height - 1,
            c = r ? Math.min(l, .5 * a) : Math.min(a, .5 * l),
            u = r ? (0, s.polyPathToPath)([3, o + .5 * c, i + .5 * l, .25 * c, 180]) : (0, s.polyPathToPath)([3, o + .5 * a, i + .5 * c, .25 * c, 90]),
            d = r ? (0, s.polyPathToPath)([3, o + a - .5 * c, i + .5 * c, .25 * c, 0]) : (0, s.polyPathToPath)([3, o + .5 * a, i + l - .5 * c, .25 * c, -90]);
        this.addGraphicalElement({
          el: "rect",
          attr: {
            x: "start" === e.type ? o : r ? o + a - c : o,
            y: "start" === e.type ? i : r ? i : i + l - c,
            width: (e.type, r ? c : a),
            height: (e.type, r ? l : c),
            fill: e.buttonFill || s.TRACKER_FILL,
            stroke: e.buttonStroke || "none"
          },
          container: n,
          component: this,
          label: "scroller" + e.type + "ButtonRect",
          id: "scroller" + e.type + "ButtonRect"
        }), this.addGraphicalElement({
          el: "path",
          attr: {
            path: "start" === e.type ? u : d,
            fill: e.arrowFillColor,
            stroke: "none"
          },
          container: n,
          component: this,
          label: "scroller" + e.type + "ButtonPath",
          id: "scroller" + e.type + "ButtonPath"
        });
      }, t;
    }(i["default"]);

    t["default"] = d;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(231),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125),
        s = n(232);

    function l(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var c = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return l(t, e), t.prototype.configureAttributes = function () {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        e.prototype.configureAttributes.call(this, t);
        var n = this.config;
        n.checked = !!t.isChecked, n.interPadding = 3, n.symbolName = "Internal_CB", n.text = (0, a.pluck)(t.text, ""), n.textStyle = s.defaultTextStyle;
      }, t.prototype.check = function () {
        this.config.checked = !0, this.asyncDraw();
      }, t.prototype.uncheck = function () {
        this.config.checked = !1, this.asyncDraw();
      }, t.prototype.toggle = function () {
        this.config.checked ? this.uncheck() : this.check();
      }, t.prototype.getContainer = function () {
        return this.getFromEnv("chart").getChildContainer("buttonGroup");
      }, t.prototype.draw = function () {
        this.config.checked ? s.SymbolStore.register("Internal_CB", s.RSymbolFns.CB_CHECKED) : s.SymbolStore.register("Internal_CB", s.RSymbolFns.CB_NOT_CHECKED), e.prototype.draw.call(this);
      }, t;
    }(i["default"]);

    t["default"] = c;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = a(n(231)),
        o = n(125),
        i = a(n(238));

    function a(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var l = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return s(t, e), t.prototype.configureAttributes = function () {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        e.prototype.configureAttributes.call(this, t);
        var n = this.config,
            r = this.getFromEnv("dataSource").chart;
        n.baseFontFamily = (0, o.pluck)(t.baseFontFamily, r.basefont, "Verdana,sans"), n.baseFontSize = (0, o.pluckNumber)(t.baseFontSize, r.basefontsize, 10), n.baseFontColor = (0, o.pluck)(t.baseFontColor, r.basefontcolor, "595959"), n.skipGraphics = !0, this.createListContainer();
      }, t.prototype.createListContainer = function () {
        this.attachChild(i["default"], "listContainer", "listContainer").configure();
      }, t.prototype.appendInMenu = function () {
        var e,
            t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
            n = this.getChild("listContainer"),
            r = void 0;

        for (e = t.length, r = 0; r < e; r++) {
          n.addItem(t[r]);
        }

        this.config.skipGraphics = !1;
      }, t;
    }(r["default"]);

    t["default"] = l;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(138),
        i = n(125),
        a = n(239),
        s = (r = a) && r.__esModule ? r : {
      "default": r
    },
        l = n(232);

    function c(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    function u(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          n = void 0,
          r = void 0,
          o = void 0,
          i = void 0;
      if ((r = e.attachChild(s["default"], "item", t.id)).configure(t), t.menu instanceof Array && (i = t.menu.length)) for (n = r.attachChild(d, "subContainer", "subContainer"), e.config.hasSubMenu = !0, n.configure(), o = 0; o < i; o++) {
        n.addItem(t.menu[o]);
      }
    }

    (0, n(132).addDep)({
      name: "manuItemContainerAnimation",
      type: "animationRule",
      extension: {
        "*.menuItemContainer.menuItemContainer": null
      }
    });

    var d = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return c(t, e), t.prototype.configureAttributes = function () {
        var e = this.config;
        this.setStyle(), e.counter = 0, e.hasSubMenu = !1, e._defaultStyle = {
          position: "absolute",
          "z-index": 50,
          top: 0 + i.PXSTRING,
          right: "auto",
          left: "auto",
          overflow: "hidden",
          background: "#ffffff",
          border: "1px solid #646464",
          "box-shadow": "#999999 2px 2px 5px",
          padding: "5px 3px",
          display: "none"
        };
      }, t.prototype.setStyle = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            t = this.config;
        t.hoverOverStyle = e.hoverOverStyle || {
          background: "#333333",
          color: "#FFFFFF",
          cursor: i.POINTER
        }, t.hoverOutStyle = e.hoverOutStyle || {
          background: "#FFFFFF",
          color: "#000000"
        };
      }, t.prototype.show = function () {
        var e = this.config,
            t = this.getFromEnv("chart"),
            n = this.getLinkedParent().config,
            r = (0, i.pluckNumber)(n.scale, 1.5),
            o = n.x,
            a = n.y,
            s = n.width * r,
            l = n.height * r,
            c = +t.getFromEnv("chartWidth"),
            u = this.getGraphicalElement("menu", "menu").element,
            d = u.style;
        clearTimeout(e.hideTimer), d.display = "block", u.offsetWidth + o > c ? (d.left = "auto", d.right = c - o - s + i.PXSTRING) : (d.left = o + i.PXSTRING, d.right = "auto"), d.top = 2 * a + l + i.PXSTRING, d.bottom = "auto", d.display = "block";
      }, t.prototype.hide = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            t = this.config,
            n = void 0,
            r = this.getGraphicalElement("menu", "menu").element;
        e.instant ? r.style.display = "none" : (n = (0, i.pluckNumber)(e.timeout, l.DEFAULT_TIMEOUT), t.hideTimer = setTimeout(function () {
          r.style.display = "none";
        }, n));
      }, t.prototype.addItem = function () {
        u(this, arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {});
      }, t.prototype.draw = function () {
        var e = this.config;
        this.addGraphicalElement({
          el: "html",
          attr: {
            type: "div"
          },
          css: e._defaultStyle,
          component: this,
          label: "menu",
          id: "menu"
        }), this.addEventListener("mouseover", this.show), this.addEventListener("mouseout", this.hide);
      }, t.prototype.getName = function () {
        return "menuItemContainer";
      }, t.prototype.getType = function () {
        return "menuItemContainer";
      }, t;
    }(o.SmartRenderer);

    t["default"] = d;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(125),
        o = n(232),
        i = n(138);

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    (0, n(132).addDep)({
      name: "manuItemAnimation",
      type: "animationRule",
      extension: {
        "*.menuItem.menuItem": null
      }
    });

    var s = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return a(t, e), t.prototype.configureAttributes = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            t = this.config,
            n = this.getLinkedParent().getLinkedParent().config;
        t.name = e.name, t.action = e.action && e.action.toLowerCase() || o.CLICK, t.eventMap = {}, t.style = {
          padding: "3px 8px",
          fontFamily: n.baseFontFamily,
          fontSize: n.baseFontSize + r.PXSTRING,
          color: "#000000",
          position: "static",
          display: "inline",
          float: "left"
        }, t.pointerStyle = {
          padding: "0px 4px 3px",
          fontFamily: n.baseFontFamily,
          fontSize: n.baseFontSize + 3 + r.PXSTRING,
          color: "#000000",
          position: "static",
          float: "left"
        }, t.itemType = e.menu instanceof Array && e.menu.length ? "subMenu" : "item", "item" === t.itemType ? t.handler = e.handler || r.stubFN : t.handler = r.stubFN, t.hoverOverStyle = e.hoverOverStyle || {}, t.hoverOutStyle = e.hoverOutStyle || {};
      }, t.prototype.applyStyle = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "mouseover",
            t = this.getLinkedParent().config,
            n = this.getGraphicalElement("menuItem", "menuItem"),
            r = this.getGraphicalElement("container", "container"),
            o = this.getGraphicalElement("menuPointer", "menuPointer");

        switch (e) {
          case "mouseover":
            n.css(t.hoverOverStyle), r.css(t.hoverOverStyle), o && o.css(t.hoverOverStyle);
            break;

          case "mouseout":
            n.css(t.hoverOutStyle), r.css(t.hoverOutStyle), o && o.css(t.hoverOutStyle);
        }
      }, t.prototype.draw = function () {
        var e = this,
            t = e.config,
            n = e.getLinkedParent();
        e.addGraphicalElement({
          el: "html",
          attr: {
            type: "div"
          },
          css: {
            display: "block",
            position: "static",
            overflow: "hidden",
            height: "100%",
            width: "100%"
          },
          container: {
            id: "menu",
            label: "menu",
            isParent: !0
          },
          component: e,
          label: "container",
          id: "container"
        }), n.config.hasSubMenu && e.addGraphicalElement({
          el: "html",
          attr: {
            type: "div",
            text: "◂"
          },
          css: t.pointerStyle,
          container: {
            id: "container",
            label: "container"
          },
          component: e,
          label: "menuPointer",
          id: "menuPointer"
        }, !0), e.addGraphicalElement({
          el: "html",
          attr: {
            type: "span",
            text: t.name
          },
          css: t.style,
          container: {
            id: "container",
            label: "container"
          },
          component: e,
          label: "menuItem",
          id: "menuItem"
        }, !0), e._mouseOverEvent || (e._mouseOverEvent = function () {
          e.applyStyle("mouseover");
        }), e._mouseOutEvent || (e._mouseOutEvent = function () {
          e.applyStyle("mouseout");
        }), e._clickEvent || (e._clickEvent = function () {
          "item" === e.config.itemType && (n.hide({
            instant: !0
          }), t.handler());
        }), e.addEventListener("mouseover", e._mouseOverEvent), e.addEventListener("mouseout", e._mouseOutEvent), e.addEventListener("click", e._clickEvent);
      }, t.prototype.getName = function () {
        return "menuItem";
      }, t.prototype.getType = function () {
        return "menuItem";
      }, t;
    }(i.SmartRenderer);

    t["default"] = s;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(231),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125);

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var l = {
      left: "start",
      right: "end",
      center: "middle"
    },
        c = {
      top: a.POSITION_TOP,
      middle: a.POSITION_MIDDLE,
      bottom: a.POSITION_BOTTOM
    },
        u = {
      0: "0",
      1: "270",
      right: "90",
      cw: "90",
      left: "270",
      ccw: "270"
    },
        d = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return s(t, e), t.prototype.__setDefaultConfig = function () {
        e.prototype.__setDefaultConfig.call(this);

        var t = this.config;
        t.font = "Verdana, sans", t.rotateText = 0;
      }, t.prototype.configureAttributes = function () {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        e.prototype.configureAttributes.call(this, t);
        var n = this.config;
        n.font = (0, a.pluck)(t.font, n.font), n.fontSize = (0, a.pluckFontSize)(t["font-size"], t.fontSize, 10) * n.scale, n.fontStyle = (0, a.pluck)(t["font-style"], t.fontStyle, "normal"), n.fontWeight = (0, a.pluck)(t["font-weight"], t.fontWeight, "normal"), n.rotateText = (0, a.pluckNumber)(t.rotateText, n.rotateText), n.rotateAngle = parseFloat(u[(0, a.pluck)(t.rotateAngle && t.rotateAngle.toLowerCase(), "0")]);
      }, t.prototype.getTextBound = function () {
        var e = this.config,
            t = [];
        return e.showTextBound && (t = [(0, a.convertColor)(e.fill), e.borderColor, e.borderThickness, 2, e.radius]), t;
      }, t.prototype.getLogicalSpace = function () {
        var e,
            t = this.getFromEnv("smartLabel"),
            n = this.config,
            r = (n.width, n.height, n.marginTop),
            o = n.marginLeft,
            i = n.marginRight,
            a = n.marginBottom;
        return {
          width: (e = t.getOriSize(this.config.text, !1)).width,
          height: e.height,
          marginTop: r,
          marginLeft: o,
          marginRight: i,
          marginBottom: a
        };
      }, t.prototype.draw = function () {
        var e,
            t = this.config;
        t.text && (e = {
          x: t.x,
          y: t.y,
          text: t.text,
          fill: (0, a.convertColor)(t.labelFill),
          "text-bound": this.getTextBound(),
          "font-style": t.fontStyle,
          "font-weight": t.fontWeight,
          "font-family": t.font,
          "font-size": t.fontSize,
          "text-anchor": l[t.hAlign],
          "vertical-align": c[t.vAlign],
          transform: t.rotateText ? (0, a.getSuggestiveRotation)(t.rotateAngle, t.x, t.y) : "t0,0"
        }, !t.isHidden && this.addGraphicalElement({
          el: "text",
          attr: e,
          component: this,
          container: {
            id: "group",
            label: "group",
            isParent: !0
          },
          label: "text",
          id: "label"
        }));
      }, t;
    }(i["default"]);

    t["default"] = d;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(231),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125);

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var l = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return s(t, e), t.prototype.__setDefaultConfig = function () {
        e.prototype.__setDefaultConfig.call(this), this.config.isVertical = 1;
      }, t.prototype.configureAttributes = function () {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        e.prototype.configureAttributes.call(this, t);
        var n = this.config;
        n.isVertical = (0, a.pluckNumber)(t.isVertical, n.isVertical);
      }, t.prototype.draw = function () {
        var e = this.config,
            t = e.x,
            n = e.y,
            r = e.width,
            o = e.height,
            i = {
          path: e.isVertical ? ["M", t + r / 2, n, "v", o] : ["M", t, n, "h", r],
          stroke: e.stroke,
          "stroke-width": e.strokeWidth,
          "stroke-linecap": "round"
        };
        !e.isHidden && this.addGraphicalElement({
          el: "path",
          attr: i,
          component: this,
          container: {
            id: "group",
            label: "group",
            isParent: !0
          },
          label: "path",
          id: "path"
        });
      }, t;
    }(i["default"]);

    t["default"] = l;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(138),
        o = n(125);

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var a = function (e) {
      function t(n) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var r = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this, n));

        return r.props = {}, r;
      }

      return i(t, e), t.prototype.configureAttributes = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            t = this.config,
            n = this.getFromEnv("chartConfig");
        this.__setDefaultConfig(), this.props.width = (0, o.pluckNumber)(e.width, 0), this.props.height = (0, o.pluckNumber)(e.height, 0), t.orientation = (0, o.pluck)(e.toolbarorientation, t.orientation), t.hPadding = (0, o.pluck)(e.toolbarhpadding, t.hPadding), t.vPadding = (0, o.pluck)(e.toolbarvpadding, t.vPadding), t.backgroundcolor = (0, o.pluck)(e.toolbarbackgroundcolor, t.backgroundcolor), t.backgroundalpha = (0, o.pluck)(e.toolbarbackgroundalpha, t.backgroundalpha), t.bordercolor = (0, o.pluck)(e.toolbarbordercolor, t.bordercolor), t.borderalpha = (0, o.pluck)(e.toolbarborderalpha, t.borderalpha), t.borderthickness = (0, o.pluck)(e.toolbarborderthickness, t.borderthickness), t.hDirection = (0, o.pluckNumber)(e.toolbarhdirection, "r" === n.toolbarHAlign ? -1 : 1), t.vDirection = (0, o.pluckNumber)(e.toolbarvdirection, "b" === n.toolbarBAlign ? -1 : 1), t.hAlign = (0, o.pluck)(e.hAlign, "center").toLowerCase(), t.vAlign = (0, o.pluck)(e.vAlign, "middle").toLowerCase(), t.marginTop = (0, o.pluckNumber)(e.marginTop, e.spacing, t.marginTop), t.marginLeft = (0, o.pluckNumber)(e.marginLeft, e.spacing, t.marginLeft), t.marginRight = (0, o.pluckNumber)(e.marginRight, e.spacing, t.marginRight), t.marginBottom = (0, o.pluckNumber)(e.marginBottom, e.spacing, t.marginBottom);
      }, t.prototype.__setDefaultConfig = function () {
        var e = this.config;
        e.orientation = "horizontal", e.hPadding = 0, e.vPadding = 0, e.backgroundcolor = "#eeeeee", e.backgroundalpha = 0, e.bordercolor = "#eeeeee", e.borderalpha = 0, e.borderthickness = 1, e.spacing = 2.5, e.marginTop = 2.5, e.marginLeft = 2.5, e.marginRight = 2.5, e.marginBottom = 2.5;
      }, t.prototype.getLogicalSpace = function () {
        var e = this.config,
            t = this.props,
            n = 0,
            r = 0;
        return this.getChildren("tool") && this.getChildren("tool").length && (this.getChildren("tool").forEach(function (t) {
          if (t.getState("visible") && !t.getState("removed")) {
            var o = t.getLogicalSpace(),
                i = o.width,
                a = o.height,
                s = o.marginTop,
                l = o.marginLeft,
                c = o.marginRight,
                u = o.marginBottom;
            "horizontal" === e.orientation ? (i !== undefined && (n += i + (c || 0) + (l || 0)), r < (a = a + (s || 0) + (u || 0)) && (r = a)) : (a !== undefined && (r += a + (s || 0) + (u || 0)), n < (i = i + (c || 0) + (l || 0)) && (n = i));
          }
        }), n += 2 * e.hPadding, r += 2 * e.vPadding, t.width = t.width > n ? t.width : n, t.height = t.height > r ? t.height : r), {
          width: n,
          height: r,
          marginTop: e.marginTop,
          marginLeft: e.marginLeft,
          marginRight: e.marginLeft,
          marginBottom: e.marginLeft
        };
      }, t.prototype.manageSpace = function () {
        var e = this.config,
            t = this.getChildren("tool") || [],
            n = void 0;

        for (var r in n = "horizontal" === e.orientation ? this._placeToolHorizontally() : this._placeToolVertically()) {
          n.hasOwnProperty(r) && this.getChild(r).setDimension(n[r]);
        }

        t.forEach(function (e) {
          e.manageSpace && e.manageSpace();
        });
      }, t.prototype._placeToolHorizontally = function () {
        var e = this,
            t = e.config,
            n = e.props,
            r = void 0,
            o = void 0,
            i = void 0,
            a = void 0,
            s = t.hPadding,
            l = n.width - t.hPadding,
            c = {},
            u = {
          left: [],
          right: [],
          center: []
        },
            d = {
          left: 0,
          right: 0,
          center: 0
        };
        return e.getChildren("tool") && e.getChildren("tool").length && ((t.hDirection > 0 ? e.getChildren("tool") : e.getChildren("tool").slice(0).reverse()).forEach(function (r) {
          if (r.getState("visible") && !r.getState("removed")) {
            var o = r.getAlignment().hAlign,
                i = r.getLogicalSpace(),
                a = i.width,
                s = i.height,
                l = i.marginTop,
                f = i.marginLeft,
                h = i.marginRight,
                p = i.marginBottom,
                g = r.getId();
            d[o] += a + (f || 0) + (h || 0), u[o].push(g), c[g] = {}, c[g].y = e.props.y + l + t.vPadding + (n.height - 2 * t.vPadding - (s + p + l)) / 2;
          }
        }), u.left.forEach(function (n) {
          var r = e.getChild(n).getLogicalSpace(),
              o = r.width,
              i = r.marginLeft,
              a = r.marginRight;
          s += i || 0, c[n].x = e.props.x + t.hPadding + s, s += o + (a || 0);
        }), u.right.reverse().forEach(function (n) {
          var r = e.getChild(n).getLogicalSpace(),
              o = r.width,
              i = r.marginLeft,
              a = r.marginRight;
          l -= o + (a || 0), c[n].x = e.props.x + t.hPadding + l, l -= i || 0;
        }), r = [d.left + t.hPadding, n.width - (d.right + t.hPadding)], o = Math.abs(r[0] - r[1]), i = r[0] + o / 2, a = i - d.center / 2, u.center.forEach(function (n) {
          var r = e.getChild(n).getLogicalSpace(),
              o = r.width,
              i = r.marginLeft,
              s = r.marginRight;
          a += i || 0, c[n].x = e.props.x + t.hPadding + a, a += o + s || 0;
        })), c;
      }, t.prototype.getAlignment = function () {
        return {
          hAlign: this.config.hAlign,
          vAlign: this.config.vAlign
        };
      }, t.prototype._placeToolVertically = function () {
        var e = this,
            t = e.config,
            n = e.props,
            r = void 0,
            o = void 0,
            i = void 0,
            a = void 0,
            s = t.vPadding,
            l = n.height - t.vPadding,
            c = {
          top: [],
          middle: [],
          bottom: []
        },
            u = {
          top: 0,
          middle: 0,
          bottom: 0
        },
            d = {};
        return e.getChildren("tool") && e.getChildren("tool").length && ((t.vDirection > 0 ? e.getChildren("tool") : e.getChildren("tool").reverse()).forEach(function (r) {
          if (r.getState("visible") && !r.getState("removed")) {
            var o = r.getAlignment().vAlign,
                i = r.getLogicalSpace(),
                a = i.width,
                s = i.height,
                l = i.marginTop,
                f = i.marginLeft,
                h = i.marginRight,
                p = i.marginBottom,
                g = r.getId();
            u[o] += s + (l || 0) + (p || 0), c[o].push(r.getId()), d[g] = {}, d[g].x = e.props.x + f + t.hPadding + f + (n.width - 2 * t.hPadding - (a + f + h)) / 2;
          }
        }), c.top.forEach(function (n) {
          var r = e.getChild(n).getLogicalSpace(),
              o = r.height,
              i = r.marginTop,
              a = r.marginBottom;
          s += i || 0, d[n].y = e.props.y + t.vPadding + s, s += o + (a || 0);
        }), c.bottom.reverse().forEach(function (n) {
          var r = e.getChild(n).getLogicalSpace(),
              o = r.height,
              i = r.marginTop,
              a = r.marginBottom;
          l -= o + (a || 0), d[n].y = e.props.y + t.vPadding + l, l -= i || 0;
        }), r = [u.top + t.vPadding, n.height - (u.bottom + t.vPadding)], o = Math.abs(r[0] - r[1]), i = r[0] + o / 2, a = i - u.middle / 2, c.middle.forEach(function (n) {
          var r = e.getChild(n).getLogicalSpace(),
              o = r.height,
              i = r.marginTop,
              s = r.marginBottom;
          a += i || 0, d[n].y = e.props.y + t.vPadding + a, a += o + s || 0;
        })), d;
      }, t.prototype.setDimension = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        e.x !== undefined && (this.props.x = e.x), e.y !== undefined && (this.props.y = e.y), e.width !== undefined && (this.props.width = e.width), e.height !== undefined && (this.props.height = e.height);
      }, t.prototype.getDimension = function () {
        return this.props;
      }, t.prototype.draw = function () {
        var e = this.config,
            t = this.getDimension();
        this.addGraphicalElement({
          id: "group",
          el: "group",
          attr: {
            name: "toolbar"
          },
          container: {
            id: "toolbar-master",
            isParent: !0
          },
          component: this,
          label: "group"
        }), this.addGraphicalElement({
          id: "carpet",
          el: "rect",
          attr: Object.assign({
            fill: (0, o.toRaphaelColor)({
              color: e.backgroundcolor,
              alpha: e.backgroundalpha
            }),
            stroke: (0, o.toRaphaelColor)({
              color: e.bordercolor,
              alpha: e.borderalpha
            }),
            "stroke-width": e.borderthickness
          }, t),
          container: {
            label: "group",
            id: "group"
          },
          component: this,
          label: "carpet"
        });
      }, t.prototype.getName = function () {
        return "toolbar";
      }, t.prototype.getType = function () {
        return "Toolbar";
      }, t;
    }(r.SmartRenderer);

    t["default"] = a;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(227);

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var a = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this)),
            r = n;

        return r._toggle = function () {
          r.isEnabled() && r.zoomOut();
        }, n;
      }

      return i(t, e), t.prototype.getName = function () {
        return "zoomResetButton";
      }, t.prototype.configure = function () {
        e.prototype.configure.call(this);
        var t = this.getLinkedParent();
        this.configureButton(), this.disable(), t.registerDependancy([{
          derivedInteraction: ["zoomin", "zoomout"],
          callback: this.dependancyFn,
          component: this
        }]);
      }, t.prototype.configureButton = function () {
        !this.config.skipGraphics && this.setLinkedItem("button", this.createButton({
          icon: "resetIcon",
          handlers: {
            click: this._toggle
          },
          tooltext: this.config.tooltext,
          state: "disabled"
        })), this.disable();
      }, t.prototype.enable = function () {
        this.config.state = "activated", e.prototype.enable.call(this);
      }, t.prototype.zoomOut = function () {
        var e,
            t,
            n,
            r,
            o,
            i = this,
            a = i.getFromEnv("chart"),
            s = i.getFromEnv("axesObArr"),
            l = i.config.hookFn,
            c = {};
        s.forEach(function (s) {
          (o = s.stack[0]) && (a.getFromEnv("animationManager").setAnimationState("zoomOut"), l && l(o.minValue, o.maxValue), s.isY ? (n = o.minValue, r = o.maxValue) : (e = o.minValue, t = o.maxValue, c = i.constructor._getZoomInfo(e, t, s.axis)), s.axis.setVisibleConfig(o.minValue, o.maxValue), s.stack.length = 0);
        }), i._raiseZoomEvents("zoomout", "zoomreset", Object.assign(c, {
          level: 1,
          startX: e,
          endX: t,
          startY: n,
          endY: r
        })), i.disable();
      }, t.prototype.dependancyFn = function (e) {
        "zoomin" === e.type ? this.enable() : "zoomout" === e.type && (this._checkStackLen() || this.disable());
      }, t;
    }(((r = o) && r.__esModule ? r : {
      "default": r
    })["default"]);

    t["default"] = a;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(243);

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var a = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this)),
            r = n;

        return r._toggle = function () {
          r.isEnabled() && r.zoomOut();
        }, n;
      }

      return i(t, e), t.prototype.getName = function () {
        return "zoomOutButton";
      }, t.prototype.configureButton = function () {
        !this.config.skipGraphics && this.setLinkedItem("button", this.createButton({
          icon: "zoomOutIcon",
          handlers: {
            click: this._toggle
          },
          tooltext: this.config.tooltext,
          state: "activated"
        }));
      }, t.prototype.zoomOut = function () {
        var e,
            t,
            n,
            r,
            o,
            i,
            a = this,
            s = a.config.hookFn,
            l = {},
            c = 0;
        a.getFromEnv("axesObArr").forEach(function (u) {
          e = u.stack.pop(), t = u.stack.length, c += t, e && (u.isY ? (o = e.minValue, i = e.maxValue) : (n = e.minValue, r = e.maxValue, l = a.constructor._getZoomInfo(n, r, u.axis)), s && s(e.minValue, e.maxValue), u.axis.setVisibleConfig(e.minValue, e.maxValue));
        }), a._raiseZoomEvents("zoomout", "zoomedout", Object.assign(l, {
          level: t,
          startX: n,
          endX: r,
          startY: o,
          endY: i
        })), c || this.disable();
      }, t;
    }(((r = o) && r.__esModule ? r : {
      "default": r
    })["default"]);

    t["default"] = a;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(227);

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var a = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this)),
            r = n;

        return r._toggle = function () {
          r.isEnabled() && r.zoom();
        }, n;
      }

      return i(t, e), t.prototype.getName = function () {
        return "zoomInButton";
      }, t.prototype.configure = function () {
        e.prototype.configure.call(this);
        var t = this.config;
        t.stepZoom = t.stepZoom || 5.33, !t.skipGraphics && this.setLinkedItem("button", this.createButton({
          icon: "zoomInIcon",
          handlers: {
            click: this._toggle
          },
          tooltext: this.config.tooltext,
          state: "activated"
        })), this.enable();
      }, t.prototype.zoom = function () {
        var e,
            t,
            n,
            r,
            o,
            i,
            a,
            s,
            l,
            c = this,
            u = {},
            d = c.config,
            f = d.hookFn,
            h = !1,
            p = Math.pow(10, d.zoomDecimalLimit) || 1;
        c.getFromEnv("animationManager").setAnimationState("zoom"), c.getFromEnv("axesObArr").forEach(function (g) {
          n = g.axis, e = n.getVisibleConfig(), (t = Math.round((e.maxValue - e.minValue) / d.stepZoom * p) / p) > Number.EPSILON && (g.stack.push(e), g.isY ? (i = e.minValue + t, a = e.maxValue - t) : (r = e.minValue + t, o = e.maxValue - t, u = c.constructor._getZoomInfo(r, o, n)), s = g.stack.length + 1, f && f(e.minValue, e.maxValue), l = n.setVisibleConfig(e.minValue + t, e.maxValue - t), h = h || l);
        }), h && c._raiseZoomEvents("zoomin", "zoomedin", Object.assign(u, {
          level: s,
          startX: r,
          endX: o,
          startY: i,
          endY: a
        }));
      }, t;
    }(((r = o) && r.__esModule ? r : {
      "default": r
    })["default"]);

    t["default"] = a;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(227),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125);

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var l = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this)),
            r = n;

        return r.controlArr = [{
          nativeInteraction: ["fc-dbclick"],
          callback: r.zoom.bind(r),
          component: r
        }], n;
      }

      return s(t, e), t.prototype.getName = function () {
        return "dbTapZoom";
      }, t.prototype.configure = function () {
        e.prototype.configure.call(this), this.enable();
      }, t.prototype.setControl = function () {
        var e = this.controlArr,
            t = this.getLinkedParent();
        t.releaseControl(e), this.isEnabled() && t.getControl(e);
      }, t.prototype.zoom = function (e) {
        var t,
            n,
            r,
            o,
            i,
            s,
            l,
            c,
            u,
            d,
            f = this,
            h = f.getFromEnv("chart"),
            p = (0, a.getMouseCoordinate)(h.getLinkedItem("container"), e, h),
            g = f.config,
            m = g.hookFn,
            v = {},
            y = !1,
            b = Math.pow(10, g.zoomDecimalLimit) || 1;
        h.getFromEnv("animationManager").setAnimationState("zoom"), f.getFromEnv("axesObArr").forEach(function (e) {
          t = e.axis, n = t.getValue(e.isY ? p.chartY : p.chartX), o = t.getVisibleConfig(), r = function (e, t, n, r) {
            var o = t - e.minValue,
                i = e.maxValue - t;
            return {
              min: Math.round((t - o / n * (n - 1)) * r) / r,
              max: Math.round((t + i / n * (n - 1)) * r) / r
            };
          }(o, n, g.stepzoom, b), e.isY ? (c = r.min, u = r.max) : (s = r.min, l = r.max, v = f.constructor._getZoomInfo(s, l, t)), t.getZoom() <= b && (m && "function" == typeof g.hookFn && m(r.min, r.max), i = t.setVisibleConfig(r.min, r.max), y = y || i, e.stack.push(o), d = e.stack.length + 1);
        }), y && f._raiseZoomEvents("zoomin", "zoomedin", Object.assign(v, {
          level: d,
          startX: s,
          endX: l,
          startY: c,
          endY: u
        }, e.originalEvent));
      }, t;
    }(i["default"]);

    t["default"] = l;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(227),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125),
        s = n(136),
        l = n(132);

    function c(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var u = Math,
        d = u.min,
        f = u.max,
        h = u.abs,
        p = "rgba(255,0,0," + (a.isIE ? .002 : 1e-6) + ")",
        g = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this)),
            r = n;

        return r.controlArr = [{
          nativeInteraction: ["fc-dragstart"],
          callback: r.dragstart.bind(r),
          component: r
        }, {
          nativeInteraction: ["fc-dragmove"],
          callback: r.dragmove.bind(r),
          component: r
        }, {
          nativeInteraction: ["fc-dragend"],
          callback: r.dragend.bind(r),
          component: r
        }], r.toggle = r.toggle.bind(r), n;
      }

      return c(t, e), t.prototype.getName = function () {
        return "dragPin";
      }, t.prototype.configure = function () {
        e.prototype.configure.call(this);
        var t = this.getFromEnv("chartConfig"),
            n = this.getFromEnv("dataSource").chart,
            r = this.getLinkedParent(),
            o = this.config;
        o.attr = o.attr || {
          stroke: "#3399ff",
          fill: "#b9d5f1",
          "stroke-width": 0
        }, o.pinAttr = o.pinAttr || {
          "stroke-width": 0,
          stroke: "none",
          fill: "#b9d5f1",
          "shape-rendering": "crisp"
        }, o.borderWidth = t.borderWidth || (t.borderWidth = (0, a.pluckNumber)(n.showborder, 1) ? (0, a.pluckNumber)(n.borderthickness, 1) : 0), !this.config.skipGraphics && this.setLinkedItem("button", this.createButton({
          icon: "pinModeIcon",
          tooltext: this.config.tooltext || "Pin mode",
          handlers: {
            click: this.toggle
          },
          state: "activated"
        })), r.registerDependancy([{
          derivedInteraction: ["zoomin", "zoomout"],
          callback: this.dependancyFn,
          component: this
        }]), this.disable(void 0, !1);
      }, t.prototype.enable = function (e, t) {
        var n = this.config;
        !0 !== n.enabled && (n.enabled = !0, n.state = "pressed", this.fireEvent("pinenabled"), this.setControl(), !t && this.getFromEnv("chart").fireChartInstanceEvent("zoommodechanged", {
          pinModeActive: !0
        }, e && e.originalEvent));
      }, t.prototype.dependancyFn = function (e) {
        "zoomin" !== e.type && "zoomout" !== e.type || this.disable(e);
      }, t.prototype.draw = function () {
        var e,
            t = this,
            n = t.config;
        t.createPin(), t.config.pinElemVisible && t.addJob("resizePinElem", function () {
          e = t.getFromEnv("xAxis")[0], t.pinRangePixels(e.getPixel(n.boxStartValue), e.getPixel(n.boxEndValue));
        }, s.priorityList.postRender);
      }, t.prototype._setConfig = function () {
        var e = this.getFromEnv("chart"),
            t = this.getFromEnv("chartConfig"),
            n = this.config,
            r = Object.assign({}, n.attr || {}),
            o = r["stroke-width"] = (0, a.pluckNumber)(r.strokeWidth, r["stroke-width"], 1),
            i = e.getFromEnv("chart-container"),
            s = (0, a.getPosition)(i, e);
        n.zoomX = "horizontal" === n.orientation || "both" === n.orientation, n.zoomY = "vertical" === n.orientation || "both" === n.orientation, n.canvasY = t.canvasTop, n.canvasX = t.canvasLeft, n.canvasW = t.canvasWidth, n.canvasH = t.canvasHeight, n.canvasX2 = t.canvasLeft + t.canvasWidth, n.canvasY2 = t.canvasTop + t.canvasHeight, n.strokeWidth = o, n.chartPosLeft = s.left, n.chartPosTop = s.top;
      }, t.prototype.disable = function (e, t) {
        var n = this.config,
            r = this.getContainer("pingroup"),
            o = this.getGraphicalElement("pintracker");
        !1 !== n.enabled && (n.enabled = !1, n.state = "activated", r && r.hide(), o && o.hide(), this.fireEvent("pindisabled"), !t && this.getFromEnv("chart").fireChartInstanceEvent("zoommodechanged", {
          pinModeActive: !1
        }, e && e.originalEvent), this.setControl(), n.pinElemVisible = !1);
      }, t.prototype.setControl = function () {
        var e = this.getLinkedParent(),
            t = this.controlArr,
            n = this.getLinkedItem("button");
        e.releaseControl(t), this.isEnabled() && e.getControl(t), n && n.setCurrentState(this.config.state);
      }, t.prototype.createPin = function () {
        var e,
            t,
            n,
            r,
            o,
            i = this,
            s = i.config,
            c = i.getFromEnv("chart"),
            u = i.getFromEnv("chartConfig"),
            d = i.getFromEnv("animationManager"),
            f = u.canvasTop,
            h = u.canvasBottom,
            g = u.canvasHeight,
            m = u.canvasLeft,
            v = s.borderWidth,
            y = u["clip-pinrect"],
            b = i.getContainer("pingroup"),
            x = i.getContainer("pinElemGroup"),
            w = i.getGraphicalElement("pinrect"),
            C = i.getGraphicalElement("pintracker");
        r = u._visw = u.canvasWidth, o = u._visx = u.canvasLeft, e = (0, l.getDep)("redraphael", "plugin").crispBound(0, f - h, 0, g, v), y = u["clip-pinrect"] = [e.x, f, e.width, e.height], b || i.addContainer("pingroup", b = d.setAnimation({
          el: "group",
          finalAttr: {
            name: "zoompin"
          },
          component: i,
          label: "group"
        }).insertBefore(c.getChildContainer("plotGroup")).hide()), b.transform(u._pingrouptransform = ["T", o, h]), x || i.addContainer("pinElemGroup", x = d.setAnimation({
          el: "group",
          attr: {
            name: "zoompinelements"
          },
          component: i,
          container: b,
          label: "group"
        })), i.config.pinAttr.x = 0, i.config.pinAttr.y = f - h, i.config.pinAttr.width = r, i.config.pinAttr.height = g, t = d.setAnimation({
          el: w || "rect",
          attr: i.config.pinAttr,
          container: b,
          component: i
        }), w || i.addGraphicalElement("pinrect", t), n = d.setAnimation({
          el: C || "rect",
          attr: {
            transform: b.transform(),
            x: 0,
            y: f - h,
            width: 0,
            height: g,
            stroke: "none",
            fill: p,
            cursor: a.hasSVG ? "ew-resize" : "e-resize"
          },
          container: c.getChildContainer("trackerGroup"),
          component: i
        }).hide(), C || i.addGraphicalElement("pintracker", n), n.undrag(), n.drag(function (e) {
          var t = e.data[0],
              r = o + t + this.__pindragdelta,
              s = this.__pinboundleft,
              l = this.__pinboundright,
              c = this.data("cliprect").slice(0);
          r < s ? r = s : r > l && (r = l), b.transform(["T", r, h]), n.transform(b.transform()), a.hasSVG || (c[0] = c[0] + r - o - this.__pindragdelta, d.setAnimation({
            el: b,
            attr: {
              "clip-rect": c
            },
            component: i
          })), this.__pindragoffset = t;
        }, function () {
          this.__pinboundleft = 0 - y[0] + o + m, this.__pinboundright = this.__pinboundleft + r - y[2], this.data("cliprect", b.attr("clip-rect")), b._.clipispath = !0;
        }, function () {
          b._.clipispath = !1, this.__pindragdelta += this.__pindragoffset, delete this.__pindragoffset, delete this.__pinboundleft, delete this.__pinboundright;
        });
      }, t.prototype.pinRangePixels = function (e, t, n) {
        var r,
            o,
            i,
            a,
            s,
            l = this.getFromEnv("chart"),
            c = l.config,
            u = c.canvasLeft,
            d = this.getFromEnv("xAxis")[0],
            f = d.getLimit(),
            h = f.max,
            p = f.min,
            g = this.getContainer("pingroup"),
            m = this.getGraphicalElement("pinrect"),
            v = this.getContainer("pinElemGroup"),
            y = c["clip-pinrect"],
            b = this.getFromEnv("animationManager"),
            x = c._pingrouptransform,
            w = [],
            C = t - e,
            _ = this.getGraphicalElement("pintracker");

        if (l.iterateComponents(function (e) {
          e.getType && "dataset" === e.getType() && w.push(e);
        }), g && m) {
          for (e === t && (g.hide(), _.hide()), s = w.length; s--;) {
            w[s].fireEvent("createpinelements", {
              group: v
            });
          }

          y[0] = e + u, y[2] = C, b.setAnimation({
            el: g,
            attr: {
              "clip-rect": y,
              transform: x
            },
            component: this
          }).show(), _.__pindragdelta = 0, _.show(), b.setAnimation({
            el: _,
            attr: {
              transform: x,
              x: e,
              width: C
            },
            component: this
          }), this.config.pinElemVisible = !0, r = Math.round(d.getValue(e + u, {
            wrtVisible: !0
          })), o = Math.round(d.getValue(t + u, {
            wrtVisible: !0
          })), r = r < p ? p : r, o = o > h ? h : o, i = d.getLabel(r).label, a = d.getLabel(o).label, n && l.fireChartInstanceEvent("pinned", {
            startIndex: r || Math.abs(r),
            endIndex: o || Math.abs(o),
            startLabel: i,
            endLabel: a
          }, n.originalEvent);
        }
      }, t.prototype.dragstart = function (e) {
        this._setConfig();

        var t,
            n,
            r = this.getFromEnv("chart"),
            o = this.getFromEnv("animationManager"),
            i = this.getFromEnv("chart-container"),
            s = this.config,
            l = s.attr,
            c = this.getGraphicalElement("resizeBox"),
            u = e.originalEvent,
            d = s.layerX = (u.pageX || u.data[0]) - s.chartPosLeft,
            f = s.layerY = (u.pageY || u.data[1]) - s.chartPosTop,
            h = s.canvasY,
            p = s.canvasX,
            g = s.canvasX2,
            m = s.canvasY2;
        t = (0, a.getPosition)(i), s.chartPosLeft = t.left, s.chartPosTop = t.top, s.oy = f, s.ox = d, s.allowMove = !1, l.x = 0, l.y = 0, l.width = 0, l.height = 0, n = o.setAnimation({
          el: c || "rect",
          attr: l,
          container: r.getChildContainer("trackerGroup"),
          component: this,
          callback: function callback() {
            this.show();
          }
        }), c || this.addGraphicalElement("resizeBox", n), d > p && d < g && f > h && f < m && (s.allowMove = !0), s.dragstartFn && "function" == typeof s.dragstartFn && s.dragstartFn(e);
      }, t.prototype.dragmove = function (e) {
        this._setConfig();

        var t = this.config,
            n = this.getFromEnv("animationManager"),
            r = this.getGraphicalElement("resizeBox"),
            o = e.originalEvent,
            i = o.pageX || o.data[2],
            a = o.page || o.data[3],
            s = t.layerX = i - t.chartPosLeft,
            l = t.layerY = a - t.chartPosTop,
            c = s - t.ox,
            u = l - t.oy,
            p = t.ox,
            g = t.oy,
            m = t.zoomX,
            v = t.zoomY,
            y = t.strokeWidth,
            b = t.canvasW,
            x = t.canvasH,
            w = t.canvasY,
            C = t.canvasX,
            _ = t.canvasX2,
            S = t.canvasY2;
        n.setAnimationState("dragMove"), t.allowMove && (t.isDragged || (t.isDragged = 1), c = -(p - d(p - (p - f(p + c, C)), _)), u = -(g - d(g - (g - f(g + u, w)), S)), n.setAnimation({
          el: r,
          attr: {
            x: (m ? d(p, p + c) : C) + .5 * y,
            y: (v ? d(g, g + u) : w) + .5 * y,
            width: m ? h(c) : b,
            height: v ? h(u) : x
          },
          component: this
        }), t.dragmoveFn && "function" == typeof t.dragmoveFn && t.dragmoveFn(e));
      }, t.prototype.dragend = function (e) {
        this._setConfig();

        var t,
            n,
            r,
            o = this.getFromEnv("chart"),
            i = o.config,
            a = this.config,
            s = this.getFromEnv("xAxis")[0],
            l = this.getGraphicalElement("resizeBox"),
            c = a.bBox;
        o.getFromEnv("animationManager").setAnimationState("dragEnd"), r = {
          chart: o,
          selectionLeft: (c = l.getBBox()).x,
          selectionTop: c.y,
          selectionHeight: c.height,
          selectionWidth: c.width,
          originalEvent: e.originalEvent
        }, a.isDragged && (a.dragendFn && "function" == typeof a.dragendFn && a.dragendFn(e, r), a.isDragged = 0), l.hide(), delete a.oy, delete a.ox, (t = c.x - i.canvasLeft) !== (n = t + c.width) && (a.boxStartValue = s.getValue(t), a.boxEndValue = s.getValue(n), this.pinRangePixels(t, n, e));
      }, t;
    }(i["default"]);

    t["default"] = g;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(227),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125);

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var l = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this)),
            r = n;

        return r.controlArr = [{
          nativeInteraction: ["fc-dragstart", "fc-dragmove"],
          callback: r.onDrag.bind(r),
          component: r
        }, {
          nativeInteraction: ["fc-dragend"],
          callback: r.onDragEnd.bind(r),
          component: r
        }], r.toggle = r.toggle.bind(r), a.isFirefox && r.controlArr.push({
          nativeInteraction: ["fc-mousedown"],
          callback: t.mousedown,
          component: r
        }), n;
      }

      return s(t, e), t.mousedown = function (e) {
        e && e.preventDefault();
      }, t.prototype.configure = function () {
        e.prototype.configure.call(this);
        !this.config.skipGraphics && this.setLinkedItem("button", this.createButton({
          icon: "panModeIcon",
          tooltext: this.config.tooltext,
          handlers: {
            click: this.toggle
          },
          state: "activated"
        })), this.getLinkedParent().registerDependancy([{
          derivedInteraction: ["zoomin", "zoomout", "dragzoomenabled", "dragzoomdisabled"],
          callback: this.dependancyFn,
          component: this
        }]), this.disable(a.UNDEF, !1);
      }, t.prototype.getName = function () {
        return "dragPan";
      }, t.prototype.enable = function (e, t) {
        this._checkStackLen() && !0 !== this.config.enabled && (this.config.enabled = !0, this.config.state = "pressed", this.fireEvent("panenabled"), !t && this.getFromEnv("chart").fireChartInstanceEvent("zoommodechanged", {
          panModeActive: !0
        }, e && e.originalEvent), this.setControl());
      }, t.prototype.disable = function (e, t) {
        !1 !== this.config.enabled && (this.config.enabled = !1, this.config.state = this._checkStackLen() ? "activated" : "disabled", this.fireEvent("pandisabled"), !t && this.getFromEnv("chart").fireChartInstanceEvent("zoommodechanged", {
          panModeActive: !1
        }, e && e.originalEvent), this.setControl());
      }, t.prototype.setControl = function () {
        var e = this.getLinkedParent(),
            t = this.getLinkedItem("button"),
            n = this.controlArr;
        e.releaseControl(n), this.isEnabled() && e.getControl(n), t && t.setCurrentState(this.isEnabled() ? this.config.state : "disabled");
      }, t.prototype.setDrag = function (e) {
        this.config.isDragging = !!e;
      }, t.prototype.isDragging = function () {
        return !!this.config.isDragging;
      }, t.prototype.onDragEnd = function () {
        this.setDrag(!1), this.getFromEnv("chart").getContainer("parentgroup").attr({
          cursor: "default"
        });
      }, t.prototype.onDrag = function (e) {
        var t,
            n,
            r,
            o,
            i,
            a,
            s,
            l,
            c,
            u,
            d,
            f = function (e) {
          return e.originalEvent && (e = e.originalEvent), e.type.match(/touch/) ? {
            x: e.touches[0].pageX,
            y: e.touches[0].pageY
          } : e.type.match(/mouse|pointer/) ? {
            x: e.pageX,
            y: e.pageY
          } : void 0;
        }(e.originalEvent);

        (function (e) {
          return !e.touches || 1 === e.touches.length;
        })(e.originalEvent) && (this.getFromEnv("chart").getContainer("parentgroup").attr({
          cursor: "move"
        }), this.getFromEnv("animationManager").setAnimationState("drag"), this.isDragging() ? this.getFromEnv("axesObArr").forEach(function (e) {
          var h, p;
          if (t = e.origConfig.minValue, n = e.origConfig.maxValue, i = e.axis, a = i.config.axisRange, s = i.getScale(), l = s.getRange(), c = s.getDomain(), u = (l[1] - l[0]) / (c[1] - c[0]), h = f, p = e.startCoord, d = {
            x: h.x - p.x,
            y: h.y - p.y
          }, o = n - t, (r = -(r = e.isY ? d.y / u : d.x / u)) > 0) r = Math.min(a.max - n, r);else {
            if (!(r < 0)) return;
            r = -Math.min(t - a.min, -r);
          }
          n = (t += r) + o, i.setVisibleConfig(t, n);
        }) : (this.getFromEnv("axesObArr").forEach(function (e) {
          e.origConfig = e.axis.getVisibleConfig(), e.startCoord = f;
        }), this.setDrag(!0)));
      }, t.prototype.dependancyFn = function (e) {
        "zoomout" === e.type ? !this._checkStackLen() && this.disable() : "zoomin" === e.type ? this.enable(e) : "dragzoomdisabled" === e.type ? this._checkStackLen() && this.enable(e) : "dragzoomenabled" === e.type && this.disable(e);
      }, t;
    }(i["default"]);

    t["default"] = l;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(227),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125);

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var l = function l(e) {
      return e < 0 ? -e : e;
    },
        c = Math.max,
        u = Math.min,
        d = function d(e, t, n, r, o) {
      var i = e.getVisibleConfig(),
          a = e.getValue(t[r ? "y" : "x"] + e.getTranslation()),
          s = a - i.minValue,
          l = i.maxValue - a,
          d = e.config.axisRange;
      return {
        min: Math.round(c(d.min, a - s / n) * o) / o,
        max: Math.round(u(d.max, a + l / n) * o) / o
      };
    },
        f = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this)),
            r = n;

        return r.controlArr = [{
          nativeInteraction: ["fc-pinchstart"],
          callback: r.pinchstart.bind(r),
          component: r
        }, {
          nativeInteraction: ["fc-pinchmove"],
          callback: r.pinchmove.bind(r),
          component: r
        }], n;
      }

      return s(t, e), t.prototype.getName = function () {
        return "pinchZoom";
      }, t.prototype.configure = function () {
        e.prototype.configure.call(this), this.enable();
      }, t.prototype.getCenter = function (e, t) {
        var n = this.getFromEnv("chart"),
            r = (0, a.getMouseCoordinate)(n.getLinkedItem("container"), {
          pageX: (e.pageX + t.pageX) / 2,
          pageY: (e.pageY + t.pageY) / 2
        }, n);
        return {
          x: r.chartX,
          y: r.chartY
        };
      }, t.prototype.pinchmove = function (e) {
        var t,
            n,
            r,
            o,
            i,
            a,
            s,
            c,
            u = this,
            f = e.originalEvent.data,
            h = f.distanceX,
            p = f.distanceY,
            g = u.config,
            m = g.touchConfig,
            v = {},
            y = !1,
            b = {},
            x = u.getFromEnv("chart"),
            w = u.getFromEnv("axesObArr"),
            C = Math.pow(10, g.zoomDecimalLimit) || 1,
            _ = x.getChildContainer().plotGroup;
        t = l(h / m.distanceX), n = l(p / m.distanceY), w.forEach(function () {
          _.transform(""), _.scale(t, n, m.center.x, m.center.y);
        }), clearTimeout(g.chartDraw), g.chartDraw = setTimeout(function () {
          _.transform(""), w.forEach(function (e) {
            var l = e.axis,
                f = d(l, m.center, e.isY ? n : t, e.isY, C),
                h = f.min,
                p = f.max,
                g = e.stack,
                x = l.getVisibleConfig(),
                w = l.getLimit(),
                _ = g.length - 1,
                S = g[_],
                E = Math.floor(h) === w.min && Math.ceil(p) === w.max,
                k = l.getZoom() >= C;

            if (S) {
              if (E) e.stack = [], v.zoomout = !0;else if (S.minValue > h && S.maxValue < p) {
                for (; S && S.minValue > h && S.maxValue < p;) {
                  g.pop(), S = g[--_];
                }

                v.zoomout = !0;
              } else k || (g.push(x), v.zoomin = !0);
            } else E || k || (g.push(x), v.zoomin = !0);
            e.isY ? (a = h, s = p) : (o = h, i = p, b = u.constructor._getZoomInfo(o, i, l)), c = e.stack.length + 1, r = l.setVisibleConfig(h, p), y = y || r;
          }), y && (v.zoomout && u._raiseZoomEvents("zoomout", "zoomedout", Object.assign(b, {
            level: c,
            startX: o,
            endX: i,
            startY: a,
            endY: s
          })), v.zoomin && u._raiseZoomEvents("zoomin", "zoomedin", Object.assign(b, {
            level: c,
            startX: o,
            endX: i,
            startY: a,
            endY: s
          }))), g.chartDraw = null;
        }, 250);
      }, t.prototype.pinchstart = function (e) {
        var t,
            n = this.getFromEnv("axesObArr"),
            r = e.originalEvent.data,
            o = r;
        this.getFromEnv("animationManager").setAnimationState("touch"), o.center = this.getCenter(r.finger0, r.finger1), this.config.touchConfig = r, n.forEach(function (e) {
          t = e.axis, e.visibleConfig = t.getVisibleConfig(), e.centerVal = t.getValue(e.isY ? o.center.y : o.center.x);
        });
      }, t.prototype.setControl = function () {
        var e = this.getLinkedParent(),
            t = this.controlArr;
        e.releaseControl(t), this.isEnabled() && e.getControl(t);
      }, t;
    }(i["default"]);

    t["default"] = f;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(227),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125);

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var l = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this)),
            r = n;

        return r.controlArr = [{
          nativeInteraction: ["fc-dragend"],
          callback: r.end.bind(r),
          component: r
        }, {
          nativeInteraction: ["fc-dragmove"],
          callback: r.move.bind(r),
          component: r
        }, {
          nativeInteraction: ["fc-dragstart"],
          callback: r.start.bind(r),
          component: r
        }], n;
      }

      return s(t, e), t.prototype.getName = function () {
        return "swipeGesture";
      }, t.prototype.configure = function () {
        e.prototype.configure.call(this), this.enable();
      }, t.prototype.getPresentScrollValue = function () {
        var e = this.config.xAxis,
            t = e.getVisibleConfig(),
            n = e.getLimit(),
            r = t.maxValue - t.minValue,
            o = n.max - n.min;
        return (t.minValue - n.min) / (o - r);
      }, t.prototype.start = function (e) {
        var t,
            n,
            r = this.getFromEnv("chart"),
            o = this.config;
        t = (0, a.getMouseCoordinate)(r.getFromEnv("chart-container"), e.originalEvent, r), o.previousX = t.chartX, o.presentScrollValue = n = this.getPresentScrollValue(), r.fireChartInstanceEvent("scrollStart", {
          scrollPosition: n
        });
      }, t.prototype.move = function (e) {
        var t,
            n = this.config,
            r = this.getFromEnv("chart"),
            o = n.xAxis,
            i = o.getChildren("scrollBar") && o.getChildren("scrollBar")[0],
            s = i && i.getChildren("scrollAnchor")[0],
            l = o.config.axisRange,
            c = (0, a.getMouseCoordinate)(r.getFromEnv("chart-container"), e.originalEvent, r).chartX,
            u = (c - n.previousX) / n.plotDifference,
            d = o.getVisibleConfig(),
            f = n.previousScrollValue = n.presentScrollValue,
            h = d.minValue - u,
            p = n.axisMin,
            g = n.axisMax,
            m = d.maxValue - u;
        h < p && p === d.minValue || m > g && g === d.maxValue || (h < p ? (m += u, m -= u = d.minValue - p, h = p) : g < m && (h += u, h += u = g - d.maxValue, m = g), t = (h - l.min) / (l.max - l.min - (m - h)), s.config.scrollPosition = t, r.getFromEnv("animationManager").setAnimationState("scroll"), o.setVisibleConfig(h, m), r.fireChartInstanceEvent("onScroll", {
          scrollPosition: f
        }), n.previousX = c, n.presentScrollValue = this.getPresentScrollValue());
      }, t.prototype.end = function () {
        var e = this.config;
        this.getFromEnv("chart").fireChartInstanceEvent("scrollEnd", {
          previousScrollPosition: e.previousScrollValue,
          scrollPosition: e.presentScrollValue
        });
      }, t.prototype.setControl = function () {
        var e = this.getLinkedParent(),
            t = this.controlArr;
        e.releaseControl(t), this.isEnabled() && e.getControl(t);
      }, t.prototype.draw = function () {
        var e = this.config,
            t = this.getFromEnv("canvas").getAxes().filter(function (e) {
          return !e.isY;
        }),
            n = e.xAxis = t && t[0] && t[0].axis,
            r = n.config.axisRange;
        e.plotDifference = n.getPixel(1) - n.getPixel(0), e.axisMin = r.min, e.axisMax = r.max;
      }, t;
    }(i["default"]);

    t["default"] = l;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };

    t["default"] = function (e) {
      var t = window,
          n = t.navigator.userAgent,
          i = /msie/i.test(n) && !t.opera,
          a = Math,
          s = a.min,
          l = a.round,
          c = t.parseFloat,
          u = String,
          d = "rgba(192,192,192," + (i ? .002 : 1e-6) + ")",
          f = {
        enabled: !1,
        "false": !1,
        0: !1,
        disabled: !0,
        "true": !0,
        1: !0
      };
      e.define && e.define([{
        name: "button",
        button: function button(t, n, o, i, a, s) {
          var l,
              c = n,
              u = this.group("button", c),
              f = t.labelFill,
              h = t.symbolFill,
              p = t.fill,
              g = t.button[5],
              m = t.button[6],
              v = t.hoverFill,
              y = t.stroke,
              b = t["symbol-stroke"],
              x = t["stroke-width"],
              w = t["symbol-stroke-width"],
              C = t.config;

          if ("object" === (void 0 === t ? "undefined" : r(t)) && t.button) {
            var _ = t.button;
            t = _[0], n = _[1], o = _[2], i = _[3], a = _[4], c = _[5];
          }

          for (l in c = c || s, u._.button = {
            bound: this.rect(u),
            tracker: this.rect(u).attr({
              fill: d,
              stroke: d,
              cursor: "pointer"
            }).data("compositeButton", u)
          }, !e.is(a, "object") && (a = {}), e.fn.button.fn) {
            u[l] = e.fn.button.fn[l];
          }

          for (l in e.fn.button.ca) {
            u.ca[l] = e.fn.button.ca[l];
          }

          return C && u.attr({
            config: C
          }), u.attr({
            "button-padding": [a.horizontalPadding, a.verticalPadding],
            "button-label": o,
            "button-label-size": g,
            "button-label-family": m,
            "button-symbol": i,
            "button-disabled": a.disabled || "false",
            "button-symbol-position": a.symbolPosition,
            "button-symbol-padding": a.symbolPadding
          }).attr("button-repaint", [t, n, a.width, a.height, a.r]).attr({
            labelFill: f,
            symbolFill: h,
            fill: p,
            hoverFill: v,
            stroke: y,
            "symbol-stroke": b,
            "stroke-width": x,
            "stroke-linecap": "round",
            "symbol-stroke-width": w
          });
        },
        data: {
          hoverin: function hoverin() {
            var e = this,
                t = e._.button,
                n = t.hoverbackIn,
                r = e._hover || {};
            r.fill || r["fill-symbol"] || r.stroke || r["stroke-width"] || r.cursor || r.labelFill || r["symbol-stroke"] ? (r.fill && e.bottom.attr("fill", r.fill) && !r["fill-symbol"] && t.symbol.attr("fill", r.fill), r["fill-symbol"] && t.symbol.attr("fill", r["fill-symbol"]), r.stroke && e.bottom.attr("stroke", r.stroke) && t.symbol.attr("stroke", r.stroke), r["stroke-width"] && e.bottom.attr("stroke-width", r["stroke-width"]) && t.symbol.attr("stroke-width", r["stroke-width"]), r.cursor && t.tracker.attr("cursor", r.cursor), r.labelFill && t.label && t.label.attr("fill", r.labelFill), r["symbol-stroke"] && t.symbol.attr("stroke", r["symbol-stroke"]), n && n()) : n && !1 === n(arguments) || e.attr("fill", "hover"), e.hovered = !0;
          },
          hoverout: function hoverout() {
            var e = this,
                t = e._.button,
                n = t.hoverbackOut,
                r = e._normal || {};
            r.fill || r["fill-symbol"] || r.stroke || r["stroke-width"] || r.cursor || r.labelFill || r["symbol-stroke"] ? (r.fill && e.bottom.attr("fill", r.fill) && !r["fill-symbol"] && t.symbol.attr("fill", r.fill), r.stroke && e.bottom.attr("stroke", r.stroke) && t.symbol.attr("stroke", r.stroke), r["fill-symbol"] && t.symbol.attr("fill", r["fill-symbol"]), r["stroke-width"] && e.bottom.attr("stroke-width", r["stroke-width"]) && t.symbol.attr("stroke-width", r["stroke-width"]), r["symbol-stroke"] && t.symbol.attr("stroke", r["symbol-stroke"]), r.labelFill && t.label && t.label.attr("fill", r.labelFill), r.cursor && t.tracker.attr("cursor", r.cursor), n && n()) : n && !1 === n(arguments) || e.attr("fill", e.pressed || e.active ? "active" : "normal"), e.hovered = !1;
          },
          mousedown: function mousedown() {
            var e = this,
                t = e._.button,
                n = e._pressed || {};
            n.fill || n["fill-symbol"] || n.stroke || n["stroke-width"] || n.cursor || n.labelFill || n["symbol-stroke"] ? (n.fill && e.bottom.attr("fill", n.fill) && !n["fill-symbol"] && t.symbol.attr("fill", n.fill), n.stroke && e.bottom.attr("stroke", n.stroke) && t.symbol.attr("stroke", n.stroke), n["fill-symbol"] && t.symbol.attr("fill", n["fill-symbol"]), n["stroke-width"] && e.bottom.attr("stroke-width", n["stroke-width"]) && t.symbol.attr("stroke-width", n["stroke-width"]), n.labelFill && t.label && t.label.attr("fill", n.labelFill), n["symbol-stroke"] && t.symbol.attr("stroke", n["symbol-stroke"]), n.cursor && t.tracker.attr("cursor", n.cursor)) : e.attr("fill", "active"), e.pressed = !0;
          },
          mouseup: function mouseup() {
            var e = this,
                t = e._.button,
                n = t.callback,
                r = e._normal || {};
            r.fill || r["fill-symbol"] || r.stroke || r["stroke-width"] || r.cursor || r.labelFill || r["symbol-stroke"] ? (r.fill && e.bottom.attr("fill", r.fill) && !r["fill-symbol"] && t.symbol.attr("fill", r.fill), r.stroke && e.bottom.attr("stroke", r.stroke) && t.symbol.attr("stroke", r.stroke), r["fill-symbol"] && t.symbol.attr("fill", r["fill-symbol"]), r["stroke-width"] && e.bottom.attr("stroke-width", r["stroke-width"]) && t.symbol.attr("stroke-width", r["stroke-width"]), r.labelFill && t.label && t.label.attr("fill", r.labelFill), r["symbol-stroke"] && t.symbol.attr("stroke", r["symbol-stroke"]), r.cursor && t.tracker.attr("cursor", r.cursor)) : e.attr("fill", (e.hovered ? "hover" : e.active && "active") || "normal"), e.pressed = !1, n && n(arguments);
          },
          mousemove: function mousemove() {
            var e = this._.button.mousemove;
            e && e(arguments);
          }
        },
        fn: {
          tooltip: function tooltip() {
            return e.el.tooltip && e.el.tooltip.apply(this._.button.tracker, arguments), this;
          },
          buttonclick: function buttonclick(e, t) {
            var n = this,
                r = n._.button;
            return t = t || n, r.callback = function () {
              return e.apply(t, arguments);
            }, n;
          },
          labelcss: function labelcss() {
            var e = this._.button,
                t = e.label;
            return e.cssArg = arguments, t && t.css.apply(t, arguments), this.attr("button-repaint", this.attrs["button-repaint"]);
          },
          buttonhover: function buttonhover(e, t, n, r, o, i) {
            var a = this,
                s = a._.button;
            return n = n || a, r = r || a, i = i || a, o && (s.mousemove = function () {
              return o.apply(i, arguments);
            }), s.hoverbackIn = function () {
              return e.apply(n, arguments);
            }, s.hoverbackOut = function () {
              return t.apply(r, arguments);
            }, a;
          },
          remove: function remove() {
            var t,
                n = this,
                r = n._.button;

            for (t in n.attr("button-disabled", "true"), r) {
              r[t] && r[t].remove && r[t].remove(), r[t] = null;
            }

            delete n._.button, e.el.remove.apply(n, arguments);
          }
        },
        ca: {
          "button-active": function buttonActive(e) {
            var t = this;
            t.attr("fill", (t.active = !!e) ? "active" : t.hovered ? "hover" : "normal");
          },
          "button-disabled": function buttonDisabled(e) {
            var t = this,
                n = t.paper,
                r = t._.button,
                o = r.tracker,
                i = t.attrs["button-disabled"],
                a = n.button.data,
                s = t._disabled || {};
            if (i = f[i], void 0 !== (e = f[e]) && e !== i) switch (e) {
              case !0:
                s.fill || s.stroke || s["stroke-width"] || s.cursor ? (s.fill && t.bottom.attr("fill", s.fill) && r.symbol.attr("fill", s.fill), s.stroke && t.bottom.attr("stroke", s.stroke) && r.symbol.attr("stroke", s.stroke), s["stroke-width"] && t.bottom.attr("stroke-width", s["stroke-width"] && r.symbol.attr("fill", s.fill)), s.cursor && r.tracker.attr("cursor", s.cursor)) : o.attr("fill", "rgba(204,204,205,.5)"), o.off("fc-mousedown", a.mousedown).off("fc-unmouseup", a.mouseup).unhover(a.hoverin, a.hoverout).unmousemove(a.mousemove);
                break;

              case !1:
                o.attr("fill", d).on("fc-mousedown", a.mousedown, t).on("fc-mouseup", a.mouseup, t).hover(a.hoverin, a.hoverout, t, t).mousemove(a.mousemove, t);
            }
          },
          "button-label": function buttonLabel(e) {
            var t = this,
                n = t._.button,
                r = t.attrs,
                o = n.label,
                i = n.cssArg,
                a = t.attrs["button-repaint"];
            "none" === (e = u(e || "")) ? o && (n.label = o.remove()) : e && (!o && (o = n.label = t.paper.text(t).insertBefore(n.tracker)), o.attr({
              text: e,
              "text-anchor": "middle",
              "vertical-align": "middle"
            }), i && i.length && o.css.apply(o, i)), a && r["button-label"] !== e && t.attr("button-repaint", a);
          },
          "button-label-size": function buttonLabelSize(e) {
            var t = this,
                n = t._.button,
                r = t.attrs,
                o = n.label,
                i = t.attrs["button-label-size"];
            o && o.attr({
              "font-size": e
            }), i && r["button-label-size"] !== e && t.attr("button-label-size", i);
          },
          "button-label-family": function buttonLabelFamily(e) {
            var t = this,
                n = t._.button,
                r = t.attrs,
                o = n.label,
                i = t.attrs["button-label-family"];
            o && (void 0 === e && (e = "sans-serif"), o.attr({
              "font-family": e
            }), i && r["button-label-family"] !== e && t.attr("button-label-family", i));
          },
          "button-symbol": function buttonSymbol(e) {
            var t = this,
                n = t._.button,
                r = n.symbol,
                o = t.attrs["button-repaint"];
            "none" === (e = u(e || "")) ? (r && (n.symbol = r.remove()), delete n.symbol) : e && !r && (r = n.symbol = t.paper.symbol(t).insertAfter(n.bound)), o && t.attr("button-repaint", o);
          },
          "button-symbol-position": function buttonSymbolPosition(e) {
            return {
              "button-symbol-position": {
                top: "top",
                right: "right",
                bottom: "bottom",
                left: "left",
                none: "none"
              }[u(e).toLowerCase()] || "none"
            };
          },
          "button-symbol-padding": function buttonSymbolPadding(e) {
            return {
              "button-symbol-padding": c(e)
            };
          },
          "button-padding": function buttonPadding(e, t) {
            return {
              "button-padding": [(null === e || void 0 === e) && (e = 5) || c(e), (null === t || void 0 === t) && e || c(t)]
            };
          },
          "button-repaint": function buttonRepaint(t, n, r, i, a) {
            var c,
                u,
                d,
                f,
                h,
                p,
                g,
                m = this._.button,
                v = m.bound,
                y = m.label,
                b = m.symbol,
                x = this.attrs,
                w = x["button-padding"],
                C = w[0],
                _ = w[1];

            if (void 0 === t && (t = 0), void 0 === n && (n = 0), void 0 !== r && void 0 !== i || (p = y && y.getBBox() || {
              width: 0,
              height: 0
            }, void 0 === r && (r = 2 * C + p.width), void 0 === i && (i = 2 * _ + p.height)), (g = e.crispBound(t, n, r, i, v.attr("stroke-width"))).r = a = (0, o.pluck)(a, l(.1 * s(i, r))), t = g.x, n = g.y, r = g.width, i = g.height, y && y.attr({
              x: t + r / 2,
              y: n + i / 2
            }), b) {
              switch (!e.is(h = x["button-symbol-padding"], "finite") && (h = .2 * i), f = .5 * (d = i - _), x["button-symbol-position"] + (y ? "+" : "-")) {
                case "right+":
                  c = t + (r += 2 * f + _) - f - C, u = n + .5 * i, y.attr("transform", ["t", -(d + h), 0]);
                  break;

                case "left+":
                  r += 2 * f + _, c = t + C + f, u = n + .5 * i, y.attr("transform", ["t", d + h, 0]);
                  break;

                case "top+":
                  i += 2 * f + h, c = t + .5 * r, u = n + w[1] + f, y.attr("transform", ["t", 0, d + h]);
                  break;

                case "bottom+":
                  c = t + .5 * r, u = n + (i += 2 * f + h) - _ - f, y.attr("transform", ["t", 0, -(d + h)]);
                  break;

                default:
                  c = t + .5 * r, u = n + .5 * i;
              }

              b.attr("symbol", [x["button-symbol"], c, u, f, r, i]);
            }

            m.bound.attr(g), m.tracker.attr(g);
          },
          fill: function fill(t) {
            var n = !(arguments.length > 1 && arguments[1] !== undefined) || arguments[1],
                r = this,
                o = r._.button,
                i = o.bound,
                a = {
              normal: o.gradient,
              active: o.gradientActive,
              hover: o.gradientHover
            }[t];
            return a || (n || ((t = e.getRGB(t)).error && (t = e.color("#cccccc")), t = "opacity" in t ? "rgba(" + [t.r, t.g, t.b, t.opacity] + ")" : "rgb(" + [t.r, t.g, t.b] + ")"), o.gradient = n ? t : [90, e.tintshade(t, -.8).rgba + ":0", e.tintshade(t, .8).rgba + ":100"].join("-"), o.gradientActive = [270, e.tintshade(t, -.8).rgba + ":0", e.tintshade(t, .8).rgba + ":100"].join("-"), a = (r.pressed || r.active) && o.gradientActive || r.hovered && o.gradienthover || o.gradient), i.attr("fill", a), !1;
          },
          hoverFill: function hoverFill(t) {
            var n = this._.button;
            return t = "opacity" in (t = e.getRGB(t)) ? "rgba(" + [t.r, t.g, t.b, t.opacity] + ")" : "rgb(" + [t.r, t.g, t.b] + ")", n.gradientHover = t, !1;
          },
          labelFill: function labelFill(e) {
            var t = this._.button,
                n = t.label;
            return n && e && (t.labelFill = e, n.attr("fill", e)), !1;
          },
          symbolFill: function symbolFill(e) {
            var t = this._.button,
                n = t.symbol;
            return n && e && (t.symbolFill = e, n.attr("fill", e)), !1;
          },
          stroke: function stroke(t) {
            var n = this._.button;
            return (t = e.color(t)).error && (t = e.color("#999999")), n.bound.attr("stroke", t), !1;
          },
          "symbol-stroke": function symbolStroke(e) {
            var t = this._.button.symbol;
            return t && e && t.attr("stroke", e), !1;
          },
          "stroke-width": function strokeWidth(e) {
            var t = this._.button;
            return t.bound.attr("stroke-width", e), t.tracker.attr("stroke-width", e), !1;
          },
          "symbol-stroke-width": function symbolStrokeWidth(e) {
            var t = this._.button.symbol;
            return t && e && t.attr("stroke-width", e), !1;
          },
          config: function config(e) {
            var t = this;
            e.hover && (t._hover = {
              fill: e.hover.fill,
              stroke: e.hover.stroke,
              "stroke-width": e.hover["stroke-width"],
              cursor: e.hover.cursor,
              "fill-symbol": e.hover["fill-symbol"],
              "symbol-stroke": e.hover["symbol-stroke"],
              labelFill: e.hover.labelFill
            }), e.disabled && (t._disabled = {
              fill: e.disabled.fill,
              stroke: e.disabled.stroke,
              "stroke-width": e.disabled["stroke-width"],
              "symbol-stroke": e.disabled["symbol-stroke"],
              cursor: e.disabled.cursor,
              labelFill: e.disabled.labelFill
            }), e.pressed && (t._pressed = {
              fill: e.pressed.fill,
              stroke: e.pressed.stroke,
              "stroke-width": e.pressed["stroke-width"],
              cursor: e.pressed.cursor,
              "fill-symbol": e.pressed["fill-symbol"],
              "symbol-stroke": e.pressed["symbol-stroke"],
              labelFill: e.pressed.labelFill
            }), e.normal && (t._normal = {
              fill: e.normal.fill,
              stroke: e.normal.stroke,
              "stroke-width": e.normal["stroke-width"],
              cursor: e.normal.cursor,
              "fill-symbol": e.normal["fill-symbol"],
              "symbol-stroke": e.normal["symbol-stroke"],
              labelFill: e.normal.labelFill
            }), e.symbol && (e.symbol = {
              stroke: e.normal.stroke,
              "stroke-width": e.normal["stroke-width"]
            });
          }
        }
      }]);
    };

    var o = n(125);
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = n(125),
        o = function o(e, t) {
      var n = e.sender,
          o = n.getLinkedItem("owner"),
          i = n.getFromEnv("chart"),
          a = o && o.getEventArgs ? o.getEventArgs(n) : {},
          s = (0, r.getMouseCoordinate)(n.getFromEnv("chart-container"), e, i);
      a.chartX = s.chartX, a.chartY = s.chartY, a.pageX = s.pageX, a.pageY = s.pageY, a.id = i.getId(), a.legendItemId = n.getId(), a.legendItemIndex = n.config.index, i.fireChartInstanceEvent(t, a, e);
    };

    t["default"] = {
      extension: function extension(e) {
        var t = void 0;
        e.addEventListener("instantiated", function (e) {
          var n;
          "legendItem" === (t = e.sender).getType() && ((n = t).addEventListener("fc-click", function (e) {
            o(e, "legendItemClicked");
          }), n.addEventListener("fc-mouseover", function (e) {
            o(e, "legendItemRollover");
          }), n.addEventListener("fc-mouseout", function (e) {
            o(e, "legendItemRollout");
          }));
        });
      },
      name: "legendEventManagerLinker",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(254),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    };

    var a = function a(e) {
      return "chartAPI" === e.getType();
    },
        s = void 0;

    function l() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          t = this.apiInstance.getChildren("exportModule");
      return (t = t && t[0]) !== s && (t.exportChart(e), !0);
    }

    t["default"] = {
      extension: function extension(e) {
        e.addEventListener("instantiated", function (e) {
          var t = e.sender;
          a(t) && t.registerFactory("export", function (e) {
            var n = void 0;
            t.getFromEnv("chartInstance").exportChart = l, !e.getChildren("export") && Number(e.getFromEnv("dataSource").chart.exportenabled) && (n = new i["default"](), e.attachChild(n, "exportModule"), n.addToEnv("chartInstance", e.getFromEnv("chartInstance")), n.addToEnv("chartMenuList", e.getFromEnv("chartMenuList")), n.configure({
              chartConfig: e.getFromEnv("dataSource").chart
            })), e.getChildren("export") && n && n.configure({
              chartConfig: e.getFromEnv("dataSource").chart
            });
          });
        });
      },
      name: "Export",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        o = n(125),
        i = n(138),
        a = n(255),
        s = n(257),
        l = n(258);
    /** !
     * @license FusionCharts JavaScript Library
     * Copyright FusionCharts Technologies LLP
     * License Information at <http://www.fusioncharts.com/license>
     *
     * @version //? write(JSON.parse(require('fs').readFileSync('./package.json')).version);
     */

    function c(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var u = /\s\bx\b=['"][^'"]+?['"]/gi,
        d = /\s\by\b=['"][^'"]+?['"]/gi,
        f = window,
        h = f.document,
        p = "https:" === f.location.protocol ? "https://export.api3.fusioncharts.com/" : "http://export.api3.fusioncharts.com/",
        g = "https:" === f.location.protocol ? "https://export.api3.fusioncharts.com/api/v1.0/logs" : "http://export.api3.fusioncharts.com/api/v1.0/logs",
        m = f.navigator.userAgent.match(/(iPad|iPhone|iPod)/g),
        v = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this));

        return n.config = {
          exportOption: {},
          chartConfig: {
            caption: "",
            subcaption: "",
            width: "",
            height: ""
          }
        }, n;
      }

      return c(t, e), t.prototype.getName = function () {
        return "exportModule";
      }, t.prototype.getType = function () {
        return "extension";
      }, t.prototype.configureMenuBar = function () {
        var e = this,
            t = e.getFromEnv("chart"),
            n = e.getFromEnv("toolbar"),
            r = !!f.btoa,
            o = e.getFromEnv("chart-attrib").exportformats,
            i = n.getChild("hamburgerMenu-" + n.getId() + "-" + t.getId() + "-0"),
            a = void 0,
            s = void 0,
            c = void 0,
            u = void 0,
            d = void 0,
            h = void 0,
            p = {
          PNG: "Export As " + l.EXPORTFORMAT.PNG.toUpperCase(),
          JPG: "Export As " + l.EXPORTFORMAT.JPG.toUpperCase(),
          PDF: "Export As " + l.EXPORTFORMAT.PDF.toUpperCase(),
          SVG: "Export As " + l.EXPORTFORMAT.SVG.toUpperCase(),
          XLS: "Export As " + l.EXPORTFORMAT.XLS.toUpperCase()
        },
            g = void 0,
            m = [],
            v = void 0;

        if (e.config.exportOption.exportenabled) {
          if (h = function h(t) {
            return function () {
              e.config.exportOption.exportformat = t, e.exportChart({});
            };
          }, o) for (u = 0, d = (a = o.split("|")).length; u < d; u++) {
            p[c = (s = a[u].split("="))[0].toUpperCase()] && (p[c] = s[1] || p[c]), p[c] && (v || (v = {})) && (v[c] = !0);
          }

          for (c in p) {
            "XLS" === c && !r || v && !v[c] || (g = {
              name: p[c],
              handler: h(c),
              action: "click"
            }, m.push(g));
          }

          i.appendInMenu(m);
        }
      }, t.prototype.configure = function (e) {
        var t,
            n,
            r,
            i = this.getFromEnv("chartInstance"),
            a = this.config,
            s = a.chartConfig,
            c = a.exportOption;
        (e = e.chartConfig).caption && (s.caption = (0, o.pluck)(e.caption, "")), e.subcaption && (s.subcaption = (0, o.pluck)(e.subcaption, "")), c.exportenabled = (0, o.pluckNumber)(e.exportenabled, 0), c.exportshowmenuitem = (0, o.pluckNumber)(e.exportshowmenuitem, 1), c.exportformat = (0, o.pluck)(e.exportformat, l.EXPORTFORMAT.PNG), c.exporthandler = (0, o.pluck)(e.html5exporthandler, e.exporthandler, p), c.exportaction = (t = void 0, e.exportaction && "string" == typeof e.exportaction ? (t = e.exportaction.toLowerCase(), [l.EXPORTACTION.DOWNLOAD, l.EXPORTACTION.SAVE, l.EXPORTACTION.DOWNLOADSAVE].indexOf(t) >= 0 ? t : l.EXPORTACTION.DOWNLOAD) : l.EXPORTACTION.DOWNLOAD), c.exporttargetwindow = (0, o.pluck)(e.exporttargetwindow, m ? "_parent" : "_self"), c.exportfilename = (0, o.pluck)(e.exportfilename, "FusionCharts"), c.exportparameters = (0, o.pluck)(e.exportparameters, ""), c.exportcallback = (0, o.pluck)(e.exportcallback, ""), c.exportwithimages = (0, o.pluckNumber)(e.exportwithimages, 1), c.exportmode = (n = void 0, "undefined" != typeof e.exportatclientside && (n = {
          1: l.EXPORTMODE.AUTO,
          0: l.EXPORTMODE.AUTO
        }[e.exportatclientside]), n = (n = e.exportmode || n || l.EXPORTMODE.AUTO).toLowerCase()), c.logenabled = (0, o.pluckNumber)(e.logenabled, 0), c.loghandler = (0, o.pluck)(e.html5loghandler, e.loghandler, g), c.logmode = void 0 !== (r = e.logmode) && "string" == typeof r && r.toUpperCase() in l.LOGMODE ? l.LOGMODE[r.toUpperCase()] : l.LOGMODE.AUTO, c.bgcolor = function (e) {
          var t = (0, o.pluckNumber)(e.options.containerBackgroundOpacity, 1);
          return e.jsVars.transparent || 0 === t ? "" : e.options.containerBackgroundColor || "#FFFFFF";
        }(i), c.bgalpha = function (e) {
          return e.jsVars.transparent ? 0 : (0, o.pluckNumber)(e.options.containerBackgroundOpacity, 1) + "";
        }(i), c.exportshowmenuitem && this.configureMenuBar();
      }, t.prototype.exportChart = function (e) {
        var t,
            n = this.getFromEnv("chartInstance"),
            i = this.getFromEnv("chart"),
            c = this.config.exportOption,
            p = "object" === (void 0 === (t = e) ? "undefined" : r(t)) && function (e) {
          var t = {},
              n = void 0;

          for (n in e) {
            t[n.toLowerCase()] = e[n];
          }

          return t;
        }(e) || {},
            g = (0, o.extend2)((0, o.extend2)({}, c), p),
            m = (g.exportformat || l.EXPORTFORMAT.PNG).toLowerCase(),
            v = g.exporthandler,
            y = g.exportaction,
            b = g.exporttargetwindow || "",
            x = g.exportfilename,
            w = g.exportparameters,
            C = g.exportcallback,
            _ = g.exportwithimages,
            S = g.exportmode,
            E = g.logenabled,
            k = g.loghandler,
            A = g.logmode,
            T = void 0,
            M = void 0,
            O = void 0,
            F = this;

        i.fireChartInstanceEvent("beforeExport", g, void 0, function () {
          var e,
              t = n.id,
              r = F.config.chartConfig.caption,
              c = F.config.chartConfig.subcaption,
              p = this.apiInstance.getFromEnv("paper"),
              I = this.apiInstance.getFromEnv("core-options")["export"].useCanvas,
              L = void 0,
              N = void 0,
              D = void 0,
              P = i.getChildren("chartMenuBar")[0],
              R = P.getChild("hamburgerMenu-" + P.getId() + "-" + i.getId() + "-0").getChild("listContainer"),
              j = void 0,
              V = (0, a.isCanvasElemSupported)(),
              B = {
            DOMId: t,
            height: p.height,
            width: p.width,
            fileName: x + "." + m,
            statusCode: void 0,
            statusMessage: void 0,
            notice: void 0
          },
              H = {
            exportAction: y,
            exportTargetWindow: b,
            exportCallback: C,
            fusionCharts: n,
            paper: p,
            chartId: t,
            exportHandler: v,
            logEnabled: E,
            logMode: A,
            logHandler: k
          },
              G = function G(e, t, i) {
            var a,
                s,
                u,
                d = void 0;
            return i = i || y, a = y, s = (0, l.createExportActionOldString)(y), u = ["exportfilename=" + x, "exportformat=" + m, "exportaction=" + s, "exportactionnew=" + a, "configuredexportaction=" + i, "exportparameters=" + w].join("|"), d = !!E, A === l.LOGMODE.CLIENT && (d = !1), {
              charttype: n.chartType(),
              stream_type: e || "",
              stream: t || "",
              meta_bgColor: g.bgcolor || "",
              meta_bgAlpha: g.bgalpha || "1",
              meta_DOMId: n.id,
              meta_width: p.width || F.config.chartConfig.width,
              meta_height: p.height || F.config.chartConfig.height,
              chart_caption: r,
              chart_sub_caption: c,
              is_single_export: !0,
              is_full_version: !1,
              version: o.PROJECT_VERSION,
              user_time_zone: -new Date().getTimezoneOffset(),
              log_enabled: d,
              parameters: u
            };
          },
              z = function z() {
            var e = y;
            return {
              chartType: n.chartType(),
              chartCaption: r,
              chartSubCaption: c,
              isSingleExport: !0,
              isFullVersion: !1,
              exportAction: e,
              userTimeZone: -new Date().getTimezoneOffset(),
              exportFileName: [x, m].join("."),
              exportFormat: m,
              version: o.PROJECT_VERSION
            };
          },
              U = function U(e) {
            var t = G(l.EXPORTFORMAT.SVG, e);
            (0, a.downloadCharts)(null, null, null, t, H);
          },
              $ = function $(e, t, n) {
            var r = void 0;
            (r = h.createElement("canvas")).width = p.width, r.height = p.height, (0, a.drawSvgOnCanvas)({
              svg: D,
              canvas: r,
              x: 0,
              y: 0,
              width: p.width,
              height: p.height,
              useCanvas: I
            }, function () {
              switch (e) {
                case l.EXPORTFORMAT.PNG:
                  t(e, r.toDataURL("image/png"), x, n);
                  break;

                case l.EXPORTFORMAT.JPEG:
                case l.EXPORTFORMAT.PDF:
                default:
                  t(e, r.toDataURL("image/jpeg"), x, n);
              }
            });
          },
              X = function X(e, t, n) {
            var r,
                o = void 0;
            r = x + "." + m, m === l.EXPORTFORMAT.SVG ? (o = (0, l.svgStrToDataUrl)(e), L = n === l.EXPORTMODE.AUTO ? G("IMAGE-DATA", o) : null, (0, a.downloadCharts)("url", o, r, L, t)) : $(m, function () {
              !function (e, t, n, r, o) {
                var i = n + "." + e;
                e === l.EXPORTFORMAT.PDF && ((0, s.JpegToPdf)(p.height, p.width), (0, s.addImage)(t), t = (0, s.getDataUrl)()), L = o === l.EXPORTMODE.AUTO ? G("IMAGE-DATA", t) : null, (0, a.downloadCharts)("url", t, i, L, r);
              }(arguments[0], arguments[1], arguments[2], arguments[3], n);
            }, t);
          },
              W = function W(e) {
            i.fireChartInstanceEvent("exportDataReady", e);
          },
              Y = function Y(e) {
            e === l.LOGMODE.CLIENT && (0, l.logCharts)(z(), H);
          },
              q = void 0,
              K = void 0,
              J = void 0;

          if ("xls" === m) {
            if ("undefined" == typeof f.btoa) return i.fireChartInstanceEvent("exportCancelled", g), !1;
            M = n.getCSVData(), W(), e = 0, T = [], M.replace(/[^\r\n]+/g, function (t) {
              T[e] = [], T[e] = t.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/).map(function (e) {
                return e.replace(/"/g, "");
              }), e += 1;
            }), O = function () {
              var e;
              return "data:application/vnd.ms-excel;base64," + (e = "<!DOCTYPE HTML PUBLIC \"-//IETF//DTD HTML//EN\"><html xmlns:o='urn:schemas-microsoft-com:office:office'xmlns:x='urn:schemas-microsoft-com:office:excel'xmlns='http://www.w3.org/TR/REC-html40'><head>\x3c!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--\x3e" + '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></head><body>' + function () {
                var e,
                    t,
                    n = void 0,
                    r = void 0,
                    o = void 0,
                    i = void 0,
                    a = void 0;
                if (!T.length) return "";

                for (e = "<table align='center' >", o = 0, t = T.length; o < t; o += 1) {
                  if (0 === o) {
                    for (n = "<thead valign='top'><tr>", i = 0, a = T[o].length; i < a; i += 1) {
                      n += "<th>" + T[o][i] + "</th>";
                    }

                    n += "</tr></thead>", r = "<tbody>";
                  } else {
                    for (r += "<tr>", i = 0, a = T[o].length; i < a; i += 1) {
                      r += "<td>" + T[o][i] + "</td>";
                    }

                    r += "</tr>";
                  }
                }

                return e + n + (r += "</tbody>") + "</table>";
              }() + "</body></html>", f.btoa(f.unescape(encodeURIComponent(e))));
            }(), q = "undefined" != typeof f.btoa && ("Chrome" === a.browserDetails.name || "Firefox" === a.browserDetails.name || "Safari" === a.browserDetails.name || "Edge" === a.browserDetails.name || "ie" === a.browserDetails.name), "server" !== S && q ? (y !== l.EXPORTACTION.DOWNLOAD && y !== l.EXPORTACTION.DOWNLOADSAVE || ((0, a.downloadCharts)("url", O, x + "." + m, null, H), i.fireChartInstanceEvent("exported", B)), y === l.EXPORTACTION.SAVE || y === l.EXPORTACTION.DOWNLOADSAVE ? (K = y, y === l.EXPORTACTION.DOWNLOADSAVE && (y = l.EXPORTACTION.SAVE), L = G("IMAGE-DATA", O, K), (0, a.downloadCharts)(null, null, null, L, H), Y(A)) : A !== l.LOGMODE.SERVER && (0, l.logCharts)(z(), H)) : (L = G("IMAGE-DATA", O), (0, a.downloadCharts)(null, null, null, L, H), Y(A));
          } else (j = R.getLinkedParent().getGraphicalElement("button", "button")) && j.attr("visibility", "hidden"), N = p.toSVG(_), D = (D = p.toSVG(_ && V)).replace(/&nbsp;/gi, " "), j && j.attr("visibility", "visible"), N = (N = (N = N.replace(/(\sd\s*=\s*["'])[M\s\d\.]*(["'])/gi, "$1M 0 0 L 0 0$2")).replace(/NS\d+:/gi, "xlink:")).replace(/&nbsp;/gi, " "), D = (D = (D = D.replace(/NS\d+:/gi, "xlink:")).replace(/(\sd\s*=\s*["'])[M\s\d\.]*(["'])/gi, "$1M 0 0 L 0 0$2")).replace(/(xlink:title\s*=\s*)['"].*["']/gi, ""), N = (N = (N = (N = (N = (N = (N = (N = N.replace(/[\w\-]+\=\"undefined\"/gi, "")).replace(/(xlink:title\s*=\s*)['"].*["']/gi, "")).replace(/rgba\(([^\)]+)\)/gi, function (e) {
            return "#" + new o.RGBtoHex(e.split(","));
          })).replace(/<svg[^>]+/i, function (e) {
            return e.match(/height/i) || !p.height && !F.config.chartConfig.height || (e += ' height="' + (p.height || F.config.chartConfig.height) + '"'), e.match(/width/i) || !p.width && !F.config.chartConfig.width || (e += ' width="' + (p.width || F.config.chartConfig.width) + '"'), e;
          })).replace(/(([\w]+\-)?opacity\s*=\s*)['"][\d\.]+e[\-\+][\d]+["']/gi, '$1"0.001"')).replace(/(([\w]+\-)?opacity\s*:\s*)[\d\.]+e[\-\+][\d]+/gi, "$10.001")).replace(/<text[^\>]+/gi, function (e) {
            return e = (e = (e = (e = (e = (e = (e = (e = e.replace(/stroke\=[\"\']([a-z0-9\#]+)?[\"\']/gi, "")).replace(/stroke\s*\:\s*([a-z0-9\#]+)?;?/gi, "")).replace(/stroke-width\=[\"\']([a-z0-9\#]+)?[\"\']/gi, "")).replace(/stroke-width\s*\:\s*([a-z0-9\#]+)?;?/gi, "")).replace(/stroke-opacity\=[\"\']([a-z0-9\#]+)?[\"\']/gi, "")).replace(/stroke-opacity\s*\:\s*([a-z0-9\#]+)?;?/gi, "")).replace(/(<text[^\>]+fill\=)([\"\'][^\"\']+[\"\'])([^\>]+)/gi, '$1$2 stroke=$2 stroke-width="0.2"$3')).replace(/(<text[^\>]+fill-opacity\=)([\"\'][^\"\']+[\"\'])([^\>]+)/gi, "$1$2 stroke-opacity=$2 $3");
          })).replace(/<(\b[^<>s\s]+\b)[^\>]+?opacity\s*=\s*['"][^1][^\>]+?(\/>|>[\s\r\n]*?<\/\1>)/gi, function (e, t) {
            var n = void 0;
            return n = ' opacity="1" stroke-opacity="1" fill="#cccccc" stroke-width="0" r="0"', e + "<" + t + (u.exec(e) || "") + (d.exec(e) || "") + (n += ' height="0.5" width="0.5" d="M 0 0 L 1 1" />');
          }), N = (0, l.makeImageUrlsAbsolute)(N), D = (0, l.makeImageUrlsAbsolute)(D), J = S === l.EXPORTMODE.SERVER, (0, l.cacheAllImages)(N, J, function () {
            L = G(l.EXPORTFORMAT.SVG, N), W(L), L = null;
            var e = void 0,
                t = "undefined" != typeof f.btoa && ("Chrome" === a.browserDetails.name || "Firefox" === a.browserDetails.name || "Safari" === a.browserDetails.name || "Edge" === a.browserDetails.name || "ie" === a.browserDetails.name),
                n = (0, l.hasUndownloadableImage)(N);
            (S === l.EXPORTMODE.CLIENT || S === l.EXPORTMODE.AUTO && !n) && t ? (D = (0, l.replaceImagesWithNonDataUrl)(D), y !== l.EXPORTACTION.DOWNLOAD && y !== l.EXPORTACTION.DOWNLOADSAVE || (X(D, H, S), i.fireChartInstanceEvent("exported", B)), y === l.EXPORTACTION.SAVE || y === l.EXPORTACTION.DOWNLOADSAVE ? (e = y, y === l.EXPORTACTION.DOWNLOADSAVE && (y = l.EXPORTACTION.SAVE), function (e, t, n) {
              var r = void 0;
              m === l.EXPORTFORMAT.SVG ? (r = (0, l.svgStrToDataUrl)(e), n(r, t)) : $(m, function () {
                n(arguments[1], t);
              }, t);
            }(D, H, function (t, n) {
              L = G("IMAGE-DATA", t, e), (0, a.downloadCharts)(null, null, null, L, n), Y(A);
            }), i.fireChartInstanceEvent("exported", B)) : A !== l.LOGMODE.SERVER && (0, l.logCharts)(z(), H)) : S === l.EXPORTMODE.AUTO ? (!function (e) {
              var t = void 0,
                  n = void 0,
                  r = (0, l.hasUndownloadableImage)(e);
              a.browserDetails.hasCanvas && "undefined" != typeof f.btoa ? ((t = h.createElement("canvas")).width = p.width, t.height = p.height, e = (0, l.embedImagesWithNonDataURL)(e), D = (0, l.replaceImagesWithNonDataUrl)(D), r || m === l.EXPORTFORMAT.SVG ? (n = G(l.EXPORTFORMAT.SVG, e), (0, a.downloadCharts)(null, null, null, n, H)) : (0, a.drawSvgOnCanvas)({
                svg: D,
                canvas: t,
                x: 0,
                y: 0,
                width: p.width,
                height: p.height,
                useCanvas: I
              }, function () {
                var e = void 0;

                switch (m) {
                  case l.EXPORTFORMAT.PNG:
                    e = t.toDataURL("image/png");
                    break;

                  case l.EXPORTFORMAT.JPEG:
                    e = t.toDataURL("image/jpeg");
                    break;

                  case l.EXPORTFORMAT.PDF:
                    (0, s.JpegToPdf)(p.height, p.width), (0, s.addImage)(t.toDataURL("image/jpeg")), e = (0, s.getDataUrl)();
                    break;

                  default:
                    e = t.toDataURL("image/jpeg");
                }

                n = G("IMAGE-DATA", e), (0, a.downloadCharts)(null, null, null, n, H);
              })) : U(e);
            }(N), Y(A)) : S === l.EXPORTMODE.SERVER && (U(N), Y(A));
          });
        }, function () {
          i.fireChartInstanceEvent("exportCancelled", g);
        });
      }, t;
    }(i.ComponentInterface);

    t["default"] = v;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.isCanvasElemSupported = t.drawSvgOnCanvas = t.browserDetails = t.downloadCharts = undefined;
    var r = s(n(256)),
        o = n(125),
        i = n(131),
        a = s(n(176));

    function s(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var l = window,
        c = l.Image,
        u = document,
        d = "download",
        f = "download-save",
        h = function h() {
      var e = u.createElement("canvas");
      return !(!e.getContext || !e.getContext("2d"));
    },
        p = function p() {
      var e,
          t = l.navigator.userAgent;
      return -1 !== (e = t.indexOf("Edge")) ? {
        name: "Edge",
        version: t.substring(e + 5, e + 11)
      } : -1 !== (e = t.indexOf("Chrome")) ? {
        name: "Chrome",
        version: t.substring(e + 7, e + 11)
      } : -1 !== (e = t.indexOf("MSIE")) ? {
        name: "ie",
        version: t.substring(e + 5, e + 9)
      } : -1 !== (e = t.indexOf("rv")) && -1 !== t.indexOf("Trident") ? {
        name: "ie",
        version: t.substring(e + 5, e + 9)
      } : -1 !== (e = t.indexOf("Firefox")) ? {
        name: "Firefox",
        version: t.substring(e + 8, e + 12)
      } : -1 !== (e = t.indexOf("Safari")) ? {
        name: "Safari",
        version: t.substring(e + 7, e + 11)
      } : {
        name: "default",
        version: "Not Known"
      };
    },
        g = p(),
        m = function m(e, t, n) {
      var r,
          o,
          i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
          a = p(),
          s = i.chartId,
          c = i.exportCallback,
          d = i.paper;
      "Chrome" === a.name || "Firefox" === a.name || "Safari" === a.name ? ("blob" === e && (t = l.URL.createObjectURL(t)), (o = u.createElement("a")).download = n, o.href = t, u.body.appendChild(o), o.onclick = function () {
        c && l[c] && "function" == typeof l[c] && l[c]({
          statusCode: 1,
          statusMessage: "success",
          DOMId: s,
          width: d && d.width,
          height: d && d.height
        }), o.parentNode.removeChild(o);
      }, o.click()) : "ie" !== a.name && "Edge" !== a.name || l.navigator.msSaveBlob && (r = "url" === e ? function (e) {
        var t, n, r, o;

        for (t = e.split(",")[0].indexOf("base64") >= 0 ? l.atob(e.split(",")[1]) : l.unescape(e.split(",")[1]), n = e.split(",")[0].split(":")[1].split(";")[0], r = new Uint8Array(t.length), o = 0; o < t.length; o++) {
          r[o] = t.charCodeAt(o);
        }

        return new l.Blob([r], {
          type: n
        });
      }(t) : t, l.navigator.msSaveBlob(r, n) && c && l[c] && "function" == typeof l[c] && l[c]({
        statusCode: 1,
        statusMessage: "success",
        DOMId: s,
        width: d && d.width,
        height: d && d.height
      }));
    };

    g.hasCanvas = h(), g.hasSvg = o.hasSVG, t.downloadCharts = function (e, t, n, r, s) {
      var c;
      !t || (c = t, g.name.toLowerCase() === "Chrome".toLowerCase() && function (e) {
        var t, n, r;

        for (t = e.length, r = e.length - 1; r >= 0; r--) {
          (n = e.charCodeAt(r)) > 127 && n <= 2047 ? t++ : n > 2047 && n <= 65535 && (t += 2), n >= 56320 && n <= 57343 && r--;
        }

        return t;
      }(c) > void 0) ? r && function (e, t) {
        var n,
            r,
            s,
            c,
            h,
            p,
            g,
            m,
            v = t.exportAction,
            y = t.exportTargetWindow,
            b = t.exportCallback,
            x = t.fusionCharts.apiInstance,
            w = t.paper,
            C = t.chartId,
            _ = t.exportHandler,
            S = e.parameters;

        if (v === d || v === f) {
          for (n in /(webkit|gecko)/gi.test(l.navigator.userAgent) && "_self" === y && (y = s = C + "export_iframe", m || (m = c = (0, o.createElement)("IFRAME", {
            name: s,
            width: "1px",
            height: "1px"
          }, u.body), c.style.cssText = "position:absolute;left:-10px;top:-10px;")), r = (0, o.createElement)("form", {
            method: "POST",
            action: _,
            target: y,
            style: "display:none;"
          }, u.body), e) {
            (0, o.createElement)("input", {
              type: "hidden",
              name: n,
              value: e[n]
            }, r);
          }

          return r.submit(), u.body.removeChild(r), r = void 0, p = S.match(/exportfilename=([^|]+)/)[1], g = S.match(/exportformat=([^|]+)/)[1], (0, i.triggerEvent)("exported", x, {
            DOMId: C,
            height: w.height,
            width: w.width,
            fileName: p + "." + g,
            statusCode: void 0,
            statusMessage: void 0,
            notice: void 0
          }), b && l[b] && "function" == typeof l[b] && l[b]({
            statusCode: 1,
            statusMessage: "success",
            DOMId: C,
            width: w && w.width,
            height: w && w.height
          }), !0;
        }

        for (n in h = new a["default"](function (e) {
          var t = {};
          e.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), function (e, n, r, o) {
            t[n] = o;
          }), b && l[b] && "function" == typeof l[b] && l[b](t), (0, i.triggerEvent)("exported", x, t);
        }, function (e) {
          var t = {
            statusCode: 0,
            statusMessage: "failure",
            error: e,
            DOMId: C,
            width: w && w.width,
            height: w && w.height
          };
          b && l[b] && "function" == typeof l[b] && l[b](t), (0, i.triggerEvent)("exported", x, t, [t]);
        }), e) {
          e.hasOwnProperty(n) && (e[n] = encodeURIComponent(e[n]));
        }

        h.post(_, e);
      }(r, s) : m(e, t, n, s);
    }, t.browserDetails = g, t.drawSvgOnCanvas = function () {
      var e,
          t,
          n,
          o,
          a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          s = arguments[1],
          u = a.svg,
          d = a.canvas,
          f = a.x,
          h = a.y,
          p = a.width,
          m = a.height,
          v = a.useCanvas;
      "ie" === g.name || "Edge" === g.name || v ? new r["default"](u, d, f, h, p, m, function () {
        s();
      }) : (o = function (e) {
        return '<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">' + e;
      }(u), n = o = "data:image/svg+xml;base64," + l.btoa(l.unescape(encodeURIComponent(o))), e = d.getContext("2d"), (t = new c()).onload = function () {
        e.drawImage(t, f, h, p, m), s();
      }, t.onerror = function () {
        (0, i.raiseWarning)(this, "", "run", "libSVGToCanvas:drawSvgOnCanvas", "Unable to load image for canvas drawing. Aborting attempt.");
      }, t.src = n);
    }, t.isCanvasElemSupported = h;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var _r4,
        o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        i = "undefined" != typeof window ? window : null,
        a = i.document,
        s = {},
        l = {};

    (_r4 = function r(e, t, n, o, i, a, s) {
      var l = {
        svg: "",
        context: "",
        callBack: "",
        imageArr: [],
        canvas: "",
        dimention: {}
      };
      if (!(this instanceof _r4)) throw new Error("This function should be used as class");
      this._getStore = function (e) {
        return "undefined" != typeof l[e] && l[e];
      }, this._setStore = function (e, t) {
        "undefined" != typeof l[e] && (l[e] = t);
      }, this._setStore("dimention", {
        x: n,
        y: o,
        width: i,
        height: a
      }), e && this.setSVG(e), t && this.setContext(t), s && this.setCallback(s), this.drawOnCanvas();
    }).prototype.setContext = function (e) {
      var t;
      if (!e.getContext || !e.getContext("2d")) throw new Error("Please provide valid canvas");
      t = e.getContext("2d"), this._setStore("canvas", e), this._setStore("context", t);
    }, _r4.prototype.getContext = function () {
      return this._getStore("context");
    }, _r4.prototype.setSVG = function (e) {
      var t;
      if ("undefined" != typeof e.documentElement) t = e, this._setStore("svg", t);else {
        if ("<" !== e.substr(0, 1)) throw new Error("Please provide valid SVG");
        t = l.StrToDom(e), this._setStore("svg", t);
      }
    }, _r4.prototype.getSVG = function () {
      return this._getStore("svg");
    }, _r4.prototype.setCallback = function (e) {
      "function" == typeof e && this._setStore("callBack", e);
    }, _r4.prototype.getCallback = function () {
      return this._getStore("callBack");
    }, _r4.prototype.drawOnCanvas = function (e, t, n, r, o, i, a) {
      var s, c, u, d, f, h, p, g;
      e && this.setSVG(e), t && this.setContext(t), a && this.setCallback(a), t = t || this._getStore("canvas"), p = this._getStore("dimention"), a = this.getCallback(), s = this.getContext(), (c = this.getSVG()) && s && (u = (g = l.getSvgDimention(c)).width, d = g.height, n = n || p.x || 0, r = r || p.y || 0, o = o || p.width || u, i = i || p.height || d, f = g.width ? o / u : 1, h = g.height ? i / d : 1, l.startTransform("translate(" + n + "," + r + ") scale(" + f + "," + h + ")", s), s.save(), s.fillStyle = "#ffffff", s.fillRect(0, 0, o, i), s.restore(), l.storeImagesInArr(this), l.drawNodes([c], [], this, s, function () {
        "function" == typeof a && a(), l.resetTransform(s);
      }));
    }, s.common = function (e, t, n, r, i) {
      var a,
          c,
          u,
          d,
          f = e.childNodes,
          h = function h() {
        e.attributes && r.restore(), i && i();
      };

      for (c in t) {
        t.hasOwnProperty(c) && "class" !== t[c].name && "id" !== t[c].name && "transform" !== t[c].name && "clip-path" !== t[c].name && "object" === o(t[c]) && e.attributes && !e.attributes[t[c].name] && e.setAttribute([t[c].name], t[c].value);
      }

      if (e.attributes && e.attributes.style) for (c in u = e.attributes.style.value.replace(/;$/, "").split(";")) {
        if (u.hasOwnProperty(c) && (d = u[c].split(":")[0].trim(), !e.attributes[d] || "undefined" === e.attributes[d].value)) try {
          e.setAttribute(d, u[c].split(":")[1].trim());
        } catch (p) {}
      }
      e.attributes && (r.save(), e.attributes.transform && l.startTransform(e.attributes.transform.value, r), e.attributes["clip-path"] && l.applyClip(e.attributes["clip-path"].value, r, n)), 0 === f.length || 1 === f.length && !f[0].tagName ? "undefined" != typeof e.tagName ? (a = "draw" + e.tagName, s[a] ? e.attributes.display && "none" === e.attributes.display.value ? h() : s[a](e, r, n, "draw", h) : h()) : h() : l.drawNodes(f, "svg" === e.tagName ? [] : e.attributes, n, r, h);
    }, s.drawtext = function (e, t, n, r, o) {
      this.drawtspan(e, t, n, r, o);
    }, s.drawtspan = function (e, t, n, r, o) {
      var s,
          c,
          u,
          d,
          f,
          h = e.innerHTML || e.textContent,
          p = e.attributes.x ? e.attributes.x.value : 0,
          g = e.attributes.y ? e.attributes.y.value : 0,
          m = e.attributes.dx ? e.attributes.dx.value : 0,
          v = e.attributes.dy ? e.attributes.dy.value : 0,
          y = "serief",
          b = "normal",
          x = "16px",
          w = [];
      a.getElementsByTagName("body")[0] && ((s = i.getComputedStyle(a.getElementsByTagName("body")[0], null)).getPropertyValue("font-family") && (y = s.getPropertyValue("font-family")), s.getPropertyValue("font-weight") && (b = s.getPropertyValue("font-weight")), s.getPropertyValue("font-size") && (x = s.getPropertyValue("font-size"))), c = e.attributes["font-family"] ? e.attributes["font-family"].value : y, u = e.attributes["font-weight"] ? e.attributes["font-weight"].value : b, d = e.attributes["text-anchor"] ? e.attributes["text-anchor"].value : "start", f = e.attributes["font-size"] ? e.attributes["font-size"].value : x, p = Number(p) + Number(m), g = Number(g) + Number(v), h = h.trim(), d = "middle" === d ? "center" : d, t.save(), t.font = u + " " + f + " " + c, t.textAlign = d, "draw" === r && ((!e.attributes.fill || e.attributes.fill && "none" !== e.attributes.fill.value) && (l.applyFillEffect(e, t, n, w), t.fillText(h, p, g), l.endFillEffect(e, t)), (!e.attributes.stroke || e.attributes.stroke && "none" !== e.attributes.stroke.value) && (l.applyStrokeEffect(e, t, n, w), t.strokeText(h, p, g), l.endStrokeEffect(e, t))), t.restore(), "function" == typeof o && o();
    }, s.drawcircle = function (e, t, n, r, o) {
      var i = Number(e.attributes.cx.value),
          a = Number(e.attributes.cy.value),
          s = Number(e.attributes.r.value),
          c = [];
      t.beginPath(), t.arc(i, a, s, 0, 2 * Math.PI), l.bBoxFromPoint([i, 1 * i + 1 * s, 1 * i - 1 * s], [a, 1 * a + 1 * s, 1 * a - 1 * s], c), "draw" === r && ((!e.attributes.fill || e.attributes.fill && "none" !== e.attributes.fill.value) && (l.applyFillEffect(e, t, n, c), t.fill(), l.endFillEffect(e, t)), (!e.attributes.stroke || e.attributes.stroke && "none" !== e.attributes.stroke.value) && (l.applyStrokeEffect(e, t, n, c), t.stroke(), l.endStrokeEffect(e, t))), t.closePath(), "function" == typeof o && o();
    }, s.drawrect = function (e, t, n, r, o) {
      var i = Number(e.attributes.x.value),
          a = Number(e.attributes.y.value),
          s = e.attributes.rx ? Number(e.attributes.rx.value) : 0,
          c = e.attributes.ry ? Number(e.attributes.ry.value) : 0,
          u = Number(e.attributes.height.value),
          d = Number(e.attributes.width.value),
          f = [],
          h = t.lineCap;
      t.lineCap = "square", l.bBoxFromPoint([i, i + d], [a, a + u], f), t.beginPath(), t.moveTo(i + s, a), t.lineTo(i + d - s, a), t.quadraticCurveTo(i + d, a, i + d, a + c), t.lineTo(i + d, a + u - c), t.quadraticCurveTo(i + d, a + u, i + d - s, a + u), t.lineTo(i + s, a + u), t.quadraticCurveTo(i, a + u, i, a + u - c), t.lineTo(i, a + c), t.quadraticCurveTo(i, a, i + s, a), "draw" === r && ((!e.attributes.fill || e.attributes.fill && "none" !== e.attributes.fill.value) && (l.applyFillEffect(e, t, n, f), t.fill(), l.endFillEffect(e, t)), (!e.attributes.stroke || e.attributes.stroke && "none" !== e.attributes.stroke.value) && (l.applyStrokeEffect(e, t, n, f), t.stroke(), l.endStrokeEffect(e, t))), t.closePath(), t.lineCap = h, "function" == typeof o && o();
    }, s.drawellipse = function (e, t, n, r, o) {
      var i = Number(e.attributes.cx.value),
          a = Number(e.attributes.cy.value),
          s = Number(e.attributes.rx.value),
          c = Number(e.attributes.ry.value),
          u = .5522848 * s,
          d = .5522848 * c,
          f = i + s,
          h = a + c,
          p = [];
      t.beginPath(), t.moveTo(i - s, a), t.bezierCurveTo(i - s, a - d, i - u, a - c, i, a - c), t.bezierCurveTo(i + u, a - c, f, a - d, f, a), t.bezierCurveTo(f, a + d, i + u, h, i, h), t.bezierCurveTo(i - u, h, i - s, a + d, i - s, a), l.bBoxFromPoint([i + s, i - s], [a + c, a - c], p), "draw" === r && ((!e.attributes.fill || e.attributes.fill && "none" !== e.attributes.fill.value) && (l.applyFillEffect(e, t, n, p), t.fill(), l.endFillEffect(e, t)), (!e.attributes.stroke || e.attributes.stroke && "none" !== e.attributes.stroke.value) && (l.applyStrokeEffect(e, t, n, p), t.stroke(), l.endStrokeEffect(e, t))), t.closePath(), "function" == typeof o && o();
    }, s.drawimage = function (e, t, n, r, o) {
      var i,
          a = e.attributes.x ? Number(e.attributes.x.value) : 0,
          s = e.attributes.y ? Number(e.attributes.y.value) : 0,
          l = e.attributes.height ? Number(e.attributes.height.value) : 0,
          c = e.attributes.width ? Number(e.attributes.width.value) : 0,
          u = n._getStore("imageArr");

      t.save(), e.attributes.opacity && (t.globalAlpha = e.attributes.opacity.value), e.attributes["xlink:href"] ? (i = e.attributes["xlink:href"].value, "complete" === u[i].status ? (t.drawImage(u[i].obj, a, s, c, l), t.globalAlpha = 1, t.restore(), "function" == typeof o && o()) : "error" === u[i].status ? (t.globalAlpha = 1, t.restore(), "function" == typeof o && o()) : "progress" === u[i].status ? (u[i].callback = function () {
        t.drawImage(u[i].obj, a, s, c, l), t.globalAlpha = 1, t.restore(), "function" == typeof o && o();
      }, u[i].errCallback = function () {
        t.globalAlpha = 1, t.restore(), "function" == typeof o && o();
      }) : (t.globalAlpha = 1, t.restore(), "function" == typeof o && o())) : (t.globalAlpha = 1, t.restore(), "function" == typeof o && o());
    }, s.drawpath = function (e, t, n, r, o) {
      var i,
          a,
          s,
          c,
          u = e.attributes.d.value.match(/[a-z][^a-z"]*/gi),
          d = [],
          f = 0,
          h = 0,
          p = {};

      for (i in t.beginPath(), u) {
        if (u.hasOwnProperty(i)) switch (a = u[i].substring(0, 1), s = l.getArgsAsArray(u[i].substring(1, u[i].length)), a) {
          case "M":
            f = Number(s[0]), h = Number(s[1]), t.moveTo(f, h), p.cx = f, p.cy = h;
            break;

          case "m":
            f += Number(s[0]), h += Number(s[1]), t.moveTo(f, h), p.cx = f, p.cy = h;
            break;

          case "L":
            for (c = 0; s[c]; c += 2) {
              l.bBoxFromPoint([f, s[c]], [h, s[c + 1]], d), f = Number(s[c]), h = Number(s[c + 1]), t.lineTo(f, h);
            }

            break;

          case "l":
            for (c = 0; s[c]; c += 2) {
              l.bBoxFromPoint([f, 1 * f + 1 * s[c]], [h, 1 * h + 1 * s[c + 1]], d), f += Number(s[c]), h += Number(s[c + 1]), t.lineTo(f, h);
            }

            break;

          case "V":
            for (c = 0; s[c]; c += 1) {
              l.bBoxFromPoint([f], [h, s[c]], d), h = Number(s[c]), t.lineTo(f, h);
            }

            break;

          case "v":
            for (c = 0; s[c]; c += 1) {
              l.bBoxFromPoint([f], [h, 1 * h + 1 * s[c]], d), h += Number(s[c]), t.lineTo(f, h);
            }

            break;

          case "H":
            for (c = 0; s[c]; c += 1) {
              l.bBoxFromPoint([f, s[c]], [h], d), f = Number(s[c]), t.lineTo(f, h);
            }

            break;

          case "h":
            for (c = 0; s[c]; c += 1) {
              l.bBoxFromPoint([f, 1 * f + 1 * s[c]], [h], d), f += Number(s[c]), t.lineTo(f, h);
            }

            break;

          case "Q":
            for (c = 0; s[c]; c += 4) {
              l.qBezierBBox(f, h, s[c], s[c + 1], s[c + 2], s[c + 3], d), t.quadraticCurveTo(Number(s[c]), Number(s[c + 1]), Number(s[c + 2]), Number(s[c + 3])), f = Number(s[c + 2]), h = Number(s[c + 3]);
            }

            break;

          case "q":
            for (c = 0; s[c]; c += 4) {
              l.qBezierBBox(f, h, f + 1 * s[c], h + 1 * s[c + 1], 1 * f + 1 * s[c + 2], 1 * h + 1 * s[c + 3], d), t.quadraticCurveTo(f + 1 * s[c], h + 1 * s[c + 1], f += Number(s[c + 2]), h += Number(s[c + 3]));
            }

            break;

          case "C":
            for (c = 0; s[c]; c += 6) {
              l.cBezierBBox(f, h, s[c], s[c + 1], s[c + 2], s[c + 3], s[c + 4], s[c + 5], d), t.bezierCurveTo(s[c], s[c + 1], s[c + 2], s[c + 3], s[c + 4], s[c + 5]), f = Number(s[c + 4]), h = Number(s[c + 5]);
            }

            break;

          case "c":
            for (c = 0; s[c]; c += 6) {
              l.cBezierBBox(f, h, f + 1 * s[c], 1 * h + 1 * s[c + 1], f + 1 * s[c + 2], 1 * h + 1 * s[c + 3], f + 1 * s[c + 4], 1 * h + 1 * s[c + 5], d), t.bezierCurveTo(f + Number(s[c]), h + Number(s[c + 1]), f + Number(s[c + 2]), h + Number(s[c + 3]), f += Number(s[c + 4]), h += Number(s[c + 5]));
            }

            break;

          case "a":
          case "A":
            for (c = 0; s[c]; c += 7) {
              var g,
                  m,
                  v,
                  y,
                  b,
                  x,
                  w,
                  C,
                  _,
                  S,
                  E,
                  k,
                  A,
                  T,
                  M,
                  O,
                  F,
                  I,
                  L = Number(s[c]),
                  N = Number(s[c + 1]);

              if (g = Number(s[c + 2]) * (Math.PI / 180), m = Number(s[c + 3]), v = Number(s[c + 4]), y = Number(s[c + 5]), b = Number(s[c + 6]), x = Math.cos(g) * (f - y) / 2 + Math.sin(g) * (h - b) / 2, w = -Math.sin(g) * (f - y) / 2 + Math.cos(g) * (h - b) / 2, L = L < 0 ? -L : L, N = N < 0 ? -N : N, (M = Math.pow(x, 2) / Math.pow(L, 2) + Math.pow(w, 2) / Math.pow(N, 2)) > 1 && (L *= Math.sqrt(M), N *= Math.sqrt(M)), O = L > N ? L : N, F = L > N ? 1 : L / N, I = L > N ? N / L : 1, C = (m === v ? -1 : 1) * Math.sqrt((Math.pow(L, 2) * Math.pow(N, 2) - Math.pow(L, 2) * Math.pow(w, 2) - Math.pow(N, 2) * Math.pow(x, 2)) / (Math.pow(L, 2) * Math.pow(w, 2) + Math.pow(N, 2) * Math.pow(x, 2))), isNaN(C) && (C = 0), S = N * x * -C / L, E = (_ = C * (L * w) / N) * Math.cos(g) - S * Math.sin(g) + (f + y) / 2, k = _ * Math.sin(g) + S * Math.cos(g) + (h + b) / 2, A = l.angleBetweenVectors(1, 0, (x - _) / L, (w - S) / N), T = l.angleBetweenVectors((x - _) / L, (w - S) / N, (-x - _) / L, (-w - S) / N), 0 === v && T > 0 && (T -= Math.PI / 180 * 360), 1 === v && T < 0 && (T += Math.PI / 180 * 360), 0 === L && 0 === N) {
                t.lineTo(y, b);
                break;
              }

              t.save();
              var D = l.combineTransformMatrix([[1, 0, E, 0, 1, k], [Math.cos(g), Math.sin(g), 0, Math.sin(g), Math.cos(g), 0], [F, 0, 0, 0, I, 0]]);
              t.transform(D[0], D[3], D[1], D[4], D[2], D[5]), t.arc(0, 0, O, A, A + T, 1 - v), t.restore(), l.arcBBox(0, 0, O, A, A + T, 1 - v, [D[0], D[3], D[1], D[4], D[2], D[5]], d), "A" === a ? (f = Number(s[c + 5]), h = Number(s[c + 6])) : (f += Number(s[c + 5]), h += Number(s[c + 6]));
            }

            break;

          case "Z":
          case "z":
            t.closePath(), f = p.cx, h = p.cy;
        }
      }

      "draw" === r && ((!e.attributes.fill || e.attributes.fill && "none" !== e.attributes.fill.value) && (l.applyFillEffect(e, t, n, d), t.fill(), l.endFillEffect(e, t)), (!e.attributes.stroke || e.attributes.stroke && "none" !== e.attributes.stroke.value) && (l.applyStrokeEffect(e, t, n, d), t.stroke(), l.endStrokeEffect(e, t)), o());
    }, l.drawNodes = function (e, t, n, r, o) {
      var i = e.length,
          a = -1,
          l = 0,
          c = 0;
      !function u() {
        var d;
        (a += 1) < i ? ((d = e[a]).tagName && "defs" === d.tagName && (d = e[a += 1]), d.attributes && (d.attributes.dy && (c = d.attributes.dy.value = 1 * d.attributes.dy.value + 1 * c), d.attributes.dx && (l = d.attributes.dx.value = 1 * d.attributes.dx.value + 1 * l)), s.common(d, t, n, r, u)) : o && o();
      }();
    }, l.getSvgDimention = function (e) {
      var t,
          n = {
        width: 0,
        height: 0
      };
      return t = e.childNodes && e.childNodes[0] && e.childNodes[0].attributes, n.width = Number(t.width && t.width.value || 0), n.height = Number(t.height && t.height.value || 0), n;
    }, l.storeImagesInArr = function (e) {
      var t,
          n,
          r,
          o,
          i = e.getSVG();

      for (o in r = e._getStore("imageArr"), t = i.getElementsByTagName("image")) {
        t.hasOwnProperty(o) && t[o].attributes && t[o].attributes["xlink:href"] && (n = t[o].attributes["xlink:href"].value, r[n] || (r[n] = [], r[n].status = "progress", r[n].callback = null, r[n].obj = new Image(), r[n].obj.onload = function (e) {
          return function () {
            var t = r[e].callback;
            t ? (r[e].status = "complete", t()) : r[e].status = "complete";
          };
        }(n), r[n].obj.onerror = function (e) {
          return function () {
            var t = r[e].errCallback;
            t ? (r[e].status = "error", t()) : r[e].status = "error";
          };
        }(n), r[n].obj.src = n));
      }
    }, l.startTransform = function (e, t) {
      var n,
          r,
          o = e.match(/[^\s][a-z,0-9.\-(\s]+\)/gi);

      for (r in o) {
        o.hasOwnProperty(r) && (o[r].indexOf("matrix") > -1 && (n = l.stringToArgs(o[r]), t.transform(n[0], n[1], n[2], n[3], n[4], n[5])), o[r].indexOf("translate") > -1 && (n = l.stringToArgs(o[r]), t.translate(n[0] || 0, n[1] || 0)), o[r].indexOf("rotate") > -1 && (3 === (n = l.stringToArgs(o[r])).length ? (t.translate(n[1], n[2]), t.rotate(n[0] * (Math.PI / 180)), t.translate(-n[1], -n[2])) : t.rotate(n[0] * (Math.PI / 180))), o[r].indexOf("scale") > -1 && (1 === (n = l.stringToArgs(o[r])).length ? t.scale(n[0] || 1, n[0] || 1) : t.scale(n[0] || 1, n[1] || 1)), o[r].indexOf("skewX") > -1 && (n = l.stringToArgs(o[r]), t.transform(1, 0, Math.tan(n[0] * (Math.PI / 180)), 1, 0, 0)), o[r].indexOf("skewY") > -1 && (n = l.stringToArgs(o[r]), t.transform(1, Math.tan(n[0] * (Math.PI / 180)), 0, 1, 0, 0)));
      }
    }, l.resetTransform = function (e) {
      e.setTransform(1, 0, 0, 1, 0, 0);
    }, l.stringToArgs = function (e) {
      var t = /\(([^)]+)/.exec(e)[1];
      return l.getArgsAsArray(t);
    }, l.getArgsAsArray = function (e) {
      var t;

      for (e = e.trim().split(/[\s,]+/), t = 0; t < e.length; t++) {
        e[t].trim(), 0 === e[t].length && e.splice(t, 1);
      }

      return e;
    }, l.applyFillEffect = function (e, t, n, r) {
      var o;
      e.attributes["fill-opacity"] && "none" !== e.attributes["fill-opacity"].value ? t.globalAlpha = e.attributes["fill-opacity"].value : t.globalAlpha = 1, e.attributes.fill && e.attributes.fill.value.indexOf("url(") > -1 ? (o = l.getFillStyleById(/url\(.*#([^)'"]+)/.exec(e.attributes.fill.value)[1], t, n, r), t.fillStyle = o) : e.attributes.fill ? t.fillStyle = e.attributes.fill.value : t.fillStyle = "#000000";
    }, l.endFillEffect = function (e, t) {
      t.globalAlpha = 1;
    }, l.applyStrokeEffect = function (e, t, n, r) {
      e.attributes["stroke-opacity"] && "none" !== e.attributes["stroke-opacity"].value && (t.globalAlpha = e.attributes["stroke-opacity"].value), e.attributes["stroke-width"] && (t.lineWidth = e.attributes["stroke-width"].value, "0" === e.attributes["stroke-width"].value && (t.globalAlpha = 0)), e.attributes["stroke-linecap"] && "none" !== e.attributes["stroke-linecap"].value && (t.lineCap = e.attributes["stroke-linecap"].value), e.attributes["stroke-linejoin"] && "none" !== e.attributes["stroke-linejoin"].value && (t.lineJoin = e.attributes["stroke-linejoin"].value), e.attributes["stroke-dasharray"] && "none" !== e.attributes["stroke-dasharray"].value && t.setLineDash && t.setLineDash(l.getArgsAsArray(e.attributes["stroke-dasharray"].value)), e.attributes.stroke ? t.strokeStyle = e.attributes.stroke.value : t.strokeStyle = "#000000";
    }, l.endStrokeEffect = function (e, t) {
      e.attributes["stroke-opacity"] && "none" !== e.attributes["stroke-opacity"].value && (t.globalAlpha = 1, t.setLineDash && t.setLineDash([]), t.lineWidth = 1), t.globalAlpha = 1;
    }, l.applyClip = function (e, t, n) {
      var r,
          o,
          i,
          a,
          c,
          u = n.getSVG();

      if (-1 !== e.indexOf("url(")) {
        for (a in r = /url\(.*#([^)'"]+)/.exec(e)[1], (o = u.getElementById(r)).attributes && (t.save(), o.attributes.transform && l.startTransform(o.attributes.transform.value, t)), i = o.childNodes) {
          i.hasOwnProperty(a) && i[a].tagName && i[a].constructor !== Array && (c = "draw" + i[a].tagName, i[a].attributes && (t.save(), i[a].attributes.transform && l.startTransform(i[a].attributes.transform.value, t)), s[c] && (s[c](i[a], t, n, "clip"), t.closePath()), i[a].attributes && t.restore());
        }

        o.attributes && t.restore(), t.clip();
      }
    }, l.getFillStyleById = function (e, t, n, r) {
      var o = n.getSVG().getElementById(e);
      return "linearGradient" === o.tagName ? l.getLinearGradient(o, t, r) : "radialGradient" === o.tagName ? l.getRadialGradient(o, t, r) : "#FFFFFF";
    }, l.getLinearGradient = function (e, t, n) {
      var r,
          o,
          i,
          a,
          s,
          c = e.attributes.x1 ? l.getPercentValue(e.attributes.x1.value, n.xMax - n.xMin, n.xMin) : 0,
          u = e.attributes.y1 ? l.getPercentValue(e.attributes.y1.value, n.yMax - n.yMin, n.yMin) : 0,
          d = e.attributes.x2 ? l.getPercentValue(e.attributes.x2.value, n.xMax - n.xMin, n.xMin) : 0,
          f = e.attributes.y2 ? l.getPercentValue(e.attributes.y2.value, n.yMax - n.yMin, n.yMin) : 0;

      for (i in r = t.createLinearGradient(c, u, d, f), o = e.childNodes) {
        o.hasOwnProperty(i) && o[i].attributes && o[i].attributes["stop-color"] && (a = l.toRGB(o[i].attributes["stop-color"].value), s = o[i].attributes["stop-opacity"] ? o[i].attributes["stop-opacity"].value : 1, a.status ? r.addColorStop(l.getPercentValue(o[i].attributes.offset.value, 1, 0), "rgba(" + a.r + "," + a.g + "," + a.b + "," + Number(s) + ")") : r.addColorStop(l.getPercentValue(o[i].attributes.offset.value, 1, 0), o[i].attributes["stop-color"].value));
      }

      return r;
    }, l.getRadialGradient = function (e, t, n) {
      var r,
          o,
          i,
          a,
          s,
          c = e.attributes.cx ? l.getPercentValue(e.attributes.cx.value, n.xMax - n.xMin, n.xMin) : n.xMin + .5 * (n.xMax - n.xMin),
          u = e.attributes.cy ? l.getPercentValue(e.attributes.cy.value, n.yMax - n.yMin, n.yMin) : n.yMin + .5 * (n.yMax - n.yMin),
          d = e.attributes.fx ? l.getPercentValue(e.attributes.fx.value, n.xMax - n.xMin, n.xMin) : n.xMin + .5 * (n.xMax - n.xMin),
          f = e.attributes.fy ? l.getPercentValue(e.attributes.fy.value, n.yMax - n.yMin, n.yMin) : n.yMin + .5 * (n.yMax - n.yMin),
          h = e.attributes.r ? l.getPercentValue(e.attributes.r.value, (n.yMax - n.yMin + n.xMax - n.xMin) / 2, 0) : l.getPercentValue("50%", (n.yMax - n.yMin + n.xMax - n.xMin) / 2, 0);

      for (i in r = t.createRadialGradient(d, f, 0, c, u, h), o = e.childNodes) {
        o.hasOwnProperty(i) && o[i].attributes && o[i].attributes["stop-color"] && (a = l.toRGB(o[i].attributes["stop-color"].value), s = o[i].attributes["stop-opacity"] ? o[i].attributes["stop-opacity"].value : 1, a.status ? r.addColorStop(l.getPercentValue(o[i].attributes.offset.value, 1, 0), "rgba(" + a.r + "," + a.g + "," + a.b + "," + Number(s) + ")") : r.addColorStop(l.getPercentValue(o[i].attributes.offset.value, 1, 0), o[i].attributes["stop-color"].value));
      }

      return r;
    }, l.getPercentValue = function (e, t, n) {
      var r;
      return -1 !== e.indexOf("%") ? ((r = /(\d.*)%/.exec(e)[1]) > 100 && (r = 100), r * t / 100 + 1 * n) : e > 1 ? e : e * t + 1 * n;
    }, l.bBoxFromPoint = function (e, t, n) {
      "undefined" != typeof n.xMin && (e.push(n.xMin, n.xMax), t.push(n.yMin, n.yMax)), n.xMin = Math.min.apply(this, e), n.xMax = Math.max.apply(this, e), n.yMin = Math.min.apply(this, t), n.yMax = Math.max.apply(this, t);
    }, l.arcBBox = function (e, t, n, r, o, i, a, s) {
      var l, c, u, d, f, h, p, g, m, v, y;
      a instanceof Array && (e = e * a[0] + e * a[2] + a[4], t = t * a[1] + t * a[3] + a[5]), y = function y(e, t, n) {
        return (e = (e + 2 * Math.PI) % (2 * Math.PI)) <= (t = (t + 2 * Math.PI) % (2 * Math.PI)) ? e <= n && n <= t : e >= t ? !(e >= n && n >= t) : void 0;
      }, l = r % (2 * Math.PI), c = o % (2 * Math.PI), i && (l = o % (2 * Math.PI), c = r % (2 * Math.PI)), u = e + n * Math.cos(l), d = t + n * Math.sin(l), m = [u, e + n * Math.cos(c)], v = [d, t + n * Math.sin(c)], y(l, c, 0) && (m.push(1 * e + 1 * n), v.push(t)), y(l, c, .5 * Math.PI) && (m.push(e), v.push(1 * t + 1 * n)), y(l, c, Math.PI) && (m.push(e - 1 * n), v.push(t)), y(l, c, 1.5 * Math.PI) && (m.push(e), v.push(t - 1 * n)), p = Math.max.apply(this, m), f = Math.min.apply(this, m), g = Math.max.apply(this, v), h = Math.min.apply(this, v), "undefined" != typeof s.xMin ? (s.xMin = Math.min(f, s.xMin), s.xMax = Math.max(p, s.xMax), s.yMin = Math.min(h, s.yMin), s.yMax = Math.max(g, s.yMax)) : (s.xMin = f, s.xMax = p, s.yMin = h, s.yMax = g);
    }, l.qBezierBBox = function (e, t, n, r, o, i, a) {
      var s,
          l,
          c,
          u,
          d,
          f,
          h,
          p,
          g = 1 * e - 2 * n + 1 * o,
          m = 1 * t - 2 * r + 1 * i;
      0 === g || 0 === m ? (d = Math.max(e, o), c = Math.min(e, o), f = Math.max(t, i), u = Math.min(t, i)) : (s = (e - n) / g, l = (t - r) / m, h = e * Math.pow(1 - s, 2) + 2 * n * (1 - s) * s + o * Math.pow(s, 2), p = t * Math.pow(1 - l, 2) + 2 * r * (1 - l) * l + i * Math.pow(l, 2), d = Math.max(e, o, h), c = Math.min(e, o, h), f = Math.max(t, i, p), u = Math.min(t, i, p)), "undefined" != typeof a.xMin ? (a.xMin = Math.min(c, a.xMin), a.xMax = Math.max(d, a.xMax), a.yMin = Math.min(u, a.yMin), a.yMax = Math.max(f, a.yMax)) : (a.xMin = c, a.xMax = d, a.yMin = u, a.yMax = f);
    }, l.cBezierBBox = function (e, t, n, r, o, i, a, s, l) {
      var c, u, d, f, h, p, g, m, v, y, b, x, w;
      null === o && null === i && (o = t + 2 / 3 * (r - t), r = (n = e + 2 / 3 * (n - e)) + 1 / 3 * (a - e), i = o + 1 / 3 * (s - t)), b = function b(e, t, n, r, o) {
        return e * Math.pow(1 - o, 3) + 3 * t * o * Math.pow(1 - o, 2) + 3 * n * o * o * (1 - o) + r * o * o * o;
      }, h = 3 * a - 9 * o + 9 * n - 3 * e, p = 6 * e - 12 * n + 6 * o, g = 3 * n - 3 * e, m = Math.pow(p, 2) - 4 * h * g, u = e, a < (c = e) && (c = a), a > u && (u = a), m >= 0 && ((v = (-p + Math.sqrt(m)) / (2 * h)) > 0 && v < 1 && ((x = b(e, n, o, a, v)) < c && (c = x), x > u && (u = x)), (y = (-p - Math.sqrt(m)) / (2 * h)) > 0 && y < 1 && ((x = b(e, n, o, a, y)) < c && (c = x), x > u && (u = x))), h = 3 * s - 9 * i + 9 * r - 3 * t, p = 6 * t - 12 * r + 6 * i, g = 3 * r - 3 * t, m = Math.pow(p, 2) - 4 * h * g, f = t, s < (d = t) && (d = s), s > f && (f = s), m >= 0 && ((v = (-p + Math.sqrt(m)) / (2 * h)) > 0 && v < 1 && ((w = b(t, r, i, s, v)) < d && (d = w), w > f && (f = w)), (y = (-p - Math.sqrt(m)) / (2 * h)) > 0 && y < 1 && ((w = b(t, r, i, s, y)) < d && (d = w), w > f && (f = w))), "undefined" != typeof l.xMin ? (l.xMin = Math.min(c, l.xMin), l.xMax = Math.max(u, l.xMax), l.yMin = Math.min(d, l.yMin), l.yMax = Math.max(f, l.yMax)) : (l.xMin = c, l.xMax = u, l.yMin = d, l.yMax = f);
    }, l.combineTransformMatrix = function (e) {
      var t,
          n,
          r = e.length - 1;
      if (r <= 0) return e[0];

      for (n = e[0], t = 1; t <= r; t++) {
        n[0] = n[0] * e[t][0] + n[1] * e[t][3], n[1] = n[0] * e[t][1] + n[1] * e[t][4], n[2] = n[0] * e[t][2] + n[1] * e[t][5] + 1 * n[2], n[3] = n[3] * e[t][0] + n[4] * e[t][3], n[4] = n[3] * e[t][1] + n[4] * e[t][4], n[5] = n[3] * e[t][2] + n[4] * e[t][5] + 1 * n[5];
      }

      return n;
    }, l.angleBetweenVectors = function (e, t, n, r) {
      var o = e * r < t * n ? -1 : 1,
          i = e * n + t * r,
          a = Math.sqrt(Math.pow(e, 2) + Math.pow(t, 2)),
          s = Math.sqrt(Math.pow(n, 2) + Math.pow(r, 2));
      return o * Math.acos(i / (a * s));
    }, l.toRGB = function (e) {
      var t,
          n,
          r,
          o = {
        r: 0,
        g: 0,
        b: 0,
        status: 0
      };
      return n = function n(e) {
        for (r in e) {
          e.hasOwnProperty(r) && (e[r] < 0 || isNaN(e[r]) ? e[r] = 0 : e[r] > 255 && (e[r] = 255));
        }

        return o = {
          r: e[0],
          g: e[1],
          b: e[2],
          status: 1
        };
      }, (e = e.trim()).match(/^rgb\(|^rgba\(/i) ? (t = /\(\s*(\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})/.exec(e), n([parseInt(t[1]), parseInt(t[2]), parseInt(t[3])])) : e.match(/^#/) && (t = /(\w{2})(\w{2})(\w{2})/.exec(e), n([parseInt(t[1], 16), parseInt(t[2], 16), parseInt(t[3], 16)])), o;
    }, l.StrToDom = function (e) {
      var t;
      return i.DOMParser ? t = new DOMParser().parseFromString(e, "text/xml") : ((t = new i.ActiveXObject("Microsoft.XMLDOM")).async = !1, t.loadXML(e)), t;
    }, t["default"] = _r4;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = [],
        o = 0,
        i = void 0,
        a = void 0,
        s = void 0,
        l = 500,
        c = 500;

    function u(e) {
      o += e.length + 1, r.push(e);
    }

    t.JpegToPdf = function (e, t) {
      i = e || l, a = t || c;
    }, t.addImage = function (e) {
      var t = /base64,(.+?)$/g.exec(e);
      s = atob(t[1]);
    }, t.getDataUrl = function () {
      return "data:application/pdf;base64," + btoa(function () {
        var e,
            t,
            n = [];

        for (u("%PDF-1.7"), n[1] = o, u("1 0 obj"), u("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), u("endobj"), n[4] = o, u("4 0 obj"), u("<< /Length 36>>"), u("stream"), u("q " + a + " 0 0 " + i + " 0 0 cm /Im3 Do Q"), u("endstream"), u("endobj"), n[5] = o, u("5 0 obj"), u("<</Type /Page /Parent 2 0 R /MediaBox [0 0 " + a + " " + i + "] /Contents [4 0 R ] /Resources <</ProcSet 1 0 R /Font <<>> /XObject <</Im3 3 0 R >> >> >>"), u("endobj"), n[3] = o, u("3 0 obj"), u("<</Type /XObject /Subtype /Image /Width " + a + " /Height " + i + " /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length " + s.length + ">>"), u("stream"), u(s), u("endstream"), u("endobj"), n[2] = o, u("2 0 obj"), u("<</Type /Pages /Kids [5 0 R ] /Count 1>>"), u("endobj"), n[6] = o, u("6 0 obj"), u("<</Type /Catalog /Pages 2 0 R >>"), u("endobj"), e = o, u("xref"), u("0 7"), u("0000000000 65535 f "), t = 1; t <= 6; t++) {
          u(("0000000000" + n[t]).slice(-10) + " 00000 n ");
        }

        return u("trailer"), u("<</Size 7 /Root 6 0 R >>"), u("startxref"), u(e), u("%%EOF"), r.join("\n");
      }());
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.svgStrToDataUrl = t.logCharts = t.extractNonDataImageFromSVG = t.parseUrl = t.extractNonDataURLFromSVG = t.removeImagesWithNonDataURL = t.hasUndownloadableImage = t.replaceImagesWithNonDataUrl = t.embedImagesWithNonDataURL = t.makeImageUrlsAbsolute = t.isCacheAllImagesCompleted = t.getImageCachedDetails = t.cacheAllImages = t.objCacheFunctions = t.createExportActionOldString = t.LOGMODE = t.EXPORTFORMAT = t.EXPORTMODE = t.EXPORTACTION = undefined;
    var r,
        o = n(255),
        i = n(176),
        a = (r = i) && r.__esModule ? r : {
      "default": r
    };

    var s,
        l = function l(e) {
      var t, n, r, o, i, a;
      t = /(<image [^\>]*href=["']([^\>'"]*)["'][^\>]*\>)/g, n = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i, r = [];

      do {
        null !== (o = t.exec(e)) && (i = o[1], a = o[2], n.test(a) || r.push(i));
      } while (o && null !== o);

      return r;
    },
        c = function c(e) {
      var t,
          n = void 0,
          r = void 0;

      for (t = l(e), n = 0; n < t.length; n++) {
        r = t[n], e = e.replace(r, "");
      }

      return e;
    },
        u = function u(e, t) {
      var n, r, o, i, a;
      t = t === undefined || t, n = /<image [^\>]*href=["']([^\>'"]*)["'][^\>]*\>/g, r = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i, o = [];

      do {
        if (null !== (i = n.exec(e))) {
          if (a = i[1], r.test(a)) continue;
          t && (a = d(a).href), o.push(a);
        }
      } while (i && null !== i);

      return o;
    },
        d = function d(e) {
      var t = document.createElement("div");
      return t.innerHTML = "<a></a>", t.firstChild.href = e, t.innerHTML = t.innerHTML, t.firstChild;
    },
        f = {
      DOWNLOAD: "download",
      SAVE: "save",
      DOWNLOADSAVE: "download-save"
    },
        h = {
      CLIENT: "client",
      SERVER: "server",
      AUTO: "auto"
    },
        p = (s = void 0, (s = {}).cacheCompleted = !1, {
      cacheAllImages: function cacheAllImages(e, t, n) {
        var r, i, a, l;
        if (t = t || !1, r = u(e), i = r.length, (0, o.isCanvasElemSupported)() && !t && i) for (a = 0, l = 0; l < i; l++) {
          !function () {
            var e, t;
            (e = r[l]) in s ? i === ++a && (s.cacheCompleted = !0, n()) : ((t = new Image()).crossOrigin = "", t.onload = function () {
              var r, o;
              (r = document.createElement("canvas")).width = t.width, r.height = t.height, r.getContext("2d").drawImage(this, 0, 0);

              try {
                o = r.toDataURL("image/png"), s[e] = {
                  loaded: !0,
                  notCORS: !0,
                  imageUri: o
                };
              } catch (l) {
                s[e] = {
                  loaded: !0,
                  notCORS: !1
                };
              } finally {
                i === ++a && (s.cacheCompleted = !0, n());
              }
            }, t.onerror = function () {
              s[e] = {
                loaded: !1
              }, i === ++a && (s.cacheCompleted = !0, n());
            }, t.src = e);
          }();
        } else n();
      },
      getImageCachedDetails: function getImageCachedDetails(e) {
        return s[e];
      },
      isCacheAllImagesCompleted: function isCacheAllImagesCompleted() {
        return s.cacheCompleted;
      }
    }),
        g = p.cacheAllImages,
        m = p.getImageCachedDetails,
        v = p.isCacheAllImagesCompleted,
        y = function y(e) {
      return e = e.replace(/<image [^\>]*\>/gi, function (e) {
        return e = e.replace(/(:href=")([^"]*)(")/gi, function (e, t, n, r) {
          return t + d(n).href + r;
        });
      });
    },
        b = function b(e) {
      var t,
          n = void 0,
          r = void 0,
          o = void 0;

      for (e = y(e), t = u(e), n = 0; n < t.length; n++) {
        r = t[n], (o = m(r)) !== undefined && o.loaded && o.notCORS && o.imageUri && (e = e.replace(r, o.imageUri));
      }

      return e;
    };

    t.EXPORTACTION = f, t.EXPORTMODE = {
      CLIENT: "client",
      SERVER: "server",
      AUTO: "auto"
    }, t.EXPORTFORMAT = {
      PNG: "png",
      SVG: "svg",
      JPEG: "jpeg",
      JPG: "jpg",
      PDF: "pdf",
      XLS: "xls"
    }, t.LOGMODE = h, t.createExportActionOldString = function (e) {
      return {
        download: f.DOWNLOAD,
        "download-save": f.DOWNLOAD,
        save: f.SAVE
      }[e];
    }, t.objCacheFunctions = p, t.cacheAllImages = g, t.getImageCachedDetails = m, t.isCacheAllImagesCompleted = v, t.makeImageUrlsAbsolute = y, t.embedImagesWithNonDataURL = b, t.replaceImagesWithNonDataUrl = function (e) {
      return e = b(e), e = c(e);
    }, t.hasUndownloadableImage = function (e) {
      return (e = b(e)) !== c(e);
    }, t.removeImagesWithNonDataURL = c, t.extractNonDataURLFromSVG = u, t.parseUrl = d, t.extractNonDataImageFromSVG = l, t.logCharts = function (e, t) {
      t.logEnabled && t.logMode !== h.SERVER && function (e, t) {
        var n = new a["default"](function () {}, function () {});

        for (var r in e) {
          e.hasOwnProperty(r) && (e[r] = encodeURIComponent(e[r]));
        }

        n.post(t.logHandler, e);
      }(e, t);
    }, t.svgStrToDataUrl = function (e) {
      var t = function (e) {
        return '<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">' + e;
      }(e);

      return t = "data:image/svg+xml;base64," + window.btoa(window.unescape(encodeURIComponent(t)));
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(255),
        o = n(257),
        i = n(125),
        a = n(258),
        s = n(131),
        l = window,
        c = void 0,
        u = Math.max,
        d = l.Image,
        f = l.navigator.userAgent.match(/(iPad|iPhone|iPod)/g),
        h = "IMAGE-DATA",
        p = "https:" === l.location.protocol ? "https://export.api3.fusioncharts.com/api/v1.0/logs" : "http://export.api3.fusioncharts.com/api/v1.0/logs",
        g = "https:" === l.location.protocol ? "https://export.api3.fusioncharts.com/" : "http://export.api3.fusioncharts.com/",
        m = "",
        v = void 0;

    function y() {
      var e,
          t,
          n,
          y,
          b,
          x = arguments[0] || {},
          w = void 0,
          C = void 0,
          _ = void 0,
          S = void 0,
          E = void 0,
          k = 0,
          A = !1,
          T = void 0,
          M = void 0,
          O = void 0,
          F = {
        exportTargetWindow: (0, i.pluck)(x.exportTargetWindow, f ? "_parent" : "_self"),
        exportAction: x.exportAction && "string" == typeof x.exportAction ? (n = x.exportAction.toLowerCase(), [a.EXPORTACTION.DOWNLOAD, a.EXPORTACTION.SAVE, a.EXPORTACTION.DOWNLOADSAVE].indexOf(n) >= 0 ? n : a.EXPORTACTION.DOWNLOAD) : a.EXPORTACTION.DOWNLOAD,
        exportFileName: (0, i.pluck)(x.exportFileName, "FusionCharts"),
        exportHandler: (0, i.pluck)(x.exportHandler, g),
        exportParameters: (0, i.pluck)(x.exportParameters, m),
        exportFormat: (0, i.pluck)(x.exportFormat, a.EXPORTFORMAT.PNG),
        exportCallback: (0, i.pluck)(x.exportCallback, m),
        exportAtClientSide: (0, i.pluckNumber)(x.exportAtClientSide, 1),
        exportMode: ("undefined" != typeof x.exportAtClientSide && (t = {
          1: a.EXPORTMODE.AUTO,
          0: a.EXPORTMODE.SERVER
        }[x.exportAtClientSide]), t = (t = x.exportMode || t || a.EXPORTMODE.AUTO).toLowerCase()),
        logEnabled: (0, i.pluckNumber)(x.logEnabled, 0),
        logMode: (e = x.logMode, void 0 !== e && "string" == typeof e && e.toUpperCase() in a.LOGMODE ? a.LOGMODE[e.toUpperCase()] : a.LOGMODE.AUTO),
        logHandler: (0, i.pluck)(x.logHandler, p)
      },
          I = F.exportFormat.toLowerCase(),
          L = 0,
          N = 0,
          D = void 0,
          P = l.document,
          R = v.items,
          j = function j(e, t, n, r) {
        var o = e,
            a = t;
        return isNaN(o) && (o = (0, i.pluckNumber)(t, r) * (n / r)), isNaN(a) && (a = (0, i.pluckNumber)(e, n) * (r / n)), {
          width: o,
          height: a
        };
      },
          V = function V(e, t, n) {
        var r, o, s, l;
        return n = n || F.exportAction, r = F.exportAction, o = (0, a.createExportActionOldString)(F.exportAction), s = ["exportfilename=" + F.exportFileName, "exportformat=" + F.exportFormat, "exportaction=" + o, "exportactionnew=" + r, "configuredexportaction=" + n, "exportparameters=" + F].join("|"), l = !!F.logEnabled, F.logMode === a.LOGMODE.CLIENT && (l = !1), {
          charttype: "combined",
          stream_type: e || "",
          stream: t || "",
          is_single_export: !1,
          is_full_version: !1,
          version: i.PROJECT_VERSION,
          user_time_zone: -new Date().getTimezoneOffset(),
          log_enabled: l,
          parameters: s
        };
      },
          B = function B() {
        return {
          chartType: "combined",
          isSingleExport: !1,
          isFullVersion: !1,
          exportAction: F.exportAction,
          userTimeZone: -new Date().getTimezoneOffset(),
          exportFileName: [F.exportFileName, F.exportFormat].join("."),
          exportFormat: F.exportFormat,
          version: i.PROJECT_VERSION
        };
      },
          H = function H(e) {
        e === a.LOGMODE.CLIENT && (0, a.logCharts)(B(), F);
      },
          G = function G(e) {
        var t, n, o;
        (0, s.triggerEvent)("beforeexport", c, c, c, function () {
          n = "undefined" != typeof l.btoa && ("Chrome" === r.browserDetails.name || "Firefox" === r.browserDetails.name || "Safari" === r.browserDetails.name || "Edge" === r.browserDetails.name || "ie" === r.browserDetails.name), F.exportMode === a.EXPORTMODE.CLIENT || F.exportMode === a.EXPORTMODE.AUTO && n ? (F.exportAction !== a.EXPORTACTION.DOWNLOAD && F.exportAction !== a.EXPORTACTION.DOWNLOADSAVE || (t = F.exportMode === a.EXPORTMODE.AUTO ? V(h, e) : null, (0, r.downloadCharts)("url", e, F.exportFileName + "." + I, t, F), (0, s.triggerEvent)("exported", c, {
            fileName: F.exportFileName + "." + I
          })), F.exportAction === a.EXPORTACTION.SAVE || F.exportAction === a.EXPORTACTION.DOWNLOADSAVE ? (o = F.exportAction, F.exportAction === a.EXPORTACTION.DOWNLOADSAVE && (F.exportAction = a.EXPORTACTION.SAVE), t = V(h, e, o), F.paper = {
            width: undefined,
            height: undefined
          }, F.fusionCharts = {}, (0, r.downloadCharts)(null, null, null, t, F), delete F.paper, delete F.fusioncharts, H(F.logMode)) : F.logMode !== a.LOGMODE.SERVER && (0, a.logCharts)(B(), F)) : (t = V(h, e), F.paper = {
            width: undefined,
            height: undefined
          }, F.fusionCharts = {}, (0, r.downloadCharts)(null, null, null, t, F), delete F.paper, delete F.fusioncharts, H(F.logMode));
        }, function () {
          (0, s.triggerEvent)("exportcancelled");
        });
      },
          z = function z(e, t) {
        var n, i;
        (w = v.items[e]).jsVars.instanceAPI && (E = (E = (E = (E = w.jsVars.instanceAPI.getFromEnv("paper").toSVG(!0)).replace(/NS\d+:/gi, "xlink:")).replace(/(\sd\s*=\s*["'])[M\s\d\.]*(["'])/gi, "$1M 0 0 L 0 0$2")).replace(/(xlink:title\s*=\s*)['"].*["']/gi, ""), k += 1, n = E, i = v.options["export"].useCanvas, (0, a.cacheAllImages)(n, !1, function () {
          n = (0, a.replaceImagesWithNonDataUrl)(n), function () {
            (0, r.drawSvgOnCanvas)({
              svg: arguments[0],
              canvas: _,
              x: this.x,
              y: this.y,
              width: this.width,
              height: this.height,
              useCanvas: arguments[1]
            }, function () {
              if (0 == (k -= 1) && A) switch (I) {
                case "png":
                  G(_.toDataURL("image/png"));
                  break;

                case "jpeg":
                  G(_.toDataURL("image/jpeg"));
                  break;

                case "pdf":
                  (0, o.JpegToPdf)(L, N), (0, o.addImage)(_.toDataURL("image/jpeg")), G((0, o.getDataUrl)());
                  break;

                default:
                  G(_.toDataURL("image/png"));
              }
            });
          }.call(t || w, n, i);
        }));
      };

      if (y = F.exportMode, (b = {})[a.EXPORTMODE.CLIENT] = 1, b[a.EXPORTMODE.AUTO] = 0, b[a.EXPORTMODE.SERVER] = 0, F.exportatclientside = b[y], r.browserDetails.hasCanvas) {
        for (function () {
          var e,
              t,
              n,
              r,
              o = x.charts;
          if (C = [], o) for (n in o) {
            o.hasOwnProperty(n) && (e = R[o[n].id]) && (t = o[n], r = j(Number(t.width), Number(t.height), e.width, e.height), C.push({
              id: e.id,
              width: r.width,
              height: r.height,
              x: t.x,
              y: t.y
            }));
          } else for (n in R) {
            R.hasOwnProperty(n) && (e = R[n], C.push({
              id: e.id,
              width: e.width,
              height: e.height
            }));
          }
        }(), D = 0, T = C.length; D < T; D += 1) {
          (O = C[D]).x = (0, i.pluckNumber)(O.x, 5), O.y = (0, i.pluckNumber)(O.y, L + 5), O.height = (0, i.pluckNumber)(O.height), O.width = (0, i.pluckNumber)(O.width), L = u(L, O.y + O.height), N = u(N, O.x + O.width);
        }

        var U, $, X;
        L = x.imageHeight || L + 5, N = x.imageWidth || N + 5, U = function U() {
          for (D = 0, T = C.length; D < T; D += 1) {
            O = C[D], D === T - 1 && (A = !0), z(O.id, O);
          }
        }, X = x.background, (_ = P.createElement("canvas")).id = "newCanvas", _.width = N, _.height = L, _.style.border = "1px solid black", (S = _.getContext("2d")).fillStyle = X && X.bgColor || "#ffffff", S.fillRect(0, 0, N, L), !X || !X.bgImage || ($ = X.bgImage).match(/http:\/\/|https:\/\//) && /(http:\/\/|https:\/\/)([^\/\:]*)/.exec($)[2] && l.location.hostname !== /(http:\/\/|https:\/\/)([^\/\:]*)/.exec($)[2] ? U() : ((M = new d()).src = X.bgImage, M._userData = X, S.globalAlpha = (0, i.pluckNumber)(X.bgImageAlpha, 100) / 100, M.onload = function () {
          var e = this._userData,
              t = (0, i.pluckNumber)(e.bgImageX, 0),
              n = (0, i.pluckNumber)(e.bgImageY, 0),
              r = j(Number(e.bgImageWidth), Number(e.bgImageHeight), this.width, this.height),
              o = r.width,
              a = r.height;

          try {
            S.drawImage(this, t, n, o, a);
          } finally {
            S.globalAlpha = 1, U();
          }
        }, M.onerror = function () {
          U();
        });
      }
    }

    t["default"] = {
      extension: function extension(e) {
        e.batchExport = y, v = e;
      },
      name: "batchExportLinker",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(261),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(125);
    t["default"] = {
      extension: function extension(e) {
        e.addEventListener("instantiated", function (e) {
          var t = e.sender;
          (function (e, t) {
            return e.getType() === t;
          })(t, "chartAPI") && t.registerFactory("logo", function (e) {
            var t = e.getFromEnv("chart-attrib"),
                n = (0, a.getValidValue)(t.logourl, "");
            (0, a.componentFactory)(e, i["default"], "logo", n ? 1 : 0, [t]);
          });
        });
      },
      name: "LogoExtension",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(138),
        o = n(125);

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var a = {
      vAlign: "top",
      hAlign: "left"
    },
        s = {
      link: {
        cursor: "pointer",
        _cursor: "pointer"
      },
      normal: {
        cursor: "default",
        _cursor: "normal"
      }
    },
        l = {
      tr: {
        vAlign: "top",
        hAlign: "right"
      },
      bl: {
        vAlign: "bottom",
        hAlign: "left"
      },
      br: {
        vAlign: "bottom",
        hAlign: "right"
      },
      cc: {
        vAlign: "middle",
        hAlign: "middle"
      }
    },
        c = !(!window.SVGAngle && !document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1")),
        u = function u(e) {
      var t = e.config;
      return {
        load: function load() {
          var n = void 0,
              r = e.getGraphicalElement("logoImage"),
              i = e.getFromEnv("chartConfig"),
              a = i.borderWidth || 0,
              s = e.getFromEnv("chart"),
              l = i.height,
              u = i.width,
              d = t.logoPosition,
              f = t.logoScale,
              h = t.logoLeftMargin,
              p = t.logoTopMargin,
              g = t.logoURL,
              m = t.logoAlpha,
              v = t.logoPositionSTR,
              y = t.logoLink;
          r.show(), n = (0, o.setImageDisplayMode)("none", d.vAlign, d.hAlign, f, a, u, l, r._.RefImg), c && (n.w = n.width || 0, n.h = n.height || 0), n.transform = "T" + h + "," + p, r.attr(n), s.fireChartInstanceEvent("LogoLoaded", {
            logoURL: g,
            logoAlpha: m,
            logoPosition: v,
            logoScale: f,
            logoLink: y
          });
        },
        error: function error(n) {
          var r = t.logoURL,
              o = t.logoAlpha,
              i = t.logoPositionSTR,
              a = t.logoScale,
              s = t.logoLink;
          e.getFromEnv("chart").fireChartInstanceEvent("LogoLoadError", {
            logoURL: r,
            logoAlpha: o,
            logoPosition: i,
            logoScale: a,
            logoLink: s,
            error: n
          });
        },
        mouseover: function mouseover(n) {
          var r = e.getFromEnv("chartInstance"),
              i = (0, o.getMouseCoordinate)(r.ref, n),
              a = e.getFromEnv("chart"),
              s = t.logoURL,
              l = t.logoAlpha,
              c = t.logoPositionSTR,
              u = t.logoScale,
              d = t.logoLink;
          a.fireChartInstanceEvent("LogoRollover", {
            logoURL: s,
            logoAlpha: l,
            logoPosition: c || "tl",
            logoScale: u,
            logoLink: d,
            chartX: i.chartX,
            chartY: i.chartY,
            pageX: i.pageX,
            pageY: i.pageY
          });
        },
        mouseout: function mouseout(n) {
          var r = e.getFromEnv("chartInstance"),
              i = (0, o.getMouseCoordinate)(r.ref, n),
              a = e.getFromEnv("chart"),
              s = t.logoURL,
              l = t.logoAlpha,
              c = t.logoPositionSTR,
              u = t.logoScale,
              d = t.logoLink;
          a.fireChartInstanceEvent("LogoRollout", {
            logoURL: s,
            logoAlpha: l,
            logoPosition: c || "tl",
            logoScale: u,
            logoLink: d,
            chartX: i.chartX,
            chartY: i.chartY,
            pageX: i.pageX,
            pageY: i.pageY
          });
        },
        click: function click(n) {
          var r = e.getFromEnv("chartInstance"),
              i = (0, o.getMouseCoordinate)(r.ref, n),
              a = e.getFromEnv("chart"),
              s = t.logoURL,
              l = t.logoAlpha,
              c = t.logoPositionSTR,
              u = t.logoScale,
              d = t.logoLink;
          a.fireChartInstanceEvent("LogoClick", {
            logoURL: s,
            logoAlpha: l,
            logoPosition: c || "tl",
            logoScale: u,
            logoLink: d,
            chartX: i.chartX,
            chartY: i.chartY,
            pageX: i.pageX,
            pageY: i.pageY
          }, void 0, t.linkClickFN);
        }
      };
    },
        d = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this)),
            r = n;

        return r.config._context = {}, r.config.handler = u(r), r.config.linkClickFN = function () {
          var e = r.config.logoLink;
          e && r.getFromEnv("linkClickFN").call({
            link: e
          }, !0);
        }, n;
      }

      return i(t, e), t.prototype.configureAttributes = function () {
        var e = this.config,
            t = this.getFromEnv("chart-attrib");
        e.logoURL = (0, o.getValidValue)(t.logourl, ""), e.logoPositionSTR = (0, o.pluck)(t.logoposition, "tl").toLowerCase(), e.logoPosition = l[e.logoPositionSTR] || a, e.logoAlpha = (0, o.pluckNumber)(t.logoalpha, 100), e.logoLink = (0, o.getValidValue)(t.logolink), e.logoScale = (0, o.pluckNumber)(t.logoscale, 100), e.logoLeftMargin = (0, o.pluckNumber)(t.logoleftmargin, 0), e.logoTopMargin = (0, o.pluckNumber)(t.logotopmargin, 0), this.setState("dirty", !0);
      }, t.prototype._contextChanged = function () {
        var e = this.config,
            t = this.getFromEnv("chartConfig"),
            n = t.borderWidth,
            r = t.width,
            o = t.height,
            i = void 0;
        return n !== e._context.chartBorderWidth && (e._context.chartBorderWidth = n, i = !0), r !== e._context.chartWidth && (e._context.chartWidth = r, i = !0), o !== e._context.chartHeight && (e._context.chartHeight = o, i = !0), i;
      }, t.prototype.draw = function () {
        var e = this.config,
            t = this.getFromEnv("animationManager"),
            n = this.getGraphicalElement("logoImage"),
            r = this.getLinkedParent().getChildContainer("logoGroup"),
            o = e.logoAlpha,
            i = e.logoURL,
            a = e.logoLink,
            l = !this.getState("removed"),
            c = this._contextChanged();

        (!l || this.getState("dirty") || c) && i && l && (n = t.setAnimation({
          el: n || "image",
          attr: {
            opacity: .01 * o || 1,
            src: i
          },
          component: this,
          container: r
        }), this.getGraphicalElement("logoImage") || (this.addGraphicalElement("logoImage", n), n.on("load", e.handler.load), n.on("error", e.handler.error), n.on("fc-click", e.handler.click), n.on("fc-mouseover", e.handler.mouseover), n.on("fc-mouseout", e.handler.mouseout)), n.css(s[a ? "link" : "normal"]));
      }, t;
    }(r.ComponentInterface);

    t["default"] = d;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };
    t["default"] = {
      extension: function extension(e) {
        e.addEventListener("register", function (t, n) {
          var o = void 0,
              i = n[0],
              a = n[1];

          if (i && "string" == typeof i && "theme" === i && a && "object" === (void 0 === a ? "undefined" : r(a))) {
            if (a instanceof Array) for (o = 0; o < a.length; o++) {
              e.addDep({
                extension: a[o],
                name: a[o].name + "Theme",
                type: "theme"
              });
            } else e.addDep({
              extension: a,
              name: a.name + "Theme",
              type: "theme"
            });
            t.preventDefault();
          }
        });
      },
      name: "ThemeEngine",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        i = n(131);
    (r = {
      outputHelpers: {
        text: function text(e, t) {
          var n = (e.sender.id || e.sender).toString();
          r.outputTo("#" + e.eventId + " [" + n + '] fired "' + e.eventType + '" event. ' + ("error" === e.eventType || "warning" === e.eventType ? t.message : ""));
        },
        event: function event(e, t) {
          this.outputTo(e, t);
        },
        verbose: function verbose(e, t) {
          r.outputTo(e.eventId, e.sender.id, e.eventType, t);
        }
      },
      outputHandler: function outputHandler(e, t) {
        "function" == typeof r.outputTo && r.currentOutputHelper(e, t);
      },
      currentOutputHelper: void 0,
      outputTo: void 0,
      enabled: !1
    }).currentOutputHelper = r.outputHelpers.text, t["default"] = {
      extension: function extension(e) {
        e["debugger"] = {
          outputFormat: function outputFormat(e) {
            return !(!e || "function" != typeof e.toLowerCase || "function" != typeof r.outputHelpers[e = e.toLowerCase()]) && (r.currentOutputHelper = r.outputHelpers[e], !0);
          },
          outputTo: function outputTo(t) {
            "function" == typeof t ? r.outputTo = t : null === t && (e["debugger"].enable(!1), delete r.outputTo);
          },
          enable: function enable(t, n, a) {
            var s;
            return "object" === (void 0 === t ? "undefined" : o(t)) && 1 === arguments.length && (t = (s = t).state, n = s.outputTo, a = s.outputFormat), "function" == typeof t && ("string" != typeof n || 2 !== arguments.length && !s || (a = n), n = t, t = !0), "boolean" == typeof t && t !== r.enabled && (r.enabled = t, r.enabled ? (0, i.addListener)("*", r.outputHandler) : (0, i.removeListener)("*", r.outputHandler)), "function" == typeof n && (r.outputTo = n), e["debugger"].outputFormat(a), r.enabled;
          }
        };
      },
      name: "Debugger",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        i = n(265),
        a = (r = i) && r.__esModule ? r : {
      "default": r
    },
        s = n(125),
        l = n(136);
    var c = 0,
        u = void 0;

    function d(e, t) {
      var n = this.apiInstance,
          r = n.getChildren("dataset")[0],
          i = r.getChildren(),
          d = i.centerLabel && i.centerLabel[0],
          f = n.config;
      d === u && ((0, s.componentFactory)(r, a["default"], "centerLabel", 1, [f]), d = i.centerLabel && i.centerLabel[0]), n.addJob("eiMethods-center-lebel" + c++, function () {
        var r,
            i,
            a = n.getDatasets()[0],
            s = a.config.piePlotOptions.innerSize;
        if (r = d.config, "object" !== (void 0 === t ? "undefined" : o(t))) t = r;else {
          for (i in r) {
            t[i] === u && (t[i] = r[i]);
          }

          r = Object.assign(r, t);
        }
        t.label = e, r.label = e, a.centerLabelConfig = r, s && d && d.draw(e || "");
      }, l.priorityList.postRender);
    }

    t["default"] = {
      extension: function extension(e) {
        var t;
        e.addEventListener("instantiated", function (e) {
          var n = e.sender;
          !t && (t = function (e) {
            return "chartAPI" === e.getType();
          }(n) && (function (e) {
            return "Doughnut2D" === e.getName();
          }(n) || function (e) {
            return "MultilevelPie" === e.getName();
          }(n))), t && function (e) {
            return "dataset" === e.getType();
          }(n) && n.registerFactory("centerLabel", function () {
            var e = n.getFromEnv("chartConfig"),
                r = n.getFromEnv("chartInstance"),
                o = !(!e.centerlabel && !e.defaultcenterlabel);
            r.centerLabel = d, (0, s.componentFactory)(n, a["default"], "centerLabel", o ? 1 : 0, [e]), t = u;
          });
        });
      },
      name: "CenterLabelExtension",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(138),
        i = n(125),
        a = n(132),
        s = n(266),
        l = (r = s) && r.__esModule ? r : {
      "default": r
    };

    function c(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    (0, a.addDep)({
      name: "centerLabelAnimation",
      type: "animationRule",
      extension: l["default"]
    });

    var u = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return c(t, e), t.prototype.getName = function () {
        return "centerLabel";
      }, t.prototype.getType = function () {
        return "centerLabel";
      }, t.prototype.configure = function (e) {
        var t = this.getFromEnv("chart-attrib"),
            n = this.getFromEnv("number-formatter"),
            r = e.dataLabelStyle,
            o = this;
        o.config = {
          label: (0, i.parseUnsafeString)((0, i.pluck)(t.defaultcenterlabel, "")),
          font: (0, i.pluck)(t.centerlabelfont, r.fontFamily),
          fontSize: (0, i.pluckNumber)(t.centerlabelfontsize, parseInt(r.fontSize, 10)),
          color: (0, i.getFirstColor)((0, i.pluck)(t.centerlabelcolor, t.valuefontcolor, e.style.inCanvasStyle.color, "555555")),
          alpha: (0, i.pluckNumber)(t.centerlabelalpha, 100),
          bold: (0, i.pluckNumber)(t.centerlabelbold, r.fontWeight),
          italic: (0, i.pluckNumber)(t.centerlabelitalic, r.style),
          bgColor: (0, i.pluck)(t.centerlabelbgcolor, ""),
          bgAlpha: (0, i.pluckNumber)(t.centerlabelbgalpha, 100),
          borderColor: (0, i.pluck)(t.centerlabelbordercolor, r.borderColor),
          borderAlpha: (0, i.pluckNumber)(t.centerlabelborderalpha, 100),
          borderThickness: (0, i.pluckNumber)(t.centerlabelborderthickness, r.borderThickness),
          borderRadius: (0, i.pluckNumber)(t.centerlabelborderradius, r.borderRadius),
          textPadding: (0, i.pluckNumber)(t.centerlabeltextpadding, r.borderPadding),
          padding: (0, i.pluckNumber)(t.centerlabelpadding, 2),
          bgOval: (0, i.pluckNumber)(t.centerlabelbgoval, 0),
          shadow: (0, i.pluckNumber)(t.showcenterlabelshadow, 0),
          hoverColor: t.centerlabelhovercolor && (0, i.getFirstColor)((0, i.pluck)(t.centerlabelhovercolor)),
          hoverAlpha: (0, i.pluckNumber)(t.centerlabelhoveralpha),
          toolText: (0, i.parseUnsafeString)((0, i.pluck)(t.centerlabeltooltext, i.BLANKSTRING))
        }, o.addExtEventListener("datasetrollover", function (e) {
          var t = e.sender.getFromEnv("dataSource"),
              r = e.data,
              a = (0, i.pluck)(function (e, t, n) {
            if (e) for (var r, o = t.length || 0; o--;) {
              r = new RegExp(t[o], "gi"), e = e.replace(r, n[o]);
            }
            return e;
          }(t.chart.centerlabel, ["\\$value", "\\$percentValue", "\\$displayValue", "\\$label"], [n.scale(r.value), r.pValue, r.displayValue, r.label]), "");
          o.draw(a, !1);
        }, this.getFromEnv("chart").getDatasets()[0]), o.addExtEventListener("datasetrollout", function (e) {
          var t = e.sender.config.label,
              n = (0, i.pluck)(t, "");
          o.draw(n, !1);
        }, this.getFromEnv("chart").getDatasets()[0]);
      }, t.prototype.draw = function (e) {
        var t,
            n = this,
            r = n.getFromEnv("chart"),
            o = r.config.canvasLeft + .5 * r.config.canvasWidth,
            a = r.config.canvasTop + .5 * r.config.canvasHeight,
            s = r.getDatasets()[0].config.innerSize,
            l = r.getDatasets()[0].config.innerSize,
            c = r.getDatasets()[0].config,
            u = this.config,
            d = n.getFromEnv("animationManager"),
            f = n.getFromEnv("smartLabel"),
            h = this.getGraphicalElement("centerLabel"),
            p = h,
            g = this.getGraphicalElement("centerLabelBg"),
            m = r.getChildContainer("plotGroup"),
            v = u.padding,
            y = 2 * u.textPadding,
            b = {
          fontFamily: u.font,
          fontSize: u.fontSize + "px",
          lineHeight: 1.2 * u.fontSize + "px",
          fontWeight: u.bold ? "bold" : "",
          fontStyle: u.italic ? "italic" : ""
        },
            x = 1.414 * (.5 * s - v) - y,
            w = 1.414 * (.5 * l - v) - y,
            C = n.getFromEnv("toolTipController");
        e = (0, i.pluck)(e, u.label), f.setStyle(b), f.useEllipsesOnOverflow(r.config.useEllipsesWhenOverflow), t = f.getSmartText(e, x, w), e ? (u.bgOval && (g = d.setAnimation({
          el: g || "circle",
          attr: {
            cx: o,
            cy: a,
            r: .5 * s - v,
            visibility: "visible",
            container: m,
            fill: (0, i.hashify)(u.bgColor),
            "fill-opacity": u.bgAlpha / 100,
            stroke: (0, i.hashify)(u.borderColor),
            "stroke-width": u.borderThickness,
            "stroke-opacity": u.borderAlpha / 100
          },
          component: n
        })), p = d.setAnimation({
          el: h || "text",
          component: n,
          container: m,
          css: b,
          attr: {
            x: o,
            y: a,
            text: t.text,
            visibility: "visible",
            direction: r.config.textDirection,
            fill: (0, i.toRaphaelColor)({
              FCcolor: {
                color: u.color,
                alpha: u.alpha
              }
            }),
            "text-bound": u.bgOval ? "none" : [(0, i.toRaphaelColor)({
              FCcolor: {
                color: u.bgColor,
                alpha: u.bgAlpha
              }
            }), (0, i.toRaphaelColor)({
              FCcolor: {
                color: u.borderColor,
                alpha: u.borderAlpha
              }
            }), u.borderThickness, u.textPadding, u.borderRadius]
          },
          label: "text"
        }), C.enableToolTip(p, u.toolText || t.tooltext)) : (p && d.setAnimation({
          el: p,
          attr: {
            visibility: "hidden"
          },
          component: n
        }), g && d.setAnimation({
          el: g,
          attr: {
            visibility: "hidden"
          },
          component: n
        })), h ? p.attr("text") !== e && n.centerLabelChange(e) : (n.addEventListener("fc-mouseover", function () {
          n._centerLabelRollover(r);
        }), n.addEventListener("fc-mouseout", function () {
          n._centerLabelRollout(r);
        }), n.addEventListener("fc-click", function () {
          n._centerLabelClick(r);
        }), n.addGraphicalElement("centerLabel", p), n.addGraphicalElement("centerLabelBg", g)), c.lastCenterLabelConfig = u, c.centerLabelConfig = u;
      }, t.prototype.centerLabelChange = function (e) {
        var t = this.getFromEnv("chart"),
            n = t.config,
            r = this.getFromEnv("chartInstance"),
            o = {
          height: n.height,
          width: n.width,
          pixelHeight: t.getFromEnv("chartWidth"),
          pixelWidth: t.getFromEnv("chartHeight"),
          id: r.id,
          renderer: r.args.renderer,
          container: r.options.containerElement,
          centerLabelText: e
        };
        t.fireChartInstanceEvent("centerLabelChanged", o);
      }, t.prototype._centerLabelRollover = function (e) {
        var t = e.config,
            n = e.getFromEnv("chartInstance"),
            r = this.config,
            o = {
          height: t.height,
          width: t.width,
          pixelHeight: e.getFromEnv("chartWidth"),
          pixelWidth: e.getFromEnv("chartHeight"),
          id: n.id,
          renderer: n.args.renderer,
          container: n.options.containerElement,
          centerLabelText: r && r.label
        };
        this.getFromEnv("paper").attr("text") && e.fireChartInstanceEvent("centerLabelRollover", o, void 0, this.hoverOnCenterLabel.bind(this, e));
      }, t.prototype._centerLabelRollout = function (e) {
        var t = e.config,
            n = e.getFromEnv("chartInstance"),
            r = this.config,
            o = {
          height: t.height,
          width: t.width,
          pixelHeight: e.getFromEnv("chartWidth"),
          pixelWidth: e.getFromEnv("chartHeight"),
          id: n.id,
          renderer: n.args.renderer,
          container: n.options.containerElement,
          centerLabelText: r && r.label
        };
        this.getFromEnv("paper").attr("text") && e.fireChartInstanceEvent("centerLabelRollout", o, void 0, this.hoverOffCenterLabel.bind(this, e));
      }, t.prototype._centerLabelClick = function (e) {
        var t,
            n = e.config,
            r = e.getFromEnv("chartInstance"),
            o = {
          height: n.height,
          width: n.width,
          pixelHeight: e.getFromEnv("chartWidth"),
          pixelWidth: e.getFromEnv("chartHeight"),
          id: r.id,
          renderer: r.args.renderer,
          container: r.options.containerElement
        };
        t = this.config, o.centerLabelText = t && t.label, this.getFromEnv("paper").attr("text") && e.fireChartInstanceEvent("centerLabelClick", o);
      }, t.prototype.hoverOnCenterLabel = function (e) {
        var t = e.getChildren("dataset")[0].config.lastCenterLabelConfig;
        (t.hoverColor || t.hoverAlpha) && this.getGraphicalElement("centerLabel").attr({
          fill: (0, i.toRaphaelColor)({
            FCcolor: {
              color: t.hoverColor || t.color,
              alpha: t.hoverAlpha || t.alpha
            }
          })
        });
      }, t.prototype.hoverOffCenterLabel = function (e) {
        var t = e.getChildren("dataset")[0].config.lastCenterLabelConfig;
        (t.hoverColor || t.hoverAlpha) && this.getGraphicalElement("centerLabel").attr({
          fill: (0, i.toRaphaelColor)({
            FCcolor: {
              color: t.color,
              alpha: t.alpha
            }
          })
        });
      }, t;
    }(o.ComponentInterface);

    t["default"] = u;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = {
      "initial.centerLabel.centerLabel.text.appearing": function initialCenterLabelCenterLabelTextAppearing(e) {
        if (e.attr) return [{
          initialAttr: {
            x: e.attr.x,
            y: e.attr.y
          }
        }];
      }
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(125),
        o = a(n(268)),
        i = a(n(270));

    function a(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var s = {
      dragnode: !0,
      hlineargauge: !0,
      column3d: !0,
      mscolumn3d: !0,
      bar3d: !0,
      pareto3d: !0,
      msbar3d: !0,
      stackedcolumn3d: !0,
      stackedbar3d: !0,
      mscombi3d: !0,
      mscolumnline3d: !0,
      stackedcolumn3dline: !0,
      mscolumn3dlinedy: !0,
      stackedcolumn3dlinedy: !0,
      realtimearea: !0,
      realtimecolumn: !0,
      realtimeline: !0,
      realtimestackedarea: !0,
      realtimestackedcolumn: !0,
      angulargauge: !0,
      realtimelinedy: !0,
      kagi: !0,
      scrollcolumn2d: !0,
      scrollline2d: !0,
      scrollarea2d: !0,
      scrollstackedcolumn2d: !0,
      scrollcombi2d: !0,
      scrollcombidy2d: !0,
      scrollcombi2dspline: !0,
      treemap: !0,
      heatmap: !0,
      boxandwhisker2d: !0,
      scatter: !0,
      timeseries: !0,
      bubble: !0,
      errorscatter: !0,
      sparkwinloss: !0,
      zoomscatter: !0,
      zoomline: !0,
      zoomlinedy: !0
    };
    t["default"] = {
      extension: function extension(e) {
        e.addEventListener("preconfigure", function (e) {
          if ("chartAPI" === e.sender.getType()) {
            var t = e.sender,
                n = t.getFromEnv("chartInstance");

            n.drawCrossline = function (e) {
              n.drawConsolidatedToolTip(e), t.iterateComponents(function (t) {
                "crossline-manager" === t.getType() && (e !== undefined ? t.show({
                  value: e
                }) : t.hide());
              });
            };
          }
        }), e.addEventListener("instantiated", function (e) {
          if ("canvas" === e.sender.getName()) {
            var t = e.sender,
                n = void 0,
                a = void 0;
            t.registerFactory("crossLineManager", function () {
              var l = e.sender.getFromEnv("chart"),
                  c = l && l.getName();
              c && !s[c.toLowerCase()] && ((0, r.componentFactory)(t, i["default"], "crosslineManagerBand"), n = t.getChildren("crosslineManagerBand")[0], a = n._handlerAPI, n.configure(), (0, r.componentFactory)(n, o["default"], "crossline"), n.addExtEventListener("fc-mouseover", a.onhover, t), n.addExtEventListener("fc-mousemove", a.onhover, t), n.addExtEventListener("fc-mouseout", a.onhoverout, t));
            });
          }
        });
      },
      name: "crossline-manager",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(138),
        i = n(125),
        a = n(132),
        s = n(269),
        l = (r = s) && r.__esModule ? r : {
      "default": r
    };

    function c(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var u = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this));

        return (0, a.addDep)({
          name: "crosslineAnimation",
          type: "animationRule",
          extension: l["default"]
        }), n;
      }

      return c(t, e), t.prototype.getName = function () {
        return "crossline";
      }, t.prototype.getType = function () {
        return "crossline";
      }, t.prototype.show = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            t = !!e.onTop,
            n = e.type;
        t !== this.config.prevRenderedOnTop && this.hide(), !this[n] && (n = "band"), this[n](e), this.config.prevRenderedOnTop = t;
      }, t.prototype.band = function () {
        var e,
            t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            n = t.managerId,
            r = t.x1,
            o = t.y1,
            a = t.x2,
            s = t.y2,
            l = t.thickness,
            c = !!t.onTop,
            u = (0, i.pluck)(t.fillcolor, "#EEEEEE"),
            d = (0, i.pluckNumber)(t.alpha, 50),
            f = (0, i.toRaphaelColor)({
          color: u,
          alpha: d
        }),
            h = void 0,
            p = this.getLinkedParent().getChildContainer("crosslineBottom"),
            g = this.getLinkedParent().getChildContainer("crosslineTop");
        e = c ? g : p, (h = this.getGraphicalElement("crosslineBand" + n)) ? t.animDuration ? h.animate({
          path: ["M", r, o, "L", a, s]
        }, t.animDuration, "ease-in") : h.attr({
          path: ["M", r, o, "L", a, s]
        }) : this.addGraphicalElement("crosslineBand" + n, this.getFromEnv("paper").path({
          path: ["M", r, o, "L", a, s],
          stroke: f,
          fill: f,
          "stroke-width": l,
          "stroke-linecap": "butt"
        }, e));
      }, t.prototype.hide = function () {
        for (var e = this.getGraphicalElement(), t = Object.keys(e), n = t.length - 1; n > -1; n--) {
          e[t[n]].stop(undefined, !0, !0), e[t[n]].remove(), delete e[t[n]];
        }
      }, t;
    }(o.ComponentInterface);

    t["default"] = u;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = {
      crossline: {
        crossline: {
          path: {
            updating: function updating(e) {
              var t = e.attr.path;
              return [{
                initialAttr: {
                  path: e.el.attr("path")
                },
                finalAttr: {
                  path: t
                }
              }];
            }
          }
        }
      }
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(125),
        o = n(138);

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var a = r.hasSVG ? 0 : .5,
        s = function s(e) {
      return {
        onhover: function onhover(t, n) {
          e.show(n.axes ? {
            axesInfo: n.axes
          } : {
            event: t
          });
        },
        onhoverout: function onhoverout(t) {
          e.hide({
            event: t
          });
        }
      };
    },
        l = function l(e, t, n) {
      return n.getFromEnv("animationManager").setAnimation({
        el: "group",
        attr: {
          name: e
        },
        container: t,
        state: "appearing",
        component: n,
        label: "group"
      });
    },
        c = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this));

        return n._handlerAPI = s(n), n;
      }

      return i(t, e), t.prototype.getAttachedAxisInfo = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            t = this.getLinkedParent().getAxes(),
            n = void 0,
            o = void 0,
            i = void 0,
            a = e.originalEvent && (0, r.getMouseCoordinate)(this.getFromEnv("chart-container"), e.originalEvent, this.getFromEnv("chart")),
            s = a && a.chartX || 0,
            l = a && a.chartY || 0;

        for (n = t.length - 1; n >= 0; n--) {
          if (o = t[n].axis, !t[n].isY) return {
            value: (i = !!o.config.isVertical) ? o.getValue(l) : o.getValue(s),
            axis: o,
            isVertical: i,
            isY: !1
          };
        }
      }, t.prototype.configure = function () {
        var e = this.config,
            t = this.getFromEnv("chartConfig"),
            n = this.getFromEnv("chart-attrib"),
            o = (0, r.pluck)(n.crosslinecolor, t.crosslinecolor, "#EEEEEE"),
            i = (0, r.pluckNumber)(t.defaultcrosslinethickness),
            a = (0, r.pluckNumber)(n.crosslineanimation, 0) && 1e3 * (0, r.pluckNumber)(n.crosslineanimationduration, .09),
            s = (0, r.pluckNumber)(n.drawcrosslineontop, t.drawcrosslineontop, 0),
            l = (0, r.pluckNumber)(n.crosslinealpha, t.crosslinealpha, 50);
        e.drawCrossLine = (0, r.pluckNumber)(n.drawcrossline, t.drawcrossline, 0), e.bandStyle = {
          fillcolor: o,
          alpha: l,
          thickness: i,
          managerId: this.getId(),
          onTop: s,
          cursor: "pointer",
          animDuration: a
        };
      }, t.prototype.createGroup = function () {
        var e = this.getLinkedParent().getChildContainer("crosslineBottom"),
            t = this.getLinkedParent().getChildContainer("crosslineTop");
        !this.getChildContainer("crosslineTop") && this.addChildContainer("crosslineTop", l("crosslineTop", t, this)), !this.getChildContainer("crosslineBottom") && this.addChildContainer("crosslineBottom", l("crosslineBottom", e, this));
      }, t.prototype.show = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            t = e.event;
        this.config.attachedCanvasAxisInfo = this.getAttachedAxisInfo(t), this._setAptAxesInfo(e.axesInfo, e.value), this._show(t);
      }, t.prototype._setAptAxesInfo = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
            t = arguments[1],
            n = e.length,
            r = void 0,
            o = this.config.attachedCanvasAxisInfo,
            i = void 0;
        if (e.length) for (i = 0; i < n; i++) {
          if ((r = e[i]).axis === o.axis) {
            o.value = r.value;
            break;
          }
        }
        void 0 !== t && (o.value = t);
      }, t.prototype._show = function (e) {
        var t,
            n,
            r = this.config,
            o = this.getFromEnv("chartConfig"),
            i = this.getChildren("crossline")[0],
            s = r.attachedCanvasAxisInfo,
            l = s.value,
            c = s.axis,
            u = s.isVertical,
            d = c.config.endPad,
            f = c.getVisibleConfig().maxValue - d,
            h = Math.round(l),
            p = s.axis.getPixel(h),
            g = void 0,
            m = void 0,
            v = void 0,
            y = Object.assign({}, r.bandStyle),
            b = void 0,
            x = this.getFromEnv("canvasConfig"),
            w = x.canvasTop,
            C = x.canvasLeft,
            _ = x.canvasWidth,
            S = w + x.canvasHeight,
            E = r.drawCrossLine;
        h < 0 || h > f || this.config.lastIndex !== h && E && (void 0 === (v = y.thickness) && (!1 === o._hascolumn ? v = 1 : (g = c.getPixel(0), m = c.getPixel(1), v = Math.abs(m - g))), t = p, n = v, b = Math.round(t + (n % 2 / 2 + a)) - (n % 2 / 2 + a), this.createGroup(), y.thickness = v, y = u ? Object.assign(y, {
          x1: C,
          y1: b,
          x2: C + _,
          y2: b
        }) : Object.assign(y, {
          x1: b,
          y1: w,
          x2: b,
          y2: S
        }), i.show(y), this.getFromEnv("chart").fireChartInstanceEvent("onChangeCrossLine", {
          currentIndex: h,
          lastIndex: this.config.lastIndex,
          source: e ? "mouse interaction" : "public API"
        }), this.config.lastIndex = h);
      }, t.prototype.hide = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            t = this.getLinkedParent(),
            n = e.event,
            o = n && n.originalEvent && (0, r.getMouseCoordinate)(t.getFromEnv("chart-container"), n && n.originalEvent, t.getFromEnv("chart")),
            i = o && o.chartX || 0,
            a = o && o.chartY || 0;
        t.isWithinCanvas(i, a) || (this.getFromEnv("chart").fireChartInstanceEvent("onChangeCrossLine", {
          lastIndex: this.config.lastIndex,
          source: n ? "mouse interaction" : "public API"
        }), delete this.config.lastIndex, this.getChildren("crossline")[0].hide());
      }, t.prototype.getType = function () {
        return "crossline-manager";
      }, t.prototype.getName = function () {
        return "crossline-manager-band-category-axis";
      }, t;
    }(o.ComponentInterface);

    t["default"] = c;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(138),
        o = n(125);

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var a = {
      candlestick: !0
    },
        s = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n,
            r = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.call(this));

        return r._handlers = (n = r, {
          onhover: function onhover(e) {
            e.originalEvent && n.show(e);
          },
          onhoverout: function onhoverout(e) {
            e.originalEvent && n.hide(e);
          }
        }), r;
      }

      return i(t, e), t.prototype.getAxesInfo = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            t = arguments[1].getAxes(),
            n = void 0,
            r = [],
            i = void 0,
            a = void 0,
            s = void 0,
            l = (0, o.getMouseCoordinate)(this.getFromEnv("chart-container"), e.originalEvent, this.getFromEnv("chart")),
            c = l.chartX || 0,
            u = l.chartY || 0;

        for (n = t.length - 1; n >= 0; n--) {
          i = t[n].axis, a = t[n].isY, s = !!i.config.isVertical, r.push({
            value: s ? i.getValue(u) : i.getValue(c),
            axis: i,
            isVertical: s,
            isY: a
          });
        }

        return r;
      }, t.prototype.getName = function () {
        return "multiCanvasCrosslineManager";
      }, t.prototype.getType = function () {
        return "multiCanvasCrosslineManager";
      }, t.prototype.show = function (e) {
        var t,
            n = e.sender,
            r = this.getFromEnv("chart");
        t = this.getAxesInfo(e, n), r.iterateComponents(function (e) {
          "canvas" === e.getName() && e !== n && e.fireEvent("fc-mousemove", {
            axes: t
          });
        });
      }, t.prototype.hide = function (e) {
        var t = e.sender,
            n = (0, o.getMouseCoordinate)(t.getFromEnv("chart-container"), e && e.originalEvent, t.getFromEnv("chart")),
            r = n.chartX,
            i = n.chartY;
        t.isWithinCanvas(r, i) || this.getFromEnv("chart").iterateComponents(function (e) {
          "canvas" === e.getName() && e !== t && e.fireEvent("fc-mouseout");
        });
      }, t;
    }(r.ComponentInterface);

    t["default"] = {
      extension: function extension(e) {
        e.addEventListener("instantiated", function (e) {
          if (e.sender.getType && "chartAPI" === e.sender.getType() && a[e.sender.getName && e.sender.getName()]) {
            var t = e.sender,
                n = void 0,
                r = void 0;
            t.registerFactory("multiCanvasCrossline", function () {
              (0, o.componentFactory)(t, s, "multiCanvasCrosslineManager"), n = t.getChildren("multiCanvasCrosslineManager")[0], r = n._handlers, t.iterateComponents(function (e) {
                "canvas" === e.getName() && (e.addEventListener("fc-mouseover", r.onhover), e.addEventListener("fc-mousemove", r.onhover), e.addEventListener("fc-mouseout", r.onhoverout));
              });
            }, ["canvas"]);
          }
        });
      },
      name: "multi-canvas-crossline-manager",
      type: "extension",
      requiresFusionCharts: !0
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.setConfig = t.getConfig = undefined;
    var r,
        o = n(273),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(280);
    t["default"] = i["default"], t.getConfig = a.getConfig, t.setConfig = a.setConfig;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(274),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    };
    t["default"] = i["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(275),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(319),
        s = n(276);

    var l = function () {
      function e(t, n, r) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.dataTables = {}, this._defaultDataTable = null, this._id = +new Date() + "", t && n && t.constructor === Array && n.constructor === Array && this.createDataTable(t, n, r);
      }

      return e.prototype.createDataTable = function (e, t, n, r) {
        if (!e || !t) throw new Error("Both data and schema must be provided to build DataTable");
        if (e.constructor !== Array) throw new Error("Data must be provided in 2D array format or array of json objects");
        if (t.constructor !== Array || 0 === t.length) throw new Error("Input schema is not in a correct format - schema must be an array of column configurations");
        var o,
            a,
            l = {},
            c = void 0;

        if (c = Object.keys(this.dataTables), r) {
          if (c.includes(r)) throw new Error("A table with the id " + r + " already exists in the DataStore. Please use a different id.");
        } else r = (0, s.createTableID)(c);

        return Object.assign(l, {
          enableIndex: !0,
          enableUTC: !1
        }, n), o = (0, s.parseAndIndexData)(e, t, l), a = new i["default"](this, o, t, l, null, null, r), 0 === c.length && (this._defaultDataTable = a), this.dataTables[r] = a, a;
      }, e.prototype.appendRows = function (e, t) {
        var n,
            r,
            o,
            i,
            a = this.getDataTable(t);
        o = a.getSchema(), i = (0, s.buildDateColumnsFormatter)(o), r = (0, s.parseData)(e, o, i), (n = a._data).push.apply(n, r), (0, s.indexData)(a._data, o, a._config, i), a._appendRows(r), this.trigger("itemsAdded", {
          rows: e,
          tableID: t
        });
      }, e.prototype.getDataTable = function (e) {
        if (e) {
          if (!this.dataTables[e]) throw new Error("DataTable with id " + e + " is not found in the DataStore.");
          return this.dataTables[e];
        }

        return this._defaultDataTable;
      }, e.prototype.on = function (e, t) {
        (0, a.addHandler)(e, t, this);
      }, e.prototype.off = function (e, t) {
        (0, a.removeHandler)(e, t, this);
      }, e.prototype.trigger = function (e, t) {
        (0, a.triggerEvent)(e, this, t);
      }, e.prototype.dispose = function () {
        var e = this;

        for (var t in e.dataTables) {
          e.dataTables[t].dispose(), delete e.dataTables[t];
        }

        delete e._id, delete e.dataTables, delete e._defaultDataTable, this.trigger("disposed"), e = null;
      }, e.prototype._propagate = function (e) {
        for (var t in this.trigger("payloadReceived", e), this.dataTables) {
          this.dataTables[t]._payloadReceiver(e);
        }
      }, e;
    }();

    t["default"] = l;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(276),
        o = n(319);

    var i = function () {
      function e(t, n, r, o, i, a, s) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this._dataStore = t, this._parentTable = i, this._parentTable && this._parentTable._children.push(this), this._children = [], this._opsFunnel = a, this._data = n || [], this._schema = r, this._config = o, this._id = s, this._result = null;
      }

      return e.prototype._appendRows = function (e) {
        var t = this._children && this._children.length || 0,
            n = this._result && this._result.schema.length || 0;
        n && (this._calcColumns = []);

        for (var r = 0; r < n; r++) {
          this._result.schema[r].calcFn && this._calcColumns.push(this._result.schema[r]);
        }

        this._result && delete this._result;

        for (var o = 0; o < t; o++) {
          this._children[o]._appendRows(e);
        }
      }, e.prototype.count = function () {
        return this._executeFunnel().data.length;
      }, e.prototype.getSchema = function () {
        return this._executeFunnel().schema;
      }, e.prototype.getID = function () {
        return this._id;
      }, e.prototype.getDataStore = function () {
        return this._dataStore;
      }, e.prototype.getChildren = function (e) {
        if (e) {
          for (var t = 0; t < this._children.length; t++) {
            if (this._children[t]._id === e) return this._children[t];
          }

          return null;
        }

        return this._children;
      }, e.prototype.getData = function (e, t) {
        e = e || 0, t = t && ("string" == typeof t || t instanceof String) || null === t ? undefined : t;

        var n = this._executeFunnel();

        return {
          data: n.data && n.data.slice(e, t && t > 0 ? e + t : t),
          schema: n.schema
        };
      }, e.prototype.dispose = function () {
        var e = this,
            t = e._children && e._children.length || 0;
        delete e._dataStore, delete e._parentTable, delete e._opsFunnel, delete e._data, delete e._schema, delete e._config, delete e._result, delete e._id;

        for (var n = 0; n < t; n++) {
          e._children[n].dispose();
        }

        delete e._children, e._trigger("disposed"), e = null;
      }, e.prototype.min = function (e) {
        var t = this.getData();
        return (0, r.columnMinValue)(e, t.data, t.schema);
      }, e.prototype.max = function (e) {
        var t = this.getData();
        return (0, r.columnMaxValue)(e, t.data, t.schema);
      }, e.prototype.unique = function (e) {
        var t = this.getData();
        return (0, r.columnUnique)(e, t.data, t.schema);
      }, e.prototype.extents = function (e) {
        var t = this.getData();
        return (0, r.columnExtents)(e, t.data, t.schema);
      }, e.prototype.addColumns = function () {
        for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        var r = t.length;

        if (r > 0) {
          this._calcColumns = this._calcColumns || [];

          for (var o = 0; o < r; o++) {
            if (!t[o].name) throw new Error("name is required in column " + (o + 1));
            if (t[o].calcFn && !(t[o].calcFn instanceof Function)) throw new Error("calcFn must be a function in column " + (o + 1));
            t[o].calcFn || (t[o].calcFn = function () {
              return undefined;
            }), this._calcColumns.push(Object.assign({}, t[o]));
          }
        }

        this._trigger("updated", t);
      }, e.prototype.query = function (t) {
        return t && t.constructor !== Array && (t = [t]), new e(this._dataStore, this._data, this._schema, this._config, this, t);
      }, e.prototype.indexOf = function (e) {
        var t = this._executeFunnel();

        return (0, r.columnIndexOf)(e, t.schema);
      }, e.prototype.on = function (e, t) {
        (0, o.addHandler)(e, t, this);
      }, e.prototype.off = function (e, t) {
        (0, o.removeHandler)(e, t, this);
      }, e.prototype._trigger = function (e, t) {
        (0, o.triggerEvent)(e, this, t);
      }, e.prototype._executeFunnel = function () {
        if (!this._result) if (this._opsFunnel) {
          var e,
              t = void 0,
              n = void 0,
              o = void 0,
              i = void 0;
          n = (t = this._parentTable._executeFunnel()).data.slice(0), o = t.schema.slice(0), i = Object.assign({}, t.config), e = this._opsFunnel.length;

          for (var a = 0; a < e; a++) {
            if (this._opsFunnel[a] && this._opsFunnel[a].fn) {
              var s = this._opsFunnel[a].fn(n, o, i);

              n = s.generatorFn ? s.generatorFn() : s.data, o = s.schema, (i = Object.assign(i, s.config)).indexBy === undefined && (i.enableIndex = !1);
            }
          }

          this._result = {
            data: n,
            schema: o,
            config: i
          };
        } else this._result = {
          data: this._data,
          schema: this._schema,
          config: this._config
        };

        if (this._calcColumns && this._calcColumns.length > 0) {
          var l = (0, r.addColumnsSchema)(this._result.schema, this._calcColumns);
          this._result.schema = l.schema, this._result.data = (0, r.addColumnsData)(this._result.data, this._result.schema, l.calcColumns), delete this._calcColumns;
        }

        return this._result;
      }, e.prototype._flushResult = function () {
        var e = this._result && this._result.schema.length || 0;
        e && (this._calcColumns = []);

        for (var t = 0; t < e; t++) {
          this._result.schema[t].calcFn && this._calcColumns.push(this._result.schema[t]);
        }

        this._result && (this._result = null);

        for (var n = 0; n < this._children.length; n++) {
          this._children[n]._flushResult();
        }

        this._trigger("resultFlushed");
      }, e.prototype.propagate = function (e) {
        this.getDataStore()._propagate({
          trigger: this,
          payload: e
        });
      }, e.prototype._payloadReceiver = function (e) {
        var t = this._children && this._children.length || 0;
        e && e.trigger && e.trigger !== this && this._trigger("payloadReceived", e);

        for (var n = 0; n < t; n++) {
          this._children[n]._payloadReceiver(e);
        }
      }, e.prototype.getMinDiff = function (e) {
        var t = this.getData();
        return (0, r.columnMinDiff)(e, t.data, t.schema, this._config.indexBy);
      }, e.prototype.isUTCEnabled = function (e) {
        return (0, r.isUTCEnabled)(e, this.getSchema());
      }, e;
    }();

    t["default"] = i;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.isUTCEnabled = t.indexData = t.parseData = t.buildDateColumnsFormatter = t.createTableID = t.parseAndIndexData = t.addColumnsData = t.addColumnsSchema = t.columnUnique = t.columnExtents = t.columnMinDiff = t.columnMaxValue = t.columnMinValue = t.columnIndexOf = undefined;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        o = n(277),
        i = n(278),
        a = u(n(279)),
        s = n(280),
        l = u(n(281)),
        c = u(n(296));

    function u(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function d(e, t) {
      if (!t || !e) return null;

      for (var n = 0; n < t.length; n++) {
        if (t[n] && t[n].hasOwnProperty("name") && t[n].name === e) return n;
      }

      return -1;
    }

    function f(e, t, n) {
      return n[e.name] !== undefined && t && isNaN(+t) ? n[e.name] ? +n[e.name].parse(t) : +new Date(t) : "number" === e.type ? (0, o.isNumber)(t) ? t : t ? parseFloat(t) : null : t;
    }

    function h(e) {
      for (var t = {}, n = 0; n < e.length; n++) {
        if (!e[n].name) throw new Error("Input schema is not in a correct format - each column must have a name");
        e[n].type && "date" === e[n].type && (t[e[n].name] = e[n].format ? (e[n].enableUTC !== undefined ? e[n].enableUTC : (0, s.getConfig)("enableUTC")) ? l["default"].utcParser(e[n].format) : l["default"].parser(e[n].format) : null);
      }

      return t;
    }

    function p(e, t, n) {
      var o = [];

      if (e.length > 0) {
        var i = n,
            a = void 0;
        i || (i = h(t));

        try {
          for (var s = t.length, l = void 0, c = void 0, u = void 0, d = 0; d < e.length; d++) {
            if (l = [], (c = e[d]).constructor === Array) for (u = Math.min(s, c.length), a = 0; a < u; a++) {
              l[a] = f(t[a], c[a], i);
            } else {
              if ("object" !== (void 0 === c ? "undefined" : r(c))) continue;

              for (a = 0; a < s; a++) {
                c[t[a].name] && (l[a] = f(t[a], c[t[a].name], i));
              }
            }
            o.push(l);
          }
        } catch (p) {
          throw new Error("Error while parsing the data - " + p);
        }
      }

      return o;
    }

    function g(e, t, n, r) {
      if (n.enableIndex) {
        var o = void 0,
            s = void 0,
            l = void 0;

        if (!n.indexBy) {
          (l = r) || (l = h(t));
          var c = Object.keys(l);
          if (c.length > 0) n.indexBy = c[0];else {
            for (o = 0; o < t.length; o++) {
              if (t[o].type && "number" === t[o].type) {
                n.indexBy = t[o].name;
                break;
              }
            }

            o === t.length && (n.indexBy = t[0].name);
          }
        }

        for (o = 0; o < t.length && (!t[o] || t[o].name !== n.indexBy); o++) {
          ;
        }

        if (o === t.length) throw new Error("Index column is not found in schema");

        switch (t[o].type) {
          case "number":
          case "date":
            s = i.numberComparator;
            break;

          default:
            s = i.stringComparator;
        }

        (0, a["default"])(e, function (e, t) {
          return s(e[o], t[o]);
        });
      }
    }

    t.columnIndexOf = d, t.columnMinValue = function (e, t, n) {
      var r,
          i = void 0;
      if (null === (r = d(e, n)) || -1 === r) return null;

      if (t && t.length > 0) {
        var a = void 0;
        i = Number.POSITIVE_INFINITY;

        for (var s = 0; s < t.length; s++) {
          a = "interval" === n[r].type ? t[s][r] ? t[s][r].start : null : t[s][r], (0, o.isNumber)(a) && a < i && (i = a);
        }
      }

      return i;
    }, t.columnMaxValue = function (e, t, n) {
      var r,
          i = void 0;
      if (null === (r = d(e, n)) || -1 === r) return null;

      if (t && t.length > 0) {
        var a = void 0;
        i = Number.NEGATIVE_INFINITY;

        for (var s = 0; s < t.length; s++) {
          a = "interval" === n[r].type ? t[s][r] ? t[s][r].end : null : t[s][r], (0, o.isNumber)(a) && a > i && (i = a);
        }
      }

      return i;
    }, t.columnMinDiff = function (e, t, n, r) {
      var a,
          s = t,
          l = t.length,
          c = void 0;
      if (null === (a = d(e, n)) || -1 === a) return null;
      if (n[a] && ["date", "number"].indexOf(n[a].type) < 0) throw new Error("Operation valid only on date or number columns");

      if (r && e === r || (s = t.slice(0)).sort(function (e, t) {
        return (0, i.numberComparator)(e[a], t[a]);
      }), s && l > 0) {
        var u = void 0,
            f = void 0,
            h = void 0;
        c = Number.POSITIVE_INFINITY;

        for (var p = 0; p < s.length - 1 && (f = s[p][a], h = s[p + 1][a], (0, o.isNumber)(h) && (0, o.isNumber)(f)) && (u = h - f, 0 !== (c = (0, o.isNumber)(u) && u >= 0 && u < c ? u : c)); p++) {
          ;
        }
      }

      return c === Number.POSITIVE_INFINITY ? null : c;
    }, t.columnExtents = function (e, t, n) {
      var r = Number.POSITIVE_INFINITY,
          i = Number.NEGATIVE_INFINITY,
          a = d(e, n),
          s = void 0;
      if (null === a || -1 === a) return null;
      if (t && t.length > 0) for (var l = 0; l < t.length; l++) {
        s = "interval" === n[a].type ? t[l][a] ? t[l][a].start : null : t[l][a], (0, o.isNumber)(s) && s < r && (r = s), s = "interval" === n[a].type ? t[l][a] ? t[l][a].end : null : t[l][a], (0, o.isNumber)(s) && s > i && (i = s);
      }
      return {
        min: r,
        max: i
      };
    }, t.columnUnique = function (e, t, n) {
      var r = d(e, n),
          o = [],
          i = void 0;
      if (null === r || -1 === r) return [];

      for (var a = 0; a < t.length; a++) {
        o.push(t[a][r]);
      }

      return t && t.length > 0 ? 1 === (i = Array.from(new c["default"](o))).length && "undefined" == typeof i[0] ? [] : i : [];
    }, t.addColumnsSchema = function (e, t) {
      for (var n = t.length, r = e.slice(0), o = 0; o < n; o++) {
        var i = r.length;
        t[o].originalName = t[o].name;

        for (var a = 0; a < i; a++) {
          t[o].name === r[a].name && (t[o].i = t[o].i && ++t[o].i || 1, t[o].name = t[o].originalName + " " + t[o].i), t[o].type && -1 !== ["string", "number", "date"].indexOf(t[o].type) || (t[o].type = "string");
        }

        delete t[o].originalName, delete t[o].i, r.push({
          name: t[o].name,
          type: t[o].type || "string"
        }), t[o].calcFn && (r[r.length - 1].calcFn = t[o].calcFn), t[o].format && (r[r.length - 1].format = t[o].format), t[o].enableUTC && (r[r.length - 1].enableUTC = t[o].enableUTC), t[o].columnIndex = r.length - 1;
      }

      return {
        schema: r,
        calcColumns: t
      };
    }, t.addColumnsData = function (e, t, n) {
      for (var r, o = e.length, i = n.length, a = t.length, s = {}, l = h(n), c = 0; c < a; c++) {
        s[t[c].name] = c;
      }

      for (var u = 0; u < o; u++) {
        for (var d = 0; d < i; d++) {
          n[d].calcFn && (r = n[d].calcFn(e[u], s, u), r = f(n[d], r, l), e[u][n[d].columnIndex] = r);
        }
      }

      return e;
    }, t.parseAndIndexData = function (e, t, n) {
      var r = h(t),
          o = p(e, t, r);
      return g(o, t, n, r), o;
    }, t.createTableID = function (e) {
      for (var t = e.length + 1; e.includes("table-" + t);) {
        t++;
      }

      return "table-" + t;
    }, t.buildDateColumnsFormatter = h, t.parseData = p, t.indexData = g, t.isUTCEnabled = function (e, t) {
      var n;
      return null === (n = d(e, t)) || -1 === n || "date" !== t[n].type && "interval" !== t[n].type ? null : t[n].enableUTC !== undefined ? t[n].enableUTC : (0, s.getConfig)("enableUTC");
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    t.isNumber = function (e) {
      return "number" == typeof e && !isNaN(e - e);
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.stringComparator = t.numberComparator = undefined;
    var r = n(277);
    t.numberComparator = function (e, t) {
      return null === e || void 0 === e ? t === e ? 0 : 1 : (0, r.isNumber)(t) ? e - t : isNaN(e) && isNaN(t) ? 0 : -1;
    }, t.stringComparator = function (e, t) {
      return null === e || void 0 === e ? t === e ? 0 : 1 : (0, r.isNumber)(t) ? (0, r.isNumber)(e) ? e - t : -1 : e === t ? 0 : e < t ? -1 : 1;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n, r, o) {
      for (n = n || 0, r = r || e.length, o = o || n + 1, t || (t = function t(e, _t6) {
        return e - _t6;
      }), n === o && ++o; o < r; ++o) {
        var i = n,
            a = o,
            s = e[a];

        do {
          var l = i + (a - i >> 1);
          t(s, e[l]) < 0 ? a = l : i = l + 1;
        } while (i < a);

        for (var c = o; c > i; --c) {
          e[c] = e[c - 1];
        }

        e[i] = s;
      }
    }

    t.__esModule = !0;
    var o = 64,
        i = 7,
        a = 256,
        s = 40;

    function l(e, t, n, r) {
      var o = n + 1;
      if (o === r) return 1;

      if (t(e[o++], e[n]) < 0) {
        for (; o < r && t(e[o], e[o - 1]) < 0;) {
          o++;
        }

        !function (e, t, n) {
          for (--n; t < n;) {
            var r = e[t];
            e[t++] = e[n], e[n--] = r;
          }
        }(e, n, o);
      } else for (; o < r && t(e[o], e[o - 1]) >= 0;) {
        o++;
      }

      return o - n;
    }

    function c(e, t, n, r, o, i) {
      var a = 0,
          s = 0,
          l = 1,
          c = void 0,
          u = void 0;

      if (i(e, t[n + o]) > 0) {
        for (s = r - o; l < s && i(e, t[n + o + l]) > 0;) {
          a = l, (l = 1 + (l << 1)) <= 0 && (l = s);
        }

        l > s && (l = s), a += o, l += o;
      } else {
        for (s = o + 1; l < s && i(e, t[n + o - l]) <= 0;) {
          a = l, (l = 1 + (l << 1)) <= 0 && (l = s);
        }

        l > s && (l = s), c = a, a = o - l, l = o - c;
      }

      for (a++; a < l;) {
        i(e, t[n + (u = a + (l - a >>> 1))]) > 0 ? a = u + 1 : l = u;
      }

      return l;
    }

    function u(e, t, n, r, o, i) {
      var a = 0,
          s = 0,
          l = 1,
          c = void 0,
          u = void 0;

      if (i(e, t[n + o]) < 0) {
        for (s = o + 1; l < s && i(e, t[n + o - l]) < 0;) {
          a = l, (l = 1 + (l << 1)) <= 0 && (l = s);
        }

        l > s && (l = s), c = a, a = o - l, l = o - c;
      } else {
        for (s = r - o; l < s && i(e, t[n + o + l]) >= 0;) {
          a = l, (l = 1 + (l << 1)) <= 0 && (l = s);
        }

        l > s && (l = s), a += o, l += o;
      }

      for (a++; a < l;) {
        i(e, t[n + (u = a + (l - a >>> 1))]) < 0 ? l = u : a = u + 1;
      }

      return l;
    }

    var d = function () {
      function e(t, n) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.arr = t, this.comparer = n, this.length = t.length, this.tmpStorageLen = this.length < 2 * a ? this.length >>> 1 : a, this.tmp = new Array(this.tmpStorageLen), this.runBaseArr = new Array(s), this.runLenArr = new Array(s), this.minGallop = i, this.stackSize = 0;
      }

      return e.prototype.pushRun = function (e, t) {
        this.runBaseArr[this.stackSize] = e, this.runLenArr[this.stackSize] = t, this.stackSize++;
      }, e.prototype.mergeCollapse = function () {
        for (var e = void 0; this.stackSize > 1;) {
          if ((e = this.stackSize - 2) >= 1 && this.runLenArr[e - 1] <= this.runLenArr[e] + this.runLenArr[e + 1] || e >= 2 && this.runLenArr[e - 2] <= this.runLenArr[e] + this.runLenArr[e - 1]) this.runLenArr[e - 1] < this.runLenArr[e + 1] && e--;else if (this.runLenArr[e] > this.runLenArr[e + 1]) break;
          this.mergeAt(e);
        }
      }, e.prototype.mergeForceCollapse = function () {
        for (var e = void 0; this.stackSize > 1;) {
          (e = this.stackSize - 2) > 0 && this.runLenArr[e - 1] < this.runLenArr[e + 1] && e--, this.mergeAt(e);
        }
      }, e.prototype.mergeAt = function (e) {
        var t,
            n = this.comparer,
            r = this.arr,
            o = this.runBaseArr[e],
            i = this.runLenArr[e],
            a = this.runBaseArr[e + 1],
            s = this.runLenArr[e + 1];
        this.runLenArr[e] = i + s, e === this.stackSize - 3 && (this.runBaseArr[e + 1] = this.runBaseArr[e + 2], this.runLenArr[e + 1] = this.runLenArr[e + 2]), this.stackSize--, o += t = u(r[a], r, o, i, 0, n), 0 !== (i -= t) && 0 !== (s = c(r[o + i - 1], r, a, s, s - 1, n)) && (i <= s ? this.mergeLo(o, i, a, s) : this.mergeHi(o, i, a, s));
      }, e.prototype.mergeLo = function (e, t, n, r) {
        var o = 0,
            a = 0,
            s = n,
            l = e,
            d = void 0,
            f = void 0,
            h = void 0,
            p = void 0;

        for (o = 0; o < t; o++) {
          this.tmp[o] = this.arr[e + o];
        }

        if (this.arr[l++] = this.arr[s++], 0 != --r) {
          if (1 !== t) {
            for (d = this.minGallop;;) {
              f = 0, h = 0, p = !1;

              do {
                if (this.comparer(this.arr[s], this.tmp[a]) < 0) {
                  if (this.arr[l++] = this.arr[s++], h++, f = 0, 0 == --r) {
                    p = !0;
                    break;
                  }
                } else if (this.arr[l++] = this.tmp[a++], f++, h = 0, 1 == --t) {
                  p = !0;
                  break;
                }
              } while ((f | h) < d);

              if (p) break;

              do {
                if (0 !== (f = u(this.arr[s], this.tmp, a, t, 0, this.comparer))) {
                  for (o = 0; o < f; o++) {
                    this.arr[l + o] = this.tmp[a + o];
                  }

                  if (l += f, a += f, (t -= f) <= 1) {
                    p = !0;
                    break;
                  }
                }

                if (this.arr[l++] = this.arr[s++], 0 == --r) {
                  p = !0;
                  break;
                }

                if (0 !== (h = c(this.tmp[a], this.arr, s, r, 0, this.comparer))) {
                  for (o = 0; o < h; o++) {
                    this.arr[l + o] = this.arr[s + o];
                  }

                  if (l += h, s += h, 0 === (r -= h)) {
                    p = !0;
                    break;
                  }
                }

                if (this.arr[l++] = this.tmp[a++], 1 == --t) {
                  p = !0;
                  break;
                }

                d--;
              } while (f >= i || h >= i);

              if (p) break;
              d < 0 && (d = 0), d += 2;
            }

            if (this.minGallop = d, d < 1 && (this.minGallop = 1), 1 === t) {
              for (o = 0; o < r; o++) {
                this.arr[l + o] = this.arr[s + o];
              }

              this.arr[l + r] = this.tmp[a];
            } else for (o = 0; o < t; o++) {
              this.arr[l + o] = this.tmp[a + o];
            }
          } else {
            for (o = 0; o < r; o++) {
              this.arr[l + o] = this.arr[s + o];
            }

            this.arr[l + r] = this.tmp[a];
          }
        } else for (o = 0; o < t; o++) {
          this.arr[l + o] = this.tmp[a + o];
        }
      }, e.prototype.mergeHi = function (e, t, n, r) {
        var o = 0,
            a = e + t - 1,
            s = r - 1,
            l = n + r - 1,
            d = 0,
            f = 0,
            h = void 0,
            p = void 0,
            g = void 0,
            m = void 0;

        for (o = 0; o < r; o++) {
          this.tmp[o] = this.arr[n + o];
        }

        if (this.arr[l--] = this.arr[a--], 0 != --t) {
          if (1 !== r) {
            for (h = this.minGallop;;) {
              p = 0, g = 0, m = !1;

              do {
                if (this.comparer(this.tmp[s], this.arr[a]) < 0) {
                  if (this.arr[l--] = this.arr[a--], p++, g = 0, 0 == --t) {
                    m = !0;
                    break;
                  }
                } else if (this.arr[l--] = this.tmp[s--], g++, p = 0, 1 == --r) {
                  m = !0;
                  break;
                }
              } while ((p | g) < h);

              if (m) break;

              do {
                if (0 !== (p = t - u(this.tmp[s], this.arr, e, t, t - 1, this.comparer))) {
                  for (t -= p, f = (l -= p) + 1, d = (a -= p) + 1, o = p - 1; o >= 0; o--) {
                    this.arr[f + o] = this.arr[d + o];
                  }

                  if (0 === t) {
                    m = !0;
                    break;
                  }
                }

                if (this.arr[l--] = this.tmp[s--], 1 == --r) {
                  m = !0;
                  break;
                }

                if (0 !== (g = r - c(this.arr[a], this.tmp, 0, r, r - 1, this.comparer))) {
                  for (r -= g, f = (l -= g) + 1, d = (s -= g) + 1, o = 0; o < g; o++) {
                    this.arr[f + o] = this.tmp[d + o];
                  }

                  if (r <= 1) {
                    m = !0;
                    break;
                  }
                }

                if (this.arr[l--] = this.arr[a--], 0 == --t) {
                  m = !0;
                  break;
                }

                h--;
              } while (p >= i || g >= i);

              if (m) break;
              h < 0 && (h = 0), h += 2;
            }

            if (this.minGallop = h, h < 1 && (this.minGallop = 1), 1 === r) {
              for (f = (l -= t) + 1, d = (a -= t) + 1, o = t - 1; o >= 0; o--) {
                this.arr[f + o] = this.arr[d + o];
              }

              this.arr[l] = this.tmp[s];
            } else for (d = l - (r - 1), o = 0; o < r; o++) {
              this.arr[d + o] = this.tmp[o];
            }
          } else {
            for (f = (l -= t) + 1, d = (a -= t) + 1, o = t - 1; o >= 0; o--) {
              this.arr[f + o] = this.arr[d + o];
            }

            this.arr[l] = this.tmp[s];
          }
        } else for (d = l - (r - 1), o = 0; o < r; o++) {
          this.arr[d + o] = this.tmp[o];
        }
      }, e;
    }();

    t["default"] = function (e, t, n, i) {
      if (e.constructor !== Array) throw new TypeError("Sorting can only be applied on arrays.");
      n = n || 0, i = i || e.length, t || (t = function t(e, _t7) {
        return e - _t7;
      });
      var a,
          s = i - n,
          c = void 0,
          u = void 0,
          f = void 0;
      if (!(s < 2)) if (s < o) r(e, t, n, i, n + (c = l(e, t, n, i)));else {
        a = function (e) {
          for (var t = 0; e >= o;) {
            t |= 1 & e, e >>= 1;
          }

          return e + t;
        }(s), u = new d(e, t);

        do {
          (c = l(e, t, n, n + s)) < a && (r(e, t, n, n + (f = s <= a ? s : a), n + c), c = f), u.pushRun(n, c), u.mergeCollapse(), s -= c, n += c;
        } while (0 !== s);

        u.mergeForceCollapse();
      }
    }, t.binaryInsertionSort = r, t.mergeSort = function f(e, t) {
      if (e.constructor !== Array) throw new TypeError("Merge sort can only be applied on Array.");
      if (1 === e.length) return e;
      t || (t = function t(e, _t8) {
        return e - _t8;
      });
      var n = Math.floor(e.length / 2),
          r = e.slice(0, n),
          o = e.slice(n);
      return function (e, t, n) {
        for (var r = [], o = 0, i = 0; o < e.length && i < t.length;) {
          n(e[o], t[i]) <= 0 ? (r.push(e[o]), o++) : (r.push(t[i]), i++);
        }

        return r.concat(e.slice(o)).concat(t.slice(i));
      }(f(r, t), f(o, t), t);
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = {
      enableUTC: !1
    };
    t.getConfig = function (e) {
      if (!e) throw new Error("configName is missing");
      return r[e];
    }, t.setConfig = function (e, t) {
      if (!e) throw new Error("configName is missing");
      r[e] = t;
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.TimeConverter = undefined;
    var r = h(n(282)),
        o = n(284),
        i = h(o),
        a = n(290),
        s = n(289),
        l = h(n(285)),
        c = h(n(291)),
        u = h(n(288)),
        d = h(n(293)),
        f = h(n(295));

    function h(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var p = /^\s*\d+/,
        g = /^\s*Q\d+/,
        m = /^%/,
        v = /[\\^$*+?|[\]().{}]/g,
        y = function y(e, t, n) {
      var r = e < 0 ? "-" : "",
          o = (r ? -e : e) + "",
          i = o.length;
      return r + (i < n ? new Array(n - i + 1).join(t) + o : o);
    },
        b = function b(e) {
      return e.replace(v, "\\$&");
    },
        x = function x(e) {
      return new RegExp("^(?:" + e.map(b).join("|") + ")", "i");
    },
        w = function w(e) {
      for (var t = {}, n = -1, r = e.length; ++n < r;) {
        t[e[n].toLowerCase()] = n;
      }

      return t;
    },
        C = function C(e, t, n) {
      var r = p.exec(t.slice(n, n + 1));
      return r ? (e.w = +r[0], n + r[0].length) : -1;
    },
        _ = function _(e, t, n) {
      var r = p.exec(t.slice(n, n + 1));
      return r ? (e.u = +r[0], n + r[0].length) : -1;
    },
        S = function S(e, t, n) {
      var r = p.exec(t.slice(n, n + 2));
      return r ? (e.U = +r[0], n + r[0].length) : -1;
    },
        E = function E(e, t, n) {
      var r = p.exec(t.slice(n, n + 2));
      return r ? (e.V = +r[0], n + r[0].length) : -1;
    },
        k = function k(e, t, n) {
      var r = p.exec(t.slice(n, n + 2));
      return r ? (e.W = +r[0], n + r[0].length) : -1;
    },
        A = function A(e, t, n) {
      var r = g.exec(t.slice(n, n + 2));
      return r ? (e.m = 3 * (r[0][1] - 1), n + r[0].length) : -1;
    },
        T = function T(e, t, n) {
      var r = p.exec(t.slice(n, n + 4));
      return r ? (e.y = +r[0], n + r[0].length) : -1;
    },
        M = function M(e, t, n) {
      var r = p.exec(t.slice(n, n + 2));
      return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
    },
        O = function O(e, t, n) {
      var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
      return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
    },
        F = function F(e, t, n) {
      var r = p.exec(t.slice(n, n + 2));
      return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
    },
        I = function I(e, t, n) {
      var r = p.exec(t.slice(n, n + 2));
      return r ? (e.d = +r[0], n + r[0].length) : -1;
    },
        L = function L(e, t, n) {
      var r = p.exec(t.slice(n, n + 3));
      return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
    },
        N = function N(e, t, n) {
      var r = p.exec(t.slice(n, n + 2));
      return r ? (e.H = +r[0], n + r[0].length) : -1;
    },
        D = function D(e, t, n) {
      var r = p.exec(t.slice(n, n + 2));
      return r ? (e.M = +r[0], n + r[0].length) : -1;
    },
        P = function P(e, t, n) {
      var r = p.exec(t.slice(n, n + 2));
      return r ? (e.S = +r[0], n + r[0].length) : -1;
    },
        R = function R(e, t, n) {
      var r = p.exec(t.slice(n, n + 3));
      return r ? (e.L = +r[0], n + r[0].length) : -1;
    },
        j = function j(e, t, n) {
      var r = p.exec(t.slice(n, n + 6));
      return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
    },
        V = function V(e, t, n) {
      var r = m.exec(t.slice(n, n + 1));
      return r ? n + r[0].length : -1;
    },
        B = function B(e, t, n) {
      var r = p.exec(t.slice(n));
      return r ? (e.Q = +r[0], n + r[0].length) : -1;
    },
        H = function H(e, t, n) {
      var r = p.exec(t.slice(n));
      return r ? (e.Q = 1e3 * +r[0], n + r[0].length) : -1;
    },
        G = function G(e, t) {
      return y(e.getDate(), t, 2);
    },
        z = function z(e, t) {
      return y(e.getHours(), t, 2);
    },
        U = function U(e, t) {
      return y(e.getHours() % 12 || 12, t, 2);
    },
        $ = function $(e, t) {
      return y(1 + l["default"].count(c["default"].floor(e), e), t, 3);
    },
        X = function X(e, t) {
      return y(e.getMilliseconds(), t, 3);
    },
        W = function W(e, t) {
      return X(e, t) + "000";
    },
        Y = function Y(e, t) {
      return y(e.getMonth() + 1, t, 2);
    },
        q = function q(e, t) {
      return y(e.getMinutes(), t, 2);
    },
        K = function K(e, t) {
      return y(e.getSeconds(), t, 2);
    },
        J = function J(e, t) {
      return "Q" + Math.ceil((e.getMonth() + 1) / 3) + ", " + e.getFullYear();
    },
        Z = function Z(e) {
      var t = e.getDay();
      return 0 === t ? 7 : t;
    },
        Q = function Q(e, t) {
      return y(a.sunday.count(c["default"].floor(e), e), t, 2);
    },
        ee = function ee(e, t) {
      var n = e.getDay();
      return e = n >= 4 || 0 === n ? a.thursday.floor(e) : a.thursday.ceil(e), y(a.thursday.count(c["default"].floor(e), e) + (4 === c["default"].floor(e).getDay()), t, 2);
    },
        te = function te(e) {
      return e.getDay();
    },
        ne = function ne(e, t) {
      return y(a.monday.count(c["default"].floor(e), e), t, 2);
    },
        re = function re(e, t) {
      return y(e.getFullYear() % 100, t, 2);
    },
        oe = function oe(e, t) {
      return y(e.getFullYear() % 1e4, t, 4);
    },
        ie = function ie(e) {
      var t = e.getTimezoneOffset();
      return (t > 0 ? "-" : (t *= -1, "+")) + y(t / 60 | 0, "0", 2) + y(t % 60, "0", 2);
    },
        ae = function ae(e, t) {
      return y(e.getUTCDate(), t, 2);
    },
        se = function se(e, t) {
      return y(e.getUTCHours(), t, 2);
    },
        le = function le(e, t) {
      return y(e.getUTCHours() % 12 || 12, t, 2);
    },
        ce = function ce(e, t) {
      return y(1 + u["default"].count(d["default"].floor(e), e), t, 3);
    },
        ue = function ue(e, t) {
      return y(e.getUTCMilliseconds(), t, 3);
    },
        de = function de(e, t) {
      return ue(e, t) + "000";
    },
        fe = function fe(e, t) {
      return y(e.getUTCMonth() + 1, t, 2);
    },
        he = function he(e, t) {
      return y(e.getUTCMinutes(), t, 2);
    },
        pe = function pe(e, t) {
      return y(e.getUTCSeconds(), t, 2);
    },
        ge = function ge(e, t) {
      return "Q" + Math.ceil((e.getUTCMonth() + 1) / 3) + ", " + e.getUTCFullYear();
    },
        me = function me(e) {
      var t = e.getUTCDay();
      return 0 === t ? 7 : t;
    },
        ve = function ve(e, t) {
      return y(s.utcSunday.count(d["default"].floor(e), e), t, 2);
    },
        ye = function ye(e, t) {
      var n = e.getUTCDay();
      return e = n >= 4 || 0 === n ? s.utcThursday.floor(e) : s.utcThursday.ceil(e), y(s.utcThursday.count(d["default"].floor(e), e) + (4 === d["default"].floor(e).getUTCDay()), t, 2);
    },
        be = function be(e) {
      return e.getUTCDay();
    },
        xe = function xe(e, t) {
      return y(s.utcMonday.count(d["default"].floor(e), e), t, 2);
    },
        we = function we(e, t) {
      return y(e.getUTCFullYear() % 100, t, 2);
    },
        Ce = function Ce(e, t) {
      return y(e.getUTCFullYear() % 1e4, t, 4);
    },
        _e = function _e() {
      return "+0000";
    },
        Se = function Se() {
      return "%";
    },
        Ee = function Ee(e) {
      return +e;
    },
        ke = function ke(e) {
      return Math.floor(+e / 1e3);
    },
        Ae = function () {
      function e(t) {
        var n = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);

        var o = t.dateTime,
            a = t.date,
            s = t.time,
            l = t.periods,
            c = t.days,
            u = t.shortDays,
            d = t.months,
            f = t.shortMonths,
            h = x(l),
            _p = w(l),
            g = x(c),
            m = w(c),
            v = x(u),
            y = w(u),
            b = x(d),
            Ae = w(d),
            Te = x(f),
            Me = w(f);

        this._formats = {
          a: function a(e) {
            return u[e.getDay()];
          },
          A: function A(e) {
            return c[e.getDay()];
          },
          b: function b(e) {
            return f[e.getMonth()];
          },
          B: function B(e) {
            return d[e.getMonth()];
          },
          d: G,
          e: G,
          f: W,
          H: z,
          I: U,
          j: $,
          L: X,
          m: Y,
          M: q,
          p: function p(e) {
            return l[+(e.getHours() >= 12)];
          },
          q: J,
          Q: Ee,
          s: ke,
          S: K,
          u: Z,
          U: Q,
          V: ee,
          w: te,
          W: ne,
          y: re,
          Y: oe,
          Z: ie,
          "%": Se
        }, this._utcFormats = {
          a: function a(e) {
            return u[e.getUTCDay()];
          },
          A: function A(e) {
            return c[e.getUTCDay()];
          },
          b: function b(e) {
            return f[e.getUTCMonth()];
          },
          B: function B(e) {
            return d[e.getUTCMonth()];
          },
          d: ae,
          e: ae,
          f: de,
          H: se,
          I: le,
          j: ce,
          L: ue,
          m: fe,
          M: he,
          p: function p(e) {
            return l[+(e.getUTCHours() >= 12)];
          },
          q: ge,
          Q: Ee,
          s: ke,
          S: pe,
          u: me,
          U: ve,
          V: ye,
          w: be,
          W: xe,
          y: we,
          Y: Ce,
          Z: _e,
          "%": Se
        }, this._parses = {
          a: function a(e, t, n) {
            var r = v.exec(t.slice(n));
            return r ? (e.w = y[r[0].toLowerCase()], n + r[0].length) : -1;
          },
          A: function A(e, t, n) {
            var r = g.exec(t.slice(n));
            return r ? (e.w = m[r[0].toLowerCase()], n + r[0].length) : -1;
          },
          b: function b(e, t, n) {
            var r = Te.exec(t.slice(n));
            return r ? (e.m = Me[r[0].toLowerCase()], n + r[0].length) : -1;
          },
          B: function B(e, t, n) {
            var r = b.exec(t.slice(n));
            return r ? (e.m = Ae[r[0].toLowerCase()], n + r[0].length) : -1;
          },
          c: null,
          d: I,
          e: I,
          f: j,
          H: N,
          I: N,
          j: L,
          L: R,
          m: F,
          M: D,
          p: function p(e, t, n) {
            var r = h.exec(t.slice(n));
            return r ? (e.p = _p[r[0].toLowerCase()], n + r[0].length) : -1;
          },
          Q: B,
          q: A,
          s: H,
          S: P,
          u: _,
          U: S,
          V: E,
          w: C,
          W: k,
          x: null,
          X: null,
          y: M,
          Y: T,
          Z: O,
          "%": V
        }, this._formats.x = function (e) {
          return new r["default"](a, n._formats).format(e);
        }, this._formats.X = function (e) {
          return new r["default"](s, n._formats).format(e);
        }, this._formats.c = function (e) {
          return new r["default"](o, n._formats).format(e);
        }, this._utcFormats.x = function (e) {
          return new r["default"](a, n._utcFormats).format(e);
        }, this._utcFormats.X = function (e) {
          return new r["default"](s, n._utcFormats).format(e);
        }, this._utcFormats.c = function (e) {
          return new r["default"](o, n._utcFormats).format(e);
        }, this._parses.c = function (e, t, r) {
          return new i["default"](o, n._parses).parseSpecifier(e, t, r);
        }, this._parses.x = function (e, t, r) {
          return new i["default"](a, n._parses).parseSpecifier(e, t, r);
        }, this._parses.X = function (e, t, r) {
          return new i["default"](s, n._parses).parseSpecifier(e, t, r);
        };
      }

      return e.prototype.formatter = function (e) {
        return new r["default"](e, this._formats);
      }, e.prototype.utcFormatter = function (e) {
        return new r["default"](e, this._utcFormats);
      }, e.prototype.parser = function (e) {
        return new i["default"](e += "", this._parses, function (e) {
          if (e.y >= 0 && e.y < 100) {
            var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
            return t.setFullYear(e.y), t;
          }

          return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
        });
      }, e.prototype.utcParser = function (e) {
        return new i["default"](e += "", this._parses, o.utcDate);
      }, e;
    }();

    t.TimeConverter = Ae, t["default"] = new Ae(f["default"]);
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(283),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    };

    var a = function () {
      function e(t, n) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this._specifier = t, this._formats = n;
      }

      return e.prototype.format = function (e) {
        var t,
            n,
            r,
            o,
            a = [],
            s = -1,
            l = 0,
            c = this._specifier,
            u = c.length;

        for (e instanceof Date || (e = new Date(+e)); ++s < u;) {
          37 === c.charCodeAt(s) && (a.push(c.slice(l, s)), t = c.charAt(++s), n = i["default"][t], null === (o = n) || void 0 === o ? n = "e" === t ? " " : "0" : t = c.charAt(++s), r = this._formats[t], r && (t = r(e, n)), a.push(t), l = s + 1);
        }

        return a.push(c.slice(l, s)), a.join("");
      }, e.prototype.toString = function () {
        return this._specifier;
      }, e;
    }();

    t["default"] = a;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = {
      "-": "",
      _: " ",
      0: "0"
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.utcDate = undefined;
    var r = l(n(283)),
        o = l(n(285)),
        i = l(n(288)),
        a = n(289),
        s = n(290);

    function l(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var c = function c(e) {
      return {
        y: e,
        m: 0,
        d: 1,
        H: 0,
        M: 0,
        S: 0,
        L: 0
      };
    },
        u = function u(e) {
      if (e.y >= 0 && e.y < 100) {
        var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
        return t.setUTCFullYear(e.y), t;
      }

      return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
    },
        d = function () {
      function e(t, n, r) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this._specifier = t, this._parses = n, this._newDate = r;
      }

      return e.prototype.parseSpecifier = function (e, t, n) {
        for (var o, i, a = 0, s = this._specifier.length, l = t.length; a < s;) {
          if (n >= l) return -1;

          if (37 === (o = this._specifier.charCodeAt(a++))) {
            if (o = this._specifier.charAt(a++), !(i = this._parses[o in r["default"] ? this._specifier.charAt(a++) : o]) || (n = i(e, t, n)) < 0) return -1;
          } else if (o !== t.charCodeAt(n++)) return -1;
        }

        return n;
      }, e.prototype.parse = function (e) {
        var t,
            n,
            r = c(1900);
        if (e += "", this.parseSpecifier(r, e, 0) !== e.length) return null;
        if ("Q" in r) return new Date(r.Q);

        if ("p" in r && (r.H = r.H % 12 + 12 * r.p), "V" in r) {
          if (r.V < 1 || r.V > 53) return null;
          "w" in r || (r.w = 1), "Z" in r ? (t = (n = (t = u(c(r.y))).getUTCDay()) > 4 || 0 === n ? a.utcMonday.ceil(t) : a.utcMonday.floor(t), t = i["default"].offset(t, 7 * (r.V - 1)), r.y = t.getUTCFullYear(), r.m = t.getUTCMonth(), r.d = t.getUTCDate() + (r.w + 6) % 7) : (t = (n = (t = this._newDate(c(r.y))).getDay()) > 4 || 0 === n ? s.monday.ceil(t) : s.monday.floor(t), t = o["default"].offset(t, 7 * (r.V - 1)), r.y = t.getFullYear(), r.m = t.getMonth(), r.d = t.getDate() + (r.w + 6) % 7);
        } else ("W" in r || "U" in r) && ("w" in r || (r.w = "u" in r ? r.u % 7 : "W" in r ? 1 : 0), n = "Z" in r ? u(c(r.y)).getUTCDay() : this._newDate(c(r.y)).getDay(), r.m = 0, r.d = "W" in r ? (r.w + 6) % 7 + 7 * r.W - (n + 5) % 7 : r.w + 7 * r.U - (n + 6) % 7);

        return "Z" in r ? (r.H += r.Z / 100 | 0, r.M += r.Z % 100, u(r)) : this._newDate(r);
      }, e.prototype.toString = function () {
        return this._specifier;
      }, e;
    }();

    t.utcDate = u, t["default"] = d;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(286),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(287);
    var s = new i["default"]("day", function (e) {
      return e.setHours(0, 0, 0, 0);
    }, function (e, t) {
      return e.setDate(e.getDate() + t);
    }, function (e, t) {
      return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * a.durationMinute) / a.durationDay;
    }, function (e) {
      return e.getDate() - 1;
    });
    t["default"] = s;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = new Date(),
        o = new Date(),
        i = function i(e) {
      return void 0 === e || null === e;
    },
        a = function () {
      function e(t, n, r, o, i) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this._name = t, this._floori = n, this._offseti = r, this._count = o, this._field = i;
      }

      return e.prototype.name = function () {
        return this._name;
      }, e.prototype.floor = function (e) {
        var t = new Date(Number(e));
        return this._floori(t), t;
      }, e.prototype.ceil = function (e) {
        var t = new Date(e - 1);
        return this._floori(t), this._offseti(t, 1), this._floori(t), t;
      }, e.prototype.round = function (e) {
        var t = this.floor(e),
            n = this.ceil(e);
        return e - t < n - e ? t : n;
      }, e.prototype.offset = function (e, t) {
        var n = new Date(Number(e));
        return this._offseti(n, i(t) ? 1 : Math.floor(t)), n;
      }, e.prototype.range = function (e, t, n) {
        var r = [],
            o = this.ceil(e),
            a = i(n) ? 1 : Math.floor(n),
            s = void 0;
        if (!(o < t && a > 0)) return r;

        do {
          s = new Date(Number(o)), r.push(s), this._offseti(o, a), this._floori(o);
        } while (s < o && o < t);

        return r;
      }, e.prototype.filter = function (t) {
        var n = this;
        return new e(this.name(), function (e) {
          if (!Number.isNaN(Number(e))) for (; n._floori(e), !t(e);) {
            e.setTime(e - 1);
          }
        }, function (e, r) {
          var o = r;
          if (!Number.isNaN(Number(e))) if (o < 0) for (; ++o <= 0;) {
            0;

            do {
              n._offseti(e, -1);
            } while (!t(e));
          } else for (; --o >= 0;) {
            do {
              n._offseti(e, 1);
            } while (!t(e));
          }
        });
      }, e.prototype.count = function (e, t) {
        var n = 0;
        return this._count && (r.setTime(Number(e)), o.setTime(Number(t)), this._floori(r), this._floori(o), n = Math.floor(this._count(r, o))), n;
      }, e.prototype.every = function (e) {
        var t = this,
            n = Math.floor(e);
        return this._count && Number.isFinite(n) && n > 0 ? n > 1 ? this.filter(this._field ? function (e) {
          return t._field(e) % n == 0;
        } : function (e) {
          return t.count(0, e) % n == 0;
        }) : this : null;
      }, e;
    }();

    t["default"] = a;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    t.durationSecond = 1e3, t.durationMinute = 6e4, t.durationHour = 36e5, t.durationDay = 864e5, t.durationWeek = 6048e5, t.durationMonth = 2592e6, t.durationQuarter = 78894e5, t.durationYear = 315576e5;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(286),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(287);
    var s = new i["default"]("day", function (e) {
      return e.setUTCHours(0, 0, 0, 0);
    }, function (e, t) {
      return e.setUTCDate(e.getUTCDate() + t);
    }, function (e, t) {
      return (t - e) / a.durationDay;
    }, function (e) {
      return e.getUTCDate() - 1;
    });
    t["default"] = s;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.utcSaturday = t.utcFriday = t.utcThursday = t.utcWednesday = t.utcTuesday = t.utcMonday = t.utcSunday = undefined;
    var r,
        o = n(286),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(287);

    var s = function s(e, t) {
      return new i["default"](t, function (t) {
        t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
      }, function (e, t) {
        return e.setUTCDate(e.getUTCDate() + 7 * t);
      }, function (e, t) {
        return (t - e) / a.durationWeek;
      });
    },
        l = s(0, "week"),
        c = s(0, "sunday"),
        u = s(1, "monday"),
        d = s(2, "tuesday"),
        f = s(3, "wednesday"),
        h = s(4, "thursday"),
        p = s(5, "friday"),
        g = s(6, "saturday");

    t["default"] = l, t.utcSunday = c, t.utcMonday = u, t.utcTuesday = d, t.utcWednesday = f, t.utcThursday = h, t.utcFriday = p, t.utcSaturday = g;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.saturday = t.friday = t.thursday = t.wednesday = t.tuesday = t.monday = t.sunday = undefined;
    var r,
        o = n(286),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(287);

    var s = function s(e, t) {
      return new i["default"](t, function (t) {
        t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
      }, function (e, t) {
        return e.setDate(e.getDate() + 7 * t);
      }, function (e, t) {
        return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * a.durationMinute) / a.durationWeek;
      });
    },
        l = s(0, "week"),
        c = s(0, "sunday"),
        u = s(1, "monday"),
        d = s(2, "tuesday"),
        f = s(3, "wednesday"),
        h = s(4, "thursday"),
        p = s(5, "friday"),
        g = s(6, "saturday");

    t["default"] = l, t.sunday = c, t.monday = u, t.tuesday = d, t.wednesday = f, t.thursday = h, t.friday = p, t.saturday = g;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(292);
    var i = new ((r = o) && r.__esModule ? r : {
      "default": r
    })["default"]("year", function (e) {
      e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
    }, function (e, t) {
      return e.setFullYear(e.getFullYear() + t);
    }, function (e, t) {
      return t.getFullYear() - e.getFullYear();
    }, function (e) {
      return e.getFullYear();
    });
    t["default"] = i;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(286),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    };

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var s = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return a(t, e), t.prototype.every = function (e) {
        var t = Math.floor(e);
        return this.count && Number.isFinite(t) && t > 0 ? new i["default"]("year", function (e) {
          e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
        }, function (e, n) {
          return e.setFullYear(e.getFullYear() + n * t);
        }) : null;
      }, t;
    }(i["default"]);

    t["default"] = s;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(294);
    var i = new ((r = o) && r.__esModule ? r : {
      "default": r
    })["default"]("year", function (e) {
      e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
    }, function (e, t) {
      return e.setUTCFullYear(e.getUTCFullYear() + t);
    }, function (e, t) {
      return t.getUTCFullYear() - e.getUTCFullYear();
    }, function (e) {
      return e.getUTCFullYear();
    });
    t["default"] = i;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(286),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    };

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var s = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return a(t, e), t.prototype.every = function (e) {
        return isFinite(e = Math.floor(e)) && e > 0 ? new i["default"]("year", function (t) {
          t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
        }, function (t, n) {
          return t.setUTCFullYear(t.getUTCFullYear() + n * e);
        }) : null;
      }, t;
    }(i["default"]);

    t["default"] = s;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    t["default"] = {
      dateTime: "%x, %X",
      date: "%-m/%-d/%Y",
      time: "%-I:%M:%S %p",
      periods: ["AM", "PM"],
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    };
  }, function (e, t, n) {
    n(297), n(78), n(298), n(301), n(312), n(315), n(317), e.exports = n(7).Set;
  }, function (e, t, n) {
    "use strict";

    var r = n(90),
        o = {};
    o[n(65)("toStringTag")] = "z", o + "" != "[object z]" && n(18)(Object.prototype, "toString", function () {
      return "[object " + r(this) + "]";
    }, !0);
  }, function (e, t, n) {
    for (var r = n(299), o = n(48), i = n(18), a = n(6), s = n(8), l = n(81), c = n(65), u = c("iterator"), d = c("toStringTag"), f = l.Array, h = {
      CSSRuleList: !0,
      CSSStyleDeclaration: !1,
      CSSValueList: !1,
      ClientRectList: !1,
      DOMRectList: !1,
      DOMStringList: !1,
      DOMTokenList: !0,
      DataTransferItemList: !1,
      FileList: !1,
      HTMLAllCollection: !1,
      HTMLCollection: !1,
      HTMLFormElement: !1,
      HTMLSelectElement: !1,
      MediaList: !0,
      MimeTypeArray: !1,
      NamedNodeMap: !1,
      NodeList: !0,
      PaintRequestList: !1,
      Plugin: !1,
      PluginArray: !1,
      SVGLengthList: !1,
      SVGNumberList: !1,
      SVGPathSegList: !1,
      SVGPointList: !1,
      SVGStringList: !1,
      SVGTransformList: !1,
      SourceBufferList: !1,
      StyleSheetList: !0,
      TextTrackCueList: !1,
      TextTrackList: !1,
      TouchList: !1
    }, p = o(h), g = 0; g < p.length; g++) {
      var m,
          v = p[g],
          y = h[v],
          b = a[v],
          x = b && b.prototype;
      if (x && (x[u] || s(x, u, f), x[d] || s(x, d, v), l[v] = f, y)) for (m in r) {
        x[m] || i(x, m, r[m], !0);
      }
    }
  }, function (e, t, n) {
    "use strict";

    var r = n(98),
        o = n(300),
        i = n(81),
        a = n(24);
    e.exports = n(80)(Array, "Array", function (e, t) {
      this._t = a(e), this._i = 0, this._k = t;
    }, function () {
      var e = this._t,
          t = this._k,
          n = this._i++;
      return !e || n >= e.length ? (this._t = undefined, o(1)) : o(0, "keys" == t ? n : "values" == t ? e[n] : [n, e[n]]);
    }, "values"), i.Arguments = i.Array, r("keys"), r("values"), r("entries");
  }, function (e, t) {
    e.exports = function (e, t) {
      return {
        value: t,
        done: !!e
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(302),
        o = n(308);
    e.exports = n(309)("Set", function (e) {
      return function () {
        return e(this, arguments.length > 0 ? arguments[0] : undefined);
      };
    }, {
      add: function add(e) {
        return r.def(o(this, "Set"), e = 0 === e ? 0 : e, e);
      }
    }, r);
  }, function (e, t, n) {
    "use strict";

    var r = n(9).f,
        o = n(46),
        i = n(303),
        a = n(21),
        s = n(304),
        l = n(305),
        c = n(80),
        u = n(300),
        d = n(306),
        f = n(13),
        h = n(307).fastKey,
        p = n(308),
        g = f ? "_s" : "size",
        m = function m(e, t) {
      var n,
          r = h(t);
      if ("F" !== r) return e._i[r];

      for (n = e._f; n; n = n.n) {
        if (n.k == t) return n;
      }
    };

    e.exports = {
      getConstructor: function getConstructor(e, t, n, c) {
        var u = e(function (e, r) {
          s(e, u, t, "_i"), e._t = t, e._i = o(null), e._f = undefined, e._l = undefined, e[g] = 0, r != undefined && l(r, n, e[c], e);
        });
        return i(u.prototype, {
          clear: function clear() {
            for (var e = p(this, t), n = e._i, r = e._f; r; r = r.n) {
              r.r = !0, r.p && (r.p = r.p.n = undefined), delete n[r.i];
            }

            e._f = e._l = undefined, e[g] = 0;
          },
          "delete": function _delete(e) {
            var n = p(this, t),
                r = m(n, e);

            if (r) {
              var o = r.n,
                  i = r.p;
              delete n._i[r.i], r.r = !0, i && (i.n = o), o && (o.p = i), n._f == r && (n._f = o), n._l == r && (n._l = i), n[g]--;
            }

            return !!r;
          },
          forEach: function forEach(e) {
            p(this, t);

            for (var n, r = a(e, arguments.length > 1 ? arguments[1] : undefined, 3); n = n ? n.n : this._f;) {
              for (r(n.v, n.k, this); n && n.r;) {
                n = n.p;
              }
            }
          },
          has: function has(e) {
            return !!m(p(this, t), e);
          }
        }), f && r(u.prototype, "size", {
          get: function get() {
            return p(this, t)[g];
          }
        }), u;
      },
      def: function def(e, t, n) {
        var r,
            o,
            i = m(e, t);
        return i ? i.v = n : (e._l = i = {
          i: o = h(t, !0),
          k: t,
          v: n,
          p: r = e._l,
          n: undefined,
          r: !1
        }, e._f || (e._f = i), r && (r.n = i), e[g]++, "F" !== o && (e._i[o] = i)), e;
      },
      getEntry: m,
      setStrong: function setStrong(e, t, n) {
        c(e, t, function (e, n) {
          this._t = p(e, t), this._k = n, this._l = undefined;
        }, function () {
          for (var e = this._k, t = this._l; t && t.r;) {
            t = t.p;
          }

          return this._t && (this._l = t = t ? t.n : this._t._f) ? u(0, "keys" == e ? t.k : "values" == e ? t.v : [t.k, t.v]) : (this._t = undefined, u(1));
        }, n ? "entries" : "values", !n, !0), d(t);
      }
    };
  }, function (e, t, n) {
    var r = n(18);

    e.exports = function (e, t, n) {
      for (var o in t) {
        r(e, o, t[o], n);
      }

      return e;
    };
  }, function (e, t) {
    e.exports = function (e, t, n, r) {
      if (!(e instanceof t) || r !== undefined && r in e) throw TypeError(n + ": incorrect invocation!");
      return e;
    };
  }, function (e, t, n) {
    var r = n(21),
        o = n(86),
        i = n(87),
        a = n(10),
        s = n(31),
        l = n(89),
        c = {},
        u = {};
    (t = e.exports = function (e, t, n, d, f) {
      var h,
          p,
          g,
          m,
          v = f ? function () {
        return e;
      } : l(e),
          y = r(n, d, t ? 2 : 1),
          b = 0;
      if ("function" != typeof v) throw TypeError(e + " is not iterable!");

      if (i(v)) {
        for (h = s(e.length); h > b; b++) {
          if ((m = t ? y(a(p = e[b])[0], p[1]) : y(e[b])) === c || m === u) return m;
        }
      } else for (g = v.call(e); !(p = g.next()).done;) {
        if ((m = o(g, y, p.value, t)) === c || m === u) return m;
      }
    }).BREAK = c, t.RETURN = u;
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(9),
        i = n(13),
        a = n(65)("species");

    e.exports = function (e) {
      var t = r[e];
      i && t && !t[a] && o.f(t, a, {
        configurable: !0,
        get: function get() {
          return this;
        }
      });
    };
  }, function (e, t, n) {
    var r = n(20)("meta"),
        o = n(11),
        i = n(19),
        a = n(9).f,
        s = 0,
        l = Object.isExtensible || function () {
      return !0;
    },
        c = !n(14)(function () {
      return l(Object.preventExtensions({}));
    }),
        u = function u(e) {
      a(e, r, {
        value: {
          i: "O" + ++s,
          w: {}
        }
      });
    },
        d = e.exports = {
      KEY: r,
      NEED: !1,
      fastKey: function fastKey(e, t) {
        if (!o(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;

        if (!i(e, r)) {
          if (!l(e)) return "F";
          if (!t) return "E";
          u(e);
        }

        return e[r].i;
      },
      getWeak: function getWeak(e, t) {
        if (!i(e, r)) {
          if (!l(e)) return !0;
          if (!t) return !1;
          u(e);
        }

        return e[r].w;
      },
      onFreeze: function onFreeze(e) {
        return c && d.NEED && l(e) && !i(e, r) && u(e), e;
      }
    };
  }, function (e, t, n) {
    var r = n(11);

    e.exports = function (e, t) {
      if (!r(e) || e._t !== t) throw TypeError("Incompatible receiver, " + t + " required!");
      return e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(5),
        i = n(18),
        a = n(303),
        s = n(307),
        l = n(305),
        c = n(304),
        u = n(11),
        d = n(14),
        f = n(91),
        h = n(83),
        p = n(310);

    e.exports = function (e, t, n, g, m, v) {
      var y = r[e],
          b = y,
          x = m ? "set" : "add",
          w = b && b.prototype,
          C = {},
          _ = function _(e) {
        var t = w[e];
        i(w, e, "delete" == e ? function (e) {
          return !(v && !u(e)) && t.call(this, 0 === e ? 0 : e);
        } : "has" == e ? function (e) {
          return !(v && !u(e)) && t.call(this, 0 === e ? 0 : e);
        } : "get" == e ? function (e) {
          return v && !u(e) ? undefined : t.call(this, 0 === e ? 0 : e);
        } : "add" == e ? function (e) {
          return t.call(this, 0 === e ? 0 : e), this;
        } : function (e, n) {
          return t.call(this, 0 === e ? 0 : e, n), this;
        });
      };

      if ("function" == typeof b && (v || w.forEach && !d(function () {
        new b().entries().next();
      }))) {
        var S = new b(),
            E = S[x](v ? {} : -0, 1) != S,
            k = d(function () {
          S.has(1);
        }),
            A = f(function (e) {
          new b(e);
        }),
            T = !v && d(function () {
          for (var e = new b(), t = 5; t--;) {
            e[x](t, t);
          }

          return !e.has(-0);
        });
        A || ((b = t(function (t, n) {
          c(t, b, e);
          var r = p(new y(), t, b);
          return n != undefined && l(n, m, r[x], r), r;
        })).prototype = w, w.constructor = b), (k || T) && (_("delete"), _("has"), m && _("get")), (T || E) && _(x), v && w.clear && delete w.clear;
      } else b = g.getConstructor(t, e, m, x), a(b.prototype, n), s.NEED = !0;

      return h(b, e), C[e] = b, o(o.G + o.W + o.F * (b != y), C), v || g.setStrong(b, e, m), b;
    };
  }, function (e, t, n) {
    var r = n(11),
        o = n(311).set;

    e.exports = function (e, t, n) {
      var i,
          a = t.constructor;
      return a !== n && "function" == typeof a && (i = a.prototype) !== n.prototype && r(i) && o && o(e, i), e;
    };
  }, function (e, t, n) {
    var r = n(11),
        o = n(10),
        i = function i(e, t) {
      if (o(e), !r(t) && null !== t) throw TypeError(t + ": can't set as prototype!");
    };

    e.exports = {
      set: Object.setPrototypeOf || ("__proto__" in {} ? function (e, t, r) {
        try {
          (r = n(21)(Function.call, n(40).f(Object.prototype, "__proto__").set, 2))(e, []), t = !(e instanceof Array);
        } catch (o) {
          t = !0;
        }

        return function (e, n) {
          return i(e, n), t ? e.__proto__ = n : r(e, n), e;
        };
      }({}, !1) : undefined),
      check: i
    };
  }, function (e, t, n) {
    var r = n(5);
    r(r.P + r.R, "Set", {
      toJSON: n(313)("Set")
    });
  }, function (e, t, n) {
    var r = n(90),
        o = n(314);

    e.exports = function (e) {
      return function () {
        if (r(this) != e) throw TypeError(e + "#toJSON isn't generic");
        return o(this);
      };
    };
  }, function (e, t, n) {
    var r = n(305);

    e.exports = function (e, t) {
      var n = [];
      return r(e, !1, n.push, n, t), n;
    };
  }, function (e, t, n) {
    n(316)("Set");
  }, function (e, t, n) {
    "use strict";

    var r = n(5);

    e.exports = function (e) {
      r(r.S, e, {
        of: function of() {
          for (var e = arguments.length, t = new Array(e); e--;) {
            t[e] = arguments[e];
          }

          return new this(t);
        }
      });
    };
  }, function (e, t, n) {
    n(318)("Set");
  }, function (e, t, n) {
    "use strict";

    var r = n(5),
        o = n(22),
        i = n(21),
        a = n(305);

    e.exports = function (e) {
      r(r.S, e, {
        from: function from(e) {
          var t,
              n,
              r,
              s,
              l = arguments[1];
          return o(this), (t = l !== undefined) && o(l), e == undefined ? new this() : (n = [], t ? (r = 0, s = i(l, arguments[2], 2), a(e, !1, function (e) {
            n.push(s(e, r++));
          })) : a(e, !1, n.push, n), new this(n));
        }
      });
    };
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if ("string" != typeof e) throw new Error("eventName must be a non-empty string");
      if (!(t instanceof Object)) throw new Error("sender must be an object");
      return t._evtHandlers && t._evtHandlers[e] || [];
    }

    t.__esModule = !0, t.addHandler = function o(e, t, n) {
      var r;

      if (t instanceof Array) {
        for (var i = [], a = t.length, s = 0; s < a; s += 1) {
          i.push(o(e, t[s], n));
        }

        return i;
      }

      if (!e || "string" != typeof e) throw new Error("eventName must be a non-empty string");
      if ("function" != typeof t) throw new Error("handler must be a function");
      if (!(n instanceof Object)) throw new Error("sender must be an object");
      n._evtHandlers = n._evtHandlers || {}, n._evtHandlers[e] && n._evtHandlers[e] instanceof Array || (n._evtHandlers[e] = []), r = n._evtHandlers[e].length;

      for (var l = 0; l < r; l++) {
        if (n._evtHandlers[e][l] === t) return !1;
      }

      return n._evtHandlers[e].push(t), !0;
    }, t.getHanlders = r, t.removeHandler = function i(e, t, n) {
      var o, a;

      if (t instanceof Array) {
        for (var s = [], l = t.length, c = 0; c < l; c += 1) {
          s.push(i(e, t[c], n));
        }

        return s;
      }

      if (!e || "string" != typeof e) throw new Error("eventName must be a non-empty string");
      if (t && "function" != typeof t) throw new Error("handler must be a function");
      if (!(n instanceof Object)) throw new Error("sender must be an object");

      if ((o = r(e, n)) instanceof Array && 0 !== o.length) {
        if (!t) return delete n._evtHandlers[e], !0;
        a = o.length;

        for (var u = 0; u < a; u++) {
          o[u] === t && o.splice(u, 1);
        }

        return !0;
      }
    }, t.triggerEvent = function (e, t, n) {
      var o, i, a;
      if (!e || "string" != typeof e) throw new Error("eventName must be a non-empty string");
      if (!(t instanceof Object)) throw new Error("sender must be an object");

      if (a = {
        eventName: e,
        sender: t,
        data: n
      }, (o = r(e, t)) instanceof Array && 0 !== o.length) {
        i = o.length;

        for (var s = 0; s < i; s++) {
          o[s](a);
        }

        return !0;
      }
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.pivot = t.sort = t.pipe = t.groupBy = t.select = t.filter = t.greaterEquals = t.greater = t.lessEquals = t.less = t.equals = t.between = undefined;
    var r = n(321);
    t.between = r.between, t.equals = r.equals, t.less = r.less, t.lessEquals = r.lessEquals, t.greater = r.greater, t.greaterEquals = r.greaterEquals, t.filter = r.filter, t.select = r.select, t.groupBy = r.groupBy, t.pipe = r.pipe, t.sort = r.sort, t.pivot = r.pivot;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.pivot = t.sort = t.pipe = t.groupBy = t.select = t.filter = t.greaterEquals = t.indexColGreaterEquals = t.greater = t.indexColGreater = t.lessEquals = t.indexColLessEquals = t.less = t.indexColLess = t.equals = t.indexColEquals = t.between = t.indexColBetween = undefined;
    var r = n(322),
        o = n(325),
        i = c(n(326)),
        a = c(n(346)),
        s = c(n(347)),
        l = c(n(348));

    function c(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    t.indexColBetween = r.indexColBetween, t.between = r.between, t.indexColEquals = r.indexColEquals, t.equals = r.equals, t.indexColLess = r.indexColLess, t.less = r.less, t.indexColLessEquals = r.indexColLessEquals, t.lessEquals = r.lessEquals, t.indexColGreater = r.indexColGreater, t.greater = r.greater, t.indexColGreaterEquals = r.indexColGreaterEquals, t.greaterEquals = r.greaterEquals, t.filter = o.filter, t.select = o.select, t.groupBy = i["default"], t.pipe = a["default"], t.sort = s["default"], t.pivot = l["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.greaterEquals = t.indexColGreaterEquals = t.greater = t.indexColGreater = t.lessEquals = t.indexColLessEquals = t.less = t.indexColLess = t.equals = t.indexColEquals = t.between = t.indexColBetween = undefined;
    var r = n(323),
        o = n(276),
        i = n(324),
        a = n(278);

    function s(e, t, n, o) {
      var s = t,
          l = n;
      return {
        ops: "indexColBetween",
        type: i.OperatorTypes.IndexOpsFilter,
        _updateArgs: function _updateArgs(e, t) {
          s = e, l = t;
        },
        fn: function fn(t, n, i, c) {
          c && (t = c.call()), o || (o = h(n, e));
          var u,
              d,
              f = void 0;
          return f = "interval" === n[e].type ? function (t, n) {
            return (0, a.numberComparator)(t[e].end, n);
          } : o, u = (0, r.leftMostExactOrGreater)(s, t, o, 0, t.length), d = (0, r.rightMostExactOrLesser)(l, t, f, u, t.length), {
            data: t,
            schema: n,
            config: i,
            generatorFn: function generatorFn() {
              return t.slice(u, d + 1);
            }
          };
        }
      };
    }

    function l(e, t, n) {
      var o = t;
      return {
        ops: "indexColEquals",
        type: i.OperatorTypes.IndexOpsFilter,
        _updateArgs: function _updateArgs(e) {
          o = e;
        },
        fn: function fn(t, i, a, s) {
          s && (t = s.call()), n || (n = h(i, e));
          var l, c;
          return (l = (0, r.leftMostExactOrGreater)(o, t, n, 0, t.length)) >= t.length || 0 !== n(t[l], o) ? {
            data: [],
            schema: i,
            config: a
          } : (c = (0, r.rightMostExactOrLesser)(o, t, n, l, t.length), {
            data: t,
            schema: i,
            config: a,
            generatorFn: function generatorFn() {
              return t.slice(l, c + 1);
            }
          });
        }
      };
    }

    function c(e, t, n) {
      var o = t;
      return {
        ops: "indexColLess",
        type: i.OperatorTypes.IndexOpsFilter,
        _updateArgs: function _updateArgs(e) {
          o = e;
        },
        fn: function fn(t, i, a, s) {
          s && (t = s.call()), n || (n = h(i, e));
          var l = (0, r.leftMostExactOrGreater)(o, t, n, 0, t.length);
          return {
            data: t,
            schema: i,
            config: a,
            generatorFn: function generatorFn() {
              return t.slice(0, l);
            }
          };
        }
      };
    }

    function u(e, t, n) {
      var o = t;
      return {
        ops: "indexColLessEquals",
        type: i.OperatorTypes.IndexOpsFilter,
        _updateArgs: function _updateArgs(e) {
          o = e;
        },
        fn: function fn(t, i, a, s) {
          s && (t = s.call()), n || (n = h(i, e));
          var l = (0, r.rightMostExactOrLesser)(o, t, n, 0, t.length);
          return {
            data: t,
            schema: i,
            config: a,
            generatorFn: function generatorFn() {
              return t.slice(0, l + 1);
            }
          };
        }
      };
    }

    function d(e, t, n) {
      var o = t;
      return {
        ops: "indexColGreater",
        type: i.OperatorTypes.IndexOpsFilter,
        _updateArgs: function _updateArgs(e) {
          o = e;
        },
        fn: function fn(t, i, a, s) {
          s && (t = s.call()), n || (n = h(i, e));
          var l = (0, r.rightMostExactOrLesser)(o, t, n, 0, t.length),
              c = (0, r.leftMostExactOrGreater)(null, t, n, l, t.length);
          return {
            data: t,
            schema: i,
            config: a,
            generatorFn: function generatorFn() {
              return t.slice(l + 1, c);
            }
          };
        }
      };
    }

    function f(e, t, n) {
      var o = t;
      return {
        ops: "indexColGreaterEquals",
        type: i.OperatorTypes.IndexOpsFilter,
        _updateArgs: function _updateArgs(e) {
          o = e;
        },
        fn: function fn(t, i, a, s) {
          s && (t = s.call()), n || (n = h(i, e));
          var l = (0, r.leftMostExactOrGreater)(o, t, n, 0, t.length),
              c = (0, r.leftMostExactOrGreater)(null, t, n, l, t.length);
          return {
            data: t,
            schema: i,
            config: a,
            generatorFn: function generatorFn() {
              return t.slice(l, c);
            }
          };
        }
      };
    }

    var h = function h(e, t) {
      switch (e[t].type) {
        case "interval":
          return function (e, n) {
            return (0, a.numberComparator)(e[t].start, n);
          };

        case "number":
        case "date":
          return function (e, n) {
            return (0, a.numberComparator)(e[t], n);
          };

        default:
          return function (e, n) {
            return (0, a.stringComparator)(String(e[t]).toLowerCase(), String(n).toLowerCase());
          };
      }
    };

    t.indexColBetween = s, t.between = function (e, t, n) {
      var r = t,
          a = n;
      return {
        ops: "between",
        type: i.OperatorTypes.GenericFilter,
        _updateArgs: function _updateArgs(e, t) {
          r = e, a = t;
        },
        fn: function fn(t, n, i, l) {
          l && (t = l.call());
          var c = (0, o.columnIndexOf)(e, n),
              u = void 0;
          if (c >= 0) return u = h(n, c), i && i.indexBy === e ? s(c, r, a, u).fn(t, n, i) : {
            data: t,
            schema: n,
            config: i,
            generatorFn: function generatorFn() {
              return t.filter(function (e) {
                return u(e, r) >= 0 && u(e, a) <= 0;
              });
            }
          };
          throw new Error("Column '" + e + "' is not found in the schema.");
        }
      };
    }, t.indexColEquals = l, t.equals = function (e, t) {
      var n = t;
      return {
        ops: "equals",
        type: i.OperatorTypes.GenericFilter,
        _updateArgs: function _updateArgs(e) {
          n = e;
        },
        fn: function fn(t, r, i, a) {
          a && (t = a.call());
          var s = (0, o.columnIndexOf)(e, r),
              c = void 0;
          if (s >= 0) return c = h(r, s), i && i.indexBy === e ? l(s, n, c).fn(t, r, i) : {
            data: t,
            schema: r,
            config: i,
            generatorFn: function generatorFn() {
              return t.filter(function (e) {
                return 0 === c(e, n);
              });
            }
          };
          throw new Error("Column '" + e + "' is not found in the schema.");
        }
      };
    }, t.indexColLess = c, t.less = function (e, t) {
      var n = t;
      return {
        ops: "less",
        type: i.OperatorTypes.GenericFilter,
        _updateArgs: function _updateArgs(e) {
          n = e;
        },
        fn: function fn(t, r, i, a) {
          a && (t = a.call());
          var s = (0, o.columnIndexOf)(e, r),
              l = void 0;
          if (s >= 0) return l = h(r, s), i && i.indexBy === e ? c(s, n, l).fn(t, r, i) : {
            data: t,
            schema: r,
            config: i,
            generatorFn: function generatorFn() {
              return t.filter(function (e) {
                return l(e, n) < 0;
              });
            }
          };
          throw new Error("Column '" + e + "' is not found in the schema.");
        }
      };
    }, t.indexColLessEquals = u, t.lessEquals = function (e, t) {
      var n = t;
      return {
        ops: "lessEquals",
        type: i.OperatorTypes.GenericFilter,
        _updateArgs: function _updateArgs(e) {
          n = e;
        },
        fn: function fn(t, r, i, a) {
          a && (t = a.call());
          var s = (0, o.columnIndexOf)(e, r),
              l = void 0;
          if (s >= 0) return l = h(r, s), i && i.indexBy === e ? u(s, n, l).fn(t, r, i) : {
            data: t,
            schema: r,
            config: i,
            generatorFn: function generatorFn() {
              return t.filter(function (e) {
                return l(e, n) <= 0;
              });
            }
          };
          throw new Error("Column '" + e + "' is not found in the schema.");
        }
      };
    }, t.indexColGreater = d, t.greater = function (e, t) {
      var n = t;
      return {
        ops: "greater",
        type: i.OperatorTypes.GenericFilter,
        _updateArgs: function _updateArgs(e) {
          n = e;
        },
        fn: function fn(t, r, i, a) {
          a && (t = a.call());
          var s = (0, o.columnIndexOf)(e, r),
              l = void 0;
          if (s >= 0) return l = h(r, s), i && i.indexBy === e ? d(s, n, l).fn(t, r, i) : {
            data: t,
            schema: r,
            config: i,
            generatorFn: function generatorFn() {
              return t.filter(function (e) {
                return null !== e[s] && "undefined" != typeof e[s] && l(e, n) > 0;
              });
            }
          };
          throw new Error("Column '" + e + "' is not found in the schema.");
        }
      };
    }, t.indexColGreaterEquals = f, t.greaterEquals = function (e, t) {
      var n = t;
      return {
        ops: "greaterEquals",
        type: i.OperatorTypes.GenericFilter,
        _updateArgs: function _updateArgs(e) {
          n = e;
        },
        fn: function fn(t, r, i, a) {
          a && (t = a.call());
          var s = (0, o.columnIndexOf)(e, r),
              l = void 0;
          if (s >= 0) return l = h(r, s), i && i.indexBy === e ? f(s, n, l).fn(t, r, i) : {
            data: t,
            schema: r,
            config: i,
            generatorFn: function generatorFn() {
              return t.filter(function (e) {
                return null !== e[s] && "undefined" != typeof e[s] && l(e, n) >= 0;
              });
            }
          };
          throw new Error("Column '" + e + "' is not found in the schema.");
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.leftMostExactOrGreater = function (e, t, n, r, o) {
      for (var i = r, a = o; i < a;) {
        var s = i + Math.floor((a - i) / 2);
        n(t[s], e) < 0 ? i = s + 1 : a = s;
      }

      return i;
    }, t.rightMostExactOrLesser = function (e, t, n, r, o) {
      for (var i = r, a = o; i < a;) {
        var s = i + Math.floor((a - i) / 2);
        n(t[s], e) > 0 ? a = s : i = s + 1;
      }

      return i - 1;
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    t.OperatorTypes = {
      IndexOpsFilter: 0,
      GenericFilter: 1,
      GroupBy: 2,
      Sort: 3,
      Select: 4
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.filter = t.select = undefined;
    var r = n(324),
        o = n(276);
    t.select = function (e, t) {
      return e = e && e.constructor !== Array ? [e] : e, {
        ops: "select",
        type: r.OperatorTypes.Select,
        fn: function fn(n, r, i, a) {
          var s = [],
              l = [];

          if (e) {
            var c = void 0;
            if ((t = t || {
              exclude: !1
            }).exclude) for (c = 0; c < r.length; c++) {
              e.includes(r[c].name) || (s.push(r[c]), l.push(c));
            } else {
              var u = void 0;

              for (c = 0; c < e.length; c++) {
                (u = (0, o.columnIndexOf)(e[c], r)) > -1 && !l.includes(u) && (s.push(r[u]), l.push(u));
              }
            }
          } else s = r;

          return {
            data: n,
            schema: s,
            config: i,
            generatorFn: function generatorFn() {
              var e = l.length;

              if (e > 0) {
                var t = [],
                    r = void 0,
                    o = void 0,
                    i = void 0;

                for (r = 0; r < n.length; r++) {
                  for (i = [], o = 0; o < e; o++) {
                    i[o] = n[r][l[o]];
                  }

                  t[r] = i;
                }

                return t;
              }

              return n.slice(0);
            }
          };
        }
      };
    }, t.filter = function (e) {
      var t = this;
      return {
        ops: "filter",
        type: r.OperatorTypes.GenericFilter,
        fn: function fn(n, r, o, i) {
          return {
            data: n,
            schema: r,
            config: o,
            generatorFn: function generatorFn() {
              i && (n = i.call());

              for (var o = {}, a = 0; a < r.length; a++) {
                o[r[a].name] = a;
              }

              return n.filter(function (n) {
                return e.call(t, n, o);
              });
            }
          };
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t._singleSortedAddRowDate = t._singleSortedAddRow = undefined;
    var r,
        o = n(276),
        i = n(327),
        a = n(342),
        s = n(343),
        l = n(344),
        c = (r = l) && r.__esModule ? r : {
      "default": r
    };
    n(345);
    var u = n(280),
        d = n(324),
        f = n(323),
        h = n(278);

    function p(e, t, n, r) {
      var o,
          i,
          a,
          s,
          l,
          u = [],
          d = t.length,
          f = n.length;

      for (t = t instanceof Array ? t : [t], n = n instanceof Array ? n : [n], a = 0; a < d; a++) {
        o = r(t[a].column, e), l = {
          name: t[a].outputAs || t[a].column,
          type: "date" === o.type ? "interval" : o.type
        }, o.enableUTC !== undefined && (l.enableUTC = o.enableUTC), u.push(l);
      }

      for (a = 0; a < f; a++) {
        if (s = n[a].operation || "avg", o = r(n[a].column, e), !c["default"].resolve(s)) throw new Error(s + " is not a defined operation");

        switch (s) {
          case "first":
          case "last":
            i = o.type;
            break;

          case "count":
            i = "number";
            break;

          default:
            if ("number" !== o.type) throw new Error(s + " can apply only on numbers");
            i = "number";
        }

        u.push({
          name: n[a].outputAs || n[a].column + (s ? " - " + s : ""),
          type: i
        });
      }

      return u;
    }

    function g(e, t, n) {
      return t && n === t[0] || (t = [n], e.push(t)), t;
    }

    function m(e, t, n, r, o) {
      if (n >= t[0].end) {
        var a = void 0;

        switch (r.duration.Unit) {
          case "Month":
          case "Quarter":
          case "Year":
            a = (0, i.getDateStart)(n, r.duration, r.enableUTC, r.weekStartFrom, o);
            break;

          default:
            a = n - (n - o) % r.duration.ms;
        }

        t = [(0, s.interval)(a, r)], e.push(t);
      }

      return t;
    }

    function v() {
      var e = {};
      return function (t, n, r) {
        if (!e[t]) {
          var i = (0, o.columnIndexOf)(t, n),
              a = n[i];
          if (a === undefined) throw new Error("incorrect column name in config - " + t);
          e[t] = a, e[t].column = t, e[t].index = i, "date" === a.type && r && (e[t].peaks = (0, o.columnExtents)(t, r, n));
        }

        return e[t];
      };
    }

    function y(e, t, n, r, o, a, l, c, u, d) {
      var f = void 0,
          h = void 0,
          p = "",
          g = [],
          m = void 0,
          v = void 0,
          y = n.length;

      if (e.length > 0) {
        for (f = 0; f < y; f++) {
          if ("date" === (h = o(n[f].column, t)).type) {
            if (a[f].startValFloorVal > e[h.index]) return c;

            switch (n[f].timeUnit.name) {
              case "Month":
              case "Quarter":
              case "Year":
                a[f].value = (0, i.getDateStart)(e[h.index], a[f].intervalConfig.duration, a[f].intervalConfig.enableUTC, a[f].intervalConfig.weekStartFrom, a[f].startValFloorVal);
                break;

              default:
                a[f].value = e[h.index] - (e[h.index] - a[f].startValFloorVal) % a[f].intervalConfig.duration.ms;
            }

            p += a[f].value + "-";
          } else g[f] = e[h.index], p += e[h.index] + "-";
        }

        if (l[p = p.slice(0, -1)] >= 0) g = u[l[p]], m = l[p];else {
          for (var x in l[p] = c++, a) {
            v = (0, s.interval)(a[x].value, a[x].intervalConfig), g[x] = v;
          }

          u.push(g), m = u.length - 1;
        }
        return d[m] = d[m] || {}, g && b(e, t, g, y, r, o, d[m]), c;
      }
    }

    function b(e, t, n, r, o, i, a) {
      var s = o.length,
          l = void 0,
          u = void 0,
          d = void 0,
          f = void 0;

      for (f = 0; f < s; f++) {
        if (e[(l = i(o[f].column, t)).index] !== undefined && null !== e[l.index]) {
          switch (u = o[f].operation || "avg") {
            case "sum":
            case "min":
            case "max":
            case "first":
            case "last":
              d = null;
              break;

            default:
              d = a[f] = a[f] && a[f] + 1 || 1;
          }

          n[r + f] = "count" === u ? d : c["default"].resolve(u)(n[r + f] !== undefined ? n[r + f] : null, e[l.index], d);
        }
      }
    }

    t["default"] = function (e, t) {
      var n = e,
          r = t;
      return {
        ops: "groupBy",
        type: d.OperatorTypes.GroupBy,
        _updateArgs: function _updateArgs(e, t) {
          n = e, r = t;
        },
        fn: function fn(e, t, l, c) {
          if (c && (e = c.call()), !n || 0 === n.length) throw new Error("groupConfigArray cannot be empty");
          if (!r || 0 === r.length) throw new Error("aggrConfigArray cannot be empty");
          return !(n instanceof Array) && n instanceof Object && (n = [n]), !(r instanceof Array) && r instanceof Object && (r = [r]), 1 === n.length && l && n[0].column === l.indexBy ? function (e, t, n, r, l) {
            var c,
                d,
                y,
                x,
                w,
                C,
                _,
                S,
                E = [],
                k = [],
                A = e.length,
                T = 0,
                M = v(),
                O = [];

            if ((c = M(r.column, t)).outputAs = r.outputAs, k = p(t, [c], l, M), A > 0) {
              if (_ = c.enableUTC || (0, u.getConfig)("enableUTC"), "date" === c.type) {
                var F = void 0,
                    I = void 0,
                    L = void 0;
                y = (0, a.duration)(r.timeUnit, Math.abs(r.binSize) || 1), e[0] && e[0][c.index] && e[A - 1] && e[A - 1][c.index] || (F = (0, o.columnExtents)(r.column, e, t, n.indexBy)), I = e[0] && e[0][c.index] || F.min, (L = r.startValue && parseInt(r.startValue, 10)) ? L >= I ? (x = (0, i.getDateStart)(L, (0, a.duration)(r.timeUnit, 1), _, r.weekStartFrom), T = (0, f.leftMostExactOrGreater)(x, e, function (e, t) {
                  return (0, h.numberComparator)(e[c.index], t);
                }, 0, e.length)) : x = (0, i.getDateStart)(I, y, _, r.weekStartFrom, L) : x = (0, i.getDateStart)(I, (0, a.duration)(r.timeUnit, 1), _, r.weekStartFrom), d = e[A - 1] && e[A - 1][c.index] || F.max;
              }

              if (x === undefined || x <= d) {
                var N = {
                  duration: y,
                  outputFormat: r.outputFormat,
                  enableUTC: _,
                  weekStartFrom: r.weekStartFrom
                };

                for (x !== undefined && (w = [(0, s.interval)(x, N)], E.push(w)), S = T; S < A; S++) {
                  e[S].length > 0 && ("date" === c.type ? w = m(E, w, e[S][c.index], N, x) : "string" !== c.type && "number" !== c.type || (w = g(E, w, e[S][c.index])), C = E.length - 1, O[C] = O[C] || {}, w && b(e[S], t, w, 1, l, M, O[C]));
                }
              }
            }

            return {
              data: E,
              schema: k,
              config: {
                indexBy: r.outputAs || r.column
              }
            };
          }(e, t, l, n[0], r) : function (e, t, n, r, o) {
            var s,
                l,
                c,
                d,
                f = [],
                h = [],
                g = [],
                m = !0,
                b = e.length,
                x = r.length,
                w = {},
                C = [],
                _ = v(),
                S = {},
                E = 0;

            for (d = 0; d < x; d++) {
              (s = _(r[d].column, t, e)).outputAs = r[d].outputAs, "date" === s.type && (w[d] || (r[d].startValue >= s.peaks.max && (m = !1), w[d] = Object.assign({}, s), w[d].intervalConfig = {
                duration: (0, a.duration)(r[d].timeUnit, Math.abs(r[d].binSize) || 1),
                outputFormat: r[d].outputFormat,
                enableUTC: s.enableUTC || (0, u.getConfig)("enableUTC"),
                weekStartFrom: r[d].weekStartFrom
              }, l = parseInt(r[d].startValue, 10) || s.peaks.min, w[d].startValFloorVal = l && (0, i.getDateStart)(l, (0, a.duration)(r[d].timeUnit, 1), w[d].intervalConfig.enableUTC, w[d].intervalConfig.weekStartFrom, parseInt(r[d].startValue, 10)), w[d].max = s.peaks.max)), g[d] = s, c || r[d].column !== n.indexBy || (c = r[d].outputAs || r[d].column);
            }

            if (h = p(t, g, o, _), m && b > 0) for (d = 0; d < b; d++) {
              E = y(e[d], t, r, o, _, w, S, E, f, C);
            }
            return {
              data: f,
              schema: h,
              config: {
                indexBy: c
              }
            };
          }(e, t, l, n, r);
        }
      };
    }, t._singleSortedAddRow = g, t._singleSortedAddRowDate = m;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.getDateOffset = t.getDateStart = t.dateRangeCaclulator = t.dateIntervalToString = t.getDefaultOutputFormat = undefined;
    var r,
        o = c(n(328)),
        i = c(n(336)),
        a = n(341),
        s = n(281),
        l = (r = s) && r.__esModule ? r : {
      "default": r
    };

    function c(e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t["default"] = e, t;
    }

    var u = {
      Year: "%Y",
      Month: "%b %Y",
      Day: "%b %d, %Y",
      Hour: "%b %d, %Y %H hrs",
      Minute: "%b %d, %Y %H:%M",
      Second: "%b %d, %Y %H:%M:%S",
      Millisecond: "%b %d, %Y %H:%M:%S:%L"
    },
        d = {
      Millisecond: o.timeMillisecond,
      Second: o.timeSecond,
      Minute: o.timeMinute,
      Hour: o.timeHour,
      Day: o.timeDay,
      Week: {
        0: o.timeSunday,
        1: o.timeMonday,
        2: o.timeTuesday,
        3: o.timeWednesday,
        4: o.timeThursday,
        5: o.timeFriday,
        6: o.timeSaturday
      },
      Month: o.timeMonth,
      Quarter: o.timeQuarter,
      Year: o.timeYear
    },
        f = {
      Millisecond: i.utcMillisecond,
      Second: i.utcSecond,
      Minute: i.utcMinute,
      Hour: i.utcHour,
      Day: i.utcDay,
      Week: {
        0: i.utcSunday,
        1: i.utcMonday,
        2: i.utcTuesday,
        3: i.utcWednesday,
        4: i.utcThursday,
        5: i.utcFriday,
        6: i.utcSaturday
      },
      Month: i.utcMonth,
      Quarter: i.utcQuarter,
      Year: i.utcYear
    };

    function h(e, t, n, r, o) {
      var i = n !== undefined && n ? f[t.Unit] : d[t.Unit];
      if (r && !a.Weekdays[r.name]) throw new Error("Invalid weekStartFrom provided: " + r);
      if (1 === t.number) return "Week" === t.Unit ? +i[(r = r || a.Weekdays.Sunday).id].floor(new Date(e)) : +i.floor(new Date(e));

      if (o) {
        var s = void 0;
        return "Week" === t.Unit ? (s = i[(r = r || a.Weekdays.Sunday).id].count(o, e) % t.number) ? p(+i[r.id].floor(e), t.Unit, -s, n, r) : +i[r.id].floor(e) : (s = i.count(o, e) % t.number) ? p(+i.floor(e), t.Unit, -s, n, r) : +i.floor(e);
      }

      return "Week" === t.Unit ? +i[(r = r || a.Weekdays.Sunday).id].every(t.number).floor(new Date(e)) : +i.every(t.number).floor(new Date(e));
    }

    function p(e, t, n, r, o) {
      switch (t) {
        case "Month":
        case "Quarter":
        case "Year":
          return +(r !== undefined && r ? f[t] : d[t]).offset(new Date(e), n);

        default:
          return e + a.DatetimeUnits[t].ms * n;
      }
    }

    t.getDefaultOutputFormat = function (e) {
      switch (e) {
        case "Millisecond":
        case "Second":
        case "Minute":
        case "Hour":
        case "Day":
        case "Month":
        case "Year":
          return u[e];

        case "Week":
          return u.Day;

        case "Quarter":
          return u.Month;
      }
    }, t.dateIntervalToString = function () {
      var e,
          t = this.config;

      switch (e = t.enableUTC !== undefined && t.enableUTC ? l["default"].utcFormatter(t.outputFormat) : l["default"].formatter(t.outputFormat), t.duration.Unit) {
        case "Millisecond":
        case "Second":
        case "Minute":
        case "Hour":
        case "Day":
        case "Month":
        case "Year":
          return e.format(new Date(this.start)) + (t.duration.number > 1 ? " - " + e.format(new Date(this.end - 1)) : "");

        case "Week":
        case "Quarter":
          return e.format(new Date(this.start)) + " - " + e.format(new Date(this.end - 1));
      }
    }, t.dateRangeCaclulator = function (e, t, n, r) {
      var o, i;
      return o = e, arguments.length > 4 && arguments[4] !== undefined && arguments[4] && ((i = Object.assign({}, t)).number = 1, o = h(o, i, n, r)), {
        startDate: o,
        endDate: p(o, t.Unit, t.number, n)
      };
    }, t.getDateStart = h, t.getDateOffset = p;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.timeYear = t.timeMonth = t.timeQuarter = t.timeSaturday = t.timeFriday = t.timeThursday = t.timeWednesday = t.timeTuesday = t.timeMonday = t.timeSunday = t.timeWeek = t.timeDay = t.timeHour = t.timeMinute = t.timeSecond = t.timeMillisecond = undefined;
    var r = h(n(329)),
        o = h(n(331)),
        i = h(n(332)),
        a = h(n(333)),
        s = h(n(285)),
        l = n(290),
        c = h(l),
        u = h(n(334)),
        d = h(n(335)),
        f = h(n(291));

    function h(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    t.timeMillisecond = r["default"], t.timeSecond = o["default"], t.timeMinute = i["default"], t.timeHour = a["default"], t.timeDay = s["default"], t.timeWeek = c["default"], t.timeSunday = l.sunday, t.timeMonday = l.monday, t.timeTuesday = l.tuesday, t.timeWednesday = l.wednesday, t.timeThursday = l.thursday, t.timeFriday = l.friday, t.timeSaturday = l.saturday, t.timeQuarter = u["default"], t.timeMonth = d["default"], t.timeYear = f["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(330);
    var i = new ((r = o) && r.__esModule ? r : {
      "default": r
    })["default"]("millisecond", function () {}, function (e, t) {
      return e.setTime(Number(e) + Number(t));
    }, function (e, t) {
      return t - e;
    });
    t["default"] = i;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(286),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    };

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
        for (var n = Object.getOwnPropertyNames(t), r = 0; r < n.length; r++) {
          var o = n[r],
              i = Object.getOwnPropertyDescriptor(t, o);
          i && i.configurable && e[o] === undefined && Object.defineProperty(e, o, i);
        }
      }(e, t));
    }

    var s = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, e.apply(this, arguments));
      }

      return a(t, e), t.prototype.every = function (e) {
        var t = Math.floor(e);
        return this.count && Number.isFinite(t) && t > 0 ? t > 1 ? new i["default"]("millisecond", function (e) {
          return e.setTime(Math.floor(e / t) * t);
        }, function (e, n) {
          return e.setTime(Number(e) + n * t);
        }, function (e, n) {
          return (n - e) / t;
        }) : this : null;
      }, t;
    }(i["default"]);

    t["default"] = s;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(286),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(287);
    var s = new i["default"]("second", function (e) {
      return e.setTime(Math.floor(e / a.durationSecond) * a.durationSecond);
    }, function (e, t) {
      return e.setTime(Number(e) + t * a.durationSecond);
    }, function (e, t) {
      return (t - e) / a.durationSecond;
    }, function (e) {
      return e.getUTCSeconds();
    });
    t["default"] = s;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(286),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(287);
    var s = new i["default"]("minute", function (e) {
      return e.setTime(Math.floor(e / a.durationMinute) * a.durationMinute);
    }, function (e, t) {
      return e.setTime(Number(e) + t * a.durationMinute);
    }, function (e, t) {
      return (t - e) / a.durationMinute;
    }, function (e) {
      return e.getMinutes();
    });
    t["default"] = s;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(286),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(287);
    var s = new i["default"]("hour", function (e) {
      var t = e.getTimezoneOffset() * a.durationMinute % a.durationHour;
      t < 0 && (t += a.durationHour), e.setTime(Math.floor((Number(e) - t) / a.durationHour) * a.durationHour + t);
    }, function (e, t) {
      return e.setTime(Number(e) + t * a.durationHour);
    }, function (e, t) {
      return (t - e) / a.durationHour;
    }, function (e) {
      return e.getHours();
    });
    t["default"] = s;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(286);
    var i = new ((r = o) && r.__esModule ? r : {
      "default": r
    })["default"]("quarter", function (e) {
      e.setMonth(e.getMonth() - (e.getMonth() + 3) % 3, 1), e.setHours(0, 0, 0, 0);
    }, function (e, t) {
      return e.setMonth(e.getMonth() + 3 * t);
    }, function (e, t) {
      return (t.getMonth() - (t.getMonth() + 3) % 3 - (e.getMonth() - (e.getMonth() + 3) % 3)) / 3 + 4 * (t.getFullYear() - e.getFullYear());
    }, function (e) {
      return Math.floor(e.getMonth() / 3);
    });
    t["default"] = i;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(286);
    var i = new ((r = o) && r.__esModule ? r : {
      "default": r
    })["default"]("month", function (e) {
      e.setDate(1), e.setHours(0, 0, 0, 0);
    }, function (e, t) {
      return e.setMonth(e.getMonth() + t);
    }, function (e, t) {
      return t.getMonth() - e.getMonth() + 12 * (t.getFullYear() - e.getFullYear());
    }, function (e) {
      return e.getMonth();
    });
    t["default"] = i;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.utcYear = t.utcMonth = t.utcQuarter = t.utcSaturday = t.utcFriday = t.utcThursday = t.utcWednesday = t.utcTuesday = t.utcMonday = t.utcSunday = t.utcWeek = t.utcDay = t.utcHour = t.utcMinute = t.utcSecond = t.utcMillisecond = undefined;
    var r = h(n(329)),
        o = h(n(331)),
        i = h(n(337)),
        a = h(n(338)),
        s = h(n(288)),
        l = n(289),
        c = h(l),
        u = h(n(339)),
        d = h(n(340)),
        f = h(n(293));

    function h(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    t.utcMillisecond = r["default"], t.utcSecond = o["default"], t.utcMinute = i["default"], t.utcHour = a["default"], t.utcDay = s["default"], t.utcWeek = c["default"], t.utcSunday = l.utcSunday, t.utcMonday = l.utcMonday, t.utcTuesday = l.utcTuesday, t.utcWednesday = l.utcWednesday, t.utcThursday = l.utcThursday, t.utcFriday = l.utcFriday, t.utcSaturday = l.utcSaturday, t.utcQuarter = u["default"], t.utcMonth = d["default"], t.utcYear = f["default"], t["default"] = {
      getInterval: function getInterval(e) {
        switch (e + "") {
          case "millisecond":
            return r["default"];

          case "second":
            return o["default"];

          case "minute":
            return i["default"];

          case "hour":
            return a["default"];

          case "day":
            return s["default"];

          case "week":
            return c["default"];

          case "sunday":
            return l.utcSunday;

          case "monday":
            return l.utcMonday;

          case "tuesday":
            return l.utcTuesday;

          case "wednesday":
            return l.utcWednesday;

          case "thursday":
            return l.utcThursday;

          case "friday":
            return l.utcFriday;

          case "saturday":
            return l.utcSaturday;

          case "quarter":
            return u["default"];

          case "month":
            return d["default"];

          case "year":
            return f["default"];
        }
      }
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(286),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(287);
    var s = new i["default"]("minute", function (e) {
      return e.setUTCSeconds(0, 0);
    }, function (e, t) {
      return e.setTime(Number(e) + t * a.durationMinute);
    }, function (e, t) {
      return (t - e) / a.durationMinute;
    }, function (e) {
      return e.getUTCMinutes();
    });
    t["default"] = s;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(286),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    },
        a = n(287);
    var s = new i["default"]("hour", function (e) {
      return e.setUTCMinutes(0, 0, 0);
    }, function (e, t) {
      return e.setTime(Number(e) + t * a.durationHour);
    }, function (e, t) {
      return (t - e) / a.durationHour;
    }, function (e) {
      return e.getUTCHours();
    });
    t["default"] = s;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(286);
    var i = new ((r = o) && r.__esModule ? r : {
      "default": r
    })["default"]("quarter", function (e) {
      e.setUTCMonth(e.getUTCMonth() - (e.getUTCMonth() + 3) % 3, 1), e.setUTCHours(0, 0, 0, 0);
    }, function (e, t) {
      return e.setUTCMonth(e.getUTCMonth() + 3 * t);
    }, function (e, t) {
      return (t.getUTCMonth() - (t.getUTCMonth() + 3) % 3 - (e.getUTCMonth() - (e.getUTCMonth() + 3) % 3)) / 3 + 4 * (t.getUTCFullYear() - e.getUTCFullYear());
    }, function (e) {
      return Math.floor(e.getMonth() / 3);
    });
    t["default"] = i;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(286);
    var i = new ((r = o) && r.__esModule ? r : {
      "default": r
    })["default"]("month", function (e) {
      e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
    }, function (e, t) {
      return e.setUTCMonth(e.getUTCMonth() + t);
    }, function (e, t) {
      return t.getUTCMonth() - e.getUTCMonth() + 12 * (t.getUTCFullYear() - e.getUTCFullYear());
    }, function (e) {
      return e.getUTCMonth();
    });
    t["default"] = i;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.Weekdays = t.DatetimeUnits = undefined;
    var r = n(287),
        o = {
      Millisecond: {
        name: "Millisecond",
        ms: 1
      },
      Second: {
        name: "Second",
        ms: r.durationSecond
      },
      Minute: {
        name: "Minute",
        ms: r.durationMinute
      },
      Hour: {
        name: "Hour",
        ms: r.durationHour
      },
      Day: {
        name: "Day",
        ms: r.durationDay
      },
      Week: {
        name: "Week",
        ms: r.durationWeek
      },
      Month: {
        name: "Month",
        ms: r.durationMonth
      },
      Quarter: {
        name: "Quarter",
        ms: r.durationQuarter
      },
      Year: {
        name: "Year",
        ms: r.durationYear
      }
    };
    t.DatetimeUnits = o, t.Weekdays = {
      Sunday: {
        name: "Sunday",
        id: 0
      },
      Monday: {
        name: "Monday",
        id: 1
      },
      Tuesday: {
        name: "Tuesday",
        id: 2
      },
      Wednesday: {
        name: "Wednesday",
        id: 3
      },
      Thursday: {
        name: "Thursday",
        id: 4
      },
      Friday: {
        name: "Friday",
        id: 5
      },
      Saturday: {
        name: "Saturday",
        id: 6
      }
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.duration = undefined;
    var r = n(341);

    t.duration = function (e, t) {
      if (!e || !r.DatetimeUnits[e.name]) throw new Error("Invalid Unit provided: " + e);
      return t = Math.abs(t) || 1, {
        Unit: e.name,
        number: t,
        ms: e.ms * t
      };
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.interval = undefined;
    var r = n(341),
        o = n(327);

    t.interval = function (e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined && arguments[2];

      if (t.duration.ms) {
        var i = (0, o.dateRangeCaclulator)(e, t.duration, t.enableUTC, t.weekStartFrom || r.Weekdays.Sunday, n),
            a = i.startDate,
            s = i.endDate;
        return t.outputFormat = t.outputFormat || (0, o.getDefaultOutputFormat)(t.duration.Unit), {
          start: a,
          end: s,
          config: t,
          toString: o.dateIntervalToString
        };
      }
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.store = {};
      }

      return e.prototype.register = function (e, t) {
        this.store[e] = t;
      }, e.prototype.resolve = function (e) {
        return this.store[e];
      }, e;
    }(),
        o = function () {
      var e = null;
      return null === e && (e = new r()), e;
    }();

    t["default"] = o;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.avg = t.sum = undefined;
    var r,
        o,
        i,
        a,
        s,
        l = n(344),
        c = (r = l) && r.__esModule ? r : {
      "default": r
    };
    t.sum = o = function o(e, t) {
      return e + t;
    }, t.avg = i = function i(e, t, n) {
      return ((n - 1) * e + t) / n;
    }, s = {
      sum: o,
      avg: i,
      count: function count(e) {
        return ++e;
      },
      min: function min(e, t) {
        return null !== e ? e > t ? t : e : t;
      },
      max: function max(e, t) {
        return null !== e ? e < t ? t : e : t;
      },
      first: function first(e, t) {
        return null === e ? t : e;
      },
      last: function last(e, t) {
        return t;
      },
      variance: a = function a(e, t, n) {
        var r,
            o = t,
            a = 0;
        return e && (o = e.avg, a = e.variance), r = o, n > 1 && (a = (a * (n - 2) + (t - (o = i(o, t, n))) * (t - r)) / (n - 1)), {
          avg: o,
          variance: a
        };
      },
      stddev: function stddev(e, t, n) {
        var r, o;
        return e && (r = {
          avg: e.avg,
          variance: e.stddev * e.stddev
        }), {
          avg: (o = a(r, t, n)).avg,
          stddev: Math.sqrt(o.variance)
        };
      }
    }, Object.entries(s).forEach(function (e) {
      c["default"].register(e[0], e[1]);
    }), t.sum = o, t.avg = i;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = function () {
      for (var e = void 0, t = [], n = [], i = [], a = function a(e, t) {
        for (var n = [], r = e.length, i = 0; i < r; i++) {
          t[i] || n.push(e[i]);
        }

        return n && n.length > 0 && (0, o.binaryInsertionSort)(n, function (e, t) {
          return e.type - t.type;
        }), n;
      }, s = arguments.length, l = Array(s), c = 0; c < s; c++) {
        l[c] = arguments[c];
      }

      e = l.length;

      for (var u = 0; u < e; u++) {
        switch (l[u].type) {
          case r.OperatorTypes.IndexOpsFilter:
          case r.OperatorTypes.GenericFilter:
            t.push(l[u]), n.push(!1);
            break;

          case r.OperatorTypes.Select:
          case r.OperatorTypes.Sort:
            t.push(l[u]), n.push(!0);
            break;

          case r.OperatorTypes.GroupBy:
            i = i.concat(a(t, n), l[u]), t = [], n = [];
        }
      }

      return i = i.concat(function (e) {
        var t = [],
            n = e.length;
        (0, o.binaryInsertionSort)(e, function (e, t) {
          return e.type - t.type;
        }), t.push(e[0]);

        for (var r = 1; r < n; r++) {
          e[r].type >= 3 && e[r].type === t[t.length - 1].type && t.pop(), t.push(e[r]);
        }

        return t;
      }(t));
    };
    var r = n(324),
        o = n(279);
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r,
        o = n(324),
        i = n(276),
        a = n(278),
        s = n(279),
        l = (r = s) && r.__esModule ? r : {
      "default": r
    };

    t["default"] = function (e) {
      var t = e;
      return {
        ops: "sort",
        type: o.OperatorTypes.Sort,
        _updateArgs: function _updateArgs(e) {
          t = e;
        },
        fn: function fn(e, n, r, o) {
          return {
            data: e,
            schema: n,
            config: t.constructor === Array && t.length ? {
              indexBy: t[0].column
            } : t.constructor === Object ? {
              indexBy: t.column
            } : undefined,
            generatorFn: function generatorFn() {
              o && (e = o.call());
              var r = void 0;
              if (t.constructor === Function) r = t;else {
                t.constructor !== Array && (t = [t]);
                var s = [],
                    c = [],
                    u = void 0,
                    d = void 0,
                    f = void 0;

                for (u = 0; u < t.length; u++) {
                  if (t[u].column) {
                    if (d = (0, i.columnIndexOf)(t[u].column, n), c.push(d), -1 === d) throw new Error("Sort column is not found in schema - " + t[u].column);

                    switch (n[d].type) {
                      case "number":
                      case "interval":
                      case "date":
                        s.push(a.numberComparator);
                        break;

                      default:
                        s.push(a.stringComparator);
                    }
                  }
                }

                r = function r(e, _r5) {
                  for (u = 0; u < t.length; u++) {
                    if (0 !== (f = "interval" === n[c[u]].type ? "desc" === t[u].order ? s[u](_r5[c[u]].start, e[c[u]].start) : s[u](e[c[u]].start, _r5[c[u]].start) : "desc" === t[u].order ? s[u](_r5[c[u]], e[c[u]]) : s[u](e[c[u]], _r5[c[u]]))) return f;
                    if (u === t.length - 1) return 0;
                  }
                };
              }
              return (0, l["default"])(e, r), e;
            }
          };
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(276),
        o = n(327),
        i = n(342),
        a = n(343),
        s = p(n(344));
    n(345);
    var l = n(280),
        c = n(324),
        u = n(326),
        d = p(u),
        f = n(278),
        h = n(323);

    function p(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function g(e, t, n, r, o, i, a, l, c) {
      var u = o.length,
          d = void 0,
          f = void 0,
          h = void 0,
          p = void 0,
          g = void 0;

      for (p = 0; p < u; p++) {
        if (e[d = l(o[p].column, t)] !== undefined && null !== e[d]) {
          switch (f = o[p].operation || "avg", g = a[e[i] + " - " + (o[p].outputAs || o[p].column + (f ? " - " + f : ""))], f) {
            case "sum":
            case "min":
            case "max":
            case "first":
            case "last":
              h = null;
              break;

            default:
              h = c[g] = c[g] && c[g] + 1 || 1;
          }

          n[r + g] = "count" === f ? h : s["default"].resolve(f)(n[r + g] !== undefined ? n[r + g] : null, e[d], h);
        }
      }
    }

    t["default"] = function (e, t, n) {
      var p = e,
          m = t,
          v = n;
      return {
        ops: "pivot",
        type: c.OperatorTypes.GroupBy,
        _updateArgs: function _updateArgs(e, t, n) {
          p = e, m = t, v = n;
        },
        fn: function fn(e, t, n, c) {
          if (0 === p.length) throw new Error("groupConfigArray cannot be empty");
          if (0 === v.length) throw new Error("aggrConfigArray cannot be empty");
          if (!m) throw new Error("pivotCol cannot be empty");
          return !(p instanceof Array) && p instanceof Object && (p = [p]), !(v instanceof Array) && v instanceof Object && (v = [v]), 1 === p.length && n && p[0].column === n.indexBy ? function (e, t, n, c, d, p) {
            var m,
                v,
                y,
                b,
                x,
                w,
                C,
                _,
                S,
                E,
                k,
                A,
                T,
                M,
                O = [],
                F = [],
                I = {},
                L = e.length,
                N = 0,
                D = (M = {}, function (e, t) {
              return M[e] || (M[e] = (0, r.columnIndexOf)(e, t)), M[e];
            }),
                P = [];

            if (-1 === (v = (0, r.columnIndexOf)(c.column, t))) throw new Error("incorrect column name in groupConfigArr - " + c);
            if (-1 === (b = (0, r.columnIndexOf)(p, t))) throw new Error("incorrect pivot column name");

            if (y = t[v], x = t[b], (C = Object.assign({}, c)).type = y.type, C.outputAs = c.outputAs, m = function (e, t, n, o, i) {
              var a,
                  l,
                  c,
                  u,
                  d,
                  h,
                  p,
                  g,
                  m,
                  v,
                  y,
                  b,
                  x,
                  w = [],
                  C = {},
                  _ = 0;

              for (n = n instanceof Array ? n : [n], o = o instanceof Array ? o : [o], u = n.length, d = o.length, v = 0; v < u; v++) {
                if (h = (0, r.columnIndexOf)(n[v].column, t), p = t[h], -1 === h) throw new Error("incorrect column name in groupConfigArr - " + n[v].column);
                x = {
                  name: n[v].outputAs || n[v].column,
                  type: "date" === p.type ? "interval" : p.type
                }, p.enableUTC !== undefined && (x.enableUTC = p.enableUTC), w.push(x);
              }

              switch (i.type) {
                case "number":
                case "date":
                  a = f.numberComparator;
                  break;

                default:
                  a = f.stringComparator;
              }

              for ((l = (0, r.columnUnique)(i.name, e, t)).sort(function (e, t) {
                return a(e, t);
              }), c = l.length, v = 0; v < d; v++) {
                if (b = o[v].operation || "avg", h = (0, r.columnIndexOf)(o[v].column, t), p = t[h], -1 === h) throw new Error("incorrect column name in aggrConfigArr - " + o[v].column);
                if (!s["default"].resolve(b)) throw new Error(b + " is not a defined operation");

                switch (b) {
                  case "first":
                  case "last":
                    g = p.type;
                    break;

                  case "count":
                    g = "number";
                    break;

                  default:
                    if ("number" !== p.type) throw new Error(b + " can apply only on numbers");
                    g = "number";
                }

                for (y = 0; y < c; y++) {
                  m = l[y] + " - " + (o[v].outputAs || o[v].column + (b ? " - " + b : "")), C[m] = _++, w.push({
                    name: m,
                    type: g
                  });
                }
              }

              return {
                schema: w,
                pivots: C
              };
            }(e, t, C, d, x), F = m.schema, I = m.pivots, L > 0) {
              if (A = y.enableUTC || (0, l.getConfig)("enableUTC"), "date" === y.type) {
                var R = void 0,
                    j = void 0,
                    V = void 0;
                _ = (0, i.duration)(c.timeUnit, Math.abs(c.binSize) || 1), e[0] && e[0][v] && e[L - 1] && e[L - 1][v] || (R = (0, r.columnExtents)(c.column, e, t, n.indexBy)), j = e[0] && e[0][v] || R.min, (V = c.startValue && parseInt(c.startValue, 10)) ? V >= j ? (S = (0, o.getDateStart)(V, (0, i.duration)(c.timeUnit, 1), A, c.weekStartFrom), N = (0, h.leftMostExactOrGreater)(S, e, function (e, t) {
                  return (0, f.numberComparator)(e[v], t);
                }, 0, e.length)) : S = (0, o.getDateStart)(j, _, A, c.weekStartFrom, V) : S = (0, o.getDateStart)(j, (0, i.duration)(c.timeUnit, 1), A, c.weekStartFrom), w = e[L - 1] && e[L - 1][v] || R.max;
              }

              if (S === undefined || S <= w) {
                var B = {
                  duration: _,
                  outputFormat: c.outputFormat,
                  enableUTC: A,
                  weekStartFrom: c.weekStartFrom
                };

                for (S !== undefined && (E = [(0, a.interval)(S, B)], O.push(E)), T = N; T < L; T++) {
                  e[T].length > 0 && ("date" === y.type ? E = (0, u._singleSortedAddRowDate)(O, E, e[T][v], B, S) : "string" !== y.type && "number" !== y.type || (E = (0, u._singleSortedAddRow)(O, E, e[T][v])), k = O.length - 1, P[k] = P[k] || {}, E && g(e[T], t, E, 1, d, b, I, D, P[k]));
                }
              }
            }

            return {
              data: O,
              schema: F,
              config: {
                indexBy: c.outputAs || c.column
              }
            };
          }(e, t, n, p[0], v, m) : function (e, t, n, o, i, a, s) {
            var l = void 0,
                c = void 0,
                u = void 0,
                h = void 0,
                p = void 0,
                g = void 0,
                m = void 0,
                v = void 0,
                y = void 0,
                b = {},
                x = {},
                w = function w(e) {
              return x.hasOwnProperty(e) ? x[e] : -1;
            },
                C = function C(e, t) {
              x[e] = t;
            },
                _ = function _(e, t, n, r) {
              return e + " - " + (t || n + (r ? " - " + r : ""));
            },
                S = [],
                E = [];

            switch (l = (0, d["default"])(i.concat({
              column: s
            }), a), c = l.fn(e, t, n, o), h = (0, r.columnUnique)(s, e, t), m = (0, r.columnIndexOf)(s, c.schema), c.schema[m].type) {
              case "number":
              case "date":
                u = f.numberComparator;
                break;

              default:
                u = f.stringComparator;
            }

            return p = h && h.sort(function (e, t) {
              return u(e, t);
            }) || [], g = c.schema.filter(function (e) {
              return e.name !== s;
            }), v = g.length, y = i.map(function (e) {
              return e.outputAs || e.column;
            }), S = function () {
              for (var e = [], t = void 0, n = function n(_n3) {
                if (y.includes(g[_n3].name)) e.push(g[_n3]), b[g[_n3].name] = _n3;else {
                  t = a.filter(function (e) {
                    return (e.outputAs || e.column + (e.operation ? " - " + e.operation : "")) === g[_n3].name;
                  })[0];

                  for (var r = 0; r < p.length; r++) {
                    e.push({
                      name: _(p[r], t.outputAs, t.column, t.operation),
                      type: g[_n3].type
                    });
                  }
                }
              }, r = 0; r < v; r++) {
                n(r);
              }

              return e;
            }(), c.data.length > 0 && (E = function (e) {
              var t = [],
                  n = e.length,
                  r = {},
                  o = void 0,
                  i = void 0,
                  l = void 0,
                  u = void 0,
                  d = void 0,
                  f = {},
                  h = "";

              for (o = 0; o < n; o++) {
                r[e[o].name] = o;
              }

              for (o = 0; o < c.data.length; o++) {
                for (f = {}, h = "", i = 0; i < c.schema.length; i++) {
                  b.hasOwnProperty(c.schema[i].name) ? (f[r[c.schema[i].name]] = c.data[o][i], "interval" === c.schema[i].type ? h += c.data[o][i].start : h += c.data[o][i]) : c.schema[i].name !== s && (u = a.filter(function (e) {
                    return (e.outputAs || e.column + (e.operation ? " - " + e.operation : "")) === c.schema[i].name;
                  })[0], (d = r[_(c.data[o][m], u.outputAs, u.column, u.operation)]) && (f[d] = c.data[o][i]));
                }

                if ((l = w(h)) > -1) {
                  var p = t[l];

                  for (var g in f) {
                    p[g] = f[g];
                  }
                } else {
                  var v = new Array(n);

                  for (var y in f) {
                    v[y] = f[y];
                  }

                  t.push(v), C(h, t.length - 1);
                }
              }

              return t;
            }(S)), {
              data: E,
              schema: S,
              config: {
                indexBy: c.config.indexBy === s ? undefined : c.config.indexBy
              }
            };
          }(e, t, n, c, p, v, m);
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.aggregatorStore = undefined;
    var r,
        o = n(344),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    };
    t.aggregatorStore = i["default"];
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.Weekdays = t.DatetimeUnits = t.duration = t.formatDate = t.parseDate = t.after = t.before = undefined;
    var r = n(351),
        o = n(352),
        i = n(342),
        a = n(341);
    t.before = r.before, t.after = r.after, t.parseDate = o.parseDate, t.formatDate = o.formatDate, t.duration = i.duration, t.DatetimeUnits = a.DatetimeUnits, t.Weekdays = a.Weekdays;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.after = t.before = undefined;
    var r = n(327),
        o = n(341);
    t.before = function (e, t, n, i) {
      if (!e) throw new Error("duration is missing");
      if (t && (isNaN(t) || isNaN(+new Date(t)))) throw new Error("timestamp is incorrect");
      return (0, r.getDateOffset)(isNaN(t) ? +new Date() : t, e.Unit, -e.number, n, i || o.Weekdays.Sunday);
    }, t.after = function (e, t, n, i) {
      if (!e) throw new Error("duration is missing");
      if (t && (isNaN(t) || isNaN(+new Date(t)))) throw new Error("timestamp is incorrect");
      return (0, r.getDateOffset)(isNaN(t) ? +new Date() : t, e.Unit, e.number, n, i || o.Weekdays.Sunday);
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.formatDate = t.parseDate = undefined;
    var r,
        o = n(281),
        i = (r = o) && r.__esModule ? r : {
      "default": r
    };
    t.parseDate = function (e, t, n) {
      var r;
      if (t && (r = (r = (n !== undefined && n ? i["default"].utcParser(t) : i["default"].parser(t)).parse(e)) && r.getTime()), r || (r = n !== undefined && n ? +new Date(e + "Z") : +new Date(e)), !r) throw new Error("Incorrect string or format provided");
      return r;
    }, t.formatDate = function (e, t, n) {
      var r;
      if (isNaN(parseInt(e, 10))) throw new Error("Timestamp must be a number: " + e);
      if (t || (t = "%a, %-d %b %Y, %H:%M:%S:%L"), !(r = (n !== undefined && n ? i["default"].utcFormatter(t) : i["default"].formatter(t)).format(new Date(e)))) throw new Error("Incorrect format provided: " + t);
      return r;
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = {
      column2d: "charts",
      column3d: "charts",
      bar2d: "charts",
      bar3d: "charts",
      pie2d: "charts",
      pie3d: "charts",
      line: "charts",
      area2d: "charts",
      doughnut2d: "charts",
      doughnut3d: "charts",
      pareto2d: "charts",
      pareto3d: "charts",
      mscolumn2d: "charts",
      mscolumn3d: "charts",
      msline: "charts",
      msarea: "charts",
      msbar2d: "charts",
      msbar3d: "charts",
      stackedcolumn2d: "charts",
      marimekko: "charts",
      stackedcolumn3d: "charts",
      stackedarea2d: "charts",
      stackedcolumn2dline: "charts",
      stackedcolumn3dline: "charts",
      stackedbar2d: "charts",
      stackedbar3d: "charts",
      msstackedcolumn2d: "charts",
      mscombi2d: "charts",
      mscombi3d: "charts",
      mscolumnline3d: "charts",
      mscombidy2d: "charts",
      mscolumn3dlinedy: "charts",
      stackedcolumn3dlinedy: "charts",
      msstackedcolumn2dlinedy: "charts",
      scatter: "charts",
      bubble: "charts",
      ssgrid: "charts",
      scrollcolumn2d: "charts",
      scrollcolumn3d: "charts",
      scrollline2d: "charts",
      scrollarea2d: "charts",
      scrollstackedcolumn2d: "charts",
      scrollcombi2d: "charts",
      scrollcombidy2d: "charts",
      spline: "charts",
      splinearea: "charts",
      msspline: "charts",
      mssplinearea: "charts",
      mssplinedy: "charts",
      multiaxisline: "powercharts",
      multilevelpie: "powercharts",
      waterfall2d: "powercharts",
      msstepline: "powercharts",
      inversemsline: "powercharts",
      inversemscolumn2d: "powercharts",
      inversemsarea: "powercharts",
      errorbar2d: "powercharts",
      errorscatter: "powercharts",
      errorline: "powercharts",
      logmsline: "powercharts",
      logmscolumn2d: "powercharts",
      logstackedcolumn2d: "powercharts",
      radar: "powercharts",
      dragnode: "powercharts",
      candlestick: "powercharts",
      selectscatter: "powercharts",
      dragcolumn2d: "powercharts",
      dragline: "powercharts",
      dragarea: "powercharts",
      boxandwhisker2d: "powercharts",
      kagi: "powercharts",
      heatmap: "powercharts",
      angulargauge: "widgets",
      bulb: "widgets",
      cylinder: "widgets",
      drawingpad: "widgets",
      funnel: "widgets",
      hbullet: "widgets",
      hled: "widgets",
      hlineargauge: "widgets",
      vlineargauge: "widgets",
      pyramid: "widgets",
      realtimearea: "widgets",
      realtimecolumn: "widgets",
      realtimeline: "widgets",
      realtimelinedy: "widgets",
      realtimestackedarea: "widgets",
      realtimestackedcolumn: "widgets",
      sparkcolumn: "widgets",
      sparkline: "widgets",
      sparkwinloss: "widgets",
      thermometer: "widgets",
      vbullet: "widgets",
      vled: "widgets",
      zoomline: "zoomline",
      zoomlinedy: "zoomline",
      gantt: "gantt",
      treemap: "treemap",
      zoomscatter: "zoomscatter",
      overlappedbar2d: "overlappedbar2d",
      overlappedcolumn2d: "overlappedcolumn2d",
      msstackedcolumn2dsplinedy: "msstackedcolumn2dsplinedy",
      timeseries: "timeseries"
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(125),
        o = 12e4,
        i = {};

    t["default"] = function (e) {
      if (!i[e]) {
        var t = document.getElementsByTagName("head")[0],
            n = document.createElement("script"),
            a = setTimeout(function () {
          n.onerror({
            type: "timeout",
            target: n
          });
        }, o);
        n.charset = "utf-8", n.timeout = o, i[e] = new Promise(function (e, t) {
          n.onload = function (t) {
            n.onerror = n.onload = null, clearTimeout(a), e(t);
          }, n.onerror = function (e) {
            n.onerror = n.onload = null, clearTimeout(a), t(e);
          };
        }), (0, r.isXSSSafe)(e, !1) || (e = "function" == typeof window.encodeURIComponent ? window.encodeURIComponent(e) : window.escape(e)), n.src = e, t.appendChild(n);
      }

      return i[e];
    };
  }, function (e, t) {
    (function (t) {
      e.exports = t;
    }).call(this, {});
  }])["default"];
});
(window.webpackJsonpFusionCharts = window.webpackJsonpFusionCharts || []).push([[2], Array(359).concat([function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = o(n(360)),
      i = o(n(431));

  function o(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function r(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var l = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.registerFactory("dataset", i["default"], ["vCanvas"]), n;
    }

    return r(t, e), t.getName = function () {
      return "SSCartesian";
    }, t.prototype.getName = function () {
      return "SSCartesian";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this);

      var t = this.config;
      t.hasLegend = !1, t.linethickness = 4;
    }, t.prototype._checkInvalidSpecificData = function () {
      var e = this.getFromEnv("dataSource").data;
      if (!e || !e.length) return !0;
    }, t.prototype._setCategories = function () {
      var e = this.getFromEnv("dataSource"),
          t = this.getChildren("xAxis"),
          n = e.dataset,
          a = e.data || n && n[0].data;
      t[0].setTickValues(a);
    }, t;
  }(a["default"]);

  t["default"] = l;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = c(n(361)),
      i = n(125),
      o = c(n(376)),
      r = c(n(424)),
      l = c(n(427)),
      s = c(n(429));

  function c(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function u(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var h = Math.max,
      d = Math.min,
      p = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.registerFactory("axis", o["default"], ["canvas"]), n.registerFactory("canvas", r["default"]), n.registerFactory("vCanvas", l["default"], ["axis"]), n.registerFactory("mouseTracker", s["default"], ["canvas"]), n;
    }

    return u(t, e), t.getName = function () {
      return "Cartesian";
    }, t.prototype.getName = function () {
      return "Cartesian";
    }, t.prototype.getType = function () {
      return "chartAPI";
    }, t.prototype._allocateXAxisLabelSpace = function (e) {
      var t,
          n = this.config,
          a = e.getAxisEndLabelDisplaySpace(),
          i = a.left,
          o = a.right,
          r = a.top,
          l = a.bottom,
          s = n.availableWidth,
          c = n.availableHeight,
          u = n.canvasLeft,
          h = n.canvasRight,
          d = n.canvasTop,
          p = n.canvasBottom,
          f = n.width,
          g = n.height,
          m = function m(e, t) {
        return e < t && t > 0 ? t - e : 0;
      };

      r + l > c && (r = c * r / (t = r + l), l = c * l / t), i + o > s && (i = s * i / (t = i + o), o = s * o / t), i = m(u, i), o = m(f - h, o), r = m(d, r), l = m(g - p, l), this._allocateSpace({
        left: i,
        right: o,
        top: r,
        bottom: l
      });
    }, t.prototype._setCategories = function () {
      var e = this.getFromEnv("dataSource"),
          t = this.getChildren("xAxis"),
          n = e.categories && e.categories.length && e.categories[0].category;
      t && t[0].setTickValues(n);
    }, t.prototype._feedAxesRawData = function () {
      var e,
          t,
          n = this.config,
          a = this.getFromEnv("dataSource");
      return e = this.getSpecificxAxisConf(), t = this.getSpecificyAxisConf(), e.vtrendlines = (0, i.extend2)([], a.vtrendlines), t.trendlines = (0, i.extend2)([], a.trendlines), n.isstacked && (t.isPercent = (0, i.pluckNumber)(n.stack100percent, 0)), {
        yAxisConf: [t],
        xAxisConf: [e]
      };
    }, t.prototype.getSpecificxAxisConf = function () {
      var e = this.getFromEnv("chart-attrib"),
          t = this.config,
          n = this.config.is3D,
          a = this.getBasexAxisConf();
      return a.isReverse = t.reverseXAxis, a.axisLineColor = (0, i.pluck)(e.xaxislinecolor, e.axislinecolor, "#000000"), a.showAlternateGridColor = (0, i.pluckNumber)(e.showalternatevgridcolor, 0), a.numDivLines = (0, i.pluckNumber)(e.numvdivlines, t.numVDivLines), a.axisName = e.xaxisname, a.setAdaptiveMin = (0, i.pluckNumber)(e.setadaptivexmin, t.setadaptivexmin, t.setadaptivexmin), a.showLimits = (0, i.pluckNumber)(e.showvlimits, t.showvlimits), a.showDivLineValues = (0, i.pluckNumber)(e.showvdivlinevalues, e.showvdivlinevalues, t.showvdivlinevalues), a.zeroPlaneThickness = (0, i.pluckNumber)(e.vzeroplanethickness, e.vdivlinethickness, t.zeroplanethickness, 2), a.zeroPlaneAlpha = (0, i.pluckNumber)(e.vzeroplanealpha, e.vdivlinealpha, t.zeroplanealpha), a.showZeroPlaneValue = (0, i.pluckNumber)(e.showvzeroplanevalue, t.showzeroplanevalue), a.showAxisLine = n ? 0 : (0, i.pluckNumber)(e.showxaxisline, e.showaxislines, e.drawAxisLines, t.showxaxisline, 0), a.maxLabelHeight = e.maxlabelheight, a.showZeroPlane = (0, i.pluckNumber)(e.showvzeroplane, t.showzeroplane), a;
    }, t.prototype.getSpecificyAxisConf = function () {
      var e = this.getFromEnv("chart-attrib"),
          t = this.config,
          n = this.config.is3D,
          a = n ? i.chartPaletteStr.chart3D : i.chartPaletteStr.chart2D,
          o = t.isInverse,
          r = this.getFromEnv("color-manager"),
          l = (0, i.pluckNumber)(e.showzeroplane, t.showzeroplane, 1),
          s = (0, i.pluckNumber)(e.showzeroplanevalue, t.showzeroplanevalue);
      return l || void 0 !== s || (s = 0), {
        isVertical: !0,
        isReverse: !o,
        isOpposit: !1,
        outCanfontFamily: (0, i.pluck)(e.outcnvbasefont, e.basefont, "Verdana,sans"),
        outCanfontSize: (0, i.pluckFontSize)(e.outcnvbasefontsize, e.basefontsize, 10),
        outCancolor: (0, i.pluck)(e.outcnvbasefontcolor, e.basefontcolor, r.getColor(a.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi, "#$1"),
        axisBreaks: e.yaxisbreaks,
        axisNamePadding: e.yaxisnamepadding,
        axisValuePadding: e.yaxisvaluespadding,
        axisNameFont: e.yaxisnamefont,
        axisNameFontSize: e.yaxisnamefontsize,
        axisNameFontColor: e.yaxisnamefontcolor,
        axisNameFontBold: e.yaxisnamefontbold,
        axisNameFontItalic: e.yaxisnamefontitalic,
        axisNameBgColor: e.yaxisnamebgcolor,
        axisNameBorderColor: e.yaxisnamebordercolor,
        axisNameAlpha: e.yaxisnamealpha,
        axisNameFontAlpha: e.yaxisnamefontalpha,
        axisNameBgAlpha: e.yaxisnamebgalpha,
        axisNameBorderAlpha: e.yaxisnameborderalpha,
        axisNameBorderPadding: e.yaxisnameborderpadding,
        axisNameBorderRadius: e.yaxisnameborderradius,
        axisNameBorderThickness: e.yaxisnameborderthickness,
        axisNameBorderDashed: e.yaxisnameborderdashed,
        axisNameBorderDashLen: e.yaxisnameborderdashlen,
        axisNameBorderDashGap: e.yaxisnameborderdashgap,
        axisNameWidth: e.yaxisnamewidth,
        useEllipsesWhenOverflow: e.useellipseswhenoverflow,
        rotateAxisName: (0, i.pluckNumber)(e.rotateyaxisname, 1),
        axisName: e.yaxisname,
        divLineColor: (0, i.pluck)(e.divlinecolor, r.getColor(a.divLineColor)),
        divLineAlpha: (0, i.pluck)(e.divlinealpha, n ? r.getColor("divLineAlpha3D") : r.getColor("divLineAlpha")),
        divLineThickness: (0, i.pluckNumber)(e.divlinethickness, 1),
        divLineIsDashed: Boolean((0, i.pluckNumber)(e.divlinedashed, e.divlineisdashed, 0)),
        divLineDashLen: (0, i.pluckNumber)(e.divlinedashlen, 4),
        divLineDashGap: (0, i.pluckNumber)(e.divlinedashgap, 2),
        showAlternateGridColor: (0, i.pluckNumber)(e.showalternatehgridcolor, 1),
        alternateGridColor: (0, i.pluck)(e.alternatehgridcolor, r.getColor("altHGridColor")),
        alternateGridAlpha: (0, i.pluck)(e.alternatehgridalpha, r.getColor("altHGridAlpha")),
        numDivLines: (0, i.pluckNumber)(e.numdivlines, t.numDivLines),
        axisMinValue: t.yRangeMin || e.yaxisminvalue,
        axisMaxValue: t.yRangeMax || e.yaxismaxvalue,
        setAdaptiveMin: (0, i.pluckNumber)(e.setadaptivesymin, e.setadaptiveymin, t.setAdaptiveMin),
        adjustDiv: e.adjustdiv,
        labelStep: e.yaxisvaluesstep,
        showAxisValues: (0, i.pluckNumber)(e.showyaxisvalues, e.showyaxisvalue, t.showyaxisvalues),
        showLimits: (0, i.pluckNumber)(e.showyaxislimits, e.showlimits, this.showLimits),
        showDivLineValues: (0, i.pluckNumber)(e.showdivlinevalues, e.showdivlinevalue, t.showdivlinevalues),
        showZeroPlane: l,
        zeroPlaneColor: e.zeroplanecolor,
        zeroPlaneThickness: (0, i.pluckNumber)(e.zeroplanethickness, e.divlinethickness, t.zeroplanethickness, 2),
        zeroPlaneAlpha: (0, i.pluckNumber)(e.zeroplanealpha, e.divlinealpha, t.zeroplanealpha),
        showZeroPlaneValue: s,
        showZeroPlaneOnTop: t.showzeroplaneontop,
        trendlineColor: e.trendlinecolor,
        trendlineToolText: e.trendlinetooltext,
        trendlineThickness: e.trendlinethickness,
        trendlineAlpha: e.trendlinealpha,
        showTrendlinesOnTop: e.showtrendlinesontop,
        showAxisLine: n ? 0 : (0, i.pluckNumber)(e.showyaxisline, e.showaxislines, e.drawAxisLines, t.showyaxisline, 0),
        axisLineThickness: (0, i.pluckNumber)(e.yaxislinethickness, e.axislinethickness, 1),
        axisLineAlpha: (0, i.pluckNumber)(e.yaxislinealpha, e.axislinealpha, 100),
        axisLineColor: (0, i.pluck)(e.yaxislinecolor, e.axislinecolor, "#000000"),
        forceTrendBelow: !!t.is3D
      };
    }, t.prototype.getBasexAxisConf = function () {
      var e = this.getFromEnv("chart-attrib"),
          t = this.config.is3D,
          n = t ? i.chartPaletteStr.chart3D : i.chartPaletteStr.chart2D,
          a = this.getFromEnv("color-manager");
      return {
        isVertical: !1,
        isOpposit: !1,
        outCanfontFamily: (0, i.pluck)(e.outcnvbasefont, e.basefont, "Verdana,sans"),
        outCanfontSize: (0, i.pluckFontSize)(e.outcnvbasefontsize, e.basefontsize, 10),
        outCancolor: (0, i.pluck)(e.outcnvbasefontcolor, e.basefontcolor, a.getColor(n.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi, "#$1"),
        axisNamePadding: e.xaxisnamepadding,
        axisValuePadding: e.labelpadding,
        axisNameFont: e.xaxisnamefont,
        axisNameFontSize: e.xaxisnamefontsize,
        axisNameFontColor: e.xaxisnamefontcolor,
        axisNameFontBold: e.xaxisnamefontbold,
        axisNameFontItalic: e.xaxisnamefontitalic,
        axisNameBgColor: e.xaxisnamebgcolor,
        axisNameBorderColor: e.xaxisnamebordercolor,
        axisNameAlpha: e.xaxisnamealpha,
        axisNameFontAlpha: e.xaxisnamefontalpha,
        axisNameBgAlpha: e.xaxisnamebgalpha,
        axisNameBorderAlpha: e.xaxisnameborderalpha,
        axisNameBorderPadding: e.xaxisnameborderpadding,
        axisNameBorderRadius: e.xaxisnameborderradius,
        axisNameBorderThickness: e.xaxisnameborderthickness,
        axisNameBorderDashed: e.xaxisnameborderdashed,
        axisNameBorderDashLen: e.xaxisnameborderdashlen,
        axisNameBorderDashGap: e.xaxisnameborderdashgap,
        useEllipsesWhenOverflow: e.useellipseswhenoverflow,
        divLineColor: (0, i.pluck)(e.vdivlinecolor, e.divlinecolor, a.getColor(n.divLineColor)),
        divLineAlpha: (0, i.pluck)(e.vdivlinealpha, e.divlinealpha, t ? a.getColor("divLineAlpha3D") : a.getColor("divLineAlpha")),
        divLineThickness: (0, i.pluckNumber)(e.vdivlinethickness, e.divlinethickness, 1),
        divLineIsDashed: Boolean((0, i.pluckNumber)(e.vdivlinedashed, e.vdivlineisdashed, e.divlinedashed, e.divlineisdashed, 0)),
        divLineDashLen: (0, i.pluckNumber)(e.vdivlinedashlen, e.divlinedashlen, 4),
        divLineDashGap: (0, i.pluckNumber)(e.vdivlinedashgap, e.divlinedashgap, 2),
        alternateGridColor: (0, i.pluck)(e.alternatevgridcolor, a.getColor("altVGridColor")),
        alternateGridAlpha: (0, i.pluck)(e.alternatevgridalpha, a.getColor("altVGridAlpha")),
        labelFont: e.labelfont,
        labelFontSize: e.labelfontsize,
        labelFontColor: e.labelfontcolor,
        labelFontAlpha: e.labelalpha,
        labelFontBold: e.labelfontbold,
        labelFontItalic: e.labelfontitalic,
        axisMinValue: e.xaxisminvalue,
        axisMaxValue: e.xaxismaxvalue,
        adjustDiv: e.adjustvdiv,
        labelDisplay: e.labeldisplay,
        showLabels: e.showlabels,
        rotateLabels: e.rotatelabels,
        slantLabel: (0, i.pluckNumber)(e.slantlabels, e.slantlabel),
        labelStep: (0, i.pluckNumber)(e.labelstep, e.xaxisvaluesstep),
        showAxisValues: (0, i.pluckNumber)(e.showxaxisvalues, e.showxaxisvalue),
        zeroPlaneColor: e.vzeroplanecolor,
        trendlineColor: e.trendlinecolor,
        trendlineToolText: e.trendlinetooltext,
        trendlineThickness: e.trendlinethickness,
        trendlineAlpha: e.trendlinealpha,
        showTrendlinesOnTop: e.showtrendlinesontop,
        axisLineThickness: (0, i.pluckNumber)(e.xaxislinethickness, e.axislinethickness, 1),
        axisLineAlpha: (0, i.pluckNumber)(e.xaxislinealpha, e.axislinealpha, 100)
      };
    }, t.prototype.getConfig = function (e) {
      return e ? this.config[e] : this.config;
    }, t.prototype._getSumValueSpace = function (e) {
      var t,
          n = {},
          a = this.isBar,
          o = this.getFromEnv("dataSource").chart,
          r = 0 !== this.showsum ? (0, i.pluckNumber)(o.showsum, this.showsum, 0) : 0,
          l = (0, i.pluckNumber)(this.config.stack100percent),
          s = this.config.isstacked,
          c = 0,
          u = [],
          h = 0;

      if (this.iterateComponents(function (e) {
        "cartesianStackGroup" !== e.getName() && "marimekkoStackgroup" !== e.getName() || u.push(e);
      }), r && l && s && u.length) {
        for (t = u.length - 1; t >= 0; t--) {
          n = u[t].getMaxSumValueSpace(), a ? c = Math.max(c, n.maxWidth) : h = Math.max(h, n.maxHeight);
        }

        h > e && (h = e), c > e && (c = e);
      }

      return {
        top: h,
        right: c
      };
    }, t.prototype.setAxisDimention = function () {
      var e = this.getChildren("xAxis") && this.getChildren("xAxis")[0],
          t = this.getChildren("yAxis") && this.getChildren("yAxis")[0],
          n = this.getFromEnv("chartConfig"),
          a = n.xDepth,
          i = this.getChildren("canvas") && this.getChildren("canvas")[0].config,
          o = i && i.canvasBorderWidth,
          r = e && e.getChildren("scrollBar") && e.getChildren("scrollBar")[0],
          l = (r && !r.getState("removed") || n.is3D) && n.shift,
          s = i && i.canvasPadding,
          c = i.canvasLeft,
          u = i && i.canvasPaddingLeft,
          h = i && i.canvasPaddingRight,
          d = i.canvasTop,
          p = i && i.canvasPaddingTop;
      e && e.setAxisConfig({
        canvasPaddingLeft: Math.max(u, s),
        canvasPaddingRight: Math.max(h, s)
      }), e && e.setAxisDimention({
        x: c + (a || 0) + Math.max(u, s),
        y: n.canvasBottom + (l || 0) + o,
        opposite: d - o,
        axisLength: i.canvasWidth - (a || 0) - Math.max(u, s) - Math.max(h, s)
      }), t && t.setAxisDimention({
        x: c - o,
        y: d + p,
        opposite: n.canvasRight + o,
        axisLength: n.canvasHeight - p - i.canvasPaddingBottom
      });
    }, t.prototype._getTrendLineMinMax = function (e, t) {
      var n,
          a,
          i,
          o,
          r,
          l = "v" === e ? this.getFromEnv("dataSource").vtrendlines : this.getFromEnv("dataSource").trendlines,
          s = {
        max: -Infinity,
        min: Infinity
      };
      if (t = t || "p", l) for (a = 0, o = l.length; a < o; a += 1) {
        for (i = 0, r = l[a].line ? l[a].line.length : 0; i < r; i += 1) {
          n = l[a].line[i], "s" === t && "s" !== n.parentyaxis || "s" !== t && "s" === n.parentyaxis || (s.max = h(n.startvalue || -Infinity, n.endvalue || -Infinity, s.max), s.min = d(n.startvalue || Infinity, n.endvalue || Infinity, s.min));
        }
      }
      return s;
    }, t;
  }(a["default"]);

  t["default"] = p;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(362),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  },
      r = n(125);

  function l(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var s = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.apply(this, arguments));
    }

    return l(t, e), t.prototype._spaceManager = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          l,
          s,
          c,
          u,
          h,
          d,
          p,
          f,
          g,
          m,
          b,
          v,
          y,
          x = this.config,
          C = this.getChildren("xAxis") && this.getChildren("xAxis")[0],
          k = this.getChildren("yAxis") && this.getChildren("yAxis") || [],
          w = x.legendposition,
          S = x.xDepth,
          _ = x.yDepth,
          L = x.canvasBgDepth,
          P = x.canvasBaseDepth,
          A = x.canvasBasePadding,
          N = this.getChildren("canvas")[0],
          E = N.config.canvasBorderWidth,
          F = x.realTimeConfig && x.realTimeConfig.showRTValue,
          O = x.borderWidth,
          T = x.canvasMarginTop,
          D = x.canvasMarginBottom,
          M = x.canvasMarginLeft,
          I = x.canvasMarginRight,
          R = x.minCanvasHeight,
          V = x.minCanvasWidth,
          B = x.minChartWidth,
          j = x.minChartHeight,
          G = x.height,
          H = x.width,
          z = !1,
          W = !1,
          q = x.origCanvasTopMargin,
          U = x.origCanvasBottomMargin,
          Y = x.origCanvasLeftMargin,
          X = x.origCanvasRightMargin,
          K = [];

      for (x.canvasWidth - 2 * O < B && (f = (x.canvasWidth - B) / 2), x.canvasHeight - 2 * O < j && (p = (x.canvasHeight - j) / 2), this._allocateSpace({
        top: p || O,
        bottom: p || O,
        left: f || O,
        right: f || O
      }), u = 0, a = k.length; u < a; u++) {
        n = k[u], e = .7 * x.availableWidth, v = n && n.placeAxis(e) || {}, K.push({
          axisIndex: u,
          spaceTaken: v
        }), n && this._allocateSpace(v);
      }

      x.yAxisSpaceAllocation = K, this._allocateSpace(this._manageActionBarSpace && this._manageActionBarSpace(.225 * x.availableHeight) || {}), this._manageLegendSpace && x.showLegend && this._manageLegendSpace(void 0), t = w === r.POSITION_BOTTOM ? .6 * x.availableHeight : .6 * x.availableWidth, _ && (this._allocateSpace({
        bottom: _
      }), x.shift = S + A + P), L && this._allocateSpace({
        right: L
      }), x.canvasWidth - 2 * E < V && (m = (x.canvasWidth - V) / 2), this._allocateSpace({
        left: m || E,
        right: m || E
      }), V > H - M - I && (W = !0, i = x.canvasWidth - V, y = M + I, M = x.canvasMarginLeft = i * M / y, I = x.canvasMarginRight = i * I / y), s = M > x.canvasLeft ? M - x.canvasLeft : 0, c = I > H - x.canvasRight ? I + x.canvasRight - H : 0, this._allocateSpace({
        left: s,
        right: c
      }), W && (y = Y + X, (d = x.canvasWidth) > V && (s = (i = d - V) * Y / y, c = i * X / y), this._allocateSpace({
        left: s,
        right: c
      })), x.actualCanvasMarginRight = c, x.actualCanvasMarginBottom = l, this._manageChartMenuBar(t), t = .2 * x.availableHeight, this._getSumValueSpace && this._allocateSpace(this._getSumValueSpace(t)), t = .3 * x.availableHeight, x.realtimeEnabled && (F ? this._allocateSpace(this._realTimeValuePositioning(t)) : this._hideRealTimeValue()), this._resetViewPortConfig && this._resetViewPortConfig(), this._setAxisScale && this._setAxisScale(), t = .6 * x.availableHeight, x.xAxisSpaceAllocation = b = C && C.placeAxis(t), C && this._allocateSpace(b), x.canvasHeight - 2 * E < R && (g = (x.canvasHeight - R) / 2), this._allocateSpace({
        top: g || E,
        bottom: g || E
      }), this._allocateSpace({
        bottom: P
      }), R > G - T - D && (z = !0, i = x.canvasHeight - R, y = T + D, T = x.canvasMarginTop = i * T / y, D = x.canvasMarginBottom = i * D / y), o = T > x.canvasTop ? T - x.canvasTop : 0, l = D > G - x.canvasBottom ? D + x.canvasBottom - G : 0, this._allocateSpace({
        top: o,
        bottom: l
      }), z && (y = q + U, (h = x.canvasHeight) > R && (o = (i = h - R) * q / y, l = i * U / y), this._allocateSpace({
        top: o,
        bottom: l
      })), x.actualCanvasMarginTop = o, x.actualCanvasMarginLeft = s, N.setDimension({
        top: x.canvasTop,
        left: x.canvasLeft,
        width: x.canvasWidth,
        height: x.canvasHeight
      });
    }, t.prototype._postSpaceManagement = function () {
      var e,
          t = this.config,
          n = this.getChildren(),
          a = n.xAxis && n.xAxis[0],
          i = n.legend && n.legend[0],
          o = t.xDepth,
          r = this.getChildren("canvas");

      for (this.setAxisDimention && this.setAxisDimention(), a && this._allocateXAxisLabelSpace(a), a && a.shiftLabels(-o, 0), i && i.postSpaceManager(), e = 0; e < (r && r.length); e++) {
        r[e].setCanvasPadding();
      }

      this.setAxisDimention && this.setAxisDimention(), this.allocateDimensionOfChartMenuBar();
    }, t;
  }(o["default"]);

  t["default"] = s;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.configurer = t._createToolBox = t._drawDataset = undefined;
  var a = b(n(161)),
      i = b(n(363)),
      o = n(132),
      r = b(n(366)),
      l = b(n(368)),
      s = b(n(370)),
      c = b(n(372)),
      u = b(n(147)),
      h = n(131),
      d = b(n(375)),
      p = n(125),
      f = b(n(127)),
      g = n(228),
      m = n(232);

  function b(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function v(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var y = (0, o.getDep)("redraphael", "plugin"),
      x = "VML" === y.type,
      C = Math.max,
      k = Math.min,
      w = Math.round,
      S = {
    datalabelclick: !0,
    connectorclick: !0,
    categoryclick: !0,
    processclick: !0,
    milestoneclick: !0,
    labelclick: !0,
    dataplotclick: !0
  },
      _ = p.preDefStr.SEVENTYSTRING,
      L = p.preDefStr.AUTOSTRING,
      P = "onpointerover" in window.document,
      A = function A(e, t, n) {
    return n.getFromEnv("animationManager").setAnimation({
      el: "group",
      attr: e,
      container: t,
      state: "appearing",
      component: n,
      label: "group"
    });
  },
      N = function N(e) {
    var t = e.data.config;
    t._containerMouseState = "mousedown", t._mdx1 = e.clientX !== p.UNDEF ? e.clientX : e.changedTouches && e.changedTouches[0].clientX, t.mdy1 = e.clientY !== p.UNDEF ? e.clientY : e.changedTouches && e.changedTouches[0].clientY, "touchstart" === e.type && (t._touchStartedAt = new Date().getTime());
  },
      E = function E(e) {
    var t = e.data.config,
        n = e.clientX !== p.UNDEF ? e.clientX : e.changedTouches && e.changedTouches[0].clientX,
        a = e.clientY !== p.UNDEF ? e.clientY : e.changedTouches && e.changedTouches[0].clientY;
    (Math.abs(t._mdx1 - n) >= 2.5 || Math.abs(t.mdy1 - a) >= 2.5) && (e.data.config._containerMouseState = undefined);
  },
      F = function F(e) {
    new Date().getTime() - e.data.config._touchStartedAt < 500 && setTimeout(function () {
      O(e);
    });
  },
      O = function O(e) {
    var t,
        n = e.data,
        a = n.getFromEnv("chartInstance"),
        i = e.originalEvent,
        o = n.config,
        r = (0, p.getMouseCoordinate)(n.getFromEnv("chart-container"), i, n);
    a.ref && "mousemove" !== o._containerMouseState && (t = (0, p.extend2)({
      height: a.args.height,
      width: a.args.width,
      pixelHeight: n.getFromEnv("chartWidth"),
      pixelWidth: n.getFromEnv("chartHeight"),
      id: a.args.id,
      renderer: a.args.renderer,
      container: a.options.containerElement
    }, r), n.fireChartInstanceEvent("chartclick", t), o.link && (!o.hotElemClicked || o.clickURLOverridesPlotLinks) && n.getFromEnv("linkClickFN").call({
      link: o.link
    }), o.hotElemClicked = !1);
  },
      T = function T(e) {
    var t = e.type,
        n = e.data,
        a = n.getFromEnv("eventListeners");
    "mouseover" !== t && "touchstart" !== t || !1 !== n.config.mouseStateIn || (n.config.mouseStateIn = !0, R.onContainerRollOver(e), a.push(f["default"].listen(x ? document : window, "mouseover", R.winMouseHover, n)));
  };

  function D() {
    var e,
        t = this,
        n = t.config,
        a = t.getFromEnv("chart-attrib"),
        i = "t" === n.toolbarVAlign ? "chartMenuBar" : "actionBar",
        o = "t" === n.toolbarVAlign ? "actionBar" : "chartMenuBar",
        r = void 0,
        l = void 0,
        s = t.getFromEnv("tool-config"),
        c = n.printOption.enabled;
    e = this.config.realTimeConfig || {}, (0, p.componentFactory)(t, g.ToolBar, o, 0, [a]), (0, p.componentFactory)(t, g.ToolBar, i, 1, [a]), r = t.getChildren(i)[0], t.addToEnv("toolbar", r), m.SymbolStore.register("ContextIcon", function (e, t, n) {
      var a = e,
          i = t,
          o = 2 * n,
          r = w(o / 4),
          l = .7 * w(o / 2),
          s = a - l,
          c = a + l,
          u = i + r,
          h = i - r;
      return ["M", s, i, "L", c, i, "M", s, u, "L", c, u, "M", s, h, "L", c, h];
    }), l = r.attachChild(g.Hamburger, "tool", "hamburgerMenu-" + r.getId() + "-" + t.getId() + "-0"), t.addToEnv("hamburger", l), l.configure(Object.assign({}, s, {
      name: "ContextIcon"
    })), l._mouseOutEvent || (l._mouseOutEvent = function () {
      this.getChild("listContainer").hide();
    }), l._mouseOverEvent || (l._mouseOverEvent = function () {
      this.getChild("listContainer").show();
    }), l.addEventListener("fc-mouseover", l._mouseOverEvent), l.addEventListener("fc-mouseout", l._mouseOutEvent), c && l.appendInMenu([{
      name: "Print",
      action: "click",
      handler: function handler() {
        t.getFromEnv("chartInstance").print();
      }
    }]), this._setRTmenu && this._setRTmenu(e.showRTmenuItem, e.useMessageLog);
  }

  function M() {
    this.getChildren("canvas")[0]._mapChildren(function (e) {
      e.syncDraw();
    });
  }

  function I(e) {
    this.config.skipConfigureIteration = {}, this.parseChartAttr(e), this.createComponent(e), this._createToolBox(), this.setTooltipStyle(), this.configureChildren();
  }

  (0, o.addDep)({
    name: "commonAnimation",
    type: "animationRule",
    extension: d["default"]
  });

  var R = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.addToEnv("stringConstants", {
        COMPONENT: "component",
        CANVAS: "canvas",
        CAPTION: "caption"
      }), n.addToEnv("getMouseCoordinate", p.getMouseCoordinate), n._drawDataset = M, n.config.mouseStateIn = !1, n.registerFactory("canvas", i["default"]), n._firstConfigure = !0, n;
    }

    return v(t, e), t.getName = function () {
      return "CommonAPI";
    }, t.prototype.plotEventHandler = function (e) {
      var t,
          n,
          a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          i = arguments[2],
          o = arguments[3],
          r = a.type,
          l = (0, p.getMouseCoordinate)(this.getFromEnv("chart-container"), a, this),
          s = e && e.data("eventArgs") || o,
          c = (0, p.extend2)(l, s),
          u = this.fireGroupEvent,
          d = e && e.data("groupId"),
          f = function f(e, t) {
        a.FusionChartsPreventEvent = !0;
      };

      "index" in c && !("dataIndex" in c) && (c.dataIndex = c.index), "value" in c && !("dataValue" in c) && (c.dataValue = c.value), "dataplotrollover" === (i = (0, p.pluck)(i, "dataplotclick").toLowerCase()) ? (a.FusionChartsPreventEvent = !1, u ? (0, h.raiseEventGroup)(d, i, c, this.getFromEnv("chartInstance"), p.UNDEF, p.UNDEF, f) : this.fireChartInstanceEvent(i, c, p.UNDEF, p.UNDEF, f)) : u && !S[i] ? (0, h.raiseEventGroup)(d, i, c, this.getFromEnv("chartInstance")) : this.fireChartInstanceEvent(i, c), "fc-click" !== r && "click" !== r && "mouseup" !== r && "touchend" !== r || !/click/i.test(i) || (n = (t = this.getFromEnv()) && t.linkClickFN, c.link && n && n.call({
        link: c.link
      }, !0));
    }, t.prototype.getName = function () {
      return "Cartesian";
    }, t.prototype.preConfigure = function (t) {
      var n = this.getFromEnv("number-formatter");
      this.addToEnv("chart-attrib", t.chart), n ? n.configure() : this.addToEnv("number-formatter", new u["default"](this)), e.prototype.preConfigure.call(this, t);
    }, t.prototype.postConfigure = function (t) {
      e.prototype.postConfigure.call(this, t), this._firstConfigure = !1;
    }, t.prototype.setDefaults = function () {
      e.prototype.setDefaults.call(this);
      var t = this.getFromEnv("number-formatter");
      t && t.setDefaults && t.setDefaults();
    }, t.prototype.getType = function () {
      return "chartAPI";
    }, t.prototype.parseChartAttr = function (e) {
      var t,
          n,
          a,
          i,
          o,
          r,
          l,
          s,
          u = e || this.getFromEnv("dataSource"),
          h = void 0,
          d = this.config.is3D,
          f = d ? p.chartPaletteStr.chart3D : p.chartPaletteStr.chart2D,
          g = void 0,
          m = this.isBar,
          b = void 0,
          v = this.getFromEnv("color-manager"),
          y = void 0,
          x = void 0,
          w = void 0;
      v || (v = new c["default"](this), this.addToEnv("color-manager", v)), u.chart = u.chart || u.graph || u.map || {}, delete u.map, delete u.graph, !(h = u.chart) && (h = u.chart = {}), g = this.config || (this.config = {}), (0, p.parseConfiguration)(h, g, {}, {
        showvalues: !0,
        crosslinecolor: !0,
        drawcrosslineontop: !0,
        crosslinealpha: !0,
        drawcrossline: !0
      }), g.showValues = (0, p.pluckNumber)(h.showvalues, g.showvalues), g.viewPortConfig = {
        scaleY: 1,
        scaleX: 1,
        x: 0,
        y: 0
      }, this.addToEnv("tool-config", function () {
        for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        var a = t[0];
        return t.slice(1).forEach(function (e) {
          for (var t in e) {
            e.hasOwnProperty(t) && e[t] !== undefined && (a[t] = e[t]);
          }
        }), a;
      }({}, {
        scale: h.toolbarbuttonscale,
        width: h.toolbarbuttonwidth,
        height: h.toolbarbuttonheight,
        radius: h.toolbarbuttonradius,
        spacing: h.toolbarbuttonspacing,
        marginTop: h.toolbarbuttonmargintop,
        marginLeft: h.toolbarbuttonmarginleft,
        marginRight: h.toolbarbuttonmarginright,
        marginBottom: h.toolbarbuttonmarginbottom,
        fill: h.toolbarbuttoncolor,
        labelFill: h.toolbarlabelcolor,
        symbolFill: h.toolbarsymbolcolor,
        hoverFill: h.toolbarbuttonhovercolor,
        stroke: h.toolbarbuttonbordercolor,
        symbolStroke: h.toolbarsymbolbordercolor,
        strokeWidth: h.toolbarbuttonborderthickness,
        symbolStrokeWidth: h.toolbarsymbolborderthickness,
        bSymbolPadding: h.toolbarsymbolpadding,
        symbolHPadding: h.toolbarsymbolhpadding,
        symbolVPadding: h.toolbarsymbolvpadding,
        hAlign: h.toolbarhalign,
        vAlign: h.toolbarvalign
      })), d && (m ? (g.xDepth = 5, g.yDepth = 5) : (g.xDepth = 10, g.yDepth = 10), g.showCanvasBase = w = Boolean((0, p.pluckNumber)(h.showcanvasbase, 1)), g.canvasBasePadding = (0, p.pluckNumber)(h.canvasbasepadding, 2), g.canvasBaseDepth = w ? (0, p.pluckNumber)(h.canvasbasedepth, 10) : 0, g.canvasBgDepth = (0, p.pluckNumber)(h.canvasbgdepth, 3)), v && v.configure(), g.placeAxisLabelsOnTop = (0, p.pluckNumber)(h.placexaxislabelsontop, 0), g.enableAnimation = (0, p.pluckNumber)(h.animation, h.defaultanimation, 1), g.showToolTip = (0, p.pluckNumber)(h.showtooltip, 1), g.printOption = {
        enabled: (0, p.pluckNumber)(h.printshowbutton, h.showprintmenuitem, 0)
      }, g.drawCrossLineOnTop = (0, p.pluckNumber)(h.drawcrosslineontop, 1), y = g.style = {}, this.addToEnv("style", y), g.textDirection = "1" === h.hasrtltext ? "rtl" : p.BLANKSTRING, y.inCanfontFamily = t = (0, p.pluck)(h.basefont, "Verdana,sans"), y.inCanfontSize = n = (0, p.pluckFontSize)(h.basefontsize, 10), y.inCancolor = b = (0, p.pluck)(h.basefontcolor, v.getColor(f.baseFontColor)), y.outCanfontFamily = (0, p.pluck)(h.outcnvbasefont, t), y.fontSize = a = (0, p.pluckFontSize)(h.outcnvbasefontsize, n), y.outCanfontSize = a + p.PXSTRING, y.outCancolor = (0, p.pluck)(h.outcnvbasefontcolor, b).replace(/^#? ([a-f0-9]+)/gi, "#$1"), y.baseFontSize = n, y.inCanfontSize = n + p.PXSTRING, y.inCancolor = b.replace(/^#? ([a-f0-9]+)/gi, "#$1"), y.inCanvasStyle = r = {
        fontFamily: t,
        fontSize: n,
        color: b
      }, y.inCanLineHeight = l = (0, p.setLineHeight)(r), x = (x = (0, p.getFirstValue)(h.valuebordercolor, p.BLANKSTRING)) ? (0, p.convertColor)(x, (0, p.pluckNumber)(h.valueborderalpha, h.valuealpha, 100)) : p.BLANKSTRING, g.reverseXAxis = this.config.allowreversexaxis && (0, p.pluckNumber)(h.reversexaxis, 0), g.showBorder = (0, p.pluckNumber)(h.showborder, d ? 0 : 1), g.borderWidth = C(g.showBorder ? (0, p.pluckNumber)(h.borderthickness, 1) : 0, 0), g.useplotgradientcolor = (0, p.pluckNumber)(h.plotgradientcolor, g.useplotgradientcolor, 0), g.valuefontbold = (0, p.pluckNumber)(h.valuefontbold, g.valuefontbold), g.dataLabelStyle = s = {
        fontFamily: (0, p.pluck)(h.valuefont, t),
        fontSize: (0, p.pluck)(h.valuefontsize, (0, p.pInt)(n, 10)) + p.PXSTRING,
        lineHeight: l,
        color: (0, p.convertColor)((0, p.pluck)(h.valuefontcolor, b), (0, p.pluckNumber)(h.valuefontalpha, h.valuealpha, 100)),
        fontWeight: g.valuefontbold ? "bold" : "normal",
        fontStyle: (0, p.pluckNumber)(h.valuefontitalic) ? "italic" : "normal",
        border: x || h.valuebgcolor ? (0, p.pluckNumber)(h.valueborderthickness, 1) + "px solid" : p.BLANKSTRING,
        borderColor: x,
        borderThickness: (0, p.pluckNumber)(h.valueborderthickness, 1),
        borderPadding: (0, p.pluckNumber)(h.valueborderpadding, 2),
        borderRadius: (0, p.pluckNumber)(h.valueborderradius, 0),
        backgroundColor: h.valuebgcolor ? (0, p.convertColor)(h.valuebgcolor, (0, p.pluckNumber)(h.valuebgalpha, h.valuealpha, 100)) : p.BLANKSTRING,
        borderDash: (0, p.pluckNumber)(h.valueborderdashed, 0) ? (0, p.getDashStyle)((0, p.pluckNumber)(h.valueborderdashlen, 4), (0, p.pluckNumber)(h.valueborderdashgap, 2)) : p.DASH_DEF
      }, (0, p.setLineHeight)(s), g.legendposition = (0, p.pluck)(h.legendposition, p.POSITION_BOTTOM), g.alignLegendWithCanvas = (0, p.pluckNumber)(h.alignlegendwithcanvas, 1), g.origMarginTop = (0, p.pluckNumber)(h.charttopmargin, this.chartTopMargin, 15), g.origMarginLeft = (0, p.pluckNumber)(h.chartleftmargin, this.chartLeftMargin, 15), g.origMarginBottom = (0, p.pluckNumber)(h.chartbottommargin, this.chartBottomMargin, 15), g.origMarginRight = (0, p.pluckNumber)(h.chartrightmargin, this.chartRightMargin, 15), g.origCanvasLeftMargin = (0, p.pluckNumber)(h.canvasleftmargin, 0), g.origCanvasRightMargin = (0, p.pluckNumber)(h.canvasrightmargin, 0), g.origCanvasTopMargin = (0, p.pluckNumber)(h.canvastopmargin, 0), g.origCanvasBottomMargin = (0, p.pluckNumber)(h.canvasbottommargin, 0), g.minChartWidthPercent = (0, p.pluckNumber)(h.minchartwidth, this.minChartWidth, 50) / 100, g.minChartHeightPercent = (0, p.pluckNumber)(h.minchartheight, this.minChartHeight, 50) / 100, g.minCanvasWidthPercent = (0, p.pluckNumber)(h.mincanvaswidth, this.minCanvasWidth, 60) / 100, g.minCanvasHeightPercent = (0, p.pluckNumber)(h.mincanvasheight, this.minCanvasHeight, 30) / 100, i = (0, p.pluck)(h.zeroplanecolor, h.divlinecolor, v.getColor(f.divLineColor)), o = (0, p.pluck)(h.zeroplanealpha, h.divlinealpha, v.getColor("divLineAlpha")), g.zeroPlaneColor = (0, p.convertColor)(i, o), g.zeroPlaneBorderColor = (0, p.convertColor)((0, p.pluck)(h.zeroplanebordercolor, i), (0, p.pluckNumber)(h.zeroplaneshowborder, 1) ? o : 0), g.zeroPlaneShowBorder = (0, p.pluckNumber)(h.zeroplaneshowborder, 1), g.realtimeEnabled = (0, p.pluckNumber)(h.realtimeenabled, this.isRealTime), g.showLegend = (0, p.pluckNumber)(h.showlegend, this.showLegend, 1), g.link = h.clickurl, g.transposeAxis = (0, p.pluckNumber)(this.transposeAxis, h.transposeaxis, 0), g.useEllipsesWhenOverflow = (0, p.pluckNumber)(h.useellipseswhenoverflow, h.useellipsewhenoverflow, 1), g.drawTrendRegion = (0, p.pluckNumber)(h.drawcrossline, 0), g.plotcolorintooltip = (0, p.pluckNumber)(h.plotcolorintooltip, this.config.singleseries ? 0 : 1), g.plotbinsize = k((0, p.pluckNumber)(h.plotbinsize, this.plotbinsize, .5), 1), g.labelbinsize = k((0, p.pluckNumber)(h.labelbinsize, 1), 1), g.labelbinsize = g.plotbinsize > g.labelbinsize ? g.plotbinsize : g.labelbinsize, g.enableMouseOutEvent = (0, p.pluckNumber)(h.enablemouseoutevent, this.enableMouseOutEvent, 1), g.plotSpacePercent = Math.max((0, p.pluckNumber)(h.plotspacepercent, this.plotSpacePercent), 0), g.maxColWidth = Math.abs((0, p.pluckNumber)(h.maxcolwidth, 50)), g.maxBarHeight = Math.abs((0, p.pluckNumber)(h.maxbarheight, 50)), g.overlapColumns = (0, p.pluckNumber)(h.overlapcolumns, h.overlapbars, g.is3D ? 0 : 1), g.plotPaddingPercent = h.plotpaddingpercent, g.tooltipgrayoutcolor = (0, p.pluck)(h.tooltipgrayoutcolor, p.preDefStr.colors.AAAAAA), g.clickURLOverridesPlotLinks = (0, p.pluckNumber)(h.clickurloverridesplotlinks, 0), g.toolbarX = (0, p.pluckNumber)(h.toolbarx), g.toolbarY = (0, p.pluckNumber)(h.toolbary), g.toolbarPosition = function (e) {
        switch (e) {
          case "tr":
          case "rt":
          case "top right":
          case "right top":
            e = "tr";
            break;

          case "br":
          case "rb":
          case "bottom right":
          case "right bottom":
            e = "br";
            break;

          case "tl":
          case "lt":
          case "top left":
          case "left top":
            e = "tl";
            break;

          case "bl":
          case "lb":
          case "bottom left":
          case "left bottom":
            e = "bl";
            break;

          default:
            e = "tr";
        }

        return e;
      }((0, p.pluck)(h.toolbarposition, "tr").toLowerCase()), g.toolbarHAlign = "left" === (p.BLANKSTRING + h.toolbarhalign).toLowerCase() ? "l" : g.toolbarPosition.charAt(1), g.toolbarVAlign = "bottom" === (p.BLANKSTRING + h.toolbarvalign).toLowerCase() ? "b" : g.toolbarPosition.charAt(0), g.toolbarVMargin = (0, p.pluckNumber)(h.toolbarvmargin, 6), g.toolbarHMargin = (0, p.pluckNumber)(h.toolbarhmargin, 10), this.addToEnv("chartConfig", g), this.addToEnv("linkClickFN", (0, p.getLinkAction)(this.getFromEnv("dataSource"), this)), this.addToEnv("dataLabelStyle", s);
    }, t.prototype.createComponent = function () {
      var e = void 0;
      e = this.config.skipConfigureIteration, this.createBaseComponent(), this.getFromEnv("animationManager").setAnimationState(this._firstConfigure ? "initial" : "update"), (0, p.componentFactory)(this, r["default"], "caption"), e.caption = !0, (0, p.componentFactory)(this, l["default"], "subCaption"), e.subCaption = !0, (0, p.componentFactory)(this, s["default"], "background"), e.background = !0, this._createConfigurableComponents && this._createConfigurableComponents(), this.config.realtimeEnabled && this._realTimeConfigure && this._realTimeConfigure();
    }, t.prototype.configureChildren = function () {
      var e = this;

      e._mapChildren(function (t) {
        !t.getState("removed") && e.config.skipConfigureIteration[t.getName()] && t.configure && t.configure();
      });
    }, t.prototype._createToolBox = function () {
      D.call(this);
    }, t.prototype.configureAttributes = function (e) {
      I.call(this, e);
    }, t.prototype.setTooltipStyle = function () {
      var e = this.config;
      this.getFromEnv("toolTipController").setStyle({
        bgColor: (0, p.convertColor)(e.tooltipbgcolor || "FFF", e.tooltipbgalpha || 100),
        rawBgColor: (e.tooltipbgcolor || "FFF").replace(/\s+/g, "").replace(/^#?([a-f0-9]+)/gi, "#$1"),
        fontColor: (e.tooltipcolor || e.basefontcolor || "545454").replace(/\s+/g, "").replace(/^#?([a-f0-9]+)/gi, "#$1"),
        borderColor: (0, p.convertColor)(e.tooltipbordercolor || "666", e.tooltipborderalpha || 100),
        rawBorderColor: (e.tooltipbordercolor || "666").replace(/\s+/g, "").replace(/^#?([a-f0-9]+)/gi, "#$1"),
        bgAlpha: (0, p.pluckNumber)(e.tooltipbgalpha, 100),
        borderThickness: (0, p.pluckNumber)(e.tooltipborderthickness, 1),
        showToolTipShadow: (0, p.pluckNumber)(e.showtooltipshadow, e.showshadow, 1),
        borderRadius: (0, p.pluckNumber)(e.tooltipborderradius, 0),
        "font-size": e.basefontsize || 10,
        "font-family": e.basefont || this.getFromEnv("style").inCanfontFamily,
        padding: (0, p.pluckNumber)(e.tooltippadding || 3),
        borderAlpha: (0, p.pluckNumber)(e.tooltipborderalpha, 100)
      });
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this);

      var t = this.config;
      t.valuefontbold = 0, t.stickytracking = 1, t.usemessagelog = 0, t.zeroplanethickness = p.UNDEF, t.animationeffect = "linear", t.showshadow = 1, t.showhovereffect = p.UNDEF, t.plothovereffect = p.UNDEF, t.anchorhovereffect = p.UNDEF, t.plotborderdashed = p.UNDEF, t.stack100percent = p.UNDEF, t.showpercentvalues = p.UNDEF, t.showpercentintooltip = p.UNDEF, t.plotbordercolor = p.UNDEF, t.showtooltip = 1, t.seriesnameintooltip = 1, t.rotatevalues = 0, t.minimizetendency = 0, t.plotfillangle = 270, t.valuepadding = 2, t.useplotgradientcolor = 1, t.plotborderthickness = 1, t.plotfillalpha = _, t.showvalues = 1, t.valueposition = L, t.drawcrossline = p.UNDEF, t.tooltipsepchar = ", ", t.usedataplotcolorforlabels = 0, t.placevaluesinside = 0, t.showplotborder = 1, t.use3dlighting = 1, t.useroundedges = 0, t.plotspacepercent = 20, t.plotpaddingpercent = p.UNDEF, t.plotfillratio = p.UNDEF, t.maxcolwidth = 50, t.plotborderdashlen = 5, t.plotborderdashgap = 4, t.useScaleRecursively = !0, t.formatnumberscale = 1, t.decimals = 2, t.decimalprecision = 10, t.tooltipbgcolor = "FFF", t.tooltipcolor = p.UNDEF, t.tooltipbordercolor = "666", t.tooltipbgalpha = 100, t.tooltipborderthickness = 1, t.showtooltipshadow = p.UNDEF, t.basefontsize = 10, t.basefont = "Verdana, sans", t.tooltipborderradius = 0, t.tooltippadding = 3, t.tooltipborderalpha = 100, t.origw = p.UNDEF, t.origh = p.UNDEF;
    }, t.prototype.configure = function (t) {
      t.chart = t.chart || t.graph || t.map || {}, e.prototype.configure.call(this, t);
    }, t.prototype._checkInvalidData = function () {
      var e = this.getFromEnv("dataSource"),
          t = this.getFromEnv("chartInstance");
      if (!(this.isWidget || this.isMap || e.data && 0 !== e.data.length || e.dataset || e.value || e.lineset || e.annotations || e.category || e.tasks || e.process || e.axis)) return this.setChartMessage(), this.drawChartMessage(), t.__state.dataReady = !1, t.jsVars.hasNativeMessage = !0, t.jsVars.drawCount += 1, !0;
    }, t.prototype._checkInvalidSpecificData = function () {
      var e = this.getFromEnv("dataSource"),
          t = e.dataset,
          n = e.categories;
      if (!t || !n || 0 === n.length || !n[0].category) return !0;
    }, t.prototype.setChartEvents = function () {
      var e = this.getFromEnv("eventListeners"),
          n = this.getFromEnv("dataSource"),
          a = n && n.chart,
          i = this.getFromEnv("paper") && this.getFromEnv("paper").canvas,
          o = this.getFromEnv("chart-container"),
          r = a && (0, p.pluckNumber)(a.enablechartmousemoveevent, 0);
      (a || i) && (f["default"].unlisten(o, P ? "click" : "touchend", P ? O : F), e.push(f["default"].listen(o, "mousedown touchstart", N, this)), e.push(f["default"].listen(o, "mousemove touchmove", E, this)), e.push(f["default"].listen(o, P ? "click" : "touchend", P ? O : F, this)), f["default"].unlisten(i, "mouseover", T, this), f["default"].unlisten(i, "touchstart", T, this), f["default"].unlisten(i, "mouseout", T, this), f["default"].unlisten(i, "touchend", T, this), e.push(f["default"].listen(i, "mouseover touchstart mouseout touchend", T, this)), f["default"].unlisten(o, "mousemove", t.onContainerMouseMove, this), f["default"].unlisten(o, "touchmove", t.onContainerMouseMove, this), r && e.push(f["default"].listen(o, "mousemove touchmove", t.onContainerMouseMove, this)));
    }, t.prototype.get = function (e, t) {
      var n = this[e];
      return t ? n && n[t] : n;
    }, t.prototype.prepareAttributes = function () {
      this.config.hasChartMessage || e.prototype.prepareAttributes.call(this);
    }, t.prototype.disposeChartStyleSheet = function () {
      var e = this.getFromEnv("paper");
      e && e.cssClear();
    }, t.prototype.createChartStyleSheet = function () {
      this.getFromEnv("paper").cssRender();
    }, t.prototype._dispose = function () {
      for (var t = this.getFromEnv("eventListeners"), n = t && t.length; n--;) {
        t[n].unlisten();
      }

      e.prototype._dispose.call(this);
    }, t.prototype._allocateSpace = function (e) {
      var t,
          n,
          a = this.getChildren("canvas"),
          i = a && a[0].config,
          o = this.config,
          r = o.canvasHeight,
          l = o.canvasWidth,
          s = o.availableHeight,
          c = o.availableWidth;
      n = o.canvasLeft += e.left || 0, t = o.canvasTop += e.top || 0, l = o.canvasWidth = C(l - ((e.left || 0) + (e.right || 0)), 0), r = o.canvasHeight = C(r - ((e.top || 0) + (e.bottom || 0)), 0), o.availableHeight = C(s - ((e.top || 0) + (e.bottom || 0)), 0), o.availableWidth = C(c - ((e.left || 0) + (e.right || 0)), 0), o.canvasRight = n + l, o.canvasBottom = t + r, i && (i.canvasPaddingLeft = C(i.canvasPaddingLeft, e.paddingLeft || 0), i.canvasPaddingRight = C(i.canvasPaddingRight, e.paddingRight || 0), i.canvasPaddingTop = C(i.canvasPaddingTop, e.paddingTop || 0), i.canvasPaddingBottom = C(i.canvasPaddingBottom, e.paddingBottom || 0)), a && a[0].setDimension({
        top: t,
        left: n,
        width: l,
        height: r
      });
    }, t.prototype._fetchCaptionPos = function (e) {
      var t = this.config,
          n = t.width,
          a = this.getChildren("chartMenuBar") && this.getChildren("chartMenuBar")[0],
          i = (a ? a.getLogicalSpace() : {}).width || 0,
          o = (this.getChildren("caption") && this.getChildren("caption")[0]).config,
          r = o.width,
          l = "l" === t.toolbarHAlign,
          s = t.width - e,
          c = l ? e : s,
          u = t.origMarginRight,
          h = t.origMarginLeft,
          d = l ? h : u;
      return o.align === p.POSITION_MIDDLE ? c - r / 2 - d - i : "start" === o.align ? l ? -1 : n - t.canvasLeft - d - r - i + o.horizontalPadding : l ? n - (u + h + i + r) : -1;
    }, t.prototype._manageCaptionSpacing = function (e, t) {
      return this.getChildren("caption")[0].manageSpace(e, t);
    }, t.prototype._manageChartMenuBar = function (e) {
      var t,
          n,
          a = this.config,
          i = this.getChildren("chartMenuBar") && this.getChildren("chartMenuBar")[0],
          o = a.toolbarY !== undefined,
          r = i ? i.getLogicalSpace() : {
        height: 0,
        width: 0
      },
          l = (this.getChildren("caption") && this.getChildren("caption")[0]).config,
          s = l.isOnTop,
          c = a.width / 2,
          u = a.canvasRight,
          h = u ? (a.canvasLeft + u) / 2 : c,
          d = 0,
          f = l.alignWithCanvas ? h : c;
      return o && (r.height = 0), i && i.setDimension({
        x: a.toolbarX !== undefined ? a.toolbarX : (0, p.pluckNumber)("l" === a.toolbarHAlign ? 0 : +a.width),
        y: a.toolbarY !== undefined ? a.toolbarY : (0, p.pluckNumber)("t" === a.toolbarVAlign ? 0 : +a.height),
        width: r.width,
        height: r.height
      }), delete l._offsetHeight, n = l.alignWithCanvas ? a.canvasWidth : a.width - a.origMarginLeft - a.origMarginRight, s ? (t = this._manageCaptionSpacing(e, n), d = this._fetchCaptionPos(f), l._offsetHeight = d < 0 ? r.height : 0, t.top = d < 0 ? (0, p.pluckNumber)(t.top, 0) + r.height : C(t.top, r.height), this._allocateSpace(t)) : (this._allocateSpace({
        top: r.height
      }), t = this._manageCaptionSpacing(e, n), this._allocateSpace(t)), {
        top: r ? C(r.height, t.top) : t.top,
        bottom: t.bottom
      };
    }, t.prototype._manageSpace = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r,
          l,
          s,
          c,
          u,
          h,
          d = this.getChildren("canvas") && this.getChildren("canvas")[0],
          p = d && d.config,
          f = this.config,
          g = this.getFromEnv("chartWidth"),
          m = this.getFromEnv("chartHeight");
      f.width = g, f.height = m, f.minChartHeight = s = f.minChartHeightPercent * m, f.minChartWidth = c = f.minChartWidthPercent * g, f.minCanvasWidth = e = f.minCanvasWidthPercent * c, f.minCanvasHeight = t = f.minCanvasHeightPercent * s, f.marginTop = n = f.origMarginTop, f.marginLeft = a = f.origMarginLeft, f.marginBottom = i = f.origMarginBottom, f.marginRight = o = f.origMarginRight, f.canvasMarginTop = f.origCanvasTopMargin, f.canvasMarginLeft = f.origCanvasLeftMargin, f.canvasMarginBottom = f.origCanvasBottomMargin, f.canvasMarginRight = f.origCanvasRightMargin, f.canvasHeight = r = f.height - f.marginTop - f.marginBottom, f.canvasWidth = l = f.width - f.marginLeft - f.marginRight, f.availableHeight = r - t, f.availableWidth = l - e, r < s && (u = m - s, f.canvasHeight = s, h = n + i, f.marginTop = u * n / h, f.marginBottom = u * i / h, f.availableHeight = s - t), l < c && (u = g - c, h = o + a, f.canvasWidth = c, f.marginLeft = u * a / h, f.marginRight = u * o / h, f.availableWidth = c - e), f.canvasLeft = f.marginLeft, f.canvasTop = f.marginTop, p && (p.canvasPaddingLeft = k(p.origCanvasLeftPad, w(.1 * f.height)), p.canvasPaddingRight = k(p.origCanvasRightPad, w(.1 * f.height)), p.canvasPaddingTop = k(p.origCanvasTopPad, w(.1 * f.height)), p.canvasPaddingBottom = k(p.origCanvasBottomPad, w(.1 * f.height))), this._spaceManager();
    }, t.prototype._preDraw = function () {
      this._mapChildren(function (e) {
        e.getState("removed") || e.preDraw && e.preDraw();
      }), this._setAxisLimits && this._setAxisLimits(), this._createToolBoxGantt && this._createToolBoxGantt();
    }, t.prototype._clearTimers = function () {
      var e,
          t = this.config && this.config.realTimeConfig,
          n = this.config.timers,
          a = n && n.setTimeout,
          i = n && n.setInterval;

      for (e in t && (t.refreshIntervalFlag = !1), a) {
        clearTimeout(a[e]);
      }

      for (e in i) {
        clearInterval(i[e]);
      }
    }, t.prototype.setChartCursor = function () {
      var e = this.config.link,
          t = this.getFromEnv("paper").canvas.style;
      y.svg ? t.cursor = e ? p.POINTER : "default" : this.getFromEnv("paper").canvas.style.cursor = e ? p.HAND : "default";
    }, t.prototype._createLayers = function () {
      var e,
          t = this.getFromEnv("animationManager");
      e = this.getContainer("parentgroup") || this.addContainer("parentgroup", t.setAnimation({
        el: "group",
        attr: {
          name: "parentgroup"
        },
        component: this
      })), !this.getChildContainer("backgroundGroup") && this.addChildContainer("backgroundGroup", A({
        name: "background"
      }, e, this)), !this.getChildContainer("axisBottomGroup") && this.addChildContainer("axisBottomGroup", A({
        name: "axisbottom"
      }, e, this)), !this.getChildContainer("belowPlotGroup") && this.addChildContainer("belowPlotGroup", A({
        name: "belowplot"
      }, e, this)), !this.getChildContainer("plotGroup") && this.addChildContainer("plotGroup", A({
        name: "plots"
      }, e, this)), !this.getChildContainer("axisTopGroup") && this.addChildContainer("axisTopGroup", A({
        name: "axistop"
      }, e, this)), !this.getChildContainer("sumLabelsLayer") && this.addChildContainer("sumLabelsLayer", A({
        name: "sumlabels",
        "class": "fusioncharts-datalabels"
      }, e, this)), !this.getChildContainer("datalabelsGroup") && this.addChildContainer("datalabelsGroup", A({
        name: "datalabel"
      }, e, this)), !this.getChildContainer("abovePlotGroup") && this.addChildContainer("abovePlotGroup", A({
        name: "aboveplot"
      }, e, this)), !this.getChildContainer("captionGroup") && this.addChildContainer("captionGroup", A({
        name: "caption"
      }, e, this)), !this.getChildContainer("defaultGroup") && this.addChildContainer("defaultGroup", A({
        name: "chartdefault"
      }, e, this)), !this.getChildContainer("defaultShadowGroup") && this.addChildContainer("defaultShadowGroup", A({
        name: "chartdefault-shadow"
      }, e, this)), !this.getChildContainer("trackerGroup") && this.addChildContainer("trackerGroup", A({
        name: "tracker"
      }, e, this)), !this.getChildContainer("toolbar-master") && this.addChildContainer("toolbar-master", A({
        name: "toolbar-master"
      }, e, this)), !this.getChildContainer("logoGroup") && this.addChildContainer("logoGroup", t.setAnimation({
        el: "group",
        attr: {
          name: "logo"
        },
        component: this
      }));
    }, t.prototype._setDataLabelStyle = function () {
      var e = this.config.dataLabelStyle,
          t = {
        fontFamily: e.fontFamily,
        fontSize: e.fontSize,
        fontWeight: e.fontWeight,
        fontStyle: e.fontStyle
      };
      this.getChildContainer("datalabelsGroup").css(t);
    }, t.prototype._manageCaptionPosition = function () {
      var e,
          t = this.config,
          n = this.getChildren(),
          a = n.caption && n.caption[0],
          i = n.subCaption && n.subCaption[0],
          o = a.config,
          r = o.widgetValueHeight || 0,
          l = i.config,
          s = void 0,
          c = void 0,
          u = t.canvasWidth,
          h = o.align,
          d = o.text,
          f = o.alignWithCanvas,
          g = o.horizontalPadding,
          m = t.width,
          b = t.canvasLeft,
          v = t.canvasRight,
          y = t.marginRight,
          x = t.marginLeft,
          C = t.marginTop,
          k = (w(b) || 0) + (0, p.pluckNumber)(u, m) / 2,
          S = o.height,
          _ = l.height,
          L = n.legend && n.legend[0] && n.legend[0].config || {},
          P = L.height || 0,
          A = L.legendPadding || 0,
          N = t.legendposition,
          E = this.getFromEnv("gLegend") || {},
          F = 0,
          O = !!(E.conf || {}).showLegend,
          T = this.config.borderWidth,
          D = n.actionBar,
          M = 0;

      switch (L.isActive || (P = 0), O && this.config.gLegendEnabled && (F = E.getLogicalSpace().height), h) {
        case "end":
          s = f ? v - g : m - g;
          break;

        case "start":
          s = f ? b + g : g;
          break;

        default:
          s = f ? k : x + .5 * (m - x - y) || m / 2;
      }

      o.isOnTop ? c = (T || 0) + (C || 0) : ("right" === N.toLowerCase() && (A = 0, P = 0, F = 0), D && ((M = (D[0].getLogicalSpace && D[0].getLogicalSpace() || {}).height) === p.UNDEF || M === Infinity || M < 0) && (M = 0), c = this.config.height - this.config.marginBottom - S - (_ || 0) - (T || 0) - (A || 0) - (P || 0) - F - r - M), c += o._offsetHeight || 0, a.setDimention({
        x: s,
        y: c
      }), e = d ? c + S + 2 : c || C || 0, i.setDimention({
        x: s,
        y: e
      });
    }, t.prototype._updateVisuals = function () {
      var e,
          t = this.getFromEnv("core-options"),
          n = this.getFromEnv("paper"),
          a = this.getFromEnv("animationManager"),
          i = this.config,
          o = this.getFromEnv("chartWidth"),
          r = this.getFromEnv("chartHeight");
      t && !t._SVGDefinitionURLUpdated && (/^\s*absolute\s*$/i.test(t.SVGDefinitionURL) && (y._url = (y._g && y._g.win || window).location.href.replace(/#.*?$/, p.BLANKSTRING)), t._SVGDefinitionURLUpdated = !0), n ? (p.hasSVG || !i._prevWidth && !i._prevHeight || n.setSize(i._prevWidth, i._prevHeight), e = {
        width: o,
        height: r
      }, a.setAnimation({
        el: n,
        attr: e,
        component: this
      })) : ((n = new y(this.getFromEnv("chart-container"), o, r)).setHTMLClassName("fusioncharts-div"), this.addToEnv("paper", n), n.setConfig("stroke-linecap", p.ROUND), this.setChartEvents()), i._prevWidth = o, i._prevHeight = r, this.setChartCursor(), this._createLayers(), this._setDataLabelStyle(), this._drawCreditLabel();
    }, t.prototype.allocateDimensionOfChartMenuBar = function () {
      var e = this.config,
          t = this.getFromEnv("toolbar"),
          n = t.config,
          a = n.hDirection,
          i = n.vDirection,
          o = t.getLogicalSpace(),
          r = t.getDimension(),
          l = r.y,
          s = r.x;
      "t" === e.toolbarVAlign ? (l += e.toolbarVMargin * i + k(0, o.height * i), s += e.toolbarHMargin * a - C(0, o.width * a), s = "l" === e.toolbarHAlign ? s + o.width : s - o.width) : (l = e.height - e.marginBottom - o.height, s = "b" === e.toolbarVAlign && "r" === e.toolbarHAlign ? e.width - e.marginRight - o.width : e.marginLeft), e.toolbarX !== undefined && (s = e.toolbarX), e.toolbarY !== undefined && (l = e.toolbarY), t.setDimension({
        x: s,
        y: l,
        width: o.width,
        height: o.height
      }), t.manageSpace();
    }, t.prototype.draw = function () {
      var e = this.getFromEnv("chartInstance");
      this.config.hasChartMessage ? (this._hide(), this.drawChartMessage(), this.fireChartInstanceEvent("nodatatodisplay", {}, [e.id]), e.jsVars.drawCount += 1, e.__state.dataReady = !1, e.jsVars.hasNativeMessage = !0) : (this._hideChartMessage(), this._clearTimers && this._clearTimers(), this.config.plotOverFlow = !1, this._show(), this._updateVisuals(), this.setState("initiated", !0), e.jsVars.drawCount += 1, e.jsVars.hasNativeMessage = !1);
    }, t.prototype.manageSpace = function () {
      this.config.hasChartMessage || (this._preDraw(), this.addToolbar && this.addToolbar(), this._manageSpace(), this._postSpaceManagement && this._postSpaceManagement());
    }, t.prototype._show = function () {
      this.getContainer("parentgroup") && this.getContainer("parentgroup").show();
    }, t.prototype._manageActionBarSpace = function () {
      var e = this.config,
          t = this.getChildren("actionBar"),
          n = (t && t[0] && t[0].getLogicalSpace() || {}).height || 0;
      return e.actionBarHeight = n, {
        bottom: n
      };
    }, t.prototype._hide = function () {
      this.getContainer("parentgroup") && this.getContainer("parentgroup").hide();
    }, t.onContainerMouseMove = function (e) {
      var t,
          n = e.data,
          a = n.getFromEnv("chartInstance"),
          i = e.originalEvent,
          o = (0, p.getMouseCoordinate)(n.getFromEnv("chart-container"), i, n);
      a.ref && (t = (0, p.extend2)({
        height: a.args.height,
        width: a.args.width,
        pixelHeight: n.getFromEnv("chartWidth"),
        pixelWidth: n.getFromEnv("chartHeight"),
        id: a.args.id,
        renderer: a.args.renderer,
        container: a.options.containerElement
      }, o), n.fireChartInstanceEvent("chartMouseMove", t));
    }, t.onContainerRollOver = function (e) {
      var t,
          n = e.data,
          a = n.getFromEnv("chartInstance"),
          i = e.originalEvent,
          o = (0, p.getMouseCoordinate)(n.getFromEnv("chart-container"), i, n);
      a.ref && (t = (0, p.extend2)({
        height: a.args.height,
        width: a.args.width,
        pixelHeight: n.getFromEnv("chartWidth"),
        pixelWidth: n.getFromEnv("chartHeight"),
        id: a.args.id,
        renderer: a.args.renderer,
        container: a.options.containerElement
      }, o), n.fireChartInstanceEvent("chartRollOver", t));
    }, t.onContainerRollOut = function (e) {
      var t,
          n = e.chart,
          a = n.getFromEnv("chartInstance"),
          i = e.event,
          o = (0, p.getMouseCoordinate)(n.getFromEnv("chart-container"), i, n);
      a.ref && (t = (0, p.extend2)({
        height: a.args.height,
        width: a.args.width,
        pixelHeight: n.getFromEnv("chartWidth"),
        pixelWidth: n.getFromEnv("chartHeight"),
        id: a.args.id,
        renderer: a.args.renderer,
        container: a.options.containerElement
      }, o), n.fireChartInstanceEvent("chartRollOut", t));
    }, t.winMouseHover = function (e) {
      var n = e.originalEvent,
          a = n.target || n.originalTarget || n.srcElement || n.relatedTarget || n.fromElement,
          i = e.data,
          o = i.getFromEnv("paper"),
          r = {
        chart: i,
        event: e.originalEvent
      };
      x ? o.getById(a.parentNode.raphaelid) || (t.onContainerRollOut(r), i.config.mouseStateIn = !1, f["default"].unlisten(document, "mouseover", t.winMouseHover)) : a.viewportElement || (i.config.mouseStateIn = !1, t.onContainerRollOut(r), f["default"].unlisten(window, "mouseover", t.winMouseHover));
    }, t;
  }(a["default"]);

  t["default"] = R, t._drawDataset = M, t._createToolBox = D, t.configurer = I;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    var t = void 0;
    (0, r.componentFactory)(e, o["default"], "canvas", e.config.showVolumeChart ? 2 : 1);

    for (var n = 0, a = (t = e.getChildren("canvas")).length; n < a; n++) {
      t[n].configure();
    }
  };
  var a,
      i = n(364),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  },
      r = n(125);
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(138),
      o = n(125),
      r = n(132),
      l = n(365),
      s = (a = l) && a.__esModule ? a : {
    "default": a
  };

  function c(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var u = Math.max,
      h = o.preDefStr.miterStr,
      d = o.preDefStr.noneStr,
      p = o.preDefStr.ROUND,
      f = function f(e, t, n) {
    return n.getFromEnv("animationManager").setAnimation({
      el: "group",
      attr: {
        name: e
      },
      container: t,
      component: n,
      label: "group"
    });
  };

  (0, r.addDep)({
    name: "canvasAnimation",
    type: "animationRule",
    extension: s["default"]
  });

  var g = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this)),
          a = n;

      return a.config = {}, a.config.axes = a.config.axes || [], a.setLinkedItem("axes", []), a.setLinkedItem("primaryAxis", {}), a.addToEnv("canvasConfig", n.config), n;
    }

    return c(t, e), t.prototype.getName = function () {
      return "canvas";
    }, t.prototype.getType = function () {
      return "canvas";
    }, t.prototype.createGroup = function () {
      var e = this.getFromEnv("chart"),
          t = e.getChildContainer(),
          n = e.getContainer("parentgroup"),
          a = this.getEffectiveDimensions(),
          i = this.getFromEnv("chart-attrib"),
          r = (0, o.pluckNumber)(i.areaovercolumns, 1),
          l = this.getChildContainer("axisReferenceVisualsFloor"),
          s = this.getChildContainer("axisReferenceVisualsBottom"),
          c = this.getChildContainer("axisReferenceVisualsMiddle"),
          u = this.getChildContainer("axisReferenceVisualsTop"),
          h = this.getChildContainer("axisReferenceVisualsCeil"),
          d = this.getChildContainer("areaGroup"),
          p = this.getChildContainer("areaShadowGroup"),
          g = this.getChildContainer("columnGroup"),
          m = this.getChildContainer("columnShadowGroup"),
          b = t.plotGroup,
          v = [a.left, a.top, a.width, a.height].toString();
      !this.getContainer("canvasGroup") && this.addContainer("canvasGroup", f("canvas", n, this)).insertAfter(t.backgroundGroup), s || (s = this.addChildContainer("axisReferenceVisualsBottom", f("axisReferenceVisualsBottom", n, this)).insertAfter(t.axisBottomGroup)), l || (l = this.addChildContainer("axisReferenceVisualsFloor", f("axisReferenceVisualsFloor", n, this)).insertAfter(t.axisBottomGroup)), l.attr({
        "clip-rect": v
      }), !this.getChildContainer("crossline") && this.addChildContainer("crossline", f("crossline", n, this)).insertBefore(t.plotGroup), !this.getChildContainer("crosslineBottom") && this.addChildContainer("crosslineBottom", f("crosslineBottom", n, this)).insertBefore(t.plotGroup), !this.getChildContainer("crosslineTop") && this.addChildContainer("crosslineTop", f("crosslineTop", n, this)).insertBefore(t.abovePlotGroup), !this.getChildContainer("datalabelsGroup") && this.addChildContainer("datalabelsGroup", f("canvasdatalabel", e.getChildContainer("datalabelsGroup"), this)), c || (c = this.addChildContainer("axisReferenceVisualsMiddle", f("axisReferenceVisualsMiddle", n, this)).insertBefore(t.plotGroup)), c.attr({
        "clip-rect": v
      }), u || (u = this.addChildContainer("axisReferenceVisualsTop", f("axisReferenceVisualsTop", n, this)).insertBefore(t.datalabelsGroup)), !this.getChildContainer("quadrantGroup") && this.addChildContainer("quadrantGroup", f("quadrant", n, this)).insertAfter(c), h || this.addChildContainer("axisReferenceVisualsCeil", f("axisReferenceVisualsCeil", n, this)).insertBefore(t.datalabelsGroup), !this.getChildContainer("sumLabelsLayer") && this.addChildContainer("sumLabelsLayer", t.sumLabelsLayer), m || (m = this.addChildContainer("columnShadowGroup", f("column-shadow-group", b, this))), g || (g = this.addChildContainer("columnGroup", f("column", b, this))), p || (p = this.addChildContainer("areaShadowGroup", f("area-shadow-group", b, this))), d || (d = this.addChildContainer("areaGroup", f("area", b, this))), r ? (m.insertBefore(p), g.insertBefore(p)) : (p.insertBefore(m), d.insertBefore(m)), !this.getChildContainer("lineShadowGroup") && this.addChildContainer("lineShadowGroup", f("line-shadow-group", b, this)), !this.getChildContainer("lineGroup") && this.addChildContainer("lineGroup", f("line", b, this)), !this.getChildContainer("defaultShadowGroup") && this.addChildContainer("defaultShadowGroup", f("default-shadow-group", b, this)), !this.getChildContainer("defaultGroup") && this.addChildContainer("defaultGroup", f("default", b, this));
    }, t.prototype.isWithinCanvas = function (e, t) {
      var n = this.config,
          a = n.canvasLeft,
          i = a + n.canvasWidth,
          o = n.canvasTop,
          r = o + n.canvasHeight;
      return e >= a && e <= i && t >= o && t <= r;
    }, t.prototype.setCanvasPadding = function () {
      var e,
          t = this.config;
      e = this.getCanvasPadding(), t.canvasPaddingLeft = u(t.canvasPaddingLeft, e.paddingLeft || 0), t.canvasPaddingRight = u(t.canvasPaddingRight, e.paddingRight || 0), t.canvasPaddingTop = u(t.canvasPaddingTop, e.paddingTop || 0), t.canvasPaddingBottom = u(t.canvasPaddingBottom, e.paddingBottom || 0);
    }, t.prototype.getEffectiveDimensions = function () {
      var e = this.config;
      return {
        left: e.canvasLeft,
        top: e.canvasTop,
        width: e.canvasWidth,
        height: e.canvasHeight,
        paddingLeft: e.canvasPaddingLeft,
        paddingTop: e.canvasPaddingTop,
        paddingRight: e.canvasPaddingRight,
        paddingBottom: e.canvasPaddingBottom
      };
    }, t.prototype.setDimension = function (e) {
      var t = this.config;
      t.canvasTop = e.top, t.canvasLeft = e.left, t.canvasWidth = e.width, t.canvasHeight = e.height;
    }, t.prototype.getCanvasPadding = function () {
      var e,
          t,
          n,
          a,
          i = this.getFromEnv("chartConfig").canvasWidth,
          o = this.config.maxPaddingPercent * i / 100,
          r = {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      };
      return this._mapChildren(function (n) {
        for (t in e = n.getCanvasPadding && n.getCanvasPadding() || {}) {
          e.hasOwnProperty(t) && (r[t] = u(e[t], r[t]));
        }
      }), n = r.paddingLeft || 0, a = r.paddingRight || 0, o < n && (r.paddingLeft = o), o < a && (r.paddingRight = o), r;
    }, t.prototype.configureAttributes = function () {
      var e,
          t,
          n,
          a,
          i,
          r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          l = this.getLinkedParent(),
          s = this.getFromEnv("chartConfig"),
          c = this.config,
          h = this.getFromEnv("chart-attrib"),
          d = this.getFromEnv("color-manager"),
          p = s.is3D,
          f = p ? o.chartPaletteStr.chart3D : o.chartPaletteStr.chart2D,
          g = c.isRoundEdges = (0, o.pluckNumber)(h.useroundedges, 0),
          m = (0, o.pluckNumber)(h.showxaxisline, h.showyaxisline, h.showaxislines, 0) ? 0 : 1;
      c.canvasBorderRadius = (0, o.pluckNumber)(h.plotborderradius, g ? 2 : 0), n = c.showCanvasBorder = Boolean((0, o.pluckNumber)(h.showcanvasborder, m, e, g ? 0 : 1)), i = c.oriCanvasBorderThickness = u((0, o.pluckNumber)(h.canvasborderthickness, g ? 0 : (0, o.pluckNumber)(l.canvasborderthickness, 2), 0)), e = c.canvasBorderWidth = p ? 0 : n ? i : 0, c.canvasBorderColor = (0, o.convertColor)((0, o.pluck)(h.canvasbordercolor, d.getColor(o.canvasBorderColorStr)), (0, o.pluck)(h.canvasborderalpha, d.getColor("canvasBorderAlpha"))), t = c.canBGAlpha = (0, o.pluck)(h.canvasbgalpha, d.getColor(o.canvasBGAlphaStr)), c.canBGColor = {
        FCcolor: {
          color: (0, o.pluck)(h.canvasbgcolor, d.getColor(f.canvasBgColor)),
          alpha: (0, o.pluck)(h.canvasbgalpha, 100),
          angle: (0, o.pluck)(h.canvasbgangle, 0),
          ratio: (0, o.pluck)(h.canvasbgratio)
        }
      }, a = c.shadow = (0, o.pluckNumber)(h.showshadow, g, 0) && g ? {
        enabled: !0,
        opacity: t / 100
      } : 0, c.shadowOnCanvasFill = a && a.enabled, c.canvasPadding = (0, o.pluckNumber)(h.canvaspadding, 0), c.origCanvasTopPad = (0, o.pluckNumber)(h.canvastoppadding, 0), c.origCanvasBottomPad = (0, o.pluckNumber)(h.canvasbottompadding, 0), c.origCanvasLeftPad = (0, o.pluckNumber)(h.canvasleftpadding, 0), c.origCanvasRightPad = (0, o.pluckNumber)(h.canvasrightpadding, 0), Object.assign(c, r), this.config.inputComponents = [], this.config.maxPaddingPercent = 12.5, this._mapChildren(function (e) {
        e.getState("removed") || e.getType && "dataset" === e.getType() || "axisRefVisuals" === e.getType() || e.configure && e.configure();
      });
    }, t.prototype.disposeAllInputs = function () {
      this.config.inputComponents.forEach(function (e) {
        e.dispose();
      }), this.config.inputComponents.length = 0;
    }, t.prototype.axisExists = function (e) {
      var t,
          n = this.getLinkedItem("axes"),
          a = void 0,
          i = !1;

      for (a = 0, t = n.length; a < t; a++) {
        if (n[a].axis === e) {
          i = !0;
          break;
        }
      }

      return i;
    }, t.prototype.attachAxis = function (e, t, n) {
      var a = this.getLinkedItem("axes"),
          i = t ? "yAxis" : "xAxis",
          o = this.getFromEnv(i) || [];
      return this.axisExists(e) || (a.push({
        axis: e,
        isY: t,
        config: n || {}
      }), o.push(e), this.addToEnv(i, o)), this;
    }, t.prototype.setPrimaryAxis = function (e, t) {
      this.getLinkedItem("primaryAxis")[e] = this.getLinkedItem("axes").find(function (e) {
        return e.axis === t;
      });
    }, t.prototype.getAxes = function () {
      var e;
      return Object.keys(e = this.getLinkedItem("primaryAxis")).length ? [e.xAxis, e.yAxis] : this.getLinkedItem("axes").slice(0);
    }, t.prototype.detachAxis = function (e, t) {
      var n = this.getLinkedItem("axes"),
          a = Infinity;
      return t ? n.splice(t, 1) : (n.forEach(function (t, n) {
        t.axis === e && (a = n);
      }), n.splice(a, 1));
    }, t.prototype.preDraw = function () {
      this._mapChildren(function (e) {
        e.getState("removed") || e.preDraw && e.preDraw();
      });
    }, t.prototype.draw = function () {
      this.createGroup(), !this.getFromEnv("chart").config.skipCanvasDrawing && this.drawCanvas();
    }, t.prototype.drawCanvas = function () {
      var e,
          t,
          n,
          a,
          i = this,
          r = i.getFromEnv("chart"),
          l = r.isBar,
          s = r.getFromEnv("dataSource").chart,
          c = i.getFromEnv("animationManager"),
          f = r.config,
          g = i.config,
          m = g.clip = {},
          b = r.getChildContainer("plotGroup"),
          v = r.getChildContainer("datalabelsGroup"),
          y = i.getGraphicalElement("canvasBorderElement"),
          x = void 0,
          C = i.getGraphicalElement("canvasElement"),
          k = void 0,
          w = g.canvasLeft || (g.canvasLeft = f.canvasLeft),
          S = g.canvasTop || (g.canvasTop = f.canvasTop),
          _ = g.canvasWidth || (g.canvasWidth = f.canvasWidth),
          L = g.canvasHeight || (g.canvasHeight = f.canvasHeight),
          P = g.xDepth = f.xDepth || 0,
          A = g.yDepth = f.yDepth || 0,
          N = i.getContainer("canvasGroup"),
          E = i.getChildContainer("quadrantGroup"),
          F = g.canvasBorderRadius,
          O = g.canvasBorderWidth,
          T = .5 * O,
          D = g.canvasBorderColor,
          M = g.canBGColor,
          I = g.canBGAlpha,
          R = g.shadow,
          V = void 0,
          B = g.showCanvasBG = Boolean((0, o.pluckNumber)(s.showcanvasbg, 1)),
          j = g.shadowOnCanvasFill,
          G = g.showCanvasBorder;

      t = M, V = {
        x: w - T,
        y: S - T,
        width: _ + O,
        height: L + O,
        r: F,
        "stroke-width": O,
        stroke: D,
        "stroke-linejoin": O > 2 ? p : h
      }, G ? (y && y.show(), x = c.setAnimation({
        el: y || "rect",
        component: i,
        attr: {
          x: w - T,
          y: S - T,
          width: _ + O,
          height: L + O,
          r: F,
          "stroke-width": O,
          stroke: D,
          "stroke-linejoin": O > 2 ? p : h
        },
        label: "rect",
        container: N
      }).shadow(R), y || i.addGraphicalElement("canvasBorderElement", x)) : y && (i.removeGraphicalElement(y), c.setAnimation({
        el: y,
        component: i,
        callback: function callback() {
          y.hide();
        }
      })), n = G ? 0 : g.oriCanvasBorderThickness, m["clip-canvas"] = [u(0, w - P - n), u(0, S - A - n), u(1, _ + 2 * P + 2 * n), u(1, L + A + 2 * n)], m["clip-sum-value"] = [u(0, w - P), l ? S : 0, u(1, l ? f.width - w : _ + 2 * P), u(1, l ? L + A : S + L)], m["clip-canvas-init"] = [u(0, w - P), u(0, S - A), 1, u(1, L + 2 * A)], e = m["clip-canvas"].slice(0), a = function a(e, t) {
        c.setAnimation({
          el: e,
          attr: {
            "clip-rect": t
          },
          label: "container",
          component: i,
          state: e.attrs["clip-rect"] ? "updating" : "appearing"
        });
      }, f.skipClipping || (a(b, e), a(v, e), a(E, e), a(i.getChildContainer("sumLabelsLayer"), m["clip-sum-value"])), B ? (V = {
        x: w,
        y: S,
        width: _,
        height: L,
        r: F,
        "stroke-width": 0,
        stroke: d,
        fill: (0, o.toRaphaelColor)(t)
      }, C && C.show(), k = c.setAnimation({
        el: C || "rect",
        attr: V,
        label: "rect",
        container: N,
        component: i
      }), C || i.addGraphicalElement("canvasElement", k), j ? k.shadow({
        opacity: I / 100
      }) : k.shadow(!1)) : C && c.setAnimation({
        el: C,
        component: i,
        callback: function callback() {
          C.hide();
        }
      });
    }, t;
  }(i.ComponentInterface);

  t["default"] = g;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = {
    "initial.canvas.canvas": function initialCanvasCanvas() {
      return {
        "rect.appearing": function rectAppearing() {
          return [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: "initial"
          }];
        },
        "*": null
      };
    },
    "update.canvas.canvas": {
      "rect.updating": [{
        slot: "middle"
      }]
    }
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(125),
      o = n(138),
      r = n(132),
      l = n(367),
      s = (a = l) && a.__esModule ? a : {
    "default": a
  };

  function c(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var u = Math.max,
      h = Math.min,
      d = Math.ceil;
  (0, r.addDep)({
    name: "captionAnimation",
    type: "animationRule",
    extension: s["default"]
  });

  var p = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.apply(this, arguments));
    }

    return c(t, e), t.prototype.getType = function () {
      return "caption";
    }, t.prototype.getName = function () {
      return "caption";
    }, t.prototype.configure = function () {
      var e = this.getFromEnv("chart"),
          t = e.getFromEnv("chart-attrib"),
          n = this.config || {},
          a = e.getFromEnv("style"),
          o = a.outCanfontFamily,
          r = a.outCancolor,
          l = a.fontSize,
          s = ["top", "center"];

      switch (this.config.text = (0, i.parseUnsafeString)(t.caption), n.style = {
        fontFamily: (0, i.pluck)(t.captionfont, o),
        color: (0, i.convertColor)((0, i.pluck)(t.captionfontcolor, r).replace(/^#? ([a-f0-9]+)/gi, "#$1")),
        fontSize: (0, i.pluckNumber)(t.captionfontsize, l + 3) + "px",
        fontWeight: 0 === (0, i.pluckNumber)(t.captionfontbold) ? i.NORMAL : i.BOLD
      }, n.align || (n.align = ""), n.align = (0, i.pluck)(t.captionposition, t.captionalignment, "center"), n.align && ((s = n.align.split("-"))[0] && (s[0] = s[0].toLowerCase()), s[1] && (s[1] = s[1].toLowerCase()), s.length < 2 && (s[1] = s[0])), s[0]) {
        case "top":
          n.isOnTop = 1;
          break;

        case "bottom":
          n.isOnTop = 0;
          break;

        default:
          n.isOnTop = (0, i.pluckNumber)(t.captionontop, 1);
      }

      switch (s[1]) {
        case "right":
          n.align = "end";
          break;

        case "left":
          n.align = "start";
          break;

        default:
          n.align = "middle";
      }

      n.isOnLeft = !(0, i.pluckNumber)(t.captiononright, 0), n.captionPosition = (0, i.getValidValue)(t.captionposition, "top").toLowerCase(), n.alignWithCanvas = (0, i.pluckNumber)(t.aligncaptionwithcanvas, e.config.alignCaptionWithCanvas, 1), n.horizontalPadding = (0, i.pluckNumber)(t.captionhorizontalpadding, n.alignWithCanvas ? 0 : 15), n.drawCaption = !0, (0, i.setLineHeight)(n.style);
    }, t.prototype.allocatePosition = function () {
      this.getFromEnv("chart")._manageCaptionPosition();
    }, t.prototype.draw = function () {
      var e,
          t = this.getFromEnv("chart"),
          n = t.config,
          a = t.getFromEnv("animationManager"),
          o = t.config.textDirection,
          r = t.getChildContainer().captionGroup,
          l = t.getFromEnv("smartLabel"),
          s = this.getGraphicalElement("captionElement"),
          c = this.getFromEnv("toolTipController"),
          u = this.config,
          h = u.style,
          d = u.text,
          p = u.x,
          f = u.align;
      d ? (e = {
        text: u.text,
        fill: h.color,
        x: p,
        y: u.y,
        "text-anchor": f || "middle",
        "vertical-align": u.verticalAlign || "top",
        visibility: u.drawCaption ? i.visibleStr : i.hiddenStr,
        direction: o
      }, (s = this.addGraphicalElement("captionElement", a.setAnimation({
        el: s || "text",
        attr: e,
        container: r,
        state: void 0,
        component: this,
        label: "text"
      }))).css(h), n.showtooltip ? c.enableToolTip(s, u.originalText) : c.disableToolTip(s), l && (l.useEllipsesOnOverflow(n.useEllipsesWhenOverflow), l.setStyle(h))) : s && a.setAnimation({
        el: s,
        component: this,
        callback: function callback() {
          this.hide();
        },
        doNotRemove: !0
      }), n.savedCaption = s;
    }, t.prototype.manageSpace = function (e, t) {
      var n,
          a,
          o,
          r,
          l,
          s = this.getFromEnv("chart"),
          c = s.config,
          p = s.getChildren("caption")[0],
          f = s.getChildren("subCaption")[0],
          g = p.config,
          m = f.config,
          b = s.getFromEnv("dataSource").chart,
          v = s.getFromEnv("smartLabel"),
          y = e,
          x = (0, i.parseUnsafeString)(b.caption),
          C = (0, i.parseUnsafeString)(b.subcaption),
          k = (0, i.pluckNumber)(b.captionpadding, 10),
          w = k,
          S = !1,
          _ = 0,
          L = 0,
          P = 0,
          A = 0,
          N = 0,
          E = s.getChildren("canvas"),
          F = u(E && E[0].config.canvasBorderThickness, 0),
          O = 0,
          T = 0;
      return y > 3 ? (k < F && (k = F + 2), x !== i.BLANKSTRING && (o = g.style, A = d((0, i.pluckNumber)(parseFloat(o.fontHeight, 10), parseFloat(o.lineHeight, 10), 12))), C !== i.BLANKSTRING && (l = m.style, N = (0, i.pluckNumber)(parseInt(l.fontHeight, 10), parseInt(l.lineHeight, 10), 12)), (A > 0 || N > 0) && ((_ = A + N + k) > (y = u(y, 0)) ? (S = !0, (L = y - _) < k ? k = u(L, 5) : (L -= k, k = 0, N > L ? (P = N - L + 10, N = 0, m._originalText = m.text, m.text = i.BLANKSTRING) : (L -= N, N = 0, A > L && (P = A - L)))) : P = y - _, v.useEllipsesOnOverflow(c.useEllipsesWhenOverflow), A > 0 && (v.setStyle(o), P = (A += P) - (n = v.getSmartText(x, t, A)).height, g.height = A = n.height, g.text = n.text, g.originalText = !!n.tooltext && n.tooltext, O = n.width), N > 0 && (v.setStyle(l), P = (N += P) - (a = v.getSmartText(C, t, N)).height, N = a.height, m.text = a.text, m.height = a.height, m.originalText = !!a.tooltext && a.tooltext, T = a.width), S && P > 0 && (k += h(w - k, P)), g.captionPadding = k, g.height = A, g.width = O, m.width = T, m.height = N, _ = A + N + k), _ > c.canvasHeight ? (_ = 0, g.drawCaption = !1) : g.drawCaption = !0, r = g.isOnTop ? {
        top: _
      } : {
        bottom: _,
        top: 5
      }) : (r = {
        bottom: 0,
        top: 0
      }, g.drawCaption = !1), r;
    }, t.prototype.setDimention = function (e) {
      var t = this.config;
      t.x = e.x, t.y = e.y;
    }, t;
  }(o.ComponentInterface);

  t["default"] = p;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = {
    "initial.caption.caption": function initialCaptionCaption() {
      return {
        "text.appearing": function textAppearing() {
          return [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: "initial"
          }];
        }
      };
    }
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(125),
      i = l(n(366)),
      o = n(132),
      r = l(n(369));

  function l(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function s(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var c = Math.max;
  (0, o.addDep)({
    name: "subcaptionAnimation",
    type: "animationRule",
    extension: r["default"]
  });

  var u = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.apply(this, arguments));
    }

    return s(t, e), t.prototype.getType = function () {
      return "caption";
    }, t.prototype.getName = function () {
      return "subCaption";
    }, t.prototype.configure = function () {
      var e = this.getFromEnv("chart"),
          t = e.getFromEnv("chart-attrib"),
          n = this.config || {},
          i = e.getFromEnv("style"),
          o = e.getChildren("caption")[0],
          r = i.outCanfontFamily,
          l = i.outCancolor,
          s = i.fontSize,
          u = ["top", "center"];

      switch (n.text = (0, a.parseUnsafeString)(t.subcaption), n.align || (n.align = ""), n.align = (0, a.pluck)(t.captionposition, t.captionalignment, "center"), o.config.align && ((u = o.config.align.split("-"))[0] && (u[0] = u[0].toLowerCase()), u[1] && (u[1] = u[1].toLowerCase()), u.length < 2 && (u[1] = u[0])), u[0]) {
        case "top":
          n.isOnTop = 1;
          break;

        case "bottom":
          n.isOnTop = 0;
          break;

        default:
          n.isOnTop = (0, a.pluckNumber)(t.captionontop, 1);
      }

      n.alignWithCanvas = (0, a.pluckNumber)(e.aligncaptionwithcanvas, t.aligncaptionwithcanvas, 1), n.horizontalPadding = (0, a.pluckNumber)(t.captionhorizontalpadding, o.config.alignWithCanvas ? 0 : 15), n.style = {
        fontFamily: (0, a.pluck)(t.subcaptionfont, t.captionfont, r),
        color: (0, a.convertColor)((0, a.pluck)(t.subcaptionfontcolor, t.captionfontcolor, l).replace(/^#? ([a-f0-9]+)/gi, "#$1")),
        fontSize: (0, a.pluckNumber)(t.subcaptionfontsize, (0, a.pluckNumber)(c((0, a.pluckNumber)(t.captionfontsize) - 3, -1), s) + (0, a.pluckNumber)(e.subTitleFontSizeExtender, 1)) + "px",
        fontWeight: 0 === (0, a.pluckNumber)(t.subcaptionfontbold, e.subTitleFontWeight, t.captionfontbold) ? a.NORMAL : a.BOLD
      }, (0, a.setLineHeight)(n.style);
    }, t.prototype.draw = function () {
      var e = this.getFromEnv("chart"),
          t = e.getFromEnv("animationManager"),
          n = e.getChildren("caption")[0],
          i = e.config,
          o = i.textDirection,
          r = e.getChildContainer().captionGroup,
          l = this.getGraphicalElement("subCaptionElement"),
          s = this.getFromEnv("toolTipController"),
          c = this.config,
          u = c.style,
          h = c.text,
          d = n.config.align,
          p = void 0;
      h ? (p = {
        text: c.text,
        fill: u.color,
        x: c.x,
        y: c.y,
        "text-anchor": d || "middle",
        "vertical-align": "top",
        direction: o,
        visibility: n.config.drawCaption ? a.visibleStr : a.hiddenStr
      }, (l = this.addGraphicalElement("subCaptionElement", t.setAnimation({
        el: l || "text",
        attr: p,
        container: r,
        state: void 0,
        component: this,
        hookFn: function hookFn() {
          this.css(u);
        },
        label: "text"
      }))).css(u), i.showtooltip ? s.enableToolTip(l, c.originalText) : s.disableToolTip(l)) : l && this.removeGraphicalElement(l), i.savedSubCaption = l;
    }, t.prototype.setDimention = function (e) {
      this.config.x = e.x, this.config.y = e.y;
    }, t;
  }(i["default"]);

  t["default"] = u;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(367),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };
  t["default"] = {
    "initial.caption.subCaption": o["default"]["initial.caption.caption"]
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(138),
      o = n(125),
      r = n(132),
      l = n(371),
      s = (a = l) && a.__esModule ? a : {
    "default": a
  };

  function c(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var u = "BackgroundLoaded",
      h = "BackgroundLoadError",
      d = "none",
      p = function p(e) {
    var t = e.config;
    return {
      load: function load() {
        var n = t.bgImageDisplayMode,
            a = t.bgImageVAlign,
            i = t.bgImageHAlign,
            o = t.bgImageScale,
            r = t.bgSWFAlpha,
            l = t.bgSWF,
            s = e.getGraphicalElement("backgroundImage")._.RefImg;

        e.getFromEnv("chart").fireChartInstanceEvent(u, {
          url: l,
          bgImageAlpha: r,
          bgImageDisplayMode: n,
          bgImageVAlign: a,
          bgImageHAlign: i,
          bgImageScale: o,
          imageheight: s.height,
          imagewidth: s.width
        });
      },
      error: function error(n) {
        var a = t.bgImageDisplayMode,
            i = t.bgImageVAlign,
            o = t.bgImageHAlign,
            r = t.bgImageScale,
            l = t.bgSWFAlpha,
            s = t.bgSWF;
        e.getFromEnv("chart").fireChartInstanceEvent(h, {
          url: s,
          bgImageAlpha: l,
          error: n,
          bgImageDisplayMode: a,
          bgImageVAlign: i,
          bgImageHAlign: o,
          bgImageScale: r
        });
      }
    };
  };

  (0, r.addDep)({
    name: "backgroundAnimation",
    type: "animationRule",
    extension: s["default"]
  });

  var f = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.config.handler = p(n), n;
    }

    return c(t, e), t.prototype.getName = function () {
      return "background";
    }, t.prototype.getType = function () {
      return "background";
    }, t.prototype._getBackgroundCosmetics = function () {
      var e = this.getFromEnv("chart-attrib"),
          t = this.getFromEnv("color-manager"),
          n = this.getFromEnv("chartConfig").is3D ? o.chartPaletteStr.chart3D : o.chartPaletteStr.chart2D;
      return {
        FCcolor: {
          color: (0, o.pluck)(e.bgcolor, t.getColor(n.bgColor)),
          alpha: (0, o.pluck)(e.bgalpha, t.getColor(n.bgAlpha)),
          angle: (0, o.pluck)(e.bgangle, t.getColor(n.bgAngle)),
          ratio: (0, o.pluck)(e.bgratio, t.getColor(n.bgRatio))
        }
      };
    }, t.prototype.configureAttributes = function () {
      var e,
          t,
          n,
          a = this.config,
          i = this.getFromEnv("chart-attrib"),
          r = this.getFromEnv("chartConfig"),
          l = r.is3D,
          s = this.getFromEnv("color-manager"),
          c = a.bgImageDisplayMode = (0, o.pluck)(i.bgimagedisplaymode, "none").toLowerCase();
      a.bgSWF = (0, o.pluck)(i.bgimage, i.bgswf), a.bgSWFAlpha = (0, o.pluckNumber)(i.bgimagealpha, i.bgswfalpha, 100), e = a.showBorder = (0, o.pluckNumber)(i.showborder, r.showBorder, l ? 0 : 1), a.borderWidth = Math.max(e ? (0, o.pluckNumber)(i.borderthickness, 1) : 0, 0), a.borderRadius = (0, o.pluckNumber)(i.borderradius, 0), a.borderDashStyle = (0, o.pluckNumber)(i.borderdashed, 0) ? (0, o.getDashStyle)((0, o.pluckNumber)(i.borderdashlen, 4), (0, o.pluckNumber)(i.borderdashgap, 2), void 0) : d, a.borderAlpha = (0, o.pluck)(i.borderalpha, l ? "100" : s && s.getColor("borderAlpha")), a.borderColor = (0, o.convertColor)((0, o.pluck)(i.bordercolor, l ? "#666666" : s && s.getColor("borderColor")), a.borderAlpha), a.bgImageVAlign = t = (0, o.getValidValue)(i.bgimagevalign, "").toLowerCase(), a.bgImageHAlign = n = (i.bgimagehalign || "").toLowerCase(), a.bgImageScale = (0, o.pluckNumber)(i.bgimagescale, 100), a.containerBackgroundColor = (0, o.getContainerBackgroundColor)(this.getFromEnv("chartInstance")), a.backgroundColor = this._getBackgroundCosmetics(), "tile" === c || "fill" === c || "fit" === c ? ("top" !== t && "middle" !== t && "bottom" !== t && (a.bgImageVAlign = "middle"), "left" !== n && "middle" !== n && "right" !== n && (a.bgImageHAlign = "middle")) : ("top" !== t && "middle" !== t && "bottom" !== t && (a.bgImageVAlign = "top"), "left" !== n && "middle" !== n && "right" !== n && (a.bgImageHAlign = "left"));
    }, t.prototype.draw = function () {
      var e,
          t,
          n,
          a,
          i,
          r,
          l = this.getFromEnv("paper"),
          s = this.getGraphicalElement("backgroundElement"),
          c = this.getGraphicalElement("borderElement"),
          u = this.config,
          h = this.getFromEnv("chart"),
          d = this.getFromEnv("chartConfig"),
          p = u.backgroundColor,
          f = this.getFromEnv("animationManager"),
          g = this.getGraphicalElement("backgroundImage"),
          m = u.bgSWF,
          b = h.getChildContainer("backgroundGroup"),
          v = d.width,
          y = d.height,
          x = u.borderWidth || 0,
          C = u.borderRadius,
          k = u.borderDashStyle,
          w = u.borderColor,
          S = u.bgSWFAlpha,
          _ = x + "," + x + "," + (v - 2 * x) + "," + (y - 2 * x),
          L = u.bgImageDisplayMode,
          P = u.bgImageVAlign,
          A = u.bgImageHAlign,
          N = u.bgImageScale;

      l.canvas.style.backgroundColor = u.containerBackgroundColor, i = y - 2 * x, n = {
        x: x,
        y: x,
        width: (r = v - 2 * x) < 0 ? 0 : r,
        height: i > 0 ? i : 0,
        stroke: o.preDefStr.noneStr,
        fill: (0, o.toRaphaelColor)(p)
      }, (e = f.setAnimation({
        el: s || "rect",
        attr: n,
        container: b,
        component: this,
        label: "rect"
      })).show(), s || this.addGraphicalElement("backgroundElement", e), i = y - x, n = {
        x: x / 2,
        y: x / 2,
        width: (r = v - x) < 0 ? 0 : r,
        height: i > 0 ? i : 0,
        stroke: w,
        "stroke-width": x,
        "stroke-dasharray": k,
        fill: o.preDefStr.noneStr,
        r: C || 0
      }, (t = f.setAnimation({
        el: c || "rect",
        attr: n,
        container: b,
        component: this,
        label: "rect"
      })).show(), c || this.addGraphicalElement("borderElement", t), m && !this.getState("removed") ? ((a = f.setAnimation({
        el: g || "imagegrid",
        attr: {
          imagegrid: [L, P, A, N, x, v, y],
          src: m,
          opacity: .01 * S,
          "clip-rect": _
        },
        container: b,
        component: this,
        label: "imagegrid"
      })).show(), g || (this.addGraphicalElement("backgroundImage", a), a.on("load", u.handler.load), a.on("error", u.handler.error))) : g && this.removeGraphicalElement(g);
    }, t;
  }(i.ComponentInterface);

  t["default"] = f;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = {
    "initial.background.background": function initialBackgroundBackground() {
      return {
        "rect.appearing": function rectAppearing() {
          return [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: "initial"
          }];
        }
      };
    }
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;

  var a,
      i = n(125),
      o = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t["default"] = e, t;
  }(n(373)),
      r = n(374),
      l = (a = r) && a.__esModule ? a : {
    "default": a
  };

  function s(e, t) {
    var n,
        a,
        o,
        r,
        l,
        s,
        c,
        u,
        d,
        p,
        f,
        g = [],
        m = h.stringConstants;
    if ((t = (t = t.replace(/\s/g, m.BLANK)).toLowerCase()) === m.BLANK || null === t || void 0 === t) g = [e];else for (o = t.split(m.COMMASTRING), r = e.split(m.COMMASTRING), l = Math.max(o.length, r.length, 1), s = o[0], c = r[0], p = /[\{\}]/gi, f = 0; f < l; f++) {
      u = (o[f] || s).replace(p, ""), d = r[f] || c, "color" === u ? g.push(d) : "light" === u.substr(0, 5) ? (a = 100 - (a = -1 === (n = u.indexOf("-")) ? 1 : u.substr(n + 1, u.length - n)), g.push((0, i.getLightColor)(d, a))) : "dark" === u.substr(0, 4) ? (a = 100 - (a = -1 === (n = u.indexOf("-")) ? 1 : u.substr(n + 1, u.length - n)), g.push((0, i.getDarkColor)(d, a))) : g.push(u);
    }
    return g;
  }

  function c(e, t) {
    var n,
        a,
        o = e.toString().split(h.stringConstants.COMMASTRING),
        r = [],
        l = 100;

    for (a = 0; a < t; a++) {
      n = (0, i.pluckNumber)(o[a]), h.defined(n) && (l = n), r[a] = l;
    }

    return r.join();
  }

  function u(e, t) {
    var n,
        a,
        i = e.split(h.stringConstants.COMMASTRING),
        o = [],
        r = 0;

    for (a = 0; a < t; a++) {
      n = i[a], n = (n = isNaN(n) || void 0 === n ? 0 : Math.abs(Number(n))) > 100 ? 100 : n, o[a] = n, r += n;
    }

    if (r = r > 100 ? 100 : r, i.length < t) for (a = i.length; a < t; a++) {
      o[a] = (100 - r) / (t - i.length);
    }
    return o[-1] = 0, o.join();
  }

  var h = function () {
    function e(t) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.parseColorMix = s, this.parseAlphaList = c, this.parseRatioList = u, this.linkedItems = {
        iapi: t
      }, this.configure(), this.paletteColors = ["AFD8F8", "F6BD0F", "8BBA00", "FF8E46", "008E8E", "D64646", "8E468E", "588526", "B3AA00", "008ED6", "9D080D", "A186BE", "CC6600", "FDC689", "ABA000", "F26D7D", "FFF200", "0054A6", "F7941C", "CC3300", "006600", "663300", "6DCFF6"];
    }

    return e.prototype.configure = function () {
      var t = this,
          n = e.stringConstants,
          a = t.linkedItems.iapi,
          r = a.getFromEnv("dataSource").chart || {},
          s = t.paletteOptions = (0, i.extend2)((0, i.extend2)({}, o), a.defaultPaletteOptions || {}, !1, !0),
          c = t.themeEnabled = r.palettethemecolor;
      t.paletteIndex = (r.palette > 0 && r.palette < 6 ? r.palette : (0, i.pluckNumber)(a.paletteIndex, 1)) - 1, t.iterator = 0, t.paletteColors = s.paletteColors[t.themeEnabled ? 0 : t.paletteIndex], e.defined(r.palettecolors) && r.palettecolors !== n.BLANK && (t.paletteColors = (0, l["default"])(r.palettecolors) ? r.palettecolors.slice() : r.palettecolors.split(/\s*\,\s*/)), t.paletteLen = t.paletteColors.length, t.useFlatColors = (0, i.pluckNumber)(r.useflatdataplotcolor, a.useFlatColor, 0), c && (t.paletteIndex = 5, s.bgColor[5] = (0, i.getLightColor)(c, 35) + n.COMMASTRING + (0, i.getLightColor)(c, 10), s.bgAngle[5] = 270, s.bgRatio[5] = n.BGRATIOSTRING, s.bgAlpha[5] = "50,50", s.canvasBgColor[5] = n.COLOR_WHITE, s.canvasBgAngle[5] = 0, s.canvasBgAlpha[5] = n.HUNDREDSTRING, s.canvasBgRatio[5] = n.BLANK, s.canvasBorderColor[5] = (0, i.getDarkColor)(c, 80), s.canvasBorderAlpha[5] = 100, s.showShadow[5] = 1, s.divLineColor[5] = (0, i.getDarkColor)(c, 20), s.divLineAlpha[5] = 40, s.altHGridColor[5] = (0, i.getLightColor)(c, 20), s.altHGridAlpha[5] = 15, s.altVGridColor[5] = (0, i.getLightColor)(c, 80), s.altVGridAlpha[5] = 10, s.anchorBgColor[5] = n.COLOR_WHITE, s.toolTipBgColor[5] = n.COLOR_WHITE, s.toolTipBorderColor[5] = (0, i.getDarkColor)(c, 80), s.baseFontColor[5] = c.split && c.split(n.COMMASTRING)[0], s.borderColor[5] = (0, i.getDarkColor)(c, 60), s.borderAlpha[5] = 50, s.legendBgColor[5] = n.COLOR_WHITE, s.legendBorderColor[5] = (0, i.getDarkColor)(c, 80), s.plotGradientColor[5] = n.COLOR_WHITE, s.plotBorderColor[5] = (0, i.getDarkColor)(c, 85), s.plotFillColor[5] = (0, i.getDarkColor)(c, 85), s.bgColor3D[5] = n.COLOR_WHITE, s.bgAlpha3D[5] = n.HUNDREDSTRING, s.bgAngle3D[5] = 90, s.bgRatio3D[5] = n.BLANK, s.canvasBgColor3D[5] = (0, i.getLightColor)(c, 20), s.canvasBaseColor3D[5] = (0, i.getLightColor)(c, 40), s.divLineColor3D[5] = (0, i.getDarkColor)(c, 20), s.divLineAlpha3D[5] = 40, s.legendBgColor3D[5] = n.COLOR_WHITE, s.legendBorderColor3D[5] = (0, i.getDarkColor)(c, 80), s.toolTipbgColor3D[5] = n.COLOR_WHITE, s.toolTipBorderColor3D[5] = (0, i.getDarkColor)(c, 80), s.baseFontColor3D[5] = c.split && c.split(n.COMMASTRING)[0], s.anchorBgColor3D[5] = n.COLOR_WHITE, s.tickColor && (s.tickColor[5] = (0, i.getDarkColor)(c, 90)), s.trendDarkColor && (s.trendDarkColor[5] = (0, i.getDarkColor)(c, 90)), s.trendLightColor && (s.trendLightColor[5] = (0, i.getLightColor)(c, s.TrendLightShadeOffset)), s.msgLogColor && (s.msgLogColor[5] = (0, i.getLightColor)(c, 80)), s.dialColor && (s.dialColor[5] = (0, i.getDarkColor)(c, 95) + ",FFFFFF," + (0, i.getDarkColor)(c, 95)), s.dialBorderColor && (s.dialBorderColor[5] = (0, i.getDarkColor)(c, 95) + ",FFFFFF," + (0, i.getDarkColor)(c, 95)), s.pivotColor && (s.pivotColor[5] = (0, i.getLightColor)(c, 95) + ",FFFFFF," + (0, i.getLightColor)(c, 95)), s.pivotBorderColor && (s.pivotBorderColor[5] = (0, i.getDarkColor)(c, 95) + ",FFFFFF," + (0, i.getDarkColor)(c, 95)), s.pointerBorderColor && (s.pointerBorderColor[5] = (0, i.getDarkColor)(c, 75)), s.pointerBgColor && (s.pointerBgColor[5] = (0, i.getDarkColor)(c, 75)), s.thmBorderColor && (s.thmBorderColor[5] = (0, i.getDarkColor)(c, 90)), s.thmFillColor && (s.thmFillColor[5] = (0, i.getLightColor)(c, 55)), s.gaugeBorderColor && (s.gaugeBorderColor[5] = (0, i.getDarkColor)(c, 90)), s.gaugeFillColor && (s.gaugeFillColor[5] = (0, i.getLightColor)(c, 55)), s.cylFillColor && (s.cylFillColor[5] = (0, i.getLightColor)(c, 55)), s.periodColor && (s.periodColor[5] = (0, i.getLightColor)(c, 10)), s.winColor && (s.winColor[5] = "666666"), s.lossColor && (s.lossColor[5] = "CC0000"), s.drawColor && (s.drawColor[5] = "666666"), s.scorelessColor && (s.scorelessColor[5] = "FF0000"), s.gridColor && (s.gridColor[5] = (0, i.getLightColor)(c, 30)), s.categoryBgColor && (s.categoryBgColor[5] = (0, i.getLightColor)(c, 10)), s.dataTableBgColor && (s.dataTableBgColor[5] = (0, i.getLightColor)(c, 10)), s.gridResizeBarColor && (s.gridResizeBarColor[5] = (0, i.getDarkColor)(c, 90)), s.scrollBarColor && (s.scrollBarColor[5] = (0, i.getLightColor)(c, 50)));
    }, e.prototype.getColor = function (e) {
      return this.paletteOptions[e][this.paletteIndex];
    }, e.prototype.getPlotColor = function (e) {
      var t = this,
          n = t.paletteColors,
          a = t.useFlatColors ? t.getColor("plotFillColor") : n[e % t.paletteLen];
      return a || (t.iterator === t.paletteLen && (t.iterator = 0), a = n[t.iterator], t.iterator += 1), a;
    }, e;
  }();

  h.stringConstants = {
    BLANK: "",
    COMMASTRING: ",",
    BGRATIOSTRING: "0,100",
    COLOR_WHITE: "FFFFFF",
    HUNDREDSTRING: "100"
  }, h.defined = function (e) {
    return void 0 !== e && null !== e;
  }, t["default"] = h;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = ["AFD8F8", "F6BD0F", "8BBA00", "FF8E46", "008E8E", "D64646", "8E468E", "588526", "B3AA00", "008ED6", "9D080D", "A186BE", "CC6600", "FDC689", "ABA000", "F26D7D", "FFF200", "0054A6", "F7941C", "CC3300", "006600", "663300", "6DCFF6"];
  t.paletteColors = [a, a, a, a, a], t.bgColor = ["CBCBCB,E9E9E9", "CFD4BE,F3F5DD", "C5DADD,EDFBFE", "A86402,FDC16D", "FF7CA0,FFD1DD"], t.bgAngle = [270, 270, 270, 270, 270], t.bgRatio = ["0,100", "0,100", "0,100", "0,100", "0,100"], t.bgAlpha = ["50,50", "60,50", "40,20", "20,10", "30,30"], t.canvasBgColor = ["FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF"], t.canvasBgAngle = [0, 0, 0, 0, 0], t.canvasBgAlpha = ["100", "100", "100", "100", "100"], t.canvasBgRatio = ["", "", "", "", ""], t.canvasBorderColor = ["545454", "545454", "415D6F", "845001", "68001B"], t.canvasBorderAlpha = [100, 100, 100, 90, 100], t.showShadow = [0, 1, 1, 1, 1], t.divLineColor = ["717170", "7B7D6D", "92CDD6", "965B01", "68001B"], t.divLineAlpha = [40, 45, 65, 40, 30], t.altHGridColor = ["EEEEEE", "D8DCC5", "99C4CD", "DEC49C", "FEC1D0"], t.altHGridAlpha = [50, 35, 10, 20, 15], t.altVGridColor = ["767575", "D8DCC5", "99C4CD", "DEC49C", "FEC1D0"], t.altVGridAlpha = [10, 20, 10, 15, 10], t.anchorBgColor = ["FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF"], t.toolTipBgColor = ["FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF"], t.toolTipBorderColor = ["545454", "545454", "415D6F", "845001", "68001B"], t.baseFontColor = ["555555", "60634E", "025B6A", "A15E01", "68001B"], t.borderColor = ["767575", "545454", "415D6F", "845001", "68001B"], t.borderAlpha = [50, 50, 50, 50, 50], t.legendBgColor = ["FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF"], t.legendBorderColor = ["545454", "545454", "415D6F", "845001", "D55979"], t.plotGradientColor = ["FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF"], t.plotBorderColor = ["333333", "8A8A8A", "FFFFFF", "FFFFFF", "FFFFFF"], t.plotFillColor = ["767575", "D8DCC5", "99C4CD", "DEC49C", "FEC1D0"], t.bgColor3D = ["FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF"], t.bgAlpha3D = ["100", "100", "100", "100", "100"], t.bgAngle3D = [90, 90, 90, 90, 90], t.bgRatio3D = ["", "", "", "", ""], t.canvasBgColor3D = ["DDE3D5", "D8D8D7", "EEDFCA", "CFD2D8", "FEE8E0"], t.canvasBaseColor3D = ["ACBB99", "BCBCBD", "C8A06C", "96A4AF", "FAC7BC"], t.divLineColor3D = ["ACBB99", "A4A4A4", "BE9B6B", "7C8995", "D49B8B"], t.divLineAlpha3D = [100, 100, 100, 100, 100], t.legendBgColor3D = ["F0F3ED", "F3F3F3", "F7F0E8", "EEF0F2", "FEF8F5"], t.legendBorderColor3D = ["C6CFB8", "C8C8C8", "DFC29C", "CFD5DA", "FAD1C7"], t.toolTipbgColor3D = ["FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF"], t.toolTipBorderColor3D = ["49563A", "666666", "49351D", "576373", "681C09"], t.baseFontColor3D = ["49563A", "4A4A4A", "49351D", "48505A", "681C09"], t.anchorBgColor3D = ["FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF", "FFFFFF"];
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    return Array.isArray(e);
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = {
    "*.*.*": {
      "*.disappearing": [{
        finalAttr: {
          opacity: 0
        },
        slot: "initial",
        callback: function callback() {
          this.hide();
        }
      }]
    }
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    var t = e.getChildren("canvas")[0],
        n = t.getChildren("axisRefVisualCartesian")[0],
        r = {
      zoomable: !0,
      pannable: !0
    },
        l = e._feedAxesRawData(),
        s = void 0,
        c = void 0,
        u = function u(e) {
      var t = e.sender;
      n.addexplicitDrawItems(t.getId(), t), n.asyncDraw();
    };

    (0, a.componentFactory)(e, i["default"], "yAxis", 1, l.yAxisConf), (0, a.componentFactory)(e, o["default"], "xAxis", 1, l.xAxisConf), s = e.getChildren("yAxis")[0], c = e.getChildren("xAxis")[0], s.setLinkedItem("canvas", t), c.setLinkedItem("canvas", t), n.setLinkedItem(s.getId(), s), n.setLinkedItem(c.getId(), c), n.addExtEventListener("visiblerangeset", u, c), n.addExtEventListener("visiblerangeset", u, s), t.attachAxis(c, !1, e.zoomX ? r : {}), t.attachAxis(s, !0, e.zoomY ? r : {}), e._setCategories();
  };
  var a = n(125),
      i = r(n(377)),
      o = r(n(422));

  function r(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = c(n(378)),
      i = n(125),
      o = c(n(398)),
      r = c(n(399)),
      l = n(386),
      s = c(n(421));

  function c(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function u(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var h = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.config.scale = new r["default"](), n;
    }

    return u(t, e), t.prototype.getName = function () {
      return "numeric";
    }, t.prototype.generateTicks = function () {
      var e = this.getScale(),
          t = this.config,
          n = t.numDivLines + 1,
          a = e.getDomain(),
          i = a[0],
          r = a[1],
          l = void 0,
          c = t.axisRange,
          u = c.min,
          h = c.max,
          d = t.dataLimit,
          p = void 0,
          f = void 0;
      return i === u && r === h ? ((0, s["default"])(d.min, d.max, e, t), t.ticks) : (l = e.ticks(n), p = Math.abs(l[1] - l[0]), i === u && -1 === l.indexOf(u) && l.unshift(u), r === h && -1 === l.indexOf(h) && l.push(h), (f = Math.abs(u % p)) && (u -= f), (f = Math.abs(h % p)) && (h -= f), t._allTicks = (0, o["default"])(u, h, p).concat(h), c.tickInterval = p, l);
    }, t.prototype.setTickValues = function (e) {
      this.config.userTicks = e || [], this.config.tickValues = {
        tickValue: []
      };
    }, t.prototype._parseTickValues = function (e) {
      var t,
          n,
          a,
          o,
          r = this.getFromEnv("chart"),
          s = this.config,
          c = e && e.length,
          u = 0;

      for (s.tickValues = {}, t = s.tickValues.tickValue = [], a = 0; a < c; a += 1) {
        if (n = (0, i.extend2)({}, e[a]), o = Number(n.x), !n.vline) {
          if ((0, l.extractStyleInfo)(n, r), !o && 0 !== o) continue;
          n.x = o, s.irregularCatAxis = !0, t.push(n), t[u].label = (0, i.parseUnsafeString)(t[u].label), u += 1;
        }
      }

      s.oriCatLen = u;
    }, t.prototype.calculateTicksOnLabelMode = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          l,
          s = this.config,
          c = s.xAxisLabelMode,
          u = Object.assign([], s.userTicks),
          h = this.getFromEnv("number-formatter");

      if ("mixed" === c || "auto" === c) {
        if (t = [], e = h.xAxis, "mixed" === c) for (n = 0, o = u.length; n < o; n += 1) {
          t[u[n].x || u[n].y || n] = !0;
        } else u = [];

        for (l = this.getAxisConfig(), r = s.ticks, a = 0; a < r.length; ++a) {
          t[n = r[a]] || u.push({
            label: i.BLANKSTRING + e.call(h, n),
            x: n,
            showverticalline: 0 === n ? l.showZeroPlane : 1,
            isNumeric: !0,
            linecolor: 0 === n ? l.zeroPlaneColor : l.divLineColor,
            linealpha: 0 === n ? l.zeroPlaneAlpha : l.divLineAlpha,
            linethickness: 0 === n ? l.zeroPlaneThickness : l.divLineThickness,
            linedashed: l.divLineIsDashed,
            linedashLen: l.divLineDashLen,
            linedashgap: l.divLineDashGap
          });
        }
      }

      this._parseTickValues(u);
    }, t.prototype.getInterval = function () {
      return this.config.axisRange.tickInterval;
    }, t.prototype._setAxisRange = function (e) {
      var t,
          n,
          a,
          o = e.min,
          r = e.max,
          l = this.config,
          c = l.axisRange,
          u = l.dataLimit,
          h = l.dependentInfo;
      if (!(o > r)) if (u.min === o && u.max === r || (n = !0), void 0 === l.visibleMin || l.setPadding || n) {
        var d = (0, i.extent)([o, r, u.min, u.max]);

        if (o = d[0], r = d[1], u.min = o, u.max = r, this.fireEvent("dataLimitSet", Object.assign({}, u)), h) {
          if (h.limit) {
            if (!(t = h.dataLimit)) return;
            var p = (0, i.extent)([o, r, t.min, t.max]);
            o = p[0], r = p[1], l.isDataLimitSet = !0;
          }

          if (h.count && void 0 === h.numDivLines) return;
        }

        (0, s["default"])(o, r, this.getScale(), l), a = l.isZeroTickForced ? 3 : 2, this.fireEvent("divlinesSet", l.ticks.length - a), l.tickValues && this.calculateTicksOnLabelMode(), this.setVisibleConfig(c.min, c.max);
      } else l.setPadding = !1;
    }, t;
  }(a["default"]);

  h.prototype.setDataLimit = l.setDataLimit, t["default"] = h;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(379),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  },
      r = n(125),
      l = n(386);

  function s(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var c = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.apply(this, arguments));
    }

    return s(t, e), t.prototype._getHMaxLabelDimention = function (e) {
      var t,
          n,
          a,
          o,
          l,
          s,
          c,
          u,
          h,
          d,
          p,
          f,
          g,
          m,
          b,
          v,
          y,
          x,
          C,
          k,
          w,
          S,
          _,
          L,
          P,
          A,
          N,
          E,
          F,
          O,
          T,
          D,
          M,
          I = this,
          R = I.config,
          V = I.getFromEnv("chart"),
          B = V.config,
          j = V.getFromEnv("smartLabel"),
          G = R.axisRange,
          H = R.labels,
          z = R.labelDisplay,
          W = R.slantLabel,
          q = H.style,
          U = R.maxLabelHeight,
          Y = I.getInterval(),
          X = R.staggerLines,
          K = R.labelStep,
          Z = B.canvasLeft,
          J = B.canvasRight,
          $ = X - 2,
          Q = G.max,
          ee = G.min,
          te = 0,
          ne = R.tickValues && R.tickValues.tickValue,
          ae = ne && ne.length,
          ie = V.distributedColumns,
          oe = 0,
          re = {
        text: r.UNDEF,
        width: 0,
        style: r.UNDEF
      },
          le = 0,
          se = 4,
          ce = r.stubFN,
          ue = r.stubFN,
          he = r.stubFN,
          de = {},
          pe = 0,
          fe = !1,
          ge = 0,
          me = !1,
          be = Number.POSITIVE_INFINITY,
          ve = R.ticks,
          ye = Number.POSITIVE_INFINITY;

      if (ie) for (v = 0; v < ae; v++) {
        ne[v + 1] ? ne[v].x && (ne[v].plotWidth = I.getPixel(ne[v + 1].x - ne[v].x) - I.getPixel(0)) : ne[v].plotWidth = I.getPixel(B.canvasRight - ne[v].x) - I.getPixel(0);
      }
      if (R.tickValues && (!ne || 0 === ne.length)) return {
        width: 0,
        height: 0
      };

      function xe(e, t) {
        switch (t.toLowerCase()) {
          case "left":
            return Math.abs(I._getCustomPixel(e));

          case "right":
            return Math.abs(B.width - I._getCustomPixel(e));
        }
      }

      if ("rotate" === z && (R.rotateLabels = 1), R.tickValues || (R.irregularCatAxis = !1), R.sWidthAdjstFactor = n = 0 === $ ? 1 : 1 === $ ? 1.5 : $, j.useEllipsesOnOverflow(B.useEllipsesWhenOverflow), j.setStyle({
        fontSize: q.fontSize,
        fontFamily: q.fontFamily,
        lineHeight: q.lineHeight,
        fontWeight: q.fontWeight
      }), R.irregularCatAxis) {
        for (ne.sort(function (e, t) {
          return e.x - t.x;
        }), v = 0, oe = ne.length; v < oe; v++) {
          if (l = ne[v], void 0 !== S) {
            if (ye = Math.abs(l.x - S), L = Math.abs(I._getCustomPixel(ee) - I._getCustomPixel(ee + ye)), j.setStyle(Object.assign({}, l.style)), L < 1.2 * j.getOriSize("W").width) {
              l.label = "", ye = be;
              continue;
            }

            P._individualIWR = L, l._individualIWL = L, be = ye;
          }

          P = l, S = l.x;
        }

        for (ye === Number.POSITIVE_INFINITY && (ye = Math.floor(Math.min(l.x, Q - l.x)), ye = Math.max(ye, 4)), v = 0, oe = ne.length; v < oe; v++) {
          l = ne[v], v || (l._individualIWL = Infinity), v === oe - 1 && (l._individualIWR = Infinity), l.individualIW = Math.min(l._individualIWL, l._individualIWR);
        }

        c = Math.abs(I._getCustomPixel(ee) - I._getCustomPixel(ee + ye)), c = Math.min(2 * xe(ne[0].x, "left"), 2 * xe(ne[oe - 1].x, "right"), c);
      } else c = Math.abs(I._getCustomPixel(ee) - I._getCustomPixel(ee + Y));

      if (e = U || e, de.__root__ = {
        getHeight: function getHeight(e) {
          var t = ne[e]._ovrStyle.lineHeight;
          return parseInt(t.replace(/(\d+)px/, "$1"), 10);
        },
        getWidth: function getWidth() {
          return e;
        },
        getCalculatedLabelStep: function getCalculatedLabelStep(e) {
          var t,
              n,
              a,
              i,
              o,
              l,
              h,
              d,
              p,
              f,
              g = 0,
              m = e.length,
              b = Number.NEGATIVE_INFINITY,
              v = {},
              y = 0;

          for (g = 0; g < m; g++) {
            (i = e[g]).style = i.style || {};
          }

          if (R.irregularCatAxis) return R.labelStep;

          for (g = 0; g < m; g++) {
            (i = e[g]) && (i.label || (i.label = ""), o = i.oriLabel || i.label, s = {
              fontSize: q.fontSize,
              fontFamily: q.fontFamily,
              lineHeight: q.lineHeight,
              fontWeight: q.fontWeight
            }, y++, i.style = i.style || {}, (0, r.extend2)(s, i.style), v[t = s.fontSize + s.fontFamily + s.lineHeight + s.fontWeight] ? o.length > v[t].label.length && (v[t].label = o) : v[t] = {
              label: o,
              style: s
            });
          }

          for (l in v) {
            v.hasOwnProperty(l) && (n = v[l].style, a = v[l].label, n.lineHeight = (0, r.setLineHeight)(n), j.setStyle(n), R.rotateLabels && (p = parseInt(n.lineHeight.replace(/(\d+)px/, "$1"), 10)), u = j.getSmartText(a, r.UNDEF, p), d = 0 === R.rotateLabels ? u.width > 60 ? 60 : u.width : u.height, b = Math.max(d, b));
          }

          return h = Math.floor(Math.abs(I._getCustomPixel(Q) - I._getCustomPixel(ee)) / b), f = Math.max(Math.ceil(y / h), R.labelStep), c = Math.abs(I._getCustomPixel(ee) - I._getCustomPixel(ee + f)), y <= h ? R.labelStep : f;
        }
      }, de._inProp = {}, de.getCopyById = function (e) {
        var t,
            n = this._inProp,
            a = this.__root__,
            i = n.copyStore;
        return (t = (i = i || {})[e]) ? t : ((0, r.extend2)(t = i[e] = {}, a), t);
      }, R.tickValues) {
        switch (z) {
          case "rotate":
            H.rotation = W ? 300 : 270, p = de.getCopyById("rotate");
            break;

          case "stagger":
            (p = de.getCopyById("stagger")).getHeight = function (e) {
              var t, n;
              return n = (t = R.tickValues.tickValue[e]) && t.style || (t.style = {}), s = {
                fontSize: q.fontSize,
                fontFamily: q.fontFamily,
                lineHeight: q.lineHeight,
                fontWeight: q.fontWeight
              }, (0, r.extend2)(s, n), j.setStyle(s), j.getOriSize(t.label).height;
            }, p.getWidth = function (e) {
              return se = 1, e.individualIW ? e.individualIW : 2 * c * n - se;
            }, he = function he(t) {
              var n,
                  a,
                  i,
                  o,
                  r,
                  l,
                  s = t.length,
                  c = 0;
              if (j.setStyle(q), i = j.getOriSize("WWW").height, a = t[s - 1], Math.floor(a._cumulativeSum) <= Math.ceil(s * (i + 2))) r = Math.floor(e / i), X = r - X < 0 ? r : X;else {
                r = Math.floor(e / (i + 4));

                do {
                  for (c = 0, o = (l = r) - 1, s = t.length; o < s;) {
                    if (s - o < r && (o = s - 1), ~~((n = t[o])._cumulativeSum - c) > -~e) {
                      fe = !0;
                      break;
                    }

                    fe = !1, c = n._cumulativeSum, o += l;
                  }
                } while (r-- && fe);

                r++, X = Math.min(X, r);
              }
              R.drawnStaggerLines = X;
            }, ce = function ce(e) {
              var t,
                  n,
                  i,
                  o,
                  r = 0;

              for (o = 0, n = e.length; o < n; o++) {
                (t = e[o]).stepSkipped || ((i = (t && t.style || {}).lineHeight) || (i = q.lineHeight), a = r++ % X, t.labelPadding = a ? i.replace(/px/i, "") * a : 0);
              }
            };
            break;

          case "none":
            (p = de.getCopyById("none")).getHeight = r.stubFN, p.getWidth = r.stubFN, ue = r.stubFN, R.rotateLabels && (H.rotation = W ? 300 : 270, _ = e), p.getCalculatedLabelStep = function () {
              return R.labelStep;
            };
            break;

          default:
            (p = de.getCopyById("auto")).getHeight = function () {
              return e;
            }, p.getWidth = function (e) {
              return e.individualIW ? e.individualIW : c - 2 * se;
            }, ue = function ue(e, t) {
              var n,
                  a,
                  i,
                  o,
                  l = V.getFromEnv("chart-attrib"),
                  s = (0, r.pluckNumber)(l && l.rotatelabels);

              if (!R.irregularCatAxis && (j.setStyle(e), j.getOriSize("WWW").width >= c && 0 !== s)) {
                for (H.rotation = W ? 300 : 270, H.forceRotate = !0, p = de.getCopyById("rotate"), h = p.getWidth, d = p.getHeight, re.width = 0, n = 0, a = t.length; n < a; n++) {
                  (i = t[n]) && (i.label || i.oriLabel) && 0 !== (0, r.pluckNumber)(i.showlabel, R.showLabels, 1) && !0 !== i.stepSkipped && (o = i._ovrStyle, j.setStyle({
                    fontSize: o.fontSize,
                    fontFamily: o.fontFamily,
                    lineHeight: o.lineHeight,
                    fontWeight: o.fontWeight
                  }), u = j.getSmartText(i.oriLabel, h(i), d(n)), i.label = u.text, i.labelTooltext = u.tooltext, i._sLabel = u, re.width < u.width && (re.text = u.text, re.width = u.width, re.height = u.height, re.style = o));
                }

                f = re.text;
              }
            };
        }

        for (h = p.getWidth, d = p.getHeight, K = R.labels.step = R.labelStep = R._oriLabelStep, K = R.labels.step = R.labelStep = p.getCalculatedLabelStep(ne), v = (0, i.minimumEnquiry)(ne), g = 0, y = 0, oe = ne.length; v < oe; v++, g++) {
          (l = ne[v]) && (l.label || l.oriLabel) && 0 !== (0, r.pluckNumber)(l.showlabel, R.showLabels, 1) && (me = !0, s = {
            fontSize: q.fontSize,
            fontFamily: q.fontFamily,
            lineHeight: q.lineHeight,
            fontWeight: q.fontWeight
          }, (0, r.extend2)(s, l.style), s.lineHeight = (0, r.setLineHeight)(s), (T = s.fontSize + s.fontFamily + s.lineHeight + s.fontWeight) !== O && (j.setStyle(s), O = T), g % K ? (l.stepSkipped = !0, l.appliedSmartLabel = !1, ge++) : (l.appliedSmartLabel = !0, l.stepSkipped = !1, l._ovrStyle = s, ne[v].plotWidth ? t = Math.max("rotate" === z ? ne[v].plotWidth - 6 : 0, d(v)) : ("rotate" === z ? v < oe - 1 && (o = I.getPixel(v + 1) - I.getPixel(v) - 10) : o = 0, "rotate" === z && isNaN(+o) && (o = B.canvasWidth / I.getVisibleLength() - 3), t = Math.max(o, d(v))), pe += (u = j.getSmartText(l.oriLabel || l.label, h(l), t)).height + 2, I.components.labels[y++] = {
            config: {
              width: u.width,
              height: u.height,
              props: {
                label: {}
              }
            }
          }, l._cumulativeSum = pe, l.oriLabel = l.oriLabel || l.label, l.label = u.text, l.labelTooltext = u.tooltext, l._sLabel = u, re.width < u.oriTextWidth && ((0, r.extend2)(re, u), re.style = s), le < u.height && (le = u.height)));
        }

        if (!me) return {
          height: 0,
          width: 0
        };
        if (he(ne, ge), ce(ne, ge), ue(re.style, ne), f = re.text || "", "mixed" === R.xAxisLabelMode) for (k = R.isPercent ? V.getFromEnv("number-formatter").percentValue : V.getFromEnv("number-formatter").xAxis, te = f.length, v = 0, D = ve && ve.length; v < D; ++v) {
          C = ve[v], (x = "" + k.call(V.getFromEnv("number-formatter"), C, R.axisIndex)).length > te && (f = x, te = x.length);
        }

        for (re.height = Math.max(le, re.height || 0), E = ne.length, v = 0, oe = ne.length; v < oe && !(A = ne[v])._sLabel; v++) {
          ;
        }

        for (v = (oe = ne.length) - 1; v >= 0 && !(N = ne[v])._sLabel; v--) {
          ;
        }

        F = 1 !== I.getZoom(), H.rotation || F || !A._sLabel ? (R.axisEndLabelDisplaySpace.left = 0, R.axisEndLabelDisplaySpace.right = 0) : (R.axisEndLabelDisplaySpace.left = Math.max(Z - (I._getCustomPixel(A.x || 0) - A._sLabel.width / 2), 0), R.axisEndLabelDisplaySpace.right = Math.max(I._getCustomPixel(N.x || E - 1) + N._sLabel.width / 2 - J, 0)), w = re;
      } else {
        for (k = R.numberFormatterFn ? V.getFromEnv("number-formatter")[R.numberFormatterFn] : R.isPercent ? V.getFromEnv("number-formatter").percentValue : V.getFromEnv("number-formatter").xAxis, v = 0, D = ve && ve.length; v < D; ++v) {
          M = ve[v], C = (0, r.toPrecision)(M, 10), x = "" + k.call(V.getFromEnv("number-formatter"), C, R.axisIndex), M === ee && (m = x), M === Q && (b = x), w = j.getOriSize(x), I.components.labels[v] = {
            config: {
              width: w.width,
              height: w.height,
              props: {
                label: {}
              }
            }
          }, x.length > te && (f = x, te = x.length);
        }

        j.setStyle({
          fontSize: q.fontSize,
          fontFamily: q.fontFamily,
          lineHeight: q.lineHeight,
          fontWeight: q.fontWeight
        }), w = j.getOriSize(f || ""), "rotate" === z && (H.rotation = 270), R.rotateLabels && (H.rotation = W ? 300 : 270), H.rotation || (m = j.getOriSize(m || ""), b = j.getOriSize(b || ""), R.axisEndLabelDisplaySpace.left = m.width / 2 + 2, R.axisEndLabelDisplaySpace.right = b.width / 2 + 2);
      }

      return R.tickValues && "stagger" === z && (w.height = X * re.height), w.width = _ ? Math.min(_, w.width) : w.width, w.width = (0, r.pluckNumber)(w.width), w.maxWidth = (0, r.pluckNumber)(w.maxWidth), w;
    }, t.prototype._getVMaxLabelDimention = function (e) {
      var t,
          n,
          a,
          i,
          o,
          l,
          s,
          c,
          u,
          h,
          d,
          p,
          f,
          g,
          m = this.config,
          b = this.getFromEnv("chart"),
          v = b.config,
          y = b.getFromEnv("smartLabel"),
          x = m.labels.style,
          C = m.useEllipsesWhenOverflow,
          k = m.maxLabelWidthPercent,
          w = m.minLabelWidthPercent,
          S = 0,
          _ = b.getFromEnv("dataSource").categories,
          L = {
        height: 0,
        width: 0
      },
          P = m.ticks,
          A = {};

      if (y.useEllipsesOnOverflow(v.useEllipsesWhenOverflow), y.setStyle({
        fontSize: x.fontSize,
        fontFamily: x.fontFamily,
        lineHeight: x.lineHeight,
        fontWeight: x.fontWeight
      }), m.tickValues) {
        for (_ && (A = {
          fontFamily: _[0].font,
          fontSize: _[0].fontsize,
          color: _[0].fontcolor
        }), k && (n = k / 100 * v.width) < e && (e = n), w && (a = w / 100 * v.width) > e && (e = a), i = 0, u = (c = m.tickValues.tickValue).length; i < u; i++) {
          h = c[i], 0 !== (0, r.pluckNumber)(h.showlabel, m.showLabels) && (f = {
            fontFamily: (0, r.pluck)(h.font, h.labelfont, A.fontFamily, x.fontFamily),
            fontSize: (0, r.pluck)(h.fontsize, h.labelfontsize, A.fontSize, x.fontSize).replace(/px/i, "") + "px",
            fontWeight: "normal" == x.fontWeight ? (0, r.pluckNumber)(h.fontbold, h.labelfontbold, 0) ? "bold" : "normal" : x.fontWeight,
            fontStyle: "normal" == x.fontStyle ? (0, r.pluckNumber)(h.fontitalic, h.labelfontitalic, 0) ? "italic" : "normal" : x.fontStyle
          }, (g = {
            fontFamily: (0, r.pluck)(f.fontFamily, A.fontFamily, x.fontFamily),
            fontSize: (0, r.pluck)(f.fontSize, A.fontSize, x.fontSize),
            fontWeight: (0, r.pluck)(f.fontWeight, x.fontWeight),
            fontStyle: (0, r.pluck)(f.fontStyle, x.fontStyle)
          }).lineHeight = (0, r.setLineHeight)(g), y.setStyle(g), d = y.getSmartText(h.oriLabel || h.label, e, x.lineHeight, C), this.components.labels[i] = {
            config: {
              width: d.width,
              height: d.height,
              props: {
                label: {}
              }
            }
          }, h.oriLabel = h.oriLabel || h.label, h.label = s = d.text, h.labelTooltext = d.tooltext, d.width > S && (L = d, S = d.width));
        }

        return L;
      }

      for (p = m.numberFormatterFn ? b.getFromEnv("number-formatter")[m.numberFormatterFn] : m.isPercent ? b.getFromEnv("number-formatter").yAxisPercentValue : b.getFromEnv("number-formatter").yAxis, i = 0, o = P && P.length; i < o; ++i) {
        l = (0, r.toPrecision)(P[i], 10), s = "" + p.call(b.getFromEnv("number-formatter"), l, m.axisIndex), d = y.getSmartText(s), this.components.labels[i] = {
          config: {
            width: d.width,
            height: d.height,
            props: {
              label: {}
            }
          }
        }, s.length > S && (t = s, S = s.length);
      }

      return y.getOriSize(t);
    }, t.prototype.getCleanValue = function (e, t) {
      return this.getFromEnv("number-formatter").getCleanValue(e, t);
    }, t.prototype.generateMinorTicks = function () {
      if (this) return [];
    }, t.prototype.setCanvas = function (e) {
      this.config.canvas = e;
    }, t.prototype._adjustNumberFormatter = function (e) {
      var t,
          n,
          a = this.config,
          i = a.axisIndex,
          o = a.isVertical,
          l = this.getFromEnv("chart").getFromEnv("number-formatter"),
          s = a._defaultDecimalPrecision,
          c = a._defaultForceDecimal,
          u = 0;
      n = o || "yAxis" === a.numberFormatterFn ? (l.Y[i] || l.Y[0]).yAxisLabelConf : l.paramX, s !== r.UNDEF ? n.decimalprecision = s : a._defaultDecimalPrecision = n.decimalprecision, c !== r.UNDEF ? n.forcedecimals = c : a._defaultForceDecimal = n.forcedecimals, parseInt(e, 10) > 0 || (t = e.toString().split(".")[1]) && ((u = t.match(/^[0]*/)[0].length + 1) > n.decimalprecision && (n.forcedecimals = 1), n.decimalprecision = Math.max(u, n.decimalprecision));
    }, t.prototype.setLabelConfig = function (e) {
      var t,
          n = this.config.labels;

      for (t in e) {
        e.hasOwnProperty(t) && (n[t] = e[t]);
      }
    }, t;
  }(o["default"]);

  c.prototype._parseLabel = l._parseLabel, c.prototype._drawLabel = l._drawLabel, c.prototype.getTrendLineLimits = l.getTrendLineLimits, c.prototype.setAxisPadding = l.setAxisPadding, c.prototype.getLabel = l.getLabel, t["default"] = c;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.minimumEnquiry = t.getCrispPath = undefined;
  var a = d(n(380)),
      i = n(125),
      o = d(n(381)),
      r = d(n(382)),
      l = d(n(383)),
      s = d(n(384)),
      c = n(132),
      u = n(229),
      h = n(386);

  function d(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function p(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var f = function f(e, t) {
    var n,
        a,
        i = !1,
        o = t % 2;
    return e[1] === e[4] && (n = e[1], a = Math.round(n), e[1] = e[4] = o ? a > n ? a - .5 : a + .5 : a, i = !0), e[2] === e[5] && (n = e[2], a = Math.round(n), e[2] = e[5] = o ? a > n ? a - .5 : a + .5 : a, i = !0), {
      path: e,
      isCrisped: i
    };
  },
      g = function g(e) {
    return function (t, n) {
      return !!(e.minValue <= t && e.maxValue >= t || e.minValue <= n && e.maxValue >= n);
    };
  },
      m = function m(e) {
    return function (t) {
      return !!(e.minValue <= t && e.maxValue >= t);
    };
  },
      b = {
    wrtVisible: !0
  },
      v = function v(e) {
    for (var t = 0, n = e.length; t < n; t++) {
      if (e[t].label || e[t].oriLabel) return t;
    }
  };

  (0, c.addDep)({
    name: "cartesianAxisAnimation",
    type: "animationRule",
    extension: o["default"]
  });

  var y = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.config.referenceInfo = [], n.config.prevTicks = [], n.config.prevIntervalArr = [], n.config.prevTrendLabels = [], n.config.prevCategoryIntervalArr = [], n;
    }

    return p(t, e), t.prototype.configureAttributes = function (t) {
      e.prototype.configureAttributes.call(this, t);
    }, t.prototype.placeAxis = function (e) {
      var t,
          n = this.getScale(),
          a = this.getFromEnv("chart"),
          i = this.getChildren("scrollBar") && this.getChildren("scrollBar")[0],
          o = this.config.isVertical,
          r = this.config.isOpposit,
          l = this.config.isReverse,
          s = a.config,
          c = {};
      return i && !i.getState("removed") && (t = i.getLogicalSpace()) && (o ? (a.config.shift = t.width + i.config.conf.padding, c[r ? "right" : "left"] = a.config.shift) : (a.config.shift = t.height + i.config.conf.padding, c[r ? "top" : "bottom"] = a.config.shift), a._allocateSpace(c)), o ? (l ? n.setRange([s.canvasBottom, s.canvasTop]) : n.setRange([s.canvasTop, s.canvasBottom]), this._placeVerticalAxis(e)) : (l ? n.setRange([s.canvasRight, s.canvasLeft]) : n.setRange([s.canvasLeft, s.canvasRight]), this._placeHorizontalAxis(e));
    }, t.prototype._placeVerticalAxis = function (e) {
      var t,
          n,
          a,
          o,
          r,
          l,
          s,
          c,
          u,
          h,
          d,
          p,
          f,
          g,
          m,
          b,
          v,
          y,
          x = this.config,
          C = this.getFromEnv("chart"),
          k = C.config,
          w = C.getFromEnv("smartLabel"),
          S = x.axisRange,
          _ = x.minLabelWidthPercent,
          L = x.name,
          P = x.isOpposit,
          A = this.getFromEnv("number-formatter"),
          N = k.canvasHeight,
          E = x.labelPadding = (0, i.pluckNumber)(x.rawAttr.axisValuePadding, 4),
          F = (0, i.pluckNumber)(x.rawAttr.axisNamePadding, 5),
          O = x.useEllipsesWhenOverflow,
          T = x.name.style,
          D = x.trend.trendStyle,
          M = x.axisName,
          I = x.trendLines,
          R = x.drawLabelsOpposit,
          V = x.drawAxisNameOpposit,
          B = 0,
          j = 0,
          G = 0,
          H = 0,
          z = 0,
          W = 0,
          q = {
        left: 0,
        right: 0
      },
          U = "",
          Y = "",
          X = 0,
          K = -1;

      if (_ && (K = _ / 100 * k.width), x.oriCanvasHeight = N, E < 0 && (x.labelPadding = 2), b = x.drawTick && x.tickLength ? x.axisLineThickness + x.tickLength : x.axisLineThickness, x.showAxisLine ? (x.labelPadding = (0, i.pluckNumber)(E, 2) + b, x.labelPadding < 0 && (x.labelPadding = (x.axisLineThickness < 0 ? 0 : b) + 2), e -= x.axisLineThickness) : (x.labelPadding = (0, i.pluckNumber)(E, 2), x.labelPadding < 0 && (x.labelPadding = 2)), u = S.max, h = S.min, x.name.rotation = 0, x.labels.step = x.labelStep, x.labels.isDraw = 1, x.labels.drawNormalVal = x.showDivLineValues, x.labels.drawLimitVal = x.showLimits, X = T.lineHeight, X = Number(X.replace(/px/i, "")), M && X < e && (e -= X), 1 !== x.showLimits && 1 !== x.showDivLineValues && (x.labels.isDraw = 0), ((p = x.drawLabels ? this._getVMaxLabelDimention(e - x.labelPadding) : {
        width: 0,
        height: 0
      }).width + x.labelPadding > e && !x.tickValues || 0 === p.width) && (x.labels.isDraw = 0), x.labels.isDraw && (x.labelMaxW = p.width > K ? p.width : K, x.labelMaxH = p.height, G = B = x.labelMaxW + x.labelPadding), x.drawTrendLines && x.drawTrendLabels && I && I.length) {
        for (o = x.isPercent ? A.percentValue : x.isVertical ? A.yAxis : A.xAxis, w.useEllipsesOnOverflow(k.useEllipsesWhenOverflow), w.setStyle({
          fontSize: D.fontSize,
          fontFamily: D.fontFamily,
          lineHeight: D.lineHeight,
          fontWeight: D.fontWeight
        }), t = 0, n = I.length; t < n; t += 1) {
          for (c = 0, f = I[t].line && I[t].line.length; c < f; c += 1) {
            g = I[t].line[c], v = A.getCleanValue((0, i.pluck)(g.startvalue, g.value, 0)), y = (0, i.pluckNumber)(g.endvalue, v), v <= u && v >= h && y <= u && y >= h && (x.isOpposit && (g.valueonright = 1), s = 1 === (m = (0, i.pluckNumber)(g.valueonright, 0)) ? g.endvalue || g.startvalue : g.startvalue || g.endvalue, (d = (0, i.parseUnsafeString)(g.origText || g.displayvalue || s || "")) === s && (d = "" + o.call(A, d)), m ? d.length > Y.length && (Y = d) : d.length > U.length && (U = d));
          }
        }

        for (W = (p = w.getOriSize(Y)).width + x.labelPadding, z = (p = w.getOriSize(U)).width + x.labelPadding, P ? (W > G && W > e && (W = e), z > e - (G = Math.max(G, W + x.labelPadding)) && (z = Math.min(z, e - G))) : (z > G && z > e && (z = e), W > e - (G = Math.max(G, z + x.labelPadding)) && (W = Math.min(W, e - G))), t = 0, n = I.length; t < n; t += 1) {
          for (c = 0, f = I[t].line && I[t].line.length; c < f; c += 1) {
            g = I[t].line[c], v = A.getCleanValue((0, i.pluck)(g.startvalue, g.value, 0)), y = (0, i.pluckNumber)(g.endvalue, v), d = 1 === Number(g.valueonright) ? g.origText || g.displayvalue || "" + y || "" : g.origText || g.displayvalue || "" + v || "", (d = (0, i.parseUnsafeString)("" + d)) !== g.endvalue && d !== g.startvalue || (d = "" + o.call(A, d)), g.origText = d, l = (m = (0, i.pluckNumber)(g.valueonright, 0)) ? w.getSmartText(d, W, C.canvasHeight, O) : w.getSmartText(d, G, C.canvasHeight, O), (a = x.parsedTrendLabels[j++]) && (a.attr.text = g.displayvalue = l.text, x.isOpposit && (a.valueOnRight = 1, a.attr["text-anchor"] = i.POSITION_START)), l.tooltext ? (g.valueToolText = l.tooltext, a && (a.valueToolText = g.valueToolText)) : (delete g.valueToolText, a && delete a.valueToolText);
          }
        }
      }

      return e += X, !x.drawAxisName || e - G - W <= 0 || "" === M ? (L.isDraw = !1, L.value = "") : (w.setStyle({
        fontSize: T.fontSize,
        fontFamily: T.fontFamily,
        lineHeight: T.lineHeight,
        fontWeight: T.fontWeight
      }), L.isDraw = !0, x.rotateAxisName ? (x.name.rotation = P ? 90 : 270, r = w.getSmartText(M, N, e - G - W), L.value = M, x.nameMaxW = Math.min(r.height), H = x.nameMaxW + F) : (r = w.getSmartText(M, e - G - W, N), L.value = M, x.nameMaxW = Math.min(r.width, e - G), x.nameMaxH = r.height, x.axisNameWidth >= 0 && (x.nameMaxW = Math.min(x.nameMaxW, x.axisNameWidth)), H = x.nameMaxW + F)), P ? (R ? (q.left += Math.max(B, z), q.right += W) : (q.left += z, q.right += Math.max(B, W)), V ? (x.axisNamePadding = q.left + F, q.left += H) : (x.axisNamePadding = q.right + F, q.right += H)) : (R ? (q.left += z, q.right += Math.max(B, W)) : (q.left += Math.max(B, z), q.right += W), V ? (x.axisNamePadding = q.right + F, q.right += H) : (x.axisNamePadding = q.left + F, q.left += H)), L.isDraw && x.axisNamePadding + x.nameMaxW > e && (x.axisNamePadding = e - x.nameMaxW, H = x.nameMaxW + x.axisNamePadding - G), q;
    }, t.prototype._placeHorizontalAxis = function (e) {
      var t,
          n,
          a,
          o,
          r,
          l,
          s,
          c,
          u,
          h,
          d,
          p,
          f,
          g,
          m,
          b,
          v,
          y,
          x = this.config,
          C = this.getFromEnv("chart"),
          k = C.config,
          w = C.getFromEnv("smartLabel"),
          S = x.axisRange,
          _ = x.name,
          L = x.isOpposit,
          P = C.getFromEnv("number-formatter"),
          A = x.drawLabelsOpposit,
          N = x.drawAxisNameOpposit,
          E = 0,
          F = k.canvasWidth,
          O = x.labelPadding = (0, i.pluckNumber)(x.rawAttr.axisValuePadding, 4),
          T = (0, i.pluckNumber)(x.rawAttr.axisNamePadding, 5),
          D = x.useEllipsesWhenOverflow,
          M = x.name.style,
          I = x.trend.trendStyle,
          R = x.axisName,
          V = x.vTrendLines,
          B = 0,
          j = 0,
          G = 0,
          H = {
        top: 0,
        bottom: 0
      },
          z = 0,
          W = 0;
      if (O < 0 && (x.labelPadding = 2), b = x.drawTick && x.tickLength ? x.axisLineThickness + x.tickLength : x.axisLineThickness, x.showAxisLine ? (x.labelPadding = (0, i.pluckNumber)(O, 2) + b, x.labelPadding < 0 && (x.labelPadding = (x.axisLineThickness < 0 ? 0 : b) + 2), e -= x.axisLineThickness) : (x.labelPadding = (0, i.pluckNumber)(O, 2), x.labelPadding < 0 && (x.labelPadding = 2)), s = S.max, c = S.min, x.labels.rotation = 0, x.labels.step = x.labelStep, x.labels.isDraw = 1, x.labels.drawNormalVal = x.showDivLineValues, x.labels.drawLimitVal = x.showLimits, W = M.lineHeight, W = Number(W.replace(/px/i, "")), R && W < e && (e -= W), x.rotateLabels && "stagger" !== x.labelDisplay && "none" !== x.labelDisplay && (x.labelDisplay = "rotate"), 1 !== x.showLimits && 1 !== x.showDivLineValues && (x.labels.isDraw = 0), g = x.drawLabels ? this._getHMaxLabelDimention(e - x.labelPadding) : {
        width: 0,
        height: 0
      }, x.labels.rotation ? g.width + x.labelPadding > e && !x.tickValues && (x.labels.isDraw = 0) : g.height + x.labelPadding > e && !x.tickValues && (x.labels.isDraw = 0), x.labels.isDraw && (x.labels.rotation ? (x.labelMaxW = g.height, x.labelMaxH = g.width, E = g.width + x.labelPadding) : (x.labelMaxW = g.width, x.labelMaxH = g.height, E = g.height + x.labelPadding), B = E), d = (B = Math.max(B, x.labelPadding)) <= e ? e - B : e, x.drawTrendLines && x.drawTrendLabels && V && x.isActive) for (m = x.isPercent ? this.getFromEnv("number-formatter").percentValue : x.isVertical ? this.getFromEnv("number-formatter").yAxis : this.getFromEnv("number-formatter").xAxis, w.useEllipsesOnOverflow(k.useEllipsesWhenOverflow), w.setStyle({
        fontSize: I.fontSize,
        fontFamily: I.fontFamily,
        lineHeight: I.lineHeight,
        fontWeight: I.fontWeight
      }), n = 0, a = V.length; n < a; n += 1) {
        for (l = 0, h = V[n].line && V[n].line.length; l < h; l += 1) {
          p = V[n].line[l], v = P.getCleanValue((0, i.pluck)(p.startvalue, p.value, 0)), y = (0, i.pluckNumber)(p.endvalue, v), v <= s && v >= c && y <= s && y >= c && (t = 1 === (0, i.pluckNumber)(p.valueonright, 0) ? p.endvalue || p.startvalue : p.startvalue || p.endvalue, (u = (0, i.parseUnsafeString)(p.origText || p.displayvalue || t || "")) === t && (u = "" + m.call(C.getFromEnv("number-formatter"), u)), p.origText = u, d - ((f = w.getSmartText(u, C.canvasWidth, I.lineHeight, D)).height + 2) < 0 ? p.displayvalue = "" : ((o = x.parsedTrendLabels[j++]) && (o.attr.text = p.displayvalue = f.text), z = z < f.height ? f.height : z), f.tooltext ? (p.valueToolText = f.tooltext, o && (o.valueToolText = p.valueToolText)) : (delete p.valueToolText, o && delete o.valueToolText));
        }
      }
      return d -= z, B += z, d += W, e += W, !x.drawAxisName || d <= 0 || "" === R ? (_.isDraw = !1, _.value = "") : (w.setStyle({
        fontSize: M.fontSize,
        fontFamily: M.fontFamily,
        lineHeight: M.lineHeight,
        fontWeight: M.fontWeight
      }), _.isDraw = !0, r = w.getSmartText(R, F, d), _.value = R, x.nameMaxW = F, x.nameMaxH = r.height, G = r.height + T, x.axisNamePadding = T + B, x.axisNamePadding + r.height > e && (x.axisNamePadding = e - r.height, G = r.height + x.axisNamePadding - B)), L ? (A ? H.bottom += E + z : (H.top += E, H.bottom += z), x.trendBottomPadding = H.bottom - z + 2, N ? H.bottom += G : H.top += G) : (A ? (H.top += E, H.bottom += z) : H.bottom += E + z, x.trendBottomPadding = H.bottom - z + 2, N ? H.top += G : H.bottom += G), H;
    }, t.prototype._parseCategoryPlotLine = function () {
      var e,
          t,
          n,
          a = this.config,
          o = a.axisRange,
          r = a.tickValues.tickValue,
          l = (0, i.convertColor)(a.divLineColor, a.divLineAlpha),
          s = a.divLineThickness,
          c = a.divLineIsDashed ? (0, i.getDashStyle)(a.divLineDashLen, a.divLineDashGap, s) : i.DASH_DEF,
          u = m(this.getVisibleConfig()),
          h = a._allTicks,
          d = h.length;
      if (e = {
        stroke: l,
        "stroke-width": s,
        "stroke-dasharray": c
      }, (!r[0] || r[0].x === i.UNDEF && r[0].y === i.UNDEF) && a.lines.isDraw && a.categoryNumDivLines) for (t = 0; t < d; ++t) {
        u(n = h[t]) && n !== o.min && n !== o.max && this.setReferenceInfo({
          from: n,
          type: "line",
          layer: 1,
          attr: e
        });
      }
    }, t.prototype._drawComponents = function () {
      var e = this.config;
      e.drawAxisName && this._drawAxisName(), e.drawAxisLine && this._drawAxisLine(), e.tickValues ? e.drawLabels && this._drawCategory() : e.drawLabels && this._drawLabel(), e.drawTrendLines && this.drawTrendLabel();
    }, t.prototype.drawTrendLabel = function () {
      var e,
          t = this.config,
          n = t.parsedTrendLabels,
          a = this.getFromEnv("animationManager"),
          o = this.getFromEnv("toolTipController"),
          r = t.axisTrendLabelContainer,
          l = t.isOpposit,
          c = t.labelPadding,
          u = t.vTrendLines,
          h = t.trendLines,
          d = t.axisDimention,
          p = this.getVisibleConfig(),
          f = p.minValue,
          g = p.maxValue,
          m = void 0,
          v = void 0,
          y = void 0,
          x = void 0,
          C = void 0,
          k = void 0,
          w = void 0,
          S = void 0,
          _ = void 0,
          L = !0,
          P = void 0,
          A = void 0,
          N = void 0,
          E = void 0,
          F = void 0,
          O = void 0;

      for (F = 0, O = n.length; F < O; F++) {
        n[F].id = F + "_trend";
      }

      for (u ? x = l ? d.opposite - (t.trendBottomPadding || 0) : d.y + (t.trendBottomPadding || 0) : (x = l ? d.opposite + (c || 0) : d.x - (c || 0), C = l ? d.x + (c || 0) : d.opposite + (c || 0)), F = 0, O = (e = (0, s["default"])(function (e, t) {
        return e.attr.text === t.attr.text;
      }, t.prevTrendLabels, n)).length; F < O; F++) {
        (N = this.getGraphicalElement(e[F].id)) && this.removeGraphicalElement(N);
      }

      if (t.prevTrendLabels = (0, i.extend2)([], n), t.drawTrendLabels) for (F = 0, O = n.length; F < O; F++) {
        v = n[F], y = this.getGraphicalElement(F + "_trend"), w = +v.from, _ = +v.to, L = !0, (E = !isNaN(_)) ? (f > (S = w + (_ - w) / 2) || g < S) && (L = !1) : (f > w || g < w) && (L = !1), L ? (u ? (P = this.getPixel(w, b), A = _ ? this.getPixel(_, b) : 0, k = (0, i.pluckNumber)(v.isTrendZone, t.isTrendZone, 1), E && _ !== w && k ? (v.attr.x = P + (A - P) / 2, v.attr.y = x) : (v.attr.x = _ ? A : P, v.attr.y = x)) : h && (P = this.getPixel(w, b), A = _ ? this.getPixel(_, b) : 0, m = (0, i.pluckNumber)(v.valueOnRight, 0), k = (0, i.pluckNumber)(v.isTrendZone, t.isTrendZone, 0), E && _ !== w && k ? (v.attr.x = m ? C : x, v.attr.y = P + (A - P) / 2) : (v.attr.x = m ? C : x, v.attr.y = _ && m ? A : P)), y = this.addGraphicalElement(F + "_trend", a.setAnimation({
          container: r,
          el: y || "text",
          attr: v.attr,
          css: v.css,
          data: {
            value: S || w
          },
          component: this,
          label: "text"
        })), t.showTooltip && v.valueToolText ? o.enableToolTip(y, v.valueToolText) : o.disableToolTip(y)) : y && this.removeGraphicalElement(y);
      } else for (F = 0, O = n.length; F < O; F++) {
        (N = this.getGraphicalElement(n[F].id)) && this.removeGraphicalElement(N);
      }
    }, t.prototype._drawAxisName = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          l = this.config,
          s = this.getFromEnv("toolTipController"),
          c = this.getLinkedItem("canvas").getEffectiveDimensions(),
          u = this.getFromEnv("animationManager"),
          h = c.left,
          d = c.top,
          p = c.width,
          f = c.height,
          g = d + f,
          m = h + p,
          b = this.getFromEnv("chart").config,
          v = l.name.style,
          y = l.name.value,
          x = l.isOpposit,
          C = l.isVertical,
          k = this.getFromEnv("smartLabel"),
          w = l.axisNameContainer,
          S = l.axisNamePadding,
          _ = l.nameMaxH,
          L = l.nameMaxW,
          P = l.axisDimention,
          A = C ? P.x : P.y,
          N = P.opposite,
          E = this.getGraphicalElement("axisName"),
          F = (0, i.pluckNumber)(l.name.rotation, C ? 90 : 270),
          O = this.getFromEnv("paper"),
          T = {
        fontFamily: v.fontFamily,
        fontSize: v.fontSize,
        lineHeight: v.lineHeight,
        fontWeight: v.fontWeight,
        fontStyle: v.fontStyle
      };
      l.name.isDraw ? (e = {
        fontFamily: v.fontFamily,
        fill: v.color,
        "vertical-align": "middle",
        "font-size": v.fontSize,
        "line-height": v.lineHeight
      }, k.useEllipsesOnOverflow(b.useEllipsesWhenOverflow), k.setStyle({
        fontSize: v.fontSize,
        fontFamily: v.fontFamily,
        lineHeight: v.lineHeight,
        fontWeight: v.fontWeight
      }), l.drawAxisNameOpposit && (x = !x, A = N), C ? (S = Math.max(S, function (e, t) {
        var n = 0;
        return e.relativeAxis && e.relativeAxis.config && e.relativeAxis.config.axisNamePadding && (n = Math.max(e.relativeAxis.config.axisNamePadding, n)), e.isOpposit && t.canvasMarginRight && (n = Math.max(n, t.canvasMarginRight - t.marginLeft - e.nameMaxW)), !e.isOpposit && t.canvasMarginLeft && (n = Math.max(n, t.canvasMarginLeft - t.marginRight - e.nameMaxW)), n;
      }(l, b)), a = l.axisNameAlignCanvas || b.captionalignment && "left" === b.captionalignment ? f : Math.max(f, l.oriCanvasHeight || 0), F ? (n = (t = k.getSmartText(y, a, L)).tooltext, o = t.width) : (n = (t = k.getSmartText(y, L, a)).tooltext, o = t.height), r = l.drawAxisNameFromBottom ? g - o / 2 : o > f ? b.height / 2 : d + f / 2, e.text = t.text, e.x = x ? (A || m) + S + L / 2 : (A || h) - S - L / 2, e.y = r) : (n = (t = k.getSmartText(y, p, _)).tooltext, x && b.canvasMarginTop && (S = Math.max(S, b.canvasMarginTop - b.marginTop - _)), !x && b.canvasMarginBottom && (S = Math.max(S, b.canvasMarginBottom - b.marginBottom - _)), e.text = t.text, e.x = h + p / 2, e.y = x ? (A || d) - S - _ / 2 : (A || g) + S + _ / 2), e["text-bound"] = "" === t.text ? [] : [v.backgroundColor, v.borderColor, v.borderColor ? v.borderThickness : 0, v.borderPadding, v.borderRadius, v.borderDash], e.transform = O.getSuggestiveRotation(C ? F : 0, e.x, e.y), E = this.addGraphicalElement("axisName", u.setAnimation({
        css: T,
        el: E || "text",
        attr: e,
        container: w,
        component: this,
        label: "text"
      })), l.showTooltip ? s.enableToolTip(E, n) : s.disableToolTip(E)) : E && this.removeGraphicalElement(E);
    }, t.prototype._drawAxisLine = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          s,
          c,
          u,
          h,
          d,
          p,
          g,
          m,
          v,
          y,
          x,
          C,
          k = this.config,
          w = k.isVertical,
          S = k.isOpposit,
          _ = this.getFromEnv("chart"),
          L = this.getLinkedItem("canvas").getEffectiveDimensions(),
          P = this.getFromEnv("animationManager"),
          A = L.top,
          N = L.left,
          E = A + L.height,
          F = N + L.width,
          O = k.axisDimention,
          T = w ? O.x : O.y,
          D = k.drawAxisLineWRTCanvas,
          M = _.getFromEnv("dataSource").chart,
          I = k.axisAxisLineContainerBottom,
          R = this.getGraphicalElement("axisLine"),
          V = [];

      if (a = 1 === (0, i.pluckNumber)(M.showyaxisline, M.showyaxisline) ? (0, i.pluckNumber)(M.yaxislinethickness, M.pyaxislinethickness, 1) : 0, k.showAxisLine) {
        if (w ? (o = S ? (T = D ? F : T) + k.axisLineThickness / 2 : (T = D ? N : T) - k.axisLineThickness / 2, n = (y = f(["M", o, E, "L", o, A], k.axisLineThickness)).path) : (o = S ? (T = D ? A : T) - k.axisLineThickness / 2 : (T = D ? E : T) + k.axisLineThickness / 2, n = (y = f(["M", N - a, o, "L", F, o], k.axisLineThickness)).path), c = {
          path: n,
          stroke: k.axisLineColor,
          "stroke-linecap": "butt",
          "stroke-width": k.axisLineThickness,
          "shape-rendering": y.isCrisped ? "crisp" : i.UNDEF
        }, k.drawTick && k.tickLength) for (e = {
          stroke: k.tickColor,
          "stroke-width": k.tickWidth
        }, r = w ? S ? o + k.tickLength : o - k.tickLength : S ? o - k.tickLength : o + k.tickLength, v = 0, C = (x = k.tickValues ? k.tickValues.tickValue.map(function (e) {
          return w ? e.y : e.x;
        }) : k.ticks).length; v < C; v += 1) {
          g = (p = x[v]) + "_tick", h = this.getGraphicalElement(g), s = this.getPixel(p, b), e.path = f(w ? ["M", o, s, "L", r, s] : ["M", s, o, "L", s, r], k.tickWidth).path, u = P.setAnimation({
            el: h || "path",
            attr: e,
            data: {
              value: p,
              path: e.path
            },
            container: I,
            component: this,
            label: "path"
          }), h || this.addGraphicalElement(g, u), V.push(g);
        }
        t = P.setAnimation({
          el: R || "path",
          attr: c,
          container: I,
          component: this,
          label: "path"
        }), R || this.addGraphicalElement("axisLine", t), V.push("axisLine");
      }

      for (v = 0, C = (m = (0, l["default"])(k.prevTicks, V)).length; v < C; v++) {
        (d = this.getGraphicalElement(m[v])) && this.removeGraphicalElement(d);
      }

      k.prevTicks = V;
    }, t.prototype._parseCategory = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          l,
          s,
          c,
          u,
          h,
          d,
          p,
          f,
          g,
          m,
          v,
          y,
          x,
          C,
          k,
          w,
          S,
          _,
          L,
          P,
          A,
          N,
          E,
          F = this.config,
          O = F.axisDimention || {},
          T = this.getFromEnv("chart"),
          D = T.getFromEnv("smartLabel"),
          M = this.components,
          I = M.labels,
          R = this.getLinkedItem("canvas").getEffectiveDimensions(),
          V = T.config,
          B = F.isOpposit,
          j = F.labels,
          G = j.style,
          H = F.isVertical,
          z = R.top,
          W = R.left,
          q = z + R.height,
          U = W + R.width,
          Y = F.labelPadding,
          X = H ? O.x : O.y,
          K = O.opposite,
          Z = T.getFromEnv("dataSource").categories,
          J = {},
          $ = F.tickValues.tickValue,
          Q = F.axisRange.min,
          ee = F.drawnStaggerLines,
          te = (F.labelStep !== F.labels.step || 1 !== this.getZoom()) && "stagger" === F.labelDisplay;

      if (F.labels.isDraw) for (H && (L = Math.abs(this.getPixel(0, b) - this.getPixel(0 + F.axisRange.tickInterval, b)), F.labelMaxH > L && (k = Math.ceil(F.labelMaxH / L)), k > F.labels.step && (F.labels.step = k)), te && (_ = 2 * Math.abs(this.getPixel(Q, b) - this.getPixel(Q + F.labels.step, b)) * F.sWidthAdjstFactor - 1), A = (a = F.labels.rotation) ? F.labelMaxH : F.labelMaxW, N = a ? F.labelMaxW : F.labelMaxH, F.drawLabelsOpposit && (B = !B, X = K), Z && Z[0] && "auto" !== F.xAxisLabelMode && (J.fontFamily = Z[0].font, J.fontSize = Z[0].fontsize, J.color = Z[0].fontcolor), F.ParentCss = p = {
        fontFamily: (0, i.pluck)(J.fontFamily, G.fontFamily),
        fontSize: (0, i.pluck)(J.fontSize, G.fontSize),
        fontWeight: (0, i.pluck)(G.fontWeight),
        fontStyle: (0, i.pluck)(G.fontStyle)
      }, p.lineHeight = (0, i.setLineHeight)(p), x = this._getCategoryArr(), M.labelIndexArr = [], e = 0, C = x.length; e < C; e += 1) {
        t = $[E = x[e].index], v = x[e].value, M.labelIndexArr.push(E), c = (0, i.pluck)(t.font, t.labelfont), u = (0, i.pluck)(t.fontsize, t.labelfontsize), h = (0, i.pluck)(t.fontbold, t.labelfontbold) ? (0, i.pluckNumber)(t.fontbold, t.labelfontbold, 0) ? "bold" : i.NORMAL : i.UNDEF, d = (0, i.pluck)(t.fontitalic, t.labelfontitalic) ? (0, i.pluckNumber)(t.fontitalic, t.labelfontitalic, 0) ? "italic" : i.NORMAL : i.UNDEF, g = (0, i.convertColor)((0, i.pluck)(t.fontcolor, t.labelfontcolor, J.color, G.color), (0, i.pluckNumber)(t.labelalpha, F.rawAttr.labelFontAlpha, T.config.singleseries ? i.UNDEF : t.alpha, 100)), c || u || h || d ? (s = {}, c && (s.fontFamily = c), u && (s.fontSize = u), h && (s.fontWeight = h), d && (s.fontStyle = d), s.lineHeight = u ? (0, i.setLineHeight)(s) : p.lineHeight) : s = i.UNDEF, (s || p) && -1 !== (r = (s || p).lineHeight).indexOf("px") && (o = r.replace(/px/i, ""), o = parseFloat(o)), !1 === t.appliedSmartLabel && (D.setStyle(t._ovrStyle || p), P = D.getSmartText(t.oriLabel || t.label, A, N), t.oriLabel = t.oriLabel || t.label, t.label = P.text, t.labelTooltext = P.labelTooltext, t.appliedSmartLabel = !0), m = this.getPixel(v, b), H ? (n = t.label || "", l = Number(t.labelPadding) || 0, f = {
          fill: g,
          "line-height": o,
          opacity: 1,
          "text-anchor": B ? i.POSITION_START : i.POSITION_END,
          text: n,
          cursor: !V.singleseries && t.link || t.labellink || G.labelLink ? i.POINTER : "",
          x: B ? (X || U) + Y : (X || W) - Y,
          y: l ? m + l : m
        }) : (n = t.label || "", l = Number(t.labelPadding) || 0, f = {
          fill: g,
          "line-height": o,
          opacity: 1,
          text: n,
          cursor: !V.singleseries && t.link || t.labellink || G.labelLink ? i.POINTER : "",
          x: m,
          y: B ? (z || X) - Y : (X || q) + Y
        }, a ? (f["text-anchor"] = B ? i.POSITION_START : i.POSITION_END, f["vertical-align"] = "middle") : (f["text-anchor"] = i.POSITION_MIDDLE, f["vertical-align"] = B ? i.POSITION_BOTTOM : i.POSITION_TOP), te ? ((w = t.labelCount % ee) && ((o = t.style.lineHeight) || (o = F.labels.style.lineHeight), S = o.replace(/px/i, "") * w, f.y = B ? f.y - S : f.y + S), D.setStyle(t._ovrStyle || p), P = D.getSmartText(t.oriLabel || t.label, _, N), t.oriLabel = t.oriLabel || t.label, f.text = t.label = P.text, t.labelTooltext = P.labelTooltext, t.appliedSmartLabel = !0) : l && (B ? f.y -= l : f.y += l)), y = {
          label: t.label,
          lineHeight: r,
          border: (0, i.pluckNumber)(t.borderthickness, t.labelborderthickness) ? (0, i.pluckNumber)(t.borderthickness, t.labelborderthickness, 1) + "px solid" : "",
          borderColor: t.bordercolor || t.labelbordercolor ? (0, i.convertColor)(t.bordercolor || t.labelbordercolor, (0, i.pluckNumber)(t.borderalpha, t.labelborderalpha, t.alpha, t.labelalpha, 100)) : i.BLANKSTRING,
          borderThickness: (0, i.pluckNumber)(t.borderthickness, t.labelborderthickness),
          borderPadding: (0, i.pluckNumber)(t.borderpadding, t.labelborderpadding),
          borderRadius: (0, i.pluckNumber)(t.borderradius, t.labelborderradius),
          backgroundColor: t.bgcolor || t.labelbgcolor ? (0, i.convertColor)(t.bgcolor || t.labelbgcolor, (0, i.pluckNumber)(t.bgalpha, t.labelbgalpha, t.alpha, t.labelalpha, F.rawAttr.labelFontAlpha, 100)) : i.BLANKSTRING,
          borderDash: (0, i.pluckNumber)(t.borderdashed, t.labelborderdashed, 0) ? (0, i.getDashStyle)((0, i.pluckNumber)(t.borderdashlen, t.labelborderdashlen, 4), (0, i.pluckNumber)(t.borderdashgap, t.labelborderdashgap, 2)) : 0 === (0, i.pluckNumber)(t.borderdashed, t.labelborderdashed) ? i.DASH_DEF : G.borderDash
        }, t.label ? f["text-bound"] = [(0, i.pluck)(y.backgroundColor, G.backgroundColor), (0, i.pluck)(y.borderColor, G.borderColor), (0, i.pluck)(y.borderThickness, G.borderThickness), (0, i.pluck)(y.borderPadding, G.borderPadding), (0, i.pluck)(y.borderRadius, G.borderRadius), (0, i.pluck)(y.borderDash, G.borderDash)] : f["text-bound"] = [], j.shiftX && (f.x += j.shiftX), j.shiftY && (f.y += j.shiftY), f.transform = (0, i.getSuggestiveRotation)(a, f.x, f.y), I[E] = I[E] || {
          config: {
            props: {
              label: {}
            }
          }
        }, I[E].config.props.label.attr = f, I[E].config.props.label.css = s;
      }
    }, t.prototype.allocatePosition = function () {
      var e = this.config;
      e.tickValues ? e.drawLabels && this._parseCategory() : e.drawLabels && this._parseLabel(), this.getChildren("scrollBar") && this.getChildren("scrollBar")[0] && this.getChildren("scrollBar")[0].setDimension(this.getScrollerDimension());
    }, t.prototype._drawCategory = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          l,
          c,
          u,
          h,
          d,
          p = this.config,
          f = this.getFromEnv("chart"),
          g = f.config,
          m = p.labels,
          b = this.getFromEnv("animationManager"),
          v = m.style,
          y = this.getFromEnv("toolTipController"),
          x = p.axisContainer,
          C = this.config.categoryLabel || (this.config.categoryLabel = []),
          k = function k(e) {
        return function (t) {
          f.plotEventHandler(this, t, e);
        };
      },
          w = p.tickValues.tickValue,
          S = [];

      if (p.labels.isDraw) {
        for (x.css(p.ParentCss), r = this._getCategoryArr(), e = 0, c = (o = (0, s["default"])(function (e, t) {
          return e.value === t.value;
        }, p.prevCategoryIntervalArr, r)).length; e < c; e++) {
          (h = this.getGraphicalElement(o[e].value + "_label")) && this.removeGraphicalElement(h);
        }

        for (p.prevCategoryIntervalArr = (0, i.extend2)([], r), e = 0, c = r.length; e < c; e += 1) {
          S[e] = r[e].value + "_label";
        }

        for (e = 0, c = r.length; e < c; e += 1) {
          t = w[d = r[e].index], a = (u = this.components.labels[d].config).props.label.attr, l = this.getGraphicalElement(S[e]), n = b.setAnimation({
            el: l || "text",
            attr: a,
            container: x,
            data: {
              value: void 0
            },
            component: this,
            label: "text",
            css: u.props.label.css
          }), l || (this.addGraphicalElement(S[e], n), n.on("fc-click", k("dataLabelClick")).hover(k("dataLabelRollOver"), k("dataLabelRollOut"))), n.data("eventArgs", {
            link: !g.singleseries && t.link || t.labellink || v.labelLink,
            text: a.text,
            index: d
          }), t.labelTooltext ? y.enableToolTip(n, t.labelTooltext) : y.disableToolTip(n), C[d] = n;
        }
      } else for (e = 0, c = p.prevCategoryIntervalArr.length; e < c; e++) {
        (h = this.getGraphicalElement(p.prevCategoryIntervalArr[e].value + "_label")) && this.removeGraphicalElement(h);
      }
    }, t.prototype._getCategoryArr = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          l,
          s,
          c,
          u,
          h = this.config,
          d = h.isVertical,
          p = 0,
          f = 0,
          g = [];

      for (e = h.tickValues.tickValue, a = v(e), n = e ? e.length - 1 : 0, d && (c = Math.abs(this.getPixel(0, b) - this.getPixel(1, b)), h.labelMaxH > c && (p = Math.ceil(h.labelMaxH / c)), p > h.labels.step && (h.labels.step = p)), s = h.labels.step > 0 ? h.labels.step : 1, u = 1 !== this.getZoom(), r = this.getVisibleConfig(), t = a; t <= n; t += s) {
        (o = e[t]) && (l = (0, i.pluckNumber)(o.x, o.y, t), 0 !== (0, i.pluckNumber)(o.showlabel, h.showLabels, 1) && (u && (l < r.minValue || l > r.maxValue) ? o.labelCount = f++ : ("auto" !== h.xAxisLabelMode && "mixed" !== h.xAxisLabelMode || 0 !== h.showZeroPlane && 0 !== h.showZeroPlaneValue || 0 !== l) && (h.labels.drawNormalVal || h.labels.drawLimitVal && (t === a || t === n)) && (h.labels.drawNormalVal || t === a || t === n) && (h.labels.drawLimitVal || t !== a && t !== n) && (o.labelCount = f++, g.push({
          index: t,
          value: l
        }))));
      }

      return g;
    }, t.prototype.getValue = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        wrtVisible: !1
      },
          n = this.getScale(),
          a = this.getTranslation();
      return n.getDomainValue(t.wrtVisible ? e : e - a);
    }, t.prototype.getPixel = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        wrtVisible: !1
      },
          n = this.getScale(),
          a = this.getTranslation(),
          i = n.getRangeValue(e);
      return t.wrtVisible ? i : i + a;
    }, t.prototype._getCustomPixel = function (e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        wrtVisible: !1
      };
      if (!t) return this.getPixel(e, n);
      var a = this.getScale().copy(),
          i = a.getRange(),
          o = i[0],
          r = i[1],
          l = Math.min(o, r),
          s = a.getRangeValue(e),
          c = this.getTranslation();
      return a.setRange([l, l + t]), n.wrtVisible ? s : s + c;
    }, t.prototype.getTranslation = function () {
      return this.config.translation || 0;
    }, t.prototype.setScrollType = function (e) {
      "none" !== e && "smart" !== e && "always" !== e || (this.config.scrollType = e, "none" === e ? this.disableScroll() : this.enableScroll());
    }, t.prototype.getScrollType = function () {
      return this.config.scrollType;
    }, t.prototype._createScrollBar = function () {
      var e,
          t = this,
          n = t.config,
          a = t.getFromEnv("chart"),
          i = t.getFromEnv("animationManager"),
          o = t.getChildren("scrollBar") && t.getChildren("scrollBar")[0];
      o || (o = t.attachChild(new u.Scroller(), "scrollBar")), o.configure({
        isHorizontal: !n.isVertical
      }), o.attachEventHandlers({
        scrollStart: function scrollStart(t) {
          e = t, a.fireChartInstanceEvent("scrollstart", {
            scrollPosition: t
          });
        },
        scroll: function scroll(e) {
          var o = n.axisRange.max,
              l = n.axisRange.min,
              s = t.getVisibleConfig(),
              c = s.minValue,
              u = s.maxValue - c,
              h = o - u,
              d = (0, r["default"])(l, h),
              p = n.isReverse ? d(1 - e) : d(e);
          t.setState("scrolling", !0), i.setAnimationState("scroll"), a.fireChartInstanceEvent("onScroll", {
            scrollPosition: e
          }), t.setVisibleConfig(p, p + u);
        },
        scrollEnd: function scrollEnd(t) {
          a.fireChartInstanceEvent("scrollend", {
            scrollPosition: t,
            prevScrollPosition: e
          });
        }
      });
    }, t.prototype._disposeScrollBar = function () {
      var e = this.getChildren("scrollBar") && this.getChildren("scrollBar")[0];
      e && e.remove();
    }, t.prototype.getScrollerDimension = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          l,
          s,
          c,
          u,
          h,
          d,
          p,
          f,
          g,
          m,
          v,
          y = this.getFromEnv("chart"),
          x = this.config,
          C = x.axisRange,
          k = x.scrollOptions || (x.scrollOptions = {}),
          w = C.max,
          S = C.min,
          _ = k.vxLength,
          L = this.getChildren("scrollBar")[0],
          P = y.getChildren("canvas")[0].config,
          A = x.scrollerContainer;
      if (L) return e = L.config, t = P.canvasLeft, n = P.canvasTop, a = P.canvasHeight, o = P.canvasWidth, r = P.canvasBorderWidth, l = x.showAxisLine && x.axisLineThickness || 0, s = (0, i.pluckNumber)(r, x.lineStartExtension), c = (0, i.pluckNumber)(r, x.lineEndExtension), k.viewPortMin = S, k.viewPortMax = w, u = (g = (p = this.getVisibleConfig()).maxValue - (f = p.minValue)) / (m = C.max - C.min), v = (f - C.min) / (m - g), h = k.windowedCanvasWidth = this.getPixel(_, b), d = k.fullCanvasWidth = this.getPixel(w - S, b) - h, e.scrollRatio = u, e.roundEdges = P.isRoundEdges, e.fullCanvasWidth = d, e.windowedCanvasWidth = h, e.parentLayer = A, e.scrollPosition = v, x.isVertical ? (e.scrollPosition = x.isReverse ? 1 - v : v, {
        x: t,
        y: n,
        height: a
      }) : (e.scrollPosition = v, {
        x: t - s,
        y: n + a + r + l - 2,
        width: o + s + c
      });
    }, t.prototype.enableScroll = function () {
      this._createScrollBar();
    }, t.prototype.disableScroll = function () {
      this._disposeScrollBar();
    }, t.prototype.isScrollEnabled = function () {
      return !!this.getChildren("scrollBar");
    }, t.prototype.setVisibleConfig = function (e, t) {
      var n,
          a = this.config,
          i = this.getZoom(),
          o = this.getScale();
      return !(e >= t || e < a.axisRange.min || t > a.axisRange.max) && (n = o.setDomain([e, t]).getDomain(), a.visibleMin = n[0], a.visibleMax = n[1], a.zoom = this._computeZoom(), a.translation = this._computeTranslation(), 1 === i && 1 === this.getZoom() || (a.ticks = this.generateTicks(), a.minorTicks = this.generateMinorTicks(), a.tickValues && this.calculateTicksOnLabelMode && this.calculateTicksOnLabelMode()), this.clearReferenceInfo(), this._parseReferenceVisuals(), this.fireEvent("visiblerangeset", {
        minValue: e,
        maxValue: t
      }), this.asyncDraw(), !0);
    }, t.prototype.hide = function () {
      var e = this.config;
      e.axisContainer && (e.axisLabelContainerTop.hide(), e.axisContainer.hide(), e.axisNameContainer.hide(), e.axisTrendLabelContainer.hide(), e.axisAxisLineContainer.hide(), e.axisAxisLineContainerBottom.hide());
    }, t.prototype.show = function () {
      var e = this.config;
      e.axisContainer && (e.axisLabelContainerTop.show(), e.axisContainer.show(), e.axisNameContainer.show(), e.axisTrendLabelContainer.show(), e.axisAxisLineContainer.show(), e.axisAxisLineContainerBottom.show());
    }, t.prototype.getZoom = function () {
      return this.config.zoom || 1;
    }, t.prototype._computeTranslation = function () {
      var e = this.config,
          t = this.getVisibleConfig(),
          n = (0, i.pluckNumber)(t.minValue, e.axisRange.min, 0),
          a = (0, i.pluckNumber)(e.axisRange.min, t.minValue, 0);
      return this.getPixel(n) - this.getPixel(a);
    }, t.prototype._computeZoom = function () {
      var e = this.config,
          t = this.getVisibleConfig(),
          n = (0, i.pluckNumber)(t.minValue, e.axisRange.min, 0),
          a = (0, i.pluckNumber)(t.maxValue, e.axisRange.max, 1),
          o = (0, i.pluckNumber)(e.axisRange.min, t.minValue, 0),
          r = (0, i.pluckNumber)(e.axisRange.max, t.maxValue, 1),
          l = e.maxZoomLimit,
          s = (r - o) / (a - n);
      return s > l ? l : s;
    }, t.prototype.getTickValues = function () {
      var e = this.config.tickValues;
      return e && e.tickValue || [];
    }, t.prototype.dataLabels = function (e) {
      var t = this.config.axisIndex;
      return this.getFromEnv("number-formatter").dataLabels(e, t);
    }, t.prototype.getAxisBase = function () {
      var e = this.getVisibleConfig(),
          t = e.minValue,
          n = e.maxValue;
      return t < 0 && n > 0 ? 0 : n <= 0 ? n : t;
    }, t.prototype._parseReferenceVisuals = function () {
      var e,
          t,
          n = this.config,
          a = this.getTickValues(),
          i = a.length,
          o = this.getFromEnv("chartConfig").is3D;
      n.isActive || (e = n.lines.isDraw, t = n.band.isDraw, n.lines.isDraw = 0, n.band.isDraw = 0), n.tickValues ? n.drawLabels && this._parseCategoryLine(a, 0, i) : n.drawPlotlines && this._parsePlotLine(), n.tickValues && "auto" !== n.xAxisLabelMode ? (n.drawPlotlines && !o && this._parseCategoryPlotLine(), n.drawPlotBands && !o && this._parseCategoryPlotBand(), "mixed" === n.xAxisLabelMode && n.drawPlotBands && !o && this._parsePlotBand()) : n.drawPlotBands && !o && this._parsePlotBand(), n.isActive || (n.lines.isDraw = e, n.band.isDraw = t), n.drawTrendLines && this._parseTrendLine();
    }, t.prototype._parseCategoryPlotBand = function () {
      var e,
          t,
          n,
          a,
          o,
          r = this.config,
          l = r.tickValues.tickValue,
          s = r.showAlternateGridColor,
          c = r.alternateGridColor,
          u = r.alternateGridAlpha,
          h = r._allTicks,
          d = this.getLimit(),
          p = d.min,
          f = d.max,
          m = g(this.getVisibleConfig());
      if ((!l[0] || l[0].x === i.UNDEF && l[0].y === i.UNDEF) && s && r.band.isDraw && r.categoryNumDivLines) for (e = {
        fill: (0, i.toRaphaelColor)((0, i.convertColor)(c, u)),
        "stroke-width": 0
      }, t = 0, o = 0; o < h.length; ++t, ++o) {
        m(h[o], h[o + 1]) && (n = h[o], t % 2 == 0 && (a = h[o + 1]) !== i.UNDEF && (n === p && (n = "canvasStart"), a === f && (a = "canvasEnd"), this.setReferenceInfo({
          from: n,
          to: a,
          layer: 0,
          type: "band",
          attr: e
        })));
      }
    }, t.prototype._parseTrendLine = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          l,
          s,
          c,
          u,
          h,
          d,
          p,
          f,
          g,
          m,
          b,
          v,
          y,
          x,
          C = this.config,
          k = C.isVertical,
          w = C.axisIndex,
          S = this.getFromEnv("chart-attrib"),
          _ = this.getFromEnv("number-formatter"),
          L = C.axisRange,
          P = L.max,
          A = L.min,
          N = C.trend.trendStyle,
          E = {
        fontFamily: N.fontFamily,
        fontSize: N.fontSize,
        lineHeight: N.lineHeight,
        fontWeight: N.fontWeight,
        fontStyle: N.fontStyle
      },
          F = C.vTrendLines,
          O = C.trendLines,
          T = 0;

      if (l = O || F) for (n = 0, a = l.length; n < a; n += 1) {
        for (e = 0, t = l[n].line && l[n].line.length; e < t; e += 1) {
          h = l[n].line[e], b = k ? "yAxis" : "xAxis", f = h.startvalue || h.value || 0, f = _.getCleanValue((0, i.pluck)(h.startvalue, h.value, 0)), g = Number(h.endvalue) || i.UNDEF, o = (0, i.getValidValue)((0, i.parseUnsafeString)((0, i.pluck)(l[n].line[e].tooltext, l[0].tooltext, C.trendlineToolText))), o = (0, i.parseTooltext)(o, [7, 15, 16, 17, 18, 19], {
            startValue: f,
            startDataValue: _[b](f, w),
            endValue: g || f,
            endDataValue: _[b](g || f, w),
            axisName: C.axisName
          }, h), f > P || f < A || g > P || g < A || (F ? (d = (0, i.parseUnsafeString)(h.displayvalue || ""), s = (0, i.pluckNumber)(h.istrendzone, C.isTrendZone, 1), g !== i.UNDEF && "" !== g && g !== f && s ? (c = {
            fill: (0, i.convertColor)((0, i.pluck)(h.color, C.trendlineColor), (0, i.pluck)(h.alpha, C.trendlineAlpha, 40)),
            "stroke-width": 0
          }, u = {
            fill: (0, i.convertColor)((0, i.pluck)(h.color, N.color), (0, i.pluck)(N.valueAlpha, h.alpha, C.trendlineAlpha, 99)),
            "vertical-align": i.POSITION_TOP,
            text: d
          }) : (m = (0, i.pluckNumber)(h.thickness, C.trendlineThickness, 1), c = {
            stroke: (0, i.convertColor)((0, i.pluck)(h.color, C.trendlineColor), (0, i.pluck)(h.alpha, C.trendlineAlpha, 99)),
            "stroke-width": m,
            "stroke-dasharray": (0, i.pluck)(h.dashed, C.trendlinesAreDashed) === i.ONESTRING ? (0, i.getDashStyle)((0, i.pluckNumber)(h.dashlen, C.trendlinesDashLen), (0, i.pluckNumber)(h.dashgap, C.trendlinesDashGap)) : i.DASH_DEF
          }, u = {
            fill: (0, i.convertColor)((0, i.pluck)(h.color, N.color), (0, i.pluck)(N.valueAlpha, h.alpha, C.trendlineAlpha, 99)),
            "vertical-align": i.POSITION_TOP,
            text: d
          })) : O && (d = (0, i.pluck)((0, i.parseUnsafeString)(h.displayvalue), h.startvalue, ""), p = (0, i.pluckNumber)(h.valueonright, 0), s = (0, i.pluckNumber)(h.istrendzone, C.isTrendZone, 0), g !== i.UNDEF && "" !== g && g !== f && s ? (c = {
            fill: (0, i.convertColor)((0, i.pluck)(h.color, C.trendlineColor), (0, i.pluck)(h.alpha, C.trendlineAlpha, 40)),
            "stroke-width": 0
          }, u = {
            "text-anchor": p ? i.POSITION_START : i.POSITION_END,
            fill: (0, i.convertColor)((0, i.pluck)(h.color, N.color), (0, i.pluck)(N.valueAlpha, h.alpha, C.trendlineAlpha, 99)),
            text: d
          }) : (m = (0, i.pluckNumber)(h.thickness, C.trendlineThickness, 1), c = {
            stroke: (0, i.convertColor)((0, i.pluck)(h.color, C.trendlineColor), (0, i.pluck)(h.alpha, C.trendlineAlpha, 99)),
            "stroke-width": m,
            "stroke-dasharray": (0, i.pluck)(h.dashed, C.trendlinesAreDashed) === i.ONESTRING ? (0, i.getDashStyle)((0, i.pluckNumber)(h.dashlen, C.trendlinesDashLen), (0, i.pluckNumber)(h.dashgap, C.trendlinesDashGap)) : i.DASH_DEF
          }, u = {
            "text-anchor": p ? i.POSITION_START : i.POSITION_END,
            fill: (0, i.convertColor)((0, i.pluck)(h.color, N.color), (0, i.pluck)(N.valueAlpha, h.alpha, C.trendlineAlpha, 99)),
            text: d
          })), u["text-bound"] = u.text ? [N.backgroundColor, N.borderColor, N.borderThickness, N.borderPadding, N.borderRadius, N.borderDash] : [], C.showTooltip && o || (o = ""), r = C.forceTrendBelow ? 0 : (0, i.pluckNumber)(h.showontop, S.showtrendlinesontop, 0), k ? (v = f, x = g !== i.UNDEF ? g : f) : (v = g !== i.UNDEF ? g : f, x = f), y = s && v !== x ? "band" : "line", v !== i.UNDEF && this.setReferenceInfo({
            from: v,
            to: x,
            toolText: o,
            attr: c,
            layer: r ? 3 : 2,
            type: y,
            id: "trend" + T + y
          }), C.parsedTrendLabels.push({
            css: E,
            valueOnRight: p,
            isTrendZone: s,
            from: f,
            to: g,
            attr: u
          }), T += 1);
        }
      }
    }, t.prototype._parsePlotLine = function () {
      var e,
          t,
          n,
          a,
          o,
          r = this.config,
          l = r.axisRange,
          s = l.max,
          c = l.min,
          u = m(this.getVisibleConfig()),
          h = r.showCanvasBorder,
          d = (0, i.convertColor)(r.divLineColor, r.divLineAlpha),
          p = r.divLineThickness,
          f = r.divLineIsDashed ? (0, i.getDashStyle)(r.divLineDashLen, r.divLineDashGap) : i.DASH_DEF,
          g = (0, i.convertColor)(r.zeroPlaneColor, r.zeroPlaneAlpha),
          b = r.zeroPlaneThickness,
          v = r._allTicks,
          y = v.length,
          x = r.showZeroPlaneOnTop,
          C = r.minorTicks,
          k = C && C.length;
      if (r.lines.isDraw) for (t = 0; t < y; ++t) {
        u(e = v[t]) && (a = {
          "stroke-dasharray": f
        }, 0 === r.showZeroPlane && 0 === e || h && (e === s || e === c) || (0 === e && e !== c && e !== s ? (a.stroke = g, a["stroke-width"] = b, x = r.showZeroPlaneOnTop) : (x = 0, a.stroke = d, a["stroke-width"] = p), this.setReferenceInfo({
          type: "line",
          from: e,
          layer: 0 === e && x ? 3 : 1,
          attr: a
        })));
      }

      for (o = {
        stroke: r.minorDivlinecolor,
        "stroke-width": r.minorDivLineThickness,
        "stroke-dasharray": f
      }, t = 0; t < k; ++t) {
        n = C[t], this.setReferenceInfo({
          type: "line",
          from: n,
          layer: 1,
          attr: o
        });
      }
    }, t.prototype._parseCategoryLine = function (e, t, n) {
      var a,
          o,
          r,
          l,
          s,
          c,
          u = this.config,
          h = this.getFromEnv("color-manager"),
          d = this.getFromEnv("chartInstance").getJSONData().categories,
          p = {};
      if (t = t || 0, n = n || e ? e.length - 1 : 0, u.drawPlotlines) for (c = 1 !== this.getZoom(), r = this.getVisibleConfig(), d && d[0] && (p.verticalLineColor = d[0].verticallinecolor, p.verticalLineAlpha = d[0].verticallinealpha, p.verticalLineThickness = d[0].verticallinethickness, p.verticalLineDashed = d[0].verticallinedashed, p.verticalLineDashLen = d[0].verticallinedashlen, p.verticalLineDashGap = d[0].verticallinedashgap), a = t; a <= n; a += 1) {
        (o = e[a]) && (s = (0, i.pluckNumber)(o.x, o.y, a), 1 === Number(o.showverticalline) && (c && (s < r.minValue || s > r.maxValue) || ((l = {
          stroke: (0, i.convertColor)((0, i.pluck)(o.linecolor, p.verticalLineColor, u.divLineColor, h.getColor("divLineColor")), (0, i.pluck)(o.linealpha, p.verticalLineAlpha, h.getColor("divLineAlpha"))),
          "stroke-width": (0, i.pluckNumber)(o.linethickness, p.verticalLineThickness, 1)
        })["stroke-dasharray"] = (0, i.pluckNumber)(o.linedashed, p.verticalLineDashed, 0) ? (0, i.getDashStyle)((0, i.pluckNumber)(o.linedashLen, p.verticalLineDashLen, 4), (0, i.pluckNumber)(o.linedashgap, p.verticalLineDashGap, 2), l["stroke-width"]) : i.DASH_DEF, this.setReferenceInfo({
          type: "line",
          from: s,
          layer: 1,
          attr: l
        }))));
      }
    }, t.prototype._parsePlotBand = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          l = this.config,
          s = l.showAlternateGridColor,
          c = l.alternateGridColor,
          u = l.alternateGridAlpha,
          h = l._allTicks,
          d = g(this.getVisibleConfig()),
          p = l.isReverse;
      if (s && l.band.isDraw) for (t = 1, e = {
        fill: (0, i.toRaphaelColor)((0, i.convertColor)(c, u)),
        "stroke-width": 0
      }, a = 0, n = h.length; a < n; ++a, ++t) {
        d(h[a], h[a + 1]) && t % 2 == 0 && h[a + 1] !== i.UNDEF && (r = p ? Math.max(h[a], h[a + 1]) : Math.min(h[a], h[a + 1]), o = p ? Math.min(h[a], h[a + 1]) : Math.max(h[a], h[a + 1]), this.setReferenceInfo({
          from: r,
          to: o,
          type: "band",
          layer: 0,
          attr: e
        }));
      }
    }, t.prototype.getReferenceInfo = function () {
      return this.config.referenceInfo;
    }, t.prototype.setReferenceInfo = function (e) {
      this.config.referenceInfo.push(e);
    }, t.prototype.clearReferenceInfo = function () {
      var e = this.config;
      e.referenceInfo = [], e.parsedTrendLabels = [], e.parsedVlineInfo = [];
    }, t.prototype.resetStoredLimits = function () {
      this.config.dataLimit = {};
    }, t.prototype.decideScroll = function () {
      var e = this.getScrollType();
      "always" === e || "smart" === e && 1 !== this.getZoom() ? this.enableScroll() : this.disableScroll();
    }, t.prototype.getAxisDimension = function () {
      var e = this.config.axisDimention;
      return {
        x: e.x,
        y: e.y,
        opposite: e.opposite,
        axisLength: e.axisLength
      };
    }, t;
  }(a["default"]);

  y.prototype.setAxisDimention = h.setAxisDimention, y.prototype.shiftLabels = h.shiftLabels, y.prototype._createContainer = h._createContainer, t["default"] = y, t.getCrispPath = f, t.minimumEnquiry = v;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(138),
      i = n(125);

  function o(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var r = function r(e, t) {
    return e < t ? t : e;
  },
      l = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.apply(this, arguments));
    }

    return o(t, e), t.prototype.getType = function () {
      return "axis";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this), this.components = {
        labels: []
      };
      var t = this.config;
      t.setAdaptiveMin = 0, t.adjustDiv = 1, t.axisNameWidth = i.UNDEF, t.rotateAxisName = 0, t.useEllipsesWhenOverflow = 1, t.divLineColor = i.UNDEF, t.divLineAlpha = i.UNDEF, t.divLineThickness = i.UNDEF, t.divLineIsDashed = i.UNDEF, t.divLineDashLen = i.UNDEF, t.divLineDashGap = i.UNDEF, t.showAlternateGridColor = i.UNDEF, t.alternateGridColor = i.UNDEF, t.alternateGridAlpha = i.UNDEF, t.showZeroPlane = 1, t.zeroPlaneAlpha = 80, t.showZeroPlaneValue = 1, t.showZeroPlaneOnTop = 1, t.showAxisLine = i.UNDEF, t.axisLineThickness = i.UNDEF, t.axisLineAlpha = i.UNDEF, t.tickLength = 0, t.trendlineToolText = i.UNDEF, t.trendlineColor = "333333", t.trendlineThickness = 1, t.trendlineAlpha = i.UNDEF, t.showTrendlinesOnTop = 0, t.trendlinesAreDashed = 0, t.trendlinesDashLen = 5, t.trendlinesDashGap = 2, t.isTrendZone = i.UNDEF, t.showTrendlines = 1, t.showTrendlineLabels = 1, t.showLabels = 1, t.maxLabelHeight = i.UNDEF, t.rotateLabels = i.UNDEF, t.slantLabel = 0, t.showAxisValues = 1, t.showTooltip = 1, t.isActive = !0, t.drawLabels = !0, t.drawOnlyCategoryLine = !1, t.drawLabelsOpposit = !1, t.drawPlotlines = !0, t.drawAxisLine = !0, t.drawPlotBands = !0, t.drawAxisName = !0, t.drawAxisNameOpposit = !1, t.axisNameAlignCanvas = !1, t.drawAxisNameFromBottom = !1, t.drawTrendLines = !0, t.drawTrendLabels = !0, t.drawTick = !0, t.drawTickMinor = !0, t.animateAxis = !0, t.drawAxisLineWRTCanvas = !0, t.isRelativeAxisInverse = !1, t.axisIndex = 0, t.uniqueClassName = 0, t.viewPortRatio = {}, t.canvas = {}, t.axisRange = {}, t.drawnStaggerLines = i.UNDEF, t.axisDimention = {}, t.forceZeroTick = !0, t.isZeroTickForced = !1, t.extremeLabels = {
        firstLabel: {},
        lastLabel: {}
      }, t._setRangeAgain = !1, t._defaultForceDecimal = i.UNDEF, t._defaultDecimalPrecision = i.UNDEF, t.rangeChanged = !1, t.dimensionChanged = !1, t.apparentScrollPos = 0, t.visibleMin = i.UNDEF, t.visibleMax = i.UNDEF, t.setPadding = !1, t.trendLimits = i.UNDEF;
    }, t.prototype.configureAttributes = function (e) {
      var t,
          n,
          a,
          o,
          l = this.config,
          s = this.getFromEnv("chart"),
          c = this.getFromEnv("dataSource"),
          u = s.config.is3D,
          h = c.chart,
          d = this.getFromEnv("number-formatter");
      t = l.rawAttr = e, l.referenceInfo = [], l.parsedTrendLabels = [], l.parsedVlineInfo = [], l.trendLines = t.trendlines, l.vTrendLines = t.vtrendlines, (0, i.parseConfiguration)(t, l), l.axisName = (0, i.parseUnsafeString)(t.axisName), l.axisValuePadding = l.axisNamePadding || (0, i.pluckNumber)(t.axisValuePadding, 4), l.axisNamePadding = l.axisNamePadding || (0, i.pluckNumber)(t.axisNamePadding, 5), l.maxLabelWidthPercent = (0, i.pluckNumber)(t.maxLabelWidthPercent), l.maxLabelWidthPercent = Math.abs(l.maxLabelWidthPercent), l.minLabelWidthPercent = Math.abs((0, i.pluckNumber)(t.minLabelWidthPercent)), l.numDivLines = (0, i.pluckNumber)(t.numDivLines, 4), l.numDivLines = r(l.numDivLines, 0), l.categoryNumDivLines = (0, i.pluckNumber)(t.numDivLines, 0), l.axisValuePadding = r(l.axisValuePadding, 0), l.isReverse = (0, i.pluckNumber)(t.isReverse, 0), l.isOpposit = (0, i.pluckNumber)(t.isOpposit, 0), l.isVertical = (0, i.pluckNumber)(t.isVertical, 0), l.categoryDivLinesFromZero = 1, l.axisMinValue = d.getCleanValue(t.axisMinValue), l.axisMaxValue = d.getCleanValue(t.axisMaxValue), l.zeroPlaneColor = (0, i.pluck)(t.zeroPlaneColor, t.divLineColor), l.zeroPlaneThickness = (0, i.pluck)(t.zeroPlaneThickness, t.divLineThickness), l.axisLineColor = (0, i.convertColor)(t.axisLineColor, t.axisLineAlpha), l.tickAlpha = (0, i.pluckNumber)(t.tickAlpha, l.axisLineAlpha), l.tickColor = (0, i.convertColor)((0, i.pluck)(t.tickColor, t.axisLineColor), l.tickAlpha), l.tickWidth = (0, i.pluckNumber)(t.tickWidth, l.axisLineThickness), l.maxZoomLimit = (0, i.pluckNumber)(h.maxzoomlimit, s.maxzoomlimit, 1e3), l.showVLines = (0, i.pluckNumber)(h.showvlines, 1), l.showVLinesOnTop = (0, i.pluckNumber)(h.showvlinesontop, 0), l.showVLineLabels = (0, i.pluckNumber)(h.showvlinelabels, this.showVLineLabels, 1), l.showVLineLabelBorder = (0, i.pluckNumber)(h.showvlinelabelborder, 1), l.rotateVLineLabels = (0, i.pluckNumber)(h.rotatevlinelabels, 0), l.vLineColor = (0, i.pluck)(h.vlinecolor, "333333"), l.vLineLabelColor = (0, i.pluck)(h.vlinelabelcolor), l.vLineThickness = (0, i.pluck)(h.vlinethickness, 1), l.vLineAlpha = (0, i.pluckNumber)(h.vlinealpha, 80), l.vLineLabelBgColor = (0, i.pluck)(h.vlinelabelbgcolor, "ffffff"), l.vLineLabelBgAlpha = (0, i.pluckNumber)(h.vlinelabelbgalpha, u ? 50 : 100), l.staggerLines = Math.max((0, i.pluckNumber)(h.staggerlines, 2), 2), l.staggerLines = r(l.staggerLines, 1), l.trendlineValuesOnOpp = (0, i.pluck)(t.trendlineValuesOnOpp, t.trendlineValuesOnOpp, 0), l.labelDisplay = (0, i.pluck)(t.labelDisplay, "auto").toLowerCase(), l.labelStep = (0, i.pluckNumber)(t.labelStep, 1), l.labelStep = Math.round(l.labelStep), l.labelStep = r(l.labelStep, 1), l.startPad = 0, l.endPad = 0, l._oriLabelStep = l.labelStep, l.showLimits = (0, i.pluckNumber)(t.showLimits, l.showAxisValues), l.showUpperLimit = t.showLimits, l.showDivLineValues = (0, i.pluckNumber)(t.showDivLineValues, l.showAxisValues), l.showCanvasBorder = s.getChildren("canvas")[0].config.showCanvasBorder ? 1 : 0, l.axisBreak = t.axisBreaks, l.isBreak = !!l.axisBreak, l.isBreak && this._processAxisBreak(), n = (n = (0, i.getFirstValue)(t.axisNameBorderColor, i.BLANKSTRING)) ? (0, i.convertColor)(n, (0, i.pluckNumber)(t.axisNameBorderAlpha, t.axisNameAlpha, 100)) : i.BLANKSTRING, l.name = l.name || {}, l.name.style = {
        fontFamily: (0, i.pluck)(t.axisNameFont, t.outCanfontFamily),
        fontSize: (0, i.pluck)(t.axisNameFontSize, (0, i.pInt)(t.outCanfontSize)) + i.PXSTRING,
        color: (0, i.convertColor)((0, i.pluck)(t.axisNameFontColor, t.outCancolor), (0, i.pluckNumber)(t.axisNameFontAlpha, t.axisNameAlpha, 100)),
        fontWeight: (0, i.pluckNumber)(t.axisNameFontBold, 1) ? "bold" : i.NORMAL,
        fontStyle: (0, i.pluckNumber)(t.axisNameFontItalic) ? "italic" : i.NORMAL,
        border: n || t.axisNameBgColor ? (0, i.pluckNumber)(t.axisNameBorderThickness, 1) + "px solid" : i.UNDEF,
        borderColor: n,
        borderThickness: (0, i.pluckNumber)(t.axisNameBorderThickness, 1),
        borderPadding: (0, i.pluckNumber)(t.axisNameBorderPadding, 2),
        borderRadius: (0, i.pluckNumber)(t.axisNameBorderRadius, 0),
        backgroundColor: t.axisNameBgColor ? (0, i.convertColor)(t.axisNameBgColor, (0, i.pluckNumber)(t.axisNameBgAlpha, t.axisNameAlpha, 100)) : i.BLANKSTRING,
        borderDash: (0, i.pluckNumber)(t.axisNameBorderDashed, 0) ? (0, i.getDashStyle)((0, i.pluckNumber)(t.axisNameBorderDashLen, 4), (0, i.pluckNumber)(t.axisNameBorderDashGap, 2)) : i.DASH_DEF
      }, l.name.style.lineHeight = (0, i.setLineHeight)(l.name.style), a = (a = (0, i.getFirstValue)(h.trendvaluebordercolor, i.BLANKSTRING)) ? (0, i.convertColor)(a, (0, i.pluckNumber)(h.trendvalueborderalpha, h.trendvaluealpha, 100)) : i.BLANKSTRING, l.trend = l.trend || {}, l.trend.trendStyle = {
        fontFamily: (0, i.pluck)(h.trendvaluefont, t.outCanfontFamily),
        color: (0, i.pluck)(h.trendvaluefontcolor, t.trendlineColor, t.outCancolor, "333333"),
        valueAlpha: h.trendvaluealpha,
        fontSize: (0, i.pluckFontSize)(h.trendvaluefontsize, (0, i.pInt)(t.outCanfontSize)) + i.PXSTRING,
        fontWeight: (0, i.pluckNumber)(h.trendvaluefontbold) ? "bold" : i.NORMAL,
        fontStyle: (0, i.pluckNumber)(h.trendvaluefontitalic) ? "italic" : i.NORMAL,
        border: a || h.trendvaluebgcolor ? (0, i.pluckNumber)(h.trendvalueborderthickness, 1) + "px solid" : "",
        borderColor: a,
        borderThickness: (0, i.pluckNumber)(h.trendvalueborderthickness, 1),
        borderPadding: (0, i.pluckNumber)(h.trendvalueborderpadding, 2),
        borderRadius: (0, i.pluckNumber)(h.trendvalueborderradius, 0),
        backgroundColor: h.trendvaluebgcolor ? (0, i.convertColor)(h.trendvaluebgcolor, (0, i.pluckNumber)(h.trendvaluebgalpha, h.trendvaluealpha, 100)) : i.BLANKSTRING,
        borderDash: (0, i.pluckNumber)(h.trendvalueborderdashed, 0) ? (0, i.getDashStyle)((0, i.pluckNumber)(h.trendvalueborderdashlen, 4), (0, i.pluckNumber)(h.trendvalueborderdashgap, 2)) : i.DASH_DEF
      }, l.trend.trendStyle.lineHeight = (0, i.setLineHeight)(l.trend.trendStyle), l.labels = l.labels || {}, l.lines = l.lines || {}, l.band = l.band || {}, o = (o = (0, i.getFirstValue)(h.labelbordercolor, i.BLANKSTRING)) ? (0, i.convertColor)(o, (0, i.pluckNumber)(h.labelborderalpha, h.labelalpha, 100)) : i.BLANKSTRING, l.labels.style = {
        fontFamily: (0, i.pluck)(t.labelFont, t.outCanfontFamily),
        fontSize: (0, i.pluckNumber)(t.labelFontSize, (0, i.pInt)(t.outCanfontSize)) + i.PXSTRING,
        fontWeight: (0, i.pluckNumber)(t.labelFontBold) ? "bold" : i.NORMAL,
        fontStyle: (0, i.pluckNumber)(t.labelFontItalic) ? "italic" : i.NORMAL,
        color: (0, i.convertColor)((0, i.pluck)(t.labelFontColor, t.outCancolor), (0, i.pluckNumber)(t.labelFontAlpha, 100)),
        labelLink: h.labellink,
        border: o || h.labelbgcolor ? (0, i.pluckNumber)(h.labelborderthickness, 1) + "px solid" : "",
        borderColor: o,
        borderThickness: (0, i.pluckNumber)(h.labelborderthickness, 1),
        borderPadding: (0, i.pluckNumber)(h.labelborderpadding, 2),
        borderRadius: (0, i.pluckNumber)(h.labelborderradius, 0),
        backgroundColor: h.labelbgcolor ? (0, i.convertColor)(h.labelbgcolor, (0, i.pluckNumber)(h.labelbgalpha, h.labelalpha, 100)) : i.BLANKSTRING,
        borderDash: (0, i.pluckNumber)(h.labelborderdashed, 0) ? (0, i.getDashStyle)((0, i.pluckNumber)(h.labelborderdashlen, 4), (0, i.pluckNumber)(h.labelborderdashgap, 2)) : i.DASH_DEF
      }, l.labels.style.lineHeight = (0, i.setLineHeight)(l.labels.style), l.numberFormatterFn = (0, i.pluck)(t.numberFormatterFn), l.apparentScrollPos = t.apparentScrollPos || l.apparentScrollPos, l.axisRange = {}, l.dataLimit = {}, l.axisEndLabelDisplaySpace = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }, l.isConfigured = !0, l._defaultForceDecimal = i.UNDEF, l._defaultDecimalPrecision = i.UNDEF, l.lines.isDraw = (0, i.pluckNumber)(t.lines && t.lines.isDraw, 1), l.band.isDraw = (0, i.pluckNumber)(t.band && t.band.isDraw, 1);
    }, t.prototype.createContainer = function (e, t, n) {
      var a = this.getFromEnv("animationManager");
      return this.addContainer(e, a.setAnimation({
        container: n,
        attr: t,
        el: this.getContainer(e) || "group",
        component: this,
        label: "group"
      }));
    }, t.prototype.createGroup = function (e, t, n) {
      var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "group";
      return this.getFromEnv("animationManager").setAnimation({
        container: n,
        attr: t,
        el: this.config[e] || "group",
        component: this,
        label: a
      });
    }, t.prototype.getValuePadding = function () {
      var e = this.config;
      return {
        left: e.startPad,
        right: e.endPad
      };
    }, t.prototype.draw = function () {
      var e,
          t,
          n,
          a,
          i = this.config,
          o = this.getFromEnv("chart").config,
          r = i.isVertical,
          l = o.viewPortConfig,
          s = this.getChildren().limitUpdater,
          c = i.viewPortRatio || {};
      this._createContainer(), n = l.y * l.scaleY, a = l.x * l.scaleX, c.scaleX && c.scaleY && (c.scaleX !== l.scaleX || c.scaleY !== l.scaleY) ? (c.scaleX = l.scaleX, c.scaleY = l.scaleY, this._drawComponents()) : (r ? (t = n - l.y * l.scaleY, i.axisContainer.transform("t0," + t), i.axisLabelContainerTop.transform("t0," + t)) : (e = a - l.x * l.scaleX, i.axisContainer.transform("t" + e + ",0"), i.axisLabelContainerTop.transform("t" + e + ",0")), this._drawComponents()), this.addExtEventListener("animationcomplete", function () {
        s && s.forEach(function (e) {
          e.draw();
        });
      }, this.getFromEnv("animationmanager")), this.addToEnv("prevScale", this.getScale().copy());
    }, t.prototype.setScale = function (e) {
      this.config.scale = e;
    }, t.prototype.getScale = function () {
      return this.config.scale;
    }, t.prototype.getLimit = function () {
      var e = this.config.axisRange;
      return {
        min: e.min,
        max: e.max,
        tickInterval: e.tickInterval
      };
    }, t.prototype.getVisibleConfig = function () {
      var e = this.config;
      return {
        minValue: e.visibleMin,
        maxValue: e.visibleMax
      };
    }, t.prototype.setAxisConfig = function (e) {
      var t,
          n = this.config;

      for (t in e) {
        e.hasOwnProperty(t) && (n[t] = e[t]);
      }
    }, t.prototype.getAxisConfig = function (e) {
      var t = this.config;
      return e ? t[e] : t;
    }, t.prototype.getVisibleLength = function () {
      var e = this.getVisibleConfig();
      return Math.abs(e.maxValue - e.minValue);
    }, t.prototype.getAxisEndLabelDisplaySpace = function () {
      return this.config.axisEndLabelDisplaySpace || {};
    }, t.prototype.getTicksLen = function () {
      var e = this.config.tickValues;
      return e && e.tickValue.length || 0;
    }, t;
  }(a.ComponentInterface);

  t["default"] = l;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = [{
    initialAttr: {
      opacity: 0
    },
    finalAttr: {
      opacity: 1
    },
    slot: "axis"
  }],
      i = [{
    initialAttr: {
      opacity: 0
    },
    finalAttr: {
      opacity: 1
    },
    slot: "final"
  }],
      o = {
    "text.appearing": i,
    "path.appearing": i,
    "rect.appearing": i
  },
      r = {
    "text.appearing": a,
    "path.appearing": a,
    "rect.appearing": a,
    "scroller.appearing": a
  };
  t["default"] = {
    "initial.axis.numeric": r,
    "initial.axis.category": r,
    "initial.axis.log": r,
    "update.axis.numeric": o,
    "update.axis.category": o,
    "update.axis.log": o
  }, t.appearingAxis = a, t.appearingFinal = i, t.axisAnimationAxis = r, t.axisAnimationFinal = o;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e, t) {
    e = Number(e);
    var n = (t = Number(t)) - e;
    return function (t) {
      return n * t + e;
    };
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;

  t["default"] = function (e, t) {
    return e.filter(function (e) {
      return t.indexOf(e) < 0;
    });
  };
}, function (e, t, n) {
  var a = n(385),
      i = n(203)(function (e, t, n) {
    for (var i = [], o = 0, r = t.length; o < r;) {
      a(e, t[o], n) || a(e, t[o], i) || i.push(t[o]), o += 1;
    }

    return i;
  });
  e.exports = i;
}, function (e, t) {
  e.exports = function (e, t, n) {
    for (var a = 0, i = n.length; a < i;) {
      if (e(t, n[a])) return !0;
      a += 1;
    }

    return !1;
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t._parseLabel = t.extractStyleInfo = t.getLabel = t.setAxisPadding = t._createContainer = t.shiftLabels = t.setTickValues = t._drawLabel = t.getPixel = t.getTrendLineLimits = t.setDataLimit = t.setAxisDimention = undefined;
  var a,
      i = n(125),
      o = n(387),
      r = (a = o) && a.__esModule ? a : {
    "default": a
  };

  var l = {
    wrtVisible: !0
  },
      s = function s(e, t) {
    var n,
        a,
        o,
        r,
        l,
        s,
        c,
        u = {
      labelfont: ["fontFamily"],
      labelfontcolor: ["fontColor"],
      labelfontsize: ["fontSize", function (e) {
        return e ? (0, i.pluckNumber)(e) + "px" : i.UNDEF;
      }],
      labelfontbold: ["fontWeight", function (e) {
        return e ? "bold" : "normal";
      }],
      labelfontitalic: ["fontStyle", function (e) {
        return e ? "italic" : "normal";
      }],
      labelfontalpha: ["fontAlpha"]
    },
        h = t.getFromEnv("dataSource").categories,
        d = h && h[0] || {},
        p = function p(e) {
      return e;
    },
        f = !1,
        g = {};

    for (n in d) {
      "category" === n || n in e || (a = d[n], e[n] = a);
    }

    for (n in u) {
      l = (r = u[n])[0], s = r[1] || p, a = e[n], o = e[l.toLowerCase()], a === i.UNDEF && o === i.UNDEF || (c = s(a)) === i.UNDEF && (c = s(o)) === i.UNDEF || (g[l] = c, f = !0), f && (e.style = g);
    }
  };

  t.setAxisDimention = function (e) {
    var t = this.getScale(),
        n = this.config,
        a = this.getFromEnv("chart").config,
        o = n.axisDimention || (n.axisDimention = {}),
        r = n.isReverse;
    o.opposite = (0, i.pluckNumber)(e.opposite, o.opposite), o.x = (0, i.pluckNumber)(e.x, o.x, a.canvasLeft), o.y = (0, i.pluckNumber)(e.y, o.y, a.canvasTop), o.axisLength = (0, i.pluckNumber)(e.axisLength, o.axisLength), n.isVertical ? r ? t.setRange([o.y + o.axisLength, o.y]) : t.setRange([o.y, o.y + o.axisLength]) : r ? t.setRange([o.x + o.axisLength, o.x]) : t.setRange([o.x, o.x + o.axisLength]), n.translation = this._computeTranslation();
  }, t.setDataLimit = function (e, t) {
    var n,
        a,
        o,
        r,
        l = this.config,
        s = this.getFromEnv("dataSource").categories,
        c = s && s[0] && s[0].category,
        u = l.startPad || 0,
        h = l.endPad || 0,
        d = l.xAxisLabelMode;

    if ("categories" === d || "mixed" === d) {
      var p = (0, i.extent)(c, function (e) {
        return Number(e.x);
      });
      n = p[0], a = p[1];
    }

    var f = this.getTrendLineLimits();
    o = f[0], r = f[1];
    var g = (0, i.extent)([o, r, n, a, t, e], function (e) {
      return Number(e);
    });
    t = g[0], e = g[1], l.originalMax = e, l.originalMin = t, e = l.isPercent ? 100 : e + h, t = l.isPercent ? 0 : t - u, this._setAxisRange({
      min: t,
      max: e
    }), l.axisRange.tickInterval !== i.UNDEF && this._adjustNumberFormatter(l.axisRange.tickInterval);
  }, t.getTrendLineLimits = function () {
    var e,
        t,
        n,
        a,
        o = this.config,
        r = o.trendLines || o.vTrendLines || o.trendPoints,
        l = r && r[0] && r[0].line || r && r.point;
    if (o.trendLimits) return o.trendLimits;
    var s = (0, i.extent)(l, function (e) {
      return "" === e.startvalue ? i.UNDEF : Number(e.startvalue);
    });
    e = s[0], t = s[1];
    var c = (0, i.extent)(l, function (e) {
      return "" === e.endvalue ? i.UNDEF : Number(e.endvalue);
    });
    return n = c[0], a = c[1], o.trendLimits = (0, i.extent)([e, t, n, a], function (e) {
      return Number(e);
    }), o.trendLimits;
  }, t.getPixel = function (e) {
    return this.getScale().getRangeValue(e);
  }, t._drawLabel = function () {
    var e,
        t,
        n,
        a,
        i,
        o,
        l,
        s,
        c,
        u,
        h,
        d = this.config,
        p = this.getFromEnv("animationManager"),
        f = this.getFromEnv("toolTipController"),
        g = d.axisRange,
        m = d.labels.style,
        b = this.components,
        v = g.max,
        y = g.min,
        x = d.axisContainer,
        C = d.extremeLabels,
        k = d.ticks,
        w = [],
        S = {
      fontFamily: m.fontFamily,
      fontSize: m.fontSize,
      fontWeight: m.fontWeight,
      fontStyle: m.fontStyle,
      lineHeight: m.lineHeight
    };
    if (d.labels.isDraw) for (h = b.labels, u = b.labelIndexArr, x.css(S), t = 0, n = u && u.length; t < n; t += 1) {
      i = (s = k[e = u[t]]) + "_label", a = this.getGraphicalElement(i), l = h[e].config.props.label.attr, a = this.addGraphicalElement(i, p.setAnimation({
        el: a || "text",
        attr: l,
        container: x,
        data: {
          value: s
        },
        component: this,
        label: "text"
      })), l.tooltext ? f.enableToolTip(a, l.tooltext) : f.disableToolTip(a), s === v ? C.lastLabel.graphic = a : s === y && (C.firstLabel.graphic = a), w.push(i);
    }

    for (e = 0, n = (c = (0, r["default"])(d.prevIntervalArr, w)).length; e < n; e++) {
      (o = this.getGraphicalElement(c[e])) && this.removeGraphicalElement(o);
    }

    d.prevIntervalArr = w;
  }, t.setTickValues = function (e) {
    var t,
        n,
        a = e && e.length,
        o = this.config,
        r = o.startPad || 0,
        l = this.getFromEnv("chart"),
        c = 0,
        u = o.tickValues = {},
        h = u.tickValue = [],
        d = u.vline = [],
        p = u.tickIdMap = {},
        f = o.endPad || 0;

    for (o.hasCategory = 1, t = 0; t < a; t += 1) {
      (n = (0, i.extend2)({}, e[t])).vline ? (n.startIndex = h.length - 1, d.push(n)) : (n.id && (p[n.id.toLowerCase()] = {
        tickObj: n,
        index: c
      }), (o.mapTickValuesById && n.id || !o.mapTickValuesById) && (s(n, l), h.push(n), h[c].label = (0, i.parseUnsafeString)(h[c].label), c += 1));
    }

    o.oriCatLen = c, this._setAxisRange({
      max: Number((0, i.toPrecision)(c - 1 + f, 10)),
      min: Number((0, i.toPrecision)(0 - r, 10)),
      tickInterval: Number((0, i.toPrecision)(1, 10))
    });
  }, t.shiftLabels = function (e, t) {
    var n = this.config.labels;
    n.shiftX = e, n.shiftY = t;
  }, t._createContainer = function () {
    var e,
        t,
        n,
        a,
        i,
        o = this.config,
        r = o.isVertical,
        l = this.getLinkedParent().getChildContainer(),
        s = l.axisBottomGroup,
        c = l.axisTopGroup,
        u = -this.getTranslation(),
        h = r ? "T0," + u : "T" + u + ",0";
    t = this.createContainer("axisNameGroup", {
      name: "dataset-Name-group"
    }, s), e = this.createContainer("axisLineGroup", {
      name: "axis-Line-group"
    }, c), n = this.createContainer("axisTrendGroupTop", {
      name: "dataset-Trend-group-top"
    }, c), a = this.createContainer("axisLabelGroup", {
      name: "dataset-Label-group"
    }, s), i = this.createContainer("axisLabelGroupTop", {
      name: "dataset-Label-group"
    }, c), this.getGraphicalElement("scrollerContainer") || this.addGraphicalElement("scrollerContainer", this.createGroup("scrollerContainer", {
      name: "scroller-container"
    }, e, "scroller")), o.axisContainer = this.createGroup("axisContainer", {
      name: "dataset-axis",
      transform: h
    }, a), o.axisLabelContainerTop = this.createGroup("axisLabelContainerTop", {
      name: "dataset-top-label",
      transform: h
    }, i), o.axisAxisLineContainer = this.createGroup("axisAxisLineContainer", {
      name: "axis-line-tick"
    }, e), o.axisTrendLabelContainer = this.createGroup("axisTrendLabelContainer", {
      name: "dataset-axis-trend-label"
    }, n), o.axisNameContainer = this.createGroup("axisNameContainer", {
      name: "dataset-axis-name"
    }, t), o.axisAxisLineContainerBottom = this.createGroup("axisAxisLineContainerBottom", {
      name: "axis-line-tick-bottom"
    }, s);
  }, t.setAxisPadding = function () {
    var e,
        t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0,
        n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0,
        a = this.config,
        i = this.getScale().getDomain(),
        o = i[0],
        r = i[1];
    1 === a.oriCatLen && (0 === t && (t = .5), 0 === n && (n = .5)), e = t - a.startPad, a.startPad = Math.max(a.startPad, t), a.endPad = Math.max(a.endPad, n), e > 0 && (a.setPadding = !0, this._setAxisRange({
      min: o - e,
      max: r + e
    })), a.tickValues || a.originalMax && a.originalMin && this.setDataLimit(a.originalMax, a.originalMin);
  }, t.getLabel = function (e) {
    var t = this.config,
        n = t.tickValues && t.tickValues.tickValue[e],
        a = {};
    return n && n.tooltext && (a.label = n.label, n.tooltext = (0, i.parseTooltext)(n.tooltext, [3], a)), {
      label: n && (n.oriLabel || n.label),
      tooltext: n && n.tooltext
    };
  }, t.extractStyleInfo = s, t._parseLabel = function () {
    var e,
        t,
        n,
        a,
        o,
        r,
        s,
        c,
        u,
        h,
        d,
        p,
        f,
        g,
        m,
        b,
        v = this,
        y = v.config,
        x = v.getLinkedItem("canvas").getEffectiveDimensions(),
        C = y.axisDimention,
        k = v.getFromEnv("chart"),
        w = k.config,
        S = y.axisRange,
        _ = y.isOpposit,
        L = y.labels,
        P = v.components,
        A = P.labels,
        N = L.style,
        E = k.getFromEnv("smartLabel"),
        F = y.isVertical,
        O = S.max,
        T = S.min,
        D = v.getFromEnv("number-formatter"),
        M = x.top,
        I = x.left,
        R = M + x.height,
        V = I + x.width,
        B = y.labelPadding,
        j = y.extremeLabels,
        G = F ? C.x : C.y,
        H = C.opposite,
        z = y.labelMaxH,
        W = y.labelMaxW,
        q = S.tickInterval,
        U = Math.abs(v.getPixel(T, l) - v.getPixel(T + q, l)),
        Y = [],
        X = y.ticks,
        K = 0,
        Z = y.isReverse,
        J = (0, i.pluckNumber)(v.getFromEnv("chart-attrib").showzeroplanevalue),
        $ = !0,
        Q = v.getLimit();

    if (E.useEllipsesOnOverflow(w.useEllipsesWhenOverflow), E.setStyle({
      fontSize: N.fontSize,
      fontFamily: N.fontFamily,
      lineHeight: N.lineHeight,
      fontWeight: N.fontWeight
    }), (a = N.lineHeight) && -1 !== a.indexOf("px") && (a = parseFloat(a.replace("px", ""))), 0 === J && ($ = !1), y.labels.isDraw) {
      if (y.drawLabelsOpposit && (_ = !_, G = H), u = {
        fill: N.color,
        "line-height": a,
        "font-size": N.fontSize,
        opacity: 1
      }, n = y.labels.rotation, F ? (y.labelMaxH > U && !y.tickValues && (s = Math.ceil(y.labelMaxH / U)), u["text-anchor"] = _ ? i.POSITION_START : i.POSITION_END) : (y.labelMaxW > U && !y.tickValues && (s = Math.ceil(y.labelMaxW / U)), n ? (u["text-anchor"] = _ ? i.POSITION_START : i.POSITION_END, u["vertical-align"] = "middle") : u["vertical-align"] = _ ? i.POSITION_BOTTOM : i.POSITION_TOP, d = I, p = w.width - V), s > y.labels.step && (y.labels.step = s), c = y.numberFormatterFn ? D[y.numberFormatterFn] : y.isPercent ? D.yAxisPercentValue : F ? D.yAxis : D.xAxis, j.firstLabel = {}, j.lastLabel = {}, b = X.filter(function (e, t, n) {
        return 0 !== e || y.showZeroPlaneValue ? !(!F && t !== n.length - 1 && v.getPixel(e, l) + y.labelMaxW > V || (t % y.labels.step == 0 ? (Y[K++] = t, 0) : !y.labels.drawLimitVal || 0 !== t && t !== n.length - 1 || (Y[K++] = t, 0))) : !(!$ || $ && Q.max !== e && Q.min !== e || (Y[K++] = t, 0));
      }), y.isZeroTickForced && -1 !== b.indexOf(0)) {
        var ee = void 0;
        K = 0, Y = [], m = v.getPixel(0), b = b.filter(function (e, t, n) {
          return ee = v.getPixel(e), 0 === n[t + 1] || 0 === n[t - 1] ? F ? !(ee + z >= m && m >= ee - z || (Y[K++] = t, 0)) : !(ee + W >= m && m >= ee - W || (Y[K++] = t, 0)) : (Y[K++] = t, !0);
        });
      }

      for (o = (F ? W : U / 2) * y.labels.step, r = F ? U / 2 : z, P.labelIndexArr = Y.slice(), e = 0, t = b.length; e < t; e += 1) {
        f = b[e], A[Y[e]] = A[Y[e]] || {
          config: {
            props: {
              label: {}
            }
          }
        }, h = Object.assign({}, u), g = i.UNDEF, (y.labels.drawNormalVal || f === T || f === O) && (y.labels.drawLimitVal || f !== T && f !== O) ? f === T && y.lowerLimitDisplay && y.labels.drawLimitVal ? (g = E.getSmartText(y.lowerLimitDisplay, o, r + a / 2), h.text = g.text, h.tooltext = g.tooltext) : f === O && y.upperLimitDisplay && y.labels.drawLimitVal ? (g = E.getSmartText(y.upperLimitDisplay, o, r + a / 2), h.text = g.text, h.tooltext = g.tooltext) : (h.text = "" + c.call(D, f, y.axisIndex), g = E.getOriSize(h.text)) : h.text = "", F ? (h.x = _ ? (G || V) + B : (G || I) - B, h.y = v.getPixel(f, l), (Z && f === T && y.lowerLimitDisplay || !Z && f === O && y.upperLimitDisplay) && g && g.height > a && (h["vertical-align"] = i.POSITION_BOTTOM), (Z && f === O && y.upperLimitDisplay || !Z && f === T && y.lowerLimitDisplay) && g && g.height > a && (h["vertical-align"] = i.POSITION_TOP), y.placeValuesInside && (h["text-anchor"] = _ ? i.POSITION_END : i.POSITION_START)) : (h.x = v.getPixel(f, l), h.y = _ ? (G || M) - B : (G || R) + B, (!Z && f === T || Z && f === O) && g && g.width > 2 * d && (h["text-anchor"] = i.POSITION_START), (!Z && f === O || Z && f === T) && g && g.width > 2 * p && (h["text-anchor"] = i.POSITION_END), y.placeValuesInside ? h["vertical-align"] = _ ? i.POSITION_TOP : i.POSITION_BOTTOM : h["vertical-align"] = _ ? i.POSITION_BOTTOM : i.POSITION_TOP), L.shiftX && (h.x += L.shiftX), L.shiftY && (h.y += L.shiftY), h.transform = (0, i.getSuggestiveRotation)(n, h.x, h.y), A[Y[e]].config.props.label.attr = h;
      }
    }
  };
}, function (e, t, n) {
  var a = n(388),
      i = n(199)(function (e, t) {
    for (var n = [], i = 0, o = e.length; i < o;) {
      a(e[i], t) || a(e[i], n) || (n[n.length] = e[i]), i += 1;
    }

    return n;
  });
  e.exports = i;
}, function (e, t, n) {
  var a = n(389);

  e.exports = function (e, t) {
    return a(t, e, 0) >= 0;
  };
}, function (e, t, n) {
  var a = n(390);

  e.exports = function (e, t, n) {
    var i, o;
    if ("function" == typeof e.indexOf) switch (typeof t) {
      case "number":
        if (0 === t) {
          for (i = 1 / t; n < e.length;) {
            if (0 === (o = e[n]) && 1 / o === i) return n;
            n += 1;
          }

          return -1;
        }

        if (t != t) {
          for (; n < e.length;) {
            if ("number" == typeof (o = e[n]) && o != o) return n;
            n += 1;
          }

          return -1;
        }

        return e.indexOf(t, n);

      case "string":
      case "boolean":
      case "function":
      case "undefined":
        return e.indexOf(t, n);

      case "object":
        if (null === t) return e.indexOf(t, n);
    }

    for (; n < e.length;) {
      if (a(e[n], t)) return n;
      n += 1;
    }

    return -1;
  };
}, function (e, t, n) {
  var a = n(199),
      i = n(391),
      o = a(function (e, t) {
    return i(e, t, [], []);
  });
  e.exports = o;
}, function (e, t, n) {
  var a = n(392),
      i = n(385),
      o = n(393),
      r = n(206),
      l = n(394),
      s = n(395),
      c = n(397);

  function u(e, t, n, o) {
    var r = a(e),
        l = a(t);

    function s(e, t) {
      return h(e, t, n.slice(), o.slice());
    }

    return !i(function (e, t) {
      return !i(s, t, e);
    }, l, r);
  }

  function h(e, t, n, a) {
    if (l(e, t)) return !0;
    var i = c(e);
    if (i !== c(t)) return !1;
    if (null == e || null == t) return !1;
    if ("function" == typeof e["fantasy-land/equals"] || "function" == typeof t["fantasy-land/equals"]) return "function" == typeof e["fantasy-land/equals"] && e["fantasy-land/equals"](t) && "function" == typeof t["fantasy-land/equals"] && t["fantasy-land/equals"](e);
    if ("function" == typeof e.equals || "function" == typeof t.equals) return "function" == typeof e.equals && e.equals(t) && "function" == typeof t.equals && t.equals(e);

    switch (i) {
      case "Arguments":
      case "Array":
      case "Object":
        if ("function" == typeof e.constructor && "Promise" === o(e.constructor)) return e === t;
        break;

      case "Boolean":
      case "Number":
      case "String":
        if (typeof e != typeof t || !l(e.valueOf(), t.valueOf())) return !1;
        break;

      case "Date":
        if (!l(e.valueOf(), t.valueOf())) return !1;
        break;

      case "Error":
        return e.name === t.name && e.message === t.message;

      case "RegExp":
        if (e.source !== t.source || e.global !== t.global || e.ignoreCase !== t.ignoreCase || e.multiline !== t.multiline || e.sticky !== t.sticky || e.unicode !== t.unicode) return !1;
    }

    for (var d = n.length - 1; d >= 0;) {
      if (n[d] === e) return a[d] === t;
      d -= 1;
    }

    switch (i) {
      case "Map":
        return e.size === t.size && u(e.entries(), t.entries(), n.concat([e]), a.concat([t]));

      case "Set":
        return e.size === t.size && u(e.values(), t.values(), n.concat([e]), a.concat([t]));

      case "Arguments":
      case "Array":
      case "Object":
      case "Boolean":
      case "Number":
      case "String":
      case "Date":
      case "Error":
      case "RegExp":
      case "Int8Array":
      case "Uint8Array":
      case "Uint8ClampedArray":
      case "Int16Array":
      case "Uint16Array":
      case "Int32Array":
      case "Uint32Array":
      case "Float32Array":
      case "Float64Array":
      case "ArrayBuffer":
        break;

      default:
        return !1;
    }

    var p = s(e);
    if (p.length !== s(t).length) return !1;
    var f = n.concat([e]),
        g = a.concat([t]);

    for (d = p.length - 1; d >= 0;) {
      var m = p[d];
      if (!r(m, t) || !h(t[m], e[m], f, g)) return !1;
      d -= 1;
    }

    return !0;
  }

  e.exports = h;
}, function (e, t) {
  e.exports = function (e) {
    for (var t, n = []; !(t = e.next()).done;) {
      n.push(t.value);
    }

    return n;
  };
}, function (e, t) {
  e.exports = function (e) {
    var t = String(e).match(/^function (\w*)/);
    return null == t ? "" : t[1];
  };
}, function (e, t, n) {
  var a = n(199)(function (e, t) {
    return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
  });
  e.exports = a;
}, function (e, t, n) {
  var a = n(200),
      i = n(206),
      o = n(396),
      r = !{
    toString: null
  }.propertyIsEnumerable("toString"),
      l = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
      s = function () {
    "use strict";

    return arguments.propertyIsEnumerable("length");
  }(),
      c = function c(e, t) {
    for (var n = 0; n < e.length;) {
      if (e[n] === t) return !0;
      n += 1;
    }

    return !1;
  },
      u = a("function" != typeof Object.keys || s ? function (e) {
    if (Object(e) !== e) return [];
    var t,
        n,
        a = [],
        u = s && o(e);

    for (t in e) {
      !i(t, e) || u && "length" === t || (a[a.length] = t);
    }

    if (r) for (n = l.length - 1; n >= 0;) {
      i(t = l[n], e) && !c(a, t) && (a[a.length] = t), n -= 1;
    }
    return a;
  } : function (e) {
    return Object(e) !== e ? [] : Object.keys(e);
  });

  e.exports = u;
}, function (e, t, n) {
  var a = n(206),
      i = Object.prototype.toString;

  e.exports = function () {
    return "[object Arguments]" === i.call(arguments) ? function (e) {
      return "[object Arguments]" === i.call(e);
    } : function (e) {
      return a("callee", e);
    };
  };
}, function (e, t, n) {
  var a = n(200)(function (e) {
    return null === e ? "Null" : e === undefined ? "Undefined" : Object.prototype.toString.call(e).slice(8, -1);
  });
  e.exports = a;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;

  t["default"] = function () {
    var e,
        t = void 0,
        n = void 0,
        a = void 0,
        i = void 0,
        o = [];
    if (arguments.length > 2 ? (t = arguments.length <= 0 ? undefined : arguments[0], n = arguments.length <= 1 ? undefined : arguments[1], a = arguments.length <= 2 ? undefined : arguments[2]) : 1 === arguments.length ? (t = 0, n = arguments.length <= 0 ? undefined : arguments[0], a = 1) : (t = arguments.length <= 0 ? undefined : arguments[0], n = arguments.length <= 1 ? undefined : arguments[1], a = 1), e = Math.floor(Math.max(0, Math.ceil((n - t) / a))), isFinite(e)) for (i = 0; i < e; ++i) {
      o.push(a * i + t);
    }
    return o;
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(400),
      i = c(a),
      o = n(416),
      r = c(o),
      l = c(n(382)),
      s = n(417);

  function c(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function u(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var h = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this, a.deInterpolateLinear, l["default"]));
    }

    return u(t, e), t.prototype.ticks = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7,
          t = this.getDomain();
      return this.majorTicks = (0, r["default"])(t[0], t[t.length - 1], e);
    }, t.prototype.tickFormat = function (e, t) {
      return (0, s.tickFormat)(this.getDomain(), e, t, this._localeConverter);
    }, t.prototype.nice = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7,
          t = this.getDomain(),
          n = 0,
          a = t.length - 1,
          i = t[n],
          r = t[a],
          l = void 0;
      return r < i && (l = i, i = r, r = l, l = n, n = a, a = l), (l = (0, o.tickIncrement)(i, r, e)) > 0 ? (i = Math.floor(i / l) * l, r = Math.ceil(r / l) * l, l = (0, o.tickIncrement)(i, r, e)) : l < 0 && (i = Math.ceil(i * l) / l, r = Math.floor(r * l) / l, l = (0, o.tickIncrement)(i, r, e)), l > 0 ? (t[n] = Math.floor(i / l) * l, t[a] = Math.ceil(r / l) * l, this.setDomain(t)) : l < 0 && (t[n] = Math.ceil(i * l) / l, t[a] = Math.floor(r * l) / l, this.setDomain(t)), this;
    }, t.prototype.copy = function () {
      return (0, a.copyScale)(this, new t());
    }, t.prototype.minorTicks = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4,
          t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.majorTicks || this.ticks(),
          n = t.length,
          a = t[1] - t[0],
          i = [],
          o = void 0,
          r = void 0,
          l = void 0,
          s = void 0;

      for (s = 0; s < n - 1; ++s) {
        for (l = t[s], r = a / (Number(e) + 1), o = 1; o <= e; o += 1) {
          i.push(l + r * o);
        }
      }

      return i;
    }, t.prototype.contextTicks = function () {
      return this.contextTicksArr || [];
    }, t.prototype.getType = function () {
      return "linear";
    }, t;
  }(i["default"]);

  t["default"] = h;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.bimap = t.deInterpolateLinear = t.copyScale = undefined;
  var a = s(n(401)),
      i = s(n(403)),
      o = s(n(402)),
      r = s(n(404)),
      l = n(405);

  function s(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var c = 0,
      u = [0, 1];

  function h(e, t, n, a) {
    var i, o;
    return e[0] > e[1] ? (i = n(e[1], e[0]), o = a(t[1], t[0])) : (i = n(e[0], e[1]), o = a(t[0], t[1])), function (e) {
      return o(i(e));
    };
  }

  function d(e, t) {
    e = Number(e);
    var n = (t = Number(t)) - e;
    return n ? function (t) {
      return (t - e) / n;
    } : (0, o["default"])(n);
  }

  var p = function () {
    function e(t, n) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.domain = u, this.range = u, this.deInterpolate = t, this.reInterpolate = n, this.interpolate = a["default"], this.clamp = !1, this.input = null, this.output = null, this.locale = r["default"], this._localeConverter = new l.NumberConverter(r["default"]), this._rescale(), this._id = "scale_" + c++;
    }

    return e.prototype._rescale = function () {
      return this.input = null, this.output = null, this;
    }, e.prototype.setDomain = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : u;
      return this.domain = e.map(Number), this._rescale();
    }, e.prototype.getDomain = function () {
      return this.domain.slice();
    }, e.prototype.setRange = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : u;
      return this.range = e.slice(), this._rescale();
    }, e.prototype.getRange = function () {
      return this.range.slice();
    }, e.prototype.setInterpolate = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : a["default"];
      return this.interpolate = e, this._rescale();
    }, e.prototype.getInterpolate = function () {
      return this.interpolate;
    }, e.prototype.setClamp = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined && arguments[0];
      return this.clamp = !!e, this._rescale();
    }, e.prototype.getClamp = function () {
      return this.clamp;
    }, e.prototype.rangeRound = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : u;
      return this.range = e.slice(), this.interpolate = i["default"], this._rescale();
    }, e.prototype.getRangeValue = function (e) {
      e = null !== e ? e : undefined;
      var t = this.getClamp() ? function (e) {
        return function (t, n) {
          t = Number(t), n = Number(n);
          var a = e(t, n);
          return function (e) {
            return e <= t ? 0 : e >= n ? 1 : a(e);
          };
        };
      }(this.deInterpolate) : this.deInterpolate;
      return this.output || (this.output = h(this.getDomain(), this.getRange(), t, this.interpolate)), this.output(Number(e));
    }, e.prototype.getDomainValue = function (e) {
      var t = this.getClamp() ? function (e) {
        return function (t, n) {
          t = Number(t), n = Number(n);
          var a = e(t, n);
          return function (e) {
            return e <= 0 ? t : e >= 1 ? n : a(e);
          };
        };
      }(this.reInterpolate) : this.reInterpolate;
      return this.input || (this.input = h(this.getRange(), this.getDomain(), d, t)), this.input(Number(e));
    }, e.prototype.setLocale = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : r["default"];
      return this.locale = e, this._localeConverter = new l.NumberConverter(e), this;
    }, e.prototype.getLocale = function () {
      return this.locale;
    }, e.prototype.getId = function () {
      return this._id;
    }, e;
  }();

  t.copyScale = function (e, t) {
    return t.setInterpolate(e.getInterpolate()).setClamp(e.getClamp()).setDomain(e.getDomain()).setRange(e.getRange());
  }, t.deInterpolateLinear = d, t.bimap = h, t["default"] = p;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = o(n(382)),
      i = o(n(402));

  function o(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function r(e) {
    return null !== e && void 0 !== e;
  }

  t["default"] = function (e, t) {
    var n = a["default"];
    return r(t) && r(e) && "boolean" != typeof t ? n(e, t) : (0, i["default"])(t);
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;

  t["default"] = function (e) {
    return function () {
      return e;
    };
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e, t) {
    e = Number(e);
    var n = (t = Number(t)) - e;
    return function (t) {
      return Math.round(n * t + e);
    };
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  t["default"] = {
    decimal: ".",
    thousands: ",",
    grouping: [3],
    prefix: "$",
    suffix: ""
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.NumberConverter = undefined;
  var a = u(n(404)),
      i = u(n(406)),
      o = u(n(408)),
      r = u(n(414)),
      l = u(n(415)),
      s = u(n(409)),
      c = n(125);

  function u(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var h = function h(e) {
    return e;
  },
      d = function () {
    function e(t) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.localeInfo = {
        group: t.grouping && t.thousands ? (0, r["default"])(t.grouping, t.thousands) : h,
        prefix: t.prefix,
        suffix: t.suffix,
        decimal: t.decimal,
        numerals: t.numerals ? (0, l["default"])(t.numerals) : h,
        percent: t.percent || "%",
        prefixes: t.prefixes || ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"]
      };
    }

    return e.prototype.formatter = function (e) {
      return new o["default"](e, this.localeInfo);
    }, e.prototype.formatPrefix = function (e, t) {
      (e = new s["default"](e)).type = "f";
      var n = this.localeInfo.prefix,
          a = this.localeInfo.suffix,
          r = (0, c.extend2)((0, c.extend2)({}, this.localeInfo), {
        prefix: "",
        suffix: ""
      }),
          l = new o["default"](e, r),
          u = 3 * Math.max(-8, Math.min(8, Math.floor((0, i["default"])(t) / 3))),
          h = Math.pow(10, -u),
          d = this.localeInfo.prefixes[8 + u / 3];
      return {
        format: function format(e) {
          return n + l.format(h * e) + d + a;
        },
        setCustomPrefix: function setCustomPrefix(e) {
          return l.setCustomPrefix(e), this;
        },
        getCustomPrefix: function getCustomPrefix(e) {
          return l.getCustomPrefix(e);
        },
        setCustomSuffix: function setCustomSuffix(e) {
          return l.setCustomSuffix(e), this;
        },
        getCustomSuffix: function getCustomSuffix(e) {
          return l.getCustomSuffix(e);
        }
      };
    }, e;
  }();

  t.NumberConverter = d, t["default"] = new d(a["default"]);
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(407),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };

  t["default"] = function (e) {
    return (e = (0, o["default"])(Math.abs(e))) ? e[1] : NaN;
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;

  t["default"] = function (e, t) {
    var n,
        a = void 0;
    return (n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0 ? null : [(a = e.slice(0, n)).length > 1 ? a[0] + a.slice(2) : a, +e.slice(n + 1)];
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = l(n(409)),
      i = l(n(410)),
      o = l(n(413)),
      r = n(411);

  function l(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var s = function s(e) {
    return void 0 === e || null === e;
  },
      c = function () {
    function e(t, n) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.specifier = new a["default"](t), this.localeInfo = n;
      var o = this.specifier.symbol;
      this.fill = this.specifier.fill, this.align = this.specifier.align, this.sign = this.specifier.sign, this.zero = this.specifier.zero, this.width = this.specifier.width, this.comma = this.specifier.comma, this.precision = this.specifier.precision, this.trim = this.specifier.trim, this.type = this.specifier.type, "n" === this.type ? (this.comma = !0, this.type = "g") : i["default"][this.type] || (s(this.precision) && (this.precision = 12), this.trim = !0, this.type = "g"), (this.zero || "0" === this.fill && "=" === this.align) && (this.zero = !0, this.fill = "0", this.align = "="), "$" === o ? this.prefix = this.localeInfo.prefix : "#" === o && /[boxX]/.test(this.type) ? this.prefix = "0" + this.type.toLowerCase() : this.prefix = "", "$" === o ? this.suffix = this.localeInfo.suffix : /[%p]/.test(this.type) ? this.suffix = this.localeInfo.percent : this.suffix = "", this.formatType = i["default"][this.type], this.mayHaveSuffix = /[defgprs%]/.test(this.type), s(this.precision) ? this.precision = 6 : /[gprs]/.test(this.type) ? this.precision = Math.max(1, Math.min(21, this.precision)) : this.precision = Math.max(0, Math.min(20, this.precision)), this.setCustomPrefix(""), this.setCustomSuffix("");
    }

    return e.prototype.format = function (e) {
      var t = this.prefix,
          n = this.suffix,
          a = this.formatType,
          i = void 0,
          l = void 0,
          s = void 0,
          c = void 0,
          u = void 0,
          h = void 0;
      if ("c" === this.type) n = a(e) + n, e = "";else if (i = (e = +e) < 0, e = a(Math.abs(e), this.precision), this.trim && (e = (0, o["default"])(e)), i && 0 == +e && (i = !1), t = i ? ("(" === this.sign ? this.sign : "-") + t : "-" === this.sign || "(" === this.sign ? "" + t : this.sign + t, n = "s" === this.type ? this.localeInfo.prefixes[8 + r.prefixExponent / 3] + n : "" + n, n += i && "(" === this.sign ? ")" : "", this.mayHaveSuffix) for (c = -1, u = e.length; ++c < u;) {
        if ((h = e.charCodeAt(c)) < 48 || h > 57) {
          n = (46 === h ? this.localeInfo.decimal + e.slice(c + 1) : e.slice(c)) + n, e = e.slice(0, c);
          break;
        }
      }

      switch (this.comma && !this.zero && (e = this.localeInfo.group(e, Infinity)), s = (l = t.length + e.length + n.length) < this.width ? new Array(this.width - l + 1).join(this.fill) : "", this.comma && this.zero && (e = this.localeInfo.group(s + e, s.length ? this.width - n.length : Infinity), s = ""), this.align) {
        case "<":
          e = t + e + n + s;
          break;

        case "=":
          e = t + s + e + n;
          break;

        case "^":
          l = s.length / 2, e = s.slice(0, l) + t + e + n + s.slice(l);
          break;

        default:
          e = s + t + e + n;
      }

      return this.getCustomPrefix() + this.localeInfo.numerals(e) + this.getCustomSuffix();
    }, e.prototype.setCustomPrefix = function (e) {
      return this._customPrefix = e + "", this;
    }, e.prototype.getCustomPrefix = function () {
      return this._customPrefix;
    }, e.prototype.setCustomSuffix = function (e) {
      return this._customSuffix = e + "", this;
    }, e.prototype.getCustomSuffix = function () {
      return this._customSuffix;
    }, e.prototype.toString = function () {
      return this.specifier.toString();
    }, e;
  }();

  t["default"] = c;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;

  var a = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i,
      i = function i(e) {
    return void 0 === e || null === e;
  },
      o = function () {
    function e(t) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e);
      var n = a.exec(t);
      if (!n) throw new Error("Invalid number format specifier: " + t);
      this.fill = n[1] || " ", this.align = n[2] || ">", this.sign = n[3] || "-", this.symbol = n[4] || "", this.zero = Boolean(n[5]), this.width = n[6] && Number(n[6]), this.comma = Boolean(n[7]), this.precision = n[8] && Number(n[8].slice(1)), this.trim = Boolean(n[9]), this.type = n[10] || "";
    }

    return e.prototype.toString = function () {
      return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (i(this.width) ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (i(this.precision) ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
    }, e;
  }();

  t["default"] = o;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = o(n(411)),
      i = o(n(412));

  function o(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  t["default"] = {
    "%": function _(e, t) {
      return (100 * e).toFixed(t);
    },
    b: function b(e) {
      return Math.round(e).toString(2);
    },
    c: function c(e) {
      return e + "";
    },
    d: function d(e) {
      return Math.round(e).toString(10);
    },
    e: function e(_e3, t) {
      return _e3.toExponential(t);
    },
    f: function f(e, t) {
      return e.toFixed(t);
    },
    g: function g(e, t) {
      return e.toPrecision(t);
    },
    o: function o(e) {
      return Math.round(e).toString(8);
    },
    p: function p(e, t) {
      return (0, i["default"])(100 * e, t);
    },
    r: i["default"],
    s: a["default"],
    X: function X(e) {
      return Math.round(e).toString(16).toUpperCase();
    },
    x: function x(e) {
      return Math.round(e).toString(16);
    }
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.prefixExponent = undefined;
  var a,
      i = n(407),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };
  var r = void 0;
  t.prefixExponent = r, t["default"] = function (e, n) {
    var a,
        i,
        l,
        s = (0, o["default"])(e, n),
        c = void 0;
    return s ? (c = s[0], (i = (a = s[1]) - (t.prefixExponent = r = 3 * Math.max(-8, Math.min(8, Math.floor(a / 3)))) + 1) === (l = c.length) ? c : i > l ? c + new Array(i - l + 1).join("0") : i > 0 ? c.slice(0, i) + "." + c.slice(i) : "0." + new Array(1 - i).join("0") + (0, o["default"])(e, Math.max(0, n + i - 1))[0]) : e + "";
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(407),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };

  t["default"] = function (e, t) {
    var n,
        a = (0, o["default"])(e, t),
        i = void 0;
    return a ? (i = a[0], n = a[1], Number(n) < 0 ? "0." + new Array(-n).join("0") + i : i.length > n + 1 ? i.slice(0, n + 1) + "." + i.slice(n + 1) : i + new Array(n - i.length + 2).join("0")) : e + "";
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    for (var t = e.length, n = 1, a = -1, i = void 0; n < t; ++n) {
      if ("." === e[n]) a = i = n;else if ("0" === e[n]) 0 === a && (a = n), i = n;else if (a > 0) {
        if (!+e[n]) break;
        a = 0;
      }
    }

    return a > 0 ? e.slice(0, a) + e.slice(i + 1) : e;
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;

  t["default"] = function (e, t) {
    return function (n, a) {
      for (var i = n.length, o = [], r = 0, l = e[0], s = 0; i > 0 && l > 0 && (s + l + 1 > a && (l = Math.max(1, a - s)), o.push(n.substring(i -= l, i + l)), !((s += l + 1) > a));) {
        l = e[r = (r + 1) % e.length];
      }

      return o.reverse().join(t);
    };
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;

  t["default"] = function (e) {
    return function (t) {
      return t.replace(/[0-9]/g, function (t) {
        return e[+t];
      });
    };
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = Math.sqrt(50),
      i = Math.sqrt(10),
      o = Math.sqrt(2);

  function r(e) {
    return e >= a ? 10 : e >= i ? 5 : e >= o ? 2 : 1;
  }

  function l() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0,
        t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1,
        n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7,
        a = (t - e) / Math.max(0, n),
        i = Math.floor(Math.log(a) / Math.LN10),
        o = a / Math.pow(10, i);
    return i >= 0 ? r(o) * Math.pow(10, i) : -Math.pow(10, -i) / r(o);
  }

  t["default"] = function () {
    var e,
        t,
        n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0,
        a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1,
        i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7,
        o = -1,
        r = void 0,
        s = [];
    if (i = +i, (n = +n) == (a = +a) && i > 0) return [n];
    if ((e = a < n) && (r = n, n = a, a = r), 0 === (t = l(n, a, i)) || !isFinite(t)) return [];
    if (t > 0) for (n = Math.ceil(n / t), a = Math.floor(a / t), r = Math.ceil(a - n + 1); ++o < r;) {
      s[o] = (n + o) * t;
    } else for (n = Math.floor(n * t), a = Math.ceil(a * t), r = Math.ceil(n - a + 1); ++o < r;) {
      s[o] = (n - o) / t;
    }
    return e && s.reverse(), s;
  }, t.tickIncrement = l, t.tickStep = function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0,
        t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1,
        n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7,
        r = Math.abs(t - e) / Math.max(0, n),
        l = Math.floor(Math.log(r) / Math.LN10),
        s = Math.pow(10, l),
        c = r / s;
    return c >= a ? s *= 10 : c >= i ? s *= 5 : c >= o && (s *= 2), t < e ? -s : s;
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.tickFormat = t.tickStep = t.tickIncrement = undefined;
  var a = s(n(405)),
      i = s(n(418)),
      o = s(n(419)),
      r = s(n(409)),
      l = s(n(420));

  function s(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var c = Math.sqrt(50),
      u = Math.sqrt(10),
      h = Math.sqrt(2),
      d = function d(e) {
    return null === e || void 0 === e;
  };

  function p(e) {
    return e >= c ? 10 : e >= u ? 5 : e >= h ? 2 : 1;
  }

  function f() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0,
        t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1,
        n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7,
        a = (t - e) / Math.max(0, n),
        i = Math.floor(Math.log(a) / Math.LN10),
        o = a / Math.pow(10, i);
    return i >= 0 ? p(o) * Math.pow(10, i) : -Math.pow(10, -i) / p(o);
  }

  function g() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0,
        t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1,
        n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7,
        a = Math.abs(t - e) / Math.max(0, n),
        i = Math.floor(Math.log(a) / Math.LN10),
        o = Math.pow(10, i),
        r = a / o;
    return r >= c ? o *= 10 : r >= u ? o *= 5 : r >= h && (o *= 2), t < e ? -o : o;
  }

  t["default"] = function () {
    var e,
        t,
        n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0,
        a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1,
        i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7,
        o = -1,
        r = void 0,
        l = [];
    if (i = +i, (n = +n) == (a = +a) && i > 0) return [n];
    if ((e = a < n) && (r = n, n = a, a = r), 0 === (t = f(n, a, i)) || !isFinite(t)) return [];
    if (t > 0) for (n = Math.ceil(n / t), a = Math.floor(a / t), r = Math.ceil(a - n + 1); ++o < r;) {
      l[o] = (n + o) * t;
    } else for (n = Math.floor(n * t), a = Math.ceil(a * t), r = Math.ceil(n - a + 1); ++o < r;) {
      l[o] = (n - o) / t;
    }
    return e && l.reverse(), l;
  }, t.tickIncrement = f, t.tickStep = g, t.tickFormat = function (e, t, n) {
    var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : a["default"],
        c = e[0],
        u = e[e.length - 1],
        h = g(c, u, d(t) ? 7 : t),
        p = void 0,
        f = void 0;

    switch ((n = new r["default"](d(n) ? ",f" : n)).type) {
      case "s":
        return f = Math.max(Math.abs(c), Math.abs(u)), p = (0, l["default"])(h, f), d(n.precision) && !isNaN(p) && (n.precision = p), function (e) {
          return s.formatPrefix(n, f).format(e);
        };

      case "":
      case "e":
      case "g":
      case "p":
      case "r":
        p = (0, o["default"])(h, Math.max(Math.abs(c), Math.abs(u))), d(n.precision) && !isNaN(p) && (n.precision = p - ("e" === n.type));
        break;

      case "f":
      case "%":
        p = (0, i["default"])(h), d(n.precision) && !isNaN(p) && (n.precision = p - 2 * ("%" === n.type));
    }

    return function (e) {
      return s.formatter(n).format(e);
    };
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(406),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };

  t["default"] = function (e) {
    return Math.max(0, -(0, o["default"])(Math.abs(e)));
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(406),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };

  t["default"] = function (e, t) {
    return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, (0, o["default"])(t) - (0, o["default"])(e)) + 1;
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(406),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };

  t["default"] = function (e, t) {
    return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor((0, o["default"])(t) / 3))) - (0, o["default"])(Math.abs(e)));
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = l(n(398)),
      i = n(125),
      o = n(400),
      r = l(n(382));

  function l(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var s = (0, o.bimap)([2, 100], [80, 20], o.deInterpolateLinear, r["default"]);

  t["default"] = function (e, t, n, o) {
    var r,
        l,
        c,
        u,
        h,
        d,
        p,
        f,
        g,
        m,
        b,
        v,
        y,
        x,
        C,
        k,
        w,
        S,
        _,
        L,
        P,
        A,
        N,
        E = o.isPercent ? 0 : o.axisMinValue,
        F = o.isPercent ? 100 : o.axisMaxValue,
        O = !!o.adjustDiv,
        T = o.numDivLines,
        D = !!o.setAdaptiveMin,
        M = o.axisRange,
        I = Math.pow(2, -24),
        R = !0,
        V = .2,
        B = !0,
        j = o.xAxisLabelMode,
        G = o.dependentInfo;

    if (r = o.majorTMNumber !== i.UNDEF ? Math.max(0, T - 2) : T, G && G.count && !G.limit && G.numDivLines !== i.UNDEF && (r = T = G.numDivLines, O = !1), l = r + 1, e === i.UNDEF && t === i.UNDEF && (e = 0, t = 1, R = !1), t === e && 0 === t && (t = 1, R = !1), "categories" !== j && "mixed" !== j || (R = !1), R ? (u = Math.floor(Math.log(Math.abs(t)) / Math.LN10), c = Math.floor(Math.log(Math.abs(e)) / Math.LN10), h = Math.max(c, u), d = Math.pow(10, h), Math.abs(t) / d < 2 && Math.abs(e) / d < 2 && (h--, d = Math.pow(10, h)), v = Math.floor(Math.log(t - e) / Math.LN10), y = Math.pow(10, v), t - e > 0 && d / y >= 10 && (d = y, h = v), f = (Math.floor(t / d) + 1) * d, g = e < 0 ? (Math.floor(Math.abs(e / d)) + 1) * d * -1 : D ? (g = Math.floor(Math.abs(e / d) - 1) * d) < 0 ? 0 : g : 0, !D && t <= 0 && (f = 0), m = !(!F && 0 !== F), b = !(!E && 0 !== E), o.freezeLimit || (!1 === m || !0 === m && Number(F) < t && t - Number(F) > I ? (t = f, m = !1) : t = Number(F), !1 === b || !0 === b && Number(E) > e && Number(E) - e > I ? (e = g, b = !1) : e = Number(E))) : (m = !(!F && 0 !== F), b = !(!E && 0 !== E), !0 === m && Number(F) >= t ? t = Number(F) : m = !1, !0 === b && Number(E) <= e ? e = Number(E) : b = !1), w = [e, t], n.setDomain(w), O && !o.freezeLimit) m || b ? (P = (x = (L = function (e, t, n, a, o, r) {
      for (var l = t - e, s = void 0, c = void 0, u = void 0, h = e, d = Math.ceil(n * (1 - a)), p = Math.floor(n * (1 + a)), f = void 0, g = void 0, m = void 0, b = void 0, v = void 0, y = void 0, x = [], C = -1, k = void 0, w = void 0, S = void 0, _ = function _(e) {
        return function (e) {
          var t = [10, 5, 2, 1],
              n = void 0,
              a = t.length,
              i = void 0;

          for (n = 0; n < a; ++n) {
            if (e % t[n] % 1 == 0) {
              i = !0;
              break;
            }
          }

          return i;
        }(s = l / (e + 1)) ? e : i.UNDEF;
      }; !(k && w || ((S = n + ++C) >= p && (w = !0), f = _(S)) || ((S = n - C) <= d && (k = !0), f = _(S)));) {
        ;
      }

      for (e < 0 && t > 0 && o && (u = !0), c = 0; c < f; c++) {
        u && h < 0 && h + s > 0 && (x.push(0), g = !0), h += s, x.push(h);
      }

      return f === i.UNDEF && o && ((b = (x = r.ticks(n)).length) > 1 ? (m = .2 * (s = Math.abs(x[0] - x[1])), v = x[0], y = x[b - 1], Math.abs(e - v) <= m && 0 !== v && x.shift(), Math.abs(t - y) <= m && 0 !== y && x.pop(), 0 !== v && 0 !== y || (g = !0)) : 0 === x[0] && (g = !0)), u && !g && -1 === x.indexOf(0) && (e < 0 && x[0] > 0 ? x = [0].concat(x) : t > 0 && x[x.length - 1] < 0 ? x.push(0) : x = [0], g = !0), {
        output: x,
        interval: s,
        isZeroTickForced: g
      };
    }(e, t, r, V = (N = r) >= 100 ? .2 : N <= 1 ? 0 : s(N) / 100, o.forceZeroTick, n)).output).length, A = L.isZeroTickForced, Math.abs((r - P + (A ? 1 : 0)) / r) > V ? p = (t - e) / l : (p = 0 === P || 1 === P && A ? t - e : L.interval, o.isZeroTickForced = A, o.ticks = [e].concat(x, t), B = !1)) : (o.ticks = r ? n.nice(l).ticks(l) : n.getDomain(), p = Math.abs(o.ticks[1] - o.ticks[0]), B = !1);else if (m || b || o.freezeLimit) p = (t - e) / l;else {
      var H = n.nice(l).getDomain();
      ((k = (C = H[0]) + (p = function (e) {
        if (e <= 1) return 1;
        var t = [],
            n = Math.ceil(e);
        return t[2] = n % 2, t[5] = n % 5, t[10] = n % 10, (0, i.safeMin)(t) + n;
      }(d = ((k = H[1]) - C) / l)) * l) - t) / t > V || (C - e) / e > V ? (n.setDomain([e, t]), p = (t - e) / l) : (e = C, t = k, n.setDomain([e, t]));
    }
    B && (e < 0 && t > 0 && o.forceZeroTick ? (0 === (_ = (S = (0, a["default"])(e, 0, p))[S.length - 1] + p) ? _ += p : o.isZeroTickForced = !0, o.ticks = S.concat(0, (0, a["default"])(_, t, p), t)) : o.ticks = (0, a["default"])(e, t, p).concat(t));
    var z = n.getDomain();
    e = z[0], t = z[1], o._allTicks = o.ticks.slice(), M.tickInterval = p, M.min = e, M.max = t;
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = s(n(378)),
      i = s(n(398)),
      o = s(n(423)),
      r = n(125),
      l = n(386);

  function s(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function c(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var u = r.preDefStr.POSITION_START,
      h = r.preDefStr.POSITION_MIDDLE,
      d = r.preDefStr.POSITION_TOP,
      p = r.preDefStr.POSITION_BOTTOM,
      f = r.preDefStr.POSITION_END,
      g = {
    wrtVisible: !0
  },
      m = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.config.scale = new o["default"](), n;
    }

    return c(t, e), t.prototype.getName = function () {
      return "category";
    }, t.prototype.getCategoryFromId = function (e) {
      var t = this.config.tickValues;
      return (t && t.tickIdMap)[e] || {};
    }, t.prototype.generateTicks = function () {
      var e = this.getScale(),
          t = this.config,
          n = e.getDomain(),
          a = t.categoryNumDivLines + 1,
          o = (n[1] - n[0]) / a,
          r = t.axisRange,
          l = r.min,
          s = r.max,
          c = (s - l) / a;
      return t._allTicks = (0, i["default"])(l, s, c).concat(s), r.tickInterval = c, (0, i["default"])(n[0], n[1], o).concat(n[1]);
    }, t.prototype._parseCategoryVline = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          l,
          s,
          c,
          g,
          m,
          b,
          v,
          y,
          x,
          C,
          k,
          w,
          S,
          _,
          L,
          P,
          A,
          N,
          E,
          F,
          O,
          T,
          D,
          M,
          I,
          R = this.config,
          V = R.axisRange,
          B = V.min,
          j = V.max,
          G = this.getFromEnv("chart").config,
          H = G.style || {},
          z = R.isVertical,
          W = {
        fontFamily: G.style.inCanfontFamily,
        fontSize: G.style.inCanfontSize,
        color: G.style.inCancolor,
        lineHeight: G.style.inCanLineHeight
      };

      for (n = (t = R.tickValues.vline).length, T = 1 !== this.getZoom(), D = this.getVisibleConfig(), o = 0; o < n; o++) {
        a = t[o], i = (0, r.parseUnsafeString)(a.label), l = Boolean((0, r.pluckNumber)(a.showlabelborder, R.showVLineLabelBorder, 1)), e = Boolean((0, r.pluckNumber)(a.showlabelbackground, 1)), "center" === (s = (0, r.pluck)(a.labelhalign, z ? u : h)) ? s = h : "left" === s ? s = u : "right" === s && (s = f), (c = (0, r.pluck)(a.labelvalign, z ? h : p).toLowerCase()) === h ? c = h : c === d ? c = p : c === p && (c = d), g = (0, r.pluckNumber)(a.labelposition, 0), m = (0, r.pluckNumber)(a.lineposition, .5), b = (0, r.pluckNumber)(a.showvlines, R.showVLines, 1), v = (0, r.pluckNumber)(a.alpha, R.vLineAlpha, 80), y = (0, r.pluck)(a.color, R.vLineColor).replace(/^#?/, "#"), x = e ? (0, r.pluck)(a.labelbgcolor, R.vLineLabelBgColor, "333333").replace(/^#?/, "#") : r.BLANKSTRING, N = (0, r.pluck)(a.labelcolor, R.vLineLabelColor, a.color, H.inCancolor, R.vLineColor).replace(/^#?/, "#"), C = (0, r.pluckNumber)(a.thickness, R.vLineThickness, 1), F = 2, k = Boolean(Number((0, r.pluck)(a.dashed, 0))), w = (0, r.pluckNumber)(a.dashlen, 5), _ = (0, r.pluckNumber)(a.dashgap, 2), S = W.fontSize, S = parseInt(S.replace(/px/i, ""), 10), E = (0, r.pluckNumber)(a.rotatelabel, R.rotateVLineLabels) ? 270 : 0, m = m < 0 || m > 1 ? .5 : m, g = g < 0 || g > 1 ? 0 : g, y = (0, r.convertColor)(y, b ? v : "0"), I = a.animate && !z ? a.startIndex + 1 : a.startIndex, O = this._getVlinePos(I, m) - (a.animate ? a.leftShift : 0), T && (O < D.minValue || O > D.maxValue) || O < B || O > j || (L = {
          opacity: 1,
          stroke: y,
          "stroke-width": C,
          "stroke-dasharray": k ? (0, r.getDashStyle)(w, _) : "none"
        }, A = {
          opacity: 1,
          text: i,
          "text-anchor": s,
          "vertical-align": c,
          "text-bound": []
        }, P = {
          fontSize: W.fontSize,
          fontFamily: W.fontFamily,
          lineHeight: W.lineHeight
        }, M = {
          from: O,
          layer: (0, r.pluckNumber)(a.showontop, R.showVLinesOnTop, 0) ? 3 : 2,
          attr: L,
          type: "line",
          startIndex: a.startIndex,
          linePosition: m
        }, i && (A["text-bound"] = [x, b && l ? y : r.BLANKSTRING, b && l ? 1 : 0, F, r.UNDEF, b && l ? "solid" : r.BLANKSTRING], A.fill = b ? N : y, M.text = {
          label: i,
          attr: A,
          layer: 4,
          labelRotation: E,
          labelPosition: g,
          css: P
        }), this.setReferenceInfo(M), this.config.parsedVlineInfo.push(M));
      }
    }, t.prototype._parseReferenceVisuals = function () {
      e.prototype._parseReferenceVisuals.call(this), this.config.drawPlotlines && this._parseCategoryVline();
    }, t.prototype.categoryInsert = function (e, t, n) {
      var a,
          i,
          o,
          l,
          s,
          c = this.config,
          u = c.axisRange.min,
          h = t.length,
          d = c.endPad || 0;

      for (a = c.tickValues.tickValue, o = c.tickValues.tickIdMap, i = c.tickValues.vline, l = 0; l < h; l += 1) {
        "true" !== (s = (0, r.extend2)({}, t[l])).vline && !0 !== s.vline && 1 !== s.vline && "1" !== s.vline ? (s.id && (o[s.id] = {
          tickObj: s,
          i: e
        }), a.splice(e, 0, s), e += 1) : (s.startIndex = e - 2, i.push(s));
      }

      n && this._setAxisRange({
        min: u,
        max: Number((0, r.toPrecision)(a.length - 1 + d, 10))
      });
    }, t.prototype.categoryDelete = function (e, t, n) {
      var a,
          i,
          o,
          r = this.config,
          l = r.axisRange,
          s = l.min;

      for (i = 0, o = (a = r.tickValues.vline).length; i < o; i++) {
        a[i].animate = !0, a[i].leftShift = t;
      }

      r.tickValues.tickValue.splice(e, t), this._shiftVline(e, t, "left"), n && this._setAxisRange({
        min: s,
        max: l.max - t
      });
    }, t.prototype._shiftVline = function (e, t, n) {
      var a,
          i,
          o = this.config,
          r = o.tickValues.vline,
          l = o.tickValues.tickValue.length,
          s = r.length;

      for (a = 0; a < s; a += 1) {
        (i = r[a]).startIndex >= e && ("right" === n ? i.startIndex += t : i.startIndex -= t, (i.startIndex < 0 || i.startIndex >= l) && (r.splice(a, 1), s -= 1, a -= 1));
      }
    }, t.prototype.categoryTranslate = function (e) {
      var t,
          n = this.config,
          a = this.getPixel(1, g) - this.getPixel(0, g);
      e = (e || 0) * a, n.isReverse && (e = -e), t = ["T", e, ",", "0"].join(""), this.realTimeTranslatableGroups = [{
        group: n.axisContainer,
        translationStr: t
      }, {
        group: n.axisTrendLabelContainer,
        translationStr: t
      }];
    }, t.prototype.updateTicksValues = function (e, t) {
      var n,
          a,
          i,
          o,
          r,
          l,
          s,
          c = this.config,
          u = c.parsedVlineInfo;
      if ((n = c.tickValues.tickValue)[e]) for (s in t) {
        t.hasOwnProperty(s) && ("x" === s && (a = !0), n[e][s] = t[s]);
      }
      if (a) for (o = 0, r = u.length; o < r; ++o) {
        if ((l = (i = u[o]).startIndex) === e) i.from = this._getVlinePos(l, i.linePosition);else if (l + 1 === e) {
          i.from = this._getVlinePos(l, i.linePosition);
          break;
        }
      }
    }, t.prototype._getVlinePos = function (e, t) {
      var n = this.getTickValues(),
          a = this.config,
          i = this.getLimit(),
          o = i.min,
          l = i.max,
          s = n[e],
          c = n[e + 1],
          u = void 0,
          h = void 0,
          d = void 0;
      return s ? c || (u = n[0] && n[0].x ? l : a.oriCatLen - 1, d = !0) : (u = n[0] && n[0].x ? o : -1, d = !0), h = d ? t : ((u = (0, r.pluckNumber)(s.x, s.y, e)) - (0, r.pluckNumber)(c.x, c.y, e + 1)) * t, u + Math.abs(h);
    }, t.prototype.getInterval = function () {
      if (this) return 1;
    }, t.prototype._setAxisRange = function (e) {
      var t,
          n,
          a = e.min,
          o = e.max,
          l = this.config,
          s = l.axisRange,
          c = l.periodLength,
          u = l.dataLimit,
          h = u.max,
          d = u.min;
      a > o || (h === o && d === a || (t = !0), l.visibleMin === r.UNDEF || l.setPadding || t ? (u.max = o, u.min = a, c && (l.categoryNumDivLines = (o - a) / c - 1), n = (o - a) / (l.categoryNumDivLines + 1), this.getScale().setDomain([a, o]), l.ticks = (0, i["default"])(a, o, n).concat(o), l._allTicks = l.ticks.slice(), s.min = a, s.max = o, s.tickInterval = n, this.setVisibleConfig(s.min, s.max)) : l.setPadding = !1);
    }, t;
  }(a["default"]);

  m.prototype.setTickValues = l.setTickValues, t["default"] = m;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(400),
      i = r(a),
      o = r(n(382));

  function r(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function l(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var s = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this, a.deInterpolateLinear, o["default"]));
    }

    return l(t, e), t.prototype.copy = function () {
      return (0, a.copyScale)(this, new t());
    }, t;
  }(i["default"]);

  t["default"] = s;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    var t = void 0,
        n = e._parseCanvasCosmetics && e._parseCanvasCosmetics();

    if ((0, o.componentFactory)(e, a["default"], "canvas", e.config.showVolumeChart ? 2 : 1), t = e.getChildren("canvas")) for (var r = 0, l = t.length; r < l; r++) {
      t[r].configure(n), (0, o.componentFactory)(t[r], i["default"], "axisRefVisualCartesian");
    }
  };
  var a = r(n(364)),
      i = r(n(425)),
      o = n(125);

  function r(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      i = n(138),
      o = c(n(382)),
      r = c(n(383)),
      l = n(379),
      s = c(n(426));

  function c(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function u(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  (0, n(132).addDep)({
    name: "cartesianAxisRefAnimation",
    type: "animationRule",
    extension: s["default"]
  });

  var h = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.config.map = {}, n.config.explicitDrawItems = {}, n;
    }

    return u(t, e), t.prototype.getType = function () {
      return "axisRefVisuals";
    }, t.prototype.getName = function () {
      return "axisRefVisualsCartesian";
    }, t.prototype.draw = function () {
      var e = this.getDrawingInfo(),
          t = void 0,
          n = this.getexplicitDrawItems(),
          a = this.config,
          i = a.map,
          o = {},
          r = void 0,
          l = void 0,
          s = void 0,
          c = void 0,
          u = void 0,
          h = void 0,
          d = this.getLinkedParent(),
          p = d.getAxes(),
          f = [],
          g = d.getChildContainer("axisReferenceVisualsFloor"),
          m = d.getChildContainer("axisReferenceVisualsBottom"),
          b = d.getChildContainer("axisReferenceVisualsMiddle"),
          v = d.getChildContainer("axisReferenceVisualsTop"),
          y = d.getChildContainer("axisReferenceVisualsCeil");

      for (d.config.trendlines = [], d.config.vtrendlines = [], r = 0; r < p.length; ++r) {
        f.push(p[r].axis.getId());
      }

      for (s in a.containers = [g, m, b, v, y], e) {
        if (e.hasOwnProperty(s) && (c = this.getLinkedItem(s), f.indexOf(c.getId()) >= 0)) for ((u = o[s]) || (u = o[s] = []), t = e[s], r = 0; r < t.length; ++r) {
          "band" === (l = (h = t[r]).type) ? u.push.apply(u, this.createBand(h, c)) : "line" === l && u.push.apply(u, this.createLine(h, c));
        }
      }

      if (a.isSmartDrawing) for (s in i) {
        i.hasOwnProperty(s) && !n[s] && this.getLinkedItem(s) && (o[s] = i[s]);
      }
      this.resetexplicitDrawItems(), this.removeExtraElements(o);
    }, t.prototype.getDrawingInfo = function () {
      var e = {},
          t = void 0,
          n = void 0,
          a = this.getexplicitDrawItems(),
          i = this.isCanvasChnaged(),
          o = (this.config.isSmartDrawing = Object.keys(a).length && !i) ? a : this.getLinkedItem();

      for (t in o) {
        o.hasOwnProperty(t) && (n = o[t], e[t] = n.getReferenceInfo());
      }

      return e;
    }, t.prototype.createLine = function (e, t) {
      var n,
          i = this.config.containers,
          r = i[e.layer],
          s = t.config,
          c = this.getFromEnv("paper"),
          u = this.getFromEnv("chart").getName(),
          h = this.getLinkedParent(),
          d = this.getFromEnv("animationManager"),
          p = this.getFromEnv("toolTipController"),
          f = h.config,
          g = f.trendlines,
          m = s.isVertical,
          b = f.canvasLeft,
          v = f.canvasTop,
          y = v + f.canvasHeight,
          x = b + f.canvasWidth,
          C = (0, o["default"])(b, x),
          k = (0, o["default"])(v, y),
          w = t.getScale(),
          S = w.getRangeValue(e.from),
          _ = void 0 !== e.to && w.getRangeValue(e.to) || S,
          L = m ? ["M", b, S, "L", x, _] : ["M", S, y, "L", _, v],
          P = e.attr,
          A = e.text,
          N = A && A.attr,
          E = A && A.labelPosition || 0,
          F = t.getId(),
          O = e.id || e.from,
          T = F + "_" + O,
          D = void 0,
          M = this.getGraphicalElement(T),
          I = void 0,
          R = void 0,
          V = e.handlers,
          B = {
        start: e.from,
        end: e.to
      };

      for (R in P.path = (0, l.getCrispPath)(L, (n = P["stroke-width"], "undefined" === !(void 0 === n || a(n)) || null !== n ? P["stroke-width"] : 1)).path.toString(), /trend/.test(e.id) && g.push({
        x1: L[1],
        y1: L[2],
        x2: L[4],
        y2: L[5],
        tooltext: e.toolText,
        tolerance: P["stroke-width"] < 5 ? 2.5 : P["stroke-width"] / 2
      }), P["stroke-linecap"] = "butt", (M = this.addGraphicalElement(T, d.setAnimation({
        container: r,
        el: M || "path",
        attr: P,
        component: this,
        axis: t,
        data: {
          value: B,
          path: L
        },
        label: "path"
      }))).data("data", B), A && (D = F + "_" + O + N.text, I = this.getGraphicalElement(D), m ? (N.x = C(E), N.y = S) : (N.x = S, N.y = k(E)), N.text = A.label, N.transform = c.getSuggestiveRotation(A.labelRotation, N.x, N.y), (I = this.addGraphicalElement(D, d.setAnimation({
        container: i[A.layer],
        el: I || "text",
        attr: N,
        component: this,
        axis: t,
        data: {
          value: e.from
        },
        label: "text",
        css: A.css
      }))).data("data", e.from)), /zoomscatter/i.test(u) || (e.toolText ? p.enableToolTip(M, e.toolText) : p.disableToolTip(M)), V) {
        V.hasOwnProperty(R) && (M.on(R, V[R].bind(t)), I && I.on(R, V[R].bind(t)));
      }

      return A ? [T, D] : [T];
    }, t.prototype.createBand = function (e, t) {
      var n,
          a,
          i = this.config.containers[e.layer],
          o = t.config,
          r = this.getFromEnv("animationManager"),
          l = this.getFromEnv("toolTipController"),
          s = this.getLinkedParent(),
          c = this.getFromEnv("chart").getName(),
          u = s.config,
          h = o.isVertical,
          d = u.canvasLeft,
          p = u.canvasTop,
          f = p + u.canvasHeight,
          g = d + u.canvasWidth,
          m = t.getScale(),
          b = e.from,
          v = void 0 !== e.to ? e.to : b,
          y = void 0,
          x = void 0,
          C = t.getId(),
          k = void 0,
          w = void 0,
          S = e.attr,
          _ = e.handlers;

      for (w in y = "canvasStart" === b ? h ? p : d : m.getRangeValue(b), x = "canvasEnd" === v ? h ? f : g : m.getRangeValue(v), a = Math.abs(y - x), h ? (S.x = d, S.y = Math.min(y, x), S.width = g - d, S.height = a) : (S.x = Math.min(y, x), S.y = p, S.width = a, S.height = f - p), n = C + "_" + (e.id || S.x + "_" + S.y), k = this.getGraphicalElement(n), /trend/.test(e.id) && s.config.vtrendlines.push({
        x1: S.x,
        y1: S.y,
        x2: S.x + S.width,
        y2: S.y + S.height,
        tooltext: e.toolText,
        tolerance: S["stroke-width"] < 5 ? 2.5 : S["stroke-width"] / 2,
        isTrendZone: 1
      }), k = this.addGraphicalElement(n, r.setAnimation({
        container: i,
        el: k || "rect",
        attr: S,
        component: this,
        label: "rect"
      })), /zoomscatter/i.test(c) || (e.toolText ? l.enableToolTip(k, e.toolText) : l.disableToolTip(k)), _) {
        _.hasOwnProperty(w) && k.on(w, _[w].bind(t));
      }

      return [n];
    }, t.prototype.removeExtraElements = function (e) {
      var t = this.config.map,
          n = void 0,
          a = void 0,
          i = void 0,
          o = void 0,
          l = void 0,
          s = void 0;

      for (n in t) {
        if (e[n]) for (o = (s = (0, r["default"])(t[n], e[n])).length, i = 0; i < o; ++i) {
          (l = this.getGraphicalElement(s[i])) && this.removeGraphicalElement(l);
        } else for (o = (a = t[n]).length, i = 0; i < o; ++i) {
          (l = this.getGraphicalElement(a[i])) && this.removeGraphicalElement(l);
        }
      }

      this.config.map = e;
    }, t.prototype.setLinkedItem = function (t, n) {
      e.prototype.setLinkedItem.call(this, t, n);
      var a = this;
      "axis" === n.getType() && a.addExtEventListener("preremove", function (e) {
        a.removeLinkedItem(e.sender.getId()), a.asyncDraw();
      }, n);
    }, t.prototype.addexplicitDrawItems = function (e, t) {
      this.config.explicitDrawItems[e] = t;
    }, t.prototype.getexplicitDrawItems = function () {
      return this.config.explicitDrawItems;
    }, t.prototype.resetexplicitDrawItems = function () {
      this.config.explicitDrawItems = {};
    }, t.prototype.isCanvasChnaged = function () {
      var e = this.getLinkedParent().getEffectiveDimensions(),
          t = this.config,
          n = void 0;
      return n = JSON.stringify(e) !== JSON.stringify(t.canvasDim), t.canvasDim = e, n;
    }, t;
  }(i.ComponentInterface);

  t["default"] = h;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(381);
  t["default"] = {
    "initial.axisRefVisuals.axisRefVisualsCartesian": a.axisAnimationAxis,
    "update.axisRefVisuals.axisRefVisualsCartesian": a.axisAnimationFinal
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    var t,
        n,
        a,
        i,
        l,
        s,
        c,
        u = e.getChildren("canvas"),
        h = u.length,
        d = [],
        p = [];

    for (i = 0; i < h; i++, d = [], p = []) {
      if (!(t = u[i]).getState("removed")) {
        for (a = t.getFromEnv("xAxis"), s = 0; s < (a && a.length); s++) {
          a[s].getState("removed") || d.push(a[s]);
        }

        for (a = t.getFromEnv("yAxis"), s = 0; s < (a && a.length); s++) {
          a[s].getState("removed") || p.push(a[s]);
        }

        for ((0, r.componentFactory)(t, o["default"], "vCanvas", d.length * p.length), n = t.getChildren("vCanvas"), l = 0, s = 0; l < (d && d.length); l++) {
          for (c = 0; c < (p && p.length); c++, s++) {
            n[s].xAxis(d[l]).yAxis(p[c]).canvas(t), n[s].configure(), n[s].addToEnv("vCanvas", n[s]);
          }
        }
      }
    }
  };
  var a,
      i = n(428),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  },
      r = n(125);
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(138),
      i = n(125);

  function o(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var r = function r(e, t) {
    return e = "comp_" + e, t && (this.config[e] = t), (t || !this.config[e]) && this || this.config[e];
  },
      l = function l(e, t) {
    return ["T", e, ",", t].join("");
  },
      s = function s(e) {
    return -e.getTranslation();
  },
      c = function c(e, t) {
    return {
      h: e,
      v: t
    };
  },
      u = ["columnShadowVcanvasGroup", "columnVcanvasGroup", "areaShadowVcanvasGroup", "areaVcanvasGroup", "lineShadowVcanvasGroup", "lineVcanvasGroup", "defaultShadowVcanvasGroup", "defaultVcanvasGroup", "sumLabelsLayer", "vcanvasLabelGroup"],
      h = function h(e, t, n) {
    return n.getFromEnv("animationManager").setAnimation({
      el: "group",
      attr: {
        name: e
      },
      container: t,
      state: "appearing",
      component: n,
      label: "group"
    });
  },
      d = function d(e) {
    return !/category/i.test(e.getName());
  },
      p = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.apply(this, arguments));
    }

    return o(t, e), t.prototype.getName = function () {
      return "virtualCanvas";
    }, t.prototype.getType = function () {
      return "canvas";
    }, t.prototype.xAxis = function (e) {
      var t = r.call(this, "xAxis", e);
      return e && this.listenToAxis(e), e && this.addToEnv("xAxis", e), t;
    }, t.prototype.yAxis = function (e) {
      var t = r.call(this, "yAxis", e);
      return e && this.listenToAxis(e), e && this.addToEnv("yAxis", e), t;
    }, t.prototype.paper = function (e) {
      return r.call(this, "paper", e);
    }, t.prototype.canvas = function (e) {
      return r.call(this, "canvas", e);
    }, t.prototype.configure = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          t = this.getFromEnv("chartConfig"),
          n = this.config;
      Object.assign(n, e), n.transposeAxis = t.transposeAxis, this._mapChildren(function (e) {
        e.getState("removed") || "dataset" === e.getType() || e.configure && e.configure();
      });
    }, t.prototype.getHorizontalVerticalAxes = function () {
      var e = this.xAxis(),
          t = this.yAxis();
      return t.config.isVertical ? c(e, t) : c(t, e);
    }, t.prototype.preDraw = function () {
      this._mapChildren(function (e) {
        e.getState("removed") || "dataset" === e.getType() || e.setVisibility && e.setVisibility();
      });

      var e,
          t = this.config.transposeAxis,
          n = this.getFromEnv("chart"),
          a = this.getAxisValuePadding(),
          i = a.left,
          o = a.right,
          r = a.top,
          l = a.bottom;
      (e = this.getDataLimits(!t)).min !== Infinity || e.max !== -Infinity ? (this._setYAxisLimits(e.min, e.max), n._storeIntialLimit && n._storeIntialLimit(e.min, e.max)) : (this._setYAxisLimits(void 0, void 0), n._storeIntialLimit && n._storeIntialLimit(void 0, void 0)), this._setXAxisLimits(e.xMin, e.xMax), this._setAxisValuePadding(i, o, r, l);
    }, t.prototype.childChanged = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          t = this.config,
          n = t.transposeAxis,
          a = void 0;
      !1 !== e.dataLimitChanged && (a = this.getDataLimits(!n), !n || a.min === t.range.min && a.max === t.range.max || (t.range.min = a.min, t.range.max = a.max, this.getFromEnv("yAxis").resetStoredLimits(), a.min !== Infinity || a.max !== -Infinity ? this._setYAxisLimits(a.min, a.max) : this._setYAxisLimits(void 0, void 0)), a.xMin === t.range.xMin && a.xMax === t.range.xMax || (t.range.xMin = a.xMin, t.range.xMax = a.xMax, this.getFromEnv("xAxis").resetStoredLimits(), this._setXAxisLimits(a.xMin, a.xMax))), this.asyncDraw();
    }, t.prototype._setAxisValuePadding = function (e, t, n, a) {
      this.getFromEnv("xAxis").setAxisPadding(e, t), n && a && this.getFromEnv("yAxis").setAxisPadding(e, t);
    }, t.prototype.getAxisValuePadding = function () {
      var e = {},
          t = -Infinity,
          n = -Infinity,
          a = -Infinity,
          i = -Infinity;
      return this._mapChildren(function (o) {
        o.getState("removed") || (e = o.getAxisValuePadding && o.getAxisValuePadding() || {}, t = Math.max(t, e.left || -Infinity), n = Math.max(n, e.right || -Infinity), a = Math.max(a, e.top || -Infinity), i = Math.max(i, e.bottom || -Infinity));
      }), t === -Infinity && (t = 0), n === -Infinity && (n = 0), a === -Infinity && (a = 0), i === -Infinity && (i = 0), this.config.padding || (this.config.padding = {}, this.config.padding.left = t, this.config.padding.right = n, this.config.padding.top = a, this.config.padding.bottom = i), {
        left: t,
        right: n,
        top: a,
        bottom: i
      };
    }, t.prototype._setYAxisLimits = function (e, t) {
      var n = this.getFromEnv("yAxis");
      d(n) && n.setDataLimit(t, e);
    }, t.prototype._setXAxisLimits = function (e, t) {
      var n = this.getFromEnv("xAxis");
      d(n) && (t !== -Infinity || e !== +Infinity ? n.setDataLimit(t, e) : n.setDataLimit(void 0, void 0));
    }, t.prototype.getDataLimits = function (e) {
      var t,
          n,
          a,
          o = this.getFromEnv("chart"),
          r = -Infinity,
          l = +Infinity,
          s = r,
          c = l,
          u = l,
          h = r;
      return this._mapChildren(function (o) {
        var d;
        o.getDataLimits && !o.getState("removed") && (e || o.getState("visible")) && (t = o.getDataLimits(e), d = t, n = (0, i.pluck)(d.xMax, r), a = (0, i.pluck)(d.xMin, l), s = Math.max(s, d.max), c = Math.min(c, d.min), h = Math.max(h, n), u = Math.min(u, a));
      }), this.config.range || (this.config.range = {}, this.config.range.min = c, this.config.range.max = s, this.config.range.xMin = u, this.config.range.xMax = h), o.config.yMax = s, o.config.yMin = c, {
        min: c,
        max: s,
        xMin: u,
        xMax: h
      };
    }, t.prototype.listenToAxis = function (e) {
      var t,
          n = this;
      t = function t() {
        n.getState("drawn") && n.asyncDraw();
      }, this.getState("visiblerangeset" + e.getId()) || (this.setState("visiblerangeset" + e.getId(), !0), n.addExtEventListener("visiblerangeset", t, e));
    }, t.prototype.createContainer = function () {
      var e = this.getLinkedParent();
      !this.getChildContainer("columnShadowVcanvasGroup") && this.addChildContainer("columnShadowVcanvasGroup", h("vcanvas-column-shadow", e.getChildContainer("columnShadowGroup"), this)), !this.getChildContainer("columnVcanvasGroup") && this.addChildContainer("columnVcanvasGroup", h("vcanvas-column-plot", e.getChildContainer("columnGroup"), this)), !this.getChildContainer("areaShadowVcanvasGroup") && this.addChildContainer("areaShadowVcanvasGroup", h("vcanvas-area-shadow", e.getChildContainer("areaShadowGroup"), this)), !this.getChildContainer("areaVcanvasGroup") && this.addChildContainer("areaVcanvasGroup", h("vcanvas-area-plot", e.getChildContainer("areaGroup"), this)), !this.getChildContainer("lineShadowVcanvasGroup") && this.addChildContainer("lineShadowVcanvasGroup", h("vcanvas-line-shadow", e.getChildContainer("lineShadowGroup"), this)), !this.getChildContainer("lineVcanvasGroup") && this.addChildContainer("lineVcanvasGroup", h("vcanvas-line-plot", e.getChildContainer("lineGroup"), this)), !this.getChildContainer("defaultShadowVcanvasGroup") && this.addChildContainer("defaultShadowVcanvasGroup", h("vcanvas-default-shadow", e.getChildContainer("defaultShadowGroup"), this)), !this.getChildContainer("defaultVcanvasGroup") && this.addChildContainer("defaultVcanvasGroup", h("vcanvas-default-plot", e.getChildContainer("defaultGroup"), this)), !this.getChildContainer("vcanvasLabelGroup") && this.addChildContainer("vcanvasLabelGroup", h("vcanvas-label", e.getChildContainer("datalabelsGroup"), this)), !this.getChildContainer("columnTrendGroup") && this.addChildContainer("columnTrendGroup", h("columnTrendGroup", this.getChildContainer("columnVcanvasGroup"), this)), !this.getChildContainer("sumLabelsLayer") && this.addChildContainer("sumLabelsLayer", h("vcanvas-sumLabelsLayer", e.getChildContainer("sumLabelsLayer"), this));
    }, t.prototype.applyTranslation = function () {
      var e = this,
          t = function (e) {
        return l(s(e.h), s(e.v));
      }(e.getHorizontalVerticalAxes());

      e.createContainer(), u.forEach(function (n) {
        var a;
        a = n, (a = e.getChildContainer(a)).attr({
          transform: t
        });
      });
    }, t.prototype.draw = function () {
      this.applyTranslation(), this.setState("drawn", !0);
    }, t.prototype.getCanvasPadding = function () {
      var e,
          t,
          n = {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      };
      return this._mapChildren(function (a) {
        if (a.getCanvasPadding && !a.getState("removed")) for (t in e = a.getCanvasPadding() || {}) {
          e.hasOwnProperty(t) && (n[t] = Math.max(e[t], n[t]));
        }
      }), n;
    }, t.prototype.rtShiftAnim = function (e, t) {
      var n,
          a = this,
          i = a.getFromEnv("xAxis"),
          o = a.getFromEnv("yAxis"),
          r = i.getPixel(1) - i.getPixel(0),
          s = o.getPixel(1) - o.getPixel(0),
          c = a.getFromEnv("animationManager");
      n = l(e = (e || 0) * r, t = (t || 0) * s), u.forEach(function (e) {
        a.getChildContainer(e).attr({
          transform: n
        }), c.setAnimation({
          el: a.getChildContainer(e),
          attrs: {
            transform: "T0,0"
          }
        });
      });
    }, t;
  }(a.ComponentInterface);

  t["default"] = p;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    var t = void 0;
    e.config.enablemousetracking ? ((0, r.componentFactory)(e, o["default"], "mouseTracker"), t = e.getChildren("mouseTracker")[0], e.config.mouseTrackerEventAdded || (t.addEvents(), e.config.mouseTrackerEventAdded = !0)) : ((t = e.getChildren("mouseTracker") && e.getChildren("mouseTracker")[0]) && t._removeListners(), e.config.mouseTrackerEventAdded = !1);
  };
  var a,
      i = n(430),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  },
      r = n(125);
}, function (e, t, n) {
  "use strict";

  function a(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  t.__esModule = !0;

  var i = "fc-mouseover",
      o = "fc-mousedown",
      r = "fc-mouseup",
      l = "fc-mousemove",
      s = "fc-click",
      c = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n,
          a = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return a.pIndex = 1, a.handler = (n = a, function (e) {
        e.originalEvent && n.getFromEnv("chart")._mouseEvtHandler(e, n.config.evtData);
      }), a.eventsList = [o, r, l, s, i], a.config = {}, a.config.evtData = {}, a;
    }

    return a(t, e), t.prototype.getMouseEvents = function (e, t, n) {
      var a = this._lastDatasetIndex,
          c = this._lastPointIndex,
          u = {
        fireOut: !1,
        events: []
      };

      switch (e.type) {
        case s:
          u.events.push(s);
          break;

        case l:
          a === t && c === n ? (clearTimeout(this.mouseoutTimer), u.events.push(l)) : (u.events.push(i), u.fireOut = !0);
          break;

        case o:
          a === t && c === n || (u.fireOut = !0, u.events.push(i)), u.events.push(o);
          break;

        case i:
          a === t && c === n ? clearTimeout(this.mouseoutTimer) : (u.fireOut = !0, u.events.push(i));
          break;

        case r:
          this.hasTouchEvent = !1, u.events.push(r);
          break;

        case "fc-mouseout":
          u.fireOut = !0;
      }

      return u;
    }, t.prototype.addEvents = function () {
      var e,
          t,
          n,
          a = this.getFromEnv("chart"),
          i = a.getChildren("canvas"),
          o = this.config.evtData,
          r = this.eventsList;

      for (a.config.enableMouseOutEvent && r.push("fc-mouseout"), this._removeListners(), o.chart = a, o.mouseTracker = this, t = 0; t < i.length; t++) {
        for (n in e = i[t], r) {
          e.addEventListener(r[n], this.handler);
        }
      }
    }, t.prototype._removeListners = function () {
      var e,
          t,
          n,
          a = this.getFromEnv("chart").getChildren("canvas"),
          i = this.eventsList;

      for (n = 0; n < a.length; n++) {
        for (t in e = a[n], i) {
          e.removeEventListener(i[t], this.handler);
        }
      }

      this._removeDocEvents();
    }, t.prototype._removeDocEvents = function () {
      this.eventOutput && this.eventOutput.unlisten(), this.eventOutput = void 0;
    }, t.prototype._dispose = function () {
      this._removeListners(), e.prototype._dispose.call(this);
    }, t;
  }(n(138).ComponentInterface);

  t["default"] = c;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    var t,
        n,
        o = e.getChildren(),
        r = o.canvas && o.canvas[0],
        l = r && r.getChildren("vCanvas"),
        s = l && l[0] || r || e,
        c = e.getFromEnv("dataSource"),
        u = c.dataset,
        h = c.data || u && u[0].data;
    n = i(h), h && 0 !== h.length ? (t = e.getDSdef(), (0, a.datasetFactory)(s, t, "dataset", 1, [n])) : e.setChartMessage();
  };

  var a = n(125),
      i = function i(e) {
    var t = [],
        n = [];
    return (0, a.fcEach)(e, function (e, a) {
      "true" !== e.vline && !0 !== e.vline && 1 !== e.vline && "1" !== e.vline ? t.push(e) : n.push({
        index: a,
        data: e
      });
    }), {
      catData: n,
      data: t
    };
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t._removePlots = undefined;
  var a,
      i = n(125),
      o = n(138),
      r = n(132),
      l = n(433),
      s = (a = l) && a.__esModule ? a : {
    "default": a
  },
      c = n(136);

  function u(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var h = void 0,
      d = i.hasTouch ? i.TOUCH_THRESHOLD_PIXELS : i.CLICK_THRESHOLD_PIXELS,
      p = i.regex.dropHash,
      f = i.preDefStr.DEFAULT,
      g = i.preDefStr.showHoverEffectStr,
      m = i.preDefStr.setRolloverAttrStr,
      b = i.preDefStr.setRolloutAttrStr,
      v = Math,
      y = v.min,
      x = v.max,
      C = v.abs,
      k = {
    top: !0
  },
      w = {
    right: !0
  },
      S = {
    left: !0
  },
      _ = {
    bottom: !0
  },
      L = v.ceil,
      P = v.round,
      A = function A() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        t = arguments[1];

    if ("function" == typeof t) {
      var n = function n(_n4) {
        if (e.hasOwnProperty(_n4)) {
          var a = e[_n4];
          Array.isArray(a) ? a.forEach(function (e) {
            return t(e, _n4);
          }) : e[_n4] && t(e[_n4], _n4);
        }
      };

      for (var a in e) {
        n(a);
      }
    }
  },
      N = function N(e, t, n) {
    return n.getFromEnv("animationManager").setAnimation({
      el: "group",
      attr: {
        name: e
      },
      container: t,
      state: "appearing",
      component: n,
      label: "group"
    });
  },
      E = function E() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
        t = arguments[1];
    e.forEach(function (e) {
      return A(e && e.graphics, t);
    }), e.length = 0;
  };

  (0, r.addDep)({
    name: "columnAnimation",
    type: "animationRule",
    extension: s["default"]
  });

  var F = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this)),
          a = n;

      return a.components = {}, a.components.removeDataArr = [], a.__hideElem = function (e, t) {
        a._setRemoveAnim(e, "label" === t ? "plotLabel" : "rect");
      }, a.__removeElem = function (e, t) {
        a.__hideElem(e, t);
      }, a.config.primitiveType = "column", n;
    }

    return u(t, e), t.prototype.getType = function () {
      return "dataset";
    }, t.prototype.getName = function () {
      return "column";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this);

      var t = this.config;
      t.showvalues = h, t.includeinlegend = 1, t.plotfillalpha = h, t.plotfillangle = h, t.ratio = h;
    }, t.prototype.preConfigure = function (t) {
      if (!t) return !1;
      this.trimData(t), this.config.JSONData = t, e.prototype.preConfigure.call(this, t);
    }, t.prototype.setSkippingInfo = function (e) {
      this.addToEnv("skipInfo", e || {
        plotsPerBin: 1,
        drawOnlyMap: [],
        draw: [],
        hide: [],
        skippingApplied: !1,
        dragHashMap: []
      });
    }, t.prototype.getSkippingInfo = function () {
      return this.getFromEnv("skipInfo") || {
        plotsPerBin: 1,
        drawOnlyMap: [],
        draw: [],
        hide: [],
        skippingApplied: !1,
        dragHashMap: []
      };
    }, t.prototype.configure = function (t) {
      if (!t) return !1;
      e.prototype.configure.call(this, t);
    }, t.prototype.configureAttributes = function () {
      var e = this.getFromEnv("chart"),
          t = this.config;
      this.parseAttributes(), this._setConfigure(), this.getState("visible") && !1 === t.oldVisible && (t.appearing = !0), t.oldVisible = this.getState("visible"), this._realTimeConfigure && this._realTimeConfigure(), !1 !== e.config.hasLegend && e.config.showLegend && this._addLegend(), this.ErrorValueConfigure && this.ErrorValueConfigure(), this.config.YForStackUpdated = !1, this.setState("dirty", !0);
    }, t.prototype.parseAttributes = function () {
      var e,
          t,
          n,
          a = this.getFromEnv("chart"),
          o = a.getChildren("yAxis")[0].config.isReverse,
          r = this.config,
          l = this.config.JSONData,
          s = a.config.singleseries,
          c = a.config,
          u = a.getFromEnv("dataSource").chart,
          h = this.getFromEnv("color-manager"),
          d = this.getJSONIndex(),
          p = r.plotColor = h.getPlotColor(d),
          f = (0, i.pluckNumber)(l.dashed, u.plotborderdashed),
          g = (0, i.pluckNumber)(u.useplotgradientcolor, 1),
          m = a.isBar,
          b = a.config.is3D,
          v = a.config.isdual;
      r.parentYAxis = v && "s" === (0, i.pluck)(l.parentyaxis && l.parentyaxis.toLowerCase(), "p") ? 1 : 0, r.maxValue = -Infinity, r.minValue = Infinity, r.defaultPadding = {
        left: .5,
        right: .5
      }, (0, i.parseConfiguration)(l, r, c, {
        data: !0
      }), r.seriesname = (0, i.parseUnsafeString)(l.seriesname), r.showValues = (0, i.pluckNumber)(l.showvalues, u.showvalues, 1), r.showplotborder = (0, i.pluckNumber)(u.showplotborder, b ? 0 : 1), e = c.plotborderdashlen, t = c.plotborderdashgap, r.plotfillangle = (0, i.pluckNumber)(360 - u.plotfillangle, m ? 180 : o ? 90 : 270), r.plotfillalpha = n = (0, i.pluck)(l.alpha, u.plotfillalpha, i.HUNDREDSTRING), r.plotColor = p = (0, i.pluck)(l.color, p), r.legendSymbolColor = (0, i.getFirstColor)(r.plotColor), r.plotgradientcolor = (0, i.getDefinedColor)(u.plotgradientcolor, h.getColor("plotGradientColor")), !g && (r.plotgradientcolor = ""), r.plotborderalpha = (0, i.pluck)(u.plotborderalpha, n, i.HUNDREDSTRING), r.plotbordercolor = (0, i.pluck)(u.plotbordercolor, b && !s ? "#ffffff" : h.getColor("plotBorderColor")), r.plotborderdashstyle = f ? (0, i.getDashStyle)(e, t, void 0) : "none", r.showShadow = b ? (0, i.pluckNumber)(u.showshadow, 1) : (0, i.pluckNumber)(u.showshadow, h.getColor("showShadow")), r.definedGroupPadding = x(c.plotSpacePercent, 0), r.includeinlegend = (0, i.pluckNumber)(l.includeinlegend, r.seriesname ? 1 : 0), this.setState("visible", 1 === (0, i.pluckNumber)(l.visible, !Number(l.initiallyhidden), 1)), !0 === this.getState("visible") ? this._conatinerHidden = !1 : this._containerHidden = !0, r.legendInteractivity = !1, this.setState("visible", 1 === (0, i.pluckNumber)(this.getState("visible"), r.JSONData.visible, !Number(r.JSONData.initiallyhidden), 1));
    }, t.prototype.trimData = function (e) {
      if (this.components || !this.components.data || !this.components.data.length) {
        var t = this.components,
            n = this.config,
            a = n && n.context,
            i = this.getFromEnv("chart").isRealTime,
            o = a && a.prevCatlen,
            r = this.getFromEnv("xAxis"),
            l = i ? 0 : r.getTicksLen(),
            s = o - l,
            c = t && t.data,
            u = c && c.length,
            h = e.data && e.data.length || 0,
            d = u - h,
            p = void 0,
            f = void 0;
        s > d ? (p = s, f = l) : (p = d, f = h), p > 0 && this.removeData(f, p, !1);
      }
    }, t.prototype.hidePlots = function () {
      var e,
          t = this,
          n = t.components.data,
          a = t.getSkippingInfo(),
          i = a.hide,
          o = a.hideLabel;
      i.forEach(function (a) {
        (e = n[a]) && e.graphics && (A(e.graphics, t.__removeElem), e && (e.graphics = {}));
      }), o.forEach(function (a) {
        (e = n[a]) && e.graphics && (A(e.graphics, t.__removeElem), e && (e.graphics = {}));
      });
    }, t.prototype._setConfigure = function (e, t) {
      var n,
          a,
          o,
          r,
          l,
          s,
          u,
          p,
          f = this,
          g = f.getFromEnv("chart"),
          m = g.config,
          b = f.config,
          v = f.getFromEnv("xAxis"),
          y = g.isRealTime,
          x = m.realTimeConfig && m.realTimeConfig.numDisplaySets,
          C = f.getFromEnv("dataSource").categories && f.getFromEnv("dataSource").categories[0] && f.getFromEnv("dataSource").categories[0].category,
          k = b.initCatLen = y ? C && Array.isArray(C) && C.filter(function (e) {
        return !e.vline;
      }).length || 0 : v.getTicksLen(),
          w = b.JSONData || [],
          S = e || w.data,
          _ = e && e.data.length,
          L = b.showplotborder,
          P = m.plotborderthickness,
          A = f.components.data,
          N = m.isDrag,
          E = f.getSkippingInfo && f.getSkippingInfo(),
          F = E && E.draw || [],
          O = E && E.skippingApplied;

      for (u = _ === h && k > x ? k - x : 0, n = y ? (0, i.pluckNumber)(_, k) : Math.min(k, S && S.length), m.dragTolerance = N ? (L && P > 5 ? P / 2 + 1 : 5) + d : 0, A || (A = f.components.data = []), O && (n = F.length), s = u; s < n; s++) {
        l = F[s] || s, e ? (a = e && e.data[l] || {}, r = t !== h ? A[p = t + l] : A[p = A.length - n + l], o = p) : (a = S && S[l] || {}, r = A[l -= u], o = l), r || (r = A[o] = {}), r.config || (r.config = {}, r.graphics = {}), f._plotConfigure(o, a, _), p && p++;
      }

      O && f.addJob("configureRestID", function () {
        f._configureRestData();
      }, c.priorityList.postRender);
    }, t.prototype._configureRestData = function () {
      var e,
          t,
          n,
          a,
          o,
          r = this.config,
          l = this.config.JSONData,
          s = l.data,
          c = this.getFromEnv("chart-attrib"),
          u = this.getFromEnv("xAxis").getTicksLen(),
          d = (this.getSkippingInfo && this.getSkippingInfo()).drawOnlyMap,
          p = this.components.data;

      for (p || (p = this.components.data = []), r.maxValue = -Infinity, r.minValue = Infinity, a = 0; a < u; a++) {
        d[a] || (n = p[a], t = a, (e = s && s[a] || {}).tooltext !== h && (e.tooltext = (0, i.parseTooltext)(e.tooltext, [3], {
          label: e.label
        }, e, c, l)), n || (n = p[a] = {}), n.config || (p[a].config = {}), this._plotConfigure(t, e), o && o++);
      }
    }, t.prototype._plotConfigure = function (e, t, n) {
      var a,
          o,
          r,
          l,
          s,
          c,
          u,
          d,
          p,
          f,
          g,
          m,
          b,
          v,
          C,
          k,
          w,
          S,
          _,
          L,
          P,
          A,
          N,
          E,
          F,
          O,
          T,
          D,
          M,
          I,
          R,
          V,
          B,
          j,
          G = this.getFromEnv("chart"),
          H = G.config,
          z = this.config,
          W = z.JSONData,
          q = G.config.singleseries,
          U = this.getFromEnv("yAxis"),
          Y = this.getFromEnv("xAxis"),
          X = this.components.data[e],
          K = G.getFromEnv("dataSource").chart,
          Z = this.getFromEnv("color-manager"),
          J = z.showplotborder,
          $ = z.plotColor,
          Q = H.showtooltip,
          ee = H.yaxisname,
          te = H.xaxisname,
          ne = H.tooltipsepchar,
          ae = H.seriesnameintooltip,
          ie = H.plotborderdashlen,
          oe = H.plotborderdashgap,
          re = H.plotborderthickness,
          le = (0, i.pluckNumber)(H.useroundedges, 0),
          se = H.plothovereffect,
          ce = z.plotfillangle,
          ue = z.plotborderdashstyle,
          he = X.config,
          de = G.isBar,
          pe = G.config.is3D,
          fe = H.use3dlighting,
          ge = H.realTimeConfig && H.realTimeConfig.numDisplaySets,
          me = ge - z.initCatLen,
          be = ge && me >= 0 ? me : 0,
          ve = H.usedataplotcolorforlabels;

      j = Y.getLabel(n ? e - n : be + e), he.origLabel = B = (0, i.getValidValue)((0, i.parseUnsafeString)(j.label)), b = he.label = (0, i.getValidValue)((0, i.parseUnsafeString)(j.tooltext)) || B, t.tooltext !== h && (t.tooltext = (0, i.parseTooltext)(t.tooltext, [3], {
        label: j.label
      }, t, K, W)), he.showValue = (0, i.pluckNumber)(t.showvalue, z.showValues), he.setValue = m = U.getCleanValue(t.value, (0, i.pluckNumber)(H.stack100percent)), he.setLink = (0, i.pluck)(t.link), he.toolTipValue = D = U.dataLabels(m), he.setDisplayValue = M = (0, i.parseUnsafeString)(t.displayvalue), he.displayValue = (0, i.pluck)(M, D), I = (0, i.pluckNumber)(t.dashed), R = (0, i.pluckNumber)(t.dashlen, ie), V = oe = (0, i.pluckNumber)(t.dashgap, oe), null !== m && (z.maxValue = x(z.maxValue, m), z.minValue = y(z.minValue, m)), he.plotBorderDashStyle = g = 1 === I ? (0, i.getDashStyle)(R, V) : 0 === I ? "none" : ue, q ? ($ = Z.getPlotColor((0, i.pluckNumber)(e - n, e)), $ = (0, i.pluck)(t.color, $), ve && Y.updateTicksValues(e, {
        labelfontcolor: (0, i.convertColor)($)
      }), f = (0, i.pluck)(t.alpha, t.borderalpha, z.plotborderalpha, d).toString()) : ($ = (0, i.pluck)(t.color, z.plotColor), f = (0, i.pluck)(t.alpha, z.plotborderalpha, d).toString()), p = (0, i.pluck)(t.ratio, z.ratio), d = (0, i.pluck)(t.alpha, z.plotfillalpha), he.shadow = {
        opacity: z.showShadow ? d / 100 : 0
      }, m < 0 && !le && (c = z.plotfillangle, ce = de ? 180 - ce : 360 - ce), he.colorArr = v = (0, i.getColumnColor)($ + "," + z.plotgradientcolor, d, p, ce, le, z.plotbordercolor, f, de ? 1 : 0, !!pe), he.originalPlotColor = $, 0 !== se && (C = (0, i.pluck)(t.hovercolor, W.hovercolor, K.plotfillhovercolor, K.columnhovercolor, $), k = (0, i.pluck)(t.hoveralpha, W.hoveralpha, K.plotfillhoveralpha, K.columnhoveralpha, d), !(w = (0, i.pluck)(t.hovergradientcolor, W.hovergradientcolor, K.plothovergradientcolor, z.plotgradientcolor)) && (w = ""), S = (0, i.pluck)(t.hoverratio, W.hoverratio, K.plothoverratio, p), _ = (0, i.pluckNumber)(360 - t.hoverangle, 360 - W.hoverangle, 360 - K.plothoverangle, ce), L = (0, i.pluck)(t.borderhovercolor, W.borderhovercolor, K.plotborderhovercolor, z.plotbordercolor), P = (0, i.pluck)(t.borderhoveralpha, W.borderhoveralpha, K.plotborderhoveralpha, K.plotfillhoveralpha, K.columnhoveralpha, f, d), A = (0, i.pluckNumber)(t.borderhoverthickness, W.borderhoverthickness, K.plotborderhoverthickness, z.showplotborder && re), N = t.borderhoverdashed || W.borderhoverdashed || K.plotborderhoverdashed, E = (0, i.pluckNumber)(t.borderhoverdashgap, W.borderhoverdashgap, K.plotborderhoverdashgap, ie), F = (0, i.pluckNumber)(t.borderhoverdashlen, W.borderhoverdashlen, K.plotborderhoverdashlen, oe), O = N !== h ? Number(N) ? (0, i.getDashStyle)(F, E) : "" : g, (H.drawTrendRegion && !pe || 1 == se && C === $) && (C = (0, i.getLightColor)(C, 70)), T = (0, i.getColumnColor)(C + "," + w, k, S, _, le, L, P.toString(), de ? 1 : 0, !!pe), he.setRolloutAttr = {
        fill: pe ? [(0, i.toRaphaelColor)(v[0]), !fe] : (0, i.toRaphaelColor)(v[0]),
        stroke: J ? (0, i.toRaphaelColor)(v[1]) : i.TRACKER_FILL,
        "stroke-width": J ? re : 0,
        "stroke-dasharray": g
      }, he.setRolloverAttr = {
        fill: pe ? [(0, i.toRaphaelColor)(T[0]), !fe] : (0, i.toRaphaelColor)(T[0]),
        stroke: L ? (0, i.toRaphaelColor)(T[1]) : i.TRACKER_FILL,
        "stroke-width": A,
        "stroke-dasharray": O
      }), a = he.toolTipValue, he.origToolText = r = (0, i.getValidValue)((0, i.parseUnsafeString)((0, i.pluck)(t.tooltext, W.plottooltext, K.plottooltext))), Q ? null === a ? u = !1 : r !== h ? (s = [1, 2, 3, 4, 5, 6, 7], o = {
        yaxisName: ee,
        xaxisName: te,
        formattedValue: a,
        label: b
      }, u = (0, i.parseTooltext)(r, s, o, t, K, W)) : (ae && (l = (0, i.getFirstValue)(W && W.seriesname)), u = l ? l + ne : "", u += b ? b + ne : "") : u = !1, he.toolText = u, he.setTooltext = u, c && (ce = c), he._x = e, he._y = m;
    }, t.prototype.updateYForStack = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          l = this.getFromEnv("chartConfig"),
          s = (0, i.pluckNumber)(l.showpercentvalues),
          c = (0, i.pluckNumber)(l.showpercentintooltip),
          u = this.config.JSONData,
          d = this.getFromEnv("chart-attrib"),
          p = this.getFromEnv("xAxis").getTicksLen(),
          f = this.components.data,
          g = this.getFromEnv("stackValues"),
          m = s || c ? -1 : 1,
          b = this.getSkippingInfo && this.getSkippingInfo(),
          v = b && b.skippingApplied,
          y = b && b.draw || [],
          x = y && y.length;

      for (v && (p = x), a = 0; a < p; a++) {
        t = (e = f[n = y[a] || a]) && e.config, e !== h && (o = (0, i.getValidValue)((0, i.parseUnsafeString)((0, i.pluck)(t.origToolText, u.plottooltext, d.plottooltext))), r = g[n] && g[n].positive + m * g[n].negative || 1, t._b = this._parseValues(n, t._b, r, o), l.stack100percent && (t._y = t.value + t._b));
      }
    }, t.prototype._parseValues = function (e, t, n, a) {
      var o,
          r,
          l = this.getFromEnv("chartConfig"),
          s = this.components.data[e].config,
          c = (0, i.pluckNumber)(l.showpercentvalues),
          u = (0, i.pluckNumber)(l.showpercentintooltip),
          h = this.getState("visible"),
          d = s.setValue,
          p = (0, i.pluckNumber)(l.stack100percent),
          f = this.getFromEnv("number-formatter"),
          g = this.getFromEnv("yAxis"),
          m = s.setDisplayValue;
      return r = (h && d || 0) / n * 100, o = f.percentValue(r), p && (s.value = r, t = (t || 0) / n * 100), u && (s.toolTipValue = o), c && !m && (s.displayValue = o), a && (s.toolText = (0, i.parseTooltext)(s.setTooltext, [14, 24, 25, 112], {
        percentValue: o,
        sum: g.dataLabels(n),
        unformattedSum: n
      })), t;
    }, t.prototype._addLegend = function () {
      var e,
          t,
          n,
          a = this.getFromEnv("chart").isBar,
          o = this.getFromEnv("chart-attrib"),
          r = this.config,
          l = (0, i.getFirstColor)(r.legendSymbolColor),
          s = this.getFromEnv("legend"),
          c = (0, i.pluckNumber)(o.use3dlighting, o.useplotgradientcolor, 1),
          u = (0, i.getLightColor)(l, 60).replace(p, i.HASHSTRING);
      r.includeinlegend ? (e = c ? {
        FCcolor: {
          color: l + "," + l + "," + (0, i.getLightColor)(l, 40) + "," + l + "," + l,
          ratio: "0,30,30,30,10",
          angle: a ? 0 : 270,
          alpha: "100,100,100,100,100"
        }
      } : {
        FCcolor: {
          color: l,
          angle: a ? 0 : 270,
          ratio: "0",
          alpha: "100"
        }
      }, n = s.getItem(this.config.legendItemId), t = {
        type: this.getName(),
        index: this.getJSONIndex(),
        label: (0, i.getFirstValue)(this.config.JSONData.seriesname)
      }, n || (this.config.legendItemId = s.createItem(this), n = s.getItem(this.config.legendItemId), this.addExtEventListener("fc-click", function () {
        n.itemClickFn();
      }, n)), n.configure(t), n.setStateCosmetics("default", {
        symbol: {
          fill: (0, i.toRaphaelColor)(e),
          rawFillColor: l,
          stroke: (0, i.toRaphaelColor)(u)
        }
      }), this.getState("visible") ? n.removeLegendState("hidden") : n.setLegendState("hidden")) : this.config.legendItemId && s.disposeItem(this.config.legendItemId);
    }, t.prototype.legendInteractivity = function (e) {
      var t = e.getLinkedParent().getFromEnv("chart"),
          n = this.getState("visible"),
          a = this.config;

      if (t.getFromEnv("animationManager").setAnimationState("legendInteraction"), a.legendInteractivity = !0, n ? this.hide() : this.show(), i.isFirefox) {
        var o = t.getChildContainer("plotGroup");
        o.attrs["clip-rect"] && o.attr({
          "clip-rect": o.attrs["clip-rect"]
        });
      }

      a.drawnEvtListenerAttached || (a.drawnEvtListenerAttached = !0, this.addEventListener("drawn", function () {
        a.legendInteractivity = !1;
      }));
    }, t.prototype.createPinElem = function () {
      var e,
          t,
          n,
          a = this.getFromEnv("chart"),
          i = arguments[1].group,
          o = this.components.data,
          r = this.graphics.pinElems || (this.graphics.pinElems = []),
          l = this.getLinkedParent().getChildContainer().columnVcanvasGroup;

      for (e = r.length - 1; e >= 0; e--) {
        r[e].remove(), r.pop();
      }

      if (this.getState("visible")) for (e = this.config.scrollMinVal; e < this.config.scrollMaxVal; e++) {
        (n = o[e]) && n.graphics && (t = n.graphics.element.clone().attr({
          transform: ["T", -(a.config._visx + C(l.transform()[0][1])), -a.config.canvasBottom]
        }), i.appendChild(t), r.push(t));
      }
    }, t.prototype._checkPointerOverColumn = function (e, t, n) {
      var a,
          i,
          o,
          r,
          l,
          s,
          c,
          u,
          p,
          f = this.getFromEnv("chart").config,
          g = f.plotborderthickness,
          m = f.showplotborder,
          b = this.components.data,
          v = b && b.length,
          y = 0,
          x = 0,
          C = f.dragTolerance || 0,
          k = (this.getSkippingInfo && this.getSkippingInfo()).plotsPerBin;

      for (c = p = (p = (u = (L(e / k) - 1) * k + 1) + k - 1) < v ? p : v; c >= u; c--) {
        if (!(a = b[c])) return;
        if (a._height < d && (y = d), a._width < d && (x = d), (a._xPos || a._yPos) && (i = a.config.setValue, m && g !== h ? s = g / 2 : g = s = 0, null !== i && (o = t - a._xPos + s, r = n - a._yPos + s + (i >= 0 ? C : 0), l = o >= -x / 2 && o <= (x || a._width) + g && r >= -y / 2 && r <= (y || a._height) + g + (i < 0 ? 2 * C : C)))) return {
          pointIndex: c,
          hovered: l,
          pointObj: b[c]
        };
      }
    }, t.prototype._getHoveredPlot = function (e, t) {
      var n,
          a,
          i = this.getFromEnv("chart").isBar,
          o = this.getFromEnv("xAxis");
      return e += o.getTranslation(), n = o.getValue(i ? t : e), (a = Math.round(n)) - n > 0 ? this._checkPointerOverColumn(a, e, t) || this._checkPointerOverColumn(a - 1, e, t) : this._checkPointerOverColumn(a + 1, e, t) || this._checkPointerOverColumn(a, e, t);
    }, t.prototype.getPlotInCategoryAt = function () {
      var e,
          t,
          n,
          a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0,
          i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0,
          o = this.components.data,
          r = this.getFromEnv("xAxis"),
          l = this.getFromEnv("yAxis"),
          s = r.getTranslation() || 0,
          c = l.getTranslation() || 0,
          u = this.getState("visible"),
          h = a + s,
          d = i + c,
          p = void 0;
      if ("category" === r.getName() && r.config.hasCategory) p = r;else {
        if ("category" !== l.getName() || !l.config.hasCategory) return !1;
        p = l;
      }
      return null !== (t = p.config.isVertical) && void 0 !== t && (e = o[Math.round(p.getValue(t ? d : h))], n = this._getHoveredPlot(a, i), u && n ? n : !(!u || !e) && {
        pointIndex: e._index,
        hovered: !1,
        pointObj: e
      });
    }, t.prototype._decideTooltipType = function (e, t) {
      var n = this.getFromEnv("chart").config.drawTrendRegion,
          a = this.components,
          i = this.getFromEnv("toolTipController"),
          o = a.data[e],
          r = o && (o.config.finalTooltext || o.config.toolText),
          l = this.config.currentToolTip,
          s = t.originalEvent;
      r && !n && (l ? i.draw(s, r, l) : l = this.config.currentToolTip = i.draw(s, r));
    }, t.prototype._firePlotEvent = function (e, t, n) {
      var a,
          i = this.getFromEnv("chart"),
          o = this.components,
          r = this.getFromEnv("toolTipController"),
          l = o.data[t],
          s = l.graphics && l.graphics.element,
          c = this.config.currentToolTip;
      if (s) switch (a = l.config.setLink, e) {
        case "fc-mouseover":
          this._decideTooltipType(t, n), function (e, t, n, a, i) {
            var o = t.graphics,
                r = o && o.element,
                l = e.getFromEnv("animationManager"),
                s = r && r.getData();
            !0 !== s.draged && (r && 0 !== s.showHoverEffect && (l.setAnimationState("mouseOver"), l.setAnimation({
              el: r,
              label: "rect",
              component: i,
              attr: r.getData().setRolloverAttr
            })), !a && r && e.plotEventHandler(r, n, "DataPlotRollOver"));
          }(i, l, n, h, this), a && (s.node.style.cursor = "pointer");
          break;

        case "fc-mouseout":
          r.hide(c), function (e, t, n, a, i) {
            var o = t.graphics,
                r = o && o.element,
                l = e.getFromEnv("animationManager"),
                s = r && r.getData();
            !0 !== s.draged && (r && 0 !== s.showHoverEffect && (l.setAnimationState("mouseOut"), l.setAnimation({
              el: r,
              label: "rect",
              component: i,
              attr: r.getData().setRolloutAttr
            })), !a && r && e.plotEventHandler(r, n, "DataPlotRollOut"));
          }(i, l, n, h, this), a && (s.node.style.cursor = f);
          break;

        case "fc-click":
          i.plotEventHandler(s, n);
          break;

        case "fc-mousemove":
          this._decideTooltipType(t, n);

      }
    }, t.prototype.createContainer = function () {
      var e,
          t,
          n,
          a,
          i = this.getType(),
          o = this.getFromEnv("chart"),
          r = this.getLinkedParent(),
          l = this.config.primitiveType || i;
      !r.getChildContainer(l + "VcanvasGroup") && (l = "default"), e = r.getChildContainer(l + "VcanvasGroup"), a = r.getChildContainer(l + "ShadowVcanvasGroup"), t = r.getChildContainer("commonElemGroup") || e, n = r.getChildContainer("anchorGroup") || e, !this.getContainer("shadowGroup") && this.addContainer("shadowGroup", N("shadow-group", a, this)), !this.getContainer("errorShadowGroup") && this.addContainer("errorShadowGroup", N("error-shadow-group", a, this)), !this.getContainer("commonElemsGroup") && this.addContainer("commonElemsGroup", N("common-elems-group", t, this)), !this.getContainer("plotGroup") && this.addContainer("plotGroup", N("plot-group", n, this)), !this.getContainer("errorPlotGroup") && this.addContainer("errorPlotGroup", N("error-plot-group", e, this)), o.hasAnchor && this.getContainer("errorPlotGroup").insertBefore(this.getContainer("plotGroup")), !this.getContainer("labelGroup") && this.addContainer("labelGroup", N("label-group", r.getChildContainer("vcanvasLabelGroup"), this).attr("class", "fusioncharts-datalabels"));
    }, t.prototype.createCoordinates = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r,
          l,
          s,
          c,
          u = this.components.data,
          d = this.getFromEnv("chart"),
          p = d.isBar,
          f = this.getFromEnv("yAxis"),
          g = this.getFromEnv("xAxis"),
          m = f.getAxisBase(),
          b = f.getPixel(m),
          v = g.config.isVertical,
          y = d.config.xDepth || 0,
          x = d.config.yDepth || 0,
          C = u.length,
          k = this.components,
          w = this.getLinkedParent(),
          S = w.getstackConf && w.getstackConf(),
          _ = k.data,
          L = this.getSkippingInfo && this.getSkippingInfo(),
          P = L && L.skippingApplied,
          A = L && L.draw || [],
          N = A && A.length;

      for (!p && (y = -y), p && (x = -x), P && (C = N), i = 0; i < C; i++) {
        t = (e = _[a = A[i] || i]) && e.config, e !== h && (n = t._b, s = g.getPixel(S && S[a] && S[a].x || t._x), o = (isFinite(s) ? s : 0) + y, c = f.getPixel(t._y), r = (isFinite(c) ? c : 0) + x, l = (n ? f.getPixel(n) : b) + x, v ? (t._Px = r, t._Py = o, t._Pby = o, t._Pbx = l) : (t._Px = o, t._Py = r, t._Pby = l, t._Pbx = o), this.getLineShift && (t._Py += this.getLineShift("y")));
      }
    }, t.prototype.setContainerVisibility = function (e) {
      var t,
          n = this.getContainer();

      for (t in n) {
        n.hasOwnProperty(t) && (!1 !== this.getState("visible") || !1 !== this._conatinerHidden && this._conatinerHidden !== h || e ? (n[t].show(), this._conatinerHidden = !1) : (n[t].hide(), this._conatinerHidden = !0));
      }
    }, t.prototype.plotAnimManager = function (e, t, n, a) {
      var i,
          o,
          r,
          l,
          s,
          c,
          u = this.getFromEnv("chart"),
          h = u.getFromEnv("animationManager"),
          d = u.config.is3D,
          p = u.config,
          f = this.getState("visible"),
          g = t.x,
          m = this.getSkippingInfo && this.getSkippingInfo(),
          b = m && m.draw || [],
          v = this.getFromEnv("plotGroup3d");
      c = ((r = e && e.config) && r.setValue) < 0, s = d ? (o = c ? v.negativeGroupArray : v.positiveGroupAarray)[u.isBar ? o.length - 1 - n : n] : this.getContainer("plotGroup"), l = {
        el: (i = e.graphics.element) || (d ? "cubepath" : "rect"),
        container: s,
        attr: f && t,
        doNotRemove: !0,
        props: {
          originalIndex: b[n] || n
        },
        index: n,
        length: a,
        component: this,
        label: "rect"
      }, f || (l.callback = function () {
        this.hide();
      }), e.graphics.element = i = h.setAnimation(l), d && (i.appendTo(s), (p.isstacked && c || !p.isstacked && u.isBar) && i.toBack()), null !== e.config.setValue ? this.getState("visible") && i.show() : (i.remove(), delete e.graphics.element), r._oldPx = r._Px, r._oldX = g, f && (e.oldPrevDataObj = e.prevDataObj);
    }, t.prototype.flushOnScroll = function (e, t) {
      for (var n = void 0, a = this.components.data, i = e, o = t - 1; i <= o; i++) {
        (n = a[i]) && n.graphics && (A(n.graphics, this.__removeElem), n.graphics = {});
      }
    }, t.prototype.removingDraw = function () {
      var t = this;
      t.components.data.forEach(function (e) {
        A(e.graphics, t.__removeElem), delete e.graphics;
      }), e.prototype.removingDraw.call(this);
    }, t.prototype._contextChanged = function () {
      var e;
      this.config.context || (this.config.context = {});
      var t,
          n = this.config.context,
          a = n.shift,
          i = this.getFromEnv("xAxis"),
          o = this.getFromEnv("yAxis"),
          r = n.axisLimit,
          l = !1,
          s = {
        yAxis: {
          limit: o.getVisibleConfig()
        },
        xAxis: {
          limit: i.getVisibleConfig()
        }
      };
      return s.yAxis.limitPixel = {
        min: o.getPixel(s.yAxis.limit.minValue),
        max: o.getPixel(s.yAxis.limit.maxValue)
      }, s.xAxis.limitPixel = {
        min: i.getPixel(s.xAxis.limit.minValue),
        max: i.getPixel(s.xAxis.limit.maxValue)
      }, r !== (t = JSON.stringify(s)) && (n.axisLimit = t, l = !0), a !== this.getFromEnv("shift") && (n.shift = this.getFromEnv("shift"), l = !0), n.prevColNum !== this.getFromEnv("numOfColumns") && (n.prevColNum = this.getFromEnv("numOfColumns"), l = !0), i.getProcessLen ? e = i.getProcessLen() : i.getTicksLen && (e = i.getTicksLen()), n.prevCatlen !== e && (n.prevCatlen = e, l = !0), !!this.getFromEnv("chart").isRealTime || l;
    }, t.prototype.calculateScrollRange = function () {
      var e = this.config,
          t = this.getFromEnv("xAxis"),
          n = void 0,
          a = t.getTicksLen(),
          i = this.getSkippingInfo && this.getSkippingInfo() || {},
          o = i.skippingApplied,
          r = i.draw || [],
          l = i.labelDraw || [],
          s = r.length;
      n = o ? s - 1 : a, e.scrollMinVal = x(P(t.getVisibleConfig().minValue), 0) - 1, e.scrollMaxVal = y(P(t.getVisibleConfig().maxValue) + 1, n) + 1, n = o ? l.length - 1 : a, e.scrollMinValForLabel = x(P(t.getVisibleConfig().minValue), 0) - 1, e.scrollMaxValForLabel = y(P(t.getVisibleConfig().maxValue) + 1, n) + 1;
    }, t.prototype.drawPlots = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r,
          l,
          s,
          c = this.getFromEnv("chart"),
          u = this.config,
          h = c.config.plothovereffect,
          d = this.components.data,
          p = this.getContainer("shadowGroup"),
          f = u._oldStartIndex,
          v = u._oldEndIndex,
          y = this.getSkippingInfo && this.getSkippingInfo(),
          x = y && y.draw;

      for (r = u.scrollMinVal, l = u.scrollMaxVal, r > f && this.flushOnScroll(f, r > v ? v : r), l < v && this.flushOnScroll(l < f ? f : l, v), u._oldStartIndex = r, u._oldEndIndex = l, e = r, s = l - 1; e < l; e++, s--) {
        (t = d[x[e] || e]) && (o = (a = t.config).props.element.attr, this.plotAnimManager(t, o, e, l), i = t.trackerConfig, (n = t.graphics.element) && (n.shadow(a.shadow, p).data("BBox", void 0), c.config.enablemousetracking && n.data("eventArgs", i.eventArgs).data(g, h).data(m, a.setRolloverAttr || {}).data(b, a.setRolloutAttr || {})));
      }

      u.appearing && (u.appearing = !1);
    }, t.prototype.setColumnPosition = function () {
      var e,
          t = void 0;

      if ((t = this.getFromEnv("plotWidth")) === h) {
        var n,
            a,
            o = this.getFromEnv("xAxis"),
            r = this.getFromEnv("chartConfig"),
            l = this.getSkippingInfo().plotsPerBin,
            s = x(r.plotSpacePercent, 0),
            c = x((0, i.pluckNumber)(s, 20) % 100, 0),
            u = 1 === l ? c / 200 : 0,
            d = o.getPixel(0),
            p = o.getPixel(l),
            f = this.getFromEnv("chart"),
            g = f.isBar ? f.config.maxBarHeight : f.config.maxColWidth,
            m = C(p - d),
            b = !0;
        t = (n = (1 - .01 * s) * m || y(m * (1 - 2 * u), 1 * g)) / 1, p - (a = n / 2) - (d - a + n) < 4 && (b = !1), 0 === c && (b = !0), this.addToEnv("isCrisp", b);
      }

      this.addToEnv("columnWidth", t), e = this.getFromEnv("shift") || 0, this.addToEnv("columnXShift", e - this.getFromEnv("columnWidth") / 2);
    }, t.prototype.parsePlotAttributes = function (e, t) {
      var n,
          a,
          o,
          r,
          l,
          s,
          c,
          u,
          h,
          p,
          f,
          g,
          m,
          b,
          v,
          x,
          L,
          P,
          A,
          N,
          E,
          F,
          O,
          T,
          D = this.config,
          M = this.config.JSONData,
          I = this.getFromEnv("chart"),
          R = I.getFromEnv("dataSource").chart,
          V = I.config.isstacked,
          B = this.config,
          j = this.groupManager,
          G = this.getJSONIndex(),
          H = t,
          z = this.getState("visible"),
          W = I.config,
          q = I.config.is3D,
          U = I.isBar,
          Y = W.xDepth || 0,
          X = W.yDepth || 0,
          K = this.getFromEnv("yAxis"),
          Z = this.getFromEnv("xAxis"),
          J = W.showtooltip,
          $ = !1 !== this.getState("visible"),
          Q = this.components.data,
          ee = e.config,
          te = K.getAxisBase(),
          ne = K.yBasePos = K.getPixel(te),
          ae = (0, i.pluckNumber)(B.plotborderthickness, W.plotborderthickness),
          ie = (0, i.pluckNumber)(W.useroundedges, 0),
          oe = B.use3dlighting,
          re = y(D.yAxisMinPixel, D.yAxisMaxPixel),
          le = j && j.stackConf,
          se = this.getFromEnv("columnXShift"),
          ce = I.config.viewPortConfig,
          ue = ce.x,
          he = ce.scaleX,
          de = (0, i.pluckNumber)(W.showplotborder);
      m = ee.setLink, v = ee.colorArr || [], Z.config.isVertical ? (u = this.getFromEnv("columnWidth"), c = se) : (l = this.getFromEnv("columnWidth"), s = se), e.graphics || (Q[H].graphics = {}), b = ee.displayValue, !$ && (ee._Py = ee._Pby), A = y(ee._Px, ee._Pbx) + (s || 0) + ue * he, N = y(ee._Py, ee._Pby) + (c || 0), le && (A -= l / 2), E = l || C(ee._Px - ee._Pbx), F = u || C(ee._Py - ee._Pby), n = U ? ee._Px - ee._Pbx > 0 ? w : S : ee._Py - ee._Pby > 0 ? _ : k, g = (0, i.getValidValue)((0, i.parseUnsafeString)((0, i.pluck)(ee.origToolText, M.plottooltext, R.plottooltext))), this.fineTunePlotDimension && (A = (T = this.fineTunePlotDimension(A, N, F, E, H)).xPos, N = T.yPos, E = T.width, F = T.height), a = A, o = N, h = E, p = F, r = Z.getPixel(1) - Z.getPixel(0) - (U ? p : h), !isFinite(p) && (p = 0), z && (r < 5 && this.getFromEnv("columnWidth") < 5 || (L = (0, i.crispBound)(A, N, h, p, ae, n, V)), L ? (a = L.x, o = L.y, ae = L["stroke-width"], h = L.width, p = L.height || 1) : (a = A, o = N), Z.config.isVertical ? a === re && (a -= ae, h += ae) : o + p === re ? p += ae : o === re && (o -= ae, p += ae), ee.setRolloutAttr && (ee.setRolloutAttr["stroke-width"] = D.showplotborder ? ae : 0)), f = ee.finalTooltext = !1 !== ee.toolText ? ee.toolText + (g ? "" : ee.toolTipValue) : "", x = ee.plotBorderDashStyle, (P = e.trackerConfig = {}).eventArgs = {
        index: H,
        link: m,
        value: ee.setValue,
        displayValue: b,
        categoryLabel: ee.origLabel,
        toolText: f,
        id: "",
        datasetIndex: G,
        datasetName: M.seriesname,
        visible: z
      }, O = ne === o + 0, ee.props = {
        element: {
          attr: {
            x: a || 0,
            width: h || 0,
            height: p || 0,
            y: o || 0,
            r: ie,
            fill: (0, i.toRaphaelColor)(v[0]) || "",
            stroke: de ? (0, i.toRaphaelColor)(v[1]) || "" : i.TRACKER_FILL,
            "stroke-width": de ? ae : 0,
            "stroke-dasharray": x,
            "stroke-linejoin": "miter",
            visibility: z,
            cursor: m ? "pointer" : ""
          }
        }
      }, q && (ee.props.element.attr.noGradient = !oe, ee.props.element.attr.xDepth = Y, ee.props.element.attr.yDepth = X), e._xPos = a + Y, e._width = h, e._yPos = o - X, e._height = p, e._index = H, e._plotBorderThickness = ae, (m || J) && (p < d && (o -= (d - p) / 2, p = d), P.attr = {
        x: a,
        y: o,
        width: h,
        height: p,
        r: ie,
        cursor: m ? "pointer" : "",
        stroke: i.TRACKER_FILL,
        "stroke-width": de ? ae : 0,
        fill: i.TRACKER_FILL,
        visibility: z
      }), ee.oldValue = void 0, e._oldYBaseTouched = O;
    }, t.prototype.parseLabelAttributes = function (e) {
      var t,
          n,
          a,
          i,
          o,
          r,
          l,
          s,
          c,
          u,
          d,
          p,
          f = this.getFromEnv("chart"),
          g = f.config,
          m = f.getFromEnv("smartLabel"),
          b = f.config.dataLabelStyle,
          v = this.config.legendInteractivity,
          y = this.getState("visible"),
          x = g.rotatevalues ? 270 : 0;
      if (c = (u = e && e.config) && u.setValue, e === h || c === h || null === c || !0 === u.labelSkip) return u && delete u.labelSkip, void ((p = e && e.graphics) && p.label && p.label.hide());
      (i = e.graphics) && (l = e._yPos, s = e._xPos, n = u.displayValue, u.showValue && null !== c ? (v && u._state || (m.setStyle(b), a = m.getOriSize(n), u._state = x ? {
        labelWidth: a.height,
        labelHeight: a.width
      } : {
        labelWidth: a.width,
        labelHeight: a.height
      }), r = (d = this._getValuePosition({
        labelWidth: u._state.labelWidth,
        labelHeight: u._state.labelHeight,
        width: e._width,
        height: e._height,
        yPos: l,
        xPos: s,
        value: c
      })).textX, o = d.textY, u.props || (u.props = {}), u.props.label = {
        attr: {
          x: r,
          y: o,
          text: n,
          "text-bound": [b.backgroundColor, b.borderColor, b.borderThickness, b.borderPadding, b.borderRadius, b.borderDash],
          opacity: y ? 1 : 0
        }
      }, t = u.props.label.attr, v || (t["line-height"] = b.lineHeight, t.fill = b.color)) : i.label && (i.label.attr({
        "text-bound": []
      }), i.label.hide()));
    }, t.prototype.allocatePosition = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r,
          l,
          s = this.getFromEnv("chart"),
          c = s.config,
          u = this.config,
          h = this.components.data.length,
          d = this.getFromEnv("yAxis"),
          p = this.components.data,
          f = c.isstacked,
          g = this.getSkippingInfo && this.getSkippingInfo(),
          m = g && g.draw;

      for (this.deleteFromEnv("columnWidth"), this.setColumnPosition(), this.calculateScrollRange(), f && this.updateYForStack(), this.createCoordinates(), a = d.getLimit(), r = d.getPixel(a.max), l = d.getPixel(a.min), i = u.scrollMinVal, o = u.scrollMaxVal, r > l ? (u.yAxisMaxPixel = r, u.yAxisMinPixel = l) : (u.yAxisMaxPixel = l, u.yAxisMinPixel = r), t = 0; t < h; t++) {
        e = m[t] || t, s.hasScroll && (e < i || e > o) || (n = p[e]) && (this.parsePlotAttributes(n, e), this.parseLabelAttributes(n));
      }
    }, t.prototype.draw = function () {
      var e,
          t,
          n = this,
          a = n.config,
          i = n.getState("visible"),
          o = n.getFromEnv("xAxis"),
          r = o.getPixel(0),
          l = o.getPixel(1),
          s = n.getFromEnv("groupMaxWidth"),
          u = n.getFromEnv("chart").config.xDepth || 0,
          h = n.getFromEnv("yAxis"),
          d = a.drawn,
          p = h.getLimit(),
          f = p.max,
          g = p.min,
          m = f > 0 && g < 0,
          b = n._contextChanged(),
          v = (n.getSkippingInfo && n.getSkippingInfo() || {}).skippingApplied;

      s || (s = C(l - r), n.addToEnv("groupMaxWidth", s)), (n.getState("removed") || n.getState("dirty") || b && i) && (!d && n.createContainer(), n.setContainerVisibility(!0), v && n.hidePlots(), n.drawPlots(), n.drawCommonElements && !n.config.skipCommonElements && n.drawCommonElements(), e = a.scrollMinValForLabel, t = a.scrollMaxValForLabel, a.drawn ? n.drawLabel(e, t) : n.addJob("labelDrawID", function () {
        n.drawLabel(e, t);
      }, c.priorityList.label), a.drawn = !0, n.removePlots(), a.oldGroupMaxWidth = s, a.oldDataIsPositiveNegative = m, a.oldZeroAxisPos = h.getPixel(h.getAxisBase()) + u, n.drawErrorValue && n.drawErrorValue(), a.prevVisible = i, a.catDiff = 0);
    }, t.prototype.show = function () {
      var e = this.getLinkedParent(),
          t = this.getFromEnv("legend");
      t && t.getItem(this.config.legendItemId) && t.getItem(this.config.legendItemId).removeLegendState("hidden"), this.setState("visible", !0), this.config.appearing = !0, this._conatinerHidden = !1, this.setState("dirty", !0), e.childChanged(), this.config.appearing = !1, this.asyncDraw();
    }, t.prototype.hide = function () {
      var e = this.getLinkedParent(),
          t = this.getFromEnv("legend");
      t && t.getItem(this.config.legendItemId) && t.getItem(this.config.legendItemId).setLegendState("hidden"), this.setState("dirty", !0), this.setState("visible", !1), e.childChanged(), this.asyncDraw();
    }, t.prototype.drawLabel = function (e, t) {
      var n,
          a,
          o,
          r,
          l,
          s,
          c,
          u,
          d,
          p,
          f,
          g,
          m = this.getFromEnv("chart"),
          b = this.getFromEnv("animationManager"),
          v = m.config,
          y = this.getFromEnv("xAxis"),
          x = this.getFromEnv("paper"),
          C = this.getState("visible"),
          k = m.getFromEnv("smartLabel"),
          w = m.config.dataLabelStyle,
          S = this.config,
          _ = y.getTicksLen(),
          L = this.components,
          P = L.data,
          A = L.pool,
          N = v.rotatevalues ? 270 : 0,
          E = S.labelDrawn,
          F = this.getSkippingInfo && this.getSkippingInfo(),
          O = F && F.skippingApplied,
          T = F && F.labelDraw || [],
          D = T.length,
          M = (0, i.pluckNumber)(e, 0),
          I = (0, i.pluckNumber)(t, O ? D : _),
          R = D === Math.abs(I - (M + 1)),
          V = function V() {
        this.attr({
          "text-bound": []
        }), this.hide();
      };

      for ((g = this.getContainer("labelGroup")).css({
        fontFamily: w.fontFamily,
        fontSize: w.fontSize,
        fontWeight: w.fontWeight,
        fontStyle: w.fontStyle
      }), g.show(), k.useEllipsesOnOverflow(m.config.useEllipsesWhenOverflow), k.setStyle(w), r = M; r < I; r++) {
        c = (u = (n = P[o = O && R ? T[r] : r]) && n.config) && u.setValue, n !== h && c !== h && null !== c && !0 !== u.labelSkip ? (l = n.graphics) && (u.showValue && null !== c ? (a = u.props.label.attr, s = n._xPos, !l.label && E && m.isRealTime && ((d = (0, i.extend2)({}, a)).x = a.x - s + (n._newXPos || 0), d.transform = x.getSuggestiveRotation(N, d.x, a.y), A && A.label[0] && (l.label = A.label[0], A.label.splice(0, 1))), a.transform = x.getSuggestiveRotation(N, a.x, a.y), (p = l.label) || A && A.label[0] && (p = l.label = A.label[0], A.label.splice(0, 1)), (p = b.setAnimation({
          el: l.label || "text",
          attr: a,
          component: this,
          label: "plotLabel",
          index: o,
          container: g,
          callback: !C && V
        })) && p.show(), l.label || (l.label = this.addGraphicalElement("plotLabel", p, !0))) : l.label && (l.label.attr({
          "text-bound": []
        }), l.label.hide())) : (u && delete u.labelSkip, (f = n && n.graphics) && f.label && f.label.hide());
      }

      S.labelDrawn = !0;
    }, t.prototype._getValuePosition = function (e) {
      var t,
          n,
          a,
          o,
          r,
          l,
          s,
          c,
          u,
          h = this.getFromEnv("chart"),
          d = h.getChildren(),
          p = h.config,
          f = d.yAxis[0],
          g = p.xDepth || 0,
          m = p.yDepth || 0,
          b = p.canvasTop,
          v = p.canvasHeight + m,
          C = e.yPos,
          k = h.config.is3D,
          w = h.config.isstacked,
          S = p.valuepadding + 2,
          _ = e.height,
          L = e.width,
          P = p.placevaluesinside,
          A = e.labelHeight,
          N = f.getAxisConfig("isReverse"),
          E = e.value,
          F = e.xPos;
      return N || (c = !(E < 0)), r = (0, i.pluck)(c, E < 0), l = u = A + S, o = _, a = C - (s = .5 * u + S), n = F + .5 * L, r ? (t = b + v - (C + _ + m), a = C) : t = C - b, w ? (a = y(b + v - .5 * l, a = C + .5 * _ + (m || 0)), a = x(b + .5 * l, a), n -= g) : P ? o >= l ? (a = C + (r ? _ - s : s), k && (n -= g, a += m)) : t >= l ? (a = C + (r ? _ + s : -s), k && r && (n -= g, a += m)) : (a = C + (r ? _ - s : s), k && (n -= g, a += m)) : t >= l ? (a = C + (r ? _ + s : -s), k && (r ? (n -= g, a += m) : n -= g / 2)) : (a = C + (r ? _ - s : s), k && (n -= g, a += m)), {
        textX: n,
        textY: a
      };
    }, t.prototype.getDataLimits = function () {
      return {
        max: this.config.maxValue,
        min: this.config.minValue
      };
    }, t.prototype.addData = function (e, t, n) {
      var a,
          i = this.components,
          o = i.data,
          r = e.data.length;

      for (i.addDataArr = e.data, 0 === t ? this.startPosition = !0 : t + r !== o.length && t !== h || (this.startPosition = !1), a = 0; a < r; a++) {
        t !== h ? o.splice(t + a, 0, {
          config: {}
        }) : o.push({
          config: {}
        });
      }

      this._setConfigure(e, t), n && this.asyncDraw();
    }, t.prototype.removeData = function (e, t, n) {
      var a,
          i,
          o = this.getFromEnv("chart"),
          r = this.components,
          l = r.data,
          s = r.removeDataArr || (r.removeDataArr = []);

      for (t === h && (t = 1), (e = e || 0) + t !== l.length && o.isRealTime ? 0 !== e && e !== h || (this.endPosition = !1) : this.endPosition = !0, r.removeDataArr = s = s.concat(l.splice(e, t)), a = (i = s.length) - 1; a >= 0; a--) {
        s[a] || s.splice(a, 1);
      }

      this.removeDataLen = i, n && this.asyncDraw();
    }, t.prototype.updateData = function (e, t, n) {
      var a = this.config,
          i = a.maxValue,
          o = a.prevMin,
          r = this.getFromEnv("chart"),
          l = this.groupManager || this,
          s = r.getFromEnv("xAxis"),
          c = r.getFromEnv("yAxis");
      this._setConfigure(e, t), this.getDataLimits(), a.maxValue === i && a.minValue === o || (this.maxminFlag = !0), n && (r._setAxisLimits(), s && s[0].asyncDraw(), c && c[0].asyncDraw(), l.asyncDraw());
    }, t.prototype.removePlots = function () {
      var e = this.components,
          t = e && e.removeDataArr;
      E(t, this.__removeElem);
    }, t.prototype.removeGraphicElem = function (e, t) {
      this.__removeElem(e, t);
    }, t.prototype.getAxisValuePadding = function () {
      return this.config.defaultPadding;
    }, t.prototype.getCanvasPadding = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          l = this.config || (this.config = {}),
          s = this.components || {},
          c = this.getFromEnv("chart"),
          u = c.config.rotatevalues,
          d = this.getFromEnv("xAxis"),
          p = this.getFromEnv("yAxis"),
          f = c.config.dataLabelStyle,
          g = this.getSkippingInfo(),
          m = g.skippingApplied,
          b = g.draw,
          v = s.data || [],
          y = m ? b[0] : 0,
          C = m ? b[b.length - 1] : v.length - 1,
          k = l.leftMostData || v[y],
          w = l.rightMostData || v[C],
          S = {},
          _ = {},
          L = 0,
          P = 0,
          A = 0,
          N = d.getPixel(0),
          E = this.getFromEnv("smartLabel"),
          F = {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
          O = 0,
          T = d.getValuePadding(),
          D = l.topMostData,
          M = l.bottomMostData;
      return this.setColumnPosition(), r = {
        xPosOffset: this.getFromEnv("columnXShift"),
        columnWidth: this.getFromEnv("columnWidth"),
        height: h
      }, k && (a = (e = k.config).showValue, n = e && e.anchorProps || {}, a && (t = e.displayValue, E.useEllipsesOnOverflow(c.config.useEllipsesWhenOverflow), E.setStyle(f), _ = E.getOriSize(t), O = u ? _.height : _.width), null !== e.setValue && (o = d.getPixel(T.left), (A = (L = n.enabled && (0, i.pluckNumber)(n.radius, 0) + (0, i.pluckNumber)(n.borderThickness, 0) / 2 || 0) - (o - N)) < 0 && (A = 0), (P = (O || 0) / 2 - (o - N) - (r && r.xPosOffset + r.columnWidth / 2 || 0)) < 0 && (P = 0)), F.paddingLeft = x(A, P)), A = P = 0, w && (a = (e = w.config).showValue, n = e && e.anchorProps || {}, a && !u && (t = e.displayValue, E.setStyle(f), S = E.getOriSize(t), O = u ? S.height : S.width), null !== e.setValue && (o = d.getPixel(T.right), (A = (L = n.enabled && (0, i.pluckNumber)(n.radius, 0) + (0, i.pluckNumber)(n.borderThickness, 0) / 2 || 0) - (o - N)) < 0 && (A = 0), (P = (O || 0) / 2 - (o - N) + (r && r.xPosOffset + r.columnWidth / 2 || 0)) < 0 && (P = 0)), F.paddingRight = x(A, P)), D && (a = (e = D.config).showValue, n = e && e.anchorProps || {}, null !== e.setValue && (L = (0, i.pluckNumber)(n.radius, 0) + (0, i.pluckNumber)(n.borderThickness, 0) / 2, P = Math.max(L - (p.getPixel(e.setValue.y) - p.getPixel(p.getLimit().max)), 0)), F.paddingTop = P), M && (n = (e = M.config) && e.anchorProps || {}, null !== e.setValue && (L = (0, i.pluckNumber)(n.radius, 0) + (0, i.pluckNumber)(n.borderThickness, 0) / 2, P = Math.max(L - (p.getPixel(p.getLimit().min) - p.getPixel(e.setValue.y)), 0)), F.paddingBottom = P), F;
    }, t.prototype.getEventArgs = function () {
      var e = this.config || {};
      return {
        datasetName: (this.config.JSONData || {}).seriesname,
        datasetIndex: this.getJSONIndex(),
        id: e.userID,
        visible: !this.getState("visible")
      };
    }, t.prototype.getData = function () {
      return this.components.data;
    }, t.prototype.setJSONIndex = function (e) {
      this.config.index = e;
    }, t.prototype.getJSONIndex = function () {
      return this.config.index || 0;
    }, t.prototype.remove = function (t) {
      var n = this.config.legendItemId,
          a = this.getFromEnv("chart").getChildren("legend"),
          i = this.getFromEnv("legend");
      a && a.length && i && n && i.disposeItem(n), e.prototype.remove.call(this, t);
    }, t.prototype.setMaxMin = function (e) {
      var t,
          n,
          a,
          i = this.components,
          o = i.data,
          r = i.removeDataArr,
          l = this.config,
          s = o.length,
          c = -Infinity,
          u = +Infinity,
          d = l.maxValue,
          p = l.minValue,
          f = r.length,
          g = !1;
      if (e) g = d === e.startValue || p === e.startValue || d < e.config.setValue || p > e.config.setValue;else if (f) for (t = 0; t < f; ++t) {
        if (d === (a = r[t] && r[t].config && r[t].config.setValue) || p === a) {
          g = !0;
          break;
        }
      }

      if (g) {
        for (t = 0; t < s; t++) {
          o[t] && (n = o[t].config.setValue) !== h && (c = x(c, n), u = y(u, n));
        }

        l.maxValue = c, l.minValue = u;
      }
    }, t;
  }(o.ComponentInterface);

  t._removePlots = E, t["default"] = F;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(125);
  t["default"] = {
    "initial.dataset.column": function initialDatasetColumn() {
      var e = this,
          t = e.getFromEnv("chart"),
          n = t.config.yDepth || 0,
          i = "y",
          o = "height",
          r = "x",
          l = "width",
          s = e.getFromEnv("yAxis"),
          c = e.getFromEnv("xAxis"),
          u = function u(a, c) {
        var u,
            h,
            d,
            p,
            f = e.config,
            g = c && c.graphics && c.graphics.element,
            m = a.attr,
            b = s.getPixel(s.getAxisBase()) + (t.isBar ? -n : n),
            v = {},
            y = f.oldZeroAxisPos;
        if (u = g.attr(), v[i] = h = u[i], v[o] = u[o], v[r] = u[r], v[l] = u[l], d = u[i] + u[o], b !== y && (y - b >= 0 ? (h > b && h <= y + .7 && (v[i] = b, d > y && (v[o] = d - v[i])), d > b && d <= y + .7 && (v[o] = b - (v[i] || 0 === v[i] ? v[i] : h))) : (h < b && h >= y - .7 && (v[i] = b, d > b && (v[o] = d - v[i])), d < b && d >= y - .7 && (v[o] = b - (v[i] || 0 === v[i] ? v[i] : h))), p = !0), e.config.catDiff && (v[r] = m[r], v[l] = m[l], p = !0), c._plot_1Start = v, p) return {
          finalAttr: v,
          slot: "axis"
        };
      };

      return {
        "rect.appearing": function rectAppearing(u) {
          var h,
              d,
              p,
              f,
              g = s.getPixel(s.getAxisBase()) + (t.isBar ? -n : n),
              m = u.props && u.props.originalIndex || u.index,
              b = e.components.data[m],
              v = u.attr;
          return c.config.isVertical && (i = "x", o = "width", r = "y", l = "height"), h = v[i], d = v[o], f = Math.sign(h + d / 2 - g), p = 1 === f ? h : h + d, b._posWRT0 = f, [{
            initialAttr: function initialAttr() {
              var e = {};
              return e[i] = p, e.opacity = 0, e[o] = 0, e;
            },
            finalAttr: {
              opacity: 1
            },
            startEnd: function startEnd() {
              var t = u.length;
              return a.animHelperFN.getTimeByValue(a.animHelperFN.animByWeight(u.index, t, .6), {
                startPx: g,
                endPx: 1 === f ? e.config.yAxisMaxPixel : e.config.yAxisMinPixel
              }, {
                startPx: p,
                endPx: 1 === f ? v[i] + v[o] : v[i]
              });
            },
            hookFn: function hookFn() {
              this.attr({
                opacity: 1
              });
            },
            effect: "linear",
            slot: "plot"
          }];
        },
        "rect.updating": function rectUpdating(a) {
          var h,
              d,
              p,
              f,
              g,
              m,
              b,
              v,
              y,
              x,
              C,
              k,
              w,
              S,
              _,
              L,
              P,
              A,
              N,
              E,
              F,
              O,
              T,
              D,
              M,
              I,
              R,
              V,
              B = [],
              j = e.components.data[a.props && a.props.originalIndex || a.index],
              G = a.attr,
              H = j && j.graphics && j.graphics.element,
              z = s.getPixel(s.getAxisBase()) + (t.isBar ? -n : n),
              W = 0,
              q = e.getFromEnv("numColDiff");

          return c.config.isVertical && (i = "x", o = "width", r = "y", l = "height"), (V = u(a, j)) && B.push(V), w = (k = j.prevDataObj) && k._plot_1Start, N = k && k._plot_1End, S = k && k._plot_2Start, _ = j.oldPrevDataObj, L = j.oldPrevDataObj && j.oldPrevDataObj._plot_1End, p = (h = (v = j._plot_1Start)[i]) + (d = v[o]), f = h + d / 2, b = (g = G[i]) + (m = G[o]) / 2, P = (p + (g + m)) / 2, E = Math.sign(f - z), F = Math.sign(b - z), (C = {})[i] = (x = {})[i] = (h + g) / 2, C[o] = x[o] = (d + m) / 2, d ? E !== F ? (C[o] = x[o] = 0, x[i] = _ && _._oldPosWRT0 === E ? L[i] + (1 === E ? L[o] : 0) : z, C[i] = S ? S[i] + (1 === F ? S[o] : 0) : z, A = y = !0) : k !== _ && (T = (O = L || !(!N || Math.sign(N[i] + N[o] / 2 - z) !== E) && N) ? O[i] + (1 === E ? O[o] : 0) : z, 1 === E ? (C[i] = x[i] = T, C[o] = x[o] = P - x[i]) : C[o] = x[o] = T - x[i], y = !0) : k && k._oldPosWRT0 === F || 0 === e.stackIndex ? ((I = {})[o] = 0, I[i] = w ? w[i] + (k._posWRT0 > 0 ? w[o] : 0) : z, j._posWRT0 = F, j._plot_1Start = I, C[i] = x[i] = (I[i] + g) / 2, C[o] = x[o] = m / 2) : f === z && (F !== j._posWRT0 ? W = .5 : (y = !0, x[i] = 1 === F ? z : z - x[o])), q < 0 ? (x[r] = G[r], x[l] = G[l], y = !0) : q > 0 ? W = .5 : v[r] === G[r] && v[l] == G[l] || (.5 === W ? ((I = {})[r] = G[r], I[l] = G[l], D = function D() {
            A && H.attr(C), H.attr(I);
          }) : (x[r] = G[r], x[l] = G[l], y = !0, D && (M = function M() {
            H.attr(I);
          }, D = void 0))), y && (B.push({
            finalAttr: x,
            startEnd: {
              start: 0,
              end: .5
            },
            hookFn: M,
            slot: "plot"
          }), W = .5), !D && (D = function D() {
            A && H.attr(C);
          }), B.push({
            effect: "linear",
            startEnd: {
              start: W,
              end: 1
            },
            finalAttr: {
              x: G.x,
              y: G.y,
              width: G.width,
              height: G.height
            },
            callback: function callback() {
              null !== j.config.setValue && void 0 !== j.config.setValue || this.hide();
            },
            hookFn: D,
            slot: "plot"
          }), delete (R = Object.assign({}, G)).x, delete R.y, delete R.width, delete R.height, B.push({
            finalAttr: R,
            effect: "linear",
            slot: "plot"
          }), j._plot_1End = x, j._plot_2Start = C, j._oldPosWRT0 = j._posWRT0, j._posWRT0 = F, B;
        },
        "rect._disappearing": function rect_disappearing(a) {
          var r,
              l,
              c,
              h,
              d,
              p = s.getPixel(s.getAxisBase()) + (t.isBar ? -n : n),
              f = e.components.removeDataArr,
              g = f && f[a.props && a.props.originalIndex || a.index] || e.components.data[a.props && a.props.originalIndex || a.index],
              m = g && g.graphics && g.graphics.element,
              b = g.oldPrevDataObj && g.oldPrevDataObj._plot_1End,
              v = [];
          if (m) return (h = u(a, g)) && v.push(h), s.config.isVertical || (i = "x", o = "width"), r = (l = (d = g._plot_1Start)[i]) + d[o] / 2 > p ? b ? b[i] + b[o] : l : b ? b[i] : p, (c = {})[i] = r, c[o] = 0, c.width = g._width, c.x = g._xPos, v.push({
            startEnd: {
              start: 0,
              end: e.getFromEnv("numOfColumns") < 1 ? 1 : .5
            },
            finalAttr: c,
            slot: "plot"
          }), g._plot_1End = a.finalAttr, v;
        },
        "plotLabel.appearing": [{
          initialAttr: {
            opacity: 0
          },
          slot: "final"
        }],
        "plotLabel._disappearing": [{
          hookFn: function hookFn() {
            this.hide();
          },
          slot: "initial"
        }],
        "plotLabel.updating": [{
          hookFn: function hookFn() {
            this.hide();
          },
          slot: "initial"
        }, {
          hookFn: function hookFn() {
            this.show();
          },
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          slot: "final"
        }],
        "group.appearing": function groupAppearing(e) {
          return "label-group" === e.attr.name ? [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: "final"
          }] : [{
            initialAttr: {
              opacity: 1
            },
            finalAttr: {
              opacity: 1
            },
            slot: "final"
          }];
        },
        "*": null
      };
    }
  };
},,,,,,,,,,,,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = l(n(450)),
      i = n(125),
      o = n(132),
      r = l(n(452));

  function l(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function s(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var c = Math.abs;
  (0, o.addDep)({
    name: "lineAnimation",
    type: "animationRule",
    extension: r["default"]
  });

  var u = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.updateYForStack = i.stubFN, n.config.primitiveType = "line", n;
    }

    return s(t, e), t.prototype.getType = function () {
      return "dataset";
    }, t.prototype.getName = function () {
      return "line";
    }, t.prototype.createPinElem = function () {
      var e,
          t,
          n,
          a = this.getFromEnv("chart"),
          i = arguments[1].group,
          o = this.config.lineOb,
          r = this.getGraphicalElement("pinElems") || this.addGraphicalElement("pinElems", []),
          l = this.getFromEnv("paper"),
          s = this.getLinkedParent().getChildContainer("lineVcanvasGroup");

      for (t = r.length - 1; t >= 0; t--) {
        r[t].remove(), r.pop();
      }

      if (this.getState("visible")) for (n in o) {
        e = o[n].el, r.push(l.path(i).attr({
          path: e.attrs.path,
          transform: ["T", -(a.config._visx + c(s.transform()[0][1])), -a.config.canvasBottom]
        }).attr(this.config.pin));
      }
    }, t.prototype._addLegend = function () {
      var e,
          t,
          n = this.getFromEnv("chart"),
          a = this.config,
          o = n.getChildren("legend")[0],
          r = (0, i.pluckNumber)(a.drawanchors, 1);
      a.includeinlegend ? (t = {
        enabled: a.includeinlegend,
        type: this.getName(),
        drawLine: (0, i.pluck)(a.drawLine, !0),
        index: this.getJSONIndex(),
        anchorSide: r ? a.anchorsides : 0,
        label: (0, i.getFirstValue)(this.config.JSONData.seriesname)
      }, (e = o.getItem(this.config.legendItemId)) || (this.config.legendItemId = o.createItem(this), e = o.getItem(this.config.legendItemId), this.addExtEventListener("fc-click", function () {
        e.itemClickFn();
      }, e)), e.setStateCosmetics("default", {
        symbol: {
          fill: (0, i.toRaphaelColor)({
            color: a.anchorbgcolor,
            alpha: a.anchorbgalpha
          }),
          rawFillColor: a.anchorbgcolor,
          rawStrokeColor: a.anchorbordercolor,
          stroke: (0, i.toRaphaelColor)({
            color: a.anchorbordercolor,
            alpha: "100"
          }),
          "stroke-width": a.anchorborderthickness,
          lineWidth: a.linethickness
        }
      }), this.getState("visible") ? e.removeLegendState("hidden") : e.setLegendState("hidden"), e.configure(t)) : this.config.legendItemId && o.disposeItem(this.config.legendItemId);
    }, t.prototype._getDataLimits = function () {
      var e = this.config,
          t = this.getFromEnv("chart").config,
          n = e.maxValue,
          a = e.minValue,
          i = -Infinity,
          o = +Infinity,
          r = t.transposeAxis;
      return !1 === this.getState("visible") && r && (n = i, a = o), {
        max: n,
        min: a
      };
    }, t.prototype._drawCommonElementsHelper = function (e) {
      var t,
          n,
          a,
          i = this,
          o = "",
          r = {},
          l = i.getFromEnv("animationManager"),
          s = i.config,
          c = s.shadow,
          u = s.linethickness,
          h = i.getContainer("commonElemsGroup"),
          d = function d() {
        !1 === i.getState("visible") && this.hide();
      };

      for (o in e) {
        for (t = ["M0,0"], n = 0, a = (r = e[o]).path && r.path.length; n < a; ++n) {
          t = t.concat(r.path[n].getPathArr());
        }

        i.config.drawLine ? (r.el = l.setAnimation({
          el: r.el || "path",
          container: h,
          component: i,
          attr: !1 !== i.getState("visible") && Object.assign({
            path: t
          }, r.attr),
          label: "line",
          callback: d
        }), i.getState("visible") && r.el && r.el.show()) : r.el && (r.el = l.setAnimation({
          el: r.el,
          component: i,
          doNotRemove: !0,
          callback: function callback() {
            this.hide();
          }
        })), !r.used && delete e[o], r.el && (u ? r.el.shadow(c, h) : r.el.shadow({
          opacity: 0
        }, h), r.el.toFront()), r.old = !0, r.used = !1, r.prevPath = r.path, r.attrs = void 0, r.path = void 0;
      }
    }, t.prototype.getLineShift = function (e) {
      var t = this.getFromEnv("chart"),
          n = t.config.is3D,
          a = t.config.use3dlineshift;
      return "y" === e ? n ? a ? 0 : -10 : 0 : n ? 10 : 0;
    }, t.prototype.drawCommonElements = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          l,
          s,
          c,
          u,
          h = this.components.data,
          d = this.config,
          p = this.getFromEnv("xAxis"),
          f = this.getFromEnv("yAxis"),
          g = d.lineDashStyle,
          m = d.linethickness,
          b = {
        color: d.linecolor,
        alpha: d.alpha
      },
          v = [(0, i.toRaphaelColor)(b), g].join(":"),
          y = v,
          x = {
        x: p.getLimit(),
        y: f.getLimit()
      },
          C = h.length,
          k = this.config.lineOb || {},
          w = 0,
          S = !1,
          _ = this.getSkippingInfo && this.getSkippingInfo(),
          L = _ && _.draw || [],
          P = L.length,
          A = _ && _.skippingApplied,
          N = function N(e, t, n) {
        var a = k[e];
        a || (a = k[e] = {}), e !== y && (a.hasDifferentColor = !0), a.used = !0, a.pathWithNull = n, a.path = a.path || [], a.stroke = e.split(":")[0], a.dashStyle = e.split(":")[1], a.path.push(t), a.dashStyle = a.dashStyle && a.dashStyle.split(","), a.attr = {
          "stroke-dasharray": a.dashStyle,
          "stroke-width": m,
          stroke: a.stroke,
          "stroke-linecap": "round",
          "stroke-linejoin": m > 2 ? "round" : "miter"
        };
      },
          E = [];

      for (x.x.minPixel = p.getPixel(x.x.min), x.x.maxPixel = p.getPixel(x.x.max), x.y.minPixel = f.getPixel(x.y.min), x.y.maxPixel = f.getPixel(x.y.max), x.y.base = f.getPixel(0), x.x.base = p.getPixel(0), A && (C = P), a = 0; a < C; ++a) {
        (o = h[n = L[a] || a]) && ((l = o.config || {})._Pbx = void 0, l._Pby = void 0, E[n] = {
          config: {
            _Px: l._Px,
            _Py: l._Py,
            setValue: l.setValue
          }
        }, t = {
          color: l.setColor,
          alpha: l.setAlpha
        }, e = l.dashStyle, v !== (r = [(0, i.toRaphaelColor)({
          color: (0, i.pluck)(t.color, b.color),
          alpha: (0, i.pluck)(t.alpha, b.alpha)
        }), e || g].join(":")) && null !== o._yVal && (S = !0, s = n, c = this.getLinePath(h, {
          begin: w,
          end: s + 1
        }), u = this.getLinePath(h, {
          begin: w,
          end: s + 1
        }, void 0), l.connStartIndex = w, l.connEndIndex = s, N(v, c, u.getPathArr()), v = r, w = n, s = null), null !== o._yVal && (v = r));
      }

      r || (r = ""), d.pathStartIndex = w, d.pathEndIndex = s, N(r, c = this.getLinePath(h, {
        begin: S ? w : d.scrollMinVal,
        end: S ? s : d.scrollMaxVal
      }), (u = this.getLinePath(h, {
        begin: w,
        end: s
      }, void 0)).getPathArr()), this._drawCommonElementsHelper(k), this.config.lineOb = k, d.prevLim = x, d.prevDataStore = E;
    }, t.prototype.show = function () {
      e.prototype.show.call(this), this.fireEvent("datasetVisibilityChanged", {
        dataset: this,
        state: "show"
      });
    }, t.prototype.hide = function () {
      e.prototype.hide.call(this), this.fireEvent("datasetVisibilityChanged", {
        dataset: this,
        state: "hide"
      });
    }, t;
  }(a["default"]);

  t["default"] = u;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = s(n(432)),
      i = n(125),
      o = n(136),
      r = n(132),
      l = s(n(451));

  function s(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function c(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var u,
      h = !i.hasSVG,
      d = "DataPlotRollOver",
      p = "DataPlotRollOut",
      f = i.hasTouch ? i.TOUCH_THRESHOLD_PIXELS : i.CLICK_THRESHOLD_PIXELS,
      g = i.preDefStr.DEFAULT,
      m = i.preDefStr.setRolloverAttrStr,
      b = i.preDefStr.setRolloutAttrStr,
      v = function v() {
    var e = this.pathArr,
        t = this.path2Arr;
    return e.length || t.length ? e.concat(t) : ["M0,0"];
  },
      y = function y(e) {
    return e !== u && null !== e && "" !== e;
  },
      x = "Z",
      C = Math,
      k = C.min,
      w = C.max,
      S = C.ceil,
      _ = function _(e, t) {
    var n,
        a = e.getFromEnv("chart").config,
        o = t.config,
        r = t.graphics,
        l = r.image || r.element,
        s = o.eventArgs,
        c = l._.RefImg,
        u = t._xPos,
        d = t._yPos,
        p = o.anchorProps,
        f = e.getContainer("shadowGroup"),
        g = o.hoverEffects,
        v = o.setLink,
        y = p.imageScale,
        x = p.imageAlpha,
        C = g.imageHoverAlpha,
        S = g.imageHoverScale,
        _ = c.height * y * .01,
        L = c.width * y * .01,
        P = c.width * S * .01,
        A = c.height * S * .01,
        N = void 0,
        E = void 0,
        F = void 0,
        O = void 0,
        T = void 0,
        D = void 0,
        M = void 0,
        I = void 0,
        R = void 0,
        V = void 0,
        B = void 0,
        j = void 0,
        G = void 0,
        H = void 0,
        z = void 0;

    n = p.isAnchorRadius, p.markerRadius = E = p.radius = n ? p.radius : k(L, _) / 2, h ? (j = {
      x: u - c.width * y * .005,
      y: d - c.height * y * .005,
      width: L,
      height: _
    }, B = {
      x: u - c.width * S * .005,
      y: d - c.height * S * .005,
      width: P,
      height: c.height * S * .01,
      alpha: C
    }, o.isAnchorsDrawn = !0, a.dragTolerance = a.dragTolerance < _ ? _ + .5 : a.dragTolerance, l.data("alwaysInvisible", !y).data("setRolloverProperties", g).data("hoverEnabled", g).data(m, B).data(b, j).data("imgRef", c).data("anchorRadius", y).data("anchorHoverRadius", S), l.attr(j), j.alpha = x) : (N = p.symbol[1], H = g.isAnchorHoverRadius, F = p.shadow, I = p.imagePadding, g.radius = H ? g.anchorRadius : E + 1, T = g.radius - I - .5 * g.anchorBorderThickness, M = E - I - .5 * p.borderThickness, B = j = {}, a.dragTolerance = a.dragTolerance < E ? E + .5 : a.dragTolerance, z = {
      fill: (0, i.toRaphaelColor)({
        color: p.bgColor,
        alpha: p.bgAlpha
      }),
      "stroke-width": p.borderThickness,
      stroke: (0, i.toRaphaelColor)({
        color: p.borderColor,
        alpha: p.borderAlpha
      })
    }, j = (0, i.extend2)({
      path: (0, i.polyPathToPath)([N || 2, u, d, E, p.startAngle, void 0])
    }, z), g && (B = {
      path: (0, i.polyPathToPath)([g.anchorSides || 2, u, d, g.radius, g.startAngle, g.dip]),
      fill: (0, i.toRaphaelColor)({
        color: g.anchorColor,
        alpha: g.anchorBgAlpha
      }),
      "stroke-width": g.anchorBorderThickness,
      stroke: (0, i.toRaphaelColor)({
        color: g.anchorBorderColor,
        alpha: g.anchorBorderAlpha
      })
    }, C > (V = w(g.anchorAlpha, g.anchorBorderAlpha)) && (C = V)), p.bgAlpha && p.borderAlpha && x > (R = w(p.bgAlpha, p.borderAlpha)) && (x = R), (G = r.element).attr(Object.assign(z, {
      path: j.path
    })), G.attr({
      cursor: v ? "pointer" : ""
    }).data("alwaysInvisible", !E).data("setRolloverProperties", g).data("hoverEnabled", g.enabled).data(m, B).data(b, j).data("anchorRadius", E).data("anchorHoverRadius", g && g.radius).data("eventArgs", s).shadow(F, f), D = (0, i.polyPathToPath)([N || 2, u, d, M > 0 ? M : 0, p.startAngle, void 0]), O = (0, i.polyPathToPath)([N || 2, u, d, T > 0 ? T : 0, g.startAngle, g.dip]), p.imgRefWidth = c.width, p.imgRefHeight = c.height, p.imgRefScale = y, p.rolloutClipRadius = M, j = {
      x: u - c.width * y * .005,
      y: d - c.height * y * .005,
      width: L,
      height: _,
      "clip-path": D
    }, B = {
      x: u - c.width * S * .005,
      y: d - c.height * S * .005,
      width: P,
      height: A,
      alpha: C,
      "clip-path": O
    }, l.attr({
      x: j.x,
      y: j.y,
      width: j.width,
      height: j.height,
      "clip-path": j["clip-path"]
    }).data("alwaysInvisible", !y).data("setRolloverProperties", g).data(m, B).data(b, j).data("anchorRadius", y).data("imgRef", c).data("anchorHoverRadius", S), o.isAnchorsDrawn = !0, E = w(E, g && g.anchorRadius || 0, 2)), t._xPos = u, t._yPos = d, e.parseLabelAttributes(t, t._index);
  };

  (0, r.addDep)({
    name: "areaAnimation",
    type: "animationRule",
    extension: l["default"]
  });

  var L = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this)),
          a = n;

      return a.__removeElem = function (e, t) {
        a._setRemoveAnim(e, "element" === t || "image" === t ? "anchor" : "label");
      }, a.config.primitiveType = "area", n;
    }

    return c(t, e), t.prototype.getType = function () {
      return "dataset";
    }, t.prototype.getName = function () {
      return "area";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this);

      var t = this.config;
      t.valueposition = u, t.plotborderdashlen = u, t.plotborderdashgap = u, t.plotborderdashstyle = u, t.plotborderthickness = u, t.linethickness = u, t.linedashlen = u, t.linedashgap = u, t.dashed = u, t.linedashstyle = u, t.linecolor = u, t.linealpha = u, t.anchorbgcolor = u, t.anchorbordercolor = u, t.anchorradius = u, t.anchoralpha = u, t.anchorimageurl = u, t.anchorsides = u, t.anchorbgalpha = u, t.anchorborderthickness = u, t.anchorshadow = u, t.anchorstartangle = u, t.anchorimagealpha = u, t.anchorimagescale = u, t.anchorimagepadding = u, t.alpha = u, t.parentyaxis = u;
    }, t.prototype._getHoveredPlot = function (e, t) {
      var n,
          a,
          i,
          o,
          r,
          l,
          s = this.getFromEnv("xAxis"),
          c = this.components.data,
          u = c.length,
          h = this.config,
          d = this.getFromEnv("chartConfig").viewPortConfig.step || 1,
          p = h && h.radius || 0,
          f = (this.getSkippingInfo && this.getSkippingInfo()).plotsPerBin;

      for (e += s.getTranslation(), a = Math.floor(Math.max(s.getValue(e - p), 0)), i = Math.ceil(Math.min(s.getValue(e + p), u - 1)), r + f - 1, f > 1 && (a = r = (S(a / f) - 1) * f + 1, i = S(i / f) * f), l = i; l >= a && (!(n = c[l]) || l % d || !(o = this.isWithinShape(n, l, e, t))); l--) {
        ;
      }

      return o;
    }, t.prototype.getClip = function (e) {
      var t = this.getFromEnv("xAxis"),
          n = this.getFromEnv("yAxis"),
          a = n.getLimit(),
          i = t.getLimit(),
          o = t.getPixel(i.min),
          r = n.getPixel(a.min),
          l = n.getPixel(a.max),
          s = Math.abs(t.getPixel(i.max) - o),
          c = r - l,
          u = [];
      return u.push(o), u.push(c < 0 ? r : l), "init" === e ? u.push(0) : "canvas" === e && u.push(s), u.push(Math.abs(c)), u;
    }, t.prototype.isWithinShape = function (e, t, n, a, o) {
      var r, l, s, c, u, h, d, p, g, m, b, v, y, x;
      if (e && ((o = e.config.setValue) || 0 === o)) return r = e.config.anchorProps, l = e.config, c = r && r.borderThickness, this, u = this.getFromEnv("chart").config.viewPortConfig, h = this.components.data, d = (0, i.pluckNumber)(l.dragTolerance, 0), x = u ? u.x * u.scaleX : 0, p = e._xPos - x, null !== (g = e._yPos) ? (y = e.config.hoverEffects, (s = Math.max(r && r.radius, y && y.anchorRadius || 0, f) + c / 2) || (s = 3), m = n - p, b = a - g, ((v = Math.sqrt(Math.pow(m, 2) + Math.pow(b, 2))) <= s || v <= d) && {
        pointIndex: t,
        hovered: !0,
        pointObj: h[t]
      }) : void 0;
    }, t.prototype._parseShadowOptions = function () {
      var e = this.getFromEnv("chart"),
          t = this.config,
          n = e.getFromEnv("dataSource").chart,
          a = this.getFromEnv("color-manager"),
          o = (0, i.pluckNumber)(e.defaultPlotShadow, a.getColor("showShadow"));
      return {
        opacity: (0, i.pluckNumber)(n.showshadow, o) ? t.alpha / 100 : 0
      };
    }, t.prototype._firePlotEvent = function (e, t, n) {
      var a,
          i,
          o,
          r = this.getFromEnv("chart"),
          l = this.components,
          s = this.getFromEnv("toolTipController"),
          c = l.data[t] || {},
          h = this.getGraphicalElement("sharedAnchor"),
          d = c.graphics && c.graphics.element || (c.config && c.config.setValue) !== u && h,
          p = this.config.currentToolTip,
          f = r.getFromEnv("paper").canvas.style;
      if (d) switch (o = (a = c.config).setLink, i = a.eventArgs, e) {
        case "fc-mouseover":
          this._decideTooltipType(t, n), this._rolloverResponseSetter(r, c, n), o && (f.cursor = "pointer");
          break;

        case "fc-mouseout":
          s.hide(p), this._rolloutResponseSetter(r, c, n), f.cursor = g;
          break;

        case "fc-click":
          r.plotEventHandler(d, n, "dataplotclick", i);
          break;

        case "fc-mousemove":
          this._decideTooltipType(t, n);

      }
    }, t.prototype._rolloverResponseSetter = function (e, t, n, a) {
      var i = t.graphics,
          o = i && (i.element || this.getAnchor(t)),
          r = o && o.data("draged"),
          l = o && o.data("hoverEnabled");
      !0 !== r && (this._hoverFunc(t, d, l, e.getFromEnv("dataSource").chart), !a && o && e.plotEventHandler(o, n, d));
    }, t.prototype._rolloutResponseSetter = function (e, t, n, a) {
      var i = t.graphics,
          o = i && (i.element || this.getAnchor(t)),
          r = o && o.data("draged"),
          l = o && o.data("hoverEnabled"),
          s = this.type,
          c = t.config,
          u = c.anchorProps,
          h = u.radius && u.anchorAlpha;
      !0 !== r && (this._hoverFunc(t, p, l, e.getFromEnv("dataSource").chart), !a && o && e.plotEventHandler(o, n, p)), c.isAnchorsDrawn && !h && "area" === s && o && o.hide();
    }, t.prototype.getAnchor = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r,
          l,
          s,
          c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          u = this.getFromEnv("animationManager"),
          h = this.getGraphicalElement("sharedAnchor"),
          d = c.config;
      return h ? (e = d.anchorProps, t = d.eventArgs, (o = (i = d.hoverEffects).enabled) && (n = i.attrs && i.attrs.setRolloutAttr, a = i.attrs && i.attrs.setRolloverAttr), r = e.radius, l = e.shadow, s = this.getFromEnv("chartConfig").prevAnchorHovered, i.anchorAnimation = 0, c._index !== s && (h.shadow(l, this.getContainer("shadowGroup")).data("anchorRadius", r).data("anchorHoverRadius", i.anchorRadius).data("hoverEnabled", o).data("eventArgs", t), o && h.data(m, a).data(b, n)), this.getFromEnv("chartConfig").prevAnchorHovered = c._index, h) : (h = u.setAnimation({
        el: "path",
        container: this.getContainer("plotGroup"),
        label: "anchor",
        doNotRemove: !0,
        component: this
      }), this.addGraphicalElement("sharedAnchor", h), h);
    }, t.prototype.configureAttributes = function (e) {
      if (!e) return !1;
      this.trimData(e);
      var t = this.getFromEnv("chart");
      this.config.JSONData = e, this.parseAttributes(), this._setConfigure(), this._realTimeConfigure && this._realTimeConfigure(), !1 !== t.config.hasLegend && t.config.showLegend && this._addLegend(), this.setState("dirty", !0);
    }, t.prototype.parseAttributes = function () {
      var e,
          t,
          n = this.getFromEnv("chart"),
          a = n.config,
          o = this.config,
          r = this.getName(),
          l = this.config.JSONData,
          s = n.getFromEnv("dataSource").chart,
          c = n.config.singleseries,
          h = this.getFromEnv("color-manager"),
          d = Math.floor(this.getJSONIndex()),
          p = (0, i.pluckNumber)(l.showplotborder, s.showplotborder || 1),
          f = (0, i.getFirstColor)(!c || (0, i.getValidValue)(s.palettecolors) ? h.getPlotColor(d) : h.getColor("plotFillColor").split(/\s*\,\s*/)[0]),
          g = a.isdual,
          m = a.haslineset;
      o.maxValue = -Infinity, o.minValue = Infinity, (0, i.parseConfiguration)(l, o, n.config, {
        data: !0
      }), o.showValues = (0, i.pluckNumber)(l.showvalues, s.showvalues, "radar" === r ? 0 : 1), o.anchorimageurl = (0, i.pluck)(l.anchorimageurl, s.anchorimageurl, u), o.plotColor = f, o.parentYAxis = g ? m ? 1 : "s" === (0, i.pluck)(l.parentyaxis && l.parentyaxis.toLowerCase(), "p") ? 1 : 0 : 0, o.valueposition = o.valueposition.toLowerCase(), o.plotfillcolor = (0, i.pluck)(l.color, s.plotfillcolor, f), o.seriesname = (0, i.parseUnsafeString)(l.seriesname), e = a.useplotgradientcolor, o.plotgradientcolor = 0 !== e ? (0, i.getDefinedColor)(s.plotgradientcolor, h.getColor("plotGradientColor")) : "", o.plotfillalpha = (0, i.pluck)(l.alpha, a.plotfillalpha), o.fillColor = {
        color: o.plotfillcolor + (o.plotgradientcolor ? "," + o.plotgradientcolor : ""),
        alpha: o.plotfillalpha,
        angle: o.plotfillangle
      }, o.plotborderalpha = p ? (0, i.pluck)(l.plotborderalpha, s.plotborderalpha, l.alpha, s.plotfillalpha, "95") : 0, o.plotbordercolor = (0, i.pluck)(l.plotbordercolor, s.plotbordercolor, s.areabordercolor, c ? (0, i.getValidValue)(s.palettecolors) ? h.getPlotColor(0) : h.getColor("plotBorderColor").split(/\s*\,\s*/)[0] : "666666"), o.drawLine = (0, i.pluckNumber)(l.drawline, s.drawlines, 1), o.plotborderdashstyle = o.dashed ? (0, i.getDashStyle)(o.plotborderdashlen, o.plotborderdashgap) : "none", o.linecolor = (0, i.pluck)(l.color, s.linecolor, o.plotColor), o.legendSymbolColor = "line" === this.type ? o.linecolor : o.plotfillcolor, o.includeinlegend = (0, i.pluckNumber)(l.includeinlegend, o.seriesname ? 1 : 0), t = (0, i.getDashStyle)(o.linedashlen, o.linedashgap), o.lineDashStyle = o.dashed ? t : "none", o.defaultPadding = {
        left: 0,
        right: 0
      }, o.shadow = this._parseShadowOptions(), o.drawanchors = (0, i.pluckNumber)(l.drawanchors, l.showanchors, s.showanchors, s.drawanchors), o.anchorbgcolor = (0, i.getFirstColor)((0, i.pluck)(l.anchorbgcolor, a.anchorbgcolor, h.getColor("anchorBgColor"))), o.anchorbordercolor = (0, i.getFirstColor)((0, i.pluck)(l.anchorbordercolor, a.anchorbordercolor, o.linecolor, o.plotColor)), this.setState("visible", 1 === (0, i.pluckNumber)(l.visible, !Number(l.initiallyhidden), 1) && o.drawLine);
    }, t.prototype._setConfigure = function (e, t) {
      var n,
          a,
          r,
          l,
          s,
          c,
          h,
          d,
          p,
          g = this.getFromEnv("chart"),
          m = this.config,
          b = g.config,
          v = this.config.JSONData || [],
          y = this.getFromEnv("xAxis"),
          x = g.isRealTime,
          C = b.realTimeConfig && b.realTimeConfig.numDisplaySets,
          k = this.getFromEnv("dataSource").categories && this.getFromEnv("dataSource").categories[0] && this.getFromEnv("dataSource").categories[0].category,
          w = m.initCatLen = x ? k && Array.isArray(k) && k.filter(function (e) {
        return !e.vline;
      }).length || 0 : y.getTicksLen(),
          S = e || v.data,
          _ = e && e.data.length,
          L = b.isDrag,
          P = this.getSkippingInfo && this.getSkippingInfo(),
          A = P && P.draw || [],
          N = A.length,
          E = P && P.skippingApplied;

      for (p = _ === u && w > C ? w - C : 0, r = x ? (0, i.pluckNumber)(_, w) : Math.min(w, S && S.length), m.imageCount = 0, (l = this.components.data) || (l = this.components.data = []), m.maxRadius = -Infinity, b.dragTolerance = b.dragTolerance || -Infinity, E && (r = N), c = p; c < r; c++) {
        s = A[c] || c, e ? (n = e && e.data[s] || {}, a = t !== u ? l[d = t + s] : l[d = l.length - r + s], h = d) : (n = S && S[s] || {}, a = l[s -= p], h = s), a || (a = l[h] = {}), a.config || (a.config = {}), a.graphics || (a.graphics = {}), this._plotConfigure(h, n, _), d && d++;
      }

      E && this.addJob("configureRestID", this._configureRestData.bind(this), o.priorityList.postRender), b.dragTolerance = L ? (b.dragTolerance > 5 ? b.dragTolerance : 5.5) + f : 0, this.ErrorValueConfigure && this.ErrorValueConfigure();
    }, t.prototype._configureRestData = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r = this.getFromEnv("chart"),
          l = this.config,
          s = r.config,
          c = this.config.JSONData.data || [],
          u = (this.getSkippingInfo && this.getSkippingInfo()).drawOnlyMap,
          h = this.getFromEnv("xAxis").getTicksLen();

      for (l.imageCount = 0, (n = this.components.data) || (n = this.components.data = []), l.maxRadius = -Infinity, s.dragTolerance = s.dragTolerance || -Infinity, l.maxValue = -Infinity, l.minValue = Infinity, a = 0; a < h; a++) {
        u[a] || (t = n[a], e = c && c[a] || {}, i = a, t || (t = n[a] = {}), t.config || (n[a].config = {}), t.graphics || (t.graphics = {}), this._plotConfigure(i, e), o && o++);
      }
    }, t.prototype._plotConfigure = function (e, t, n) {
      var a,
          o,
          r,
          l,
          s,
          c,
          h,
          d,
          p,
          g,
          m = this.getFromEnv("chart"),
          b = this.config,
          v = m.config,
          y = this.config.JSONData,
          x = m.getFromEnv("dataSource").chart,
          C = this.components.data[e],
          S = this.getFromEnv("xAxis"),
          _ = this.getFromEnv("yAxis"),
          L = v.isDrag,
          P = C && C.config,
          A = (0, i.parseUnsafeString)(v.yaxisname),
          N = (0, i.parseUnsafeString)(v.xaxisname),
          E = v.tooltipsepchar,
          F = b.dashed,
          O = v.realTimeConfig && v.realTimeConfig.numDisplaySets,
          T = O - b.initCatLen,
          D = O && T >= 0 ? T : 0;

      p = S.getLabel(n ? e - n : D + e), P.label = (0, i.getValidValue)((0, i.parseUnsafeString)(p.tooltext || p.label)), t.tooltext !== u && (t.tooltext = (0, i.parseTooltext)(t.tooltext, [3], {
        label: p.label
      }, t, x, y)), P.setValue = r = _.getCleanValue(t.value, b.stack100percent), P.setLink = (0, i.pluck)(t.link), P.anchorProps = this._parseAnchorProperties(e), b.maxRadius = w(P.anchorProps.radius + P.anchorProps.borderThickness / 2, b.maxRadius), g = P.anchorProps.radius + P.anchorProps.borderThickness / 2, P.dragTolerance = L ? (g < 6 ? 5.5 : g + .5) + f : 0, P.label = (0, i.getValidValue)((0, i.parseUnsafeString)(p.tooltext || p.label)), P.showValue = (0, i.pluckNumber)(t.showvalue, b.showValues), P.dashed = (0, i.pluckNumber)(t.dashed, F), P.dashStyle = P.dashed ? (0, i.getDashStyle)(b.linedashlen, b.linedashgap) : "none", P.color = (0, i.pluck)(t.color, b.linecolor), P.setColor = t.color, P.setAlpha = t.alpha, P.setDashed = t.dashed, P.alpha = (0, i.pluck)(t.alpha, t.linealpha, b.linealpha), P.origLabel = (0, i.getValidValue)((0, i.parseUnsafeString)(p.label)), null !== r && (b.maxValue = w(b.maxValue, r), b.minValue = k(b.minValue, r)), P.setTooltext = (0, i.parseUnsafeString)(t.toolText), P.toolTipValue = o = _.dataLabels(r), P.setDisplayValue = l = (0, i.parseUnsafeString)(t.displayvalue), P.displayValue = (0, i.pluck)(l, o), P.formatedVal = h = P.toolTipValue, P.setTooltext = (0, i.getValidValue)((0, i.parseUnsafeString)((0, i.pluck)(t.tooltext, y.plottooltext, x.plottooltext))), P.valuePosition = (0, i.pluck)(t.valueposition, b.valueposition), P.valuePosition && (P.valuePosition = P.valuePosition.toLowerCase()), v.showtooltip ? null === h ? a = !1 : P.setTooltext !== u ? (s = [1, 2, 3, 4, 5, 6, 7], c = {
        yaxisName: A,
        xaxisName: N,
        formattedValue: h,
        label: P.label
      }, a = (0, i.parseTooltext)(P.setTooltext, s, c, t, x, y)) : (v.seriesnameintooltip && (d = (0, i.getFirstValue)(y && y.seriesname)), a = d ? d + E : "", a += P.label ? P.label + E : "", a += P.setTooltext ? "" : P.toolTipValue) : a = !1, P.toolText = a, P.setLevelTooltext = P.setTooltext, P._x = t.index === u ? e : t.index, P._y = r, P.finalTooltext = P.setTooltext = a, P.hoverEffects = this._parseHoverEffectOptions(C, t), P.anchorProps.isAnchorHoverRadius = P.hoverEffects.anchorRadius, v.dragTolerance = w(v.dragTolerance, b.maxRadius, P.hoverEffects.anchorRadius);
    }, t.prototype.drawCommonElements = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          l,
          s,
          c = this,
          u = c.components.data,
          h = c.getFromEnv("chart"),
          d = c.config,
          p = h.config,
          f = c.getFromEnv("xAxis"),
          g = c.getFromEnv("yAxis"),
          m = d.scrollMinVal,
          b = d.scrollMaxVal,
          v = !p.drawfullareaborder,
          y = d.plotbordercolor,
          x = d.plotborderalpha,
          C = d.plotborderdashstyle,
          k = d.plotborderthickness,
          w = d.fillColor,
          S = c.getFromEnv("animationManager"),
          _ = {
        x: f.getLimit(),
        y: g.getLimit()
      },
          L = [],
          P = d.shadow,
          A = c.getContainer("shadowGroup"),
          N = f.getState("scrolling"),
          E = c.getSkippingInfo && c.getSkippingInfo(),
          F = E && E.draw || [],
          O = F.length,
          T = E && E.skippingApplied;

      for (_.x.minPixel = f.getPixel(_.x.min), _.x.maxPixel = f.getPixel(_.x.max), _.y.minPixel = g.getPixel(_.y.min), _.y.maxPixel = g.getPixel(_.y.max), _.y.base = g.getPixel(0), _.x.base = f.getPixel(0), T && (m = 0, b = O), l = m; l < b; l++) {
        u[r = F[l] || l] && u[r].config && (L[r] = {
          config: {
            _Px: u[r].config._Px,
            _Pbx: u[r].config._Pbx,
            _Py: u[r].config._Py,
            _Pby: u[r].config._Pby,
            setValue: u[r].config.setValue
          }
        });
      }

      s = {
        begin: m,
        end: b
      }, a = {
        path: (n = this.getLinePath(u, N ? s : null, !c.getState("visible") && "base")).getPathArr(),
        stroke: (0, i.toRaphaelColor)({
          color: y,
          alpha: x
        }),
        "stroke-width": v ? 0 : k,
        "stroke-linecap": "round",
        fill: (0, i.toRaphaelColor)(w),
        "stroke-linejoin": k > 2 ? "round" : "miter",
        "stroke-dasharray": C
      }, t = c.getGraphicalElement("lineElement"), e = S.setAnimation({
        el: t || "path",
        container: c.getContainer("commonElemsGroup"),
        attr: c.getState("visible") && a,
        component: c,
        doNotRemove: !0,
        label: "line",
        callback: function callback() {
          !c.getState("visible") && this.hide();
        }
      }), !t && e && c.addGraphicalElement("lineElement", e), c.getState("visible") && e && e.show(), c.getState("visible") && !N && e.shadow(P, A), N || (o = c.getGraphicalElement("connector"), v ? o = c.addGraphicalElement("connector", S.setAnimation({
        attr: {
          path: n.getPathArr(),
          stroke: (0, i.toRaphaelColor)({
            color: y,
            alpha: x
          }),
          "stroke-width": k,
          "stroke-linecap": "round",
          "stroke-linejoin": k > 2 ? "round" : "miter",
          "stroke-dasharray": C
        },
        el: o || "path",
        container: c.getContainer("commonElemsGroup"),
        component: c,
        label: "line",
        callback: !c.getState("visible") && function () {
          this.hide();
        }
      })) : o && S.setAnimation({
        attr: {},
        el: o,
        container: c.getContainer("commonElemsGroup"),
        component: c,
        label: "line",
        callback: function callback() {
          this.hide();
        }
      })), d.prevLim = _, d.prevDataStore = L, "realTimeUpdate" === h.state && (c.realTimeUpdated = !0), p.connectnulldataOld = p.connectnulldata;
    }, t.prototype.parsePlotAttributes = function (e, t) {
      var n,
          a,
          o,
          r,
          l,
          s,
          c,
          u,
          h,
          d,
          p,
          f = this.getJSONIndex(),
          g = this.getState("visible"),
          v = this.config,
          y = this.config.JSONData,
          x = t,
          C = {},
          k = {},
          w = {};
      u = (p = e.config)._Px, h = p._Py, n = p._x, a = p._y, r = p.setLink, o = p.setValue, C = p.anchorProps, d = p.displayValue, c = p.hoverEffects, s = p.finalTooltext = p.toolText, p.eventArgs = {
        index: x,
        link: r,
        value: o,
        displayValue: d,
        categoryLabel: p.origLabel,
        toolText: s,
        id: v.userID,
        datasetIndex: f || 0,
        datasetName: y.seriesname,
        visible: g
      }, l = C.symbol, e._xPos = u, e._yPos = h, e._xVal = n, e._yVal = a, e._index = x, null !== a && null !== n ? (p.eventArgs.x = n, p.eventArgs.y = a, c.enabled && (w = {
        path: (0, i.polyPathToPath)([c.anchorSides || 2, u, h, c.anchorRadius, c.startAngle, c.dip]),
        fill: (0, i.toRaphaelColor)({
          color: c.anchorColor,
          alpha: c.anchorBgAlpha
        }),
        stroke: (0, i.toRaphaelColor)({
          color: c.anchorBorderColor,
          alpha: c.anchorBorderAlpha
        }),
        "stroke-width": c.anchorBorderThickness
      }, k = {
        path: (0, i.polyPathToPath)([l[1] || 2, u, h, C.radius, C.startAngle, p.dip || 0]),
        fill: (0, i.toRaphaelColor)({
          color: C.bgColor,
          alpha: C.bgAlpha
        }),
        stroke: (0, i.toRaphaelColor)({
          color: C.borderColor,
          alpha: C.borderAlpha
        }),
        "stroke-width": C.borderThickness
      }, c.attrs = {
        hoverEnabled: c.enabled,
        anchorRadius: C.radius,
        anchorHoverRadius: c.anchorRadius
      }, c.attrs[m] = w, c.attrs[b] = k, C.isAnchorHoverRadius = c.attrs.anchorRadius), C.imageUrl && (p.anchorImageLoaded = !1), p.props = {
        element: {
          attr: {
            path: (0, i.polyPathToPath)([l[1] || 2, u, h, C.radius, C.startAngle, p.dip || 0]),
            fill: (0, i.toRaphaelColor)({
              color: C.bgColor,
              alpha: C.bgAlpha
            }),
            stroke: (0, i.toRaphaelColor)({
              color: C.borderColor,
              alpha: C.borderAlpha
            }),
            "stroke-width": C.borderThickness
          }
        }
      }) : o && (o.isNull = !0);
    }, t.prototype.parseLabelAttributes = function (e, t) {
      var n,
          a,
          i,
          o,
          r,
          l,
          s,
          c,
          h,
          d,
          p,
          f,
          g,
          m,
          b,
          v,
          x,
          C,
          k,
          w,
          S,
          _,
          L = this.getFromEnv("chart"),
          P = L.config,
          A = this.getFromEnv("smartLabel"),
          N = L.config.dataLabelStyle,
          E = this.components.data,
          F = P.stack100percent,
          O = P.rotatevalues ? 270 : 0,
          T = P.canvasTop,
          D = P.canvasHeight,
          M = L.config.isstacked,
          I = t;

      if (S = (g = e && e.config) && g.setValue, e !== u && S !== u && null !== S && !0 !== g.labelSkip) {
        switch (h = g.anchorProps, b = e._yPos || e.config._Py, m = e._xPos || e.config._Px, w = h.markerRadius || h.radius - 3, a = P.valuepadding + 2 + w, g.valuePosition) {
          case "above":
            d = 0;
            break;

          case "below":
            d = 1;
            break;

          default:
            v = E[I - 1] && E[I - 1].config || {}, M && F ? (x = v.value, C = g.value) : (x = v.setValue, C = g.setValue), d = I && x > C ? 1 : 0;
        }

        n = g.displayValue, k = g.showValue, y(n) && "" !== n && null !== C && k && (_ = {
          text: n,
          fill: N.color,
          "text-bound": [N.backgroundColor, N.borderColor, N.borderThickness, N.borderPadding, N.borderRadius, N.borderDash]
        }, i = A.getOriSize(n), g._state = g._state || {}, O ? (g._state.labelWidth = i.height, g._state.labelHeight = i.width, g._rotated = !0) : (g._state.labelWidth = i.width, g._state.labelHeight = i.height, g._rotated = !1), o = r = g._state.labelHeight, o += a, c = .5 * r + a, p = b - T, f = T + D - b, l = b, s = m, o += 4, d ? f > o ? (l += c, g._valueBelowPoint = 1) : p > o && (l -= c, g._valueBelowPoint = 0) : p > o ? (l -= c, g._valueBelowPoint = 0) : f > o && (l += c, g._valueBelowPoint = 1), _.x = s, _.y = l), g.props = g.props || {}, g.props.label = {
          attr: _
        };
      } else g && delete g.labelSkip;
    }, t.prototype.allocatePosition = function () {
      var e,
          t,
          n = this,
          a = n.config,
          i = n.getFromEnv("chart"),
          o = i.config,
          r = o.showpercentvalues,
          l = o.showpercentintooltip,
          s = n.components,
          c = s.data,
          h = n.getFromEnv("xAxis"),
          d = 0,
          p = 0,
          f = o.isstacked,
          g = Number(o.stack100percent),
          m = o.viewPortConfig.step || 1,
          b = i.hasScroll,
          v = n.getSkippingInfo && n.getSkippingInfo(),
          y = v && v.labelDraw || [],
          x = v && v.draw || [];

      for (t = s.animAttrs = [], n.calculateScrollRange(), h.getState("scrolling") || f && (g || r || l) && n.updateYForStack(), n.createCoordinates(), p = a.scrollMinVal; p < a.scrollMaxVal; p += m) {
        d = x[p] || p, b && !o.skipAttr && (d < void 0 || d > void 0) || ((e = c[d]) && e.config ? n.parsePlotAttributes(e, d) : t[d] = u);
      }

      for (m > 1 && a.skipIgnorerIndices.map(function (e) {
        return c[e];
      }).filter(function (e) {
        return e || e.config;
      }).forEach(function (e) {
        return n.parsePlotAttributes(e, d);
      }), p = a.scrollMinValForLabel; p < a.scrollMaxValForLabel; p += m) {
        d = y[p] || p, e = c[d], n.parseLabelAttributes(e, d);
      }
    }, t.prototype.drawPlot = function (e, t) {
      var n = this.config,
          a = e.config,
          i = e.graphics,
          o = a.anchorProps,
          r = this.getState("visible"),
          l = o.radius,
          s = o.shadow,
          c = o.anchorAlpha,
          h = l && c,
          d = this.getContainer("plotGroup"),
          p = this.getContainer("shadowGroup"),
          f = this.getFromEnv("animationManager"),
          g = void 0,
          v = void 0,
          y = void 0;
      null !== a._y && null !== a._x ? (o.imageUrl ? this.drawAnchorImage(e) : (g = i.element, (y = i.image) && y.remove(), delete i.image, (n.drawanchors || h) && r && null !== e.config.setValue ? (g = i.element = f.setAnimation({
        el: g || "path",
        container: d,
        attr: a.props.element.attr,
        index: t,
        length: length,
        callback: function callback() {
          this.show();
        },
        component: this,
        label: "anchor"
      })).shadow(s, p) : g && (this.__removeElem(i.element, "element"), delete i.element, g = u)), v = a.hoverEffects, g && (v.enabled ? g.data("hoverEnabled", v.attrs.hoverEnabled).data("anchorRadius", v.attrs.anchorRadius).data("anchorHoverRadius", v.attrs.anchorHoverRadius).data(m, v.attrs[m]).data(b, v.attrs[b]) : g.data("hoverEnabled", !1), g.data("eventArgs", a && a.eventArgs))) : i.element && (i.element = f.setAnimation({
        el: i.element,
        component: this
      }));
    }, t.prototype.drawPlots = function () {
      var e,
          t,
          n,
          a = this,
          i = a.getFromEnv("chart").config,
          o = a.components,
          r = a.config,
          l = o.data,
          s = 0,
          c = 0,
          h = o.animAttrs,
          d = r._oldStartIndex,
          p = r._oldEndIndex,
          f = a.getGraphicalElement("sharedAnchor"),
          g = i.viewPortConfig.step || 1,
          m = a.getSkippingInfo && a.getSkippingInfo(),
          b = m && m.draw || [];

      for (h = o.animAttrs = [], t = r.scrollMinVal, n = r.scrollMaxVal, t > d && a.flushOnScroll(d, t > p ? p : t), n < p && a.flushOnScroll(n < d ? d : n, p), r._oldStartIndex = t, r._oldEndIndex = n, a.hideAllAnchors && a.hideAllAnchors(), c = t; c < n; c += g) {
        s = b[c] || c, (e = l[s]) && e.config ? a.drawPlot(e, s) : h[s] = u;
      }

      g > 1 && r.skipIgnorerIndices.map(function (e) {
        return l[e];
      }).filter(function (e) {
        return e || e.config;
      }).forEach(function (e) {
        return a.drawPlot(e, s);
      }), 0 === s || r.drawanchors ? f && f.hide() : f ? f.hide() : a.getAnchor();
    }, t.prototype.drawAnchorImage = function (e) {
      var t = this.getContainer("plotGroup"),
          n = e.graphics,
          a = this.getFromEnv("animationManager"),
          i = void 0,
          o = h ? n.element : n.image,
          r = e.config.anchorProps,
          l = r.anchorAlpha && r.radius,
          s = r.imageAlpha;
      this.getState("visible") && l ? (h || (n.element = a.setAnimation({
        el: n.element || "path",
        container: t,
        attr: e.config.props.element.attr,
        label: "anchor",
        component: this
      }).show()), e.config.props.element.attr.opacity = .01 * s, i = a.setAnimation({
        el: o || "image",
        container: t,
        component: this,
        label: "anchor",
        attr: {
          opacity: .01 * s
        }
      }), h ? n.element = i : n.image = i, o ? i.attrs.src !== r.imageUrl ? i.attr("src", r.imageUrl) : i._.RefImg && _(this, e) : (i.on("load", this._onAnchorImageLoad(e)), i.attr("src", r.imageUrl)), i.show()) : (n.image && a.setAnimation({
        el: n.image,
        state: "disappearing",
        component: this,
        doNotRemove: !0,
        callback: function callback() {
          this.hide();
        }
      }), n.element && a.setAnimation({
        el: n.element,
        state: "disappearing",
        component: this,
        doNotRemove: !0,
        callback: function callback() {
          this.hide();
        }
      }));
    }, t.prototype.getLineSegment = function (e, t, n) {
      var a = t._Px,
          i = t._Py,
          o = t._Pbx,
          r = t._Pby,
          l = this.getFromEnv("yAxis").getPixel(0),
          s = t.setValue,
          c = this.getFromEnv("chart").config.connectnulldata;
      return "zero" === n ? (i = l, r = l) : "base" === n && (i = t._Pby), null === s || s.isNull ? c || (e.pointsJoined > 0 && (e.path2Arr[e.path2Arr.length - 1] !== x && r !== u && e.path2Arr.push(x), e.pathArr = e.pathArr.concat(e.path2Arr), e.path2Arr = []), e.temp = [], e.temp2 = [], e.lastValidValue = !1) : e.lastValidValue ? (e.temp.length && (e.pathArr = e.pathArr.concat(e.temp), o !== u && (e.path2Arr = e.temp2, e.temp2 = []), e.temp = [], e.pointsJoined++), e.pathArr.push(["L", a, i]), r !== u && e.path2Arr.unshift(["L", a, r])) : (e.temp.push(["M", a, i]), r !== u && e.temp2.push(["L", o, r]), e.pointsJoined = 0, e.lastValidValue = !0), e;
    }, t.prototype.getLinePath = function (e, t, n) {
      var a,
          i,
          o,
          r,
          l,
          s,
          c,
          h,
          d = this,
          p = d.getFromEnv("chart").config,
          f = e.length,
          g = t && t.begin || 0,
          m = d.getState("visible") ? t && t.end || f : 0,
          b = p.viewPortConfig.step || 1,
          y = (d.removeDataLen, []),
          C = d.getSkippingInfo && d.getSkippingInfo(),
          k = C && C.draw || [],
          w = k.length,
          S = C && C.skippingApplied,
          _ = d.config.skipIgnorerIndices,
          L = [],
          P = {},
          A = 0;

      for (0, y = y.concat(e), S && (g = 0, m = w), i = g + 0; i < m + 0; i += b) {
        if (l = y[a = k[i] || i]) if ((o = l.config).setValue === u || o && !0 === o.isSkipped) o && delete o.isSkipped;else {
          if (b > 1) for (; _[A] < i;) {
            (c = y[_[A]]) && ((h = c.config).setValue === u || h && !0 === h.isSkipped ? h && delete h.isSkipped : (L = L.concat(h), A++));
          }
          L = L.concat(o), r = o._Pby, s = i;
        }
      }

      if (b > 1) for (a = s + 1; a <= i; a++) {
        (l = y[k[a] || a]) && ((o = l.config).setValue === u || o && !0 === o.isSkipped ? o && delete o.isSkipped : _.includes(a) && (L = L.concat(o), r = o._Pby));
      }
      return (P = L.reduce(function (e, t) {
        return d.getLineSegment(e, t, n);
      }, {
        temp: [],
        temp2: [],
        pathArr: [],
        path2Arr: [],
        pointsJoined: 0,
        lastValidValue: !1,
        getPathArr: v
      })).path2Arr[P.path2Arr.length - 1] !== x && P.pointsJoined > 0 && r !== u && P.path2Arr.push(x), P;
    }, t.prototype._removeDataVisuals = function (e) {
      var t,
          n,
          a,
          i,
          o = this.components.pool || (this.components.pool = {});
      if (e) for (n in a = e.graphics) {
        t = o[n] || (o[n] = []), (i = a[n]).hide && "function" == typeof i.hide && (i.attr({
          "text-bound": []
        }), i.hide(), i.shadow && i.shadow(!1)), t.push(a[n]);
      }
    }, t.prototype._parseAnchorProperties = function (e, t) {
      var n,
          a,
          o,
          r = this.config,
          l = this.getName(),
          s = this.getFromEnv("chart"),
          c = s.config.anchoralpha,
          h = !s.config.anchoralpha && /area/gi.test(l) ? 0 : 1,
          d = r.JSONData,
          p = s.getFromEnv("dataSource").chart,
          f = (t || d.data || [])[e] || {},
          g = {};
      return a = (0, i.pluck)(f.anchorstartangle, d.anchorstartangle, p.anchorstartangle, f.anchorimagealpha, d.anchorimagealpha, p.anchorimagealpha, f.anchorimagescale, d.anchorimagescale, p.anchorimagescale, f.anchorimagepadding, d.anchorimagepadding, p.anchorimagepadding, f.anchorimageurl, d.anchorimageurl, p.anchorimageurl, f.anchorradius, d.anchorradius, p.anchorradius, f.anchorbgcolor, d.anchorbgcolor, p.anchorbgcolor, f.anchorbordercolor, d.anchorbordercolor, p.anchorbordercolor, f.anchoralpha, d.anchoralpha, p.anchoralpha, f.anchorsides, d.anchorsides, p.anchorsides, f.anchorborderthickness, d.anchorborderthickness, p.anchorborderthickness, u) !== u, o = (0, i.pluckNumber)(f.drawanchors, r.drawanchors), g.enabled = a ? (0, i.pluckNumber)(o, a) : (0, i.pluckNumber)(o, h), g.startAngle = (0, i.pluckNumber)(f.anchorstartangle, r.anchorstartangle), g.imageAlpha = (0, i.pluckNumber)(f.anchorimagealpha, r.anchorimagealpha), g.imageScale = (0, i.pluckNumber)(f.anchorimagescale, r.anchorimagescale), g.imagePadding = (0, i.pluckNumber)(f.anchorimagepadding, r.anchorimagepadding), g.imagePadding < 0 && (g.imagePadding = 0), g.imageUrl = (0, i.pluck)(f.anchorimageurl, r.anchorimageurl), g.imageUrl && r.imageCount++, g.radius = g.enabled ? (0, i.pluckNumber)(f.anchorradius, r.anchorradius) : 0, g.isAnchorRadius = (0, i.pluck)(f.anchorradius, d.anchorradius, p.anchorradius), g.bgColor = (0, i.pluck)(f.anchorbgcolor, r.anchorbgcolor), c = g.enabled ? (0, i.getFirstAlpha)((0, i.pluck)(f.anchoralpha, r.anchoralpha, g.enabled ? i.HUNDREDSTRING : "0")) : 0, g.anchorAlpha = c, g.bgAlpha = (0, i.getFirstAlpha)((0, i.pluck)(f.anchorbgalpha, r.anchorbgalpha, c)) * c / 100, g.imageAlpha = g.imageAlpha * c / 100, g.borderColor = (0, i.pluck)(f.anchorbordercolor, r.anchorbordercolor), g.borderAlpha = c, g.sides = (0, i.pluck)(f.anchorsides, r.anchorsides), g.borderThickness = (0, i.pluck)(f.anchorborderthickness, r.anchorborderthickness), g.symbol = (0, i.mapSymbolName)(g.sides).split("_"), n = (0, i.pluckNumber)(f.anchorshadow, r.anchorshadow) && g.radius >= 1, g.shadow = {
        opacity: n ? c / 100 : 0
      }, g;
    }, t.prototype._hideGraphics = function (e) {
      var t, n;

      for (n in e) {
        if (e.hasOwnProperty(n)) {
          if (!(t = e[n])) continue;
          t.hide ? t.hide() : this._hideGraphics(t);
        }
      }
    }, t.prototype._parseHoverEffectOptions = function (e, t) {
      var n = this.config.JSONData,
          a = this.getFromEnv("chart"),
          o = a.getFromEnv("dataSource").chart,
          r = a.config,
          l = e.config,
          s = this.config,
          c = l.anchorProps || {},
          h = r.plothovereffect,
          d = s.drawanchors,
          p = {
        enabled: !1
      };
      return t = t || {}, 0 !== h && 0 !== d && (p.enabled = (0, i.pluck)(t.hovercolor, t.anchorhovercolor, t.hovercolor, n.hovercolor, t.anchorbghovercolor, n.anchorbghovercolor, o.anchorbghovercolor, n.anchorhovercolor, o.anchorhovercolor, t.hoveralpha, t.anchorhoveralpha, n.anchorhoveralpha, o.anchorhoveralpha, t.bghoveralpha, t.anchorbghoveralpha, n.anchorbghoveralpha, o.anchorbghoveralpha, t.anchorborderhovercolor, t.borderhovercolor, n.anchorborderhovercolor, o.anchorborderhovercolor, t.anchorborderhoverthickness, t.borderhoverthickness, n.anchorborderhoverthickness, o.anchorborderhoverthickness, t.anchorborderhoveralpha, t.borderhoveralpha, n.anchorborderhoveralpha, o.anchorborderhoveralpha, t.hoverdip, t.anchorhoverdip, n.anchorhoverdip, o.anchorhoverdip, t.anchorhoverstartangle, n.anchorhoverstartangle, o.anchorhoverstartangle, t.hoversides, t.anchorhoversides, n.anchorhoversides, o.anchorhoversides, t.hoverradius, t.anchorhoverradius, n.anchorhoverradius, o.anchorhoverradius, n.plotfillhovercolor, o.plotfillhovercolor, r.plothovereffect, u) !== u, p.startAngle = (0, i.pluckNumber)(t.anchorhoverstartangle, n.anchorhoverstartangle, o.anchorhoverstartangle, c.startAngle), p.anchorSides = (0, i.pluckNumber)(t.hoversides, t.anchorhoversides, n.anchorhoversides, o.anchorhoversides, c.sides), p.anchorRadius = (0, i.pluckNumber)(t.anchorhoverradius, n.anchorhoverradius, o.anchorhoverradius), p.isAnchorHoverRadius = p.anchorRadius, p.anchorRadius = (0, i.pluckNumber)(p.anchorRadius, c.radius + (h ? 2 : 0)), p.anchorScale = (0, i.pluck)(t.hoverscale, n.anchorscale, o.anchorscale), p.imageHoverScale = (0, i.pluckNumber)(t.anchorimagehoverScale, n.anchorimagehoverscale, o.anchorimagehoverscale, 110), p.imageHoverAlpha = (0, i.pluckNumber)(t.anchorimagehoveralpha, n.anchorimaghoverealpha, o.anchorimagehoveralpha), p.anchorAlpha = (0, i.pluck)(t.anchorhoveralpha, t.hoveralpha, n.anchorhoveralpha, o.anchorhoveralpha, c.anchorAlpha), p.anchorColor = (0, i.getFirstColor)((0, i.pluck)(t.hovercolor, t.anchorhovercolor, t.hoverColor, t.anchorbghovercolor, n.anchorbghovercolor, n.anchorhovercolor, n.hovercolor, o.anchorbghovercolor, o.anchorhovercolor, o.plotfillhovercolor, c.bgColor)), p.anchorBgAlpha = (0, i.pluck)(t.bghoveralpha, t.anchorbghoveralpha, n.anchorbghoveralpha, o.anchorbghoveralpha, o.plotfillhoveralpha, c.bgAlpha), p.anchorBgAlpha = p.anchorBgAlpha * p.anchorAlpha / 100, p.anchorBorderColor = (0, i.pluck)(t.borderhovercolor, t.anchorborderhovercolor, n.anchorborderhovercolor, o.anchorborderhovercolor, c.borderColor), p.anchorBorderAlpha = (0, i.pluck)(t.borderhoveralpha, t.anchorborderhoveralpha, n.anchorborderhoveralpha, o.anchorborderhoveralpha, p.anchorAlpha, c.borderAlpha), p.anchorBorderThickness = (0, i.pluckNumber)(t.borderhoverthickness, t.anchorborderhoverthickness, n.anchorborderhoverthickness, o.anchorborderhoverthickness, o.anchorBorderThickness, c.borderThickness), p.dip = (0, i.pluck)(t.hoverdip, t.anchorhoverdip, n.anchorhoverdip, o.anchorhoverdip, c.dip), p.anchorAnimation = (0, i.pluckNumber)(t.anchorhoveranimation, n.anchorhoveranimation, o.anchorhoveranimation, 1)), p;
    }, t.prototype._hoverPlotAnchor = function (e, t) {
      var n,
          a,
          i,
          o,
          r,
          l = this.getFromEnv("smartLabel"),
          s = this.getFromEnv("chart").getChildren("canvas")[0].getEffectiveDimensions(),
          c = s.top,
          u = c + s.height,
          f = e.config._Py,
          g = this.getFromEnv("animationManager"),
          v = this.getGraphicalElement("sharedAnchor"),
          y = e.graphics.element || v,
          x = e.graphics.label,
          C = e.config || {},
          k = C.anchorProps.anchorAlpha,
          w = C && C.anchorProps.imageUrl,
          S = h && w ? e.graphics.element : e.graphics.image,
          _ = "image" === y.type,
          L = y.data("anchorRadius"),
          P = y.data("anchorHoverRadius"),
          A = y.data(m),
          N = y.data(b),
          E = x && (x.data("isBelow") ? 1 : -1) * (_ ? .5 * (A.height - N.height) : P - L),
          F = t === d ? A : N,
          O = !0,
          T = {
        path: F.path
      },
          D = {
        fill: F.fill,
        "stroke-width": F["stroke-width"],
        stroke: F.stroke
      },
          M = x && x.data("rotation") || "";

      f - 3 * (n = l.getOriSize(C.displayValue).height) / 2 + E < c ? E = c - f + 3 * n / 2 : f + 3 * n / 2 + E > u && (E = u - f - 3 * n / 2), r = {
        transform: "T0," + (t === d ? E : 0) + M
      }, g.setAnimationState(t === d ? "mouseOver" : "mouseOut"), S && (i = S.data(m), o = S.data(b), (a = t == d ? i : o).alpha *= .01), _ ? T.alpha *= .01 : Object.assign(T, D), (t === d && !P || t === p && !L) && (O = !1), g.setAnimation({
        el: y,
        label: "anchor",
        component: this,
        doNotRemove: !0,
        callback: function callback() {
          !O && y.hide();
        },
        attr: O && T
      }), O && y.show(), S && (g.setAnimation({
        el: S,
        label: "anchor",
        component: this,
        attr: O && a
      }), O && S.show()), (e.graphics && e.graphics.element || v && v.element) && k && x && g.setAnimation({
        el: x,
        label: "label",
        component: this,
        doNotRemove: !0,
        attr: r
      });
    }, t.prototype.drawLabel = function (e, t) {
      var n,
          a,
          o,
          r,
          l,
          s,
          c,
          h,
          d,
          p,
          f,
          g,
          m = this.getFromEnv("chart"),
          b = m.config,
          v = this.getFromEnv("smartLabel"),
          x = m.config.dataLabelStyle,
          C = this.components.data,
          k = this.getFromEnv("paper"),
          w = this.getFromEnv("animationManager"),
          S = "",
          _ = b.rotatevalues ? 270 : 0,
          L = this.getContainer("labelGroup"),
          P = this.getState("visible"),
          A = C.length,
          N = this.getSkippingInfo && this.getSkippingInfo(),
          E = N && N.skippingApplied,
          F = N && N.labelDraw || [],
          O = F.length,
          T = (0, i.pluckNumber)(e, 0),
          D = (0, i.pluckNumber)(t, E ? O : A),
          M = O === Math.abs(D - (T + 1));

      for (c = {
        "font-weight": x.fontWeight,
        "font-style": x.fontStyle,
        "font-family": x.fontFamily,
        "font-size": x.fontSize,
        "line-height": x.lineHeight
      }, v.setStyle(c), d = T; d < D; d++) {
        p = (r = (h = C[E && M ? F[d] : d]) && h.config) && r.setValue, h !== u && p !== u && null !== p && !0 !== r.labelSkip ? (n = h.graphics, S = r.displayValue, l = r.showValue, s = n.label, f = r.props.label.attr, y(S) && l && P ? (o = r.props.label.attr.x, a = r.props.label.attr.y, f.transform = k.getSuggestiveRotation(_, o, a), n.label = s = w.setAnimation({
          el: s || "text",
          container: L,
          component: this,
          attr: f,
          label: "label"
        }), s.data("isBelow", r._valueBelowPoint), s.data("rotation", f.transform)) : s && (n.label = w.setAnimation({
          el: s,
          component: this,
          label: "label"
        }))) : (r && delete r.labelSkip, (g = h && h.graphics) && g.label && (g.label = w.setAnimation({
          el: g.label,
          component: this
        })));
      }
    }, t.prototype.getAxisValuePadding = function () {
      return this.config.defaultPadding;
    }, t.prototype._hoverFunc = function (e, t, n, a) {
      if (n) return this._hoverPlotAnchor(e, t, a);
    }, t.prototype._onAnchorImageLoad = function (e) {
      var t = this;
      return function () {
        var n = e._index;
        _(t, e), t.config.drawn ? t.drawLabel(n, n + 1) : t.addJob("labelUpdateOnImageLoadID" + n, function () {
          t.drawLabel(n, n + 1);
        }, o.priorityList.label);
      };
    }, t;
  }(a["default"]);

  t["default"] = L;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = {
    "*.dataset.area": function datasetArea() {
      return {
        "anchor.appearing": [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          startEnd: {
            start: .5,
            end: 1
          },
          slot: "plot"
        }],
        "anchor.updating": [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          slot: "final"
        }],
        "anchor.disappearing": [{
          finalAttr: {
            opacity: 0,
            "fill-opacity": 0,
            "stroke-opacity": 0
          },
          slot: "final"
        }],
        "line.appearing": function lineAppearing(e) {
          var t = e.component,
              n = t.components.data,
              a = t.getFromEnv("chartConfig").isstacked,
              i = t.getFromEnv("chartConfig").is3D,
              o = t.getLinePath(n, null, a || i ? "base" : "zero"),
              r = e.attr,
              l = t.getState("_total"),
              s = t.config._childIndex;
          return [{
            initialAttr: {
              opacity: 0,
              path: o.getPathArr()
            },
            finalAttr: {
              opacity: 1,
              path: r.path
            },
            startEnd: {
              start: a ? .5 / l * s : 0,
              end: a ? .5 / l * (s + 1) : .5
            },
            slot: "plot",
            hookFn: function hookFn() {
              this.attr({
                opacity: 1
              });
            }
          }];
        },
        "label.appearing": [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          slot: "final"
        }],
        "label.updating": function labelUpdating() {
          return [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: "final"
          }];
        },
        "group.appearing": function groupAppearing(e) {
          return "label-group" === e.attr.name ? [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: "final"
          }] : "plot-group" === e.attr.name ? [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            startEnd: {
              start: .5,
              end: 1
            },
            slot: "plot"
          }] : [{
            initialAttr: {
              opacity: 1
            },
            finalAttr: {
              opacity: 1
            },
            slot: "final"
          }];
        },
        "*": null
      };
    }
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = {
    "*.dataset.line": function datasetLine() {
      var e = this.getClip("canvas"),
          t = this.getClip("init");
      return {
        "anchor.appearing": function anchorAppearing() {
          return [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: "final"
          }];
        },
        "anchor.updating": function anchorUpdating() {
          return [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: "plot"
          }];
        },
        "anchor.disappearing": function anchorDisappearing() {
          return [{
            finalAttr: {
              opacity: 0,
              "fill-opacity": 0,
              "stroke-opacity": 0
            },
            slot: "plot"
          }];
        },
        "line.appearing": function lineAppearing() {
          return [{
            initialAttr: {
              "clip-rect": t
            },
            finalAttr: {
              "clip-rect": e
            },
            slot: "middle",
            callback: function callback() {
              this.attr({
                "clip-rect": null
              });
            }
          }];
        },
        "line.updating": function lineUpdating() {
          return [{
            initialAttr: {
              opacity: 1,
              "clip-rect": t
            },
            finalAttr: {
              opacity: 1,
              "clip-rect": e
            },
            slot: "plot"
          }];
        },
        "label.appearing": [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          slot: "final"
        }],
        "group.appearing": function groupAppearing(e) {
          return "label-group" === e.attr.name ? [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: "final"
          }] : "plot-group" === e.attr.name ? [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            startEnd: {
              start: .5,
              end: 1
            },
            slot: "plot"
          }] : [{
            initialAttr: {
              opacity: 1
            },
            finalAttr: {
              opacity: 1
            },
            slot: "final"
          }];
        },
        "*": null
      };
    }
  };
},,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.__postSpaceManagement = t.__spaceManager = t.__feedAxesRawData = undefined;
  var a = r(n(459)),
      i = r(n(432)),
      o = n(125);

  function r(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function l(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  function s() {
    var e,
        t,
        n = this.config,
        a = this.getFromEnv("color-manager"),
        i = this.getFromEnv("dataSource"),
        r = i.chart,
        l = this.config.is3D,
        s = l ? o.chartPaletteStr.chart3D : o.chartPaletteStr.chart2D;
    return e = {
      isVertical: !0,
      isReverse: !1,
      isOpposit: !1,
      outCanfontFamily: (0, o.pluck)(r.outcnvbasefont, r.basefont, "Verdana,sans"),
      outCanfontSize: (0, o.pluckFontSize)(r.outcnvbasefontsize, r.basefontsize, 10),
      outCancolor: (0, o.pluck)(r.outcnvbasefontcolor, r.basefontcolor, a.getColor(s.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi, "#$1"),
      axisNamePadding: r.xaxisnamepadding,
      maxLabelWidthPercent: r.maxlabelwidthpercent,
      minLabelWidthPercent: r.minlabelwidthpercent,
      axisValuePadding: r.labelpadding,
      axisNameFont: r.xaxisnamefont,
      axisNameFontSize: r.xaxisnamefontsize,
      axisNameFontColor: r.xaxisnamefontcolor,
      axisNameFontBold: r.xaxisnamefontbold,
      axisNameFontItalic: r.xaxisnamefontitalic,
      axisNameBgColor: r.xaxisnamebgcolor,
      axisNameBorderColor: r.xaxisnamebordercolor,
      axisNameAlpha: r.xaxisnamealpha,
      axisNameFontAlpha: r.xaxisnamefontalpha,
      axisNameBgAlpha: r.xaxisnamebgalpha,
      axisNameBorderAlpha: r.xaxisnameborderalpha,
      axisNameBorderPadding: r.xaxisnameborderpadding,
      axisNameBorderRadius: r.xaxisnameborderradius,
      axisNameBorderThickness: r.xaxisnameborderthickness,
      axisNameBorderDashed: r.xaxisnameborderdashed,
      axisNameBorderDashLen: r.xaxisnameborderdashlen,
      axisNameBorderDashGap: r.xaxisnameborderdashgap,
      axisNameWidth: r.xaxisnamewidth,
      useEllipsesWhenOverflow: r.useellipseswhenoverflow,
      divLineColor: (0, o.pluck)(r.vdivlinecolor, r.divlinecolor, a.getColor(s.divLineColor)),
      divLineAlpha: (0, o.pluck)(r.vdivlinealpha, r.divlinealpha, l ? a.getColor("divLineAlpha3D") : a.getColor("divLineAlpha")),
      divLineThickness: (0, o.pluckNumber)(r.vdivlinethickness, r.divlinethickness, 1),
      divLineIsDashed: Boolean((0, o.pluckNumber)(r.vdivlinedashed, r.vdivlineisdashed, r.divlinedashed, r.divlineisdashed, 0)),
      divLineDashLen: (0, o.pluckNumber)(r.vdivlinedashlen, r.divlinedashlen, 4),
      divLineDashGap: (0, o.pluckNumber)(r.vdivlinedashgap, r.divlinedashgap, 2),
      showAlternateGridColor: 0,
      alternateGridColor: (0, o.pluck)(r.alternatehgridcolor, a.getColor("altHGridColor")),
      alternateGridAlpha: (0, o.pluck)(r.alternatehgridalpha, a.getColor("altHGridAlpha")),
      numDivLines: r.numvdivlines,
      labelFont: r.labelfont,
      labelFontSize: r.labelfontsize,
      labelFontColor: r.labelfontcolor,
      labelFontAlpha: r.labelalpha,
      labelFontBold: r.labelfontbold,
      labelFontItalic: r.labelfontitalic,
      axisName: r.xaxisname,
      axisMinValue: r.xaxisminvalue,
      axisMaxValue: r.xaxismaxvalue,
      setAdaptiveMin: r.setadaptivexmin,
      adjustDiv: r.adjustvdiv,
      labelDisplay: r.labeldisplay,
      showLabels: r.showlabels,
      rotateLabels: r.rotatelabels,
      slantLabel: (0, o.pluckNumber)(r.slantlabels, r.slantlabel),
      labelStep: (0, o.pluckNumber)(r.labelstep, r.xaxisvaluesstep),
      showAxisValues: (0, o.pluckNumber)(r.showxaxisvalues, r.showxaxisvalue),
      showLimits: r.showvlimits,
      showDivLineValues: (0, o.pluckNumber)(r.showvdivlinevalues, r.showvdivlinevalues),
      zeroPlaneColor: r.vzeroplanecolor,
      zeroPlaneThickness: (0, o.pluckNumber)(r.vzeroplanethickness, r.vdivlinethickness, 2),
      zeroPlaneAlpha: (0, o.pluckNumber)(r.vzeroplanealpha, r.vdivlinealpha, n.zeroplanealpha),
      showZeroPlaneValue: r.showvzeroplanevalue,
      trendlineColor: r.trendlinecolor,
      trendlineToolText: r.trendlinetooltext,
      trendlineThickness: r.trendlinethickness,
      rotateAxisName: (0, o.pluckNumber)(r.rotatexaxisname, 1),
      trendlineAlpha: r.trendlinealpha,
      showTrendlinesOnTop: r.showtrendlinesontop,
      showAxisLine: l ? 0 : (0, o.pluckNumber)(r.showxaxisline, r.showaxislines, r.drawAxisLines, 0),
      axisLineThickness: (0, o.pluckNumber)(r.xaxislinethickness, r.axislinethickness, 1),
      axisLineAlpha: (0, o.pluckNumber)(r.xaxislinealpha, r.axislinealpha, 100),
      axisLineColor: (0, o.pluck)(r.xaxislinecolor, r.axislinecolor, "#000000")
    }, (t = {
      isVertical: !1,
      isReverse: !1,
      isOpposit: !1,
      outCanfontFamily: (0, o.pluck)(r.outcnvbasefont, r.basefont, "Verdana,sans"),
      outCanfontSize: (0, o.pluckFontSize)(r.outcnvbasefontsize, r.basefontsize, 10),
      outCancolor: (0, o.pluck)(r.outcnvbasefontcolor, r.basefontcolor, a.getColor(s.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi, "#$1"),
      axisNamePadding: r.yaxisnamepadding,
      axisValuePadding: r.yaxisvaluespadding,
      axisNameFont: r.yaxisnamefont,
      axisNameFontSize: r.yaxisnamefontsize,
      axisNameFontColor: r.yaxisnamefontcolor,
      axisNameFontBold: r.yaxisnamefontbold,
      axisNameFontItalic: r.yaxisnamefontitalic,
      axisNameBgColor: r.yaxisnamebgcolor,
      axisNameBorderColor: r.yaxisnamebordercolor,
      axisNameAlpha: r.yaxisnamealpha,
      axisNameFontAlpha: r.yaxisnamefontalpha,
      axisNameBgAlpha: r.yaxisnamebgalpha,
      axisNameBorderAlpha: r.yaxisnameborderalpha,
      axisNameBorderPadding: r.yaxisnameborderpadding,
      axisNameBorderRadius: r.yaxisnameborderradius,
      axisNameBorderThickness: r.yaxisnameborderthickness,
      axisNameBorderDashed: r.yaxisnameborderdashed,
      axisNameBorderDashLen: r.yaxisnameborderdashlen,
      axisNameBorderDashGap: r.yaxisnameborderdashgap,
      axisNameWidth: r.yaxisnamewidth,
      useEllipsesWhenOverflow: r.useellipseswhenoverflow,
      axisName: r.yaxisname,
      divLineColor: (0, o.pluck)(r.divlinecolor, a.getColor(s.divLineColor)),
      divLineAlpha: (0, o.pluck)(r.divlinealpha, l ? a.getColor("divLineAlpha3D") : a.getColor("divLineAlpha")),
      divLineThickness: (0, o.pluckNumber)(r.divlinethickness, 1),
      divLineIsDashed: Boolean((0, o.pluckNumber)(r.divlinedashed, r.divlineisdashed, 0)),
      divLineDashLen: (0, o.pluckNumber)(r.divlinedashlen, 4),
      divLineDashGap: (0, o.pluckNumber)(r.divlinedashgap, 2),
      showAlternateGridColor: (0, o.pluckNumber)(r.showalternatevgridcolor, 1),
      alternateGridColor: (0, o.pluck)(r.alternatevgridcolor, a.getColor("altVGridColor")),
      alternateGridAlpha: (0, o.pluck)(r.alternatevgridalpha, a.getColor("altVGridAlpha")),
      numDivLines: r.numdivlines,
      axisMinValue: r.yaxisminvalue,
      axisMaxValue: r.yaxismaxvalue,
      setAdaptiveMin: r.setadaptiveymin,
      adjustDiv: r.adjustdiv,
      labelStep: r.yaxisvaluesstep,
      showAxisValues: (0, o.pluckNumber)(r.showyaxisvalues, r.showyaxisvalue),
      showLimits: (0, o.pluckNumber)(r.showyaxislimits, r.showlimits, this.showLimits),
      showDivLineValues: (0, o.pluckNumber)(r.showdivlinevalues, r.showdivlinevalue),
      zeroPlaneColor: r.zeroplanecolor,
      zeroPlaneThickness: (0, o.pluckNumber)(r.zeroplanethickness, r.divlinethickness, 2),
      zeroPlaneAlpha: (0, o.pluckNumber)(r.zeroplanealpha, r.divlinealpha, n.zeroplanealpha),
      showZeroPlaneValue: r.showzeroplanevalue,
      trendlineColor: r.trendlinecolor,
      trendlineToolText: r.trendlinetooltext,
      trendlineThickness: r.trendlinethickness,
      trendlineAlpha: r.trendlinealpha,
      isTrendZone: 0,
      showTrendlinesOnTop: r.showtrendlinesontop,
      showAxisLine: l ? 0 : (0, o.pluckNumber)(r.showyaxisline, r.showaxislines, r.drawAxisLines, 0),
      axisLineThickness: (0, o.pluckNumber)(r.yaxislinethickness, r.axislinethickness, 1),
      axisLineAlpha: (0, o.pluckNumber)(r.yaxislinealpha, r.axislinealpha, 100),
      axisLineColor: (0, o.pluck)(r.yaxislinecolor, r.axislinecolor, "#000000"),
      numberFormatterFn: "yAxis",
      showZeroPlaneOnTop: n.showzeroplaneontop,
      forceTrendBelow: !!n.is3D
    }).vtrendlines = i.trendlines, e.trendlines = i.vtrendlines, n.isstacked && (t.isPercent = (0, o.pluckNumber)(n.stack100percent, 0)), {
      xAxisConf: [e],
      yAxisConf: [t]
    };
  }

  function c() {
    var e,
        t,
        n,
        a,
        i,
        r,
        l,
        s,
        c,
        u,
        h,
        d,
        p,
        f,
        g,
        m,
        b,
        v,
        y,
        x = this.config,
        C = this.getChildren(),
        k = C.yAxis && C.yAxis[0],
        w = C.xAxis && C.xAxis || [],
        S = o.preDefStr.POSITION_BOTTOM,
        _ = x.legendposition,
        L = x.xDepth,
        P = x.yDepth,
        A = C.canvas[0],
        N = x.canvasBgDepth,
        E = x.canvasBaseDepth,
        F = x.canvasBasePadding,
        O = C.canvas[0].config.canvasBorderWidth,
        T = x.realTimeConfig && x.realTimeConfig.showRTValue,
        D = x.borderWidth,
        M = x.canvasMarginTop,
        I = x.canvasMarginBottom,
        R = x.canvasMarginLeft,
        V = x.canvasMarginRight,
        B = x.minCanvasHeight,
        j = x.minCanvasWidth,
        G = x.minChartWidth,
        H = x.minChartHeight,
        z = x.height,
        W = x.width,
        q = !1,
        U = !1,
        Y = x.origCanvasTopMargin,
        X = x.origCanvasBottomMargin,
        K = x.origCanvasLeftMargin,
        Z = x.origCanvasRightMargin;
    x.canvasWidth - 2 * D < G && (d = (x.canvasWidth - G) / 2), x.canvasHeight - 2 * D < H && (h = (x.canvasHeight - H) / 2), this._allocateSpace({
      top: h || D,
      bottom: h || D,
      left: d || D,
      right: d || D
    }), n = w[0], e = .7 * x.availableWidth, x.yAxisSpaceAllocation = b = n && n.placeAxis(e), n && this._allocateSpace(b), g = .225 * x.availableHeight, f = this._manageActionBarSpace && this._manageActionBarSpace(g) || {}, this._allocateSpace(f), this._manageLegendSpace && this._manageLegendSpace(), t = _ === S ? .6 * x.availableHeight : .6 * x.availableWidth, P && (this._allocateSpace({
      left: P
    }), x.shift = L + F + E), N && this._allocateSpace({
      top: N
    }), x.canvasWidth - 2 * O < j && (m = (x.canvasWidth - j) / 2), this._allocateSpace({
      left: m || O,
      right: m || O
    }), j > W - R - V && (U = !0, a = x.canvasWidth - j, y = R + V, R = x.canvasMarginLeft = a * R / y, V = x.canvasMarginRight = a * V / y), l = R > x.canvasLeft ? R - x.canvasLeft : 0, s = V > W - x.canvasRight ? V + x.canvasRight - W : 0, this._allocateSpace({
      left: l,
      right: s
    }), this._allocateSpace({
      left: E
    }), U && (y = K + Z, (u = x.canvasWidth) > j && (l = (a = u - j) * K / y, s = a * Z / y), this._allocateSpace({
      left: l,
      right: s
    })), x.actualCanvasMarginRight = s, x.actualCanvasMarginBottom = r, this._manageChartMenuBar(t), t = .2 * x.availableHeight, this._allocateSpace(this._getSumValueSpace(t)), t = .3 * x.availableHeight, x.realtimeEnabled && (T ? this._allocateSpace(this._realTimeValuePositioning(t)) : this._hideRealTimeValue()), t = .6 * x.availableHeight, x.xAxisSpaceAllocation = v = k && k.placeAxis(t), k && this._allocateSpace(v), t = .3 * x.availableHeight, this._manageScrollerPosition && this._manageScrollerPosition(t), x.canvasHeight - 2 * O < B && (p = (x.canvasHeight - B) / 2), this._allocateSpace({
      top: p || O,
      bottom: p || O
    }), B > z - M - I && (q = !0, a = x.canvasHeight - B, y = M + I, M = x.canvasMarginTop = a * M / y, I = x.canvasMarginBottom = a * I / y), i = M > x.canvasTop ? M - x.canvasTop : 0, r = I > z - x.canvasBottom ? I + x.canvasBottom - z : 0, this._allocateSpace({
      top: i,
      bottom: r
    }), q && (y = Y + X, (c = x.canvasHeight) > B && (i = (a = c - B) * Y / y, r = a * X / y), this._allocateSpace({
      top: i,
      bottom: r
    })), x.actualCanvasMarginTop = i, x.actualCanvasMarginLeft = l, A.setDimension({
      top: x.canvasTop,
      left: x.canvasLeft,
      width: x.canvasWidth,
      height: x.canvasHeight
    });
  }

  function u() {
    var e,
        t,
        n,
        a,
        i = this.config,
        o = this.getChildren(),
        r = o.xAxis && o.xAxis[0],
        l = o.yAxis && o.yAxis[0],
        s = o.legend && o.legend[0],
        c = i.xDepth,
        u = o.canvas[0].config,
        h = u.canvasBorderWidth,
        d = u.canvasPadding,
        p = Math.max;
    l && this._allocateXAxisLabelSpace(l), e = u.canvasPaddingLeft, t = u.canvasPaddingRight, n = u.canvasPaddingTop, a = u.canvasPaddingBottom, l && l.setAxisDimention({
      x: u.canvasLeft + e,
      y: u.canvasTop + u.canvasHeight + h,
      opposite: u.canvasTop - h,
      axisLength: u.canvasWidth - e - t
    }), r && r.setAxisDimention({
      x: u.canvasLeft - (i.shift || 0) - h,
      y: u.canvasTop + (c || 0) + p(n, d),
      opposite: u.canvasRight + h,
      axisLength: u.canvasHeight - (c || 0) - p(n, d) - p(a, d)
    }), s && s.postSpaceManager(), this.allocateDimensionOfChartMenuBar();
  }

  var h = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.apply(this, arguments));
    }

    return l(t, e), t.prototype.getName = function () {
      return "MSBarCartesian";
    }, t.getName = function () {
      return "MSBarCartesian";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this), this.config.enablemousetracking = !0;
    }, t.prototype._feedAxesRawData = function () {
      return s.call(this);
    }, t.prototype._spaceManager = function () {
      c.call(this);
    }, t.prototype._postSpaceManagement = function () {
      u.call(this);
    }, t.prototype.getDSdef = function () {
      return i["default"];
    }, t.prototype.getDSGroupdef = function () {}, t;
  }(a["default"]);

  t.__feedAxesRawData = s, t.__spaceManager = c, t.__postSpaceManagement = u, t["default"] = h;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = l(n(360)),
      i = n(460),
      o = l(n(461)),
      r = l(n(462));

  function l(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function s(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var c = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.registerFactory("dataset", o["default"], ["vCanvas"]), n.registerFactory("legend", r["default"]), n;
    }

    return s(t, e), t.getName = function () {
      return "MSCartesian";
    }, t.prototype.getName = function () {
      return "MSCartesian";
    }, t.prototype.getType = function () {
      return "chartAPI";
    }, t.prototype._createLayers = function () {
      e.prototype._createLayers.call(this);

      var t = this.getFromEnv("animationManager");
      !this.getChildContainer("legendGroup") && this.addChildContainer("legendGroup", t.setAnimation({
        el: "group",
        attr: {
          name: "legend"
        },
        component: this,
        container: this.getContainer("parentgroup"),
        label: "group"
      }));
    }, t.prototype._manageLegendSpace = function () {
      i._manageLegendSpace.call(this);
    }, t.prototype.manageGradientLegendSpace = function (e) {
      return i.manageGradientLegendSpace.call(this, e);
    }, t;
  }(a["default"]);

  t["default"] = c;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.manageGradientLegendSpace = t._manageLegendSpace = undefined;
  var a = n(125);
  t._manageLegendSpace = function () {
    var e,
        t,
        n,
        i,
        o = this.config,
        r = this.getChildren("legend") && this.getChildren("legend")[0],
        l = this.getChildren("gLegend") && this.getChildren("gLegend")[0],
        s = this.getFromEnv("dataSource").colorrange,
        c = o.hasLegend,
        u = {},
        h = this.hasGradientLegend,
        d = this.getFromEnv("dataSource").chart,
        p = (0, a.pluckNumber)(d.mapbycategory, 0);
    h && s && (0, a.pluckNumber)(s.gradient) && !p ? (e = l.conf, h = !0, o.gLegendEnabled = !0, i = .5, t = e.legendPosition) : (e = r && r.config, h = !1, o.gLegendEnabled = !1, i = (t = e && e.legendPos) === a.POSITION_RIGHT ? .8 : .4), n = t === a.POSITION_RIGHT ? o.availableWidth * i : o.availableHeight * i, h ? u = this.manageGradientLegendSpace(n) : !1 !== c && r && !r.getState("removed") && (u = r && r._manageLegendPosition(n)), this._allocateSpace({
      bottom: u && u.bottom || 0,
      right: u && u.right || 0
    });
  }, t.manageGradientLegendSpace = function (e) {
    var t,
        n,
        i,
        o,
        r = this.config,
        l = this.getFromEnv("gLegend"),
        s = l && l.conf;
    return r.gLegendPadding = (0, a.pluckNumber)(this.getFromEnv("chart-attrib").legendpadding, 10), i = Math.min(r.gLegendPadding, .5 * e), s ? (t = s.legendPosition, o = l.getLogicalSpace(e), n = t === a.POSITION_BOTTOM ? {
      bottom: (o.height || 0) + i
    } : {
      right: (o.width || 0) + i
    }) : n = {
      bottom: 0,
      right: 0
    }, n;
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    var t,
        n,
        i = e.getFromEnv("dataSource").dataset,
        o = void 0,
        r = o = e.getChildren().canvas[0].getChildren("vCanvas")[0],
        l = e.config.defaultDatasetType || "",
        s = void 0;
    i ? ((n = e.getDSGroupdef()) && ((0, a.componentFactory)(o, n, "datasetGroup_" + l, 1, [i]), s = o.getChildren("datasetGroup_" + l)), s && (r = s[0]), t = e.getDSdef(), (0, a.datasetFactory)(r, t, "dataset", i.length, i)) : e.setChartMessage();
  };
  var a = n(125);
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    var t = void 0;
    (0, i.componentFactory)(e, r["default"], "legend"), (t = e.getChildren("legend")[0]).configure(), e.addToEnv("legend", t), e.config.showLegend || t.remove();
  };
  var a,
      i = n(125),
      o = n(463),
      r = (a = o) && a.__esModule ? a : {
    "default": a
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(125),
      i = n(138),
      o = u(n(464)),
      r = n(132),
      l = n(228),
      s = u(n(466)),
      c = n(136);

  function u(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function h(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var d = {
    left: a.POSITION_START,
    right: a.POSITION_END,
    center: a.POSITION_MIDDLE
  },
      p = Math,
      f = p.min,
      g = p.max,
      m = p.floor,
      b = p.ceil,
      v = a.preDefStr.NORMAL,
      y = {
    fontWeight: {
      1: a.preDefStr.BOLD,
      0: v
    },
    fontStyle: {
      1: "italic",
      0: v
    },
    textDecoration: {
      1: "underline",
      0: a.preDefStr.noneStr
    }
  },
      x = function x(e) {
    var t = void 0,
        n = void 0;
    return {
      dragstart: function dragstart() {
        t = e.config.xL || e.config.xPos, n = e.config.yL || e.config.yPos;
      },
      dragmove: function dragmove(a) {
        var i,
            o,
            r = a.originalEvent.data[0],
            l = a.originalEvent.data[1],
            s = e.config,
            u = e.getFromEnv("chartConfig"),
            h = (s.borderWidth || 0) + 2;
        i = f(g(t + r, h), u.width - s.width - h), o = f(g(n + l, h), u.height - s.height - h), s.xPos = s.xL = i, s.yPos = s.yL = o, e.addJob("draw", e.dragDraw, c.priorityList && c.priorityList.draw);
      }
    };
  };

  (0, r.addDep)({
    name: "legendAnimation",
    type: "animationRule",
    extension: s["default"]
  });

  var C = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this)),
          a = n;

      return a._stateCosmetics = {}, a._legendState = [], a.dragDraw = function () {
        a.draw();
      }, a.drawScroll = function () {
        a.createItemGroup();
      }, a.config.handlers = x(a), n;
    }

    return h(t, e), t.prototype.createItem = function (e) {
      var t;
      return t = new o["default"](), this.attachChild(t, "legendItem"), t.setLinkedItem("owner", e), t.addEventListener("mouseover", function () {
        t.setLegendState("hover", !0);
      }), t.addEventListener("mouseout", function () {
        t.removeLegendState("hover");
      }), t.getId();
    }, t.prototype.getItem = function (e) {
      var t = this.getChildren().legendItem;
      if (void 0 === e) return !1;
      if (t) for (var n = 0; n < t.length; n++) {
        if (t[n].getId() === e) return t[n];
      }
    }, t.prototype.getSortedLegendItems = function () {
      var e,
          t = this.getChildren("legendItem") || [],
          n = this.config.reverselegend,
          a = {},
          i = [],
          o = void 0;

      for (o = 0, e = t.length; o < e; o++) {
        void 0 === t[o].config.index ? a[e + o] = t[o] : a[t[o].config.index] = t[o];
      }

      return Object.keys(a).sort(function (e, t) {
        return n ? t - e : e - t;
      }).forEach(function (e) {
        i.push(a[e]);
      }), i;
    }, t.prototype.disposeItem = function (e) {
      var t = this.getItem(e);
      t && t.remove();
    }, t.prototype.getName = function () {
      return "legend";
    }, t.prototype.getType = function () {
      return "legend";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this);

      var t = this.config;
      t.enabled = !0, t.symbolWidth = 12, t.borderRadius = 1, t.lastScrollPos = 0, t.oriSymbolPadding = 3, t.textPadding = 4, t.scrollY = 0, t.backgroundColor = "#FFFFFF", t.initialItemX = 0, t.title = {
        text: a.BLANKSTRING,
        x: 0,
        y: 0,
        padding: 2
      }, t.scroll = {}, t.itemStyle = {};
    }, t.prototype.createLegendGroup = function () {
      var e,
          t = this.config,
          n = this.getFromEnv("chart"),
          a = n.config,
          i = this.getFromEnv("animationManager"),
          o = .5 * (t.borderWidth || 0) + 2,
          r = this.getContainer("legendGroup");
      t.xL && (t.xL = f(g(t.xL, o), a.width - t.width - o)), t.yL && (t.yL = f(g(t.yL, o), a.height - t.height - o)), e = i.setAnimation({
        el: r || "group",
        attr: {
          name: "legendGroup",
          transform: ["T", t.xL || t.xPos, t.yL || t.yPos]
        },
        container: n.getChildContainer("legendGroup"),
        component: this
      }), r || this.addContainer("legendGroup", e);
    }, t.prototype.draw = function () {
      this.createLegendGroup(), this.drawLegendBox(), this.createItemGroup(), this.drawCaption(), this.createScrollGroup(), this.decideScroll();
    }, t.prototype.decideScroll = function () {
      var e = this.config;
      e.scroll.enabled ? this.createScrollBar() : e.hasScroll && (this.getChildren("legendScrollBar")[0].remove(), e.hasScroll = !1);
    }, t.prototype.createItemGroup = function () {
      var e,
          t = this.getFromEnv("animationManager"),
          n = this.getContainer("legendGroup"),
          i = this.getChildContainer("itemGroup"),
          o = (0, a.pluckNumber)(this.config.padding, 4),
          r = .5 * o,
          l = Math.max(this.config.height - o, 0),
          s = "," + this.config.width + "," + l;
      return e = t.setAnimation({
        el: i || "group",
        attr: {
          name: "item",
          transform: ["T", 0, this.config.scrollY || 0]
        },
        container: n,
        component: this
      }), i || this.addChildContainer("itemGroup", e), this.config.scroll.enabled ? e.attr({
        "clip-rect": "0," + r + s
      }) : e.attr({
        "clip-rect": null
      }), e;
    }, t.prototype.createScrollGroup = function () {
      var e = this.getFromEnv("animationManager"),
          t = this.getChildContainer("scrollGroup"),
          n = this.getContainer("legendGroup");
      this.config.scroll.enabled && !this.getGraphicalElement("scrollerContainer") && this.addGraphicalElement("scrollerContainer", e.setAnimation({
        el: t || "group",
        attr: {
          name: "scrollGroup"
        },
        container: n,
        component: this,
        label: "scroller"
      }));
    }, t.prototype.createScrollBar = function () {
      var e,
          t,
          n,
          i,
          o,
          r,
          s = this,
          u = s.config,
          h = s.getFromEnv("chart-attrib"),
          d = s.getChildren("legendScrollBar") && s.getChildren("legendScrollBar")[0],
          p = u.borderWidth || 0,
          f = .5 * p,
          g = (0, a.pluckNumber)(u.padding, 4),
          m = .5 * g,
          b = u.width,
          v = u.height;
      e = {
        conf: {
          isHorizontal: !1
        },
        handler: {
          scroll: function scroll(e) {
            u.lastScrollPos = e, u.scrollY = (n - u.totalHeight) * e, s.addJob("scrollDraw", s.drawScroll, c.priorityList && c.priorityList.draw);
          },
          mousedown: function mousedown(e) {
            e.preventDefault(), e.stopPropagation();
          }
        }
      }, h.legendscrollbgcolor && (e.conf.color = (0, a.convertColor)(h.legendscrollbgcolor)), d || (d = s.attachChild(new l.Scroller(), "legendScrollBar"), this.config.hasScroll = !0), d.configure(e.conf), d.attachEventHandlers(e.handler), t = d.config, n = Math.max(v - g, 0), i = b - 10 + m - p, o = f, r = Math.max(v - p, 0), t.scrollRatio = (n + g) / u.totalHeight, t.startPercent = 0, t.scrollPosition = u.lastScrollPos, t.parentLayer = s.getChildContainer("scrollGroup"), d.setDimension({
        x: i,
        y: o,
        height: r
      });
    }, t.prototype.drawCaption = function () {
      var e,
          t,
          n,
          i,
          o = this.getChildContainer("itemGroup"),
          r = this.getGraphicalElement("caption"),
          l = this.getFromEnv("animationManager"),
          s = this.config,
          c = (0, a.pluckNumber)(s.padding, 4),
          u = s.scroll.enabled,
          h = s.width;

      if (s.title && s.title.text !== a.BLANKSTRING && s.validLegendItem) {
        switch (s.title.align) {
          case a.POSITION_START:
            n = c;
            break;

          case a.POSITION_END:
            n = h - c - (u ? 10 : 0);
            break;

          default:
            n = .5 * h;
        }

        t = s.title.style, e = {
          text: s.title.text,
          title: s.title.originalText || a.BLANKSTRING,
          x: n,
          y: c,
          fill: s.title.style.color,
          direction: s.textDirection,
          "line-height": t.lineHeight,
          "vertical-align": a.POSITION_TOP,
          "text-anchor": s.title.align,
          opacity: 1
        }, i = {
          "font-weight": t.fontWeight,
          "font-style": t.fontStyle,
          "font-family": t.fontFamily,
          "font-size": t.fontSize
        }, r && r.show(), r ? l.setAnimation({
          el: r,
          attr: e,
          component: this
        }) : (r = l.setAnimation({
          el: "text",
          attr: e,
          component: this,
          container: o
        }), (r = this.addGraphicalElement("caption", r)).css(i)), this.getFromEnv("toolTipController").enableToolTip(r, s.title.originalText);
      } else r && l.setAnimation({
        el: r,
        component: this,
        doNotRemove: !0,
        callback: function callback() {
          r.hide();
        }
      });
    }, t.prototype.drawLegendBox = function () {
      var e,
          t = this.getFromEnv("animationManager"),
          n = this.config,
          a = this.getContainer("legendGroup"),
          i = n.width,
          o = this.getGraphicalElement("box"),
          r = n.height,
          l = n.borderRadius,
          s = n.backgroundColor,
          c = n.borderColor,
          u = n.borderAlpha,
          h = n.backgroundAlpha,
          d = n.borderWidth || 0;
      return e = t.setAnimation({
        el: o || "rect",
        attr: {
          x: 0,
          y: 0,
          width: i,
          height: r,
          r: l,
          stroke: c,
          "stroke-width": d,
          fill: s || "none",
          "stroke-opacity": u / 100,
          "fill-opacity": h / 100,
          cursor: n.legendAllowDrag ? "move" : "default"
        },
        container: a,
        component: this,
        label: "legendGroup"
      }), o || (this.addGraphicalElement("box", e), e.shadow(n.shadow)), e;
    }, t.prototype.getPosition = function () {
      var e,
          t,
          n,
          i,
          o,
          r = this.getFromEnv("chart").config,
          l = this.config,
          s = r.height - r.canvasBottom,
          c = r.canvasLeft,
          u = r.canvasWidth,
          h = l.chartMarginLeft || 0,
          d = l.chartMarginRight || 0,
          p = l.chartMarginBottom || 0,
          f = r.actionBarHeight || 0,
          g = l.actualCanvasMarginLeft || 0,
          m = r.actualCanvasMarginBottom || 0,
          b = r.actualCanvasMarginRight || 0,
          v = l.alignLegendWithCanvas,
          y = r.height,
          x = r.canvasTop,
          C = l.width || 0,
          k = l.height || 0,
          w = r.borderWidth,
          S = r.oriCanvasLeft,
          _ = r.oriTopSpace,
          L = r.oriBottomSpace,
          P = 0,
          A = l.borderWidth || 0;
      return l.legendPos === a.POSITION_RIGHT && (l.align = a.POSITION_RIGHT, l.verticalAlign = a.POSITION_MIDDLE, o = l.layout = "vertical"), o ? (e = r.width - d - b - C - w, t = (P = (0, a.pluckNumber)(_, x)) + .5 * (y - (0, a.pluckNumber)(L, s) - P - k) + (l.y || 0)) : (n = r.width - (h + g + (d + b)), i = v ? u - C : n - C, e = (v ? (0, a.pluckNumber)(S, c) : h + g) + i / 2, t = y - k - m - p - f), (0, a.crispBound)(e, t, C, k, A);
    }, t.prototype.setTranslation = function (e, t) {
      var n = this.config;
      n._translateX = e, n._translateY = t, n.translate = "t" + e + "," + t;
    }, t.prototype.allocatePosition = function () {
      var e,
          t = this.config;
      e = t.translate ? (0, a.crispBound)(t._translateX, t._translateY, t.width, t.height, t.borderWidth) : this.getPosition(), t.xPos = e.x, t.yPos = e.y, t.width = e.width, t.height = e.height;
    }, t.prototype._manageLegendPosition = function (e) {
      var t = this.config,
          n = t.legendPos;
      return t.padding = 4, t.textPadding = 4, n === a.POSITION_RIGHT ? this._placeLegendBlockRight(e) : this._placeLegendBlockBottom(e);
    }, t.prototype.setDimension = function (e) {
      var t,
          n,
          i,
          o,
          r = this.config,
          l = this.getSortedLegendItems(),
          s = l.length,
          c = e.width,
          u = e.height,
          h = 2 * u,
          d = void 0,
          p = void 0,
          v = void 0,
          y = void 0,
          x = 0,
          C = 0,
          k = 0,
          w = 0,
          S = 0,
          _ = 0,
          L = 0,
          P = 0,
          A = [],
          N = !1,
          E = r.padding,
          F = r.textPadding,
          O = this.getFromEnv("smartLabel"),
          T = this.getStateCosmetics("default"),
          D = parseInt(T.text["font-size"], 10) || 10,
          M = 0,
          I = 0,
          R = void 0,
          V = void 0,
          B = void 0,
          j = void 0,
          G = void 0,
          H = r.title,
          z = H.padding,
          W = void 0,
          q = r.minimiseWrappingInLegend,
          U = r.legendPadding,
          Y = r.legendScale,
          X = r.alignLegendWithCanvas,
          K = r.numColumns,
          Z = r.oriSymbolPadding,
          J = void 0,
          $ = void 0,
          Q = void 0,
          ee = void 0,
          te = void 0,
          ne = void 0,
          ae = void 0,
          ie = void 0,
          oe = void 0,
          re = void 0,
          le = c;

      for ($ = {
        width: 2 * E,
        height: 2 * E
      }, (J = D + 1) <= 0 && (J = 1), Z *= Y, (J = f(J *= Y, c -= 2 * E)) <= 0 && (Z = J = 0), r.symbolWidth = J, r.textPadding = 4, r.legendHeight = n = J + 2 * Z, r.rowHeight = R = g(parseInt(T.text["line-height"], 10) || 12, n), t = F + Z + E, O.setStyle((0, a.extend2)({}, T.text)), i = O.getOriSize(a.TESTSTR).height, V = U + r.borderWidth / 2 + 1, V = f(V, u - i - 8), U = .05 * R, r.initialItemY = 0, r.initialItemX = 0, Q = 0; Q < s; Q += 1) {
        p = d = (y = l[Q]).config || (y.config = {}), (v = d.name = (0, a.parseUnsafeString)(p.label)) === a.BLANKSTRING || 0 === p.enabled || !1 === p.enabled || y.getState("removed") ? d.enabled = 0 : (d.enabled = 1, k += 1, ie = !0, oe = O.getOriSize(v), x = g(x, oe.width), _ = g(_, f(oe.height, h)), C += oe.width);
      }

      if (r.validLegendItem = ie, w = C / k, C += (o = n + U + F + Z + 2 * E) * k, r.x = !X && C > le ? 0 : r.x, ie) {
        for (w += o, x += o, K > 0 && k < K && (K = k), C <= c && (K <= 0 || K === k) ? (K = k, S = w = C / k, N = !0, _ > R && (P = (_ - R) / 2, R = _)) : K > 0 && (S = c / K) > w ? S > x && (S = x) : c > x && (q || 1.5 * w > x) ? (k < (K = m(c / x)) && (K = k), S = x) : c >= 2 * w ? (k < (K = m(c / w)) && (K = k), (S = m(c / K)) > x && (S = x)) : (K = 1, S = c), r.itemWidth = S, (B = b(S - o)) < 0 && (Z = B = F = 0), r.symbolPadding = Z, r.textPadding = F, r.width = S * K - U, H.oriText !== a.BLANKSTRING && (O.setStyle(H.style), oe = O.getSmartText(H.oriText, c, h), H.text = oe.text, oe.tooltext && (H.originalText = oe.tooltext), W = oe.width + 2 * E, r.width < W && (r.initialItemX = (W - r.width) / 2, r.width = W), r.initialItemY = L = oe.height + z), O.setStyle((0, a.extend2)({}, T.text)), Q = 0; Q < s; Q += 1) {
          if (0 !== (d = (y = l[Q]).config).enabled) {
            if (0 === B && (A[I] = !0, d.name = a.BLANKSTRING, ee = 1, ne = parseInt(I / K, 10), te = I % K, d._legendX = te * S, d._legendY = ne * R + 2 * E, d._legendH = ee * R, d._totalWidth = J + Z), N) (oe = O.getOriSize(d.name)).height < R && (d._legendTestY = (R - oe.height) / 2), d._markerYGutter = P, d._legendX = M, d._legendY = 2 * E, d._legendH = R, d._totalWidth = J + t + oe.width, M += oe.width + o;else {
              for (oe = O.getSmartText(d.name, B, h), d.name = oe.text, oe.tooltext && (d.originalText = oe.tooltext); !0 === A[I];) {
                I += 1;
              }

              for (j = oe.height / R, G = I, ee = 0; ee < j; ee += 1, G += K) {
                A[G] = !0;
              }

              oe.height < R && (d._legendTestY = (R - oe.height) / 2), ne = parseInt(I / K, 10), te = I % K, d._legendX = te * S, d._legendY = ne * R + 2 * E, d._legendH = ee * R, d._totalWidth = J + t + oe.width;
            }
            I++;
          }
        }

        ae = N ? 1 : b(A.length / K), $.height += ae * R + L, r.height = r.totalHeight = $.height, r.rowHeight = R, r.legendNumColumns = K, r.height - 2 * Z > u ? (r.height = u, (re = r.scroll || (r.scroll = {})).enabled = !0, re.flatScrollBars = r.flatScrollBars, re.scrollBar3DLighting = r.scrollBar3DLighting, r.width = r.width + 12 > c ? r.width : r.width + 12) : r.scroll.enabled = !1, V += r.height, r.isActive = !0, r.enabled = !0;
      } else r.enabled = !1, r.width = 0, V = 0;

      return {
        width: c,
        height: V
      };
    }, t.prototype._placeLegendBlockBottom = function (e) {
      var t,
          n,
          i,
          o,
          r,
          l = this.getFromEnv("chart"),
          s = l.config,
          c = l.getFromEnv("chartWidth"),
          u = l.getFromEnv("chartHeight"),
          h = s.canvasLeft,
          d = s.width - (s.canvasRight || 0),
          p = l.getFromEnv("smartLabel"),
          f = this.config,
          g = f.chartMarginLeft,
          m = f.chartMarginRight,
          b = f.chartMarginTop,
          v = f.alignLegendWithCanvas,
          y = this.getSortedLegendItems().length,
          x = f.legendPadding,
          C = s.canvasMarginRight,
          k = s.canvasMarginLeft,
          w = l.getChildren("yAxis"),
          S = w && w[0].config.isVertical ? w : l.getChildren("xAxis"),
          _ = S && S[0],
          L = S && S[1],
          P = _ && _.config || {},
          A = L && L.config || {},
          N = P.nameMaxW,
          E = A.nameMaxW,
          F = P.name && P.name.style || {},
          O = A.name && A.name.style || {},
          T = P.axisName || a.BLANKSTRING,
          D = A.axisName || a.BLANKSTRING,
          M = s.canvasWidth - s.canvasMarginLeft - s.canvasMarginRight;

      return f.paddingBottom = s.height - s.canvasBottom, p.useEllipsesOnOverflow(s.useEllipsesWhenOverflow), p.setStyle(F), o = p.getOriSize(T), p.setStyle(O), r = p.getOriSize(D), M < x && (f.padding = x = M = 0), (o || r) && (n = (0, a.pluckNumber)(o.height, 0) > (0, a.pluckNumber)(r.height, 0) ? (i = N) && o.width : (i = E) && r.width), M = v ? M : c - (n + b > u - e ? 2 * i + m + g + C + k : m + g + k + C), f.showLegend && 0 !== y ? (f.x = (h - g - d + m) / 2, t = this.setDimension({
        width: M,
        height: e
      }).height) : (t = 0, f.height = 0, f.width = 0), {
        bottom: t,
        right: 0
      };
    }, t.prototype._placeLegendBlockRight = function (e) {
      var t,
          n,
          i,
          o,
          r,
          l,
          s,
          c,
          u,
          h,
          d = this.config,
          p = this.getFromEnv("chart"),
          m = p.config,
          b = p.getFromEnv("smartLabel"),
          v = p.getChildren("canvas")[0].config.canvasBorderThickness || 0,
          y = d.textPadding,
          x = d.title.padding,
          C = d.oriSymbolPadding,
          k = d.legendPadding,
          w = d.legendScale,
          S = this.getStateCosmetics("default"),
          _ = parseInt(S.text["font-size"], 10),
          L = 2 * m.canvasHeight,
          P = 0,
          A = 2 * d.padding,
          N = {
        width: A,
        height: A
      },
          E = {},
          F = !1,
          O = this.getSortedLegendItems(),
          T = O.length,
          D = 0;

      if (d.initialItemY = 0, d.initialItemX = 0, (e -= A + k) < k && (d.padding = k = e = 0), (o = _ + 1) <= 0 && (o = 1), C *= w, (o = f(o *= w, e)) <= 0 && (C = o = 0), d.symbolPadding = C, d.symbolWidth = o, d.legendHeight = r = o + 2 * C, d.rowHeight = g(parseInt(S.text["line-height"], 10) || 12, r), t = k + d.borderWidth / 2 + v, (i = e - r - k - y) < 0 && (i = 0), b.useEllipsesOnOverflow(m.useEllipsesWhenOverflow), b.setStyle((0, a.extend2)({}, S.text)), d.showLegend && 0 !== T) {
        for (D = 0; D < T; D += 1) {
          u = l = (h = O[D]).config || (h.config = {}), s = l.name = (0, a.parseUnsafeString)(u.label), l._legendX = 0, l._legendY = N.height, 0 !== u.enabled && !1 !== u.enabled && s !== a.BLANKSTRING ? (l.enabled = 1, F = !0, 0 === i ? (N.height += l._legendH = r, l.name = a.BLANKSTRING, l._totalWidth = o + C) : (n = b.getSmartText(s, i, L), l.name = n.text, n.tooltext && (l.originalText = n.tooltext), n.height < r && (l._legendTestY = (r - n.height) / 2), l._totalWidth = o + C + y + n.width + k, N.height += l._legendH = g(n.height, r), P = g(n.width, P))) : l.enabled = 0;
        }

        d.validLegendItem = F, F ? (d.itemWidth = P + r + k + y, d.width = d.itemWidth + A, d.title.oriText !== a.BLANKSTRING && (b.setStyle(d.title.style), n = b.getSmartText(d.title.oriText, e, L), d.title.text = n.text, n.tooltext && (d.title.originalText = n.tooltext), c = n.width + A, d.width < c && (d.initialItemX = (c - d.width) / 2, d.width = c), d.initialItemY = n.height + x, N.height += d.initialItemY), d.height = d.totalHeight = N.height, t = f(d.width + t, e), E.right = t + k, d.isActive = !0, d.enabled = !0) : (d.enabled = !1, d.width = 0, E.right = 0);
      } else E.right = 0, d.height = 0, d.width = 0;

      return E;
    }, t.prototype.postSpaceManager = function () {
      var e = this.config,
          t = e.legendPos,
          n = this.getFromEnv("chart").config.canvasHeight;
      t === a.POSITION_RIGHT && (e.height > n ? (e.height = n, e.scroll.enabled = !0, e.scroll.flatScrollBars = e.flatScrollBars, e.scroll.scrollBar3DLighting = e.scrollBar3DLighting, e.width += (e.scroll.scrollBarWidth = 10) + (e.scroll.scrollBarPadding = 2)) : e.scroll.enabled = !1);
    }, t.prototype.configureAttributes = function () {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      e.prototype.configureAttributes.call(this, t);

      var n,
          i,
          o,
          r,
          l,
          s = this.config,
          c = this.getFromEnv("chart"),
          u = c.config,
          h = this.getFromEnv("style"),
          p = c.getFromEnv("chart-attrib"),
          f = c.config.is3D,
          m = this.getFromEnv("color-manager"),
          b = f ? a.chartPaletteStr.chart3D : a.chartPaletteStr.chart2D,
          v = s.interactiveLegend = !1 !== c.hasInteractiveLegend && Boolean((0, a.pluckNumber)(p.interactivelegend, 1)),
          x = (0, a.pluckNumber)(p.useroundedges, 0),
          C = h.outCancolor,
          k = t.style && t.style.text,
          w = (0, a.pluck)(p.legenditemfont, k && k["font-family"], h.outCanfontFamily),
          S = (0, a.pluckNumber)(p.legendiconscale, 1),
          _ = (0, a.pluckFontSize)(p.legenditemfontsize, k && k["font-size"], h.fontSize) + "px",
          L = (0, a.pluck)(p.legenditemfontcolor, k && k.color, C).replace(/^#?([a-f0-9]+)/gi, "#$1"),
          P = (0, a.getFirstColor)((0, a.pluck)(p.legenditemhoverfontcolor, L));

      s.isActive = !1, s.chartMarginTop = u.origMarginTop, s.chartMarginRight = u.origMarginRight, s.chartMarginBottom = u.origMarginBottom, s.chartMarginLeft = u.origMarginLeft, s.reverselegend = (0, a.pluckNumber)(p.reverselegend, 0), s.showLegend = (0, a.pluckNumber)(p.showlegend, !c.dontShowLegendByDefault, 1), n = (0, a.setLineHeight)({
        fontSize: _
      }), s.legendPos = (0, a.pluck)(p.legendposition, c.legendposition, t.legendPosition, a.POSITION_BOTTOM).toLowerCase(), s.numColumns = (0, a.pluckNumber)(p.legendnumcolumns, 0), s.xL = s.yL = 0, (S <= 0 || S > 5) && (S = 1), s.drawCustomLegendIcon = (0, a.pluckNumber)(p.drawcustomlegendicon, t.drawcustomlegendicon, 0), s.legendScale = S, s.legendPadding = (0, a.pluckNumber)(p.legendpadding, 7), s.alignLegendWithCanvas = (0, a.pluckNumber)(t.alignlegendwithcanvas, u.alignLegendWithCanvas), s.title.style = {
        fontFamily: (0, a.pluck)(p.legendcaptionfont, w),
        fontSize: (0, a.pluckFontSize)(p.legendcaptionfontsize, h.fontSize) + "px",
        color: (0, a.pluck)(p.legendcaptionfontcolor, C).replace(/^#?([a-f0-9]+)/gi, "#$1"),
        fontWeight: y.fontWeight[(0, a.pluckNumber)(p.legendcaptionfontbold, 1)] || a.BLANKSTRING
      }, l = p.legendcaptionalignment ? p.legendcaptionalignment.toLowerCase() : d.center, s.title.align = d[l] || d.center, s.title.style["text-anchor"] = s.title.align, s.padding = 4, i = (0, a.pluck)(p.legendbordercolor, m.getColor(b.legendBorderColor)), o = s.borderAlpha = (0, a.pluckNumber)(p.legendborderalpha, 100), s.borderColor = (0, a.convertColor)(i, o), s.borderWidth = (0, a.pluckNumber)(p.legendborderthickness, t.legendborderthickness, !x || p.legendbordercolor ? 1 : 0), s.borderRadius = (0, a.pluckNumber)(x, 0), s.backgroundAlpha = r = (0, a.pluckNumber)(p.legendbgalpha, t.legendbgalpha, 100), s.backgroundColor = (0, a.convertColor)((0, a.pluck)(p.legendbgcolor, m.getColor(b.legendBgColor)), r), s.symbol3DLighting = Boolean((0, a.pluckNumber)(p.use3dlighting, p.useplotgradientcolor, 1)), s.shadow = Boolean((0, a.pluckNumber)(p.legendshadow, 1)), s.shadow && (s.shadow = {
        enabled: s.shadow,
        opacity: g(o, r) / 100
      }), s.prevReversed = Boolean((0, a.pluckNumber)(s.reversed, 0)), s.reversed = Boolean((0, a.pluckNumber)(p.reverselegend, 0)), s.lineWidth = (0, a.pluckNumber)(p.linethickness, 2), s.borderRadius = (0, a.pluckNumber)(p.legendborderradius, x ? 3 : 0), s.legendAllowDrag = Boolean((0, a.pluckNumber)(p.legendallowdrag, 0)), s.title.oriText = (0, a.parseUnsafeString)((0, a.getFirstValue)(p.legendcaption, a.BLANKSTRING)), s.legendScrollBgColor = (0, a.getFirstColor)((0, a.pluck)(p.legendscrollbgcolor, p.scrollcolor, m.getColor("altHGridColor"))), s.legendScrollBarColor = (0, a.pluck)(p.legendscrollbarcolor, i), s.legendScrollBtnColor = (0, a.pluck)(p.legendscrollbtncolor, i), s.minimiseWrappingInLegend = (0, a.pluckNumber)(p.minimisewrappinginlegend, 0), s.flatScrollBars = (0, a.pluckNumber)(p.flatscrollbars, 0), s.scrollBar3DLighting = (0, a.pluckNumber)(p.scrollbar3dlighting, 1), s.orderReversed = !1, this.setStateCosmetics("hidden", {
        symbol: {
          fill: (0, a.convertColor)((0, a.pluck)(p.legenditemhiddencolor, "cccccc").replace(/^#?([a-f0-9]+)/gi, "#$1")),
          stroke: (0, a.convertColor)((0, a.pluck)(p.legenditemhiddencolor, "cccccc").replace(/^#?([a-f0-9]+)/gi, "#$1"))
        },
        text: {
          fill: (0, a.convertColor)((0, a.pluck)(p.legenditemhiddencolor, "cccccc").replace(/^#?([a-f0-9]+)/gi, "#$1"))
        }
      }), this.setStateCosmetics("default", {
        text: {
          fill: (0, a.convertColor)(L),
          "font-family": w,
          cursor: v ? a.preDefStr.POINTER : "default",
          "font-size": _,
          "line-height": n,
          "vertical-align": a.POSITION_TOP,
          "text-anchor": a.POSITION_START,
          direction: "rtl" === u.textDirection ? "rtl" : "initial",
          "font-weight": y.fontWeight[(0, a.pluckNumber)(p.legenditemfontbold, 0)] || a.BLANKSTRING
        },
        symbol: {
          bgColor: (0, a.pluck)(p.legendiconbgcolor),
          cursor: v ? a.preDefStr.POINTER : "default",
          borderColor: (0, a.pluck)(p.legendiconbordercolor),
          bgAlpha: (0, a.pluck)(p.legendiconbgalpha, p.legendiconalpha, 100),
          borderAlpha: (0, a.pluck)(p.legendiconborderalpha, p.legendiconalpha, 100),
          borderThickness: (0, a.pluckNumber)(p.legendiconborderthickness),
          startAngle: (0, a.pluckNumber)(p.legendiconstartangle, 45),
          sides: (0, a.pluckNumber)(p.legendiconsides, t.legendiconsides, 4)
        }
      }), this.setStateCosmetics("hover", function (e, t) {
        return t.hasState("hidden") || (e.text || (e.text = {}), e.text.fill = (0, a.convertColor)(P.replace(/^#?([a-f0-9]+)/gi, "#$1")), e.text.cursor = "inherit"), e;
      }), s.legendAllowDrag && !s._dragEvtListenerBinded ? (this.addEventListener("fc-dragstart", s.handlers.dragstart), this.addEventListener("fc-dragmove", s.handlers.dragmove), s._dragEvtListenerBinded = !0) : (this.removeEventListener("fc-dragstart", s.handlers.dragstart), this.removeEventListener("fc-dragmove", s.handlers.dragmove), s._dragEvtListenerBinded = !1);
    }, t.prototype.getLegendState = function () {
      return this._legendState;
    }, t.prototype.hasState = function (e) {
      var t,
          n,
          a = this.getLegendState();

      for (t = 0, n = a.length; t < n; t++) {
        if (a[t] === e) return !0;
      }

      return !1;
    }, t.prototype.setLegendState = function (e, t) {
      this.hasState(e) || (t ? this._legendState.push(e) : this._legendState.unshift(e)), this.asyncDraw();
    }, t.prototype.removeLegendState = function (e) {
      var t,
          n,
          a = 1;
      if (e) for (t = 0, n = this._legendState.length; t < n && a; t++) {
        e === this._legendState[t] && (this._legendState.splice(t, 1), a = 0);
      } else this._legendState.length = 0;
      this.asyncDraw();
    }, t.prototype.setStateCosmetics = function (e, t) {
      this._stateCosmetics[e] = t;
    }, t.prototype.removeStateCosmetics = function (e) {
      delete this._stateCosmetics[e];
    }, t.prototype.getStateCosmetics = function (e) {
      return this._stateCosmetics[e];
    }, t.prototype.hide = function () {
      var e = this.getFromEnv("chart").getChildContainer("legendGroup");
      e && e.hide();
    }, t;
  }(i.ComponentInterface);

  t["default"] = C;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      o = n(125),
      r = n(138),
      l = n(132),
      s = n(465),
      c = (a = s) && a.__esModule ? a : {
    "default": a
  };

  function u(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var h = o.preDefStr.POINTER,
      d = "M",
      p = "L",
      f = function f(e, t) {
    var n = e.config,
        a = e.getLinkedParent().config,
        i = a.symbolWidth,
        r = (0, o.pluckNumber)(a.padding, 4),
        l = .5 * i,
        s = (a.initialItemX || 0) + n._legendX + r,
        c = (a.initialItemY || 0) + n._legendY - r,
        u = s + a.symbolPadding + l,
        d = c + (n._markerYGutter || 0) + a.symbolPadding + l,
        p = (0, o.mapSymbolName)(n.anchorSide),
        f = n.symbol = p && p.split("_") || [],
        g = "spoke" === f[0] ? 1 : 0;
    return ("line" === n.type || n.drawLine) && (l *= .6), {
      path: (0, o.polyPathToPath)([f[1] || 2, u, d, l, n.startAngle, n.spoke || g]),
      cursor: t.cursor || h,
      stroke: t.stroke,
      fill: t.fill,
      "stroke-width": t["stroke-width"] || .5
    };
  };

  (0, l.addDep)({
    name: "legendItemAnimation",
    type: "animationRule",
    extension: c["default"]
  });

  var g = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n._stateCosmetics = {}, n._legendState = [], n;
    }

    return u(t, e), t.prototype.getName = function () {
      return "legendItem";
    }, t.prototype.parseLegendCosmetics = function () {
      var e = this.getLinkedParent(),
          t = e.getLegendState(),
          n = this.getLegendState(),
          a = void 0,
          i = void 0,
          r = ["default"],
          l = {},
          s = void 0;

      for (r = r.concat(t, n), s = 0; s < r.length; s++) {
        a = e.getStateCosmetics(r[s]), i = this.getStateCosmetics(r[s]), a && ("function" == typeof a ? l = a(l, this) : (0, o.extend2)(l, a)), i && ("function" == typeof i ? l = i(l, this) : (0, o.extend2)(l, i));
      }

      return l;
    }, t.prototype.getType = function () {
      return "legendItem";
    }, t.prototype.configure = function (e) {
      var t,
          n,
          a = this.config;

      for (t in e) {
        if (e.hasOwnProperty(t)) if ("object" !== i(e[t])) a[t] = e[t];else {
          var o = a[t] ? a[t] : {};

          for (n in e[t]) {
            o[n] = e[t][n];
          }

          a[t] = o;
        }
      }
    }, t.prototype.itemClickFn = function () {
      var e = this.getFromEnv("chart-attrib"),
          t = (0, o.pluckNumber)(e.interactivelegend, 1),
          n = this.getLinkedItem("owner");
      t && n.legendInteractivity(this);
    }, t.prototype.dispose = function () {
      this.removeEventListener("fc-click", this.click), this.removeEventListener("fc-mouseover", this.mouseover), this._dispose();
    }, t.prototype.getLegendState = function () {
      return this._legendState;
    }, t.prototype.hasState = function (e) {
      var t,
          n,
          a = this.getLegendState();

      for (t = 0, n = a.length; t < n; t++) {
        if (a[t] === e) return !0;
      }

      return !1;
    }, t.prototype.setLegendState = function (e, t) {
      this.hasState(e) || (t ? this._legendState.push(e) : this._legendState.unshift(e)), this.asyncDraw();
    }, t.prototype.removeLegendState = function (e) {
      var t,
          n,
          a = 1;
      if (e) for (t = 0, n = this._legendState.length; t < n && a; t++) {
        e === this._legendState[t] && (this._legendState.splice(t, 1), a = 0);
      } else this._legendState.length = 0;
      this.asyncDraw();
    }, t.prototype.removeStateCosmetics = function (e) {
      delete this._stateCosmetics[e];
    }, t.prototype.setStateCosmetics = function (e, t) {
      this._stateCosmetics[e] = t;
    }, t.prototype.getStateCosmetics = function (e) {
      return this._stateCosmetics[e];
    }, t.prototype.draw = function () {
      var e,
          t,
          n,
          a,
          i,
          r,
          l,
          s,
          c,
          u,
          g,
          m,
          b,
          v,
          y,
          x,
          C,
          k,
          w,
          S,
          _,
          L,
          P,
          A,
          N,
          E,
          F,
          O,
          T,
          D,
          M,
          I,
          R,
          V,
          B,
          j,
          G,
          H,
          z = this.getLinkedParent(),
          W = z.getFromEnv("chart").config,
          q = this.getFromEnv("animationManager"),
          U = this.config,
          Y = z.config,
          X = Y.legendHeight,
          K = Y.symbolPadding,
          Z = Y.symbolWidth,
          J = Y.interactiveLegend,
          $ = Y.textPadding || 2,
          Q = (0, o.pluckNumber)(Y.padding, 4),
          ee = Y.itemHoverStyle,
          te = z.getChildContainer("itemGroup"),
          ne = Y.drawCustomLegendIcon,
          ae = this.hasState("hidden"),
          ie = {};

      n = (e = this.parseLegendCosmetics()).symbol, a = Y.initialItemX || 0, i = Y.initialItemY || 0, c = U.type, w = e.symbol.stroke || "000000", S = e.symbol.fill, t = e.symbol.lineWidth || Y.lineWidth, L = U.anchorSide, P = U.drawLine, u = a + U._legendX + Q, g = i + U._legendY - Q, M = this.getGraphicalElement("legendItemBackground"), s = this.getGraphicalElement("legendItemText"), m = this.getGraphicalElement("legendItemLine"), v = this.getGraphicalElement("legendItemSymbol"), !(J = (0, o.pluck)(U.interactiveLegend, J)) && (e.cursor = "default"), I = e.text, G = u + X + $ - 2, H = g + (U._legendTestY || 0), I.text = U.name, I.x = G, I.y = H, l = q.setAnimation({
        el: s || "text",
        attr: I,
        component: this,
        container: te,
        label: "icon"
      }), s || (l = this.addGraphicalElement("legendItemText", l)), l.data("legendItem", U), R = !1, ne && !1 !== U.customLegendIcon ? (E = !ae && n.borderColor, F = (0, o.pluck)(n.borderAlpha), A = !ae && n.bgColor, N = (0, o.pluck)(n.bgAlpha, "100"), O = e.symbol.rawFillColor, S = ae ? e.symbol.fill : A || O, S = (0, o.convertColor)(S, N), T = e.symbol.rawStrokeColor, w = ae ? e.symbol.stroke : E || T || O, w = (0, o.convertColor)(w, F), y = u + K + (x = .5 * Z), r = g + (U._markerYGutter || 0) + K + x, C = "spoke" === (k = (0, o.mapSymbolName)(n.sides) && (0, o.mapSymbolName)(n.sides).split("_") || [])[0] ? 1 : 0, V = {
        path: (0, o.polyPathToPath)([k[1] || 2, y, r, x, n.startAngle || 0, C]),
        cursor: e.symbol.cursor || h,
        stroke: w,
        fill: S,
        "stroke-width": (0, o.pluckNumber)(n.borderThickness, 1)
      }) : "line" === c || P ? (r = g + (U._markerYGutter || 0) + K + .5 * Z, j = {
        path: [d, u + K, r, p, u + K + Z, r]
      }, R = !0, ie = {
        opacity: W.legendiconalpha || 1,
        "stroke-width": t,
        stroke: w,
        cursor: e.cursor || h
      }, L && (V = f(this, e.symbol))) : L ? V = f(this, e.symbol) : "line" !== c && (w = U.symbolStroke || w, V = {
        path: function (e, t, n, a, i) {
          var o,
              r,
              l,
              s,
              c,
              u,
              h,
              f,
              g,
              m,
              b,
              v = [d],
              y = "Z";

          switch (i) {
            case "column":
            case "dragColumn":
            case "column3D":
            case "realtimeColumn":
            case "errorBar2D":
              r = .5 * (o = .25 * n), l = .7 * a, s = .4 * a, v = v.concat([e, t + a, "l", 0, -l, o, 0, 0, l, "z", "m", o + r, 0, "l", 0, -a, o, 0, 0, a, "z", "m", o + r, 0, "l", 0, -s, o, 0, 0, s, "z"]);
              break;

            case "bar2D":
            case "bar3D":
              o = .3 * n, r = .6 * n, s = (l = a / 4) / 2, v = v.concat([e, t, p, e + r, t, e + r, t + l, e, t + l, y, d, e, t + l + s, p, e + n, t + l + s, e + n, t + l + s + l, e, t + 2 * l + s, y, d, e, t + 2 * (l + s), p, e + o, t + 2 * (l + s), e + o, t + a, e, t + a, y]);
              break;

            case "area":
            case "area3d":
            case "areaspline":
            case "dragArea":
            case "realTimeArea":
            case "splinearea":
              o = .3 * n, r = .6 * n, l = .6 * a, s = .2 * a, c = .8 * a, v = v.concat([e, t + c, p, e, t + l, e + o, t + s, e + r, t + l, e + n, t + s, e + n, t + c, y]);
              break;

            case "pie2D":
            case "pie3d":
            case "doughnut2D":
            case "doughnut3D":
              r = .9 * (o = .5 * n), u = e + o + (m = 1), f = t + o - m, h = e + o - (b = 1), g = t + o + b, v = v.concat([u, f, p, u, f - r + m, "A", r - m, r - m, 0, 0, 1, u + r - m, f, y, d, h, g, p, h, g - r, "A", r, r, 0, 1, 0, h + r, g, y]);
              break;

            case "boxandwhisker2d":
              v = v.concat([e, t, p, e + n, t, e + n, t + a, e, t + a, y]);
              break;

            default:
              v = v.concat([e, t, p, e + n, t, e + n, t + a, e, t + a, y]);
          }

          return {
            path: v
          };
        }(u + K, g + (U._markerYGutter || 0) + K, Z, Z, c).path,
        "stroke-width": .5,
        stroke: w,
        fill: S,
        cursor: e.cursor || h
      }), j && R ? (Object.assign(j, ie), m = q.setAnimation({
        el: m || "path",
        attr: j,
        component: this,
        callback: function callback() {
          this.show();
        },
        container: te
      }), this.getGraphicalElement("legendItemLine") || (m = this.addGraphicalElement("legendItemLine", m))) : m && m.hide(), V ? (V.opacity = (0, o.pluckNumber)(e.symbol.opacity, 1), b = q.setAnimation({
        el: v || "path",
        attr: V,
        component: this,
        callback: function callback() {
          this.show();
        },
        container: te,
        label: "icon"
      }), v && v.node || (b = this.addGraphicalElement("legendItemSymbol", b)), b.data("legendItem", U)) : v && v.hide(), _ = e.background && e.background.legendBackgroundColor ? (0, o.convertColor)(e.background.legendBackgroundColor, e.background.alpha) : o.TRACKER_FILL, B = {
        x: u,
        y: g,
        width: U._totalWidth,
        height: U._legendH,
        r: 0,
        fill: _,
        opacity: 1,
        "stroke-width": 1,
        stroke: "none",
        cursor: e.symbol.cursor || h
      }, D = q.setAnimation({
        el: M || "rect",
        attr: B,
        css: void 0,
        component: this,
        label: "background",
        container: te
      }), M || this.addGraphicalElement("legendItemBackground", D), D.data("legendItem", this).data("interactive", J).data("itemHoverStyle", ee).data("itemStyle", e);
    }, t;
  }(r.ComponentInterface);

  t["default"] = g;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = {
    "*.legendItem.legendItem": function legendItemLegendItem() {
      return {
        "icon.appearing": function iconAppearing() {
          return [{
            initialAttr: {
              opacity: 0
            },
            slot: "plot",
            startEnd: {
              start: .5,
              end: 1
            },
            finalAttr: {
              opacity: 1
            }
          }];
        },
        "background.appearing": function backgroundAppearing(e) {
          return [{
            initialAttr: {
              opacity: 0
            },
            slot: "plot",
            startEnd: {
              start: .5,
              end: 1
            },
            finalAttr: {
              opacity: e.attr.opacity
            }
          }];
        },
        "icon.disappearing": function iconDisappearing() {
          return [{
            finalAttr: {
              opacity: 0
            },
            slot: "initial"
          }];
        }
      };
    }
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = [{
    initialAttr: {
      opacity: 0
    },
    finalAttr: {
      opacity: 1
    },
    slot: "plot"
  }],
      i = [{
    slot: "plot",
    startEnd: {
      start: 0,
      end: .5
    }
  }],
      o = [{
    slot: "intial"
  }];
  t["default"] = {
    "*.legend.legend": function legendLegend() {
      return {
        "legendGroup.appearing": a,
        "legendGroup.updating": i,
        "legendGroup.disappearing": o,
        "scroller.appearing": a,
        "scroller.updating": i,
        "scroller.disappearing": o
      };
    }
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.drawLabel = undefined;
  var a = l(n(432)),
      i = n(125),
      o = n(132),
      r = l(n(468));

  function l(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function s(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var c = i.preDefStr.visibleStr,
      u = i.preDefStr.hiddenStr,
      h = i.preDefStr.POSITION_MIDDLE,
      d = i.preDefStr.POSITION_START,
      p = i.preDefStr.POSITION_END,
      f = Math,
      g = f.min,
      m = f.max,
      b = function b() {
    var e,
        t,
        n,
        a,
        o,
        r,
        l,
        s,
        f,
        b,
        v,
        y,
        x,
        C,
        k,
        w,
        S,
        _,
        L,
        P,
        A,
        N,
        E,
        F,
        O = this.getFromEnv("chart"),
        T = O.config,
        D = this.config.JSONData,
        M = this.getFromEnv("animationManager"),
        I = O.getChildren("canvas")[0].config,
        R = O.config.dataLabelStyle,
        V = D.data,
        B = O.config.categories,
        j = O.config.is3D,
        G = O.config.isstacked,
        H = B && B.length,
        z = V && V.length,
        W = this.getData(),
        q = O.getFromEnv("smartLabel"),
        U = I.yDepth,
        Y = I.xDepth,
        X = O.getFromEnv("number-formatter"),
        K = "",
        Z = T.placevaluesinside,
        J = T.canvasWidth,
        $ = T.canvasLeft,
        Q = T.valuepadding + 2,
        ee = this.getContainer("labelGroup"),
        te = this.getSkippingInfo && this.getSkippingInfo(),
        ne = te && te.skippingApplied,
        ae = te && te.labelDraw || [],
        ie = ae.length,
        oe = this.getState("visible"),
        re = function re() {
      this.hide();
    };

    for (oe && ee.show(), q.setStyle(R), e = ne ? ie : H < z ? H : z, o = 0; o < e; o++) {
      w = (P = (t = W[a = ne ? ae[o] : o]) && t.config) && P.setValue, void 0 !== t && void 0 !== w && null !== w && !0 !== P.labelSkip ? (l = t.graphics) && (r = V[a], x = t._yPos, C = t._xPos, w = X.getCleanValue(r.value), y = (0, i.pluckNumber)(w) < 0, s = t._height, k = t._width, S = G ? h : y ? Z ? d : p : Z ? p : d, K = P.displayValue, N = l.label, P.showValue && void 0 !== (F = K) && null !== F && K !== i.BLANKSTRING && null !== w ? (n = {
        text: K,
        fill: R.color,
        "text-bound": [R.backgroundColor, R.borderColor, R.borderThickness, R.borderPadding, R.borderRadius, R.borderDash],
        "line-height": R.lineHeight,
        visibility: this.getState("visible") ? c : u
      }, _ = q.getOriSize(K).width, _ += Q, L = Q, f = x + .5 * s, b = C + (y ? 0 : k), v = y ? C - $ : $ + J - (C + k), G ? (b = m($ + .5 * _, b += .5 * (y ? k : -k)), b = g($ + J - .5 * _, b), b -= j ? Y : 0, f += j ? U : 0) : Z ? k >= _ ? (b += y ? L : -L, j && (f += U, b -= Y)) : _ < v ? (b += y ? -L : L, S = y ? p : d, j && y && (b -= Y)) : (y ? (b = C + k + m(_ - C - k + $, 0) - L, S = p) : (b = C - m(_ - ($ + J - C), 0) + L, S = d), j && (b -= Y, f += U)) : v >= _ ? (b += y ? -L : L, j && y && (b -= Y, f += Y)) : (b += y ? L + _ : -(L + _), j && (b -= Y, f += U)), (b > $ + J || b < $) && (b = $ + 4, S = d), n["text-anchor"] = S, n.x = b, n.y = f, n["text-bound"] = [R.backgroundColor, R.borderColor, R.borderThickness, R.borderPadding, R.borderRadius, R.borderDash], n.opacity = oe ? 1 : 0, A = M.setAnimation({
        el: N || "text",
        container: ee,
        component: this,
        attr: n,
        callback: !oe && re,
        label: "plotLabel"
      }), N || (l.label = A)) : l.label && (l.label = M.setAnimation({
        el: l.label,
        component: this
      }))) : ((E = t && t.graphics) && E.label && E.label.hide(), P && delete P.labelSkip);
    }

    this.config.labelDrawn = !0;
  };

  (0, o.addDep)({
    name: "barAnimation",
    type: "animationRule",
    extension: r["default"]
  });

  var v = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.apply(this, arguments));
    }

    return s(t, e), t.prototype.getType = function () {
      return "dataset";
    }, t.prototype.getName = function () {
      return "bar2D";
    }, t.prototype.drawLabel = function () {
      b.call(this);
    }, t;
  }(a["default"]);

  t.drawLabel = b, t["default"] = v;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(125);
  t["default"] = {
    "initial.dataset.bar2D": function initialDatasetBar2D() {
      var e = this,
          t = e.getFromEnv("chart"),
          n = t.config.yDepth || 0,
          i = e.getFromEnv("yAxis");
      return {
        "rect.appearing": function rectAppearing(o) {
          var r,
              l,
              s,
              c,
              u = i.getPixel(i.getAxisBase()) + (t.isBar ? -n : n),
              h = o.index,
              d = e.components.data[h],
              p = o.attr;
          return r = p.x, l = p.width, c = Math.sign(r + l / 2 - u), s = 1 === c ? r : r + l, d._posWRT0 = c, [{
            initialAttr: function initialAttr() {
              var e = {};
              return e.x = s, e.width = 0, e.opacity = 0, e;
            },
            finalAttr: {
              opacity: 1
            },
            startEnd: function startEnd() {
              var t = o.length;
              return a.animHelperFN.getTimeByValue(a.animHelperFN.animByWeight(h, t, .6), {
                startPx: u,
                endPx: 1 === c ? e.config.yAxisMaxPixel : e.config.yAxisMinPixel
              }, {
                startPx: s,
                endPx: 1 === c ? p.x + p.width : p.x
              });
            },
            hookFn: function hookFn() {
              this.attr({
                opacity: 1
              });
            },
            effect: "linear",
            slot: "plot"
          }];
        },
        "plotLabel.appearing": function plotLabelAppearing() {
          return [{
            initialAttr: {
              opacity: 0
            },
            slot: "final"
          }];
        },
        "*": null
      };
    }
  };
},,,,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.hideFn = t.plotClickHandler = t.labelClickFn = t.trimData = t.plotGraphicClick = undefined;
  var a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      i = h(n(450)),
      o = n(125),
      r = n(132),
      l = h(n(477)),
      s = h(n(216)),
      c = n(136),
      u = h(n(182));

  function h(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function d(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var p = (0, r.getDep)("redraphael", "plugin"),
      f = void 0,
      g = window,
      m = g.document,
      b = !o.hasSVG,
      v = "createTouch" in m,
      y = v && !(g.navigator.maxTouchPoints || g.navigator.msMaxTouchPoints),
      x = o.preDefStr.visibleStr,
      C = 8 === m.documentMode ? x : "",
      k = Math,
      w = k.atan2,
      S = k.sin,
      _ = k.cos,
      L = k.max,
      P = k.min,
      A = k.abs,
      N = k.ceil,
      E = k.floor,
      F = k.PI,
      O = F / 2,
      T = 180 / k.PI,
      D = 2 * F,
      M = F + O,
      I = function I(e, t, n) {
    return n.getFromEnv("animationManager").setAnimation({
      el: "group",
      attr: {
        name: e
      },
      container: t,
      component: n,
      label: "group"
    });
  },
      R = function R(e, t, n, a, i) {
    return w((t - n[1] - a.top) / i, e - n[0] - a.left);
  },
      V = function V(e, t) {
    return function (n) {
      !t.data("plotItem").seriesData.isRotating && e.plotGraphicClick.call(t, n);
    };
  },
      B = function B(e) {
    return function (t) {
      var n,
          i,
          o,
          r,
          l,
          s,
          c,
          u,
          h,
          d,
          p,
          f,
          g = this.element || this,
          m = g.plotItem || g.data("plotItem"),
          b = g.data("eventArgs") || {},
          x = m.chart,
          C = e.getFromEnv("animationManager"),
          k = m.index,
          w = e.config,
          S = w.enableMultiSlicing,
          _ = e.components.data[k],
          L = _.graphics,
          P = _.config,
          A = P.doNotSlice,
          N = P.slicedTranslation;

      if (!w.isRotating && t && x.plotEventHandler(g, t), !(w.isRotating || w.singletonCase || A || (i = !S && e.sliceInOtherPies(k), (l = P.sliced) && i))) {
        if (v && !y) {
          if (d = new Date().getTime(), m.lastSliceTimeStamp && d - m.lastSliceTimeStamp < 400) return;
          m.lastSliceTimeStamp = d;
        }

        return o = L.element, u = L.connector, r = L.label || L.dataLabel, N = "object" === (void 0 === N ? "undefined" : a(N)) ? "t" + N : N, h = P.connectorPath, s = (l ? -1 : 1) * P.transX, c = (l ? -1 : 1) * P.transY, p = o.data("eventArgs") || o.data("eventArgs", {}), x.fireChartInstanceEvent("slicingStart", {
          slicedState: l,
          dataIndex: "index" in b && b.index,
          data: e.getPlotData(k, l)
        }), C.setAnimationState("slicing"), C.setAnimation({
          el: o,
          attr: {
            transform: l ? "t0,0" : N
          },
          component: e,
          label: "slice",
          callback: function callback() {
            x.fireChartInstanceEvent("slicingEnd", {
              slicedState: l,
              dataIndex: "index" in b && b.index,
              data: e.getPlotData(k, !l)
            });
          }
        }), r && r.x && ((n = r.data("textPos")) || (n = r.data("textPos", {
          x: r.x,
          y: r.y
        })), C.setAnimation({
          el: r,
          attr: {
            x: r.x + (l ? 0 : s),
            y: r.y + (l ? 0 : c)
          },
          label: "label-sliced",
          component: e
        }), n.x = r.x + (l ? 0 : s)), h && ((f = h.slice(0))[1] += s, f[2] += c, f[4] += s, f[5] += c, f[6] += s, f[7] += c, C.setAnimation({
          el: u,
          attr: {
            path: f
          },
          label: "connector-sliced",
          component: e
        }), P.connectorPath = f), p.isSliced = l = P.sliced = !l, l;
      }
    };
  },
      j = function j(e) {
    var t = e.getFromEnv("animationManager");
    return {
      plotDragMove: function plotDragMove(t) {
        var n,
            a = this.data("plotItem"),
            i = a.chart,
            o = t.data,
            r = o[0],
            l = o[1],
            s = o[2],
            u = o[3],
            h = a.seriesData,
            d = e.config;
        isNaN(r) || isNaN(l) || !d.enableRotation || h.singletonCase || h.isRightClicked || (n = R.call(t, s, u, h.pieCenter, h.chartPosition, 1), h.dragStartAngle === n || h.isRotating || (h.isRotating = !0, i.fireChartInstanceEvent("RotationStart", {
          startingAngle: h._rotationalStartAngle = i._startingAngle()
        })), d.startAngle += n - h.dragStartAngle, h.dragStartAngle = n, h.moveDuration = 0, d.updateInited || (d.updateInited = !0, i.addJob("pie_batch_rotate", i._batchRotate || (i._batchRotate = function () {
          e._rotate(), d.updateInited = !1;
        }), c.priorityList.draw, {
          oneInAFrame: !0
        })));
      },
      plotDragStart: function plotDragStart(t) {
        var n,
            a = this.data("plotItem"),
            i = a.chart,
            r = a.seriesData,
            l = e.config,
            s = (0, o.pluckNumber)(t.button, t.originalEvent.button),
            c = -l.startAngle * T,
            u = t.data[0],
            h = t.data[1];
        r.isRightClicked = !(o.touchEnabled || 0 === s || 1 === s), l.enableRotation && !r.isRightClicked && (r.isRotating = !1, r.chartPosition = function (e, t) {
          var n,
              a = {
            left: 0,
            top: 0
          };
          if (e.getBoundingClientRect) n = e.getBoundingClientRect(), a.top = n.top + (g.pageYOffset || m.scrollTop || 0) - (m.clientTop || 0), a.left = n.left + (g.pageXOffset || m.scrollLeft || 0) - (m.clientLeft || 0);else for (; e;) {
            a.left += e.offsetLeft || 0, a.top += e.offsetTop || 0, e === m.body || e === m.documentElement || t || (a.left -= e.scrollLeft || 0, a.top -= e.scrollTop || 0), e = e.offsetParent;
          }
          return a;
        }(i.getFromEnv("chart-container")), n = R.call(t, u, h, r.pieCenter, r.chartPosition, 1), r.dragStartAngle = n, r.startingAngleOnDragStart = c);
      },
      plotDragEnd: function plotDragEnd() {
        var t = this.data("plotItem"),
            n = t.chart,
            a = n.getChildren("dataset")[0].config,
            i = n.config,
            r = t.seriesData,
            l = -a.startAngle * T;
        r.isRightClicked || (i.clicked = !0, n.disposed || e._rotate(), delete i.clicked, r.isRotating && (setTimeout(function () {
          r.isRotating = !1;
        }, 0), n.fireChartInstanceEvent("RotationEnd", {
          startingAngle: (0, o.normalizeAngle)(l, !0),
          changeInAngle: l - a.startingAngleOnDragStart
        })), !r.isHovered && e.config.handlersAPI.onPlotHover(this, !1));
      },
      plotRollOver: function plotRollOver(e) {
        var t = this.plotItem || this.data("plotItem"),
            n = t.chart,
            a = t.seriesData,
            i = n.getDatasets()[0],
            o = i.getFromEnv("animationManager");
        a.isRotating || (n.plotEventHandler(this, e, "DataPlotRollOver"), i.config.handlersAPI.onPlotHover(this, !0, o)), i.fireEvent("datasetrollover", t), a.isHovered = !0;
      },
      plotRollOut: function plotRollOut(e) {
        var t = this.plotItem || this.data("plotItem"),
            n = t.chart,
            a = t.seriesData,
            i = n.getDatasets()[0];
        a.isRotating || (n.plotEventHandler(this, e, "DataPlotRollOut"), i.config.handlersAPI.onPlotHover(this, !1)), i.fireEvent("datasetrollout", t), a.isHovered = !1;
      },
      onPlotHover: function onPlotHover(n, a) {
        var i = n.data("plotItem"),
            r = i.center,
            l = i.rolloverProperties || {},
            s = a ? l.color : i.color,
            c = a ? l.borderWidth : i.borderWidth,
            u = a ? l.borderColor : i.borderColor;
        s && (a && (s.cx = r[0], s.cy = r[1], s.r = i.radius), l.enabled && t.setAnimation({
          el: i.graphic,
          component: e,
          attr: {
            fill: (0, o.toRaphaelColor)(s),
            "stroke-width": c,
            stroke: u
          }
        }));
      }
    };
  },
      G = function G(e, t) {
    return e.point.value - t.point.value;
  },
      H = function H(e, t) {
    return e.angle - t.angle;
  },
      z = function z(e, t) {
    t && e.getFromEnv("linkClickFN") && e.getFromEnv("linkClickFN").call({
      link: t
    }, !0);
  },
      W = function W() {
    this.hide();
  },
      q = ["start", "start", "end", "end"],
      U = [-1, 1, 1, -1],
      Y = [1, 1, -1, -1];

  function X(e) {
    if (this.config.JSONData) {
      var t,
          n,
          a = void 0,
          i = this.getFromEnv("legend"),
          o = void 0,
          r = this.config.JSONData,
          l = r.data && r.data.length,
          s = e.data && e.data.length || 0,
          c = l - s;

      for (c > 0 && this.removeData(s, c, !1), a = 0, t = (n = this.components.removeDataArr || []).length; a < t; a++) {
        (o = n[a].config).legendItemId && i.disposeItem(o.legendItemId);
      }
    }
  }

  (0, r.addDep)({
    name: "pie2dAnimation",
    type: "animationRule",
    extension: l["default"]
  }), (0, s["default"])(p);

  var K = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.plotGraphicClick = B(n), n;
    }

    return d(t, e), t.prototype.getType = function () {
      return "dataset";
    }, t.prototype.getName = function () {
      return "pie2D";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this), this.config.doughnutradius = 0;
    }, t.prototype.configureAttributes = function (e) {
      if (!e) return !1;
      this.trimData(e), this.config.JSONData = e;
      var t,
          n,
          a,
          i,
          r = this.getFromEnv("chart"),
          l = r.config,
          s = this.config,
          c = this.config.JSONData,
          u = this.getFromEnv("chart-attrib"),
          h = r.config.is3D,
          d = void 0;
      s.handlersAPI = j(this), this.setState("visible", 1 === (0, o.pluckNumber)(this.config.JSONData.visible, !Number(this.config.JSONData.initiallyhidden), 1)), (0, o.parseConfiguration)({}, this.config, r && r.config), i = s.enableAnimation = (0, o.pluckNumber)(u.animation, u.defaultanimation, 1), s.animation = !!i && {
        duration: 1e3 * (0, o.pluckNumber)(u.animationduration, u.moveduration, 1)
      }, s.transposeAnim = !(!i && !(0, o.pluckNumber)(s.transposeanimation, 1)) && {
        duration: 1e3 * (0, o.pluckNumber)(u.transposeanimduration, .2)
      }, s.showPlotBorder = (0, o.pluckNumber)(u.showplotborder, 1), s.showHoverEffect = (0, o.pluckNumber)(u.plothovereffect, u.showhovereffect, f), s.showTooltip = (0, o.pluckNumber)(u.showtooltip, 1), s.toolText = (0, o.getValidValue)((0, o.parseUnsafeString)((0, o.pluck)(c.plottooltext, u.plottooltext))), a = s.enableMultiSlicing = (0, o.pluckNumber)(u.enablemultislicing, 1), t = s.use3DLighting = (0, o.pluckNumber)(u.use3dlighting, 1), d = s.radius3D = t ? (0, o.pluckNumber)(u.radius3d, 90) : 100, s.showZeroPies = (0, o.pluckNumber)(u.showzeropies, 1), s.showPercentInToolTip = (0, o.pluckNumber)(u.showpercentintooltip, 1), s.showLabels = (0, o.pluckNumber)(u.showlabels, 1), s.showValues = (0, o.pluckNumber)(c.showvalues, u.showvalues, 1), s.showPercentValues = (0, o.pluckNumber)(u.showpercentvalues, u.showpercentagevalues, 0), n = s.toolTipSepChar = (0, o.pluck)(u.tooltipsepchar, u.hovercapsepchar, o.COMMASPACE), s.labelSepChar = (0, o.pluck)(u.labelsepchar, n), s.pieBorderColor = (0, o.pluck)(u.plotbordercolor, u.piebordercolor), s.pieBorderAlpha = (0, o.pluckNumber)(u.plotborderalpha, u.pieborderalpha), s.pieBorderThickness = s.showPlotBorder ? (0, o.pluckNumber)(u.plotborderthickness, u.pieborderthickness, l.plotborderthickness, 1) : 0, s.plotDashLen = (0, o.pluckNumber)(u.plotborderdashlen, 5), s.plotDashGap = (0, o.pluckNumber)(u.plotborderdashgap, 4), s.showValueInLegend = (0, o.pluckNumber)(u.showvalueinlegend, 0), s.showLabelInLegend = (0, o.pluckNumber)(u.showlabelinlegend, 1), s.valueBeforeLabelInLegend = (0, o.pluckNumber)(u.valuebeforelabelinlegend, 0), s.showValueAsPercentInLegend = (0, o.pluckNumber)(u.showvalueaspercentinlegend, 1), s.legendSepChar = (0, o.pluck)(u.legendsepchar, ", "), s.showvalues = (0, o.pluckNumber)(u.showvalues, 1), s.chartPosition = (0, o.getPosition)(r.getFromEnv("chart-container"), r), s.timerThreshold = 30, d > 100 && (d = 100), d < 0 && (d = 0), s.showLegend = (0, o.pluckNumber)(u.showlegend, 0), s.reverselegend = !(0, o.pluckNumber)(u.reverselegend, 0), r.config.is3D = h, s.pieYScale = (0, o.pluckNumber)(u.pieyscale, 40), s.pieYScale < 1 && (s.pieYScale = 1), s.pieYScale >= 100 && (s.pieYScale = 80), s.pieYScale /= 100, s.pieSliceDepth = (0, o.pluckNumber)(u.pieslicedepth, 15), s.pieSliceDepth < 1 && (s.pieSliceDepth = 1), s.managedPieSliceDepth = s.pieSliceDepth, s.enableMultiSlicing = !!a, s.startAngle = (0, o.pluckNumber)(u.startingangle, 0) % 360 * (-F / 180), s.usePerPointLabelColor = u.colorlabelsfromplot == o.ONESTRING, s.reversePlotOrder = (0, o.pluckNumber)(u.reverseplotorder, 0), s.animateClockWise = (0, o.pluckNumber)(u.animateclockwise, s.reversePlotOrder), s.showShadow = (0, o.pluckNumber)(u.showshadow, 1), s.singletonCase = 1 === c.data.length, s.valueTotal = 0, this._setConfigure(), l.showLegend && this._addLegend();
    }, t.prototype.trimData = function (e) {
      X.call(this, e);
    }, t.prototype._parseDisplayProperties = function (e, t) {
      var n,
          a,
          i,
          r,
          l,
          s,
          c,
          u,
          h,
          d = "",
          p = this.getFromEnv("chart"),
          g = this.getFromEnv("number-formatter"),
          m = p.getFromEnv("chart-attrib"),
          b = this.config,
          v = (0, o.pluckNumber)(t.y, g.getCleanValue(e.value, !0)),
          y = b.valueTotal,
          x = b.showLabels,
          C = (0, o.parseUnsafeString)((0, o.pluck)(t.seriesName, e.label, e.name, o.BLANKSTRING)),
          k = b.showPercentValues,
          w = b.showPercentInToolTip,
          S = b.labelSepChar,
          _ = b.toolTipSepChar,
          L = b.showTooltip;
      n = (0, o.getValidValue)((0, o.parseUnsafeString)((0, o.pluck)(e.tooltext, b.toolText))), a = t.pValue = g.percentValue(v / y * 100), r = t.value = g.dataLabels(v) || o.BLANKSTRING, l = 1 === (0, o.pluckNumber)(e.showlabel, x) ? C : o.BLANKSTRING, s = 1 === (h = (0, o.pluckNumber)(e.showvalue, b.showValues)) ? 1 === k ? a : r : o.BLANKSTRING, i = w ? a : r, c = (0, o.getValidValue)((0, o.parseUnsafeString)(e.displayvalue)), u = (0, o.pluck)(c, C + S + (k ? a : r), o.BLANKSTRING), s = c !== f && h ? c : s !== o.BLANKSTRING && l !== o.BLANKSTRING ? l + S + s : (0, o.pluck)(l, s), L && (d = n !== f ? (0, o.parseTooltext)(n, [1, 2, 3, 5, 6, 7, 14, 24, 25], {
        formattedValue: r,
        label: C,
        yaxisName: (0, o.parseUnsafeString)(m.yaxisname),
        xaxisName: (0, o.parseUnsafeString)(m.xaxisname),
        percentValue: a,
        sum: g.dataLabels(y),
        unformattedSum: y
      }, e, m) : (d = C) != o.BLANKSTRING ? d + _ + i : i), t.displayValue = s, t.displayValueArgs = u, t.toolText = d, t.seriesName = C, t.categoryLabel = C;
    }, t.prototype._isStyled = function (e) {
      if (this.getFromEnv("chart").config.usedataplotcolorforlabels || e.labelbordercolor || e.labelbgcolor || e.labelborderthickness || e.labelborderalpha || e.labelalpha || e.labelfont || e.labelfontsize || e.labelfontcolor || e.labelfontalpha || e.labelalpha || e.labelfontbold || e.labelfontitalic || e.labelborderpadding || e.labelborderradius || e.labelbgalpha || e.labelborderdashed || e.labelborderdashlen || e.labelborderdashgap) return !0;
    }, t.prototype._setConfigure = function (e, t) {
      var n,
          a,
          i,
          r,
          l,
          s,
          c,
          h,
          d,
          p,
          g,
          m,
          b,
          v,
          y,
          x,
          C,
          k,
          w = this.components,
          S = w.removeDataArr = w.removeDataArr || [],
          _ = this.getFromEnv("chart"),
          P = _.getFromEnv("dataSource").chart,
          A = _.config,
          N = this.config,
          E = this.config.JSONData,
          F = (e || E).data,
          O = F && F.length,
          T = N.showZeroPies,
          D = N.valueTotal || 0,
          M = [],
          I = (0, o.pluckNumber)(P.plotborderdashed, 0),
          R = this.components.data || (this.components.data = []),
          V = this.getFromEnv("number-formatter"),
          B = this.getFromEnv("color-manager"),
          j = N.labelInLeg,
          G = N.valInLeg,
          H = N.pieBorderThickness,
          z = N.reversePlotOrder,
          W = N.radius3D,
          q = N.enableMultiSlicing,
          U = N.lastSlicedid || 0,
          Y = (0, o.pluckNumber)(P.plotBorderDashed, 5),
          X = (0, o.pluckNumber)(P.plotborderdashgap, 4),
          K = (0, o.pluckNumber)(P.valuebeforelabelinlegend, 0),
          Z = (0, o.pluckNumber)(P.showvalueaspercentinlegend, 1),
          J = 0,
          $ = (0, o.pluck)(P.legendsepchar, ", ");

      for (A.dataLabelStyle = (0, o.parsexAxisStyles)({}, {}, P, A.dataLabelStyle, i), n = 0; n < O; n += 1) {
        b = F[n], null === (x = V.getCleanValue(b.value, !0)) || !T && 0 === x ? J += 1 : (M.push(b), D += x);
      }

      if (!N.singletonCase && (N.singletonCase = O - J == 1), J && R.length > O - J) for (n = R.length - 1; J > 0; n -= 1, J -= 1) {
        R[n] && (C = (b = R[n]).config, S.push(b), C.y = null);
      }

      for (0 === D && (M = []), N.valueTotal = D, N.dataLabelCounter = 0, A.allPlotSliceEnabled = A.enableslicing, n = (O = M.length) - 1; n >= 0; n -= 1) {
        v = n, e ? (k = M[n], b = t !== f ? R[v = t + n] : R[v = R.length - O + n]) : (b = R[n] || (R[n] = {
          graphics: {},
          config: {}
        }), k = M[n]), (y = b && b.config) || (y = R[v].config = {}), b.graphics || (R[v].graphics = {}), y.y = x = V.getCleanValue(k.value, !0), y.seriesName = a = (0, o.parseUnsafeString)((0, o.pluck)(k.label, k.name, o.BLANKSTRING)), y.labellink = (0, o.pluck)(k.labellink, P.labellink), i = (0, o.pluck)(k.color, B.getPlotColor(n)), r = (0, o.pluck)(k.alpha, P.plotfillalpha, o.HUNDREDSTRING), s = (l = y.borderConfig = this._parseBorderConfig(i, r, k)).setPlotBorderColor, c = l.setPlotBorderAlpha, h = {
          opacity: L(r, c) / 100
        }, (g = Boolean((0, o.pluckNumber)(k.issliced, P.issliced, 0))) && (q || (-1 !== U && (R[R.length - U - 1].sliced = !1), N.lastSlicedid = n), N.preSliced = g), m = (0, o.pluckNumber)(k.dashed, I) ? (0, o.getDashStyle)((0, o.pluck)(k.dashlen, Y), (0, o.pluck)(k.dashgap, X), H) : "none", this._parseDisplayProperties(k, y), d = j ? a : o.BLANKSTRING, G && (p = Z ? V.legendPercentValue(x / D * 100) : V.legendValue(x), d = K ? p + (d && $ + d) : (d && d + $) + p), N.dataLabelCounter += 1, this._isStyled(k) ? y.style = (0, o.parsexAxisStyles)(k, {}, P, A.dataLabelStyle, i) : y.style && delete y.style, y.showInLegend = d !== o.BLANKSTRING, y.isVisible = !0, y.name = d, y.shadow = h, y.setColor = i, y.color = (0, u["default"])(i, r, W, N.doughnutradius), y._3dAlpha = r, y.borderColor = (0, o.convertColor)(s, c), y.borderWidth = H, y.link = (0, o.getValidValue)(k.link), y.sliced = g, y.dashStyle = m, (y.doNotSlice = (0, o.pluck)(k.enableslicing, A.enableslicing) != o.ONESTRING) || A.allPlotSliceEnabled !== o.ZEROSTRING || (A.allPlotSliceEnabled = o.ONESTRING), this._parseHoverEffectOptions(n), y.centerLabelConfig = void 0, y.radius3D = W;
      }

      z && R && R.reverse(), N.dataArr = M, N.enableRotation = R.length > 1 ? (0, o.pluckNumber)(P.enablerotation, 1) : 0;
    }, t.prototype._parseHoverEffectOptions = function (e) {
      var t,
          n,
          a,
          i,
          r,
          l,
          s,
          c,
          u,
          h,
          d = this.getFromEnv("chart").getFromEnv("dataSource").chart,
          p = this.config,
          g = this.components.data[e].config,
          m = this.config.JSONData,
          b = m.data[e],
          v = g.setColor,
          y = g._3dAlpha,
          x = p.radius3D,
          C = g.borderConfig,
          k = C.setPlotBorderAlpha,
          w = C.setPlotBorderColor,
          S = p.setBorderWidth,
          _ = (0, o.pluckNumber)(g.hovereffect, p.showHoverEffect),
          L = g.hoverEffects = {
        enabled: _
      };

      if (_ === f && (_ = L.enabled = (0, o.pluck)(b.hovercolor, m.hovercolor, d.plotfillhovercolor, b.hoveralpha, m.hoveralpha, d.plotfillhoveralpha, b.borderhovercolor, m.borderhovercolor, d.plotborderhovercolor, b.borderhoveralpha, m.borderhoveralpha, d.plotborderhoveralpha, d.plotfillhoveralpha, b.borderhoverthickness, m.borderhoverthickness, d.plotborderhoverthickness, f) !== f), _) {
        if (t = (0, o.pluckNumber)(b.highlightonhover, m.highlight, d.highlight, 1), (n = (0, o.pluck)(b.hovercolor, m.hovercolor, d.plotfillhovercolor)) && t && (t = 0), n = (0, o.pluck)(n, v), a = (0, o.pluck)(b.hoveralpha, m.hoveralpha, d.plotfillhoveralpha, y), i = (0, o.pluck)(b.borderhovercolor, m.borderhovercolor, d.plotborderhovercolor, w), r = (0, o.pluck)(b.borderhoveralpha, m.borderhoveralpha, d.plotborderhoveralpha, d.plotfillhoveralpha, k), l = (0, o.pluckNumber)(b.borderhoverthickness, m.borderhoverthickness, d.plotborderhoverthickness, S), n.replace(/,+?$/, ""), 1 === t) {
          for (u = (c = (s = "string" == typeof n) ? n.split(/\s{0,},\s{0,}/) : n.color.split(/\s{0,},\s{0,}/)).length, h = 0; h < u; h++) {
            c[h] = (0, o.getLightColor)(c[h], 70);
          }

          s ? n = c.join(",") : n.color = c.join(",");
        }

        this._setHoverColor(L, n, a, x), L.alpha = a, L.borderColor = (0, o.convertColor)(i, r), L.borderAlpha = r, L.borderWidth = l;
      } else L.enabled = !1;
    }, t.prototype.placeDataLabels = function (e, t, n, a) {
      var i,
          r,
          l,
          s,
          c,
          u,
          h,
          d,
          p,
          g,
          m,
          b,
          v,
          y,
          x,
          w,
          T,
          I,
          R,
          B,
          j,
          X,
          K,
          Z,
          J,
          $,
          Q,
          ee,
          te,
          ne,
          ae,
          ie,
          oe,
          re,
          le,
          se,
          ce,
          ue,
          he,
          de,
          pe,
          fe,
          ge,
          me,
          be,
          ve,
          ye = this,
          xe = ye.getFromEnv("chart"),
          Ce = xe.config,
          ke = ye.getFromEnv("animationManager"),
          we = ye.getFromEnv("toolTipController"),
          Se = xe.getChildren("legend")[0],
          _e = ye.getContainer("label-group"),
          Le = ye.config,
          Pe = Ce.canvasLeft,
          Ae = Ce.canvasTop,
          Ne = Ce.canvasWidth,
          Ee = Pe + .5 * Ce.canvasWidth,
          Fe = Ae + .5 * Ce.canvasHeight,
          Oe = xe.getFromEnv("smartLabel"),
          Te = Le.dataLabelOptions,
          De = Te.style,
          Me = (0, o.pluckNumber)(N(parseFloat(De.lineHeight)), 12),
          Ie = 1 === t.length && Ce.singletonPlaceValue,
          Re = Te.skipOverlapLabels,
          Ve = Te.manageLabelOverflow,
          Be = Te.connectorPadding,
          je = Te.distance,
          Ge = a && a.metrics || [Ee, Fe, 2 * Le.pieMinRadius, Le.innerSize || 0],
          He = Ge[1],
          ze = Ge[0],
          We = .5 * Ge[2],
          qe = [[], [], [], []],
          Ue = Pe,
          Ye = Ae,
          Xe = Ne,
          Ke = n.labelsRadius = We + je,
          Ze = parseInt(De.fontSize, 10),
          Je = Ze,
          $e = Je / 2,
          Qe = [Be, Be, -Be, -Be],
          et = n.labelsMaxInQuadrant = E(Ke / Je),
          tt = Te.isSmartLineSlanted,
          nt = Ge[3] / 2,
          at = Number.POSITIVE_INFINITY,
          it = [],
          ot = [],
          rt = Le.handlersAPI.plotDragStart,
          lt = Le.handlersAPI.plotDragEnd,
          st = Le.handlersAPI.plotDragMove,
          ct = Le.handlersAPI.plotRollOver,
          ut = Le.handlersAPI.plotRollOut,
          ht = function ht(e) {
        var t = {},
            n = "";

        for (n in e) {
          t[n] = e[n];
        }

        return e;
      },
          dt = function dt(e, t) {
        return function () {
          e.attr(t);
        };
      };

      if (Se ? (r = (i = Se.config).symbolWidth, l = i.align, s = i.borderWidth) : (r = 0, l = 0, s = 0), Oe.useEllipsesOnOverflow(Ce.useEllipsesWhenOverflow), e || Oe.setStyle(De), !nt && Le.singletonCase && Ie) Z = t[0], (me = Z.config._textAttrs).text && (fe = Z.graphics, pe = Z.config, oe = fe.label, Z.slicedTranslation = [Ue, Ye], me["text-anchor"] = "middle", me.x = 0, me.y = 0, me.transform = ["t", ze, He], ie = ke.setAnimation({
        el: oe || "text",
        attr: me,
        component: ye,
        css: be,
        label: "label",
        container: _e
      }), oe || (fe.label = ie, ie.on("fc-dragstart", rt).on("fc-dragmove", st).on("fc-dragend", lt).on("fc-click", z.bind(ie, xe, Z.config.labellink)).on("fc-click", V(ye, ie)).on("fc-mouseover", ct).on("fc-mouseout", ut)), ie.x = ze, ie.data("textPos", {
        x: ze,
        y: He
      }).data("plotItem", me.plotItem).data("eventArgs", me.eventArgs), null !== pe.y && pe.y !== f && ie.show(), fe.connector && ke.setAnimation({
        el: fe.connector,
        component: ye,
        attr: {
          path: []
        }
      }));else if (Ie) ue = nt + (We - nt) / 2, (0, o.fcEach)(t, function (e) {
        pe = e.config, (me = pe._textAttrs).text && (fe = e.graphics, oe = fe.label, null !== pe.y && pe.y !== f && (($ = fe.connector) && $.show(), ie && ie.show()), me.transform = "t0,0", J = pe.angle, X = He + ue * S(J), I = ze + ue * _(J), me._x = I, me._y = X, e.sliced && (ce = e.slicedTranslation, re = ce[0] - Ue, le = ce[1] - Ye, I += re, X += le), me["text-anchor"] = "middle", me.x = 0, me.y = 0, me.transform = ["t", I, X], ie = ke.setAnimation({
          el: oe || "text",
          attr: me,
          component: ye,
          label: "label",
          css: be,
          container: _e
        }), oe || (fe.label = ie, ie.on("fc-dragstart", rt).on("fc-dragmove", st).on("fc-dragend", lt).on("fc-click", z.bind(ie, xe, e.config.labellink)).on("fc-click", V(ye, ie)).on("fc-mouseover", ct).on("fc-mouseout", ut)), ie.x = me._x, ie.x = me._x, ie.y = me._y, ie.data("plotItem", me.plotItem).data("eventArgs", me.eventArgs), me.visibility === C && ie.show());
      });else {
        for (h = t.length - 1; h >= 0; h--) {
          Z = t[h], pe = Z.config, ((me = pe._textAttrs || {}).text = pe.displayValue) ? (fe = Z.graphics, null !== pe.y && pe.y !== f && (ie = fe.label, ($ = fe.connector) && $.show(), ie && ie.show()), me.text = pe.displayValue, me.transform = "t0,0", (J = pe.angle % D) < 0 && (J = D + J), qe[J >= 0 && J < O ? 1 : J < F ? 2 : J < M ? 3 : 0].push({
            point: Z,
            angle: J
          })) : (Z.graphics.connector && (Z.graphics.connector = ke.setAnimation({
            el: Z.graphics.connector,
            component: ye
          })), Z.graphics.label && (Z.graphics.label = ke.setAnimation({
            el: Z.graphics.label,
            component: ye,
            callback: W
          })));
        }

        for (h = y = 4; h--;) {
          if (Re && (ee = qe[h].length - et) > 0) for (qe[h].sort(G), p = 0, v = (te = qe[h].splice(0, ee)).length; p < v; p += 1) {
            Z = te[p].point, me = Z.config._textAttrs, (fe = Z.graphics).label && (fe.label = ke.setAnimation({
              el: fe.label,
              component: ye
            })), fe.connector && (fe.connector = ke.setAnimation({
              el: fe.connector,
              component: ye
            }));
          }
          qe[h].sort(H);
        }

        for (ae = L(qe[0].length, qe[1].length, qe[2].length, qe[3].length), ne = L(P(ae, et) * Je, Ke + Je), ot = qe[0].concat(qe[1]), it = qe[2].concat(qe[3]), h = ot.length - 1; h >= 0; h--) {
          delete (de = ot[h].point.config).clearance, delete de.clearanceShift, g = A(ne * S(de.angle)), Math.abs(at - g) < 2 * Me && (de.clearance = 0, ot[h + 1].point.clearanceShift = Me / 2), at = g;
        }

        for (at = Number.POSITIVE_INFINITY, h = 0, v = it.length; h < v; h++) {
          delete (de = it[h].point.config).clearance, delete de.clearanceShift, g = A(ne * S(de.angle)), Math.abs(at - g) < 2 * Me && (de.clearance = 0, it[h - 1].point.clearanceShift = Me / 2), at = g;
        }

        for (qe[1].reverse(), qe[3].reverse(); y--;) {
          for (v = (K = qe[y]).length, Re || ($e = (Je = v > et ? ne / v : Ze) / 2), b = v * Je, c = ne, h = 0; h < v; h += 1, b -= Je) {
            c < (g = A(ne * S(K[h].angle))) ? g = c : g < b && (g = b), c = (K[h].oriY = g) - Je;
          }

          for (u = q[y], m = ne - (v - 1) * Je, c = 0, h = K.length - 1; h >= 0; h -= 1, m += Je) {
            Z = K[h].point, J = K[h].angle, pe = Z.config, (me = pe._textAttrs || {}).text && ((be = pe._textCss).cursor = pe.labellink ? "pointer" : "", fe = Z.graphics, x = pe.sliced, ie = fe.label, (g = A(ne * S(J))) < c ? g = c : g > m && (g = m), c = g + Je, he = pe.clearance === f ? 2 * N((0, o.pluckNumber)(parseFloat(pe.style.border), 12), 12) : 2 * N((0, o.pluckNumber)(parseFloat(pe.style.border), pe.clearance)), B = (g + K[h].oriY) / 2, w = ze + Y[y] * Ke * _(k.asin(B / ne)), B *= U[y], B += He, j = He + We * S(J), T = ze + We * _(J), (y < 2 && w < T || y > 1 && w > T) && (w = T), X = B - $e - 2, R = (I = w + Qe[y]) + Qe[y], me._x = R, Ve && (d = y > 1 ? R - Ce.canvasLeft : Ce.canvasLeft + Xe - R, Oe.setStyle(pe.style), Me = (0, o.pluckNumber)(N(parseFloat(pe.style.lineHeight)), 12) + he, "right" === l && pe.transX > 0 ? d -= r + 2 * s : "right" !== l && pe.transY > 0 && (B -= Je), se = Oe.getSmartText(pe.displayValue, d, Me), pe.clearance === f && se.height > Je && (B += Je), me.text = se.text, me.tooltip = se.tooltext), me._y = B, x && (re = pe.transX, le = pe.transY, I += re, w += re, T += re, j += le, B += le, X += le, R += re), me["text-anchor"] = u, me.vAlign = "middle", me.opacity = 1, me.x = R, me.y = B, ge = ie && ie.data("textPos"), null !== pe.y && pe.y !== f && (ge ? (ve = ht(me), ke.setAnimation({
              el: ie,
              attr: ve,
              callback: dt(ie, me),
              component: ye
            })) : (ie = fe.label = ke.setAnimation({
              el: "text",
              attr: me,
              css: be,
              label: "label",
              container: _e,
              component: ye
            })).on("fc-dragstart", rt).on("fc-dragmove", st).on("fc-dragend", lt).on("fc-click", z.bind(ie, xe, Z.config.labellink)).on("fc-click", V(ye, ie)).on("fc-mouseover", ct).on("fc-mouseout", ut)), ie.x = me._x, ie._x = me._x, ie.y = me._y, me.tooltip && (we.enableToolTip(ie, me.tooltip), delete me.tooltip), me.visibility === C && ie.show(), ie.data("textPos", {
              x: R,
              y: B
            }).data("plotItem", me.plotItem).data("eventArgs", me.eventArgs), ($ = fe.connector) && (pe.connectorPath = Q = ["M", T, j, "L", tt ? w : T, B, I, B], $.data("connectorPath") && Ce.clicked || ke.setAnimation({
              el: $,
              attr: {
                path: Q
              },
              label: "connector",
              component: ye
            }), $.data("connectorPath", {
              path: Q
            })));
          }
        }
      }
    }, t.prototype._setHoverColor = function (e, t, n, a) {
      a ? e.color = (0, u["default"])(t, n, a, this.config.doughnutradius) : (e.color = t, e.alpha = n);
    }, t.prototype.updateData = function () {
      var t = this.config,
          n = this.components.data;
      t.valueTotal -= n[arguments[1]].config.y, e.prototype.updateData.call(this, arguments);
    }, t.prototype._rotate = function () {
      var e,
          t,
          n,
          a,
          i,
          r,
          l,
          s,
          c,
          u = this.getFromEnv("chart"),
          h = this.config,
          d = this.components.data,
          p = u.config,
          g = h.piePlotOptions,
          m = (h.startAngle || 0) % D,
          b = h.slicingDistance,
          v = h.valueTotal,
          y = D / v,
          x = p.canvasLeft + .5 * p.canvasWidth,
          C = p.canvasTop + .5 * p.canvasHeight,
          k = h.pieMinRadius,
          w = .5 * (g.innerSize || 0);

      for (i = r = m, c = 0; c < d.length; c += 1) {
        l = d[c].config, s = d[c].graphics, null !== (n = l.y) && n !== f && (r = i, a = .5 * ((i -= h.singletonCase ? D : n * y) + r), l.angle = a, l.transX = _(a) * b, l.transY = S(a) * b, l.slicedTranslation = "t" + _(a) * b + o.COMMASTRING + S(a) * b, (t = l._rotateAttrs) || (t = l._rotateAttrs = {
          ringpath: [],
          transform: o.BLANKSTRING
        }), (e = t.ringpath)[0] = x, e[1] = C, e[2] = k, e[3] = w, e[4] = i, e[5] = r, s.element.attr({
          ringpath: t.ringpath,
          transform: l.sliced ? l.slicedTranslation : ""
        }));
      }

      this.placeDataLabels(!0, d, h);
    }, t.prototype._parsePiePlotOptions = function () {
      var e = this.config;
      return {
        size: e.pieMinRadius,
        slicedOffset: e.slicingDistance
      };
    }, t.prototype._parseDataLabelOptions = function () {
      return {
        style: this.getFromEnv("chart").config.dataLabelStyle
      };
    }, t.prototype._addLegend = function () {
      var e,
          t,
          n,
          a,
          i = this.getFromEnv("legend"),
          r = this.components.data;

      for (e = 0; e < r.length; e++) {
        if (null !== (t = r[e].config).y && t.seriesName) a = {
          index: e,
          type: this.getName(),
          label: t.seriesName,
          enabled: (0, o.pluckNumber)(t.includeInLegend, 1)
        }, (n = i.getItem(t.legendItemId)) || (t.legendItemId = i.createItem(this), n = i.getItem(t.legendItemId), this.addExtEventListener("fc-click", n.itemClickFn, n)), n.configure(a), n.setStateCosmetics("default", {
          symbol: {
            fill: (0, o.toRaphaelColor)(t.setColor),
            rawFillColor: t.setColor,
            stroke: (0, o.toRaphaelColor)(t.borderColor)
          }
        });else {
          if (!t.legendItemId) continue;
          (n = i.getItem(t.legendItemId)) && i.disposeItem(n.getId()), delete t.legendItemId;
        }
      }
    }, t.prototype.getPlotData = function (e, t) {
      var n,
          i,
          o,
          r = this.components.data[e].config,
          l = this.config.userData || (this.config.userData = []);
      if (l[e]) n = l[e];else {
        for (o in n = l[e] = {}, r) {
          "object" !== a(i = r[o]) && "function" != typeof i && 0 !== o.indexOf("_") && (n[o] = i);
        }

        n.value = n.y, n.categoryLabel = n.label = n.seriesName, delete n.y, delete n.total, delete n.doNotSlice, delete n.name, delete n.seriesName, delete n.centerAngle, delete n.showInLegend, delete n.angle, delete n.endAngle, delete n.isVisible, delete n.setColor, delete n.slicedTranslation, delete n.startAngle, delete n.transX, delete n.transY, delete n.pValue;
      }
      return n.sliced = t, n;
    }, t.prototype._parseBorderConfig = function (e, t, n) {
      var a = this.config.pieBorderColor,
          i = this.getFromEnv("chart").getFromEnv("dataSource").chart,
          r = (0, o.pluck)(n.bordercolor, a),
          l = (0, o.pluck)(n.borderalpha, i.plotborderalpha, i.pieborderalpha);
      return {
        setPlotBorderColor: r = (0, o.pluck)(r, (0, o.getLightColor)(e, 25)).split(o.COMMASTRING)[0],
        setPlotBorderAlpha: l = i.showplotborder == o.ZEROSTRING ? o.ZEROSTRING : (0, o.pluck)(l, t, "80")
      };
    }, t.prototype.legendInteractivity = function (e) {
      var t,
          n = this.components.data,
          a = void 0,
          i = e.getId(),
          o = void 0;

      for (a = 0, t = n.length; a < t; a++) {
        n[a].config.legendItemId === i && (o = n[a].graphics, this.plotGraphicClick.call(o.element));
      }
    }, t.prototype.hideElements = function () {
      var e = this.data && this.data("plotItem").chart,
          t = e.getChildren("dataset") && e.getChildren("dataset")[0],
          n = 0,
          a = this._ && this._.shadows || [];
      if (t) for (this.hide(); n < a.length; n += 1) {
        a[n].hide();
      }
    }, t.prototype._createContainer = function () {
      var e,
          t,
          n,
          a,
          i = this.getName(),
          o = this.groupName,
          r = this.getLinkedParent(),
          l = o || this.dsGroup || i;
      !r.getChildContainer(l + "Group") && (l = "default"), e = r.getChildContainer("datalabelsGroup"), t = this.getContainer("pie-groups") || this.addContainer("pie-groups", I("pie", e, this)), n = this.getContainer("pie-plot-groups") || this.addContainer("pie-plot-groups", I("pie-plot", t, this)), a = this.getContainer("pie-label-groups") || this.addContainer("pie-label-groups", I("pie-label", t, this)), this.getContainer("plot-group") || this.addContainer("plot-group", I("plots", n, this)), this.getContainer("plot-shadow-group") || this.addContainer("plot-shadow-group", I("plot-shadows", n, this).toBack()), this.getContainer("label-group") || this.addContainer("label-group", I("labels", a, this)), this.getContainer("connector-shadow-group") || this.addContainer("connector-shadow-group", I("connector-shadows", a, this)), this.getContainer("anchor-shadow-group") || this.addContainer("anchor-shadow-group", I("anchor-shadows", a, this));
    }, t.prototype.allocatePosition = function () {
      var e,
          t,
          n = this.components.data,
          a = n.length;

      for (e = 0; e < a; e++) {
        t = n[e], this.parsePlotAttributes(t, e), this.parseLabelAttributes(t, e);
      }
    }, t.prototype.parsePlotAttributes = function (e, t) {
      var n,
          a,
          i,
          r,
          l,
          s,
          c,
          u,
          h,
          d,
          p,
          g,
          m,
          v,
          y = this.components.data,
          x = this.getFromEnv("chart"),
          C = x.config,
          k = this.config,
          w = t,
          L = y.length,
          P = C.canvasWidth,
          A = C.canvasHeight,
          N = C.canvasLeft + .5 * P,
          E = C.canvasTop + .5 * A,
          F = k.valueTotal,
          O = k.piePlotOptions = this._parsePiePlotOptions(),
          T = O.slicedOffset,
          M = O.size,
          I = .5 * (k.innerSize || 0),
          R = (k.startAngle || 0) % D,
          V = R - D,
          B = k.animateClockWise;

      m = F && D / F, k.pieCenter = [N, E], r = R, l = R, t > 0 && (r = y[t - 1].config.startAngle, l = y[t - 1].config.endAngle), c = (s = e.config).y, u = s.displayValue, h = s.sliced, n = s.toolText, a = !!s.link, null !== c && c !== f && !1 !== s.isVisible && ((d = s.color).r = M, d.cx = N, d.cy = E, l = r, p = .5 * ((r -= k.singletonCase ? D : c * m) + l), B ? V : R, g = k.previousData = {
        cx: N,
        cy: E,
        r: M,
        r2: I
      }, i = this.config.drawn ? [g.cx, g.cy, g.r, g.r2, r, l] : [N, E, M, I, r, l], s.eventArgs = {
        index: k.reversePlotOrder ? L - 1 - w : w,
        link: s.link,
        value: s.y,
        displayValue: s.displayValueArgs,
        categoryLabel: s.categoryLabel,
        isSliced: h,
        toolText: n,
        pValue: s.pValue
      }, h && (s.slicedTranslation = "t" + _(p) * T + "," + S(p) * T), v = {
        "stroke-width": s.borderWidth,
        stroke: s.borderColor,
        fill: b ? function (e, t) {
          var n = t ? 1 : f;
          return (0, o.toRaphaelColor)({
            color: (0, o.getFirstColor)(e.color, n),
            alpha: (0, o.getFirstAlpha)(e.alpha, n)
          });
        }(s.color, k.doughnutradius) : (0, o.toRaphaelColor)(s.color),
        transform: h ? s.slicedTranslation : "",
        "stroke-dasharray": s.dashStyle,
        redrawDataLabels: R,
        ringpath: i,
        cursor: a ? "pointer" : ""
      }, s.props = {
        element: {
          attr: v
        }
      }, s.eventArgs = {
        index: k.reversePlotOrder ? L - 1 - w : w,
        link: s.link,
        value: s.y,
        displayValue: s.displayValueArgs,
        categoryLabel: s.categoryLabel,
        isSliced: h,
        toolText: n,
        pValue: s.pValue
      }, s.plotItem = {
        chart: x,
        index: w,
        seriesData: k,
        value: c,
        pValue: s.pValue,
        displayValue: s.displayValue || "",
        angle: s.angle = p,
        angle1: s.startAngle = r,
        angle2: s.endAngle = l,
        slicedX: _(p) * T,
        slicedY: S(p) * T,
        sliced: h,
        labelText: u,
        toolText: n,
        name: s.name,
        link: s.link,
        percentage: F ? c * F / 100 : 0,
        originalIndex: L - w - 1,
        style: s.style,
        color: (0, o.toRaphaelColor)(s.color),
        borderColor: s.borderColor,
        borderWidth: s.borderWidth,
        rolloverProperties: s.hoverEffects,
        radius: M,
        center: [N, E],
        innerDiameter: 2 * I,
        centerLabelConfig: s.centerLabelConfig,
        isVisible: s.isVisible,
        label: s.seriesName,
        connector: void 0,
        transX: s.transX = _(p) * T,
        transY: s.transY = S(p) * T,
        slicedTranslation: s.slicedTranslation = "t" + _(p) * T + "," + S(p) * T
      });
    }, t.prototype.parseLabelAttributes = function (e) {
      var t,
          n,
          a,
          i,
          o,
          r = this.getFromEnv("chart").config,
          l = r.dataLabelStyle,
          s = this.config,
          c = r.style,
          u = r.textDirection,
          h = s.dataLabelOptions;
      (i = (t = e.config)._textAttrs) || (i = t._textAttrs = {}), n = t.y, a = t.displayValue, c = t.style, null !== n && n !== f && !1 !== t.isVisible && (a !== f ? (c && ((o = t._textCss) || (o = t._textCss = {}), o.fontFamily = c.fontFamily, o.fontSize = c.fontSize, o.lineHeight = c.lineHeight, o.fontWeight = c.fontWeight, o.fontStyle = c.fontStyle), t.plotItem.style = t.style = c || (c = l), i.text = a, i.fill = c.color || "#000000", i["text-bound"] = [c.backgroundColor, c.borderColor, c.borderThickness, c.borderPadding, c.borderRadius, c.borderDash], i.direction = u, i.lineHeight = c.lineHeight, i.visibility = x) : i.visibility = "hidden", t.props.label = {
        attr: i,
        css: o
      }, t.props.connector = {
        attr: {
          visibility: C,
          "stroke-width": h.connectorWidth,
          stroke: h.connectorColor || "#606060"
        }
      });
    }, t.prototype.draw = function () {
      var e,
          t,
          n,
          a,
          i,
          r,
          l,
          s,
          c,
          u,
          h,
          d,
          p,
          g,
          m,
          b,
          v,
          y,
          x,
          C,
          k,
          w,
          S,
          _ = this,
          L = _.getFromEnv("animationManager"),
          P = _.getFromEnv("chart").config,
          N = P.dataLabelStyle,
          E = _.config,
          F = E.showShadow,
          O = P.alphaanimation,
          T = _.components,
          D = T.data,
          M = T.removeDataArr = T.removeDataArr || [],
          I = P.style,
          R = _.pool,
          B = _.getState("visible"),
          j = T.data || [],
          G = j.length,
          H = P.canvasWidth,
          z = P.canvasHeight,
          q = P.canvasLeft + .5 * H,
          U = P.canvasTop + .5 * z,
          Y = E.handlersAPI.plotDragStart,
          X = E.handlersAPI.plotDragEnd,
          K = E.handlersAPI.plotDragMove,
          Z = E.handlersAPI.plotRollOver,
          J = E.handlersAPI.plotRollOut,
          $ = function () {
        var e = E.pieCenter || [],
            t = E.piePlotOptions || [],
            n = {
          cx: e[0],
          cy: e[1],
          r: t.size,
          r2: .5 * (E.innerSize || 0)
        };
        return function (e) {
          var t,
              a = !1;

          for (t in e) {
            if (A(e[t] - n[t]) > 5) {
              a = !0;
              break;
            }
          }

          return a;
        };
      }(),
          Q = E.piePlotOptions = _._parsePiePlotOptions(),
          ee = E.dataLabelOptions,
          te = Q.size,
          ne = .5 * (E.innerSize || 0),
          ae = {
        plot: {
          data: [],
          animType: "linear"
        },
        initial: {
          data: []
        },
        final: {
          data: []
        }
      },
          ie = _.getFromEnv("toolTipController");

      for (_.getContainer("pie-groups") || _._createContainer(), s = _.getContainer("plot-group"), c = _.getContainer("plot-shadow-group"), u = _.getContainer("label-group"), h = _.getContainer("connector-shadow-group"), d = _.getContainer("anchor-shadow-group"), _.config.drawn && (e = $({
        cx: q,
        cy: U,
        r: te,
        r2: ne
      }) && !1), u.css(N), x = E.valueTotal, B && x ? (s.show(), c.show(), u.show(), h.show(), d.show()) : (s.hide(), c.hide(), u.hide(), h.hide(), d.hide()), M.length && _.removeElement(ae), t = 0; t < G; t += 1) {
        p = (n = j[t]).graphics, (w = (g = n.config)._textAttrs) || (w = g._textAttrs = {}), m = g.y, b = g.displayValue, a = g.toolText, I = g.style, null !== m && m !== f && !1 !== g.isVisible && (r = p.element, y = p.label, k = p.connector, b !== f ? (I ? ((S = g._textCss) || (S = g._textCss = {}), S.fontFamily = I.fontFamily, S.fontSize = I.fontSize, S.lineHeight = I.lineHeight, S.fontWeight = I.fontWeight, S.fontStyle = I.fontStyle) : g._textCss && (y && y.removeCSS(), delete g._textCss, S = f), g.style = I || (I = N), w = g.props.label.attr, y ? S && (y.css(S), delete S.fontFamily, delete S.fontSize, delete S.lineHeight, delete S.fontWeight, delete S.fontStyle, S = f) : R && R.label && R.label.length && (y = p.label = R.label.splice(0, 1)[0]), y && L.setAnimation({
          el: y,
          attr: {
            opacity: 1
          },
          component: _
        }), ee.distance > 0 && ee.connectorWidth && ee.enableSmartLabels ? (k || R && R.connector.length && (k = p.connector = R.connector.splice(0, 1)[0]), C = L.setAnimation({
          el: k || "path",
          container: u,
          label: "connector",
          attr: g.props.connector.attr,
          component: _
        }).show(), k || (p.connector = C, C.on("fc-dragstart", Y).on("fc-dragmove", K).on("fc-dragend", X).on("fc-mouseover", Z).on("fc-mouseout", J)), L.setAnimation({
          el: C,
          attr: {
            opacity: 1
          },
          doNotRemove: !0,
          component: _
        })) : k && L.setAnimation({
          el: k,
          doNotRemove: !0,
          attr: {
            opacity: 0
          },
          component: _
        })) : (y && L.setAnimation({
          el: y,
          callback: W,
          doNotRemove: !0,
          component: _
        }), k && L.setAnimation({
          el: k,
          callback: W,
          doNotRemove: !0,
          component: _
        })), x ? (y && y.show(), C && C.show()) : (y && y.hide(), C && C.hide()), O && L.setAnimation({
          el: s,
          attr: {
            opacity: 1
          },
          component: _,
          callback: void 0
        }), x && L.setAnimation({
          el: u,
          attr: {
            opacity: 1
          },
          component: _
        }), i = L.setAnimation({
          el: r || "ringpath",
          attr: g.props.element.attr,
          label: "ringpath",
          props: {
            startAngle: _.config.startAngle
          },
          container: s,
          component: _
        }), r || (p.element = i, i.on("fc-dragstart", Y).on("fc-dragmove", K).on("fc-dragend", X).on("fc-click", V(_, i)).on("fc-mouseover", Z).on("fc-mouseout", J)), v = g.plotItem, l = g.eventArgs, v.graphic = i, i.show().shadow(F && g.shadow, c).data("plotItem", v).data("dataset", this).data("eventArgs", l), ie.enableToolTip(i, a), w.plotItem = v, w.eventArgs = l, C && C.data("plotItem", v).data("eventArgs", l));
      }

      _.placeDataLabels(!1, D, E, null, ae), !_.config.__attachRestoreColor && _.addExtEventListener("animationComplete", function () {
        var t, n;
        if (e) for (t = 0; t < G; t += 1) {
          (n = j[t]).graphics.element && n.graphics.element.attr({
            fill: (0, o.toRaphaelColor)(n.config.color)
          });
        }
      }, L), _.config.__attachRestoreColor = !0, _.config.drawn = !0;
    }, t.prototype.sliceInOtherPies = function (e) {
      var t,
          n = this.components.data,
          a = n.length,
          i = 0;

      for (this.enableMultiSlicing = !0; a--;) {
        a !== e && (t = n[a]).config.sliced && ++i && this.plotGraphicClick.call(t.graphics);
      }

      return this.enableMultiSlicing = !1, !!i;
    }, t.prototype.removeElement = function () {
      var e,
          t,
          n,
          a,
          i = this.getFromEnv("animationManager"),
          o = this.getFromEnv("chart").config,
          r = this.components.removeDataArr || [],
          l = this.pool = this.pool = {},
          s = r.length,
          c = this.config,
          u = o.canvasWidth,
          h = o.canvasHeight,
          d = o.canvasLeft + .5 * u,
          p = o.canvasTop + .5 * h,
          f = this.hideElements,
          g = c.pieMinRadius,
          m = .5 * (c.innerSize || 0),
          b = c.startAngle - D;

      for (a = 0; a < s; a++) {
        for (t in n = r[0].graphics) {
          (e = n[t]) && ("element" === t ? i.setAnimation({
            el: e,
            attr: {
              ringpath: [d, p, g, m, b, b + .01],
              transform: ""
            },
            callback: f,
            component: this
          }) : i.setAnimation({
            el: e,
            attr: {
              opacity: 0
            },
            callback: f,
            component: this
          }), l[t] || (l[t] = []), l[t].push(e));
        }

        r.splice(0, 1);
      }
    }, t.prototype.getEventArgs = function (e) {
      var t = e.config.index,
          n = this.components.data[t].config || {};
      return {
        datasetName: n.seriesName,
        datasetIndex: t,
        id: n.userID,
        visible: n.isVisible,
        label: n.seriesName,
        value: n.value,
        percentValue: n.pValue,
        tooltext: n.toolText,
        link: n.link,
        sliced: n.sliced
      };
    }, t.prototype.remove = function (t) {
      var n = this.config.legendItemId,
          a = this.getFromEnv("legend");
      a && n && a.disposeItem(n), e.prototype.remove.call(this, t);
    }, t;
  }(i["default"]);

  t["default"] = K, t.plotGraphicClick = B, t.trimData = X, t.labelClickFn = z, t.plotClickHandler = V, t.hideFn = W;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  t["default"] = {
    "initial.dataset.pie2D": function initialDatasetPie2D() {
      return {
        "group.appearing": function groupAppearing(e) {
          return [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: e.component.getFromEnv("chartConfig").alphaanimation ? "plot" : "initial"
          }];
        },
        "ringpath.appearing": function ringpathAppearing(e) {
          var t = e.component,
              n = e.attr.ringpath.slice(0),
              a = e.attr.ringpath.slice(0),
              i = e.props.startAngle,
              o = e.component.config,
              r = t.getFromEnv("chartConfig"),
              l = o.animateClockWise;
          return r.alphaanimation ? [{}] : (l && (a[4] += 2 * Math.PI, a[5] += 2 * Math.PI), n[4] = i, n[5] = i, [{
            initialAttr: {
              ringpath: n
            },
            finalAttr: {
              ringpath: a,
              transform: ""
            },
            startEnd: {
              start: 0,
              end: .75
            },
            effect: "linear",
            slot: "plot"
          }, {
            initialAttr: {
              transform: "",
              ringpath: a
            },
            finalAttr: {
              ringpath: a
            },
            startEnd: {
              start: .75,
              end: 1
            },
            effect: "linear",
            slot: "plot"
          }]);
        },
        "label.appearing": [{
          initialAttr: {
            opacity: "0"
          },
          finalAttr: {
            opacity: "1"
          },
          slot: "final"
        }],
        "connector.updating": function connectorUpdating(e) {
          return [{
            initialAttr: {
              path: e.attr.path,
              "stroke-opacity": "0"
            },
            finalAttr: {
              "stroke-opacity": "1"
            },
            slot: "final"
          }];
        },
        "label.updating": function labelUpdating(e) {
          return [{
            initialAttr: {
              x: e.el.attrs.x
            },
            slot: "plot"
          }];
        }
      };
    },
    "slicing.dataset.pie2D": function slicingDatasetPie2D() {
      return {
        "slice.updating": function sliceUpdating(e) {
          return "t0,0" !== (e.attr && e.attr.transform) ? [{
            initialAttr: {
              transform: "t0,0"
            },
            slot: "plot"
          }] : [{
            finalAttr: {
              transform: "t0,0"
            },
            slot: "plot"
          }];
        }
      };
    }
  };
},, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.manageGradientLegendSpace = t._manageLegendSpace = undefined;
  var a = n(125);
  t._manageLegendSpace = function () {
    var e,
        t,
        n,
        i,
        o = this.config,
        r = this.getChildren("legend") && this.getChildren("legend")[0],
        l = this.getChildren("gLegend") && this.getChildren("gLegend")[0],
        s = this.getFromEnv("dataSource").colorrange,
        c = o.hasLegend,
        u = {},
        h = this.hasGradientLegend,
        d = this.getFromEnv("dataSource").chart,
        p = (0, a.pluckNumber)(d.mapbycategory, 0);
    h && s && (0, a.pluckNumber)(s.gradient) && !p ? (e = l.conf, h = !0, o.gLegendEnabled = !0, i = .5, t = e.legendPosition) : (e = r && r.config, h = !1, o.gLegendEnabled = !1, i = (t = e && e.legendPos) === a.POSITION_RIGHT ? .8 : .4), n = t === a.POSITION_RIGHT ? o.availableWidth * i : o.availableHeight * i, h ? u = this.manageGradientLegendSpace(n) : !1 !== c && r && !r.getState("removed") && (u = r && r._manageLegendPosition(n)), this._allocateSpace({
      bottom: u && u.bottom || 0,
      right: u && u.right || 0
    });
  }, t.manageGradientLegendSpace = function (e) {
    var t,
        n,
        i,
        o,
        r = this.config,
        l = this.getFromEnv("gLegend"),
        s = l && l.conf;
    return r.gLegendPadding = (0, a.pluckNumber)(this.getFromEnv("chart-attrib").legendpadding, 10), i = Math.min(r.gLegendPadding, .5 * e), s ? (t = s.legendPosition, o = l.getLogicalSpace(e), n = t === a.POSITION_BOTTOM ? {
      bottom: (o.height || 0) + i
    } : {
      right: (o.width || 0) + i
    }) : n = {
      bottom: 0,
      right: 0
    }, n;
  };
},,,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  };

  t["default"] = function (e) {
    var t,
        n,
        i,
        o = window.parseFloat,
        r = e._createNode,
        l = e._setFillAndStroke,
        s = e.el.constructor,
        c = {
      Q: "L",
      Z: "X",
      q: "l",
      z: "x",
      ",": " "
    },
        u = /,?([achlmqrstvxz]),?/gi,
        h = function h() {
      return this.join(",").replace(u, t);
    };

    e.svg ? (t = "$1", n = function n() {
      var n = e.is(arguments[0], "array") ? arguments[0] : Array.prototype.slice.call(arguments);
      n ? "string" == typeof n ? n = n.replace(u, t) : n.toString = h : n = "M0,0", this.node.setAttribute("d", n.toString());
    }, e._engine.litepath = function (t, n, a, i, o) {
      var c,
          u = r("path");
      return (i || n).canvas.appendChild(u), (c = new s(u, n, i)).type = "litepath", c.id = u.raphaelid = e._oid++, u.raphael = !0, l(c, o || {
        fill: "none",
        stroke: "#000"
      }), c;
    }, e._getPath.litepath = function (t) {
      return e.parsePathString(t.node.getAttribute("d"));
    }) : e.vml && (t = function t(e, _t9) {
      return c[_t9] || _t9;
    }, i = function i() {
      var e = this;
      return e._transform.apply(e, arguments), e._.bcoord && (e.node.coordsize = e._.bcoord), e;
    }, n = function n(e) {
      return e ? "string" == typeof e ? e = e.replace(u, t) : e.toString = h : e = "M0,0", this.node.path = e, this;
    }, e._engine.litepath = function (t, n, a, l, c) {
      var u,
          h = r("shape"),
          d = h.style,
          p = new s(h, n, l),
          f = c || {
        fill: "none",
        stroke: "#000"
      };
      return d.cssText = "position:absolute;left:0;top:0;width:21600px;height:21600px;", a = o(a), isNaN(a) ? h.coordsize = "21600 21600" : (p._.bzoom = a, d.width = "1px", d.height = "1px", h.coordsize = p._.bcoord = a + " " + a), h.coordorigin = n.coordorigin, p.type = "litepath", p.id = h.raphaelid = e._oid++, h.raphael = !0, p._transform = p.transform, p.transform = i, e._setFillAndStroke(p, f), (l || n).canvas.appendChild(h), (u = r("skew")).on = !0, h.appendChild(u), p.skew = u, p;
    }, e._getPath.litepath = function (t) {
      return e.parsePathString(t.node.path || "");
    }), e.fn.litepath = function (t, i, o) {
      var r, l, c;
      return "object" === (void 0 === t ? "undefined" : a(t)) && t.constructor !== s && (r = t, l = (t = t.litepath).zoom, o = t.group), i && i.constructor === s ? (o = i, l = void 0) : l = i, t && t.constructor === s && (o = t, t = ""), (c = e._engine.litepath(t, this, l, o, r)).ca.litepath = n, t && c.attr("litepath", e.is(t, "array") ? [t] : t), this.__set__ && this.__set__.push(c), this._elementsById[c.id] = c;
    };
  };
},,,,,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.setAxisDimention = t.getSpecificyAxisConf = t.getSpecificxAxisConf = t._feedAxesRawData = undefined;
  var a = l(n(459)),
      i = l(n(496)),
      o = n(125),
      r = l(n(497));

  function l(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function s(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var c,
      u,
      h,
      d,
      p = Math.max,
      f = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.registerFactory("axis", i["default"], ["canvas"]), n.registerFactory("dataset", r["default"], ["vCanvas"]), n;
    }

    return s(t, e), t.getName = function () {
      return "MSDyBaseCartesian";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this), this.config.syncaxislimits = 0;
    }, t.prototype._feedAxesRawData = function () {
      var e,
          t,
          n,
          a,
          i,
          r,
          l,
          s,
          c,
          u = this.config,
          h = this.getFromEnv("color-manager"),
          d = this.getFromEnv("dataSource"),
          p = this.getFromEnv("chart-attrib"),
          f = this.config.is3D,
          g = f ? o.chartPaletteStr.chart3D : o.chartPaletteStr.chart2D,
          m = u.primaryAxisOnleft = (0, o.pluckNumber)(p.primaryaxisonleft, 1),
          b = (0, o.pluckNumber)(p.syncaxislimits, 0),
          v = [{
        line: []
      }],
          y = [{
        line: []
      }],
          x = d.trendlines || [],
          C = (0, o.pluckNumber)(p.showzeroplane, 1),
          k = (0, o.pluckNumber)(p.showzeroplanevalue);

      for (C || k !== o.UNDEF || (k = 0), e = this.getSpecificxAxisConf(), t = this.getSpecificyAxisConf(), n = {
        isActive: !1,
        isPercent: this.isPercentage,
        axisIndex: 1,
        uniqueClassName: 1,
        outCanfontFamily: (0, o.pluck)(p.outcnvbasefont, p.basefont, "Verdana,sans"),
        outCanfontSize: (0, o.pluckFontSize)(p.outcnvbasefontsize, p.basefontsize, 10),
        outCancolor: (0, o.pluck)(p.outcnvbasefontcolor, p.basefontcolor, h.getColor(g.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi, "#$1"),
        axisNamePadding: p.yaxisnamepadding,
        axisValuePadding: p.yaxisvaluespadding,
        axisNameFont: p.syaxisnamefont,
        axisNameFontSize: p.syaxisnamefontsize,
        axisNameFontColor: p.syaxisnamefontcolor,
        axisNameFontBold: p.syaxisnamefontbold,
        axisNameFontItalic: p.syaxisnamefontitalic,
        axisNameBgColor: p.syaxisnamebgcolor,
        axisNameBorderColor: p.syaxisnamebordercolor,
        axisNameAlpha: p.syaxisnamealpha,
        axisNameFontAlpha: p.syaxisnamefontalpha,
        axisNameBgAlpha: p.syaxisnamebgalpha,
        axisNameBorderAlpha: p.syaxisnameborderalpha,
        axisNameBorderPadding: p.syaxisnameborderpadding,
        axisNameBorderRadius: p.syaxisnameborderradius,
        axisNameBorderThickness: p.syaxisnameborderthickness,
        axisNameBorderDashed: p.syaxisnameborderdashed,
        axisNameBorderDashLen: p.syaxisnameborderdashlen,
        axisNameBorderDashGap: p.syaxisnameborderdashgap,
        axisNameWidth: p.syaxisnamewidth,
        useEllipsesWhenOverflow: p.useellipseswhenoverflow,
        rotateAxisName: (0, o.pluckNumber)(p.rotateyaxisname, 1),
        axisName: p.syaxisname,
        divLineColor: (0, o.pluck)(p.divlinecolor, h.getColor(g.divLineColor)),
        divLineAlpha: (0, o.pluck)(p.divlinealpha, h.getColor("divLineAlpha")),
        divLineThickness: (0, o.pluckNumber)(p.divlinethickness, 1),
        divLineIsDashed: Boolean((0, o.pluckNumber)(p.divlinedashed, p.divlineisdashed, 0)),
        divLineDashLen: (0, o.pluckNumber)(p.divlinedashlen, 4),
        divLineDashGap: (0, o.pluckNumber)(p.divlinedashgap, 2),
        showAlternateGridColor: (0, o.pluckNumber)(p.showalternatehgridcolor, 1),
        alternateGridColor: (0, o.pluck)(p.alternatehgridcolor, h.getColor("altHGridColor")),
        alternateGridAlpha: (0, o.pluck)(p.alternatehgridalpha, h.getColor("altHGridAlpha")),
        numDivLines: p.numdivlines,
        axisMinValue: b ? (0, o.pluckNumber)(p.syaxisminvalue, p.pyaxisminvalue, p.yaxisminvalue) : p.syaxisminvalue,
        axisMaxValue: b ? (0, o.pluckNumber)(p.syaxismaxvalue, p.pyaxismaxvalue, p.yaxismaxvalue) : p.syaxismaxvalue,
        setAdaptiveMin: p.setadaptivesymin || p.setadaptiveymin,
        adjustDiv: p.adjustdiv,
        labelStep: p.yaxisvaluesstep,
        showAxisValues: (0, o.pluckNumber)(p.showsyaxisvalues, p.showsyaxisvalue, p.showyaxisvalues, p.showyaxisvalue),
        showLimits: (0, o.pluckNumber)(p.showsecondarylimits, p.showyaxislimits, p.showlimits),
        showDivLineValues: (0, o.pluckNumber)(p.showdivlinesecondaryvalue, p.showyaxisvalues, p.showyaxisvalue, 1),
        showZeroPlane: C,
        zeroPlaneColor: p.zeroplanecolor,
        zeroPlaneThickness: (0, o.pluckNumber)(p.zeroplanethickness, p.divlinethickness, 2),
        zeroPlaneAlpha: p.zeroplanealpha,
        showZeroPlaneValue: k,
        trendlineColor: p.trendlinecolor,
        trendlineToolText: p.trendlinetooltext,
        trendlineThickness: p.trendlinethickness,
        trendlineAlpha: p.trendlinealpha,
        showTrendlinesOnTop: p.showtrendlinesontop,
        showAxisLine: f ? 0 : (0, o.pluckNumber)(p.showsyaxisline, p.showaxislines, p.drawAxisLines, 0),
        axisLineThickness: (0, o.pluckNumber)(p.syaxislinethickness, p.axislinethickness, 1),
        axisLineAlpha: (0, o.pluckNumber)(p.syaxislinealpha, p.axislinealpha, 100),
        axisLineColor: (0, o.pluck)(p.syaxislinecolor, p.axislinecolor, "#000000")
      }, e.vtrendlines = (0, o.extend2)([], d.vtrendlines), s = 0, l = x.length; s < l; s++) {
        for (r = (a = x[s] && x[s].line || []).length, c = 0; c < r; c++) {
          "s" === (i = a[c] || {}).parentyaxis ? v[0].line.push(i) : y[0].line.push(i);
        }
      }

      return t.trendlines = (0, o.extend2)([], y), n.trendlines = (0, o.extend2)([], v), 1 === m ? (t.isVertical = !0, t.isReverse = !0, t.isOpposit = !1, n.isVertical = !0, n.isReverse = !0, n.isOpposit = !0) : (t.isVertical = !0, t.isReverse = !0, t.isOpposit = !0, n.isVertical = !0, n.isReverse = !0, n.isOpposit = !1), {
        yAxisConf: [t, n],
        xAxisConf: [e]
      };
    }, t.prototype.getSpecificxAxisConf = function () {
      var e = this.getFromEnv("chart-attrib"),
          t = this.config.is3D,
          n = this.getBasexAxisConf(),
          a = this.config;
      return n.zeroPlaneThickness = (0, o.pluckNumber)(e.vzeroplanethickness, e.vdivlinethickness, 2), n.zeroPlaneAlpha = (0, o.pluckNumber)(e.vzeroplanealpha, e.vdivlinealpha, a.zeroplanealpha), n.showZeroPlaneValue = e.showvzeroplanevalue, n.showAxisLine = t ? 0 : (0, o.pluckNumber)(e.showxaxisline, e.showaxislines, e.drawAxisLines, 0), n.axisLineColor = (0, o.pluck)(e.xaxislinecolor, e.axislinecolor, "#000000"), n.isReverse = !1, n.showAlternateGridColor = (0, o.pluckNumber)(e.showalternatevgridcolor, 0), n.numDivLines = e.numvdivlines, n.maxLabelHeight = e.maxlabelheight, n.axisName = e.xaxisname, n.setAdaptiveMin = e.setadaptivexmin, n.showLimits = e.showvlimits, n.showDivLineValues = (0, o.pluckNumber)(e.showvdivlinevalues, e.showvdivlinevalues), n;
    }, t.prototype.getSpecificyAxisConf = function () {
      var e = this.getFromEnv("chart-attrib"),
          t = this.config.is3D,
          n = t ? o.chartPaletteStr.chart3D : o.chartPaletteStr.chart2D,
          a = this.config,
          i = this.getFromEnv("color-manager"),
          r = (0, o.pluckNumber)(e.syncaxislimits, 0),
          l = (0, o.pluckNumber)(e.showzeroplane, 1),
          s = (0, o.pluckNumber)(e.showzeroplanevalue);
      return l || s !== o.UNDEF || (s = 0), {
        outCanfontFamily: (0, o.pluck)(e.outcnvbasefont, e.basefont, "Verdana,sans"),
        outCanfontSize: (0, o.pluckFontSize)(e.outcnvbasefontsize, e.basefontsize, 10),
        outCancolor: (0, o.pluck)(e.outcnvbasefontcolor, e.basefontcolor, i.getColor(n.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi, "#$1"),
        axisNamePadding: (0, o.pluckNumber)(e.pyaxisnamepadding, e.yaxisnamepadding),
        axisValuePadding: (0, o.pluckNumber)(e.pyaxisvaluespadding, e.yaxisvaluespadding),
        axisNameFont: (0, o.pluck)(e.pyaxisnamefont, e.yaxisnamefont),
        axisNameFontSize: (0, o.pluckNumber)(e.pyaxisnamefontsize, e.yaxisnamefontsize),
        axisNameFontColor: (0, o.pluck)(e.pyaxisnamefontcolor, e.yaxisnamefontcolor),
        axisNameFontBold: (0, o.pluckNumber)(e.pyaxisnamefontbold, e.yaxisnamefontbold),
        axisNameFontItalic: (0, o.pluckNumber)(e.pyaxisnamefontitalic, e.yaxisnamefontitalic),
        axisNameBgColor: (0, o.pluck)(e.pyaxisnamebgcolor, e.yaxisnamebgcolor),
        axisNameBorderColor: (0, o.pluck)(e.pyaxisnamebordercolor, e.yaxisnamebordercolor),
        axisNameAlpha: (0, o.pluckNumber)(e.pyaxisnamealpha, e.yaxisnamealpha),
        axisNameFontAlpha: (0, o.pluckNumber)(e.pyaxisnamefontalpha, e.yaxisnamefontalpha),
        axisNameBgAlpha: (0, o.pluckNumber)(e.pyaxisnamebgalpha, e.yaxisnamebgalpha),
        axisNameBorderAlpha: (0, o.pluckNumber)(e.pyaxisnameborderalpha, e.yaxisnameborderalpha),
        axisNameBorderPadding: (0, o.pluckNumber)(e.pyaxisnameborderpadding, e.yaxisnameborderpadding),
        axisNameBorderRadius: (0, o.pluckNumber)(e.pyaxisnameborderradius, e.yaxisnameborderradius),
        axisNameBorderThickness: (0, o.pluckNumber)(e.pyaxisnameborderthickness, e.yaxisnameborderthickness),
        axisNameBorderDashed: (0, o.pluckNumber)(e.pyaxisnameborderdashed, e.yaxisnameborderdashed),
        axisNameBorderDashLen: (0, o.pluckNumber)(e.pyaxisnameborderdashlen, e.yaxisnameborderdashlen),
        axisNameBorderDashGap: (0, o.pluckNumber)(e.pyaxisnameborderdashgap, e.yaxisnameborderdashgap),
        axisNameWidth: (0, o.pluckNumber)(e.pyaxisnamewidth, e.yaxisnamewidth),
        useEllipsesWhenOverflow: e.useellipseswhenoverflow,
        rotateAxisName: (0, o.pluckNumber)(e.rotateyaxisname, 1),
        axisName: (0, o.pluck)(e.pyaxisname, e.yaxisname),
        divLineColor: (0, o.pluck)(e.divlinecolor, i.getColor(n.divLineColor)),
        divLineAlpha: (0, o.pluck)(e.divlinealpha, i.getColor("divLineAlpha")),
        divLineThickness: (0, o.pluckNumber)(e.divlinethickness, 1),
        divLineIsDashed: Boolean((0, o.pluckNumber)(e.divlinedashed, e.divlineisdashed, 0)),
        divLineDashLen: (0, o.pluckNumber)(e.divlinedashlen, 4),
        divLineDashGap: (0, o.pluckNumber)(e.divlinedashgap, 2),
        showAlternateGridColor: (0, o.pluckNumber)(e.showalternatehgridcolor, 1),
        alternateGridColor: (0, o.pluck)(e.alternatehgridcolor, i.getColor("altHGridColor")),
        alternateGridAlpha: (0, o.pluck)(e.alternatehgridalpha, i.getColor("altHGridAlpha")),
        numDivLines: e.numdivlines,
        axisMinValue: r ? (0, o.pluckNumber)(e.syaxisminvalue, e.pyaxisminvalue, e.yaxisminvalue) : (0, o.pluckNumber)(e.pyaxisminvalue, e.yaxisminvalue),
        axisMaxValue: r ? (0, o.pluckNumber)(e.syaxismaxvalue, e.pyaxismaxvalue, e.yaxismaxvalue) : (0, o.pluckNumber)(e.pyaxismaxvalue, e.yaxismaxvalue),
        setAdaptiveMin: e.setadaptiveymin,
        adjustDiv: e.adjustdiv,
        labelStep: e.yaxisvaluesstep,
        showAxisValues: (0, o.pluckNumber)(e.showyaxisvalues, e.showyaxisvalue),
        showLimits: (0, o.pluckNumber)(e.showyaxislimits, e.showlimits, this.showLimits),
        showDivLineValues: (0, o.pluckNumber)(e.showdivlinevalues, e.showdivlinevalue),
        showZeroPlane: l,
        zeroPlaneColor: e.zeroplanecolor,
        zeroPlaneThickness: (0, o.pluckNumber)(e.zeroplanethickness, e.divlinethickness, a.zeroplanethickness, 2),
        zeroPlaneAlpha: (0, o.pluckNumber)(e.zeroplanealpha, e.divlinealpha, a.zeroplanealpha),
        showZeroPlaneValue: s,
        showZeroPlaneOnTop: a.showzeroplaneontop,
        trendlineColor: e.trendlinecolor,
        trendlineToolText: e.trendlinetooltext,
        trendlineThickness: e.trendlinethickness,
        trendlineAlpha: e.trendlinealpha,
        showTrendlinesOnTop: e.showtrendlinesontop,
        showAxisLine: t ? 0 : (0, o.pluckNumber)(e.showyaxisline, e.showaxislines, e.drawAxisLines, 0),
        axisLineThickness: (0, o.pluckNumber)(e.yaxislinethickness, e.axislinethickness, 1),
        axisLineAlpha: (0, o.pluckNumber)(e.yaxislinealpha, e.axislinealpha, 100),
        axisLineColor: (0, o.pluck)(e.yaxislinecolor, e.axislinecolor, "#000000"),
        forceTrendBelow: !!a.is3D
      };
    }, t.prototype.setAxisDimention = function () {
      var e,
          t,
          n = this.config,
          a = this.getChildren(),
          i = a.yAxis,
          o = a.xAxis && a.xAxis[0],
          r = i[0],
          l = i[1],
          s = n.xDepth,
          c = a.canvas[0].config,
          u = c.canvasBorderWidth,
          h = c.canvasPadding,
          d = c.canvasPaddingLeft,
          f = c.canvasPaddingRight,
          g = c.canvasPaddingTop,
          m = n.primaryAxisOnleft,
          b = c.canvasPaddingBottom;
      o && o.setAxisDimention({
        x: n.canvasLeft + (s || 0) + p(d, h),
        y: n.canvasBottom + (n.shift || 0) + u,
        opposite: n.canvasTop - u,
        axisLength: n.canvasWidth - (s || 0) - p(d, h) - p(f, h)
      }), m ? (n.yAxisStartXPos = n.canvasLeft - u, n.sYAxisStartXPos = n.canvasRight + u) : (n.yAxisStartXPos = n.canvasRight + u, n.sYAxisStartXPos = n.canvasLeft - u), e = n.yAxisStartXPos, t = n.sYAxisStartXPos, r && r.setAxisDimention({
        x: e,
        y: n.canvasTop + g,
        opposite: t,
        axisLength: n.canvasHeight - g - b
      }), l && l.setAxisDimention({
        x: t,
        y: n.canvasTop + g,
        opposite: e,
        axisLength: n.canvasHeight - g - b
      });
    }, t;
  }(a["default"]);

  t._feedAxesRawData = c = f.prototype._feedAxesRawData, t.getSpecificxAxisConf = u = f.prototype.getSpecificxAxisConf, t.getSpecificyAxisConf = h = f.prototype.getSpecificyAxisConf, t.setAxisDimention = d = f.prototype.setAxisDimention, t._feedAxesRawData = c, t.getSpecificxAxisConf = u, t.getSpecificyAxisConf = h, t.setAxisDimention = d, t["default"] = f;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    var t,
        n = e.getChildren("canvas")[0],
        r = function r(e, t) {
      return JSON.stringify(e) !== JSON.stringify(t);
    },
        l = {
      zoomable: !0,
      pannable: !0
    },
        s = void 0,
        c = !!Number(e.config.syncaxislimits),
        u = void 0,
        h = n.getChildren("axisRefVisualCartesian")[0],
        d = e._feedAxesRawData(),
        p = function p(e) {
      var t = e.sender;
      h.addexplicitDrawItems(t.getId(), t), h.asyncDraw();
    };

    (0, a.componentFactory)(e, o["default"], "xAxis", 1, d.xAxisConf), (0, a.componentFactory)(e, i["default"], "yAxis", 2, d.yAxisConf), s = (t = e.getChildren()).xAxis[0], (u = t.yAxis).forEach(function (t) {
      t.setLinkedItem("canvas", n), h.setLinkedItem(t.getId(), t), h.addExtEventListener("visiblerangeset", p, t), n.attachAxis(t, !0, e.zoomY ? l : {});
    }), s.setLinkedItem("canvas", n), h.setLinkedItem(s.getId(), s), u[1].setAxisConfig({
      dependentInfo: {
        id: u[0].getId(),
        count: !0,
        limit: c
      }
    }), u[1].getState("divlineEventAdded") || (u[1].addExtEventListener("divlinesSet", function (e) {
      var t = u[1].config.dependentInfo;
      e.sender.getId() === t.id && (t.numDivLines = e.data);
    }, u[0]), u[1].setState("divlineEventAdded", !0)), c && (u[1].getState("dataLimitEventAdded") || (u[1].addExtEventListener("dataLimitSet", function (e) {
      var t = u[1].config.dependentInfo;
      e.sender.getId() === t.id && r(t.dataLimit, e.data) && (t.dataLimit = e.data, u[1].config.isDataLimitSet && u[1].setDataLimit());
    }, u[0]), u[1].setState("dataLimitEventAdded", !0)), u[0].setAxisConfig({
      dependentInfo: {
        id: u[1].getId(),
        limit: !0
      }
    }), u[0].getState("dataLimitEventAdded") || (u[0].addExtEventListener("dataLimitSet", function (e) {
      var t = u[0].config.dependentInfo;
      e.sender.getId() === t.id && r(t.dataLimit, e.data) && (t.dataLimit = e.data, u[0].setDataLimit());
    }, u[1]), u[0].setState("dataLimitEventAdded", !0))), h.addExtEventListener("visiblerangeset", p, s), n.attachAxis(s, !1, e.zoomX ? l : {}), e._setCategories();
  };
  var a = n(125),
      i = r(n(377)),
      o = r(n(422));

  function r(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    var t = e.getFromEnv("dataSource").dataset,
        n = e.getChildren().canvas[0].getChildren("vCanvas"),
        r = n[0],
        l = n[1],
        s = void 0,
        c = e.getFromEnv("chartConfig").isdual,
        u = void 0,
        h = {
      vCanvasDatasetsDef0: {},
      vCanvasDatasetsDef1: {}
    },
        d = void 0,
        p = void 0,
        f = void 0,
        g = void 0,
        m = void 0,
        b = void 0,
        v = void 0,
        y = {},
        x = {};

    for (t || e.setChartMessage(), u = 0; u < t.length; u++) {
      "s" === (m = (s = t[u]).parentyaxis || "").toLowerCase() && c ? (g = (0, a.pluck)(s.renderas, e.config.sDefaultDatasetType), b = l, v = x, d = h.vCanvasDatasetsDef1) : (g = (0, a.pluck)(s.renderas, e.config.defaultDatasetType), b = r, v = y, d = h.vCanvasDatasetsDef0), g = e.getDSType(g, "s" === m.toLowerCase()), (f = e.getDSGroupdef(g, "s" === m.toLowerCase())) && ((0, a.componentFactory)(b, f, o), v[f.getName().toLowerCase()] = !0), v[g.toLowerCase()] = !0, d[g] ? (d[g].conf.push(s), d[g].indices.push(u)) : (d[g] = {}, d[g].indices = [u], d[g].classDef = e.getDSdef(g), d[g].conf = [s], d[g].pYAxis = m.toLowerCase(), d[g].parent = f ? b.getChildren(o)[0] : b);
    }

    for (var C in e.config._hascolumn = !1, h) {
      if (h.hasOwnProperty(C)) for (g in d = h[C]) {
        d.hasOwnProperty(g) && ("group" === (p = d[g]).parent.getType() && p.parent.configure(p.conf), (0, a.datasetFactory)(p.parent, p.classDef, "dataset_" + g, p.conf.length, p.conf, p.indices), "column" === g && (e.config._hascolumn = !0));
      }
    }

    (0, i.removeComponents)(n[0], Object.keys(y)), (0, i.removeComponents)(n[1], Object.keys(x));
  };
  var a = n(125),
      i = n(498),
      o = "multiseriesColumnManager";
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;

  t.removeComponents = function (e, t) {
    e && e.iterateComponents(function (e) {
      -1 !== t.indexOf(e.getName().toLowerCase()) || e.getLinkedParent().getState("removed") || e.remove();
    });
  };
},,,,,,,,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = c(n(450)),
      i = n(125),
      o = c(n(511)),
      r = n(132),
      l = n(512),
      s = c(n(513));

  function c(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function u(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var h = i.preDefStr.setRolloverAttrStr,
      d = i.preDefStr.setRolloutAttrStr;
  (0, r.addDep)({
    name: "mssplineareaAnimation",
    type: "animationRule",
    extension: s["default"]
  });

  var p = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.drawCommonElements = i.stubFN, n;
    }

    return u(t, e), t.prototype.getType = function () {
      return "dataset";
    }, t.prototype.configureAttributes = function (t) {
      e.prototype.configureAttributes && e.prototype.configureAttributes.call(this, t), o["default"].call(this);
    }, t.prototype.getDataLimits = function () {
      return {
        max: this.config.maxValue,
        min: this.config.minValue
      };
    }, t.prototype.drawPlots = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          s,
          c,
          u,
          p,
          f,
          g,
          m,
          b,
          v,
          y,
          x,
          C,
          k,
          w,
          S,
          _,
          L,
          P,
          A = this.config,
          N = this.getFromEnv("chart"),
          E = N.config,
          F = this.getFromEnv("xAxis"),
          O = null,
          T = [],
          D = this.components.data,
          M = E.connectnulldata,
          I = E.minimizetendency,
          R = A.plotbordercolor,
          V = A.plotborderalpha,
          B = A.plotBorderDashStyle,
          j = A.plotborderthickness,
          G = this.getContainer(),
          H = [],
          z = this.getGraphicalElement("splineElement"),
          W = A.fillColor,
          q = this.components.removeDataArr || [],
          U = q.length,
          Y = G && G.shadowGroup,
          X = A.shadow,
          K = this.getState("visible"),
          Z = {},
          J = !E.drawfullareaborder,
          $ = this.getGraphicalElement("connector"),
          Q = this.getFromEnv("animationManager"),
          ee = A._oldStartIndex,
          te = A._oldEndIndex,
          ne = this.config.JSONData.renderas || N.config.defaultDatasetType,
          ae = /area/gi.test(ne);

      for (A.imagesLoaded = 0, D || (D = this.components.data), e = F.getTicksLen(), L = A.scrollMinVal, P = A.scrollMaxVal, L > ee && this.flushOnScroll(ee, L > te ? te : L), P < te && this.flushOnScroll(P < ee ? ee : P, te), A._oldStartIndex = L, A._oldEndIndex = P, t = L; t < P; t++) {
        (c = D[t]) && (f = (s = c && c.config).setValue, C = (Z = s.anchorProps).shadow, u = c.graphics.element, p = c.graphics.hotElement, w = c.graphics.image, null === f ? (u && u.hide(), p && p.hide(), w && w.hide(), M || (O = null)) : (o = s._Py, a = s._Px, !1 === K && (o = s._Pby), T.push({
          x: a,
          y: o,
          lastXPos: r,
          lastYPos: O
        }), r = a, O = o, b = Z.anchorAlpha, x = Z.radius && b, m = s.hoverEffects, y = u ? K && x ? "updating" : "disappearing" : "appearing", Z.imageUrl ? this.drawAnchorImage(c) : (v = Object.assign({}, s.props.element.attr), "disappearing" !== y && K || (v = i.UNDEF), u = c.graphics.element = Q.setAnimation({
          el: u || "path",
          attr: v,
          container: G.plotGroup,
          component: this,
          label: "anchor"
        }), w && w.hide(), u && u.show().shadow(C, G.anchorShadowGroup).data("anchorRadius", Z.radius).data("anchorHoverRadius", m.anchorRadius).data("eventArgs", s.eventArgs), m.enabled && u && u.data("anchorRadius", Z.radius).data("anchorHoverRadius", m.anchorRadius).data("hoverEnabled", m.enabled).data(h, m.attrs.setRolloverAttr).data(d, m.attrs.setRolloutAttr))));
      }

      for (n = e, S = {
        path: H = (H = (0, l.getSplinePath)(T, s && s._Pby, I, ae, n).closedPath).join(),
        stroke: (0, i.toRaphaelColor)({
          color: R,
          alpha: V
        }),
        "stroke-width": J ? 0 : j,
        fill: (0, i.toRaphaelColor)(W),
        "stroke-linecap": "round",
        "stroke-linejoin": j > 2 ? "round" : "miter",
        "stroke-dasharray": B
      }, this.getState("visible") || (S = i.UNDEF), !(g = Q.setAnimation({
        el: z || "path",
        attr: S,
        container: G.commonElemsGroup,
        component: this,
        label: "line"
      })) && z && this.removeGraphicalElement(z), z || this.addGraphicalElement("splineElement", g), "" !== H && this.getState("visible") ? g.show().shadow(X, Y) : g && g.hide(), J && (_ = {
        path: [],
        stroke: (0, i.toRaphaelColor)({
          color: R,
          alpha: V
        }),
        "stroke-width": j,
        "stroke-linecap": "round",
        "stroke-linejoin": j > 2 ? "round" : "miter",
        "stroke-dasharray": B,
        name: "connector"
      }, k = Q.setAnimation({
        el: $ || "path",
        attr: _,
        container: G.areaGroup,
        state: $ ? this.getState("visible") ? "updating" : "disappearing" : "appearing",
        component: this,
        label: "line"
      }), $ || this.addGraphicalElement("connector", k)), t = 0; t < U; t++) {
        this._removeDataVisuals(q.shift());
      }
    }, t.prototype.getName = function () {
      return "splinearea";
    }, t;
  }(a["default"]);

  t["default"] = p;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;

  var a = function a(e, t, n) {
    var a,
        o,
        r,
        l,
        s = {};

    for (o = 0; o < e.length; ++o) {
      s["D" + e[o].index] = 0;
    }

    for (a = 0; a < 10; ++a) {
      for (o = 0; o < e.length; ++o) {
        r = 0 === o ? (3 * (e[o + 1].y - e[o].y) - s["D" + e[o + 1].index]) / 2 : o === e.length - 1 ? (3 * (e[o].y - e[o - 1].y) - s["D" + e[o - 1].index]) / 2 : (3 * (e[o + 1].y - e[o - 1].y) - s["D" + e[o + 1].index] - s["D" + e[o - 1].index]) / 4, s["D" + e[o].index] = r;
      }
    }

    for (l = Math.round(t / (e.length - 1)), o = 1; o < e.length; ++o) {
      i(o, e, s, n, l);
    }
  },
      i = function i(e, t, n, a, _i4) {
    var o,
        r,
        l,
        s,
        c,
        u,
        h,
        d,
        p,
        f,
        g,
        m,
        b = t,
        v = e;

    for (o = n["D" + b[0].index], r = n["D" + b[v].index], l = b[0].y, s = o, c = 3 * (b[v].y - b[0].y) - 2 * o - r, u = 2 * (b[0].y - b[v].y) + o + r, h = a.max, d = a.min, p = 0, f = _i4; p <= f; p++) {
      (m = l + s * (g = p / f) + c * g * g + u * g * g * g) < d && (d = m), m > h && (h = m);
    }

    a.max = h, a.min = d;
  };

  t["default"] = function () {
    var e,
        t = this.config,
        n = this.getFromEnv("chart"),
        i = this.getFromEnv("chartConfig"),
        o = n.config.origRenderWidth,
        r = i.connectnulldata,
        l = i.minimizetendency,
        s = this.components.data,
        c = Number.MIN_VALUE,
        u = Number.MAX_VALUE;
    0 === l && (e = function h(e, t, n, i, o) {
      var r = [],
          l = !1,
          s = i || 0;

      for (o = o || {
        max: Number.MIN_VALUE,
        min: Number.MAX_VALUE
      }; s < e.length; ++s) {
        if (l) {
          if (isNaN(e[s].config.setValue) || null === e[s].config.setValue) {
            if (n) continue;
            break;
          }

          r.push({
            index: s,
            y: e[s].config.setValue
          });
        } else {
          if (isNaN(e[s].config.setValue) || null === e[s].config.setValue) continue;
          l = !0, r.push({
            index: s,
            y: e[s].config.setValue
          });
        }
      }

      return r.length > 2 && a(r, t, o), s < e.length && !n && h(e, t, n, s, o), o;
    }(s, o, r), t.maxValue = Math.max(t.maxValue, e.max), t.minValue = Math.min(t.minValue, e.min), t.maxValue === c && (t.maxValue = 0), t.minValue === u && (t.minValue = 0));
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;

  var a = "M",
      i = "Z",
      o = "R",
      r = "C",
      l = Math,
      s = l.sqrt,
      c = l.abs,
      u = function u(e, t, n, a) {
    return (a - t) / (n - e);
  },
      h = function h(e, t, n, a) {
    return (e - n) * t + a;
  },
      d = function d(e, t, n, a) {
    return (e - a) / t + n;
  },
      p = function p(e, t, n, a) {
    var i = (a - t) / s((n - e) * (n - e) + (a - t) * (a - t)),
        o = c(.5 * i);
    return e * o + n * (1 - o);
  },
      f = function f(e, t, n, a) {
    var l = e.length,
        s = e[l - 1],
        c = s.length,
        u = s[0],
        h = s[c - 2];
    c < 3 || (u !== o && u !== r || 3 !== c || (e[l - 1][0] = "L"), t && e.push(["L", h, a, n, a, i]));
  };

  t.getSplinePath = function (e, t, n, l, s) {
    var c,
        g,
        m,
        b,
        v,
        y,
        x,
        C,
        k,
        w,
        S,
        _,
        L,
        P,
        A,
        N,
        E,
        F,
        O,
        T,
        D,
        M,
        I,
        R,
        V,
        B = n,
        j = [null],
        G = [],
        H = [];

    for (R = 0, V = e.length; R < V; R += 1) {
      _ = e[R], M = e[R - 1] || {}, I = e[R + 1] || {}, v = _.x, g = _.y, y = M.x, m = M.y, x = I.x, b = I.y, C = _.lastYPos, k = _.lastXPos, F = G.length, w = H.length, B ? null !== C ? (c = T, R === e.length - 1 ? (E = j[R - O - 1], N = h(A = L = (v + y) / 2, E, y, m), (m > g && N < g || m < g && N > g) && (A = d(N = g, E, y, m)), T.push(A, N, L, (g + m) / 2, v, g), G.push(T), H.push(T), l && f(G, !0, D, t), l && f(H, !1)) : (E = j[R - O - 1], m > g && b >= g || m < g && b <= g ? (S = 0, L = p(y, m, v, g), P = g, R - O != 1 ? (N = h(A = L, E, y, m), (m > g && N < g || m < g && N > g) && (A = d(N = g, E, y, m)), T.push(A, N, L, P, v, g)) : T.push((v + y) / 2, (g + m) / 2, L, P, v, g)) : m === g ? (S = 0, T.push(y, m, v, g, v, g)) : (m > g && g > b || m < g && g < b) && (S = u(y, m, x, b), L = p(y, m, v, g), P = h(L, S, v, g), (m > g && P > m || m < g && P < m) && (L = d(P = m, S, v, g)), R - O != 1 ? (N = h(A = L, E, y, m), (m > g && N < g || m < g && N > g) && (A = d(N = g, E, y, m)), T.push(A, N, L, P, v, g)) : T.push((v + y) / 2, (g + m) / 2, L, P, v, g)), j.push(S))) : null === C && 0 !== R ? (c || (c = []), c[0] === r && (G.push(T), H.push(T), l && f(G, !0, D, t), l && f(H, !1)), G.push([a, v, g]), H.push([a, v, g]), D = v, T = [r], O = R, j = [null]) : (G.push([a, v, g]), H.push([a, v, g]), D = v, T = [r], O = R) : null !== C ? F >= 2 ? (G[F - 1][0] === a && G.push([o]), H[w - 1][0] === a && H.push([o]), F = G.length, w = H.length, (c = G[F - 1]).length, G[F - 1].push(v), G[F - 1].push(g), H[w - 1].push(v), H[w - 1].push(g), R === s - 1 && c[0] === o && (f(G, !0, D, t), f(H, !1))) : (G.push([a, k, C]), G.push([o, v, g]), H.push([a, k, C]), H.push([o, v, g]), D = k) : null === C && F >= 2 && ((c = G[F - 1])[0] === o && (f(G, !0, D, t), f(H, !1)), G.push([a, v, g]), H.push([a, v, g]), D = v);
    }

    return c = G[G.length - 1], l && c && (c[c.length - 1] === i || c[0] !== o && c[0] !== r || (f(G, !0, D, t), f(H, !1))), l || (G = B ? G : H).length >= 2 && f(G, !1), {
      closedPath: G,
      openPath: H
    };
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(125);
  t["default"] = {
    "*.dataset.splinearea": function datasetSplinearea() {
      return {
        "anchor.appearing": [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          startEnd: {
            start: .5,
            end: 1
          },
          slot: "plot"
        }],
        "anchor.updating": [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          slot: "final"
        }],
        "anchor.disappearing": [{
          finalAttr: {
            opacity: 0,
            "fill-opacity": 0,
            "stroke-opacity": 0
          },
          slot: "final"
        }],
        "line.appearing": function lineAppearing(e) {
          var t = e.component,
              n = t.components.data,
              i = t.getLinePath(n, null, "zero"),
              o = e.attr;
          return [{
            initialAttr: {
              opacity: 0,
              path: function (e) {
                var t = e.length,
                    n = [],
                    i = void 0,
                    o = void 0,
                    r = !1,
                    l = !0,
                    s = void 0;

                for (s = 0; s < t; ++s) {
                  i = e[s], l ? (n.push(i), o = (0, a.extend2)([], i), l = !1) : "Z" !== i ? r || (n.push(i), i.toString() === e[s - 1].toString() && (r = !0)) : (l = !0, r = !1, o[0] = "L", n.push(o, "Z"));
                }

                return n;
              }(i.getPathArr())
            },
            finalAttr: {
              opacity: 1,
              path: o && o.path
            },
            startEnd: {
              start: 0,
              end: .5
            },
            slot: "plot",
            hookFn: function hookFn() {
              this.attr({
                opacity: 1
              });
            }
          }];
        },
        "label.appearing": [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          slot: "final"
        }],
        "label.updating": function labelUpdating() {
          return [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: "final"
          }];
        },
        "group.appearing": function groupAppearing(e) {
          return "label-group" === e.attr.name ? [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: "final"
          }] : "plot-group" === e.attr.name ? [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            startEnd: {
              start: .5,
              end: 1
            },
            slot: "plot"
          }] : [{
            initialAttr: {
              opacity: 1
            },
            finalAttr: {
              opacity: 1
            },
            slot: "final"
          }];
        }
      };
    }
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = c(n(449)),
      i = n(125),
      o = c(n(511)),
      r = n(132),
      l = n(512),
      s = c(n(515));

  function c(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function u(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  (0, r.addDep)({
    name: "mssplineAnimation",
    type: "animationRule",
    extension: s["default"]
  });

  var h = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.apply(this, arguments));
    }

    return u(t, e), t.prototype.getType = function () {
      return "dataset";
    }, t.prototype.getName = function () {
      return "spline";
    }, t.prototype.configureAttributes = function (t) {
      e.prototype.configureAttributes && e.prototype.configureAttributes.call(this, t), o["default"].call(this);
    }, t.prototype.getDataLimits = function () {
      return {
        max: this.config.maxValue,
        min: this.config.minValue
      };
    }, t.prototype.drawCommonElements = function () {
      var e,
          t,
          n,
          a,
          o,
          r = this.components.data,
          s = this.config,
          c = Number(this.getFromEnv("chartConfig").connectnulldata),
          u = this.getFromEnv("xAxis"),
          h = this.getFromEnv("yAxis"),
          d = s.lineDashStyle,
          p = s.linethickness,
          f = [],
          g = null,
          m = {
        color: s.linecolor,
        alpha: s.alpha
      },
          b = {
        x: u.getLimit(),
        y: h.getLimit()
      },
          v = this.getState("visible") ? r.length : 0,
          y = s.lineOb || {},
          x = [],
          C = this.getFromEnv("chart"),
          k = /area/gi.test(C.defaultDatasetType);

      for (b.x.minPixel = u.getPixel(b.x.min), b.x.maxPixel = u.getPixel(b.x.max), b.y.minPixel = h.getPixel(b.y.min), b.y.maxPixel = h.getPixel(b.y.max), b.y.base = h.getPixel(0), b.x.base = u.getPixel(0), t = 0; t < v; ++t) {
        (n = r[t]) && (o = (a = n.config || {}).setValue, a._Pbx = void 0, a._Pby = void 0, x[t] = {
          config: {
            _Px: a._Px,
            _Py: a._Py,
            setValue: a.setValue
          }
        }, c || null !== o && void 0 !== o ? (f.push({
          x: a._Px,
          y: a._Py,
          lastYPos: g,
          lastXPos: e
        }), g = a._Py, e = a._Px) : g = null);
      }

      s.pathStartIndex = 0, s.pathEndIndex = void 0, y["default"] = y["default"] || {}, y["default"].used = !0, y["default"].path = [{
        pathArr: (0, l.getSplinePath)(f, h.getPixel(h.getAxisBase()), C.config.minimizetendency, k).closedPath,
        path2Arr: [],
        getPathArr: function getPathArr() {
          var e = this.pathArr,
              t = this.path2Arr;
          return e.length || t.length ? e.concat(t) : [];
        }
      }], y["default"].attr = {
        "stroke-dasharray": d,
        "stroke-width": p,
        stroke: (0, i.toRaphaelColor)(m),
        "stroke-linecap": "round"
      }, this._drawCommonElementsHelper(y), this.config.lineOb = y, s.prevLim = b, s.prevDataStore = x;
    }, t;
  }(a["default"]);

  t["default"] = h;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(452),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };
  t["default"] = {
    "*.dataset.spline": o["default"]["*.dataset.line"]
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(138),
      i = n(125);

  function o(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var r = Math,
      l = r.min,
      s = r.max,
      c = r.abs,
      u = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.setState("visible", !0), n;
    }

    return o(t, e), t.prototype.getType = function () {
      return "group";
    }, t.getName = function () {
      return "columnMultiSeriesgroup";
    }, t.prototype.getName = function () {
      return "columnMultiSeriesgroup";
    }, t.prototype.preConfigure = function (t) {
      if (!t) return !1;
      this.config.JSONData = t, e.prototype.preConfigure.call(this, t);
    }, t.prototype.configure = function (t) {
      if (!t) return !1;
      e.prototype.configure.call(this, t);
    }, t.prototype.setVisibility = function () {
      var e = 0;
      this._mapChildren(function (e) {
        e.setVisibility && e.setVisibility();
      }), this._mapChildren(function (t) {
        t.getState("visible") && e++;
      }), this.setState("visible", !!e);
    }, t.prototype.createContainer = function () {
      var e = this.getFromEnv("animationManager"),
          t = void 0,
          n = void 0,
          a = this.getLinkedParent().getChildContainer();

      for (t in a) {
        n = a[t], !this.getChildContainer(t) && this.addChildContainer(t, e.setAnimation({
          el: "group",
          attr: {
            name: "manager-" + t
          },
          component: this,
          container: n
        }));
      }
    }, t.prototype.allocatePosition = function () {
      this.setColumnPosition();
    }, t.prototype.draw = function () {
      this.createContainer();
    }, t.prototype.getCanvasPadding = function () {
      var e,
          t,
          n = {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      };
      return this.setColumnPosition(), this._mapChildren(function (a) {
        for (t in e = !a.getState("removed") && a.getState("visible") && a.getCanvasPadding && a.getCanvasPadding() || {}) {
          e.hasOwnProperty(t) && (n[t] = Math.max(e[t], n[t]));
        }
      }), n;
    }, t.prototype.setColumnPosition = function () {
      var e,
          t,
          n,
          a,
          o = this.getFromEnv("chartConfig"),
          r = this.getFromEnv("chart-attrib"),
          u = this.getFromEnv("xAxis"),
          h = this.getFromEnv("numOfColumns"),
          d = o.plotSpacePercent,
          p = s((0, i.pluckNumber)(d, 20) % 100, 0),
          f = p / 200,
          g = u.getPixel(0),
          m = u.getPixel(1),
          b = this.getFromEnv("chart").isBar ? o.maxBarHeight : o.maxColWidth,
          v = c(m - g),
          y = void 0,
          x = o.plotPaddingPercent,
          C = !0,
          k = o.overlapColumns,
          w = 0,
          S = 0;
      this.addToEnv("groupMaxWidth", v), this._mapChildren(function (e) {
        e.getState("removed") || !1 === e.getState("visible") || S++;
      }), this.addToEnv("numOfColumns", S), this.addToEnv("numColDiff", (0, i.pluckNumber)(h - S, 0)), y = (1 - .01 * d) * v || l(v * (1 - 2 * f), b * (S || 1)), void 0 === r.plotspacepercent && y >= o.canvasWidth / 2 && (y = v - b / 2), n = l((e = 0 === S ? y : y / S) - 1, S > 1 ? k || void 0 !== x ? x > 0 ? e * x / 100 : 0 : 4 : 0), this.addToEnv("plotWidth", e - n), t = -(S / 2 * e - e / 2), this._mapChildren(function (a) {
        !a.getState("removed") && a.getState("visible") && (a.addToEnv("shift", t + w * e + n / 2), w++);
      }), m - (a = y / 2) - (g - a + y) < 4 && (C = !1), 0 === p && (C = !0), this.addToEnv("isCrisp", C);
    }, t.prototype.childChanged = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          t = this.config,
          n = this.getLinkedParent(),
          a = void 0,
          i = 0,
          o = this.getState("visible"),
          r = {},
          l = void 0;
      this._mapChildren(function (e) {
        e.getState("visible") && i++;
      }), this.setState("visible", !!i), o !== !!i && (l = !0), !1 !== e.dataLimitChanged && ((a = this.getDataLimits()).min === t.range.min && a.max === t.range.max || (t.range.min = a.min, t.range.max = a.max, r.dataLimitChanged = !0, l = !0)), l ? n.childChanged && n.childChanged(r) : this.asyncDraw();
    }, t.prototype.getAxisValuePadding = function () {
      var e = {},
          t = -Infinity,
          n = -Infinity;
      return this._mapChildren(function (a) {
        a.getState("removed") || (e = a.getAxisValuePadding && a.getAxisValuePadding() || {}, t = Math.max(t, e.left || -Infinity), n = Math.max(n, e.right || -Infinity));
      }), t === -Infinity && (t = 0), n === -Infinity && (n = 0), this.config.padding || (this.config.padding = {}, this.config.padding.left = t, this.config.padding.right = n), {
        left: t,
        right: n
      };
    }, t.prototype.getDataLimits = function (e) {
      var t = +Infinity,
          n = -Infinity,
          a = void 0,
          i = 0,
          o = function o(e) {
        n = Math.max(n, e.max), t = Math.min(t, e.min);
      };

      return this._mapChildren(function (t) {
        t.getState("removed") || (!1 !== t.getState("visible") ? (i++, a = t.getDataLimits(e), o(a)) : e && (a = t.getDataLimits(e), o(a)));
      }), i ? this.setState("visible", !0) : this.setState("visible", !1), this.config.range || (this.config.range = {}, this.config.range.min = this.config.dataMin, this.config.range.max = this.config.dataMax), {
        max: n,
        min: t
      };
    }, t.prototype.isVisible = function () {
      return !this.isNotVisible;
    }, t;
  }(a.ComponentInterface);

  t["default"] = u;
},, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = r(n(459)),
      i = r(n(432)),
      o = r(n(516));

  function r(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function l(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var s = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.eiMethods = {}, n;
    }

    return l(t, e), t.getName = function () {
      return "MSColumn2D";
    }, t.prototype.getName = function () {
      return "MSColumn2D";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this), this.config.friendlyName = "Multi-series Column Chart", this.config.defaultDatasetType = "column", this.config.enablemousetracking = !0;
    }, t.prototype.getDSdef = function () {
      return i["default"];
    }, t.prototype.getDSGroupdef = function () {
      return o["default"];
    }, t;
  }(a["default"]);

  t["default"] = s;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.scrollTo = undefined;
  var a = n(136);

  t.scrollTo = function (e) {
    var t = this.apiInstance;
    t.addJob("scrollToAPoint", function () {
      if (e >= 0 && e <= 1) {
        var n = (t.getChildren && t.getChildren()).xAxis[0],
            a = n.getChildren("scrollBar") && n.getChildren("scrollBar")[0],
            i = a && a.getChildren("scrollAnchor")[0],
            o = n.getLimit && n.getLimit(),
            r = n.getVisibleConfig && n.getVisibleConfig(),
            l = r.maxValue - r.minValue,
            s = o.max - o.min,
            c = e * (s - l) + o.min,
            u = c + l,
            h = (r.minValue - o.min) / (s - l);
        i.config.scrollPosition = e, t.fireChartInstanceEvent("scrollStart", {
          scrollPosition: h
        }), n.setVisibleConfig(c, u), t.fireChartInstanceEvent("scrollEnd", {
          previousScrollPosition: h,
          scrollPosition: e
        });
      }
    }, a.priorityList.postRender);
  };
},,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(138),
      o = n(125),
      r = n(132),
      l = n(526),
      s = (a = l) && a.__esModule ? a : {
    "default": a
  };

  function c(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var u = o.preDefStr.visibleStr,
      h = Math,
      d = h.min,
      p = h.max;
  (0, r.addDep)({
    name: "cartesianStackAnimation",
    type: "animationRule",
    extension: s["default"]
  });

  var f = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.setState("visible", !0), n;
    }

    return c(t, e), t.prototype.getType = function () {
      return "group";
    }, t.getName = function () {
      return "cartesianStackGroup";
    }, t.prototype.getName = function () {
      return "cartesianStackGroup";
    }, t.prototype.preConfigure = function (t) {
      if (!t) return !1;
      this.config.JSONData = t, e.prototype.preConfigure.call(this, t);
    }, t.prototype.configure = function (t) {
      if (!t) return !1;
      e.prototype.configure.call(this, t);
    }, t.prototype.setSkippingInfo = function (e) {
      this.addToEnv("skipInfo", e || {
        drawOnlyMap: [],
        plotsPerBin: 1,
        draw: [],
        hide: [],
        skippingApplied: !1,
        dragHashMap: [],
        prevDrawArray: []
      });
    }, t.prototype.getSkippingInfo = function () {
      return this.getFromEnv("skipInfo") || {
        drawOnlyMap: [],
        plotsPerBin: 1,
        draw: [],
        hide: [],
        skippingApplied: !1,
        dragHashMap: [],
        prevDrawArray: []
      };
    }, t.prototype.setVisibility = function () {
      var e = 0;
      this._mapChildren(function (t) {
        t.getState("visible") && e++;
      }), this.setState("visible", !!e);
    }, t.prototype.createContainer = function () {
      var e = this.getFromEnv("animationManager"),
          t = void 0,
          n = this.getLinkedParent(),
          a = void 0,
          i = n.getChildContainer();

      for (t in i) {
        a = i[t], !this.getChildContainer(t) && this.addChildContainer(t, e.setAnimation({
          el: "group",
          attr: {
            name: "manager-" + t
          },
          container: a,
          component: this
        }));
      }

      !this.getContainer("sumLabelsLayer") && this.addContainer("sumLabelsLayer", e.setAnimation({
        el: "group",
        attr: {
          name: "manager-sumLabelsLayer",
          "class": "fusioncharts-datalabels"
        },
        label: "group",
        container: n.getChildContainer("sumLabelsLayer"),
        component: this
      })), !this.getChildContainer("commonElemGroup") && this.addChildContainer("commonElemGroup", e.setAnimation({
        el: "group",
        attr: {
          name: "manager-common-elem-group"
        },
        label: "group",
        container: n.getChildContainer("areaVcanvasGroup"),
        component: this
      })), !this.getChildContainer("anchorGroup") && this.addChildContainer("anchorGroup", e.setAnimation({
        el: "group",
        attr: {
          name: "manager-anchor-group"
        },
        label: "group",
        container: n.getChildContainer("areaVcanvasGroup"),
        component: this
      }));
    }, t.prototype.draw = function () {
      this.createContainer(), this.drawSumValue();
    }, t.prototype._setStackPosition = function () {
      var e = +Infinity,
          t = -Infinity,
          n = this.getFromEnv("numOfColumns"),
          a = 0,
          i = [],
          r = this.getSkippingInfo && this.getSkippingInfo() || {},
          l = r.draw || [],
          s = l.length,
          c = r.skippingApplied;
      this._mapChildren(function (n) {
        if (!n.getState("removed") && !1 !== n.getState("visible")) {
          a++;
          var o = void 0,
              r = n.getData(),
              u = void 0,
              h = void 0,
              f = void 0,
              g = 0,
              m = r && r.length,
              b = 0;

          for (c && (m = s), h = 0; h < m; h++) {
            (o = r[u = l[h] || h]) && o.config && void 0 !== o.config.setValue && (i[u] || (i[u] = {}), f = o.config.setValue, i[u].positive || (i[u].positive = 0), i[u].negative || (i[u].negative = 0), f >= 0 ? (g = f + (b = i[u].positive), i[u].positive = g) : f < 0 && (g = f + (b = i[u].negative), i[u].negative = g), null !== f && (i[u].isNotNull = !0), t = p(g, t), e = d(g, e), o.config._y = g, o.config._b = b);
          }
        }
      }), this.config.stackValues = i, this.config.dataMin = e, this.config.dataMax = t, a ? this.setState("visible", !0) : this.setState("visible", !1), this.addToEnv("stackValues", i), this.addToEnv("numOfColumns", a), this.addToEnv("numColDiff", (0, o.pluckNumber)(n - a, 0));
    }, t.prototype.allocatePosition = function () {
      this._setStackPosition();
    }, t.prototype._getXpos = function (e) {
      var t = this.getFromEnv("shift") || 0;
      return this.getFromEnv("xAxis").getPixel(e) + t;
    }, t.prototype.drawSumValue = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0,
          t = arguments[1],
          n = this.config,
          a = this.getFromEnv("yAxis"),
          i = this.getFromEnv("paper"),
          r = this.getFromEnv("animationManager"),
          l = this.getFromEnv("chart"),
          s = l.isBar,
          c = this.getFromEnv("smartLabel"),
          h = l.config,
          d = h.canvasRight,
          p = this.getFromEnv("chart-attrib"),
          f = (0, o.pluckNumber)(h.stack100percent),
          g = h.rotatevalues ? 270 : 0,
          m = n.stackValues,
          b = t || m && m.length,
          v = h.dataLabelStyle,
          y = void 0,
          x = void 0,
          C = void 0,
          k = void 0,
          w = void 0,
          S = void 0,
          _ = this.getContainer("sumLabelsLayer"),
          L = this.getGraphicalElement("sumLabels"),
          P = void 0,
          A = void 0,
          N = void 0,
          E = void 0,
          F = void 0,
          O = void 0,
          T = void 0,
          D = void 0,
          M = void 0,
          I = void 0;

      if ((0, o.pluckNumber)(p.showsum, l.showsum, 0)) {
        if (_.css(v), c.setStyle(v), (D = L && L.length) > (M = m.length)) for (; D >= M;) {
          I = L[D], D--, I && (I.hide(), this.removeGraphicalElement(I));
        }

        for (y = e; y < b; y++) {
          P = Array.isArray(L) && L[y], m[y] && m[y].isNotNull ? (F = (T = (N = m[y].positive) + (E = m[y].negative)) < 0 ? E : N, (O = a.dataLabels(T)) && (k = v.backgroundColor, w = v.borderColor, S = c.getOriSize(O), s ? (C = this._getXpos(y) + S.height / 2, x = a.getPixel(f ? 100 : F) + S.width / 2, f || (x -= x + S.width > d ? x + S.width - d : 0)) : (x = this._getXpos(y), C = a.getPixel(f ? 100 : F)), (A = this.getSumValuePosition(S, {
            stack100percent: f,
            rotateValues: g,
            xPos: x,
            yPos: C,
            offsetY: F
          })).text = O, A.fill = v.color, A["text-bound"] = [k, w, v.borderThickness, v.borderPadding, v.borderRadius, v.borderDash], A["line-height"] = v.lineHeight, A.visibility = u, A.transform = i.getSuggestiveRotation(g, A.x, A.y), A["text-anchor"] && delete A["text-bound"], (P = r.setAnimation({
            el: P || "text",
            attr: A,
            label: "text",
            container: _,
            component: this
          })).show(), Array.isArray(L) && L[y] || this.addGraphicalElement("sumLabels", P, !0))) : P && P.hide();
        }
      } else r.setAnimation({
        el: _,
        label: "sumLabelGroup"
      }), _.hide();
    }, t.prototype.getSumValuePosition = function (e, t) {
      var n,
          a,
          i,
          o = this.getFromEnv("chart"),
          r = o.config,
          l = r.canvasBottom,
          s = r.canvasTop,
          c = o.config.is3D,
          u = o.isBar,
          h = t.stack100percent,
          d = r.yDepth,
          p = r.xDepth,
          f = t.yPos,
          g = t.xPos,
          m = this.getFromEnv("canvasConfig").canvasBorderWidth,
          b = t.offsetY;
      return i = (i = n = t.rotateValues ? e.width : e.height) / 2 + 2, h ? s <= n ? f = i : (f = u ? t.yPos : s - i - m, g += u ? m : 0) : (b >= 0 && ((a = f - s) < n ? f = f + i - a : (f -= i, g += u ? 2 : 0)), b < 0 && ((a = l - f) < n ? f -= i : f += i, c && (g -= p, f += d))), {
        x: g,
        y: f
      };
    }, t.prototype.childChanged = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          t = this.config,
          n = this.getLinkedParent(),
          a = void 0,
          i = this.getState("visible"),
          o = 0,
          r = {},
          l = void 0;
      this._mapChildren(function (e) {
        e.getState("visible") && o++;
      }), this.setState("visible", !!o), i !== !!o && (l = !0), !1 !== e.dataLimitChanged && ((a = this.getDataLimits()).min === t.range.min && a.max === t.range.max || (t.range.min = a.min, t.range.max = a.max, r.dataLimitChanged = !0, l = !0)), l ? n.childChanged && n.childChanged(r) : this.asyncDraw();
    }, t.prototype.getAxisValuePadding = function () {
      var e = {},
          t = -Infinity,
          n = -Infinity;
      return this._mapChildren(function (a) {
        a.getState("removed") || (e = a.getAxisValuePadding && a.getAxisValuePadding() || {}, t = Math.max(t, e.left || -Infinity), n = Math.max(n, e.right || -Infinity));
      }), t === -Infinity && (t = 0), n === -Infinity && (n = 0), this.config.padding || (this.config.padding = {}, this.config.padding.left = t, this.config.padding.right = n), {
        left: t,
        right: n
      };
    }, t.prototype.getDataLimits = function (e) {
      return this._setStackPosition(), this.config.range || (this.config.range || (this.config.range = {}), this.config.range.min = this.config.dataMin, this.config.range.max = this.config.dataMax), e ? this._getStackLimit() : {
        max: this.config.dataMax,
        min: this.config.dataMin
      };
    }, t.prototype._getStackLimit = function () {
      var e = +Infinity,
          t = -Infinity,
          n = [],
          a = this.getSkippingInfo && this.getSkippingInfo() || {},
          i = a.draw || [],
          o = i.length,
          r = a.skippingApplied;
      return this._mapChildren(function (a) {
        if (!a.getState("removed")) {
          var l = void 0,
              s = a.getData(),
              c = void 0,
              u = void 0,
              h = void 0,
              f = 0,
              g = s && s.length;

          for (r && (g = o), u = 0; u < g; u++) {
            (l = s[c = i[u] || u]) && l.config && void 0 !== l.config.setValue && null !== l.config.setValue && (n[c] || (n[c] = {}), h = l.config.setValue, n[c].positive || (n[c].positive = 0), n[c].negative || (n[c].negative = 0), h > 0 ? (f = h + n[c].positive, n[c].positive = f) : h < 0 && (f = h + n[c].negative, n[c].negative = f), t = p(f, t), e = d(f, e));
          }
        }
      }), {
        max: t,
        min: e
      };
    }, t.prototype.isVisible = function () {
      return !this.isNotVisible;
    }, t.prototype.getMaxSumValueSpace = function () {
      var e,
          t,
          n,
          a,
          i,
          o = this.config.stackValues,
          r = this.getFromEnv("chart"),
          l = {},
          s = o && o.length,
          c = this.getFromEnv("number-formatter"),
          u = 0,
          h = 0,
          d = this.getFromEnv("smartLabel"),
          f = r.config.dataLabelStyle;

      for (d.useEllipsesOnOverflow(r.config.useEllipsesWhenOverflow), d.setStyle(f), e = 0; e < s; e++) {
        o[e] && (i = o[e].positive + o[e].negative, t = c.dataLabels(i), n = (l = d.getOriSize(t)).width, a = l.height, h = p(h, n), u = p(u, a));
      }

      return {
        maxWidth: h,
        maxHeight: u
      };
    }, t.prototype.getCanvasPadding = function () {
      var e,
          t,
          n = {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      };
      return this._setStackPosition(), this._mapChildren(function (a) {
        for (t in e = a.getCanvasPadding && a.getCanvasPadding() || {}) {
          e.hasOwnProperty(t) && (n[t] = Math.max(e[t], n[t]));
        }
      }), n;
    }, t;
  }(i.ComponentInterface);

  t["default"] = f;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;

  var a = function a() {
    return [{
      initialAttr: {
        opacity: 1
      },
      finalAttr: {
        opacity: 1
      },
      slot: "plot"
    }];
  },
      i = function i() {
    return [{
      initialAttr: {
        opacity: 0
      },
      finalAttr: {
        opacity: 1
      },
      slot: "final"
    }];
  };

  t["default"] = {
    "initial.group.cartesianStackGroup": function initialGroupCartesianStackGroup() {
      return {
        "group.appearing": a,
        "text.appearing": i,
        "*": null
      };
    },
    "initial.group.marimekkoStackgroup": function initialGroupMarimekkoStackgroup() {
      return {
        "text.appearing": i,
        "*": null
      };
    }
  };
},,,,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = s(n(518)),
      i = s(n(535)),
      o = s(n(537)),
      r = s(n(462)),
      l = n(125);

  function s(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function c(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var u = function u(e, t, n) {
    var a,
        i,
        o,
        r,
        l,
        s,
        c,
        u,
        h,
        d,
        p,
        f = n && n.length,
        g = e,
        m = t;
    if (!f) return undefined;

    for (a = f - 1; a >= 0; a--) {
      if (u = (o = n[a]).x1, h = o.y1, d = o.x2, p = o.y2, o.isTrendZone) {
        if (g >= u && g <= d && m >= h && m <= p) return o;
      } else if (h !== p && u !== d ? (r = i = (h - p) / (u - d), l = -1, s = h - i * u, c = Math.abs(r * g + l * m + s) / Math.sqrt(Math.pow(r, 2) + Math.pow(l, 2))) : u === d ? c = Math.abs(u - g) : h === p && (c = Math.abs(h - m)), c <= o.tolerance) return o;
    }
  },
      h = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.registerFactory("axis", o["default"], ["canvas"]), n.registerFactory("legend", r["default"]), n.registerFactory("quadrant", function (e) {
        var t = e.getChildren("canvas")[0],
            n = void 0,
            a = e.getChildren(),
            o = function o() {
          return n.asyncDraw();
        };

        (0, l.componentFactory)(t, i["default"], "quadrant"), (n = t.getChildren("quadrant")[0]).addExtEventListener("visiblerangeset", o, a.xAxis[0]), n.addExtEventListener("visiblerangeset", o, a.yAxis[0]), n.configure();
      }, ["dataset"]), n;
    }

    return c(t, e), t.getName = function () {
      return "ScatterBase";
    }, t.prototype.mouseoutHandler = function (e, t, n) {
      var a = this.config.datasetOrder || this.getDatasets(),
          i = this.getChildren("mouseTracker")[0];
      a[t] && a[t].components.data[n] ? a[t]._firePlotEvent("fc-mouseout", n, e) : this.getFromEnv("toolTipController").hideAll(), delete i._lastDatasetIndex, delete i._lastPointIndex;
    }, t.prototype.parseChartAttr = function (t) {
      e.prototype.parseChartAttr.call(this, t), this.config.drawTrendRegion = 0;
    }, t.prototype.__setDefaultConfig = function () {
      var t = this.config;
      e.prototype.__setDefaultConfig && e.prototype.__setDefaultConfig.call(this), t.valuefontbold = 0, t.stickytracking = 1, t.usemessagelog = 0, t.animationeffect = "linear", t.showshadow = 1, t.showhovereffect = void 0, t.plothovereffect = void 0, t.anchorhovereffect = void 0, t.plotborderdashed = void 0, t.stack100percent = void 0, t.showpercentvalues = void 0, t.showpercentintooltip = void 0, t.plotbordercolor = void 0, t.showtooltip = 1, t.seriesnameintooltip = 1, t.rotatevalues = 0, t.minimizetendency = 0, t.plotfillangle = 270, t.valuepadding = 2, t.useplotgradientcolor = 1, t.plotborderthickness = 1, t.plotfillalpha = "70", t.showvalues = 1, t.valueposition = "auto", t.tooltipsepchar = ", ", t.usedataplotcolorforlabels = 0, t.placevaluesinside = 0, t.showplotborder = 1, t.use3dlighting = 1, t.useroundedges = 0, t.plotspacepercent = 20, t.plotpaddingpercent = void 0, t.plotfillratio = void 0, t.maxcolwidth = 50, t.plotborderdashlen = 5, t.plotborderdashgap = 4, t.useScaleRecursively = !0, t.zeroplanethickness = 1, t.zeroplanealpha = 40, t.showzeroplaneontop = 0, t.setadaptivexmin = 1;
    }, t.prototype._drawTrendTooltip = function (e, t) {
      var n = this.getFromEnv("toolTipController"),
          a = this.config.currentTrendToolTip,
          i = e.tooltext,
          o = t.originalEvent;
      a ? n.draw(o, i, a) : a = this.config.currentTrendToolTip = n.draw(o, i);
    }, t.prototype._mouseEvtHandler = function (e, t) {
      var n,
          a,
          i,
          o,
          r,
          s,
          c,
          h,
          d,
          p,
          f = this,
          g = t.mouseTracker,
          m = f.getChildren("canvas")[0],
          b = f.getFromEnv("toolTipController"),
          v = e.originalEvent,
          y = f.config,
          x = y.canvasBaseDepth || 0,
          C = y.canvasLeft - (y.toleranceLeft || 0),
          k = y.canvasRight + (y.toleranceRight || 0),
          w = y.canvasBottom + (y.toleranceBottom || 0),
          S = y.canvasTop - (y.toleranceTop || 0),
          _ = y.datasetOrder || f.getDatasets(),
          L = !1,
          P = _.length,
          A = g._lastDatasetIndex,
          N = g._lastPointIndex;

      if (o = (i = (0, l.getMouseCoordinate)(f.getFromEnv("chart-container"), v, f)).chartX, r = i.chartY, o > C - x && o < k && r > S && r < w + x) {
        for (; P-- && !L;) {
          (s = _[P]) && s.getState("visible") && ((c = s._getHoveredPlot && s._getHoveredPlot(o, r)) && c.hovered || n) && (L = !0, c.datasetIndex = P, p = g.getMouseEvents(e, c.datasetIndex, c.pointIndex));
        }

        n = u(o, r, m.config.vtrendlines), a = u(o, r, m.config.trendlines);
      }

      if ((!L || p && p.fireOut) && void 0 !== A && _[A] && _[A]._firePlotEvent && (p && !p.events.length ? g.mouseoutTimer = setTimeout(function () {
        f.mouseoutHandler(e, A, N);
      }, 20) : (f.mouseoutHandler(e, A, N), clearTimeout(g.mouseoutTimer))), L) for (f.config.currentTrendToolTip && b.hide(f.config.currentTrendToolTip), (d = p.events && p.events.length) && (g._lastDatasetIndex = c.datasetIndex, N = g._lastPointIndex = c.pointIndex), h = 0; h < d; h += 1) {
        s && s._firePlotEvent && s._firePlotEvent(p.events[h], N, e, c.datasetIndex);
      } else n && n.tooltext ? f._drawTrendTooltip(n, e) : a && a.tooltext ? f._drawTrendTooltip(a, e) : f.config.currentTrendToolTip && b.hide(f.config.currentTrendToolTip);
    }, t.prototype._setCategories = function () {
      var e = this.getFromEnv("dataSource"),
          t = e.chart,
          n = this.getChildren("xAxis"),
          a = (0, l.pluck)(t.xaxislabelmode, "categories"),
          i = e.categories,
          o = i && i[0] && i[0].category;
      n[0].setAxisConfig({
        xAxisLabelMode: "categories"
      }), "auto" !== a && "mixed" !== a && o && o.length > 0 ? n[0].setTickValues(o) : "auto" !== a ? (n[0].setTickValues(o), n[0].setAxisConfig({
        xAxisLabelMode: "mixed"
      })) : (n[0].setTickValues(o), n[0].setAxisConfig({
        xAxisLabelMode: "auto"
      }));
    }, t.prototype._allocateSpace = function (e) {
      var t = this.getChildren("canvas"),
          n = t && t[0].config,
          a = this.config,
          i = a.canvasHeight,
          o = a.canvasWidth,
          r = a.availableHeight,
          l = a.availableWidth;
      a.canvasLeft += e.left || 0, a.canvasTop += e.top || 0, o = a.canvasWidth = Math.max(o - ((e.left || 0) + (e.right || 0)), 0), i = a.canvasHeight = Math.max(i - ((e.top || 0) + (e.bottom || 0)), 0), a.availableHeight = Math.max(r - ((e.top || 0) + (e.bottom || 0)), 0), a.availableWidth = Math.max(l - ((e.left || 0) + (e.right || 0)), 0), a.canvasRight = a.canvasLeft + o, a.canvasBottom = a.canvasTop + i, n && (n.canvasPaddingLeft = Math.max(n.canvasPaddingLeft, e.paddingLeft || 0), n.canvasPaddingRight = Math.max(n.canvasPaddingRight, e.paddingRight || 0), n.canvasPaddingTop = Math.max(n.canvasPaddingTop, e.paddingTop || 0), n.canvasPaddingBottom = Math.max(n.canvasPaddingBottom, e.paddingBottom || 0)), t[0].setDimension({
        top: a.canvasTop,
        left: a.canvasLeft,
        width: a.canvasWidth,
        height: a.canvasHeight
      });
    }, t.prototype._postSpaceManagement = function () {
      var e,
          t = this.config,
          n = this.getChildren(),
          a = n.xAxis && n.xAxis[0],
          i = n.legend && n.legend[0],
          o = t.xDepth,
          r = this.getChildren("canvas");

      for (this.setAxisDimention(), a && this._allocateXAxisLabelSpace(a), a && a.shiftLabels(-o, 0), i && i.postSpaceManager(), e = 0; e < (r && r.length); e++) {
        r[e].setCanvasPadding();
      }

      this.setAxisDimention(), this.allocateDimensionOfChartMenuBar();
    }, t.prototype._checkInvalidSpecificData = function () {
      if (!this.getFromEnv("dataSource").dataset) return !0;
    }, t;
  }(a["default"]);

  t["default"] = h;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(138),
      o = n(125),
      r = n(132),
      l = n(536),
      s = (a = l) && a.__esModule ? a : {
    "default": a
  };

  function c(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var u = o.preDefStr.POSITION_START,
      h = o.preDefStr.POSITION_TOP,
      d = o.preDefStr.POSITION_BOTTOM,
      p = o.preDefStr.POSITION_END;
  (0, r.addDep)({
    name: "quadrantAnimation",
    type: "animationRule",
    extension: s["default"]
  });

  var f = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this)),
          a = n;

      return a.pIndex = 1, a.components = {}, a.conf = {}, a.graphics = {}, n;
    }

    return c(t, e), t.prototype.getType = function () {
      return "canvas";
    }, t.prototype.getName = function () {
      return "quadrant";
    }, t.prototype.configure = function () {
      var e,
          t,
          n,
          a,
          i,
          r,
          l,
          s,
          c,
          u,
          h,
          d,
          p,
          f,
          g,
          m,
          b,
          v,
          y,
          x,
          C,
          k,
          w,
          S,
          _ = this.conf,
          L = this.getFromEnv("chart"),
          P = L.config,
          A = L.getFromEnv("dataSource").chart,
          N = L.getChildren("canvas")[0].config,
          E = P.dataLabelStyle,
          F = L.getFromEnv("smartLabel");
      (_.enabled = (0, o.pluckNumber)(A.drawquadrant, 0)) && (b = (0, o.pluckNumber)(A.quadrantxval), v = (0, o.pluckNumber)(A.quadrantyval), y = (0, o.convertColor)((0, o.pluck)(A.quadrantlinecolor, N.canvasBorderColor), (0, o.pluck)(A.quadrantlinealpha, A.quadrantlinealpha, o.HUNDREDSTRING)), x = (0, o.pluckNumber)(A.quadrantlinethickness, N.canvasBorderThickness), k = (0, o.pluckNumber)(A.quadrantlinedashed, A.quadrantlineisdashed, 0), C = (0, o.pluckNumber)(A.quadrantlinedashlen, 4), w = (0, o.pluckNumber)(A.quadrantlinedashgap, 2), S = k ? (0, o.getDashStyle)(C, w) : "none", _.xVal = b, _.yVal = v, _.quadrantLineColor = y, _.quadrantLineThickness = x, _.dashStyle = S, p = (0, o.getValidValue)(A.quadrantlabeltl, ""), f = (0, o.getValidValue)(A.quadrantlabeltr, ""), g = (0, o.getValidValue)(A.quadrantlabelbl, ""), m = (0, o.getValidValue)(A.quadrantlabelbr, ""), _.quadrantLabelPadding = (0, o.pluckNumber)(A.quadrantlabelpadding, 3), F.useEllipsesOnOverflow(P.useEllipsesWhenOverflow), F.setStyle(E), "" !== p ? (r = (0, o.getFirstValue)(A.quadrantlabeltlbordercolor, A.quadrantlabelbordercolor, ""), l = (0, o.pluck)(A.quadrantlabeltlbgcolor, A.quadrantlabelbgcolor), s = (0, o.pluckNumber)(A.quadrantlabeltlborderthickness, A.quadrantlabelborderthickness, 1), r = r ? (0, o.convertColor)(r, (0, o.pluckNumber)(A.quadrantlabeltlborderalpha, A.quadrantlabelborderalpha, A.quadrantlabeltlalpha, A.quadrantlabelalpha, 100)) : "", (c = _.tlConfig) || (c = _.tlConfig = {
        enabled: !0,
        styleObj: {}
      }), c.label = p, c.styleObj.fontSize = (0, o.pluck)((0, o.pluckNumber)(A.quadrantlabeltlfontsize, A.quadrantlabelfontsize), parseInt(E.fontSize, 10)) + "px", c.styleObj.lineHeight = E.lineHeight, c.styleObj.fontFamily = (0, o.pluck)(A.quadrantlabeltlfont, A.quadrantlabelfont, E.fontFamily), c.styleObj.color = (0, o.convertColor)((0, o.pluck)(A.quadrantlabeltlfontcolor, A.quadrantlabelfontcolor, E.color), (0, o.pluckNumber)(A.quadrantlabeltlfontalpha, A.quadrantlabelfontalpha, 100)), c.styleObj.fontWeight = (0, o.pluckNumber)(A.quadrantlabeltlfontbold, A.quadrantlabelfontbold) ? "bold" : "normal", c.styleObj.fontStyle = (0, o.pluckNumber)(A.quadrantlabeltlfontitalic, A.quadrantlabelfontitalic) ? "italic" : "normal", (0, o.setLineHeight)(c.styleObj), e = r, t = (0, o.pluckNumber)(A.quadrantlabeltlborderpadding, A.quadrantlabelborderpadding, 2), n = (0, o.pluckNumber)(A.quadrantlabeltlborderradius, A.quadrantlabelborderradius, 0), a = l ? (0, o.convertColor)(l, (0, o.pluckNumber)(A.quadrantlabeltlbgalpha, A.quadrantlabelbgalpha, A.quadrantlabeltlalpha, A.quadrantlabelalpha, 100)) : "", i = (0, o.pluckNumber)(A.quadrantlabeltlborderdashed, A.quadrantlabelborderdashed, 0) ? (0, o.getDashStyle)((0, o.pluckNumber)(A.quadrantlabeltlborderdashlen, A.quadrantlabelborderdashlen, 4), (0, o.pluckNumber)(A.quadrantlabeltlborderdashgap, A.quadrantlabelborderdashgap, 2)) : "none", c["text-bound"] = [a, e, s, t, n, i]) : _.tlConfig && (_.tlConfig.label = p), "" !== f ? (r = (0, o.getFirstValue)(A.quadrantlabeltrbordercolor, A.quadrantlabelbordercolor, ""), l = (0, o.pluck)(A.quadrantlabeltrbgcolor, A.quadrantlabelbgcolor), s = (0, o.pluckNumber)(A.quadrantlabeltrborderthickness, A.quadrantlabelborderthickness, 1), r = r ? (0, o.convertColor)(r, (0, o.pluckNumber)(A.quadrantlabeltrborderalpha, A.quadrantlabelborderalpha, A.quadrantlabeltralpha, A.quadrantlabelalpha, 100)) : "", (u = _.trConfig) || (u = _.trConfig = {
        enabled: !0,
        styleObj: {}
      }), u.label = (0, o.getValidValue)(A.quadrantlabeltr, ""), u.styleObj.fontSize = (0, o.pluck)((0, o.pluckNumber)(A.quadrantlabeltrfontsize, A.quadrantlabelfontsize), parseInt(E.fontSize, 10)) + "px", u.styleObj.lineHeight = E.lineHeight, u.styleObj.fontFamily = (0, o.pluck)(A.quadrantlabeltrfont, A.quadrantlabelfont, E.fontFamily), u.styleObj.color = (0, o.convertColor)((0, o.pluck)(A.quadrantlabeltrfontcolor, A.quadrantlabelfontcolor, E.color), (0, o.pluckNumber)(A.quadrantlabeltrfontalpha, A.quadrantrabelfontalpha, 100)), u.styleObj.fontWeight = (0, o.pluckNumber)(A.quadrantlabeltrfontbold, A.quadrantlabelfontbold) ? "bold" : "normal", u.styleObj.fontStyle = (0, o.pluckNumber)(A.quadrantlabeltrfontitalic, A.quadrantlabelfontitalic) ? "italic" : "normal", (0, o.setLineHeight)(u.styleObj), e = r, t = (0, o.pluckNumber)(A.quadrantlabeltrborderpadding, A.quadrantlabelborderpadding, 2), n = (0, o.pluckNumber)(A.quadrantlabeltrborderradius, A.quadrantlabelborderradius, 0), a = l ? (0, o.convertColor)(l, (0, o.pluckNumber)(A.quadrantlabeltrbgalpha, A.quadrantlabelbgalpha, A.quadrantlabeltralpha, A.quadrantlabelalpha, 100)) : "", i = (0, o.pluckNumber)(A.quadrantlabeltrborderdashed, A.quadrantlabelborderdashed, 0) ? (0, o.getDashStyle)((0, o.pluckNumber)(A.quadrantlabeltrborderdashlen, A.quadrantlabelborderdashlen, 4), (0, o.pluckNumber)(A.quadrantlabeltrborderdashgap, A.quadrantlabelborderdashgap, 2)) : "none", u["text-bound"] = [a, e, s, t, n, i]) : _.trConfig && (_.trConfig.label = f), "" !== g ? (r = (0, o.getFirstValue)(A.quadrantlabelblbordercolor, A.quadrantlabelbordercolor, ""), l = (0, o.pluck)(A.quadrantlabelblbgcolor, A.quadrantlabelbgcolor), s = (0, o.pluckNumber)(A.quadrantlabelblborderthickness, A.quadrantlabelborderthickness, 1), r = r ? (0, o.convertColor)(r, (0, o.pluckNumber)(A.quadrantlabelblborderalpha, A.quadrantlabelborderalpha, A.quadrantlabelblalpha, A.quadrantlabelalpha, 100)) : "", (h = _.blConfig) || (h = _.blConfig = {
        enabled: !0,
        styleObj: {}
      }), h.label = g, h.styleObj.fontSize = (0, o.pluck)((0, o.pluckNumber)(A.quadrantlabelblfontsize, A.quadrantlabelfontsize), parseInt(E.fontSize, 10)) + "px", h.styleObj.lineHeight = E.lineHeight, h.styleObj.fontFamily = (0, o.pluck)(A.quadrantlabelblfont, A.quadrantlabelfont, E.fontFamily), h.styleObj.color = (0, o.convertColor)((0, o.pluck)(A.quadrantlabelblfontcolor, A.quadrantlabelfontcolor, E.color), (0, o.pluckNumber)(A.quadrantlabelblfontalpha, A.quadrantlabelfontalpha, 100)), h.styleObj.fontWeight = (0, o.pluckNumber)(A.quadrantlabelblfontbold, A.quadrantlabelfontbold) ? "bold" : "normal", h.styleObj.fontStyle = (0, o.pluckNumber)(A.quadrantlabelblfontitalic, A.quadrantlabelfontitalic) ? "italic" : "normal", (0, o.setLineHeight)(h.styleObj), e = r, t = (0, o.pluckNumber)(A.quadrantlabelblborderpadding, A.quadrantlabelborderpadding, 2), n = (0, o.pluckNumber)(A.quadrantlabelblborderradius, A.quadrantlabelborderradius, 0), a = l ? (0, o.convertColor)(l, (0, o.pluckNumber)(A.quadrantlabelblbgalpha, A.quadrantlabelbgalpha, A.quadrantlabelblalpha, A.quadrantlabelalpha, 100)) : "", i = (0, o.pluckNumber)(A.quadrantlabelblborderdashed, A.quadrantlabelborderdashed, 0) ? (0, o.getDashStyle)((0, o.pluckNumber)(A.quadrantlabelblborderdashlen, A.quadrantlabelborderdashlen, 4), (0, o.pluckNumber)(A.quadrantlabelblborderdashgap, A.quadrantlabelborderdashgap, 2)) : "none", h["text-bound"] = [a, e, s, t, n, i]) : _.blConfig && (_.blConfig.label = g), "" !== m ? (r = (0, o.getFirstValue)(A.quadrantlabelbrbordercolor, A.quadrantlabelbordercolor, ""), l = (0, o.pluck)(A.quadrantlabelbrbgcolor, A.quadrantlabelbgcolor), s = (0, o.pluckNumber)(A.quadrantlabelbrborderthickness, A.quadrantlabelborderthickness, 1), r = r ? (0, o.convertColor)(r, (0, o.pluckNumber)(A.quadrantlabelbrborderalpha, A.quadrantlabelborderalpha, A.quadrantlabelbralpha, A.quadrantlabelalpha, 100)) : "", (d = _.brConfig) || (d = _.brConfig = {
        enabled: !0,
        styleObj: {}
      }), d.label = (0, o.getValidValue)(A.quadrantlabelbr, ""), d.styleObj.fontSize = (0, o.pluck)((0, o.pluckNumber)(A.quadrantlabelbrfontsize, A.quadrantlabelfontsize), parseInt(E.fontSize, 10)) + "px", d.styleObj.lineHeight = E.lineHeight, d.styleObj.fontFamily = (0, o.pluck)(A.quadrantlabelbrfont, A.quadrantlabelfont, E.fontFamily), d.styleObj.color = (0, o.convertColor)((0, o.pluck)(A.quadrantlabelbrfontcolor, A.quadrantlabelfontcolor, E.color), (0, o.pluckNumber)(A.quadrantlabelbrfontalpha, A.quadrantrabelfontalpha, 100)), d.styleObj.fontWeight = (0, o.pluckNumber)(A.quadrantlabelbrfontbold, A.quadrantlabelfontbold) ? "bold" : "normal", d.styleObj.fontStyle = (0, o.pluckNumber)(A.quadrantlabelbrfontitalic, A.quadrantlabelfontitalic) ? "italic" : "normal", (0, o.setLineHeight)(d.styleObj), a = l ? (0, o.convertColor)(l, (0, o.pluckNumber)(A.quadrantlabelbrbgalpha, A.quadrantlabelbgalpha, A.quadrantlabelbralpha, A.quadrantlabelalpha, 100)) : "", e = r, t = (0, o.pluckNumber)(A.quadrantlabelbrborderpadding, A.quadrantlabelborderpadding, 2), n = (0, o.pluckNumber)(A.quadrantlabelbrborderradius, A.quadrantlabelborderradius, 0), i = (0, o.pluckNumber)(A.quadrantlabelbrborderdashed, A.quadrantlabelborderdashed, 0) ? (0, o.getDashStyle)((0, o.pluckNumber)(A.quadrantlabelbrborderdashlen, A.quadrantlabelborderdashlen, 4), (0, o.pluckNumber)(A.quadrantlabelbrborderdashgap, A.quadrantlabelborderdashgap, 2)) : "none", d["text-bound"] = [a, e, s, t, n, i]) : _.brConfig && (_.brConfig.label = m));
    }, t.prototype._preDraw = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r = this.conf,
          l = this.getFromEnv("chart"),
          s = l.getChildren("xAxis")[0],
          c = l.getChildren("yAxis")[0],
          u = s.getLimit(),
          h = c.getLimit(),
          d = u.max,
          p = h.max,
          f = u.min,
          g = h.min,
          m = l.config,
          b = m.canvasWidth,
          v = m.canvasHeight,
          y = r.quadrantLabelPadding,
          x = r.tlConfig,
          C = r.trConfig,
          k = r.blConfig,
          w = r.brConfig;
      return e = r.xVal || (r.xVal = (f + d) / 2), (t = r.yVal || (r.yVal = (g + p) / 2)) >= g && t <= p && e >= f && e <= d ? (a = b - (n = b / (d - f) * (e - f)), i = v - (o = v / (p - g) * (t - g)), n -= y, a -= y, o -= y, ((i -= y) < 0 || n < 0) && (x.enabled = !1), (i < 0 || a < 0) && (C.enabled = !1), (o < 0 || n < 0) && (k.enabled = !1), (o < 0 || n < 0) && (w.enabled = !1)) : r.enabled = !1, this;
    }, t.prototype._createGroups = function () {
      var e,
          t = this.getFromEnv("chart"),
          n = t.getFromEnv("animationManager"),
          a = t.getChildren("canvas")[0].getChildContainer("quadrantGroup"),
          i = this.getContainer("quadrantChildContainer"),
          o = this.getContainer("quadrantLineGroup"),
          r = this.getContainer("quadrantTLGroup"),
          l = this.getContainer("quadrantTRGroup"),
          s = this.getContainer("quadrantBLGroup"),
          c = this.getContainer("quadrantBRGroup");
      e = n.setAnimation({
        el: i || "group",
        attr: {
          name: "quadrant-child-container"
        },
        container: a,
        component: this,
        label: "group"
      }), i || this.addContainer("quadrantChildContainer", e), this.addContainer("quadrantLineGroup", n.setAnimation({
        el: o || "group",
        attr: {
          name: "quadrantLineGroup"
        },
        container: e,
        component: this,
        label: "group"
      })), this.addContainer("quadrantTLGroup", n.setAnimation({
        el: r || "group",
        attr: {
          name: "quadrantTLGroup"
        },
        container: e,
        component: this,
        label: "group"
      })), this.addContainer("quadrantTRGroup", n.setAnimation({
        el: l || "group",
        attr: {
          name: "quadrantTRGroup"
        },
        container: e,
        component: this,
        label: "group"
      })), this.addContainer("quadrantBLGroup", n.setAnimation({
        el: s || "group",
        attr: {
          name: "quadrantBLGroup"
        },
        container: e,
        component: this,
        label: "group"
      })), this.addContainer("quadrantBRGroup", n.setAnimation({
        el: c || "group",
        attr: {
          name: "quadrantBRGroup"
        },
        container: e,
        component: this,
        label: "group"
      }));
    }, t.prototype.draw = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r,
          l = this._preDraw(),
          s = l.conf,
          c = l.getFromEnv("chart"),
          f = c.config,
          g = f.reverseXAxis,
          m = {
        wrtVisible: !0
      },
          b = l.getFromEnv("smartLabel"),
          v = l.getFromEnv("animationManager"),
          y = l.graphics,
          x = y.tlLabel,
          C = y.trLabel,
          k = y.blLabel,
          w = y.brLabel,
          S = f.textDirection,
          _ = c.getChildren("xAxis")[0],
          L = c.getChildren("yAxis")[0],
          P = s.tlConfig || {},
          A = s.trConfig || {},
          N = s.blConfig || {},
          E = s.brConfig || {},
          F = P.enabled && P.label,
          O = A.enabled && A.label,
          T = N.enabled && N.label,
          D = E.enabled && E.label,
          M = f.canvasLeft,
          I = f.canvasTop,
          R = s.quadrantLabelPadding,
          V = _.getLimit(),
          B = L.getLimit(),
          j = g ? V.min : V.max,
          G = g ? V.max : V.min,
          H = B.max,
          z = B.min,
          W = _.getPixel(G, m) + R,
          q = _.getPixel(j, m) - R,
          U = L.getPixel(z, m) - R,
          Y = L.getPixel(H, m) + R,
          X = _.getPixel(s.xVal, m),
          K = L.getPixel(s.yVal, m),
          Z = X - W,
          J = q - X,
          $ = K - Y,
          Q = U - K,
          ee = y.horizontalQuadLine,
          te = y.verticalQuadLine,
          ne = function ne() {
        this.hide();
      };

      l._createGroups(), t = l.getContainer("quadrantChildContainer"), n = l.getContainer("quadrantLineGroup"), a = l.getContainer("quadrantTLGroup"), i = l.getContainer("quadrantTRGroup"), o = l.getContainer("quadrantBLGroup"), r = l.getContainer("quadrantBRGroup"), s.enabled ? (t.show(), y.horizontalQuadLine = v.setAnimation({
        el: ee || "path",
        container: n,
        attr: {
          path: "M" + M + " " + K + "h" + f.canvasWidth,
          stroke: s.quadrantLineColor,
          "stroke-dasharray": s.dashStyle,
          "stroke-width": s.quadrantLineThickness,
          "stroke-linecap": "butt"
        },
        component: l,
        label: "path"
      }), y.verticalQuadLine = v.setAnimation({
        el: te || "path",
        container: n,
        attr: {
          path: "M" + X + " " + I + "v" + f.canvasHeight,
          stroke: s.quadrantLineColor,
          "stroke-width": s.quadrantLineThickness,
          "stroke-dasharray": s.dashStyle,
          "stroke-linecap": "butt"
        },
        component: l,
        label: "path"
      }), F ? (b.useEllipsesOnOverflow(f.useEllipsesWhenOverflow), b.setStyle(s.tlConfig.styleObj), e = b.getSmartText(F, Z, $), (x = y.tlLabel = v.setAnimation({
        el: x || "text",
        attr: {
          "text-anchor": u,
          "vertical-align": h,
          x: W,
          y: Y,
          text: e.text,
          direction: S,
          "text-bound": s.tlConfig["text-bound"]
        },
        container: a,
        component: l,
        label: "text"
      })).css(s.tlConfig.styleObj)) : x && v.setAnimation({
        el: x,
        callback: ne,
        component: this,
        label: "text"
      }), O ? (b.setStyle(s.trConfig.styleObj), e = b.getSmartText(O, J, $), (C = y.trLabel = v.setAnimation({
        el: C || "text",
        attr: {
          "text-anchor": p,
          "vertical-align": h,
          direction: S,
          x: q,
          y: Y,
          text: e.text,
          "text-bound": s.trConfig["text-bound"]
        },
        container: i,
        component: l,
        label: "text"
      })).css(s.trConfig.styleObj)) : C && v.setAnimation({
        el: C,
        callback: ne,
        component: this,
        label: "text"
      }), T ? (b.setStyle(s.blConfig.styleObj), e = b.getSmartText(T, Z, Q), (k = y.blLabel = v.setAnimation({
        el: k || "text",
        attr: {
          "text-anchor": u,
          "vertical-align": d,
          direction: S,
          x: W,
          y: U,
          text: e.text,
          "text-bound": s.blConfig["text-bound"]
        },
        container: o,
        component: l,
        label: "text"
      })).css(s.blConfig.styleObj)) : k && v.setAnimation({
        el: k,
        callback: ne,
        component: this,
        label: "text"
      }), D ? (b.setStyle(s.brConfig.styleObj), e = b.getSmartText(D, J, Q), (w = y.brLabel = v.setAnimation({
        el: w || "text",
        attr: {
          "text-anchor": p,
          "vertical-align": d,
          direction: S,
          x: q,
          y: U,
          text: e.text,
          "text-bound": s.brConfig["text-bound"]
        },
        container: r,
        component: l,
        label: "text"
      })).css(s.brConfig.styleObj)) : w && v.setAnimation({
        el: w,
        callback: ne,
        component: this,
        label: "text"
      })) : t && v.setAnimation({
        el: t,
        component: l,
        doNotRemove: !0,
        callback: function callback() {
          this.hide();
        },
        label: "group"
      });
    }, t;
  }(i.ComponentInterface);

  t["default"] = f;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = {
    "initial.canvas.quadrant": function initialCanvasQuadrant() {
      return {
        "path.appearing": function pathAppearing() {
          return [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: "axis"
          }];
        },
        "text.appearing": function textAppearing() {
          return [{
            initialAttr: {
              opacity: 0
            },
            finalAttr: {
              opacity: 1
            },
            slot: "plot"
          }];
        }
      };
    }
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    var t = e.getChildren("canvas")[0],
        n = t.getChildren("axisRefVisualCartesian")[0],
        a = {
      zoomable: !0,
      pannable: !0
    },
        o = e._feedAxesRawData(),
        l = void 0,
        s = void 0,
        c = function c(e) {
      var t = e.sender;
      n.addexplicitDrawItems(t.getId(), t), n.asyncDraw();
    };

    (0, i.componentFactory)(e, r["default"], "yAxis", 1, o.yAxisConf), (0, i.componentFactory)(e, r["default"], "xAxis", 1, o.xAxisConf), l = e.getChildren("yAxis")[0], s = e.getChildren("xAxis")[0], l.setLinkedItem("canvas", t), s.setLinkedItem("canvas", t), n.setLinkedItem(l.getId(), l), n.setLinkedItem(s.getId(), s), n.addExtEventListener("visiblerangeset", c, s), n.addExtEventListener("visiblerangeset", c, l), t.attachAxis(s, !1, e.zoomX ? a : {}), t.attachAxis(l, !0, e.zoomY ? a : {}), e._setCategories();
  };
  var a,
      i = n(125),
      o = n(377),
      r = (a = o) && a.__esModule ? a : {
    "default": a
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = s(n(449)),
      i = n(125),
      o = n(132),
      r = s(n(539)),
      l = s(n(540));

  function s(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function c(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var u = Math,
      h = u.max,
      d = u.min,
      p = u.round;
  (0, o.addDep)({
    name: "scatterAnimation",
    type: "animationRule",
    extension: l["default"]
  });

  var f = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.apply(this, arguments));
    }

    return c(t, e), t.prototype.getType = function () {
      return "dataset";
    }, t.prototype.setupHoverTracker = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          l,
          s = this.config.searchDataArr = [],
          c = this.components.data,
          u = {},
          h = this.getSkippingInfo && this.getSkippingInfo(),
          d = h && h.draw || [],
          p = d.length,
          f = h && h.skippingApplied;

      for (n = c.length, f && (n = p), t = 0; t < n; t++) {
        (o = c[e = d[t] || [t]]) && (a = (l = o.config)._Px, i = l._Py, u = l.anchorProps, s.push({
          x: a,
          y: i,
          index: e,
          data: o,
          r: u.radius || 0
        }));
      }

      this.config.dataTree = new r["default"]().buildKdTree(s);
    }, t.prototype.getName = function () {
      return "scatter";
    }, t.prototype.configureAttributes = function (e) {
      if (!e) return !1;
      this.trimData(e), this.config.JSONData = e;
      var t,
          n,
          a,
          o,
          r,
          l = this.getFromEnv("chart"),
          s = this.config,
          c = s.JSONData,
          u = l.areaAlpha,
          h = l.getFromEnv("dataSource").chart,
          d = this.getFromEnv("color-manager"),
          p = (0, i.pluckNumber)(c.showplotborder, h.showplotborder || 1),
          f = d.getPlotColor(this.index),
          g = s.lineDashed = (0, i.pluckNumber)(c.linedashed, c.dashed, h.linedashed, 0),
          m = this.isLineSet;
      s.plotColor = f, o = (0, i.pluckNumber)(l.defaultPlotShadow, d.getColor("showShadow")), s.xAxisLabelMode = (0, i.pluck)(h.xaxislabelmode, "categories"), s.toolTipSepChar = (0, i.pluck)(h.tooltipsepchar, ", "), s.defaultValuePadding = {
        left: 0,
        right: 0
      }, s.parentYAxis = n = m ? 1 : "s" === (0, i.pluck)(c.parentyaxis && c.parentyaxis.toLowerCase(), "p") ? 1 : 0, this.config.yAxis = this.getFromEnv("yAxis")[n], s.connectNullData = (0, i.pluckNumber)(h.connectnulldata, 0), s.seriesname = (0, i.parseUnsafeString)(c.seriesname), s.includeinlegend = (0, i.pluckNumber)(c.includeinlegend, s.seriesname ? 1 : 0), s.enableAnimation = a = (0, i.pluckNumber)(h.animation, h.defaultanimation, 1), s.animation = !!a && {
        duration: 1e3 * (0, i.pluckNumber)(h.animationduration, 1)
      }, s.transposeanimation = (0, i.pluckNumber)(h.transposeanimation, a), s.transposeanimduration = 1e3 * (0, i.pluckNumber)(h.transposeanimduration, .2), s.showvalues = (0, i.pluckNumber)(c.showvalues, h.showvalues), s.valuePadding = (0, i.pluckNumber)(h.valuepadding, 2), s.valuePosition = (0, i.pluck)(c.valueposition, h.valueposition, "auto"), s.showTooltip = (0, i.pluckNumber)(h.showtooltip, 1), s.seriesNameInTooltip = (0, i.pluckNumber)(h.seriesnameintooltip, 1), s.plotFillColor = s.plotfillcolor = (0, i.pluck)(c.color, h.plotfillcolor, f), s.plotFillAngle = s.plotFillAngle = (0, i.pluck)(h.plotfillangle, 270), s.plotFillAlpha = s.plotfillalpha = (0, i.pluck)(c.alpha, h.plotfillalpha, u, "70"), r = (0, i.pluckNumber)(h.useplotgradientcolor, 1), s.plotGradientColor = s.plotgradientcolor = 0 !== r ? (0, i.getDefinedColor)(h.plotgradientcolor, d.getColor("plotGradientColor")) : "", s.fillColor = s.fillcolor = {
        color: s.plotfillcolor + (s.plotgradientcolor ? "," + s.plotgradientcolor : i.BLANKSTRING),
        alpha: s.plotfillalpha,
        angle: s.plotFillAngle
      }, s.plotBorderAlpha = s.plotborderalpha = p ? (0, i.pluck)(c.plotborderalpha, h.plotborderalpha, c.alpha, "95") : 0, s.plotBorderColor = s.plotbordercolor = (0, i.pluck)(c.plotbordercolor, h.plotbordercolor, h.areabordercolor, "666666"), s.dashed = t = (0, i.pluckNumber)(c.dashed, h.plotborderdashed), s.plotBorderDashLen = s.plotborderdashlen = (0, i.pluck)(c.plotborderdashlen, h.plotborderdashlen, 5), s.plotBorderDashGap = s.plotborderdashgap = (0, i.pluck)(c.plotborderdashgap, h.plotborderdashgap, 4), s.plotBorderThickness = s.plotborderthickness = (0, i.pluckNumber)(c.plotborderthickness, h.plotborderthickness, 1), s.plotBorderDashStyle = s.plotborderdashstyle = t ? (0, i.getDashStyle)(s.plotborderdashlen, s.plotborderdashgap) : "none", s.showHoverEffect = s.showhovereffect = (0, i.pluckNumber)(h.plothovereffect, h.anchorhovereffect, h.showhovereffect, void 0), s.rotateValues = (0, i.pluckNumber)(h.rotatevalues) ? 270 : 0, s.drawLine = (0, i.pluckNumber)(c.drawline, h.drawlines, 0), s.lineThickness = s.linethickness = (0, i.pluckNumber)(c.linethickness, h.linethickness, 2), s.lineDashLen = s.linedashlen = (0, i.pluckNumber)(c.linedashlen, h.linedashlen, 5), s.lineDashGap = s.linedashgap = (0, i.pluckNumber)(c.linedashgap, h.linedashgap, 4), s.lineAlpha = s.linealpha = (0, i.pluckNumber)(c.linealpha, h.linealpha, c.alpha, i.HUNDREDSTRING), s.lineColor = s.linecolor = (0, i.pluck)(c.linecolor, h.linecolor, c.color, s.plotColor), s.lineDashStyle = s.linedashstyle = (0, i.getDashStyle)(s.linedashlen, s.linedashgap), s.lineDashStyle = s.linedashstyle = g ? s.linedashstyle : "none", s.shadow = {
        opacity: (0, i.pluckNumber)(h.showshadow, o) ? s.linealpha / 100 : 0
      }, s.drawanchors = (0, i.pluckNumber)(c.drawanchors, c.showanchors, h.drawanchors, h.showanchors), s.anchorbgcolor = (0, i.getFirstColor)((0, i.pluck)(c.anchorbgcolor, h.anchorbgcolor, d.getColor("anchorBgColor"))), s.anchorbordercolor = (0, i.getFirstColor)((0, i.pluck)(c.anchorbordercolor, c.color, h.anchorbordercolor, s.linecolor)), s.anchorradius = (0, i.pluckNumber)(c.anchorradius, h.anchorradius, 3), s.anchoralpha = (0, i.pluck)(c.anchoralpha, c.alpha, h.anchoralpha, i.HUNDREDSTRING), s.anchorbgalpha = (0, i.pluck)(c.anchorbgalpha, c.alpha, h.anchorbgalpha, i.HUNDREDSTRING), s.anchorborderthickness = (0, i.pluck)(c.anchorborderthickness, h.anchorborderthickness, 1), s.anchorsides = (0, i.pluckNumber)(c.anchorsides, h.anchorsides, s.index + 3), s.anchorimageurl = (0, i.pluck)(c.anchorimageurl, h.anchorimageurl), s.anchorimagealpha = (0, i.pluckNumber)(c.anchorimagealpha, h.anchorimagealpha, 100), s.anchorimagescale = (0, i.pluckNumber)(c.anchorimagescale, h.anchorimagescale, 100), s.anchorimagepadding = (0, i.pluckNumber)(c.anchorimagepadding, h.anchorimagepadding, 1), s.anchorstartangle = (0, i.pluckNumber)(c.anchorstartangle, h.anchorstartangle, 90), s.anchorshadow = (0, i.pluckNumber)(c.anchorshadow, h.anchorshadow, 0), s.plotToolText = (0, i.getValidValue)((0, i.parseUnsafeString)((0, i.pluck)(c.plottooltext, h.plottooltext))), this.setState("visible", 1 === (0, i.pluckNumber)(c.visible, !Number(c.initiallyhidden), 1)), this._setConfigure(), !1 !== l.config.hasLegend && l.config.showLegend && this._addLegend(), this.setState("dirty", !0);
    }, t.prototype.calculateScrollRange = function () {
      var e = this.config,
          t = this.getFromEnv("chart"),
          n = this.getFromEnv("xAxis"),
          a = t.hasScroll,
          i = this.components.data.length;
      e.scrollMinVal = a ? h(p(n.getVisibleConfig().minValue) - 1, 0) : 0, e.scrollMaxVal = a ? d(p(n.getVisibleConfig().maxValue) + 2, i) : i, e.scrollMinValForLabel = e.scrollMinVal, e.scrollMaxValForLabel = e.scrollMaxVal;
    }, t.prototype._setConfigure = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          l,
          s,
          c,
          u,
          h,
          d,
          p = -Infinity,
          f = +Infinity,
          g = p,
          m = f,
          b = f,
          v = p,
          y = this.components.data || (this.components.data = []),
          x = this.getFromEnv("chart"),
          C = this.config,
          k = C.JSONData,
          w = x.getFromEnv("dataSource").chart,
          S = k.data || [],
          _ = S.length,
          L = this.getFromEnv("number-formatter"),
          P = (0, i.parseUnsafeString)(w.yaxisname),
          A = (0, i.parseUnsafeString)(w.xaxisname),
          N = C.lineDashed,
          E = C.linedashstyle,
          F = C.parentYAxis,
          O = C.toolTipSepChar,
          T = C.seriesname;

      for (C.imageCount = 0, e = 0; e < _; e += 1) {
        a = S[e], (t = (n = y[e] || (y[e] = {})).config || (n.config = {})).setValue = o = {
          x: L.getCleanValue(a.x),
          y: L.getCleanValue(a.y)
        }, null !== o.x && null !== o.y && (o.x > v && (v = o.x, C.rightMostData = n), o.x < b && (b = o.x, C.leftMostData = n), o.y > g && (g = o.y, C.topMostData = n), o.y < m && (m = o.y, C.bottomMostData = n)), t._x = o.x, t._y = o.y, t.setLink = (0, i.pluck)(a.link), t.anchorProps = this._parseAnchorProperties(e), t.showValue = (0, i.pluckNumber)(a.showvalue, C.showvalues), t.dashed = (0, i.pluckNumber)(a.dashed, N), t.color = (0, i.pluck)(a.color, C.linecolor), t.alpha = (0, i.pluck)(a.alpha, C.linealpha), t.dashStyle = t.dashed ? E : "none", t.toolTipValue = l = L.dataLabels(o.y, F), t.setDisplayValue = d = (0, i.parseUnsafeString)(a.displayvalue), u = t.formatedVal = (0, i.pluck)(a.toolTipValue, L.dataLabels(o.y, F)), h = L.xAxis(o.x), t.displayValue = (0, i.pluck)(d, l), t.setTooltext = (0, i.getValidValue)((0, i.parseUnsafeString)((0, i.pluck)(a.tooltext, C.plotToolText))), C.showTooltip ? void 0 !== t.setTooltext ? (s = [4, 5, 6, 7, 8, 9, 10, 11], c = {
          yaxisName: P,
          xaxisName: A,
          yDataValue: u,
          xDataValue: h
        }, r = (0, i.parseTooltext)(t.setTooltext, s, c, a, w, k)) : null === u ? r = !1 : (r = T ? T + O : i.BLANKSTRING, r += o.x ? h + O : i.BLANKSTRING, r += l) : r = !1, t.toolText = r, n ? n.graphics || (y[e].graphics = {}) : n = y[e] = {
          graphics: {}
        }, t.hoverEffects = this._parseHoverEffectOptions(n, a), t.anchorProps.isAnchorHoverRadius = t.hoverEffects.anchorRadius;
      }

      C.xMax = v, C.xMin = b, C.yMin = m, C.yMax = g, this.ErrorValueConfigure && this.ErrorValueConfigure();
    }, t.prototype._getHoveredPlot = function (e, t) {
      var n = this.config.dataTree.getNeighbour({
        x: e,
        y: t
      }, !0);
      if (n) return {
        pointIndex: n.index || n.i,
        hovered: !0,
        pointObj: n.data
      };
    }, t.prototype.drawPlots = function () {
      e.prototype.drawPlots.call(this), this.setupHoverTracker();
    }, t.prototype.getRegressionPoints = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r,
          l,
          s = this.getChildren("regression"),
          c = -Infinity,
          u = Infinity,
          h = -Infinity,
          d = Infinity;

      if (s && s.length && !s[0].getState("removed")) {
        for (r = (e = s[0]._config.regressionPoints || []).length, t = 0; t < r; t++) {
          for (i = e[t], n = 0; n < i.length; n++) {
            for (l = (o = i[n] || []).length, a = 0; a < l; a++) {
              c = Math.max(c, o[a].x), u = Math.min(u, o[a].x), h = Math.max(h, o[a].y), d = Math.min(d, o[a].y);
            }
          }
        }

        return {
          max: h,
          min: d,
          xMax: c,
          xMin: u
        };
      }
    }, t.prototype.getDataLimits = function () {
      var e = this.config,
          t = this.getFromEnv("chart").config,
          n = e.yMax,
          a = e.yMin,
          i = e.xMax,
          o = e.xMin,
          r = -Infinity,
          l = +Infinity,
          s = t.transposeAxis,
          c = this.getRegressionPoints();
      return !1 === this.getState("visible") && s && (n = r, a = l, i = r, o = l), c && (n = Math.max(n, c.max), a = Math.min(a, c.min), i = Math.max(i, c.xMax), o = Math.min(o, c.xMin)), {
        max: n,
        min: a,
        xMax: i,
        xMin: o
      };
    }, t.prototype.getAxisValuePadding = function () {
      return this.config.defaultValuePadding;
    }, t.prototype.getCanvasPadding = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          l,
          s,
          c,
          u,
          p,
          f,
          g,
          m,
          b,
          v,
          y,
          x = this.config || (this.config = {}),
          C = this.components || {},
          k = this.getFromEnv("chartConfig"),
          w = k.rotatevalues,
          S = this.getFromEnv("xAxis"),
          _ = this.getFromEnv("yAxis"),
          L = S.config.isReverse,
          P = this.getFromEnv("dataLabelStyle"),
          A = C.data || [],
          N = A.length,
          E = x.leftMostData || A[0],
          F = x.rightMostData || A[A.length - 1],
          O = x.topMostData,
          T = x.bottomMostData,
          D = d(k.canvasHeight, k.canvasWidth) / 8,
          M = S.getValue(0),
          I = 1,
          R = 1,
          V = k.zMax,
          B = x.bubbleScale,
          j = {},
          G = {},
          H = 0,
          z = 0,
          W = S.config.axisRange,
          q = W.min,
          U = W.max,
          Y = _.config.axisRange,
          X = Y.min,
          K = Y.max,
          Z = S.getPixel(q),
          J = S.getPixel(U),
          $ = this.getFromEnv("smartLabel"),
          Q = {
        paddingLeft: 0,
        paddingRight: 0
      },
          ee = 0;

      for (e = D / Math.sqrt(V), c = 0; c < N; c++) {
        t = A[c].config, n = E.config, a = F.config, l = Math.sqrt(t.z), m = Math.round(l * e) * B || 0, b = S.getValue(m) - M, u = t.x - b / 2, 1 === I && (l = Math.sqrt(n.z), m = Math.round(l * e) * B || 0, b = S.getValue(m) - M, p = n.x - b / 2), 1 === R && (l = Math.sqrt(a.z), m = Math.round(l * e) * B || 0, b = S.getValue(m) - M, f = a.x - b / 2), I = 0, R = 0, p > u && (E = A[c], I = 1), f < u && (F = A[c], R = 1);
      }

      return E && (r = (o = E.config).anchorProps.radius, (v = o.showValue) && (g = o.displayValue, $.useEllipsesOnOverflow(k.useEllipsesWhenOverflow), $.setStyle(P), G = $.getOriSize(g), ee = w ? G.height : G.width), null !== o.setValue && (u = S.getPixel(o.setValue.x), z = L ? J - (s = u - .5 * ee) : Z - (s = u - .5 * ee), H = !L && u - r <= Z || L && u - r <= J ? L ? J - (u - r) : Z - (u - r) : 0), Q.paddingLeft = h(z, H)), F && (v = (o = F.config).showValue, r = o.anchorProps.radius, v && (g = o.displayValue, $.setStyle(P), j = $.getOriSize(g), ee = w ? j.height : j.width), null !== o.setValue && (z = (s = (u = S.getPixel(o.setValue.x)) - Z + .5 * ee) - J + Z, L && (z = s), H = !L && u + r >= J || L && u + r >= Z ? L ? u + r - Z : u + r - J : 0), Q.paddingRight = h(z, H)), O && (r = (o = O.config).anchorProps.radius || 0, K = _.getPixel(K), null !== o.setValue && (y = _.getPixel(o.setValue.y), H = (0, i.pluckNumber)(r, 0) + (0, i.pluckNumber)(o.anchorProps.borderThickness, 0) / 2), Q.paddingTop = K - (y - H) > 0 ? K - (y - H) : 0), T && (r = (o = T.config).anchorProps.radius || 0, X = _.getPixel(X), null !== o.setValue && (y = _.getPixel(o.setValue.y), H = (0, i.pluckNumber)(r, 0) + (0, i.pluckNumber)(o.anchorProps.borderThickness, 0) / 2), Q.paddingBottom = y + H - X > 0 ? y + H - X : 0), Q;
    }, t.prototype._addLegend = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          l,
          s = this.getFromEnv("chart"),
          c = this.config,
          u = s.getChildren("legend")[0],
          h = (0, i.pluckNumber)(c.drawanchors, 1),
          d = {
        fillColor: (r = c.anchorbgcolor, l = i.HUNDREDSTRING, r = (0, i.getFirstColor)(r), l = (0, i.getFirstAlpha)(l), {
          FCcolor: {
            gradientUnits: "objectBoundingBox",
            cx: .4,
            cy: .4,
            r: "100%",
            color: (0, i.getLightColor)(r, 70) + "," + (0, i.getDarkColor)(r, 50),
            alpha: l + "," + l,
            ratio: i.BGRATIOSTRING,
            radialGradient: !0
          }
        }),
        lineColor: {
          FCcolor: {
            color: c.anchorbordercolor,
            alpha: c.anchoralpha
          }
        },
        lineWidth: c.anchorborderthickness
      };
      u.config.symbol3DLighting ? d.fillcolor && d.fillcolor.FCcolor ? (e = (0, i.extend2)({}, d.fillcolor)).FCcolor.alpha = "100" : e = (0, i.pluck)(d.fillColor) : e = {
        FCcolor: {
          color: (0, i.pluck)((t = d.fillColor) && (t.FCcolor && t.FCcolor.color.split(",")[0] || t)),
          angle: 0,
          ratio: "0",
          alpha: "100"
        }
      }, a = {
        enabled: c.includeInLegend,
        type: this.type,
        drawLine: (0, i.pluck)(c.drawLine, !0),
        anchorSide: h ? c.anchorsides : 0,
        label: (0, i.getFirstValue)(this.config.JSONData.seriesname)
      }, c.includeinlegend ? ((o = u.getItem(this.config.legendItemId)) ? o.configure({
        style: u.config.itemStyle,
        hiddenStyle: u.config.itemHiddenStyle,
        datasetVisible: u.config.datasetVisible,
        hoverStyle: u.config.itemHoverStyle
      }) : (this.config.legendItemId = u.createItem(this), o = u.getItem(this.config.legendItemId), this.addExtEventListener("fc-click", function () {
        o.itemClickFn();
      }, o)), o.configure(a), o.setStateCosmetics("default", {
        symbol: {
          fill: (0, i.toRaphaelColor)(e),
          rawFillColor: c.anchorbgcolor,
          rawStrokeColor: c.lineColor,
          stroke: (0, i.toRaphaelColor)((0, i.pluck)((n = d.lineColor) && (n.FCcolor && n.FCcolor.color.split(",")[0] || n))),
          "stroke-width": c.anchorborderthickness
        }
      }), this.getState("visible") ? o.removeLegendState("hidden") : o.setLegendState("hidden")) : this.config.legendItemId && u.disposeItem(this.config.legendItemId);
    }, t.prototype.getDSGroupdef = function () {}, t.prototype.trimData = function (e) {
      if (this.config.JSONData) {
        var t = this.config,
            n = t && t.context,
            a = n && n.prevCatlen,
            i = this.getFromEnv("xAxis").getTicksLen(),
            o = a - i,
            r = t.JSONData,
            l = r.data && r.data.length,
            s = e.data && e.data.length || 0,
            c = l - s,
            u = void 0,
            h = void 0;
        o > c ? (u = o, h = i) : (u = c, h = s), u > 0 && this.removeData(h, u, !1);
      }
    }, t;
  }(a["default"]);

  t["default"] = f;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  /** !
   * @license FusionCharts JavaScript Library - KDtree
   * Copyright FusionCharts Technologies LLP
   * License Information at <http://www.fusioncharts.com/license>
   *
   * @version //? write(JSON.parse(require('fs').readFileSync('./package.json')).version);
   */

  var a = function a(e, t, n, _a, i) {
    return Math.pow(n - e, 2) + Math.pow(_a - t, 2) <= Math.pow(i, 2);
  },
      i = Math.PI,
      o = Math.cos,
      r = Math.sin,
      l = Math.max,
      s = Math.min,
      c = i / 180,
      u = function u(e, t, n, a, i, o) {
    var r, l, s;
    return r = (a - t) * (i - n), l = (n - e) * (o - a), isNaN(r) && (r = 0), isNaN(l) && (l = 0), 0 === (s = r - l) ? 0 : s > 0 ? 1 : 2;
  },
      h = function h(e, t, n, a, i, o) {
    return n <= l(e, i) && n >= s(e, i) && a <= l(t, o) && a >= s(t, o);
  },
      d = function d(e, t, n, a, i, o, r, l) {
    var s = u(e, t, n, a, i, o),
        c = u(e, t, n, a, r, l),
        d = u(i, o, r, l, e, t),
        p = u(i, o, r, l, n, a);
    return s !== c && d !== p || !(0 !== s || !h(e, t, i, o, n, a)) || !(0 !== c || !h(e, t, r, l, n, a)) || !(0 !== d || !h(i, o, e, t, r, l)) || !(0 !== p || !h(i, o, n, a, r, l));
  },
      p = function p(e, t, n, l, s, _p2, f) {
    var g,
        m,
        b,
        v,
        y,
        x,
        C,
        k = Infinity,
        w = 0,
        S = !1;

    if (a(e, t, n, l, s) && _p2 >= 3) {
      for (m = void 0 === f ? .5 * i : f % 360 * c, C = 2 * i / _p2, b = n + s * o(-m), x = l + s * r(-m), g = 0; g < _p2; g++) {
        if (v = n + s * o(-(m += C)), y = l + s * r(-m), d(b, x, v, y, e, t, k, t)) {
          if (0 === u(b, x, e, t, v, y)) return h(b, x, e, t, v, y);
          w++;
        }

        b = v, x = y;
      }

      S = w % 2 != 0;
    }

    return S;
  },
      f = function f(e, t) {
    return !e || e && t && t.i > e.i ? t : e;
  };

  var g = function () {
    function e(t) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e);
      this.configure(t);
    }

    return e.prototype.configure = function (e) {
      this.validatorFn = e ? this.shapeValidator() : this.defaultValidator();
    }, e.prototype.defaultValidator = function () {
      var e = this;
      return function (t) {
        var n = e.mousePoint;
        return !!(t && Math.pow((t.x - n.x) / e.xLimit, 2) + Math.pow((t.y - n.y) / e.yLimit, 2) <= 1);
      };
    }, e.prototype.shapeValidator = function () {
      var e = this;
      return function (t) {
        var n,
            i,
            o,
            r,
            l,
            s,
            c,
            u,
            h = e.mousePoint,
            d = t && t.shapeInfo,
            f = !1,
            g = h.x,
            m = h.y;

        switch (d && d.type) {
          case "circle":
            i = d.radius, f = a(g, m, t.x, t.y, i);
            break;

          case "arc":
            n = d.innerradius, i = d.radius, f = !a(g, m, t.x, t.y, n) && a(g, m, t.x, t.y, i);
            break;

          case "polygon":
            i = d.radius, r = d.startAngle, o = d.sides, f = p(g, m, t.x, t.y, i, o, r);
            break;

          case "rect":
          case "rectangle":
            l = t.x, c = t.y, s = l + (d.width || 0), u = c + (d.height || 0), f = g >= l && g <= s && m >= c && m <= u;
            break;

          case "default":
            f = !1;
        }

        return f;
      };
    }, e.prototype.buildKdTree = function (e) {
      return this.kdTree = function (e) {
        var t,
            _n5,
            _a2,
            i = e && e[0] && e[0].r || 5,
            o = Math.max,
            r = Math.floor,
            l = Math.sqrt,
            s = Math.min,
            c = Math.log,
            u = Math.exp,
            h = Math.pow;

        function d(e, t, n) {
          var a = e[t];
          e[t] = e[n], e[n] = a;
        }

        for (_n5 = function n(e, t, a, i) {
          for (var h, p, f, g, m, b, v, y, x, C; i > a;) {
            for (i - a > 600 && (p = t - a + 1, f = c(h = i - a + 1), g = .5 * u(2 * f / 3), m = .5 * l(f * g * (h - g) / h) * (p - h / 2 < 0 ? -1 : 1), b = o(a, r(t - p * g / h + m)), v = s(i, r(t + (h - p) * g / h + m)), _n5(e, t, b, v)), y = e[t], x = a, C = i, d(e, a, t), e[i].x > y.x && d(e, a, i); x < C;) {
              for (d(e, x, C), x++, C--; e[x].x < y.x;) {
                x++;
              }

              for (; e[C].x > y.x;) {
                C--;
              }
            }

            e[a].x === y.x ? d(e, a, C) : d(e, ++C, i), C <= t && (a = C + 1), t <= C && (i = C - 1);
          }
        }, _a2 = function a(e, t, n, i) {
          for (var h, p, f, g, m, b, v, y, x, C; i > n;) {
            for (i - n > 600 && (p = t - n + 1, f = c(h = i - n + 1), g = .5 * u(2 * f / 3), m = .5 * l(f * g * (h - g) / h) * (p - h / 2 < 0 ? -1 : 1), b = o(n, r(t - p * g / h + m)), v = s(i, r(t + (h - p) * g / h + m)), _a2(e, t, b, v)), y = e[t], x = n, C = i, d(e, n, t), e[i].y > y.y && d(e, n, i); x < C;) {
              for (d(e, x, C), x++, C--; e[x].y < y.y;) {
                x++;
              }

              for (; e[C].y > y.y;) {
                C--;
              }
            }

            e[n].y === y.y ? d(e, n, C) : d(e, ++C, i), C <= t && (n = C + 1), t <= C && (i = C - 1);
          }
        }, t = (e = e || []).length; t--;) {
          e[t].r > i && (i = e[t].r), e[t].i = t, e[t].x = +e[t].x, e[t].y = +e[t].y;
        }

        return {
          tree: 0 === e.length ? {} : function p(e, t, i, o) {
            var r,
                l = {},
                s = o ? "y" : "x";
            return t === i ? (l.point = e[t], l) : i - t == 1 ? (e[t][s] > e[i][s] ? (l.point = e[t], l.left = {
              point: e[i]
            }) : (l.point = e[i], l.left = {
              point: e[t]
            }), l) : (r = t + i >> 1, o ? _a2(e, r, t, i) : _n5(e, r, t, i), l.point = e[r], l.left = p(e, t, r - 1, !o), l.right = p(e, r + 1, i, !o), l);
          }(e, 0, e.length - 1, !1),
          search: function search(e, t, n, a) {
            var o,
                r,
                s,
                c = this.tree,
                u = e - i,
                d = e + i,
                p = t - i,
                f = t + i,
                g = !1,
                m = 0;

            function b(e, t, n, a) {
              return l(h(e - n, 2) + h(t - a, 2));
            }

            function v(a, i) {
              return "circle" === n ? b(a, i, e, t) <= u : a >= u && a <= d && i >= p && i <= f;
            }

            function y(e, t, n) {
              return e >= t && e <= n;
            }

            function x(n) {
              var a = y(e, n.x1, n.x2) && y(t, n.y1, n.y2),
                  i = b(e, t, n.point.x, n.point.y);
              if (!o) return o = n, g = a, void (m = i);
              a ? g ? n.point.i > o.point.i && (o = n, g = a, m = i) : (o = n, g = a, m = i) : g || i < m && (o = n, g = a, m = i);
            }

            function C(a, i) {
              "circle" === n ? u = a : (u = e - a || 0, d = e + a || 0, p = t - i || 0, f = t + i || 0);
            }

            return a = a || {}, s = function s(e) {
              e && e.point && (C(a.rx || e.point.r, a.ry || e.point.r), v(e.point.x, e.point.y) && x(e), p <= e.point.y && r(e.left), f >= e.point.y && r(e.right));
            }, (r = function r(e) {
              e && e.point && (C(a.rx || e.point.r, a.ry || e.point.r), v(e.point.x, e.point.y) && x(e), u <= e.point.x && s(e.left), d >= e.point.x && s(e.right));
            })(c), o && o.point || o;
          }
        };
      }(e), this.tree = this.kdTree.tree, this;
    }, e.prototype.getNeighbour = function (e, t, n) {
      var a = this.tree,
          i = {
        x1: e.x - this.xLimit,
        x2: e.x + this.xLimit,
        y1: e.y - this.yLimit,
        y2: e.y + this.yLimit
      },
          o = this.validatorFn;
      return this.mousePoint = e, t ? this.kdTree && this.kdTree.search(e.x, e.y, n, e.options) : a ? this._searchBtwnLimit(i, a, !0, o) : void 0;
    }, e.prototype._searchBtwnLimit = function (e, t, n, a) {
      var i,
          o,
          r = n ? "x" : "y",
          l = n ? e.x1 : e.y1,
          s = n ? e.x2 : e.y2;
      if (void 0 !== (i = t && t.point && t.point[r])) return a(t.point) && (o = t.point), i >= l && t.left && (o = f(o, this._searchBtwnLimit(e, t.left, !n, a))), i <= s && t.right && (o = f(o, this._searchBtwnLimit(e, t.right, !n, a))), o;
    }, e.prototype._setSearchLimit = function (e, t) {
      this.xLimit = e, this.yLimit = t;
    }, e;
  }();

  g.prototype.constructor = g, t["default"] = g;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(452),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };
  t["default"] = {
    "*.dataset.scatter": o["default"]["*.dataset.line"]
  };
},,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t._checkInvalidSpecificData = undefined;
  var a = l(n(459)),
      i = l(n(432)),
      o = l(n(525)),
      r = l(n(547));

  function l(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function s(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var c = function c() {
    var e = this.getFromEnv("dataSource"),
        t = e.dataset,
        n = e.categories,
        a = void 0;
    if (!t || !n) return !0;
    if (a = t.length) for (; a--;) {
      if (!t[a].dataset) return !0;
    }
  },
      u = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.registerFactory("dataset", r["default"], ["vCanvas"]), n;
    }

    return s(t, e), t.getName = function () {
      return "MSStackedColumn2D";
    }, t.prototype._checkInvalidSpecificData = function () {
      return c.call(this);
    }, t.prototype.getName = function () {
      return "MSStackedColumn2D";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this);

      var t = this.config;
      t.friendlyName = "Multi-series Stacked Column Chart", t.defaultDatasetType = "column", t.isstacked = !0, t.enablemousetracking = !0;
    }, t.prototype.getDSdef = function () {
      return i["default"];
    }, t.prototype.getDSGroupdef = function () {
      return o["default"];
    }, t;
  }(a["default"]);

  t["default"] = u, t._checkInvalidSpecificData = c;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    var t = e.getFromEnv("dataSource").dataset,
        n = t && t.length,
        a = void 0,
        o = void 0,
        l = 0,
        s = void 0,
        c = e.getChildren("canvas")[0].getChildren("vCanvas")[0],
        u = void 0,
        h = void 0,
        d = [],
        p = void 0;

    if (t) {
      for ((0, i.componentFactory)(c, r["default"], "multiSeriesGroup_column"), p = c.getChildren("multiSeriesGroup_column")[0], a = 0; a < n; a++) {
        d.push(t[a].dataset);
      }

      for ((0, i.componentFactory)(p, e.getDSGroupdef(), "stackedGroup_column", n, d), h = p.getChildren("stackedGroup_column"), a = 0; a < h.length; a++) {
        if (!0 !== h[a].getState("removed")) {
          if (!(s = t[a].dataset)) return void e.setChartMessage();
          o = s && s.length, u = Array(o).fill(a * l).map(function (e, t) {
            return e + t;
          }), (0, i.datasetFactory)(h[a], e.getDSdef(), "dataset_column", o, s, u), l = o;
        }
      }

      e.config._lastDatasetIndex = u[u.length - 1];
    } else e.setChartMessage();
  };
  var a,
      i = n(125),
      o = n(516),
      r = (a = o) && a.__esModule ? a : {
    "default": a
  };
},,, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = i(n(450));

  function i(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function o(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var r = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.defaultPlotShadow = 0, n;
    }

    return o(t, e), t.getName = function () {
      return "MSArea";
    }, t.prototype.getName = function () {
      return "MSArea";
    }, t.prototype.getDSdef = function () {
      return a["default"];
    }, t.prototype.getDSGroupdef = function () {
      return undefined;
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this);

      var t = this.config;
      t.friendlyName = "Multi-series Area Chart", t.defaultDatasetType = "area", t.defaultcrosslinethickness = 1;
    }, t;
  }(i(n(551))["default"]);

  t["default"] = r;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t._setDefaultConfig = undefined;
  var a,
      i = n(518),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  },
      r = n(125);

  function l(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var s = r.preDefStr.SEVENTYSTRING,
      c = function c() {
    var e = this.config;
    e.anchorborderthickness = 1, e.anchorimageurl = void 0, e.anchorimagepadding = 1, e.anchorsides = 1, e.anchoralpha = void 0, e.anchorbgalpha = r.HUNDREDSTRING, e.anchorimagealpha = r.HUNDREDSTRING, e.anchorimagescale = 100, e.anchorstartangle = 90, e.anchorshadow = 0, e.anchorbgcolor = void 0, e.anchorbordercolor = void 0, e.anchorradius = 3, e.showvalues = 1, e.plotfillalpha = s, e.linedashlen = 5, e.linedashgap = 4, e.linedashed = void 0, e.linealpha = r.HUNDREDSTRING, e.linethickness = 2, e.drawfullareaborder = 1, e.connectnulldata = 0;
  },
      u = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.apply(this, arguments));
    }

    return l(t, e), t.getName = function () {
      return "AreaBase";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this), c.call(this);
    }, t;
  }(o["default"]);

  t["default"] = u, t._setDefaultConfig = c;
},,,,,,,,,,,,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(125),
      i = u(n(495)),
      o = n(546),
      r = u(n(449)),
      l = u(n(432)),
      s = u(n(525)),
      c = u(n(568));

  function u(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function h(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var d = a.preDefStr.SEVENTYSTRING,
      p = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.stack100percent = 0, n.hasLineSet = !0, n.lineset = !0, n.registerFactory("dataset", c["default"], ["vCanvas"]), n;
    }

    return h(t, e), t.getName = function () {
      return "MSStackedColumn2DLineDy";
    }, t.prototype.getName = function () {
      return "MSStackedColumn2DLineDy";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this);

      var t = this.config;
      t.sDefaultDatasetType = "line", t.friendlyName = "Multi-series Dual Y-Axis Stacked Column and Line Chart", t.defaultDatasetType = "column", t.isdual = !0, t.haslineset = !0, t.isstacked = !0, t.enablemousetracking = !0, t.anchorborderthickness = 1, t.anchorimageurl = void 0, t.anchorimagepadding = 1, t.anchorsides = 1, t.anchoralpha = void 0, t.anchorbgalpha = a.HUNDREDSTRING, t.anchorimagealpha = a.HUNDREDSTRING, t.anchorimagescale = 100, t.anchorstartangle = 90, t.anchorshadow = 0, t.anchorbgcolor = void 0, t.anchorbordercolor = void 0, t.anchorradius = 3, t.showvalues = 1, t.plotfillalpha = d, t.linedashlen = 5, t.linedashgap = 4, t.linedashed = void 0, t.linealpha = a.HUNDREDSTRING, t.linethickness = 2, t.drawfullareaborder = 1, t.connectnulldata = 0;
    }, t.prototype._checkInvalidSpecificData = function () {
      return o._checkInvalidSpecificData.call(this);
    }, t.prototype.getDSdef = function (e) {
      return "line" === e ? r["default"] : l["default"];
    }, t.prototype.getDSGroupdef = function () {
      return s["default"];
    }, t;
  }(i["default"]);

  t["default"] = p;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    var t,
        n = e.getFromEnv("dataSource"),
        a = n.dataset,
        i = n.lineset,
        s = void 0,
        c = e.getChildren("canvas")[0].getChildren("vCanvas")[1];
    a || 0 !== i.length ? ((0, o["default"])(e), t = e.config._lastDatasetIndex + 1, i && i.length ? (s = Array(i.length).fill(t).map(function (e, t) {
      return e + t;
    }), (0, r.datasetFactory)(c, e.getDSdef("line"), "dataset_line", i.length, i, s)) : l(c)) : e.setChartMessage();
  };
  var a,
      i = n(547),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  },
      r = n(125);

  var l = function l(e) {
    var t = e.getChildren("dataset_line"),
        n = void 0;

    for (n = t && t.length - 1; n > -1; n--) {
      t[n].remove();
    }
  };
},,,,,,,,,,,,,,,,,,,,,,,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = o(n(551)),
      i = o(n(449));

  function o(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function r(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var l = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.defaultPlotShadow = 1, n.axisPaddingLeft = 0, n.axisPaddingRight = 0, n;
    }

    return r(t, e), t.getName = function () {
      return "MSLine";
    }, t.prototype.getName = function () {
      return "MSLine";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this);

      var t = this.config;
      t.friendlyName = "Multi-series Line Chart", t.defaultDatasetType = "line", t.zeroplanethickness = 1, t.zeroplanealpha = 40, t.showzeroplaneontop = 0, t.enablemousetracking = !0, t.defaultcrosslinethickness = 1;
    }, t.prototype.getDSdef = function () {
      return i["default"];
    }, t.prototype.getDSGroupdef = function () {}, t;
  }(a["default"]);

  t["default"] = l;
},,, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(599),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };
  t["default"] = o["default"];
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(600),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };
  t["default"] = o["default"];
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(551),
      i = o(n(514));

  function o(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function r(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var l = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.defaultPlotShadow = 1, n;
    }

    return r(t, e), t.getName = function () {
      return "Spline";
    }, t.prototype.getName = function () {
      return "Spline";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this);

      var t = this.config;
      t.friendlyName = "Spline Chart", t.singleseries = !0, t.defaultDatasetType = "msspline", t.minimizetendency = 0, t.zeroplanethickness = 1, t.zeroplanealpha = 40, t.showzeroplaneontop = 0, t.enablemousetracking = !0, t.defaultcrosslinethickness = 1, a._setDefaultConfig.call(this);
    }, t.prototype.getDSdef = function () {
      return i["default"];
    }, t;
  }(o(n(359))["default"]);

  t["default"] = l;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(602),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };
  t["default"] = o["default"];
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = r(n(600)),
      i = n(551),
      o = r(n(510));

  function r(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function l(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var s = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.defaultPlotShadow = 0, n;
    }

    return l(t, e), t.getName = function () {
      return "SplineArea";
    }, t.prototype.getName = function () {
      return "SplineArea";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this);

      var t = this.config;
      i._setDefaultConfig.call(this), t.friendlyName = "Spline Area Chart", t.singleseries = !0, t.hasLegend = !1, t.defaultDatasetType = "mssplinearea", t.anchoralpha = "100", t.minimizetendency = 0, t.enablemousetracking = !0, t.defaultcrosslinethickness = 1, t.showzeroplaneontop = 1;
    }, t.prototype.getDSdef = function () {
      return o["default"];
    }, t.prototype.getDSGroupdef = function () {}, t;
  }(a["default"]);

  t["default"] = s;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(604),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };
  t["default"] = o["default"];
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(605),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };
  t["default"] = o["default"];
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(551),
      i = o(n(514));

  function o(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function r(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var l = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.defaultPlotShadow = 1, n;
    }

    return r(t, e), t.getName = function () {
      return "MSSpline";
    }, t.prototype.getName = function () {
      return "MSSpline";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this);

      var t = this.config;
      t.friendlyName = "Multi-series Spline  Chart", t.defaultDatasetType = "msspline", t.minimizetendency = 0, t.zeroplanethickness = 1, t.zeroplanealpha = 40, t.showzeroplaneontop = 0, t.enablemousetracking = !0, t.defaultcrosslinethickness = 1, a._setDefaultConfig.call(this);
    }, t.prototype.getDSdef = function () {
      return i["default"];
    }, t.prototype.getDSGroupdef = function () {}, t;
  }(o(n(459))["default"]);

  t["default"] = l;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(607),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };
  t["default"] = o["default"];
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(551),
      i = r(n(495)),
      o = r(n(514));

  function r(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function l(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var s = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.isDual = !0, n;
    }

    return l(t, e), t.getName = function () {
      return "MSSplineDy";
    }, t.prototype.getName = function () {
      return "MSSplineDy";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this);

      var t = this.config;
      t.friendlyName = "Multi-series Dual Y-Axis Spline Chart", t.defaultDatasetType = "msspline", t.minimizetendency = 0, t.zeroplanethickness = 1, t.zeroplanealpha = 40, t.showzeroplaneontop = 0, t.enablemousetracking = !0, t.defaultcrosslinethickness = 1, t.isdual = !0, a._setDefaultConfig.call(this);
    }, t.prototype.getDSdef = function () {
      return o["default"];
    }, t.prototype.getDSGroupdef = function () {}, t.prototype.getDSType = function () {
      return "spline";
    }, t;
  }(i["default"]);

  t["default"] = s;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(609),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };
  t["default"] = o["default"];
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = r(n(605)),
      i = n(551),
      o = r(n(510));

  function r(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function l(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var s = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.friendlyName = "Multi-series Spline Area Chart", n.defaultPlotShadow = 0, n;
    }

    return l(t, e), t.getName = function () {
      return "MSSplineArea";
    }, t.prototype.getName = function () {
      return "MSSplineArea";
    }, t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this);

      var t = this.config;
      i._setDefaultConfig.call(this), t.defaultDatasetType = "mssplinearea", t.minimizetendency = 0, t.zeroplanethickness = 2, t.zeroplanealpha = 80, t.showzeroplaneontop = 1, t.enablemousetracking = !0, t.defaultcrosslinethickness = 1;
    }, t.prototype.getDSdef = function () {
      return o["default"];
    }, t.prototype.getDSGroupdef = function () {}, t;
  }(a["default"]);

  t["default"] = s;
},,,,, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(615),
      i = n(618),
      o = n(621),
      r = n(624),
      l = n(632),
      s = Object(a["default"])(Object(i["default"])(["fantasy-land/chain", "chain"], r["default"], function (e, t) {
    return "function" == typeof t ? function (n) {
      return e(t(n))(n);
    } : Object(o["default"])(!1)(Object(l["default"])(e, t));
  }));
  t["default"] = s;
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "default", function () {
    return o;
  });
  var a = n(616),
      i = n(617);

  function o(e) {
    return function t(n, o) {
      switch (arguments.length) {
        case 0:
          return t;

        case 1:
          return Object(i["default"])(n) ? t : Object(a["default"])(function (t) {
            return e(n, t);
          });

        default:
          return Object(i["default"])(n) && Object(i["default"])(o) ? t : Object(i["default"])(n) ? Object(a["default"])(function (t) {
            return e(t, o);
          }) : Object(i["default"])(o) ? Object(a["default"])(function (t) {
            return e(n, t);
          }) : e(n, o);
      }
    };
  }
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "default", function () {
    return i;
  });
  var a = n(617);

  function i(e) {
    return function t(n) {
      return 0 === arguments.length || Object(a["default"])(n) ? t : e.apply(this, arguments);
    };
  }
}, function (e, t, n) {
  "use strict";

  function a(e) {
    return null != e && "object" == typeof e && !0 === e["@@functional/placeholder"];
  }

  n.r(t), n.d(t, "default", function () {
    return a;
  });
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "default", function () {
    return o;
  });
  var a = n(619),
      i = n(620);

  function o(e, t, n) {
    return function () {
      if (0 === arguments.length) return n();
      var o = Array.prototype.slice.call(arguments, 0),
          r = o.pop();

      if (!Object(a["default"])(r)) {
        for (var l = 0; l < e.length;) {
          if ("function" == typeof r[e[l]]) return r[e[l]].apply(r, o);
          l += 1;
        }

        if (Object(i["default"])(r)) return t.apply(null, o)(r);
      }

      return n.apply(this, arguments);
    };
  }
}, function (e, t, n) {
  "use strict";

  n.r(t), t["default"] = Array.isArray || function (e) {
    return null != e && e.length >= 0 && "[object Array]" === Object.prototype.toString.call(e);
  };
}, function (e, t, n) {
  "use strict";

  function a(e) {
    return "function" == typeof e["@@transducer/step"];
  }

  n.r(t), n.d(t, "default", function () {
    return a;
  });
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "default", function () {
    return i;
  });
  var a = n(622);

  function i(e) {
    return function t(n) {
      for (var i, o, r, l = [], s = 0, c = n.length; s < c;) {
        if (Object(a["default"])(n[s])) for (r = 0, o = (i = e ? t(n[s]) : n[s]).length; r < o;) {
          l[l.length] = i[r], r += 1;
        } else l[l.length] = n[s];
        s += 1;
      }

      return l;
    };
  }
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(616),
      i = n(619),
      o = n(623),
      r = Object(a["default"])(function (e) {
    return !!Object(i["default"])(e) || !!e && "object" == typeof e && !Object(o["default"])(e) && (1 === e.nodeType ? !!e.length : 0 === e.length || e.length > 0 && e.hasOwnProperty(0) && e.hasOwnProperty(e.length - 1));
  });
  t["default"] = r;
}, function (e, t, n) {
  "use strict";

  function a(e) {
    return "[object String]" === Object.prototype.toString.call(e);
  }

  n.r(t), n.d(t, "default", function () {
    return a;
  });
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(615),
      i = n(625),
      o = n(632),
      r = Object(a["default"])(function (e, t) {
    return Object(o["default"])(e, Object(i["default"])(t));
  });
  t["default"] = r;
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(626),
      i = n(622),
      o = n(627),
      r = n(631);

  t["default"] = function (e) {
    var t = function (e) {
      return {
        "@@transducer/init": r["default"].init,
        "@@transducer/result": function transducerResult(t) {
          return e["@@transducer/result"](t);
        },
        "@@transducer/step": function transducerStep(t, n) {
          var i = e["@@transducer/step"](t, n);
          return i["@@transducer/reduced"] ? Object(a["default"])(i) : i;
        }
      };
    }(e);

    return {
      "@@transducer/init": r["default"].init,
      "@@transducer/result": function transducerResult(e) {
        return t["@@transducer/result"](e);
      },
      "@@transducer/step": function transducerStep(e, n) {
        return Object(i["default"])(n) ? Object(o["default"])(t, e, n) : Object(o["default"])(t, e, [n]);
      }
    };
  };
}, function (e, t, n) {
  "use strict";

  function a(e) {
    return {
      "@@transducer/value": e,
      "@@transducer/reduced": !0
    };
  }

  n.r(t), n.d(t, "default", function () {
    return a;
  });
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "default", function () {
    return c;
  });
  var a = n(622),
      i = n(628),
      o = n(629);

  function r(e, t, n) {
    for (var a = n.next(); !a.done;) {
      if ((t = e["@@transducer/step"](t, a.value)) && t["@@transducer/reduced"]) {
        t = t["@@transducer/value"];
        break;
      }

      a = n.next();
    }

    return e["@@transducer/result"](t);
  }

  function l(e, t, n, a) {
    return e["@@transducer/result"](n[a](Object(o["default"])(e["@@transducer/step"], e), t));
  }

  var s = "undefined" != typeof Symbol ? Symbol.iterator : "@@iterator";

  function c(e, t, n) {
    if ("function" == typeof e && (e = Object(i["default"])(e)), Object(a["default"])(n)) return function (e, t, n) {
      for (var a = 0, i = n.length; a < i;) {
        if ((t = e["@@transducer/step"](t, n[a])) && t["@@transducer/reduced"]) {
          t = t["@@transducer/value"];
          break;
        }

        a += 1;
      }

      return e["@@transducer/result"](t);
    }(e, t, n);
    if ("function" == typeof n["fantasy-land/reduce"]) return l(e, t, n, "fantasy-land/reduce");
    if (null != n[s]) return r(e, t, n[s]());
    if ("function" == typeof n.next) return r(e, t, n);
    if ("function" == typeof n.reduce) return l(e, t, n, "reduce");
    throw new TypeError("reduce: list must be array or iterable");
  }
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "default", function () {
    return i;
  });

  var a = function () {
    function e(e) {
      this.f = e;
    }

    return e.prototype["@@transducer/init"] = function () {
      throw new Error("init not implemented on XWrap");
    }, e.prototype["@@transducer/result"] = function (e) {
      return e;
    }, e.prototype["@@transducer/step"] = function (e, t) {
      return this.f(e, t);
    }, e;
  }();

  function i(e) {
    return new a(e);
  }
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(630),
      i = n(615),
      o = Object(i["default"])(function (e, t) {
    return Object(a["default"])(e.length, function () {
      return e.apply(t, arguments);
    });
  });
  t["default"] = o;
}, function (e, t, n) {
  "use strict";

  function a(e, t) {
    switch (e) {
      case 0:
        return function () {
          return t.apply(this, arguments);
        };

      case 1:
        return function (e) {
          return t.apply(this, arguments);
        };

      case 2:
        return function (e, n) {
          return t.apply(this, arguments);
        };

      case 3:
        return function (e, n, a) {
          return t.apply(this, arguments);
        };

      case 4:
        return function (e, n, a, i) {
          return t.apply(this, arguments);
        };

      case 5:
        return function (e, n, a, i, o) {
          return t.apply(this, arguments);
        };

      case 6:
        return function (e, n, a, i, o, r) {
          return t.apply(this, arguments);
        };

      case 7:
        return function (e, n, a, i, o, r, l) {
          return t.apply(this, arguments);
        };

      case 8:
        return function (e, n, a, i, o, r, l, s) {
          return t.apply(this, arguments);
        };

      case 9:
        return function (e, n, a, i, o, r, l, s, c) {
          return t.apply(this, arguments);
        };

      case 10:
        return function (e, n, a, i, o, r, l, s, c, u) {
          return t.apply(this, arguments);
        };

      default:
        throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
    }
  }

  n.r(t), n.d(t, "default", function () {
    return a;
  });
}, function (e, t, n) {
  "use strict";

  n.r(t), t["default"] = {
    init: function init() {
      return this.xf["@@transducer/init"]();
    },
    result: function result(e) {
      return this.xf["@@transducer/result"](e);
    }
  };
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(615),
      i = n(618),
      o = n(633),
      r = n(627),
      l = n(634),
      s = n(635),
      c = n(637),
      u = Object(a["default"])(Object(i["default"])(["fantasy-land/map", "map"], l["default"], function (e, t) {
    switch (Object.prototype.toString.call(t)) {
      case "[object Function]":
        return Object(s["default"])(t.length, function () {
          return e.call(this, t.apply(this, arguments));
        });

      case "[object Object]":
        return Object(r["default"])(function (n, a) {
          return n[a] = e(t[a]), n;
        }, {}, Object(c["default"])(t));

      default:
        return Object(o["default"])(e, t);
    }
  }));
  t["default"] = u;
}, function (e, t, n) {
  "use strict";

  function a(e, t) {
    for (var n = 0, a = t.length, i = Array(a); n < a;) {
      i[n] = e(t[n]), n += 1;
    }

    return i;
  }

  n.r(t), n.d(t, "default", function () {
    return a;
  });
}, function (e, t, n) {
  "use strict";

  n.r(t);

  var a = n(615),
      i = n(631),
      o = function () {
    function e(e, t) {
      this.xf = t, this.f = e;
    }

    return e.prototype["@@transducer/init"] = i["default"].init, e.prototype["@@transducer/result"] = i["default"].result, e.prototype["@@transducer/step"] = function (e, t) {
      return this.xf["@@transducer/step"](e, this.f(t));
    }, e;
  }(),
      r = Object(a["default"])(function (e, t) {
    return new o(e, t);
  });

  t["default"] = r;
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(630),
      i = n(616),
      o = n(615),
      r = n(636),
      l = Object(o["default"])(function (e, t) {
    return 1 === e ? Object(i["default"])(t) : Object(a["default"])(e, Object(r["default"])(e, [], t));
  });
  t["default"] = l;
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "default", function () {
    return o;
  });
  var a = n(630),
      i = n(617);

  function o(e, t, n) {
    return function () {
      for (var r = [], l = 0, s = e, c = 0; c < t.length || l < arguments.length;) {
        var u;
        c < t.length && (!Object(i["default"])(t[c]) || l >= arguments.length) ? u = t[c] : (u = arguments[l], l += 1), r[c] = u, Object(i["default"])(u) || (s -= 1), c += 1;
      }

      return s <= 0 ? n.apply(this, r) : Object(a["default"])(s, o(e, r, n));
    };
  }
}, function (e, t, n) {
  "use strict";

  n.r(t);

  var a = n(616),
      i = n(638),
      o = n(639),
      r = !{
    toString: null
  }.propertyIsEnumerable("toString"),
      l = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
      s = function () {
    return arguments.propertyIsEnumerable("length");
  }(),
      c = function c(e, t) {
    for (var n = 0; n < e.length;) {
      if (e[n] === t) return !0;
      n += 1;
    }

    return !1;
  },
      u = "function" != typeof Object.keys || s ? function (e) {
    if (Object(e) !== e) return [];
    var t,
        n,
        a = [],
        u = s && Object(o["default"])(e);

    for (t in e) {
      !Object(i["default"])(t, e) || u && "length" === t || (a[a.length] = t);
    }

    if (r) for (n = l.length - 1; n >= 0;) {
      t = l[n], Object(i["default"])(t, e) && !c(a, t) && (a[a.length] = t), n -= 1;
    }
    return a;
  } : function (e) {
    return Object(e) !== e ? [] : Object.keys(e);
  },
      h = Object(a["default"])(u);

  t["default"] = h;
}, function (e, t, n) {
  "use strict";

  function a(e, t) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }

  n.r(t), n.d(t, "default", function () {
    return a;
  });
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(638),
      i = Object.prototype.toString;

  t["default"] = function () {
    return "[object Arguments]" === i.call(arguments) ? function (e) {
      return "[object Arguments]" === i.call(e);
    } : function (e) {
      return Object(a["default"])("callee", e);
    };
  };
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(641),
      i = n(616),
      o = n(635),
      r = Object(i["default"])(function (e) {
    return Object(o["default"])(e.length, function () {
      var t = 0,
          n = arguments[0],
          i = arguments[arguments.length - 1],
          o = Array.prototype.slice.call(arguments, 0);
      return o[0] = function () {
        var e = n.apply(this, Object(a["default"])(arguments, [t, i]));
        return t += 1, e;
      }, e.apply(this, o);
    });
  });
  t["default"] = r;
}, function (e, t, n) {
  "use strict";

  function a(e, t) {
    var n;
    e = e || [], t = t || [];
    var a = e.length,
        i = t.length,
        o = [];

    for (n = 0; n < a;) {
      o[o.length] = e[n], n += 1;
    }

    for (n = 0; n < i;) {
      o[o.length] = t[n], n += 1;
    }

    return o;
  }

  n.r(t), n.d(t, "default", function () {
    return a;
  });
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(615),
      i = Object(a["default"])(function (e, t) {
    for (var n, a = 0, i = e.length, o = t.length, r = []; a < i;) {
      for (n = 0; n < o;) {
        r[r.length] = [e[a], t[n]], n += 1;
      }

      a += 1;
    }

    return r;
  });
  t["default"] = i;
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(644),
      i = n(616),
      o = Object(i["default"])(function (e) {
    return null != e && "function" == typeof e.clone ? e.clone() : Object(a["default"])(e, [], [], !0);
  });
  t["default"] = o;
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "default", function () {
    return o;
  });
  var a = n(645),
      i = n(646);

  function o(e, t, n, r) {
    var l = function l(a) {
      for (var i = t.length, l = 0; l < i;) {
        if (e === t[l]) return n[l];
        l += 1;
      }

      for (var s in t[l + 1] = e, n[l + 1] = a, e) {
        a[s] = r ? o(e[s], t, n, !0) : e[s];
      }

      return a;
    };

    switch (Object(i["default"])(e)) {
      case "Object":
        return l({});

      case "Array":
        return l([]);

      case "Date":
        return new Date(e.valueOf());

      case "RegExp":
        return Object(a["default"])(e);

      default:
        return e;
    }
  }
}, function (e, t, n) {
  "use strict";

  function a(e) {
    return new RegExp(e.source, (e.global ? "g" : "") + (e.ignoreCase ? "i" : "") + (e.multiline ? "m" : "") + (e.sticky ? "y" : "") + (e.unicode ? "u" : ""));
  }

  n.r(t), n.d(t, "default", function () {
    return a;
  });
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(616),
      i = Object(a["default"])(function (e) {
    return null === e ? "Null" : e === undefined ? "Undefined" : Object.prototype.toString.call(e).slice(8, -1);
  });
  t["default"] = i;
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(648),
      i = n(650),
      o = Object(i["default"])(a["default"]);
  t["default"] = o;
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(616),
      i = n(649),
      o = Object(a["default"])(i["default"]);
  t["default"] = o;
}, function (e, t, n) {
  "use strict";

  function a(e) {
    return e;
  }

  n.r(t), n.d(t, "default", function () {
    return a;
  });
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(651),
      i = n(615),
      o = Object(i["default"])(function (e, t) {
    for (var n, i, o = new a["default"](), r = [], l = 0; l < t.length;) {
      n = e(i = t[l]), o.add(n) && r.push(i), l += 1;
    }

    return r;
  });
  t["default"] = o;
}, function (e, t, n) {
  "use strict";

  n.r(t);

  var a = n(652),
      i = function () {
    function e() {
      this._nativeSet = "function" == typeof Set ? new Set() : null, this._items = {};
    }

    return e.prototype.add = function (e) {
      return !o(e, !0, this);
    }, e.prototype.has = function (e) {
      return o(e, !1, this);
    }, e;
  }();

  function o(e, t, n) {
    var i,
        o = typeof e;

    switch (o) {
      case "string":
      case "number":
        return 0 === e && 1 / e == -Infinity ? !!n._items["-0"] || (t && (n._items["-0"] = !0), !1) : null !== n._nativeSet ? t ? (i = n._nativeSet.size, n._nativeSet.add(e), n._nativeSet.size === i) : n._nativeSet.has(e) : o in n._items ? e in n._items[o] || (t && (n._items[o][e] = !0), !1) : (t && (n._items[o] = {}, n._items[o][e] = !0), !1);

      case "boolean":
        if (o in n._items) {
          var r = e ? 1 : 0;
          return !!n._items[o][r] || (t && (n._items[o][r] = !0), !1);
        }

        return t && (n._items[o] = e ? [!1, !0] : [!0, !1]), !1;

      case "function":
        return null !== n._nativeSet ? t ? (i = n._nativeSet.size, n._nativeSet.add(e), n._nativeSet.size === i) : n._nativeSet.has(e) : o in n._items ? !!Object(a["default"])(e, n._items[o]) || (t && n._items[o].push(e), !1) : (t && (n._items[o] = [e]), !1);

      case "undefined":
        return !!n._items[o] || (t && (n._items[o] = !0), !1);

      case "object":
        if (null === e) return !!n._items["null"] || (t && (n._items["null"] = !0), !1);

      default:
        return (o = Object.prototype.toString.call(e)) in n._items ? !!Object(a["default"])(e, n._items[o]) || (t && n._items[o].push(e), !1) : (t && (n._items[o] = [e]), !1);
    }
  }

  t["default"] = i;
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "default", function () {
    return i;
  });
  var a = n(653);

  function i(e, t) {
    return Object(a["default"])(t, e, 0) >= 0;
  }
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "default", function () {
    return i;
  });
  var a = n(654);

  function i(e, t, n) {
    var i, o;
    if ("function" == typeof e.indexOf) switch (typeof t) {
      case "number":
        if (0 === t) {
          for (i = 1 / t; n < e.length;) {
            if (0 === (o = e[n]) && 1 / o === i) return n;
            n += 1;
          }

          return -1;
        }

        if (t != t) {
          for (; n < e.length;) {
            if ("number" == typeof (o = e[n]) && o != o) return n;
            n += 1;
          }

          return -1;
        }

        return e.indexOf(t, n);

      case "string":
      case "boolean":
      case "function":
      case "undefined":
        return e.indexOf(t, n);

      case "object":
        if (null === t) return e.indexOf(t, n);
    }

    for (; n < e.length;) {
      if (Object(a["default"])(e[n], t)) return n;
      n += 1;
    }

    return -1;
  }
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(615),
      i = n(655),
      o = Object(a["default"])(function (e, t) {
    return Object(i["default"])(e, t, [], []);
  });
  t["default"] = o;
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "default", function () {
    return h;
  });
  var a = n(656),
      i = n(657),
      o = n(658),
      r = n(638),
      l = n(659),
      s = n(637),
      c = n(646);

  function u(e, t, n, o) {
    var r = Object(a["default"])(e),
        l = Object(a["default"])(t);

    function s(e, t) {
      return h(e, t, n.slice(), o.slice());
    }

    return !Object(i["default"])(function (e, t) {
      return !Object(i["default"])(s, t, e);
    }, l, r);
  }

  function h(e, t, n, a) {
    if (Object(l["default"])(e, t)) return !0;
    var i = Object(c["default"])(e);
    if (i !== Object(c["default"])(t)) return !1;
    if (null == e || null == t) return !1;
    if ("function" == typeof e["fantasy-land/equals"] || "function" == typeof t["fantasy-land/equals"]) return "function" == typeof e["fantasy-land/equals"] && e["fantasy-land/equals"](t) && "function" == typeof t["fantasy-land/equals"] && t["fantasy-land/equals"](e);
    if ("function" == typeof e.equals || "function" == typeof t.equals) return "function" == typeof e.equals && e.equals(t) && "function" == typeof t.equals && t.equals(e);

    switch (i) {
      case "Arguments":
      case "Array":
      case "Object":
        if ("function" == typeof e.constructor && "Promise" === Object(o["default"])(e.constructor)) return e === t;
        break;

      case "Boolean":
      case "Number":
      case "String":
        if (typeof e != typeof t || !Object(l["default"])(e.valueOf(), t.valueOf())) return !1;
        break;

      case "Date":
        if (!Object(l["default"])(e.valueOf(), t.valueOf())) return !1;
        break;

      case "Error":
        return e.name === t.name && e.message === t.message;

      case "RegExp":
        if (e.source !== t.source || e.global !== t.global || e.ignoreCase !== t.ignoreCase || e.multiline !== t.multiline || e.sticky !== t.sticky || e.unicode !== t.unicode) return !1;
    }

    for (var d = n.length - 1; d >= 0;) {
      if (n[d] === e) return a[d] === t;
      d -= 1;
    }

    switch (i) {
      case "Map":
        return e.size === t.size && u(e.entries(), t.entries(), n.concat([e]), a.concat([t]));

      case "Set":
        return e.size === t.size && u(e.values(), t.values(), n.concat([e]), a.concat([t]));

      case "Arguments":
      case "Array":
      case "Object":
      case "Boolean":
      case "Number":
      case "String":
      case "Date":
      case "Error":
      case "RegExp":
      case "Int8Array":
      case "Uint8Array":
      case "Uint8ClampedArray":
      case "Int16Array":
      case "Uint16Array":
      case "Int32Array":
      case "Uint32Array":
      case "Float32Array":
      case "Float64Array":
      case "ArrayBuffer":
        break;

      default:
        return !1;
    }

    var p = Object(s["default"])(e);
    if (p.length !== Object(s["default"])(t).length) return !1;
    var f = n.concat([e]),
        g = a.concat([t]);

    for (d = p.length - 1; d >= 0;) {
      var m = p[d];
      if (!Object(r["default"])(m, t) || !h(t[m], e[m], f, g)) return !1;
      d -= 1;
    }

    return !0;
  }
}, function (e, t, n) {
  "use strict";

  function a(e) {
    for (var t, n = []; !(t = e.next()).done;) {
      n.push(t.value);
    }

    return n;
  }

  n.r(t), n.d(t, "default", function () {
    return a;
  });
}, function (e, t, n) {
  "use strict";

  function a(e, t, n) {
    for (var a = 0, i = n.length; a < i;) {
      if (e(t, n[a])) return !0;
      a += 1;
    }

    return !1;
  }

  n.r(t), n.d(t, "default", function () {
    return a;
  });
}, function (e, t, n) {
  "use strict";

  function a(e) {
    var t = String(e).match(/^function (\w*)/);
    return null == t ? "" : t[1];
  }

  n.r(t), n.d(t, "default", function () {
    return a;
  });
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(615),
      i = Object(a["default"])(function (e, t) {
    return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
  });
  t["default"] = i;
},,,,,,,,,,,,,,,, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(676),
      i = n(615),
      o = Object(i["default"])(function (e, t) {
    return Object(a["default"])({}, e, t);
  });
  t["default"] = o;
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(677);
  t["default"] = "function" == typeof Object.assign ? Object.assign : a["default"];
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "default", function () {
    return i;
  });
  var a = n(638);

  function i(e) {
    if (null == e) throw new TypeError("Cannot convert undefined or null to object");

    for (var t = Object(e), n = 1, i = arguments.length; n < i;) {
      var o = arguments[n];
      if (null != o) for (var r in o) {
        Object(a["default"])(r, o) && (t[r] = o[r]);
      }
      n += 1;
    }

    return t;
  }
},,,,,,,,,,,,,,,,,,, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(616),
      i = Object(a["default"])(function (e) {
    for (var t = 0, n = []; t < e.length;) {
      for (var a = e[t], i = 0; i < a.length;) {
        "undefined" == typeof n[i] && (n[i] = []), n[i].push(a[i]), i += 1;
      }

      t += 1;
    }

    return n;
  });
  t["default"] = i;
},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = l(n(402)),
      i = n(400),
      o = l(i),
      r = l(n(737));

  function l(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function s(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var c = function c(e, t) {
    return (t = Math.log(t / e)) ? function (n) {
      return Math.log(n / e) / t;
    } : (0, a["default"])(t);
  },
      u = function u(e, t) {
    return e < 0 ? function (n) {
      return -Math.pow(-t, n) * Math.pow(-e, 1 - n);
    } : function (n) {
      return Math.pow(t, n) * Math.pow(e, 1 - n);
    };
  },
      h = function h(e) {
    return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
  },
      d = function d(e) {
    return 10 === e ? h : e === Math.E ? Math.exp : function (t) {
      return Math.pow(e, t);
    };
  },
      p = function p(e) {
    return e === Math.E ? Math.log : 10 === e ? Math.log10 : 2 === e ? Math.log2 : function (t) {
      return Math.log(t) / Math.log(e);
    };
  },
      f = function f(e) {
    return function (t) {
      return -e(-t);
    };
  },
      g = function (e) {
    function t() {
      var n;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), (n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this, c, u)), n).setDomain([1, 10]), n.base = 10, n.logs = p(n.base), n.pows = d(n.base), n;
    }

    return s(t, e), t.prototype._rescaleLog = function () {
      return this.logs = p(this.base), this.pows = d(this.base), this.getDomain()[0] < 0 && (this.logs = f(this.logs), this.pows = f(this.pows)), this;
    }, t.prototype.setBase = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
      return this.base = Number(e), this._rescaleLog();
    }, t.prototype.getBase = function () {
      return this.base;
    }, t.prototype.setDomain = function () {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [1, 10];
      return e.prototype.setDomain.call(this, t), this._rescaleLog();
    }, t.prototype.nice = function () {
      var e,
          t,
          n = this.getDomain(),
          a = n[0],
          i = n[1],
          o = this.base;
      return a === i && (a -= a / 100), e = Math.log(a) / Math.log(o), t = Math.log(i) / Math.log(o), (e % 1 || t % 1) && (a <= i ? (a = this.pows(Math.floor(e)), i = this.pows(Math.ceil(t))) : (a = this.pows(Math.ceil(e)), i = this.pows(Math.floor(t))), this.setDomain([a, i])), this;
    }, t.prototype.tickFormat = function (e, t) {
      var n = this,
          a = this.base,
          i = Math.max(1, a * e / this.ticks().length);
      return null == t && (t = 10 === a ? ".0e" : ","), "function" != typeof t && (t = this._localeConverter.formatter(t)), e === Infinity ? function (e) {
        return t.format(e);
      } : (null == e && (e = 10), function (e) {
        var o = e / n.pows(Math.round(n.logs(e)));
        return o * a < a - .5 && (o *= a), o <= i ? t.format(e) : "";
      });
    }, t.prototype.ticks = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r = this.getDomain(),
          l = r[0],
          s = r[1],
          c = 1,
          u = 0,
          h = [],
          d = this.base;
      if (l <= 0 || s <= 0) return h;

      if (l > s) {
        var p = this.getDomain();
        s = p[0], l = p[1], c = 0;
      }

      for (d > 1 ? (t = e = Math.ceil(Math.log(s) / Math.log(d)), n = Math.floor(Math.log(l) / Math.log(d))) : d > 0 && d < 1 && (e = Math.floor(Math.log(s) / Math.log(d)), t = Math.ceil(Math.log(l) / Math.log(d)), n = e), i = e, o = t; o >= n; --o) {
        l <= (a = this.pows(i)) && s >= a && (h[u++] = a), d > 1 ? i-- : i++;
      }

      return this.majorTicks = c ? h.reverse() : h;
    }, t.prototype.copy = function () {
      return (0, i.copyScale)(this, new t().setBase(this.base));
    }, t.prototype.minorTicks = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.majorTicks || this.ticks(),
          n = this.base,
          a = (0, r["default"])(t),
          i = void 0,
          o = [],
          l = Math.log(n) / Math.log(10),
          s = n > 1 ? -1 : 1,
          c = void 0,
          u = void 0,
          h = void 0,
          d = void 0;
      return e = Number(e) || l % 1 ? 4 : 8, a.forEach(function (t) {
        var a = t[0],
            r = t[1];

        for (n > 1 ? c = Math.ceil(Math.log(r) / Math.log(n)) : n > 0 && n < 1 && (c = Math.floor(Math.log(r) / Math.log(n))), h = Math.pow(n, c) - Math.pow(n, c + s), u = h / (e + 1), i = 1; i <= e; ++i) {
          a <= (d = Math.pow(n, c + s) + u * i) && r >= d && o.push(d);
        }
      }), o;
    }, t.prototype.contextTicks = function () {
      return this.contextTicksArr || [];
    }, t.prototype.getType = function () {
      return "log";
    }, t;
  }(o["default"]);

  t["default"] = g;
}, function (e, t, n) {
  "use strict";

  function a(e, t) {
    return [e, t];
  }

  t.__esModule = !0, t["default"] = function (e, t) {
    null !== t && void 0 !== t || (t = a);

    for (var n = 0, i = e.length - 1, o = e[0], r = new Array(i < 0 ? 0 : i); n < i;) {
      r[n] = t(o, o = e[++n]);
    }

    return r;
  };
},,,,,,,,,,, function (e, t) {
  e.exports = function (e) {
    return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
      enumerable: !0,
      get: function get() {
        return e.l;
      }
    }), Object.defineProperty(e, "id", {
      enumerable: !0,
      get: function get() {
        return e.i;
      }
    }), e.webpackPolyfill = 1), e;
  };
},,,,,,,,,,,,,, function (e, t, n) {
  "use strict";

  n.r(t);
  var a = n(615),
      i = n(618),
      o = n(763),
      r = Object(a["default"])(Object(i["default"])(["all"], o["default"], function (e, t) {
    for (var n = 0; n < t.length;) {
      if (!e(t[n])) return !1;
      n += 1;
    }

    return !0;
  }));
  t["default"] = r;
}, function (e, t, n) {
  "use strict";

  n.r(t);

  var a = n(615),
      i = n(764),
      o = n(631),
      r = function () {
    function e(e, t) {
      this.xf = t, this.f = e, this.all = !0;
    }

    return e.prototype["@@transducer/init"] = o["default"].init, e.prototype["@@transducer/result"] = function (e) {
      return this.all && (e = this.xf["@@transducer/step"](e, !0)), this.xf["@@transducer/result"](e);
    }, e.prototype["@@transducer/step"] = function (e, t) {
      return this.f(t) || (this.all = !1, e = Object(i["default"])(this.xf["@@transducer/step"](e, !1))), e;
    }, e;
  }(),
      l = Object(a["default"])(function (e, t) {
    return new r(e, t);
  });

  t["default"] = l;
}, function (e, t, n) {
  "use strict";

  function a(e) {
    return e && e["@@transducer/reduced"] ? e : {
      "@@transducer/value": e,
      "@@transducer/reduced": !0
    };
  }

  n.r(t), n.d(t, "default", function () {
    return a;
  });
},,,, function (e, t, n) {
  n(297), n(78), n(298), n(769), n(770), n(771), n(772), e.exports = n(7).Map;
}, function (e, t, n) {
  "use strict";

  var a = n(302),
      i = n(308);
  e.exports = n(309)("Map", function (e) {
    return function () {
      return e(this, arguments.length > 0 ? arguments[0] : undefined);
    };
  }, {
    get: function get(e) {
      var t = a.getEntry(i(this, "Map"), e);
      return t && t.v;
    },
    set: function set(e, t) {
      return a.def(i(this, "Map"), 0 === e ? 0 : e, t);
    }
  }, a, !0);
}, function (e, t, n) {
  var a = n(5);
  a(a.P + a.R, "Map", {
    toJSON: n(313)("Map")
  });
}, function (e, t, n) {
  n(316)("Map");
}, function (e, t, n) {
  n(318)("Map");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.create = t.createGenerateClassName = t.sheets = t.RuleList = t.SheetsManager = t.SheetsRegistry = t.toCssValue = t.getDynamicStyles = undefined;
  var a = n(774);
  Object.defineProperty(t, "getDynamicStyles", {
    enumerable: !0,
    get: function get() {
      return h(a)["default"];
    }
  });
  var i = n(775);
  Object.defineProperty(t, "toCssValue", {
    enumerable: !0,
    get: function get() {
      return h(i)["default"];
    }
  });
  var o = n(776);
  Object.defineProperty(t, "SheetsRegistry", {
    enumerable: !0,
    get: function get() {
      return h(o)["default"];
    }
  });
  var r = n(777);
  Object.defineProperty(t, "SheetsManager", {
    enumerable: !0,
    get: function get() {
      return h(r)["default"];
    }
  });
  var l = n(779);
  Object.defineProperty(t, "RuleList", {
    enumerable: !0,
    get: function get() {
      return h(l)["default"];
    }
  });
  var s = n(790);
  Object.defineProperty(t, "sheets", {
    enumerable: !0,
    get: function get() {
      return h(s)["default"];
    }
  });
  var c = n(791);
  Object.defineProperty(t, "createGenerateClassName", {
    enumerable: !0,
    get: function get() {
      return h(c)["default"];
    }
  });
  var u = h(n(794));

  function h(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var d = t.create = function (e) {
    return new u["default"](e);
  };

  t["default"] = d();
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  };

  t["default"] = function i(e) {
    var t = null;

    for (var n in e) {
      var o = e[n],
          r = void 0 === o ? "undefined" : a(o);
      if ("function" === r) t || (t = {}), t[n] = o;else if ("object" === r && null !== o && !Array.isArray(o)) {
        var l = i(o);
        l && (t || (t = {}), t[n] = l);
      }
    }

    return t;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t["default"] = function (e) {
    var t = arguments.length > 1 && arguments[1] !== undefined && arguments[1];
    if (!Array.isArray(e)) return e;
    var n = "";
    if (Array.isArray(e[0])) for (var i = 0; i < e.length && "!important" !== e[i]; i++) {
      n && (n += ", "), n += a(e[i], " ");
    } else n = a(e, ", ");
    t || "!important" !== e[e.length - 1] || (n += " !important");
    return n;
  };

  var a = function a(e, t) {
    for (var n = "", a = 0; a < e.length && "!important" !== e[a]; a++) {
      n && (n += t), n += e[a];
    }

    return n;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }

    return function (t, n, a) {
      return n && e(t.prototype, n), a && e(t, a), t;
    };
  }();

  var i = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.registry = [];
    }

    return a(e, [{
      key: "add",
      value: function value(e) {
        var t = this.registry,
            n = e.options.index;
        if (-1 === t.indexOf(e)) if (0 === t.length || n >= this.index) t.push(e);else for (var a = 0; a < t.length; a++) {
          if (t[a].options.index > n) return void t.splice(a, 0, e);
        }
      }
    }, {
      key: "reset",
      value: function value() {
        this.registry = [];
      }
    }, {
      key: "remove",
      value: function value(e) {
        var t = this.registry.indexOf(e);
        this.registry.splice(t, 1);
      }
    }, {
      key: "toString",
      value: function value(e) {
        return this.registry.filter(function (e) {
          return e.attached;
        }).map(function (t) {
          return t.toString(e);
        }).join("\n");
      }
    }, {
      key: "index",
      get: function get() {
        return 0 === this.registry.length ? 0 : this.registry[this.registry.length - 1].options.index;
      }
    }]), e;
  }();

  t["default"] = i;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a,
      i = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }

    return function (t, n, a) {
      return n && e(t.prototype, n), a && e(t, a), t;
    };
  }(),
      o = n(778),
      r = (a = o) && a.__esModule ? a : {
    "default": a
  };

  var l = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.sheets = [], this.refs = [], this.keys = [];
    }

    return i(e, [{
      key: "get",
      value: function value(e) {
        var t = this.keys.indexOf(e);
        return this.sheets[t];
      }
    }, {
      key: "add",
      value: function value(e, t) {
        var n = this.sheets,
            a = this.refs,
            i = this.keys,
            o = n.indexOf(t);
        return -1 !== o ? o : (n.push(t), a.push(0), i.push(e), n.length - 1);
      }
    }, {
      key: "manage",
      value: function value(e) {
        var t = this.keys.indexOf(e),
            n = this.sheets[t];
        return 0 === this.refs[t] && n.attach(), this.refs[t]++, this.keys[t] || this.keys.splice(t, 0, e), n;
      }
    }, {
      key: "unmanage",
      value: function value(e) {
        var t = this.keys.indexOf(e);
        -1 !== t ? this.refs[t] > 0 && (this.refs[t]--, 0 === this.refs[t] && this.sheets[t].detach()) : (0, r["default"])(!1, "SheetsManager: can't find sheet to unmanage");
      }
    }, {
      key: "size",
      get: function get() {
        return this.keys.length;
      }
    }]), e;
  }();

  t["default"] = l;
}, function (e, t, n) {
  "use strict";

  var a = function a() {};

  a = function a(e, t, n) {
    var a = arguments.length;
    n = new Array(a > 2 ? a - 2 : 0);

    for (var i = 2; i < a; i++) {
      n[i - 2] = arguments[i];
    }

    if (t === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
    if (t.length < 10 || /^[s\W]*$/.test(t)) throw new Error("The warning format should be able to uniquely identify this warning. Please, use a more descriptive format than: " + t);

    if (!e) {
      var o = 0,
          r = "Warning: " + t.replace(/%s/g, function () {
        return n[o++];
      });
      "undefined" != typeof console && console.error(r);

      try {
        throw new Error(r);
      } catch (l) {}
    }
  }, e.exports = a;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var a in n) {
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
    }

    return e;
  },
      i = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }

    return function (t, n, a) {
      return n && e(t.prototype, n), a && e(t, a), t;
    };
  }(),
      o = c(n(780)),
      r = c(n(788)),
      l = c(n(781)),
      s = c(n(789));

  function c(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var u = function () {
    function e(t) {
      var n = this;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.map = {}, this.raw = {}, this.index = [], this.update = function (e, t) {
        var a = n.options,
            i = a.jss.plugins,
            o = a.sheet;
        if ("string" == typeof e) i.onUpdate(t, n.get(e), o);else for (var r = 0; r < n.index.length; r++) {
          i.onUpdate(e, n.index[r], o);
        }
      }, this.options = t, this.classes = t.classes;
    }

    return i(e, [{
      key: "add",
      value: function value(e, t, n) {
        var i = this.options,
            r = i.parent,
            c = i.sheet,
            u = i.jss,
            h = i.Renderer,
            d = i.generateClassName;
        !(n = a({
          classes: this.classes,
          parent: r,
          sheet: c,
          jss: u,
          Renderer: h,
          generateClassName: d
        }, n)).selector && this.classes[e] && (n.selector = "." + (0, s["default"])(this.classes[e])), this.raw[e] = t;
        var p = (0, o["default"])(e, t, n),
            f = void 0;
        !n.selector && p instanceof l["default"] && (f = d(p, c), p.selector = "." + (0, s["default"])(f)), this.register(p, f);
        var g = n.index === undefined ? this.index.length : n.index;
        return this.index.splice(g, 0, p), p;
      }
    }, {
      key: "get",
      value: function value(e) {
        return this.map[e];
      }
    }, {
      key: "remove",
      value: function value(e) {
        this.unregister(e), this.index.splice(this.indexOf(e), 1);
      }
    }, {
      key: "indexOf",
      value: function value(e) {
        return this.index.indexOf(e);
      }
    }, {
      key: "process",
      value: function value() {
        var e = this.options.jss.plugins;
        this.index.slice(0).forEach(e.onProcessRule, e);
      }
    }, {
      key: "register",
      value: function value(e, t) {
        this.map[e.key] = e, e instanceof l["default"] && (this.map[e.selector] = e, t && (this.classes[e.key] = t));
      }
    }, {
      key: "unregister",
      value: function value(e) {
        delete this.map[e.key], e instanceof l["default"] && (delete this.map[e.selector], delete this.classes[e.key]);
      }
    }, {
      key: "link",
      value: function value(e) {
        for (var t = this.options.sheet.renderer.getUnescapedKeysMap(this.index), n = 0; n < e.length; n++) {
          var a = e[n],
              i = this.options.sheet.renderer.getKey(a);
          t[i] && (i = t[i]);
          var o = this.map[i];
          o && (0, r["default"])(o, a);
        }
      }
    }, {
      key: "toString",
      value: function value(e) {
        for (var t = "", n = this.options.sheet, a = !!n && n.options.link, i = 0; i < this.index.length; i++) {
          var o = this.index[i].toString(e);
          (o || a) && (t && (t += "\n"), t += o);
        }

        return t;
      }
    }]), e;
  }();

  t["default"] = u;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t["default"] = function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "unnamed",
        t = arguments[1],
        n = arguments[2],
        r = n.jss,
        l = (0, o["default"])(t),
        s = r.plugins.onCreateRule(e, l, n);
    if (s) return s;
    "@" === e[0] && (0, a["default"])(!1, "[JSS] Unknown at-rule %s", e);
    return new i["default"](e, l, n);
  };
  var a = r(n(778)),
      i = r(n(781)),
      o = r(n(783));

  function r(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var a in n) {
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
    }

    return e;
  },
      i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      o = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }

    return function (t, n, a) {
      return n && e(t.prototype, n), a && e(t, a), t;
    };
  }(),
      r = c(n(778)),
      l = c(n(782)),
      s = c(n(775));

  function c(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var u = function () {
    function e(t, n, a) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.type = "style", this.isProcessed = !1;
      var i = a.sheet,
          o = a.Renderer,
          r = a.selector;
      this.key = t, this.options = a, this.style = n, r && (this.selectorText = r), this.renderer = i ? i.renderer : new o();
    }

    return o(e, [{
      key: "prop",
      value: function value(e, t) {
        if (t === undefined) return this.style[e];
        if (this.style[e] === t) return this;
        var n = null == (t = this.options.jss.plugins.onChangeValue(t, e, this)) || !1 === t,
            a = e in this.style;
        if (n && !a) return this;
        var i = n && a;
        if (i ? delete this.style[e] : this.style[e] = t, this.renderable) return i ? this.renderer.removeProperty(this.renderable, e) : this.renderer.setProperty(this.renderable, e, t), this;
        var o = this.options.sheet;
        return o && o.attached && (0, r["default"])(!1, 'Rule is not linked. Missing sheet option "link: true".'), this;
      }
    }, {
      key: "applyTo",
      value: function value(e) {
        var t = this.toJSON();

        for (var n in t) {
          this.renderer.setProperty(e, n, t[n]);
        }

        return this;
      }
    }, {
      key: "toJSON",
      value: function value() {
        var e = {};

        for (var t in this.style) {
          var n = this.style[t];
          "object" !== (void 0 === n ? "undefined" : i(n)) ? e[t] = n : Array.isArray(n) && (e[t] = (0, s["default"])(n));
        }

        return e;
      }
    }, {
      key: "toString",
      value: function value(e) {
        var t = this.options.sheet,
            n = !!t && t.options.link ? a({}, e, {
          allowEmpty: !0
        }) : e;
        return (0, l["default"])(this.selector, this.style, n);
      }
    }, {
      key: "selector",
      set: function set(e) {
        if (e !== this.selectorText && (this.selectorText = e, this.renderable && !this.renderer.setSelector(this.renderable, e) && this.renderable)) {
          var t = this.renderer.replaceRule(this.renderable, this);
          t && (this.renderable = t);
        }
      },
      get: function get() {
        return this.selectorText;
      }
    }]), e;
  }();

  t["default"] = u;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t["default"] = function (e, t) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        a = "";
    if (!t) return a;
    var i = n.indent,
        l = i === undefined ? 0 : i,
        s = t.fallbacks;
    if (l++, s) if (Array.isArray(s)) for (var c = 0; c < s.length; c++) {
      var u = s[c];

      for (var h in u) {
        var d = u[h];
        null != d && (a += "\n" + r(h + ": " + (0, o["default"])(d) + ";", l));
      }
    } else for (var p in s) {
      var f = s[p];
      null != f && (a += "\n" + r(p + ": " + (0, o["default"])(f) + ";", l));
    }

    for (var g in t) {
      var m = t[g];
      null != m && "fallbacks" !== g && (a += "\n" + r(g + ": " + (0, o["default"])(m) + ";", l));
    }

    return a || n.allowEmpty ? a = r(e + " {" + a + "\n", --l) + r("}", l) : a;
  };
  var a,
      i = n(775),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };

  function r(e, t) {
    for (var n = "", a = 0; a < t; a++) {
      n += "  ";
    }

    return n + e;
  }
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  };

  t["default"] = function s(e) {
    if (null == e) return e;
    var t = void 0 === e ? "undefined" : a(e);
    if ("string" === t || "number" === t || "function" === t) return e;
    if (l(e)) return e.map(s);
    if ((0, r["default"])(e)) return e;
    var n = {};

    for (var i in e) {
      var o = e[i];
      "object" !== (void 0 === o ? "undefined" : a(o)) ? n[i] = o : n[i] = s(o);
    }

    return n;
  };

  var i,
      o = n(784),
      r = (i = o) && i.__esModule ? i : {
    "default": i
  };
  var l = Array.isArray;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
      i = n(785),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };

  t["default"] = function (e) {
    return e && e[o["default"]] && e === e[o["default"]]();
  };
}, function (e, t, n) {
  "use strict";

  n.r(t), function (e, a) {
    var i,
        o = n(787);
    i = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== e ? e : a;
    var r = Object(o["default"])(i);
    t["default"] = r;
  }.call(this, n(118), n(786)(e));
}, function (e, t) {
  e.exports = function (e) {
    if (!e.webpackPolyfill) {
      var t = Object.create(e);
      t.children || (t.children = []), Object.defineProperty(t, "loaded", {
        enumerable: !0,
        get: function get() {
          return t.l;
        }
      }), Object.defineProperty(t, "id", {
        enumerable: !0,
        get: function get() {
          return t.i;
        }
      }), Object.defineProperty(t, "exports", {
        enumerable: !0
      }), t.webpackPolyfill = 1;
    }

    return t;
  };
}, function (e, t, n) {
  "use strict";

  function a(e) {
    var t,
        n = e.Symbol;
    return "function" == typeof n ? n.observable ? t = n.observable : (t = n("observable"), n.observable = t) : t = "@@observable", t;
  }

  n.r(t), n.d(t, "default", function () {
    return a;
  });
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t["default"] = function (e, t) {
    e.renderable = t, e.rules && t.cssRules && e.rules.link(t.cssRules);
  };
}, function (e, t, n) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = e.CSS,
        a = /([[\].#*$><+~=|^:(),"'`])/g;

    t["default"] = function (e) {
      return n && n.escape ? n.escape(e) : e.replace(a, "\\$1");
    };
  }).call(this, n(118));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
      i = n(776),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };
  t["default"] = new o["default"]();
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = o(n(778)),
      i = (o(n(792)), o(n(793)));

  function o(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  t["default"] = function () {
    var e = 0;
    return function (t, n) {
      (e += 1) > 1e10 && (0, a["default"])(!1, "[JSS] You might have a memory leak. Rule counter is at %s.", e);
      var o = "",
          r = "";
      return n && (o = n.options.classNamePrefix || "", null != n.options.jss.id && (r += n.options.jss.id)), o + t.key + "-" + i["default"] + (r && "-" + r) + "-" + e;
    };
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var a in n) {
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
    }

    return e;
  },
      i = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }

    return function (t, n, a) {
      return n && e(t.prototype, n), a && e(t, a), t;
    };
  }(),
      o = l(n(788)),
      r = l(n(779));

  function l(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var s = function () {
    function e(t, n) {
      var i = this;

      for (var o in function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.update = function (e, t) {
        return "string" == typeof e ? i.rules.update(e, t) : i.rules.update(e), i;
      }, this.attached = !1, this.deployed = !1, this.linked = !1, this.classes = {}, this.options = a({}, n, {
        sheet: this,
        parent: this,
        classes: this.classes
      }), this.renderer = new n.Renderer(this), this.rules = new r["default"](this.options), t) {
        this.rules.add(o, t[o]);
      }

      this.rules.process();
    }

    return i(e, [{
      key: "attach",
      value: function value() {
        return this.attached ? this : (this.deployed || this.deploy(), this.renderer.attach(), !this.linked && this.options.link && this.link(), this.attached = !0, this);
      }
    }, {
      key: "detach",
      value: function value() {
        return this.attached ? (this.renderer.detach(), this.attached = !1, this) : this;
      }
    }, {
      key: "addRule",
      value: function value(e, t, n) {
        var a = this.queue;
        this.attached && !a && (this.queue = []);
        var i = this.rules.add(e, t, n);
        return this.options.jss.plugins.onProcessRule(i), this.attached ? this.deployed ? (a ? a.push(i) : (this.insertRule(i), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = undefined)), i) : i : (this.deployed = !1, i);
      }
    }, {
      key: "insertRule",
      value: function value(e) {
        var t = this.renderer.insertRule(e);
        t && this.options.link && (0, o["default"])(e, t);
      }
    }, {
      key: "addRules",
      value: function value(e, t) {
        var n = [];

        for (var a in e) {
          n.push(this.addRule(a, e[a], t));
        }

        return n;
      }
    }, {
      key: "getRule",
      value: function value(e) {
        return this.rules.get(e);
      }
    }, {
      key: "deleteRule",
      value: function value(e) {
        var t = this.rules.get(e);
        return !!t && (this.rules.remove(t), !this.attached || !t.renderable || this.renderer.deleteRule(t.renderable));
      }
    }, {
      key: "indexOf",
      value: function value(e) {
        return this.rules.indexOf(e);
      }
    }, {
      key: "deploy",
      value: function value() {
        return this.renderer.deploy(), this.deployed = !0, this;
      }
    }, {
      key: "link",
      value: function value() {
        var e = this.renderer.getRules();
        return e && this.rules.link(e), this.linked = !0, this;
      }
    }, {
      key: "toString",
      value: function value(e) {
        return this.rules.toString(e);
      }
    }]), e;
  }();

  t["default"] = s;
}, function (e, t, n) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = "2f1acc6c3a606b082e5eef5e54414ffb";
    null == e[n] && (e[n] = 0), t["default"] = e[n]++;
  }).call(this, n(118));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      i = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var a in n) {
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
    }

    return e;
  },
      o = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }

    return function (t, n, a) {
      return n && e(t.prototype, n), a && e(t, a), t;
    };
  }(),
      r = v(n(795)),
      l = v(n(792)),
      s = v(n(796)),
      c = v(n(797)),
      u = v(n(803)),
      h = v(n(804)),
      d = v(n(790)),
      p = v(n(781)),
      f = v(n(791)),
      g = v(n(780)),
      m = v(n(805)),
      b = v(n(806));

  function v(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var y = c["default"].concat([u["default"], h["default"]]),
      x = 0,
      C = function () {
    function e(t) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.id = x++, this.version = "9.8.7", this.plugins = new s["default"](), this.options = {
        createGenerateClassName: f["default"],
        Renderer: r["default"] ? m["default"] : b["default"],
        plugins: []
      }, this.generateClassName = (0, f["default"])(), this.use.apply(this, y), this.setup(t);
    }

    return o(e, [{
      key: "setup",
      value: function value() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return e.createGenerateClassName && (this.options.createGenerateClassName = e.createGenerateClassName, this.generateClassName = e.createGenerateClassName()), null != e.insertionPoint && (this.options.insertionPoint = e.insertionPoint), (e.virtual || e.Renderer) && (this.options.Renderer = e.Renderer || (e.virtual ? b["default"] : m["default"])), e.plugins && this.use.apply(this, e.plugins), this;
      }
    }, {
      key: "createStyleSheet",
      value: function value(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            n = t.index;
        "number" != typeof n && (n = 0 === d["default"].index ? 0 : d["default"].index + 1);
        var a = new l["default"](e, i({}, t, {
          jss: this,
          generateClassName: t.generateClassName || this.generateClassName,
          insertionPoint: this.options.insertionPoint,
          Renderer: this.options.Renderer,
          index: n
        }));
        return this.plugins.onProcessSheet(a), a;
      }
    }, {
      key: "removeStyleSheet",
      value: function value(e) {
        return e.detach(), d["default"].remove(e), this;
      }
    }, {
      key: "createRule",
      value: function value(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        "object" === (void 0 === e ? "undefined" : a(e)) && (n = t, t = e, e = undefined);
        var i = n;
        i.jss = this, i.Renderer = this.options.Renderer, i.generateClassName || (i.generateClassName = this.generateClassName), i.classes || (i.classes = {});
        var o = (0, g["default"])(e, t, i);
        return !i.selector && o instanceof p["default"] && (o.selector = "." + i.generateClassName(o)), this.plugins.onProcessRule(o), o;
      }
    }, {
      key: "use",
      value: function value() {
        for (var e = this, t = arguments.length, n = Array(t), a = 0; a < t; a++) {
          n[a] = arguments[a];
        }

        return n.forEach(function (t) {
          -1 === e.options.plugins.indexOf(t) && (e.options.plugins.push(t), e.plugins.use(t));
        }), this;
      }
    }]), e;
  }();

  t["default"] = C;
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "isBrowser", function () {
    return i;
  });
  var a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      i = "object" === ("undefined" == typeof window ? "undefined" : a(window)) && "object" === ("undefined" == typeof document ? "undefined" : a(document)) && 9 === document.nodeType;
  t["default"] = i;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a,
      i = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }

    return function (t, n, a) {
      return n && e(t.prototype, n), a && e(t, a), t;
    };
  }(),
      o = n(778),
      r = (a = o) && a.__esModule ? a : {
    "default": a
  };

  var l = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.hooks = {
        onCreateRule: [],
        onProcessRule: [],
        onProcessStyle: [],
        onProcessSheet: [],
        onChangeValue: [],
        onUpdate: []
      };
    }

    return i(e, [{
      key: "onCreateRule",
      value: function value(e, t, n) {
        for (var a = 0; a < this.hooks.onCreateRule.length; a++) {
          var i = this.hooks.onCreateRule[a](e, t, n);
          if (i) return i;
        }

        return null;
      }
    }, {
      key: "onProcessRule",
      value: function value(e) {
        if (!e.isProcessed) {
          for (var t = e.options.sheet, n = 0; n < this.hooks.onProcessRule.length; n++) {
            this.hooks.onProcessRule[n](e, t);
          }

          e.style && this.onProcessStyle(e.style, e, t), e.isProcessed = !0;
        }
      }
    }, {
      key: "onProcessStyle",
      value: function value(e, t, n) {
        for (var a = e, i = 0; i < this.hooks.onProcessStyle.length; i++) {
          a = this.hooks.onProcessStyle[i](a, t, n), t.style = a;
        }
      }
    }, {
      key: "onProcessSheet",
      value: function value(e) {
        for (var t = 0; t < this.hooks.onProcessSheet.length; t++) {
          this.hooks.onProcessSheet[t](e);
        }
      }
    }, {
      key: "onUpdate",
      value: function value(e, t, n) {
        for (var a = 0; a < this.hooks.onUpdate.length; a++) {
          this.hooks.onUpdate[a](e, t, n);
        }
      }
    }, {
      key: "onChangeValue",
      value: function value(e, t, n) {
        for (var a = e, i = 0; i < this.hooks.onChangeValue.length; i++) {
          a = this.hooks.onChangeValue[i](a, t, n);
        }

        return a;
      }
    }, {
      key: "use",
      value: function value(e) {
        for (var t in e) {
          this.hooks[t] ? this.hooks[t].push(e[t]) : (0, r["default"])(!1, '[JSS] Unknown hook "%s".', t);
        }
      }
    }]), e;
  }();

  t["default"] = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = s(n(798)),
      i = s(n(799)),
      o = s(n(800)),
      r = s(n(801)),
      l = s(n(802));

  function s(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var c = {
    "@charset": a["default"],
    "@import": a["default"],
    "@namespace": a["default"],
    "@keyframes": i["default"],
    "@media": o["default"],
    "@supports": o["default"],
    "@font-face": r["default"],
    "@viewport": l["default"],
    "@-ms-viewport": l["default"]
  },
      u = Object.keys(c).map(function (e) {
    var t = new RegExp("^" + e),
        n = c[e];
    return {
      onCreateRule: function onCreateRule(e, a, i) {
        return t.test(e) ? new n(e, a, i) : null;
      }
    };
  });
  t["default"] = u;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }

    return function (t, n, a) {
      return n && e(t.prototype, n), a && e(t, a), t;
    };
  }();

  var i = function () {
    function e(t, n, a) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.type = "simple", this.isProcessed = !1, this.key = t, this.value = n, this.options = a;
    }

    return a(e, [{
      key: "toString",
      value: function value(e) {
        if (Array.isArray(this.value)) {
          for (var t = "", n = 0; n < this.value.length; n++) {
            t += this.key + " " + this.value[n] + ";", this.value[n + 1] && (t += "\n");
          }

          return t;
        }

        return this.key + " " + this.value + ";";
      }
    }]), e;
  }();

  t["default"] = i;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a,
      i = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var a in n) {
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
    }

    return e;
  },
      o = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }

    return function (t, n, a) {
      return n && e(t.prototype, n), a && e(t, a), t;
    };
  }(),
      r = n(779),
      l = (a = r) && a.__esModule ? a : {
    "default": a
  };

  var s = function () {
    function e(t, n, a) {
      for (var o in function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.type = "keyframes", this.isProcessed = !1, this.key = t, this.options = a, this.rules = new l["default"](i({}, a, {
        parent: this
      })), n) {
        this.rules.add(o, n[o], i({}, this.options, {
          parent: this,
          selector: o
        }));
      }

      this.rules.process();
    }

    return o(e, [{
      key: "toString",
      value: function value() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          indent: 1
        },
            t = this.rules.toString(e);
        return t && (t += "\n"), this.key + " {\n" + t + "}";
      }
    }]), e;
  }();

  t["default"] = s;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a,
      i = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var a in n) {
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
    }

    return e;
  },
      o = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }

    return function (t, n, a) {
      return n && e(t.prototype, n), a && e(t, a), t;
    };
  }(),
      r = n(779),
      l = (a = r) && a.__esModule ? a : {
    "default": a
  };

  var s = function () {
    function e(t, n, a) {
      for (var o in function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.type = "conditional", this.isProcessed = !1, this.key = t, this.options = a, this.rules = new l["default"](i({}, a, {
        parent: this
      })), n) {
        this.rules.add(o, n[o]);
      }

      this.rules.process();
    }

    return o(e, [{
      key: "getRule",
      value: function value(e) {
        return this.rules.get(e);
      }
    }, {
      key: "indexOf",
      value: function value(e) {
        return this.rules.indexOf(e);
      }
    }, {
      key: "addRule",
      value: function value(e, t, n) {
        var a = this.rules.add(e, t, n);
        return this.options.jss.plugins.onProcessRule(a), a;
      }
    }, {
      key: "toString",
      value: function value() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          indent: 1
        },
            t = this.rules.toString(e);
        return t ? this.key + " {\n" + t + "\n}" : "";
      }
    }]), e;
  }();

  t["default"] = s;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a,
      i = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }

    return function (t, n, a) {
      return n && e(t.prototype, n), a && e(t, a), t;
    };
  }(),
      o = n(782),
      r = (a = o) && a.__esModule ? a : {
    "default": a
  };

  var l = function () {
    function e(t, n, a) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.type = "font-face", this.isProcessed = !1, this.key = t, this.style = n, this.options = a;
    }

    return i(e, [{
      key: "toString",
      value: function value(e) {
        if (Array.isArray(this.style)) {
          for (var t = "", n = 0; n < this.style.length; n++) {
            t += (0, r["default"])(this.key, this.style[n]), this.style[n + 1] && (t += "\n");
          }

          return t;
        }

        return (0, r["default"])(this.key, this.style, e);
      }
    }]), e;
  }();

  t["default"] = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a,
      i = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }

    return function (t, n, a) {
      return n && e(t.prototype, n), a && e(t, a), t;
    };
  }(),
      o = n(782),
      r = (a = o) && a.__esModule ? a : {
    "default": a
  };

  var l = function () {
    function e(t, n, a) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.type = "viewport", this.isProcessed = !1, this.key = t, this.style = n, this.options = a;
    }

    return i(e, [{
      key: "toString",
      value: function value(e) {
        return (0, r["default"])(this.key, this.style, e);
      }
    }]), e;
  }();

  t["default"] = l;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = r(n(781)),
      i = r(n(780)),
      o = r(n(784));

  function r(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  t["default"] = {
    onCreateRule: function onCreateRule(e, t, n) {
      if (!(0, o["default"])(t)) return null;
      var a = t,
          r = (0, i["default"])(e, {}, n);
      return a.subscribe(function (e) {
        for (var t in e) {
          r.prop(t, e[t]);
        }
      }), r;
    },
    onProcessRule: function onProcessRule(e) {
      if (e instanceof a["default"]) {
        var t = e,
            n = t.style,
            i = function i(e) {
          var a = n[e];
          if (!(0, o["default"])(a)) return "continue";
          delete n[e], a.subscribe({
            next: function next(n) {
              t.prop(e, n);
            }
          });
        };

        for (var r in n) {
          i(r);
        }
      }
    }
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = r(n(779)),
      i = r(n(781)),
      o = r(n(780));

  function r(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var l = Date.now(),
      s = "fnValues" + l,
      c = "fnStyle" + ++l;
  t["default"] = {
    onCreateRule: function onCreateRule(e, t, n) {
      if ("function" != typeof t) return null;
      var a = (0, o["default"])(e, {}, n);
      return a[c] = t, a;
    },
    onProcessStyle: function onProcessStyle(e, t) {
      var n = {};

      for (var a in e) {
        var i = e[a];
        "function" == typeof i && (delete e[a], n[a] = i);
      }

      return (t = t)[s] = n, e;
    },
    onUpdate: function onUpdate(e, t) {
      if (t.rules instanceof a["default"]) t.rules.update(e);else if (t instanceof i["default"]) {
        if ((t = t)[s]) for (var n in t[s]) {
          t.prop(n, t[s][n](e));
        }
        var o = (t = t)[c];

        if (o) {
          var r = o(e);

          for (var l in r) {
            t.prop(l, r[l]);
          }
        }
      }
    }
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }

    return function (t, n, a) {
      return n && e(t.prototype, n), a && e(t, a), t;
    };
  }(),
      i = s(n(778)),
      o = s(n(790)),
      r = s(n(781)),
      l = s(n(775));

  function s(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var c = function c(e) {
    var t = void 0;
    return function () {
      return t || (t = e()), t;
    };
  };

  function u(e, t) {
    try {
      return e.style.getPropertyValue(t);
    } catch (n) {
      return "";
    }
  }

  function h(e, t, n) {
    try {
      var a = n;
      if (Array.isArray(n) && (a = (0, l["default"])(n, !0), "!important" === n[n.length - 1])) return e.style.setProperty(t, a, "important"), !0;
      e.style.setProperty(t, a);
    } catch (i) {
      return !1;
    }

    return !0;
  }

  function d(e, t) {
    try {
      e.style.removeProperty(t);
    } catch (n) {
      (0, i["default"])(!1, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', n.message, t);
    }
  }

  var p,
      f = 1,
      g = 7,
      m = (p = function p(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return e.substr(t, e.indexOf("{") - 1);
  }, function (e) {
    if (e.type === f) return e.selectorText;

    if (e.type === g) {
      var t = e.name;
      if (t) return "@keyframes " + t;
      var n = e.cssText;
      return "@" + p(n, n.indexOf("keyframes"));
    }

    return p(e.cssText);
  });

  function b(e, t) {
    return e.selectorText = t, e.selectorText === t;
  }

  var v,
      y,
      x = c(function () {
    return document.head || document.getElementsByTagName("head")[0];
  }),
      C = (v = void 0, y = !1, function (e) {
    var t = {};
    v || (v = document.createElement("style"));

    for (var n = 0; n < e.length; n++) {
      var a = e[n];

      if (a instanceof r["default"]) {
        var i = a.selector;

        if (i && -1 !== i.indexOf("\\")) {
          y || (x().appendChild(v), y = !0), v.textContent = i + " {}";
          var o = v.sheet;

          if (o) {
            var l = o.cssRules;
            l && (t[l[0].selectorText] = a.key);
          }
        }
      }
    }

    return y && (x().removeChild(v), y = !1), t;
  });

  function k(e) {
    var t = o["default"].registry;

    if (t.length > 0) {
      var n = function (e, t) {
        for (var n = 0; n < e.length; n++) {
          var a = e[n];
          if (a.attached && a.options.index > t.index && a.options.insertionPoint === t.insertionPoint) return a;
        }

        return null;
      }(t, e);

      if (n) return n.renderer.element;
      if (n = function (e, t) {
        for (var n = e.length - 1; n >= 0; n--) {
          var a = e[n];
          if (a.attached && a.options.insertionPoint === t.insertionPoint) return a;
        }

        return null;
      }(t, e)) return n.renderer.element.nextElementSibling;
    }

    var a = e.insertionPoint;

    if (a && "string" == typeof a) {
      var r = function (e) {
        for (var t = x(), n = 0; n < t.childNodes.length; n++) {
          var a = t.childNodes[n];
          if (8 === a.nodeType && a.nodeValue.trim() === e) return a;
        }

        return null;
      }(a);

      if (r) return r.nextSibling;
      (0, i["default"])("jss" === a, '[JSS] Insertion point "%s" not found.', a);
    }

    return null;
  }

  var w = c(function () {
    var e = document.querySelector('meta[property="csp-nonce"]');
    return e ? e.getAttribute("content") : null;
  }),
      S = function () {
    function e(t) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.getPropertyValue = u, this.setProperty = h, this.removeProperty = d, this.setSelector = b, this.getKey = m, this.getUnescapedKeysMap = C, this.hasInsertedRules = !1, t && o["default"].add(t), this.sheet = t;
      var n = this.sheet ? this.sheet.options : {},
          a = n.media,
          i = n.meta,
          r = n.element;
      this.element = r || document.createElement("style"), this.element.setAttribute("data-jss", ""), a && this.element.setAttribute("media", a), i && this.element.setAttribute("data-meta", i);
      var l = w();
      l && this.element.setAttribute("nonce", l);
    }

    return a(e, [{
      key: "attach",
      value: function value() {
        !this.element.parentNode && this.sheet && (this.hasInsertedRules && (this.deploy(), this.hasInsertedRules = !1), function (e, t) {
          var n = t.insertionPoint,
              a = k(t);

          if (a) {
            var o = a.parentNode;
            o && o.insertBefore(e, a);
          } else if (n && "number" == typeof n.nodeType) {
            var r = n,
                l = r.parentNode;
            l ? l.insertBefore(e, r.nextSibling) : (0, i["default"])(!1, "[JSS] Insertion point is not in the DOM.");
          } else x().insertBefore(e, a);
        }(this.element, this.sheet.options));
      }
    }, {
      key: "detach",
      value: function value() {
        this.element.parentNode.removeChild(this.element);
      }
    }, {
      key: "deploy",
      value: function value() {
        this.sheet && (this.element.textContent = "\n" + this.sheet.toString() + "\n");
      }
    }, {
      key: "insertRule",
      value: function value(e, t) {
        var n = this.element.sheet,
            a = n.cssRules,
            o = e.toString();
        if (t || (t = a.length), !o) return !1;

        try {
          n.insertRule(o, t);
        } catch (r) {
          return (0, i["default"])(!1, "[JSS] Can not insert an unsupported rule \n\r%s", e), !1;
        }

        return this.hasInsertedRules = !0, a[t];
      }
    }, {
      key: "deleteRule",
      value: function value(e) {
        var t = this.element.sheet,
            n = this.indexOf(e);
        return -1 !== n && (t.deleteRule(n), !0);
      }
    }, {
      key: "indexOf",
      value: function value(e) {
        for (var t = this.element.sheet.cssRules, n = 0; n < t.length; n++) {
          if (e === t[n]) return n;
        }

        return -1;
      }
    }, {
      key: "replaceRule",
      value: function value(e, t) {
        var n = this.indexOf(e),
            a = this.insertRule(t, n);
        return this.element.sheet.deleteRule(n), a;
      }
    }, {
      key: "getRules",
      value: function value() {
        return this.element.sheet.cssRules;
      }
    }]), e;
  }();

  t["default"] = S;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }

    return function (t, n, a) {
      return n && e(t.prototype, n), a && e(t, a), t;
    };
  }();

  var i = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e);
    }

    return a(e, [{
      key: "setProperty",
      value: function value() {
        return !0;
      }
    }, {
      key: "getPropertyValue",
      value: function value() {
        return "";
      }
    }, {
      key: "removeProperty",
      value: function value() {}
    }, {
      key: "setSelector",
      value: function value() {
        return !0;
      }
    }, {
      key: "getKey",
      value: function value() {
        return "";
      }
    }, {
      key: "attach",
      value: function value() {}
    }, {
      key: "detach",
      value: function value() {}
    }, {
      key: "deploy",
      value: function value() {}
    }, {
      key: "insertRule",
      value: function value() {
        return !1;
      }
    }, {
      key: "deleteRule",
      value: function value() {
        return !0;
      }
    }, {
      key: "replaceRule",
      value: function value() {
        return !1;
      }
    }, {
      key: "getRules",
      value: function value() {}
    }, {
      key: "indexOf",
      value: function value() {
        return -1;
      }
    }]), e;
  }();

  t["default"] = i;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = p(n(808)),
      i = p(n(810)),
      o = p(n(811)),
      r = p(n(812)),
      l = p(n(813)),
      s = p(n(814)),
      c = p(n(816)),
      u = p(n(818)),
      h = p(n(820)),
      d = p(n(826));

  function p(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  t["default"] = function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      plugins: [(0, a["default"])(e.template), (0, i["default"])(e.global), (0, o["default"])(e.extend), (0, r["default"])(e.nested), (0, l["default"])(e.compose), (0, s["default"])(e.camelCase), (0, c["default"])(e.defaultUnit), (0, u["default"])(e.expand), (0, h["default"])(e.vendorPrefixer), (0, d["default"])(e.propsSort)]
    };
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
      i = n(809),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };

  var r = function r(e) {
    "string" == typeof e.style && (e.style = (0, o["default"])(e.style));
  };

  t["default"] = function () {
    return {
      onProcessRule: r
    };
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
      i = n(778),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };
  var r = /;\n/;

  t["default"] = function (e) {
    for (var t = {}, n = e.split(r), a = 0; a < n.length; a++) {
      var i = (n[a] || "").trim();

      if (i) {
        var l = i.indexOf(":");

        if (-1 !== l) {
          var s = i.substr(0, l).trim(),
              c = i.substr(l + 1).trim();
          t[s] = c;
        } else (0, o["default"])(!1, 'Malformed CSS string "%s"', i);
      }
    }

    return t;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var a in n) {
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
    }

    return e;
  },
      i = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }

    return function (t, n, a) {
      return n && e(t.prototype, n), a && e(t, a), t;
    };
  }();

  t["default"] = function () {
    return {
      onCreateRule: function onCreateRule(e, t, n) {
        if (e === l) return new c(e, t, n);
        if ("@" === e[0] && e.substr(0, s.length) === s) return new u(e, t, n);
        var a = n.parent;
        a && ("global" !== a.type && "global" !== a.options.parent.type || (n.global = !0));
        n.global && (n.selector = e);
        return null;
      },
      onProcessRule: function onProcessRule(e) {
        if ("style" !== e.type) return;
        (function (e) {
          var t = e.options,
              n = e.style,
              i = n[l];
          if (!i) return;

          for (var o in i) {
            t.sheet.addRule(o, i[o], a({}, t, {
              selector: d(o, e.selector)
            }));
          }

          delete n[l];
        })(e), function (e) {
          var t = e.options,
              n = e.style;

          for (var i in n) {
            if (i.substr(0, l.length) === l) {
              var o = d(i.substr(l.length), e.selector);
              t.sheet.addRule(o, n[i], a({}, t, {
                selector: o
              })), delete n[i];
            }
          }
        }(e);
      }
    };
  };

  var o = n(773);

  function r(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  var l = "@global",
      s = "@global ",
      c = function () {
    function e(t, n, i) {
      for (var l in r(this, e), this.type = "global", this.key = t, this.options = i, this.rules = new o.RuleList(a({}, i, {
        parent: this
      })), n) {
        this.rules.add(l, n[l], {
          selector: l
        });
      }

      this.rules.process();
    }

    return i(e, [{
      key: "getRule",
      value: function value(e) {
        return this.rules.get(e);
      }
    }, {
      key: "addRule",
      value: function value(e, t, n) {
        var a = this.rules.add(e, t, n);
        return this.options.jss.plugins.onProcessRule(a), a;
      }
    }, {
      key: "indexOf",
      value: function value(e) {
        return this.rules.indexOf(e);
      }
    }, {
      key: "toString",
      value: function value() {
        return this.rules.toString();
      }
    }]), e;
  }(),
      u = function () {
    function e(t, n, i) {
      r(this, e), this.name = t, this.options = i;
      var o = t.substr(s.length);
      this.rule = i.jss.createRule(o, n, a({}, i, {
        parent: this,
        selector: o
      }));
    }

    return i(e, [{
      key: "toString",
      value: function value(e) {
        return this.rule.toString(e);
      }
    }]), e;
  }(),
      h = /\s*,\s*/g;

  function d(e, t) {
    for (var n = e.split(h), a = "", i = 0; i < n.length; i++) {
      a += t + " " + n[i].trim(), n[i + 1] && (a += ", ");
    }

    return a;
  }
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  };

  t["default"] = function () {
    return {
      onProcessStyle: function onProcessStyle(e, t, n) {
        return "extend" in e ? c(e, t, n) : e;
      },
      onChangeValue: function onChangeValue(e, t, n) {
        if ("extend" !== t) return e;

        if (null == e || !1 === e) {
          for (var a in n[s]) {
            n.prop(a, null);
          }

          return n[s] = null, null;
        }

        for (var i in e) {
          n.prop(i, e[i]);
        }

        return n[s] = e, null;
      }
    };
  };

  var i,
      o = n(778),
      r = (i = o) && i.__esModule ? i : {
    "default": i
  };

  var l = function l(e) {
    return e && "object" === (void 0 === e ? "undefined" : a(e)) && !Array.isArray(e);
  },
      s = "extendCurrValue" + Date.now();

  function c(e, t, n) {
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return function (e, t, n, i) {
      if ("string" !== a(e.extend)) {
        if (Array.isArray(e.extend)) for (var o = 0; o < e.extend.length; o++) {
          c(e.extend[o], t, n, i);
        } else for (var s in e.extend) {
          "extend" !== s ? l(e.extend[s]) ? (s in i || (i[s] = {}), c(e.extend[s], t, n, i[s])) : i[s] = e.extend[s] : c(e.extend.extend, t, n, i);
        }
      } else {
        if (!n) return;
        var u = n.getRule(e.extend);
        if (!u) return;
        if (u === t) return void (0, r["default"])(!1, "[JSS] A rule tries to extend itself \r\n%s", t);
        var h = u.options.parent;
        h && c(h.rules.raw[e.extend], t, n, i);
      }
    }(e, t, n, i), function (e, t, n, a) {
      for (var i in e) {
        "extend" !== i && (l(a[i]) && l(e[i]) ? c(e[i], t, n, a[i]) : l(e[i]) ? a[i] = c(e[i], t, n) : a[i] = e[i]);
      }
    }(e, t, n, i), i;
  }
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var a in n) {
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
    }

    return e;
  };

  t["default"] = function () {
    function e(e) {
      return function (t, n) {
        var a = e.getRule(n);
        return a ? a.selector : ((0, r["default"])(!1, "[JSS] Could not find the referenced rule %s in %s.", n, e.options.meta || e), n);
      };
    }

    var t = function t(e) {
      return -1 !== e.indexOf("&");
    };

    function n(e, n) {
      for (var a = n.split(l), i = e.split(l), o = "", r = 0; r < a.length; r++) {
        for (var c = a[r], u = 0; u < i.length; u++) {
          var h = i[u];
          o && (o += ", "), o += t(h) ? h.replace(s, c) : c + " " + h;
        }
      }

      return o;
    }

    function i(e, t, n) {
      if (n) return a({}, n, {
        index: n.index + 1
      });
      var i = e.options.nestingLevel;
      return i = i === undefined ? 1 : i + 1, a({}, e.options, {
        nestingLevel: i,
        index: t.indexOf(e) + 1
      });
    }

    return {
      onProcessStyle: function onProcessStyle(o, r) {
        if ("style" !== r.type) return o;
        var l = r.options.parent,
            s = void 0,
            u = void 0;

        for (var h in o) {
          var d = t(h),
              p = "@" === h[0];

          if (d || p) {
            if (s = i(r, l, s), d) {
              var f = n(h, r.selector);
              u || (u = e(l)), f = f.replace(c, u), l.addRule(f, o[h], a({}, s, {
                selector: f
              }));
            } else p && l.addRule(h, null, s).addRule(r.key, o[h], {
              selector: r.selector
            });

            delete o[h];
          }
        }

        return o;
      }
    };
  };

  var i,
      o = n(778),
      r = (i = o) && i.__esModule ? i : {
    "default": i
  };
  var l = /\s*,\s*/g,
      s = /&/g,
      c = /\$([\w-]+)/g;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t["default"] = function () {
    return {
      onProcessStyle: function onProcessStyle(e, t) {
        return e.composes ? (function n(e, t) {
          if (!t) return !0;

          if (Array.isArray(t)) {
            for (var a = 0; a < t.length; a++) {
              var i = n(e, t[a]);
              if (!i) return !1;
            }

            return !0;
          }

          if (t.indexOf(" ") > -1) return n(e, t.split(" "));
          var r = e.options.parent;

          if ("$" === t[0]) {
            var l = r.getRule(t.substr(1));
            return l ? l === e ? ((0, o["default"])(!1, "[JSS] Cyclic composition detected. \r\n%s", e), !1) : (r.classes[e.key] += " " + r.classes[l.key], !0) : ((0, o["default"])(!1, "[JSS] Referenced rule is not defined. \r\n%s", e), !1);
          }

          return e.options.parent.classes[e.key] += " " + t, !0;
        }(t, e.composes), delete e.composes, e) : e;
      }
    };
  };
  var a,
      i = n(778),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t["default"] = function () {
    return {
      onProcessStyle: function onProcessStyle(e) {
        if (Array.isArray(e)) {
          for (var t = 0; t < e.length; t++) {
            e[t] = r(e[t]);
          }

          return e;
        }

        return r(e);
      },
      onChangeValue: function onChangeValue(e, t, n) {
        var a = (0, o["default"])(t);
        return t === a ? e : (n.prop(a, e), null);
      }
    };
  };
  var a,
      i = n(815),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };

  function r(e) {
    var t = {};

    for (var n in e) {
      t[(0, o["default"])(n)] = e[n];
    }

    return e.fallbacks && (Array.isArray(e.fallbacks) ? t.fallbacks = e.fallbacks.map(r) : t.fallbacks = r(e.fallbacks)), t;
  }
}, function (e, t, n) {
  "use strict";

  var a = /[A-Z]/g,
      i = /^ms-/,
      o = {};

  e.exports = function (e) {
    return e in o ? o[e] : o[e] = e.replace(a, "-$&").toLowerCase().replace(i, "-ms-");
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  };

  t["default"] = function () {
    var e = r(arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {});
    return {
      onProcessStyle: function onProcessStyle(t, n) {
        if ("style" !== n.type) return t;

        for (var a in t) {
          t[a] = s(a, t[a], e);
        }

        return t;
      },
      onChangeValue: function onChangeValue(t, n) {
        return s(n, t, e);
      }
    };
  };

  var i,
      o = n(817);

  function r(e) {
    var t = /(-[a-z])/g,
        n = function n(e) {
      return e[1].toUpperCase();
    },
        a = {};

    for (var i in e) {
      a[i] = e[i], a[i.replace(t, n)] = e[i];
    }

    return a;
  }

  var l = r(((i = o) && i.__esModule ? i : {
    "default": i
  })["default"]);

  function s(e, t, n) {
    if (!t) return t;
    var i = t,
        o = void 0 === t ? "undefined" : a(t);

    switch ("object" === o && Array.isArray(t) && (o = "array"), o) {
      case "object":
        if ("fallbacks" === e) {
          for (var r in t) {
            t[r] = s(r, t[r], n);
          }

          break;
        }

        for (var c in t) {
          t[c] = s(e + "-" + c, t[c], n);
        }

        break;

      case "array":
        for (var u = 0; u < t.length; u++) {
          t[u] = s(e, t[u], n);
        }

        break;

      case "number":
        0 !== t && (i = t + (n[e] || l[e] || ""));
    }

    return i;
  }
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t["default"] = {
    "animation-delay": "ms",
    "animation-duration": "ms",
    "background-position": "px",
    "background-position-x": "px",
    "background-position-y": "px",
    "background-size": "px",
    border: "px",
    "border-bottom": "px",
    "border-bottom-left-radius": "px",
    "border-bottom-right-radius": "px",
    "border-bottom-width": "px",
    "border-left": "px",
    "border-left-width": "px",
    "border-radius": "px",
    "border-right": "px",
    "border-right-width": "px",
    "border-spacing": "px",
    "border-top": "px",
    "border-top-left-radius": "px",
    "border-top-right-radius": "px",
    "border-top-width": "px",
    "border-width": "px",
    "border-after-width": "px",
    "border-before-width": "px",
    "border-end-width": "px",
    "border-horizontal-spacing": "px",
    "border-start-width": "px",
    "border-vertical-spacing": "px",
    bottom: "px",
    "box-shadow": "px",
    "column-gap": "px",
    "column-rule": "px",
    "column-rule-width": "px",
    "column-width": "px",
    "flex-basis": "px",
    "font-size": "px",
    "font-size-delta": "px",
    height: "px",
    left: "px",
    "letter-spacing": "px",
    "logical-height": "px",
    "logical-width": "px",
    margin: "px",
    "margin-after": "px",
    "margin-before": "px",
    "margin-bottom": "px",
    "margin-left": "px",
    "margin-right": "px",
    "margin-top": "px",
    "max-height": "px",
    "max-width": "px",
    "margin-end": "px",
    "margin-start": "px",
    "mask-position-x": "px",
    "mask-position-y": "px",
    "mask-size": "px",
    "max-logical-height": "px",
    "max-logical-width": "px",
    "min-height": "px",
    "min-width": "px",
    "min-logical-height": "px",
    "min-logical-width": "px",
    motion: "px",
    "motion-offset": "px",
    outline: "px",
    "outline-offset": "px",
    "outline-width": "px",
    padding: "px",
    "padding-bottom": "px",
    "padding-left": "px",
    "padding-right": "px",
    "padding-top": "px",
    "padding-after": "px",
    "padding-before": "px",
    "padding-end": "px",
    "padding-start": "px",
    "perspective-origin-x": "%",
    "perspective-origin-y": "%",
    perspective: "px",
    right: "px",
    "shape-margin": "px",
    size: "px",
    "text-indent": "px",
    "text-stroke": "px",
    "text-stroke-width": "px",
    top: "px",
    "transform-origin": "%",
    "transform-origin-x": "%",
    "transform-origin-y": "%",
    "transform-origin-z": "%",
    "transition-delay": "ms",
    "transition-duration": "ms",
    "vertical-align": "px",
    width: "px",
    "word-spacing": "px",
    "box-shadow-x": "px",
    "box-shadow-y": "px",
    "box-shadow-blur": "px",
    "box-shadow-spread": "px",
    "font-line-height": "px",
    "text-shadow-x": "px",
    "text-shadow-y": "px",
    "text-shadow-blur": "px"
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  };

  t["default"] = function () {
    return {
      onProcessStyle: function onProcessStyle(e, t) {
        if (!e || "style" !== t.type) return e;

        if (Array.isArray(e)) {
          for (var n = 0; n < e.length; n++) {
            e[n] = s(e[n], t);
          }

          return e;
        }

        return s(e, t);
      }
    };
  };

  var i = n(819);

  function o(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function r(e, t, n, i) {
    return null == n[t] ? e : 0 === e.length ? [] : Array.isArray(e[0]) ? r(e[0], t, n) : "object" === a(e[0]) ? function (e, t, n) {
      return e.map(function (e) {
        return l(e, t, n, !1, !0);
      });
    }(e, t, i) : [e];
  }

  function l(e, t, n, a, r) {
    if (!i.propObj[t] && !i.customPropObj[t]) return [];
    var l = [];
    if (i.customPropObj[t] && (e = function (e, t, n, a) {
      for (var i in n) {
        var r = n[i];

        if ("undefined" != typeof e[i] && (a || !t.prop(r))) {
          var l = s(o({}, r, e[i]), t)[r];
          a ? t.style.fallbacks[r] = l : t.style[r] = l;
        }

        delete e[i];
      }

      return e;
    }(e, n, i.customPropObj[t], a)), Object.keys(e).length) for (var c in i.propObj[t]) {
      e[c] ? Array.isArray(e[c]) ? l.push(null === i.propArrayInObj[c] ? e[c] : e[c].join(" ")) : l.push(e[c]) : null != i.propObj[t][c] && l.push(i.propObj[t][c]);
    }
    return !l.length || r ? l : [l];
  }

  function s(e, t, n) {
    for (var o in e) {
      var c = e[o];

      if (Array.isArray(c)) {
        if (!Array.isArray(c[0])) {
          if ("fallbacks" === o) {
            for (var u = 0; u < e.fallbacks.length; u++) {
              e.fallbacks[u] = s(e.fallbacks[u], t, !0);
            }

            continue;
          }

          e[o] = r(c, o, i.propArray), e[o].length || delete e[o];
        }
      } else if ("object" === (void 0 === c ? "undefined" : a(c))) {
        if ("fallbacks" === o) {
          e.fallbacks = s(e.fallbacks, t, !0);
          continue;
        }

        e[o] = l(c, o, t, n), e[o].length || delete e[o];
      } else "" === e[o] && delete e[o];
    }

    return e;
  }
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  t.propArray = {
    "background-size": !0,
    "background-position": !0,
    border: !0,
    "border-bottom": !0,
    "border-left": !0,
    "border-top": !0,
    "border-right": !0,
    "border-radius": !0,
    "border-image": !0,
    "border-width": !0,
    "border-style": !0,
    "border-color": !0,
    "box-shadow": !0,
    flex: !0,
    margin: !0,
    padding: !0,
    outline: !0,
    "transform-origin": !0,
    transform: !0,
    transition: !0
  }, t.propArrayInObj = {
    position: !0,
    size: !0
  }, t.propObj = {
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    margin: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    background: {
      attachment: null,
      color: null,
      image: null,
      position: null,
      repeat: null
    },
    border: {
      width: null,
      style: null,
      color: null
    },
    "border-top": {
      width: null,
      style: null,
      color: null
    },
    "border-right": {
      width: null,
      style: null,
      color: null
    },
    "border-bottom": {
      width: null,
      style: null,
      color: null
    },
    "border-left": {
      width: null,
      style: null,
      color: null
    },
    outline: {
      width: null,
      style: null,
      color: null
    },
    "list-style": {
      type: null,
      position: null,
      image: null
    },
    transition: {
      property: null,
      duration: null,
      "timing-function": null,
      timingFunction: null,
      delay: null
    },
    animation: {
      name: null,
      duration: null,
      "timing-function": null,
      timingFunction: null,
      delay: null,
      "iteration-count": null,
      iterationCount: null,
      direction: null,
      "fill-mode": null,
      fillMode: null,
      "play-state": null,
      playState: null
    },
    "box-shadow": {
      x: 0,
      y: 0,
      blur: 0,
      spread: 0,
      color: null,
      inset: null
    },
    "text-shadow": {
      x: 0,
      y: 0,
      blur: null,
      color: null
    }
  }, t.customPropObj = {
    border: {
      radius: "border-radius",
      image: "border-image",
      width: "border-width",
      style: "border-style",
      color: "border-color"
    },
    background: {
      size: "background-size",
      image: "background-image"
    },
    font: {
      style: "font-style",
      variant: "font-variant",
      weight: "font-weight",
      stretch: "font-stretch",
      size: "font-size",
      family: "font-family",
      lineHeight: "line-height",
      "line-height": "line-height"
    },
    flex: {
      grow: "flex-grow",
      basis: "flex-basis",
      direction: "flex-direction",
      wrap: "flex-wrap",
      flow: "flex-flow",
      shrink: "flex-shrink"
    },
    align: {
      self: "align-self",
      items: "align-items",
      content: "align-content"
    },
    grid: {
      "template-columns": "grid-template-columns",
      templateColumns: "grid-template-columns",
      "template-rows": "grid-template-rows",
      templateRows: "grid-template-rows",
      "template-areas": "grid-template-areas",
      templateAreas: "grid-template-areas",
      template: "grid-template",
      "auto-columns": "grid-auto-columns",
      autoColumns: "grid-auto-columns",
      "auto-rows": "grid-auto-rows",
      autoRows: "grid-auto-rows",
      "auto-flow": "grid-auto-flow",
      autoFlow: "grid-auto-flow",
      row: "grid-row",
      column: "grid-column",
      "row-start": "grid-row-start",
      rowStart: "grid-row-start",
      "row-end": "grid-row-end",
      rowEnd: "grid-row-end",
      "column-start": "grid-column-start",
      columnStart: "grid-column-start",
      "column-end": "grid-column-end",
      columnEnd: "grid-column-end",
      area: "grid-area",
      gap: "grid-gap",
      "row-gap": "grid-row-gap",
      rowGap: "grid-row-gap",
      "column-gap": "grid-column-gap",
      columnGap: "grid-column-gap"
    }
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t["default"] = function () {
    return {
      onProcessRule: function onProcessRule(e) {
        "keyframes" === e.type && (e.key = "@" + a.prefix.css + e.key.substr(1));
      },
      onProcessStyle: function onProcessStyle(e, t) {
        if ("style" !== t.type) return e;

        for (var n in e) {
          var i = e[n],
              o = !1,
              r = a.supportedProperty(n);
          r && r !== n && (o = !0);
          var l = !1,
              s = a.supportedValue(r, i);
          s && s !== i && (l = !0), (o || l) && (o && delete e[n], e[r || n] = s || i);
        }

        return e;
      },
      onChangeValue: function onChangeValue(e, t) {
        return a.supportedValue(t, e);
      }
    };
  };

  var a = function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
    return t["default"] = e, t;
  }(n(821));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.supportedValue = t.supportedProperty = t.prefix = undefined;
  var a = r(n(822)),
      i = r(n(823)),
      o = r(n(825));

  function r(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  t["default"] = {
    prefix: a["default"],
    supportedProperty: i["default"],
    supportedValue: o["default"]
  },
  /**
      * CSS Vendor prefix detection and property feature testing.
      *
      * @copyright Oleg Slobodskoi 2015
      * @website https://github.com/jsstyles/css-vendor
      * @license MIT
      */
  t.prefix = a["default"], t.supportedProperty = i["default"], t.supportedValue = o["default"];
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
      i = n(795);
  var o = "",
      r = "";

  if (((a = i) && a.__esModule ? a : {
    "default": a
  })["default"]) {
    var l = {
      Moz: "-moz-",
      ms: "-ms-",
      O: "-o-",
      Webkit: "-webkit-"
    },
        s = document.createElement("p").style;

    for (var c in l) {
      if (c + "Transform" in s) {
        o = c, r = l[c];
        break;
      }
    }
  }

  t["default"] = {
    js: o,
    css: r
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t["default"] = function (e) {
    if (!l) return e;
    if (null != s[e]) return s[e];
    (0, o["default"])(e) in l.style ? s[e] = e : i["default"].js + (0, o["default"])("-" + e) in l.style ? s[e] = i["default"].css + e : s[e] = !1;
    return s[e];
  };
  var a = r(n(795)),
      i = r(n(822)),
      o = r(n(824));

  function r(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var l = void 0,
      s = {};

  if (a["default"]) {
    l = document.createElement("p");
    var c = window.getComputedStyle(document.documentElement, "");

    for (var u in c) {
      isNaN(u) || (s[c[u]] = c[u]);
    }
  }
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t["default"] = function (e) {
    return e.replace(a, i);
  };
  var a = /[-\s]+(.)?/g;

  function i(e, t) {
    return t ? t.toUpperCase() : "";
  }
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t["default"] = function (e, t) {
    if (!l) return t;
    if ("string" != typeof t || !isNaN(parseInt(t, 10))) return t;
    var n = e + t;
    if (null != r[n]) return r[n];

    try {
      l.style[e] = t;
    } catch (a) {
      return r[n] = !1, !1;
    }

    "" !== l.style[e] ? r[n] = t : ("-ms-flex" === (t = i["default"].css + t) && (t = "-ms-flexbox"), l.style[e] = t, "" !== l.style[e] && (r[n] = t));
    r[n] || (r[n] = !1);
    return l.style[e] = "", r[n];
  };
  var a = o(n(795)),
      i = o(n(822));

  function o(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  var r = {},
      l = void 0;
  a["default"] && (l = document.createElement("p"));
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t["default"] = function () {
    function e(e, t) {
      return e.length - t.length;
    }

    return {
      onProcessStyle: function onProcessStyle(t, n) {
        if ("style" !== n.type) return t;
        var a = {},
            i = Object.keys(t).sort(e);

        for (var o in i) {
          a[i[o]] = t[i[o]];
        }

        return a;
      }
    };
  };
},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function () {
    var e,
        t,
        n,
        a,
        i,
        o = this.getChildren(),
        r = this.getDatasets(),
        l = o.xAxis && o.xAxis[0] || o.scale,
        s = [],
        c = 0;

    if (r) {
      for (e = r.length, t = 0; t < e; t++) {
        c = Math.max(c, r[t].components.data.length);
      }

      for (t = 0; t < c; t++) {
        for ((i = s[t] = [])[0] = l.getLabel(t).label, n = 1; n <= e; n++) {
          a = r[n - 1].components.data[t], i[n] = a && a.config.setValue;
        }
      }

      return s;
    }
  };
},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    !function (e) {
      var t = e.getChildren("colorManager");
      if (!e.getFromEnv("dataSource").colorrange) return t && (t[0].config.legendItemIds = []), void e.deleteFromEnv("colorManager");
      if (t) return e.addToEnv("colorManager", t[0]), void t[0].configure();
      t = new o["default"](), e.attachChild(t, "colorManager"), e.addToEnv("colorManager", t), t.configure();
    }(e);
  };
  var a,
      i = n(949),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(138),
      i = l(n(950)),
      o = l(n(951)),
      r = n(125);

  function l(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }

  function s(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  function c(e) {
    var t = e || h;
    return (0, r.getValidColor)(t) || h;
  }

  var u = "rgba(192,192,192," + (r.isIE ? .002 : 1e-6) + ")",
      h = "#000000",
      d = function () {
    var e,
        t = {};
    return t.legendCarpetConf = {
      spreadFactor: .85,
      allowDrag: !1,
      captionAlignment: "center",
      padding: {
        v: 3,
        h: 3
      },
      style: {
        fill: "#e4d9c1",
        stroke: "#c4b89d"
      }
    }, t.legendCaptionConf = {
      spreadFactor: .2,
      padding: {
        v: 2,
        h: 2
      },
      style: {
        fill: "#786B50",
        fontFamily: "sans-serif",
        fontSize: "12px",
        fontWeight: "bold",
        fontStyle: "normal"
      },
      bound: {
        style: {
          stroke: "none"
        }
      }
    }, t.legendBodyConf = {
      spreadFactor: .8,
      padding: {
        v: 2,
        h: 2
      },
      bound: {
        style: {
          stroke: "none"
        }
      }
    }, t.legendAxisConf = {
      legendAxisHeight: 11,
      spreadFactor: .4,
      padding: {
        v: 1,
        h: 1
      },
      style: {
        stroke: "none",
        "stroke-opacity": 0,
        "stroke-width": 1
      },
      line: {
        grooveLength: 3,
        offset: 8,
        style: {
          stroke: "rgba(255, 255, 255, 0.65)",
          "stroke-width": 1.5
        }
      },
      shadow: {
        style: {
          stroke: "none",
          fill: (0, r.toRaphaelColor)({
            FCcolor: {
              alpha: "25,0,0",
              angle: 360,
              color: "000000,FFFFFF,FFFFFF",
              ratio: "0,30,40"
            }
          })
        }
      },
      bound: {
        style: {
          stroke: "none"
        }
      }
    }, t.sliderGroupConf = {
      showTooltip: 1,
      outerCircle: {
        rFactor: 1.4,
        style: {
          fill: u,
          stroke: "#757575",
          "stroke-width": 3
        }
      },
      innerCircle: {
        rFactor: .65,
        style: {
          fill: u,
          stroke: "#FFFFFF"
        }
      }
    }, t.axisTextItemConf = {
      spreadFactor: .3,
      padding: {
        v: 1,
        h: 1
      },
      style: {
        fill: "#786B50",
        fontFamily: "sans-serif",
        fontSize: "12px",
        fontWeight: "normal",
        fontStyle: "normal"
      }
    }, {
      init: function init(t) {
        e = t.chart;
      },
      legacyDataParser: function legacyDataParser(t, n) {
        var a,
            i,
            o,
            l,
            s,
            u,
            h,
            d,
            p,
            f,
            g,
            m,
            b,
            v = {},
            y = e.getFromEnv("number-formatter"),
            x = e.getFromEnv("dataSource"),
            C = x.dataset,
            k = x.data;
        if (n = n || {}, !t) return !1;

        for ("maps" !== e.defaultDatasetType || void 0 !== n.min && void 0 !== n.max ? "HeatMap" !== e.getName() || void 0 !== n.min && void 0 !== n.max || (n = {
          min: Infinity,
          max: -Infinity
        }, C.forEach(function (e) {
          e.data && e.data.forEach(function (e) {
            n.min = Math.min(n.min, (0, r.pluckNumber)(e.value, n.min)), n.max = Math.max(n.max, (0, r.pluckNumber)(e.value, n.max));
          });
        })) : (n = {
          min: Infinity,
          max: -Infinity
        }, k && k.forEach(function (e) {
          n.min = Math.min(n.min, (0, r.pluckNumber)(e.value, n.min)), n.max = Math.max(n.max, (0, r.pluckNumber)(e.value, n.min));
        })), v.mapByPercent = g = !!(0, r.pluckNumber)(t.mapbypercent, 0), a = t.color || [], void 0 === t.minvalue && (t.minvalue = void 0 !== n.min ? g ? 0 : n.min : 0), void 0 === t.maxvalue && (t.maxvalue = void 0 !== n.max ? g ? 100 : n.max : 100), t.maxvalue !== t.minvalue && n.min !== Infinity && n.max !== -Infinity || (t.minvalue = 0, t.maxvalue = 100), m = !1, s = 0, h = a.length; s < h; s++) {
          if (a[s].maxvalue) {
            m = !0;
            break;
          }
        }

        for (m || (a = []), o = t.code, d = v.colorRange = [], v.gradient = !!(0, r.pluckNumber)(t.gradient, 1), a.length ? o = c(o) : (o ? (l = c(o), o = c()) : (o = c(), b = o, l = (0, r.getLightColor)(b, 1)), a.push({
          code: l,
          maxvalue: t.maxvalue,
          label: void 0
        })), function (t) {
          var n,
              a,
              i,
              o = e.getFromEnv("number-formatter");

          for (n = 0, a = t.length; n < a; n++) {
            (i = t[n].maxvalue) && (t[n].maxvalue = o.getCleanValue(i));
          }
        }(a), a = a.sort(function (e, t) {
          return e.maxvalue - t.maxvalue;
        }), p = f = t.minvalue && y.getCleanValue(t.minvalue), f = (void 0 !== p || null !== p) && (g ? p + "%" : y.legendValue(p)), d.push({
          code: (0, r.dehashify)(o),
          value: p,
          displayValue: f,
          label: t.startlabel
        }), s = 0, h = a.length; s < h; s++) {
          u = c((i = a[s]).code || i.color), p = f = i.maxvalue, isNaN(parseInt(p, 10)) || (f = (void 0 !== p || null !== p) && (g ? p + "%" : y.legendValue(p)), d.push({
            code: (0, r.dehashify)(u),
            value: p,
            displayValue: f,
            label: i.label || i.displayvalue
          }));
        }

        return d[d.length - 1].label = t.endlabel || i.label, v;
      },
      getDefaultConf: function getDefaultConf(e) {
        return t[e];
      }
    };
  }(),
      p = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.datasource = {}, n.config.legendItemIds = [], n;
    }

    return s(t, e), t.prototype.configure = function () {
      var e,
          t = this.getFromEnv("chart"),
          n = "maps" === t.defaultDatasetType,
          a = "TreeMap" === t.getName(),
          l = this.getFromEnv("dataSource").chart.mapbycategory,
          s = t.getFromEnv("number-formatter"),
          c = void 0,
          u = t.config.showLegend,
          h = t.getChildren("colorRange") && t.getChildren("colorRange")[0];

      switch (t.addToEnv("colorManager", this), this.datasource = t.getFromEnv("dataSource"), e = this.datasource.colorrange, h && h.remove({
        instant: !0
      }), u || (this.config.legendItemIds = []), n ? e.gradient && Number(e.gradient) ? "gradient" : e.color ? "icon" : "none" : a ? "gradient" : e.gradient && "0" != e.gradient && !Number(l) ? "gradient" : "icon") {
        case "gradient":
          d.init({
            chart: t
          }), c = d.legacyDataParser(e), (0, r.componentFactory)(t, o["default"], "colorRange", 1, [c]), h = t.getChildren("colorRange")[0], t.addToEnv("colorRange", h), c || (h._dontPlot = !0), this.config.legendItemIds = [], this._configureGradientLegend(h);
          break;

        case "icon":
          (0, r.componentFactory)(t, i["default"], "colorRange", 1, [{
            colorRange: e,
            sortLegend: 0,
            mapByCategory: (0, r.pluckNumber)(l, 0),
            defaultColor: "cccccc",
            numberFormatter: s
          }]), t.addToEnv("colorRange", t.getChildren("colorRange")[0]), u && this._addLegendItems();
          break;

        case "none":
          t.deleteFromEnv("colorManager"), this.config.legendItemIds = [];
      }
    }, t.prototype._configureGradientLegend = function (e) {
      var t = this,
          n = t.getFromEnv("chart").getFromEnv("gLegend");
      n && (n.setColorRange(e), t.addExtEventListener("rangeUpdated", function (e, n) {
        t.fireEvent("legendUpdate", {
          "original-event": e,
          maxMinArray: n,
          component: "gradientlegend"
        });
      }, n));
    }, t.prototype._addLegendItems = function () {
      var e = this.config,
          t = this.getFromEnv("chart"),
          n = t.getChildren("legend")[0],
          a = t.getFromEnv("colorRange").colorArr,
          i = void 0,
          o = void 0,
          l = a.length,
          s = void 0,
          c = void 0,
          u = void 0;

      for (c = 0; c < l; c++) {
        u = {
          label: (0, r.pluck)(a[c].label, a[c].displayvalue),
          datasetObj: a[c],
          index: c
        }, o = (0, r.getLightColor)(a[c].code, 40), i = {
          FCcolor: {
            color: a[c].code + "," + a[c].code + "," + o,
            ratio: "0,70,30",
            angle: 270,
            alpha: "100,100,100"
          }
        }, (s = n.getItem(e.legendItemIds[c])) || (e.legendItemIds.push(n.createItem(this)), (s = n.getItem(e.legendItemIds[c])).addEventListener("fc-click", s.itemClickFn)), s.removeLegendState("hidden"), a[c].legendItemId = s && s.getId(), s.configure(u), s.setStateCosmetics("default", {
          symbol: {
            fill: (0, r.toRaphaelColor)(i),
            rawFillColor: a[c].code
          }
        });
      }

      for (c = l; c < e.legendItemIds.length; c++) {
        n.disposeItem(e.legendItemIds[c]);
      }

      e.legendItemIds.splice(l);
    }, t.prototype.legendInteractivity = function (e) {
      var t = this.getFromEnv("colorRange").colorArr[e.config.index];
      this.fireEvent("legendUpdate", {
        legendItem: e,
        colorObj: t,
        component: "legend"
      });
    }, t.prototype.getColor = function (e) {
      var t = this.datasource.colorrange,
          n = this.datasource.chart.mapbycategory;
      return !Number(n) && Number(t.gradient) ? {
        code: this.getColorByValue(e)
      } : this.getColorObj(e);
    }, t.prototype.getValueRatio = function () {
      return this.getFromEnv("colorRange").getValueRatio();
    }, t.prototype.getCumulativeValueRatio = function () {
      return this.getFromEnv("colorRange").getCumulativeValueRatio();
    }, t.prototype.getBoxFill = function (e) {
      return this.getFromEnv("colorRange").getBoxFill(e);
    }, t.prototype.getColorByValue = function (e) {
      return this.getFromEnv("colorRange").getColorByValue(e);
    }, t.prototype.getColorObj = function (e) {
      return this.getFromEnv("colorRange").getColorObj(e);
    }, t;
  }(a.ComponentInterface);

  t["default"] = p;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(125);

  function i(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var o = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this)),
          a = n;

      return a.mapByCategory = !1, a.colorArr = [], a.noValidRange = !0, a.sortLegend = !1, n;
    }

    return i(t, e), t.prototype.__setDefaultConfig = function () {
      e.prototype.__setDefaultConfig.call(this), this.config.defaultObj = {
        code: "CCCCCC",
        alpha: "100"
      };
    }, t.prototype.getType = function () {
      return "colorComponent";
    }, t.prototype.getName = function () {
      return "colorBucket";
    }, t.prototype.configure = function (e) {
      if (e) {
        var t = this.mapByCategory,
            n = e.numberFormatter,
            i = e.colorRange || {},
            o = (0, a.extend2)([], i.color),
            r = this.getLinkedParent(),
            l = this.getFromEnv("dataSource"),
            s = Math.min(Math.max((0, a.pluckNumber)(l.chart.palette, 0) - 1, 0), 4),
            c = r.defaultPaletteOptions && r.defaultPaletteOptions.paletteColors[s],
            u = (0, a.pluckNumber)(n.getCleanValue(i.maxvalue), Infinity),
            h = (0, a.pluckNumber)(n.getCleanValue(i.minvalue), -Infinity),
            d = this.colorArr,
            p = void 0,
            f = void 0,
            g = void 0,
            m = void 0,
            b = void 0,
            v = void 0,
            y = void 0,
            x = void 0,
            C = void 0,
            k = void 0,
            w = void 0;

        if (void 0 !== e.mapByCategory && (t = this.mapByCategory = !!Number(e.mapByCategory)), (o = t ? o.filter(function (e) {
          return e.code || e.color;
        }) : o.filter(function (e) {
          return e.minvalue || e.maxvalue;
        })).forEach(function (e) {
          e.minvalue && e.maxvalue && +e.maxvalue < +e.minvalue && (x = e.maxvalue, e.maxvalue = e.minvalue, e.minvalue = x), e.minvalue ? e.maxvalue ? (k = n.getCleanValue(e.minvalue), C = n.getCleanValue(e.maxvalue), e.rangeLabel = n.dataLabels(k) + "-" + n.dataLabels(C)) : (k = n.getCleanValue(e.minvalue), e.maxvalue = C = u, e.rangeLabel = C === Infinity ? ">" + n.dataLabels(k) : n.dataLabels(k) + "-" + n.dataLabels(C)) : (e.minvalue = k = h, C = n.getCleanValue(e.maxvalue), e.rangeLabel = k === -Infinity ? "<" + n.dataLabels(C) : n.dataLabels(k) + "-" + n.dataLabels(C));
        }), o.sort(function (e, t) {
          return +e.minvalue == +t.minvalue ? e.maxvalue - t.maxvalue : e.minvalue - t.minvalue;
        }), o && (p = o.length)) {
          for (d.length = 0, f = 0; f < p; f += 1) {
            y = o[f], g = (0, a.pluck)(y.color, y.code, c && c[f]), m = (0, a.pluck)(y.alpha), v = (0, a.pluck)(y.bordercolor), b = (0, a.pluck)(y.borderalpha, 100), C = (0, a.pluckNumber)(y.maxvalue), k = (0, a.pluckNumber)(y.minvalue), w = (0, a.pluck)(y.label, y.displayvalue, y.rangeLabel), (g && C >= k || t && w) && d.push({
              code: g,
              alpha: m || "100",
              oriAlpha: m,
              maxvalue: C,
              minvalue: k,
              label: (0, a.parseUnsafeString)(w),
              labelId: w.toLowerCase(),
              bordercolor: v,
              borderAlpha: b,
              name: y.name
            });
          }

          this.sortedColorArr = this.colorArr.slice(0);
        } else this.noValidRange = !0, this.colorArr = [], this.sortedColorArr = [];
      }
    }, t.prototype.getColorObj = function (e) {
      if (void 0 === e) return {
        outOfRange: !0
      };
      var t = void 0,
          n = this.sortedColorArr,
          i = this.gradient ? 1 : 0,
          o = n[i],
          r = void 0;

      if (this.mapByCategory) {
        for (e = (0, a.parseUnsafeString)(e).toLowerCase() || e.toString().toLowerCase(); o;) {
          if (o.labelId === e || o.maxvalue >= e && o.minvalue <= e) return {
            code: o.code,
            alpha: o.alpha || "100",
            oriAlpha: o.oriAlpha,
            seriesIndex: i,
            legendItemId: o.legendItemId
          };
          o = n[i += 1];
        }

        return {
          outOfRange: !0
        };
      }

      if (this.gradient) {
        if (this.scaleMin <= e && this.scaleMax >= e) {
          for (; o && o.maxvalue < e;) {
            o = n[i += 1];
          }

          return r = (e - o.minvalue) / o.range, {
            code: function (e, t, n) {
              var i = e[0],
                  o = e[1],
                  r = e[2],
                  l = i + (t[0] - i) * n,
                  s = o + (t[1] - o) * n,
                  c = r + (t[2] - r) * n;
              return {
                hex: (a.COLOR_BLACK + (l << 16 | s << 8 | c).toString(16)).slice(-6),
                rgb: [l, s, c]
              };
            }(n[i - 1].codeRGB, o.codeRGB, r).hex
          };
        }

        return {
          outOfRange: !0
        };
      }

      for (; o;) {
        if (e < o.minvalue && !t) return 0 === i ? {
          code: o.code,
          alpha: o.alpha || "100",
          oriAlpha: o.oriAlpha,
          seriesIndex: i,
          name: o.name,
          label: o.label,
          outOfRange: !0,
          bordercolor: o.bordercolor,
          borderalpha: o.borderAlpha
        } : {
          code: n[i - 1].code,
          alpha: n[i - 1].alpha || "100",
          oriAlpha: n[i - 1].oriAlpha,
          seriesIndex: i,
          name: n[i - 1].name,
          label: n[i - 1].label,
          outOfRange: !0,
          bordercolor: n[i - 1].bordercolor,
          borderalpha: n[i - 1].borderAlpha
        };
        if (e > o.maxvalue && i === n.length - 1) return {
          code: o.code,
          alpha: o.alpha || "100",
          oriAlpha: o.oriAlpha,
          seriesIndex: i,
          name: o.name,
          label: o.label,
          outOfRange: !0,
          bordercolor: o.bordercolor,
          borderalpha: o.borderAlpha
        };
        if (o.maxvalue > e && o.minvalue <= e) return {
          code: o.code,
          alpha: o.alpha || "100",
          oriAlpha: o.oriAlpha,
          seriesIndex: i,
          name: o.name,
          label: o.label,
          bordercolor: o.bordercolor,
          borderalpha: o.borderAlpha
        };
        if (e === o.maxvalue && (t = {
          code: o.code,
          alpha: o.alpha || "100",
          oriAlpha: o.oriAlpha,
          seriesIndex: i,
          name: o.name,
          label: o.label,
          bordercolor: o.bordercolor,
          borderalpha: o.borderAlpha
        }), i === n.length - 1 && t) return t;
        o = n[i += 1];
      }

      return n.length ? void 0 : {
        outOfRange: !0
      };
    }, t.prototype.getColorRangeArr = function (e, t) {
      var n,
          i,
          o,
          r,
          l,
          s,
          c,
          u,
          h = this.colorArr,
          d = [];

      if (!this.defaultAsigned && (e > t && (n = e, e = t, t = n), e < t && (r = this.getColorObj(e), s = this.getColorObj(t), r && s))) {
        for (l = e, i = r.seriesIndex, o = s.seriesIndex; i <= o; i += 1) {
          (c = (0, a.extend2)({}, h[i])).minvalue !== l && (c.minvalue = l), d.push(c), u = c, l = c.maxvalue;
        }

        u && (u.maxvalue = t);
      }

      return d;
    }, t;
  }(n(138).ComponentInterface);

  t["default"] = o;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = n(138),
      i = n(125);

  function o(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var r = function (e) {
    function t() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.call(this));

      return n.colorRange = {}, n.valueRatio = {}, n.data = {}, n.mapByPercent = undefined, n;
    }

    return o(t, e), t.prototype.getType = function () {
      return "colorComponent";
    }, t.prototype.getName = function () {
      return "gradientColorRange";
    }, t.prototype.configure = function (e) {
      if (e) {
        var t,
            n,
            a = void 0;

        for (this.data = e, this.appender = "", n = this.colorRange = e.colorRange.sort(function (e, t) {
          return e.value - t.value;
        }), this.valueRatio = void 0, this.values = [], a = 0, t = n.length; a < t; a++) {
          this.values.push(n[a].value);
        }
      }
    }, t.prototype.getValueRatio = function () {
      var e,
          t,
          n = this.colorRange,
          a = n.length,
          i = this.valueRatio,
          o = n[a - 1].value,
          r = n[0].value,
          l = o - r,
          s = 0;
      if (i) return i;

      for (i = this.valueRatio = [], e = 0; e < a; e++) {
        t = (n[e].value - r) / l, i.push(100 * (t - s)), s = t;
      }

      return i;
    }, t.prototype.getCumulativeValueRatio = function () {
      var e,
          t,
          n = this.colorRange,
          a = n.length,
          i = n[0].value,
          o = n[a - 1].value,
          r = [];

      for (t = 0; t < a; t++) {
        e = n[t], r.push((e.value - i) / (o - i) * 100);
      }

      return r;
    }, t.prototype.getBoxFill = function (e) {
      var t,
          n,
          a,
          o,
          r = this.colorRange,
          l = r.length,
          s = [];

      for (o = e ? 90 : 0, n = 0; n < l; n++) {
        t = r[n], s.push(t.code);
      }

      return a = {
        FCcolor: {
          alpha: "100,100,100",
          angle: o,
          color: s.join(","),
          ratio: this.getValueRatio().join(",")
        }
      }, (0, i.toRaphaelColor)(a);
    }, t.prototype.getColorByValue = function (e) {
      var t,
          n,
          a,
          o,
          r = this.values,
          l = this.colorRange;

      if (void 0 !== e && null !== e) {
        for (n = 0, t = r.length; n < t; n++) {
          if (e === r[n]) {
            o = l[n].code;
            break;
          }

          if (!n && e < r[n]) {
            a = !0;
            break;
          }

          if (n === t - 1 && e > r[n]) {
            a = !0;
            break;
          }

          if (e > r[n] && e < r[n + 1]) {
            s = l[n], c = l[n + 1], u = e, h = void 0, d = void 0, void 0, void 0, void 0, void 0, void 0, void 0, p = s.value, f = s.code, g = (0, i.HEXtoRGB)(f), m = c.value, b = c.code, v = (0, i.HEXtoRGB)(b), h = m - p, d = [Math.round(g[0] + (v[0] - g[0]) / h * (u - p)), Math.round(g[1] + (v[1] - g[1]) / h * (u - p)), Math.round(g[2] + (v[2] - g[2]) / h * (u - p))], o = (0, i.RGBtoHex)(d);
            break;
          }
        }

        var s, c, u, h, d, p, f, g, m, b, v;
        if (!a) return o;
      }
    }, t;
  }(a.ComponentInterface);

  t["default"] = r;
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t["default"] = function (e) {
    !function (e) {
      var t = e.getFromEnv("dataSource").colorrange,
          n = e.getFromEnv("dataSource").chart.mapbycategory,
          r = "maps" === e.defaultDatasetType,
          l = "TreeMap" === e.getName(),
          s = void 0,
          c = e.getFromEnv("legend"),
          u = e.getFromEnv("gLegend");
      s = t && e.config.showLegend ? r ? t.gradient && Number(t.gradient) ? "gradient" : t.color ? "icon" : "none" : l ? t.gradient && "0" != t.gradient ? "gradient" : "none" : t.gradient && "0" != t.gradient && !Number(n) ? "gradient" : "icon" : "none";

      switch (s) {
        case "gradient":
          e.deleteFromEnv("legend"), c && c.remove(), (0, a.componentFactory)(e, i["default"], "gLegend", 1), (u = e.getChildren("gLegend")[0]).configure(), e.addToEnv("gLegend", u);
          break;

        case "icon":
          e.deleteFromEnv("gLegend"), u && u.remove(), (0, a.componentFactory)(e, o["default"], "legend", 1, {
            showLegend: !0
          }), (c = e.getChildren("legend")[0]).configure(), e.addToEnv("legend", c);
          break;

        case "none":
          e.deleteFromEnv("gLegend"), e.deleteFromEnv("legend"), u && u.remove(), c && c.remove();
      }
    }(e);
  };
  var a = n(125),
      i = r(n(953)),
      o = r(n(463));

  function r(e) {
    return e && e.__esModule ? e : {
      "default": e
    };
  }
}, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      i = n(125),
      o = n(138);

  function r(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function l(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  function s(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var c = void 0,
      u = {},
      h = "rgba(192,192,192," + (i.isIE ? .002 : 1e-6) + ")",
      d = void 0,
      p = !1,
      f = !0,
      g = "#000000",
      m = {}.hasOwnProperty,
      b = "M",
      v = "L",
      y = void 0;

  function x(e, t) {
    return function n(e, t) {
      var i, o;

      for (o in e) {
        m.call(e, o) && (i = e[o], t[o] === c ? t[o] = i : "object" === (void 0 === i ? "undefined" : a(i)) && null !== i && n(i, t[o]));
      }
    }(e, t), t;
  }

  function C(e) {
    var t = e || g;
    return (0, i.getValidColor)(t) || g;
  }

  function k(e) {
    var t,
        n = e.fontSize + "";
    return n ? (t = n.replace(/(\d+)(px)*/, "$1px"), e.fontSize = t, e) : e;
  }

  function w(e) {
    return !(e !== c && void 0 !== e && null !== e && !isNaN(e));
  }

  u.CAPTION = "CAPTION", u.LEGEND_BODY = "LEGEND_BODY", u.AXIS_LABEL = "LEGEND_LABEL", u.LEGEND_AXIS = "LEGEND_AXIS", u.RANGE = "RANGE", u.AXIS_VALUE = "AXIS_VALUE", d = function () {
    var e,
        t = {};
    return t.legendCarpetConf = {
      spreadFactor: .85,
      allowDrag: !1,
      captionAlignment: "center",
      padding: {
        v: 3,
        h: 3
      },
      style: {
        fill: "#e4d9c1",
        stroke: "#c4b89d"
      }
    }, t.legendCaptionConf = {
      spreadFactor: .2,
      padding: {
        v: 2,
        h: 2
      },
      style: {
        fill: "#786B50",
        fontFamily: "sans-serif",
        fontSize: "12px",
        fontWeight: "bold",
        fontStyle: "normal"
      },
      bound: {
        style: {
          stroke: "none"
        }
      }
    }, t.legendBodyConf = {
      spreadFactor: .8,
      padding: {
        v: 2,
        h: 2
      },
      bound: {
        style: {
          stroke: "none"
        }
      }
    }, t.legendAxisConf = {
      legendAxisHeight: 11,
      spreadFactor: .4,
      padding: {
        v: 1,
        h: 1
      },
      style: {
        stroke: "none",
        "stroke-opacity": 0,
        "stroke-width": 1
      },
      line: {
        grooveLength: 3,
        offset: 8,
        style: {
          stroke: "rgba(255, 255, 255, 0.65)",
          "stroke-width": 1.5
        }
      },
      shadow: {
        style: {
          stroke: "none",
          fill: (0, i.toRaphaelColor)({
            FCcolor: {
              alpha: "25,0,0",
              angle: 360,
              color: "000000,FFFFFF,FFFFFF",
              ratio: "0,30,40"
            }
          })
        }
      },
      bound: {
        style: {
          stroke: "none"
        }
      }
    }, t.sliderGroupConf = {
      showTooltip: 1,
      outerCircle: {
        rFactor: 1.4,
        style: {
          fill: h,
          stroke: "#757575",
          "stroke-width": 3
        }
      },
      innerCircle: {
        rFactor: .65,
        style: {
          fill: h,
          stroke: "#FFFFFF"
        }
      }
    }, t.axisTextItemConf = {
      spreadFactor: .3,
      padding: {
        v: 1,
        h: 1
      },
      style: {
        fill: "#786B50",
        fontFamily: "sans-serif",
        fontSize: "12px",
        fontWeight: "normal",
        fontStyle: "normal"
      }
    }, {
      init: function init(t) {
        e = t.chart;
      },
      legacyDataParser: function legacyDataParser(t, n) {
        var a,
            o,
            r,
            l,
            s,
            u,
            h,
            d,
            p,
            f,
            g,
            m,
            b,
            v = {},
            y = e.getFromEnv("number-formatter");
        if (!t) return !1;

        for (v.mapByPercent = g = !!(0, i.pluckNumber)(t.mapbypercent, 0), a = t.color || [], t.minvalue === c && (t.minvalue = n.min !== c ? g ? 0 : n.min : 0), t.maxvalue === c && (t.maxvalue = n.max !== c ? g ? 100 : n.max : 100), m = !1, s = 0, h = a.length; s < h; s++) {
          if (a[s].maxvalue) {
            m = !0;
            break;
          }
        }

        for (m || (a = []), r = t.code, d = v.colorRange = [], v.gradient = !!(0, i.pluckNumber)(t.gradient, 1), a.length ? r = C(r) : (r ? (l = C(r), r = C()) : (r = C(), b = r, l = (0, i.getLightColor)(b, 1)), a.push({
          code: l,
          maxvalue: t.maxvalue,
          label: c
        })), function (t) {
          var n,
              a,
              i,
              o = e.getFromEnv("number-formatter");

          for (n = 0, a = t.length; n < a; n++) {
            (i = t[n].maxvalue) && (t[n].maxvalue = o.getCleanValue(i));
          }
        }(a), a = a.sort(function (e, t) {
          return e.maxvalue - t.maxvalue;
        }), p = f = t.minvalue && y.getCleanValue(t.minvalue), f = (p !== c || null !== p) && (g ? p + "%" : y.legendValue(p)), d.push({
          code: (0, i.dehashify)(r),
          value: p,
          displayValue: f,
          label: t.startlabel
        }), s = 0, h = a.length; s < h; s++) {
          u = C((o = a[s]).code || o.color), p = f = o.maxvalue, isNaN(parseInt(p, 10)) || (f = (p !== c || null !== p) && (g ? p + "%" : y.legendValue(p)), d.push({
            code: (0, i.dehashify)(u),
            value: p,
            displayValue: f,
            label: o.label || o.displayvalue
          }));
        }

        return d[d.length - 1].label = t.endlabel || o.label, v;
      },
      getDefaultConf: function getDefaultConf(e) {
        return t[e];
      }
    };
  }();

  var S = function (e) {
    function t() {
      r(this, t);
      var n = l(this, e.call(this));
      return y = n, n.enabled = !1, n.drawOptions = {}, n.components = {}, n;
    }

    return s(t, e), t.prototype.getType = function () {
      return "gradientLegend";
    }, t.prototype.getName = function () {
      return "gLegend";
    }, t.prototype.setColorRange = function (e) {
      var t = this.drawOptions.colorRange = e;
      t && t._preparationGoneWrong && (this._dontPlot = !0);
    }, t.prototype.configureAttributes = function () {
      var e,
          t,
          n,
          a,
          o,
          r,
          l,
          s,
          u,
          h,
          p = this.getFromEnv("chart"),
          f = this.getFromEnv("dataSource").chart,
          g = this.conf = {},
          m = f.outcnvbasefont,
          b = f.outcnvbasefontsize,
          v = f.outcnvbasefontcolor,
          y = p.config.dataLabelStyle;
      d.init({
        chart: p
      }), this.data = this.getFromEnv("dataSource").colorrange, this._dontPlot || (this.drawOptions = {
        smartLabel: this.getFromEnv("smartLabel"),
        gLegend: this
      }, this._dontPlot = !1, this._recalculateLogicalSpace = !0, g.caption = (0, i.pluck)(f.legendcaption), g.legendPosition = (0, i.pluck)(f.legendposition, "bottom").toLowerCase(), g.showLegend = (0, i.pluckNumber)(f.showlegend, 1), g.interactiveLegend = (0, i.pluckNumber)(f.interactivelegend, 1), g.showLegendLabels = (0, i.pluckNumber)(f.showlegendlabels, 1), e = f.legenditemfontcolor || v, t = f.legenditemfont || m, n = f.legenditemfontsize || b, a = (0, i.pluckNumber)(f.legenditemfontbold, 0), o = f.legendcaptionfontcolor || v, r = f.legendcaptionfont || m, l = f.legendcaptionfontsize || b, s = (0, i.pluckNumber)(f.legendcaptionfontbold, 1), h = (u = f.legendaxisbordercolor ? (0, i.hashify)((0, i.dehashify)(f.legendaxisbordercolor)) : c) ? (0, i.pluckNumber)(f.legendaxisborderalpha, 100) / 100 : c, g.axisTextItemConf = {
        style: {
          fill: e ? (0, i.convertColor)((0, i.pluck)(e)) : y.color,
          fontFamily: t ? (0, i.pluck)(t) : y.fontFamily,
          fontSize: n ? (0, i.pluckNumber)(n) : y.fontSize.match(/\d+/)[0],
          fontWeight: a ? "bold" : y.fontWeight
        }
      }, g.legendCaptionConf = {
        style: {
          fill: o ? (0, i.convertColor)((0, i.pluck)(o)) : y.color,
          fontFamily: r ? (0, i.pluck)(r) : y.fontFamily,
          fontSize: l ? (0, i.pluckNumber)(l) : y.fontSize.match(/\d+/)[0],
          fontWeight: s ? "bold" : y.fontWeight,
          fontStyle: "normal"
        }
      }, g.legendAxisConf = {
        legendAxisHeight: 11,
        style: {
          stroke: u,
          "stroke-opacity": h
        },
        line: {
          style: {
            stroke: (0, i.convertColor)((0, i.pluck)(f.legendscalelinecolor, "FFF8E9"), (0, i.pluckNumber)(f.legendscalelinealpha, 100)),
            "stroke-width": (0, i.pluckNumber)(f.legendscalelinethickness)
          }
        }
      }, g.sliderGroupConf = {
        showTooltip: (0, i.pluckNumber)(f.showtooltip, 1),
        outerCircle: {
          rFactor: (0, i.pluckNumber)(f.sliderdiameterfactor),
          style: {
            stroke: (0, i.convertColor)((0, i.pluck)(f.legendpointerbordercolor, "757575"), (0, i.pluckNumber)(f.legendpointerborderalpha, 100))
          }
        },
        innerCircle: {
          rFactor: (0, i.pluckNumber)(f.sliderholediameterfactor),
          style: {
            stroke: (0, i.convertColor)((0, i.pluck)(f.legendpointercolor, "FFFFFF"), (0, i.pluckNumber)(f.legendpointeralpha, 100))
          }
        }
      }, g.legendCarpetConf = {
        spreadFactor: (0, i.pluckNumber)(f.legendspreadfactor),
        allowDrag: !!(0, i.pluckNumber)(f.legendallowdrag, 0),
        captionAlignment: (0, i.pluck)(f.legendcaptionalignment, "center"),
        style: {
          fill: (0, i.convertColor)((0, i.pluck)(f.legendbgcolor, "e4d9c1"), (0, i.pluckNumber)(f.legendbgalpha, 100)),
          stroke: (0, i.convertColor)((0, i.pluck)(f.legendbordercolor, "c4b89d"), (0, i.pluckNumber)(f.legendborderalpha, 100)),
          "stroke-width": (0, i.pluckNumber)(f.legendborderthickness, 1)
        }
      });
    }, t.prototype.postConfigureInit = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r,
          l,
          s,
          c,
          h,
          p = this.conf;
      this.elem = {}, p.interactiveLegend ? (a = x(d.getDefaultConf("sliderGroupConf"), p.sliderGroupConf), this.sGroup ? ((n = this.elem.sGroup = this.sGroup).configure(a), this.elem.sGroup.gLegend = this) : (this.sGroup = this.elem.sGroup = n = new O(a), n.configure(a), this.elem.sGroup.gLegend = this)) : (this.sGroup && this.sGroup.dispose(), this.sGroup && delete this.sGroup), (a = x(d.getDefaultConf("legendCarpetConf"), p.legendCarpetConf)).legendPosition = p.legendPosition, h = d.getDefaultConf("legendBodyConf"), "bottom" === p.legendPosition ? (this.drawOptions.refSideKey = "canvasWidth", this.drawOptions.refOffsetKey = "canvasLeft", i = x(d.getDefaultConf("axisTextItemConf"), p.axisTextItemConf), h.legendPosition = "bottom", (c = x(d.getDefaultConf("legendAxisConf"), p.legendAxisConf)).legendPosition = "bottom", i.legendPosition = "bottom") : (this.drawOptions.refSideKey = "canvasHeight", this.drawOptions.refOffsetKey = "canvasTop", i = x(d.getDefaultConf("axisTextItemConf"), p.axisTextItemConf), h.legendPosition = "right", (c = x(d.getDefaultConf("legendAxisConf"), p.legendAxisConf)).legendPosition = "right", i.legendPosition = "right"), Object.keys(this.components).length || (this.components.LegendCarpet = new L(), this.components.LegendBody = new A(), this.components.LegendAxis = new E(), this.components.LegendValues = new T(), p.showLegendLabels && (this.components.LegendLabels = new N())), t = this.components.LegendAxis, l = this.components.LegendValues, e = this.components.LegendCarpet, o = this.components.LegendBody, p.showLegendLabels && (r = this.components.LegendLabels), this.components.LegendCarpet.configure(a), this.components.LegendValues.configure(i), this.components.LegendAxis.configure(c), this.components.LegendBody.configure(this.drawOptions.colorRange, h, i), p.showLegendLabels && r.configure(i), p.caption ? (s = x(d.getDefaultConf("legendCaptionConf"), p.legendCaptionConf), this.componentCaption && Object.keys(this.componentCaption).length ? this.componentCaption.configure(p.caption, s) : (this.componentCaption = new P()).configure(p.caption, s), e.addCompositions(this.componentCaption, u.CAPTION)) : (e.removeCompositions(u.CAPTION), this.componentCaption && this.componentCaption.dispose(), delete this.componentCaption), n && t.addCompositions(n, u.RANGE), r && o.addCompositions(r, u.AXIS_LABEL), o.addCompositions(t, u.LEGEND_AXIS), o.addCompositions(l, u.AXIS_VALUE), e.addCompositions(o, u.LEGEND_BODY), this.elem.gl = new _(e);
    }, t.prototype.getValueRange = function () {
      var e,
          t,
          n = this.elem && this.elem.sGroup,
          a = n.sliders,
          i = n.extremes;
      return e = a["false"].currPos, t = i[1] - i[0] + a["true"].currPos, [{
        min: n.getValueFormPixel(e),
        max: n.getValueFormPixel(t)
      }];
    }, t.prototype._dispose = function () {
      this.elem && this.elem.gl && this.elem.gl.dispose(), this.elem = {}, e.prototype._dispose.call(this);
    }, t.prototype.getCalculatedLogicalSpace = function () {
      return this._logicalArea;
    }, t.prototype.setCalculatedLogicalSpace = function (e) {
      this._logicalArea = e;
    }, t.prototype.getLogicalSpace = function (e) {
      var t,
          n,
          a,
          i = this.conf,
          o = {
        height: 0,
        width: 0
      },
          r = this.drawOptions,
          l = this.getFromEnv("chartConfig");
      return this._recalculateLogicalSpace ? this._dontPlot ? o : (this._recalculateLogicalSpace = !1, this.postConfigureInit(), i.showLegend ? (n = r.refSideKey, a = r.refOffsetKey, this.drawOptions.refSide = l[n], this.drawOptions.refOffset = l[a], this.drawOptions.maxOtherSide = e || this.drawOptions.maxOtherSide, this.elem.gl && (t = this.elem.gl.getLogicalSpace(this.drawOptions, !0), this.elem.gl && this.setCalculatedLogicalSpace(t)), this.getCalculatedLogicalSpace()) : o) : (n = r.refSideKey, a = r.refOffsetKey, this.drawOptions.refSide = l[n], this.drawOptions.refOffset = l[a], this.drawOptions.maxOtherSide = e || this.drawOptions.maxOtherSide, t = this.elem.gl.getLogicalSpace(this.drawOptions, !0), this.setCalculatedLogicalSpace(t), this.getCalculatedLogicalSpace() || o);
    }, t.prototype.resetLegend = function () {
      var e;
      (e = this.elem && this.elem.sGroup) && e.reset();
    }, t.prototype.allocatePosition = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r = this.getFromEnv("chart"),
          l = r.config,
          s = this.conf || {},
          c = s.legendPosition,
          u = l.canvasLeft,
          h = l.canvasTop,
          d = l.canvasWidth,
          p = l.canvasHeight,
          f = l.marginBottom,
          g = l.marginRight;
      r.config.gLegendEnabled && (e = this.getCalculatedLogicalSpace(), n = s.width = e.width, a = s.height = e.height, "bottom" === c ? (i = u + ((t = d - n) < 0 ? 0 : t / 2), o = l.height - e.height - f - (l.actionBarHeight || 0)) : (o = h + ((t = p - a) < 0 ? 0 : t / 2), i = l.width - e.width - g), s.xPos = i, s.yPos = o);
    }, t.prototype.draw = function () {
      var e = this.getFromEnv("chart"),
          t = e.getFromEnv("dataSource").colorrange,
          n = this.conf || {},
          a = e.hasGradientLegend;
      e.config.gLegendEnabled && t && a && this.drawLegendComponent(n.xPos, n.yPos, {
        parentGroup: e.getContainer("parentgroup"),
        animationManager: e.getFromEnv("animationManager")
      });
    }, t.prototype.drawLegendComponent = function (e, t, n) {
      var a,
          i = this.conf;
      this._dontPlot || (i.showLegend ? (this.drawOptions.animationManager = n.animationManager, this.drawOptions.parentGroup = n.parentGroup, this.drawOptions.x = e, this.drawOptions.y = t, this.drawOptions.maxOtherSide = this.drawOptions.maxOtherSide || n.maxOtherSide, a = this.elem.gl.draw(this.drawOptions).getBBox(), i.xPos = a.x, i.yPos = a.y, i.height = a.height, i.width = a.width, this.enabled = !0) : this.enabled = !1);
    }, t;
  }(o.ComponentInterface),
      _ = function () {
    function e(t) {
      r(this, e), this.carpet = t;
    }

    return e.prototype.draw = function (e) {
      return this.carpet.draw(e);
    }, e.prototype.getLogicalSpace = function (e, t) {
      return this.carpet.getLogicalSpace(e, t);
    }, e.prototype.dispose = function () {
      this.carpet && this.carpet.group && this.carpet.group.remove();
    }, e;
  }(),
      L = function () {
    function e(t) {
      r(this, e), this.conf = t, this._id = "GL_CARPET", this.compositionsByCategory = {}, this.node = c, this.group = c, this._lSpace = c, this.autoRecalculate = !1, this.groupName = "fc-gradient-legend", this.moveInstructions = {};
    }

    return e.prototype.configure = function (e) {
      this.conf = e;
    }, e.prototype.getName = function () {
      return "LegendCarpet";
    }, e.prototype.getType = function () {
      return "legend";
    }, e.prototype.addCompositions = function (e, t) {
      this.compositionsByCategory[t] = e;
    }, e.prototype.removeCompositions = function (e) {
      delete this.compositionsByCategory[e];
    }, e.prototype.getBoundingBox = function (e) {
      var t,
          n,
          a = this.conf,
          i = a.spreadFactor,
          o = e.refSide,
          r = e.alignment,
          l = e.refOffset,
          s = e.x,
          u = e.y;
      return "bottom" === this.conf.legendPosition ? (t = a.width = o * i, n = e.maxOtherSide, !r || s !== c && null !== s || (s = (l + o) / 2 - t / 2)) : (n = a.height = o * i, t = e.maxOtherSide, !r || u !== c && null !== u || (u = (l + o) / 2 - n / 2)), {
        width: t,
        height: n,
        x: s,
        y: u
      };
    }, e.prototype.getPostCalcDecisionsH = function (e, t) {
      var n,
          a = this.conf.padding,
          i = 0;

      for (n in this.moveInstructions = {}, t) {
        i += t[n].height || 0;
      }

      e.height = i + 2 * a.v;
    }, e.prototype.getLogicalSpace = function (e, t) {
      var n,
          a,
          i,
          o,
          r,
          l = this._lSpace,
          s = ["CAPTION", "LEGEND_BODY"],
          c = this.conf.padding,
          u = this.compositionsByCategory,
          h = 0,
          d = {},
          p = 0;
      if (l && !t) return l.isImpure = !0, l;
      (w((l = this._lSpace = a = this.getBoundingBox(e)).x) || w(l.y) || w(l.height) || w(l.width)) && (this.autoRecalculate = !0), (i = x(a, {})).height -= 2 * c.v, i.width -= 2 * c.h, i.x += c.h, i.y += c.v;

      for (var f = 0; f < s.length; f++) {
        (n = u[s[f]]) && ((r = x(i, {})).y += h, h = i.height * n.conf.spreadFactor, r.height = h + p, o = n.getLogicalSpace(x(r, {}), e, t), p = r.height - o.height, d[s[f]] = o, h = o.height);
      }

      return this.getPostCalcDecisions(a, d), this._lSpace = a, a;
    }, e.prototype.setupDragging = function () {
      var e = this.group,
          t = 0,
          n = 0,
          a = 0,
          o = 0;
      e.css({
        cursor: "move"
      }), e.drag(function (i, r) {
        t = i, n = r, e.attr({
          transform: "t" + (a + t) + "," + (o + n)
        });
      }, function () {
        a += t, o += n;
      }, i.stubFN);
    }, e.prototype.draw = function (e) {
      var t,
          n,
          a,
          i = this.conf,
          o = ["CAPTION", "LEGEND_BODY"],
          r = this.compositionsByCategory,
          l = e.animationManager,
          s = e.parentGroup;
      this.getLogicalSpace(e, this.autoRecalculate), a = this._lSpace, this.group = t = l.setAnimation({
        el: this.group || "group",
        attr: {
          name: this.groupName
        },
        component: y,
        container: s,
        label: "carpetGroup"
      }), this.node = l.setAnimation({
        el: this.node || "rect",
        attr: a,
        css: i.style,
        component: y,
        container: t,
        label: "rect"
      });

      for (var c = 0; c < o.length; c++) {
        (n = r[o[c]]) && n.draw(i.captionAlignment, a, {
          animationManager: l,
          colorRange: e.colorRange,
          numberFormatter: e.numberFormatter,
          parentLayer: t,
          smartLabel: e.smartLabel,
          moveInstructions: this.moveInstructions[void 0],
          gLegend: e.gLegend
        });
      }

      return i.allowDrag && this.setupDragging(), this.node;
    }, e.prototype.getPostCalcDecisions = function (e, t) {
      return "bottom" === this.conf.legendPosition ? this.getPostCalcDecisionsH(e, t) : this.getPostCalcDecisionsV(e, t);
    }, e.prototype.getPostCalcDecisionsV = function (e, t) {
      var n,
          a,
          i,
          o = this.conf.padding,
          r = Number.NEGATIVE_INFINITY,
          l = this.moveInstructions;

      for (a in this.getPostCalcDecisionsH(e, t), t) {
        r = r < (n = t[a].width) ? n : r;
      }

      for (a in e.width = r + 2 * o.h, t) {
        (i = r - (n = t[a].width)) && (l[a] = "t" + i / 2 + ",0");
      }
    }, e;
  }(),
      P = function () {
    function e(t, n) {
      r(this, e), this.rawText = t, this.conf = n, this._id = "GL_CAPTION", this.node = c, this.bound = c, this._lSpace = c, this.LegendCaption = {}, this.LegendCaption.LEFT = {
        x: function x(e, t) {
          return t.x + e.width / 2 + 2;
        }
      }, this.LegendCaption.RIGHT = {
        x: function x(e, t) {
          return t.x + t.width - e.width / 2 - 2;
        }
      }, this.LegendCaption.CENTER = {
        x: function x() {
          var e = arguments[1];
          return e.x + e.width / 2;
        }
      };
    }

    return e.prototype.configure = function (e, t) {
      this.rawText = e, this.conf = t;
    }, e.prototype.getName = function () {
      return "LegendCaption";
    }, e.prototype.getType = function () {
      return "caption";
    }, e.prototype.getLogicalSpace = function (e, t, n) {
      var a,
          i,
          o,
          r,
          l = this.conf.padding,
          s = this._lSpace,
          u = this.rawText,
          h = t.gLegend.getFromEnv("chartConfig");
      return s && !n ? (s.isImpure = !0, s) : (s = this._lSpace = {
        bound: {
          height: 0,
          width: 0
        },
        node: {
          logicArea: c,
          smartText: c
        }
      }, a = t.smartLabel, u ? ((i = x(e, {})).height -= 2 * l.v, i.width -= 2 * l.h, i.x += l.h, i.y += l.v, a.useEllipsesOnOverflow(h.useEllipsesWhenOverflow), k(r = x(this.conf.style, {})), a.setStyle(this._metaStyle = r), o = a.getSmartText(u, i.width, i.height), i.height = o.height, i.width = o.width, e.height = o.height + 2 * l.v, e.width = o.width + 2 * l.h, s.node.smartText = o, s.node.logicArea = i, s.bound = e, e) : s.bound);
    }, e.prototype.draw = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r,
          l,
          s,
          c,
          u,
          h = this.conf,
          d = h.bound || {};
      return arguments.length >= 3 ? (r = arguments[0], l = arguments[1], s = arguments[2]) : arguments.length >= 2 && (r = arguments[0], s = arguments[1]), e = s.parentLayer, u = s.animationManager, this.group = t = u.setAnimation({
        el: this.group || "group",
        attr: {
          name: "legend-caption"
        },
        css: h.style,
        component: y,
        container: e
      }), this.getLogicalSpace(l, s), c = (i = this._lSpace).node, a = i.bound, this.bound = n = u.setAnimation({
        el: this.bound || "rect",
        attr: a,
        css: d.style,
        container: t,
        component: y
      }), o = "string" == typeof r ? this.LegendCaption[r.toUpperCase()].x(c.smartText, l || c.logicArea) : r, this.node = u.setAnimation({
        el: this.node || "text",
        attr: {
          text: c.smartText.text,
          x: o,
          y: c.logicArea.y + c.smartText.height / 2,
          lineHeight: this._metaStyle.lineHeight,
          fill: h.style.fill
        },
        container: t,
        component: y
      }), {
        group: t,
        bound: n,
        node: this.node
      };
    }, e.prototype.dispose = function () {
      this.group.remove(), this.bound.remove(), this.node.remove();
    }, e;
  }(),
      A = function () {
    function e(t, n, a) {
      r(this, e), this.colorRange = t, this.conf = n, this.childTextConf = a, this._id = "GL_BODY", this.bound = c, this.group = c, this.compositionsByCategory = {}, this._lSpace = c, this.SC_STACK = [u.AXIS_LABEL, u.LEGEND_AXIS, u.AXIS_VALUE], this.DARW_STACK = [u.AXIS_VALUE, u.LEGEND_AXIS, u.AXIS_LABEL];
    }

    return e.prototype.configure = function (e, t, n) {
      this.colorRange = e, this.conf = t, this.childTextConf = n, this.compositionsByCategory = {};
    }, e.prototype.getName = function () {
      return "LegendBody";
    }, e.prototype.getType = function () {
      return "legend";
    }, e.prototype.addCompositions = function (e, t) {
      this.compositionsByCategory[t] = e;
    }, e.prototype.getSpaceTaken = function (e) {
      return "bottom" === this.conf.legendPosition ? e.height : e.width;
    }, e.prototype.getLogicalSpace = function (e, t, n) {
      var a,
          i,
          o,
          r,
          l,
          s,
          u,
          h = this._lSpace,
          d = this.conf.padding,
          p = this.compositionsByCategory,
          f = 0;
      if (h && !n) return h.isImpure = !0, h;

      for (h = this._lSpace = {
        bound: {
          height: 0,
          width: 0
        },
        node: {
          logicArea: c
        }
      }, (r = x(e, {})).height -= 2 * d.v, r.width -= 2 * d.h, r.x += d.h, r.y += d.v, l = this.getCompositionPlotAreaFor(r), t.colorRange = this.colorRange, s = 0, u = this.SC_STACK.length; s < u; s++) {
        (a = p[this.SC_STACK[s]]) && (i = l(o, a.conf.spreadFactor), o = a.getLogicalSpace(x(i, {}), t, n), f += this.getSpaceTaken(o));
      }

      return this.updateEffectivePlotArea(e, r, f), h.node.logicArea = r, h.bound = e, e;
    }, e.prototype.draw = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r,
          l,
          s,
          c,
          u = this.childTextConf,
          h = this.conf.bound.style || {},
          d = this.compositionsByCategory;

      for (arguments.length >= 3 ? (o = arguments[1], l = arguments[2]) : arguments.length >= 2 && (l = arguments[1]), t = l.parentLayer, e = l.animationManager, this.getLogicalSpace(o, l), r = this._lSpace, this.group = i = e.setAnimation({
        el: this.group || "group",
        attr: {
          name: "legend-body",
          transform: "t0,0"
        },
        css: u.style,
        container: t,
        component: y
      }), this.bound = n = e.setAnimation({
        el: this.bound || "rect",
        attr: r.bound,
        css: h,
        container: i,
        component: y
      }), l.colorRange = this.colorRange, l.parentLayer = i, s = 0, c = this.DARW_STACK.length; s < c; s++) {
        (a = d[this.DARW_STACK[s]]) && a.draw(l);
      }

      return l.moveInstructions && i.attr({
        transform: l.moveInstructions
      }), {
        bound: n,
        group: i
      };
    }, e.prototype.getCompositionPlotAreaFor = function (e) {
      var t,
          n = "bottom" === this.conf.legendPosition;
      return t = x(e, {}), function (a, i) {
        return a = a || {}, n ? (t.y += a.height || 0, t.height = e.height * i) : (t.x += a.width || 0, t.width = e.width * i), t;
      };
    }, e.prototype.updateEffectivePlotArea = function (e, t, n) {
      var a = this.conf.padding;
      "bottom" === this.conf.legendPosition ? (t.height = n, e.height = n + 2 * a.v) : (t.width = n, e.width = n + 2 * a.h);
    }, e;
  }(),
      N = function () {
    function e(t) {
      r(this, e), this.conf = t, this.node = [], this._id = "GL_LABELS";
    }

    return e.prototype.configure = function (e) {
      this.conf = e;
    }, e.prototype.getType = function () {
      return "label";
    }, e.prototype.getName = function () {
      return "LegendLabel";
    }, e.prototype.getEffectivePlotArea = function (e) {
      var t = this.conf.padding;
      return e.height -= 2 * t.v, e.width -= 2 * t.h, e.x += t.h, e.y += t.v, e;
    }, e.prototype.getLogicalSpace = function (e, t, n) {
      var a,
          i,
          o,
          r,
          l,
          s,
          u,
          h,
          d,
          p,
          f,
          g,
          m,
          b,
          v,
          y,
          C,
          w,
          S,
          _,
          L,
          P,
          A,
          N = "bottom" === this.conf.legendPosition,
          E = this._lSpace,
          F = this.conf,
          O = F.padding,
          T = [],
          D = t.gLegend.getFromEnv("chartConfig"),
          M = [];

      if (E && !n) return E.isImpure = !0, E;

      for (a = t.colorRange, i = t.smartLabel, p = a.getCumulativeValueRatio(), o = a.colorRange, m = (E = this._lSpace = {
        bound: {
          height: 0,
          width: 0
        },
        node: {
          logicArea: c,
          smartTexts: []
        }
      }).node.smartTexts, h = x(e, {}), v = this.getEffectivePlotArea(h), A = N ? v.width : v.height, i.useEllipsesOnOverflow(D.useEllipsesWhenOverflow), P = x(F.style, {}), k(this._metaStyle = P), i.setStyle(P), y = i.getSmartText("W"), r = 0, l = o.length; r < l; r++) {
        (d = o[r].label) ? M.push({
          oriIndex: r,
          label: d
        }) : m[r] = c;
      }

      if (0 === (l = M.length)) return {
        height: 0,
        width: 0
      };

      for (g = f = l > 1 ? (p[M[l - 1].oriIndex] - p[M[0].oriIndex]) / 2 * A / 100 : Math.max(p[M[0].oriIndex], 100 - p[M[0].oriIndex]) / 2 * A / 100, N ? ((_ = i.getSmartText(M[0].label, g, v.height)).x = p[M[0].oriIndex] * v.width / 100, s = _.x + _.width) : ((_ = i.getSmartText(M[0].label, g, v.width)).y = p[M[0].oriIndex] * v.height / 100, s = _.y + _.width), T.push(_.height), m[M[0].oriIndex] = _, N ? ((_ = i.getSmartText(M[l - 1].label, g, v.height)).x = p[M[l - 1].oriIndex] * v.width / 100, u = _.x - _.width) : ((_ = i.getSmartText(M[l - 1].label, g, v.width)).y = p[M[l - 1].oriIndex] * v.height / 100, u = _.y - _.width), T.push(_.height), m[M[l - 1].oriIndex] = _, S = s, r = 1; r < l - 1; r++) {
        d = M[r].label, L = M[r].oriIndex, _ = c, C = r + 1 === l - 1 ? u : p[M[r + 1].oriIndex] * A / 100, w = p[M[r].oriIndex] * A / 100, (f = Math.min(w - S, C - w)) > 2 * y.width && (N ? (_ = i.getSmartText(d, f, v.height)).x = p[L] * v.width / 100 : (_ = i.getSmartText(d, f, v.width)).y = p[L] * v.height / 100, S = f, T.push(_.height)), m[M[r].oriIndex] = _;
      }

      return b = Math.max.apply(Math, T), N ? (v.height = b, e.height = b + 2 * O.v) : (v.width = b, e.width = b + 2 * O.v), E.node.logicArea = v, E.bound = e, e;
    }, e.prototype.draw = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r,
          l,
          s,
          c,
          u,
          h,
          d = "bottom" === this.conf.legendPosition,
          p = this.conf,
          f = p.bound && p.bound.style || {
        stroke: "none"
      },
          g = {};
      arguments.length >= 2 && arguments[1] ? (a = arguments[0], r = arguments[1]) : arguments.length >= 1 && (r = arguments[0]), h = r.animationManager, e = r.parentLayer, this.getLogicalSpace(a, r), s = (o = this._lSpace).node.logicArea, c = o.node.smartTexts, this.group = n = h.setAnimation({
        el: this.group || "group",
        attr: {
          name: "legend-labels"
        },
        container: e,
        component: y
      }), this.bound = t = h.setAnimation({
        el: this.bound || "rect",
        attr: o.bound,
        css: f,
        container: n,
        component: y
      });

      for (var m = 0; m < this.node.length; m++) {
        this.node[m].remove();
      }

      for (this.node = [], l = 0, u = c.length; l < u; l++) {
        (i = c[l]) && (d ? (g.y = s.y + i.height / 2, g.x = l === u - 1 ? s.x + i.x - i.width / 2 : l ? s.x + i.x : s.x + i.x + i.width / 2) : (g.x = s.x + i.height / 2, g.y = l === u - 1 ? s.y + i.y - i.width / 2 : l ? s.y + i.y : s.y + i.y + i.width / 2), this.node.push(h.setAnimation({
          el: "text",
          attr: {
            text: i.text,
            x: g.x,
            y: g.y,
            lineHeight: this._metaStyle.lineHeight,
            fill: p.style.fill,
            transform: d ? "R0" : "R270," + g.x + "," + g.y
          },
          container: n,
          component: y
        })));
      }

      return {
        group: n,
        bound: t,
        node: this.node
      };
    }, e;
  }(),
      E = function () {
    function e(t) {
      r(this, e), this.conf = t, this._id = "FL_AXIS", this.node = c, this.group = c, this.shadow = c, this.markerLine = c, this.compositionsByCategory = {};
    }

    return e.prototype.configure = function (e) {
      this.conf = e;
    }, e.prototype.getName = function () {
      return "LegendAxis";
    }, e.prototype.getType = function () {
      return "axis";
    }, e.prototype.addCompositions = function (e, t) {
      this.compositionsByCategory[t] = e;
    }, e.prototype.getLogicalSpace = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r = "bottom" === this.conf.legendPosition,
          l = arguments[0],
          s = arguments[2],
          h = this._lSpace,
          d = this.conf,
          p = d.padding,
          f = d.legendAxisHeight,
          g = this.compositionsByCategory,
          m = 0;
      return h && !s ? (h.isImpure = !0, h) : (h = this._lSpace = {
        bound: {
          height: 0,
          width: 0
        },
        node: {
          logicArea: c
        }
      }, (i = x(l, {})).height -= 2 * p.v, i.width -= 2 * p.h, i.x += p.h, i.y += p.v, e = f / 2 + d.line.offset, t = f / 2, (a = g[u.RANGE]) && (o = a.sliders["false"].conf.outerCircle.rFactor * f, t += m = Math.max(o / 2 - f / 2, 0)), r ? (i.y += m, i.height = n = t + e + m, l.height = n + 2 * p.v) : (i.x += m, i.width = n = t + e + m, l.width = n + 2 * p.v), h.node.logicArea = i, h.bound = l, l);
    }, e.prototype.getDrawableAxisArea = function (e) {
      var t = this.conf,
          n = "bottom" === this.conf.legendPosition;
      return {
        x: e.x,
        y: e.y,
        width: n ? e.width : t.legendAxisHeight,
        height: n ? t.legendAxisHeight : e.height,
        r: t.legendAxisHeight / 2
      };
    }, e.prototype.preDrawingRangeParamV = function (e) {
      return {
        x: e.x + e.width / 2,
        calculationBase: e.width,
        rangeStart: e.y,
        rangeEnd: e.y + e.height,
        prop: "x"
      };
    }, e.prototype.preDrawingRangeParamH = function (e) {
      return {
        y: e.y + e.height / 2,
        calculationBase: e.height,
        rangeStart: e.x,
        rangeEnd: e.x + e.width,
        prop: "y"
      };
    }, e.prototype.preDrawingRangeParam = function (e) {
      return "bottom" === this.conf.legendPosition ? this.preDrawingRangeParamH(e) : this.preDrawingRangeParamV(e);
    }, e.prototype.getScaleMarkerPathStrH = function (e, t) {
      var n,
          a,
          i,
          o,
          r,
          l = x(e, {}),
          s = this.conf.line,
          c = "",
          u = "";

      for (l.x += l.r, l.width -= 2 * l.r, r = l.y + l.height, n = 0, a = t.length; n < a; n++) {
        i = t[n], o = l.x + i * l.width / 100, c += b + o + "," + (r - s.grooveLength) + v + o + "," + (r + s.offset);
      }

      return c + (u += b + l.x + "," + (r + s.offset) + v + (l.x + l.width) + "," + (r + s.offset));
    }, e.prototype.getColorGradientH = function (e) {
      return {
        axis: e.getBoxFill(),
        shadow: (0, i.toRaphaelColor)({
          FCcolor: {
            alpha: "25,0,0",
            angle: 90,
            color: "000000,FFFFFF,FFFFFF",
            ratio: "0,30,40"
          }
        })
      };
    }, e.prototype.draw = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r,
          l,
          s,
          c,
          h,
          d,
          p,
          f,
          g = this.conf,
          m = g.bound || {},
          b = g.line,
          v = m.style || {},
          x = this.compositionsByCategory;

      for (n in arguments.length >= 2 ? (t = arguments[0], d = arguments[1]) : arguments.length >= 1 && (d = arguments[0]), p = d.animationManager, e = d.parentLayer, i = (a = d.colorRange).getCumulativeValueRatio(), this.getLogicalSpace(t, d), h = this._lSpace, this.group = r = p.setAnimation({
        el: this.group || "group",
        attr: {
          name: "legend-axis"
        },
        container: e,
        component: y
      }), this.bound = p.setAnimation({
        el: this.bound || "rect",
        attr: h.bound,
        css: v,
        component: y,
        container: r
      }), c = this.getDrawableAxisArea(h.node.logicArea), s = this.getColorGradient(a), g.style.fill = s.axis, g.shadow.style.fill = s.shadow, this.node = p.setAnimation({
        el: this.node || "rect",
        attr: c,
        css: g.style,
        container: r,
        component: y
      }), this.shadow = p.setAnimation({
        el: this.shadow || "rect",
        attr: c,
        css: g.shadow.style,
        container: r,
        component: y
      }), f = this.getScaleMarkerPathStr(c, i), this.path = p.setAnimation({
        el: this.path || "path",
        attr: {
          path: f
        },
        css: b.style,
        container: r,
        component: y
      }), x) {
        switch (o = x[n], n) {
          case u.RANGE:
            d[(l = this.preDrawingRangeParam(c)).prop] = l[l.prop], d.key = l.prop, d.rCalcBase = l.calculationBase, d.parentLayer = r, o.draw(l.rangeStart, l.rangeEnd, d);
        }
      }
    }, e.prototype.getScaleMarkerPathStr = function (e, t) {
      return "bottom" === this.conf.legendPosition ? this.getScaleMarkerPathStrH(e, t) : this.getScaleMarkerPathStrV(e, t);
    }, e.prototype.getColorGradient = function (e) {
      return "bottom" === this.conf.legendPosition ? this.getColorGradientH(e) : this.getColorGradientV(e);
    }, e.prototype.getScaleMarkerPathStrV = function (e, t) {
      var n,
          a,
          i,
          o,
          r,
          l = x(e, {}),
          s = this.conf.line,
          c = "",
          u = "";

      for (l.y += l.r, l.height -= 2 * l.r, o = l.x + l.width, n = 0, i = t.length; n < i; n++) {
        a = t[n], r = l.y + a * l.height / 100, c += b + (o - s.grooveLength) + "," + r + v + (o + s.offset) + "," + r;
      }

      return c + (u += b + (o + s.offset) + "," + l.y + v + (o + s.offset) + "," + (l.y + l.height));
    }, e.prototype.getColorGradientV = function (e) {
      return {
        axis: e.getBoxFill(!0),
        shadow: (0, i.toRaphaelColor)({
          FCcolor: {
            alpha: "25,0,0",
            angle: 360,
            color: "000000,FFFFFF,FFFFFF",
            ratio: "0,30,40"
          }
        })
      };
    }, e;
  }(),
      F = function () {
    function e(t, n, a) {
      r(this, e), this.conf = n.conf, this.sliderIndex = t, this.rangeGroup = n.sliderGroup, this._id = a, this.node = c, this.tracker = c, this.currPos = 0, this.swing = [];
    }

    return e.prototype.configure = function (e, t, n) {
      this.conf = t.conf, this.sliderIndex = e, this.rangeGroup = t.sliderGroup, this._id = n, this.currPos = 0, this.swing = [];
    }, e.prototype.getType = function () {
      return "slider";
    }, e.prototype.getName = function () {
      return "Slider";
    }, e.prototype.updateSwingRange = function (e, t) {
      this.swing[+e] = t;
    }, e.prototype.draw = function (e, t, n, a) {
      var i,
          o,
          r,
          l,
          s,
          c,
          u,
          d = a.parentLayer,
          p = a.animationManager,
          f = this.conf,
          g = f.outerCircle,
          m = f.innerCircle,
          b = p.getFromEnv("chart").config,
          v = Math.ceil(g.rFactor * a.rCalcBase / 2),
          x = Math.ceil(m.rFactor * a.rCalcBase / 2),
          C = v - x,
          k = a.gLegend.getFromEnv("toolTipController"),
          w = this.sliderIndex;
      return f.outerRadius = v, f.innerRadius = x, this._scaleVal = t, m.style["stroke-width"] = C, x += l = Math.ceil(g.style["stroke-width"] / 2), o = this.node = p.setAnimation({
        el: this.node || "group",
        attr: {
          name: "fc-gl-slider",
          cursor: "pointer",
          transform: "t0,0"
        },
        container: d,
        component: y
      }), "x" === a.key ? (s = n, c = e, c += w ? -x : +x) : (s = e, c = n, s += w ? -x : +x), this.oCircle = p.setAnimation({
        el: this.oCircle || "circle",
        attr: {
          cx: s,
          cy: c,
          r: v
        },
        css: g.style,
        container: o,
        component: y
      }), this.iCircle = p.setAnimation({
        el: this.iCircle || "circle",
        attr: {
          cx: s,
          cy: c,
          r: x
        },
        css: m.style,
        container: o,
        component: y
      }), u = this.tracker = p.setAnimation({
        el: this.tracker || "circle",
        attr: {
          cx: s,
          cy: c,
          r: v + 5,
          fill: h,
          stroke: h,
          cursor: "pointer"
        },
        container: o,
        component: y
      }), o.attr({
        transform: "x" === a.key ? "t0," + this.currPos : "t" + this.currPos + ",0"
      }), i = b.showToolTip ? t : "", k.enableToolTip(u, i), this._dragAPI = r = this.getDragAPI("x" === a.key), u.undrag(), u.drag(r.dragging, r.dragStart, r.dragEnd), {
        translateAscending: v + l
      };
    }, e.prototype.getDragAPI = function (e) {
      var t,
          n,
          a,
          i,
          o = this,
          r = o.node,
          l = o.sliderIndex,
          s = o.rangeGroup,
          c = o.conf.innerRadius;
      return {
        dragging: function dragging(u) {
          var h, d, p, f, g;
          return u.stopPropagation(), p = e ? u.data[1] : u.data[0], l ? (h = t[0] - t[1] + c, d = 0) : (h = 0, d = t[1] - t[0] - c), (g = o.currPos + p) < h ? p += h - g : g > d && (p -= g - d), r.attr({
            transform: e ? "t0," + (o.currPos + p) : "t" + (o.currPos + p) + ",0"
          }), n = p, a && clearTimeout(a), a = setTimeout(function () {
            s.updateWhenInRest(o, o.currPos + p);
          }, 100), f = s.updateWhenInMove(o, o.currPos + p), o.conf.showTooltip && o.tracker.data("__FC_tooltipText", f), i = !0, !0;
        },
        dragStart: function dragStart(e) {
          e.stopPropagation(), t = o.swing, i = !1, s.dragStarted(o);
        },
        dragEnd: function dragEnd() {
          var e;
          s.dragCompleted(o, i, o.currPos + n), i && (a && clearTimeout(a), a = setTimeout(function () {
            s.updateWhenInRest(o, o.currPos);
          }, 100), o.currPos += n, e = t[+l] + o.currPos, s.updateRange(o, e));
        }
      };
    }, e.prototype.dispose = function () {
      this.node.remove(), this.oCircle.remove(), this.iCircle.remove(), this.tracker.remove();
    }, e;
  }(),
      O = function () {
    function e(t) {
      r(this, e);
      var n = t,
          a = {};
      this._id = "GL_SG1", this.conf = t, a.conf = n, this.extremes = [], this.sliders = {}, this.min = undefined, this.max = undefined, a.sliderGroup = this, this.valueRange = [], this.callbacks = [], this.sliders[p] = new F(p, a, this._id + "_" + +p), this.sliders[f] = new F(f, a, this._id + "_" + +f);
    }

    return e.prototype.configure = function (e) {
      var t = e,
          n = {};
      this.min = undefined, this.max = undefined, this.conf = e, n.conf = t, n.sliderGroup = this, this.sliders[p].configure(p, n, this._id + "_" + +p), this.sliders[f].configure(f, n, this._id + "_" + +f);
    }, e.prototype.getType = function () {
      return "slider";
    }, e.prototype.getName = function () {
      return "SliderGroup";
    }, e.prototype.initRange = function (e, t) {
      var n = e.sliderIndex;
      this.extremes[+n] = t;
    }, e.prototype.updateRange = function (e, t) {
      var n = e.sliderIndex;
      this.sliders[!n].updateSwingRange(n, t);
    }, e.prototype.reset = function () {
      var e = {};
      e.conf = this.conf, e.sliderGroup = this, this.min = undefined, this.max = undefined, this.sliders[p].configure(p, e, this._id + "_" + +p), this.sliders[f].configure(f, e, this._id + "_" + +f), this.draw.apply(this, this._drawParams);
    }, e.prototype.draw = function (e, t, n) {
      var a,
          i,
          o,
          r,
          l,
          s,
          c = this.sliders,
          u = c[p],
          h = c[f],
          d = n.colorRange,
          g = d.colorRange,
          m = d.data.mapByPercent,
          b = n.gLegend.getFromEnv("number-formatter");
      return this._fcChart = n.gLegend.getFromEnv("chart"), this.getValueFormPixel = function (e, t, n, a) {
        var i = (t - e) / (a - n);

        this.getValueFormPixel = function (t) {
          return e + i * t;
        };
      }, this.updateWhenInMove = function (e, t) {
        this.updateWhenInMove = function (n, a) {
          var i,
              o,
              r = this.extremes;
          return i = n.sliderIndex ? r[1] - r[0] + a : a, o = this.getValueFormPixel(i), o = t ? parseFloat(o).toFixed(2) + "%" : e.legendValue(o);
        };
      }, this._drawParams = [e, t, n], this.updateWhenInMove(b, m), o = u.conf.outerCircle, i = u.conf.innerCircle, r = Math.ceil(i.rFactor * n.rCalcBase / 2), r += Math.ceil(o.style["stroke-width"] / 2), this.extremes[0] = e + r, this.extremes[1] = t - r, l = this.extremes[1] - this.extremes[0], this.min = this.min ? this.min : g[0].value, this.max = this.max ? this.max : g[g.length - 1].value, s = g[g.length - 1].value - g[0].value, u.currPos = l * (this.min - g[0].value) / s, h.currPos = l * (this.max - g[0].value) / s - l, u.draw(e, m ? b.legendPercentValue(this.min) : b.legendValue(this.min), n[n.key], n), a = h.draw(t, m ? b.legendPercentValue(this.max) : b.legendValue(this.max), n[n.key], n), u.swing = this.extremes.slice(0), h.swing = this.extremes.slice(0), u.swing[1] += h.currPos, h.swing[0] += u.currPos, this.getValueFormPixel(g[0].value, g[g.length - 1].value, this.extremes[0], this.extremes[1]), a;
    }, e.prototype.updateWhenInRest = function (e, t) {
      var n,
          a,
          i = this.sliders,
          o = this.extremes,
          r = e.sliderIndex;
      r ? (n = i[!r].currPos, a = o[1] - o[0] + t) : (n = t, a = o[1] - o[0] + i[!r].currPos), this.min = Number(this.getValueFormPixel(n).toFixed(2)), this.max = Number(this.getValueFormPixel(a).toFixed(2)), this.gLegend.fireEvent("rangeUpdated", [{
        min: this.min,
        max: this.max
      }]);
    }, e.prototype.dragStarted = function (e) {
      var t = this.sliders,
          n = this.extremes,
          a = e.conf,
          i = this._fcChart;
      i.fireChartInstanceEvent("legendpointerdragstart", {
        pointerIndex: +e.sliderIndex,
        pointers: [{
          value: this.getValueFormPixel(t["false"].currPos)
        }, {
          value: this.getValueFormPixel(n[1] - n[0] + t["true"].currPos)
        }],
        legendPointerHeight: a.outerRadius,
        legendPointerWidth: a.innerRadius,
        outerRadius: a.outerRadius,
        innerRadius: a.innerRadius
      }, [i.id]);
    }, e.prototype.dragCompleted = function (e, t, n) {
      var a,
          i,
          o = this.sliders,
          r = this.extremes,
          l = e.conf,
          s = this.getValueFormPixel(o["false"].currPos),
          c = this.getValueFormPixel(r[1] - r[0] + o["true"].currPos),
          u = this._fcChart;
      e.sliderIndex ? (a = s, i = this.getValueFormPixel(r[1] - r[0] + n)) : (a = this.getValueFormPixel(n), i = c), t && u.fireChartInstanceEvent("legendrangeupdated", {
        previousMinValue: s,
        previousMaxValue: c,
        minValue: a,
        maxValue: i
      }, [u.id]), u.fireChartInstanceEvent("legendpointerdragstop", {
        pointerIndex: +e.sliderIndex,
        pointers: [{
          value: a
        }, {
          value: i
        }],
        legendPointerHeight: l.outerRadius,
        legendPointerWidth: l.innerRadius,
        outerRadius: l.outerRadius,
        innerRadius: l.innerRadius
      }, [u.id]);
    }, e.prototype.dispose = function () {
      this.sliders[p].dispose(), this.sliders[f].dispose();
    }, e;
  }(),
      T = function (e) {
    function t() {
      r(this, t);
      var n = l(this, e.call(this, arguments[0]));
      return n._id = "GL_VALUES", n.node = [], n;
    }

    return s(t, e), t.prototype.configure = function (e) {
      this.conf = e;
    }, t.prototype.getName = function () {
      return "LegendValues";
    }, t.prototype.getType = function () {
      return "legend";
    }, t.prototype.getLogicalSpace = function (e, t, n) {
      var a,
          i,
          o,
          r,
          l,
          s,
          u,
          h,
          d,
          p,
          f,
          g,
          m,
          b,
          v,
          y,
          C,
          w,
          S,
          _,
          L,
          P,
          A,
          N,
          E,
          F = "bottom" === this.conf.legendPosition,
          O = this._lSpace,
          T = this.conf,
          D = T.padding,
          M = t.gLegend.getFromEnv("chartConfig"),
          I = [],
          R = [];

      if (O && !n) return O.isImpure = !0, O;

      for (a = t.colorRange, i = t.smartLabel, o = a.colorRange, u = a.getCumulativeValueRatio(), E = (O = this._lSpace = {
        bound: {
          height: 0,
          width: 0
        },
        node: {
          logicArea: c,
          smartTexts: []
        }
      }).node.smartTexts, (_ = x(e, {})).height -= 2 * D.v, _.width -= 2 * D.h, _.x += D.h, _.y += D.v, i.useEllipsesOnOverflow(M.useEllipsesWhenOverflow), N = x(T.style, {}), k(this._metaStyle = N), i.setStyle(N), A = i.getSmartText("W"), s = o.length, F ? (f = h = (u[s - 1] - u[0]) / 2 * _.width / 100, P = o[0].displayValue, (r = i.getSmartText("string" != typeof P && P !== c && P.toString() || P, f, _.height)).x = u[0] * _.width / 100, g = r.x + r.width, I.push(r.height)) : (f = h = (u[s - 1] - u[0]) / 2 * _.height / 100, (r = i.getSmartText(o[0].displayValue, _.width, f)).y = u[0] * _.height / 100, v = r.y + r.width, R.push(r.width)), E[0] = r, F ? ((r = i.getSmartText(o[s - 1].displayValue, f, _.height)).x = u[s - 1] * _.width / 100, b = r.x - r.width, I.push(r.height), m = g) : ((r = i.getSmartText(o[s - 1].displayValue, _.width, f)).y = u[s - 1] * _.height / 100, C = r.y - r.height, R.push(r.width), y = v), E[s - 1] = r, l = 1; l < s - 1; l++) {
        r = c, L = o[l].displayValue, F ? (d = l + 1 === s - 1 ? b : u[l + 1] * _.width / 100, p = u[l] * _.width / 100, (h = Math.min(p - m, d - p)) > 1.5 * A.width && ((r = i.getSmartText(L, 2 * h, _.height)).x = u[l] * _.width / 100, m = h, I.push(r.height))) : (d = l + 1 === s - 1 ? C : u[l + 1] * _.height / 100, p = u[l] * _.height / 100, (h = Math.min(p - y, d - p)) > 2 * A.height && ((r = i.getSmartText(L, _.width, 2 * h)).y = u[l] * _.height / 100, y = h, R.push(r.width))), E[l] = r;
      }

      return F ? (w = Math.max.apply(Math, I), _.height = w, e.height = w + 2 * D.v) : (S = Math.max.apply(Math, R), _.width = S, e.width = S + 2 * D.h), O.node.logicArea = _, O.bound = e, e;
    }, t.prototype.draw = function () {
      var e,
          t,
          n,
          a,
          i,
          o,
          r,
          l,
          s,
          c,
          u,
          h,
          d,
          p = this.conf,
          f = "bottom" === p.legendPosition,
          g = p.bound && p.bound.style || {
        stroke: "none"
      },
          m = {};
      arguments.length >= 2 && arguments[1] ? (a = arguments[0], r = arguments[1]) : arguments.length >= 1 && (r = arguments[0]), d = r.animationManager, e = r.parentLayer, l = r.colorRange.getCumulativeValueRatio(), this.getLogicalSpace(a, r), o = (i = this._lSpace).node.logicArea, u = i.node.smartTexts, this.group = n = d.setAnimation({
        el: this.group || "group",
        attr: {
          name: "legend-values"
        },
        container: e,
        component: y
      }), this.bound = t = d.setAnimation({
        el: this.bound || "rect",
        attr: i.bound,
        css: g,
        container: n,
        component: y
      });

      for (var b = 0; b < this.node.length; b++) {
        this.node[b].remove();
      }

      for (this.node = [], s = 0, c = l.length; s < c; s++) {
        (h = u[s]) && (f ? (m.y = o.y + h.height / 2, m.x = s === c - 1 ? o.x + h.x - h.width / 2 : s ? o.x + h.x : o.x + h.x + h.width / 2) : (m.x = o.x + h.width / 2, m.y = s === c - 1 ? o.y + h.y - h.height / 2 : s ? o.y + h.y : o.y + h.y + h.height / 2), this.node.push(d.setAnimation({
          el: "text",
          attr: {
            text: h.text,
            x: m.x,
            y: m.y,
            lineHeight: this._metaStyle.lineHeight,
            fill: p.style.fill
          },
          container: n,
          component: y
        })));
      }

      return {
        group: n,
        bound: t
      };
    }, t;
  }(N);

  t["default"] = S;
},,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.getCoordinates = t.getPlotFromPixel = t.polarToCartesian = t.cartesianToPolar = undefined;

  var a = n(125),
      i = function i(e) {
    return e * (Math.PI / 180);
  },
      o = function o(e) {
    return e * (180 / Math.PI);
  },
      r = function r(e, t) {
    var n, a;
    return n = Math.sqrt(e * e + t * t), a = o(Math.atan(t / e)), e < 0 && t >= 0 ? a += 180 : e < 0 && t < 0 ? a += 180 : e > 0 && t < 0 && (a += 360), {
      radius: n,
      theta: i(a)
    };
  },
      l = function l(e, t) {
    return !(arguments.length > 2 && arguments[2] !== undefined) || arguments[2] || (t = i(t)), {
      x: e * Math.cos(t),
      y: e * Math.sin(t)
    };
  };

  t.cartesianToPolar = r, t.polarToCartesian = l, t.getPlotFromPixel = function (e, t) {
    var n,
        a,
        i = e.x,
        l = e.y,
        s = t.getScale();
    return a = r(i, l), n = s.getDomainValue(a.theta), o(n);
  }, t.getCoordinates = function (e, t) {
    var n,
        i = t.getScale(),
        o = e.radius,
        r = t.config,
        s = r.axisDimention.centerX,
        c = r.axisDimention.centerY,
        u = void 0;
    return o = (0, a.pluckNumber)(o, r.radius, 0), n = i.getRangeValue(e.theta), (u = l(o, n)).x += s, u.y += c, u;
  };
},,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  t["default"] = [{
    initialAttr: {
      opacity: 0
    },
    finalAttr: {
      opacity: 1
    },
    slot: "axis"
  }];
},,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(267),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  };
  t["default"] = o["default"];
},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0, t.symbolList = undefined;
  var a,
      i = (0, n(132).getDep)("redraphael", "plugin"),
      o = Math.cos,
      r = Math.sin,
      l = Math.PI;
  t.symbolList = a = {
    pinModeIcon: function pinModeIcon(e, t, n) {
      var a = .5 * n,
          i = e - n,
          o = e + n,
          r = e - a,
          l = e + a,
          s = e + .5,
          c = s + 1,
          u = s + 1.5,
          h = t - n,
          d = t + a,
          p = t - a,
          f = t + (n - a);
      return ["M", i, h, "L", r, p, r, f, i, d, e - .5, d, e, t + n + .5, s, d, o, d, l, f, l, p, o, h, u, h, u, p, u, f, c, f, c, p, u, p, u, h, "Z"];
    },
    zoomOutIcon: function zoomOutIcon(e, t, n) {
      var a = e - .2 * n,
          l = t - .2 * n,
          s = .8 * n,
          c = i.rad(43),
          u = i.rad(48),
          h = a + s * o(c),
          d = l + s * r(c),
          p = a + s * o(u),
          f = l + s * r(u),
          g = n,
          m = i.rad(45);
      return ["M", h, d, "A", s, s, 0, 1, 0, p, f, "Z", "M", h + 1, d + 1, "L", h + g * o(m), d + g * r(m), p + g * o(m), f + g * r(m), p + 1, f + 1, "Z", "M", a - 2, l, "L", a + 2, l, "Z"];
    },
    resetIcon: function resetIcon(e, t, n) {
      var a = n,
          i = e - a,
          s = t,
          c = (l / 2 + l) / 2,
          u = e + a * o(c),
          h = t + a * r(c),
          d = 2 * a / 3;
      return ["M", i, s, "A", a, a, 0, 1, 1, u, h, "L", u + d, h - 1, u + 2, h + d - .5, u, h];
    },
    zoomInIcon: function zoomInIcon(e, t, n) {
      var a = e - .2 * n,
          l = t - .2 * n,
          s = .8 * n,
          c = i.rad(43),
          u = i.rad(48),
          h = a + s * o(c),
          d = l + s * r(c),
          p = a + s * o(u),
          f = l + s * r(u),
          g = n,
          m = i.rad(45);
      return ["M", h, d, "A", s, s, 0, 1, 0, p, f, "Z", "M", h + 1, d + 1, "L", h + g * o(m), d + g * r(m), p + g * o(m) - 1, f + g * r(m) - 1, p + 1, f + 1, "Z", "M", a - 2, l, "L", a + 2, l, "Z", "M", a, l - 2, "L", a, l + 2, "Z"];
    },
    zoomModeIcon: function zoomModeIcon(e, t, n) {
      var a = [],
          l = e - .2 * n,
          s = t - .2 * n,
          c = .8 * n,
          u = i.rad(43),
          h = i.rad(48),
          d = l + c * o(u),
          p = s + c * r(u),
          f = l + c * o(h),
          g = s + c * r(h),
          m = n,
          b = i.rad(45),
          v = d + m * o(b),
          y = p + m * r(b),
          x = f + m * o(b) - 1,
          C = g + m * r(b) - 1;
      return a = a.concat(["M", d, p, "A", c, c, 0, 1, 0, f, g, "Z", "M", d + 1, p + 1, "L", v, y, x, C, x + 1, C - 1, x + 1.5, C + 1.5, x - 1, C + 1, x, C, f + 1, g + 1, "Z", "M", l - 2, s, "L", l + 2, s, "Z", "M", l, s - 2, "L", l, s + 2, "Z"]);
    },
    panModeIcon: function panModeIcon(e, t, n) {
      var a;
      return [].concat(["M", (a = e) - (n *= 2.5) / 16, t - n / 8, "L", a + n / 16, t - n / 8, "L", a + n / 16, t - n / 3.2, "L", a + 6 * n / 32, t - 10 * n / 32, "L", a, t - n / 2, "L", a - 6 * n / 32, t - 10 * n / 32, "L", a - n / 16, t - n / 3.2, "Z", "M", a + 4 * n / 32, t - 2 * n / 32, "L", a + 10 * n / 32, t - 2 * n / 32, "L", a + 10 * n / 32, t - 6 * n / 32, "L", a + 16 * n / 32, t, "L", a + 10 * n / 32, t + 6 * n / 32, "L", a + 10 * n / 32, t + 2 * n / 32, "L", a + 4 * n / 32, t + 2 * n / 32, "Z", "M", a + 2 * n / 32, t + 5 * n / 32, "L", a + 2 * n / 32, t + 10 * n / 32, "L", a + 6 * n / 32, t + 10 * n / 32, "L", a, t + 16 * n / 32, "L", a - 6 * n / 32, t + 10 * n / 32, "L", a - 2 * n / 32, t + 10 * n / 32, "L", a - 2 * n / 32, t + 5 * n / 32, "Z", "M", a - 4 * n / 32, t - 2 * n / 32, "L", a - 10 * n / 32, t - 2 * n / 32, "L", a - 10 * n / 32, t - 6 * n / 32, "L", a - 16 * n / 32, t, "L", a - 10 * n / 32, t + 6 * n / 32, "L", a - 10 * n / 32, t + 2 * n / 32, "L", a - 4 * n / 32, t + 2 * n / 32, "Z"]);
    }
  }, t.symbolList = a;
},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, function (e, t, n) {
  "use strict";

  t.__esModule = !0;
  var a,
      i = n(516),
      o = (a = i) && a.__esModule ? a : {
    "default": a
  },
      r = n(125);

  function l(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
      for (var n = Object.getOwnPropertyNames(t), a = 0; a < n.length; a++) {
        var i = n[a],
            o = Object.getOwnPropertyDescriptor(t, i);
        o && o.configurable && e[i] === undefined && Object.defineProperty(e, i, o);
      }
    }(e, t));
  }

  var s = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, e.apply(this, arguments));
    }

    return l(t, e), t.prototype.getType = function () {
      return "group";
    }, t.prototype.getName = function () {
      return "columnOverlappedGroup";
    }, t.prototype.setColumnPosition = function () {
      var e = this.getFromEnv("chart-attrib"),
          t = this.getFromEnv("xAxis"),
          n = this.getFromEnv("chart"),
          a = this.getFromEnv("numOfColumns"),
          i = Math.max((0, r.pluckNumber)(e.plotspacepercent), 0),
          o = Math.max((0, r.pluckNumber)(i, 20) % 100, 0),
          l = o / 200,
          s = t.getPixel(0),
          c = t.getPixel(1),
          u = n.isBar ? n.config.maxBarHeight : n.config.maxColWidth,
          h = Math.abs(c - s),
          d = void 0,
          p = !0,
          f = 0,
          g = 0;
      this.addToEnv("groupMaxWidth", h), this._mapChildren(function (e) {
        e.getState("removed") || !1 === e.getState("visible") || g++;
      }), this.addToEnv("numOfColumns", g), this.addToEnv("numColDiff", (0, r.pluckNumber)(a - g, 0)), void 0 === (d = this.getFromEnv("plotWidth")) && (d = (1 - .01 * i) * h || Math.min(h * (1 - 2 * l), u * (g || 1))), this._mapChildren(function (e) {
        e.getState("removed") || !1 === e.getState("visible") || (e.addToEnv("plotWidth", d - d / g * f), f++);
      }), c - NaN - (s - NaN + void 0) < 4 && (p = !1), 0 === o && (p = !0), this.addToEnv("isCrisp", p);
    }, t;
  }(o["default"]);

  t["default"] = s;
}])]);